
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1Xeln", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("keyLG")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $keyLG = parcelRequire("keyLG");

});
parcelRegister("keyLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7fdd3fbee96fc7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $g0Gtc = parcelRequire("g0Gtc");

var $2i4sA = parcelRequire("2i4sA");

var $x9xyg = parcelRequire("x9xyg");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $d31Su = parcelRequire("d31Su");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $38Y30 = parcelRequire("38Y30");

var $4dRjY = parcelRequire("4dRjY");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $dIdda = parcelRequire("dIdda");


var $ahuix = parcelRequire("ahuix");

var $8wh20 = parcelRequire("8wh20");
const $bd7fdd3fbee96fc7$export$2532845c810cfaa1 = ()=>{
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$df49868e6ee293e));
    });
    const [boardIdStr] = (0, $dIdda.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const isCompanyManaged = (0, $ahuix.useIsCMPBacklogRoute)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isAuthenticated = (0, $9NiTW.checkAuthentication)(tenantContext);
    const hasSoftwareLicense = (0, $3RV1W.checkLicense)(tenantContext, 'software');
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: `${boardId}`,
        experience: "viewBacklog",
        analyticsSource: "backlog",
        edition: tenantContext.appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isClassic: isCompanyManaged,
            isUIF: true,
            synthetic: (0, $co1wz.ff)('jsw.pollinator.tenants'),
            isBacklogWithRelayEnabled: (0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay'),
            jswSprintPlanningWhiteboards: (0, $4R6GH.fg)('sprint_planning_whiteboards_kill_switch')
        }
    }, hasSoftwareLicense ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wh20.default), {
        isCompanyManaged: isCompanyManaged
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: "ng-backlog-context-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null)));
};
const $bd7fdd3fbee96fc7$var$BacklogWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd7fdd3fbee96fc7$export$2532845c810cfaa1, null));
var $bd7fdd3fbee96fc7$export$2e2bcd8739ae039 = $bd7fdd3fbee96fc7$var$BacklogWrapper;

});
parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("1qjZt")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("1qjZt", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lzKF1").then(()=>parcelRequire('eX102'));

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $a64d16806d35fb92$export$b5f697f1279a473e = 'USE_RESOURCE_START';
const $a64d16806d35fb92$export$a6940922387b16 = 'USE_RESOURCE_READY';
const $a64d16806d35fb92$export$e9163c48bfd4013e = 'BACKLOG_PREFETCHED_DATA_READY';
const $a64d16806d35fb92$export$fb27ff41b54b88b0 = 'AGG_DATA_TRANSFORM_START';
const $a64d16806d35fb92$export$bde49eba9c87d991 = 'AGG_DATA_TRANSFORM_END';
const $a64d16806d35fb92$export$df49868e6ee293e = 'BACKLOG_ROOT_SPA_APP_START';
const $a64d16806d35fb92$export$dedbdcc35e955187 = 'BACKLOG';
const $a64d16806d35fb92$export$e927a5d1b72f0b68 = 'ENABLED';
const $a64d16806d35fb92$export$8cd212c10b4124d2 = 'DISABLED';
const $a64d16806d35fb92$export$912d9029af46d426 = 'Board is locationless';

parcelRegister("ahuix", function(module, exports) {

$parcel$export(module.exports, "getBoardUrl", () => $4f74b523b1495014$export$505a9f131607d070);
$parcel$export(module.exports, "getCMPBoardUrl", () => $4f74b523b1495014$export$c89a0c88af322ce1);
$parcel$export(module.exports, "isBacklogDisabled", () => $4f74b523b1495014$export$c5cfccba3ef0f2a9);
$parcel$export(module.exports, "useOnce", () => $4f74b523b1495014$export$392544347a18b6ea);
$parcel$export(module.exports, "getIdFromAri", () => $4f74b523b1495014$export$79640a85913af5aa);
$parcel$export(module.exports, "useIsCMPBacklogRoute", () => $4f74b523b1495014$export$d2d03c28ed220603);

var $5uXOq = parcelRequire("5uXOq");

var $65Ltd = parcelRequire("65Ltd");

var $dXq4S = parcelRequire("dXq4S");

var $6jY6G = parcelRequire("6jY6G");

const $4f74b523b1495014$export$505a9f131607d070 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/boards/${boardId}`;
const $4f74b523b1495014$export$c89a0c88af322ce1 = (projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
const $4f74b523b1495014$export$c5cfccba3ef0f2a9 = (data)=>{
    if (!data?.boardScope.features) return false;
    return data.boardScope.features.some(({ key: key, status: status })=>key === (0, $a64d16806d35fb92$export$dedbdcc35e955187) && status === (0, $a64d16806d35fb92$export$8cd212c10b4124d2));
};
const $4f74b523b1495014$var$defaultPredicate = ()=>true;
const $4f74b523b1495014$export$392544347a18b6ea = (callback, predicate = $4f74b523b1495014$var$defaultPredicate)=>{
    const done = (0, $5uXOq.useRef)(false);
    if (!done.current && predicate()) {
        callback();
        done.current = true;
    }
};
const $4f74b523b1495014$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $4f74b523b1495014$export$d2d03c28ed220603 = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        (0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
    ].includes(route.name);
};

});

parcelRegister("8wh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9eecd2d577f994b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $i1Rjy = parcelRequire("i1Rjy");

var $jVPfn = parcelRequire("jVPfn");

var $bcP1m = parcelRequire("bcP1m");
const $e9eecd2d577f994b$var$BacklogMetaAPIConsumerWrapper = ({ isCompanyManaged: isCompanyManaged })=>{
    if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVPfn.default), null);
    if ((0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i1Rjy.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcP1m.default), null);
};
var $e9eecd2d577f994b$export$2e2bcd8739ae039 = $e9eecd2d577f994b$var$BacklogMetaAPIConsumerWrapper;

});
parcelRegister("i1Rjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f08f0cc022f5d77$export$2e2bcd8739ae039);

var $loNZB = parcelRequire("loNZB");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $8Uumt = parcelRequire("8Uumt");

var $gEFwt = parcelRequire("gEFwt");

var $6BZYo = parcelRequire("6BZYo");

var $x9xyg = parcelRequire("x9xyg");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $feJRr = parcelRequire("feJRr");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $jgtyX = parcelRequire("jgtyX");

var $aN2bG = parcelRequire("aN2bG");

var $9SRRO = parcelRequire("9SRRO");

var $aJzGl = parcelRequire("aJzGl");

var $76Weg = parcelRequire("76Weg");

var $9kARR = parcelRequire("9kARR");

var $9dbF6 = parcelRequire("9dbF6");

var $dZw8H = parcelRequire("dZw8H");

var $bVDE5 = parcelRequire("bVDE5");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");


var $ahuix = parcelRequire("ahuix");

var $hHoqo = parcelRequire("hHoqo");

var $fpQn9 = parcelRequire("fpQn9");

var $5S6NV = parcelRequire("5S6NV");
const $9f08f0cc022f5d77$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $9f08f0cc022f5d77$export$e14c6311549531c9 = ({ backlogQueryReference: backlogQueryReference })=>{
    const [projectKey] = (0, $dIdda.usePathParam)('projectKey');
    const [boardIdStr] = (0, $dIdda.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const tenantContext = (0, $9OXo1.useTenantContext)(); /* eslint-disable @atlassian/relay/unused-fields */ 
    const aggData = (0, $8Uumt.usePreloadedQuery)((0, $loNZB.default), backlogQueryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
        (0, $x9xyg.setMeasure)('use-resource-fetch-finish', (0, $a64d16806d35fb92$export$b5f697f1279a473e), (0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    });
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    const hasSuspended = (0, $9kARR.useGetHasSuspended)();
    const isCacheHit = !isInitialRender && !hasSuspended;
    const projectKeyFromContext = aggData?.boardScope.projectLocation.key || '';
    const projectNameFromContext = aggData?.boardScope.projectLocation.name || '';
    const projectIdFromContext = (0, $ahuix.getIdFromAri)(aggData?.boardScope.projectLocation.id || '');
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    const getDataFromAGG = (0, $fpQn9.useGetDataFromAGG)({
        cloudId: tenantContext.cloudId,
        boardId: boardId
    });
    (0, $5uXOq.useEffect)(()=>{
        // only run the query if projectId exists in context
        // we load the query client-side because:
        //  1. The field relies on projectId which isn't available from the URL path
        //  2. We don't want version data to block the critical page load
        if (loadVersionFilterRelayQuery != null && projectIdFromContext.length > 0) {
            const jiraProjectId = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'project',
                resourceId: `${projectIdFromContext}`
            });
            loadVersionFilterRelayQuery({
                jiraProjectIds: [
                    jiraProjectId
                ],
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        projectIdFromContext,
        tenantContext.cloudId
    ]); // redirect to the board only if the backlog is disabled, no redirect if timeout
    if ((0, $5S6NV.isBacklogDisabledFromAggData)(aggData)) {
        const urlProjectKey = projectKey ?? projectKeyFromContext;
        const boardUrl = (0, $ahuix.getBoardUrl)(urlProjectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76Weg.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $9f08f0cc022f5d77$var$bindToOnJiraGlobalIssueCreateClose,
        projectKey: projectKey ?? projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        rapidViewId: String(boardId),
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: null,
        prefetchedAggData: aggData,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS2741: Property 'baseUrl' is missing
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        projectKey: projectKeyFromContext,
        projectName: projectNameFromContext,
        projectId: projectIdFromContext,
        isSimplifiedProject: true
    }, backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey ?? projectKeyFromContext ?? null
    })));
};
const $9f08f0cc022f5d77$export$180813d52fa33cf7 = ()=>{
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const response = (0, $ao2h1.useRelayResource)((0, $aN2bG.backlogRelayResource));
    const backlogQueryReference = response.queryReference;
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
        (0, $x9xyg.setMeasure)('use-resource', (0, $a64d16806d35fb92$export$b5f697f1279a473e), (0, $a64d16806d35fb92$export$a6940922387b16));
    }, ()=>!!backlogQueryReference);
    if (backlogQueryReference != null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "backlog-api-consumer-with-relay",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJzGl.NextGenBacklogSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerFallback), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHoqo.BacklogCriticalDataBoundary), {
        errorCaptureKey: backlogQueryReference.fetchKey.toString(),
        backlogRootQueryName: backlogQueryReference.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f08f0cc022f5d77$export$e14c6311549531c9, {
        backlogQueryReference: backlogQueryReference
    }))));
    return null;
};
var $9f08f0cc022f5d77$export$2e2bcd8739ae039 = $9f08f0cc022f5d77$export$180813d52fa33cf7;

});
parcelRegister("feJRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa35a5a19d0a4620$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $8Qrwl = parcelRequire("8Qrwl");
class $aa35a5a19d0a4620$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $dIdda = parcelRequire("dIdda");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("jgtyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d50d3b3c70ebfb2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<988f36c7e9bf3e951137674b9ef54912>>
 * @relayHash a2c0c16f16d55ac0bad51490b643bb96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba
const $2d50d3b3c70ebfb2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v11 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionFilterRelay_softwareFilters"
                                                    },
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7 /*: any*/ 
                                                                ]
                                                            },
                                                            v8 /*: any*/ 
                                                        ]
                                                    },
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewBacklogVersionFilterRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v12 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "viewBacklogVersionFilterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2d50d3b3c70ebfb2$var$node.hash = "816fe123d295a6d9e687adcba29002c6";
var $2d50d3b3c70ebfb2$export$2e2bcd8739ae039 = $2d50d3b3c70ebfb2$var$node;

});

parcelRegister("76Weg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ff35acd8df483e6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $hfc8j = parcelRequire("hfc8j");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $AeWM3 = parcelRequire("AeWM3");

var $aWb5p = parcelRequire("aWb5p");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $x9xyg = parcelRequire("x9xyg");

var $bRUzT = parcelRequire("bRUzT");

var $j2mQS = parcelRequire("j2mQS");

var $9pe79 = parcelRequire("9pe79");

var $4R6GH = parcelRequire("4R6GH");

var $97Kan = parcelRequire("97Kan");

var $joFsm = parcelRequire("joFsm");

var $3HwlS = parcelRequire("3HwlS");

var $95EVP = parcelRequire("95EVP");

var $8PRuf = parcelRequire("8PRuf");


var $hN2XX = parcelRequire("hN2XX");

var $bicfN = parcelRequire("bicfN");

var $dIdda = parcelRequire("dIdda");

var $10Ngv = parcelRequire("10Ngv");

var $9s7RG = parcelRequire("9s7RG");

var $f6RVN = parcelRequire("f6RVN");

var $5kotP = parcelRequire("5kotP");

var $guzeq = parcelRequire("guzeq");

var $cinXQ = parcelRequire("cinXQ");

var $3FUwR = parcelRequire("3FUwR");

var $81CEh = parcelRequire("81CEh");

var $5qbje = parcelRequire("5qbje");

var $gUpx5 = parcelRequire("gUpx5");

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $bNDq8 = parcelRequire("bNDq8");

var $c7Xu8 = parcelRequire("c7Xu8");

var $bI3co = parcelRequire("bI3co");

var $lHBhO = parcelRequire("lHBhO");

var $9OvEV = parcelRequire("9OvEV");

var $gshHs = parcelRequire("gshHs");

var $hzdKw = parcelRequire("hzdKw");

var $dM9vk = parcelRequire("dM9vk");
/**
 * Set performance marks for rendering performance
 */ function $5ff35acd8df483e6$var$measureRender() {
    (0, $x9xyg.setMark)('render:start');
    requestAnimationFrame(()=>{
        (0, $x9xyg.setMark)('render:end');
        (0, $x9xyg.setMeasure)('render', 'render:start', 'render:end');
    });
}
// eslint-disable-next-line jira/react/no-class-components
class $5ff35acd8df483e6$var$Backlog extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            isServer: false,
            isCompanyManaged: false,
            initialState: {}
        };
    }
    static getAppPropsFromProps(props) {
        return {
            locale: props.locale,
            baseUrl: props.baseUrl,
            rapidViewId: props.rapidViewId,
            isCompanyManaged: props.isCompanyManaged ?? false,
            xsrfToken: props.xsrfToken,
            projectKey: props.projectKey,
            projectId: props.projectId,
            projectName: props.projectName,
            cloudId: props.cloudId,
            atlassianAccountId: props.atlassianAccountId
        };
    }
    constructor(props){
        super(props);
        this.prefetchedData = null;
        this.hasRendered = false;
        this.onGetLocation = ()=>this.props.location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onPush = (path, state)=>{
            this.props.push(path, state);
        };
        const { isCompanyManaged: isCompanyManaged } = props;
        const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_CONSTRUCTOR_START));
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_REDUX_START));
        const rootEpic = (0, $cinXQ.default)(props.isServer, props.isCompanyManaged, ()=>this.props.location, props.push, props.replace, (0, $AeWM3.getClient)(props.baseUrl, (0, $aWb5p.default), props.xsrfToken));
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreStartMark));
        const createStoreOptions = {
            rootEpic: (0, $j2mQS.disposableEpic)(rootEpic),
            dependencies: {
                isCompanyManaged: isCompanyManaged,
                fetchDataFromAGG: props.getDataFromAGG,
                storeFieldsActions: props.storeFieldsActions,
                refetchVersionsForProjects: props.refetchVersionsForProjects,
                createAnalyticsEvent: props.createAnalyticsEvent
            }
        };
        this.store = (0, $c1MAf.createStoreWithCache)(props.rapidViewId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props.initialState ?? {}, {
            ...createStoreOptions,
            disableStoreCaches: props.disableStoreCaches ?? false
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreEndMark));
        (0, $x9xyg.setMeasure)('create-redux-store', (0, $8PRuf.jswCreateReduxStoreStartMark), (0, $8PRuf.jswCreateReduxStoreEndMark));
        this.store.dispatch((0, $3lZ6i.initializeAppProps)($5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(props)));
        // Fire multiple requests to get data for the board. GraphQL please save us.
        (0, $x9xyg.measureFunc)('loadAppData', ()=>{
            if (props.isCompanyManaged) {
                if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
                    if (props.prefetchCmpBacklogDataPromise) props.prefetchCmpBacklogDataPromise.then((data)=>{
                        this.store.dispatch((0, $3lZ6i.loadAppData)({
                            prefetchCmpBacklogData: data
                        }));
                    });
                    else this.store.dispatch((0, $3lZ6i.loadAppData)());
                } else if (props.prefetchedJiraPlanRestDataPromise) // TODO: Handle error
                props.prefetchedJiraPlanRestDataPromise.then((data)=>{
                    this.store.dispatch((0, $3lZ6i.loadAppData)({
                        prefetchedJiraPlanRestData: data
                    }));
                });
                else if (props.prefetchedJiraPlanRestData) this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedJiraPlanRestData: props.prefetchedJiraPlanRestData
                }));
                else this.store.dispatch((0, $3lZ6i.loadAppData)());
            } else if ((0, $f6RVN.isBacklogWithRelayEnabled)() && props.prefetchedAggData) this.store.dispatch((0, $3lZ6i.loadAppData)({
                prefetchedAggData: props.prefetchedAggData
            }));
            else if (props.prefetchedData) {
                this.prefetchedData = props.prefetchedData;
                this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedData: props.prefetchedData
                }));
            } else this.store.dispatch((0, $3lZ6i.loadAppData)());
        });
        (0, $x9xyg.measureFunc)('loadConfigData', ()=>{
            this.store.dispatch((0, $3lZ6i.loadConfigData)());
            this.store.dispatch((0, $c7Xu8.loadPriorities)());
            // This isn't required on the server, so it shouldn't be requested.
            if (!false) this.store.dispatch((0, $bI3co.requestCurrentUser)());
        });
        (0, $x9xyg.measureFunc)('setCollapsedCardLists', ()=>{
            const lists = (0, $3FUwR.getBacklogSettings)(Number(props.rapidViewId)).collapsedCardLists;
            if (lists) {
                const listsIds = Object.keys(lists);
                if (listsIds.length > 0) this.store.dispatch((0, $a7yHf.setCollapsedCardLists)(listsIds));
            }
        });
        (0, $x9xyg.measureFunc)('setCollapsedCardGroups', ()=>{
            const groups = (0, $3FUwR.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $a7yHf.setCollapsedCardGroups)(groupIds));
            }
        });
        (0, $x9xyg.measureFunc)('setExpandedCardGroups', ()=>{
            const groups = (0, $3FUwR.getBacklogCardGroupSettings)(Number(props.rapidViewId));
            if (groups) {
                const groupIds = Object.keys(groups);
                if (groupIds.length > 0) this.store.dispatch((0, $a7yHf.setExpandedCardGroups)(groupIds));
            }
        });
        (0, $x9xyg.measureFunc)('toggleHiddenLabels', ()=>{
            if (isCompanyManaged) {
                const willHideEpicLabels = (0, $81CEh.getHideEpics)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardEpicFields)(willHideEpicLabels));
                const willToggleStatusLabels = (0, $81CEh.getHideStatuses)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardStatusFields)(willToggleStatusLabels));
                const willToggleVersionLabels = (0, $81CEh.getHideVersions)(props.rapidViewId);
                this.store.dispatch((0, $bNDq8.toggleCardVersionFields)(willToggleVersionLabels));
            }
        });
        (0, $x9xyg.measureFunc)('setIncludeSubtasksInWorkloadModal', ()=>{
            if (isCompanyManaged) {
                const includeSubtasksLocal = (0, $3FUwR.getWorkloadSubtaskSettings)();
                this.store.dispatch((0, $lHBhO.setIncludeSubtasksAction)(includeSubtasksLocal));
            }
        });
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_REDUX_END));
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_CONSTRUCTOR_END));
    }
    componentDidMount() {
        this.hasRendered = true;
        (0, $5qbje.removeLocationLegacyPanelQueryParameters)(this.props.location, this.props.push);
        if ((0, $f6RVN.isBacklogWithRelayEnabled)() && this.props.isCacheHit) this.store.dispatch((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_ON_MOUNT)));
    }
    componentDidUpdate(prevProps) {
        const prevAppProps = $5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(prevProps);
        const appProps = $5ff35acd8df483e6$var$Backlog.getAppPropsFromProps(this.props);
        // If our resource cache data is different, load it up!!!
        // We fire a refresh on cached mount and it will proc this lifecycle event
        // See src/packages/spa-apps/nextgen-backlog/src/resources-cache-refresh
        if (!(0, $f6RVN.isBacklogWithRelayEnabled)() && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(prevProps.prefetchedData, this.props.prefetchedData)) // if this has a source key, and the key is the one we get from the resources
        // cache updater. Don't process it.
        {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.props.prefetchedData) && (!((0, $8631d6ce464ccf2e$export$889129cf7f70997b) in this.props.prefetchedData) || this.props.prefetchedData[0, $8631d6ce464ccf2e$export$889129cf7f70997b] !== (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1))) {
                // fires an analytics event to track that the cache is stale and will be updated
                (0, $hN2XX.triggerCacheRefreshAnalytics)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187));
                this.store.dispatch((0, $3lZ6i.loadAppData)({
                    prefetchedData: this.props.prefetchedData
                }));
            }
        }
        if ((0, $9pe79.default)(prevAppProps, appProps)) return;
        this.store.dispatch((0, $3lZ6i.initializeAppProps)(appProps));
    }
    componentWillUnmount() {
        if (this.store && this.store.dispatch) this.store.dispatch((0, $bRUzT.DISPOSE_ACTION));
        (0, $c1MAf.unmountCachedStore)();
    }
    renderContent() {
        const { rapidViewId: rapidViewId, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, prefetchedAggData: prefetchedAggData, prefetchedJiraPlanRestData: prefetchedJiraPlanRestData, prefetchCmpBacklogData: prefetchCmpBacklogData } = this.props;
        const inner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfc8j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OvEV.default), {
            isCacheHit: isCacheHit,
            prefetchedData: this.prefetchedData,
            prefetchedAggData: prefetchedAggData,
            prefetchedPlanData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? prefetchCmpBacklogData?.result : prefetchedJiraPlanRestData,
            getLocation: this.onGetLocation,
            push: this.onPush,
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })));
        const AppStyleComponent = (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $5ff35acd8df483e6$var$ContentAppStyle : (0, $lf2Au.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AppStyleComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gshHs.default), {
            boardId: Number(rapidViewId)
        }, inner), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $5kotP.flagsMapper)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bicfN.default), {
            origin: (0, $8631d6ce464ccf2e$export$dedbdcc35e955187)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joFsm.default), {
            getCustomData: (0, $gUpx5.getCustomDataForMemoryAnalyticsFromUrl)
        }));
    }
    render() {
        const { isCompanyManaged: isCompanyManaged } = this.props;
        const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
        if (!this.hasRendered) {
            (0, $x9xyg.setMark)((0, $8PRuf.jswRenderStartMark));
            metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_RENDER_START));
            $5ff35acd8df483e6$var$measureRender();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $guzeq.APP_ID),
            teamName: (0, $guzeq.TEAM_NAME),
            packageName: (0, $guzeq.PACKAGE_NAME),
            store: this.store,
            fallback: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1MAf.BacklogReduxProvider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzdKw.default), {
            bindToOnJiraGlobalIssueCreateClose: this.props.bindToOnJiraGlobalIssueCreateClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
            client: (0, $aWb5p.default)
        }, this.renderContent())));
    }
}
const $5ff35acd8df483e6$var$BacklogWrapper = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const storeFieldsActions = (0, $10Ngv.useStoreFields)();
    const refetchVersions = (0, $9s7RG.useVersionsRefetch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5ff35acd8df483e6$var$Backlog, {
        ...props,
        storeFieldsActions: storeFieldsActions,
        refetchVersionsForProjects: refetchVersions,
        createAnalyticsEvent: createAnalyticsEvent
    });
});
// withRouter types are wrong
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5ff35acd8df483e6$var$BacklogWithRouter = (0, $dIdda.withRouter)($5ff35acd8df483e6$var$BacklogWrapper);
var $5ff35acd8df483e6$export$2e2bcd8739ae039 = $5ff35acd8df483e6$var$BacklogWithRouter;
const $5ff35acd8df483e6$var$ContentAppStyle = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5ff35acd8df483e6$var$contentStyle
    }, children);
const $5ff35acd8df483e6$var$contentStyle = (0, $jJ1Sb.xcss)({
    font: 'font.body',
    height: 'inherit',
    letterSpacing: 'normal',
    display: 'contents'
});

});
parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("aWb5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6560d9e86b64da$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $43WKH = parcelRequire("43WKH");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $4tcSU = parcelRequire("4tcSU");

var $04zaL = parcelRequire("04zaL");

var $azkDJ = parcelRequire("azkDJ");

var $5uTwE = parcelRequire("5uTwE");



const $de6560d9e86b64da$var$retryLink = new (0, $lC4FX.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $04zaL.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $de6560d9e86b64da$var$errorLink = (0, $h4ppL.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'errorType'
            ], null);
            return (0, $04zaL.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $04zaL.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null);
        (0, $04zaL.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $de6560d9e86b64da$var$fragmentMatcher = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($5uTwE))
});
const $de6560d9e86b64da$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $de6560d9e86b64da$var$fragmentMatcher
};
const $de6560d9e86b64da$var$cache = new (0, $ivfDv.InMemoryCache)($de6560d9e86b64da$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $de6560d9e86b64da$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $de6560d9e86b64da$var$xsrfLink = ()=>(0, $43WKH.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $4tcSU.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $de6560d9e86b64da$var$clientCreator = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: 'SWAG',
        link: (0, $clSzL.ApolloLink).from([
            $de6560d9e86b64da$var$retryLink,
            $de6560d9e86b64da$var$xsrfLink(),
            $de6560d9e86b64da$var$errorLink,
            (0, $azkDJ.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($de6560d9e86b64da$var$cache),
            new (0, $JPsIz.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $de6560d9e86b64da$var$customFetch
            })
        ]),
        cache: $de6560d9e86b64da$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$de6560d9e86b64da$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $de6560d9e86b64da$var$clientCreator
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("43WKH", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $2f550436daecafe0$export$2f04de43fe27971a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $2f550436daecafe0$export$2f04de43fe27971a(setter) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        var request = (0, $3VFsf.__rest)(operation, []);
        return new (0, $clSzL.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $dJl1T = parcelRequire("dJl1T");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $dJl1T.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("azkDJ", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2beb653db54497a1$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bBkFW = parcelRequire("bBkFW");
const $2beb653db54497a1$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bBkFW.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("5uTwE", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$9249f8c63b854f95$export$2e2bcd8739ae039 = (0, $47bDC.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $gwIPs.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $gwIPs.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("bRUzT", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $b69e8859fbb50550$export$78be82e7e063a3fb);

const $b69e8859fbb50550$export$78be82e7e063a3fb = {
    type: (0, $167b7959815986d2$export$58387e80544dbf03)
};

});
const $167b7959815986d2$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("j2mQS", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $1c9d4320a4bfd294$export$e6b812e492b046b8);
parcelRequire("7qVV7");

const $1c9d4320a4bfd294$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $167b7959815986d2$export$58387e80544dbf03)));

});

parcelRegister("9pe79", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cb96a92cdfd43f$export$2e2bcd8739ae039);

var $0xdyK = parcelRequire("0xdyK");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$06cb96a92cdfd43f$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $0xdyK.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $0xdyK.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("0xdyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50cb723ebf4f109$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $c50cb723ebf4f109$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("joFsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45670090ce80d9dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $5jlQc = parcelRequire("5jlQc");
const $45670090ce80d9dc$var$MemoryObserver = ({ getCustomData: getCustomData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const memoryReporter = new (0, $5jlQc.PollingMemoryReporter)(createAnalyticsEvent, getCustomData);
        memoryReporter.start();
        memoryReporter.setBucketTimeouts();
        return ()=>{
            memoryReporter.stop();
            memoryReporter.clearBucketTimeouts();
        };
    }, [
        createAnalyticsEvent,
        getCustomData
    ]);
    return null;
};
var $45670090ce80d9dc$export$2e2bcd8739ae039 = $45670090ce80d9dc$var$MemoryObserver;

});
parcelRegister("5jlQc", function(module, exports) {

$parcel$export(module.exports, "PollingMemoryReporter", () => $621c8fa9757e42da$export$3e76404af7b93e06);

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");

var $4wNtT = parcelRequire("4wNtT");

var $aA83m = parcelRequire("aA83m");
const $621c8fa9757e42da$var$minMs = 60000; // number of ms in a minute
const $621c8fa9757e42da$export$54912f9240c8e5db = 20 * $621c8fa9757e42da$var$minMs;
const $621c8fa9757e42da$export$9f536c7d89257714 = [
    2 * $621c8fa9757e42da$var$minMs,
    10 * $621c8fa9757e42da$var$minMs
];
const $621c8fa9757e42da$export$c63950c55adb1607 = (createAnalyticsEvent, getCustomData)=>{
    try {
        const memoryUsageReport = (0, $aA83m.getMemoryUsageReport)();
        if (memoryUsageReport == null) return;
        const { sessionTime: sessionTime, performanceMemoryEntry: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } } = memoryUsageReport;
        const customData = getCustomData ? getCustomData() : {};
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'memory tracked', {
            bucket: (0, $4wNtT.memoryBucketHandler).getBucket(usedJSHeapSize),
            sessionTime: sessionTime,
            sessionTimeBucket: (0, $4wNtT.sessionTimeBucketHandler).getBucket(sessionTime),
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize,
            ...customData
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('observability.memory-metrics.measure-and-report-memory', 'Failed to poll for memory usage');
    }
};
class $621c8fa9757e42da$export$3e76404af7b93e06 {
    constructor(createAnalyticsEvent, getCustomData){
        this.pollInterval = null;
        this.bucketTimeouts = null;
        this.report = ()=>{
            $621c8fa9757e42da$export$c63950c55adb1607(this.createAnalyticsEvent, this.getCustomData);
        };
        this.onVisibilityChange = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const isHidden = window.document?.hidden === true;
            if (isHidden) this.stop();
            else {
                this.stop();
                this.start();
            }
        };
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.getCustomData = getCustomData;
    }
    start() {
        if (this.pollInterval != null) return;
        this.report();
        // @ts-expect-error - TS2322 - Type 'Timer' is not assignable to type 'number'.
        this.pollInterval = setInterval(()=>{
            if (this.pollInterval == null) return;
            this.report();
        }, $621c8fa9757e42da$export$54912f9240c8e5db);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    stop() {
        if (this.pollInterval != null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    setBucketTimeouts() {
        this.bucketTimeouts = $621c8fa9757e42da$export$9f536c7d89257714.map((ms)=>setTimeout(()=>{
                this.report();
            }, ms));
    }
    clearBucketTimeouts() {
        this.bucketTimeouts?.forEach((timeout)=>{
            clearTimeout(timeout);
        });
    }
}

});
parcelRegister("4wNtT", function(module, exports) {

$parcel$export(module.exports, "memoryBucketHandler", () => $2459a841a83bbb5c$export$26aac2ead17b35e5);
$parcel$export(module.exports, "sessionTimeBucketHandler", () => $2459a841a83bbb5c$export$af08fe8a31c89520);
class $2459a841a83bbb5c$export$a9fa854dd2f29162 {
    constructor(buckets, options){
        this.buckets = buckets;
        this.formatLabel = options?.formatLabel ?? ((low, high)=>`${low}-${high ?? 'Inf'}`);
    }
    /**
	 * Returns the lowest matching bucket for this measurement.
	 *
	 * For example, if buckets are [0, 10, 20, 30] and the measurement is 15,
	 * this function will return 10 meaning this measurement is in the 10-20
	 * range.
	 */ getBucket(measurement) {
        const bucketIndex = this.buckets.findIndex((bucket)=>measurement < bucket);
        if (bucketIndex < 0) return this.formatLabel(this.buckets[this.buckets.length - 1]);
        return this.formatLabel(this.buckets[bucketIndex - 1], this.buckets[bucketIndex]);
    }
}
const $2459a841a83bbb5c$var$mbBytes = 1048576; // number of bytes in a MB
const $2459a841a83bbb5c$var$minMs = 60000; // number of ms in a minute
const $2459a841a83bbb5c$export$26aac2ead17b35e5 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    100 * $2459a841a83bbb5c$var$mbBytes,
    200 * $2459a841a83bbb5c$var$mbBytes,
    400 * $2459a841a83bbb5c$var$mbBytes,
    800 * $2459a841a83bbb5c$var$mbBytes,
    1600 * $2459a841a83bbb5c$var$mbBytes,
    3200 * $2459a841a83bbb5c$var$mbBytes
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$mbBytes}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$mbBytes : 'Inf'}MB`
});
const $2459a841a83bbb5c$export$af08fe8a31c89520 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    2 * $2459a841a83bbb5c$var$minMs,
    5 * $2459a841a83bbb5c$var$minMs,
    10 * $2459a841a83bbb5c$var$minMs,
    20 * $2459a841a83bbb5c$var$minMs
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$minMs}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$minMs : 'Inf'}MIN`
});

});



parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


const $8631d6ce464ccf2e$export$9b8283d5878d2491 = 'BOARD';
const $8631d6ce464ccf2e$export$dedbdcc35e955187 = 'BACKLOG';
const $8631d6ce464ccf2e$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $8631d6ce464ccf2e$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8631d6ce464ccf2e$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $8631d6ce464ccf2e$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("hN2XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e79ffcea087bf1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $43e79ffcea087bf1$export$e78b5ce2eed37743);

var $cab1K = parcelRequire("cab1K");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics = new (0, $cab1K.Subject)();
var $43e79ffcea087bf1$export$2e2bcd8739ae039 = $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics;
const $43e79ffcea087bf1$export$e78b5ce2eed37743 = (origin)=>{
    $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});

parcelRegister("bicfN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c2dc8c17f1f21ea3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iqr2y = parcelRequire("iqr2y");

var $ddxdb = parcelRequire("ddxdb");

var $4NXqP = parcelRequire("4NXqP");

var $k3C5L = parcelRequire("k3C5L");
const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapper = ({ origin: origin })=>{
    (0, $ddxdb.default)(origin);
    (0, $k3C5L.default)();
    (0, $4NXqP.default)(origin);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c2dc8c17f1f21ea3$var$ResourcesCacheWrapper, props));
var $c2dc8c17f1f21ea3$export$2e2bcd8739ae039 = $c2dc8c17f1f21ea3$var$ResourcesCacheWrapperWithBoundary;

});
parcelRegister("ddxdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c7e4eef3bac87c$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $5uXOq = parcelRequire("5uXOq");
parcelRequire("7mHDu");
parcelRequire("1oQta");

var $8Uumt = parcelRequire("8Uumt");

var $koeKL = parcelRequire("koeKL");

var $dIdda = parcelRequire("dIdda");

var $b0yad = parcelRequire("b0yad");

var $8asTe = parcelRequire("8asTe");

var $77kqL = parcelRequire("77kqL");
/*
 * This hook is for handling when a change is performed that should invalidate the cache of another
 * resource. In the current case, the BOARD and BACKLOG caches are intertwined such that a major change
 * in the BOARD will invalidate the BACKLOG.
 */ const $18c7e4eef3bac87c$var$useResourcesCacheInvalidation = (origin)=>{
    const [resourcesRef] = (0, $8asTe.default)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ match: match }] = (0, $dIdda.useRouter)();
    const boardId = match.params.boardId || '';
    (0, $5uXOq.useEffect)(()=>{
        // We don't want to refresh every time we have a change. Instead we only tell it to refresh its cache
        // AFTER we leave. The reason for doing this is we get a fresh cached version AFTER we've done all
        // our actions (and we minimise the number of API calls)
        let needToClearResourcesCacheOnExit = false;
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $b0yad.default).filter((val)=>val === origin).take(1).subscribe(()=>{
            // If we get an invalidation specific to this page, we flush out the caches of
            // all other pages we have cached that could be impacted
            Object.keys(resourcesRef.current).filter((key)=>key !== origin).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Resource>>'.
                resourcesRef.current[key].clear();
            });
            // Invalidate the boardScope resource in the Relay store
            (0, $77kqL.invalidateRelayStore)(environment, cloudId, boardId);
            // If we are allowed to refresh this cache on exit, set the flag for it
            if (origin in resourcesRef.current) needToClearResourcesCacheOnExit = true;
        });
        return ()=>{
            subscription.unsubscribe();
            if (needToClearResourcesCacheOnExit && origin in resourcesRef.current) {
                // Clear out this cache after we leave so when we come back we get a more up to date version.
                resourcesRef.current[origin].clear();
                // Invalidate the boardScope resource in the Relay store
                (0, $77kqL.invalidateRelayStore)(environment, cloudId, boardId);
            }
        };
    }, [
        origin,
        resourcesRef,
        environment,
        cloudId,
        boardId
    ]);
    return [
        (0, $b0yad.default)
    ];
};
var $18c7e4eef3bac87c$export$2e2bcd8739ae039 = $18c7e4eef3bac87c$var$useResourcesCacheInvalidation;

});
parcelRegister("b0yad", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7966c085fcd143$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $0d7966c085fcd143$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $0d7966c085fcd143$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $0d7966c085fcd143$export$c5ab3b0612bd31b4);

var $cab1K = parcelRequire("cab1K");


var $h8O2U = parcelRequire("h8O2U");
const $0d7966c085fcd143$var$invalidationTracker = new (0, $h8O2U.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject = new (0, $cab1K.Subject)();
var $0d7966c085fcd143$export$2e2bcd8739ae039 = $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject;
const $0d7966c085fcd143$export$76c3549b2288ab5d = (origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6))=>{
    $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject.next(origin);
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$77045c8772786aca = (origin, reason)=>{
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$c5ab3b0612bd31b4 = (origin)=>$0d7966c085fcd143$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("h8O2U", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $42c3911f8f33a9e0$export$71900622f425a7c3);

class $42c3911f8f33a9e0$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $8631d6ce464ccf2e$export$9b8283d5878d2491)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$dedbdcc35e955187)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});


parcelRegister("8asTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c43deb1cb1e63c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5qQ9I = parcelRequire("5qQ9I");

var $bAB30 = parcelRequire("bAB30");

var $jsFU4 = parcelRequire("jsFU4");

var $dIdda = parcelRequire("dIdda");

// We only ever want refresh and update in this component
// @ts-expect-error - TS7031 - Binding element 'update' implicitly has an 'any' type. | TS7031 - Binding element 'refresh' implicitly has an 'any' type. | TS7031 - Binding element 'clear' implicitly has an 'any' type.
const $7c43deb1cb1e63c2$var$buildResource = ({ update: update, refresh: refresh, clear: clear })=>({
        update: update,
        refresh: refresh,
        clear: clear
    });
/*
 * Simple hook that wraps the commonly used JSW resources in a dictionary and returns them
 */ const $7c43deb1cb1e63c2$var$useResourcesCacheTracker = ()=>{
    const boardResource = (0, $dIdda.useResource)((0, $5qQ9I.boardResource));
    const backlogResource = (0, $dIdda.useResource)((0, $bAB30.backlogResource));
    const roadmapResource = (0, $dIdda.useResource)((0, $jsFU4.nextGenRoadmapResource));
    // Store the retrieved objects in an internal state. The reason for doing this is because when our routes
    // change, the objects returned from useResource appear to change as well. We don't want/need that.
    const resourcesByOriginByRef = (0, $5uXOq.useRef)({});
    (0, $5uXOq.useEffect)(()=>{
        resourcesByOriginByRef.current = {
            [(0, $b982f18ac4600ef5$export$9b8283d5878d2491)]: $7c43deb1cb1e63c2$var$buildResource(boardResource),
            [(0, $b982f18ac4600ef5$export$dedbdcc35e955187)]: $7c43deb1cb1e63c2$var$buildResource(backlogResource),
            [(0, $b982f18ac4600ef5$export$ffff0a2c60bf4822)]: $7c43deb1cb1e63c2$var$buildResource(roadmapResource)
        };
    }, [
        boardResource,
        backlogResource,
        roadmapResource
    ]);
    // @ts-expect-error - TS2322 - Type 'MutableRefObject<{}>' is not assignable to type 'ResourcesDictionary'.
    return [
        resourcesByOriginByRef
    ];
};
var $7c43deb1cb1e63c2$export$2e2bcd8739ae039 = $7c43deb1cb1e63c2$var$useResourcesCacheTracker;

});
const $b982f18ac4600ef5$export$9b8283d5878d2491 = 'BOARD';
const $b982f18ac4600ef5$export$dedbdcc35e955187 = 'BACKLOG';
const $b982f18ac4600ef5$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $b982f18ac4600ef5$export$78244dbb77cfa6b6 = 'UNKNOWN';


parcelRegister("77kqL", function(module, exports) {

$parcel$export(module.exports, "invalidateRelayStore", () => $27e06e0f0fab949e$export$fac5cf9145049c1c);

var $dXq4S = parcelRequire("dXq4S");
const $27e06e0f0fab949e$export$fac5cf9145049c1c = (environment, cloudId, boardId)=>{
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: boardId
    });
    environment.commitUpdate((store)=>{
        const boardScopeRecord = store.getRoot().getLinkedRecord('boardScope', {
            boardId: boardAri
        });
        if (boardScopeRecord) boardScopeRecord.invalidateRecord();
    });
};

});


parcelRegister("4NXqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0697b27d8d29769e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("1oQta");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hN2XX = parcelRequire("hN2XX");
/*
 * This hook is for firing an analytics event to track whether the cache is stale
 * It will be fired when we load a cache but the cache is stale and later gets updated
 */ const $0697b27d8d29769e$var$useCacheRefreshAnalytics = (origin)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const subscription = (0, $hN2XX.default).filter((val)=>val === origin).subscribe(()=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'resourcesCacheInvalidator updatedStaleData', {
                origin: origin
            });
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        createAnalyticsEvent,
        origin
    ]);
    return [
        (0, $hN2XX.default)
    ];
};
var $0697b27d8d29769e$export$2e2bcd8739ae039 = $0697b27d8d29769e$var$useCacheRefreshAnalytics;

});

parcelRegister("k3C5L", function(module, exports) {

$parcel$export(module.exports, "default", () => $47581646a47d84d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");
parcelRequire("1oQta");


var $gBFyV = parcelRequire("gBFyV");

var $8asTe = parcelRequire("8asTe");
/*
 * Note this is only really used to handle real-time updates or any other methods of updating the cache
 */ const $47581646a47d84d9$var$useResourcesCacheUpdater = ()=>{
    // Use a local resources cache to track all the useResource instances for each key
    const [resourcesByRef] = (0, $8asTe.default)();
    (0, $5uXOq.useEffect)(()=>{
        // We only need to proc this once and then we don't care about any further invalidation events
        const subscription = (0, $gBFyV.default).filter((msg)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(msg.origin)).subscribe((msg)=>{
            // Only handle this update if we have the resources in our dictionary
            if (msg.origin in resourcesByRef.current) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(msg.payload)) resourcesByRef.current[msg.origin].clear();
                else // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type '(currentData: any) => any' is not assignable to parameter of type '() => null'. | TS7006 - Parameter 'currentData' implicitly has an 'any' type.
                resourcesByRef.current[msg.origin].update((currentData)=>({
                        ...currentData,
                        ...msg.payload,
                        // Metadata to tell us where this actually came from
                        [(0, $8631d6ce464ccf2e$export$889129cf7f70997b)]: (0, $8631d6ce464ccf2e$export$b7dfe28569b170a1)
                    }));
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        resourcesByRef
    ]);
    return [
        (0, $gBFyV.default)
    ];
};
var $47581646a47d84d9$export$2e2bcd8739ae039 = $47581646a47d84d9$var$useResourcesCacheUpdater;

});
parcelRegister("gBFyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bba9321b275587$export$2e2bcd8739ae039);

var $cab1K = parcelRequire("cab1K");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$48bba9321b275587$export$2e2bcd8739ae039 = new (0, $cab1K.Subject)();

});



parcelRegister("10Ngv", function(module, exports) {

$parcel$export(module.exports, "getExtractedFields", () => $c9327b9d7a8ceb5b$export$44c042f94120778f);
$parcel$export(module.exports, "useStoreFields", () => $c9327b9d7a8ceb5b$export$52c92ba3608fca57);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $x9xyg = parcelRequire("x9xyg");

var $3fAi8 = parcelRequire("3fAi8");

var $9zRWV = parcelRequire("9zRWV");

var $kzhoX = parcelRequire("kzhoX");
const $c9327b9d7a8ceb5b$export$44c042f94120778f = (0, $8QpSo.default)((extractedCustomFields)=>Object.values(extractedCustomFields).reduce((extractedFields, extractedCustomFieldId)=>{
        const extractedCustomField = extractedCustomFieldId || '';
        if (extractedCustomField) extractedFields.push(extractedCustomField);
        return extractedFields;
    }, [
        ...(0, $9zRWV.extractedFixedFields)
    ]));
const $c9327b9d7a8ceb5b$export$52c92ba3608fca57 = ({ issueParents: issueParents } = {})=>{
    const [, fieldsValueActions] = (0, $3fAi8.useFieldsValuesActions)();
    const storeFieldsActions = (0, $5uXOq.useMemo)(()=>{
        const storeFieldsFromCardCreateData = (cardCreateData, fieldConfigs)=>{
            (0, $kzhoX.mergeFieldsFromCardCreateData)(cardCreateData, fieldsValueActions, fieldConfigs, issueParents);
        };
        const storeFieldsFromFetchIssuesData = (issues, epicIssueType)=>{
            (0, $x9xyg.measureFunc)('storeFieldsFromFetchIssuesData', ()=>{
                (0, $kzhoX.mergeFieldsFromFetchIssuesData)(issues, fieldsValueActions, epicIssueType);
            });
        };
        const storeFieldsFromPrefetchedData = (prefetchedData, fieldConfigs)=>(0, $x9xyg.measureFunc)('storeFieldsFromPrefetchedData', ()=>{
                (0, $kzhoX.mergeFieldsFromPrefetchedData)(prefetchedData, fieldsValueActions, fieldConfigs);
            });
        const storeFieldsFromPrefetchedAggData = (prefetchedAggData, fieldConfigs)=>(0, $x9xyg.measureFunc)('storeFieldsFromPrefetchedAggData', ()=>{
                (0, $kzhoX.mergeFieldsFromPrefetchedAggData)(prefetchedAggData, fieldsValueActions, fieldConfigs);
            });
        const storeFieldsFromPrefetchedPlanData = (prefetchedJiraPlanRestData, epicIssueType)=>(0, $x9xyg.measureFunc)('storeFieldsFromPrefetchedJiraPlanRestData', ()=>{
                (0, $kzhoX.mergeFieldsFromPrefetchedJiraPlanData)(prefetchedJiraPlanRestData, fieldsValueActions, epicIssueType);
            });
        return {
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData,
            storeFieldsFromPrefetchedAggData: storeFieldsFromPrefetchedAggData,
            storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData
        };
    }, [
        fieldsValueActions,
        issueParents
    ]);
    return storeFieldsActions;
};

});
parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $ddbc380ab4ee430c$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $7JoAD = parcelRequire("7JoAD");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $7JoAD.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $7JoAD.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $7JoAD.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("9zRWV", function(module, exports) {

$parcel$export(module.exports, "extractedFixedFields", () => $fe0974115005346b$export$302ef72acec731a7);

var $5fc53 = parcelRequire("5fc53");

const $fe0974115005346b$export$302ef72acec731a7 = [
    (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
    (0, $e9be48d6d2c01760$export$4420b7468f889692),
    (0, $e9be48d6d2c01760$export$e18419056f3d184a),
    (0, $5fc53.PRIORITY_TYPE),
    (0, $5fc53.PARENT_TYPE),
    (0, $5fc53.HIERARCHY_LEVEL_ABOVE)
];

});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';


parcelRegister("kzhoX", function(module, exports) {

$parcel$export(module.exports, "mergeFieldsFromCardCreateData", () => $15fdca5a32d65b6b$export$d2f0044e31dbf46e);
$parcel$export(module.exports, "mergeFieldsFromFetchIssuesData", () => $15fdca5a32d65b6b$export$934909337e38984d);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedData", () => $15fdca5a32d65b6b$export$ccb35cdb8dc761f5);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedAggData", () => $15fdca5a32d65b6b$export$eb61dff658e38dce);
$parcel$export(module.exports, "mergeFieldsFromPrefetchedJiraPlanData", () => $15fdca5a32d65b6b$export$6503472ec8a310fa);

var $kPH5D = parcelRequire("kPH5D");

var $4Xk2W = parcelRequire("4Xk2W");

var $dPSWJ = parcelRequire("dPSWJ");

var $iHPnC = parcelRequire("iHPnC");

var $fhSLy = parcelRequire("fhSLy");

var $7Fute = parcelRequire("7Fute");

var $44VbI = parcelRequire("44VbI");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");


var $dpWCZ = parcelRequire("dpWCZ");

var $f01qr = parcelRequire("f01qr");
const $15fdca5a32d65b6b$var$toFieldAccessibleValues = (fields = [])=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))((0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, (/*@__PURE__*/$parcel$interopDefault($kPH5D)))(fields, ({ isFieldAccessible: isFieldAccessible })=>isFieldAccessible), ({ fieldKey: fieldKey })=>fieldKey), ({ fieldValue: fieldValue })=>fieldValue);
const $15fdca5a32d65b6b$export$599b8b9cc9396260 = ({ issue: { assignee: assignee, status: status, summary: summary }, priority: priority, parentId: parentId, ...restOfTheCard }, { storyPointFieldId: storyPointFieldId }, issueParents)=>{
    const estimate = 'estimate' in restOfTheCard ? restOfTheCard.estimate : null;
    // NOTE: Pre-populated fields should follow the same logic as how they are handled in syncing (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
    const StoryPointKey = storyPointFieldId || '';
    const parentValue = parentId && issueParents?.length ? issueParents.find(({ id: id })=>Number(id) === Number(parentId)) : null;
    const issueParentType = issueParents?.length ? issueParents[0].issueType : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimate),
            fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
            fieldValue: estimate?.originalEstimate?.value ?? null
        },
        {
            isFieldAccessible: Boolean(StoryPointKey && estimate),
            fieldKey: StoryPointKey,
            fieldValue: estimate?.storyPoints ?? null
        },
        {
            isFieldAccessible: Boolean(status && status.id),
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692),
            fieldValue: (0, $44VbI.getStatusShape)(status.id, status.name, status.category)
        },
        {
            isFieldAccessible: Boolean(assignee && assignee.accountId),
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a),
            fieldValue: (0, $fhSLy.getUserShape)(assignee?.accountId || '', assignee?.displayName || '', assignee?.avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priority && priority.name),
            fieldKey: (0, $5fc53.PRIORITY_TYPE),
            fieldValue: priority
        },
        {
            isFieldAccessible: Boolean(parentValue && parentId),
            fieldKey: (0, $5fc53.PARENT_TYPE),
            fieldValue: parentValue ? (0, $7Fute.getParentShape)(parentValue.id, parentValue.key, parentValue.summary, {
                id: parentValue.issueType.id,
                name: parentValue.issueType.name,
                iconUrl: parentValue.issueType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(issueParentType),
            fieldKey: (0, $5fc53.HIERARCHY_LEVEL_ABOVE),
            fieldValue: issueParentType ? (0, $7Fute.getHierarchyShape)({
                id: issueParentType.id,
                name: issueParentType.name,
                iconUrl: issueParentType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $15fdca5a32d65b6b$var$toFieldAccessibleValues(fields);
};
const $15fdca5a32d65b6b$export$de671f46cd9f407c = (issue, epicIssueType)=>{
    const { summary: summary, status: status, assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl, priorityName: priorityName, priorityUrl: priorityUrl, estimateStatistic: estimateStatistic } = issue;
    const epicField = (0, $dpWCZ.hasEpicField)(issue) && (0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel) ? issue.epicField : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimateStatistic?.statFieldId),
            fieldKey: estimateStatistic?.statFieldId ?? '',
            fieldValue: estimateStatistic?.statFieldValue?.value ?? null
        },
        {
            isFieldAccessible: Boolean(status?.id),
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692),
            fieldValue: (0, $44VbI.getStatusShape)(status.id, status.name, status.statusCategory.key)
        },
        {
            isFieldAccessible: Boolean(assigneeAccountId && assigneeName && avatarUrl),
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a),
            fieldValue: (0, $fhSLy.getUserShape)(assigneeAccountId || '', assigneeName || '', avatarUrl)
        },
        {
            isFieldAccessible: Boolean(priorityName && priorityUrl),
            fieldKey: (0, $5fc53.PRIORITY_TYPE),
            fieldValue: {
                name: priorityName,
                iconUrl: priorityUrl
            }
        },
        {
            isFieldAccessible: Boolean((0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $5fc53.PARENT_TYPE),
            fieldValue: epicField ? (0, $7Fute.getParentShape)((0, $f01qr.getIdFromAri)(String(epicField.issueId)), epicField.epicKey, epicField.summary || epicField.text, {
                id: epicField.issueTypeId,
                name: epicField.label,
                iconUrl: epicField.issueTypeIconUrl
            }, (0, $iHPnC.asColor)(epicField.color || epicField.epicColor)) : null
        },
        {
            isFieldAccessible: Boolean((0, $g4tDr.isBaseHierarchyLevel)(issue.typeHierarchyLevel)),
            fieldKey: (0, $5fc53.HIERARCHY_LEVEL_ABOVE),
            fieldValue: epicField || epicIssueType ? (0, $7Fute.getHierarchyShape)({
                id: epicField?.issueTypeId ?? epicIssueType?.id,
                name: epicField?.label ?? epicIssueType?.name,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                iconUrl: epicField?.issueTypeIconUrl ?? epicIssueType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $15fdca5a32d65b6b$var$toFieldAccessibleValues(fields);
};
const $15fdca5a32d65b6b$export$62abca6d719f7b31 = (card, { storyPointFieldId: storyPointFieldId }, cardParents)=>{
    const estimate = 'estimate' in card ? card.estimate : null;
    // NOTE: Pre-populated fields should follow the same logic as how they are handled in syncing (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
    const StoryPointKey = storyPointFieldId || '';
    const { status: status, assignee: assignee, priority: priority, parentId: parentId, summary: summary } = card;
    const parentValue = parentId && cardParents?.length ? cardParents.filter(Boolean).find(({ id: id })=>id === parentId) : null;
    const filteredCardParents = cardParents?.filter(Boolean);
    const cardParentCardType = filteredCardParents?.length ? filteredCardParents[0].cardType : null;
    const fields = [
        {
            isFieldAccessible: Boolean(estimate),
            fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
            fieldValue: estimate?.originalEstimate?.value ?? null
        },
        {
            isFieldAccessible: Boolean(StoryPointKey && estimate),
            fieldKey: StoryPointKey,
            fieldValue: estimate?.storyPoints ?? null
        },
        {
            isFieldAccessible: Boolean(status && status.id),
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692),
            // @ts-expect-error TS2322: Type 'string' is not assignable to type 'StatusCategoryKeys'.
            fieldValue: (0, $44VbI.getStatusShape)(status.id, status.name, status.category)
        },
        {
            isFieldAccessible: Boolean(assignee && assignee.accountId),
            fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a),
            fieldValue: (0, $fhSLy.getUserShape)(assignee?.accountId || '', assignee?.name || '', assignee?.picture)
        },
        {
            isFieldAccessible: Boolean(priority && priority.name),
            fieldKey: (0, $5fc53.PRIORITY_TYPE),
            fieldValue: priority
        },
        {
            isFieldAccessible: Boolean(parentValue && parentId),
            fieldKey: (0, $5fc53.PARENT_TYPE),
            fieldValue: parentValue ? (0, $7Fute.getParentShape)((0, $f01qr.getIdFromAri)(parentValue.id), parentValue.key, parentValue.summary, {
                id: parentValue.cardType.id,
                name: parentValue.cardType.name,
                iconUrl: parentValue.cardType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(cardParentCardType),
            fieldKey: (0, $5fc53.HIERARCHY_LEVEL_ABOVE),
            fieldValue: cardParentCardType ? (0, $7Fute.getHierarchyShape)({
                id: cardParentCardType.id,
                name: cardParentCardType.name,
                iconUrl: cardParentCardType.iconUrl
            }) : null
        },
        {
            isFieldAccessible: Boolean(summary),
            fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f),
            fieldValue: summary ?? null
        }
    ];
    return $15fdca5a32d65b6b$var$toFieldAccessibleValues(fields);
};
const $15fdca5a32d65b6b$export$d2f0044e31dbf46e = (cardCreateData, { mergeIssues: mergeIssues }, fieldConfigs, issueParents)=>{
    if (!cardCreateData?.planModeCardCreate) return;
    const { newCards: newCards } = cardCreateData.planModeCardCreate;
    if (newCards && newCards.length) {
        const issuesWithFields = newCards.map((card)=>{
            const fieldValues = $15fdca5a32d65b6b$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$934909337e38984d = (issues, { mergeIssues: mergeIssues }, epicIssueType)=>{
    if (issues && issues.length) {
        const issuesWithFields = issues.map((issue)=>{
            const fieldValues = $15fdca5a32d65b6b$export$de671f46cd9f407c(issue, epicIssueType);
            return {
                [issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$ccb35cdb8dc761f5 = (prefetchedData, { mergeIssues: mergeIssues }, fieldConfigs)=>{
    if (!prefetchedData?.boardScope) return;
    const { backlog: { cards: backlogCards }, board: { cards: boardCards, issueParents: issueParents }, sprints: sprints } = prefetchedData.boardScope;
    const cards = sprints.reduce((allCards, { cards: sprintCards })=>[
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...allCards,
            ...sprintCards
        ], [
        ...backlogCards,
        ...boardCards
    ]);
    if (cards.length) {
        const issuesWithFields = cards.map((card)=>{
            const fieldValues = $15fdca5a32d65b6b$export$599b8b9cc9396260(card, fieldConfigs, issueParents);
            return {
                [card.issue.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$eb61dff658e38dce = (prefetchedAggData, { mergeIssues: mergeIssues }, fieldConfigs)=>{
    if (!prefetchedAggData) return;
    const { backlog: backlog, board: { cards: boardCards }, sprints: sprints, cardParents: cardParents } = prefetchedAggData.boardScope;
    const backlogCards = backlog?.cards || [];
    const sprintCards = sprints.filter(Boolean).flatMap((sprint)=>sprint.cards);
    const cards = [
        ...backlogCards.filter(Boolean),
        ...boardCards.filter(Boolean),
        ...sprintCards.filter(Boolean)
    ];
    if (cards.length) {
        const issuesWithFields = cards.map((card)=>{
            const fieldValues = $15fdca5a32d65b6b$export$62abca6d719f7b31(card, fieldConfigs, cardParents.filter(Boolean));
            return {
                [card.key]: fieldValues
            };
        });
        mergeIssues(issuesWithFields);
    }
};
const $15fdca5a32d65b6b$export$6503472ec8a310fa = (prefetchedJiraPlanRestData, fieldValueServiceActions, epicIssueType)=>{
    if (!prefetchedJiraPlanRestData) return;
    const { issues: issues } = prefetchedJiraPlanRestData;
    $15fdca5a32d65b6b$export$934909337e38984d(issues, fieldValueServiceActions, epicIssueType);
};

});
parcelRegister("kPH5D", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $8BRGu = parcelRequire("8BRGu");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f2a9fed894a6616c$var$filter(collection, predicate) {
    var func = $8LQ84(collection) ? $2GdQn : $8BRGu;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $f2a9fed894a6616c$var$filter;

});
parcelRegister("8BRGu", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $644b6c0ae483a6c5$var$baseFilter(collection, predicate) {
    var result = [];
    $e7pfQ(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $644b6c0ae483a6c5$var$baseFilter;

});


parcelRegister("4Xk2W", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
    $1m3dq(result, key, value);
});
module.exports = $39bc38f0156cacc0$var$keyBy;

});

parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});

parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ggSx2 = parcelRequire("ggSx2");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");

var $kFsv3 = parcelRequire("kFsv3");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $kFsv3.Colors).PURPLE;
    if (color in (0, $kFsv3.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $kFsv3.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $kFsv3.ServerColors).SERVER_PURPLE;
    if (color in (0, $kFsv3.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $kFsv3.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
    if (color in (0, $kFsv3.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $kFsv3.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $kFsv3.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $kFsv3.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $kFsv3.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $kFsv3.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $kFsv3.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $kFsv3 = parcelRequire("kFsv3");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $kFsv3.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $5e0c0d4e15efb4a6$exports).P200})`,
    [(0, $kFsv3.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
    [(0, $kFsv3.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
    [(0, $kFsv3.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $5e0c0d4e15efb4a6$exports).T200})`,
    [(0, $kFsv3.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
    [(0, $kFsv3.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R200})`,
    [(0, $kFsv3.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
    [(0, $kFsv3.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $5e0c0d4e15efb4a6$exports).P400})`,
    [(0, $kFsv3.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
    [(0, $kFsv3.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $5e0c0d4e15efb4a6$exports).G400})`,
    [(0, $kFsv3.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $5e0c0d4e15efb4a6$exports).T400})`,
    [(0, $kFsv3.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y400})`,
    [(0, $kFsv3.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
    [(0, $kFsv3.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $5e0c0d4e15efb4a6$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $5e0c0d4e15efb4a6$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $5e0c0d4e15efb4a6$exports).P200})`,
    [(0, $5e0c0d4e15efb4a6$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
    [(0, $5e0c0d4e15efb4a6$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
    [(0, $5e0c0d4e15efb4a6$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $5e0c0d4e15efb4a6$exports).T200})`,
    [(0, $5e0c0d4e15efb4a6$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
    [(0, $5e0c0d4e15efb4a6$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R200})`,
    [(0, $5e0c0d4e15efb4a6$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
    [(0, $5e0c0d4e15efb4a6$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $5e0c0d4e15efb4a6$exports).P400})`,
    [(0, $5e0c0d4e15efb4a6$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
    [(0, $5e0c0d4e15efb4a6$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $5e0c0d4e15efb4a6$exports).G400})`,
    [(0, $5e0c0d4e15efb4a6$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $5e0c0d4e15efb4a6$exports).T400})`,
    [(0, $5e0c0d4e15efb4a6$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y400})`,
    [(0, $5e0c0d4e15efb4a6$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
    [(0, $5e0c0d4e15efb4a6$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $5e0c0d4e15efb4a6$exports).N700})`
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $kFsv3.SERVER_PURPLE)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.SERVER_DARK_PURPLE)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.SERVER_BLUE)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.SERVER_DARK_BLUE)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.SERVER_GREEN)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.SERVER_DARK_GREEN)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.SERVER_TEAL)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.SERVER_DARK_TEAL)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.SERVER_YELLOW)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.SERVER_DARK_YELLOW)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.SERVER_ORANGE)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.SERVER_DARK_ORANGE)]: (0, $kFsv3.DARK_ORANGE),
    [(0, $kFsv3.SERVER_GREY)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.SERVER_DARK_GREY)]: (0, $kFsv3.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $kFsv3.AGILE_COLOR_1)]: (0, $kFsv3.DARK_GREY),
    [(0, $kFsv3.AGILE_COLOR_2)]: (0, $kFsv3.DARK_YELLOW),
    [(0, $kFsv3.AGILE_COLOR_3)]: (0, $kFsv3.YELLOW),
    [(0, $kFsv3.AGILE_COLOR_4)]: (0, $kFsv3.DARK_BLUE),
    [(0, $kFsv3.AGILE_COLOR_5)]: (0, $kFsv3.DARK_TEAL),
    [(0, $kFsv3.AGILE_COLOR_6)]: (0, $kFsv3.GREEN),
    [(0, $kFsv3.AGILE_COLOR_7)]: (0, $kFsv3.PURPLE),
    [(0, $kFsv3.AGILE_COLOR_8)]: (0, $kFsv3.DARK_PURPLE),
    [(0, $kFsv3.AGILE_COLOR_9)]: (0, $kFsv3.ORANGE),
    [(0, $kFsv3.AGILE_COLOR_10)]: (0, $kFsv3.BLUE),
    [(0, $kFsv3.AGILE_COLOR_11)]: (0, $kFsv3.TEAL),
    [(0, $kFsv3.AGILE_COLOR_12)]: (0, $kFsv3.GREY),
    [(0, $kFsv3.AGILE_COLOR_13)]: (0, $kFsv3.DARK_GREEN),
    [(0, $kFsv3.AGILE_COLOR_14)]: (0, $kFsv3.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $kFsv3.GHX_LABEL_1)]: (0, $kFsv3.AGILE_COLOR_1),
    [(0, $kFsv3.GHX_LABEL_2)]: (0, $kFsv3.AGILE_COLOR_2),
    [(0, $kFsv3.GHX_LABEL_3)]: (0, $kFsv3.AGILE_COLOR_3),
    [(0, $kFsv3.GHX_LABEL_4)]: (0, $kFsv3.AGILE_COLOR_4),
    [(0, $kFsv3.GHX_LABEL_5)]: (0, $kFsv3.AGILE_COLOR_5),
    [(0, $kFsv3.GHX_LABEL_6)]: (0, $kFsv3.AGILE_COLOR_6),
    [(0, $kFsv3.GHX_LABEL_7)]: (0, $kFsv3.AGILE_COLOR_7),
    [(0, $kFsv3.GHX_LABEL_8)]: (0, $kFsv3.AGILE_COLOR_8),
    [(0, $kFsv3.GHX_LABEL_9)]: (0, $kFsv3.AGILE_COLOR_9),
    [(0, $kFsv3.GHX_LABEL_10)]: (0, $kFsv3.AGILE_COLOR_10),
    [(0, $kFsv3.GHX_LABEL_11)]: (0, $kFsv3.AGILE_COLOR_11),
    [(0, $kFsv3.GHX_LABEL_12)]: (0, $kFsv3.AGILE_COLOR_12),
    [(0, $kFsv3.GHX_LABEL_13)]: (0, $kFsv3.AGILE_COLOR_13),
    [(0, $kFsv3.GHX_LABEL_14)]: (0, $kFsv3.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $kFsv3.DARK_GREY)]: 'grey',
    [(0, $kFsv3.DARK_YELLOW)]: 'yellow',
    [(0, $kFsv3.YELLOW)]: 'yellowLight',
    [(0, $kFsv3.DARK_BLUE)]: 'blue',
    [(0, $kFsv3.DARK_TEAL)]: 'teal',
    [(0, $kFsv3.GREEN)]: 'greenLight',
    [(0, $kFsv3.PURPLE)]: 'purpleLight',
    [(0, $kFsv3.DARK_PURPLE)]: 'purple',
    [(0, $kFsv3.ORANGE)]: 'redLight',
    [(0, $kFsv3.BLUE)]: 'blueLight',
    [(0, $kFsv3.TEAL)]: 'tealLight',
    [(0, $kFsv3.GREY)]: 'greyLight',
    [(0, $kFsv3.DARK_GREEN)]: 'green',
    [(0, $kFsv3.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $kFsv3.AGILE_COLOR_1)]: 'grey',
    [(0, $kFsv3.AGILE_COLOR_2)]: 'yellow',
    [(0, $kFsv3.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $kFsv3.AGILE_COLOR_4)]: 'blue',
    [(0, $kFsv3.AGILE_COLOR_5)]: 'teal',
    [(0, $kFsv3.AGILE_COLOR_6)]: 'greenLight',
    [(0, $kFsv3.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $kFsv3.AGILE_COLOR_8)]: 'purple',
    [(0, $kFsv3.AGILE_COLOR_9)]: 'redLight',
    [(0, $kFsv3.AGILE_COLOR_10)]: 'blueLight',
    [(0, $kFsv3.AGILE_COLOR_11)]: 'tealLight',
    [(0, $kFsv3.AGILE_COLOR_12)]: 'greyLight',
    [(0, $kFsv3.AGILE_COLOR_13)]: 'green',
    [(0, $kFsv3.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $kFsv3.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $5e0c0d4e15efb4a6$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $5e0c0d4e15efb4a6$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $5e0c0d4e15efb4a6$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $5e0c0d4e15efb4a6$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $5e0c0d4e15efb4a6$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $5e0c0d4e15efb4a6$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $5e0c0d4e15efb4a6$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $5e0c0d4e15efb4a6$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $5e0c0d4e15efb4a6$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $5e0c0d4e15efb4a6$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $5e0c0d4e15efb4a6$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $5e0c0d4e15efb4a6$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $5e0c0d4e15efb4a6$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $5e0c0d4e15efb4a6$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $5e0c0d4e15efb4a6$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $5e0c0d4e15efb4a6$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $5e0c0d4e15efb4a6$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $5e0c0d4e15efb4a6$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $5e0c0d4e15efb4a6$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $5e0c0d4e15efb4a6$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $5e0c0d4e15efb4a6$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $5e0c0d4e15efb4a6$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $5e0c0d4e15efb4a6$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $5e0c0d4e15efb4a6$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $5e0c0d4e15efb4a6$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $5e0c0d4e15efb4a6$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $5e0c0d4e15efb4a6$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $5e0c0d4e15efb4a6$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $5e0c0d4e15efb4a6$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $5e0c0d4e15efb4a6$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $5e0c0d4e15efb4a6$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $5e0c0d4e15efb4a6$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $5e0c0d4e15efb4a6$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $kFsv3.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $5e0c0d4e15efb4a6$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $5e0c0d4e15efb4a6$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $5e0c0d4e15efb4a6$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $5e0c0d4e15efb4a6$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $5e0c0d4e15efb4a6$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $5e0c0d4e15efb4a6$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $5e0c0d4e15efb4a6$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $5e0c0d4e15efb4a6$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $5e0c0d4e15efb4a6$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $5e0c0d4e15efb4a6$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $5e0c0d4e15efb4a6$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $5e0c0d4e15efb4a6$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $5e0c0d4e15efb4a6$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $5e0c0d4e15efb4a6$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $5e0c0d4e15efb4a6$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $5e0c0d4e15efb4a6$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $5e0c0d4e15efb4a6$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $5e0c0d4e15efb4a6$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $5e0c0d4e15efb4a6$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $5e0c0d4e15efb4a6$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $5e0c0d4e15efb4a6$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $5e0c0d4e15efb4a6$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $kFsv3.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $5e0c0d4e15efb4a6$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
var $5e0c0d4e15efb4a6$exports = {};

$parcel$export($5e0c0d4e15efb4a6$exports, "R50", () => $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", () => $5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", () => $5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", () => $5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", () => $5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", () => $5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", () => $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", () => $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", () => $5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", () => $5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", () => $5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", () => $5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", () => $5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", () => $5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", () => $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", () => $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", () => $5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", () => $5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", () => $5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", () => $5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", () => $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", () => $5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", () => $5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", () => $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", () => $5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", () => $5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", () => $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", () => $5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", () => $5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", () => $5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", () => $5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", () => $5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", () => $5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", () => $5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", () => $5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", () => $5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", () => $5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", () => $5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", () => $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", () => $5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", () => $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", () => $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", () => $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", () => $5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", () => $5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", () => $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", () => $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", () => $5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", () => $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", () => $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", () => $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", () => $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", () => $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", () => $5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", () => $5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", () => $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", () => $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", () => $5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", () => $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", () => $5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", () => $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", () => $5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", () => $5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", () => $5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", () => $5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", () => $5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", () => $5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", () => $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", () => $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", () => $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", () => $5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", () => $5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", () => $5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", () => $5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", () => $5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", () => $5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", () => $5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", () => $5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", () => $5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", () => $5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", () => $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", () => $5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", () => $5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", () => $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", () => $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", () => $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", () => $5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", () => $5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", () => $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", () => $5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", () => $5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", () => $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", () => $5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", () => $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", () => $5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", () => $5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", () => $5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", () => $5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", () => $5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", () => $5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", () => $5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", () => $5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", () => $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", () => $5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", () => $5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", () => $5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", () => $5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", () => $5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", () => $5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", () => $5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", () => $5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", () => $5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", () => $5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", () => $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", () => $5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", () => $5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", () => $5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", () => $5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", () => $5e0c0d4e15efb4a6$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';

parcelRegister("kFsv3", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $da8a77f13d52b186$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $da8a77f13d52b186$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $da8a77f13d52b186$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $da8a77f13d52b186$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $da8a77f13d52b186$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $da8a77f13d52b186$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $da8a77f13d52b186$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $da8a77f13d52b186$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $da8a77f13d52b186$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $da8a77f13d52b186$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $da8a77f13d52b186$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $da8a77f13d52b186$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $da8a77f13d52b186$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $da8a77f13d52b186$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $da8a77f13d52b186$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $da8a77f13d52b186$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $da8a77f13d52b186$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $da8a77f13d52b186$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $da8a77f13d52b186$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $da8a77f13d52b186$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $da8a77f13d52b186$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $da8a77f13d52b186$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $da8a77f13d52b186$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $da8a77f13d52b186$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $da8a77f13d52b186$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $da8a77f13d52b186$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $da8a77f13d52b186$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $da8a77f13d52b186$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $da8a77f13d52b186$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $da8a77f13d52b186$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $da8a77f13d52b186$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $da8a77f13d52b186$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $da8a77f13d52b186$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $da8a77f13d52b186$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $da8a77f13d52b186$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $da8a77f13d52b186$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $da8a77f13d52b186$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $da8a77f13d52b186$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $da8a77f13d52b186$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $da8a77f13d52b186$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $da8a77f13d52b186$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $da8a77f13d52b186$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $da8a77f13d52b186$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $da8a77f13d52b186$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $da8a77f13d52b186$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $da8a77f13d52b186$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $da8a77f13d52b186$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $da8a77f13d52b186$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $da8a77f13d52b186$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $da8a77f13d52b186$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $da8a77f13d52b186$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $da8a77f13d52b186$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $da8a77f13d52b186$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $da8a77f13d52b186$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $da8a77f13d52b186$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $da8a77f13d52b186$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $da8a77f13d52b186$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $da8a77f13d52b186$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $da8a77f13d52b186$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $da8a77f13d52b186$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
    $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    $da8a77f13d52b186$export$c815fe495e8174a0,
    $da8a77f13d52b186$export$738c3b9a44c87ecc,
    $da8a77f13d52b186$export$1225f83626261b80,
    $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    $da8a77f13d52b186$export$d0446fe88325854e,
    $da8a77f13d52b186$export$bb848c92687e69dc,
    $da8a77f13d52b186$export$aab610c505c06a8f,
    $da8a77f13d52b186$export$466af87757d343a2,
    $da8a77f13d52b186$export$3de5e29ed1757f9b,
    $da8a77f13d52b186$export$da02e4820b6ab753,
    $da8a77f13d52b186$export$7d278ca694634874,
    $da8a77f13d52b186$export$26453300bfc61cb8
];
const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
const $da8a77f13d52b186$export$c537fa0d021d010b = {
    PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
    BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
    DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
    GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
    TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
    DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
    YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
    DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
    ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
    DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
    GREY: $da8a77f13d52b186$export$7d278ca694634874,
    DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
};
const $da8a77f13d52b186$export$d33d39828a18210a = {
    SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
    SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
    SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
    SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
    SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
    SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
    SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
    SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
};
const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
    GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
    GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
    GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
    GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
    GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
    GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
    GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
    GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
    GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
};
const $da8a77f13d52b186$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
    AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
    AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
    AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
};

});


parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $12ZsE = parcelRequire("12ZsE");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($12ZsE)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("12ZsE", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});

const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';


parcelRegister("7Fute", function(module, exports) {

$parcel$export(module.exports, "getLozengeThemeByColor", () => $92894d61150c3ebf$export$949dc67535a8ff2);
$parcel$export(module.exports, "getParentShape", () => $92894d61150c3ebf$export$1a0682c86bbf9e96);
$parcel$export(module.exports, "getHierarchyShape", () => $92894d61150c3ebf$export$5f81302d25451851);
$parcel$export(module.exports, "formatOptionList", () => $92894d61150c3ebf$export$48f827b6d0c5862);
$parcel$export(module.exports, "transformToEpic", () => $92894d61150c3ebf$export$11773371cf35c9f8);

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $92894d61150c3ebf$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $92894d61150c3ebf$export$949dc67535a8ff2 = (color = (0, $k8qVk.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $92894d61150c3ebf$export$9b822862d986dfdf[color] ?? $92894d61150c3ebf$export$9b822862d986dfdf[0, $k8qVk.DEFAULT_EPIC_COLOR];
const $92894d61150c3ebf$export$1a0682c86bbf9e96 = (id, key, summary, issuetype, color)=>({
        id: id,
        key: key,
        color: color,
        fields: {
            summary: summary,
            issuetype: issuetype
        }
    });
const $92894d61150c3ebf$export$5f81302d25451851 = ({ id: id, name: name, iconUrl: iconUrl })=>({
        name: 'Epic',
        level: 1,
        issueTypeIds: [
            Number(id)
        ],
        issueTypes: [
            {
                id: id,
                name: name,
                iconUrl: iconUrl
            }
        ]
    });
const $92894d61150c3ebf$export$48f827b6d0c5862 = (unformattedOptions, currentParent, label)=>{
    const filteredOptions = unformattedOptions.filter((option)=>option.key !== currentParent);
    const parentList = filteredOptions.slice(0, (0, $k8qVk.MAX_SUGGESTIONS)).map((option)=>({
            label: `${option.key} ${option.fields.summary}`,
            value: option.fields.summary,
            iconUrl: option.fields.issuetype.iconUrl,
            ...option
        }));
    return {
        options: parentList.length > 0 ? [
            {
                label: label,
                options: parentList
            }
        ] : [],
        hasMoreOptions: filteredOptions.length > (0, $k8qVk.MAX_SUGGESTIONS)
    };
};
const $92894d61150c3ebf$export$11773371cf35c9f8 = ({ id: id, key: key, summary: summary, color: color, issueType: { id: issueTypeId, name: issueTypeName, iconUrl: iconUrl } })=>({
        id: id,
        key: key,
        summary: summary,
        color: color,
        issueType: {
            id: issueTypeId,
            name: issueTypeName,
            iconUrl: iconUrl
        }
    });

});
parcelRegister("k8qVk", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $93cb8f2923e7410b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $93cb8f2923e7410b$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAX_SUGGESTIONS", () => $93cb8f2923e7410b$export$eb8d067f048699c8);
$parcel$export(module.exports, "MENU_WIDTH", () => $93cb8f2923e7410b$export$2467bcf8f6d5c6b6);
$parcel$export(module.exports, "MENU_EMPTY_WIDTH", () => $93cb8f2923e7410b$export$84f510916a7dff2e);
$parcel$export(module.exports, "LONG_LABEL_LIMIT", () => $93cb8f2923e7410b$export$29ec59bc4d551a41);
$parcel$export(module.exports, "PARENT_SWITCHER_LOZENGE_TEST_ID", () => $93cb8f2923e7410b$export$680faa54dc6da799);
$parcel$export(module.exports, "PARENT_SWITCHER_LOADING_SPINNER_TEST_ID", () => $93cb8f2923e7410b$export$11e2185ebbcf7235);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_ACTIONS_TEST_ID", () => $93cb8f2923e7410b$export$2aa213773f04da8f);
$parcel$export(module.exports, "PARENT_SWITCHER_LABEL_TEST_ID", () => $93cb8f2923e7410b$export$bccc9d1ffeb474d3);
$parcel$export(module.exports, "PARENT_SWITCHER_ADD_PARENT_BUTTON_TEST_ID", () => $93cb8f2923e7410b$export$cc185b35b5eb5c92);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_REMOVE_PARENT_TEST_ID", () => $93cb8f2923e7410b$export$31b523708d2a8acb);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_VIEW_ALL_PARENTS_TEST_ID", () => $93cb8f2923e7410b$export$ac3a223c1d7cac9a);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_EMPTY_TEST_ID", () => $93cb8f2923e7410b$export$beb7535f4921d585);
$parcel$export(module.exports, "PARENT_SWITCHER_OPEN_ISSUE_CREATE_LINK_TEST_ID", () => $93cb8f2923e7410b$export$a019f396c99849dc);

var $kFsv3 = parcelRequire("kFsv3");

var $3XO6n = parcelRequire("3XO6n");
const $93cb8f2923e7410b$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraParentSwitcherField');
const $93cb8f2923e7410b$export$c2357bec51c5cf5b = (0, $kFsv3.PURPLE);
const $93cb8f2923e7410b$export$eb8d067f048699c8 = 5;
const $93cb8f2923e7410b$export$2467bcf8f6d5c6b6 = 345;
const $93cb8f2923e7410b$export$84f510916a7dff2e = 180;
const $93cb8f2923e7410b$export$29ec59bc4d551a41 = 40;
const $93cb8f2923e7410b$export$680faa54dc6da799 = 'issue-field-parent-switcher.common.ui.epic-lozenge.epic-lozenge';
const $93cb8f2923e7410b$export$2082958b673f1f66 = 'issue-field-parent-switcher.common.ui.epic-tag.tag';
const $93cb8f2923e7410b$export$11813783c408cdf1 = `[data-testid="${$93cb8f2923e7410b$export$680faa54dc6da799}"]`;
const $93cb8f2923e7410b$export$11e2185ebbcf7235 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.loading-content.parent-switcher-suggested-parents-loading-spinner';
const $93cb8f2923e7410b$export$2aa213773f04da8f = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.actions';
const $93cb8f2923e7410b$export$bccc9d1ffeb474d3 = 'issue-field-parent.edit-view.options.';
const $93cb8f2923e7410b$export$cc185b35b5eb5c92 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.add-parent-button';
const $93cb8f2923e7410b$export$31b523708d2a8acb = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.remove-parent';
const $93cb8f2923e7410b$export$986b8ef30a6bdca7 = `[data-testid="${$93cb8f2923e7410b$export$31b523708d2a8acb}"]`;
const $93cb8f2923e7410b$export$ac3a223c1d7cac9a = 'issue-field-parent-switcher.ui.edit.view-all-parents';
const $93cb8f2923e7410b$export$6494872dab91ac11 = `[data-testid="${$93cb8f2923e7410b$export$ac3a223c1d7cac9a}"]`;
const $93cb8f2923e7410b$export$beb7535f4921d585 = 'issue-field-parent-switcher.ui.edit.empty-container';
const $93cb8f2923e7410b$export$c0432cfce03a69a8 = `[data-testid="${$93cb8f2923e7410b$export$beb7535f4921d585}"]`;
const $93cb8f2923e7410b$export$a019f396c99849dc = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.empty-content.open-issue-create';

});


parcelRegister("44VbI", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $d665573e03a66c7e$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $d665573e03a66c7e$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $d665573e03a66c7e$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $d665573e03a66c7e$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $d665573e03a66c7e$export$e2dafe47b17b2cfc);

var $8QpSo = parcelRequire("8QpSo");

var $gULOk = parcelRequire("gULOk");
const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, $8QpSo.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $d665573e03a66c7e$export$38146914a8d06579 = (0, $8QpSo.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $d665573e03a66c7e$var$memoizedTranformOptions = (0, $8QpSo.default)($d665573e03a66c7e$var$formatOptions);
const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $gULOk.StatusCategoryIds)[category] || (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("dpWCZ", function(module, exports) {

$parcel$export(module.exports, "hasEpicField", () => $95a38fe46100fd22$export$c4f57165afac73d9);
$parcel$export(module.exports, "isEpicField", () => $95a38fe46100fd22$export$3d4ac06796ffcbf4);
function $95a38fe46100fd22$export$c4f57165afac73d9(issue) {
    return issue && 'epicField' in issue;
}
function $95a38fe46100fd22$export$3d4ac06796ffcbf4(value) {
    return value && 'issueId' in value;
}

});

parcelRegister("f01qr", function(module, exports) {

$parcel$export(module.exports, "getCardListId", () => $a60ef25f21c3c03d$export$e65113cd51859079);
$parcel$export(module.exports, "sendFailToMoveAnalytic", () => $a60ef25f21c3c03d$export$a3cba232834b9a4c);
$parcel$export(module.exports, "sendSuccessToMoveAnalytic", () => $a60ef25f21c3c03d$export$8b6d119d11f4d263);
$parcel$export(module.exports, "getIdFromAri", () => $a60ef25f21c3c03d$export$79640a85913af5aa);
$parcel$export(module.exports, "isObjectArrayEqual", () => $a60ef25f21c3c03d$export$65067f0a588374c3);
$parcel$export(module.exports, "toShortCustomFieldId", () => $a60ef25f21c3c03d$export$36c037bc7f404c2);
$parcel$export(module.exports, "toArray", () => $a60ef25f21c3c03d$export$45b10814cc054894);

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $6Kx1w = parcelRequire("6Kx1w");

var $fZneA = parcelRequire("fZneA");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $guzeq = parcelRequire("guzeq");

var $2lpqS = parcelRequire("2lpqS");
const $a60ef25f21c3c03d$export$e65113cd51859079 = (cardListId)=>{
    if (cardListId && cardListId.startsWith((0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX))) return cardListId.substr((0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX).length);
    if (cardListId && cardListId.startsWith((0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE))) return cardListId.split('::')[2];
    if (cardListId && cardListId.startsWith((0, $2lpqS.TRANSITION_ZONE_DROPPABLE_TYPE))) return cardListId.split('::')[1];
    return cardListId;
};
const $a60ef25f21c3c03d$export$9067d4d6678cd6bc = (droppableId)=>droppableId.startsWith((0, $2lpqS.TRANSITION_ZONE_DROPPABLE_TYPE));
const $a60ef25f21c3c03d$var$getDndOperation = (srcDroppableId, destDroppableId, cardListId, isActiveSprint)=>{
    if (srcDroppableId === destDroppableId) return 0, $2lpqS.DND_OPERATION_MOVE_INSIDE_LIST;
    if (cardListId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_BACKLOG;
    if (cardListId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_BOARD;
    if (isActiveSprint(cardListId)) return 0, $2lpqS.DND_OPERATION_MOVE_TO_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_OPERATION_MOVE_TO_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$var$getDndSource = (srcDroppableId, destDroppableId, isActiveSprint)=>{
    if (srcDroppableId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_DROP_ZONES_BACKLOG;
    if (srcDroppableId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(srcDroppableId)) return 0, $2lpqS.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$var$getDndDestination = (cardListId, isActiveSprint)=>{
    if (cardListId === (0, $guzeq.BACKLOG)) return 0, $2lpqS.DND_DROP_ZONES_BACKLOG;
    if (cardListId === (0, $guzeq.BOARD)) return 0, $2lpqS.DND_DROP_ZONES_BOARD;
    if (isActiveSprint(cardListId)) return 0, $2lpqS.DND_DROP_ZONES_ACTIVE_SPRINT;
    return 0, $2lpqS.DND_DROP_ZONES_FUTURE_SPRINT;
};
const $a60ef25f21c3c03d$export$a3cba232834b9a4c = (analyticsEvent, cardIds, error, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a60ef25f21c3c03d$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a60ef25f21c3c03d$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $2lpqS.DND_TARGET_BACKLOG_CARD);
    const operation = $a60ef25f21c3c03d$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
        numCards: cardIds.length,
        errorMessage: error.message,
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget,
        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
    });
};
const $a60ef25f21c3c03d$export$8b6d119d11f4d263 = (cardId, analyticsEvent, cardListId, isActiveSprint)=>{
    const srcDroppableId = analyticsEvent.payload?.attributes?.source ?? '';
    const destDroppableId = analyticsEvent.payload?.attributes?.target ?? '';
    const dndSource = $a60ef25f21c3c03d$var$getDndSource(srcDroppableId, destDroppableId, isActiveSprint);
    const dndDestination = $a60ef25f21c3c03d$var$getDndDestination(cardListId, isActiveSprint);
    const dndTarget = analyticsEvent.payload?.attributes?.type ?? (0, $2lpqS.DND_TARGET_BACKLOG_CARD);
    const operation = $a60ef25f21c3c03d$var$getDndOperation(srcDroppableId, destDroppableId, cardListId, isActiveSprint);
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlog updated', String(cardId), {
        operation: operation,
        dndDestination: dndDestination,
        dndSource: dndSource,
        dndTarget: dndTarget
    });
};
const $a60ef25f21c3c03d$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $a60ef25f21c3c03d$export$65067f0a588374c3 = (a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($6Kx1w)))(a, b, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))));
const $a60ef25f21c3c03d$export$36c037bc7f404c2 = (customFieldId)=>{
    if (!(0, $2lpqS.CUSTOM_FIELD_ID_REGEX).test(customFieldId ?? '')) return undefined;
    const fieldId = customFieldId?.match((0, $2lpqS.CUSTOM_FIELD_ID_REGEX))?.[1];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) return undefined;
    return `cf[${fieldId}]`;
};
const $a60ef25f21c3c03d$export$45b10814cc054894 = (x)=>Array.isArray(x) ? x : x.split(',');

});
parcelRegister("6Kx1w", function(module, exports) {

var $2GdQn = parcelRequire("2GdQn");

var $g7i7g = parcelRequire("g7i7g");

var $7txx8 = parcelRequire("7txx8");

var $f3SOL = parcelRequire("f3SOL");

var $hYfgW = parcelRequire("hYfgW");
/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */ var $4ea0a7c2fafe415b$var$xorWith = $g7i7g(function(arrays) {
    var comparator = $hYfgW(arrays);
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return $7txx8($2GdQn(arrays, $f3SOL), undefined, comparator);
});
module.exports = $4ea0a7c2fafe415b$var$xorWith;

});
parcelRegister("7txx8", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $ekcP3 = parcelRequire("ekcP3");

var $7CoLY = parcelRequire("7CoLY");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $571540db172adafd$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $7CoLY(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $55pzo(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $7CoLY($ekcP3(result, 1), iteratee, comparator);
}
module.exports = $571540db172adafd$var$baseXor;

});


parcelRegister("guzeq", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DATE_DISPLAY_FORMAT", () => $34991cd92e3fb74d$export$faf85b5ed93b0538);
$parcel$export(module.exports, "BACKLOG", () => $34991cd92e3fb74d$export$dedbdcc35e955187);
$parcel$export(module.exports, "BOARD", () => $34991cd92e3fb74d$export$9b8283d5878d2491);
$parcel$export(module.exports, "SPRINT", () => $34991cd92e3fb74d$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "INACTIVE_SPRINT", () => $34991cd92e3fb74d$export$88abd69a9006b2b);
$parcel$export(module.exports, "ACTIVE_SPRINT", () => $34991cd92e3fb74d$export$2f9f63c9e8b8a7fc);
$parcel$export(module.exports, "TOP_OF_LIST", () => $34991cd92e3fb74d$export$1a271033d96c4e9a);
$parcel$export(module.exports, "BOTTOM_OF_LIST", () => $34991cd92e3fb74d$export$fe366e1b5f8f6917);
$parcel$export(module.exports, "BOTTOM_OF_CARD_GROUP", () => $34991cd92e3fb74d$export$29472abe5c298701);
$parcel$export(module.exports, "BEFORE_CARD", () => $34991cd92e3fb74d$export$6ee6fb5615cbbfaf);
$parcel$export(module.exports, "TRANSITION_ZONE", () => $34991cd92e3fb74d$export$825ad5563e6c16b4);
$parcel$export(module.exports, "NONE", () => $34991cd92e3fb74d$export$c53d0f541b41b88e);
$parcel$export(module.exports, "ISSUE_LIST", () => $34991cd92e3fb74d$export$7be7e0393bed6707);
$parcel$export(module.exports, "SPRINT_STATE_FUTURE", () => $34991cd92e3fb74d$export$1dec7a5987befb9f);
$parcel$export(module.exports, "SPRINT_STATE_ACTIVE", () => $34991cd92e3fb74d$export$91f438b1afe47b53);
$parcel$export(module.exports, "SPRINT_MOVE_TO_TOP", () => $34991cd92e3fb74d$export$c557f656e9558605);
$parcel$export(module.exports, "SPRINT_MOVE_UP", () => $34991cd92e3fb74d$export$d44a21a036e6d362);
$parcel$export(module.exports, "SPRINT_MOVE_DOWN", () => $34991cd92e3fb74d$export$c3959a41530f5d37);
$parcel$export(module.exports, "SPRINT_MOVE_TO_BOTTOM", () => $34991cd92e3fb74d$export$40b71d704f7a26b4);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $34991cd92e3fb74d$export$cb17e3c17bc50301);
$parcel$export(module.exports, "ESTIMATION_ROLLUP_BADGE_MAX", () => $34991cd92e3fb74d$export$b79b504ff88a1727);
$parcel$export(module.exports, "BACKLOG_LONG_TASKS_DND_MARK_NAME", () => $34991cd92e3fb74d$export$bb1ee0864c80dcde);
$parcel$export(module.exports, "SPRINT_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$3fa2dca6095ef23a);
$parcel$export(module.exports, "ISSUE_LIST_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$946ee3a604b332d2);
$parcel$export(module.exports, "KANBAN_BACKLOG_STRATEGY", () => $34991cd92e3fb74d$export$869ee62868d7be07);
$parcel$export(module.exports, "REFRESH_SOURCE_FAILURE", () => $34991cd92e3fb74d$export$d9d2fe902bd6d9a7);
$parcel$export(module.exports, "REFRESH_SOURCE_REALTIME", () => $34991cd92e3fb74d$export$af001fd9213b0b63);
$parcel$export(module.exports, "REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS", () => $34991cd92e3fb74d$export$9af8a111003cd702);
$parcel$export(module.exports, "REFRESH_SOURCE_GLOBAL_ISSUE_CREATE", () => $34991cd92e3fb74d$export$8cabdc85b8691f12);
$parcel$export(module.exports, "REFRESH_SOURCE_SPRINT_COMPLETE", () => $34991cd92e3fb74d$export$600567015cf0b58e);
$parcel$export(module.exports, "REFRESH_SOURCE_STATUS_REMAPPED", () => $34991cd92e3fb74d$export$443de2b93e4aa6c6);
$parcel$export(module.exports, "REFRESH_SOURCE_ON_MOUNT", () => $34991cd92e3fb74d$export$26392593c7297db8);
$parcel$export(module.exports, "REFRESH_SOURCE_ACTIVE_TAB", () => $34991cd92e3fb74d$export$968a5895f5ee4e93);
$parcel$export(module.exports, "REFRESH_SOURCE_POLLING", () => $34991cd92e3fb74d$export$8125ab02c04ac8e7);
$parcel$export(module.exports, "APP_ID", () => $34991cd92e3fb74d$export$d76071d5de2774fc);
$parcel$export(module.exports, "TEAM_NAME", () => $34991cd92e3fb74d$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PACKAGE_NAME", () => $34991cd92e3fb74d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "EDIT_BOARD_CONFIG", () => $34991cd92e3fb74d$export$b893894941c14e43);
$parcel$export(module.exports, "DELETE_ISSUE", () => $34991cd92e3fb74d$export$4e8756b18ce4cf17);
$parcel$export(module.exports, "CREATE_ISSUE", () => $34991cd92e3fb74d$export$a84692caf5a334ea);
$parcel$export(module.exports, "MANAGE_SPRINT", () => $34991cd92e3fb74d$export$47e89ba04d79d88d);
$parcel$export(module.exports, "EDIT_ISSUE", () => $34991cd92e3fb74d$export$52f11126cce982f0);
$parcel$export(module.exports, "VIEW_BOARD", () => $34991cd92e3fb74d$export$6fca44a139cecd72);
$parcel$export(module.exports, "ADMINISTER_BOARD", () => $34991cd92e3fb74d$export$120f9058cc2d23b7);
$parcel$export(module.exports, "BULK_CHANGE", () => $34991cd92e3fb74d$export$66cb530046350ea5);
$parcel$export(module.exports, "ASSIGN_ISSUE", () => $34991cd92e3fb74d$export$e3e5ec492e10f340);
$parcel$export(module.exports, "TRANSITION_ISSUE", () => $34991cd92e3fb74d$export$627a3f8561c04066);
$parcel$export(module.exports, "ARCHIVE_ISSUE", () => $34991cd92e3fb74d$export$84886e19f4ac5f8e);
$parcel$export(module.exports, "ISSUE_COUNT_ID", () => $34991cd92e3fb74d$export$e371c88c3137ffb);
$parcel$export(module.exports, "ESTIMATION_TYPE_ID_PREFIX", () => $34991cd92e3fb74d$export$81b5ed4ed651b2bc);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_FIELD_ID", () => $34991cd92e3fb74d$export$d02889a654103c98);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_ID", () => $34991cd92e3fb74d$export$4c2cf346f4d818c5);
$parcel$export(module.exports, "NUMERIC_ESTIMATE_FIELD_ID_PREFIX", () => $34991cd92e3fb74d$export$4091097a73cc5002);
$parcel$export(module.exports, "ISSUE_COUNT", () => $34991cd92e3fb74d$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $34991cd92e3fb74d$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $34991cd92e3fb74d$export$405b6d72f2d243a9);
$parcel$export(module.exports, "REMAINING_TIME_ESTIMATE", () => $34991cd92e3fb74d$export$612ef20a8c97681f);
$parcel$export(module.exports, "statisticFieldToEstimateType", () => $34991cd92e3fb74d$export$674f0c6f9382fdff);
$parcel$export(module.exports, "statisticFieldPrefixes", () => $34991cd92e3fb74d$export$69ce8a2ab6160d00);
$parcel$export(module.exports, "GROUP_TYPE", () => $34991cd92e3fb74d$export$d5d0dfb4a0060b5a);
const $34991cd92e3fb74d$export$45c85543ba71221d = 'YYYY-MM-DDTHH:mm:ssZ';
const $34991cd92e3fb74d$export$faf85b5ed93b0538 = 'd MMM';
const $34991cd92e3fb74d$export$dedbdcc35e955187 = 'BACKLOG';
const $34991cd92e3fb74d$export$9b8283d5878d2491 = 'BOARD';
const $34991cd92e3fb74d$export$a316570a0dbfd2b0 = 'SPRINT';
const $34991cd92e3fb74d$export$88abd69a9006b2b = 'INACTIVE_SPRINT';
const $34991cd92e3fb74d$export$2f9f63c9e8b8a7fc = 'ACTIVE_SPRINT';
const $34991cd92e3fb74d$export$1a271033d96c4e9a = 'TOP_OF_LIST';
const $34991cd92e3fb74d$export$fe366e1b5f8f6917 = 'BOTTOM_OF_LIST';
const $34991cd92e3fb74d$export$29472abe5c298701 = 'BOTTOM_OF_CARD_GROUP';
const $34991cd92e3fb74d$export$6ee6fb5615cbbfaf = 'BEFORE_CARD';
const $34991cd92e3fb74d$export$825ad5563e6c16b4 = 'TRANSITION_ZONE';
const $34991cd92e3fb74d$export$c53d0f541b41b88e = 'NONE';
const $34991cd92e3fb74d$export$7be7e0393bed6707 = 'ISSUE_LIST';
const $34991cd92e3fb74d$export$1dec7a5987befb9f = 'FUTURE';
const $34991cd92e3fb74d$export$91f438b1afe47b53 = 'ACTIVE';
const $34991cd92e3fb74d$export$c557f656e9558605 = 'SPRINT_MOVE_TO_TOP';
const $34991cd92e3fb74d$export$d44a21a036e6d362 = 'SPRINT_MOVE_UP';
const $34991cd92e3fb74d$export$c3959a41530f5d37 = 'SPRINT_MOVE_DOWN';
const $34991cd92e3fb74d$export$40b71d704f7a26b4 = 'SPRINT_MOVE_TO_BOTTOM';
const $34991cd92e3fb74d$export$cb17e3c17bc50301 = 'Epic';
const $34991cd92e3fb74d$export$b79b504ff88a1727 = 999;
const $34991cd92e3fb74d$export$bb1ee0864c80dcde = 'backlog.long-tasks-dnd';
const $34991cd92e3fb74d$export$8f153823e4517a88 = 'backlog.long-tasks-card-mouseleave';
const $34991cd92e3fb74d$export$48a5a6ab3930a7b0 = 'backlog.long-tasks-card-drag-to-drop-target';
const $34991cd92e3fb74d$export$d7ca4ead68e4382c = 'NONE';
const $34991cd92e3fb74d$export$3fa2dca6095ef23a = 'SPRINT';
const $34991cd92e3fb74d$export$946ee3a604b332d2 = 'ISSUE_LIST';
const $34991cd92e3fb74d$export$869ee62868d7be07 = 'KANBAN_BACKLOG';
const $34991cd92e3fb74d$export$d9d2fe902bd6d9a7 = 'FAILURE';
const $34991cd92e3fb74d$export$af001fd9213b0b63 = 'REALTIME';
const $34991cd92e3fb74d$export$9af8a111003cd702 = 'KANBAN_CARD_MOVE_SUCCESS';
const $34991cd92e3fb74d$export$8cabdc85b8691f12 = 'GLOBAL_ISSUE_CREATE';
const $34991cd92e3fb74d$export$600567015cf0b58e = 'SPRINT_COMPLETE';
const $34991cd92e3fb74d$export$443de2b93e4aa6c6 = 'STATUS_REMAPPED';
const $34991cd92e3fb74d$export$26392593c7297db8 = 'ON_MOUNT';
const $34991cd92e3fb74d$export$968a5895f5ee4e93 = 'ACTIVE_TAB';
const $34991cd92e3fb74d$export$8125ab02c04ac8e7 = 'POLLING';
const $34991cd92e3fb74d$export$66e48a348bf0e91e = 'ADD_ISSUE_TYPE_MODAL';
const $34991cd92e3fb74d$export$d76071d5de2774fc = 'software.backlog';
const $34991cd92e3fb74d$export$d57b6b390e78d90f = 'a4t-tanuki';
const $34991cd92e3fb74d$export$b8b9d90f9e5bd72b = '@atlassian/jira-software-backlog';
const $34991cd92e3fb74d$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $34991cd92e3fb74d$export$4e8756b18ce4cf17 = 'DELETE_ISSUE';
const $34991cd92e3fb74d$export$a84692caf5a334ea = 'CREATE_ISSUE';
const $34991cd92e3fb74d$export$47e89ba04d79d88d = 'MANAGE_SPRINT';
const $34991cd92e3fb74d$export$52f11126cce982f0 = 'EDIT_ISSUE';
const $34991cd92e3fb74d$export$6fca44a139cecd72 = 'VIEW_BOARD';
const $34991cd92e3fb74d$export$120f9058cc2d23b7 = 'ADMINISTER_BOARD';
const $34991cd92e3fb74d$export$66cb530046350ea5 = 'BULK_CHANGE';
const $34991cd92e3fb74d$export$e3e5ec492e10f340 = 'ASSIGN_ISSUE';
const $34991cd92e3fb74d$export$627a3f8561c04066 = 'TRANSITION_ISSUE';
const $34991cd92e3fb74d$export$84886e19f4ac5f8e = 'ARCHIVE_ISSUE';
const $34991cd92e3fb74d$export$e371c88c3137ffb = 'issueCount_';
const $34991cd92e3fb74d$export$81b5ed4ed651b2bc = 'field_';
const $34991cd92e3fb74d$export$d02889a654103c98 = 'field_timeoriginalestimate';
const $34991cd92e3fb74d$export$4c2cf346f4d818c5 = 'timeoriginalestimate';
const $34991cd92e3fb74d$export$3a68c8006649e940 = 'field_customfield_';
const $34991cd92e3fb74d$export$4091097a73cc5002 = 'customfield_';
const $34991cd92e3fb74d$export$8775696968c9b13c = 'ISSUE_COUNT';
const $34991cd92e3fb74d$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $34991cd92e3fb74d$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $34991cd92e3fb74d$export$612ef20a8c97681f = 'timeestimate';
const $34991cd92e3fb74d$export$674f0c6f9382fdff = {
    [$34991cd92e3fb74d$export$e371c88c3137ffb]: $34991cd92e3fb74d$export$8775696968c9b13c,
    [$34991cd92e3fb74d$export$d02889a654103c98]: $34991cd92e3fb74d$export$bfb354504bb547a0,
    [$34991cd92e3fb74d$export$3a68c8006649e940]: $34991cd92e3fb74d$export$405b6d72f2d243a9
};
const $34991cd92e3fb74d$export$69ce8a2ab6160d00 = [
    $34991cd92e3fb74d$export$e371c88c3137ffb,
    $34991cd92e3fb74d$export$d02889a654103c98,
    $34991cd92e3fb74d$export$3a68c8006649e940
];
const $34991cd92e3fb74d$export$31089ea8b3e502e3 = 'card';
const $34991cd92e3fb74d$export$d5d0dfb4a0060b5a = 'group';

});

parcelRegister("2lpqS", function(module, exports) {

$parcel$export(module.exports, "HEADER_DROPPABLE_ID_PREFIX", () => $e859f81c51db2b78$export$5e2fff92b27c1bb8);
$parcel$export(module.exports, "CARD_LIST_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$afbd2d45ce529690);
$parcel$export(module.exports, "CARD_GROUP_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$849c01670da437ac);
$parcel$export(module.exports, "TRANSITION_ZONE_DROPPABLE_TYPE", () => $e859f81c51db2b78$export$6e35851fe8cf8301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $e859f81c51db2b78$export$794f07be04aca3fe);
$parcel$export(module.exports, "DND_DROP_ZONES_ACTIVE_SPRINT", () => $e859f81c51db2b78$export$adbf9ce386bc3037);
$parcel$export(module.exports, "DND_DROP_ZONES_FUTURE_SPRINT", () => $e859f81c51db2b78$export$bb216fa10db6b6bb);
$parcel$export(module.exports, "DND_DROP_ZONES_BOARD", () => $e859f81c51db2b78$export$338b523135b4db48);
$parcel$export(module.exports, "DND_DROP_ZONES_BACKLOG", () => $e859f81c51db2b78$export$f6bf4fdaad3caf69);
$parcel$export(module.exports, "DND_TARGET_BACKLOG_CARD", () => $e859f81c51db2b78$export$695859afe4db61d7);
$parcel$export(module.exports, "DND_TARGET_DIVIDER", () => $e859f81c51db2b78$export$62679ec8251801eb);
$parcel$export(module.exports, "DND_OPERATION_MOVE_INSIDE_LIST", () => $e859f81c51db2b78$export$7ade48b3d11b4061);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_ACTIVE_SPRINT", () => $e859f81c51db2b78$export$1ffb6fb519522507);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_FUTURE_SPRINT", () => $e859f81c51db2b78$export$f1ed61bbffc6eb2c);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BACKLOG", () => $e859f81c51db2b78$export$dc9b10088e3cd5b6);
$parcel$export(module.exports, "DND_OPERATION_MOVE_TO_BOARD", () => $e859f81c51db2b78$export$5b4e8a4b9c2dd508);
$parcel$export(module.exports, "CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$6be26aedd8f95d5e);
$parcel$export(module.exports, "COMPACT_CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$9207e617cac36dce);
$parcel$export(module.exports, "EXTRA_CARD_ROW_HEIGHT", () => $e859f81c51db2b78$export$85b6f126b8e736d4);
$parcel$export(module.exports, "INLINE_CARD_CREATE_ROW_HEIGHT", () => $e859f81c51db2b78$export$226ce682b3342af4);
$parcel$export(module.exports, "LABELS_FIELD_SEPARATOR", () => $e859f81c51db2b78$export$e74bc8e59eb08066);
$parcel$export(module.exports, "CUSTOM_FIELD_ID_REGEX", () => $e859f81c51db2b78$export$cb26d91c4e639201);
$parcel$export(module.exports, "UNASSIGNED_USER", () => $e859f81c51db2b78$export$299e0e1e1265f5e9);

const $e859f81c51db2b78$export$5e2fff92b27c1bb8 = 'HEADER-DROP-';
const $e859f81c51db2b78$export$afbd2d45ce529690 = 'CARD';
const $e859f81c51db2b78$export$849c01670da437ac = 'CARD-GROUP';
const $e859f81c51db2b78$export$6e35851fe8cf8301 = 'TRANSITION-ZONE';
const $e859f81c51db2b78$export$794f07be04aca3fe = 0;
const $e859f81c51db2b78$export$adbf9ce386bc3037 = 'activeSprint';
const $e859f81c51db2b78$export$bb216fa10db6b6bb = 'futureSprint';
const $e859f81c51db2b78$export$3df2915b3d2a36e = 'sprint';
const $e859f81c51db2b78$export$338b523135b4db48 = 'board';
const $e859f81c51db2b78$export$f6bf4fdaad3caf69 = 'backlog';
const $e859f81c51db2b78$export$67e35e305110c91d = 'epicPanel';
const $e859f81c51db2b78$export$f95492d2a4f371d0 = 'versionPanel';
const $e859f81c51db2b78$export$2a5a5a3183150769 = 'cardGroup';
const $e859f81c51db2b78$export$695859afe4db61d7 = 'backlogCard';
const $e859f81c51db2b78$export$b1b86bcaf2a12330 = 'epicPanelCard';
const $e859f81c51db2b78$export$2e29fc7afa544ab5 = 'versionPanelCard';
const $e859f81c51db2b78$export$62679ec8251801eb = 'divider';
const $e859f81c51db2b78$export$a080ee3f8cb7aa62 = 'moveListToList';
const $e859f81c51db2b78$export$7ade48b3d11b4061 = 'moveInsideList';
const $e859f81c51db2b78$export$1ffb6fb519522507 = 'moveToActiveSprint';
const $e859f81c51db2b78$export$f1ed61bbffc6eb2c = 'moveToFutureSprint';
const $e859f81c51db2b78$export$dc9b10088e3cd5b6 = 'moveToBacklog';
const $e859f81c51db2b78$export$5b4e8a4b9c2dd508 = 'moveToBoard';
const $e859f81c51db2b78$export$41f0d8a4d1ec169b = 'cardParentSet';
const $e859f81c51db2b78$export$bc493dacb9d33787 = 'epicRankUpdate';
const $e859f81c51db2b78$export$6be26aedd8f95d5e = 40;
const $e859f81c51db2b78$export$9207e617cac36dce = 32;
const $e859f81c51db2b78$export$85b6f126b8e736d4 = 30;
const $e859f81c51db2b78$export$226ce682b3342af4 = 40;
const $e859f81c51db2b78$export$e74bc8e59eb08066 = ', ';
const $e859f81c51db2b78$export$cb26d91c4e639201 = /^customfield_([0-9]+)$/;
const $e859f81c51db2b78$export$299e0e1e1265f5e9 = {
    id: (0, $15a528573ccd89ae$export$12e572fd459c10dc),
    displayName: '',
    avatarUrl: ''
};

});
const $15a528573ccd89ae$export$d597759d33be802e = 'TEXT';
const $15a528573ccd89ae$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $15a528573ccd89ae$export$37aee82a3cb1e8f7 = 'LABEL';
const $15a528573ccd89ae$export$2a4f270075a033de = 'ISSUE_PARENT';
const $15a528573ccd89ae$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $15a528573ccd89ae$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $15a528573ccd89ae$export$a4ad2735b021c132 = 'VERSION';
const $15a528573ccd89ae$export$af1e30ebbae9df3b = 'COMPONENT';
const $15a528573ccd89ae$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $15a528573ccd89ae$export$a316570a0dbfd2b0 = 'SPRINT';
const $15a528573ccd89ae$export$e50006273435e7d4 = 'STATUS';
const $15a528573ccd89ae$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $15a528573ccd89ae$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $15a528573ccd89ae$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $15a528573ccd89ae$export$871e58afc769b358 = 'GOAL';
const $15a528573ccd89ae$export$6c4d37c7f376a1de = 'CLEAR';
const $15a528573ccd89ae$export$db362e2d293fe52e = 'DEPENDENCIES';
const $15a528573ccd89ae$export$12e572fd459c10dc = 'unassigned';
const $15a528573ccd89ae$export$ac95b4b2317d4b33 = 'unassigned';
const $15a528573ccd89ae$export$81ef49afbbead0a1 = 'label unassigned';
const $15a528573ccd89ae$export$4b7c755e61199a36 = 'unassigned';
const $15a528573ccd89ae$export$c9408e3fb31ddc71 = 'offline';
const $15a528573ccd89ae$export$7a105aa475396c65 = 'online';





parcelRegister("9s7RG", function(module, exports) {

$parcel$export(module.exports, "useVersionsRefetch", () => $f222005a4baea078$export$869337d912ff312a);

var $4G03t = parcelRequire("4G03t");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $93BDy = parcelRequire("93BDy");
const $f222005a4baea078$export$869337d912ff312a = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const boardAri = (0, $93BDy.useBoardAri)();
    return (0, $5uXOq.useCallback)((jiraProjectIds)=>(0, $8Uumt.fetchQuery)(environment, (0, $4G03t.default), {
            jiraProjectIds: jiraProjectIds,
            boardId: boardAri
        }), [
        boardAri,
        environment
    ]);
};

});
parcelRegister("4G03t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c70024d36539ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f54d95893611ccf73c87633a2ada7495>>
 * @relayHash 7e9a3b7bc844d1ec4fb559b84add4cb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7d9e578e9ba33fb985edfb4b958f4947985bf9d7c2c8e5a724a31013b41d04b1

var $iWXRl = parcelRequire("iWXRl");
const $c0c70024d36539ad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v2 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "UNRELEASED"
        ]
    }, v3 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v4 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        },
        v3 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "versionsForProjects",
                                "args": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ 
                                ],
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "versionPanel_softwareVersionBacklogPanelRelay_jiraVersionEdges"
                                            },
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            },
                                            v6 /*: any*/ 
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.versionsForProjects"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useVersionsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "releaseDate"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "boardId",
                                                            "variableName": "boardId"
                                                        }
                                                    ],
                                                    "concreteType": "JiraVersionStatistics",
                                                    "kind": "LinkedField",
                                                    "name": "statistics",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "doneEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalEstimate"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "percentageCompleted"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "notEstimated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "done"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalIssueCount"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "toDo"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "inProgress"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                        },
                                                        v10 /*: any*/ ,
                                                        {
                                                            "alias": "editProjectConfig",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "type",
                                                                    "value": "EDIT_PROJECT_CONFIG"
                                                                }
                                                            ],
                                                            "concreteType": "JiraProjectAction",
                                                            "kind": "LinkedField",
                                                            "name": "action",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canPerform"
                                                                }
                                                            ],
                                                            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7d9e578e9ba33fb985edfb4b958f4947985bf9d7c2c8e5a724a31013b41d04b1",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "useVersionsRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default)
            }
        }
    };
}();
$c0c70024d36539ad$var$node.hash = "49947aa3f8615f5dcdee393f6d3fd187";
var $c0c70024d36539ad$export$2e2bcd8739ae039 = $c0c70024d36539ad$var$node;

});
parcelRegister("iWXRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6555d355a0c222e8$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6555d355a0c222e8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('jira_nav4_eap_drop_2') && (0, $dCm1o.isVisualRefreshEnabled)();
    }
};

});


parcelRegister("93BDy", function(module, exports) {

$parcel$export(module.exports, "useBoardAri", () => $7ad70603ab4b6b31$export$f53dd1c04c0f3767);

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $dIdda = parcelRequire("dIdda");
const $7ad70603ab4b6b31$export$f53dd1c04c0f3767 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [{ match: match }] = (0, $dIdda.useRouter)();
    return (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(match.params.boardId)
    });
};

});


parcelRegister("f6RVN", function(module, exports) {

$parcel$export(module.exports, "JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT", () => $e70219a0f392597e$export$c96e6dd90e90240d);
$parcel$export(module.exports, "isErrorTrackingEnabledWithSentry", () => $e70219a0f392597e$export$23d600ca6d887b4d);
$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $e70219a0f392597e$export$bc84f8a9593e9b2c);
$parcel$export(module.exports, "emitApdexOnAnimationFrame", () => $e70219a0f392597e$export$2d887f955f551bbf);
$parcel$export(module.exports, "isInAddPeopleButtonOpenTMPExperimentCohort", () => $e70219a0f392597e$export$c1643b1f0828d302);
$parcel$export(module.exports, "isEpicPanelInProgressBarTooltipsUpdateEnabled", () => $e70219a0f392597e$export$27e8747e31aae323);
$parcel$export(module.exports, "isViewSettingAsPanelExpEnabledWithNoExposure", () => $e70219a0f392597e$export$6f295af995afef94);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
// Add your feature flag name as a constant
const $e70219a0f392597e$var$ERROR_TRACKING_ENABLED = 'fe.platform.error.tracking.enabled';
const $e70219a0f392597e$var$CRITICAL_QUERY_WITH_RELAY = 'jsw.perf.critical-backlog-with-relay';
const $e70219a0f392597e$var$BACKLOG_WITH_RELAY_ENABLED = 'jsw.perf.critical-backlog-with-relay';
const $e70219a0f392597e$var$EMIT_APDEX_ON_ANIMATION_FRAME = 'jsw.perf.board-backlog-emit-apdex-on-animation-frame';
const $e70219a0f392597e$var$UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';
const $e70219a0f392597e$export$c96e6dd90e90240d = 'jsw_sprint_planning_whiteboards';
const $e70219a0f392597e$export$52a40ff46dc0c1ad = [
    $e70219a0f392597e$var$ERROR_TRACKING_ENABLED,
    $e70219a0f392597e$var$CRITICAL_QUERY_WITH_RELAY,
    $e70219a0f392597e$var$BACKLOG_WITH_RELAY_ENABLED,
    $e70219a0f392597e$var$EMIT_APDEX_ON_ANIMATION_FRAME,
    'modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl',
    $e70219a0f392597e$var$UIF_STATSIG_EXPOSURES_UPDATES,
    $e70219a0f392597e$export$c96e6dd90e90240d
];
const $e70219a0f392597e$export$23d600ca6d887b4d = ()=>(0, $co1wz.ff)('fe.platform.error.tracking.enabled');
const $e70219a0f392597e$export$dbc1d97903ce0912 = ()=>(0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay');
const $e70219a0f392597e$export$bc84f8a9593e9b2c = ()=>(0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay');
const $e70219a0f392597e$export$2d887f955f551bbf = ()=>(0, $co1wz.ff)('jsw.perf.board-backlog-emit-apdex-on-animation-frame');
function $e70219a0f392597e$export$c1643b1f0828d302() {
    return (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
}
const $e70219a0f392597e$export$27e8747e31aae323 = ()=>(0, $co1wz.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl');
const $e70219a0f392597e$export$6f295af995afef94 = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});

parcelRegister("5kotP", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $2643af30ba48de1c$export$4de5eb17326eea98);

var $5uXOq = parcelRequire("5uXOq");

var $alNv9 = parcelRequire("alNv9");

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $6c57g = parcelRequire("6c57g");

var $4cr9K = parcelRequire("4cr9K");

var $4tEQ4 = parcelRequire("4tEQ4");

var $avYIL = parcelRequire("avYIL");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");

var $6GNN7 = parcelRequire("6GNN7");

var $e978U = parcelRequire("e978U");

var $60s5X = parcelRequire("60s5X");

var $7VNNI = parcelRequire("7VNNI");

var $dpfT9 = parcelRequire("dpfT9");

var $9KRJk = parcelRequire("9KRJk");

var $2A04N = parcelRequire("2A04N");

var $aLVM6 = parcelRequire("aLVM6");

var $i9g1N = parcelRequire("i9g1N");

var $kzCvy = parcelRequire("kzCvy");

var $dS41P = parcelRequire("dS41P");

var $cen46 = parcelRequire("cen46");

var $t6MXq = parcelRequire("t6MXq");

var $jRU2X = parcelRequire("jRU2X");
const $2643af30ba48de1c$export$4de5eb17326eea98 = (action)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'meta',
        'optimistic',
        'type'
    ], null) === (0, $alNv9.REVERT) && (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'meta',
        'showGenericFlag'
    ], null) === true) return (0, $467lJ.default).genericError();
    switch(action.type){
        case 0, $hf5c2.CARD_CREATE_FILTERED:
            return (props)=>// @ts-expect-error - TS2322 - Type '{ card: Card; id: string | number; onDismissed: ((id: string | number) => void) & ((id: string | number) => void); }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<{ onPrimaryActionClick: (cardId: any) => void; }, "onPrimaryActionClick">, any, any>> & Readonly<...> & Readonly<...>'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VNNI.default), {
                    ...props,
                    card: action.payload
                });
        case 0, $hf5c2.CARD_CREATE_FILTERED_V2:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpfT9.default), {
                    ...props,
                    cardIds: action.payload
                });
        case 0, $6GNN7.CARD_DRAG_DISALLOWED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aLVM6.CardDragDisallowedFlag), props);
        case 0, $e978U.FLAG_SPRINT_STARTED:
            return (0, $t6MXq.showSprintStartedFlag)();
        case 0, $4cr9K.SHOW_ERROR_FLAG_FROM_SWAG:
            return (0, $4tEQ4.extractFlagFromAction)(action);
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2A04N.default), {
                    ...props,
                    cardKeys: action.payload.cardsIdentifiers.map((cardIds)=>cardIds.key)
                });
        case 0, $hf5c2.CARD_CREATE_UNMAPPED:
            return (props)=>{
                const { payload: { cardKeys: cardKeys, numIssues: numIssues } } = action;
                if (cardKeys) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2A04N.default), {
                    ...props,
                    cardKeys: cardKeys
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KRJk.default), {
                    ...props,
                    numIssues: numIssues
                });
            };
        case 0, $8MHVw.FILTERED_CARD_FAILURE:
        case 0, $8MHVw.REFILTER_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS41P.default), props);
        case 0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzCvy.default), props);
        case 0, $hf5c2.CARD_CREATE_GLOBAL:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c57g.CardCreateGlobalFlag), {
                    ...props,
                    cardKeys: action.payload.globalIssues.map((issue)=>issue.issueKey)
                });
        case 0, $hf5c2.CARD_CREATE_SPLIT_ISSUE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cen46.SplitIssueSuccessFlag), {
                    ...props,
                    originalIssueKey: action.payload.originalIssueKey,
                    issueKeys: action.payload.newIssueKeys
                });
        case 0, $6GNN7.CARDS_MOVE_DISABLED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9g1N.default), {
                    ...props,
                    boardId: action.payload.boardId,
                    isAdmin: action.payload.isAdmin
                });
        case 0, $6GNN7.CARDS_TRANSITION_AND_RANK_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRU2X.TransitionAndRankFailureFlag), {
                    ...props,
                    errorMessages: action.payload.errorMessages
                });
        case 0, $avYIL.BULK_OPS_SHOW_FAILED_FLAG:
            return (props)=>{
                const { payload: payload } = action;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $60s5X.default), {
                    ...props,
                    ...payload
                });
            };
        default:
            return undefined;
    }
};

});
parcelRegister("alNv9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.optimistic = module.exports.ensureState = module.exports.REVERT = module.exports.COMMIT = module.exports.BEGIN = undefined;
var $78924382a593567a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bXQuv = parcelRequire("bXQuv");
var $78924382a593567a$var$BEGIN = module.exports.BEGIN = '@@optimist/BEGIN';
var $78924382a593567a$var$COMMIT = module.exports.COMMIT = '@@optimist/COMMIT';
var $78924382a593567a$var$REVERT = module.exports.REVERT = '@@optimist/REVERT';
var $78924382a593567a$var$isOptimistState = function isOptimistState(state) {
    return state && Object.keys(state).length === 3 && state.hasOwnProperty('beforeState') && state.hasOwnProperty('history') && state.hasOwnProperty('current');
};
var $78924382a593567a$var$ensureState = module.exports.ensureState = function ensureState(state) {
    return $78924382a593567a$var$isOptimistState(state) ? state.current : state;
};
var $78924382a593567a$var$createState = function createState(state) {
    return {
        beforeState: undefined,
        history: [],
        current: state
    };
};
var $78924382a593567a$var$applyCommit = function applyCommit(state, targetActionIndex, reducer) {
    var history = state.history;
    // If the action to commit is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutCommit = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutCommit, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic item in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            beforeState: undefined
        });
        // Create a new history starting with the next one
        var newHistory = historyWithoutCommit.slice(nextOptimisticIndex);
        // And run every action up until that next one to get the new beforeState
        var newBeforeState = history.reduce(function(mutState, action, index) {
            return index <= nextOptimisticIndex ? reducer(mutState, action) : mutState;
        }, state.beforeState);
        return $78924382a593567a$var$_extends({}, state, {
            history: newHistory,
            beforeState: newBeforeState
        });
    } else {
        // If the committed action isn't the first in the queue, find out where it is
        var actionToCommit = history[targetActionIndex];
        // Make it a regular non-optimistic action
        var newAction = Object.assign({}, actionToCommit, {
            meta: Object.assign({}, actionToCommit.meta, {
                optimistic: null
            })
        });
        var _newHistory = state.history.slice();
        _newHistory.splice(targetActionIndex, 1, newAction);
        return $78924382a593567a$var$_extends({}, state, {
            history: _newHistory
        });
    }
};
var $78924382a593567a$var$applyRevert = function applyRevert(state, targetActionIndex, reducer) {
    var beforeState = state.beforeState, history = state.history;
    var newHistory = void 0;
    // If the action to revert is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutRevert = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutRevert, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic action in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            current: historyWithoutRevert.reduce(function(s, action) {
                return reducer(s, action);
            }, beforeState),
            beforeState: undefined
        });
        newHistory = historyWithoutRevert.slice(nextOptimisticIndex);
    } else {
        newHistory = history.slice();
        newHistory.splice(targetActionIndex, 1);
    }
    var newCurrent = newHistory.reduce(function(s, action) {
        return reducer(s, action);
    }, beforeState);
    return $78924382a593567a$var$_extends({}, state, {
        history: newHistory,
        current: newCurrent,
        beforeState: beforeState
    });
};
var $78924382a593567a$var$optimistic = module.exports.optimistic = function optimistic(reducer) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = Object.assign({
        maxHistory: 100
    }, rawConfig);
    return function(state, action) {
        if (state === undefined || !$78924382a593567a$var$isOptimistState(state)) state = $78924382a593567a$var$createState(reducer($78924382a593567a$var$ensureState(state), {}));
        var historySize = state.history.length;
        var _ref = action.meta && action.meta.optimistic || {}, type = _ref.type, id = _ref.id;
        // a historySize means there is at least 1 outstanding fetch
        if (historySize) {
            if (type !== $78924382a593567a$var$COMMIT && type !== $78924382a593567a$var$REVERT) {
                if (historySize > config.maxHistory) console.error('@@optimist: Possible memory leak detected.\n                  Verify all actions result in a commit or revert and\n                  don\'t use optimistic-UI for long-running server fetches');
                // if it's a BEGIN but we already have a historySize, treat it like a non-opt
                return $78924382a593567a$var$_extends({}, state, {
                    history: state.history.concat([
                        action
                    ]),
                    current: reducer(state.current, action)
                });
            }
            var targetActionIndex = (0, $bXQuv.findIndex)(state.history, function(action) {
                return action.meta && action.meta.optimistic && action.meta.optimistic.id === id;
            });
            if (targetActionIndex === -1) throw new Error('@@optimist: Failed to ' + (type === $78924382a593567a$var$COMMIT ? 'commit' : 'revert') + '. Transaction #' + id + ' does not exist!');
            // for resolutions, add a flag so that we know it is not an optimistic action
            action.meta.optimistic.isNotOptimistic = true;
            // include the resolution in the history & current state
            var nextState = $78924382a593567a$var$_extends({}, state, {
                history: state.history.concat([
                    action
                ]),
                current: reducer(state.current, action)
            });
            var applyFunc = type === $78924382a593567a$var$COMMIT ? $78924382a593567a$var$applyCommit : $78924382a593567a$var$applyRevert;
            return applyFunc(nextState, targetActionIndex, reducer);
        }
        // create a beforeState since one doesn't already exist
        if (type === $78924382a593567a$var$BEGIN) return $78924382a593567a$var$_extends({}, state, {
            history: state.history.concat([
                action
            ]),
            current: reducer(state.current, action),
            beforeState: state.current
        });
        // standard action escape
        return $78924382a593567a$var$_extends({}, state, {
            current: reducer(state.current, action)
        });
    };
};

});
parcelRegister("bXQuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = $8b5dec00f6be39ba$var$findIndex;
function $8b5dec00f6be39ba$var$findIndex(arr, predicate) {
    var l = arr.length;
    for(var i = 0; i < l; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}

});


parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description
    });

});


parcelRegister("6c57g", function(module, exports) {

$parcel$export(module.exports, "CardCreateGlobalFlag", () => $44cad0f844ccec7d$export$b6918b93a6420e06);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $ftuxv = parcelRequire("ftuxv");

var $6ioBm = parcelRequire("6ioBm");

var $24y3R = parcelRequire("24y3R");

var $eCbBU = parcelRequire("eCbBU");
const $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';
const $44cad0f844ccec7d$export$93f5b027a66006a6 = ({ onDismissed: onDismissed, id: id, cardKeys: cardKeys })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = (0, $24y3R.getIssueDiscoveryUrl)(cardKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const flagTitle = cardKeys.length > 1 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitle, {
        issueCount: cardKeys.length
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).createSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).createSuccessFlagTitle, {
        issueKey: cardKeys[0]
    });
    const actions = [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).viewIssueLinkTextIssueTermRefresh : (0, $eCbBU.default).viewIssueLinkText, {
                numIssues: cardKeys.length
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$var$CopySuccess, null, formatMessage((0, $eCbBU.default).linkCopied)) : formatMessage((0, $eCbBU.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: flagTitle,
        actions: actions
    }));
};
const $44cad0f844ccec7d$var$CheckEligibilityAndReturnFlag = (props)=>{
    const { id: id, cardKeys: cardKeys, onDismissed: onDismissed } = props;
    const { isLoading: isLoading, shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag } = (0, $ftuxv.useRecommendTrialToFree)({
        id: id
    });
    if (isLoading) return null;
    if (shouldShowRecommendTrialFlag) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ioBm.RecommendTrialToFreeFlag), {
        flagId: `${id}`,
        issueKeys: cardKeys,
        onDismiss: onDismissed ? ()=>onDismissed(id) : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$export$93f5b027a66006a6, props);
};
const $44cad0f844ccec7d$export$b6918b93a6420e06 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate'), $44cad0f844ccec7d$var$CheckEligibilityAndReturnFlag, $44cad0f844ccec7d$export$93f5b027a66006a6); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44cad0f844ccec7d$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1ft0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $1eg3p = parcelRequire("1eg3p");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $hPtZI.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $hPtZI.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $hPtZI.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("fhw5b")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eg3p.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("lKKug", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("fhw5b", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));

});


parcelRegister("ftuxv", function(module, exports) {

$parcel$export(module.exports, "useRecommendTrialToFree", () => $94af4859a16bc856$export$12cc6b04754d240d);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $joX8T = parcelRequire("joX8T");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $95EVP = parcelRequire("95EVP");

var $8zOmE = parcelRequire("8zOmE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2XPB5 = parcelRequire("2XPB5");

var $bPCb6 = parcelRequire("bPCb6");
const $94af4859a16bc856$export$12cc6b04754d240d = ({ id: id })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { software: jswEdition } = (0, $k9JTq.useAppEditions)();
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_recommended_trial_to_free_ab');
    const cohort = expConfig.get((0, $joX8T.COHORT), (0, $joX8T.NOT_ENROLLED));
    const isPassedGate = (0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate');
    const flagId = (0, $2XPB5.getFlagId)();
    const [shouldShowRecommendTrialFlag, setShouldShowRecommendTrialFlag] = (0, $5uXOq.useState)(false);
    const isInJiraProject = projectContext?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTestCohort = cohort === 'test';
    const isEligible = (0, $5uXOq.useMemo)(()=>isPassedGate && cohort !== (0, $joX8T.NOT_ENROLLED) && jswEdition === (0, $ldyPw.FREE_EDITION) && isInJiraProject && (!flagId || flagId === `${id}`), [
        isPassedGate,
        cohort,
        jswEdition,
        isInJiraProject,
        flagId,
        id
    ]);
    const { userCanUpgrade: userCanUpgrade, isLoading: isLoading } = (0, $bPCb6.useCheckIfUserCanUpgrade)(!isEligible);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEligible || !userCanUpgrade) return;
        // only fire exposure if the user is eligible
        fireExposure();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'rtfExperiment exposed', {
            experiment: 'jira_recommended_trial_to_free_ab',
            cohort: cohort
        });
        // for the test cohort, we will set the flag as seen once it has rendered
        if (!isTestCohort) {
            (0, $2XPB5.setHasSeenFlag)(`${id}`);
            return;
        }
        // only set the flag if the user is eligible and in the test cohort
        setShouldShowRecommendTrialFlag(true);
    }, [
        isEligible,
        userCanUpgrade,
        cohort,
        isTestCohort,
        id,
        fireExposure,
        createAnalyticsEvent
    ]);
    return {
        shouldShowRecommendTrialFlag: shouldShowRecommendTrialFlag,
        isLoading: isLoading
    };
};

});
parcelRegister("2XPB5", function(module, exports) {

$parcel$export(module.exports, "getFlagId", () => $3543236f451df4c9$export$415e9f2b45fdf9bb);
$parcel$export(module.exports, "setHasSeenFlag", () => $3543236f451df4c9$export$3d880171a29f5f5c);
const $3543236f451df4c9$var$storageKey = 'jira_recommended_trial_to_free_ab_flag_seen';
function $3543236f451df4c9$export$415e9f2b45fdf9bb() {
    if (typeof window === 'undefined') return true;
    return localStorage.getItem($3543236f451df4c9$var$storageKey)?.toString();
}
function $3543236f451df4c9$export$3d880171a29f5f5c(id) {
    if (typeof window === 'undefined') return;
    localStorage.setItem($3543236f451df4c9$var$storageKey, id);
}

});

parcelRegister("bPCb6", function(module, exports) {

$parcel$export(module.exports, "useCheckIfUserCanUpgrade", () => $4bb7ecfce8361721$export$8242cede3f5a02b3);

var $fLoq8 = parcelRequire("fLoq8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $95EVP = parcelRequire("95EVP");

var $koeKL = parcelRequire("koeKL");
const $4bb7ecfce8361721$export$8242cede3f5a02b3 = (skip = false)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [userCanUpgrade, setUserCanUpgrade] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        (0, $8Uumt.fetchQuery)(environment, (0, $fLoq8.default), {
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
        }).subscribe({
            start: ()=>{
                setIsLoading(true);
            },
            complete: ()=>{
                setIsLoading(false);
            },
            next: (data)=>{
                const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canUserUpgrade = entitlement?.experienceCapabilities?.changeOffering?.isAvailableToUser;
                setUserCanUpgrade(!!canUserUpgrade);
            },
            error: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'useCheckIfUserCanUpgrade',
                        packageName: 'jiraRecommendTrialToFree',
                        teamName: 'luna-growth'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
                setIsLoading(false);
                setUserCanUpgrade(false);
            }
        });
    }, [
        cloudId,
        skip,
        createAnalyticsEvent,
        environment
    ]);
    return {
        userCanUpgrade: userCanUpgrade,
        isLoading: isLoading
    };
};

});
parcelRegister("fLoq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $456100b00a8c0d97$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5260673e7b49f18bba0b28122ce4ee09>>
 * @relayHash 0e295bd8cf5556f9a2ed20c4e7811231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721
const $456100b00a8c0d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "eligibilityUserCanUpgradeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3363969b24a2c14b0a0a295feb9e9c205423d0ccd5685c2eaf9083dda1987721",
            "metadata": {},
            "name": "eligibilityUserCanUpgradeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$456100b00a8c0d97$var$node.hash = "bfb3759dfd2863e60432f4c195d1030a";
var $456100b00a8c0d97$export$2e2bcd8739ae039 = $456100b00a8c0d97$var$node;

});



parcelRegister("6ioBm", function(module, exports) {

$parcel$export(module.exports, "RecommendTrialToFreeFlag", () => $8c6d38d59ee39900$export$2de2b4a8ed8a1389);

var $5uXOq = parcelRequire("5uXOq");

var $1PedV = parcelRequire("1PedV");

var $flJYh = parcelRequire("flJYh");
const $8c6d38d59ee39900$export$2de2b4a8ed8a1389 = ({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PedV.FeatureGateChecker), {
        experiment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $flJYh.IssueCreatedFlag), {
            flagId: flagId,
            onDismiss: onDismiss,
            issueKeys: issueKeys
        })
    });

});
parcelRegister("1PedV", function(module, exports) {

$parcel$export(module.exports, "FeatureGateChecker", () => $6adbd2160cc3d9ec$export$5f9d7deb88921f2f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3Syrj = parcelRequire("3Syrj");
const $6adbd2160cc3d9ec$export$5f9d7deb88921f2f = ({ experiment: experiment })=>{
    const isInGate = !!(0, $4R6GH.fg)('jira_recommended_trial_to_free_ab_gate');
    if (isInGate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Syrj.EligibilityChecker), null, experiment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("3Syrj", function(module, exports) {

$parcel$export(module.exports, "EligibilityChecker", () => $93b19d108b39ba8d$export$cca196bfee81cdcf);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $bPCb6 = parcelRequire("bPCb6");
const $93b19d108b39ba8d$export$cca196bfee81cdcf = ({ children: children })=>{
    const cohort = (0, $6s1PB.expVal)('jira_recommended_trial_to_free_ab', 'cohort', 'not_enrolled');
    const { userCanUpgrade: userCanUpgrade } = (0, $bPCb6.useCheckIfUserCanUpgrade)(cohort === 'not_enrolled');
    const { software: jswEdition } = (0, $k9JTq.useAppEditions)();
    const eligibleForTrial = jswEdition === (0, $ldyPw.FREE_EDITION) && userCanUpgrade && cohort && cohort === 'test';
    if (eligibleForTrial) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});


parcelRegister("flJYh", function(module, exports) {

$parcel$export(module.exports, "IssueCreatedFlag", () => $6e8c2958b2d97644$export$6ac95aa79f7e7f3f);

var $56tYp = parcelRequire("56tYp");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $WQRtS = parcelRequire("WQRtS");

var $8Uumt = parcelRequire("8Uumt");

var $89thI = parcelRequire("89thI");

var $53KbV = parcelRequire("53KbV");

var $3nMUH = parcelRequire("3nMUH");

var $N53xe = parcelRequire("N53xe");

var $29ctK = parcelRequire("29ctK");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $iaTnv = parcelRequire("iaTnv");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $39xOx = parcelRequire("39xOx");

var $pa9q9 = parcelRequire("pa9q9");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $aOzfJ = parcelRequire("aOzfJ");

var $2XPB5 = parcelRequire("2XPB5");

var $5mx0k = parcelRequire("5mx0k");
function $6e8c2958b2d97644$export$6ac95aa79f7e7f3f(props) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $39xOx.JSErrorBoundary), {
        id: "rtfIssueCreatedFlag",
        packageName: "jiraRecommendTrialToFree",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ $5uXOq.createElement($6e8c2958b2d97644$export$92f18cc245e11db5, props));
}
function $6e8c2958b2d97644$export$92f18cc245e11db5({ flagId: flagId, onDismiss: onDismiss, issueKeys: issueKeys }) {
    const [showReloadPageModal, setShowReloadPageModal] = (0, $5uXOq.useState)(false);
    const openModal = (0, $5uXOq.useCallback)(()=>setShowReloadPageModal(true), []);
    const closeModal = (0, $5uXOq.useCallback)(()=>setShowReloadPageModal(false), []);
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const linkToTrial = (0, $8Uumt.useLazyLoadQuery)((0, $56tYp.default), {
        cloudId: cloudId,
        productKey: 'jira-software.ondemand',
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    })?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOffering?.experienceUrl;
    (0, $5uXOq.useEffect)(()=>{
        (0, $2XPB5.setHasSeenFlag)(flagId);
    }, [
        flagId
    ]);
    const origin = new (0, $WQRtS.default)({
        product: 'jira'
    });
    const issueCount = issueKeys.length;
    if (showReloadPageModal) return /*#__PURE__*/ $5uXOq.createElement((0, $5mx0k.ReloadPageModal), {
        closeModal: closeModal
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "recommendTrialToFreeFlag"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $6e8c2958b2d97644$var$cardStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $iaTnv.default), {
        alignInline: "start",
        spread: "space-between"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), {
        alignInline: "stretch",
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $6e8c2958b2d97644$var$inlineStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($N53xe))), {
        label: "success",
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "large",
        spacing: "spacious"
    }), /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $6e8c2958b2d97644$var$titleStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1m92z.default), null, issueCount > 1 ? /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-multiple",
        defaultMessage: "You've created {issueCount, plural, one {# issue} other {# issues}}",
        values: {
            issueCount: issueCount
        }
    }) : /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.card-title-single",
        defaultMessage: 'You\'ve created "{issueKey}" issue',
        values: {
            issueKey: issueKeys[0]
        }
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $89thI.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'rtfDismissFlag');
            if (onDismiss) {
                onDismiss();
                return;
            }
            dismissFlag(flagId);
        },
        "aria-label": "Close"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nMUH))), {
        label: "close",
        color: "var(--ds-icon, #44546F)"
    }))), /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), {
        space: "space.200",
        alignBlock: "center",
        spread: "space-between",
        grow: "fill",
        xcss: $6e8c2958b2d97644$var$contentContainerStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $iaTnv.default), {
        alignBlock: "center",
        alignInline: "start",
        space: "space.100",
        xcss: $6e8c2958b2d97644$var$mainContentStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $53KbV.default), {
        size: "small"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.content-title",
        defaultMessage: "Now add your team"
    })), /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $6e8c2958b2d97644$var$bodyStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1m92z.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.content",
        defaultMessage: "Upgrade to get unlimited users and add everyone you work with."
    }))), linkToTrial && /*#__PURE__*/ $5uXOq.createElement((0, $29ctK.default), {
        href: origin.addToUrl(linkToTrial),
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'rtfTryItFree');
            openModal();
        },
        target: "_blank"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1m92z.default), {
        color: "color.link"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.issue-created.try-it-now-link",
        defaultMessage: "Try it free"
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $iaTnv.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $6e8c2958b2d97644$var$illustrationStackStyles
    }, /*#__PURE__*/ $5uXOq.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aOzfJ))),
        alt: "",
        className: (0, $bwpsq.default)([
            "_c71l1ame _p12f1ame"
        ])
    }))))));
}
const $6e8c2958b2d97644$var$cardStyles = (0, $jJ1Sb.xcss)({
    borderColor: 'color.border',
    borderRadius: '3px',
    boxShadow: 'elevation.shadow.overlay',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay'
});
const $6e8c2958b2d97644$var$inlineStyles = (0, $jJ1Sb.xcss)({
    borderBottom: '1px solid',
    borderColor: 'color.border',
    padding: 'space.200'
});
const $6e8c2958b2d97644$var$titleStyles = (0, $jJ1Sb.xcss)({
    fontSize: 'font.body'
});
const $6e8c2958b2d97644$var$contentContainerStyles = (0, $jJ1Sb.xcss)({
    background: 'color.neutral.light',
    paddingInline: 'space.250',
    paddingBlock: 'space.400',
    width: '100%'
});
const $6e8c2958b2d97644$var$mainContentStyles = (0, $jJ1Sb.xcss)({
    maxWidth: '240px'
});
const $6e8c2958b2d97644$var$bodyStyles = (0, $jJ1Sb.xcss)({
    fontSize: 'font.body',
    lineHeight: '20px',
    fontWeight: '400'
});
const $6e8c2958b2d97644$var$illustrationStyles = null;
const $6e8c2958b2d97644$var$illustrationStackStyles = (0, $jJ1Sb.xcss)({
    paddingTop: 'space.200'
});

});
parcelRegister("56tYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a5082779d6bc38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a0d3fbb3610dfdcd8128a1b88d6f6a8>>
 * @relayHash 9e0292a0e9e1a7cfc043ea04242ec447
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319
const $a7a5082779d6bc38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d7442a20376f6ce597664338dc598c7ade7ff8e2f238b04acb696e15c5022319",
            "metadata": {},
            "name": "issueCreatedFlagGetTrialLinkQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a7a5082779d6bc38$var$node.hash = "4d50fdd81aa1005eb031986467ce9f75";
var $a7a5082779d6bc38$export$2e2bcd8739ae039 = $a7a5082779d6bc38$var$node;

});

parcelRegister("N53xe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be69851386531f5b95e24ba5766e7ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09387fbcbc7f61df$var$_react = $09387fbcbc7f61df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $09387fbcbc7f61df$var$_success = $09387fbcbc7f61df$var$_interopRequireDefault((parcelRequire("6K6ZN")));

var $09387fbcbc7f61df$var$_success2 = $09387fbcbc7f61df$var$_interopRequireDefault((parcelRequire("gwvLf")));
function $09387fbcbc7f61df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09387fbcbc7f61df$var$SuccessIcon = (props)=>/*#__PURE__*/ $09387fbcbc7f61df$var$_react.default.createElement($09387fbcbc7f61df$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $09387fbcbc7f61df$var$_success2.default
    }, props));
$09387fbcbc7f61df$var$SuccessIcon.Name = 'SuccessIconMigration';
var $09387fbcbc7f61df$var$_default = module.exports.default = $09387fbcbc7f61df$var$SuccessIcon;

});
parcelRegister("6K6ZN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e8c772aea92ac0c$var$_react = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4e8c772aea92ac0c$var$_UNSAFE_baseNew = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("huIZN")));
function $4e8c772aea92ac0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e8c772aea92ac0c$var$SuccessIcon = (props)=>/*#__PURE__*/ $4e8c772aea92ac0c$var$_react.default.createElement($4e8c772aea92ac0c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$4e8c772aea92ac0c$var$SuccessIcon.displayName = 'SuccessIcon';
var $4e8c772aea92ac0c$var$_default = module.exports.default = $4e8c772aea92ac0c$var$SuccessIcon;

});

parcelRegister("gwvLf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c078459a20aa5362$var$_react = $c078459a20aa5362$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $c078459a20aa5362$var$_success = $c078459a20aa5362$var$_interopRequireDefault((parcelRequire("6K6ZN")));
function $c078459a20aa5362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c078459a20aa5362$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $c078459a20aa5362$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $c078459a20aa5362$var$_success.default
    }));
$c078459a20aa5362$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $c078459a20aa5362$var$_default = module.exports.default = $c078459a20aa5362$var$EditorSuccessIcon;

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("aOzfJ", function(module, exports) {
module.exports = new URL("now-add-your-team.9826b1af.svg", import.meta.url).toString();

});

parcelRegister("5mx0k", function(module, exports) {

$parcel$export(module.exports, "ReloadPageModal", () => $11cc1ff3d8018c4e$export$7db633aff5c8fd9a);

var $5uXOq = parcelRequire("5uXOq");

var $dHJL9 = parcelRequire("dHJL9");

var $lrYDv = parcelRequire("lrYDv");

var $dOHxT = parcelRequire("dOHxT");
var $ezPyr = parcelRequire("ezPyr");
var $bvt08 = parcelRequire("bvt08");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");
var $lkDqR = parcelRequire("lkDqR");

var $dsFR3 = parcelRequire("dsFR3");
var $1m92z = parcelRequire("1m92z");

var $ousew = parcelRequire("ousew");
const $11cc1ff3d8018c4e$export$7db633aff5c8fd9a = ({ closeModal: closeModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lrYDv))), {
        label: "info",
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.title",
        defaultMessage: "Reload this page"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        id: "jira-recommend-trial-to-free.reload-this-page.body",
        defaultMessage: "If you've upgraded, reload this page to start your trial. Changes may take up to a minute."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        appearance: "subtle",
        onClick: closeModal
    }, "Close"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        appearance: "primary",
        onClick: ()=>{
            if (typeof window !== 'undefined') window.location.reload();
        }
    }, "Reload"))));

});
parcelRegister("lrYDv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9db27b03aad4de5$var$_react = $f9db27b03aad4de5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f9db27b03aad4de5$var$_UNSAFE_baseNew = $f9db27b03aad4de5$var$_interopRequireDefault((parcelRequire("huIZN")));
function $f9db27b03aad4de5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9db27b03aad4de5$var$InformationIcon = (props)=>/*#__PURE__*/ $f9db27b03aad4de5$var$_react.default.createElement($f9db27b03aad4de5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$f9db27b03aad4de5$var$InformationIcon.displayName = 'InformationIcon';
var $f9db27b03aad4de5$var$_default = module.exports.default = $f9db27b03aad4de5$var$InformationIcon;

});




parcelRegister("24y3R", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $ebd8351448f87226$export$852450339fdb3b37);
const $ebd8351448f87226$export$852450339fdb3b37 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});

parcelRegister("eCbBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a405eb29c4610c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a405eb29c4610c88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "software-flags.card-create-global.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkText: {
        "id": "software-flags.card-create-global.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    },
    copyLink: {
        "id": "software-flags.card-create-global.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "software-flags.card-create-global.link-copied",
        "defaultMessage": "Copied"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    }
});

});


parcelRegister("4cr9K", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR_FLAG_FROM_SWAG", () => $dcafaf5dc15a1c9d$export$849b6aff5e6c9763);
$parcel$export(module.exports, "showErrorFlag", () => $dcafaf5dc15a1c9d$export$dfa2148cdb92917d);
$parcel$export(module.exports, "XSRF_CHECK_FAILED", () => $dcafaf5dc15a1c9d$export$653597ecd43ee3b5);
const $dcafaf5dc15a1c9d$export$849b6aff5e6c9763 = 'SHOW_ERROR_FLAG_FROM_SWAG';
const $dcafaf5dc15a1c9d$export$dfa2148cdb92917d = (error)=>({
        type: $dcafaf5dc15a1c9d$export$849b6aff5e6c9763,
        payload: error
    });
const $dcafaf5dc15a1c9d$export$653597ecd43ee3b5 = 'XSRF_CHECK_FAILED';

});

parcelRegister("4tEQ4", function(module, exports) {

$parcel$export(module.exports, "getErrorFlag", () => $854596c2afd2e9d8$export$7a23a73c35436772);
$parcel$export(module.exports, "extractFlagFromAction", () => $854596c2afd2e9d8$export$6783b18b1c9d1ab1);

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $4cr9K = parcelRequire("4cr9K");

var $i5xPZ = parcelRequire("i5xPZ");

var $cNrxd = parcelRequire("cNrxd");
const $854596c2afd2e9d8$export$2cf9ab1b4d75e34e = (error)=>{
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors || graphQLErrors.length === 0) return null;
    const applicationError = graphQLErrors.find((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'errorType'
        ], false));
    if (!applicationError) return null;
    return {
        errorType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(applicationError, [
            'extensions',
            'errorType'
        ], '')
    };
};
const $854596c2afd2e9d8$export$eeae51b1c2ad1cfa = (error)=>{
    if ((0, $cNrxd.isFetchError)(error)) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null),
        userMessage: null
    };
    const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
    if (networkError) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null),
        userMessage: null
    };
    if (graphQLErrors.length > 0) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'statusCode'
        ], null),
        userMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'userMessage'
        ], null)
    };
    return {
        statusCode: null,
        userMessage: null
    };
};
const $854596c2afd2e9d8$var$isApplicationError = (error)=>{
    const applicationError = $854596c2afd2e9d8$export$2cf9ab1b4d75e34e(error);
    return applicationError?.errorType === (0, $4cr9K.XSRF_CHECK_FAILED);
};
const $854596c2afd2e9d8$export$7a23a73c35436772 = (error)=>{
    if (!(0, $cNrxd.isFetchError)(error)) {
        // check if any error contains "errorType", and process prior to http-status-code
        if ($854596c2afd2e9d8$var$isApplicationError(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'error',
            title: (0, $i5xPZ.default).xsrfCheckFailedTitle,
            description: (0, $i5xPZ.default).xsrfCheckFailedDescription,
            error: error
        };
    }
    const { statusCode: httpStatusCode, userMessage: userMessage } = $854596c2afd2e9d8$export$eeae51b1c2ad1cfa(error);
    if ((httpStatusCode === 400 || httpStatusCode === 403) && userMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        type: 'error',
        title: (0, $467lJ.default).genericError().title,
        description: [
            (0, $i5xPZ.default).genericErrorDescription,
            {
                userMessage: userMessage
            }
        ],
        error: error
    };
    if (httpStatusCode === 401) {
        const unauthorizedError = (0, $467lJ.default).unauthorized();
        unauthorizedError.error = error;
        return unauthorizedError;
    }
    if (httpStatusCode === 403) {
        const forbiddenError = (0, $467lJ.default).forbidden();
        forbiddenError.error = error;
        return forbiddenError;
    }
    const genericError = (0, $467lJ.default).genericError();
    genericError.error = error;
    return genericError;
};
const $854596c2afd2e9d8$export$6783b18b1c9d1ab1 = (action)=>{
    const { payload: error } = action;
    if ((0, $cNrxd.isSwagError)(error) || (0, $cNrxd.isFetchError)(error)) return $854596c2afd2e9d8$export$7a23a73c35436772(error);
    // eslint-disable-next-line no-console
    console.error('Action showErrorFlag(error) contains invalid error format. \n Make sure you are using query$() or mutation$() utils from @atlassian/jira-software-swag in /rest layer');
    return undefined;
};

});
parcelRegister("i5xPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a9111c121ba41d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61a9111c121ba41d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericErrorDescription: {
        "id": "software-swag.common.generic-error-description",
        "defaultMessage": "{userMessage}"
    },
    xsrfCheckFailedTitle: {
        "id": "software-swag.common.xsrf-check-failed-title",
        "defaultMessage": "Our session has expired"
    },
    xsrfCheckFailedDescription: {
        "id": "software-swag.common.xsrf-check-failed-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage);
        this.graphQLErrors = [];
        this.networkError = null;
        // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});


parcelRegister("avYIL", function(module, exports) {

$parcel$export(module.exports, "BULK_OPS_SHOW_FAILED_FLAG", () => $c0a333a3121809e1$export$d9ef62afaf787d0f);
$parcel$export(module.exports, "bulkOpsShowFailedFlag", () => $c0a333a3121809e1$export$4a9779e37388dc91);
const $c0a333a3121809e1$export$d9ef62afaf787d0f = 'state.actions.bulk-ops-flags.BULK_OPS_SHOW_FAILED_FLAG';
const $c0a333a3121809e1$export$4a9779e37388dc91 = (payload)=>({
        type: $c0a333a3121809e1$export$d9ef62afaf787d0f,
        payload: payload
    });

});

parcelRegister("hf5c2", function(module, exports) {

$parcel$export(module.exports, "CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC", () => $ba18c1f1070affea$export$3b377ab2ad221faa);
$parcel$export(module.exports, "CARD_CREATE_MULTIPLE_REQUEST", () => $ba18c1f1070affea$export$ffc92aa1986bdcac);
$parcel$export(module.exports, "CARD_CREATE_SUCCESS", () => $ba18c1f1070affea$export$f1c65160dd038544);
$parcel$export(module.exports, "CARD_CREATE_FAILURE", () => $ba18c1f1070affea$export$10f0879d5640132c);
$parcel$export(module.exports, "CARD_CREATE_FILTERED", () => $ba18c1f1070affea$export$20457ba50549c0b6);
$parcel$export(module.exports, "CARD_CREATE_FILTERED_V2", () => $ba18c1f1070affea$export$a7dcdd006d3cee32);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED", () => $ba18c1f1070affea$export$ac5655119bbf2fd5);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK", () => $ba18c1f1070affea$export$db85d3288a006ee9);
$parcel$export(module.exports, "CARD_CREATE_GLOBAL", () => $ba18c1f1070affea$export$7e3530b9017404ec);
$parcel$export(module.exports, "CARD_CREATE_SPLIT_ISSUE", () => $ba18c1f1070affea$export$3a82665bcf11f9d6);
$parcel$export(module.exports, "cardCreateMultipleRequest", () => $ba18c1f1070affea$export$67a60206c7a89110);
$parcel$export(module.exports, "cardCreateEndOfBacklogOptimistic", () => $ba18c1f1070affea$export$ffd447be3d58e464);
$parcel$export(module.exports, "cardCreateSuccess", () => $ba18c1f1070affea$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $ba18c1f1070affea$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $ba18c1f1070affea$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardCreateUnmapped", () => $ba18c1f1070affea$export$2afdf25d9071462e);
$parcel$export(module.exports, "cardCreateUnmappedWithIssueLink", () => $ba18c1f1070affea$export$7e2a2d17eb3fb542);
$parcel$export(module.exports, "cardCreateGlobal", () => $ba18c1f1070affea$export$7fd1edcce679a11d);
$parcel$export(module.exports, "splitIssueCreate", () => $ba18c1f1070affea$export$f587280de61983a7);

var $c0irb = parcelRequire("c0irb");
const $ba18c1f1070affea$export$3b377ab2ad221faa = 'state.actions.cards.create.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC';
const $ba18c1f1070affea$export$ffc92aa1986bdcac = 'state.actions.cards.create.CARD_CREATE_MULTIPLE_REQUEST';
const $ba18c1f1070affea$export$f1c65160dd038544 = 'state.actions.cards.create.CARD_CREATE_SUCCESS';
const $ba18c1f1070affea$export$10f0879d5640132c = 'state.actions.cards.create.CARD_CREATE_FAILURE';
const $ba18c1f1070affea$export$20457ba50549c0b6 = 'state.actions.cards.create.CARD_CREATE_FILTERED';
const $ba18c1f1070affea$export$a7dcdd006d3cee32 = 'state.actions.cards.create.CARD_CREATE_FILTERED_V2';
const $ba18c1f1070affea$export$ac5655119bbf2fd5 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED';
const $ba18c1f1070affea$export$db85d3288a006ee9 = 'state.actions.cards.create.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK';
const $ba18c1f1070affea$export$7e3530b9017404ec = 'state.actions.cards.create.CARD_CREATE_GLOBAL';
const $ba18c1f1070affea$export$3a82665bcf11f9d6 = 'state.actions.cards.create.CARD_CREATE_SPLIT_ISSUE';
const $ba18c1f1070affea$export$67a60206c7a89110 = ({ tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon, parentId: parentId, fixVersions: fixVersions, insertBefore: insertBefore = null, listId: listId, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, analyticsEvent: analyticsEvent })=>({
        type: $ba18c1f1070affea$export$ffc92aa1986bdcac,
        payload: {
            tempIds: tempIds,
            summaries: summaries,
            typeId: typeId,
            parentId: parentId,
            typeIcon: typeIcon,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$ffd447be3d58e464 = (changeEvent)=>({
        type: $ba18c1f1070affea$export$3b377ab2ad221faa,
        payload: {
            changeEvent: changeEvent
        }
    });
const $ba18c1f1070affea$export$b70c18d8546382b2 = (card, listId, temporaryCardId, createdWithRank, createdWithBulk, optimisticId, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$f1c65160dd038544,
        payload: {
            card: card,
            listId: listId,
            temporaryCardId: temporaryCardId,
            createdWithRank: createdWithRank,
            createdWithBulk: createdWithBulk
        },
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$151deebc0c103b3c = (numCards, optimisticId, errorMessage, statusCode, isClientFetchError = false, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$10f0879d5640132c,
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        },
        payload: {
            numCards: numCards,
            errorMessage: errorMessage,
            statusCode: statusCode,
            isClientFetchError: isClientFetchError
        }
    });
const $ba18c1f1070affea$export$f069b59557af9611 = (card)=>({
        type: $ba18c1f1070affea$export$20457ba50549c0b6,
        payload: card
    });
const $ba18c1f1070affea$export$f1c368b5cfb9b941 = (cardIds)=>({
        type: $ba18c1f1070affea$export$a7dcdd006d3cee32,
        payload: cardIds
    });
const $ba18c1f1070affea$export$2afdf25d9071462e = (numIssues, cardKeys, optimisticId, analyticsEvent)=>({
        type: $ba18c1f1070affea$export$ac5655119bbf2fd5,
        payload: {
            numIssues: numIssues,
            cardKeys: cardKeys
        },
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $ba18c1f1070affea$export$7e2a2d17eb3fb542 = (cardsIdentifiers)=>({
        type: $ba18c1f1070affea$export$db85d3288a006ee9,
        payload: {
            cardsIdentifiers: cardsIdentifiers
        }
    });
const $ba18c1f1070affea$export$7fd1edcce679a11d = (globalIssues)=>({
        type: $ba18c1f1070affea$export$7e3530b9017404ec,
        payload: {
            globalIssues: globalIssues
        }
    });
const $ba18c1f1070affea$export$f587280de61983a7 = (originalIssueKey, newIssueKeys)=>({
        type: $ba18c1f1070affea$export$3a82665bcf11f9d6,
        payload: {
            originalIssueKey: originalIssueKey,
            newIssueKeys: newIssueKeys
        }
    });

});
parcelRegister("c0irb", function(module, exports) {

$parcel$export(module.exports, "beginOptimisticUiMeta", () => $dc00a23f33d26d32$export$ebf02a95198109b6);
$parcel$export(module.exports, "commitOptimisticUiMeta", () => $dc00a23f33d26d32$export$76fabd640a0893d7);
$parcel$export(module.exports, "revertOptimisticUiMeta", () => $dc00a23f33d26d32$export$732172a3c90c9446);
$parcel$export(module.exports, "revertOptimisticUiWithFlagMeta", () => $dc00a23f33d26d32$export$62b48e9d9fa388fd);
$parcel$export(module.exports, "revertOptimisticUiWithDisabledFlagMeta", () => $dc00a23f33d26d32$export$b28d028621480a59);

var $alNv9 = parcelRequire("alNv9");

var $7Jxgt = parcelRequire("7Jxgt");
const $dc00a23f33d26d32$export$afc40f9cba31cfb3 = 'OPTIMISTIC_REVERT_FLAG';
const $dc00a23f33d26d32$export$ebf02a95198109b6 = ()=>({
        optimistic: {
            type: (0, $alNv9.BEGIN),
            id: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4()
        }
    });
const $dc00a23f33d26d32$export$76fabd640a0893d7 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.COMMIT),
            id: optimisticId
        }
    });
const $dc00a23f33d26d32$export$732172a3c90c9446 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        }
    });
const $dc00a23f33d26d32$export$62b48e9d9fa388fd = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        showGenericFlag: true
    });
const $dc00a23f33d26d32$export$b28d028621480a59 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        showGenericFlag: false
    });

});


parcelRegister("8MHVw", function(module, exports) {

$parcel$export(module.exports, "FILTERED_CARD_REQUEST", () => $1a641115eaf94368$export$4bd6c1b43abf609);
$parcel$export(module.exports, "filteredCardsRequest", () => $1a641115eaf94368$export$f3f4ad1fd3672b39);
$parcel$export(module.exports, "FILTERED_CARD_SUCCESS", () => $1a641115eaf94368$export$8f5834f2d50f84b5);
$parcel$export(module.exports, "filteredCardsSuccess", () => $1a641115eaf94368$export$aa1ef8dc8bb1be1b);
$parcel$export(module.exports, "FILTERED_CARD_FAILURE", () => $1a641115eaf94368$export$a17483c6b4ef650d);
$parcel$export(module.exports, "filteredCardsFailed", () => $1a641115eaf94368$export$8357ffeaf5f8e6b8);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_SUCCESS", () => $1a641115eaf94368$export$40b57191c66adf76);
$parcel$export(module.exports, "clearFilteredCardsSuccess", () => $1a641115eaf94368$export$f614b38cfc8bdee4);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_FAILURE", () => $1a641115eaf94368$export$deb9be1fa48a7771);
$parcel$export(module.exports, "clearFilteredCardsFailed", () => $1a641115eaf94368$export$aaedb9c3d66fff54);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR_REQUEST", () => $1a641115eaf94368$export$55f9625eb5f081fe);
$parcel$export(module.exports, "clearFilteredCardsRequest", () => $1a641115eaf94368$export$1eb5e229a2675c22);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR", () => $1a641115eaf94368$export$507d49f4a5857f49);
$parcel$export(module.exports, "clearFilteredCards", () => $1a641115eaf94368$export$81b4fe421a8e6fe4);
$parcel$export(module.exports, "REFILTER_SUCCESS", () => $1a641115eaf94368$export$4d3b992e541cd8ce);
$parcel$export(module.exports, "refilterSuccess", () => $1a641115eaf94368$export$a76ad4df662ec1fb);
$parcel$export(module.exports, "REFILTER_FAILURE", () => $1a641115eaf94368$export$f09f82741fa84c27);
$parcel$export(module.exports, "refilterFailure", () => $1a641115eaf94368$export$138c508cb95b66c3);
const $1a641115eaf94368$export$4bd6c1b43abf609 = 'state.actions.cards.filtered-cards.FILTERED_CARD_REQUEST';
const $1a641115eaf94368$export$f3f4ad1fd3672b39 = (issueIds, analyticsEvent, customFilterIds)=>({
        type: $1a641115eaf94368$export$4bd6c1b43abf609,
        payload: {
            issueIds: issueIds,
            customFilterIds: customFilterIds
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$8f5834f2d50f84b5 = 'state.actions.cards.filtered-cards.FILTERED_CARD_SUCCESS';
const $1a641115eaf94368$export$aa1ef8dc8bb1be1b = (cardIds, numCustomFiltersApplied, numIssueIds, analyticsEvent)=>({
        type: $1a641115eaf94368$export$8f5834f2d50f84b5,
        payload: cardIds,
        meta: {
            analyticsEvent: analyticsEvent,
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        }
    });
const $1a641115eaf94368$export$a17483c6b4ef650d = 'state.actions.cards.filtered-cards.FILTERED_CARD_FAILURE';
const $1a641115eaf94368$export$8357ffeaf5f8e6b8 = (error, analyticsEvent)=>({
        type: $1a641115eaf94368$export$a17483c6b4ef650d,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$40b57191c66adf76 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_SUCCESS';
const $1a641115eaf94368$export$f614b38cfc8bdee4 = (analyticsEvent)=>({
        type: $1a641115eaf94368$export$40b57191c66adf76,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$deb9be1fa48a7771 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_FAILURE';
const $1a641115eaf94368$export$aaedb9c3d66fff54 = (error, analyticsEvent)=>({
        type: $1a641115eaf94368$export$deb9be1fa48a7771,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$55f9625eb5f081fe = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR_REQUEST';
const $1a641115eaf94368$export$1eb5e229a2675c22 = (analyticsEvent)=>({
        type: $1a641115eaf94368$export$55f9625eb5f081fe,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $1a641115eaf94368$export$507d49f4a5857f49 = 'state.actions.cards.filtered-cards.FILTERED_CARD_CLEAR';
const $1a641115eaf94368$export$81b4fe421a8e6fe4 = ()=>({
        type: $1a641115eaf94368$export$507d49f4a5857f49
    });
const $1a641115eaf94368$export$4d3b992e541cd8ce = 'state.actions.cards.filtered-cards.REFILTER_SUCCESS';
const $1a641115eaf94368$export$a76ad4df662ec1fb = (excludedCardIds, filteredCardIds)=>({
        type: $1a641115eaf94368$export$4d3b992e541cd8ce,
        payload: {
            excludedCardIds: excludedCardIds,
            filteredCardIds: filteredCardIds
        }
    });
const $1a641115eaf94368$export$f09f82741fa84c27 = 'state.actions.cards.filtered-cards.REFILTER_FAILURE';
const $1a641115eaf94368$export$138c508cb95b66c3 = (error)=>({
        type: $1a641115eaf94368$export$f09f82741fa84c27,
        payload: {
            error: error
        }
    });

});

parcelRegister("6GNN7", function(module, exports) {

$parcel$export(module.exports, "CARDS_MOVE", () => $6badb4c03b3b2474$export$b33d2f47990782ba);
$parcel$export(module.exports, "cardsMove", () => $6badb4c03b3b2474$export$68ae240377a1a3d7);
$parcel$export(module.exports, "CARDS_MOVE_REQUEST", () => $6badb4c03b3b2474$export$e13d64a2ffca3097);
$parcel$export(module.exports, "cardsMoveRequest", () => $6badb4c03b3b2474$export$798efca6e002e359);
$parcel$export(module.exports, "CARDS_MOVE_NON_OPTIMISTIC_REQUEST", () => $6badb4c03b3b2474$export$6ae1b17e1807f013);
$parcel$export(module.exports, "cardsMoveNonOptimisticRequest", () => $6badb4c03b3b2474$export$c581f6c48c739c84);
$parcel$export(module.exports, "CARDS_MOVE_SUCCESS", () => $6badb4c03b3b2474$export$1b15bd4898d41956);
$parcel$export(module.exports, "cardsMoveSuccess", () => $6badb4c03b3b2474$export$d9bd27fc2155921d);
$parcel$export(module.exports, "CARDS_MOVE_FAILURE", () => $6badb4c03b3b2474$export$cfcb4c2d7a25be3d);
$parcel$export(module.exports, "cardsMoveFailure", () => $6badb4c03b3b2474$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "CARDS_TRANSITION_AND_RANK_FAILURE", () => $6badb4c03b3b2474$export$f9b68831e6b4477c);
$parcel$export(module.exports, "cardsTransitionAndRankFailure", () => $6badb4c03b3b2474$export$46bbdf3a931c511);
$parcel$export(module.exports, "cardsMoveCancel", () => $6badb4c03b3b2474$export$1d737d00c97bf50e);
$parcel$export(module.exports, "CARDS_MOVE_SET", () => $6badb4c03b3b2474$export$b807c0f117e6382c);
$parcel$export(module.exports, "cardsMoveSet", () => $6badb4c03b3b2474$export$106b66132b61ee71);
$parcel$export(module.exports, "CARDS_MOVE_DISABLED", () => $6badb4c03b3b2474$export$93dd8120f4a8e5e9);
$parcel$export(module.exports, "cardsMoveDisabled", () => $6badb4c03b3b2474$export$426568831df3d9fb);
$parcel$export(module.exports, "CARD_DRAG_DISALLOWED", () => $6badb4c03b3b2474$export$98c6114056f9246b);
$parcel$export(module.exports, "cardDragDisallowed", () => $6badb4c03b3b2474$export$a6e3bd55037d34be);

var $c0irb = parcelRequire("c0irb");
const $6badb4c03b3b2474$export$b33d2f47990782ba = 'state.actions.cards.move.CARDS_MOVE';
const $6badb4c03b3b2474$export$68ae240377a1a3d7 = (payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$b33d2f47990782ba,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $6badb4c03b3b2474$export$e13d64a2ffca3097 = 'state.actions.cards.move.CARDS_MOVE_REQUEST';
const $6badb4c03b3b2474$export$798efca6e002e359 = (payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$e13d64a2ffca3097,
        payload: payload,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $6badb4c03b3b2474$export$6ae1b17e1807f013 = 'state.actions.cards.move.CARDS_MOVE_NON_OPTIMISTIC_REQUEST';
const $6badb4c03b3b2474$export$c581f6c48c739c84 = (optimisticId, payload, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$6ae1b17e1807f013,
        payload: payload,
        meta: {
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        }
    });
const $6badb4c03b3b2474$export$1b15bd4898d41956 = 'state.actions.cards.move.CARDS_MOVE_SUCCESS';
const $6badb4c03b3b2474$export$d9bd27fc2155921d = (optimisticId, cardIds, cardListId, analyticsEvent, targetStatusId)=>({
        type: $6badb4c03b3b2474$export$1b15bd4898d41956,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            targetStatusId: targetStatusId
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$cfcb4c2d7a25be3d = 'state.actions.cards.move.CARDS_MOVE_FAILURE';
const $6badb4c03b3b2474$export$418f4abeb5fa5e63 = (optimisticId, cardIds, cardListId, analyticsEvent, error)=>({
        type: $6badb4c03b3b2474$export$cfcb4c2d7a25be3d,
        payload: {
            cardIds: cardIds,
            cardListId: cardListId,
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$f9b68831e6b4477c = 'CARDS_TRANSITION_AND_RANK_FAILURE';
const $6badb4c03b3b2474$export$46bbdf3a931c511 = (optimisticId, errorMessages, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$f9b68831e6b4477c,
        payload: {
            errorMessages: errorMessages
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$705d22119d4bbfd3 = 'state.actions.cards.move.CARDS_MOVE_CANCEL';
const $6badb4c03b3b2474$export$1d737d00c97bf50e = (optimisticId, analyticsEvent)=>({
        type: $6badb4c03b3b2474$export$705d22119d4bbfd3,
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$b807c0f117e6382c = 'state.actions.cards.move.CARDS_MOVE_SET';
const $6badb4c03b3b2474$export$106b66132b61ee71 = (payload)=>({
        type: $6badb4c03b3b2474$export$b807c0f117e6382c,
        payload: payload
    });
const $6badb4c03b3b2474$export$93dd8120f4a8e5e9 = 'state.actions.cards.move.CARDS_MOVE_DISABLED';
const $6badb4c03b3b2474$export$426568831df3d9fb = (optimisticId, analyticsEvent, boardId, isAdmin)=>({
        type: $6badb4c03b3b2474$export$93dd8120f4a8e5e9,
        payload: {
            boardId: boardId,
            isAdmin: isAdmin
        },
        meta: {
            analyticsEvent: analyticsEvent,
            ...(0, $c0irb.revertOptimisticUiWithDisabledFlagMeta)(optimisticId)
        }
    });
const $6badb4c03b3b2474$export$98c6114056f9246b = 'state.actions.cards.move.CARD_DRAG_DISALLOWED';
const $6badb4c03b3b2474$export$a6e3bd55037d34be = ()=>({
        type: $6badb4c03b3b2474$export$98c6114056f9246b
    });

});

parcelRegister("e978U", function(module, exports) {

$parcel$export(module.exports, "FLAG_SPRINT_STARTED", () => $b5a409985e3b6a97$export$694f8ba06b56ee81);
$parcel$export(module.exports, "showSprintStartedFlagAction", () => $b5a409985e3b6a97$export$10698da25970db59);
const $b5a409985e3b6a97$export$694f8ba06b56ee81 = 'state.actions.sprints.start.FLAG_SPRINT_STARTED';
const $b5a409985e3b6a97$export$10698da25970db59 = ()=>({
        type: $b5a409985e3b6a97$export$694f8ba06b56ee81
    });

});

parcelRegister("60s5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3e92fd24fb3750c$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $4mqko = parcelRequire("4mqko");

var $dGljH = parcelRequire("dGljH");

var $iXH87 = parcelRequire("iXH87");
const $f3e92fd24fb3750c$var$mapDispatchToProps = (dispatch, { failedActionBuilders: failedActionBuilders, onDismissed: onDismissed, id: flagId, failedIssueKeys: failedIssueKeys, failedBatchIds: failedBatchIds })=>({
        onRetry: ()=>{
            onDismissed?.(flagId);
            if (failedActionBuilders.length < 1) return;
            const action = (0, $aB8eX.batchActions)(failedActionBuilders.map((f)=>{
                const builtAction = f();
                return {
                    ...builtAction,
                    meta: {
                        ...builtAction.meta,
                        failedBatchIds: failedBatchIds
                    }
                };
            }));
            dispatch(action);
        },
        onSelectFailedItems: (getCardIdFromCardKey)=>{
            onDismissed?.(flagId);
            const failedCardIds = failedIssueKeys.map((key)=>getCardIdFromCardKey(key));
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dispatch((0, $4mqko.cardMultiSelect)(failedCardIds));
        }
    });
const $f3e92fd24fb3750c$var$onSelectFailedItemsFactory = (0, $8QpSo.default)((getCardIdFromCardKey, onSelectFailedItems)=>()=>onSelectFailedItems(getCardIdFromCardKey));
const $f3e92fd24fb3750c$var$onViewSummaryFactory = (0, $8QpSo.default)((failedIssueKeys, onDismissed, flagId)=>()=>{
        const cardKeys = failedIssueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        const url = `/issues/?jql=${jqlSearch}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
        onDismissed?.(flagId);
    });
const $f3e92fd24fb3750c$export$9d1611c77c2fe928 = ({ getCardIdFromCardKey: getCardIdFromCardKey }, { onRetry: onRetry, onSelectFailedItems: onSelectFailedItems }, { failedActionBuilders: failedActions, failedIssueKeys: failedIssueKeys, id: flagId, onDismissed: onDismissed, failedBatchIds: failedBatchIds, failureReason: failureReason, ...restOwnProps })=>{
    const hasReachedRetryLimit = failedBatchIds && failedBatchIds?.length > 2;
    const shouldShowRetryButton = failedActions.length > 0 && !hasReachedRetryLimit && failureReason !== 'validation';
    const shouldShowViewSummaryButton = failureReason !== 'network' || failureReason === 'network' && !hasReachedRetryLimit;
    const shouldShowSelectFailedItemsButton = failureReason === 'validation';
    const shouldShowHelpButton = hasReachedRetryLimit && failureReason !== 'network' && failureReason !== 'validation';
    return {
        failedCount: failedIssueKeys.length,
        onRetry: onRetry,
        onSelectFailedItems: $f3e92fd24fb3750c$var$onSelectFailedItemsFactory(getCardIdFromCardKey, onSelectFailedItems),
        onViewSummary: $f3e92fd24fb3750c$var$onViewSummaryFactory(failedIssueKeys, onDismissed, flagId),
        showRetryButton: shouldShowRetryButton,
        showViewSummaryButton: shouldShowViewSummaryButton,
        showSelectFailedItemsButton: shouldShowSelectFailedItemsButton,
        showLearnMoreButton: !!shouldShowHelpButton,
        id: flagId,
        failureReason: failureReason,
        onDismissed: onDismissed,
        ...restOwnProps
    };
};
const $f3e92fd24fb3750c$var$mapStateToProps = (state)=>({
        getCardIdFromCardKey: (0, $dGljH.makeCardIdFromCardKey)(state)
    });
var $f3e92fd24fb3750c$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f3e92fd24fb3750c$var$mapStateToProps, $f3e92fd24fb3750c$var$mapDispatchToProps, $f3e92fd24fb3750c$export$9d1611c77c2fe928)((0, $iXH87.default));

});
parcelRegister("4mqko", function(module, exports) {

$parcel$export(module.exports, "CARD_CLICK", () => $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6);
$parcel$export(module.exports, "cardClick", () => $9b08934ab8e0c5b7$export$e7d364bce6e7eb03);
$parcel$export(module.exports, "PARENT_CLICK", () => $9b08934ab8e0c5b7$export$3c3fc48f596a8caf);
$parcel$export(module.exports, "parentClick", () => $9b08934ab8e0c5b7$export$5b3ee90f81d7c287);
$parcel$export(module.exports, "CARD_TOGGLE_SELECTION", () => $9b08934ab8e0c5b7$export$5f8bf17701529b20);
$parcel$export(module.exports, "cardToggleSelection", () => $9b08934ab8e0c5b7$export$bf1970aeeba42166);
$parcel$export(module.exports, "CARD_EMPTY_SELECTION", () => $9b08934ab8e0c5b7$export$9aba3277bb9b4f3);
$parcel$export(module.exports, "cardEmptySelection", () => $9b08934ab8e0c5b7$export$9bbdebcbf6166d18);
$parcel$export(module.exports, "CARD_SINGLE_SELECT", () => $9b08934ab8e0c5b7$export$c68d63d54996a817);
$parcel$export(module.exports, "cardSingleSelect", () => $9b08934ab8e0c5b7$export$9df5a921382fd88e);
$parcel$export(module.exports, "CARD_MULTI_SELECT", () => $9b08934ab8e0c5b7$export$674d868bde506f3c);
$parcel$export(module.exports, "cardMultiSelect", () => $9b08934ab8e0c5b7$export$43cca0fb4ffd3a83);
$parcel$export(module.exports, "SET_LAST_SELECTED_CARD_KEY", () => $9b08934ab8e0c5b7$export$c355c5f11b814fa5);
$parcel$export(module.exports, "setLastSelectedCardKey", () => $9b08934ab8e0c5b7$export$7cfa242c22a8bfdd);
$parcel$export(module.exports, "CARD_CLEAR_RELATIVE_CARD", () => $9b08934ab8e0c5b7$export$2310cdad67e30ee6);
$parcel$export(module.exports, "cardClearRelativeCard", () => $9b08934ab8e0c5b7$export$74e6e8a2495983f2);
$parcel$export(module.exports, "CARD_MULTI_SELECT_EXTEND", () => $9b08934ab8e0c5b7$export$73624cc5484d682a);
$parcel$export(module.exports, "cardMultiSelectExtend", () => $9b08934ab8e0c5b7$export$651e3bf6aa397b17);
$parcel$export(module.exports, "CARD_MULTI_REMOVE", () => $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9);
$parcel$export(module.exports, "cardMultiRemove", () => $9b08934ab8e0c5b7$export$f44e863d2e71da4a);
const $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6 = 'state.actions.cards.selection.CARD_CLICK';
const $9b08934ab8e0c5b7$export$e7d364bce6e7eb03 = (cardId, withCmd, withShift, withCheckbox, fireSelectionAnalytics, externalAction)=>({
        type: $9b08934ab8e0c5b7$export$1f7bc7dd5a83e5d6,
        payload: {
            cardId: cardId,
            withCmd: withCmd,
            withShift: withShift,
            withCheckbox: withCheckbox,
            fireSelectionAnalytics: fireSelectionAnalytics,
            externalAction: externalAction
        }
    });
const $9b08934ab8e0c5b7$export$3c3fc48f596a8caf = 'state.actions.cards.selection.PARENT_CLICK';
const $9b08934ab8e0c5b7$export$5b3ee90f81d7c287 = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$3c3fc48f596a8caf,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$5f8bf17701529b20 = 'state.actions.cards.selection.CARD_TOGGLE_SELECTION';
const $9b08934ab8e0c5b7$export$bf1970aeeba42166 = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$5f8bf17701529b20,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$9aba3277bb9b4f3 = 'state.actions.cards.selection.CARD_EMPTY_SELECTION';
const $9b08934ab8e0c5b7$export$9bbdebcbf6166d18 = ()=>({
        type: $9b08934ab8e0c5b7$export$9aba3277bb9b4f3
    });
const $9b08934ab8e0c5b7$export$c68d63d54996a817 = 'state.actions.cards.selection.CARD_SINGLE_SELECT';
const $9b08934ab8e0c5b7$export$9df5a921382fd88e = (cardId)=>({
        type: $9b08934ab8e0c5b7$export$c68d63d54996a817,
        payload: {
            cardId: cardId
        }
    });
const $9b08934ab8e0c5b7$export$674d868bde506f3c = 'state.actions.cards.selection.CARD_MULTI_SELECT';
const $9b08934ab8e0c5b7$export$43cca0fb4ffd3a83 = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$674d868bde506f3c,
        payload: {
            cardIds: cardIds
        }
    });
const $9b08934ab8e0c5b7$export$c355c5f11b814fa5 = 'state.actions.cards.selection.SET_LAST_SELECTED_CARD_KEY';
const $9b08934ab8e0c5b7$export$7cfa242c22a8bfdd = (cardKey)=>({
        type: $9b08934ab8e0c5b7$export$c355c5f11b814fa5,
        payload: {
            cardKey: cardKey
        }
    });
const $9b08934ab8e0c5b7$export$2310cdad67e30ee6 = 'state.actions.cards.selection.CARD_CLEAR_RELATIVE_CARD';
const $9b08934ab8e0c5b7$export$74e6e8a2495983f2 = ()=>({
        type: $9b08934ab8e0c5b7$export$2310cdad67e30ee6
    });
const $9b08934ab8e0c5b7$export$73624cc5484d682a = 'state.actions.cards.selection.CARD_MULTI_SELECT_EXTEND';
const $9b08934ab8e0c5b7$export$651e3bf6aa397b17 = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$73624cc5484d682a,
        payload: {
            cardIds: cardIds
        }
    });
const $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9 = 'state.actions.cards.selection.CARD_MULTI_REMOVE';
const $9b08934ab8e0c5b7$export$f44e863d2e71da4a = (cardIds)=>({
        type: $9b08934ab8e0c5b7$export$3311b2d7e3ec44e9,
        payload: {
            cardIds: cardIds
        }
    });

});

parcelRegister("dGljH", function(module, exports) {

$parcel$export(module.exports, "getCardLists", () => $5ed71ca496f4aade$export$75be3facf1d769f7);
$parcel$export(module.exports, "getCards", () => $5ed71ca496f4aade$export$bc61c71d8347e4d9);
$parcel$export(module.exports, "isBacklogEmptySelector", () => $5ed71ca496f4aade$export$77a8abb93bb2e730);
$parcel$export(module.exports, "getCardListsKeys", () => $5ed71ca496f4aade$export$b0ebc690fddac876);
$parcel$export(module.exports, "getCardsCount", () => $5ed71ca496f4aade$export$4bb6cca38ab53750);
$parcel$export(module.exports, "getCardColor", () => $5ed71ca496f4aade$export$49e99cd9a6ce8b74);
$parcel$export(module.exports, "getCardEpicColor", () => $5ed71ca496f4aade$export$dc5c6effc654e62c);
$parcel$export(module.exports, "makeGetCardTypeHierarchyLevel", () => $5ed71ca496f4aade$export$66175bb0467d3f5b);
$parcel$export(module.exports, "hasCardExtraFields", () => $5ed71ca496f4aade$export$962651073dd96b20);
$parcel$export(module.exports, "getCardExtraFields", () => $5ed71ca496f4aade$export$f338837bff9d7477);
$parcel$export(module.exports, "getCardListCount", () => $5ed71ca496f4aade$export$d63ed38773ad2770);
$parcel$export(module.exports, "getOrderedCardIdsByCardListId", () => $5ed71ca496f4aade$export$3593c0292d4c2e0b);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdExcludingSubtasks", () => $5ed71ca496f4aade$export$91f28e45d69d8c3c);
$parcel$export(module.exports, "getOrderedCardListIds", () => $5ed71ca496f4aade$export$5895481c46e9779a);
$parcel$export(module.exports, "getOrderedCardIdsByCardListIdWithLimit", () => $5ed71ca496f4aade$export$5e8030258431459d);
$parcel$export(module.exports, "makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks", () => $5ed71ca496f4aade$export$c9e173fcee586682);
$parcel$export(module.exports, "getSelectedCards", () => $5ed71ca496f4aade$export$ad9f3c6d3dd8c300);
$parcel$export(module.exports, "getLastSelectedCardKey", () => $5ed71ca496f4aade$export$c30df5b31e28112c);
$parcel$export(module.exports, "getDetailViewData", () => $5ed71ca496f4aade$export$401c35958b2ae848);
$parcel$export(module.exports, "getListSelectionRelativeCard", () => $5ed71ca496f4aade$export$aa636ff49e4c9964);
$parcel$export(module.exports, "getFocusedCard", () => $5ed71ca496f4aade$export$10aea3ed8ea28af7);
$parcel$export(module.exports, "isFilteredCardsLoading", () => $5ed71ca496f4aade$export$eadf838276efbfae);
$parcel$export(module.exports, "isCardSelected", () => $5ed71ca496f4aade$export$a67ae423fb9ea0f9);
$parcel$export(module.exports, "getCardAutoScroll", () => $5ed71ca496f4aade$export$4eeaff5dde2f423b);
$parcel$export(module.exports, "getActiveCard", () => $5ed71ca496f4aade$export$c090658018e2f5dc);
$parcel$export(module.exports, "getActiveCardKey", () => $5ed71ca496f4aade$export$1542f5de67e48825);
$parcel$export(module.exports, "getActiveCardAssignee", () => $5ed71ca496f4aade$export$1b32fabbb013793a);
$parcel$export(module.exports, "cardsSelector", () => $5ed71ca496f4aade$export$c6ca016832785256);
$parcel$export(module.exports, "getCardIds", () => $5ed71ca496f4aade$export$841def0f013aa3d3);
$parcel$export(module.exports, "isDetailViewOpenWithAnySelectedCardSelector", () => $5ed71ca496f4aade$export$9e2c1554ae605d31);
$parcel$export(module.exports, "getOrderedAssignees", () => $5ed71ca496f4aade$export$793179e0c0778f7d);
$parcel$export(module.exports, "getOrderedLabels", () => $5ed71ca496f4aade$export$2777f818bf992a42);
$parcel$export(module.exports, "getOrderedVersions", () => $5ed71ca496f4aade$export$d35c7777091af15b);
$parcel$export(module.exports, "getOrderedCardTypes", () => $5ed71ca496f4aade$export$7fd50a0e5f559f3a);
$parcel$export(module.exports, "getLastSelectedCard", () => $5ed71ca496f4aade$export$66743788dd4e9bd8);
$parcel$export(module.exports, "willDetailViewShow", () => $5ed71ca496f4aade$export$e6b4eade500df666);
$parcel$export(module.exports, "makeCardKeyFromCardId", () => $5ed71ca496f4aade$export$588fddef6c4ed7f9);
$parcel$export(module.exports, "makeCardIdFromCardKey", () => $5ed71ca496f4aade$export$10cabd141980d8a2);
$parcel$export(module.exports, "makeOrderedVisibleCardsForCardList", () => $5ed71ca496f4aade$export$869d157a8342f44f);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardList", () => $5ed71ca496f4aade$export$488409900307c7a6);
$parcel$export(module.exports, "makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit", () => $5ed71ca496f4aade$export$b544e9d18cad6c7d);
$parcel$export(module.exports, "getFilteredOrderedCardIdsByCardListId", () => $5ed71ca496f4aade$export$338dee38ad2f42f6);
$parcel$export(module.exports, "makeOrderVisibleCardIdsForCardListWithLimit", () => $5ed71ca496f4aade$export$d5b2e72cab21ec54);
$parcel$export(module.exports, "shouldShowDetailView", () => $5ed71ca496f4aade$export$786319817f19c360);
$parcel$export(module.exports, "makeOrderedVisibleCardIdsForCardList", () => $5ed71ca496f4aade$export$c24a16d8eafb7cff);
$parcel$export(module.exports, "makeOrderedVisibleCardEntriesOld", () => $5ed71ca496f4aade$export$b3426d0830bb4960);
$parcel$export(module.exports, "getExpandedCardGroups", () => $5ed71ca496f4aade$export$d2f7dc3ebc256192);
$parcel$export(module.exports, "makeGetCardGroupExpanded", () => $5ed71ca496f4aade$export$e3846ee85e6596cc);
$parcel$export(module.exports, "getParentIdByChildIdSelector", () => $5ed71ca496f4aade$export$8f9f740048610b66);
$parcel$export(module.exports, "getChildIdsByParentIdSelector", () => $5ed71ca496f4aade$export$63ae7bac909d8340);
$parcel$export(module.exports, "makeGetCardHierarchyLevel", () => $5ed71ca496f4aade$export$c0ec2d5d5f08d6fd);
$parcel$export(module.exports, "makeGetOrderedCardEntries", () => $5ed71ca496f4aade$export$e8229a391aa249b1);
$parcel$export(module.exports, "makeGetAllAttachedToParentCardGroupEntries", () => $5ed71ca496f4aade$export$8187607852c1fedc);
$parcel$export(module.exports, "makeOrderedVisibleCardEntries", () => $5ed71ca496f4aade$export$f4b996b8eaed63ba);
$parcel$export(module.exports, "makeGetVisibleCardOrderFromCardEntries", () => $5ed71ca496f4aade$export$2a0bb0de1d232830);
$parcel$export(module.exports, "getVisibleCardIds", () => $5ed71ca496f4aade$export$ef62d40ffc479d23);
$parcel$export(module.exports, "makeIsCardVisible", () => $5ed71ca496f4aade$export$6b61f32266c676c3);
$parcel$export(module.exports, "makeIsCardOnBoard", () => $5ed71ca496f4aade$export$325317470b38c674);
$parcel$export(module.exports, "makeGetCardListIdByCardId", () => $5ed71ca496f4aade$export$44b7fd430cc830af);
$parcel$export(module.exports, "makeGetFastVirtualListMinimumOffSetByCardListId", () => $5ed71ca496f4aade$export$9436834ba11ae17a);
$parcel$export(module.exports, "makeGetCardListAnalyticsTypeById", () => $5ed71ca496f4aade$export$ab100b26d47e733e);
$parcel$export(module.exports, "makeGetTopCardIdFromCardList", () => $5ed71ca496f4aade$export$57205cd918d1a471);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardList", () => $5ed71ca496f4aade$export$c30c77f267ed58fa);
$parcel$export(module.exports, "hasCardTypesSelector", () => $5ed71ca496f4aade$export$a1e0feed5c998c95);
$parcel$export(module.exports, "getCollapsedCardLists", () => $5ed71ca496f4aade$export$14682dc3868ac2f2);
$parcel$export(module.exports, "makeIsCardListCollapsed", () => $5ed71ca496f4aade$export$48519a9ef4b7246c);
$parcel$export(module.exports, "getVisibleCardListIds", () => $5ed71ca496f4aade$export$a23657169ef5c959);
$parcel$export(module.exports, "getVisibleSprintCardLists", () => $5ed71ca496f4aade$export$277d12d0ad2acbb1);
$parcel$export(module.exports, "isAnyOptimisticCardList", () => $5ed71ca496f4aade$export$44ac769c42548b1);
$parcel$export(module.exports, "makeGetNextCardListId", () => $5ed71ca496f4aade$export$91ea52aeac57cc52);
$parcel$export(module.exports, "getFlattenOrderedCardIds", () => $5ed71ca496f4aade$export$9fc808638e14d4f0);
$parcel$export(module.exports, "makeIsCardListDisabled", () => $5ed71ca496f4aade$export$b40f586b1b1b5b3d);
$parcel$export(module.exports, "makeGetMaxColumnLimit", () => $5ed71ca496f4aade$export$86fa3555538a1895);
$parcel$export(module.exports, "makeGetMinColumnLimit", () => $5ed71ca496f4aade$export$daddaca8cdd663b3);
$parcel$export(module.exports, "validFilterValuesSelector", () => $5ed71ca496f4aade$export$a3e606d31ce14076);
$parcel$export(module.exports, "hasInvalidFilterValuesSelector", () => $5ed71ca496f4aade$export$e5ce012c8ff94f67);
$parcel$export(module.exports, "selectedCardsForVersionsPanelSelector", () => $5ed71ca496f4aade$export$116ea4e15b17d748);
$parcel$export(module.exports, "selectedPartialCardsWithTypeHierarchyLevelSelector", () => $5ed71ca496f4aade$export$97279e04a1cfee44);
$parcel$export(module.exports, "partialCardsFromCardIdsSelector", () => $5ed71ca496f4aade$export$cb1654a9ed6d9099);
$parcel$export(module.exports, "cardsForFlagWithCommentModalFromCardIdsSelector", () => $5ed71ca496f4aade$export$9656edc7cd965e96);
$parcel$export(module.exports, "numTotalIssueChildren", () => $5ed71ca496f4aade$export$1b6edd941a4eaddd);
$parcel$export(module.exports, "numCompleteIssueChildren", () => $5ed71ca496f4aade$export$18ec94fe8e415ca5);
$parcel$export(module.exports, "getKeyByIdForAllIssueTypes", () => $5ed71ca496f4aade$export$ebb887ede9b3994e);
$parcel$export(module.exports, "getIdByKeyForAllIssueTypes", () => $5ed71ca496f4aade$export$8d7d30d4816f6177);
$parcel$export(module.exports, "getCardIdWithAboveICCOpen", () => $5ed71ca496f4aade$export$7170cae353180463);
$parcel$export(module.exports, "hasICCOpen", () => $5ed71ca496f4aade$export$8f8d79952e8c1b8f);
$parcel$export(module.exports, "getAllCardIdsIncludingIssueParents", () => $5ed71ca496f4aade$export$ee56c425125d2ef6);
$parcel$export(module.exports, "getCardListStats", () => $5ed71ca496f4aade$export$22d153c4cb386f10);
$parcel$export(module.exports, "shouldRenderRichElements", () => $5ed71ca496f4aade$export$6450c8aec6d3b414);
$parcel$export(module.exports, "makeGetDefaultRowSize", () => $5ed71ca496f4aade$export$454eae1b4bd66f70);
$parcel$export(module.exports, "getDefaultCardHeight", () => $5ed71ca496f4aade$export$697c63a5f8659c9);
$parcel$export(module.exports, "getIsCardListDragInProgress", () => $5ed71ca496f4aade$export$ac2362f84ffb1564);
$parcel$export(module.exports, "getIsDragging", () => $5ed71ca496f4aade$export$59261b5a26c04c00);
$parcel$export(module.exports, "makeGetSourceCardListId", () => $5ed71ca496f4aade$export$a62ade440fb97a7a);
$parcel$export(module.exports, "makeGetSourceCardGroupId", () => $5ed71ca496f4aade$export$f787c700d21c234a);
$parcel$export(module.exports, "cardVersionsSelector", () => $5ed71ca496f4aade$export$2b8ccf236ef3c2ad);
$parcel$export(module.exports, "getFirstNonEmptyCardListId", () => $5ed71ca496f4aade$export$10c1cb90425eb140);
$parcel$export(module.exports, "backlogHasFlaggedCards", () => $5ed71ca496f4aade$export$91d6529e043b6231);
$parcel$export(module.exports, "backlogHasPriority", () => $5ed71ca496f4aade$export$df669897ce3195c6);
$parcel$export(module.exports, "backlogHasDueDate", () => $5ed71ca496f4aade$export$41cf0539676d3407);
$parcel$export(module.exports, "backlogHasStoryPoints", () => $5ed71ca496f4aade$export$242c58db4e305622);
$parcel$export(module.exports, "backlogHasEstimates", () => $5ed71ca496f4aade$export$261deb4fe884b0a1);
$parcel$export(module.exports, "getLastNonEmptyCardListId", () => $5ed71ca496f4aade$export$5bab56d9e503125d);
$parcel$export(module.exports, "makeGetDraggingCardIds", () => $5ed71ca496f4aade$export$eb5d19e26822928b);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hm7zS = parcelRequire("hm7zS");

var $k8IPx = parcelRequire("k8IPx");

var $hIkqU = parcelRequire("hIkqU");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $dPSWJ = parcelRequire("dPSWJ");

var $fEeCa = parcelRequire("fEeCa");

var $gJBT6 = parcelRequire("gJBT6");

var $fr1K2 = parcelRequire("fr1K2");

var $icGZu = parcelRequire("icGZu");

var $iThRn = parcelRequire("iThRn");

var $2nvJN = parcelRequire("2nvJN");

var $kGsr8 = parcelRequire("kGsr8");

var $3JOCw = parcelRequire("3JOCw");

var $8O7FC = parcelRequire("8O7FC");

var $g4tDr = parcelRequire("g4tDr");


var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");


var $ee1tL = parcelRequire("ee1tL");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $e5nhF = parcelRequire("e5nhF");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $9ZuIF = parcelRequire("9ZuIF");

var $fpDLy = parcelRequire("fpDLy");
const $5ed71ca496f4aade$export$75be3facf1d769f7 = (state)=>(0, $e5nhF.getEntities)(state).cardList;
const $5ed71ca496f4aade$export$bc61c71d8347e4d9 = (state)=>(0, $e5nhF.getEntities)(state).card;
const $5ed71ca496f4aade$export$77a8abb93bb2e730 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length === 0);
const $5ed71ca496f4aade$export$b0ebc690fddac876 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7
], (cardLists)=>Object.keys(cardLists));
const $5ed71ca496f4aade$export$4bb6cca38ab53750 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>Object.keys(cards).length);
const $5ed71ca496f4aade$var$getCardById = (cards, cardId)=>cards[String(cardId)];
const $5ed71ca496f4aade$export$49e99cd9a6ce8b74 = (state, cardId)=>{
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const color = $5ed71ca496f4aade$var$getCardById(cards, cardId)?.color;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color);
};
const $5ed71ca496f4aade$export$dc5c6effc654e62c = (state, cardId)=>{
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const color = $5ed71ca496f4aade$var$getCardById(cards, cardId)?.epicColor;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color))) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(color);
};
const $5ed71ca496f4aade$export$66175bb0467d3f5b = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents),
    (0, $74oBv.getBaseLevelCardTypes)
], (cards, parents, allCardTypes)=>(cardId)=>{
        const card = cards[cardId];
        if (card) {
            const cardType = allCardTypes.find((it)=>it.id === card.typeId);
            return cardType?.typeHierarchyLevel ?? (0, $g4tDr.BASE_HIERARCHY_TYPE);
        }
        const parent = parents[cardId];
        return parent ? (0, $g4tDr.PARENT_HIERARCHY_TYPE) : (0, $g4tDr.BASE_HIERARCHY_TYPE);
    });
const $5ed71ca496f4aade$export$962651073dd96b20 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>card?.extraFields ? card.extraFields.length > 0 : false));
const $5ed71ca496f4aade$export$f338837bff9d7477 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const extraFieldsMap = new Map();
    Object.values(cards).forEach((card)=>{
        card.extraFields?.forEach((field)=>extraFieldsMap.set(field.id, field));
    });
    return Array.from(extraFieldsMap.values());
});
const $5ed71ca496f4aade$export$d63ed38773ad2770 = (state)=>{
    const { cardList: cardList } = (0, $e5nhF.getEntities)(state);
    return Object.keys(cardList).length;
};
const $5ed71ca496f4aade$export$3593c0292d4c2e0b = (state)=>(0, $e5nhF.getEntities)(state).cardOrder;
const $5ed71ca496f4aade$export$85056ee91e64823a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>orderedCardIdsByCardListId?.[cardListId] || []));
const $5ed71ca496f4aade$export$91f28e45d69d8c3c = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (allCards, orderedCardIdsByCardListId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsByCardListId?.[cardListId];
        if (!cardIds) return [];
        return cardIds.filter((cardId)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel));
    }));
const $5ed71ca496f4aade$export$70f41e60f354f620 = (cardOrder, cardListOrder, limit = 50)=>{
    let currentCount = 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truncatedCardIds = {};
    cardListOrder.forEach((listId)=>{
        const cardIds = cardOrder[listId];
        if (!cardIds) return;
        const remaining = limit - currentCount;
        const sliceAmount = Math.min(remaining, cardIds.length);
        const firstCards = cardIds.slice(0, sliceAmount);
        truncatedCardIds[listId] = firstCards;
        currentCount += sliceAmount;
    });
    return truncatedCardIds;
};
const $5ed71ca496f4aade$export$5895481c46e9779a = (state)=>(0, $e5nhF.getEntities)(state).cardListOrder;
const $5ed71ca496f4aade$export$5e8030258431459d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardOrder, cardListOrder)=>$5ed71ca496f4aade$export$70f41e60f354f620(cardOrder, cardListOrder));
const $5ed71ca496f4aade$export$c9e173fcee586682 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (allCards, orderedCardIdsByCardListId, cardListOrder)=>{
    const initialResult = $5ed71ca496f4aade$export$70f41e60f354f620(orderedCardIdsByCardListId, cardListOrder);
    const result = {};
    cardListOrder.forEach((cardListId)=>{
        const cardIds = initialResult[cardListId] ?? [];
        result[cardListId] = cardIds.filter((cardId)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>result[cardListId] ?? []);
});
const $5ed71ca496f4aade$export$ad9f3c6d3dd8c300 = (state)=>state.ui.cards.selected;
const $5ed71ca496f4aade$export$c30df5b31e28112c = (state)=>state.ui.cards.lastSelectedCardKey;
const $5ed71ca496f4aade$export$401c35958b2ae848 = (state)=>state.ui.detailView;
const $5ed71ca496f4aade$export$aa636ff49e4c9964 = (state)=>state.ui.cards.listSelectionRelativeCard;
const $5ed71ca496f4aade$export$10aea3ed8ea28af7 = (state)=>state.ui.cards.focused;
const $5ed71ca496f4aade$export$5496a8bd76ac3cc7 = (state)=>state.ui.cards.filteredCards.filteredCardsIds;
const $5ed71ca496f4aade$export$eadf838276efbfae = (state)=>state.ui.cards.filteredCards.isLoading;
const $5ed71ca496f4aade$export$73a0d145c861a8f6 = (state)=>state.ui.cards.fields.isStatusFieldsHidden;
const $5ed71ca496f4aade$export$62270500eeccff2a = (state)=>state.ui.cards.fields.isVersionFieldsHidden;
const $5ed71ca496f4aade$export$f96a2f7628e75ad2 = (state)=>state.ui.cards.fields.isEpicFieldsHidden;
const $5ed71ca496f4aade$export$a67ae423fb9ea0f9 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (selectedCards)=>(cardId)=>selectedCards.includes(cardId));
const $5ed71ca496f4aade$export$4eeaff5dde2f423b = (state)=>state.ui.cards.autoScroll;
const $5ed71ca496f4aade$export$c090658018e2f5dc = (state)=>{
    const focusedCard = $5ed71ca496f4aade$export$10aea3ed8ea28af7(state);
    if (focusedCard !== null) return focusedCard;
    const selectedCards = $5ed71ca496f4aade$export$ad9f3c6d3dd8c300(state);
    return selectedCards[selectedCards.length - 1];
};
const $5ed71ca496f4aade$export$1542f5de67e48825 = (state)=>{
    const activeCardId = $5ed71ca496f4aade$export$c090658018e2f5dc(state);
    const allCards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].key;
};
const $5ed71ca496f4aade$export$1b32fabbb013793a = (state)=>{
    const activeCardId = $5ed71ca496f4aade$export$c090658018e2f5dc(state);
    const allCards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    return allCards[String(activeCardId)] && allCards[String(activeCardId)].assignee;
};
const $5ed71ca496f4aade$export$c6ca016832785256 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, (cards)=>Object.values(cards));
const $5ed71ca496f4aade$export$841def0f013aa3d3 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.map((card)=>card.id));
const $5ed71ca496f4aade$export$9e2c1554ae605d31 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$401c35958b2ae848,
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300
], (detailView, selectedCards)=>detailView && selectedCards.indexOf(detailView.cardId) > -1);
const $5ed71ca496f4aade$export$793179e0c0778f7d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $9ZuIF.getCurrentUser),
    (0, $jG5HW.getIsCompanyManaged)
], (allCards, currentUser, isCompanyManaged)=>{
    const currentUserId = currentUser ? currentUser.id : null;
    const assigneeList = Object.values(allCards).map((card)=>card.assignee) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((people, person)=>{
        if (person && person.id !== currentUserId) people.push(person);
        return people;
    }, []);
    const uniqueAssigneeList = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(assigneeList, (assignee)=>assignee.id);
    if (isCompanyManaged) uniqueAssigneeList.sort((a, b)=>a.displayName.localeCompare(b.displayName));
    else {
        const assigneeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(assigneeList, (assignee)=>assignee.id);
        uniqueAssigneeList.sort((a, b)=>assigneeCounts[b.id] - assigneeCounts[a.id]);
    }
    if (currentUser) uniqueAssigneeList.unshift(currentUser);
    return (0, $7uUwQ.freeze)(uniqueAssigneeList);
});
const $5ed71ca496f4aade$export$2777f818bf992a42 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).reduce((labels, card)=>{
        if (card.labels && card.labels.length > 0) labels.push(...card.labels);
        return labels;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$d35c7777091af15b = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$f9311774fcd7a245 = (0, $dGvGJ.createSelector)([
    (0, $fpDLy.getVersionsOrder)
], (versions)=>versions.concat().sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b)));
const $5ed71ca496f4aade$export$d4dec7daa49a8c5 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(allCards).map((card)=>String(card.typeId))));
const $5ed71ca496f4aade$export$7fd50a0e5f559f3a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    (0, $74oBv.getCardTypes)
], (uniqCardTypeIds, allCardTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uniqCardTypes = uniqCardTypeIds.reduce((cardTypes, typeId)=>{
        const foundCardType = allCardTypes.find((cardType)=>String(cardType.id) === typeId);
        if (foundCardType) cardTypes.push({
            id: String(foundCardType.id),
            name: foundCardType.name,
            iconUrl: foundCardType.iconUrl,
            typeHierarchyLevel: foundCardType.typeHierarchyLevel ?? null
        });
        return cardTypes;
    }, []);
    return uniqCardTypes.sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $5ed71ca496f4aade$export$66743788dd4e9bd8 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300
], (cardSelection)=>cardSelection.slice(-1)[0] || null);
const $5ed71ca496f4aade$export$e6b4eade500df666 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$c30df5b31e28112c
], (lastSelectedCardKey)=>lastSelectedCardKey !== '');
const $5ed71ca496f4aade$export$588fddef6c4ed7f9 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, issueParents)=>{
    const unmappedParents = {};
    Object.values(cards).forEach(({ parentId: parentId, parentKey: parentKey })=>{
        if (parentId && parentKey && !cards[parentId] && !issueParents[parentId] && !unmappedParents[parentId]) unmappedParents[parentId] = {
            key: parentKey
        };
    });
    return (cardId)=>(cards[cardId] || issueParents[cardId] || unmappedParents[cardId])?.key ?? null;
});
const $5ed71ca496f4aade$export$10cabd141980d8a2 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (allCards)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardKey)=>{
        const cardIdWithKey = Object.keys(allCards).find((cardId)=>allCards[cardId]?.key === cardKey);
        return Number(cardIdWithKey);
    }));
const $5ed71ca496f4aade$export$4d2a5b62ef91607b = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$5496a8bd76ac3cc7,
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (filterValues, filteredCardIds, allCards)=>(0, $l9VFH.filter)(filterValues, filteredCardIds || undefined, Object.values(allCards)));
const $5ed71ca496f4aade$export$869d157a8342f44f = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCards = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibleCards);
});
const $5ed71ca496f4aade$export$488409900307c7a6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>{
    const getOrderedVisibleCardsExcludingSubtasks = (cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibleCardsExcludingSubtasks);
});
const $5ed71ca496f4aade$export$aed4af4b88bc3874 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$5e8030258431459d,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $5ed71ca496f4aade$export$b544e9d18cad6c7d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$5e8030258431459d,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>{
        const cardIds = orderedCardIdsLists[cardListId];
        if (!cardIds) return [];
        const unfilteredList = cardIds.filter((cardId)=>allCards[String(cardId)] && !(0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)].typeHierarchyLevel)).map((cardId)=>allCards[String(cardId)]);
        return filterFunction(unfilteredList);
    }));
const $5ed71ca496f4aade$export$338dee38ad2f42f6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, orderedCardIdsLists, filterFunction)=>Object.fromEntries(Object.entries(orderedCardIdsLists).map(([key, values])=>{
        const unfilteredList = values.filter((cardId)=>allCards[String(cardId)]).map((cardId)=>allCards[String(cardId)]);
        const filteredIds = filterFunction(unfilteredList).map((card)=>card.id);
        return [
            key,
            filteredIds
        ];
    })));
const $5ed71ca496f4aade$export$d5b2e72cab21ec54 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$aed4af4b88bc3874
], (getOrderedVisibleCardsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id)));
const $5ed71ca496f4aade$export$786319817f19c360 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$401c35958b2ae848
], (detailView)=>detailView !== null);
const $5ed71ca496f4aade$export$c24a16d8eafb7cff = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>card.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$b3426d0830bb4960 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$869d157a8342f44f
], (getOrderedVisibleCardsForCardList)=>{
    const getOrderedVisibileCardIds = (cardListId)=>getOrderedVisibleCardsForCardList(cardListId).map((card)=>({
                type: 'card',
                cardId: card.id
            }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$d2f7dc3ebc256192 = (state)=>state.ui.cardList.cardGroupExpanded;
const $5ed71ca496f4aade$export$e3846ee85e6596cc = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$d2f7dc3ebc256192
], (cards, expandedCardGroups)=>{
    const getCardGroupExpanded = (cardId)=>{
        const card = $5ed71ca496f4aade$var$getCardById(cards, cardId);
        if (card && card.parentId && (0, $g4tDr.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel)) // you passed in a subtask, checking if the parent is expanded
        return expandedCardGroups[card.parentId];
        return expandedCardGroups[cardId];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupExpanded);
});
const $5ed71ca496f4aade$export$8f9f740048610b66 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const getParentId = (cardId)=>$5ed71ca496f4aade$var$getCardById(cards, cardId)?.parentId ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getParentId);
});
const $5ed71ca496f4aade$export$63ae7bac909d8340 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const cardsByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(cards, (card)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, 'parentId', 'NO_PARENT'));
    const cardsWithParent = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(cardsByParent, 'NO_PARENT');
    return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(cardsWithParent, (childCards)=>childCards.map((card)=>card.id));
});
const $5ed71ca496f4aade$export$c0ec2d5d5f08d6fd = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>{
    const getHierarchyLevel = (cardId)=>$5ed71ca496f4aade$var$getCardById(cards, cardId)?.typeHierarchyLevel ?? undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getHierarchyLevel);
});
const $5ed71ca496f4aade$export$e8229a391aa249b1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$8f9f740048610b66,
    $5ed71ca496f4aade$export$869d157a8342f44f,
    $5ed71ca496f4aade$export$e3846ee85e6596cc
], (getParentId, getOrderedVisibleCardsForCardList, getIsGroupExpanded)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = [];
        const cards = getOrderedVisibleCardsForCardList(cardListId);
        const cardIds = cards.map((card)=>card.id);
        const nonParentCardIds = cards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
        const parentCardIds = cards.filter((card)=>(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !!getParentId(card.id)).map((card)=>card.id);
        const parentCardIdsByChild = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(parentCardIds, getParentId);
        const childCardEntries = [
            []
        ];
        cardIds?.forEach((cardId)=>{
            if (nonParentCardIds.includes(cardId)) {
                cardEntries.push({
                    type: 'card',
                    cardId: cardId
                });
                return;
            }
            const parentId = getParentId(cardId);
            if (!parentId || !(parentId in parentCardIdsByChild)) return;
            const isGroupCollapsed = !getIsGroupExpanded(parentId);
            const parent = cardEntries.find((entry)=>!(0, $ee1tL.isCardEntryGroup)(entry) && entry.cardId === parentId);
            // If parent and subtasks are in the same list find parent index and insert group next to it
            if (nonParentCardIds.includes(parentId)) {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                if (parent !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: parentCardIdsByChild[parentId],
                        isAttachedToParent: isAttachedToParent,
                        // Only card groups with a parent are able to be visually collapsed
                        isCollapsed: isGroupCollapsed && isAttachedToParent
                    });
                } else childCardEntries.push(parentCardIdsByChild[parentId]);
            } else {
                const isAttachedToParent = nonParentCardIds.includes(parentId);
                cardEntries.push({
                    type: 'group',
                    parentId: parentId,
                    cardIds: parentCardIdsByChild[parentId],
                    isAttachedToParent: isAttachedToParent,
                    isCollapsed: isGroupCollapsed && isAttachedToParent
                });
            }
            delete parentCardIdsByChild[parentId];
        });
        if (childCardEntries.length > 0) {
            childCardEntries.forEach((subtask)=>{
                const parentId = getParentId(subtask[0]);
                const parent = cardEntries.find((entry)=>!(0, $ee1tL.isCardEntryGroup)(entry) && entry.cardId === parentId);
                if (parent !== undefined && parentId !== undefined) {
                    const parentIndex = cardEntries.indexOf(parent);
                    const isCollapsed = !getIsGroupExpanded(parentId);
                    cardEntries.splice(parentIndex + 1, 0, {
                        type: 'group',
                        parentId: parentId,
                        cardIds: subtask,
                        isAttachedToParent: true,
                        isCollapsed: isCollapsed
                    });
                }
            });
            return cardEntries;
        }
        return cardEntries;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$8187607852c1fedc = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$b0ebc690fddac876,
    $5ed71ca496f4aade$export$e8229a391aa249b1
], (cardListKeys, getOrderedCardEntries)=>{
    const getAllAttachedToParentCardGroupEntries = ()=>{
        let cardEntryGroups = [];
        cardListKeys.forEach((cardListId)=>{
            const cardEntries = getOrderedCardEntries(cardListId);
            const groupCardEntries = cardEntries.filter((0, $ee1tL.isCardEntryGroup));
            const attachedToParentGroupCardEntries = groupCardEntries.filter((cardEntry)=>cardEntry.isAttachedToParent);
            cardEntryGroups = cardEntryGroups.concat(attachedToParentGroupCardEntries);
        });
        return cardEntryGroups;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getAllAttachedToParentCardGroupEntries);
});
const $5ed71ca496f4aade$export$f4b996b8eaed63ba = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$e8229a391aa249b1
], (getOrderedCardEntries)=>{
    const getOrderedVisibileCardIds = (cardListId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        return cardEntries.filter((cardEntry)=>{
            if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) return !cardEntry.isCollapsed;
            return true;
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOrderedVisibileCardIds);
});
const $5ed71ca496f4aade$export$2a0bb0de1d232830 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$f4b996b8eaed63ba
], (cardEntries)=>{
    const getVisibleCardOrderFromCardEntries = (cardListId)=>{
        const currentCardEntries = cardEntries(cardListId);
        return currentCardEntries.flatMap((entry)=>(0, $ee1tL.isCardEntryGroup)(entry) ? entry.cardIds : entry.cardId);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getVisibleCardOrderFromCardEntries);
});
const $5ed71ca496f4aade$export$ef62d40ffc479d23 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$c24a16d8eafb7cff,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (getOrderedVisibleCardIdsForCardList, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((allCards, id)=>allCards.concat(getOrderedVisibleCardIdsForCardList(id)), []));
const $5ed71ca496f4aade$export$6b61f32266c676c3 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    $5ed71ca496f4aade$export$4d2a5b62ef91607b
], (allCards, filterFunction)=>(id)=>{
        const card = allCards[`${id}`];
        if (!card) return false;
        const list = filterFunction([
            card
        ]);
        return list.length !== 0;
    });
const $5ed71ca496f4aade$export$325317470b38c674 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getIsCardOnBoard = (id)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(cardIdsByCardList, [
            (0, $guzeq.BOARD)
        ], []).includes(id);
    return getIsCardOnBoard;
});
const $5ed71ca496f4aade$export$44b7fd430cc830af = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>{
    const getCardListIdByCardId = (id)=>Object.keys(cardIdsByCardList).find((cardListId)=>cardIdsByCardList[cardListId].includes(id));
    return getCardListIdByCardId;
});
const $5ed71ca496f4aade$export$9436834ba11ae17a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff
], (cardListIds, orderedVisibleCardIdsForCardList)=>{
    const getFastVirtualListMinimumOffSetByCardListId = (cardListId)=>{
        const cardListIndex = cardListIds.findIndex((id)=>id === cardListId);
        let offset = 0;
        for(let i = 0; i < cardListIndex; i += 1)offset += orderedVisibleCardIdsForCardList(cardListIds[i]).length * 40;
        return offset;
    };
    return getFastVirtualListMinimumOffSetByCardListId;
});
const $5ed71ca496f4aade$export$ab100b26d47e733e = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7
], (cardLists)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>{
        if (id === (0, $guzeq.BACKLOG)) return 0, $guzeq.BACKLOG;
        // If its a sprint, figure out whether its an active one or not, else kanban board
        const card = cardLists[id];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(card) && card.type === (0, $guzeq.SPRINT) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(card.sprintData)) return card.sprintData.state === 'ACTIVE' ? (0, $guzeq.ACTIVE_SPRINT) : (0, $guzeq.INACTIVE_SPRINT);
        // Default to null or we will get skewed analytics
        return id === (0, $guzeq.BOARD) ? (0, $guzeq.BOARD) : null;
    }));
const $5ed71ca496f4aade$export$57205cd918d1a471 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cardIdsByCardList, allCards)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardIdsByCardList[cardListId], ignoredIds);
        const cardId = list.length > 0 ? list[0] : null;
        if (cardId && (0, $g4tDr.isSubtaskHierarchyLevel)(allCards[String(cardId)]?.typeHierarchyLevel)) return allCards[String(cardId)].parentId;
        return cardId;
    });
const $5ed71ca496f4aade$export$c30c77f267ed58fa = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (cardIdsByCardList)=>(cardListId, ignoredIds = [])=>{
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardIdsByCardList[cardListId], ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $5ed71ca496f4aade$export$a1e0feed5c998c95 = (0, $dGvGJ.createSelector)([
    (0, $74oBv.getBaseLevelCardTypes)
], (cardTypes)=>cardTypes?.length > 0);
const $5ed71ca496f4aade$export$14682dc3868ac2f2 = (state)=>state.ui.cardList.collapsed;
const $5ed71ca496f4aade$export$48519a9ef4b7246c = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$14682dc3868ac2f2
], (collapsedCardLists)=>(cardListId)=>!!collapsedCardLists[cardListId]);
const $5ed71ca496f4aade$export$a23657169ef5c959 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardLists, ids)=>ids.filter((id)=>!cardLists[id]?.isOptimistic));
const $5ed71ca496f4aade$export$277d12d0ad2acbb1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a
], (cardLists, ids)=>ids.reduce((accVisibleSprintCardLists, id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        if (card && !card.isOptimistic && card.type === (0, $guzeq.SPRINT)) accVisibleSprintCardLists.push(card);
        return accVisibleSprintCardLists;
    }, []));
const $5ed71ca496f4aade$export$44ac769c42548b1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$a23657169ef5c959
], (all, visible)=>all.length !== visible.length);
const $5ed71ca496f4aade$export$91ea52aeac57cc52 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$a23657169ef5c959
], (ids)=>{
    const getNextCardListId = (cardListId)=>{
        const index = ids.indexOf(cardListId);
        if (index === -1 || index === ids.length - 1) return null;
        return ids[index + 1];
    };
    return getNextCardListId;
});
const $5ed71ca496f4aade$export$9fc808638e14d4f0 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$a23657169ef5c959
], (cardIdsByCardListId, cardListIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    cardListIds.reduce((cardIds, cardListId)=>{
        cardIds.push(...cardIdsByCardListId[cardListId]);
        return cardIds;
    }, []));
const $5ed71ca496f4aade$export$e84ce0fc304b2d5d = (state)=>state.ui.cardList.disabled;
const $5ed71ca496f4aade$export$b40f586b1b1b5b3d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$e84ce0fc304b2d5d
], (disabled)=>{
    const getIsCardListDisabled = (cardListId)=>Boolean(disabled[cardListId]);
    return getIsCardListDisabled;
});
const $5ed71ca496f4aade$var$getMaxColumnLimitFromCardList = (cardList)=>cardList.maxColumnLimit;
const $5ed71ca496f4aade$var$getMinColumnLimitFromCardList = (cardList)=>cardList.minColumnLimit;
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
const $5ed71ca496f4aade$var$makeGetColumnLimit = (columnLimitSelector)=>(0, $dGvGJ.createSelector)([
        $5ed71ca496f4aade$export$75be3facf1d769f7,
        (0, $jG5HW.getIsCompanyManaged),
        (0, $jG5HW.isKanbanBacklogStrategy)
    ], (cardLists, isCompanyManaged, isKanban)=>{
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const getColumnLimit = (cardListId)=>isCompanyManaged && isKanban && cardLists[cardListId] && columnLimitSelector(cardLists[cardListId]) ? columnLimitSelector(cardLists[cardListId]) : undefined;
        return getColumnLimit;
    });
const $5ed71ca496f4aade$export$86fa3555538a1895 = $5ed71ca496f4aade$var$makeGetColumnLimit($5ed71ca496f4aade$var$getMaxColumnLimitFromCardList);
const $5ed71ca496f4aade$export$daddaca8cdd663b3 = $5ed71ca496f4aade$var$makeGetColumnLimit($5ed71ca496f4aade$var$getMinColumnLimitFromCardList);
const $5ed71ca496f4aade$export$a3e606d31ce14076 = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$793179e0c0778f7d,
    $5ed71ca496f4aade$export$2777f818bf992a42,
    (0, $fmuR9.issueParentIdsSelector),
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    $5ed71ca496f4aade$export$f9311774fcd7a245,
    (0, $l9VFH.getCMPFilters),
    (0, $jG5HW.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
        (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
        (0, $41ce9b5576b92b7a$export$d597759d33be802e),
        (0, $41ce9b5576b92b7a$export$2a4f270075a033de),
        (0, $41ce9b5576b92b7a$export$ebb48b08205007c5),
        (0, $41ce9b5576b92b7a$export$a4ad2735b021c132),
        'CUSTOM_FILTER'
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $2lpqS.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const validFilters = {};
    if (filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb]) {
        const allValidAssignees = isCompanyManaged ? validAssigneesWithUnassignedOption : validAssignees;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allValidAssignees.map((person)=>person.id), filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validLabels, filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de]) {
        // Ignore the epic/issue parent filter validation in CMP
        if (isCompanyManaged) validFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de];
        else {
            const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueParentIdsWithUnassignedOption, filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] ?? []);
            if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = inter;
        }
    }
    if (filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueTypeIds, filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] = inter;
    }
    if (filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allValidVersions, filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] ?? []);
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] = inter;
    }
    if (isCompanyManaged && filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (inter.length > 0) validFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] = inter;
    }
    Object.keys(filters).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return validFilters;
});
const $5ed71ca496f4aade$export$333b83a56fe77194 = (0, $dGvGJ.createSelector)([
    (0, $l9VFH.getFilters),
    $5ed71ca496f4aade$export$793179e0c0778f7d,
    $5ed71ca496f4aade$export$2777f818bf992a42,
    (0, $fmuR9.issueParentIdsSelector),
    $5ed71ca496f4aade$export$d4dec7daa49a8c5,
    $5ed71ca496f4aade$export$f9311774fcd7a245,
    (0, $l9VFH.getCMPFilters),
    (0, $jG5HW.getIsCompanyManaged)
], (filters, validAssignees, validLabels, validIssueParentIds, validIssueTypeIds, validVersions, validCustomFilters, isCompanyManaged)=>{
    const filterTypeWhitelist = [
        (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
        (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
        (0, $41ce9b5576b92b7a$export$d597759d33be802e),
        (0, $41ce9b5576b92b7a$export$2a4f270075a033de),
        (0, $41ce9b5576b92b7a$export$ebb48b08205007c5),
        (0, $41ce9b5576b92b7a$export$a4ad2735b021c132),
        (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)
    ];
    const validIssueParentIdsWithUnassignedOption = [
        String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
        ...validIssueParentIds
    ];
    const validAssigneesWithUnassignedOption = [
        (0, $2lpqS.UNASSIGNED_USER),
        ...validAssignees
    ];
    const validVersionsWithUnassignedOption = [
        (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
        ...validVersions
    ];
    const invalidFilters = {};
    if (filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb]) {
        const allValidAssignees = validAssigneesWithUnassignedOption;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb], allValidAssignees.map((person)=>person.id));
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7], validLabels);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] = diff;
    }
    // Ignore the epic/issue parent filter validation in CMP
    if (filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] && !isCompanyManaged) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de], validIssueParentIdsWithUnassignedOption);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5], validIssueTypeIds);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] = diff;
    }
    if (filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132]) {
        const allValidVersions = isCompanyManaged ? validVersionsWithUnassignedOption : validVersions;
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132], allValidVersions);
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] = diff;
    }
    if (isCompanyManaged && filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] = diff;
    }
    Object.keys(filters)// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in filter selectors`);
    });
    return invalidFilters;
});
const $5ed71ca496f4aade$export$e5ce012c8ff94f67 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$333b83a56fe77194
], (invalidFilterValues)=>Object.keys(invalidFilterValues).length > 0);
const $5ed71ca496f4aade$export$116ea4e15b17d748 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, $5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, fixVersions: fixVersions } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            fixVersions: fixVersions
        };
    }));
const $5ed71ca496f4aade$export$97279e04a1cfee44 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, $5ed71ca496f4aade$export$ad9f3c6d3dd8c300, (cards, cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
        const { id: id, key: key, parentId: parentId, projectId: projectId, typeHierarchyLevel: typeHierarchyLevel } = cards[String(cardId)];
        return {
            id: id,
            key: key,
            parentId: parentId,
            projectId: projectId,
            typeHierarchyLevel: typeHierarchyLevel
        };
    }));
const $5ed71ca496f4aade$export$cb1654a9ed6d9099 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$bc61c71d8347e4d9, (cards)=>{
    const getPartialCardsFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, parentId: parentId, projectId: projectId } = cards[String(cardId)];
            return {
                id: id,
                key: key,
                parentId: parentId,
                projectId: projectId
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getPartialCardsFromCardIds);
});
const $5ed71ca496f4aade$export$9656edc7cd965e96 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $74oBv.getCardTypesForFilter)
], (cards, cardTypes)=>{
    const getCardsForFlagWithCommentModalFromCardIds = (cardIds)=>cardIds.filter((cardId)=>cards[String(cardId)]).map((cardId)=>{
            const { id: id, key: key, summary: summary, typeId: typeId } = cards[String(cardId)];
            const type = cardTypes.find((it)=>it.id === String(typeId)) ?? {
                id: String(typeId),
                name: '',
                iconUrl: ''
            };
            return {
                id: id,
                key: key,
                summary: summary,
                type: type
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardsForFlagWithCommentModalFromCardIds);
});
const $5ed71ca496f4aade$export$a9b1eabca1c583fe = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>{
    const getIsAssignedToIssueParent = (selectedIds)=>cards.some((card)=>selectedIds.includes(card.id) && card.parentId);
    return getIsAssignedToIssueParent;
});
const $5ed71ca496f4aade$export$1b6edd941a4eaddd = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numTotalChildren, 0));
const $5ed71ca496f4aade$export$18ec94fe8e415ca5 = (0, $dGvGJ.createSelector)($5ed71ca496f4aade$export$c6ca016832785256, (cards)=>cards.reduce((num, card)=>num + card.numCompleteChildren, 0));
const $5ed71ca496f4aade$export$ebb887ede9b3994e = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        if (cards[cardId]) return cards[cardId].key;
        if (parents[cardId]) return parents[cardId].key;
        return null;
    }));
const $5ed71ca496f4aade$export$8d7d30d4816f6177 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9,
    (0, $fmuR9.getIssueParents)
], (cards, parents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((key)=>{
        const cardId = Object.keys(cards).find((id)=>cards[id].key === key);
        if (cardId) return Number(cardId);
        const parentId = Object.keys(parents).find((id)=>parents[id].key === key);
        if (parentId) return Number(parentId);
        return null;
    }));
const $5ed71ca496f4aade$export$7170cae353180463 = (state)=>state.ui.cards.richCard.cardIdWithAboveIccOpen ?? null;
const $5ed71ca496f4aade$export$8f8d79952e8c1b8f = (state, { cardId: cardId })=>cardId === $5ed71ca496f4aade$export$7170cae353180463(state);
const $5ed71ca496f4aade$export$a874620d473113d0 = (state)=>state.ui.cards.richCard.mainActiveCard;
const $5ed71ca496f4aade$export$ee56c425125d2ef6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$841def0f013aa3d3,
    (0, $fmuR9.issueParentIdsSelector)
], (cardIds, parentIds)=>{
    const formattedParentIds = parentIds.map((id)=>Number(id));
    return [
        ...cardIds,
        ...formattedParentIds
    ];
});
const $5ed71ca496f4aade$export$22d153c4cb386f10 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$75be3facf1d769f7,
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$3593c0292d4c2e0b,
    $5ed71ca496f4aade$export$ab100b26d47e733e
], (cardLists, cardListIds, cardIdsByCardListId, getCardListAnalyticsTypeById)=>{
    const getListCount = (listId)=>listId && cardIdsByCardListId[listId] && cardIdsByCardListId[listId].length || 0;
    const boardIssueNo = getListCount((0, $guzeq.BOARD));
    const backlogIssueNo = getListCount((0, $guzeq.BACKLOG));
    const sprintStats = cardListIds.map((cardListId)=>({
            count: getListCount(cardListId),
            type: getCardListAnalyticsTypeById(cardListId)
        })).filter(({ type: type })=>type === (0, $guzeq.ACTIVE_SPRINT) || type === (0, $guzeq.INACTIVE_SPRINT));
    const activeSprintIssueNo = sprintStats.find(({ type: type })=>type === (0, $guzeq.ACTIVE_SPRINT))?.count ?? 0;
    const sprintsCount = sprintStats.length;
    const sprintsCardCounts = sprintStats.map(({ count: count })=>count);
    const sprintsMaxIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(sprintsCardCounts);
    const sprintsIssueNo = (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(sprintsCardCounts);
    const sprintsAverageIssueNo = sprintsIssueNo / sprintsCount;
    return {
        boardIssueNo: boardIssueNo,
        activeSprintIssueNo: activeSprintIssueNo,
        backlogIssueNo: backlogIssueNo,
        sprintsCount: sprintsCount,
        sprintsMaxIssueNo: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        sprintsMaxIssueNo,
        sprintsAverageIssueNo: sprintsAverageIssueNo,
        sprintsIssueNo: sprintsIssueNo
    };
});
const $5ed71ca496f4aade$export$6450c8aec6d3b414 = (0, $dGvGJ.createSelector)([
    (state, props)=>props.cardId,
    (state)=>$5ed71ca496f4aade$export$a874620d473113d0(state),
    (state)=>$5ed71ca496f4aade$export$3593c0292d4c2e0b(state),
    (state)=>$5ed71ca496f4aade$export$c24a16d8eafb7cff(state)
], (targetCardId, activeCardId, orderedCardIdsByCardListId, getVisibleCardsForCardList)=>{
    if (!activeCardId) return false;
    if (targetCardId === activeCardId) return true;
    const activeCardList = Object.entries(orderedCardIdsByCardListId).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, cardIds])=>Array.isArray(cardIds) && cardIds.includes(activeCardId));
    if (!activeCardList) return false;
    const [activeCardListId] = activeCardList;
    const activeCardListCardIds = getVisibleCardsForCardList(activeCardListId);
    if (!Array.isArray(activeCardListCardIds)) return false;
    const activeCardIndex = activeCardListCardIds.indexOf(activeCardId);
    const targetCardIndex = activeCardListCardIds.indexOf(targetCardId);
    return activeCardIndex !== -1 && targetCardIndex !== -1 && targetCardIndex === activeCardIndex + 1;
});
const $5ed71ca496f4aade$export$454eae1b4bd66f70 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$962651073dd96b20
], (hasExtraFields)=>({ isInlineCardCreateOpen: isInlineCardCreateOpen, numberOfCardsInCardEntry: numberOfCardsInCardEntry, isCompact: isCompact, hideExtraFields: hideExtraFields = false })=>{
        const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
        const shouldHideExtraFields = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? hideExtraFields : false;
        const rowHeight = hasExtraFields && !shouldHideExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
        const groupHeight = rowHeight * numberOfCardsInCardEntry;
        const inlineCreateHeight = isInlineCardCreateOpen ? (0, $2lpqS.INLINE_CARD_CREATE_ROW_HEIGHT) : 0;
        return groupHeight + inlineCreateHeight;
    });
const $5ed71ca496f4aade$export$697c63a5f8659c9 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$962651073dd96b20
], (hasExtraFields)=>(isCompact)=>{
        const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
        return hasExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    });
const $5ed71ca496f4aade$export$88889176877886a9 = (state)=>state.ui.cardList.dragState;
const $5ed71ca496f4aade$export$ac2362f84ffb1564 = (state, cardListId)=>Boolean($5ed71ca496f4aade$export$88889176877886a9(state)[cardListId]);
const $5ed71ca496f4aade$export$59261b5a26c04c00 = (state)=>state.ui.cardList.isDragging;
const $5ed71ca496f4aade$export$a62ade440fb97a7a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$3593c0292d4c2e0b
], (orderedCardListIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>Object.keys(orderedCardListIds).find((cardListId)=>orderedCardListIds[cardListId].includes(cardId))));
const $5ed71ca496f4aade$export$f787c700d21c234a = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$f4b996b8eaed63ba
], (orderedCardEntriesByCardListId)=>{
    const getCardGroupId = (cardListId, cardId)=>{
        if (cardListId === undefined) return undefined;
        const orderedCardEntries = orderedCardEntriesByCardListId(cardListId);
        const group = orderedCardEntries.find((entry)=>entry.type === (0, $guzeq.GROUP_TYPE) && entry.parentId !== cardId && entry.cardIds.includes(cardId));
        return group !== null && group?.type === (0, $guzeq.GROUP_TYPE) ? `${group.parentId}-${cardListId}` : undefined;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupId);
});
const $5ed71ca496f4aade$export$2b8ccf236ef3c2ad = (state, cardId)=>{
    const versions = (0, $fpDLy.getEntitiesVersions)(state);
    const cards = $5ed71ca496f4aade$export$bc61c71d8347e4d9(state);
    const card = $5ed71ca496f4aade$var$getCardById(cards, cardId);
    return card?.fixVersions?.map((versionId)=>versions?.[versionId]).filter(Boolean) ?? [];
};
const $5ed71ca496f4aade$export$10c1cb90425eb140 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$a23657169ef5c959,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff,
    $5ed71ca496f4aade$export$48519a9ef4b7246c
], (visibleCardListIds, getOrderedVisibleCardIdsForCardList, getIsCardListCollapsed)=>visibleCardListIds.find((listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0 && !getIsCardListCollapsed(listId)));
const $5ed71ca496f4aade$export$91d6529e043b6231 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.isFlagged));
const $5ed71ca496f4aade$export$df669897ce3195c6 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.priority));
const $5ed71ca496f4aade$export$41cf0539676d3407 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.dueDate));
const $5ed71ca496f4aade$export$242c58db4e305622 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.estimate?.storyPoints));
const $5ed71ca496f4aade$export$261deb4fe884b0a1 = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$bc61c71d8347e4d9
], (cards)=>(0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(cards, (card)=>!!card?.estimate?.originalEstimate?.value));
const $5ed71ca496f4aade$export$5bab56d9e503125d = (0, $dGvGJ.createSelector)([
    $5ed71ca496f4aade$export$5895481c46e9779a,
    $5ed71ca496f4aade$export$c24a16d8eafb7cff
], (orderedCardListIds, getOrderedVisibleCardIdsForCardList)=>(0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))(orderedCardListIds, (listId)=>getOrderedVisibleCardIdsForCardList(listId).length > 0));
const $5ed71ca496f4aade$export$eb5d19e26822928b = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.isCmpKanbanProject),
    $5ed71ca496f4aade$export$ad9f3c6d3dd8c300,
    $5ed71ca496f4aade$export$9fc808638e14d4f0,
    $5ed71ca496f4aade$export$8f9f740048610b66
], (isCmpKanbanBacklog, selectedCardIds, orderedCardIds, getParentIdByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((draggingCardId)=>{
        const relevantCards = new Set(selectedCardIds.includes(draggingCardId) ? selectedCardIds : [
            draggingCardId
        ]);
        return orderedCardIds.filter((cardId)=>{
            if (isCmpKanbanBacklog) return relevantCards.has(cardId);
            const parentId = getParentIdByChildId(cardId);
            return relevantCards.has(cardId) && (!parentId || !relevantCards.has(parentId));
        });
    }));

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});


parcelRegister("icGZu", function(module, exports) {

var $2k3l6 = parcelRequire("2k3l6");

var $bxDef = parcelRequire("bxDef");

var $6kYP8 = parcelRequire("6kYP8");

var $8LQ84 = parcelRequire("8LQ84");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d40ab2104a331ebd$var$some(collection, predicate, guard) {
    var func = $8LQ84(collection) ? $2k3l6 : $6kYP8;
    if (guard && $4rDUz(collection, predicate, guard)) predicate = undefined;
    return func(collection, $bxDef(predicate, 3));
}
module.exports = $d40ab2104a331ebd$var$some;

});
parcelRegister("6kYP8", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $49d3cab0435826ab$var$baseSome(collection, predicate) {
    var result;
    $e7pfQ(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $49d3cab0435826ab$var$baseSome;

});


parcelRegister("iThRn", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $dc0b37ac120f9bb6$var$sum(array) {
    return array && array.length ? $gBzAF(array, $etyzk) : 0;
}
module.exports = $dc0b37ac120f9bb6$var$sum;

});
parcelRegister("gBzAF", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $c16bb58eedefe4cd$var$baseSum;

});


parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


const $41ce9b5576b92b7a$export$d597759d33be802e = 'TEXT';
const $41ce9b5576b92b7a$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $41ce9b5576b92b7a$export$37aee82a3cb1e8f7 = 'LABEL';
const $41ce9b5576b92b7a$export$2a4f270075a033de = 'ISSUE_PARENT';
const $41ce9b5576b92b7a$export$a4ad2735b021c132 = 'VERSION';
const $41ce9b5576b92b7a$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $41ce9b5576b92b7a$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $41ce9b5576b92b7a$export$360e7ca29749d455 = 6;

parcelRegister("ee1tL", function(module, exports) {

$parcel$export(module.exports, "isCardEntryGroup", () => $bfdc71dc0d0cc8bd$export$1f425e415814c059);
$parcel$export(module.exports, "getCardEntryGroupKey", () => $bfdc71dc0d0cc8bd$export$57a979d82c39e211);
const $bfdc71dc0d0cc8bd$export$1f425e415814c059 = (cardEntry)=>cardEntry?.type === 'group';
const $bfdc71dc0d0cc8bd$export$57a979d82c39e211 = ({ parentId: parentId }, cardListId)=>`cardGroup-${cardListId}-${parentId}`;

});

parcelRegister("jG5HW", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $4d4429919f577b04$export$f654b28f82155665);
$parcel$export(module.exports, "getLocale", () => $4d4429919f577b04$export$180605366c04f0cd);
$parcel$export(module.exports, "getCloudId", () => $4d4429919f577b04$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getAtlassianAccountId", () => $4d4429919f577b04$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getIsCompanyManaged", () => $4d4429919f577b04$export$a5407237e82f55bc);
$parcel$export(module.exports, "getIsBoardCrossProject", () => $4d4429919f577b04$export$28687faffae2aeb1);
$parcel$export(module.exports, "getDetailView", () => $4d4429919f577b04$export$afc39f7bfa2dc85);
$parcel$export(module.exports, "getRapidViewId", () => $4d4429919f577b04$export$d5d5a91bd9ef0413);
$parcel$export(module.exports, "getProjectName", () => $4d4429919f577b04$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjects", () => $4d4429919f577b04$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProjectIds", () => $4d4429919f577b04$export$178da5d750a5a582);
$parcel$export(module.exports, "projectIdSelector", () => $4d4429919f577b04$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "getProjectKey", () => $4d4429919f577b04$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getSessionId", () => $4d4429919f577b04$export$b3739caaf2580dd);
$parcel$export(module.exports, "getProjectAris", () => $4d4429919f577b04$export$aa9d76803f3432de);
$parcel$export(module.exports, "getRankCustomFieldId", () => $4d4429919f577b04$export$e98a0db7f9514370);
$parcel$export(module.exports, "getStoryPointFieldId", () => $4d4429919f577b04$export$60b2b9fa88a67144);
$parcel$export(module.exports, "getSprintFieldId", () => $4d4429919f577b04$export$84ee6604e6063636);
$parcel$export(module.exports, "getEpicLinkFieldId", () => $4d4429919f577b04$export$366de0fbf3478a25);
$parcel$export(module.exports, "getEpicIssueType", () => $4d4429919f577b04$export$c58dde3f1e86a4e4);
$parcel$export(module.exports, "getRequestColumnMigration", () => $4d4429919f577b04$export$55ebbbc856ff6213);
$parcel$export(module.exports, "getName", () => $4d4429919f577b04$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getBacklogStrategy", () => $4d4429919f577b04$export$a5a7be8ea88122cc);
$parcel$export(module.exports, "getTimeTrackingOptions", () => $4d4429919f577b04$export$cb06173d4516a1bf);
$parcel$export(module.exports, "getJqlQuery", () => $4d4429919f577b04$export$2af3643b1d2591eb);
$parcel$export(module.exports, "getIsParallelSprintsEnabled", () => $4d4429919f577b04$export$3dc3b60a5f5423b3);
$parcel$export(module.exports, "isKanbanBacklogStrategy", () => $4d4429919f577b04$export$5aa5fa3e0697f97f);
$parcel$export(module.exports, "isScrumBacklogStrategy", () => $4d4429919f577b04$export$3c97bd51d3f010f7);
$parcel$export(module.exports, "getKanbanBoardColumnId", () => $4d4429919f577b04$export$a97644e2ddb37b5e);
$parcel$export(module.exports, "getKanbanBacklogColumnId", () => $4d4429919f577b04$export$b5c1d7f6a57c60b8);
$parcel$export(module.exports, "getKanbanTargetColumnId", () => $4d4429919f577b04$export$e4c5fb56a3200047);
$parcel$export(module.exports, "getHasActiveSprints", () => $4d4429919f577b04$export$b7c097c5d71343b7);
$parcel$export(module.exports, "isCardMoveDisabled", () => $4d4429919f577b04$export$6cea212e63a4af6c);
$parcel$export(module.exports, "isCmpKanbanProject", () => $4d4429919f577b04$export$8b4b78473e0920ac);
$parcel$export(module.exports, "isCheckboxSelectionMode", () => $4d4429919f577b04$export$af914ee70a3d8e9f);
$parcel$export(module.exports, "isCMPScrumBacklog", () => $4d4429919f577b04$export$481012a7a1572742);
$parcel$export(module.exports, "getBoardType", () => $4d4429919f577b04$export$985c8cf86abe2d42);

var $dGvGJ = parcelRequire("dGvGJ");

var $dXq4S = parcelRequire("dXq4S");


var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");
const $4d4429919f577b04$export$f654b28f82155665 = (state)=>state.config.baseUrl;
const $4d4429919f577b04$export$180605366c04f0cd = (state)=>state.config.locale;
const $4d4429919f577b04$export$14407a25c57e1f92 = (state)=>state.config.xsrfToken;
const $4d4429919f577b04$export$fdd2c0ba94025c3c = (state)=>state.config.cloudId;
const $4d4429919f577b04$export$f5baf4f0aaa47428 = (state)=>state.config.atlassianAccountId;
const $4d4429919f577b04$export$a5407237e82f55bc = (state)=>state.config.isCompanyManaged;
const $4d4429919f577b04$export$28687faffae2aeb1 = (state)=>state.config.isBoardCrossProject;
const $4d4429919f577b04$export$afc39f7bfa2dc85 = (state)=>state.ui.detailView;
const $4d4429919f577b04$export$d5d5a91bd9ef0413 = (state)=>state.config.rapidViewId;
/*
 * @deprecated getProjectId getter should not be used for company-managed. Use projectIdSelector instead.
 * Eventually this will have to be deprecated for team-managed project as well.
 * */ const $4d4429919f577b04$var$getProjectId = (state)=>state.config.projectId;
const $4d4429919f577b04$export$2cd058184eb75757 = (state)=>state.config.projectName;
const $4d4429919f577b04$export$b00a271f69f3d728 = (0, $dGvGJ.createSelector)([
    (0, $e5nhF.getEntities)
], (entities)=>entities.project.projects);
const $4d4429919f577b04$export$178da5d750a5a582 = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$a5407237e82f55bc,
    $4d4429919f577b04$export$b00a271f69f3d728,
    $4d4429919f577b04$var$getProjectId
], (isCompanyManaged, projects, projectId)=>isCompanyManaged ? projects.map((x)=>x.id) : [
        projectId
    ]);
const $4d4429919f577b04$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$178da5d750a5a582
], (projectIds)=>projectIds[0]);
const $4d4429919f577b04$export$667f2a0f99c75faa = (state)=>state.config.projectKey;
const $4d4429919f577b04$export$b3739caaf2580dd = (state)=>state.config.sessionId;
const $4d4429919f577b04$export$aa9d76803f3432de = (0, $dGvGJ.createSelector)([
    $4d4429919f577b04$export$178da5d750a5a582,
    $4d4429919f577b04$export$fdd2c0ba94025c3c
], (projectIds, cloudId)=>projectIds.map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        })));
const $4d4429919f577b04$export$e98a0db7f9514370 = (state)=>state.config.rankCustomFieldId;
const $4d4429919f577b04$export$60b2b9fa88a67144 = (state)=>state.config.storyPointFieldId;
const $4d4429919f577b04$export$84ee6604e6063636 = (state)=>state.config.sprintFieldId;
const $4d4429919f577b04$export$366de0fbf3478a25 = (state)=>state.config.epicLinkField?.id;
const $4d4429919f577b04$export$c58dde3f1e86a4e4 = (state)=>state.config.epicIssueType ?? null;
const $4d4429919f577b04$export$55ebbbc856ff6213 = (state)=>state.config.requestColumnMigration;
const $4d4429919f577b04$export$7d9f7e9c1c02b41e = (state)=>state.config.name;
const $4d4429919f577b04$export$a5a7be8ea88122cc = (state)=>state.config.backlogStrategy;
const $4d4429919f577b04$export$cb06173d4516a1bf = (state)=>state.config.timeTrackingOptions;
const $4d4429919f577b04$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $4d4429919f577b04$export$3dc3b60a5f5423b3 = (state)=>state.config.parallelSprints;
const $4d4429919f577b04$export$5aa5fa3e0697f97f = (state)=>state.config.backlogStrategy === (0, $guzeq.KANBAN_BACKLOG_STRATEGY);
const $4d4429919f577b04$export$3c97bd51d3f010f7 = (state)=>$4d4429919f577b04$export$a5a7be8ea88122cc(state) === (0, $guzeq.SPRINT_BACKLOG_STRATEGY);
const $4d4429919f577b04$export$a97644e2ddb37b5e = (state)=>state?.config?.kanbanBoardColumnId ?? null;
const $4d4429919f577b04$export$b5c1d7f6a57c60b8 = (state)=>state?.config?.kanbanBacklogColumnId ?? null;
const $4d4429919f577b04$export$e4c5fb56a3200047 = (state)=>(cardListType)=>cardListType === (0, $guzeq.BACKLOG) ? $4d4429919f577b04$export$b5c1d7f6a57c60b8(state) : $4d4429919f577b04$export$a97644e2ddb37b5e(state);
const $4d4429919f577b04$export$b7c097c5d71343b7 = (state)=>{
    // TODO: Update this to use Object.values when TS comes in
    // Damn you Flow.
    const { cardList: cardList } = (0, $e5nhF.getEntities)(state);
    return Object.keys(cardList).some((key)=>cardList[key].sprintData?.state === (0, $guzeq.SPRINT_STATE_ACTIVE));
};
const $4d4429919f577b04$export$6cea212e63a4af6c = (state)=>state.config.isCompanyManaged === true && state.config.isOrderedByRank === false;
const $4d4429919f577b04$export$8b4b78473e0920ac = (state)=>$4d4429919f577b04$export$a5407237e82f55bc(state) && $4d4429919f577b04$export$5aa5fa3e0697f97f(state);
const $4d4429919f577b04$export$af914ee70a3d8e9f = (state)=>state.ui.cards.isCheckboxSelectionMode;
const $4d4429919f577b04$export$481012a7a1572742 = (state)=>$4d4429919f577b04$export$a5407237e82f55bc(state) && $4d4429919f577b04$export$3c97bd51d3f010f7(state);
const $4d4429919f577b04$export$985c8cf86abe2d42 = (state)=>{
    if ($4d4429919f577b04$export$a5407237e82f55bc(state)) {
        if ($4d4429919f577b04$export$3c97bd51d3f010f7(state)) return 0, $a9c483c0d986286a$export$8ee1fad10cc70eb5;
        if ($4d4429919f577b04$export$5aa5fa3e0697f97f(state)) return 0, $a9c483c0d986286a$export$9f54a1518145e351;
    }
    return 0, $a9c483c0d986286a$export$9a2b21d55c0f061c;
};

});
const $a9c483c0d986286a$export$dfd208682d29484c = 'software-backlog';
const $a9c483c0d986286a$export$b6e4306772e8a60d = 'ng-backlog';
const $a9c483c0d986286a$export$7858b0b4e02abd78 = 'cmp-backlog';
const $a9c483c0d986286a$export$840e3848643f7781 = 'backlog';
const $a9c483c0d986286a$export$9f54a1518145e351 = 'Kanban';
const $a9c483c0d986286a$export$8ee1fad10cc70eb5 = 'Scrum';
const $a9c483c0d986286a$export$9a2b21d55c0f061c = 'Agility';

parcelRegister("e5nhF", function(module, exports) {

$parcel$export(module.exports, "getEntities", () => $31f541e32b7bdffd$export$e2e3f9f64b249105);
$parcel$export(module.exports, "getIssueParentsOrderIds", () => $31f541e32b7bdffd$export$6074a6cc45eb2317);

var $alNv9 = parcelRequire("alNv9");
const $31f541e32b7bdffd$export$e2e3f9f64b249105 = (state)=>(0, $alNv9.ensureState)(state.entities);
const $31f541e32b7bdffd$export$6074a6cc45eb2317 = (state)=>$31f541e32b7bdffd$export$e2e3f9f64b249105(state).issueParentsOrder;

});


parcelRegister("74oBv", function(module, exports) {

$parcel$export(module.exports, "getCardTypes", () => $dc0656ae0ef75194$export$b20723ae469526fe);
$parcel$export(module.exports, "getBaseLevelCardTypes", () => $dc0656ae0ef75194$export$25d4089e81ce95ff);
$parcel$export(module.exports, "getCardTypesForFilter", () => $dc0656ae0ef75194$export$9b7f24e4cefec566);
$parcel$export(module.exports, "manageIssueTypesSelector", () => $dc0656ae0ef75194$export$3d59df9affe3fcf3);
$parcel$export(module.exports, "getHasAnyIssueTypeWithRequireFields", () => $dc0656ae0ef75194$export$67aba0fda804be4c);

var $alNv9 = parcelRequire("alNv9");

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");

var $g4tDr = parcelRequire("g4tDr");

var $02Psx = parcelRequire("02Psx");

var $jG5HW = parcelRequire("jG5HW");
const $dc0656ae0ef75194$export$b20723ae469526fe = (state)=>(0, $alNv9.ensureState)(state.entities).cardTypes;
const $dc0656ae0ef75194$export$25d4089e81ce95ff = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$b20723ae469526fe, (cardTypes)=>cardTypes.length > 0 ? cardTypes?.filter((issueType)=>issueType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE)) : []);
const $dc0656ae0ef75194$export$9b7f24e4cefec566 = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>({
            id: String(cardType.id),
            name: cardType.name,
            iconUrl: cardType.iconUrl
        })));
const $dc0656ae0ef75194$export$d4dec7daa49a8c5 = (0, $dGvGJ.createSelector)($dc0656ae0ef75194$export$25d4089e81ce95ff, (cardTypes)=>cardTypes.map((cardType)=>String(cardType.id)));
const $dc0656ae0ef75194$export$3d59df9affe3fcf3 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getBaseUrl),
    (0, $jG5HW.getProjectKey)
], (_, projectKey)=>(0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey));
const $dc0656ae0ef75194$export$67aba0fda804be4c = (0, $dGvGJ.createSelector)([
    $dc0656ae0ef75194$export$25d4089e81ce95ff
], (cardTypes)=>cardTypes.some((cardType)=>cardType.hasRequiredFields));

});

parcelRegister("l9VFH", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $424c5f2057b4a72b$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getCMPFilters", () => $424c5f2057b4a72b$export$b85cb74b5db260e6);
$parcel$export(module.exports, "getAppliedParentFilters", () => $424c5f2057b4a72b$export$889ee627c9da88af);
$parcel$export(module.exports, "getAppliedAssigneeFilters", () => $424c5f2057b4a72b$export$4724d05a9e1b68d8);
$parcel$export(module.exports, "getAppliedVersionFilters", () => $424c5f2057b4a72b$export$f08351012de61e58);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $424c5f2057b4a72b$export$60ee89f2718fc651);
$parcel$export(module.exports, "getAppliedCustomFilters", () => $424c5f2057b4a72b$export$e4cc6991cb44d849);
$parcel$export(module.exports, "getAppliedCustomFilterQueries", () => $424c5f2057b4a72b$export$5d6b2188da2fc080);
$parcel$export(module.exports, "getLastFilteredIssueTypeId", () => $424c5f2057b4a72b$export$66fc4c808781b0dd);
$parcel$export(module.exports, "filter", () => $424c5f2057b4a72b$export$3dea766d36a8935f);

var $dGvGJ = parcelRequire("dGvGJ");

var $hYfgW = parcelRequire("hYfgW");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $dVREV = parcelRequire("dVREV");


var $e5nhF = parcelRequire("e5nhF");
const $424c5f2057b4a72b$export$1933a9fe712fc1fd = (state)=>state.ui.filters;
const $424c5f2057b4a72b$export$b85cb74b5db260e6 = (state)=>(0, $e5nhF.getEntities)(state).customFilters.filters;
const $424c5f2057b4a72b$export$889ee627c9da88af = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$2a4f270075a033de];
const $424c5f2057b4a72b$export$4724d05a9e1b68d8 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb];
const $424c5f2057b4a72b$export$f08351012de61e58 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$a4ad2735b021c132];
const $424c5f2057b4a72b$export$60ee89f2718fc651 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7];
const $424c5f2057b4a72b$export$e4cc6991cb44d849 = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$68d693c35a8d8866];
const $424c5f2057b4a72b$export$5d6b2188da2fc080 = (0, $dGvGJ.createSelector)([
    $424c5f2057b4a72b$export$b85cb74b5db260e6,
    $424c5f2057b4a72b$export$e4cc6991cb44d849
], (filters, currentAppliedFilters)=>filters.filter((f)=>currentAppliedFilters?.includes(f.id)).map((f)=>f.query).filter(Boolean));
const $424c5f2057b4a72b$export$7ea0d3589e75ea3e = (state)=>$424c5f2057b4a72b$export$1933a9fe712fc1fd(state)[0, $41ce9b5576b92b7a$export$ebb48b08205007c5];
const $424c5f2057b4a72b$export$66fc4c808781b0dd = (0, $dGvGJ.createSelector)([
    $424c5f2057b4a72b$export$7ea0d3589e75ea3e
], (issueTypes)=>{
    if (issueTypes && issueTypes.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(issueTypes));
    return undefined;
});
const $424c5f2057b4a72b$export$79e3f18eafd008ab = (issue)=>Number(issue.id) < 0;
const $424c5f2057b4a72b$export$3dea766d36a8935f = (filterValues, filteredIssueIds, cards)=>{
    const toFilterableIssue = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(({ id: id, key: key, summary: summary, labels: labels, typeId: typeId, parentId: parentId, assignee: assignee, fixVersions: fixVersions })=>{
        const filterableAssignee = assignee ? {
            id: assignee.id,
            displayName: assignee.displayName
        } : undefined;
        return {
            id: String(id),
            key: key,
            summary: summary,
            labels: labels,
            type: {
                id: String(typeId)
            },
            versionIds: fixVersions,
            parentId: typeof parentId !== 'undefined' && parentId !== null ? String(parentId) : undefined,
            assignee: filterableAssignee
        };
    });
    const issuesContext = cards && cards.length ? {
        list: [],
        hash: {}
    } : undefined;
    if (issuesContext) cards?.filter((card)=>card.typeHierarchyLevel !== (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC)).forEach((card)=>{
        const filterableIssue = toFilterableIssue(card);
        issuesContext.list.push(filterableIssue);
        issuesContext.hash[card.id] = filterableIssue;
    });
    const filterFunction = (0, $dVREV.createFilterFunction)(filterValues, {
        filteredIssueIds: filteredIssueIds,
        issues: issuesContext
    }, (0, $dVREV.createDefaultMatcherCreators)(), [
        $424c5f2057b4a72b$export$79e3f18eafd008ab
    ]);
    return (issues)=>issues.filter((issue)=>{
            const filterableIssue = toFilterableIssue(issue);
            return filterFunction(filterableIssue);
        });
};

});
parcelRegister("dVREV", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $da698aa4f276c01f$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $da698aa4f276c01f$export$5b4da3e2bd753e6);


var $83R7M = parcelRequire("83R7M");

var $9NUFF = parcelRequire("9NUFF");

var $bOpxF = parcelRequire("bOpxF");

var $2Ol4g = parcelRequire("2Ol4g");

var $kSow3 = parcelRequire("kSow3");

var $91AxA = parcelRequire("91AxA");

var $8wcaA = parcelRequire("8wcaA");

var $7vODb = parcelRequire("7vODb");

var $bliRS = parcelRequire("bliRS");

var $iZeAQ = parcelRequire("iZeAQ");

var $ly5rg = parcelRequire("ly5rg");

var $4nYh7 = parcelRequire("4nYh7");

var $gbBLn = parcelRequire("gbBLn");

var $gw6jA = parcelRequire("gw6jA");
const $da698aa4f276c01f$export$551eb27bf5bd708 = ()=>({
        [(0, $15a528573ccd89ae$export$d597759d33be802e)]: (0, $gbBLn.textMatcherCreator),
        [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $83R7M.assigneeMatcherCreator),
        [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: (0, $7vODb.labelMatcherCreator),
        [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: (0, $kSow3.issueParentMatcherCreator),
        [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: (0, $91AxA.issueProjectMatcherCreator),
        [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: (0, $8wcaA.issueTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $gw6jA.versionMatcherCreator),
        [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $9NUFF.componentMatcherCreator),
        [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: (0, $bliRS.requestTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: (0, $ly5rg.statusCategoryMatcherCreator),
        [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: (0, $4nYh7.statusMatcherCreator),
        [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: (0, $iZeAQ.sprintMatcherCreator),
        [(0, $15a528573ccd89ae$export$871e58afc769b358)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: (0, $bOpxF.dependenciesMatcherCreator)
    });
const $da698aa4f276c01f$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $da698aa4f276c01f$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $da698aa4f276c01f$var$createMatchers(filter, context, matcherCreators ?? $da698aa4f276c01f$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("83R7M", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $516b0f9136210863$export$5c453ff7d8a6957f);

var $g5X3G = parcelRequire("g5X3G");

const $516b0f9136210863$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)));
};

});

parcelRegister("9NUFF", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $f76f751e605f1ced$export$667cab6ac6c65512);

const $f76f751e605f1ced$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $15a528573ccd89ae$export$4b7c755e61199a36)));
};

});

parcelRegister("bOpxF", function(module, exports) {

$parcel$export(module.exports, "dependenciesMatcherCreator", () => $03061179e3dc93a9$export$18a8a0a9891403f1);

var $4R6GH = parcelRequire("4R6GH");

var $kIDH3 = parcelRequire("kIDH3");
const $03061179e3dc93a9$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
    // General rule of dependencies filter is that it should include issues that has at least 1 dependency matches the selected filter.
    // So if off track is selected, it should include issues that has at least 1 off track dependency and vice versa,
    // if on track is selected, it should include issues that has at least 1 on track dependency.
    // If both off track and on track are selected, it should include issues that has at least 1 off track or on track dependency.
    if (dependenciesFilter && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        const includeOffTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).OFF_TRACK);
        const includeOnTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).ON_TRACK);
        return (issue)=>includeOffTrack && !!issue.hasOfftrackDependency || includeOnTrack && !!issue.hasOntrackDependency;
    }
    return ()=>true;
};

});
parcelRegister("kIDH3", function(module, exports) {

$parcel$export(module.exports, "DependencyFilterOption", () => $ddac187df0965772$export$499848eca2db01cf);
const $ddac187df0965772$export$499848eca2db01cf = {
    OFF_TRACK: 'off-track',
    ON_TRACK: 'on-track'
};

});


parcelRegister("2Ol4g", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $497597637c50e49d$export$4493d922cd011b1a);
const $497597637c50e49d$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kSow3", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $a81202b8afefb6ff$export$4729465fe91e6864);

const $a81202b8afefb6ff$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $9ac224d9ad6eb576$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if (checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return isAncestorInFilter(parentId, checked.concat(id));
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if (id === parentId) return false;
        return isAncestorInFilter(parentId, [
            id
        ]);
    };
};

});
const $9ac224d9ad6eb576$export$794f07be04aca3fe = '0';
const $9ac224d9ad6eb576$export$cb17e3c17bc50301 = 'Epic';
const $9ac224d9ad6eb576$export$7fbc739f2667a35e = 'Subtask';


parcelRegister("91AxA", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $4fdd97fe73369965$export$b10ee43342090204);

var $4Djk8 = parcelRequire("4Djk8");
const $4fdd97fe73369965$export$b10ee43342090204 = (projectFilter)=>{
    if (!(0, $4Djk8.isIncrementPlanningBoardM1Enabled)()) return ()=>true;
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});
parcelRegister("4Djk8", function(module, exports) {

$parcel$export(module.exports, "isIncrementPlanningBoardM1Enabled", () => $b1680bdcd6e77b35$export$3cf7abcb30f8ee4d);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $co1wz = parcelRequire("co1wz");
const $b1680bdcd6e77b35$export$40a610084ff0408 = 'com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1';
const $b1680bdcd6e77b35$export$3cf7abcb30f8ee4d = ()=>(0, $co1wz.ff)($b1680bdcd6e77b35$export$40a610084ff0408); // </qfeyaerts>

});


parcelRegister("8wcaA", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $1427bf4cc0e6bee2$export$48b17418005f8b9b);
const $1427bf4cc0e6bee2$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("7vODb", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $40f84c5420493f05$export$71d90ee236f2e796);

const $40f84c5420493f05$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $15a528573ccd89ae$export$81ef49afbbead0a1)));
};

});

parcelRegister("bliRS", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba);
const $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("iZeAQ", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $18f99efa97d4433e$export$4706275ba29d0c7);
const $18f99efa97d4433e$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("ly5rg", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $e669431e48d4db53$export$bb986e45707c6c33);
const $e669431e48d4db53$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("4nYh7", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $931417eb46388f8b$export$c61724a440d8ea1d);
const $931417eb46388f8b$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("gbBLn", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $b425285590e5a6aa$export$71a22d4a5d2891fc);

var $8QDwl = parcelRequire("8QDwl");

var $gJBT6 = parcelRequire("gJBT6");
const $b425285590e5a6aa$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $b425285590e5a6aa$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $b425285590e5a6aa$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((displayName)=>regExp.test(displayName));
};
const $b425285590e5a6aa$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $b425285590e5a6aa$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $b425285590e5a6aa$var$doesSummaryContainText(summary, lowercaseText) || $b425285590e5a6aa$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});
parcelRegister("8QDwl", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $6711d60dd8e02df4$var$escapeRegExp(string) {
    string = $jJVtR(string);
    return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
}
module.exports = $6711d60dd8e02df4$var$escapeRegExp;

});


parcelRegister("gw6jA", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $f7a5a8a45b854dff$export$fb114a888e0e17b4);

const $f7a5a8a45b854dff$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $15a528573ccd89ae$export$ac95b4b2317d4b33)));
};

});



parcelRegister("fmuR9", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $d93b8942be551a65$export$df9259146e40d32c);
$parcel$export(module.exports, "issueParentsSelector", () => $d93b8942be551a65$export$27ed9219e3872aed);
$parcel$export(module.exports, "issueParentsToListItemSelector", () => $d93b8942be551a65$export$ed2bad70f85ffb04);
$parcel$export(module.exports, "issueParentIdsSelector", () => $d93b8942be551a65$export$e69b35537968b7e1);
$parcel$export(module.exports, "partialIssueParentSelector", () => $d93b8942be551a65$export$3e87abb8e670325c);
$parcel$export(module.exports, "issueParentTypeIdsSelector", () => $d93b8942be551a65$export$80f40427dc008040);
$parcel$export(module.exports, "firstParentIssueTypeNameSelector", () => $d93b8942be551a65$export$461364b3b51e10c1);
$parcel$export(module.exports, "filteredParentsSelector", () => $d93b8942be551a65$export$a69ed0ba1bae99d6);
$parcel$export(module.exports, "issueHierarchyLevelSelector", () => $d93b8942be551a65$export$877c3c60e0259f4b);

var $dGvGJ = parcelRequire("dGvGJ");

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");

var $l9VFH = parcelRequire("l9VFH");
const $d93b8942be551a65$export$df9259146e40d32c = (state)=>(0, $e5nhF.getEntities)(state).issueParents;
const $d93b8942be551a65$export$fc955fffc3b3200c = (0, $dGvGJ.createSelector)([
    $d93b8942be551a65$export$df9259146e40d32c
], (issueParents)=>{
    const issueParentById = (parentId)=>issueParents[String(parentId)] || null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueParentById);
});
const $d93b8942be551a65$export$27ed9219e3872aed = (0, $dGvGJ.createSelector)([
    $d93b8942be551a65$export$df9259146e40d32c,
    (0, $e5nhF.getIssueParentsOrderIds)
], (issueParents, issueParentsOrderIds)=>issueParentsOrderIds.reduce((issueParentsArray, issueParentId)=>{
        const issueParent = issueParents[issueParentId];
        issueParent && issueParentsArray.push(issueParent);
        return issueParentsArray;
    }, []));
const $d93b8942be551a65$export$ed2bad70f85ffb04 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary })=>({
            id: String(id),
            name: summary
        })));
const $d93b8942be551a65$export$e69b35537968b7e1 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$df9259146e40d32c, (issueParents)=>Object.keys(issueParents));
const $d93b8942be551a65$export$3e87abb8e670325c = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary, issueType: issueType, key: key })=>({
            id: id,
            summary: summary,
            key: key,
            issueType: issueType
        })));
const $d93b8942be551a65$export$80f40427dc008040 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issueParents.map(({ issueType: issueType })=>issueType.id)));
const $d93b8942be551a65$export$461364b3b51e10c1 = (0, $dGvGJ.createSelector)($d93b8942be551a65$export$27ed9219e3872aed, (issueParents)=>issueParents ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))(issueParents), [
        'issueType',
        'name'
    ], (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME)) : (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME));
const $d93b8942be551a65$export$a69ed0ba1bae99d6 = (0, $dGvGJ.createSelector)((0, $l9VFH.getAppliedParentFilters), $d93b8942be551a65$export$df9259146e40d32c, (filteredParentIds, issueParents)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredParentIds) ? filteredParentIds?.map((filteredParentId)=>issueParents?.[filteredParentId]) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .filter(Boolean) || [] : []);
const $d93b8942be551a65$export$877c3c60e0259f4b = (0, $dGvGJ.createSelector)([], ()=>{
    const getIssueHierarchyLevel = (isEpicPanel = false)=>isEpicPanel ? (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC) : (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE);
    return getIssueHierarchyLevel;
});

});
parcelRegister("2HfxU", function(module, exports) {

module.exports = (parcelRequire("bH3EF"));

});
parcelRegister("bH3EF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $88368ba58341d518$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $88368ba58341d518$var$head;

});



parcelRegister("9ZuIF", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser", () => $944a15bb4c308ca0$export$e5432d4c8eb97ea7);
$parcel$export(module.exports, "isCurrentUserLoaded", () => $944a15bb4c308ca0$export$6b3694fe2dc20c31);

var $alNv9 = parcelRequire("alNv9");
const $944a15bb4c308ca0$export$e5432d4c8eb97ea7 = (state)=>(0, $alNv9.ensureState)(state.entities).currentUser;
const $944a15bb4c308ca0$export$6b3694fe2dc20c31 = (state)=>$944a15bb4c308ca0$export$e5432d4c8eb97ea7(state) !== null;
const $944a15bb4c308ca0$export$5ebc6cb2748e1881 = (state)=>// @ts-expect-error - TS2531 - Object is possibly 'null'.
    (0, $alNv9.ensureState)(state.entities).currentUser.id;

});

parcelRegister("fpDLy", function(module, exports) {

$parcel$export(module.exports, "getEntitiesVersions", () => $019de366069e2a30$export$6dd679056b6b958c);
$parcel$export(module.exports, "getVersionsOrder", () => $019de366069e2a30$export$5b7ad9152ad991bf);
$parcel$export(module.exports, "isVersionsFeatureEnabled", () => $019de366069e2a30$export$5f0729b6671904c3);

var $24ebX = parcelRequire("24ebX");

var $e5nhF = parcelRequire("e5nhF");
const $019de366069e2a30$var$getConfig = (state)=>state.config;
const $019de366069e2a30$export$6dd679056b6b958c = (state)=>(0, $e5nhF.getEntities)(state).versions;
const $019de366069e2a30$export$5b7ad9152ad991bf = (state)=>(0, $e5nhF.getEntities)(state).version.versions;
const $019de366069e2a30$export$5f0729b6671904c3 = (0, $24ebX.createSelector)([
    $019de366069e2a30$var$getConfig
], (config)=>config.version.isVersionsFeatureEnabled || false);

});
parcelRegister("24ebX", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $f4af8f8b2496e057$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $f4af8f8b2496e057$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $dGvGJ = parcelRequire("dGvGJ");

var $eKGsF = parcelRequire("eKGsF");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f4af8f8b2496e057$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $eKGsF.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $eKGsF.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $f4af8f8b2496e057$export$3a90d1d234e724b5 = (0, $dGvGJ.createSelectorCreator)($f4af8f8b2496e057$var$weakMapMemoize);
const $f4af8f8b2496e057$export$595d22ed68ca2841 = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize));

});
parcelRegister("eKGsF", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $a725e29cfc60dcfc$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $a725e29cfc60dcfc$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$NULL = {};
const $a725e29cfc60dcfc$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $a725e29cfc60dcfc$var$UNDEFINED;
    if (key === null) return $a725e29cfc60dcfc$var$NULL;
    return key;
};
const $a725e29cfc60dcfc$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $a725e29cfc60dcfc$var$UNDEFINED) return undefined;
    if (x === $a725e29cfc60dcfc$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a725e29cfc60dcfc$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $a725e29cfc60dcfc$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
        $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]));
        if (element) $a725e29cfc60dcfc$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $a725e29cfc60dcfc$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($a725e29cfc60dcfc$export$7abc386bcfed62e1(args[index]), result);
};
const $a725e29cfc60dcfc$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, result) : $a725e29cfc60dcfc$var$storeToWeakMapChain(args, 0, weakMap, $a725e29cfc60dcfc$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$a725e29cfc60dcfc$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});




parcelRegister("iXH87", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eb23df8fb7f3b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");


var $gOlJR = parcelRequire("gOlJR");
function $7eb23df8fb7f3b4f$export$2e2bcd8739ae039({ failedCount: failedCount, id: flagId, onRetry: onRetry, onViewSummary: onViewSummary, totalCount: totalCount, onDismissed: onDismissed, showRetryButton: showRetryButton, showViewSummaryButton: showViewSummaryButton, showSelectFailedItemsButton: showSelectFailedItemsButton, showLearnMoreButton: showLearnMoreButton, failureReason: failureReason, onSelectFailedItems: onSelectFailedItems }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const openInProductHelp = (0, $5Zxxp.useHelpPanelLink)();
    const didAllUpdatesFail = failedCount === totalCount;
    const actions = (0, $5uXOq.useMemo)(()=>{
        const flagActions = [];
        if (showSelectFailedItemsButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).selectFailedActionContent),
            onClick: onSelectFailedItems
        });
        if (showRetryButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).retryActionContent),
            onClick: onRetry
        });
        if (showViewSummaryButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).viewSummaryActionContent),
            onClick: onViewSummary
        });
        if (showLearnMoreButton) flagActions.push({
            content: formatMessage((0, $gOlJR.default).learnMoreActionContent),
            onClick: ()=>openInProductHelp?.((0, $0722405d3fdf7822$export$8f3a5e9fd2211cd2))
        });
        return flagActions;
    }, [
        showRetryButton,
        showViewSummaryButton,
        formatMessage,
        onRetry,
        onViewSummary,
        onSelectFailedItems,
        showSelectFailedItemsButton,
        openInProductHelp,
        showLearnMoreButton
    ]);
    const title = didAllUpdatesFail ? formatMessage((0, $gOlJR.default).flagTitleError) : formatMessage((0, $gOlJR.default).flagTitlePartialError, {
        failedCount: failedCount,
        totalCount: totalCount
    });
    const description = showRetryButton ? formatMessage((0, $gOlJR.default).flagDescriptionError) : formatMessage((0, $gOlJR.default).flagDescriptionErrorTryLater);
    const validationErrorDescription = formatMessage((0, $gOlJR.default).flagDescriptionValidationError);
    const networkErrorDescriptionTryLater = formatMessage((0, $gOlJR.default).flagDescriptionNetworkError);
    const descriptionMap = {
        network: showRetryButton ? description : networkErrorDescriptionTryLater,
        validation: validationErrorDescription,
        server: description,
        mixed: description
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: flagId,
        onDismissed: onDismissed,
        title: title,
        description: descriptionMap[failureReason],
        actions: actions,
        testId: "software-backlog.flags.bulk-actions.error.bulk-actions-failed-flag"
    });
}

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $78Shg = parcelRequire("78Shg");

var $29ctK = parcelRequire("29ctK");

var $jpY8v = parcelRequire("jpY8v");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const isIphEnabled = (0, $co1wz.ff)('iph.enabled') && !(0, $jpY8v.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $78Shg.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $78Shg.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $78Shg.ARTICLE_TYPE)[type]);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29ctK.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;

});

const $0722405d3fdf7822$export$8f3a5e9fd2211cd2 = '62h4g5fA9BUhungZSSNyEl';

parcelRegister("gOlJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd682ff44ff9fa0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1cd682ff44ff9fa0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retryActionContent: {
        "id": "backlog.flags.bulk-actions.error.retry-action-content",
        "defaultMessage": "Try again"
    },
    viewSummaryActionContent: {
        "id": "backlog.flags.bulk-actions.error.view-summary-action-content",
        "defaultMessage": "View summary"
    },
    selectFailedActionContent: {
        "id": "backlog.flags.bulk-actions.error.select-failed-action-content",
        "defaultMessage": "Select failed items"
    },
    learnMoreActionContent: {
        "id": "backlog.flags.bulk-actions.error.learn-more-action-content",
        "defaultMessage": "Learn more"
    },
    flagTitleError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-error",
        "defaultMessage": "Failed to update"
    },
    flagTitlePartialError: {
        "id": "backlog.flags.bulk-actions.error.flag-title-partial-error",
        "defaultMessage": "{failedCount}/{totalCount} {totalCount, plural, one {items} other {items}} not updated"
    },
    flagDescriptionError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error",
        "defaultMessage": "We were unable to update some of the items. Try again, or view the items that failed to update."
    },
    flagDescriptionErrorTryLater: {
        "id": "backlog.flags.bulk-actions.error.flag-description-error-try-later",
        "defaultMessage": "You can view the items that failed to update in a new tab, or wait a few minutes and try again."
    },
    flagDescriptionNetworkError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-network-error",
        "defaultMessage": "There might be something wrong with the connection. Wait a few minutes, then try again."
    },
    flagDescriptionValidationError: {
        "id": "backlog.flags.bulk-actions.error.flag-description-validation-error",
        "defaultMessage": "The items might not be editable, or you may require permissions. Select the failed items to try again, or view a summary of the failed items."
    }
});

});



parcelRegister("7VNNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b79d788c37b87ec$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $38qhf = parcelRequire("38qhf");

var $fSbPL = parcelRequire("fSbPL");
var $7b79d788c37b87ec$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, (dispatch)=>({
        onPrimaryActionClick: (cardId)=>{
            // @ts-expect-error - Argument of type 'string' is not assignable to parameter of type 'number'.
            dispatch((0, $38qhf.openDetailView)(cardId));
        }
    }))((0, $fSbPL.default));

});
parcelRegister("38qhf", function(module, exports) {

$parcel$export(module.exports, "OPEN_DETAIL_VIEW", () => $5b286b4f283f0f82$export$674d39029d0816cc);
$parcel$export(module.exports, "openDetailView", () => $5b286b4f283f0f82$export$d412abc3bc336eb6);
$parcel$export(module.exports, "OPEN_DETAIL_VIEW_DEBOUNCED", () => $5b286b4f283f0f82$export$372223232eefdb08);
$parcel$export(module.exports, "openDetailViewDebounced", () => $5b286b4f283f0f82$export$9147c3f14f6ec3b9);
$parcel$export(module.exports, "UPDATE_DETAIL_VIEW", () => $5b286b4f283f0f82$export$e38020a85931f37e);
$parcel$export(module.exports, "updateDetailView", () => $5b286b4f283f0f82$export$d5df566661a69c2d);
$parcel$export(module.exports, "CLOSE_DETAIL_VIEW", () => $5b286b4f283f0f82$export$c22445a1fd3a65ce);
$parcel$export(module.exports, "closeDetailView", () => $5b286b4f283f0f82$export$b996efd4b4df6740);
const $5b286b4f283f0f82$export$674d39029d0816cc = 'state.actions.detail-view.OPEN_DETAIL_VIEW';
const $5b286b4f283f0f82$export$d412abc3bc336eb6 = (cardId, externalAction)=>({
        type: $5b286b4f283f0f82$export$674d39029d0816cc,
        payload: {
            cardId: cardId,
            externalAction: externalAction
        }
    });
const $5b286b4f283f0f82$export$372223232eefdb08 = 'state.actions.detail-view.OPEN_DETAIL_VIEW_DEBOUNCED';
const $5b286b4f283f0f82$export$9147c3f14f6ec3b9 = (cardId, externalAction)=>({
        type: $5b286b4f283f0f82$export$372223232eefdb08,
        payload: {
            cardId: cardId,
            externalAction: externalAction
        }
    });
const $5b286b4f283f0f82$export$e38020a85931f37e = 'state.actions.detail-view.UPDATE_DETAIL_VIEW';
const $5b286b4f283f0f82$export$d5df566661a69c2d = ()=>({
        type: $5b286b4f283f0f82$export$e38020a85931f37e
    });
const $5b286b4f283f0f82$export$c22445a1fd3a65ce = 'state.actions.detail-view.CLOSE_DETAIL_VIEW';
const $5b286b4f283f0f82$export$b996efd4b4df6740 = (issueId)=>({
        type: $5b286b4f283f0f82$export$c22445a1fd3a65ce,
        payload: {
            issueId: issueId
        }
    });

});

parcelRegister("fSbPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $30bc80a2dc56149a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $jQ7vZ = parcelRequire("jQ7vZ");


var $boh8Y = parcelRequire("boh8Y");
const $30bc80a2dc56149a$var$CardIsFiltered = ({ onPrimaryActionClick: onPrimaryActionClick, card: card, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        ...props,
        key: card.key,
        title: formatMessage((0, $boh8Y.default).createdCardIsFilteredTitle, {
            cardKey: card.key
        }),
        description: formatMessage((0, $boh8Y.default).createdCardIsFilteredDescription),
        actions: [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $boh8Y.default).createdCardIsFilteredLinkIssueTermRefresh : (0, $boh8Y.default).createdCardIsFilteredLink),
                onClick: ()=>{
                    onPrimaryActionClick(String(card.id));
                    setIssueKey(card.key);
                }
            }
        ]
    });
};
var $30bc80a2dc56149a$export$2e2bcd8739ae039 = $30bc80a2dc56149a$var$CardIsFiltered;

});
parcelRegister("8igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b804070d792a00$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$87b804070d792a00$export$2e2bcd8739ae039 = (0, $3KRpp.WarningFlag);

});

parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $dIdda = parcelRequire("dIdda");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $dIdda.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

const $4f4a02cead13bb5a$export$e39925d10cebc0b = 'text';
const $4f4a02cead13bb5a$export$f78d8c81fcad32a2 = 'assignee';
const $4f4a02cead13bb5a$export$e729d951ab128c3b = 'label';
const $4f4a02cead13bb5a$export$3a0c4bc79274bbaa = 'selectedIssue';
const $4f4a02cead13bb5a$export$8a2cab795731dc42 = 'issueParent';
const $4f4a02cead13bb5a$export$7f765927237d6fb0 = 'issueParentPanel';
const $4f4a02cead13bb5a$export$9c304e612707f622 = 'versionPanel';
const $4f4a02cead13bb5a$export$fa7b72626a2e0090 = 'issueType';
const $4f4a02cead13bb5a$export$392308739e657b75 = 'version';
const $4f4a02cead13bb5a$export$cb08ebea4a46cd29 = 'customFilter';
const $4f4a02cead13bb5a$export$61119f100c357d06 = 'isInsightsOpen';
const $4f4a02cead13bb5a$export$ec3c43b997309252 = 'epics';
const $4f4a02cead13bb5a$export$a86c1a6dde9da34f = 'versions';

parcelRegister("boh8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b16a8d175a8dd8f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b16a8d175a8dd8f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createdCardIsFilteredTitle: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-title",
        "defaultMessage": "{cardKey} has been created."
    },
    createdCardIsFilteredDescription: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-description",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdCardIsFilteredLink: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link",
        "defaultMessage": "View issue"
    },
    createdCardIsFilteredLinkIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered.created-card-is-filtered-link-issue-term-refresh",
        "defaultMessage": "View issue"
    }
});

});



parcelRegister("dpfT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $899cbbc8a3182d22$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $38qhf = parcelRequire("38qhf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $aMEh9 = parcelRequire("aMEh9");
const $899cbbc8a3182d22$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $899cbbc8a3182d22$var$isCustomFiltersActive = (state)=>$899cbbc8a3182d22$var$getActiveCustomFilterIds(state).length > 0;
const $899cbbc8a3182d22$var$mapStateToProps = (state, { cardIds: cardIds })=>({
        cards: (0, $dGljH.partialCardsFromCardIdsSelector)(state)(cardIds),
        showCustomFiltersSettingsLink: (0, $1z1J7.canEditBoardConfig)(state) && $899cbbc8a3182d22$var$isCustomFiltersActive(state),
        customFiltersSettingsUrl: (0, $dfMzt.getCustomFiltersSettingsUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state))
    });
const $899cbbc8a3182d22$var$mapDispatchToProps = {
    onViewIssue: (0, $38qhf.openDetailView)
};
const $899cbbc8a3182d22$export$9d1611c77c2fe928 = (stateProps, dispatchProps, { id: id, onDismissed: onDismissed })=>({
        id: id,
        onDismissed: onDismissed,
        ...stateProps,
        ...dispatchProps
    });
var $899cbbc8a3182d22$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($899cbbc8a3182d22$var$mapStateToProps, $899cbbc8a3182d22$var$mapDispatchToProps, $899cbbc8a3182d22$export$9d1611c77c2fe928)((0, $aMEh9.default));

});
parcelRegister("dfMzt", function(module, exports) {

$parcel$export(module.exports, "getColumnStatusMappingUrl", () => $f6db5d87cddd7a75$export$5eee224adec4e661);
$parcel$export(module.exports, "getCustomFiltersSettingsUrl", () => $f6db5d87cddd7a75$export$15f763506e87c58e);
$parcel$export(module.exports, "getCustomFilterFromUrlQuery", () => $f6db5d87cddd7a75$export$7076eae01bf61f73);

var $ebyGx = parcelRequire("ebyGx");

var $f01qr = parcelRequire("f01qr");
const $f6db5d87cddd7a75$export$5eee224adec4e661 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;
const $f6db5d87cddd7a75$export$15f763506e87c58e = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
const $f6db5d87cddd7a75$export$7076eae01bf61f73 = ({ search: search })=>{
    const queryParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    if (queryParameters?.customFilter) return (0, $f01qr.toArray)(queryParameters.customFilter);
    if (queryParameters.quickFilter) return (0, $f01qr.toArray)(queryParameters.quickFilter);
    return undefined;
};

});

parcelRegister("1z1J7", function(module, exports) {

$parcel$export(module.exports, "getPermissions", () => $3cd8560dd862a6b3$export$e10fd44ca431fa8e);
$parcel$export(module.exports, "canViewBoard", () => $3cd8560dd862a6b3$export$86298d668b506539);
$parcel$export(module.exports, "canEditBoardConfig", () => $3cd8560dd862a6b3$export$6dd65380225d5199);
$parcel$export(module.exports, "canManageSprints", () => $3cd8560dd862a6b3$export$8830b0b3ee0a6ade);
$parcel$export(module.exports, "canCreateIssues", () => $3cd8560dd862a6b3$export$38d976fa7e28ee53);
$parcel$export(module.exports, "canEditIssue", () => $3cd8560dd862a6b3$export$3f2995080649d07c);
$parcel$export(module.exports, "canDeleteIssues", () => $3cd8560dd862a6b3$export$f9d3b77685359020);
$parcel$export(module.exports, "canAssignIssues", () => $3cd8560dd862a6b3$export$5df0ca7091398ef7);
$parcel$export(module.exports, "canTransitionIssues", () => $3cd8560dd862a6b3$export$e03f24612ae6fce6);
$parcel$export(module.exports, "canBulkEditIssues", () => $3cd8560dd862a6b3$export$793ca6e17cc6edb8);

const $3cd8560dd862a6b3$export$e10fd44ca431fa8e = (state)=>state.config.permissions;
const $3cd8560dd862a6b3$export$86298d668b506539 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$feb9a4de117c162] || false;
const $3cd8560dd862a6b3$export$6dd65380225d5199 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$b35e3ebf2c83a499] || false;
const $3cd8560dd862a6b3$export$8830b0b3ee0a6ade = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$d765836bd761b2ee] || false;
const $3cd8560dd862a6b3$export$38d976fa7e28ee53 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$526c94c551c00291] || false;
const $3cd8560dd862a6b3$export$3f2995080649d07c = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$8a1ecb9983951227] || false;
const $3cd8560dd862a6b3$export$f9d3b77685359020 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$a20ec683078f5f77] || false;
const $3cd8560dd862a6b3$export$5df0ca7091398ef7 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$9c0523cef5fab15e] || false;
const $3cd8560dd862a6b3$export$e03f24612ae6fce6 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$b5f3bd28b6a935be] || false;
const $3cd8560dd862a6b3$export$793ca6e17cc6edb8 = (state)=>$3cd8560dd862a6b3$export$e10fd44ca431fa8e(state)[0, $a33d0dff7e784665$export$a71edb30f3453bef] || false;

});
const $a33d0dff7e784665$export$feb9a4de117c162 = 'CAN_VIEW_BOARD';
const $a33d0dff7e784665$export$a71edb30f3453bef = 'CAN_BULK_CHANGE_ISSUES';
const $a33d0dff7e784665$export$b35e3ebf2c83a499 = 'CAN_EDIT_BOARD_CONFIG';
const $a33d0dff7e784665$export$d765836bd761b2ee = 'CAN_MANAGE_SPRINTS';
const $a33d0dff7e784665$export$526c94c551c00291 = 'CAN_CREATE_ISSUES';
const $a33d0dff7e784665$export$8a1ecb9983951227 = 'CAN_EDIT_ISSUES';
const $a33d0dff7e784665$export$a20ec683078f5f77 = 'CAN_DELETE_ISSUES';
const $a33d0dff7e784665$export$9c0523cef5fab15e = 'CAN_ASSIGN_ISSUES';
const $a33d0dff7e784665$export$b5f3bd28b6a935be = 'CAN_TRANSITION_ISSUES';
const $a33d0dff7e784665$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';


parcelRegister("aMEh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b18d4a8086f34f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $jQ7vZ = parcelRequire("jQ7vZ");


var $1RaZ1 = parcelRequire("1RaZ1");
const $8b18d4a8086f34f0$var$linkStart = '{linkStart}';
const $8b18d4a8086f34f0$var$linkEnd = '{linkEnd}';
const $8b18d4a8086f34f0$var$getIssueLink = (key)=>`/browse/${key}`;
const $8b18d4a8086f34f0$var$CardCreateFiltered = ({ cards: cards, id: id, onDismissed: onDismissed, onViewIssue: onViewIssue, customFiltersSettingsUrl: customFiltersSettingsUrl, showCustomFiltersSettingsLink: showCustomFiltersSettingsLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    const onActionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const onClickSingleCard = (0, $5uXOq.useCallback)((e)=>{
        if (cards.length === 1) {
            e.preventDefault();
            onViewIssue(cards[0].id);
            setIssueKey(cards[0].key);
        }
    }, [
        cards,
        onViewIssue,
        setIssueKey
    ]);
    const actions = [
        ...showCustomFiltersSettingsLink ? [
            {
                content: formatMessage((0, $1RaZ1.default).settingsLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: onActionClick
            }
        ] : []
    ];
    const isSingle = cards.length === 1;
    if (isSingle) {
        const card = cards[0];
        const issueLinkComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: $8b18d4a8086f34f0$var$getIssueLink(card.key),
                onClick: onClickSingleCard
            }, card.key);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
            id: id,
            onDismissed: onDismissed,
            title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).issueHiddenTitleIssueTermRefresh : (0, $1RaZ1.default).issueHiddenTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
                message: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).issueHiddenDescriptionIssueTermRefresh : (0, $1RaZ1.default).issueHiddenDescription, {
                    linkStart: $8b18d4a8086f34f0$var$linkStart,
                    linkEnd: $8b18d4a8086f34f0$var$linkEnd
                }),
                componentsMapping: {
                    link: issueLinkComponent
                }
            }),
            actions: [
                {
                    content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).issueLinkIssueTermRefresh : (0, $1RaZ1.default).issueLink),
                    onClick: onClickSingleCard,
                    href: $8b18d4a8086f34f0$var$getIssueLink(card.key)
                },
                ...actions
            ]
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).multipleIssuesHiddenTitleIssueTermRefresh : (0, $1RaZ1.default).multipleIssuesHiddenTitle),
        description: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1RaZ1.default).multipleIssuesHiddenDescriptionIssueTermRefresh : (0, $1RaZ1.default).multipleIssuesHiddenDescription),
        actions: actions
    });
};
var $8b18d4a8086f34f0$export$2e2bcd8739ae039 = $8b18d4a8086f34f0$var$CardCreateFiltered;

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $dJl1T.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("14uhY", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $5f614763a26e8877$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $5f614763a26e8877$export$575dc7c4a154874b);

var $eNf8a = parcelRequire("eNf8a");
const $5f614763a26e8877$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $5f614763a26e8877$var$sessionStorage = (0, $eNf8a.createSessionExpirableStorageProvider)('navigation');
const $5f614763a26e8877$export$127f7bd1c092fc8f = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $5f614763a26e8877$var$sessionStorage.set($5f614763a26e8877$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $5f614763a26e8877$export$575dc7c4a154874b = ()=>String($5f614763a26e8877$var$sessionStorage.get($5f614763a26e8877$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("1RaZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b7029a91dab57d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e4b7029a91dab57d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title",
        "defaultMessage": "Changes are saved, but the issue isn\u2019t visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLink: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link",
        "defaultMessage": "View issue"
    },
    multipleIssuesHiddenTitle: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title",
        "defaultMessage": "Changes are saved, but issues aren't visible"
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description",
        "defaultMessage": "Created issues are currently hidden by a filter."
    },
    settingsLink: {
        "id": "backlog.flags.card-create-filtered-v2.settings-link",
        "defaultMessage": "Manage custom filters"
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but the issue isn\u2019t visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Issue {linkStart}{linkEnd} is currently hidden by a filter."
    },
    issueLinkIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.issue-link-issue-term-refresh",
        "defaultMessage": "View issue"
    },
    multipleIssuesHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but issues aren't visible"
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-filtered-v2.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "Created issues are currently hidden by a filter."
    }
});

});



parcelRegister("9KRJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6019ad4abeab9d16$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $6wkXY = parcelRequire("6wkXY");
const $6019ad4abeab9d16$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $dfMzt.getColumnStatusMappingUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $1z1J7.canEditBoardConfig)(state)
    });
var $6019ad4abeab9d16$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6019ad4abeab9d16$var$mapStateToProps, {})((0, $6wkXY.CardCreateUnmappedFlag));

});
parcelRegister("6wkXY", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $69a5bf3ca297f4c6$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $5qfKt = parcelRequire("5qfKt");
const $69a5bf3ca297f4c6$export$41f7bf5526b10063 = ({ onDismissed: onDismissed, id: id, numIssues: numIssues, boardConfigUrl: boardConfigUrl, isConfigureBoardEnabled: isConfigureBoardEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getActions = isConfigureBoardEnabled ? [
        {
            content: formatMessage((0, $5qfKt.default).assignStatuses),
            href: boardConfigUrl
        }
    ] : [];
    const getDescription = (0, $5uXOq.useCallback)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return numIssues > 1 ? formatMessage((0, $5qfKt.default).multipleIssuesHiddenDescriptionIssueTermRefresh, {
            numIssues: numIssues
        }) : formatMessage((0, $5qfKt.default).issueHiddenDescriptionIssueTermRefresh);
        return numIssues > 1 ? formatMessage((0, $5qfKt.default).multipleIssuesHiddenDescription, {
            numIssues: numIssues
        }) : formatMessage((0, $5qfKt.default).issueHiddenDescription);
    }, [
        formatMessage,
        numIssues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5qfKt.default).issueHiddenTitleIssueTermRefresh : (0, $5qfKt.default).issueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getDescription(),
        actions: getActions
    });
};

});
parcelRegister("5qfKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31345c7df07b908$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d31345c7df07b908$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "The issue is assigned to a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "backlog.flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues} issues have been created, but one or more have a status that\u2019s not visible on the board and backlog."
    },
    assignStatuses: {
        "id": "backlog.flags.card-create-unmapped.assign-statuses",
        "defaultMessage": "Assign statuses"
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "The issue is assigned to a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "backlog.flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues} issues have been created, but one or more have a status that\u2019s not visible on the board and backlog."
    }
});

});



parcelRegister("2A04N", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28c6c7b53310f29$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $esJnl = parcelRequire("esJnl");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");
const $f28c6c7b53310f29$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $dfMzt.getColumnStatusMappingUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state)),
        isConfigureBoardEnabled: (0, $1z1J7.canEditBoardConfig)(state)
    });
var $f28c6c7b53310f29$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($f28c6c7b53310f29$var$mapStateToProps, {})((0, $esJnl.CardCreateUnmappedFlag));

});
parcelRegister("esJnl", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $39f5c9a19aa037a2$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $24y3R = parcelRequire("24y3R");

var $pvsdI = parcelRequire("pvsdI");
const $39f5c9a19aa037a2$export$41f7bf5526b10063 = ({ cardKeys: cardKeys, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const numIssues = cardKeys.length;
    const getFlagDescription = ()=>formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenDescriptionIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenDescription);
    const getActions = ()=>{
        const actions = [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).issueLinkIssueTermRefresh : (0, $pvsdI.default).issueLink, {
                    numIssues: numIssues
                }),
                href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
                target: '_blank'
            }
        ];
        return actions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
};

});
parcelRegister("pvsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834fa35b5b67285$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3834fa35b5b67285$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLink: {
        "id": "software-flags.card-create-unmapped.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-link-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description-issue-term-refresh",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    }
});

});



parcelRegister("aLVM6", function(module, exports) {

$parcel$export(module.exports, "CardDragDisallowedFlag", () => $db84e05fef80cb1a$export$7df6cad02c3a09f1);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $kULld = parcelRequire("kULld");
function $db84e05fef80cb1a$export$7df6cad02c3a09f1({ id: id, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $kULld.default).removeSubtaskTitle),
        description: formatMessage((0, $kULld.default).removeSubtaskDescription)
    });
}

});
parcelRegister("kULld", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92e7dc823f52d13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f92e7dc823f52d13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeSubtaskTitle: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-title",
        "defaultMessage": "Subtasks can't be moved from their parent on the backlog"
    },
    removeSubtaskDescription: {
        "id": "backlog.flags.card-drag-disallowed.remove-subtask-description",
        "defaultMessage": "Select a subtask to view and edit its details"
    }
});

});


parcelRegister("i9g1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8422601ec4afa025$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $lTqEw = parcelRequire("lTqEw");
const $8422601ec4afa025$export$321f8e7a5f776e25 = ({ id: id, boardId: boardId, isAdmin: isAdmin, onDismissed: onDismissed })=>{
    const getEditFilterUrl = `/secure/RapidBoard.jspa?rapidView=${boardId}&config=filter`;
    const learnMoreUrl = 'https://support.atlassian.com/jira-software-cloud/docs/enable-ranking/';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getContent = ()=>{
        if (isAdmin) return {
            description: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).descriptionIssueTermRefresh : (0, $lTqEw.default).description),
            actions: [
                {
                    content: formatMessage((0, $lTqEw.default).showJqlFilterForBoard),
                    href: getEditFilterUrl
                },
                {
                    content: formatMessage((0, $lTqEw.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
        return {
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).descriptionIssueTermRefresh : (0, $lTqEw.default).description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $lTqEw.default).contactAdmin)),
            actions: [
                {
                    content: formatMessage((0, $lTqEw.default).learnMore),
                    href: learnMoreUrl
                }
            ]
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        // @ts-expect-error isAutoDismiss prop looks to be unused but should be tested before removing
        isAutoDismiss: true,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lTqEw.default).titleIssueTermRefresh : (0, $lTqEw.default).title),
        ...getContent()
    });
};
var $8422601ec4afa025$export$2e2bcd8739ae039 = $8422601ec4afa025$export$321f8e7a5f776e25;

});
parcelRegister("lTqEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd0c94f07a9fb44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dd0c94f07a9fb44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.flags.card-move-disabled.title",
        "defaultMessage": "Issues can\u2019t be manually ranked"
    },
    description: {
        "id": "backlog.flags.card-move-disabled.description",
        "defaultMessage": "The board\u2019s filter query isn\u2019t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank."
    },
    contactAdmin: {
        "id": "backlog.flags.card-move-disabled.contact-admin",
        "defaultMessage": "Contact your admin to adjust the board filter."
    },
    showJqlFilterForBoard: {
        "id": "backlog.flags.card-move-disabled.show-jql-filter-for-board",
        "defaultMessage": "Manage board filter"
    },
    learnMore: {
        "id": "backlog.flags.card-move-disabled.learn-more",
        "defaultMessage": "Learn more"
    },
    titleIssueTermRefresh: {
        "id": "backlog.flags.card-move-disabled.title-issue-term-refresh",
        "defaultMessage": "Issues can\u2019t be manually ranked"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.flags.card-move-disabled.description-issue-term-refresh",
        "defaultMessage": "The board\u2019s filter query isn\u2019t sorted by rank. To rank issues manually on your board and backlog, sort issues by ascending rank."
    }
});

});


parcelRegister("kzCvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8edc96250ceb721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $qgGvU = parcelRequire("qgGvU");
const $c8edc96250ceb721$var$ClearCustomFilterFailed = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $qgGvU.default).endUserTitle),
        description: formatMessage((0, $qgGvU.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $qgGvU.default).endUserActionLink),
                onClick: onClick
            }
        ]
    });
};
var $c8edc96250ceb721$export$2e2bcd8739ae039 = $c8edc96250ceb721$var$ClearCustomFilterFailed;

});
parcelRegister("qgGvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $783edd5a65af9cf5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $783edd5a65af9cf5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    endUserTitle: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't clear your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-description",
        "defaultMessage": "Refresh the page and try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.clear-custom-filter-failed.end-user-action-link",
        "defaultMessage": "Reload page"
    }
});

});


parcelRegister("dS41P", function(module, exports) {

$parcel$export(module.exports, "default", () => $467edcaf2bf4621a$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dfMzt = parcelRequire("dfMzt");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $4DYFQ = parcelRequire("4DYFQ");
const $467edcaf2bf4621a$var$mapStateToProps = (state)=>({
        canAccessCustomFilterSettings: (0, $1z1J7.canEditBoardConfig)(state),
        customFiltersSettingsUrl: (0, $dfMzt.getCustomFiltersSettingsUrl)((0, $jG5HW.getProjectKey)(state), (0, $jG5HW.getRapidViewId)(state))
    });
var $467edcaf2bf4621a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($467edcaf2bf4621a$var$mapStateToProps, {})((0, $4DYFQ.default));

});
parcelRegister("4DYFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42591bef76b3fd7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");

var $gwk8F = parcelRequire("gwk8F");
const $a42591bef76b3fd7$var$CustomFilterFailed = ({ id: id, customFiltersSettingsUrl: customFiltersSettingsUrl, canAccessCustomFilterSettings: canAccessCustomFilterSettings, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dismissFlag = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customFilterFailedFlagLink', {
            canAccessCustomFilterSettings: canAccessCustomFilterSettings
        });
        onDismissed(id);
    }, [
        canAccessCustomFilterSettings,
        id,
        onDismissed
    ]);
    return canAccessCustomFilterSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $gwk8F.default).adminUserTitle),
        description: formatMessage((0, $gwk8F.default).adminUserDescription),
        actions: [
            {
                content: formatMessage((0, $gwk8F.default).adminUserActionLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: dismissFlag
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $gwk8F.default).endUserTitle),
        description: formatMessage((0, $gwk8F.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $gwk8F.default).endUserActionLink),
                onClick: dismissFlag
            }
        ]
    });
};
var $a42591bef76b3fd7$export$2e2bcd8739ae039 = $a42591bef76b3fd7$var$CustomFilterFailed;

});
parcelRegister("gwk8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cedcb9101baaa70$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5cedcb9101baaa70$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminUserTitle: {
        "id": "backlog.flags.custom-filter-failed.admin-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    adminUserDescription: {
        "id": "backlog.flags.custom-filter-failed.admin-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. You can check your filter queries and try again."
    },
    adminUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.admin-user-action-link",
        "defaultMessage": "Manage custom filters"
    },
    endUserTitle: {
        "id": "backlog.flags.custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    endUserDescription: {
        "id": "backlog.flags.custom-filter-failed.end-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. Contact your Jira admin to check the filter queries, then try again."
    },
    endUserActionLink: {
        "id": "backlog.flags.custom-filter-failed.end-user-action-link",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("cen46", function(module, exports) {

$parcel$export(module.exports, "SplitIssueSuccessFlag", () => $bd0e2adb84ca6fae$export$75ae40d8ea21392a);

var $47bDC = parcelRequire("47bDC");

var $5uXOq = parcelRequire("5uXOq");


var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $cnvr3 = parcelRequire("cnvr3");
// eslint-disable-next-line @compiled/no-css-prop-without-css-function, @atlaskit/design-system/consistent-css-prop-usage
const $bd0e2adb84ca6fae$var$copiedSuccessStyles = {
    color: `var(--ds-background-success-pressed, ${(0, $5e0c0d4e15efb4a6$export$940e1f69e873f202)})`
};
const $bd0e2adb84ca6fae$var$getIssueDiscoveryUrl = (issueKeys)=>{
    if (issueKeys.length > 1) {
        const cardKeys = issueKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${cardKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${issueKeys[0]}`;
};
var $bd0e2adb84ca6fae$var$_StyledSpan = /*#__PURE__*/ (0, $47bDC.default)("span").withConfig({
    componentId: "jhvvvj-0"
})`${$bd0e2adb84ca6fae$var$copiedSuccessStyles}`;
const $bd0e2adb84ca6fae$export$75ae40d8ea21392a = ({ originalIssueKey: originalIssueKey, issueKeys: issueKeys, onDismissed: onDismissed, id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = $bd0e2adb84ca6fae$var$getIssueDiscoveryUrl(issueKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const getFlagTitle = (0, $5uXOq.useCallback)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh, {
            issueCount: issueKeys.length
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagTitleIssueTermRefresh, {
            issueKey: issueKeys[0]
        });
        return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueKeys.length
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagTitle, {
            issueKey: issueKeys[0]
        });
    }, [
        formatMessage,
        issueKeys
    ]);
    const getFlagDescription = (0, $5uXOq.useCallback)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multipleIssuesCreatedSuccessFlagDescriptionIssueTermRefresh, {
            issueKey: originalIssueKey
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagDescriptionIssueTermRefresh, {
            issueKey: originalIssueKey
        });
        return issueKeys.length > 1 ? formatMessage((0, $cnvr3.default).multipleIssuesCreatedSuccessFlagDescription, {
            issueKey: originalIssueKey
        }) : formatMessage((0, $cnvr3.default).createSuccessFlagDescription, {
            issueKey: originalIssueKey
        });
    }, [
        formatMessage,
        issueKeys,
        originalIssueKey
    ]);
    const flagActions = [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cnvr3.default).viewIssueLinkTextIssueTermRefresh : (0, $cnvr3.default).viewIssueLinkText, {
                numIssues: issueKeys.length
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd0e2adb84ca6fae$var$_StyledSpan, null, formatMessage((0, $cnvr3.default).linkCopied)) : formatMessage((0, $cnvr3.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        description: getFlagDescription(),
        actions: flagActions
    });
};

});
parcelRegister("cnvr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5990d8181de93287$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5990d8181de93287$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created issue \"{issueKey}\""
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "backlog.flags.split-issue-success.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# new issues}}"
    },
    createSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description",
        "defaultMessage": "It's linked to issue \"{issueKey}\"."
    },
    createSuccessFlagDescriptionIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.create-success-flag-description-issue-term-refresh",
        "defaultMessage": "It's linked to issue \"{issueKey}\"."
    },
    multipleIssuesCreatedSuccessFlagDescription: {
        "id": "backlog.flags.split-issue-success.multiple-issues-created-success-flag-description",
        "defaultMessage": "They're linked to issue \"{issueKey}\"."
    },
    multipleIssuesCreatedSuccessFlagDescriptionIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.multiple-issues-created-success-flag-description-issue-term-refresh",
        "defaultMessage": "They're linked to issue \"{issueKey}\"."
    },
    viewIssueLinkText: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    copyLink: {
        "id": "backlog.flags.split-issue-success.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "backlog.flags.split-issue-success.link-copied",
        "defaultMessage": "Copied"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# new issues}}"
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "backlog.flags.split-issue-success.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("t6MXq", function(module, exports) {

$parcel$export(module.exports, "showSprintStartedFlag", () => $63e4a485d7c77bf2$export$16e805c83a7e91ec);

var $kQyxB = parcelRequire("kQyxB");
const $63e4a485d7c77bf2$export$16e805c83a7e91ec = ()=>({
        type: 'success',
        title: (0, $kQyxB.default).sprintStartedTitle,
        description: (0, $kQyxB.default).sprintStartedParallelSprintDescription
    });

});
parcelRegister("kQyxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2783654e55be6c1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2783654e55be6c1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintStartedTitle: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-title",
        "defaultMessage": "Sprint started"
    },
    sprintStartedDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-description",
        "defaultMessage": "We\u2019ve taken you to your team\u2019s sprint board. Good luck team!"
    },
    sprintStartedParallelSprintDescription: {
        "id": "backlog.flags.sprint-started-flag.sprint-started-parallel-sprint-description",
        "defaultMessage": "We\u2019ve filtered the board to show your new sprint. Good luck, team!"
    }
});

});


parcelRegister("jRU2X", function(module, exports) {

$parcel$export(module.exports, "TransitionAndRankFailureFlag", () => $b99c3e12f982237a$export$ecea190680b7bcc);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $8GzsK = parcelRequire("8GzsK");
function $b99c3e12f982237a$export$ecea190680b7bcc({ id: id, errorMessages: errorMessages, onDismissed: onDismissed }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        title: formatMessage((0, $8GzsK.default).title),
        onDismissed: onDismissed,
        description: errorMessages.join('. ')
    });
}

});
parcelRegister("8GzsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9567e8de9a41b1b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a9567e8de9a41b1b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.flags.transition-and-rank-failure.title",
        "defaultMessage": "We couldn't move your card"
    }
});

});



parcelRegister("cinXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f4292cbc22f5db0$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $4R6GH = parcelRequire("4R6GH");

var $63Y57 = parcelRequire("63Y57");

var $f6RVN = parcelRequire("f6RVN");

var $e2PDn = parcelRequire("e2PDn");

var $eBTGr = parcelRequire("eBTGr");

var $4IyFO = parcelRequire("4IyFO");

var $hnaxO = parcelRequire("hnaxO");

var $gqn54 = parcelRequire("gqn54");

var $eKj5K = parcelRequire("eKj5K");

var $lTfMj = parcelRequire("lTfMj");

var $kOw1j = parcelRequire("kOw1j");

var $5o0zk = parcelRequire("5o0zk");

var $ntGXV = parcelRequire("ntGXV");

var $3EYDb = parcelRequire("3EYDb");

var $hHUaf = parcelRequire("hHUaf");

var $jQmfK = parcelRequire("jQmfK");

var $eVhWm = parcelRequire("eVhWm");

var $028Rt = parcelRequire("028Rt");

var $jv1aX = parcelRequire("jv1aX");

var $iKvYD = parcelRequire("iKvYD");

var $1pwBu = parcelRequire("1pwBu");

var $aXaCi = parcelRequire("aXaCi");

var $7w8zv = parcelRequire("7w8zv");

var $f4vxM = parcelRequire("f4vxM");

var $f5yE6 = parcelRequire("f5yE6");

var $hCa2B = parcelRequire("hCa2B");

var $h1Jne = parcelRequire("h1Jne");

var $7u8UG = parcelRequire("7u8UG");

var $3xTTB = parcelRequire("3xTTB");

var $dfRpl = parcelRequire("dfRpl");

var $cnhvw = parcelRequire("cnhvw");

var $BJrNt = parcelRequire("BJrNt");

var $jQJPl = parcelRequire("jQJPl");

var $5z625 = parcelRequire("5z625");

var $vO8Pq = parcelRequire("vO8Pq");

var $41ack = parcelRequire("41ack");

var $9Vyzy = parcelRequire("9Vyzy");

var $1fqjN = parcelRequire("1fqjN");

var $hcyWF = parcelRequire("hcyWF");

var $cZpfH = parcelRequire("cZpfH");

var $3l3iU = parcelRequire("3l3iU");

var $13hY5 = parcelRequire("13hY5");

var $jRnbG = parcelRequire("jRnbG");

var $1JXN4 = parcelRequire("1JXN4");

var $8Z17A = parcelRequire("8Z17A");

var $2sQbO = parcelRequire("2sQbO");

var $gnmD3 = parcelRequire("gnmD3");

var $h34Bb = parcelRequire("h34Bb");

var $83JtA = parcelRequire("83JtA");

var $dZEjB = parcelRequire("dZEjB");

var $6BlmG = parcelRequire("6BlmG");

var $7ixW2 = parcelRequire("7ixW2");

var $51zzD = parcelRequire("51zzD");

var $9kHz3 = parcelRequire("9kHz3");
const $9f4292cbc22f5db0$var$createRootEpic = (isServer, isCompanyManaged, getLocation, push, replace, // eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient)=>{
    const withGraphQLEpicsKillSwitch = (0, $63Y57.withKillSwitch)(!(0, $4R6GH.fg)('jsw_cmp_backlog_remove_epics_request'));
    const withUifCmpKillSwitch = (0, $63Y57.withKillSwitch)(isCompanyManaged);
    const withAddPeopleButtonOpenTMPExperimentKillSwitch = (0, $63Y57.withKillSwitch)((0, $f6RVN.isInAddPeopleButtonOpenTMPExperimentCohort)());
    const clientEpics = isServer ? [] : [
        (0, $jQJPl.issueViewUpdateEpic),
        (0, $8Z17A.postLoadCleanDataEpic),
        (0, $83JtA.sprintCreateEpic),
        (0, $dZEjB.sprintDeleteEpic),
        (0, $6BlmG.sprintMoveEpic),
        (0, $BJrNt.filteredCardsEpic),
        (0, $1pwBu.beforeMoveCardsEpic),
        (0, $aXaCi.cardsMoveRequestEpic),
        (0, $eKj5K.cardClickEpic)(getLocation, push),
        (0, $1JXN4.selectIssueParentEpic)(getLocation, push),
        (0, $iKvYD.cardsFlagWithCommentEpic),
        (0, $f4vxM.default),
        (0, $kOw1j.cardDeleteEpic)(getLocation, push),
        (0, $jQmfK.cardRefreshEpic),
        (0, $ntGXV.cardListToggleEpic),
        (0, $3EYDb.cardPostCreateEpic),
        (0, $7w8zv.cardsNavigateEpic),
        (0, $hCa2B.detailViewCloseEpic)(getLocation, push),
        (0, $7u8UG.detailViewUpdateEpic),
        (0, $h1Jne.detailViewOpenDebouncedEpic)(getLocation, push),
        (0, $cnhvw.filterValidValuesEpic)(getLocation, push),
        (0, $h34Bb.default)(getLocation, push, isCompanyManaged),
        // This still needs to be loaded because the critical query is not loaded in CMP
        // which holds the other user data.
        (0, $1fqjN.loadCurrentUserEpic),
        (0, $63Y57.withSwitch)(isCompanyManaged)((0, $9Vyzy.loadConfigDataEpicCmp), (0, $41ack.loadConfigDataEpic)),
        ...withUifCmpKillSwitch([
            (0, $cZpfH.loadPermissionsEpic),
            ...withGraphQLEpicsKillSwitch([
                (0, $hcyWF.loadIssueParentsEpic)
            ]),
            (0, $vO8Pq.loadCardCreateConfigEpic),
            (0, $3xTTB.refetchEpicPanelEpic),
            (0, $5o0zk.cardGroupToggleEpic),
            (0, $hHUaf.cardRankAfterGlobalIssueCreateEpic),
            (0, $9kHz3.workloadModalSubtaskToggleEpic)
        ]),
        (0, $e2PDn.default),
        (0, $gnmD3.refreshDataEpic),
        (0, $dfRpl.default),
        (0, $hnaxO.buildAssignToMeEpic)(swagClient),
        (0, $51zzD.refreshBacklog)(),
        (0, $hnaxO.cardAssignToMeThrottledEpic),
        (0, $028Rt.default),
        (0, $eVhWm.default),
        (0, $f5yE6.checkGlobalIssueCreateEpic),
        (0, $lTfMj.cardCreateMultipleGqlEpic),
        (0, $jRnbG.onTogglePanelEpic)(getLocation, replace),
        (0, $jRnbG.onCloseInsightsEpic)(getLocation, replace),
        ...(0, $63Y57.withKillSwitch)(!isCompanyManaged)([
            (0, $cZpfH.loadPermissionsEpic)
        ]),
        (0, $13hY5.loadPrioritiesEpic),
        (0, $eBTGr.default),
        (0, $2sQbO.refetchVersionsEpic),
        (0, $jv1aX.cardsBulkOperationsFailureEpic),
        ...(0, $63Y57.withKillSwitch)(isCompanyManaged)([
            (0, $jv1aX.cardsBulkOperationsSuccessEpicCmp)
        ]),
        (0, $gqn54.cardAutoScrollOnFilterEpic),
        ...withAddPeopleButtonOpenTMPExperimentKillSwitch([
            (0, $4IyFO.getCanUserInviteEpic)
        ]),
        ...(0, $63Y57.withKillSwitch)(()=>(0, $4R6GH.fg)('sprint_planning_whiteboards_kill_switch'))([
            (0, $7ixW2.loadWhiteboardsEntrypointExperimentEpic)
        ])
    ];
    const loadEpic = (0, $63Y57.withSwitch)(isCompanyManaged)((0, $3l3iU.loadPlanDataEpic), (0, $5z625.loadAgilityGraphqlDataEpic));
    return (0, $e1AU2.combineEpics)(loadEpic, ...clientEpics);
};
var $9f4292cbc22f5db0$export$2e2bcd8739ae039 = $9f4292cbc22f5db0$var$createRootEpic;

});
parcelRegister("63Y57", function(module, exports) {

$parcel$export(module.exports, "withSwitch", () => $5e9a3144cc583fc1$export$645938e27cb11e4e);
$parcel$export(module.exports, "withKillSwitch", () => $5e9a3144cc583fc1$export$2a43929f73f32330);
$parcel$export(module.exports, "fromRelayObservable", () => $5e9a3144cc583fc1$export$b57c7b401625b0df);
parcelRequire("1oQta");

var $kVLXA = parcelRequire("kVLXA");
function $5e9a3144cc583fc1$var$executePredicate(predicate) {
    if (predicate !== null && typeof predicate === 'function') return predicate();
    if (predicate !== null && typeof predicate === 'boolean') return predicate;
    return false;
}
const $5e9a3144cc583fc1$export$645938e27cb11e4e = (...predicates)=>(matchedPredicateEpic, unmatchedPredicateEpic)=>(action$, store, dependencies)=>predicates.every($5e9a3144cc583fc1$var$executePredicate) ? matchedPredicateEpic(action$, store, dependencies) : unmatchedPredicateEpic(action$, store, dependencies);
const $5e9a3144cc583fc1$export$2a43929f73f32330 = (...predicates)=>(epics)=>epics.map((epic)=>(action$, store, dependencies)=>epic(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                action$.filter(()=>predicates.every($5e9a3144cc583fc1$var$executePredicate)), store, dependencies));
const $5e9a3144cc583fc1$export$b57c7b401625b0df = (create)=>(0, $kVLXA.Observable).create((sink)=>{
        const subscription = create().subscribe(sink);
        return ()=>subscription.unsubscribe();
    });

});

parcelRegister("e2PDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3f412b9ece8b4c$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $l6pDE = parcelRequire("l6pDE");

var $3b59T = parcelRequire("3b59T");
var // @ts-expect-error - TS2769: Type 'void' is not assignable to type 'BoardIssueMoveShowAction'.
$6c3f412b9ece8b4c$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $l6pDE.default), (0, $3b59T.default));

});
parcelRegister("l6pDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad09ca4581dbd798$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("7mHDu");
parcelRequire("6cbqE");

var $jIyVb = parcelRequire("jIyVb");

var $3lZ6i = parcelRequire("3lZ6i");

var $3qXBy = parcelRequire("3qXBy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad09ca4581dbd798$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA)).take(1).switchMap(()=>(0, $jIyVb.shouldDisplayDialog)(store.getState()).flatMap((shouldDisplay)=>shouldDisplay ? (0, $kVLXA.Observable).of((0, $3qXBy.boardIssueMoveShow)()) : (0, $kVLXA.Observable).empty()));

});
parcelRegister("jIyVb", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayDialog", () => $c542be53d12c746b$export$fd02a046fd38bde);
$parcel$export(module.exports, "dismissDialog", () => $c542be53d12c746b$export$581c7e9b587e8156);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("hZWgu");

var $8AOG8 = parcelRequire("8AOG8");

var $jG5HW = parcelRequire("jG5HW");

var $7b0Pa = parcelRequire("7b0Pa");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");
const $c542be53d12c746b$var$shouldCheckForDialog = (state)=>{
    const canEdit = (0, $1z1J7.canEditBoardConfig)(state);
    const isAlreadyOpen = (0, $7b0Pa.isDialogOpen)(state);
    const isSprintsEnabled = (0, $k35me.isBacklogWithSprints)(state);
    return canEdit && !isAlreadyOpen && !isSprintsEnabled;
};
const $c542be53d12c746b$export$fd02a046fd38bde = (state)=>{
    if ($c542be53d12c746b$var$shouldCheckForDialog(state)) return (0, $kVLXA.Observable).of((0, $jG5HW.getRequestColumnMigration)(state));
    return (0, $kVLXA.Observable).of(false);
};
const $c542be53d12c746b$export$581c7e9b587e8156 = (state)=>{
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    return (0, $8AOG8.dismissMigrationModal)(baseUrl, rapidViewId).ignoreElements();
};

});
parcelRegister("8AOG8", function(module, exports) {

$parcel$export(module.exports, "dismissMigrationModal", () => $cd8b23f08d3813c3$export$e05baac531611192);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");
const $cd8b23f08d3813c3$export$716b4280dda478e9 = 'DismissFirstColumnMigrationModalBacklog';
const $cd8b23f08d3813c3$export$19a8cfc9fd174c1c = (0, $ivqh1.gqlTagSwag)`
    mutation DismissFirstColumnMigrationModalBacklog($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;
const $cd8b23f08d3813c3$export$e05baac531611192 = (baseUrl, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $cd8b23f08d3813c3$export$716b4280dda478e9, $cd8b23f08d3813c3$export$19a8cfc9fd174c1c, {
        boardId: boardId
    });

});
parcelRegister("ivqh1", function(module, exports) {

$parcel$export(module.exports, "gqlTagSwag", () => $01c130fdc769ad97$export$c4eea1172a449e1a);

var $ftbQH = parcelRequire("ftbQH");
const $01c130fdc769ad97$export$c4eea1172a449e1a = (0, $ftbQH.gqlTagRest);

});
parcelRegister("ftbQH", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $e1de9369168f5428$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $e1de9369168f5428$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("6iJbJ", function(module, exports) {

$parcel$export(module.exports, "mutation$", () => $fd52b7b2722ec81e$export$3c168c5a8b47d553);

var $4nUsC = parcelRequire("4nUsC");
const $fd52b7b2722ec81e$export$3c168c5a8b47d553 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('mutation', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $cHBMC = parcelRequire("cHBMC");

var $dJl1T = parcelRequire("dJl1T");

var $kobfu = parcelRequire("kobfu");

var $4R6GH = parcelRequire("4R6GH");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $dJl1T.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $cHBMC.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                // eslint-disable-next-line jira/ff/no-preconditioning
                if ((0, $4R6GH.fg)('jsw_swag_response_too_many_errors_log_fix') && response.errors.length > 100) {
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("aZFhV", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");

var $1QOns = parcelRequire("1QOns");
/** `Object#toString` result references. */ var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $800fa0dabdb52684$var$isError(value) {
    if (!$fC1Kz(value)) return false;
    var tag = $beQoo(value);
    return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
}
module.exports = $800fa0dabdb52684$var$isError;

});

parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $x9xyg = parcelRequire("x9xyg");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});




parcelRegister("7b0Pa", function(module, exports) {

$parcel$export(module.exports, "isDialogOpen", () => $856a62ef091671f4$export$61d407d1c7ec6926);
const $856a62ef091671f4$export$61d407d1c7ec6926 = (state)=>state.ui.boardIssueMoveDialog.isOpen;

});

parcelRegister("k35me", function(module, exports) {

$parcel$export(module.exports, "makeGetSprintEstimations", () => $b6dd983165ce5ba4$export$36e03197e8c5fd07);
$parcel$export(module.exports, "makeIsCardListActiveSprint", () => $b6dd983165ce5ba4$export$5ce180897302be5f);
$parcel$export(module.exports, "makeIsSprintCardList", () => $b6dd983165ce5ba4$export$560f07fa8255aee3);
$parcel$export(module.exports, "getAllSprints", () => $b6dd983165ce5ba4$export$60a2c24a37c53cfb);
$parcel$export(module.exports, "makeGetOtherOrderedSprints", () => $b6dd983165ce5ba4$export$7ac571a2238dcc12);
$parcel$export(module.exports, "makeGetNextSprintId", () => $b6dd983165ce5ba4$export$b6b936656317fb38);
$parcel$export(module.exports, "makeGetPreviousNotStartedSprintId", () => $b6dd983165ce5ba4$export$a192949a255d1997);
$parcel$export(module.exports, "getFirstInactiveSprintId", () => $b6dd983165ce5ba4$export$e5a3f72422855e02);
$parcel$export(module.exports, "getLastInactiveSprintId", () => $b6dd983165ce5ba4$export$d38a80f79acac8b8);
$parcel$export(module.exports, "makeCanEditSprint", () => $b6dd983165ce5ba4$export$d0747858fa55f115);
$parcel$export(module.exports, "isBacklogWithSprints", () => $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5);
$parcel$export(module.exports, "makeIsSprintMenuVisible", () => $b6dd983165ce5ba4$export$c30c507815cb669f);
$parcel$export(module.exports, "makeIsStartSprintVisible", () => $b6dd983165ce5ba4$export$b617a44e0fda9735);
$parcel$export(module.exports, "makeIsCreateSprintVisible", () => $b6dd983165ce5ba4$export$fd48a9e7d9ffc297);
$parcel$export(module.exports, "makeIsStartSprintEnabled", () => $b6dd983165ce5ba4$export$35ab6d7577f201a3);
$parcel$export(module.exports, "makeIsCompleteSprintVisible", () => $b6dd983165ce5ba4$export$b447779f07c42b51);
$parcel$export(module.exports, "makeIsAddSprintDatesButtonVisible", () => $b6dd983165ce5ba4$export$47615c8fc3c602b6);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $bAfUr = parcelRequire("bAfUr");
const $b6dd983165ce5ba4$export$36e03197e8c5fd07 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeOrderedVisibleCardsForCardList),
    (0, $bAfUr.getInitialStatusIds),
    (0, $bAfUr.getResolutionDoneStatusIds),
    (0, $45Qwd.getEstimationType),
    (0, $jG5HW.isCmpKanbanProject)
], (getOrderedVisibleCardsForCardList, initialStatusIds, resolutionDoneStatusIds, estimationType, isCmpKanban)=>{
    const getSprintEstimations = (cardListId)=>{
        let list = getOrderedVisibleCardsForCardList(cardListId);
        if (!isCmpKanban) list = list.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const estimations = {
            NOT_STARTED: 0,
            IN_PROGRESS: 0,
            DONE: 0
        };
        list.forEach((card)=>{
            const incrementTypes = Object.freeze({
                [(0, $guzeq.ORIGINAL_ESTIMATE)]: card.estimate?.originalEstimate?.value || 0,
                [(0, $guzeq.STORY_POINTS)]: card.estimate?.storyPoints || 0,
                [(0, $guzeq.ISSUE_COUNT)]: 1
            });
            const increment = incrementTypes[estimationType] || 0;
            if (initialStatusIds.includes(card.statusId)) estimations.NOT_STARTED += increment;
            else if (resolutionDoneStatusIds.includes(card.statusId)) estimations.DONE += increment;
            else estimations.IN_PROGRESS += increment;
        });
        return estimations;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getSprintEstimations);
});
const $b6dd983165ce5ba4$export$5ce180897302be5f = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const isCardListActiveSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $guzeq.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'ACTIVE');
    return isCardListActiveSprint;
});
const $b6dd983165ce5ba4$export$548ce523ca2b9fc0 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const isCardListFutureSprint = (cardListId)=>Boolean(cardLists[cardListId]?.type === (0, $guzeq.SPRINT) && cardLists[cardListId]?.sprintData?.state === 'FUTURE');
    return isCardListFutureSprint;
});
const $b6dd983165ce5ba4$export$560f07fa8255aee3 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>(cardListId)=>Boolean(cardLists && cardLists[cardListId]?.type === (0, $guzeq.SPRINT)));
const $b6dd983165ce5ba4$export$3df6198cde5435f9 = (state, sprintId)=>(0, $dGljH.getCardLists)(state)[String(sprintId)].name;
const $b6dd983165ce5ba4$export$4402d4ed26f26131 = (state, sprintId)=>(0, $dGljH.getCardLists)(state)[String(sprintId)].sprintData || null;
const $b6dd983165ce5ba4$export$60a2c24a37c53cfb = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $guzeq.SPRINT)));
const $b6dd983165ce5ba4$export$7ac571a2238dcc12 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>{
    const getOtherOrderedSprints = (id)=>cardListIds.map((cardListId)=>cardLists[cardListId]).filter((cardList)=>cardList.type === (0, $guzeq.SPRINT) && cardList.id !== id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getOtherOrderedSprints);
});
const $b6dd983165ce5ba4$export$b6b936656317fb38 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds)
], (cardListIds)=>{
    const getNextSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const nextCardListIndex = index + 1;
        if (index === -1 || index === cardListIds.length - 1 || cardListIds[nextCardListIndex] === (0, $guzeq.BACKLOG)) return null;
        return cardListIds[nextCardListIndex];
    };
    return getNextSprintId;
});
const $b6dd983165ce5ba4$export$a192949a255d1997 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.getCardLists)
], (cardListIds, cardLists)=>{
    const getPrevNotStartedSprintId = (sprintId)=>{
        const index = cardListIds.indexOf(sprintId);
        const previousCardListIndex = index - 1;
        const previousCardListId = cardListIds[previousCardListIndex];
        if (index === -1 || index === 0 || cardLists[previousCardListId].type !== (0, $guzeq.SPRINT) || !cardLists[previousCardListId].sprintData || // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[previousCardListId].sprintData.state !== 'FUTURE') return null;
        return previousCardListId;
    };
    return getPrevNotStartedSprintId;
});
const $b6dd983165ce5ba4$export$e5a3f72422855e02 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists),
    (0, $dGljH.getVisibleCardListIds)
], (cardLists, ids)=>ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $guzeq.SPRINT) && card.sprintData?.state === 'FUTURE';
    })[0]);
const $b6dd983165ce5ba4$export$d38a80f79acac8b8 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists),
    (0, $dGljH.getVisibleCardListIds)
], (cardLists, ids)=>{
    const unscheduledSprints = ids.filter((id)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const card = cardLists[id];
        return card.type === (0, $guzeq.SPRINT) && card.sprintData?.state === 'FUTURE';
    });
    return unscheduledSprints[unscheduledSprints.length - 1];
});
const $b6dd983165ce5ba4$export$d0747858fa55f115 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const getCanEditSprint = (id)=>Boolean(cardLists[id] && cardLists[id].type === (0, $guzeq.SPRINT) && cardLists[id].sprintData && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id].sprintData.canUpdateSprint);
    return getCanEditSprint;
});
const $b6dd983165ce5ba4$export$a0cc63864a6ae856 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getCardLists)
], (cardLists)=>{
    const getSprintById = (id)=>// @ts-expect-error - TS2322 - Type 'Sprint | null | undefined' is not assignable to type 'Sprint | null'. | TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        cardLists[id] && cardLists[id].sprintData ? cardLists[id].sprintData : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getSprintById);
});
const $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getBacklogStrategy)
], (backlogStrategy)=>backlogStrategy === (0, $guzeq.SPRINT));
const $b6dd983165ce5ba4$export$c30c507815cb669f = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$a0cc63864a6ae856,
    $b6dd983165ce5ba4$export$d0747858fa55f115
], (areSprintsEnabled, getSprintById, canEditSprint)=>{
    const isSprintMenuVisible = (id)=>{
        if (!areSprintsEnabled) return false;
        const sprint = getSprintById(id);
        if (!sprint) return false;
        return canEditSprint(id);
    };
    return isSprintMenuVisible;
});
const $b6dd983165ce5ba4$export$b617a44e0fda9735 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$d0747858fa55f115,
    $b6dd983165ce5ba4$export$548ce523ca2b9fc0,
    (0, $jG5HW.getIsParallelSprintsEnabled),
    (0, $jG5HW.getIsCompanyManaged)
], (areSprintsEnabled, canEditSprint, isFutureSprint, isParallelSprintsEnabled, isCompanyManaged)=>{
    const isStartSprintVisible = (id, isFirstList)=>{
        if ((0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions')) {
            if (!areSprintsEnabled || isCompanyManaged && !isParallelSprintsEnabled && !isFirstList) return false;
        } else if (!areSprintsEnabled || !canEditSprint(id) || isCompanyManaged && !isParallelSprintsEnabled && !isFirstList) return false;
        return isFutureSprint(id);
    };
    return isStartSprintVisible;
});
const $b6dd983165ce5ba4$export$fd48a9e7d9ffc297 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    (0, $1z1J7.canManageSprints)
], (areSprintsEnabled, sprintsManageEnabled)=>{
    const isCreateSprintVisible = (id)=>{
        if ((0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions')) {
            if (!areSprintsEnabled) return false;
        } else if (!areSprintsEnabled || !sprintsManageEnabled) return false;
        return id === (0, $guzeq.BACKLOG);
    };
    return isCreateSprintVisible;
});
const $b6dd983165ce5ba4$export$35ab6d7577f201a3 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $jG5HW.getIsParallelSprintsEnabled),
    $b6dd983165ce5ba4$export$b617a44e0fda9735
], (isCompanyManaged, isParallelSprintsEnabled, isStartSprintVisible)=>(id, isFirstList)=>{
        if (!isStartSprintVisible(id, isFirstList)) return false;
        // First list in backlog always has start sprint button enabled regardless
        if (isFirstList) return true;
        // Agility Boards always have parallel sprints enabled
        return isCompanyManaged ? isParallelSprintsEnabled : true;
    });
const $b6dd983165ce5ba4$export$b447779f07c42b51 = (0, $dGvGJ.createSelector)([
    $b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5,
    $b6dd983165ce5ba4$export$d0747858fa55f115,
    $b6dd983165ce5ba4$export$5ce180897302be5f
], (areSprintsEnabled, canEditSprint, isActiveSprint)=>{
    const isCompleteSprintVisible = (id)=>(0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') // shows the button but disabled based on permission
         ? areSprintsEnabled && isActiveSprint(id) : areSprintsEnabled && canEditSprint(id) && isActiveSprint(id);
    return isCompleteSprintVisible;
});
const $b6dd983165ce5ba4$export$47615c8fc3c602b6 = (0, $dGvGJ.createSelector)([
    (state)=>(0, $dGljH.getCardLists)(state),
    (state)=>$b6dd983165ce5ba4$export$d0747858fa55f115(state),
    (state)=>$b6dd983165ce5ba4$export$5a6d0e1cb58a7ee5(state),
    // @ts-expect-error - TS7031 - Binding element 'cardListId' implicitly has an 'any' type.
    (state, { cardListId: cardListId })=>cardListId
], (cardLists, canEditSprint, areSprintsEnabled, cardListId)=>Boolean(areSprintsEnabled && canEditSprint(cardListId) && cardLists[cardListId].sprintData && !cardLists[cardListId].sprintData?.startDate && !cardLists[cardListId].sprintData?.endDate));

});
parcelRegister("45Qwd", function(module, exports) {

$parcel$export(module.exports, "getEstimationType", () => $9eb91d07319b2140$export$29518a6a820fd3eb);
$parcel$export(module.exports, "isOriginalEstimateTypeSelector", () => $9eb91d07319b2140$export$6a137137bd478798);
$parcel$export(module.exports, "isNumericEstimateTypeSelector", () => $9eb91d07319b2140$export$97ec2e51e7a87787);
$parcel$export(module.exports, "getEstimationFieldId", () => $9eb91d07319b2140$export$d49fd37e39c6e680);
$parcel$export(module.exports, "getEstimationName", () => $9eb91d07319b2140$export$402e2f057625b12d);
$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabled", () => $9eb91d07319b2140$export$7de59b2ad512814f);

var $dGvGJ = parcelRequire("dGvGJ");

var $guzeq = parcelRequire("guzeq");

var $dGljH = parcelRequire("dGljH");

var $e5nhF = parcelRequire("e5nhF");
const $9eb91d07319b2140$export$930445b4a7dea9c7 = (state)=>(0, $e5nhF.getEntities)(state).estimation;
const $9eb91d07319b2140$export$a8f00aa8643e90b5 = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.isEstimationFeatureEnabled);
const $9eb91d07319b2140$export$29518a6a820fd3eb = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.estimationType);
const $9eb91d07319b2140$export$6a137137bd478798 = (state)=>$9eb91d07319b2140$export$29518a6a820fd3eb(state) === (0, $guzeq.ORIGINAL_ESTIMATE);
const $9eb91d07319b2140$export$97ec2e51e7a87787 = (state)=>$9eb91d07319b2140$export$29518a6a820fd3eb(state) === (0, $guzeq.STORY_POINTS);
const $9eb91d07319b2140$export$d49fd37e39c6e680 = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.estimationFieldId);
const $9eb91d07319b2140$export$402e2f057625b12d = (0, $dGvGJ.createSelector)($9eb91d07319b2140$export$930445b4a7dea9c7, (estimation)=>estimation.name);
const $9eb91d07319b2140$export$7de59b2ad512814f = (0, $dGvGJ.createSelector)((0, $dGljH.getCards), (allCards)=>{
    const listOfCards = Object.values(allCards);
    if (listOfCards.length <= 0) return false;
    return !!listOfCards[0]?.estimate?.timeRemainingEstimate;
});

});

parcelRegister("bAfUr", function(module, exports) {

$parcel$export(module.exports, "getInitialStatusIds", () => $0bb134b497279a79$export$3b740680bb74be21);
$parcel$export(module.exports, "getResolutionDoneStatusIds", () => $0bb134b497279a79$export$a1205d43535ec163);
$parcel$export(module.exports, "getColumnStatusByStatusId", () => $0bb134b497279a79$export$2ae22d7372adb0d1);
$parcel$export(module.exports, "getColumnStatusIds", () => $0bb134b497279a79$export$eb0fe596a80f835f);
$parcel$export(module.exports, "isStatusMappedToBoardOld", () => $0bb134b497279a79$export$b9df98cb1a9ce42b);
$parcel$export(module.exports, "isStatusMappedToBoard", () => $0bb134b497279a79$export$48bfbcc6c0173871);
$parcel$export(module.exports, "makeGetKanbanSingleColumnStatusId", () => $0bb134b497279a79$export$5826bba123eba4f6);
$parcel$export(module.exports, "isStatusVisibleOnCmpKanbanBacklog", () => $0bb134b497279a79$export$87b2d43ded99833b);
$parcel$export(module.exports, "areStatusesFromSameColumn", () => $0bb134b497279a79$export$7c7e516bfb4a3562);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $gULOk = parcelRequire("gULOk");

var $guzeq = parcelRequire("guzeq");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $kwBUh = parcelRequire("kwBUh");
const $0bb134b497279a79$export$3b740680bb74be21 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $kwBUh.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const initialStatusColumn = columnsArray.find((column)=>column.order === 0);
            return initialStatusColumn ? initialStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((initialStatuses, column)=>{
        column.statuses.forEach((status)=>{
            const isInitialStatus = /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
                (0, $gULOk.StatusCategoryTypes).NEW,
                (0, $gULOk.StatusCategoryTypes).UNDEFINED
            ]/* eslint-enable @typescript-eslint/consistent-type-assertions */ .includes(status.category);
            isInitialStatus && initialStatuses.push(status.id);
        });
        return initialStatuses;
    }, []);
});
const $0bb134b497279a79$export$a1205d43535ec163 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $kwBUh.getColumns)
], (isCompanyManaged, columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    if (isCompanyManaged) {
        if (columnsArray.length) {
            const resolutionDoneStatusColumn = columnsArray.find((column)=>column.order === columnsArray.length - 1);
            return resolutionDoneStatusColumn ? resolutionDoneStatusColumn.statuses.map((status)=>status.id) : [];
        }
    }
    return columnsArray.reduce((resolutionDoneStatuses, column)=>{
        column.statuses.forEach((status)=>{
            if (status.category === (0, $gULOk.StatusCategoryTypes).DONE) resolutionDoneStatuses.push(status.id);
        });
        return resolutionDoneStatuses;
    }, []);
});
const $0bb134b497279a79$export$2ae22d7372adb0d1 = (statusId)=>(0, $dGvGJ.createSelector)([
        (0, $kwBUh.getColumns)
    ], (columns)=>{
        if (!columns) return null;
        // We do this kind of loop because its more efficient than the alternative loops
        for (const columnKey of Object.keys(columns)){
            const status = (columns[columnKey].statuses || []).find((s)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(s) && s.id === statusId);
            // Terminate early if we find what we need (flow doesn't like isNil here)
            if (status !== undefined && status !== null) return status;
        }
        return null;
    });
const $0bb134b497279a79$export$eb0fe596a80f835f = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns)
], (columns)=>{
    if (!columns) return [];
    const columnsArray = Object.values(columns);
    return columnsArray.reduce((statuseIds, column)=>{
        column.statuses.forEach((status)=>{
            statuseIds.push(status.id);
        });
        return statuseIds;
    }, []);
});
const $0bb134b497279a79$export$b9df98cb1a9ce42b = (statusId)=>(0, $dGvGJ.createSelector)([
        $0bb134b497279a79$export$eb0fe596a80f835f
    ], (columnStatusIds)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    });
const $0bb134b497279a79$export$48bfbcc6c0173871 = (0, $dGvGJ.createSelector)([
    $0bb134b497279a79$export$eb0fe596a80f835f
], (columnStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>{
        if (!columnStatusIds) return false;
        return columnStatusIds.includes(statusId);
    }));
const $0bb134b497279a79$export$5826bba123eba4f6 = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getIsCompanyManaged),
    (0, $jG5HW.isKanbanBacklogStrategy),
    (0, $dGljH.getCardLists),
    (0, $jG5HW.getKanbanTargetColumnId),
    (0, $kwBUh.makeGetColumn)
], (isCompanyManaged, isKanbanStrategy, cardLists, selectKanbanTargetColumnId, getColumn)=>(cardListId)=>{
        if (!isCompanyManaged || !isKanbanStrategy) return undefined;
        const cardList = cardLists[cardListId];
        if (!cardList) return undefined;
        if (cardList.type === (0, $guzeq.SPRINT)) return undefined;
        const targetColumnId = selectKanbanTargetColumnId(cardList.type);
        if (!targetColumnId) return undefined;
        const column = getColumn(targetColumnId);
        if (!column) return undefined;
        return column.statuses.length === 1 ? column.statuses[0].id : undefined;
    });
const $0bb134b497279a79$export$84797642e3c942d3 = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns),
    (0, $jG5HW.getKanbanBoardColumnId),
    (0, $jG5HW.getKanbanBacklogColumnId)
], (columns, kanbanBoardColumnId, kanbanBacklogColumnId)=>{
    if (!columns || !kanbanBoardColumnId || !kanbanBacklogColumnId) return [];
    const boardStatuses = columns[kanbanBoardColumnId].statuses;
    const backlogStatuses = columns[kanbanBacklogColumnId].statuses;
    return [
        ...boardStatuses,
        ...backlogStatuses
    ].map((columnStatus)=>columnStatus.id);
});
const $0bb134b497279a79$export$87b2d43ded99833b = (0, $dGvGJ.createSelector)([
    $0bb134b497279a79$export$84797642e3c942d3
], (visibleStatusIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>visibleStatusIds.includes(statusId)));
const $0bb134b497279a79$export$7c7e516bfb4a3562 = (0, $dGvGJ.createSelector)([
    (0, $kwBUh.getColumns)
], (columns)=>// The first two statusIds have been named explicitly to ensure
    // at least two statuses are required for comparison
    (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((firstStatusId, secondStatusId, ...remainingStatusIds)=>{
        if (!columns) return false;
        // The column that houses the first status is the point of reference.
        // We'll check whether all other statuses exist in this column.
        const columnOfFirstStatus = (0, $kwBUh.findColumnByStatusId)(columns, firstStatusId);
        const statusesToCheck = [
            secondStatusId,
            ...remainingStatusIds
        ];
        if (!columnOfFirstStatus) return false;
        const columnStatusIds = columnOfFirstStatus.statuses.map(({ id: id })=>id);
        return statusesToCheck.every((statusId)=>columnStatusIds.includes(statusId));
    }, // Construct a custom cache key for memoize as it
    // only uses the first arg for the cache key by default
    (...statusIds)=>[
            ...statusIds.concat().sort()
        ].join('_')));

});
parcelRegister("kwBUh", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $d00b9b2cbbfb80a8$export$978e30a0fb8610d8);
$parcel$export(module.exports, "makeGetColumn", () => $d00b9b2cbbfb80a8$export$c8e2f531112a8425);
$parcel$export(module.exports, "findColumnByStatusId", () => $d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1);
$parcel$export(module.exports, "getColumnCount", () => $d00b9b2cbbfb80a8$export$813bef8f01765aa1);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $e5nhF = parcelRequire("e5nhF");
const $d00b9b2cbbfb80a8$export$978e30a0fb8610d8 = (state)=>(0, $e5nhF.getEntities)(state).column;
const $d00b9b2cbbfb80a8$export$c8e2f531112a8425 = (state)=>(columnId)=>{
        const columns = $d00b9b2cbbfb80a8$export$978e30a0fb8610d8(state);
        if (!columns) return null;
        return columns[String(columnId)] ?? null;
    };
const $d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1 = (columns, statusId)=>columns && Object.values(columns).find((column)=>column.statuses.some((columnStatus)=>columnStatus.id === statusId));
const $d00b9b2cbbfb80a8$export$c0868dfc0085fdc9 = (0, $dGvGJ.createSelector)([
    $d00b9b2cbbfb80a8$export$978e30a0fb8610d8
], (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((statusId)=>$d00b9b2cbbfb80a8$export$b8cb2be3dbed32e1(columns, statusId)));
const $d00b9b2cbbfb80a8$export$813bef8f01765aa1 = (columns)=>{
    if (!columns || Object.keys(columns).length === 0) return {
        initialColumnCount: 0,
        inProgressColumnCount: 0,
        doneColumnCount: 0
    };
    // the order of columns in the state is not guaranteed so if you want to get the correct column object you will need to sort them by tje column's "order"
    const cols = Object.values(columns);
    const initialColumnCount = 1;
    const doneColumnCount = cols.length > 1 ? 1 : 0;
    const inProgressColumnCount = Math.max(0, cols.length - 2); // columns between initial and done
    return {
        initialColumnCount: initialColumnCount,
        inProgressColumnCount: inProgressColumnCount,
        doneColumnCount: doneColumnCount
    };
};

});




parcelRegister("3lZ6i", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $a8888b8c4c9e815d$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $a8888b8c4c9e815d$export$5f0e35553cecddfe);
$parcel$export(module.exports, "LOAD_APP_DATA_REQUEST", () => $a8888b8c4c9e815d$export$4f8b7d7927a22b01);
$parcel$export(module.exports, "loadAppData", () => $a8888b8c4c9e815d$export$c0b92fee0bc9f9f3);
$parcel$export(module.exports, "LOAD_APP_DATA_FAILURE", () => $a8888b8c4c9e815d$export$b707057781245e8f);
$parcel$export(module.exports, "loadAppDataFailure", () => $a8888b8c4c9e815d$export$442c6ce163728713);
$parcel$export(module.exports, "SET_APP_DATA", () => $a8888b8c4c9e815d$export$913417342844b14c);
$parcel$export(module.exports, "setAppData", () => $a8888b8c4c9e815d$export$9f61e044a5ec71f4);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_REQUEST", () => $a8888b8c4c9e815d$export$a7098c3930b55b23);
$parcel$export(module.exports, "loadConfigData", () => $a8888b8c4c9e815d$export$6ca3a482217f96bb);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_FAILURE", () => $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6);
$parcel$export(module.exports, "loadConfigDataFailure", () => $a8888b8c4c9e815d$export$a6d32f0fe95fd7);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_MODEL_SUCCESS", () => $a8888b8c4c9e815d$export$1231ea6d6fc1e894);
$parcel$export(module.exports, "loadConfigDataModelSuccess", () => $a8888b8c4c9e815d$export$11bca38ca7a076c9);
$parcel$export(module.exports, "LOAD_CONFIG_DATA_SUCCESS", () => $a8888b8c4c9e815d$export$e84bf3e6432acad9);
$parcel$export(module.exports, "loadConfigDataSuccess", () => $a8888b8c4c9e815d$export$2d8a793787dedc61);
$parcel$export(module.exports, "SET_CONFIG_DATA", () => $a8888b8c4c9e815d$export$b46a9391a0c75503);
$parcel$export(module.exports, "setConfigData", () => $a8888b8c4c9e815d$export$6da10c57829cd8e6);
$parcel$export(module.exports, "BACKLOG_VIEW", () => $a8888b8c4c9e815d$export$bcb8585a82b8f8c7);
$parcel$export(module.exports, "backlogView", () => $a8888b8c4c9e815d$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "REFRESH_DATA_REQUEST", () => $a8888b8c4c9e815d$export$f015544c9ef3cb40);
$parcel$export(module.exports, "refreshDataRequest", () => $a8888b8c4c9e815d$export$7245a5bb55cf1c);
$parcel$export(module.exports, "refreshDataFailure", () => $a8888b8c4c9e815d$export$5bb841369f417b5b);
$parcel$export(module.exports, "CHECK_GLOBAL_ISSUE_CREATE", () => $a8888b8c4c9e815d$export$d3342655e6919343);
$parcel$export(module.exports, "checkGlobalIssueCreate", () => $a8888b8c4c9e815d$export$d2425890b90f3347);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_REQUEST", () => $a8888b8c4c9e815d$export$1dd1f39bb2e82807);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_SUCCESS", () => $a8888b8c4c9e815d$export$a62958b8add4d4a0);
$parcel$export(module.exports, "loadCardCreateConfigSuccess", () => $a8888b8c4c9e815d$export$42eba9692ae3b59c);
$parcel$export(module.exports, "LOAD_CARD_CREATE_CONFIG_FAILURE", () => $a8888b8c4c9e815d$export$4b08535554f72f68);
$parcel$export(module.exports, "loadCardCreateConfigFailure", () => $a8888b8c4c9e815d$export$eddf97b41d9e89cf);
const $a8888b8c4c9e815d$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $a8888b8c4c9e815d$export$5f0e35553cecddfe = (payload)=>({
        type: $a8888b8c4c9e815d$export$84856e4ae7cd7538,
        payload: payload
    });
const $a8888b8c4c9e815d$export$4f8b7d7927a22b01 = 'state.actions.app.LOAD_APP_DATA_REQUEST';
const $a8888b8c4c9e815d$export$c0b92fee0bc9f9f3 = (payload = {})=>({
        type: $a8888b8c4c9e815d$export$4f8b7d7927a22b01,
        payload: payload
    });
const $a8888b8c4c9e815d$export$b707057781245e8f = 'state.actions.app.LOAD_APP_DATA_FAILURE';
const $a8888b8c4c9e815d$export$442c6ce163728713 = ()=>({
        type: $a8888b8c4c9e815d$export$b707057781245e8f
    });
const $a8888b8c4c9e815d$export$913417342844b14c = 'state.actions.app.SET_APP_DATA';
const $a8888b8c4c9e815d$export$9f61e044a5ec71f4 = (payload)=>({
        type: $a8888b8c4c9e815d$export$913417342844b14c,
        payload: payload
    });
const $a8888b8c4c9e815d$export$a7098c3930b55b23 = 'state.actions.app.LOAD_CONFIG_DATA_REQUEST';
const $a8888b8c4c9e815d$export$6ca3a482217f96bb = ()=>({
        type: $a8888b8c4c9e815d$export$a7098c3930b55b23
    });
const $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6 = 'state.actions.app.LOAD_CONFIG_DATA_FAILURE';
const $a8888b8c4c9e815d$export$a6d32f0fe95fd7 = ()=>({
        type: $a8888b8c4c9e815d$export$d9a7e4743c3f9bb6
    });
const $a8888b8c4c9e815d$export$1231ea6d6fc1e894 = 'state.actions.app.LOAD_CONFIG_DATA_MODEL_SUCCESS';
const $a8888b8c4c9e815d$export$11bca38ca7a076c9 = (payload)=>({
        type: $a8888b8c4c9e815d$export$1231ea6d6fc1e894,
        payload: payload
    });
const $a8888b8c4c9e815d$export$e84bf3e6432acad9 = 'state.actions.app.LOAD_CONFIG_DATA_SUCCESS';
const $a8888b8c4c9e815d$export$2d8a793787dedc61 = ()=>({
        type: $a8888b8c4c9e815d$export$e84bf3e6432acad9
    });
const $a8888b8c4c9e815d$export$b46a9391a0c75503 = 'state.actions.app.SET_CONFIG_DATA';
const $a8888b8c4c9e815d$export$6da10c57829cd8e6 = (payload)=>({
        type: $a8888b8c4c9e815d$export$b46a9391a0c75503,
        payload: payload
    });
const $a8888b8c4c9e815d$export$bcb8585a82b8f8c7 = 'state.actions.app.BACKLOG_VIEW';
const $a8888b8c4c9e815d$export$4696f1f49cfb7d46 = (analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$bcb8585a82b8f8c7,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $a8888b8c4c9e815d$export$f015544c9ef3cb40 = 'state.actions.app.REFRESH_DATA_REQUEST';
const $a8888b8c4c9e815d$export$7245a5bb55cf1c = (source, issues, storeFieldsActions)=>({
        type: $a8888b8c4c9e815d$export$f015544c9ef3cb40,
        payload: {
            source: source,
            issues: issues,
            storeFieldsActions: storeFieldsActions
        }
    });
const $a8888b8c4c9e815d$export$447a7d83169b5ed9 = 'state.actions.app.REFRESH_DATA_FAILURE';
const $a8888b8c4c9e815d$export$5bb841369f417b5b = ()=>({
        type: $a8888b8c4c9e815d$export$447a7d83169b5ed9
    });
const $a8888b8c4c9e815d$export$d3342655e6919343 = 'state.actions.app.CHECK_GLOBAL_ISSUE_CREATE';
const $a8888b8c4c9e815d$export$d2425890b90f3347 = (issues)=>({
        type: $a8888b8c4c9e815d$export$d3342655e6919343,
        payload: {
            issues: issues
        }
    });
const $a8888b8c4c9e815d$export$1dd1f39bb2e82807 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_REQUEST';
const $a8888b8c4c9e815d$export$149bf88f2a958c35 = ()=>({
        type: $a8888b8c4c9e815d$export$1dd1f39bb2e82807
    });
const $a8888b8c4c9e815d$export$a62958b8add4d4a0 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_SUCCESS';
const $a8888b8c4c9e815d$export$42eba9692ae3b59c = (response, analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$a62958b8add4d4a0,
        payload: response,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $a8888b8c4c9e815d$export$4b08535554f72f68 = 'state.actions.app.LOAD_CARD_CREATE_CONFIG_FAILURE';
const $a8888b8c4c9e815d$export$eddf97b41d9e89cf = (error, analyticsEvent)=>({
        type: $a8888b8c4c9e815d$export$4b08535554f72f68,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("3qXBy", function(module, exports) {

$parcel$export(module.exports, "BOARD_ISSUE_MOVE_CANCEL", () => $478abff165c36fa8$export$22ae87f30df1ab2a);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $478abff165c36fa8$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_SHOW", () => $478abff165c36fa8$export$e229682e10ad017a);
$parcel$export(module.exports, "boardIssueMoveShow", () => $478abff165c36fa8$export$afe8c48481994c25);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE", () => $478abff165c36fa8$export$a0efdae17a1cafbf);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $478abff165c36fa8$export$47de1859c695eca7);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_SUCCESS", () => $478abff165c36fa8$export$7bbe0c5ad5f82e3b);
$parcel$export(module.exports, "BOARD_ISSUE_MOVE_EXECUTE_FAILURE", () => $478abff165c36fa8$export$a246706d8be8143c);

var $c0irb = parcelRequire("c0irb");
const $478abff165c36fa8$export$22ae87f30df1ab2a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_CANCEL';
const $478abff165c36fa8$export$21c319cd4bbf2b2f = ()=>({
        type: $478abff165c36fa8$export$22ae87f30df1ab2a
    });
const $478abff165c36fa8$export$e229682e10ad017a = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_SHOW';
const $478abff165c36fa8$export$afe8c48481994c25 = ()=>({
        type: $478abff165c36fa8$export$e229682e10ad017a
    });
const $478abff165c36fa8$export$a0efdae17a1cafbf = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE';
const $478abff165c36fa8$export$47de1859c695eca7 = ()=>({
        type: $478abff165c36fa8$export$a0efdae17a1cafbf,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $478abff165c36fa8$export$7bbe0c5ad5f82e3b = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS';
const $478abff165c36fa8$export$403d172f0e549eb1 = (optimisticId)=>({
        type: $478abff165c36fa8$export$7bbe0c5ad5f82e3b,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $478abff165c36fa8$export$a246706d8be8143c = 'state.actions.board-issue-move.BOARD_ISSUE_MOVE_EXECUTE_FAILURE';
const $478abff165c36fa8$export$3c31c79b76c3db3b = (optimisticId)=>({
        type: $478abff165c36fa8$export$a246706d8be8143c,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("3b59T", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d0c98c20f0247b$export$2e2bcd8739ae039);

var $jIyVb = parcelRequire("jIyVb");
parcelRequire("hZWgu");
parcelRequire("6cbqE");

var $3qXBy = parcelRequire("3qXBy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$56d0c98c20f0247b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL), (0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE)).switchMap(()=>(0, $jIyVb.dismissDialog)(store.getState()).ignoreElements());

});


parcelRegister("eBTGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2123bb6f294a6113$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("d6iim");
parcelRequire("fjPtF");

var $7Jxgt = parcelRequire("7Jxgt");

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $g4slm = parcelRequire("g4slm");

var $avYIL = parcelRequire("avYIL");

var $js96S = parcelRequire("js96S");

var $6JzCg = parcelRequire("6JzCg");
const $2123bb6f294a6113$export$d03120aa6150e275 = (action$)=>action$.ofType((0, $js96S.CARD_SET_REQUEST)).mergeMap((action)=>{
        const { batchId: batchId, setMutations: setMutations } = action.payload;
        return (0, $kVLXA.Observable).from(setMutations).mergeMap((mutation)=>{
            const { optimistic: { id: optimisticId }, [(0, $6JzCg.CARD_SET_META_KEY)]: { fieldId: fieldId, issueKey: issueKey, newValue: newValue, retryAction: retryAction }, analyticsEvent: analyticsEvent } = mutation;
            return (0, $g4slm.default)({
                issueKey: issueKey,
                fieldId: fieldId,
                newValue: newValue
            }).map(()=>(0, $js96S.cardSetIndividualResponseSuccess)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId
                }, optimisticId, analyticsEvent)).catch((error)=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData('bulk-ops-send-request-epic', `Failed to set card field '${fieldId}'`, error);
                const isNetworkError = (0, $fZneA.isClientFetchError)(error);
                const isUserValidationError = (0, $jJZqs.isValidationError)(error);
                // eslint-disable-next-line no-nested-ternary
                const failureReason = isNetworkError ? 'network' : isUserValidationError ? 'validation' : 'server';
                const statusCode = 'statusCode' in error ? error.statusCode : undefined;
                return (0, $kVLXA.Observable).of((0, $js96S.cardSetIndividualResponseFailure)({
                    batchId: batchId,
                    issueKey: issueKey,
                    fieldId: fieldId,
                    retryAction: retryAction,
                    failureReason: failureReason,
                    statusCode: statusCode
                }, optimisticId, analyticsEvent));
            });
        }).bufferCount(setMutations.length).mergeMap((cardSetRequestResponses)=>(0, $kVLXA.Observable).of((0, $aB8eX.batchActions)(cardSetRequestResponses)));
    });
const $2123bb6f294a6113$var$isActionWithCardSetMeta = (action)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    action.meta?.[0, $6JzCg.CARD_SET_META_KEY] !== undefined;
const $2123bb6f294a6113$var$isCardSetIndividualResponse = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS) || action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $2123bb6f294a6113$var$isCardSetIndividualRequestFailure = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE);
const $2123bb6f294a6113$var$getFailureReason = (failedActions)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const firstFailureReason = failedActions[0].payload.failureReason;
    const isAllSameFailureReason = failedActions.every((action)=>action.payload.failureReason === firstFailureReason);
    return isAllSameFailureReason ? firstFailureReason : 'mixed';
};
const $2123bb6f294a6113$export$1d45daa6c882af99 = (action$)=>action$.ofType((0, $aB8eX.BATCH)).mergeMap((action)=>{
        const cardSetMetaActions = action.payload.filter($2123bb6f294a6113$var$isActionWithCardSetMeta);
        if (cardSetMetaActions.length < 1) return (0, $kVLXA.Observable).empty();
        const cardSetActions$ = (0, $kVLXA.Observable).from(cardSetMetaActions).map((actionWithCardSetMeta)=>actionWithCardSetMeta.meta);
        const batchId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        const request$ = cardSetActions$.bufferCount(cardSetMetaActions.length).map((setMutations)=>(0, $js96S.cardSetRequest)(setMutations, batchId));
        const response$ = action$.ofType((0, $aB8eX.BATCH)).mergeMap((batchAction)=>batchAction.payload).filter($2123bb6f294a6113$var$isCardSetIndividualResponse).filter((cardSetIndividualResponse)=>cardSetIndividualResponse.payload.batchId === batchId).bufferCount(cardSetMetaActions.length).mergeMap((cardSetRequestResponses)=>{
            const failedActions = cardSetRequestResponses.filter($2123bb6f294a6113$var$isCardSetIndividualRequestFailure);
            if (!failedActions.length) return (0, $kVLXA.Observable).empty();
            const totalCount = cardSetRequestResponses.length;
            const previousFailedBatchIds = cardSetMetaActions[0].meta.failedBatchIds;
            const failedActionBuilders = failedActions.map((failedAction)=>failedAction.payload.retryAction);
            const failedIssueKeys = failedActions.map((failedAction)=>failedAction.payload.issueKey);
            const failedBatchIds = previousFailedBatchIds?.length ? previousFailedBatchIds.concat(batchId) : [
                batchId
            ];
            return (0, $kVLXA.Observable).of((0, $avYIL.bulkOpsShowFailedFlag)({
                failedActionBuilders: failedActionBuilders,
                failedIssueKeys: failedIssueKeys,
                totalCount: totalCount,
                failedBatchIds: failedBatchIds,
                failureReason: $2123bb6f294a6113$var$getFailureReason(failedActions)
            }));
        });
        return request$.merge(response$);
    });
var $2123bb6f294a6113$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($2123bb6f294a6113$export$1d45daa6c882af99, $2123bb6f294a6113$export$d03120aa6150e275);

});
parcelRegister("g4slm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c29720f4ae98da0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $fund4 = parcelRequire("fund4");
parcelRequire("9o0uh");
const $9c29720f4ae98da0$var$cardSetService = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $kVLXA.Observable).fromPromise((0, $fund4.default)({
        issueKey: issueKey,
        fieldId: fieldId,
        newValue: newValue
    }));
var $9c29720f4ae98da0$export$2e2bcd8739ae039 = $9c29720f4ae98da0$var$cardSetService;

});
parcelRegister("fund4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d42a6296829b6c86$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

var $4tcSU = parcelRequire("4tcSU");
const $d42a6296829b6c86$var$getFieldUpdate = (fieldId, value)=>({
        fields: {
            [fieldId]: value
        }
    });
const $d42a6296829b6c86$var$cardUpdateRest = ({ fieldId: fieldId, issueKey: issueKey, newValue: newValue })=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($d42a6296829b6c86$var$getFieldUpdate(fieldId, newValue))
    });
const $d42a6296829b6c86$export$31627ab97a843839 = ({ fieldId: fieldId, cardId: cardId, newValue: newValue, fieldsToForcePresent: fieldsToForcePresent })=>(0, $eusud.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $ebyGx.stringify)({
            issueId: cardId,
            [fieldId]: newValue,
            atl_token: (0, $4tcSU.default)(),
            skipScreenCheck: true,
            singleFieldEdit: true,
            fieldsToForcePresent: fieldsToForcePresent
        })
    });
var $d42a6296829b6c86$export$2e2bcd8739ae039 = $d42a6296829b6c86$var$cardUpdateRest;

});


parcelRegister("js96S", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_REQUEST", () => $c5e269039e50e9db$export$952416878bada00d);
$parcel$export(module.exports, "cardSetRequest", () => $c5e269039e50e9db$export$dc4cb42f76517e71);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_SUCCESS", () => $c5e269039e50e9db$export$8cbba69660c382bc);
$parcel$export(module.exports, "cardSetIndividualResponseSuccess", () => $c5e269039e50e9db$export$a84ab8ecccfa05f1);
$parcel$export(module.exports, "CARD_SET_INDIVIDUAL_REQUEST_FAILURE", () => $c5e269039e50e9db$export$a0fc6789cc35a208);
$parcel$export(module.exports, "cardSetIndividualResponseFailure", () => $c5e269039e50e9db$export$fff072d58f0c031f);

var $c0irb = parcelRequire("c0irb");
const $c5e269039e50e9db$export$952416878bada00d = 'state.actions.card-set.CARD_SET_REQUEST';
const $c5e269039e50e9db$export$dc4cb42f76517e71 = (setMutations, batchId)=>({
        type: $c5e269039e50e9db$export$952416878bada00d,
        payload: {
            setMutations: setMutations,
            batchId: batchId
        }
    });
const $c5e269039e50e9db$export$8cbba69660c382bc = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS';
const $c5e269039e50e9db$export$a84ab8ecccfa05f1 = (payload, optimisticId, analyticsEvent)=>({
        type: $c5e269039e50e9db$export$8cbba69660c382bc,
        payload: payload,
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $c5e269039e50e9db$export$a0fc6789cc35a208 = 'state.actions.card-set.CARD_SET_INDIVIDUAL_REQUEST_FAILURE';
const $c5e269039e50e9db$export$fff072d58f0c031f = (payload, optimisticId, analyticsEvent)=>({
        type: $c5e269039e50e9db$export$a0fc6789cc35a208,
        payload: payload,
        meta: {
            ...(0, $c0irb.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("6JzCg", function(module, exports) {

$parcel$export(module.exports, "CARD_SET_META_KEY", () => $5ecc710be775690b$export$d065026949290531);
$parcel$export(module.exports, "setCardSetMeta", () => $5ecc710be775690b$export$6bd5fd0b08cb2b1d);

var $c0irb = parcelRequire("c0irb");
const $5ecc710be775690b$export$d065026949290531 = Symbol('CARD_SET_META_KEY');
const $5ecc710be775690b$export$6bd5fd0b08cb2b1d = (payload, analyticsEvent)=>({
        [$5ecc710be775690b$export$d065026949290531]: payload,
        analyticsEvent: analyticsEvent,
        ...(0, $c0irb.beginOptimisticUiMeta)()
    });

});


parcelRegister("4IyFO", function(module, exports) {

$parcel$export(module.exports, "getCanUserInviteEpic", () => $c3edad855ff9bf08$export$89828008460b535c);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $h5rxs = parcelRequire("h5rxs");

var $3lZ6i = parcelRequire("3lZ6i");

var $dzRFd = parcelRequire("dzRFd");

var $jG5HW = parcelRequire("jG5HW");
const $c3edad855ff9bf08$export$89828008460b535c = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $jG5HW.getIsCompanyManaged)(state);
        if (isCMPBoard) return (0, $kVLXA.Observable).of();
        const projectId = (0, $jG5HW.projectIdSelector)(state);
        return (0, $h5rxs.fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $kVLXA.Observable).of((0, $dzRFd.setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.can-user-invite.load.failure',
                    packageName: 'jiraSoftwareBacklog',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("h5rxs", function(module, exports) {

$parcel$export(module.exports, "fetchCanUserInviteService", () => $b47f0516cea8a6f8$export$583ef539d905855);

var $5Hg0D = parcelRequire("5Hg0D");
const $b47f0516cea8a6f8$export$583ef539d905855 = (projectId)=>(0, $5Hg0D.getUserInviteCapability)(projectId);

});
parcelRegister("5Hg0D", function(module, exports) {

$parcel$export(module.exports, "getUserInviteCapability", () => $aa15bfeb3d297399$export$22c733f1adfb0925);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
const $aa15bfeb3d297399$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others`;
const $aa15bfeb3d297399$export$22c733f1adfb0925 = (projectId)=>(0, $487fd.default)($aa15bfeb3d297399$var$getCanInviteOthersUrl(projectId), {
        method: 'GET'
    });

});


parcelRegister("dzRFd", function(module, exports) {

$parcel$export(module.exports, "SET_CAN_USER_INVITE", () => $ac8b0dfc5f6ea546$export$c09a6e8888fd28fa);
$parcel$export(module.exports, "setCanUserInvite", () => $ac8b0dfc5f6ea546$export$c07b821618e68774);
const $ac8b0dfc5f6ea546$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
const $ac8b0dfc5f6ea546$export$c07b821618e68774 = (payload)=>({
        type: $ac8b0dfc5f6ea546$export$c09a6e8888fd28fa,
        payload: payload
    });

});


parcelRegister("hnaxO", function(module, exports) {

$parcel$export(module.exports, "buildAssignToMeEpic", () => $7402c8a809d95853$export$f773e45c14115697);
$parcel$export(module.exports, "cardAssignToMeThrottledEpic", () => $7402c8a809d95853$export$5ed483b9a7992e55);
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("3awJm");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $aYkSv = parcelRequire("aYkSv");

var $4G04L = parcelRequire("4G04L");

var $8hVbJ = parcelRequire("8hVbJ");

var $g4P00 = parcelRequire("g4P00");
const $7402c8a809d95853$export$59640cb3aa92677 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, action, { onStart: onStart, onSuccess: onSuccess } = {})=>{
    const { id: optimisticId } = action.meta.optimistic;
    const { cardId: cardId, assignee: assignee, concurrentId: concurrentId } = action.payload;
    if (onStart) onStart(action);
    return (0, $kVLXA.Observable).fromPromise((0, $aYkSv.assignToMe)(swagClient, {
        issueId: `${cardId}`,
        accountId: assignee?.id
    })).map(()=>{
        if (onSuccess) onSuccess(action);
        return (0, $g4P00.assignToMeSuccess)(optimisticId, concurrentId);
    }).catch(()=>(0, $kVLXA.Observable).of((0, $g4P00.assignToMeFailure)(optimisticId, concurrentId)));
};
const $7402c8a809d95853$var$hooks = {
    onStart: ({ payload: { concurrentId: concurrentId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(concurrentId)) (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.assignToMeInteraction)(concurrentId).mark('feedback');
        });
        if (fireShortcutAnalyticsFn) fireShortcutAnalyticsFn({
            id: 'assignToMeKeyboardShortcut',
            key: 'i',
            attributes: {
                assignStatus: assignee !== null ? 'assign' : 'unassign'
            }
        });
    },
    onSuccess: ({ payload: { concurrentId: concurrentId } })=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(concurrentId)) (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.assignToMeInteraction)(concurrentId).stop();
        });
    }
};
const $7402c8a809d95853$export$f773e45c14115697 = (swagClient)=>(action$)=>action$.ofType((0, $g4P00.ASSIGN_TO_ME_REQUEST)).flatMap((action)=>$7402c8a809d95853$export$59640cb3aa92677(swagClient, action, $7402c8a809d95853$var$hooks));
const $7402c8a809d95853$export$5ed483b9a7992e55 = (action$)=>action$.ofType((0, $g4P00.ASSIGN_TO_ME_REQUEST_THROTTLED)).throttleTime(500).flatMap((action)=>{
        const { cardId: cardId, assignee: assignee, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        (0, $8hVbJ.assignToMeInteraction)(concurrentId).start();
        return (0, $kVLXA.Observable).of((0, $g4P00.assignToMeRequest)({
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }));
    });

});
parcelRegister("aYkSv", function(module, exports) {

$parcel$export(module.exports, "assignToMe", () => $4addbd3196ad60f5$export$521df9d10558315a);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $cNrxd = parcelRequire("cNrxd");

var $1EJrV = parcelRequire("1EJrV");

var $j8ZVG = parcelRequire("j8ZVG");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4addbd3196ad60f5$var$onMutationError = (error)=>{
    if ((0, $1EJrV.isExpectedGraphQLError)(error)) return;
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'assignToMeMutationFailed',
            packageName: 'jiraSoftwareKeyboardShortcuts'
        }
    });
};
const $4addbd3196ad60f5$export$521df9d10558315a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, variables)=>swagClient.mutate({
        mutation: (0, $j8ZVG.MUTATION),
        variables: variables
    }).then((result)=>{
        if (result.errors && result.errors.length || !result.data) throw new (0, $cNrxd.SwagError)({
            // @ts-expect-error - TS2322 - Type 'readonly GraphQLError[] | undefined' is not assignable to type 'GraphqlError[] | undefined'.
            graphQLErrors: result.errors,
            errorMessage: 'Assign to me failed'
        });
        return result.data;
    }).catch((err)=>{
        $4addbd3196ad60f5$var$onMutationError(err);
        throw err;
    });
const $4addbd3196ad60f5$export$5d2cd46d1c41b734 = ()=>{
    const [assignToMeMutation] = (0, $j8ZVG.useAssignToMeMutation)();
    return (0, $5uXOq.useCallback)(({ issueId: issueId, accountId: accountId })=>{
        const assignMutationPromise = assignToMeMutation({
            variables: {
                issueId: issueId,
                accountId: accountId
            }
        });
        assignMutationPromise.catch($4addbd3196ad60f5$var$onMutationError);
        return assignMutationPromise;
    }, [
        assignToMeMutation
    ]);
};

});
parcelRegister("1EJrV", function(module, exports) {

$parcel$export(module.exports, "isExpectedGraphQLError", () => $ec71481172594c19$export$9bfdf944b8987eac);
const $ec71481172594c19$export$9bfdf944b8987eac = (error)=>Boolean(error.graphQLErrors?.length > 0 && error.graphQLErrors?.every((graphQLError)=>{
        const statusCode = graphQLError?.extensions?.statusCode;
        return Boolean(statusCode);
    }));

});

parcelRegister("j8ZVG", function(module, exports) {

$parcel$export(module.exports, "MUTATION", () => $37c313ac561550fe$export$7473a9a03a67999e);
$parcel$export(module.exports, "useAssignToMeMutation", () => $37c313ac561550fe$export$9c4806aca0078faa);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $37c313ac561550fe$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation AssignIssue($issueId: ID!, $accountId: ID) {
        assignIssue(input: { issueId: $issueId, accountId: $accountId }) {
            statusCode
            message
        }
    }
`;
const $37c313ac561550fe$export$9c4806aca0078faa = ()=>(0, $5tTFS.useMutation)($37c313ac561550fe$export$7473a9a03a67999e);

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("4G04L", function(module, exports) {

$parcel$export(module.exports, "scheduleAfterRender", () => $2060ab97dc501826$export$a845aafd0a0e29e6);

var $gg6CF = parcelRequire("gg6CF");

var $6cAn5 = parcelRequire("6cAn5");
const $2060ab97dc501826$export$a845aafd0a0e29e6 = (callback)=>{
    if ($gg6CF && $gg6CF.unstable_scheduleCallback) // Wait a tick for renders that will still be scheduled on this event-loop tick.
    $6cAn5.nextTick(()=>{
        try {
            // Schedule an idle priority callback with react's scheduler.
            $gg6CF.unstable_scheduleCallback($gg6CF.unstable_IdlePriority, ()=>{
                callback();
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // React.js' lower priority is at minimum 0ms or a postMessage tick.
            // Waiting 1ms seems to be a good enough approximation to run after that.
            setTimeout(()=>{
                callback();
            }, 1);
        }
    });
    else setTimeout(()=>{
        callback();
    }, 1);
};

});

parcelRegister("8hVbJ", function(module, exports) {

$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_START", () => $1f56309c299aaf11$export$c4552a2c37c43ea9);
$parcel$export(module.exports, "PAGE_LOAD_MARK_CONSTRUCTOR_END", () => $1f56309c299aaf11$export$6aa9fcaba5907700);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_START", () => $1f56309c299aaf11$export$57eb941eb8f235ee);
$parcel$export(module.exports, "PAGE_LOAD_MARK_REDUX_END", () => $1f56309c299aaf11$export$7f8583ae22e5705f);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START", () => $1f56309c299aaf11$export$765cd8e38999963b);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END", () => $1f56309c299aaf11$export$f7e5395ee7a2ecfb);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_START", () => $1f56309c299aaf11$export$a4eb0ce95caacc19);
$parcel$export(module.exports, "PAGE_LOAD_MARK_RENDER_END", () => $1f56309c299aaf11$export$a4a935943fc371c5);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_START", () => $1f56309c299aaf11$export$f987279f084c1947);
$parcel$export(module.exports, "CRITICAL_RELAY_RESOURCE_GET_DATA_END", () => $1f56309c299aaf11$export$86d7d16316a4fd86);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START", () => $1f56309c299aaf11$export$9437b7e8f9f46514);
$parcel$export(module.exports, "PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END", () => $1f56309c299aaf11$export$6377757b944905f8);
$parcel$export(module.exports, "USE_RESOURCE_START", () => $1f56309c299aaf11$export$226c1bb9e4c0f2ee);
$parcel$export(module.exports, "USE_RESOURCE_READY", () => $1f56309c299aaf11$export$1037ea278e95f493);
$parcel$export(module.exports, "RENDER_START", () => $1f56309c299aaf11$export$672257010af09af1);
$parcel$export(module.exports, "RENDER_END", () => $1f56309c299aaf11$export$b4f76538e9c39ff7);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_START", () => $1f56309c299aaf11$export$c637a04c5a8cc32c);
$parcel$export(module.exports, "JSW_CRITICAL_RESOURCE_END", () => $1f56309c299aaf11$export$cbf503ef2abe660d);
$parcel$export(module.exports, "nextGenBacklogPageLoad", () => $1f56309c299aaf11$export$412da6c620d3c22f);
$parcel$export(module.exports, "uifBacklogNewUiPageLoad", () => $1f56309c299aaf11$export$dafd90f37e91dd7d);
$parcel$export(module.exports, "issueViewOpenInteraction", () => $1f56309c299aaf11$export$412ac2e825a54154);
$parcel$export(module.exports, "issueRankInteraction", () => $1f56309c299aaf11$export$b49f1606cfd9ead4);
$parcel$export(module.exports, "filterInteraction", () => $1f56309c299aaf11$export$8decf314e9f3b4a0);
$parcel$export(module.exports, "issueCreateInteraction", () => $1f56309c299aaf11$export$be312698838f27be);
$parcel$export(module.exports, "issueDeleteInteraction", () => $1f56309c299aaf11$export$1b8cf3f3c2894329);
$parcel$export(module.exports, "flagToggleInteraction", () => $1f56309c299aaf11$export$6c532396e24c45e7);
$parcel$export(module.exports, "assignToMeInteraction", () => $1f56309c299aaf11$export$79f93553011c8d54);
$parcel$export(module.exports, "cardListToggleInteraction", () => $1f56309c299aaf11$export$570f89c911f782e4);
$parcel$export(module.exports, "createSprintInteraction", () => $1f56309c299aaf11$export$208bdc4a71e10bff);
$parcel$export(module.exports, "deleteSprintInteraction", () => $1f56309c299aaf11$export$b4f79447cf23e1d8);
$parcel$export(module.exports, "moveSprintInteraction", () => $1f56309c299aaf11$export$6dc2d6f22f8f27e1);
$parcel$export(module.exports, "startSprintModalLoad", () => $1f56309c299aaf11$export$b582949e90c55414);
$parcel$export(module.exports, "completeSprintModalLoad", () => $1f56309c299aaf11$export$281157708c6b132a);
$parcel$export(module.exports, "customFilterInteraction", () => $1f56309c299aaf11$export$ae56111e009a2b76);
$parcel$export(module.exports, "clearCustomFilterInteraction", () => $1f56309c299aaf11$export$776b3d2eaed43448);
$parcel$export(module.exports, "versionsPanelLoad", () => $1f56309c299aaf11$export$b2b67b41751ce72b);
$parcel$export(module.exports, "inlineEditStatusInteraction", () => $1f56309c299aaf11$export$7e4ecb299cc27d61);
$parcel$export(module.exports, "inlineEditAssigneeInteraction", () => $1f56309c299aaf11$export$2acaf09c8ee524bb);
$parcel$export(module.exports, "inlineEditStoryPointInteraction", () => $1f56309c299aaf11$export$98f90b59da066325);
$parcel$export(module.exports, "inlineEditOriginalEstimateInteraction", () => $1f56309c299aaf11$export$d01dddd30d43031c);

var $cHBMC = parcelRequire("cHBMC");

const $1f56309c299aaf11$export$c4552a2c37c43ea9 = 'CONSTRUCTOR_START';
const $1f56309c299aaf11$export$6aa9fcaba5907700 = 'CONSTRUCTOR_END';
const $1f56309c299aaf11$export$57eb941eb8f235ee = 'REDUX_START';
const $1f56309c299aaf11$export$7f8583ae22e5705f = 'REDUX_END';
const $1f56309c299aaf11$export$765cd8e38999963b = 'TRANSFORM_CRITICAL_START';
const $1f56309c299aaf11$export$f7e5395ee7a2ecfb = 'TRANSFORM_CRITICAL_END';
const $1f56309c299aaf11$export$a4eb0ce95caacc19 = 'RENDER_START';
const $1f56309c299aaf11$export$a4a935943fc371c5 = 'RENDER_END';
const $1f56309c299aaf11$export$f987279f084c1947 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start';
const $1f56309c299aaf11$export$86d7d16316a4fd86 = 'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end';
const $1f56309c299aaf11$export$9437b7e8f9f46514 = 'TRANSFORM_CRITICAL_REST_START';
const $1f56309c299aaf11$export$6377757b944905f8 = 'TRANSFORM_CRITICAL_REST_END';
const $1f56309c299aaf11$export$226c1bb9e4c0f2ee = 'USE_RESOURCE_START';
const $1f56309c299aaf11$export$1037ea278e95f493 = 'USE_RESOURCE_READY';
const $1f56309c299aaf11$export$672257010af09af1 = 'RENDER_START_FRAME';
const $1f56309c299aaf11$export$b4f76538e9c39ff7 = 'RENDER_END_FRAME';
const $1f56309c299aaf11$export$c637a04c5a8cc32c = 'JSW_CRITICAL_RESOURCE_START';
const $1f56309c299aaf11$export$cbf503ef2abe660d = 'JSW_CRITICAL_RESOURCE_END';
const $1f56309c299aaf11$export$6516506c3fb10def = 'EARLY_FETCH_START';
const $1f56309c299aaf11$export$8d6886d639f5aab0 = 'EARLY_FETCH_END';
const $1f56309c299aaf11$var$NEXT_GEN_BACKLOG = 'next-gen-backlog';
const $1f56309c299aaf11$var$UIF_BACKLOG_NEW_UI = 'classic-backlog';
const $1f56309c299aaf11$var$backlogPageLoad = (key)=>(0, $cHBMC.metrics).pageLoad({
        key: key,
        featureFlags: [],
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 14000
                },
                transition: {
                    threshold: 14000
                }
            }
        },
        timings: [
            {
                key: 'product/page-constructor',
                startMark: $1f56309c299aaf11$export$c4552a2c37c43ea9,
                endMark: $1f56309c299aaf11$export$6aa9fcaba5907700
            },
            {
                key: 'product/page-constructor/redux-setup',
                startMark: $1f56309c299aaf11$export$57eb941eb8f235ee,
                endMark: $1f56309c299aaf11$export$7f8583ae22e5705f
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-data',
                startMark: $1f56309c299aaf11$export$765cd8e38999963b,
                endMark: $1f56309c299aaf11$export$f7e5395ee7a2ecfb
            },
            {
                key: 'product/page-constructor/redux-setup/transform-critical-rest-data',
                startMark: $1f56309c299aaf11$export$9437b7e8f9f46514,
                endMark: $1f56309c299aaf11$export$6377757b944905f8
            },
            {
                key: 'product/render',
                startMark: $1f56309c299aaf11$export$a4eb0ce95caacc19,
                endMark: $1f56309c299aaf11$export$a4a935943fc371c5
            },
            {
                key: 'fixed-render',
                startMark: $1f56309c299aaf11$export$672257010af09af1,
                endMark: $1f56309c299aaf11$export$b4f76538e9c39ff7
            },
            {
                key: 'use-resource-call',
                startMark: $1f56309c299aaf11$export$226c1bb9e4c0f2ee,
                endMark: $1f56309c299aaf11$export$1037ea278e95f493
            },
            {
                key: 'critical-resource-get-data',
                startMark: $1f56309c299aaf11$export$f987279f084c1947,
                endMark: $1f56309c299aaf11$export$86d7d16316a4fd86
            },
            {
                key: 'critical-resource',
                startMark: $1f56309c299aaf11$export$c637a04c5a8cc32c,
                endMark: $1f56309c299aaf11$export$cbf503ef2abe660d
            },
            {
                key: 'early-fetch',
                startMark: $1f56309c299aaf11$export$6516506c3fb10def,
                endMark: $1f56309c299aaf11$export$8d6886d639f5aab0
            },
            {
                key: (0, $ce556f125dee8174$export$48552baa9db8ce1d),
                endMark: (0, $ce556f125dee8174$export$99c08ec92759c71c)
            }
        ]
    });
const $1f56309c299aaf11$export$412da6c620d3c22f = $1f56309c299aaf11$var$backlogPageLoad($1f56309c299aaf11$var$NEXT_GEN_BACKLOG);
const $1f56309c299aaf11$export$dafd90f37e91dd7d = $1f56309c299aaf11$var$backlogPageLoad($1f56309c299aaf11$var$UIF_BACKLOG_NEW_UI);
const $1f56309c299aaf11$export$412ac2e825a54154 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.issue-view-open',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000_6000'
    },
    timings: [
        {
            key: 'feedbackPreMount',
            endMark: 'feedbackPreMountEnd'
        }
    ]
});
const $1f56309c299aaf11$export$b49f1606cfd9ead4 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.issue-rank',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '100_200_500_1000_1500'
    }
});
const $1f56309c299aaf11$export$8decf314e9f3b4a0 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '100_200_500_1000_1200_1500'
    }
});
const $1f56309c299aaf11$export$2562fe4b040b7db0 = (0, $cHBMC.metrics).interaction({
    key: 'backlogCardRenderHoverState',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardHover',
            endMark: 'backlogCardHoverRendered'
        }
    ]
});
const $1f56309c299aaf11$export$f735dcf907082d42 = (0, $cHBMC.metrics).interaction({
    key: 'backlogCardMouseLeaveTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardMouseLeaveTiming',
            endMark: 'backlogCardMouseLeaveTimingEnd'
        }
    ]
});
const $1f56309c299aaf11$export$753f9e06af8cfa2e = (0, $cHBMC.metrics).interaction({
    key: 'backlogCardDragDropTargetTiming',
    histogram: {
        result: '100_200_300_500_700_1000_1250_1500_1750_2000_2500_3000',
        response: ''
    },
    timings: [
        {
            key: 'backlogCardDragDropTargetTiming',
            endMark: 'backlogCardDragDropTargetRendered'
        }
    ]
});
const $1f56309c299aaf11$export$be312698838f27be = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.issue-create',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '1000_2000_3000_4000_5000'
    }
});
const $1f56309c299aaf11$export$1b8cf3f3c2894329 = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.issue-delete'
});
const $1f56309c299aaf11$export$6c532396e24c45e7 = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.flag-toggle',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $1f56309c299aaf11$export$79f93553011c8d54 = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.assign-to-me',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $1f56309c299aaf11$export$570f89c911f782e4 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.card-list-toggle'
});
const $1f56309c299aaf11$export$208bdc4a71e10bff = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.sprint-create'
});
const $1f56309c299aaf11$export$b4f79447cf23e1d8 = (0, $cHBMC.metrics).concurrent.interaction({
    key: 'backlog.sprint-delete',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $1f56309c299aaf11$export$6dc2d6f22f8f27e1 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.sprint-move',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000'
    }
});
const $1f56309c299aaf11$export$b582949e90c55414 = (0, $cHBMC.metrics).interaction({
    key: 'start-sprint-modal-load'
});
const $1f56309c299aaf11$export$281157708c6b132a = (0, $cHBMC.metrics).interaction({
    key: 'complete-sprint-modal-load'
});
const $1f56309c299aaf11$export$ae56111e009a2b76 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.custom-filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $1f56309c299aaf11$export$776b3d2eaed43448 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.clear-custom-filter'
});
const $1f56309c299aaf11$export$b2b67b41751ce72b = (0, $cHBMC.metrics).interaction({
    key: 'backlog.versions-panel-load'
});
const $1f56309c299aaf11$export$7e4ecb299cc27d61 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.inline-issue-field-status'
});
const $1f56309c299aaf11$export$2acaf09c8ee524bb = (0, $cHBMC.metrics).interaction({
    key: 'backlog.inline-issue-field-assignee'
});
const $1f56309c299aaf11$export$98f90b59da066325 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.inline-issue-field-story-point'
});
const $1f56309c299aaf11$export$d01dddd30d43031c = (0, $cHBMC.metrics).interaction({
    key: 'backlog.inline-issue-field-original-estimate'
});

});

parcelRegister("g4P00", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST", () => $2d9ad77c206dcf96$export$4a7b4d6811230566);
$parcel$export(module.exports, "assignToMeRequest", () => $2d9ad77c206dcf96$export$e2776354d9221c82);
$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST_THROTTLED", () => $2d9ad77c206dcf96$export$f241ab4d2fe8b61e);
$parcel$export(module.exports, "assignToMeRequestThrottled", () => $2d9ad77c206dcf96$export$13bfccdb4d681951);
$parcel$export(module.exports, "assignToMeSuccess", () => $2d9ad77c206dcf96$export$caabee9a075ba7f1);
$parcel$export(module.exports, "assignToMeFailure", () => $2d9ad77c206dcf96$export$50fd16f97611da56);

var $c0irb = parcelRequire("c0irb");
const $2d9ad77c206dcf96$export$4a7b4d6811230566 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST';
const $2d9ad77c206dcf96$export$e2776354d9221c82 = ({ cardId: cardId, assignee: assignee, concurrentId: concurrentId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn })=>({
        type: $2d9ad77c206dcf96$export$4a7b4d6811230566,
        payload: {
            cardId: cardId,
            assignee: assignee,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $2d9ad77c206dcf96$export$f241ab4d2fe8b61e = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_REQUEST_THROTTLED';
const $2d9ad77c206dcf96$export$13bfccdb4d681951 = (cardId, assignee, fireShortcutAnalyticsFn)=>({
        type: $2d9ad77c206dcf96$export$f241ab4d2fe8b61e,
        payload: {
            cardId: cardId,
            assignee: assignee,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $2d9ad77c206dcf96$export$1249a100986a9489 = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_SUCCESS';
const $2d9ad77c206dcf96$export$caabee9a075ba7f1 = (optimisticId, concurrentId)=>({
        type: $2d9ad77c206dcf96$export$1249a100986a9489,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $2d9ad77c206dcf96$export$1ce003be5a9445ee = 'state.actions.cards.assign-to-me.ASSIGN_TO_ME_FAILURE';
const $2d9ad77c206dcf96$export$50fd16f97611da56 = (optimisticId, concurrentId)=>({
        type: $2d9ad77c206dcf96$export$1ce003be5a9445ee,
        payload: {
            concurrentId: concurrentId
        },
        meta: (0, $c0irb.revertOptimisticUiMeta)(optimisticId)
    });

});


parcelRegister("gqn54", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollOnFilterEpic", () => $b70d4603454af212$export$1eee00ad491917f1);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $9Z18E = parcelRequire("9Z18E");

var $dGljH = parcelRequire("dGljH");
const $b70d4603454af212$export$1eee00ad491917f1 = (action$, store)=>action$.ofType((0, $9Z18E.CARD_AUTO_SCROLL_REQUEST_ON_FILTER)).mergeMap(()=>{
        const state = store.getState();
        const selectedIssueId = (0, $dGljH.getLastSelectedCard)(state);
        return selectedIssueId ? (0, $kVLXA.Observable).of((0, $9Z18E.cardAutoScroll)(selectedIssueId)) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("9Z18E", function(module, exports) {

$parcel$export(module.exports, "CARD_AUTO_SCROLL", () => $ce845b910b9935bd$export$21e828c0e9d1105a);
$parcel$export(module.exports, "cardAutoScroll", () => $ce845b910b9935bd$export$274e46dc8e4633e0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_FILTER", () => $ce845b910b9935bd$export$3a965e6001d5e2e9);
$parcel$export(module.exports, "cardAutoScrollRequestOnFilter", () => $ce845b910b9935bd$export$58d9ced87e626159);
const $ce845b910b9935bd$export$21e828c0e9d1105a = 'state.actions.card.CARD_AUTO_SCROLL';
const $ce845b910b9935bd$export$274e46dc8e4633e0 = (cardId)=>({
        type: $ce845b910b9935bd$export$21e828c0e9d1105a,
        payload: {
            cardId: cardId
        }
    });
const $ce845b910b9935bd$export$3a965e6001d5e2e9 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_FILTER';
const $ce845b910b9935bd$export$58d9ced87e626159 = ()=>({
        type: $ce845b910b9935bd$export$3a965e6001d5e2e9
    });

});


parcelRegister("eKj5K", function(module, exports) {

$parcel$export(module.exports, "cardClickEpic", () => $e232d0c2125d72fa$export$d1fdf7f3fe665b5b);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $f6RVN = parcelRequire("f6RVN");


var $7SF9g = parcelRequire("7SF9g");

var $cik5h = parcelRequire("cik5h");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $9g0YE = parcelRequire("9g0YE");

var $dGljH = parcelRequire("dGljH");
const $e232d0c2125d72fa$var$getCardIdsToListSelection = (state, relativeCardId, clickedCardId)=>{
    const relativeCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(relativeCardId);
    const clickedCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(clickedCardId);
    if (!relativeCardListId || !clickedCardListId) return [];
    // selecting from the same card list
    if (relativeCardListId === clickedCardListId) {
        const cards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
        const relativeCardIndex = cards.indexOf(relativeCardId);
        const clickedCardIndex = cards.indexOf(clickedCardId);
        const cardInBetween = clickedCardIndex > relativeCardIndex ? cards.slice(relativeCardIndex, clickedCardIndex + 1) : cards.slice(clickedCardIndex, relativeCardIndex + 1).reverse();
        return cardInBetween;
    }
    // selecting from across card lists
    const orderedCardListIds = (0, $dGljH.getOrderedCardListIds)(state);
    const relativeCardListIndex = orderedCardListIds.indexOf(relativeCardListId);
    const clickedCardListIndex = orderedCardListIds.indexOf(clickedCardListId);
    const isSelectingCardListBelow = clickedCardListIndex > relativeCardListIndex;
    // getting all cards in card lists that are in between the relative and clicked cards
    const cardListsInBetween = orderedCardListIds.filter((_, index)=>{
        if (isSelectingCardListBelow) return index > relativeCardListIndex && index < clickedCardListIndex;
        return index > clickedCardListIndex && index < relativeCardListIndex;
    });
    const cardsInBetweenCardList = cardListsInBetween.reduce((result, key)=>result.concat((0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(key)), []);
    const orderedCardsInBetweenCardLists = isSelectingCardListBelow ? cardsInBetweenCardList : cardsInBetweenCardList.reverse();
    // getting cards from where the relative card is based on the card order
    const relativeCardListCards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(relativeCardListId);
    const cardsToAddInRelativeCardList = isSelectingCardListBelow ? relativeCardListCards.slice(relativeCardListCards.indexOf(relativeCardId), relativeCardListCards.length) : relativeCardListCards.slice(0, relativeCardListCards.indexOf(relativeCardId) + 1).reverse();
    // getting cards from where the clicked card is based on the card order
    const clickedCardListCards = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(clickedCardListId);
    const cardsToAddInClickedCardList = isSelectingCardListBelow ? clickedCardListCards.slice(0, clickedCardListCards.indexOf(clickedCardId) + 1) : clickedCardListCards.slice(clickedCardListCards.indexOf(clickedCardId), clickedCardListCards.length).reverse();
    return [
        ...cardsToAddInRelativeCardList,
        ...orderedCardsInBetweenCardLists,
        ...cardsToAddInClickedCardList
    ];
};
const $e232d0c2125d72fa$var$getLocationAfterCloseInsights = (location)=>(0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), false, location);
const $e232d0c2125d72fa$export$d1fdf7f3fe665b5b = (getLocation, push)=>(action$, store)=>action$.ofType((0, $4mqko.CARD_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId, withCmd: withCmd, withShift: withShift } = action.payload;
            const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
            const focusedCard = (0, $dGljH.getFocusedCard)(state);
            const getCardKeyFromCardId = (0, $dGljH.makeCardKeyFromCardId)(state);
            if (!withShift && !withCmd && action.payload.externalAction) {
                const actions = [
                    (0, $4mqko.cardSingleSelect)(cardId)
                ];
                actions.push((0, $9g0YE.closeInsightsPanel)(false));
                (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $9g0YE.closeViewSettingsPanel)());
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $cik5h.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $e232d0c2125d72fa$var$getLocationAfterCloseInsights(getLocation())));
                actions.push((0, $38qhf.openDetailView)(cardId, action.payload.externalAction));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            if (!withShift && !withCmd) {
                const actions = [
                    (0, $4mqko.cardSingleSelect)(cardId),
                    (0, $38qhf.openDetailView)(cardId)
                ];
                actions.push((0, $9g0YE.closeInsightsPanel)(false));
                (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && actions.push((0, $9g0YE.closeViewSettingsPanel)());
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(!!action.payload.withCheckbox));
                push((0, $cik5h.addSelectedIssueToUrl)(getCardKeyFromCardId(cardId), $e232d0c2125d72fa$var$getLocationAfterCloseInsights(getLocation())));
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: 1,
                    issue_ids: [
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withShift && withCmd) {
                const relativeCardId = (0, $dGljH.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $kVLXA.Observable).empty();
                const cardsToBeSelected = $e232d0c2125d72fa$var$getCardIdsToListSelection(state, relativeCardId, cardId);
                const relativeCardIndex = selectedCardIds.indexOf(relativeCardId);
                const newSelectionList = selectedCardIds.slice(0, relativeCardIndex === -1 ? selectedCardIds.length : relativeCardIndex) // clean last shift+cmd list selection
                .filter((cardIdInSelectedList)=>!cardsToBeSelected.includes(cardIdInSelectedList)) // unique list
                .concat(cardsToBeSelected);
                const actions = [
                    (0, $4mqko.cardMultiSelect)(newSelectionList)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: newSelectionList.length,
                    issue_ids: newSelectionList
                });
                actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withShift) {
                const relativeCardId = (0, $dGljH.getListSelectionRelativeCard)(state);
                if (!relativeCardId) return (0, $kVLXA.Observable).empty();
                const cardsToBeSelected = $e232d0c2125d72fa$var$getCardIdsToListSelection(state, relativeCardId, cardId).reverse();
                const actions = [
                    (0, $4mqko.cardMultiSelect)(cardsToBeSelected)
                ];
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: cardsToBeSelected.length,
                    issue_ids: cardsToBeSelected
                });
                focusedCard !== relativeCardId && actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                return (0, $kVLXA.Observable).from(actions);
            }
            if (withCmd) {
                const actions = [];
                if (selectedCardIds.length === 1 && cardId === selectedCardIds[0]) {
                    actions.push((0, $4mqko.cardEmptySelection)(), (0, $38qhf.closeDetailView)());
                    actions.push((0, $8SI0F.setCheckboxSelectionMode)(false));
                } else {
                    actions.push((0, $4mqko.cardToggleSelection)(cardId));
                    actions.push((0, $8SI0F.setCheckboxSelectionMode)(true));
                }
                action.payload.fireSelectionAnalytics?.({
                    numSelectedCards: selectedCardIds.includes(cardId) ? selectedCardIds.length - 1 : selectedCardIds.length + 1,
                    issue_ids: selectedCardIds.includes(cardId) ? selectedCardIds.filter((id)=>id !== cardId) : [
                        ...selectedCardIds,
                        cardId
                    ]
                });
                return (0, $kVLXA.Observable).from(actions);
            }
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("7SF9g", function(module, exports) {

$parcel$export(module.exports, "setPanelsUrl", () => $85434ff057809d96$export$b0d97eda249239c5);
parcelRequire("6hSeW");
parcelRequire("fp4O3");

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

const $85434ff057809d96$export$b0d97eda249239c5 = (panel, isOpen, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    if (isOpen) // using 'visible' as this is what the old CMP uses
    search.set(panel, panel === (0, $4f4a02cead13bb5a$export$61119f100c357d06) ? true : 'visible');
    else search.unset(panel);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("cik5h", function(module, exports) {

$parcel$export(module.exports, "addSelectedIssueToUrl", () => $fe1f24bd5e953f6b$export$56eb5b2509c9e59c);
$parcel$export(module.exports, "removeSelectedIssueFromUrl", () => $fe1f24bd5e953f6b$export$e850ae281e93782);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

const $fe1f24bd5e953f6b$export$56eb5b2509c9e59c = (cardKey, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.set((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa), cardKey);
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $fe1f24bd5e953f6b$export$e850ae281e93782 = (location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("8SI0F", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_SELECTION_MODE", () => $eca1da487a90baaa$export$2993cc8e0a65cc79);
$parcel$export(module.exports, "setCheckboxSelectionMode", () => $eca1da487a90baaa$export$bb628ef7fc94ed9);
const $eca1da487a90baaa$export$2993cc8e0a65cc79 = 'state.actions.cards.checkbox-selection-mode.CHECKBOX_SELECTION_MODE';
const $eca1da487a90baaa$export$bb628ef7fc94ed9 = (isCheckboxSelectionMode)=>({
        type: $eca1da487a90baaa$export$2993cc8e0a65cc79,
        payload: {
            isCheckboxSelectionMode: isCheckboxSelectionMode
        }
    });

});

parcelRegister("9g0YE", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_PANEL", () => $7804c0f987e094d3$export$81879e9427948bf);
$parcel$export(module.exports, "togglePanel", () => $7804c0f987e094d3$export$67879b1cfc177b88);
$parcel$export(module.exports, "CLOSE_INSIGHTS_PANEL", () => $7804c0f987e094d3$export$8e43d92e9c342d0);
$parcel$export(module.exports, "closeInsightsPanel", () => $7804c0f987e094d3$export$4fda8ba2e49f8d0c);
$parcel$export(module.exports, "CLOSE_VIEW_SETTINGS_PANEL", () => $7804c0f987e094d3$export$b1f480ba0abd2610);
$parcel$export(module.exports, "closeViewSettingsPanel", () => $7804c0f987e094d3$export$ef3e4b5eca4263a7);
$parcel$export(module.exports, "SET_ALL_PANELS", () => $7804c0f987e094d3$export$c2b45216f8258443);
$parcel$export(module.exports, "setAllPanels", () => $7804c0f987e094d3$export$550d1aa0feb70ab4);
$parcel$export(module.exports, "SET_ALL_PANELS_SUCCESS", () => $7804c0f987e094d3$export$8c036bde1eda2c94);
const $7804c0f987e094d3$export$81879e9427948bf = 'state.actions.panels.TOGGLE_PANEL';
const $7804c0f987e094d3$export$67879b1cfc177b88 = (panel)=>({
        type: $7804c0f987e094d3$export$81879e9427948bf,
        payload: {
            panel: panel
        }
    });
const $7804c0f987e094d3$export$8e43d92e9c342d0 = 'state.actions.panels.CLOSE_INSIGHTS_PANEL';
const $7804c0f987e094d3$export$4fda8ba2e49f8d0c = (shouldUpdateLocation = true)=>({
        type: $7804c0f987e094d3$export$8e43d92e9c342d0,
        payload: {
            shouldUpdateLocation: shouldUpdateLocation
        }
    });
const $7804c0f987e094d3$export$b1f480ba0abd2610 = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL';
const $7804c0f987e094d3$export$ef3e4b5eca4263a7 = ()=>({
        type: $7804c0f987e094d3$export$b1f480ba0abd2610
    });
const $7804c0f987e094d3$export$c2b45216f8258443 = 'state.actions.panels.SET_ALL_PANELS';
const $7804c0f987e094d3$export$550d1aa0feb70ab4 = ()=>({
        type: $7804c0f987e094d3$export$c2b45216f8258443
    });
const $7804c0f987e094d3$export$8c036bde1eda2c94 = 'state.actions.panels.SET_ALL_PANELS_SUCCESS';
const $7804c0f987e094d3$export$9491aa22a408c1a9 = (panels)=>({
        type: $7804c0f987e094d3$export$8c036bde1eda2c94,
        payload: {
            panels: panels
        }
    });

});


parcelRegister("lTfMj", function(module, exports) {

$parcel$export(module.exports, "cardCreateMultipleGqlEpic", () => $0ee7d1e105ae28ce$export$2d487b79844af2c);

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $fZneA = parcelRequire("fZneA");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $4cr9K = parcelRequire("4cr9K");

var $cNrxd = parcelRequire("cNrxd");

var $guzeq = parcelRequire("guzeq");


var $hNeni = parcelRequire("hNeni");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $5Eoed = parcelRequire("5Eoed");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");

var $aU3CO = parcelRequire("aU3CO");

var $bAfUr = parcelRequire("bAfUr");
const $0ee7d1e105ae28ce$var$parseFirstFetchErrorMessage = (error)=>{
    if ((0, $cNrxd.isJson)(error.message)) {
        const response = JSON.parse(error.message);
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))((0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(response, 'errors', null))) ?? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(response, 'generalErrors[0]', null) ?? null);
    }
    return error.message;
};
const $0ee7d1e105ae28ce$var$getBadRequestErrorMessage = (error)=>{
    if ((0, $cNrxd.isSwagError)(error)) {
        const badRequestError = error.graphQLErrors.find(({ extensions: { statusCode: statusCode } })=>statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977));
        return badRequestError ? badRequestError.message : null;
    }
    if ((0, $cNrxd.isFetchError)(error) && error.statusCode === (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977)) return $0ee7d1e105ae28ce$var$parseFirstFetchErrorMessage(error);
    return null;
};
const $0ee7d1e105ae28ce$export$2d487b79844af2c = (action$, store)=>action$.ofType((0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST)).mergeMap((action)=>{
        const { payload: { listId: listId, insertBefore: insertBefore, storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData, tempIds: tempIds, summaries: summaries, typeId: typeId, parentId: parentId, fixVersions: fixVersions }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        const inlineCreateSessionId = (0, $aU3CO.getInlineCreateSessionId)(state);
        return (0, $hNeni.cardCreateService)(serviceContext, store, summaries, typeId, parentId, fixVersions, listId, insertBefore, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData).flatMap((cardsCreated)=>{
            if (cardsCreated === null) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmapped)(summaries.length, null, optimisticId, analyticsEvent));
            if (!(0, $bAfUr.isStatusMappedToBoardOld)(cardsCreated[0].statusId)(state)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmapped)(summaries.length, cardsCreated.map((cardCreated)=>cardCreated.key), optimisticId, analyticsEvent));
            const actions = cardsCreated.map((cardCreated, index)=>(0, $hf5c2.cardCreateSuccess)(cardCreated, listId, tempIds[index], insertBefore !== null, summaries.length > 1, optimisticId, analyticsEvent));
            // We should refetch versions data when an issue is inline created to keep the version panel on sync
            // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
            actions.push((0, $gwOHY.refetchVersions)());
            if ((0, $jG5HW.isCmpKanbanProject)(state)) {
                const cardListStatusId = (0, $bAfUr.makeGetKanbanSingleColumnStatusId)(state)(listId);
                if (cardListStatusId && !(0, $bAfUr.areStatusesFromSameColumn)(state)(cardListStatusId, cardsCreated[0].statusId)) actions.push((0, $3lZ6i.loadAppData)());
            }
            return (0, $kVLXA.Observable).from(actions);
        }).catch((error)=>{
            const validationErrorMessage = $0ee7d1e105ae28ce$var$getBadRequestErrorMessage(error);
            const statusCode = (0, $3vXOY.extractStatusCode)(error);
            const isClientFetchError = (0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isUserNetworkError)(error);
            if (validationErrorMessage) return (0, $kVLXA.Observable).from([
                (0, $5Eoed.openModal)({
                    type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                    payload: {
                        cardListId: listId,
                        cardParentId: parentId,
                        cardSummary: summaries[0],
                        cardTypeId: typeId,
                        rankBeforeCardId: insertBefore,
                        fixVersions: fixVersions,
                        submitErrorMessage: validationErrorMessage,
                        sessionId: inlineCreateSessionId
                    }
                }),
                (0, $hf5c2.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, isClientFetchError)
            ]);
            return (0, $kVLXA.Observable).from([
                (0, $hf5c2.cardCreateFailure)(summaries.length, optimisticId, error.message, statusCode, isClientFetchError, analyticsEvent),
                (0, $4cr9K.showErrorFlag)(error),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

parcelRegister("01j5n", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $5ca31bd2f34603ab$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $5ca31bd2f34603ab$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $5ca31bd2f34603ab$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $5ca31bd2f34603ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $g0Gtc = parcelRequire("g0Gtc");

var $dJl1T = parcelRequire("dJl1T");

var $kobfu = parcelRequire("kobfu");

var $co1wz = parcelRequire("co1wz");

var $fZneA = parcelRequire("fZneA");

var $dIdda = parcelRequire("dIdda");

var $eKlYC = parcelRequire("eKlYC");

var $hdE8g = parcelRequire("hdE8g");

var $3vXOY = parcelRequire("3vXOY");

var $e2KRD = parcelRequire("e2KRD");

const $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReasonWithStatusCode)((0, $3e83829bdc9c581d$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $5ca31bd2f34603ab$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $5ca31bd2f34603ab$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $5ca31bd2f34603ab$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $5ca31bd2f34603ab$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($5ca31bd2f34603ab$export$34bc86f6bf17f1e0(errorResponse)) return 0, $3e83829bdc9c581d$export$3c39b2049cd1acb3;
    if ($5ca31bd2f34603ab$export$8a5d666d6e5b82fc(errorResponse)) return 0, $3e83829bdc9c581d$export$fdfe3175a0c7be80;
    if ((0, $fZneA.isClientFetchError)(errorResponse)) return 0, $3e83829bdc9c581d$export$38fe4329f59f7ac5;
    if ((0, $co1wz.ff)('jsw.cmp.response-null-abort') && $5ca31bd2f34603ab$export$7193151b5738a995(errorResponse)) return 0, $3e83829bdc9c581d$export$49d11848b43d6dbf;
    if ($5ca31bd2f34603ab$export$ed0f33c09abc69f3(errorResponse)) return 0, $3e83829bdc9c581d$export$32e56551129a1642;
    return null;
};
const $5ca31bd2f34603ab$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(errorResponse);
    const abortFailureReason = $5ca31bd2f34603ab$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $hdE8g.extractTraceId)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const hash = (0, $kobfu.getErrorHash)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(window, [
        'BUILD_KEY'
    ]) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $3e83829bdc9c581d$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash,
            isBacklogWithRelayEnabled: (0, $eKlYC.isBacklogWithRelayEnabled)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // 40x missing permission, experience does not exist, not logged in, etc
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
        to: "/jira/projects?showFlag=jsw.project-not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $5ca31bd2f34603ab$export$2e2bcd8739ae039 = $5ca31bd2f34603ab$var$responseToSla;

});
parcelRegister("eKlYC", function(module, exports) {

$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $988924d63bfd64f6$export$bc84f8a9593e9b2c);

var $co1wz = parcelRequire("co1wz");
const $988924d63bfd64f6$export$bc84f8a9593e9b2c = ()=>(0, $co1wz.ff)('jsw.perf.critical-backlog-with-relay');

});

parcelRegister("hdE8g", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $6db1ddf832c04f2d$export$431eacb6aecbacdf);
const $6db1ddf832c04f2d$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("3vXOY", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $47b135a1579c5003$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $47b135a1579c5003$export$1fdf7c1c0741a7e7);

var $9XE6b = parcelRequire("9XE6b");

var $fEeCa = parcelRequire("fEeCa");
const $47b135a1579c5003$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(statusCodes);
    return statusCode || null;
};
const $47b135a1579c5003$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $47b135a1579c5003$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});

parcelRegister("e2KRD", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $360af9265ac477eb$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $360af9265ac477eb$export$cc7dce678df87fe9);
const $360af9265ac477eb$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $360af9265ac477eb$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $3e83829bdc9c581d$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $3e83829bdc9c581d$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $3e83829bdc9c581d$export$7b9f56c34c008ec2 = '429-error';
const $3e83829bdc9c581d$export$3c39b2049cd1acb3 = 'user-network-error';
const $3e83829bdc9c581d$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $3e83829bdc9c581d$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $3e83829bdc9c581d$export$49d11848b43d6dbf = 'response-null-error';
const $3e83829bdc9c581d$export$32e56551129a1642 = 'client-third-party-app-error';
const $3e83829bdc9c581d$export$fa14a20fcf1b1eb4 = 'unknown';


const $b107c54ec82f76f2$export$86a0c18887a92eae = 'MOVE_CARDS_ACTIVE_SPRINT';
const $b107c54ec82f76f2$export$dcb8eb3e585ecde = 'MOVE_CARD_SELECT_TRANSITION';
const $b107c54ec82f76f2$export$87c7cb14aa706e2d = 'DELETE_CARD';
const $b107c54ec82f76f2$export$96d8f8ff51c496e3 = 'DELETE_SPRINT';
const $b107c54ec82f76f2$export$9d5b8103d4fbbb34 = 'ASSIGN_ISSUE_PARENT';
const $b107c54ec82f76f2$export$55cae6fd3c958bc5 = 'GLOBAL_ISSUE_CREATE';
const $b107c54ec82f76f2$export$77e94846ed2f57d7 = 'SPLIT_ISSUE_BACKLOG';
const $b107c54ec82f76f2$export$34f52cb2089ddc40 = 'FLAG_WITH_COMMENT_BACKLOG';

parcelRegister("hNeni", function(module, exports) {

$parcel$export(module.exports, "cardCreateService", () => $8e7733a925b3c12d$export$73bba27938f44f97);

var $hYfgW = parcelRequire("hYfgW");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $8URt5 = parcelRequire("8URt5");

var $k35me = parcelRequire("k35me");

var $eWiJG = parcelRequire("eWiJG");

var $aqpnO = parcelRequire("aqpnO");
const $8e7733a925b3c12d$var$createOverrides = (state, cardListId)=>{
    const isSprintCardList = (0, $k35me.makeIsSprintCardList)(state);
    const epicLinkShortCustomFieldId = (0, $9Pc1U.epicLinkShortCustomFieldIdSelector)(state);
    const sprintShortCustomFieldId = (0, $9Pc1U.sprintShortCustomFieldIdSelector)(state);
    const sprintId = isSprintCardList(cardListId) ? Number(cardListId) : undefined;
    const issueParent = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $fmuR9.filteredParentsSelector)(state));
    const assignee = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedAssigneeFilters)(state));
    const version = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedVersionFilters)(state));
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $l9VFH.getAppliedLabelFilters)(state));
    return {
        ...assignee ? {
            assignee: assignee
        } : {},
        ...sprintId && sprintShortCustomFieldId ? {
            [sprintShortCustomFieldId]: sprintId
        } : {},
        ...issueParent && epicLinkShortCustomFieldId ? {
            [epicLinkShortCustomFieldId]: issueParent.key
        } : {},
        ...version ? {
            fixVersion: version
        } : {},
        ...label ? {
            labels: label
        } : {}
    };
};
function $8e7733a925b3c12d$export$73bba27938f44f97(serviceContext, store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData) {
    if (serviceContext.isCompanyManaged) {
        const state = store.getState();
        const contexts = (0, $8URt5.jqlContextSelector)(state);
        const epicIssueType = (0, $jG5HW.getEpicIssueType)(state);
        const overrides = $8e7733a925b3c12d$var$createOverrides(state, cardListId);
        return (0, $aqpnO.inlineCardCreateService)(serviceContext, {
            summary: summaries[0],
            issueTypeId: String(issueTypeId),
            contexts: contexts,
            overrides: overrides,
            epicIssueType: epicIssueType,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData
        });
    }
    return (0, $eWiJG.createMultipleCardService)(store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId, storeFieldsFromCardCreateData);
}

});
parcelRegister("9Pc1U", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $f4b895e6f32be889$export$44487a86467333c3);
$parcel$export(module.exports, "isConfigLoaded", () => $f4b895e6f32be889$export$d39ab0d27414dd81);
$parcel$export(module.exports, "isCriticalDataLoaded", () => $f4b895e6f32be889$export$d3455c208c1b3727);
$parcel$export(module.exports, "isUserAtLeastMemberOfProject", () => $f4b895e6f32be889$export$56dbce3d18728488);
$parcel$export(module.exports, "isInlineIssueCreateAvailableForCurrentUser", () => $f4b895e6f32be889$export$61b79888ee8d503a);
$parcel$export(module.exports, "getAllFeatures", () => $f4b895e6f32be889$export$a15e774d3d888bb9);
$parcel$export(module.exports, "getShowEpicAsPanel", () => $f4b895e6f32be889$export$60ba0c8082dd51bc);
$parcel$export(module.exports, "getEpicLinkField", () => $f4b895e6f32be889$export$3a84de4f399e5939);
$parcel$export(module.exports, "getEpicColorFieldId", () => $f4b895e6f32be889$export$b02b4f80d1c4ab0b);
$parcel$export(module.exports, "epicLinkShortCustomFieldIdSelector", () => $f4b895e6f32be889$export$71a1cd2c8522f4bf);
$parcel$export(module.exports, "sprintShortCustomFieldIdSelector", () => $f4b895e6f32be889$export$d1c61551fd7c800e);
$parcel$export(module.exports, "getCanInviteOthersToProject", () => $f4b895e6f32be889$export$5124aa00ca92f2c0);

var $dGvGJ = parcelRequire("dGvGJ");

var $f01qr = parcelRequire("f01qr");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");
const $f4b895e6f32be889$export$44487a86467333c3 = (state)=>state.config;
const $f4b895e6f32be889$export$d39ab0d27414dd81 = (state)=>state.ui.isConfigLoaded;
const $f4b895e6f32be889$export$d3455c208c1b3727 = (state)=>state.ui.isCriticalDataLoaded;
const $f4b895e6f32be889$export$65853863ca35552 = (state)=>$f4b895e6f32be889$export$44487a86467333c3(state).isInlineCardCreateEnabled;
const $f4b895e6f32be889$var$canViewBoardAndCreateOrMutateIssues = (state)=>(0, $1z1J7.canViewBoard)(state) && ((0, $1z1J7.canCreateIssues)(state) || (0, $1z1J7.canEditIssue)(state) || (0, $1z1J7.canDeleteIssues)(state) || (0, $1z1J7.canAssignIssues)(state) || (0, $1z1J7.canTransitionIssues)(state) || (0, $1z1J7.canBulkEditIssues)(state));
const $f4b895e6f32be889$var$canCreateOrMutateIssues = (state)=>(0, $1z1J7.canCreateIssues)(state) || (0, $1z1J7.canEditIssue)(state) || (0, $1z1J7.canDeleteIssues)(state);
const $f4b895e6f32be889$export$56dbce3d18728488 = (state)=>// This is a proxy for the DW idea of Project 'Member' but it's still flawed and not compatible with company-managed permission model.
    // If a user can create, edit or delete issues in this project, they must be at least a Member,
    // and enjoy all the privileges of a Project Member (e.g. creating and ranking issues).
    (0, $jG5HW.getIsCompanyManaged)(state) ? $f4b895e6f32be889$var$canViewBoardAndCreateOrMutateIssues(state) : $f4b895e6f32be889$var$canCreateOrMutateIssues(state);
const $f4b895e6f32be889$export$61b79888ee8d503a = (0, $dGvGJ.createSelector)([
    $f4b895e6f32be889$export$56dbce3d18728488,
    (0, $jG5HW.getIsCompanyManaged),
    (0, $1z1J7.canCreateIssues)
], (isMember, isCompanyManaged, canUserCreateIssues)=>isCompanyManaged ? canUserCreateIssues : isMember);
const $f4b895e6f32be889$export$a15e774d3d888bb9 = (state)=>state.config.allFeatures;
const $f4b895e6f32be889$export$60ba0c8082dd51bc = (state)=>!(0, $jG5HW.getIsCompanyManaged)(state) || state.config.showEpicAsPanel;
const $f4b895e6f32be889$export$3a84de4f399e5939 = (state)=>state.config.epicLinkField;
const $f4b895e6f32be889$export$b02b4f80d1c4ab0b = (state)=>state.config.epicColorFieldId;
const $f4b895e6f32be889$export$71a1cd2c8522f4bf = (0, $dGvGJ.createSelector)([
    $f4b895e6f32be889$export$3a84de4f399e5939
], (epicLinkField)=>epicLinkField?.id ? (0, $f01qr.toShortCustomFieldId)(epicLinkField?.id) : undefined);
const $f4b895e6f32be889$export$d1c61551fd7c800e = (0, $dGvGJ.createSelector)([
    (0, $jG5HW.getSprintFieldId)
], (sprintCustomFieldId)=>sprintCustomFieldId ? (0, $f01qr.toShortCustomFieldId)(sprintCustomFieldId) : undefined);
const $f4b895e6f32be889$export$5124aa00ca92f2c0 = (state)=>state.config.canInviteOthersToProject;

});

parcelRegister("8URt5", function(module, exports) {

$parcel$export(module.exports, "jqlContextSelector", () => $85418be1dfd8983d$export$a0b5ed948695afc3);

var $dGvGJ = parcelRequire("dGvGJ");

var $l9VFH = parcelRequire("l9VFH");
const $85418be1dfd8983d$export$2af3643b1d2591eb = (state)=>state.config.jqlQuery;
const $85418be1dfd8983d$export$a0b5ed948695afc3 = (0, $dGvGJ.createSelector)([
    $85418be1dfd8983d$export$2af3643b1d2591eb,
    (0, $l9VFH.getAppliedCustomFilterQueries)
], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(jqlQuery, jqlCustomFilters)=>[
        jqlQuery,
        ...jqlCustomFilters
    ]);

});

parcelRegister("eWiJG", function(module, exports) {

$parcel$export(module.exports, "createMultipleCardService", () => $f9f16a630333a4e4$export$76edf6a735664e34);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $a0k9j = parcelRequire("a0k9j");

var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $dGljH = parcelRequire("dGljH");
const $f9f16a630333a4e4$var$transformer = ({ id: id, done: isDone, flagged: isFlagged, parentId: parentId, fixVersions: fixVersions, issue: { key: key, summary: summary, type: { id: cardTypeId, iconUrl: cardTypeUrl }, labels: labels, status: { id: statusId }, assignee: assignee }, priority: priority, dueDate: dueDate }, projectId)=>({
        id: Number(id),
        key: key,
        summary: summary,
        icon: cardTypeUrl,
        typeId: Number(cardTypeId),
        isDone: isDone,
        labels: labels,
        isFlagged: isFlagged,
        assignee: assignee ? {
            id: assignee.accountId,
            displayName: assignee.displayName,
            avatarUrl: assignee.avatarUrl
        } : null,
        issueUrl: `/browse/${key}`,
        statusId: statusId,
        parentId: parentId || '' ? Number(parentId) : null,
        fixVersions: fixVersions || [],
        priority: priority,
        dueDate: dueDate,
        estimate: null,
        numCompleteChildren: 0,
        numTotalChildren: 0,
        projectId: projectId
    });
const $f9f16a630333a4e4$export$76edf6a735664e34 = (// TODO: Passing the store is against the architecture, use service-context instead and request objects;
// additionally, don't pass in a callback parameter
store, summaries, issueTypeId, parentId, fixVersions, cardListId, rankBeforeCardId = null, storeFieldsFromCardCreateData)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const assignee = (0, $3QmBe.getMostRecentAssigneeFilter)(state);
    const labels = (0, $3QmBe.getAppliedLabelFilters)(state);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const cardList = (0, $dGljH.getCardLists)(state)[cardListId];
    const projectId = (0, $jG5HW.projectIdSelector)(state);
    return (0, $a0k9j.default)(baseUrl, {
        boardId: boardId,
        destination: cardList.type,
        destinationId: cardList.type === (0, $guzeq.SPRINT) ? cardList.id : null,
        newCards: summaries.map((summary)=>({
                summary: summary,
                issueTypeId: issueTypeId,
                parentId: parentId === (0, $2lpqS.UNASSIGNED_EPIC_ID) ? null : parentId,
                fixVersions: fixVersions,
                assigneeId: assignee ? assignee.id : null,
                labels: labels || []
            })),
        rankBeforeCardId: rankBeforeCardId
    }).flatMap((result)=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        // Pre-populate extracted fields (Sweet State) using card create data
        storeFieldsFromCardCreateData(result, fieldConfigs);
        if (result.planModeCardCreate.newCards && result.planModeCardCreate.newCards.length > 0) {
            const transformedCards = result.planModeCardCreate.newCards.map((card)=>$f9f16a630333a4e4$var$transformer(card, projectId));
            return (0, $kVLXA.Observable).of(transformedCards);
        }
        return (0, $kVLXA.Observable).of(null);
    });
};

});
parcelRegister("a0k9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b15a5d8d00a25d0$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $1b15a5d8d00a25d0$var$MUTATION_NAME = 'BacklogCreateCard';
const $1b15a5d8d00a25d0$export$e904bac7f43ed94a = ()=>`
    mutation ${$1b15a5d8d00a25d0$var$MUTATION_NAME} (
        $boardId: ID!,
        $destination: PlanModeDestination!,
        $destinationId: ID,
        $newCards: [NewCard!]!,
        $rankBeforeCardId: Long
    ) {
        planModeCardCreate(input: {
            boardId: $boardId,
            destination: $destination,
            destinationId: $destinationId,
            newCards: $newCards,
            rankBeforeCardId: $rankBeforeCardId
        }) {
            newCards {
                id
                flagged
                done
                parentId
                fixVersions
                issue {
                    id
                    key
                    summary
                    labels
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type {
                        id
                        name
                        iconUrl
                    }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1b15a5d8d00a25d0$export$2e2bcd8739ae039 = (baseUrl, input)=>{
    const { boardId: boardId, destination: destination, destinationId: destinationId, newCards: newCards, rankBeforeCardId: rankBeforeCardId } = input;
    const variables = {
        boardId: boardId,
        destination: destination,
        destinationId: destinationId,
        newCards: newCards,
        rankBeforeCardId: rankBeforeCardId
    };
    return (0, $6iJbJ.mutation$)(baseUrl, $1b15a5d8d00a25d0$var$MUTATION_NAME, $1b15a5d8d00a25d0$export$e904bac7f43ed94a(), variables);
};

});

parcelRegister("3QmBe", function(module, exports) {

$parcel$export(module.exports, "getMostRecentAssigneeFilter", () => $39764b8392382256$export$aeda5a2993a15e54);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $39764b8392382256$export$60ee89f2718fc651);
$parcel$export(module.exports, "getLastAppliedParentFilters", () => $39764b8392382256$export$b88c37c6fa8adc17);

var $dGvGJ = parcelRequire("dGvGJ");

var $hYfgW = parcelRequire("hYfgW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");
const $39764b8392382256$export$aeda5a2993a15e54 = (0, $dGvGJ.createSelector)((0, $l9VFH.getFilters), (0, $dGljH.getOrderedAssignees), (filters, allAssignees)=>{
    const assignees = filters.ASSIGNEE;
    if (assignees && assignees.length > 0) {
        const lastSelectedKey = assignees[assignees.length - 1];
        const lastSelected = allAssignees.find((assignee)=>assignee.id === lastSelectedKey);
        if (lastSelected) return lastSelected;
    }
    return null;
});
const $39764b8392382256$export$60ee89f2718fc651 = (state)=>{
    const labels = state.ui.filters.LABEL;
    if (labels && labels.length > 0) return labels;
    return null;
};
const $39764b8392382256$export$b88c37c6fa8adc17 = (0, $dGvGJ.createSelector)((0, $l9VFH.getAppliedParentFilters), (parentIds)=>{
    if (parentIds && parentIds.length > 0) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(parentIds));
    return null;
});

});


parcelRegister("aqpnO", function(module, exports) {

$parcel$export(module.exports, "inlineCardCreateService", () => $475f23634c6f5948$export$239dafa7fe96b795);
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $3vPnu = parcelRequire("3vPnu");

var $fhHy4 = parcelRequire("fhHy4");

var $fCYjW = parcelRequire("fCYjW");
const $475f23634c6f5948$var$fetchNewlyCreatedIssue = (boardId)=>(inlineCreateResponse)=>(0, $fhHy4.fetchIssue)(boardId, Number(inlineCreateResponse.issue.issueId));
const $475f23634c6f5948$var$updateIssueConfigStore = (epicIssueType, storeFieldsFromFetchIssuesData)=>(issue)=>{
        storeFieldsFromFetchIssuesData([
            issue
        ], epicIssueType);
        return issue;
    };
const $475f23634c6f5948$var$transformIssueToCard = (issue)=>[
        (0, $3vPnu.transformCard)(issue)
    ];
function $475f23634c6f5948$export$239dafa7fe96b795(serviceContext, { summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides, epicIssueType: epicIssueType, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData }) {
    return (0, $fCYjW.inlineCreateIssue)({
        summary: summary,
        issueTypeId: issueTypeId,
        contexts: contexts,
        overrides: overrides
    }).flatMap($475f23634c6f5948$var$fetchNewlyCreatedIssue(serviceContext.boardId)).map($475f23634c6f5948$var$updateIssueConfigStore(epicIssueType, storeFieldsFromFetchIssuesData)).map($475f23634c6f5948$var$transformIssueToCard);
}

});
parcelRegister("3vPnu", function(module, exports) {

$parcel$export(module.exports, "transformCard", () => $e8ed48e7d53ec7da$export$dcbde76ab89d36a);

var $hGgHi = parcelRequire("hGgHi");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $eaTAr = parcelRequire("eaTAr");

var $dpWCZ = parcelRequire("dpWCZ");
const $e8ed48e7d53ec7da$var$isNumericFieldEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.includes((0, $guzeq.NUMERIC_ESTIMATE_FIELD_ID_PREFIX));
const $e8ed48e7d53ec7da$var$isTimeOriginalEstimate = (statisticField)=>statisticField && statisticField?.statFieldId?.startsWith((0, $guzeq.ORIGINAL_ESTIMATE_ID));
const $e8ed48e7d53ec7da$var$transformEstimateStatistic = ({ estimateStatistic: estimateStatistic, trackingStatistic: trackingStatistic })=>{
    const timeRemainingEstimate = trackingStatistic?.statFieldValue ? {
        value: trackingStatistic?.statFieldValue?.value || 0,
        valueAsText: trackingStatistic?.statFieldValue?.text || ''
    } : null;
    const storyPoints = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic) && $e8ed48e7d53ec7da$var$isNumericFieldEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.value) ? Number(estimateStatistic?.statFieldValue?.value) : null;
    const originalEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic) && $e8ed48e7d53ec7da$var$isTimeOriginalEstimate(estimateStatistic) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.value) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateStatistic?.statFieldValue?.text) ? {
        value: estimateStatistic?.statFieldValue?.value,
        valueAsText: estimateStatistic?.statFieldValue?.text
    } : null;
    return {
        storyPoints: storyPoints,
        originalEstimate: originalEstimate,
        timeRemainingEstimate: timeRemainingEstimate
    };
};
const $e8ed48e7d53ec7da$var$transformPriority = ({ priorityName: priorityName, priorityUrl: priorityUrl })=>priorityName && priorityUrl ? {
        name: priorityName,
        iconUrl: priorityUrl
    } : null;
const $e8ed48e7d53ec7da$var$transformAssignee = ({ assigneeAccountId: assigneeAccountId, assigneeName: assigneeName, avatarUrl: avatarUrl })=>assigneeAccountId && assigneeName && avatarUrl ? {
        id: assigneeAccountId,
        displayName: assigneeName,
        avatarUrl: avatarUrl
    } : null;
const $e8ed48e7d53ec7da$var$transformParentId = (issue)=>{
    if ((0, $g4tDr.isSubtaskHierarchyLevel)(issue.typeHierarchyLevel)) return issue.parentId ?? null;
    if (!(0, $dpWCZ.hasEpicField)(issue) || !(0, $dpWCZ.isEpicField)(issue.epicField)) return null;
    return issue.epicField.issueId ?? null;
};
const $e8ed48e7d53ec7da$var$toExtraField = (extraField)=>{
    const { id: id, label: label, renderer: renderer, text: text, html: html } = extraField;
    if ((0, $eaTAr.isExtraFieldHtml)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        html: html
    };
    if ((0, $eaTAr.isExtraFieldDate)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text,
        html: html
    };
    if ((0, $eaTAr.isExtraFieldText)(extraField)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        id: id,
        label: label,
        renderer: renderer,
        text: text
    };
    return undefined;
};
const $e8ed48e7d53ec7da$var$transformCardExtraFields = (issue)=>(issue?.extraFields ?? []).map($e8ed48e7d53ec7da$var$toExtraField).filter(Boolean);
const $e8ed48e7d53ec7da$var$getIssueEpicColor = (issue)=>(0, $dpWCZ.hasEpicField)(issue) ? issue.epicField.color || issue.epicField.epicColor : issue.color;
const $e8ed48e7d53ec7da$export$dcbde76ab89d36a = (issue)=>({
        id: issue.id,
        key: issue.key,
        summary: issue.summary,
        labels: issue.labels ?? [],
        assignee: $e8ed48e7d53ec7da$var$transformAssignee(issue),
        typeId: Number(issue.typeId),
        icon: issue.typeUrl,
        isDone: issue.done,
        isFlagged: issue.flagged,
        issueUrl: `/browse/${issue.key}`,
        statusId: issue.statusId,
        parentId: $e8ed48e7d53ec7da$var$transformParentId(issue),
        parentKey: issue.parentKey,
        priority: $e8ed48e7d53ec7da$var$transformPriority(issue),
        projectId: issue.projectId,
        dueDate: null,
        estimate: $e8ed48e7d53ec7da$var$transformEstimateStatistic(issue),
        numCompleteChildren: 0,
        numTotalChildren: 0,
        fixVersions: issue.fixVersions?.map(String),
        color: issue.color,
        epicColor: $e8ed48e7d53ec7da$var$getIssueEpicColor(issue),
        extraFields: $e8ed48e7d53ec7da$var$transformCardExtraFields(issue),
        typeHierarchyLevel: issue.typeHierarchyLevel,
        hidden: issue.hidden
    });

});
parcelRegister("eaTAr", function(module, exports) {

$parcel$export(module.exports, "isExtraFieldHtml", () => $d13e0dbf27e02f79$export$d1fe808976407c4c);
$parcel$export(module.exports, "isExtraFieldDate", () => $d13e0dbf27e02f79$export$da33088c7c3e5cb2);
$parcel$export(module.exports, "isExtraFieldLabel", () => $d13e0dbf27e02f79$export$748f5a82c0532889);
$parcel$export(module.exports, "isExtraFieldThumbnail", () => $d13e0dbf27e02f79$export$236190af5d6fde4c);
$parcel$export(module.exports, "isExtraFieldText", () => $d13e0dbf27e02f79$export$899a90d8d4afc87b);

var $5fc53 = parcelRequire("5fc53");

function $d13e0dbf27e02f79$var$isExtraField(field, rendererTypes = []) {
    if (field !== null && typeof field === 'object' && 'renderer' in field) return rendererTypes.some((rendererType)=>field?.renderer === rendererType);
    return false;
}
function $d13e0dbf27e02f79$export$d1fe808976407c4c(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$bda4531b1a353ad5)
    ]) && 'html' in field;
}
function $d13e0dbf27e02f79$export$da33088c7c3e5cb2(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$17bb0a20b1f25353)
    ]);
}
function $d13e0dbf27e02f79$export$748f5a82c0532889(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$9b9dcd4746c10184)
    ]) && field.id === (0, $5fc53.LABELS_TYPE);
}
function $d13e0dbf27e02f79$export$236190af5d6fde4c(field) {
    return $d13e0dbf27e02f79$export$d1fe808976407c4c(field) && field.id === (0, $1f23dc9825a8e3a5$export$a44cd70654f485a4);
}
function $d13e0dbf27e02f79$export$899a90d8d4afc87b(field) {
    return $d13e0dbf27e02f79$var$isExtraField(field, [
        (0, $1f23dc9825a8e3a5$export$9b9dcd4746c10184),
        (0, $1f23dc9825a8e3a5$export$110883b3780f4ea),
        (0, $1f23dc9825a8e3a5$export$bde36270f821fce6),
        (0, $1f23dc9825a8e3a5$export$8edb5204f086f2f1),
        (0, $1f23dc9825a8e3a5$export$2bff164ceff5df7e)
    ]);
}

});
const $1f23dc9825a8e3a5$export$9b9dcd4746c10184 = 'text';
const $1f23dc9825a8e3a5$export$8edb5204f086f2f1 = 'status';
const $1f23dc9825a8e3a5$export$bde36270f821fce6 = 'duration';
const $1f23dc9825a8e3a5$export$110883b3780f4ea = 'number';
const $1f23dc9825a8e3a5$export$17bb0a20b1f25353 = 'date';
const $1f23dc9825a8e3a5$export$bda4531b1a353ad5 = 'html';
const $1f23dc9825a8e3a5$export$2bff164ceff5df7e = 'url';
const $1f23dc9825a8e3a5$export$a44cd70654f485a4 = 'thumbnail';



parcelRegister("fhHy4", function(module, exports) {

$parcel$export(module.exports, "fetchIssue", () => $162bf599e41e206c$export$dcd87b70796c5c27);

var $487fd = parcelRequire("487fd");
function $162bf599e41e206c$export$dcd87b70796c5c27(boardId, issueId) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/plan/backlog/issue.json?rapidViewId=${boardId}&issueId=${issueId}`);
}

});

parcelRegister("fCYjW", function(module, exports) {

$parcel$export(module.exports, "inlineCreateIssue", () => $10ad9f4102677363$export$6a4019ebc77bfcad);

var $487fd = parcelRequire("487fd");
function $10ad9f4102677363$export$6a4019ebc77bfcad({ summary: summary, issueTypeId: issueTypeId, contexts: contexts, overrides: overrides }) {
    return (0, $487fd.default)('/rest/inline-create/1.0/issue', {
        method: 'POST',
        body: JSON.stringify({
            summary: summary,
            issueTypeId: issueTypeId,
            contexts: contexts,
            overrides: overrides
        })
    });
}

});



parcelRegister("i4Z8q", function(module, exports) {

$parcel$export(module.exports, "makeServiceContext", () => $8bf18a91ef99273b$export$47bf8333d7adacd0);

var $jG5HW = parcelRequire("jG5HW");
function $8bf18a91ef99273b$export$47bf8333d7adacd0(state) {
    return {
        boardId: (0, $jG5HW.getRapidViewId)(state),
        isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state)
    };
}

});

parcelRegister("5Eoed", function(module, exports) {

$parcel$export(module.exports, "OPEN_MODAL", () => $e3f3ab7c36d05c39$export$d1956215992c54b);
$parcel$export(module.exports, "openModal", () => $e3f3ab7c36d05c39$export$a7f6cffb6b8ba11c);
$parcel$export(module.exports, "CLOSE_MODAL", () => $e3f3ab7c36d05c39$export$d984830de9a39518);
$parcel$export(module.exports, "closeModal", () => $e3f3ab7c36d05c39$export$3f6fecd573f3fa48);
const $e3f3ab7c36d05c39$export$d1956215992c54b = 'state.actions.modals.OPEN_MODAL';
const $e3f3ab7c36d05c39$export$a7f6cffb6b8ba11c = (payload)=>({
        type: $e3f3ab7c36d05c39$export$d1956215992c54b,
        payload: payload
    });
const $e3f3ab7c36d05c39$export$d984830de9a39518 = 'state.actions.modals.CLOSE_MODAL';
const $e3f3ab7c36d05c39$export$3f6fecd573f3fa48 = ()=>({
        type: $e3f3ab7c36d05c39$export$d984830de9a39518
    });

});

parcelRegister("gwOHY", function(module, exports) {

$parcel$export(module.exports, "SET_VERSIONS", () => $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7);
$parcel$export(module.exports, "setVersions", () => $6d6a4c65ff06d5cc$export$44737a4035599644);
$parcel$export(module.exports, "UPDATE_VERSION", () => $6d6a4c65ff06d5cc$export$c4aaf486103b8376);
$parcel$export(module.exports, "updateVersion", () => $6d6a4c65ff06d5cc$export$5652a4ac6807e581);
$parcel$export(module.exports, "REFETCH_VERSIONS", () => $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c);
$parcel$export(module.exports, "refetchVersions", () => $6d6a4c65ff06d5cc$export$70fb16a0ad235611);
const $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7 = 'state.actions.version.SET_VERSIONS';
const $6d6a4c65ff06d5cc$export$44737a4035599644 = (payload)=>({
        type: $6d6a4c65ff06d5cc$export$8d55849a0d8ef0c7,
        payload: payload
    });
const $6d6a4c65ff06d5cc$export$c4aaf486103b8376 = 'state.actions.version.UPDATE_VERSION';
const $6d6a4c65ff06d5cc$export$5652a4ac6807e581 = (version)=>({
        type: $6d6a4c65ff06d5cc$export$c4aaf486103b8376,
        payload: {
            version: version
        }
    });
const $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c = 'state.actions.version.REFETCH_VERSIONS';
const $6d6a4c65ff06d5cc$export$70fb16a0ad235611 = ()=>({
        type: $6d6a4c65ff06d5cc$export$a4ef9c1f4cfa323c
    });

});

parcelRegister("aU3CO", function(module, exports) {

$parcel$export(module.exports, "getInlineCreateSessionId", () => $5246fcf6b22584f7$export$12a9e7e0a7f5b591);
$parcel$export(module.exports, "getCardTypesForICC", () => $5246fcf6b22584f7$export$544c7fd474a93225);

var $dGvGJ = parcelRequire("dGvGJ");

var $g4tDr = parcelRequire("g4tDr");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $9Pc1U = parcelRequire("9Pc1U");

var $e5nhF = parcelRequire("e5nhF");
const $5246fcf6b22584f7$export$1ca4cd34e6f2914c = (state)=>(0, $e5nhF.getEntities)(state).inlineCreate;
const $5246fcf6b22584f7$export$12a9e7e0a7f5b591 = (0, $dGvGJ.createSelector)([
    $5246fcf6b22584f7$export$1ca4cd34e6f2914c
], (inlineCreateState)=>inlineCreateState?.sessionId);
const $5246fcf6b22584f7$var$getInlineCreateCardTypeIds = (0, $dGvGJ.createSelector)([
    $5246fcf6b22584f7$export$1ca4cd34e6f2914c
], (inlineCreate)=>inlineCreate.cardTypeIds);
const $5246fcf6b22584f7$export$544c7fd474a93225 = (0, $dGvGJ.createSelector)([
    (0, $74oBv.getCardTypes),
    $5246fcf6b22584f7$var$getInlineCreateCardTypeIds,
    (0, $jG5HW.isCmpKanbanProject),
    (0, $9Pc1U.getShowEpicAsPanel)
], (cardTypes, cardTypeIds, isCmpKanban, showEpicAsPanel)=>cardTypes.filter((cardType)=>isCmpKanban && !showEpicAsPanel ? cardType.typeHierarchyLevel === (0, $g4tDr.EPIC_PARENT_HIERARCHY_TYPE) || cardType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE) : cardType.typeHierarchyLevel === (0, $g4tDr.BASE_HIERARCHY_TYPE)).filter((cardType)=>cardTypeIds?.includes(cardType.id)));

});


parcelRegister("kOw1j", function(module, exports) {

$parcel$export(module.exports, "cardDeleteEpic", () => $014d2de2519d2da4$export$eb4bca8cd893632);
parcelRequire("zjDln");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $guzeq = parcelRequire("guzeq");

var $3UEQx = parcelRequire("3UEQx");

var $cik5h = parcelRequire("cik5h");

var $3lZ6i = parcelRequire("3lZ6i");

var $legw4 = parcelRequire("legw4");

var $jG5HW = parcelRequire("jG5HW");
const $014d2de2519d2da4$export$eb4bca8cd893632 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $legw4.CARD_DELETE_REQUEST)).mergeMap((action)=>{
            const { payload: { cardId: cardId }, meta: { optimistic: { id: optimisticId } } } = action;
            const state = store.getState();
            const baseUrl = (0, $jG5HW.getBaseUrl)(state);
            push((0, $cik5h.removeSelectedIssueFromUrl)(getLocation()));
            return (0, $3UEQx.default)(baseUrl, String(cardId)).flatMap(()=>{
                const actions = [
                    (0, $legw4.cardDeleteSuccess)(cardId, optimisticId)
                ];
                return (0, $kVLXA.Observable).from(actions);
            }).catch(()=>(0, $kVLXA.Observable).from([
                    (0, $legw4.cardDeleteFailure)(cardId, optimisticId),
                    (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
                ]));
        });

});
parcelRegister("3UEQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eac278b6b027a840$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $eac278b6b027a840$var$MUTATION_NAME = 'BacklogDeleteCard';
const $eac278b6b027a840$export$e904bac7f43ed94a = ()=>`mutation ${$eac278b6b027a840$var$MUTATION_NAME} ($issueId: ID!) {
        deleteCard(issueId: $issueId) {
            success
        }
    }`;
const $eac278b6b027a840$var$cardDeleteGraphql = (baseUrl, issueId)=>// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    (0, $6iJbJ.mutation$)(baseUrl, $eac278b6b027a840$var$MUTATION_NAME, $eac278b6b027a840$export$e904bac7f43ed94a(), {
        issueId: issueId
    });
var $eac278b6b027a840$export$2e2bcd8739ae039 = $eac278b6b027a840$var$cardDeleteGraphql;

});

parcelRegister("legw4", function(module, exports) {

$parcel$export(module.exports, "CARD_DELETE_REQUEST", () => $25b07de62d83e2e6$export$9bc1d1c298c8f5af);
$parcel$export(module.exports, "cardDeleteRequest", () => $25b07de62d83e2e6$export$d2ea563d7459b747);
$parcel$export(module.exports, "CARD_DELETE_SUCCESS", () => $25b07de62d83e2e6$export$c9235af922e153a1);
$parcel$export(module.exports, "cardDeleteSuccess", () => $25b07de62d83e2e6$export$abf29851b85a5dc);
$parcel$export(module.exports, "CARD_DELETE_FAILURE", () => $25b07de62d83e2e6$export$229ed28ef1c0b98);
$parcel$export(module.exports, "cardDeleteFailure", () => $25b07de62d83e2e6$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "CARD_DELETE", () => $25b07de62d83e2e6$export$b82590935cfab60f);
$parcel$export(module.exports, "cardDelete", () => $25b07de62d83e2e6$export$ba9d764de574147c);

var $c0irb = parcelRequire("c0irb");
const $25b07de62d83e2e6$export$9bc1d1c298c8f5af = 'state.actions.cards.delete.CARD_DELETE_REQUEST';
const $25b07de62d83e2e6$export$d2ea563d7459b747 = (payload)=>({
        type: $25b07de62d83e2e6$export$9bc1d1c298c8f5af,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $25b07de62d83e2e6$export$c9235af922e153a1 = 'state.actions.cards.delete.CARD_DELETE_SUCCESS';
const $25b07de62d83e2e6$export$abf29851b85a5dc = (cardId, optimisticId)=>({
        type: $25b07de62d83e2e6$export$c9235af922e153a1,
        payload: {
            cardId: cardId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $25b07de62d83e2e6$export$229ed28ef1c0b98 = 'state.actions.cards.delete.CARD_DELETE_FAILURE';
const $25b07de62d83e2e6$export$14995a1d9fdd27aa = (cardId, optimisticId)=>({
        type: $25b07de62d83e2e6$export$229ed28ef1c0b98,
        payload: {
            cardId: cardId
        },
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $25b07de62d83e2e6$export$b82590935cfab60f = 'state.actions.cards.delete.CARD_DELETE';
const $25b07de62d83e2e6$export$ba9d764de574147c = (cardId)=>({
        type: $25b07de62d83e2e6$export$b82590935cfab60f,
        payload: {
            cardId: cardId
        }
    });

});


parcelRegister("5o0zk", function(module, exports) {

$parcel$export(module.exports, "cardGroupToggleEpic", () => $e1610f16a32f448c$export$dcdf634c78f06f28);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $e1610f16a32f448c$export$dcdf634c78f06f28 = (action$, store)=>action$.ofType((0, $a7yHf.CARD_GROUP_TOGGLE), (0, $a7yHf.COLLAPSE_ALL_CARD_GROUPS), (0, $a7yHf.SET_EXPANDED_CARD_GROUP)).flatMap(()=>{
        const state = store.getState();
        const expandedCardGroups = (0, $dGljH.getExpandedCardGroups)(state);
        (0, $3FUwR.setBacklogCardGroupSettings)(Number((0, $jG5HW.getRapidViewId)(state)), expandedCardGroups);
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("3FUwR", function(module, exports) {

$parcel$export(module.exports, "getDetailViewWidthRatio", () => $adc0c55af25e35a9$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $adc0c55af25e35a9$export$d194f7c4bdc33538);
$parcel$export(module.exports, "getBacklogSettings", () => $adc0c55af25e35a9$export$385952056bbb1deb);
$parcel$export(module.exports, "setBacklogSettings", () => $adc0c55af25e35a9$export$6ddb49680d7ce77d);
$parcel$export(module.exports, "getPanelStateOld", () => $adc0c55af25e35a9$export$87f4e6f908d51646);
$parcel$export(module.exports, "getPanelState", () => $adc0c55af25e35a9$export$6f4f3781f70858b9);
$parcel$export(module.exports, "setPanelStateOld", () => $adc0c55af25e35a9$export$58bb10ae80996d55);
$parcel$export(module.exports, "setPanelState", () => $adc0c55af25e35a9$export$5554b6f93f40abe5);
$parcel$export(module.exports, "unsetPanelState", () => $adc0c55af25e35a9$export$48192827b67d2f17);
$parcel$export(module.exports, "getBacklogCardGroupSettings", () => $adc0c55af25e35a9$export$74b19271af6b55e5);
$parcel$export(module.exports, "setBacklogCardGroupSettings", () => $adc0c55af25e35a9$export$d5b7ae0d62d4ef81);
$parcel$export(module.exports, "getWorkloadSubtaskSettings", () => $adc0c55af25e35a9$export$b1494519a5c8386e);
$parcel$export(module.exports, "setWorkloadSubtaskSettings", () => $adc0c55af25e35a9$export$fc1a0f95945c8afd);

var $hqTkp = parcelRequire("hqTkp");

var $bSSG7 = parcelRequire("bSSG7");
const $adc0c55af25e35a9$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('backlog');
const $adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX = 'gh.backlogSettings.';
const $adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX = 'gh.backlogCardGroupSettings.';
const $adc0c55af25e35a9$var$PANEL_STATE = 'panel-state';
const $adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS = 'gh.workloadModal.subtasks';
const $adc0c55af25e35a9$export$5a9c556da9744b1b = ()=>{
    const value = $adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $adc0c55af25e35a9$export$d194f7c4bdc33538 = (ratio)=>$adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$DETAIL_VIEW_WIDTH_RATIO, ratio);
const $adc0c55af25e35a9$export$385952056bbb1deb = (boardId)=>{
    const data = $adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX}${boardId}`);
    if (!data || !data.collapsedCardLists) return {};
    return data;
};
const $adc0c55af25e35a9$export$6ddb49680d7ce77d = (boardId, settings)=>{
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$BACKLOG_SETTINGS_PREFIX}${boardId}`, settings);
};
const $adc0c55af25e35a9$export$87f4e6f908d51646 = ()=>$adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$PANEL_STATE);
const $adc0c55af25e35a9$export$6f4f3781f70858b9 = (boardId)=>$adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`);
const $adc0c55af25e35a9$export$58bb10ae80996d55 = (panelState)=>$adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$PANEL_STATE, panelState);
const $adc0c55af25e35a9$export$5554b6f93f40abe5 = (panelState, boardId)=>{
    const currentPanelState = $adc0c55af25e35a9$export$6f4f3781f70858b9(boardId) || [];
    if (!currentPanelState.includes(panelState)) $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, [
        ...currentPanelState,
        panelState
    ]);
};
const $adc0c55af25e35a9$export$b31b38479befe75d = (panels, boardId)=>{
    const openPanels = Object.entries(panels).filter(([_, value])=>value === true).map(([key])=>key);
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, openPanels);
};
const $adc0c55af25e35a9$export$48192827b67d2f17 = (panelState, boardId)=>{
    const currentPanelState = $adc0c55af25e35a9$export$6f4f3781f70858b9(boardId);
    if (currentPanelState?.includes(panelState)) $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$PANEL_STATE}-${boardId}`, (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(currentPanelState, panelState));
};
const $adc0c55af25e35a9$export$74b19271af6b55e5 = (boardId)=>{
    const data = $adc0c55af25e35a9$var$localStorage.get(`${$adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`);
    return data ?? {};
};
const $adc0c55af25e35a9$export$d5b7ae0d62d4ef81 = (boardId, settings)=>{
    $adc0c55af25e35a9$var$localStorage.set(`${$adc0c55af25e35a9$var$BACKLOG_CARDGROUP_SETTINGS_PREFIX}${boardId}`, settings);
};
const $adc0c55af25e35a9$export$b1494519a5c8386e = ()=>{
    const data = $adc0c55af25e35a9$var$localStorage.get($adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS);
    return !!data;
};
const $adc0c55af25e35a9$export$fc1a0f95945c8afd = (includeSubtasks)=>{
    $adc0c55af25e35a9$var$localStorage.set($adc0c55af25e35a9$var$WORKLOAD_MODAL_SUBTASKS, includeSubtasks);
};

});
parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});


parcelRegister("a7yHf", function(module, exports) {

$parcel$export(module.exports, "CARD_LIST_TOGGLE", () => $ef75a116916584d7$export$8ac407f033388640);
$parcel$export(module.exports, "cardListToggle", () => $ef75a116916584d7$export$90d6f3c77a83064c);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_LIST", () => $ef75a116916584d7$export$8e3dbeb7df2e2eed);
$parcel$export(module.exports, "setCollapsedCardLists", () => $ef75a116916584d7$export$5f2a6b9a0552b438);
$parcel$export(module.exports, "CARD_LISTS_DISABLE", () => $ef75a116916584d7$export$cc7cd3c4009760cc);
$parcel$export(module.exports, "cardListsDisable", () => $ef75a116916584d7$export$3bb589b09264f63f);
$parcel$export(module.exports, "CARD_LISTS_ENABLE_ALL", () => $ef75a116916584d7$export$649d537a55101566);
$parcel$export(module.exports, "cardListsEnableAll", () => $ef75a116916584d7$export$f44d80a86eadf7f4);
$parcel$export(module.exports, "CARD_LIST_DRAG_START", () => $ef75a116916584d7$export$dc86559f09e710b9);
$parcel$export(module.exports, "cardListDragStart", () => $ef75a116916584d7$export$87075c8b80f899ee);
$parcel$export(module.exports, "CARD_LIST_DRAG_END", () => $ef75a116916584d7$export$39a50360ed362605);
$parcel$export(module.exports, "cardListDragEnd", () => $ef75a116916584d7$export$e6bf5fbe83cd7d74);
$parcel$export(module.exports, "CARD_GROUP_TOGGLE", () => $ef75a116916584d7$export$bde12efd87a4ac85);
$parcel$export(module.exports, "cardGroupToggle", () => $ef75a116916584d7$export$92a3d8e003e4f107);
$parcel$export(module.exports, "SET_COLLAPSED_CARD_GROUP", () => $ef75a116916584d7$export$9da147a1292f7381);
$parcel$export(module.exports, "SET_EXPANDED_CARD_GROUP", () => $ef75a116916584d7$export$3f7371c8d6ee730e);
$parcel$export(module.exports, "setCollapsedCardGroups", () => $ef75a116916584d7$export$b56fc1f894629222);
$parcel$export(module.exports, "setExpandedCardGroups", () => $ef75a116916584d7$export$7ff65c0e4fbb1fb);
$parcel$export(module.exports, "CLEAR_COLLAPSED_CARD_GROUP", () => $ef75a116916584d7$export$f79940d7e9a921f6);
$parcel$export(module.exports, "CLEAR_EXPANDED_CARD_GROUP", () => $ef75a116916584d7$export$a93c0bd80b95451c);
$parcel$export(module.exports, "clearExpandedCardGroup", () => $ef75a116916584d7$export$f3ccf76393691844);
$parcel$export(module.exports, "COLLAPSE_ALL_CARD_GROUPS", () => $ef75a116916584d7$export$a081f6cfebf37017);
$parcel$export(module.exports, "collapseAllCardGroups", () => $ef75a116916584d7$export$5f921ba0e1020c03);
const $ef75a116916584d7$export$8ac407f033388640 = 'state.actions.card-list.CARD_LIST_TOGGLE';
const $ef75a116916584d7$export$90d6f3c77a83064c = (cardListId)=>({
        type: $ef75a116916584d7$export$8ac407f033388640,
        payload: {
            cardListId: cardListId
        }
    });
const $ef75a116916584d7$export$8e3dbeb7df2e2eed = 'state.actions.card-list.SET_COLLAPSED_CARD_LIST';
const $ef75a116916584d7$export$5f2a6b9a0552b438 = (cardListIds)=>({
        type: $ef75a116916584d7$export$8e3dbeb7df2e2eed,
        payload: {
            cardListIds: cardListIds
        }
    });
const $ef75a116916584d7$export$cc7cd3c4009760cc = 'state.actions.card-list.CARD_LISTS_DISABLE';
const $ef75a116916584d7$export$3bb589b09264f63f = (cardListIds)=>({
        type: $ef75a116916584d7$export$cc7cd3c4009760cc,
        payload: {
            cardListIds: cardListIds
        }
    });
const $ef75a116916584d7$export$649d537a55101566 = 'state.actions.card-list.CARD_LISTS_ENABLE_ALL';
const $ef75a116916584d7$export$f44d80a86eadf7f4 = ()=>({
        type: $ef75a116916584d7$export$649d537a55101566
    });
const $ef75a116916584d7$export$dc86559f09e710b9 = 'state.actions.card-list.DRAG_START';
const $ef75a116916584d7$export$87075c8b80f899ee = (cardListIds, sourceCardListId, sourceCardGroupId)=>({
        type: $ef75a116916584d7$export$dc86559f09e710b9,
        payload: {
            cardListIds: cardListIds,
            sourceCardListId: sourceCardListId,
            sourceCardGroupId: sourceCardGroupId
        }
    });
const $ef75a116916584d7$export$39a50360ed362605 = 'state.actions.card-list.DRAG_END';
const $ef75a116916584d7$export$e6bf5fbe83cd7d74 = ()=>({
        type: $ef75a116916584d7$export$39a50360ed362605
    });
const $ef75a116916584d7$export$bde12efd87a4ac85 = 'state.actions.card-list.CARD_GROUP_TOGGLE';
const $ef75a116916584d7$export$92a3d8e003e4f107 = (parentId)=>({
        type: $ef75a116916584d7$export$bde12efd87a4ac85,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$9da147a1292f7381 = 'state.actions.card-list.SET_COLLAPSED_CARD_GROUP';
const $ef75a116916584d7$export$3f7371c8d6ee730e = 'state.actions.card-list.SET_EXPANDED_CARD_GROUP';
const $ef75a116916584d7$export$b56fc1f894629222 = (parentIds)=>({
        type: $ef75a116916584d7$export$9da147a1292f7381,
        payload: {
            parentIds: parentIds
        }
    });
const $ef75a116916584d7$export$7ff65c0e4fbb1fb = (parentIds)=>({
        type: $ef75a116916584d7$export$3f7371c8d6ee730e,
        payload: {
            parentIds: parentIds
        }
    });
const $ef75a116916584d7$export$f79940d7e9a921f6 = 'state.actions.card-list.CLEAR_COLLAPSED_CARD_GROUP';
const $ef75a116916584d7$export$a93c0bd80b95451c = 'state.actions.card-list.CLEAR_EXPANDED_CARD_GROUP';
const $ef75a116916584d7$export$2847fdebb2aad4f5 = (parentId)=>({
        type: $ef75a116916584d7$export$f79940d7e9a921f6,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$f3ccf76393691844 = (parentId)=>({
        type: $ef75a116916584d7$export$a93c0bd80b95451c,
        payload: {
            parentId: parentId
        }
    });
const $ef75a116916584d7$export$a081f6cfebf37017 = 'state.actions.card-list.COLLAPSE_ALL_CARD_GROUPS';
const $ef75a116916584d7$export$5f921ba0e1020c03 = ()=>({
        type: $ef75a116916584d7$export$a081f6cfebf37017
    });

});


parcelRegister("ntGXV", function(module, exports) {

$parcel$export(module.exports, "cardListToggleEpic", () => $0ca27dd893a538ce$export$35eb239dac6e0c31);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $0ca27dd893a538ce$export$35eb239dac6e0c31 = (action$, store)=>action$.ofType((0, $a7yHf.CARD_LIST_TOGGLE)).flatMap(()=>{
        const state = store.getState();
        const collapsedCardLists = (0, $dGljH.getCollapsedCardLists)(state);
        (0, $3FUwR.setBacklogSettings)(Number((0, $jG5HW.getRapidViewId)(state)), {
            collapsedCardLists: collapsedCardLists
        });
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("3EYDb", function(module, exports) {

$parcel$export(module.exports, "cardPostCreateEpic", () => $608a6ccdf0dfdb54$export$bae9f8e0951e31da);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hf5c2 = parcelRequire("hf5c2");

var $dGljH = parcelRequire("dGljH");
const $608a6ccdf0dfdb54$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $608a6ccdf0dfdb54$var$isCustomFiltersActive = (state)=>$608a6ccdf0dfdb54$var$getActiveCustomFilterIds(state).length > 0;
const $608a6ccdf0dfdb54$export$bae9f8e0951e31da = (action$, store)=>action$.ofType((0, $hf5c2.CARD_CREATE_SUCCESS)).mergeMap((action)=>{
        const state = store.getState();
        const visibleCardIds = (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(action.payload.listId);
        if (!visibleCardIds.includes(action.payload.card.id)) {
            // don't show this flag here if custom filters are active,
            // we'll show it after the refiltering succeeds
            if (!$608a6ccdf0dfdb54$var$isCustomFiltersActive(state)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateFilteredV2)([
                action.payload.card.id
            ]));
        }
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("hHUaf", function(module, exports) {

$parcel$export(module.exports, "cardRankAfterGlobalIssueCreateEpic", () => $3e6c86d4e1aab4ec$export$40e733b396c30c9b);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("6cbqE");
parcelRequire("7mHDu");
parcelRequire("fPS7b");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $6GNN7 = parcelRequire("6GNN7");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $3e6c86d4e1aab4ec$export$40e733b396c30c9b = (action$, store, dependencies)=>action$.ofType((0, $hf5c2.CARD_CREATE_GLOBAL)).switchMap((cardCreateGlobalAction)=>{
        const state = store.getState();
        const lastSelectedCardId = (0, $dGljH.getLastSelectedCard)(state);
        const cardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
        const listId = lastSelectedCardId && (0, $dGljH.makeGetCardListIdByCardId)(state)(lastSelectedCardId);
        // We should not rank created issues from GIC when:
        // - there is no selected card
        // - the board is not ordered by rank (this will also filter out TMP projects)
        // - the card is not part of any card list
        // - the card is not on `BACKLOG` card list
        if (!lastSelectedCardId || cardMoveDisabled || !listId || listId !== (0, $guzeq.BACKLOG)) return (0, $kVLXA.Observable).empty();
        const { payload: { globalIssues: globalIssues } } = cardCreateGlobalAction;
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({}) : {};
        return action$.ofType((0, $3lZ6i.SET_APP_DATA)).filter(()=>{
            const cards = (0, $dGljH.getCards)(store.getState());
            return globalIssues.every(({ issueId: issueId })=>cards[issueId]);
        }).take(1).flatMap(()=>{
            const cardIds = globalIssues.map((createdIssue)=>parseInt(createdIssue.issueId, 10));
            return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)({
                cardIds: cardIds,
                cardListId: listId,
                isBetweenLists: false,
                beforeCardId: null,
                afterCardId: lastSelectedCardId
            }, analyticsEvent));
        });
    });

});

parcelRegister("jQmfK", function(module, exports) {

$parcel$export(module.exports, "cardRefreshEpic", () => $93cf125363aaffce$export$343b49279bcad83d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $kBFd5 = parcelRequire("kBFd5");

var $i4Z8q = parcelRequire("i4Z8q");

var $fdAim = parcelRequire("fdAim");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");
const $93cf125363aaffce$var$getRefreshCardId = (action, state)=>{
    const { payload: { cardId: cardId } } = action;
    if (cardId) return cardId;
    const detailViewData = (0, $dGljH.getDetailViewData)(state);
    if (detailViewData) return detailViewData.cardId;
    return null;
};
const $93cf125363aaffce$export$343b49279bcad83d = (action$, store)=>action$.ofType((0, $fdAim.CARD_REFRESH_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const cardId = $93cf125363aaffce$var$getRefreshCardId(action, state);
        const issueParents = (0, $fmuR9.getIssueParents)(state);
        const projectId = (0, $jG5HW.projectIdSelector)(state);
        /** TODO: issueParents check part below to be removed WHEN
		 * Swag supports fetching epic level issues OR
		 * FE updates backlog optimistically (in redux store) instead of relying on refetching issues via GraphQL
		 */ if (!cardId || issueParents[String(cardId)]) return (0, $kVLXA.Observable).empty();
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        return (0, $kBFd5.cardLoadService)(serviceContext, cardId, projectId).map((card)=>(0, $fdAim.cardRefreshSuccess)(card)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.card-refresh-graphql.failure', 'Failed to refresh issue', error);
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("kBFd5", function(module, exports) {

$parcel$export(module.exports, "cardLoadService", () => $2348e1764f321cfa$export$77afcec7b8f1f966);
parcelRequire("d0pqD");

var $3vPnu = parcelRequire("3vPnu");

var $7nLcW = parcelRequire("7nLcW");

var $fhHy4 = parcelRequire("fhHy4");

var $4EjDu = parcelRequire("4EjDu");
function $2348e1764f321cfa$export$77afcec7b8f1f966(serviceContext, cardId, projectId) {
    if (serviceContext.isCompanyManaged) return (0, $fhHy4.fetchIssue)(serviceContext.boardId, cardId).map((0, $3vPnu.transformCard));
    return (0, $7nLcW.default)('', serviceContext.boardId, cardId).map((cardData)=>(0, $4EjDu.cardTransformer)(cardData, projectId));
}

});
parcelRegister("7nLcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca25373e5ee2ca6$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $fca25373e5ee2ca6$var$cardDataOperationName = 'BacklogCardQuery';
const $fca25373e5ee2ca6$export$71eec30d9db46a56 = ()=>`
    query ${$fca25373e5ee2ca6$var$cardDataOperationName} ($boardId: ID!, $cardId: ID!) {
        boardScope(boardId: $boardId) {
            cards(cardIds: [$cardId]) {
                id
                issue {
                    id
                    key
                    summary
                    labels
                    type {
                        id
                        name
                        iconUrl
                    }
                    status {
                        id
                        name
                        category
                    }
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                }
                flagged
                done
                parentId
                fixVersions
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                childIssuesMetadata {
                    complete
                    total
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fca25373e5ee2ca6$export$2e2bcd8739ae039 = (baseUrl, boardId, cardId)=>(0, $cBLvH.query$)(baseUrl, $fca25373e5ee2ca6$var$cardDataOperationName, $fca25373e5ee2ca6$export$71eec30d9db46a56(), {
        boardId: boardId,
        cardId: cardId
    }).flatMap((data)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        (0, $kVLXA.Observable).of(data.boardScope.cards[0]));

});
parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});


parcelRegister("4EjDu", function(module, exports) {

$parcel$export(module.exports, "cardTransformer", () => $be43b450a4c183c9$export$c44fc4642496cd94);
$parcel$export(module.exports, "default", () => $be43b450a4c183c9$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $kGsr8 = parcelRequire("kGsr8");

var $dMEgP = parcelRequire("dMEgP");

var $sLb2Q = parcelRequire("sLb2Q");

var $co1wz = parcelRequire("co1wz");

var $g4tDr = parcelRequire("g4tDr");



var $f01qr = parcelRequire("f01qr");


var $guzeq = parcelRequire("guzeq");


var $8hVbJ = parcelRequire("8hVbJ");
const $be43b450a4c183c9$var$backlogList = (0, $7uUwQ.freeze)({
    id: (0, $guzeq.BACKLOG),
    type: (0, $guzeq.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $be43b450a4c183c9$var$isFeatureEnabled = (features, featureKey)=>(features || []).some(({ key: key, status: status })=>key === featureKey && status === (0, $0b986b66d9bedfde$export$e927a5d1b72f0b68));
const $be43b450a4c183c9$var$isEstimationFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4181c6622414bfdf));
const $be43b450a4c183c9$var$isVersionsFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$173708eb8a9ba955));
const $be43b450a4c183c9$export$64e7b2d3af76d9e6 = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4279f6f79febea0a));
const $be43b450a4c183c9$var$isBacklogFeatureEnabled = (features)=>$be43b450a4c183c9$var$isFeatureEnabled(features, (0, $guzeq.BACKLOG));
const $be43b450a4c183c9$var$assigneeTransformer = ({ accountId: accountId, displayName: displayName, avatarUrl: avatarUrl })=>({
        id: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    });
const $be43b450a4c183c9$export$c44fc4642496cd94 = ({ id: id, issue: { key: key, type: type, summary: summary, labels: labels, status: status, assignee: assignee }, done: done, flagged: flagged, parentId: parentId, priority: priority, dueDate: dueDate, estimate: estimate, childIssuesMetadata: childIssuesMetadata, fixVersions: fixVersions }, projectId)=>({
        summary: summary,
        id: Number(id),
        key: key,
        labels: labels,
        assignee: assignee ? $be43b450a4c183c9$var$assigneeTransformer(assignee) : null,
        icon: type.iconUrl,
        isDone: done,
        isFlagged: flagged,
        typeId: Number(type.id),
        issueUrl: `/browse/${key}`,
        statusId: status.id,
        parentId: parentId || '' ? Number(parentId) : null,
        priority: priority || null,
        dueDate: dueDate || '' || null,
        estimate: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate) ? null : {
            ...estimate,
            timeRemainingEstimate: null
        },
        numCompleteChildren: childIssuesMetadata?.complete || 0,
        numTotalChildren: childIssuesMetadata?.total || 0,
        fixVersions: fixVersions,
        projectId: Number(projectId)
    });
const $be43b450a4c183c9$var$cardTypesTransformer = (issueTypes)=>issueTypes.reduce((baseLevelCardTypes, { hierarchyLevelType: hierarchyLevelType, id: id, ...issueType })=>{
        if (hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE)) baseLevelCardTypes.push({
            id: Number(id),
            typeHierarchyLevel: hierarchyLevelType,
            ...issueType
        });
        return baseLevelCardTypes;
    }, []);
const $be43b450a4c183c9$var$storyPointFieldIdTransformer = (availableEstimation)=>{
    const storyPointId = availableEstimation.find(({ statisticFieldId: statisticFieldId })=>statisticFieldId !== (0, $guzeq.ORIGINAL_ESTIMATE_FIELD_ID) && statisticFieldId !== (0, $guzeq.ISSUE_COUNT_ID))?.statisticFieldId || '';
    return storyPointId.replace((0, $guzeq.ESTIMATION_TYPE_ID_PREFIX), '') || null;
};
const $be43b450a4c183c9$var$getBacklogStrategy = (features)=>{
    if (!$be43b450a4c183c9$var$isBacklogFeatureEnabled(features)) return 0, $guzeq.NONE;
    if ($be43b450a4c183c9$export$64e7b2d3af76d9e6(features)) return 0, $guzeq.SPRINT;
    return 0, $guzeq.ISSUE_LIST;
};
const $be43b450a4c183c9$export$69760b7e76c533f9 = ({ jira: { timeTrackingOptions: timeTrackingOptions }, boardScope: { board: { rankCustomFieldId: rankCustomFieldId }, projectLocation: { name: name, features: projectFeatures }, currentUser: { permissions: permissions }, features: features, estimation: estimation, backlog: { requestColumnMigration: requestColumnMigration } } })=>{
    const transformedConfig = {
        rankCustomFieldId: Number(rankCustomFieldId),
        requestColumnMigration: requestColumnMigration,
        name: name,
        permissions: (0, $co1wz.ff)('issue-unarchival_wdpb9') ? {
            [(0, $a33d0dff7e784665$export$d765836bd761b2ee)]: permissions.includes((0, $guzeq.MANAGE_SPRINT)),
            [(0, $a33d0dff7e784665$export$526c94c551c00291)]: permissions.includes((0, $guzeq.CREATE_ISSUE)),
            [(0, $a33d0dff7e784665$export$8a1ecb9983951227)]: permissions.includes((0, $guzeq.EDIT_ISSUE)),
            [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: permissions.includes((0, $guzeq.EDIT_BOARD_CONFIG)),
            [(0, $e525e6c25695c9df$export$e6bcada406923d66)]: permissions.includes((0, $guzeq.ARCHIVE_ISSUE))
        } : {
            [(0, $a33d0dff7e784665$export$d765836bd761b2ee)]: permissions.includes((0, $guzeq.MANAGE_SPRINT)),
            [(0, $a33d0dff7e784665$export$526c94c551c00291)]: permissions.includes((0, $guzeq.CREATE_ISSUE)),
            [(0, $a33d0dff7e784665$export$8a1ecb9983951227)]: permissions.includes((0, $guzeq.EDIT_ISSUE)),
            [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: permissions.includes((0, $guzeq.EDIT_BOARD_CONFIG))
        },
        version: {
            isVersionsFeatureEnabled: $be43b450a4c183c9$var$isVersionsFeatureEnabled(projectFeatures)
        },
        allFeatures: features,
        backlogStrategy: $be43b450a4c183c9$var$getBacklogStrategy(features),
        storyPointFieldId: $be43b450a4c183c9$var$storyPointFieldIdTransformer(estimation.available),
        timeTrackingOptions: timeTrackingOptions
    };
    return transformedConfig;
};
const $be43b450a4c183c9$export$4055277b2f3e701f = ({ id: id, name: name, goal: goal, startDate: startDate, endDate: endDate, daysRemaining: daysRemaining, sprintState: sprintState }, canUpdateSprint)=>({
        id: String(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: startDate,
            endDate: endDate,
            daysRemaining: daysRemaining,
            state: sprintState,
            canUpdateSprint: canUpdateSprint
        }
    });
const $be43b450a4c183c9$export$9a5176a1a22928d9 = (issueParents)=>issueParents.reduce((issueParentsEntityState, issueParent)=>Object.assign(issueParentsEntityState, {
            [issueParent.id]: issueParent
        }), {});
const $be43b450a4c183c9$export$f96dae738e4d5e19 = (isEstimationEnabled, estimation)=>{
    const estimateFieldKey = estimation.current.customFieldId || '';
    if (isEstimationEnabled && estimateFieldKey) return estimateFieldKey === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) ? (0, $guzeq.ORIGINAL_ESTIMATE) : (0, $guzeq.STORY_POINTS);
    return 0, $guzeq.ISSUE_COUNT;
};
const $be43b450a4c183c9$export$6b3f2edb57acc06e = (isEstimationEnabled, estimation)=>isEstimationEnabled ? estimation.current.customFieldId : null;
const $be43b450a4c183c9$export$3bf59b7c6d7e91d9 = (features, estimation)=>{
    const isEstimationEnabled = $be43b450a4c183c9$var$isEstimationFeatureEnabled(features);
    return {
        isEstimationFeatureEnabled: isEstimationEnabled,
        estimationType: $be43b450a4c183c9$export$f96dae738e4d5e19(isEstimationEnabled, estimation),
        estimationFieldId: $be43b450a4c183c9$export$6b3f2edb57acc06e(isEstimationEnabled, estimation),
        name: ''
    };
};
const $be43b450a4c183c9$export$cfeec69489a32e7d = (allCards)=>({
        versions: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []))
    });
const $be43b450a4c183c9$var$projectTransformer = (projectLocation)=>({
        projects: [
            {
                id: Number((0, $f01qr.getIdFromAri)(projectLocation.id)),
                isSimplified: true,
                key: projectLocation.key,
                name: projectLocation.name
            }
        ]
    });
const $be43b450a4c183c9$export$2e67aaf0261afb3 = (data)=>{
    const { currentUser: { permissions: permissions }, sprints: sprints, backlog: backlog, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const canUpdateSprint = permissions.includes((0, $guzeq.MANAGE_SPRINT));
    const cardList = {
        [(0, $guzeq.BACKLOG)]: $be43b450a4c183c9$var$backlogList
    };
    const cardListOrder = [];
    const cardOrder = {
        [(0, $guzeq.BACKLOG)]: backlog.cards.reduce((backlogCardOrder, { id: id, done: done })=>done ? backlogCardOrder : backlogCardOrder.concat(Number(id)), [])
    };
    let cards = [];
    sprints.forEach((sprint)=>{
        cardList[sprint.id] = $be43b450a4c183c9$export$4055277b2f3e701f(sprint, canUpdateSprint);
        cardListOrder.push(String(sprint.id));
        cardOrder[sprint.id] = sprint.cards.map(({ id: id })=>Number(id));
        cards = cards.concat(sprint.cards);
    });
    cardListOrder.push((0, $guzeq.BACKLOG));
    cards = cards.concat(backlog.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$be43b450a4c183c9$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: cardList,
            cardListOrder: cardListOrder,
            card: card,
            cardTypes: $be43b450a4c183c9$var$cardTypesTransformer(issueTypes),
            cardOrder: cardOrder,
            issueParents: $be43b450a4c183c9$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $be43b450a4c183c9$export$3bf59b7c6d7e91d9(features, estimation),
            version: $be43b450a4c183c9$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            },
            project: $be43b450a4c183c9$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $be43b450a4c183c9$export$69760b7e76c533f9(data)
    };
};
const $be43b450a4c183c9$export$8714abbd873c8285 = (data)=>{
    const { backlog: backlog, board: board, board: { issueParents: issueParents }, features: features, estimation: estimation, projectLocation: { id: projectId, issueTypes: issueTypes } } = data.boardScope;
    const cards = backlog.cards.concat(board.cards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>id), cards.map((cardData)=>$be43b450a4c183c9$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: {
                [(0, $guzeq.BOARD)]: {
                    id: (0, $guzeq.BOARD),
                    type: (0, $guzeq.BOARD),
                    name: 'Board',
                    issueListKey: backlog.boardIssueListKey
                },
                [(0, $guzeq.BACKLOG)]: $be43b450a4c183c9$var$backlogList
            },
            cardListOrder: [
                (0, $guzeq.BOARD),
                (0, $guzeq.BACKLOG)
            ],
            cardTypes: $be43b450a4c183c9$var$cardTypesTransformer(issueTypes),
            card: card,
            cardOrder: {
                [(0, $guzeq.BOARD)]: board.cards.map(({ id: id })=>Number(id)),
                [(0, $guzeq.BACKLOG)]: backlog.cards.map(({ id: id })=>Number(id))
            },
            issueParents: $be43b450a4c183c9$export$9a5176a1a22928d9(issueParents),
            issueParentsOrder: issueParents.map(({ id: id })=>id),
            estimation: $be43b450a4c183c9$export$3bf59b7c6d7e91d9(features, estimation),
            version: $be43b450a4c183c9$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: issueTypes.map((it)=>Number(it.id))
            },
            project: $be43b450a4c183c9$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $be43b450a4c183c9$export$69760b7e76c533f9(data)
    };
};
const $be43b450a4c183c9$var$transformCriticalData = (data, isCompanyManaged)=>{
    const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_START));
    const result = $be43b450a4c183c9$export$64e7b2d3af76d9e6(data.boardScope.features) ? $be43b450a4c183c9$export$2e67aaf0261afb3(data) : $be43b450a4c183c9$export$8714abbd873c8285(data);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_END));
    return result;
};
var $be43b450a4c183c9$export$2e2bcd8739ae039 = $be43b450a4c183c9$var$transformCriticalData;

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


const $e525e6c25695c9df$export$9f1186f5f46d05d7 = 'CAN_MANAGE_LABS';
const $e525e6c25695c9df$export$1d4594bb2516d9ef = 'CAN_RANK_COLUMNS';
const $e525e6c25695c9df$export$aadc620ce91112df = 'CAN_EDIT_BOARD';
const $e525e6c25695c9df$export$5cd553a40d575c6c = 'CAN_EDIT_ISSUE';
const $e525e6c25695c9df$export$b5cf1ddd753a0a1c = 'CAN_RENAME_COLUMNS';
const $e525e6c25695c9df$export$c5d82f9af027c432 = 'CAN_CREATE_COLUMNS';
const $e525e6c25695c9df$export$9205190dd90cb392 = 'CAN_CREATE_CARDS';
const $e525e6c25695c9df$export$d4845393d78ba468 = 'CAN_DELETE_ISSUE';
const $e525e6c25695c9df$export$112115098b6cf79b = 'CAN_MANAGE_SPRINT';
const $e525e6c25695c9df$export$7c16e92435670968 = 'CAN_MANAGE_AUTOMATION';
const $e525e6c25695c9df$export$172db259b98bcef1 = 'CAN_RELEASE';
const $e525e6c25695c9df$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';

const $0b986b66d9bedfde$export$4279f6f79febea0a = 'SPRINTS';
const $0b986b66d9bedfde$export$4181c6622414bfdf = 'ESTIMATION';
const $0b986b66d9bedfde$export$173708eb8a9ba955 = 'RELEASES';
const $0b986b66d9bedfde$export$e927a5d1b72f0b68 = 'ENABLED';
const $0b986b66d9bedfde$export$8cd212c10b4124d2 = 'DISABLED';
const $0b986b66d9bedfde$export$b0409bb9b247a093 = 'COMING_SOON';



parcelRegister("fdAim", function(module, exports) {

$parcel$export(module.exports, "CARD_REFRESH_REQUEST", () => $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b);
$parcel$export(module.exports, "CARD_REFRESH_SUCCESS", () => $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1);
$parcel$export(module.exports, "cardRefreshRequest", () => $2abd2fdf8ad53fef$export$54efae65153e525a);
$parcel$export(module.exports, "cardRefreshSuccess", () => $2abd2fdf8ad53fef$export$8c0b797631a3987f);
const $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b = 'state.actions.cards.refresh.CARD_REFRESH_REQUEST';
const $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1 = 'state.actions.cards.refresh.CARD_REFRESH_SUCCESS';
const $2abd2fdf8ad53fef$export$54efae65153e525a = (cardId, changeEvent)=>({
        type: $2abd2fdf8ad53fef$export$a5cacf6c12c6c43b,
        payload: {
            cardId: cardId,
            changeEvent: changeEvent || null
        }
    });
const $2abd2fdf8ad53fef$export$8c0b797631a3987f = (card)=>({
        type: $2abd2fdf8ad53fef$export$5d5ffe0a39497fb1,
        payload: card
    });

});


parcelRegister("eVhWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1820cf215861eb7$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");


var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $czUNp = parcelRequire("czUNp");

var $dGljH = parcelRequire("dGljH");

var $bAfUr = parcelRequire("bAfUr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1820cf215861eb7$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $czUNp.CARD_STATUS_CHECK)).mergeMap((action)=>{
        const { payload: payload } = action;
        if ('fieldId' in payload && payload.fieldId !== (0, $e9be48d6d2c01760$export$4420b7468f889692)) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const hasIssueOnBacklog = (0, $dGljH.getAllCardIdsIncludingIssueParents)(state).includes(Number(payload.issueId));
        // since ChangeEvent can be of different type and not all have fieldValue
        // @ts-expect-error - TS2339 - Property 'fieldValue' does not exist on type '{ fieldId: string; fieldValue: any; } | { fieldId: string; } | { fieldId: string; fieldValue: any; } | { typeName: string; } | { newParentIssueId: string | null; oldParentIssueId: string | null; } | ChangedIssueLink | { ...; } | { ...; } | { ...; }'.
        const isStatusIdMappedToBoard = payload.meta.fieldValue ? (0, $bAfUr.isStatusMappedToBoardOld)(payload.meta.fieldValue.id)(state) : false;
        // if an unmapped issue(including parent) does not exist on backlog & its remapped with status change,
        // need to refresh the data, so that issue will reappear on backlog
        return !hasIssueOnBacklog && isStatusIdMappedToBoard ? (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_STATUS_REMAPPED))) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("czUNp", function(module, exports) {

$parcel$export(module.exports, "CARD_STATUS_SET", () => $7cb4a4f27fcd037f$export$ecf291dab442850b);
$parcel$export(module.exports, "cardStatusSet", () => $7cb4a4f27fcd037f$export$8f909d4ac3011c05);
$parcel$export(module.exports, "CARD_STATUS_CHECK", () => $7cb4a4f27fcd037f$export$17514c9f1eddf04d);
$parcel$export(module.exports, "cardStatusCheck", () => $7cb4a4f27fcd037f$export$9fafd08cacc25a20);
const $7cb4a4f27fcd037f$export$ecf291dab442850b = 'state.actions.status.CARD_STATUS_SET';
const $7cb4a4f27fcd037f$export$8f909d4ac3011c05 = (cardId, prevStatusId, statusId, statusCategory, isCMP)=>({
        type: $7cb4a4f27fcd037f$export$ecf291dab442850b,
        payload: {
            cardId: cardId,
            prevStatusId: prevStatusId,
            statusId: statusId,
            statusCategory: statusCategory,
            isCMP: isCMP
        }
    });
const $7cb4a4f27fcd037f$export$17514c9f1eddf04d = 'state.actions.status.CARD_STATUS_CHECK';
const $7cb4a4f27fcd037f$export$9fafd08cacc25a20 = (payload)=>({
        type: $7cb4a4f27fcd037f$export$17514c9f1eddf04d,
        payload: payload
    });

});


parcelRegister("028Rt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8072515d79f2e477$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $hf5c2 = parcelRequire("hf5c2");

var $czUNp = parcelRequire("czUNp");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $bAfUr = parcelRequire("bAfUr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8072515d79f2e477$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $czUNp.CARD_STATUS_SET)).mergeMap((action)=>{
        const { payload: { cardId: cardId, prevStatusId: prevStatusId, statusId: statusId } } = action;
        const state = store.getState();
        const cardKey = (0, $dGljH.makeCardKeyFromCardId)(state)(cardId);
        if (!(0, $bAfUr.isStatusMappedToBoard)(state)(statusId)) return (0, $kVLXA.Observable).of((0, $hf5c2.cardCreateUnmappedWithIssueLink)([
            {
                id: cardId,
                key: cardKey
            }
        ]));
        if ((0, $jG5HW.isCmpKanbanProject)(state)) {
            const statusIdIsVisible = (0, $bAfUr.isStatusVisibleOnCmpKanbanBacklog)(state)(statusId);
            const cardHasMovedColumn = !(0, $bAfUr.areStatusesFromSameColumn)(state)(prevStatusId, statusId);
            if (!statusIdIsVisible || cardHasMovedColumn) return (0, $kVLXA.Observable).from([
                (0, $3lZ6i.loadAppData)(),
                (0, $a7yHf.clearExpandedCardGroup)(cardId)
            ]);
        }
        const isCMP = (0, $jG5HW.getIsCompanyManaged)(state);
        if (isCMP) // For CMP, always do a data refresh on status transition
        // to ensure the issue's resolution is correct.
        return (0, $kVLXA.Observable).from([
            (0, $3lZ6i.loadAppData)()
        ]);
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("jv1aX", function(module, exports) {

$parcel$export(module.exports, "cardsBulkOperationsFailureEpic", () => $3b557eae5da9a56a$export$7900f6327252d82);
$parcel$export(module.exports, "cardsBulkOperationsSuccessEpicCmp", () => $3b557eae5da9a56a$export$1398e97029b0b992);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $eSSqy = parcelRequire("eSSqy");
const $3b557eae5da9a56a$export$7900f6327252d82 = (action$)=>action$.ofType((0, $eSSqy.CARDS_BULK_OPERATIONS_FAILURE)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE)));
    });
const $3b557eae5da9a56a$export$1398e97029b0b992 = (action$)=>action$.ofType((0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)).flatMap((action)=>{
        if (action.payload.length === 0) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppData)());
    });

});
parcelRegister("eSSqy", function(module, exports) {

$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_REQUESTS", () => $4b622b7cab87e15c$export$89d925e1f8ce24b2);
$parcel$export(module.exports, "cardsBulkOperationsRequests", () => $4b622b7cab87e15c$export$1edfb57ee17c64a7);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_SUCCESS", () => $4b622b7cab87e15c$export$3f2add5deaccd21);
$parcel$export(module.exports, "cardsBulkOperationsSuccess", () => $4b622b7cab87e15c$export$a9c3b26200843a57);
$parcel$export(module.exports, "CARDS_BULK_OPERATIONS_FAILURE", () => $4b622b7cab87e15c$export$11514e15dcf93257);
$parcel$export(module.exports, "cardsBulkOperationsFailure", () => $4b622b7cab87e15c$export$ca0b712e0be4eecd);

var $c0irb = parcelRequire("c0irb");
const $4b622b7cab87e15c$export$89d925e1f8ce24b2 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_REQUESTS';
const $4b622b7cab87e15c$export$1edfb57ee17c64a7 = (payload)=>({
        type: $4b622b7cab87e15c$export$89d925e1f8ce24b2,
        payload: payload,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $4b622b7cab87e15c$export$3f2add5deaccd21 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_SUCCESS';
const $4b622b7cab87e15c$export$a9c3b26200843a57 = (optimisticId, payload)=>({
        type: $4b622b7cab87e15c$export$3f2add5deaccd21,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $4b622b7cab87e15c$export$11514e15dcf93257 = 'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_FAILURE';
const $4b622b7cab87e15c$export$ca0b712e0be4eecd = (optimisticId, payload)=>({
        type: $4b622b7cab87e15c$export$11514e15dcf93257,
        meta: (0, $c0irb.revertOptimisticUiMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("iKvYD", function(module, exports) {

$parcel$export(module.exports, "cardsFlagWithCommentEpic", () => $da9c82ece9086f7c$export$a1e5554df37d16f8);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");

var $guzeq = parcelRequire("guzeq");

var $63NNS = parcelRequire("63NNS");

var $3lZ6i = parcelRequire("3lZ6i");

var $aKajY = parcelRequire("aKajY");
const $da9c82ece9086f7c$export$a1e5554df37d16f8 = (action$, store)=>action$.ofType((0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST)).mergeMap((action)=>{
        const { payload: { cards: cards, flag: flag }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        return (0, $63NNS.default)(store, action).flatMap((response)=>{
            if (response === null) {
                // if we get here, all of the issues were successfully updated
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    numCards: cards.length,
                    flagAction: flag ? 'added' : 'removed'
                });
                return (0, $kVLXA.Observable).of((0, $aKajY.cardsFlagWithCommentSuccess)(optimisticId, {
                    cards: cards
                }));
            }
            // if we get here, at least one of the issues failed to be updated,
            // so we treat it as a failure
            const error = new Error(response.errorMessages.join(', '));
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.cards-flag-with-comment.partial-failure', 'Failed to flag and/or comment on some issues.', error);
            throw error;
        }).catch(()=>{
            // if we get here directly from the cardsFlagWithCommentService, none
            // of the issues were successfully updated
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'flagCards',
                numCards: cards.length,
                flagAction: flag ? 'added' : 'removed'
            });
            return (0, $kVLXA.Observable).from([
                (0, $aKajY.cardsFlagWithCommentFailure)(optimisticId, {
                    cards: cards
                }),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("63NNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $54678a7970acef10$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $fYPeZ = parcelRequire("fYPeZ");

var $dGljH = parcelRequire("dGljH");
const $54678a7970acef10$export$de42cacd38bf80bd = (store, action)=>{
    const { payload: { cards: cards, flag: flag, comment: comment } } = action;
    const state = store.getState();
    const allCards = (0, $dGljH.getCards)(state);
    const issueKeys = cards.map((id)=>allCards[String(id)].key);
    return (0, $kVLXA.Observable).fromPromise((0, $fYPeZ.default)(issueKeys, flag, comment));
};
var $54678a7970acef10$export$2e2bcd8739ae039 = $54678a7970acef10$export$de42cacd38bf80bd;

});
parcelRegister("fYPeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a56f37a43de2568b$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $iwPwz = parcelRequire("iwPwz");
const $a56f37a43de2568b$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $a56f37a43de2568b$var$noContentStatus = 204;
const $a56f37a43de2568b$export$5e94598347afb988 = (issueKeys, flag, comment)=>fetch($a56f37a43de2568b$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $a56f37a43de2568b$var$noContentStatus) return null;
        return response.text().then((body)=>body ? JSON.parse(body) : null);
    });
var $a56f37a43de2568b$export$2e2bcd8739ae039 = $a56f37a43de2568b$export$5e94598347afb988;

});


parcelRegister("aKajY", function(module, exports) {

$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_REQUEST", () => $3faa5ac58d7af7dd$export$54cb48f5bedda9b0);
$parcel$export(module.exports, "cardsFlagWithCommentRequest", () => $3faa5ac58d7af7dd$export$5e94598347afb988);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_SUCCESS", () => $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb);
$parcel$export(module.exports, "cardsFlagWithCommentSuccess", () => $3faa5ac58d7af7dd$export$de9dc95767a5ba8a);
$parcel$export(module.exports, "CARDS_FLAG_WITH_COMMENT_FAILURE", () => $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb);
$parcel$export(module.exports, "cardsFlagWithCommentFailure", () => $3faa5ac58d7af7dd$export$83679228bcad76fd);

var $c0irb = parcelRequire("c0irb");
const $3faa5ac58d7af7dd$export$54cb48f5bedda9b0 = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_REQUEST';
const $3faa5ac58d7af7dd$export$5e94598347afb988 = (payload, analyticsEvent)=>({
        type: $3faa5ac58d7af7dd$export$54cb48f5bedda9b0,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_SUCCESS';
const $3faa5ac58d7af7dd$export$de9dc95767a5ba8a = (optimisticId, payload)=>({
        type: $3faa5ac58d7af7dd$export$7ae03d8a0b15c6bb,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId),
        payload: payload
    });
const $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb = 'state.actions.cards.flag-with-comment.CARDS_FLAG_WITH_COMMENT_FAILURE';
const $3faa5ac58d7af7dd$export$83679228bcad76fd = (optimisticId, payload)=>({
        type: $3faa5ac58d7af7dd$export$b85cf7baff5e9cdb,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId),
        payload: payload
    });

});


parcelRegister("1pwBu", function(module, exports) {

$parcel$export(module.exports, "beforeMoveCardsEpic", () => $75c07ecefd9b343a$export$4cb77cd53144053d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $g4tDr = parcelRequire("g4tDr");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");


var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $bAfUr = parcelRequire("bAfUr");

var $4RNa9 = parcelRequire("4RNa9");
const $75c07ecefd9b343a$var$getBeforeCardId = (action, topCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $guzeq.TOP_OF_LIST)) return topCardId || null;
    if (action.payload.placement === (0, $guzeq.BEFORE_CARD)) return action.payload.beforeCardId;
    return null;
};
const $75c07ecefd9b343a$var$getAfterCardId = (action, bottomCardId)=>{
    const { placement: placement } = action.payload;
    if (placement === (0, $guzeq.BOTTOM_OF_LIST) || placement === (0, $guzeq.BOTTOM_OF_CARD_GROUP)) return bottomCardId || null;
    return null;
};
const $75c07ecefd9b343a$export$c53c1ed4374c27e3 = ({ state: state, cardListId: cardListId, cardIds: cardIds, isDroppedInTransitionZone: isDroppedInTransitionZone, beforeCardId: beforeCardId, afterCardId: afterCardId, targetStatusId: targetStatusId, analyticsEvent: analyticsEvent, newCardOrderGlobal: newCardOrderGlobal })=>{
    const newCardOrder = (0, $4RNa9.getNewCardOrder)(state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone);
    return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)({
        cardIds: cardIds,
        cardListId: cardListId,
        newCardOrder: newCardOrder,
        newCardOrderGlobal: newCardOrderGlobal,
        targetStatusId: targetStatusId,
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isBetweenLists: true
    }, analyticsEvent));
};
const $75c07ecefd9b343a$export$4cb77cd53144053d = (action$, store)=>action$.ofType((0, $6GNN7.CARDS_MOVE)).mergeMap((action)=>{
        const state = store.getState();
        const rankCustomFieldId = (0, $jG5HW.getRankCustomFieldId)(state);
        if (!rankCustomFieldId) return (0, $kVLXA.Observable).empty();
        const { payload: { cardIds: cardIds, cardListId: destinationCardListId, isBetweenLists: isBetweenLists, isFromActiveSprint: isFromActiveSprint, placement: placement }, meta: { analyticsEvent: analyticsEvent } } = action;
        const cardListId = (0, $f01qr.getCardListId)(destinationCardListId);
        const cardOrder = (0, $dGljH.getFlattenOrderedCardIds)(state);
        const cardLists = (0, $dGljH.getCardLists)(state);
        const cards = (0, $dGljH.getCards)(state);
        const isCmpKanbanBacklog = (0, $jG5HW.isCmpKanbanProject)(state);
        const isCmpScrumBacklog = (0, $jG5HW.isCMPScrumBacklog)(state);
        const isCmpBacklog = (0, $jG5HW.getIsCompanyManaged)(state);
        let cardsToMove = cardIds || (0, $dGljH.getSelectedCards)(state);
        let newCardOrderGlobal;
        const isMovingSubtasks = (0, $4RNa9.getIsMovingSubtasks)(cards, cardsToMove);
        const cardParentId = cardsToMove.filter((card)=>(0, $g4tDr.isSubtaskHierarchyLevel)(cards[card]?.typeHierarchyLevel)).reduce((id, curr)=>cards[curr].parentId ?? id, null);
        const targetStatusId = isBetweenLists ? (0, $bAfUr.makeGetKanbanSingleColumnStatusId)(state)(cardListId) : undefined;
        if (isCmpBacklog) {
            const getCardListIdByCardId = (0, $dGljH.makeGetCardListIdByCardId)(state);
            const getCardGroupByParentId = (0, $ld0jI.makeGetCardGroupByParentId)(state);
            cardsToMove = (0, $4RNa9.getCMPCardsToMove)({
                cardIds: cardsToMove,
                getCardListIdByCardId: getCardListIdByCardId,
                getCardGroupByParentId: getCardGroupByParentId,
                isCmpScrumBacklog: isCmpScrumBacklog
            });
        }
        const orderedCardIds = cardOrder.filter((orderedCardId)=>cardsToMove.includes(orderedCardId));
        const topCardId = (0, $dGljH.makeGetTopCardIdFromCardList)(state)(cardListId, cardsToMove);
        const bottomCardId = isMovingSubtasks && cardParentId && placement !== (0, $guzeq.BOTTOM_OF_LIST) ? (0, $ld0jI.makeGetBottomCardIdFromCardGroup)(state)(cardListId, cardParentId, cardsToMove) : (0, $dGljH.makeGetBottomCardIdFromCardList)(state)(cardListId, cardsToMove);
        const beforeCardId = $75c07ecefd9b343a$var$getBeforeCardId(action, topCardId);
        // When dropping on subtask and moving card is not a subtask set bottom as the parentId of the subtasks
        const bottomId = bottomCardId && !isMovingSubtasks && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[bottomCardId]?.typeHierarchyLevel) ? cards[bottomCardId]?.parentId : bottomCardId;
        const afterCardId = $75c07ecefd9b343a$var$getAfterCardId(action, bottomId);
        if (isCmpKanbanBacklog) {
            const isTransitionZoneDestination = action.payload.placement === (0, $guzeq.TRANSITION_ZONE);
            newCardOrderGlobal = (0, $4RNa9.getNewCardOrderGlobal)(state, orderedCardIds, beforeCardId, afterCardId, isMovingSubtasks);
            if (isBetweenLists && (isTransitionZoneDestination || isMovingSubtasks)) return $75c07ecefd9b343a$export$c53c1ed4374c27e3({
                state: state,
                cardListId: cardListId,
                cardIds: orderedCardIds,
                isDroppedInTransitionZone: isTransitionZoneDestination,
                beforeCardId: beforeCardId,
                afterCardId: afterCardId,
                targetStatusId: targetStatusId,
                analyticsEvent: analyticsEvent,
                newCardOrderGlobal: newCardOrderGlobal
            });
        }
        const payload = {
            cardIds: orderedCardIds,
            cardListId: cardListId,
            isBetweenLists: isBetweenLists,
            beforeCardId: beforeCardId,
            afterCardId: afterCardId,
            targetStatusId: targetStatusId,
            newCardOrderGlobal: newCardOrderGlobal
        };
        const toActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(cardListId);
        if (isBetweenLists && (isFromActiveSprint || toActiveSprint)) {
            const originCardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(orderedCardIds[0]);
            return (0, $kVLXA.Observable).of((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$86a0c18887a92eae),
                payload: {
                    cardIds: orderedCardIds,
                    originCardListName: originCardListId ? cardLists[originCardListId].name : '',
                    destinationCardListName: cardLists[cardListId].name,
                    confirmActionPayload: payload,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveRequest)(payload, analyticsEvent));
    });

});
parcelRegister("ld0jI", function(module, exports) {

$parcel$export(module.exports, "makeGetCardGroupByParentId", () => $0271650b1fb6a13c$export$d2788281fedf0254);
$parcel$export(module.exports, "makeGetCardGroupByChildId", () => $0271650b1fb6a13c$export$c259bd0429fd462d);
$parcel$export(module.exports, "makeGetBottomCardIdFromCardGroup", () => $0271650b1fb6a13c$export$310938eee52c1639);
$parcel$export(module.exports, "makeIsCardInCollapsedCardGroup", () => $0271650b1fb6a13c$export$7e51b32fda52165e);

var $dGvGJ = parcelRequire("dGvGJ");

var $k8IPx = parcelRequire("k8IPx");

var $gJBT6 = parcelRequire("gJBT6");

var $ee1tL = parcelRequire("ee1tL");

var $dGljH = parcelRequire("dGljH");
const $0271650b1fb6a13c$export$d2788281fedf0254 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetOrderedCardEntries)
], (getOrderedCardEntries)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardListId, parentId)=>{
        const cardEntries = getOrderedCardEntries(cardListId);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return cardEntries.find((cardEntry)=>(0, $ee1tL.isCardEntryGroup)(cardEntry) && cardEntry.parentId === parentId);
    }, (cardListId, parentId)=>`${cardListId}::${parentId}`));
const $0271650b1fb6a13c$export$c259bd0429fd462d = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetCardListIdByCardId),
    (0, $dGljH.getParentIdByChildIdSelector),
    $0271650b1fb6a13c$export$d2788281fedf0254
], (getCardListIdByCardId, getParentIdByChildId, getCardGroupByParentId)=>{
    const getCardGroupByChildId = (cardId)=>{
        const cardListId = getCardListIdByCardId(cardId);
        if (!cardListId) return null;
        const parentId = getParentIdByChildId(cardId);
        return parentId ? getCardGroupByParentId(cardListId, parentId) : null;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getCardGroupByChildId);
});
const $0271650b1fb6a13c$export$310938eee52c1639 = (0, $dGvGJ.createSelector)([
    $0271650b1fb6a13c$export$d2788281fedf0254
], (getCardGroupByParentId)=>(cardListId, parentId, ignoredIds)=>{
        const cardGroup = getCardGroupByParentId(cardListId, parentId);
        if (!cardGroup) return null;
        const list = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(cardGroup.cardIds, ignoredIds);
        return list.length > 0 ? list[list.length - 1] : null;
    });
const $0271650b1fb6a13c$export$7e51b32fda52165e = (0, $dGvGJ.createSelector)([
    $0271650b1fb6a13c$export$c259bd0429fd462d
], (getCardGroupByChildId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardGroup = getCardGroupByChildId(cardId);
        if (cardGroup) return cardGroup.isCollapsed;
        return false;
    }));

});

parcelRegister("4RNa9", function(module, exports) {

$parcel$export(module.exports, "getIsMovingSubtasks", () => $13554e2871800c00$export$a9e6d5ca31611623);
$parcel$export(module.exports, "getCMPCardsToMove", () => $13554e2871800c00$export$9b3afea889889644);
$parcel$export(module.exports, "getNewCardOrder", () => $13554e2871800c00$export$5455144e38b4d576);
$parcel$export(module.exports, "getNewCardOrderGlobal", () => $13554e2871800c00$export$7bc7f0caf073cc20);

var $g4tDr = parcelRequire("g4tDr");

var $lt7Oy = parcelRequire("lt7Oy");

var $dGljH = parcelRequire("dGljH");
const $13554e2871800c00$export$a9e6d5ca31611623 = (cards, cardsToMove)=>cardsToMove.some((cardId)=>cards[cardId] && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $13554e2871800c00$var$removeSubtasks = (cards, cardIds)=>cardIds.filter((cardId)=>cards[cardId] && !(0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId].typeHierarchyLevel));
const $13554e2871800c00$export$9b3afea889889644 = ({ cardIds: cardIds, getCardListIdByCardId: getCardListIdByCardId, getCardGroupByParentId: getCardGroupByParentId, isCmpScrumBacklog: isCmpScrumBacklog })=>{
    // For each card, we check if it is the parent of
    // a collapsed card group in kanban, or any card
    // group in scurm. If yes, we take the subtasks in
    // this card group and add them to the subtasksToMove.
    const subtasksToMove = cardIds.flatMap((cardId)=>{
        const listId = getCardListIdByCardId(cardId);
        const cardGroup = listId && getCardGroupByParentId(listId, cardId);
        if (cardGroup && (isCmpScrumBacklog || cardGroup.isCollapsed)) return cardGroup.cardIds;
        return [];
    });
    return [
        ...cardIds,
        ...subtasksToMove
    ];
};
const $13554e2871800c00$export$546ed7c4f4fa68f9 = (cardIdOrder, cardIds)=>cardIdOrder.filter((cardId)=>cardIds.includes(cardId));
const $13554e2871800c00$export$5455144e38b4d576 = (state, cardListId, cardIds, beforeCardId, afterCardId, isDroppedInTransitionZone)=>{
    const globalCardOrder = (0, $lt7Oy.getCardOrderGlobal)(state);
    const cardListCardOrder = (0, $lt7Oy.getCardOrderByCardlistId)(state, cardListId);
    const allCards = (0, $dGljH.getCards)(state);
    // 1. Handle when cards are dropped and ranked within a cardlist.
    // This could include both subtasks and non-subtasks, where
    // the card that was dragged was a non-subtask.
    // This can only occur when the backlog is sorted by rank.
    if (!isDroppedInTransitionZone && (beforeCardId || afterCardId)) {
        const subtaskCardIds = [];
        const nonSubtaskCardIds = [];
        cardIds.forEach((cardId)=>{
            const card = allCards[cardId];
            const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
            if (isSubtask) subtaskCardIds.push(cardId);
            else nonSubtaskCardIds.push(cardId);
        });
        // a. Order subtasks within the cardlist according to their global rank
        const newCardOrder = $13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, [
            ...subtaskCardIds,
            ...cardListCardOrder
        ]);
        const insertIndex = beforeCardId ? newCardOrder.indexOf(beforeCardId) : newCardOrder.indexOf(afterCardId || 0) + 1;
        // b. Insert sorted non-subtasks into the position in the cardlist they were dropped
        newCardOrder.splice(insertIndex, 0, ...$13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, nonSubtaskCardIds));
        return newCardOrder;
    }
    // 2. Handle when cards are dropped in a cardlist where the backlog is not
    // sorted by rank, or when the dragged card is a subtask, and therefore
    // not itself rankable.
    return $13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, [
        ...cardIds,
        ...cardListCardOrder
    ]);
};
const $13554e2871800c00$export$7bc7f0caf073cc20 = (state, cardIds, beforeCardId, afterCardId, isMovingSubtasks)=>{
    const globalCardOrder = (0, $lt7Oy.getCardOrderGlobal)(state);
    const cards = (0, $dGljH.getCards)(state);
    if (!(beforeCardId || afterCardId)) return globalCardOrder;
    let cardsToMove = cardIds.concat();
    // When multiple cards including both subtasks and
    // non-subtasks have moved, and the dropped card is
    // a non-subtask, the subtasks will keep their global order,
    // while the non-subtasks will have their order changed
    // based on beforeCardId or afterCardId
    if (isMovingSubtasks) cardsToMove = $13554e2871800c00$var$removeSubtasks(cards, cardIds);
    // Remove all the cards that have moved, to be
    // placed back into their new position below
    const newCardOrderGlobal = globalCardOrder.filter((cardId)=>!cardsToMove.includes(cardId));
    const insertIndex = beforeCardId ? newCardOrderGlobal.indexOf(beforeCardId) : newCardOrderGlobal.indexOf(afterCardId) + 1;
    newCardOrderGlobal.splice(insertIndex, 0, ...$13554e2871800c00$export$546ed7c4f4fa68f9(globalCardOrder, cardsToMove));
    return newCardOrderGlobal;
};

});
parcelRegister("lt7Oy", function(module, exports) {

$parcel$export(module.exports, "getCardOrderGlobal", () => $3d50e9abbfaef6cd$export$befde80c539a6f40);
$parcel$export(module.exports, "getCardOrderByCardlistId", () => $3d50e9abbfaef6cd$export$e79e737a0d7a721b);

var $e5nhF = parcelRequire("e5nhF");
const $3d50e9abbfaef6cd$export$b7cd5af9264d7384 = (state)=>(0, $e5nhF.getEntities)(state).cardOrder;
const $3d50e9abbfaef6cd$export$befde80c539a6f40 = (state)=>(0, $e5nhF.getEntities)(state).cardOrderGlobal;
const $3d50e9abbfaef6cd$export$e79e737a0d7a721b = (state, cardListId)=>$3d50e9abbfaef6cd$export$b7cd5af9264d7384(state)[cardListId];

});



parcelRegister("aXaCi", function(module, exports) {

$parcel$export(module.exports, "cardsMoveRequestEpic", () => $8ccaab8bb1e5bac0$export$8d85b975065644ab);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("d0pqD");

var $dJl1T = parcelRequire("dJl1T");

var $8zOmE = parcelRequire("8zOmE");

var $2lpqS = parcelRequire("2lpqS");

var $86ezP = parcelRequire("86ezP");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");


var $bhjL2 = parcelRequire("bhjL2");

var $4aiwT = parcelRequire("4aiwT");

var $lDAfn = parcelRequire("lDAfn");

var $7PjMX = parcelRequire("7PjMX");

var $3oKOV = parcelRequire("3oKOV");

var $iruXQ = parcelRequire("iruXQ");

var $i4Z8q = parcelRequire("i4Z8q");

var $ifBw8 = parcelRequire("ifBw8");


var $lyvhj = parcelRequire("lyvhj");

var $3lZ6i = parcelRequire("3lZ6i");

var $a1ybZ = parcelRequire("a1ybZ");

var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");
const $8ccaab8bb1e5bac0$var$isCardsMoveNonOptimisticRequestAction = (action)=>action && 'meta' in action && 'optimisticId' in action.meta;
const $8ccaab8bb1e5bac0$var$getOptimisticId = (action)=>$8ccaab8bb1e5bac0$var$isCardsMoveNonOptimisticRequestAction(action) ? action.meta.optimisticId : action.meta.optimistic.id;
const $8ccaab8bb1e5bac0$var$getTargetStatusId = (action)=>{
    if (action.payload.selectedTransition) return String(action.payload.selectedTransition.toStatusId);
    return action.payload.targetStatusId;
};
const $8ccaab8bb1e5bac0$var$moveToSprint = (params)=>(0, $7PjMX.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), Number(params.cardList.id), params.cardKeys, params.beforeCardKey, params.afterCardKey, false);
const $8ccaab8bb1e5bac0$var$moveCardToList = (params, targetColumn, isCompanyManaged, isCmpKanban)=>isCompanyManaged ? (0, $iruXQ.transitionAndRankService)({
        rankCustomFieldId: params.rankCustomFieldId,
        issueKeys: params.cardKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: params.beforeCardKey,
        rankAfterIssueIdOrKey: params.afterCardKey,
        rapidViewId: Number(params.rapidViewId),
        selectedTransitionId: params.selectedTransition?.id,
        calculateNewIssuesOrder: isCmpKanban
    }) : (0, $bhjL2.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey, params.afterCardKey, Number(params.rapidViewId), params.cardListId);
const $8ccaab8bb1e5bac0$var$moveCardToBacklog = (params)=>(0, $7PjMX.default)(params.baseUrl, params.rankCustomFieldId, Number(params.rapidViewId), null, params.cardKeys, params.beforeCardKey, params.afterCardKey, true);
const $8ccaab8bb1e5bac0$var$moveInsideList = (params, errorLogAttributes)=>{
    if (!params.beforeCardKey && !params.afterCardKey) {
        if (errorLogAttributes) (0, $dJl1T.default).safeErrorWithoutCustomerData('jsw.backlog.cards-move.request-epic', 'Failed to rank cards due to missing beforeCardKey and afterCardKey', errorLogAttributes);
        return (0, $kVLXA.Observable).empty();
    }
    if (params.afterCardKey) return (0, $4aiwT.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.afterCardKey);
    return (0, $lDAfn.default)(params.baseUrl, params.rankCustomFieldId, params.cardKeys, params.beforeCardKey);
};
const $8ccaab8bb1e5bac0$export$e9800111bfe3c5b3 = (action, state, servicePayload)=>{
    const { payload: { isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId } } = action;
    const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
    const { cardListType: cardListType } = servicePayload;
    const errorLogAttributes = {
        beforeCardId: beforeCardId,
        afterCardId: afterCardId,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
    // move cards within a Sprint or to a different Sprint list when in Scrum board
    if (cardListType === (0, $guzeq.SPRINT)) {
        if (serviceContext.isCompanyManaged) return $8ccaab8bb1e5bac0$var$moveToSprint(servicePayload);
        return $8ccaab8bb1e5bac0$var$moveToSprint(servicePayload);
    }
    // move cards within the backlog or to the backlog when in Scrum board
    if ((0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.SPRINT) && cardListType === (0, $guzeq.BACKLOG)) {
        if (serviceContext.isCompanyManaged) return $8ccaab8bb1e5bac0$var$moveCardToBacklog(servicePayload);
        return $8ccaab8bb1e5bac0$var$moveCardToBacklog(servicePayload);
    }
    const targetColumnId = (0, $jG5HW.getKanbanTargetColumnId)(state)(servicePayload.cardListType);
    if (serviceContext.isCompanyManaged && (0, $jG5HW.isKanbanBacklogStrategy)(state)) {
        // move cards from one list to another list for Kanban board
        if (isBetweenLists) {
            const isCompanyManagedKanban = true;
            return $8ccaab8bb1e5bac0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, isCompanyManagedKanban);
        }
        // move cards within a list for Kanban board
        return $8ccaab8bb1e5bac0$var$moveInsideList(servicePayload, errorLogAttributes);
    }
    // move cards from one list to another list for Kanban board
    if (isBetweenLists) return $8ccaab8bb1e5bac0$var$moveCardToList(servicePayload, targetColumnId, serviceContext.isCompanyManaged, (0, $jG5HW.isKanbanBacklogStrategy)(state));
    // move cards within a list for Kanban board
    return $8ccaab8bb1e5bac0$var$moveInsideList(servicePayload, errorLogAttributes);
};
const $8ccaab8bb1e5bac0$var$rankForTransitionScreen = (action, params)=>(transitionScreenEvent)=>{
        const { payload: { cardIds: cardIds, cardListId: cardListId, selectedTransition: selectedTransition }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(action);
        const analyticsEventProperties = {
            withSelectedTransition: !!selectedTransition
        };
        if ((0, $lyvhj.isShowEvent)(transitionScreenEvent)) {
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen show', analyticsEventProperties);
            return (0, $kVLXA.Observable).empty();
        }
        if ((0, $lyvhj.isSuccessfulEvent)(transitionScreenEvent)) {
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen success', analyticsEventProperties);
            return $8ccaab8bb1e5bac0$var$moveInsideList(params).map(()=>(0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)));
        }
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'transitionScreen cancel', analyticsEventProperties);
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
    };
const $8ccaab8bb1e5bac0$var$handleMoveCardSuccess = (action, state, dispatch, params)=>(response)=>{
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists, beforeCardId: beforeCardId, afterCardId: afterCardId }, meta: { analyticsEvent: analyticsEvent } } = action;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(action);
        const { cardKeys: cardKeys } = params;
        if (!serviceContext.isCompanyManaged) return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent));
        if ((0, $3oKOV.isFailedTransitionAndRankResponse)(response) && (0, $3oKOV.hasMultipleTransitions)(response)) {
            const transitions = (0, $3oKOV.getPossibleTransitions)(response).map((possibleTransition)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: possibleTransition.id,
                    name: possibleTransition.name,
                    hasScreen: possibleTransition.hasTransitionView,
                    toStatusId: possibleTransition.targetStatus
                }));
            return (0, $kVLXA.Observable).of((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$dcb8eb3e585ecde),
                payload: {
                    cardKeys: cardKeys,
                    transitions: transitions,
                    moveCardsActionPayload: {
                        cardIds: cardIds,
                        cardListId: cardListId,
                        isBetweenLists: isBetweenLists,
                        beforeCardId: beforeCardId,
                        afterCardId: afterCardId
                    },
                    optimisticId: optimisticId,
                    analyticsEvent: analyticsEvent
                }
            }));
        }
        if ((0, $3oKOV.isFailedTransitionAndRankResponse)(response) && (0, $3oKOV.hasTransitionScreens)(response)) {
            const transition = (0, $3oKOV.getFirstTransitionScreen)(response);
            if (!transition) return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
            return (0, $ifBw8.transitionScreenDialogService)({
                issueId: cardIds[0],
                issueKey: cardKeys[0],
                transitionId: transition.id,
                analyticsEvent: analyticsEvent,
                dispatch: dispatch
            }).flatMap($8ccaab8bb1e5bac0$var$rankForTransitionScreen(action, params));
        }
        if (serviceContext.isCompanyManaged && (0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.KANBAN_BACKLOG_STRATEGY)) {
            const actions = [
                (0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)),
                // TODO: Review why we need this and avoid it on most cases
                // This will refresh
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS))
            ];
            const getCardIdFromCardKey = (0, $dGljH.makeCardIdFromCardKey)(state);
            const newCardOrder = (0, $3oKOV.getNewCardOrder)(response)?.map((cardKey)=>getCardIdFromCardKey(cardKey));
            if (newCardOrder) actions.push((0, $a1ybZ.setCardOrderGlobal)(newCardOrder));
            return (0, $kVLXA.Observable).from(actions);
        }
        return (0, $kVLXA.Observable).of((0, $6GNN7.cardsMoveSuccess)(optimisticId, cardIds, cardListId, analyticsEvent, $8ccaab8bb1e5bac0$var$getTargetStatusId(action)));
    };
const $8ccaab8bb1e5bac0$var$getCardMoveParams = (action, state)=>{
    const { payload: { cardIds: cardIds, cardListId: cardListId, beforeCardId: beforeCardId, afterCardId: afterCardId, selectedTransition: selectedTransition } } = action;
    const rankCustomFieldId = (0, $jG5HW.getRankCustomFieldId)(state);
    if (!rankCustomFieldId) return null;
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const cardEntities = (0, $dGljH.getCards)(state);
    const cardLists = (0, $dGljH.getCardLists)(state);
    const isCardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
    if (cardListId === String((0, $2lpqS.UNASSIGNED_EPIC_ID))) return null;
    const cardKeys = cardIds.map((id)=>cardEntities[String(id)].key);
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const derivedCardListId = (0, $f01qr.getCardListId)(cardListId);
    const cardList = cardLists[derivedCardListId];
    const cardListType = cardList.type;
    const getCardKeyByCardId = (0, $dGljH.makeCardKeyFromCardId)(state);
    const beforeCardKey = !isCardMoveDisabled && beforeCardId ? getCardKeyByCardId(beforeCardId) : null;
    const afterCardKey = !isCardMoveDisabled && afterCardId ? getCardKeyByCardId(afterCardId) : null;
    return {
        cardIds: cardIds,
        cardKeys: cardKeys,
        cardListId: derivedCardListId,
        cardList: cardList,
        cardListType: cardListType,
        beforeCardKey: beforeCardKey,
        afterCardKey: afterCardKey,
        baseUrl: baseUrl,
        rankCustomFieldId: rankCustomFieldId,
        rapidViewId: rapidViewId,
        selectedTransition: selectedTransition
    };
};
const $8ccaab8bb1e5bac0$export$8d85b975065644ab = (action$, store)=>action$.ofType((0, $6GNN7.CARDS_MOVE_REQUEST), (0, $6GNN7.CARDS_MOVE_NON_OPTIMISTIC_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const dispatch = store.dispatch.bind(store);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const cardsMoveAction = action;
        const { payload: { cardIds: cardIds, cardListId: cardListId, isBetweenLists: isBetweenLists }, meta: { analyticsEvent: analyticsEvent } } = cardsMoveAction;
        const optimisticId = $8ccaab8bb1e5bac0$var$getOptimisticId(cardsMoveAction);
        // Card move is disabled only if in a CMP board jql filter is not order by RANK
        const cardMoveDisabled = (0, $jG5HW.isCardMoveDisabled)(state);
        if (!isBetweenLists && cardMoveDisabled) return (0, $kVLXA.Observable).from([
            (0, $6GNN7.cardsMoveDisabled)(optimisticId, analyticsEvent, (0, $jG5HW.getRapidViewId)(state), (0, $1z1J7.canEditBoardConfig)(state)),
            (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
        ]);
        const cardMoveParams = $8ccaab8bb1e5bac0$var$getCardMoveParams(cardsMoveAction, state);
        if (!cardMoveParams) return (0, $kVLXA.Observable).empty();
        const { cardKeys: cardKeys } = cardMoveParams;
        const serviceContext = (0, $i4Z8q.makeServiceContext)(state);
        if (serviceContext.isCompanyManaged && (0, $jG5HW.getBacklogStrategy)(state) === (0, $guzeq.KANBAN_BACKLOG_STRATEGY) && cardMoveParams.selectedTransition && cardMoveParams.selectedTransition.hasScreen) return (0, $ifBw8.transitionScreenDialogService)({
            issueId: cardIds[0],
            issueKey: cardKeys[0],
            transitionId: cardMoveParams.selectedTransition.id,
            analyticsEvent: analyticsEvent,
            dispatch: dispatch
        }).flatMap($8ccaab8bb1e5bac0$var$rankForTransitionScreen(action, cardMoveParams));
        return $8ccaab8bb1e5bac0$export$e9800111bfe3c5b3(cardsMoveAction, state, cardMoveParams).flatMap($8ccaab8bb1e5bac0$var$handleMoveCardSuccess(cardsMoveAction, state, dispatch, cardMoveParams)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.cards-move.failure', 'Failed to move cards', error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: false
            });
            return (0, $kVLXA.Observable).from([
                (0, $86ezP.hasJiraErrorMessages)(error) ? (0, $6GNN7.cardsTransitionAndRankFailure)(optimisticId, (0, $86ezP.parseJiraErrorMessages)(error), analyticsEvent) : (0, $6GNN7.cardsMoveFailure)(optimisticId, cardIds, cardListId, analyticsEvent, error),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("86ezP", function(module, exports) {

$parcel$export(module.exports, "hasJiraErrorMessages", () => $04ea1bc08d605bdc$export$7ee986d35f407138);
$parcel$export(module.exports, "parseJiraErrorMessages", () => $04ea1bc08d605bdc$export$d11297bc34463f4);

var $9XE6b = parcelRequire("9XE6b");
const $04ea1bc08d605bdc$var$parseMessage = (error)=>{
    if (error === null || typeof error !== 'object') return null;
    try {
        const message = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'message'
        ], null);
        return JSON.parse(message);
    } catch  {
        return null;
    }
};
const $04ea1bc08d605bdc$var$hasErrorMessagesProperty = (response)=>response !== null && typeof response === 'object' && 'errorMessages' in response && Array.isArray(response.errorMessages);
function $04ea1bc08d605bdc$export$7ee986d35f407138(error) {
    const response = $04ea1bc08d605bdc$var$parseMessage(error);
    return $04ea1bc08d605bdc$var$hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}
function $04ea1bc08d605bdc$export$d11297bc34463f4(error) {
    const response = $04ea1bc08d605bdc$var$parseMessage(error);
    if ($04ea1bc08d605bdc$var$hasErrorMessagesProperty(response)) return response.errorMessages;
    return [];
}

});

parcelRegister("bhjL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59919940a3a06e64$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$59919940a3a06e64$export$2e2bcd8739ae039 = (baseUrl, rankCustomFieldId, issueKeys, rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey, rapidViewId, target)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/assignToListAndRank`, {
        method: 'PUT',
        body: JSON.stringify({
            calculateNewIssuesOrder: false,
            issueKeys: issueKeys,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            rankCustomFieldId: rankCustomFieldId,
            rapidViewId: rapidViewId,
            target: target
        })
    });

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $aDvGo = parcelRequire("aDvGo");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $aDvGo.default), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});


parcelRegister("4aiwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d597f77b0d3b31b1$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d597f77b0d3b31b1$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankAfterKey)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/after`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankAfterKey: rankAfterKey
        })
    });

});

parcelRegister("lDAfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c62d96eb390687c$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8c62d96eb390687c$export$2e2bcd8739ae039 = (baseUrl, customFieldId, issueKeys, rankBeforeKey)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/api/rank/before`, {
        method: 'PUT',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueKeys: issueKeys,
            rankBeforeKey: rankBeforeKey
        })
    });

});

parcelRegister("7PjMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a402c1819855ea$export$2e2bcd8739ae039);

var $7zmUm = parcelRequire("7zmUm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14a402c1819855ea$export$2e2bcd8739ae039 = (baseUrl, customFieldId, rapidViewId, sprintId, issueKeys, rankBeforeKey, rankAfterKey, addToBacklog)=>(0, $7zmUm.default)(`${baseUrl}/rest/greenhopper/1.0/sprint/rank`, {
        method: 'PUT',
        body: JSON.stringify({
            addToBacklog: addToBacklog,
            calculateNewIssuesOrder: false,
            customFieldId: customFieldId,
            idOrKeys: issueKeys,
            rapidViewId: rapidViewId,
            sprintId: sprintId,
            ...rankAfterKey ? {
                idOrKeyAfter: rankAfterKey
            } : {},
            ...!rankAfterKey && rankBeforeKey ? {
                idOrKeyBefore: rankBeforeKey
            } : {}
        })
    });

});

parcelRegister("3oKOV", function(module, exports) {

$parcel$export(module.exports, "isFailedTransitionAndRankResponse", () => $d27d53af272cdb68$export$baa57c6351668324);
$parcel$export(module.exports, "hasTransitionScreens", () => $d27d53af272cdb68$export$197df750c1dc3961);
$parcel$export(module.exports, "hasMultipleTransitions", () => $d27d53af272cdb68$export$e642abf2d8cab89c);
$parcel$export(module.exports, "getFirstTransitionScreen", () => $d27d53af272cdb68$export$b886c9119f3b41db);
$parcel$export(module.exports, "getPossibleTransitions", () => $d27d53af272cdb68$export$a422da2e79341934);
$parcel$export(module.exports, "getNewCardOrder", () => $d27d53af272cdb68$export$5455144e38b4d576);
function $d27d53af272cdb68$export$baa57c6351668324(response) {
    if (response !== null && typeof response === 'object') return 'issuesWereTransitioned' in response && !response.issuesWereTransitioned;
    return false;
}
function $d27d53af272cdb68$export$197df750c1dc3961(response) {
    return response.possibleTransitions.length > 0 && response.possibleTransitions.some((transition)=>transition.hasTransitionView);
}
function $d27d53af272cdb68$export$e642abf2d8cab89c(response) {
    return response.possibleTransitions.length > 1;
}
function $d27d53af272cdb68$export$b886c9119f3b41db(response) {
    return response.possibleTransitions.find((transition)=>transition.hasTransitionView);
}
function $d27d53af272cdb68$export$a422da2e79341934(response) {
    return response.possibleTransitions || [];
}
function $d27d53af272cdb68$export$5455144e38b4d576(response) {
    return response !== null && typeof response === 'object' && response.newIssuesOrder !== undefined ? response.newIssuesOrder : null;
}

});

parcelRegister("iruXQ", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankService", () => $49ab892d169e619b$export$dfb4be6fa5ae4b7);

var $iAiqV = parcelRequire("iAiqV");
const $49ab892d169e619b$export$dfb4be6fa5ae4b7 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $iAiqV.transitionAndRankFetch)({
        rankCustomFieldId: rankCustomFieldId,
        issueKeys: issueKeys,
        targetColumn: targetColumn,
        rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
        rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
        rapidViewId: rapidViewId,
        selectedTransitionId: selectedTransitionId,
        calculateNewIssuesOrder: calculateNewIssuesOrder
    });

});
parcelRegister("iAiqV", function(module, exports) {

$parcel$export(module.exports, "transitionAndRankFetch", () => $75b32455d39c3970$export$11e7ff3f2320f2c4);

var $487fd = parcelRequire("487fd");
const $75b32455d39c3970$export$11e7ff3f2320f2c4 = ({ rankCustomFieldId: rankCustomFieldId, issueKeys: issueKeys, targetColumn: targetColumn, rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey, rankAfterIssueIdOrKey: rankAfterIssueIdOrKey, rapidViewId: rapidViewId, selectedTransitionId: selectedTransitionId, calculateNewIssuesOrder: calculateNewIssuesOrder = false })=>(0, $487fd.default)('/rest/greenhopper/1.0/xboard/transitionAndRank', {
        method: 'PUT',
        body: JSON.stringify({
            mode: 'plan',
            calculateNewIssuesOrder: calculateNewIssuesOrder,
            rapidViewId: rapidViewId,
            issueKeys: issueKeys,
            targetColumn: targetColumn,
            rankCustomFieldId: rankCustomFieldId,
            rankBeforeIssueIdOrKey: rankBeforeIssueIdOrKey,
            rankAfterIssueIdOrKey: rankAfterIssueIdOrKey,
            selectedTransitionId: selectedTransitionId
        })
    });

});


parcelRegister("ifBw8", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogService", () => $bade04f26adcd1b9$export$659d73295f3a3de8);

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $6zjUi = parcelRequire("6zjUi");


var $jOZwR = parcelRequire("jOZwR");
function $bade04f26adcd1b9$export$659d73295f3a3de8({ issueId: issueId, issueKey: issueKey, transitionId: transitionId, analyticsEvent: analyticsEvent, dispatch: dispatch }) {
    return new (0, $kVLXA.Observable)((subscriber)=>{
        const handleDialogSuccess = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogSuccess)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogCancel = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogCancel)());
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition cancel', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogError = (error)=>{
            subscriber.error(error || new Error('Transition screen failed'));
            subscriber.complete();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: (0, $708436aca879dc5c$export$7b6d848ab1be1ec3),
                isModalOpen: true
            });
        };
        const handleDialogShow = ()=>{
            subscriber.next((0, $jOZwR.transitionScreenDialogShow)());
        };
        dispatch((0, $6zjUi.openIssueTransitionModal)({
            issueId: String(issueId),
            issueKey: issueKey,
            transitionId: String(transitionId),
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError,
            onDialogSuccess: handleDialogSuccess
        }));
        handleDialogShow();
    });
}

});
parcelRegister("6zjUi", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_TRANSITION_MODAL", () => $271e58db57b2749f$export$8832c8eada77a7);
$parcel$export(module.exports, "openIssueTransitionModal", () => $271e58db57b2749f$export$bb76131907dfafc);
$parcel$export(module.exports, "CLOSE_ISSUE_TRANSITION_MODAL", () => $271e58db57b2749f$export$e15861bd6dba960e);
$parcel$export(module.exports, "closeIssueTransitionModal", () => $271e58db57b2749f$export$221941c279d4f72);
const $271e58db57b2749f$export$8832c8eada77a7 = 'state.actions.issue.issue-transition-modal.OPEN_ISSUE_TRANSITION_MODAL';
const $271e58db57b2749f$export$bb76131907dfafc = (payload)=>({
        type: $271e58db57b2749f$export$8832c8eada77a7,
        payload: payload
    });
const $271e58db57b2749f$export$e15861bd6dba960e = 'state.actions.issue.issue-transition-modal.CLOSE_ISSUE_TRANSITION_MODAL';
const $271e58db57b2749f$export$221941c279d4f72 = ()=>({
        type: $271e58db57b2749f$export$e15861bd6dba960e
    });

});

const $708436aca879dc5c$export$33dc74496d86bd4a = 'SHOW_EVENT';
const $708436aca879dc5c$export$d03e9fb76fb73c30 = 'SUCCESS_EVENT';
const $708436aca879dc5c$export$c2f5880ac823ea8e = 'CANCEL_EVENT';
const $708436aca879dc5c$export$7b6d848ab1be1ec3 = 'software-backlog-issue-transition';

parcelRegister("jOZwR", function(module, exports) {

$parcel$export(module.exports, "transitionScreenDialogShow", () => $3527f4d0d7c961d6$export$7cab574154dd97ed);
$parcel$export(module.exports, "transitionScreenDialogSuccess", () => $3527f4d0d7c961d6$export$818eb39bfb8e0008);
$parcel$export(module.exports, "transitionScreenDialogCancel", () => $3527f4d0d7c961d6$export$b353addc50c0b6fe);

const $3527f4d0d7c961d6$export$7cab574154dd97ed = ()=>({
        type: (0, $708436aca879dc5c$export$33dc74496d86bd4a)
    });
const $3527f4d0d7c961d6$export$818eb39bfb8e0008 = ()=>({
        type: (0, $708436aca879dc5c$export$d03e9fb76fb73c30)
    });
const $3527f4d0d7c961d6$export$b353addc50c0b6fe = ()=>({
        type: (0, $708436aca879dc5c$export$c2f5880ac823ea8e)
    });

});


parcelRegister("lyvhj", function(module, exports) {

$parcel$export(module.exports, "isShowEvent", () => $7fb7df51b6c9fae5$export$cd300abbf6342075);
$parcel$export(module.exports, "isSuccessfulEvent", () => $7fb7df51b6c9fae5$export$351a696eb45d767b);

function $7fb7df51b6c9fae5$export$cd300abbf6342075(event) {
    return event.type === (0, $708436aca879dc5c$export$33dc74496d86bd4a);
}
function $7fb7df51b6c9fae5$export$351a696eb45d767b(event) {
    return event.type === (0, $708436aca879dc5c$export$d03e9fb76fb73c30);
}

});

parcelRegister("a1ybZ", function(module, exports) {

$parcel$export(module.exports, "SET_CARD_ORDER_GLOBAL", () => $a5e0723950a9346d$export$596e51910ab2bf17);
$parcel$export(module.exports, "setCardOrderGlobal", () => $a5e0723950a9346d$export$4148d0f8b0a57f36);
const $a5e0723950a9346d$export$596e51910ab2bf17 = 'state.actions.card-order-global.SET_CARD_ORDER_GLOBAL';
const $a5e0723950a9346d$export$4148d0f8b0a57f36 = (cardIds)=>({
        type: $a5e0723950a9346d$export$596e51910ab2bf17,
        payload: cardIds
    });

});


parcelRegister("7w8zv", function(module, exports) {

$parcel$export(module.exports, "cardsNavigateEpic", () => $37d703f3a937c8ec$export$e2e898999df763ff);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $lReb9 = parcelRequire("lReb9");

var $cscVG = parcelRequire("cscVG");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $abzh7 = parcelRequire("abzh7");

var $dGljH = parcelRequire("dGljH");

var $2Z0Yd = parcelRequire("2Z0Yd");
const $37d703f3a937c8ec$export$e2e898999df763ff = (action$, store)=>action$.ofType((0, $cscVG.CARD_NEXT), (0, $cscVG.CARD_PREV)).throttleTime(250).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $dGljH.getActiveCard)(state);
        const isActiveCardVisible = activeCardId !== undefined ? (0, $abzh7.makeIsCardVisibleAndNotCollapsed)(state)(activeCardId) : false;
        const isNext = type === (0, $cscVG.CARD_NEXT);
        const getFirstSelectableIssueFn = isNext ? (0, $abzh7.getFirstSelectableIssueAscending) : (0, $abzh7.getFirstSelectableIssueDescending);
        const makeNextOrPrevIssueFn = isNext ? (0, $abzh7.makeGetNextSelectableIssue) : (0, $abzh7.makeGetPrevSelectableIssue);
        const nextIssueId = activeCardId !== undefined && isActiveCardVisible ? makeNextOrPrevIssueFn(state)(activeCardId) : getFirstSelectableIssueFn(state);
        const attributes = isNext ? {
            key: 'j',
            id: 'nextIssueKeyboardShortcut'
        } : {
            key: 'k',
            id: 'previousIssueKeyboardShortcut'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if (nextIssueId !== undefined) {
            const actions = [
                (0, $4mqko.cardSingleSelect)(nextIssueId),
                (0, $lReb9.cardFocus)(nextIssueId)
            ];
            if ((0, $2Z0Yd.isDetailViewOpen)(state)) actions.push((0, $38qhf.openDetailViewDebounced)(nextIssueId));
            return (0, $kVLXA.Observable).from(actions);
        }
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("lReb9", function(module, exports) {

$parcel$export(module.exports, "CARD_FOCUS", () => $34ee37e501257be7$export$7de76f693f0d3820);
$parcel$export(module.exports, "cardFocus", () => $34ee37e501257be7$export$e462552ef1675527);
$parcel$export(module.exports, "CARD_BLUR", () => $34ee37e501257be7$export$6ac448f92e1f338b);
$parcel$export(module.exports, "cardBlur", () => $34ee37e501257be7$export$9dea9abf478df7d7);
const $34ee37e501257be7$export$7de76f693f0d3820 = 'state.actions.cards.focus.CARD_FOCUS';
const $34ee37e501257be7$export$e462552ef1675527 = (cardId)=>({
        type: $34ee37e501257be7$export$7de76f693f0d3820,
        payload: {
            cardId: cardId
        }
    });
const $34ee37e501257be7$export$6ac448f92e1f338b = 'state.actions.cards.focus.CARD_BLUR';
const $34ee37e501257be7$export$9dea9abf478df7d7 = ()=>({
        type: $34ee37e501257be7$export$6ac448f92e1f338b
    });

});

parcelRegister("cscVG", function(module, exports) {

$parcel$export(module.exports, "CARD_NEXT", () => $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd);
$parcel$export(module.exports, "cardNext", () => $dfa4dcfddc32a7f2$export$d848405832f5c1d5);
$parcel$export(module.exports, "CARD_PREV", () => $dfa4dcfddc32a7f2$export$22f722071ae1a37d);
$parcel$export(module.exports, "cardPrev", () => $dfa4dcfddc32a7f2$export$6dc88d98f7609a22);
const $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd = 'state.actions.cards.navigate.CARD_NEXT';
const $dfa4dcfddc32a7f2$export$d848405832f5c1d5 = (fireShortcutAnalyticsFn)=>({
        type: $dfa4dcfddc32a7f2$export$e780294f9cb0bbfd,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $dfa4dcfddc32a7f2$export$22f722071ae1a37d = 'state.actions.cards.navigate.CARD_PREV';
const $dfa4dcfddc32a7f2$export$6dc88d98f7609a22 = (fireShortcutAnalyticsFn)=>({
        type: $dfa4dcfddc32a7f2$export$22f722071ae1a37d,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });

});

parcelRegister("abzh7", function(module, exports) {

$parcel$export(module.exports, "getFirstSelectableIssueAscending", () => $48c95a9b729fa3da$export$10c0b19e7f67cd54);
$parcel$export(module.exports, "getFirstSelectableIssueDescending", () => $48c95a9b729fa3da$export$66eabf17ea5e1f07);
$parcel$export(module.exports, "makeIsCardVisibleAndNotCollapsed", () => $48c95a9b729fa3da$export$796b5629f15fb2a0);
$parcel$export(module.exports, "makeGetNextSelectableIssue", () => $48c95a9b729fa3da$export$a57bd23e25548782);
$parcel$export(module.exports, "makeGetPrevSelectableIssue", () => $48c95a9b729fa3da$export$6075bf86943a5068);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");
const $48c95a9b729fa3da$export$c09bebfcb61f3779 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.makeOrderedVisibleCardIdsForCardList),
    (0, $dGljH.makeGetVisibleCardOrderFromCardEntries),
    (0, $dGljH.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).find((cardList)=>cardList.length));
const $48c95a9b729fa3da$export$10c0b19e7f67cd54 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[0]);
const $48c95a9b729fa3da$export$66eabf17ea5e1f07 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$c09bebfcb61f3779, (cardList)=>cardList && cardList[cardList.length - 1]);
const $48c95a9b729fa3da$export$796b5629f15fb2a0 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeGetCardListIdByCardId),
    (0, $dGljH.makeIsCardListCollapsed),
    (0, $dGljH.makeIsCardVisible),
    (0, $ld0jI.makeIsCardInCollapsedCardGroup),
    (0, $jG5HW.isCmpKanbanProject)
], (getCardListByCardId, isCardListCollapsed, isCardVisible, isCardInCollapsedCardGroup, isCmpKanbanBacklog)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardListId = getCardListByCardId(cardId);
        if (cardListId === undefined) return false;
        if (isCmpKanbanBacklog) return !isCardListCollapsed(cardListId) && !isCardInCollapsedCardGroup(cardId) && isCardVisible(cardId);
        return !isCardListCollapsed(cardListId) && isCardVisible(cardId);
    }));
const $48c95a9b729fa3da$export$1b5a343b24b5f39d = (0, $dGvGJ.createSelector)([
    (0, $dGljH.getVisibleCardListIds),
    (0, $dGljH.makeOrderedVisibleCardIdsForCardList),
    (0, $dGljH.makeGetVisibleCardOrderFromCardEntries),
    (0, $dGljH.makeIsCardListCollapsed)
], (cardListIds, getOrderedVisibleCardsByCardList, getVisibleCardOrderFromCardEntries, isCardListCollapsed)=>cardListIds.filter((id)=>!isCardListCollapsed(id)).map((id)=>getVisibleCardOrderFromCardEntries(id)).flat());
const $48c95a9b729fa3da$export$a57bd23e25548782 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        if (cardIndex < 0) return undefined;
        return selectableIssues[cardIndex + 1];
    }));
const $48c95a9b729fa3da$export$6075bf86943a5068 = (0, $dGvGJ.createSelector)($48c95a9b729fa3da$export$1b5a343b24b5f39d, (selectableIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardId)=>{
        const cardIndex = selectableIssues.indexOf(cardId);
        return selectableIssues[cardIndex - 1];
    }));

});

parcelRegister("2Z0Yd", function(module, exports) {

$parcel$export(module.exports, "isDetailViewOpen", () => $ca8ab0542b41ad2e$export$6c8a703f6e6f7f67);
const $ca8ab0542b41ad2e$export$6c8a703f6e6f7f67 = (state)=>Boolean(state.ui.detailView);

});


parcelRegister("f4vxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $76de12c19b37c861$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $et6P7 = parcelRequire("et6P7");

var $fdAim = parcelRequire("fdAim");

var $dGljH = parcelRequire("dGljH");
function $76de12c19b37c861$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $et6P7.CARDS_PARENT_SET_OPTIMISTIC)).mergeMap((action)=>{
        const { payload: { cards: cards, parentId: parentId }, meta: { optimistic: optimistic } } = action;
        const cardEntities = (0, $dGljH.getCards)(store.getState());
        const changedCardIds = cards.filter(({ id: id })=>{
            const card = cardEntities[id];
            return card?.parentId !== parentId;
        }).map((card)=>card.id);
        if (changedCardIds.length === 0) return (0, $kVLXA.Observable).of((0, $et6P7.cardsParentSetSuccess)(optimistic.id, {
            cards: cards
        }));
        return (0, $kVLXA.Observable).fromPromise(action.payload.requestPromise).flatMap(()=>(0, $kVLXA.Observable).of((0, $et6P7.cardsParentSetSuccess)(optimistic.id, {
                cards: cards
            }))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('cards.parent-set.failure', 'Failed to set card parent', error);
            const actions = changedCardIds.map((cardId)=>(0, $fdAim.cardRefreshRequest)(cardId));
            return (0, $kVLXA.Observable).from([
                (0, $et6P7.cardsParentSetFailure)(optimistic.id),
                ...actions
            ]);
        });
    });
}

});
parcelRegister("et6P7", function(module, exports) {

$parcel$export(module.exports, "CARDS_PARENT_SET_OPTIMISTIC", () => $5e3c87ff0135645a$export$91e916b961a6d9b);
$parcel$export(module.exports, "cardsParentSetOptimistic", () => $5e3c87ff0135645a$export$3feb2fd47a9012aa);
$parcel$export(module.exports, "CARDS_PARENT_SET_SUCCESS", () => $5e3c87ff0135645a$export$249765deb6efe8ae);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $5e3c87ff0135645a$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "CARDS_PARENT_SET_FAILURE", () => $5e3c87ff0135645a$export$36c7e0e6fa088864);
$parcel$export(module.exports, "cardsParentSetFailure", () => $5e3c87ff0135645a$export$24c3df942a1f1dd5);

var $c0irb = parcelRequire("c0irb");
const $5e3c87ff0135645a$export$91e916b961a6d9b = 'state.actions.cards.parent.CARDS_PARENT_SET_OPTIMISTIC';
const $5e3c87ff0135645a$export$3feb2fd47a9012aa = (payload)=>({
        type: $5e3c87ff0135645a$export$91e916b961a6d9b,
        payload: payload,
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)()
        }
    });
const $5e3c87ff0135645a$export$249765deb6efe8ae = 'state.actions.cards.parent.CARDS_PARENT_SET_SUCCESS';
const $5e3c87ff0135645a$export$30fe913aeacc7d4c = (optimisticId, payload)=>({
        type: $5e3c87ff0135645a$export$249765deb6efe8ae,
        payload: payload,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $5e3c87ff0135645a$export$36c7e0e6fa088864 = 'state.actions.cards.parent.CARDS_PARENT_SET_FAILURE';
const $5e3c87ff0135645a$export$24c3df942a1f1dd5 = (optimisticId)=>({
        type: $5e3c87ff0135645a$export$36c7e0e6fa088864,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("f5yE6", function(module, exports) {

$parcel$export(module.exports, "checkGlobalIssueCreateEpic", () => $e3caf3d5e48a492a$export$c92e72129db344be);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $gwOHY = parcelRequire("gwOHY");

var $bAfUr = parcelRequire("bAfUr");
const $e3caf3d5e48a492a$export$c92e72129db344be = (action$, store)=>action$.ofType((0, $3lZ6i.CHECK_GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const { payload: { issues: globalIssues } } = action;
        if (globalIssues.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const actions = [];
        // We should refetch versions data when an issue is created to keep the version panel on sync
        // and to avoid this issue: https://hello.atlassian.net/browse/FEBA-1548a
        actions.push((0, $gwOHY.refetchVersions)());
        // Check if any globally created issues have unmapped statuses
        // (this doesn't however apply to epics since they will be visible on the backlog and board)
        const columnStatusIds = (0, $bAfUr.getColumnStatusIds)(state);
        const unmappedIssuesExist = globalIssues.filter((issue)=>issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1).some((issue)=>!columnStatusIds.includes(issue.createdIssueDetails.fields.status.id));
        if (unmappedIssuesExist) {
            const cardsIdentifiers = globalIssues.map((issue)=>({
                    id: Number(issue.issueId),
                    key: issue.issueKey
                }));
            actions.push((0, $hf5c2.cardCreateUnmappedWithIssueLink)(cardsIdentifiers));
        } else actions.push((0, $hf5c2.cardCreateGlobal)(globalIssues));
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("hCa2B", function(module, exports) {

$parcel$export(module.exports, "detailViewCloseEpic", () => $ef368a28185fe9b2$export$511093f766907f93);
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kVLXA = parcelRequire("kVLXA");

var $luHLg = parcelRequire("luHLg");

var $cik5h = parcelRequire("cik5h");

var $38qhf = parcelRequire("38qhf");

var $l9VFH = parcelRequire("l9VFH");
const $ef368a28185fe9b2$export$511093f766907f93 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $38qhf.CLOSE_DETAIL_VIEW)).switchMap((action)=>{
            const state = store.getState();
            const filters = (0, $l9VFH.getAppliedParentFilters)(state);
            const issueId = action.payload?.issueId;
            push((0, $cik5h.removeSelectedIssueFromUrl)((0, $luHLg.removeIssueParentFromUrlByFilters)(getLocation(), issueId, filters)));
            return (0, $kVLXA.Observable).empty();
        });

});
parcelRegister("luHLg", function(module, exports) {

$parcel$export(module.exports, "removeIssueParentFromUrlByFilters", () => $54b3470035e6f164$export$87a36404d6a49f8a);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $ebyGx = parcelRequire("ebyGx");

const $54b3470035e6f164$export$87a36404d6a49f8a = (location, issueId, filters = [])=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search);
    const updatedSearchParams = (0, $7uUwQ.chain)(searchParams);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchParams[0, $4f4a02cead13bb5a$export$8a2cab795731dc42]) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId)) {
        const urlIssueParents = searchParams[0, $4f4a02cead13bb5a$export$8a2cab795731dc42].split(',');
        // The closed issueId is in IssueParent QueryParams, but not in Filters , probably caused by deleting epics in detail view
        const issueIdStr = issueId.toString();
        if (urlIssueParents.includes(issueIdStr) && !filters.includes(issueIdStr)) urlIssueParents.splice(urlIssueParents.indexOf(issueIdStr), 1);
        urlIssueParents.length > 0 ? updatedSearchParams.set((0, $4f4a02cead13bb5a$export$8a2cab795731dc42), urlIssueParents.join(',')) : updatedSearchParams.unset((0, $4f4a02cead13bb5a$export$8a2cab795731dc42));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(updatedSearchParams.value())
    };
};

});


parcelRegister("h1Jne", function(module, exports) {

$parcel$export(module.exports, "detailViewOpenDebouncedEpic", () => $0c01dab87f8c9561$export$2e5970b542a40342);
parcelRequire("fp4O3");
parcelRequire("eSGL3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $38qhf = parcelRequire("38qhf");

var $dGljH = parcelRequire("dGljH");
const $0c01dab87f8c9561$export$2e5970b542a40342 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $38qhf.OPEN_DETAIL_VIEW_DEBOUNCED)).debounceTime(500).mergeMap((action)=>{
            push((0, $cik5h.addSelectedIssueToUrl)((0, $dGljH.makeCardKeyFromCardId)(store.getState())(action.payload.cardId), getLocation()));
            return (0, $kVLXA.Observable).of((0, $38qhf.openDetailView)(action.payload.cardId, action.payload.externalAction));
        });

});

parcelRegister("7u8UG", function(module, exports) {

$parcel$export(module.exports, "detailViewUpdateEpic", () => $abc7cf427dc3e86e$export$ddc67837ea92e238);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $eSSqy = parcelRequire("eSSqy");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $38qhf = parcelRequire("38qhf");

var $czUNp = parcelRequire("czUNp");

var $dGljH = parcelRequire("dGljH");
const $abc7cf427dc3e86e$export$ddc67837ea92e238 = (action$, store)=>action$.ofType((0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS), (0, $et6P7.CARDS_PARENT_SET_SUCCESS), (0, $6GNN7.CARDS_MOVE_SUCCESS), (0, $czUNp.CARD_STATUS_SET), (0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)).switchMap((action)=>{
        const state = store.getState();
        const { cardId: cardId } = (0, $dGljH.getDetailViewData)(state) || {};
        if (!cardId) return (0, $kVLXA.Observable).empty();
        if (action.type === (0, $eSSqy.CARDS_BULK_OPERATIONS_SUCCESS)) {
            if (action.payload.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        }
        if (action.type === (0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS) && action.payload.cards.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        if (action.type === (0, $et6P7.CARDS_PARENT_SET_SUCCESS) && action.payload.cards.map((card)=>card.id).includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        if (action.type === (0, $6GNN7.CARDS_MOVE_SUCCESS)) {
            const parentIds = (0, $dGljH.partialCardsFromCardIdsSelector)(state)(action.payload.cardIds).map((card)=>card.parentId);
            if (action.payload.cardIds.includes(cardId) || parentIds.includes(cardId)) return (0, $kVLXA.Observable).of((0, $38qhf.updateDetailView)());
        }
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("3xTTB", function(module, exports) {

$parcel$export(module.exports, "refetchEpicPanelEpic", () => $edb8106e01e05ab1$export$da2d2f9f49d2aaf1);

var $aB8eX = parcelRequire("aB8eX");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("6cbqE");

var $3bPZM = parcelRequire("3bPZM");

var $7JoAD = parcelRequire("7JoAD");

var $3lZ6i = parcelRequire("3lZ6i");

var $js96S = parcelRequire("js96S");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $et6P7 = parcelRequire("et6P7");
const $edb8106e01e05ab1$var$isCardSetIndividualResponse = (action)=>action.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS);
const $edb8106e01e05ab1$var$isBatchCardParentSetSuccess = (batchAction)=>batchAction.payload.some((action)=>$edb8106e01e05ab1$var$isCardSetIndividualResponse(action) && action.payload.fieldId === (0, $5fc53.PARENT_TYPE));
const $edb8106e01e05ab1$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS = 500;
const $edb8106e01e05ab1$export$da2d2f9f49d2aaf1 = (action$)=>action$.ofType((0, $et6P7.CARDS_PARENT_SET_SUCCESS), (0, $3lZ6i.REFRESH_DATA_REQUEST), (0, $hf5c2.CARD_CREATE_SUCCESS), (0, $legw4.CARD_DELETE_SUCCESS), (0, $aB8eX.BATCH)).debounceTime($edb8106e01e05ab1$var$REFETCH_EPIC_PANEL_DEBOUNCE_MS).switchMap((action)=>{
        if (action.type === (0, $aB8eX.BATCH) && !$edb8106e01e05ab1$var$isBatchCardParentSetSuccess(action)) return (0, $kVLXA.Observable).empty();
        /**
			 * This action is only triggered by DnD into the epic panel, so we can directly call refetch
			 * there instead of waiting for the debounce.
			 *
			 * TODO: remove CARDS_PARENT_SET_SUCCESS from action list once FG is cleaned up
			 */ if (action.type === (0, $et6P7.CARDS_PARENT_SET_SUCCESS) && (0, $4R6GH.fg)('jsw_epic_panel_paginated_fetch')) return (0, $kVLXA.Observable).empty();
        const epicPanelRefetchStoreInstance = (0, $7JoAD.defaultRegistry).getStore((0, $3bPZM.EpicPanelRefetchStore));
        const { triggerEpicPanelRefetch: triggerEpicPanelRefetch } = epicPanelRefetchStoreInstance.actions;
        triggerEpicPanelRefetch();
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("3bPZM", function(module, exports) {

$parcel$export(module.exports, "EpicPanelRefetchStore", () => $a89a33b3e24797dc$export$161cbc183f817581);
$parcel$export(module.exports, "useShouldRefetchEpicPanel", () => $a89a33b3e24797dc$export$3c3bb9bb30c98856);

var $7JoAD = parcelRequire("7JoAD");
const $a89a33b3e24797dc$var$triggerEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: true
        });
    };
const $a89a33b3e24797dc$var$finishEpicPanelRefetch = ()=>({ setState: setState })=>{
        setState({
            shouldRefetchEpicPanel: false
        });
    };
const $a89a33b3e24797dc$var$actions = {
    triggerEpicPanelRefetch: $a89a33b3e24797dc$var$triggerEpicPanelRefetch,
    finishEpicPanelRefetch: $a89a33b3e24797dc$var$finishEpicPanelRefetch
};
const $a89a33b3e24797dc$export$161cbc183f817581 = (0, $7JoAD.createStore)({
    name: 'jira-software-backlog-panel-should-refetch-epic',
    initialState: {
        shouldRefetchEpicPanel: false
    },
    actions: $a89a33b3e24797dc$var$actions
});
const $a89a33b3e24797dc$export$3c3bb9bb30c98856 = (0, $7JoAD.createHook)($a89a33b3e24797dc$export$161cbc183f817581);

});


parcelRegister("dfRpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4837d662057d5604$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $dJl1T = parcelRequire("dJl1T");

var $469SI = parcelRequire("469SI");

var $fAcQ9 = parcelRequire("fAcQ9");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hseEV = parcelRequire("hseEV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4837d662057d5604$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA)).switchMap(()=>{
        const state = store.getState();
        const ctx = (0, $i4Z8q.makeServiceContext)(state);
        return (0, $fAcQ9.loadExtensionDataService)(ctx).map((0, $469SI.transformExtensionLoad)).flatMap((extension)=>(0, $kVLXA.Observable).of((0, $hseEV.extensionFetchSuccess)(extension))).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.extension.operations', error.message, error);
            // ABE-21: Handle this when the call is made as part of the non-critical path
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("469SI", function(module, exports) {

$parcel$export(module.exports, "transformExtensionLoad", () => $085023d6346c2432$export$8fb5dd35b8f7d028);
const $085023d6346c2432$export$8fb5dd35b8f7d028 = (response)=>{
    const operations = response.extension ? response.extension.operations.map((op)=>({
            icon: {
                url: op.icon && op.icon.url
            },
            name: op.name,
            url: op.url,
            tooltip: op.tooltip,
            styleClass: op.styleClass
        })) : [];
    return {
        operations: operations
    };
};

});

parcelRegister("fAcQ9", function(module, exports) {

$parcel$export(module.exports, "loadExtensionDataService", () => $491d5dad7741f821$export$f33c43566824ade1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $24yxP = parcelRequire("24yxP");
function $491d5dad7741f821$export$f33c43566824ade1(ctx) {
    if (ctx.isCompanyManaged) return (0, $kVLXA.Observable).empty();
    return (0, $24yxP.fetchExtensionData)('', ctx.boardId);
}

});
parcelRegister("24yxP", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $d6ab7af6d082f738$export$5fe98ae96d282610);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $d6ab7af6d082f738$var$softwareBacklogExtensionOperationName = 'SoftwareBacklogExtension';
const $d6ab7af6d082f738$export$1d6e6c1cef4b8fcc = (boardId)=>`query ${$d6ab7af6d082f738$var$softwareBacklogExtensionOperationName} {
        boardScope(boardId:${boardId}) {
            backlog {
                extension {
                    operations {
                        icon {
                           url
                        }
                        name
                        url
                        tooltip
                        styleClass
                    }
                }
            }
        }
    }`;
const $d6ab7af6d082f738$export$5fe98ae96d282610 = (contextPath, boardId)=>(0, $cBLvH.query$)(contextPath, $d6ab7af6d082f738$var$softwareBacklogExtensionOperationName, $d6ab7af6d082f738$export$1d6e6c1cef4b8fcc(boardId)).flatMap((data)=>(0, $kVLXA.Observable).of(data.boardScope.backlog));

});


parcelRegister("hseEV", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_FETCH_SUCCESS", () => $e2ea6d89308c0cc3$export$4b80f261a964f809);
$parcel$export(module.exports, "extensionFetchSuccess", () => $e2ea6d89308c0cc3$export$12037fbc95e2254d);
const $e2ea6d89308c0cc3$export$4b80f261a964f809 = 'state.actions.extension.EXTENSION_FETCH_SUCCESS';
const $e2ea6d89308c0cc3$export$12037fbc95e2254d = (extension)=>({
        type: $e2ea6d89308c0cc3$export$4b80f261a964f809,
        payload: {
            extension: extension
        }
    });

});


parcelRegister("cnhvw", function(module, exports) {

$parcel$export(module.exports, "filterValidValuesEpic", () => $1b72c186edda326d$export$92792813ec12d76);
parcelRequire("zjDln");
parcelRequire("1oQta");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $jgEcS = parcelRequire("jgEcS");

var $likqC = parcelRequire("likqC");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $9ZuIF = parcelRequire("9ZuIF");
const $1b72c186edda326d$var$makeFilter = (state)=>(0, $9Pc1U.isCriticalDataLoaded)(state) && (0, $9ZuIF.isCurrentUserLoaded)(state) && (0, $9Pc1U.isConfigLoaded)(state) && (0, $dGljH.hasInvalidFilterValuesSelector)(state);
const $1b72c186edda326d$export$92792813ec12d76 = (getLocation, push)=>(action$, store)=>action$.filter(()=>$1b72c186edda326d$var$makeFilter(store.getState())).mergeMap(()=>{
            const state = store.getState();
            const filters = (0, $dGljH.validFilterValuesSelector)(state);
            const actions = [
                (0, $likqC.setAllFilters)(filters)
            ];
            const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
            push((0, $jgEcS.getPushPayload)(filters, getLocation(), isCompanyManaged));
            return (0, $kVLXA.Observable).from(actions);
        });

});
parcelRegister("jgEcS", function(module, exports) {

$parcel$export(module.exports, "getPushPayload", () => $0e7a205a3891e68f$export$6ee0645423b27902);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");


const $0e7a205a3891e68f$export$6ee0645423b27902 = (filters, location, isCompanyManaged)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    filters[0, $41ce9b5576b92b7a$export$d597759d33be802e] ? search.set((0, $4f4a02cead13bb5a$export$e39925d10cebc0b), filters[0, $41ce9b5576b92b7a$export$d597759d33be802e]) : search.unset((0, $4f4a02cead13bb5a$export$e39925d10cebc0b));
    filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] ? search.set((0, $4f4a02cead13bb5a$export$f78d8c81fcad32a2), filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$f78d8c81fcad32a2));
    filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] ? search.set((0, $4f4a02cead13bb5a$export$e729d951ab128c3b), filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$e729d951ab128c3b));
    filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] ? search.set((0, $4f4a02cead13bb5a$export$8a2cab795731dc42), filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$8a2cab795731dc42));
    filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] ? search.set((0, $4f4a02cead13bb5a$export$fa7b72626a2e0090), filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$fa7b72626a2e0090));
    filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] ? search.set((0, $4f4a02cead13bb5a$export$392308739e657b75), filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$392308739e657b75));
    if (isCompanyManaged) filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866] ? search.set((0, $4f4a02cead13bb5a$export$cb08ebea4a46cd29), filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866].join(',')) : search.unset((0, $4f4a02cead13bb5a$export$cb08ebea4a46cd29));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};

});

parcelRegister("likqC", function(module, exports) {

$parcel$export(module.exports, "SET_ALL_FILTERS", () => $97e1cddba88799b1$export$2771e5a27cdc85fe);
$parcel$export(module.exports, "setAllFilters", () => $97e1cddba88799b1$export$1e6b2e9f0ff84131);
const $97e1cddba88799b1$export$2771e5a27cdc85fe = 'state.actions.filters.SET_ALL_FILTERS';
const $97e1cddba88799b1$export$1e6b2e9f0ff84131 = (filters, filterType)=>({
        type: $97e1cddba88799b1$export$2771e5a27cdc85fe,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType
        }
    });

});


parcelRegister("BJrNt", function(module, exports) {

$parcel$export(module.exports, "filteredCardsEpic", () => $ef125b900a6a43e7$export$e2f185e35a8c9054);

var $e1AU2 = parcelRequire("e1AU2");

var $7DoPy = parcelRequire("7DoPy");

var $h6CKH = parcelRequire("h6CKH");

var $S4gg9 = parcelRequire("S4gg9");
const $ef125b900a6a43e7$export$e2f185e35a8c9054 = (0, $e1AU2.combineEpics)((0, $h6CKH.filteredCardsRequestEpic), (0, $S4gg9.refilterRequestEpic), (0, $7DoPy.clearFilterRequestEpic));

});
parcelRegister("7DoPy", function(module, exports) {

$parcel$export(module.exports, "clearFilterRequestEpic", () => $e3b2d5360bf951aa$export$f800c2415f438ec5);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("zjDln");

var $dJl1T = parcelRequire("dJl1T");

var $j0SXO = parcelRequire("j0SXO");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $8MHVw = parcelRequire("8MHVw");

var $sRW5v = parcelRequire("sRW5v");
const $e3b2d5360bf951aa$export$4670d1476dee8194 = (action, store, dependencies)=>{
    const state = store.getState();
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $i4Z8q.makeServiceContext)(state);
    return (0, $j0SXO.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        epicIssueType: null,
        storeFieldsActions: dependencies?.storeFieldsActions
    }).mergeMap((data)=>(0, $kVLXA.Observable).from([
            (0, $8MHVw.clearFilteredCardsSuccess)(analyticsEvent),
            (0, $3lZ6i.setAppData)(data)
        ])).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.clear-filtered-cards.failure', 'Failed to load plan data to clear cards filter', error);
        return (0, $kVLXA.Observable).of((0, $8MHVw.clearFilteredCardsFailed)(error, analyticsEvent));
    });
};
const $e3b2d5360bf951aa$export$f800c2415f438ec5 = (action$, store, dependencies)=>action$.ofType((0, $8MHVw.FILTERED_CARD_CLEAR_REQUEST)).throttleTime((0, $sRW5v.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$e3b2d5360bf951aa$export$4670d1476dee8194(action, store, dependencies));

});
parcelRegister("j0SXO", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataService", () => $45918024f87d3a8f$export$102560d7738611a1);
parcelRequire("d0pqD");

var $bpHwy = parcelRequire("bpHwy");

var $ey78P = parcelRequire("ey78P");

var $3qYzN = parcelRequire("3qYzN");
function $45918024f87d3a8f$export$102560d7738611a1({ boardId: boardId, isCompanyManaged: isCompanyManaged, activeQuickFilters: activeQuickFilters, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    return (0, $ey78P.fetchPlanData)({
        rapidViewId: boardId,
        activeQuickFilters: activeQuickFilters,
        operation: 'fetchBacklogData'
    }).map((data)=>{
        if (storeFieldsActions?.storeFieldsFromPrefetchedPlanData) storeFieldsActions.storeFieldsFromPrefetchedPlanData(data, epicIssueType);
        (0, $bpHwy.refreshUIFBacklogData)(Number(boardId), data);
        return (0, $3qYzN.transformPlanData)(data, isCompanyManaged, activeQuickFilters);
    });
}

});
parcelRegister("bpHwy", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $620843ca516c403b$export$240c6c415d37cd75);
$parcel$export(module.exports, "refreshUIFBoardData", () => $620843ca516c403b$export$f34cbc63057c38be);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $620843ca516c403b$export$60a4d33615c60f8);
$parcel$export(module.exports, "refreshUIFBacklogData", () => $620843ca516c403b$export$69efc1d2bf5ce2ae);

var $jywXF = parcelRequire("jywXF");

var $cRqmM = parcelRequire("cRqmM");

var $l8SKN = parcelRequire("l8SKN");

var $c1BZi = parcelRequire("c1BZi");
async function $620843ca516c403b$export$240c6c415d37cd75(params) {
    const { cachedPromise: cachedPromise, refreshPromise: refreshPromise } = (0, $c1BZi.fetchUIFBoardDataStream)(params);
    const refreshResult = refreshPromise.then((value)=>({
            value: value,
            type: 'refresh'
        }));
    const { value: result, type: type } = await Promise.race([
        cachedPromise.then((value)=>value != null ? {
                value: value,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: isCacheHit ? refreshPromise : null,
        isCacheHit: isCacheHit
    };
}
async function $620843ca516c403b$export$f34cbc63057c38be(boardId, response) {
    (0, $l8SKN.setBoardCachedEntry)({
        boardId: boardId
    }, {
        timestamp: Date.now(),
        etag: response.etag,
        data: response
    });
}
async function $620843ca516c403b$export$60a4d33615c60f8(boardId, queryParameters) {
    const { cachedPromise: cachedPromise, requestPromise: requestPromise } = (0, $jywXF.fetchUIFBacklogData)(boardId, queryParameters);
    const refreshResult = requestPromise.then((response)=>{
        $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response);
        return {
            result: response,
            type: 'refresh'
        };
    });
    const { result: result, type: type } = await Promise.race([
        cachedPromise.then((cachedResult)=>cachedResult != null ? {
                result: cachedResult.data,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: type === 'cache' ? requestPromise : null,
        isCacheHit: isCacheHit
    };
}
function $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response) {
    return (0, $cRqmM.setBacklogCachedEntry)(boardId, {
        timestamp: Date.now(),
        data: response
    });
}

});
parcelRegister("jywXF", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $b625b9c23407900e$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $b625b9c23407900e$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $b625b9c23407900e$export$a0c2e05a12ae5621);

var $ebyGx = parcelRequire("ebyGx");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $fIEjn = parcelRequire("fIEjn");

var $cRqmM = parcelRequire("cRqmM");

var $aBK23 = parcelRequire("aBK23");

var $hUQ5s = parcelRequire("hUQ5s");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $b625b9c23407900e$var$backlogResponsePromise;
let $b625b9c23407900e$var$backlogResponse = null;
const $b625b9c23407900e$export$b08a6e96e3de5356 = (response)=>{
    $b625b9c23407900e$var$backlogResponsePromise = response;
};
const $b625b9c23407900e$export$592ab10c6cb9d596 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponsePromise;
    $b625b9c23407900e$var$backlogResponsePromise = null;
    return response;
};
const $b625b9c23407900e$export$55e9294018933a18 = (response)=>{
    $b625b9c23407900e$var$backlogResponse = response;
};
const $b625b9c23407900e$export$b55ab086f6a0c481 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponse;
    $b625b9c23407900e$var$backlogResponse = null;
    return response;
};
const $b625b9c23407900e$var$onEnd = ()=>{
    (0, $x9xyg.setMark)('uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $b625b9c23407900e$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $x9xyg.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
    (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
    const headers = {
        ...enhancedCapabilityHeader ? {
            'X-Atlassian-Capability': enhancedCapabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $fIEjn.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok) {
        $b625b9c23407900e$var$onEnd();
        const traceId = (0, $l83Uu.getTraceId)(res);
        const message = (0, $aBK23.extractErrorMessage)(json);
        if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        else throw new (0, $dO0aE.FetchError)(res.status, message);
    }
    $b625b9c23407900e$var$onEnd();
    return json;
};
const $b625b9c23407900e$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $x9xyg.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
        (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
        const headers = {
            ...enhancedCapabilityHeader ? {
                'X-Atlassian-Capability': enhancedCapabilityHeader
            } : {}
        };
        Object.assign(headers, (0, $fIEjn.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            $b625b9c23407900e$var$onEnd();
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        $b625b9c23407900e$var$onEnd();
        return json;
    })();
    const cachedPromise = (0, $cRqmM.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $b625b9c23407900e$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $aBK23.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
        const backlogData = $b625b9c23407900e$export$60a4d33615c60f8(boardId, queryParameters);
        $b625b9c23407900e$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $b625b9c23407900e$export$df49ad631c58a3f6(boardId, queryParameters);
        $b625b9c23407900e$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("dO0aE", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $7345e390d0c3a088$export$26e841bcf1aeb894);
$parcel$export(module.exports, "ResponseNullError", () => $7345e390d0c3a088$export$895e385291c3b753);
/* eslint-disable max-classes-per-file */ class $7345e390d0c3a088$var$ExtensibleError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.message = message;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $7345e390d0c3a088$export$26e841bcf1aeb894 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(statusCode, message, traceId){
        super(message == null ? `Fetch call failed with status code: ${statusCode}` : message);
        this.graphQLErrors = [];
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.networkError = {
            statusCode: statusCode
        };
        this.skipSentry = true;
        if (traceId != null) this.traceId = traceId;
    }
}
class $7345e390d0c3a088$export$895e385291c3b753 extends $7345e390d0c3a088$var$ExtensibleError {
    constructor(message){
        super(message);
        this.name = 'ResponseNullError';
        this.skipSentry = true;
    }
}

});

parcelRegister("cRqmM", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $31c19adcc162b6bc$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $31c19adcc162b6bc$export$d01cbd23f4b0c290);

var $sn9QA = parcelRequire("sn9QA");

var $2FZUH = parcelRequire("2FZUH");
const $31c19adcc162b6bc$export$1ba4f312a27970c1 = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-backlog');
async function $31c19adcc162b6bc$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $31c19adcc162b6bc$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    return $31c19adcc162b6bc$export$1ba4f312a27970c1.set(key, entry);
}
async function $31c19adcc162b6bc$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    try {
        const entry = await $31c19adcc162b6bc$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $31c19adcc162b6bc$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("2FZUH", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ec6817f630f9a6c9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $ec6817f630f9a6c9$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $ec6817f630f9a6c9$export$59c82678f286b00f);

var $8QpSo = parcelRequire("8QpSo");

var $sn9QA = parcelRequire("sn9QA");

var $co1wz = parcelRequire("co1wz");
const $ec6817f630f9a6c9$var$EXPIRATION_TIME_OLD = 86400000; // 1 day
const $ec6817f630f9a6c9$var$EXPIRATION_TIME = 259200000; // 3 days
const $ec6817f630f9a6c9$var$extendExpirationTime = ()=>(0, $co1wz.ff)('jsw.perf.local-device-cache-extend-expiery_seg8y');
function $ec6817f630f9a6c9$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $ec6817f630f9a6c9$var$extendExpirationTime() ? $ec6817f630f9a6c9$var$EXPIRATION_TIME : $ec6817f630f9a6c9$var$EXPIRATION_TIME_OLD;
    return timeDelta < expirationTime;
}
const $ec6817f630f9a6c9$export$c1e0336bde96e2dc = (0, $8QpSo.default)(()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $ec6817f630f9a6c9$export$59c82678f286b00f(boardId) {
    const accountId = $ec6817f630f9a6c9$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $ec6817f630f9a6c9$export$cc1314e9c2424f02 = (0, $sn9QA.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("aBK23", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2271887588c9e1ef$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2271887588c9e1ef$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2271887588c9e1ef$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2271887588c9e1ef$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2271887588c9e1ef$export$8cc545829c7461b0);
$parcel$export(module.exports, "View", () => $2271887588c9e1ef$export$27a5bd065ad55220);
$parcel$export(module.exports, "getViewSettings", () => $2271887588c9e1ef$export$3ae70db4a97563c);

var $ebyGx = parcelRequire("ebyGx");

var $cYeCp = parcelRequire("cYeCp");
const $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2271887588c9e1ef$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2271887588c9e1ef$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2271887588c9e1ef$export$e59cda69449c77c2 = (feature, boardId)=>{
    const cachedFilters = localStorage.getItem(`__storejs_software_${feature}-filters.${boardId}`);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2271887588c9e1ef$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX) ?? $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2271887588c9e1ef$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {}
    };
};
const $2271887588c9e1ef$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2271887588c9e1ef$export$8cc545829c7461b0 = (json)=>{
    if ($2271887588c9e1ef$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};
/* Copied from jira/src/packages/software/view-settings/src/services/local-storage/index.tsx
 to reduce bundle size by using native localStorage */ const $2271887588c9e1ef$var$VIEW_SETTINGS = 'view-settings';
const $2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE = 'jira-software-view-settings';
const $2271887588c9e1ef$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $2271887588c9e1ef$export$36e24695f02d4503 = (view)=>{
    if (view && view === $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD) return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD}`;
        default:
            return $2271887588c9e1ef$var$VIEW_SETTINGS;
    }
    return $2271887588c9e1ef$var$VIEW_SETTINGS;
};
const $2271887588c9e1ef$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>{
    /**
	 * This usage is excluded via package exclusion in jira/ratcheting-rules.tsx
	 * Because it is only a READ Operation, and reads are not blocked in compliant APIs.
	 * This read will be tracked via a compliant API read in following code
	 * - Initializing view-settings panel on board: jira/src/packages/software/view-settings/src/ui/index.tsx
	 * - rendering cards on the board (Implementatin In Progress https://hello.jira.atlassian.cloud/browse/PNDR-1926)
	 * More context in this discussion: https://atlassian.slack.com/archives/C02785CLSTW/p1722822320190909
	 */ const viewSettingStorageValue = localStorage.getItem(`__storejs_${$2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE}_${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`) || // return legacy view settings if prefixed storage doesn't exist
    localStorage.getItem(`__storejs_${$2271887588c9e1ef$var$VIEW_SETTINGS_LOCAL_STORAGE}_${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`);
    return JSON.parse(viewSettingStorageValue ?? 'null');
};

});
parcelRegister("cYeCp", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e84c24ee8b7a736a$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e84c24ee8b7a736a$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e84c24ee8b7a736a$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e84c24ee8b7a736a$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e84c24ee8b7a736a$export$eed360eb853808ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

const $e84c24ee8b7a736a$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $2634c0a33984ecbe$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $2634c0a33984ecbe$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e84c24ee8b7a736a$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$ec3c43b997309252));
    search.unset((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $2634c0a33984ecbe$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    if (!(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: false,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
    };
    const issuesQuery = searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'visible' ? true : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e84c24ee8b7a736a$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5), 'hidden');
    if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
        search.unset((0, $2634c0a33984ecbe$export$8b0819c4fa234ad));
        search.unset((0, $2634c0a33984ecbe$export$1692762d83d78f09));
        if (incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $2634c0a33984ecbe$export$8b0819c4fa234ad), 'visible');
        if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $2634c0a33984ecbe$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$eed360eb853808ee = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});
const $2634c0a33984ecbe$export$ec3c43b997309252 = 'epics';
const $2634c0a33984ecbe$export$a86c1a6dde9da34f = 'versions';
const $2634c0a33984ecbe$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $2634c0a33984ecbe$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $2634c0a33984ecbe$export$1692762d83d78f09 = 'issueIdsToShowDependencies';



parcelRegister("hUQ5s", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $f874c35ef69356eb$export$dab2d96649ebf00a);

var $aBK23 = parcelRequire("aBK23");
const $f874c35ef69356eb$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $f874c35ef69356eb$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $aBK23.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $f874c35ef69356eb$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $f874c35ef69356eb$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $f874c35ef69356eb$export$68c4c1e22c91f23f
    });

});


parcelRegister("l8SKN", function(module, exports) {

$parcel$export(module.exports, "setBoardCachedEntry", () => $378b724625452625$export$ce85349d82f1217c);
$parcel$export(module.exports, "getBoardCachedEntry", () => $378b724625452625$export$992aa38aa2da87a4);

var $sn9QA = parcelRequire("sn9QA");

var $x9xyg = parcelRequire("x9xyg");

var $2FZUH = parcelRequire("2FZUH");
const $378b724625452625$export$13bc140835202cda = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-board');
function $378b724625452625$export$4c715dd110bf64d2({ boardId: boardId, accountId: accountId, queryParameters: queryParameters }) {
    const params = [
        accountId,
        boardId
    ];
    if (queryParameters) params.push(JSON.stringify(queryParameters));
    const paramString = params.join('::');
    return `local-device-cache::${paramString}`;
}
async function $378b724625452625$export$ce85349d82f1217c({ boardId: boardId, queryParameters: queryParameters }, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $378b724625452625$export$13bc140835202cda.clearAll();
        return Promise.resolve();
    }
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const key = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    return $378b724625452625$export$13bc140835202cda.set(key, entry);
}
async function $378b724625452625$export$992aa38aa2da87a4({ boardId: boardId, queryParameters: queryParameters }) {
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const cacheKey = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    try {
        (0, $x9xyg.setMark)('uif-board-fetch-read-cache-start');
        const entry = await $378b724625452625$export$13bc140835202cda.get(cacheKey);
        if (entry) (0, $x9xyg.setMark)('uif-board-fetch-read-cache-end');
        else return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $378b724625452625$export$13bc140835202cda.remove(cacheKey);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("c1BZi", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardDataStream", () => $8173307478a42629$export$92fdd848ddb362ed);

var $dO0aE = parcelRequire("dO0aE");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $d4P1V = parcelRequire("d4P1V");

var $l8SKN = parcelRequire("l8SKN");
function $8173307478a42629$export$92fdd848ddb362ed({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    const { cachedPromise: cachedBoardData, promise: promise } = (0, $d4P1V.fetchUIFBoardData)({
        boardId: boardId,
        queryParameters: queryParameters,
        fields: fields
    });
    const cachedPromise = cachedBoardData.then((cache)=>cache?.data ?? null);
    const refreshPromise = (async ()=>{
        const response = await promise;
        if ((0, $co1wz.ff)('jsw.cmp.response-null-abort') && !response) {
            if ((0, $4R6GH.fg)('skip_responsenullerror_on_sentry')) throw new (0, $dO0aE.ResponseNullError)('CMP fetchUIFBoardData returned null');
            const error = new Error('CMP fetchUIFBoardData returned null');
            error.name = 'ResponseNullError';
            throw error;
        }
        (0, $l8SKN.setBoardCachedEntry)({
            boardId: boardId
        }, {
            timestamp: Date.now(),
            etag: response.etag,
            data: response
        });
        return response;
    })();
    return {
        cachedPromise: cachedPromise,
        refreshPromise: refreshPromise
    };
}

});
parcelRegister("d4P1V", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $29c6e7c438197219$export$240c6c415d37cd75);
$parcel$export(module.exports, "runUIFBoardEarlyScript", () => $29c6e7c438197219$export$4c749dee5e4e8bc6);

var $ebyGx = parcelRequire("ebyGx");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $fIEjn = parcelRequire("fIEjn");

var $l8SKN = parcelRequire("l8SKN");

var $aBK23 = parcelRequire("aBK23");
const $29c6e7c438197219$export$5aec1fe89a336a5d = 'fetchBoardData';
let $29c6e7c438197219$var$combinedBoardPromises = null;
function $29c6e7c438197219$var$putBoardEarlyScriptResponse(promises) {
    $29c6e7c438197219$var$combinedBoardPromises = promises;
}
function $29c6e7c438197219$export$1601e80f8f15c5cd() {
    const promises = $29c6e7c438197219$var$combinedBoardPromises;
    $29c6e7c438197219$var$combinedBoardPromises = null;
    return promises;
}
function $29c6e7c438197219$export$3b583d36792fd1ab(boardId) {
    const isCardCoversToggled = (0, $aBK23.getViewSettings)({
        boardId: Number(boardId),
        view: (0, $aBK23.View).BOARD
    })?.showCardCovers;
    if ((0, $4R6GH.fg)('jsw_card_cover_image_default_on')) {
        // If viewSetting isn't set, return skipCardCovers as false by default
        if (isCardCoversToggled === null || isCardCoversToggled === undefined) return false;
    }
    return !isCardCoversToggled;
}
function $29c6e7c438197219$export$240c6c415d37cd75({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    // It is important that there is no async operation before this first
    // return block, otherwise we may create a cycle of this fetch with itself.
    const response = $29c6e7c438197219$export$1601e80f8f15c5cd();
    if (response) return response;
    (0, $x9xyg.setMark)('uif-board-fetch-start');
    const query = {
        moduleKey: (0, $4R6GH.fg)('cmp_board_use_agile-web-board-service_module') ? 'agile-web-board-service' : 'agile-mobile-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        skipEtag: true,
        skipExtraFields: true,
        includeHidden: true,
        activeQuickFilters: (0, $aBK23.convertQuickFiltersToString)(queryParameters) ?? (0, $aBK23.getCachedQuickFilters)('board', boardId),
        fields: fields,
        operation: $29c6e7c438197219$export$5aec1fe89a336a5d,
        ...(0, $4R6GH.fg)('jsw_cmp_card_cover_images') ? {
            skipCardCovers: $29c6e7c438197219$export$3b583d36792fd1ab(boardId)
        } : {}
    };
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    (0, $x9xyg.setMark)('uif-board-fetch-start-request');
    const boardDataUrl = `/rest/boards/latest/board/${boardId}?${queryStr}`;
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$664edf77d4c76110));
    const headers = {
        ...capabilityHeader ? {
            'X-Atlassian-Capability': capabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $fIEjn.getActiveTraceHttpRequestHeaders)(boardDataUrl));
    const cachedPromise = (0, $l8SKN.getBoardCachedEntry)({
        boardId: boardId
    });
    const promise = fetch(boardDataUrl, {
        headers: headers
    }).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        (0, $x9xyg.setMark)('uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch/request', 'uif-board-fetch-start-request', 'uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch', 'uif-board-fetch-start', 'uif-board-fetch-end');
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        return json;
    });
    return {
        cachedPromise: cachedPromise,
        promise: promise
    };
}
function $29c6e7c438197219$export$4c749dee5e4e8bc6(location) {
    const parsedResult = (0, $aBK23.parseBoardLocation)(location);
    if (!parsedResult) return false;
    $29c6e7c438197219$var$putBoardEarlyScriptResponse($29c6e7c438197219$export$240c6c415d37cd75(parsedResult));
    return true;
}

});



parcelRegister("ey78P", function(module, exports) {

$parcel$export(module.exports, "fetchPlanData", () => $1863e9cebf4aed19$export$be4775dacb1fbad6);

var $ebyGx = parcelRequire("ebyGx");

var $487fd = parcelRequire("487fd");
function $1863e9cebf4aed19$export$be4775dacb1fbad6(fetchPlanOptions) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchPlanOptions)}`);
}

});

parcelRegister("3qYzN", function(module, exports) {

$parcel$export(module.exports, "transformPlanData", () => $5f4cd5ebb1f1e87b$export$5c1a457e91f81261);

var $7uUwQ = parcelRequire("7uUwQ");

var $chc6P = parcelRequire("chc6P");

var $183uB = parcelRequire("183uB");

var $4Xk2W = parcelRequire("4Xk2W");

var $2nvJN = parcelRequire("2nvJN");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");

var $3vPnu = parcelRequire("3vPnu");

var $3teSA = parcelRequire("3teSA");

var $8hVbJ = parcelRequire("8hVbJ");
const $5f4cd5ebb1f1e87b$var$NONE = 'None';
const $5f4cd5ebb1f1e87b$var$boardList = {
    id: (0, $guzeq.BOARD),
    type: (0, $guzeq.BOARD),
    name: 'Board',
    issueListKey: null
};
const $5f4cd5ebb1f1e87b$var$backlogList = (0, $7uUwQ.freeze)({
    id: (0, $guzeq.BACKLOG),
    type: (0, $guzeq.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $5f4cd5ebb1f1e87b$var$transformCards = (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issues.map((0, $3vPnu.transformCard)), 'id');
const $5f4cd5ebb1f1e87b$var$isInKanbanContainer = (issue, column)=>!!column && column.statusIds.includes(issue.statusId);
const $5f4cd5ebb1f1e87b$var$transformKanbanCardsOrder = ({ issues: issues, selectedForDevelopmentColumn: board, backlogColumn: backlog })=>{
    const cardIdByContainerType = {
        [(0, $guzeq.BOARD)]: [],
        [(0, $guzeq.BACKLOG)]: []
    };
    issues.forEach((issue)=>{
        if ($5f4cd5ebb1f1e87b$var$isInKanbanContainer(issue, board)) cardIdByContainerType[0, $guzeq.BOARD].push(issue.id);
        else if ($5f4cd5ebb1f1e87b$var$isInKanbanContainer(issue, backlog)) cardIdByContainerType[0, $guzeq.BACKLOG].push(issue.id);
    });
    return cardIdByContainerType;
};
const $5f4cd5ebb1f1e87b$var$transformConfig = (response)=>{
    const isKanban = (0, $3teSA.isKanbanPlanDataResponse)(response);
    return {
        requestColumnMigration: false,
        rankCustomFieldId: response.rankCustomFieldId || -1,
        version: {
            // We want the versions feature to be always true for CMP
            isVersionsFeatureEnabled: true
        },
        allFeatures: [],
        backlogStrategy: isKanban ? (0, $guzeq.KANBAN_BACKLOG_STRATEGY) : (0, $guzeq.SPRINT_BACKLOG_STRATEGY),
        kanbanBoardColumnId: isKanban ? response?.selectedForDevelopmentColumn?.id : null,
        kanbanBacklogColumnId: isKanban ? response?.backlogColumn?.id : null,
        hierarchyNomenclature: response?.flexibleNomenclatureData?.levelOneName ? {
            firstLevelName: response?.flexibleNomenclatureData?.levelOneName
        } : null,
        permissions: (0, $4R6GH.fg)('jsw-perf-backlog-status-field-ui-mutation') ? {
            CAN_CREATE_ISSUES: response.canCreateIssue,
            CAN_EDIT_ISSUES: response.canCreateIssue,
            CAN_MANAGE_SPRINTS: response.canManageSprints,
            // The BE will always return `true` otherwise it will return a 401 error
            CAN_VIEW_BOARD: true
        } : undefined
    };
};
const $5f4cd5ebb1f1e87b$var$isValidDateSprint = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(value) !== $5f4cd5ebb1f1e87b$var$NONE;
const $5f4cd5ebb1f1e87b$var$getSprintDate = (value)=>$5f4cd5ebb1f1e87b$var$isValidDateSprint(value) ? value : '';
const $5f4cd5ebb1f1e87b$var$transformSprint = ({ id: id, name: name, goal: goal, isoStartDate: isoStartDate, isoEndDate: isoEndDate, daysRemaining: daysRemaining, state: state, canUpdateSprint: canUpdateSprint })=>({
        id: String(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoStartDate),
            endDate: $5f4cd5ebb1f1e87b$var$getSprintDate(isoEndDate),
            daysRemaining: daysRemaining,
            state: state,
            canUpdateSprint: canUpdateSprint
        }
    });
const $5f4cd5ebb1f1e87b$var$transformVersions = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))((0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(response.versionData?.versionsPerProject, (versions, projectId)=>versions.map((version)=>({
                id: version.id,
                name: version.name,
                projectId: Number(projectId)
            }))), (version)=>String(version.id));
const $5f4cd5ebb1f1e87b$var$toVersionIds = (versions)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    versions ? versions.map((version)=>String(version.id)) : [];
const $5f4cd5ebb1f1e87b$var$transformVersionsOrder = (response)=>response?.versionData?.versionsPerProject ? (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.keys(response.versionData.versionsPerProject).map((projectId)=>$5f4cd5ebb1f1e87b$var$toVersionIds(response.versionData.versionsPerProject[projectId]))) : [];
const $5f4cd5ebb1f1e87b$var$transformFilteredCardIds = (issues, activeQuickFilters)=>{
    if (!activeQuickFilters.length) return null;
    return new Set(issues.map((issue)=>String(issue.id)));
};
const $5f4cd5ebb1f1e87b$var$transformIssueIdsBySprint = (issues, sprintId)=>issues.filter((issue)=>issue.sprintIds?.includes(sprintId) ?? false).map((issue)=>issue.id);
const $5f4cd5ebb1f1e87b$var$extractCardTypes = (issues)=>Array.from(issues.reduce((acc, val)=>{
        if (acc.has(val.typeId)) return acc;
        return acc.set(val.typeId, {
            id: Number(val.typeId),
            name: val.typeName,
            iconUrl: val.typeUrl,
            hasRequiredFields: null,
            typeHierarchyLevel: (0, $g4tDr.getHierarchyLevelType)(val.typeHierarchyLevel)
        });
    }, new Map()).values());
const $5f4cd5ebb1f1e87b$var$isSubtask = (issue)=>typeof issue.parentKey === 'string' && issue.parentKey.length > 0;
const $5f4cd5ebb1f1e87b$export$c53ff095db760b09 = (issues, issueIdInSprints)=>{
    if (issues.length === 0) return [];
    const backlogIssues = issues.filter((issue)=>!issueIdInSprints.includes(issue.id));
    const backlogIssueIds = new Set();
    if (backlogIssues.length > 0) {
        const subtasks = backlogIssues.filter($5f4cd5ebb1f1e87b$var$isSubtask);
        backlogIssues.forEach((issue)=>{
            // In case the issue has already been processed return to prevent the loop below which is expensive.
            if (backlogIssueIds.has(issue.id)) return;
            backlogIssueIds.add(issue.id);
            // subtasks can not have subtasks and thus the work below is unnecessary.
            if ($5f4cd5ebb1f1e87b$var$isSubtask(issue)) return;
            subtasks.forEach((subtask)=>{
                if (subtask.parentId !== issue.id) return;
                backlogIssueIds.add(subtask.id);
            });
        });
    }
    return Array.from(backlogIssueIds);
};
const $5f4cd5ebb1f1e87b$var$transformScrumBacklog = (response, activeQuickFilters)=>{
    const cardList = {
        [(0, $guzeq.BACKLOG)]: $5f4cd5ebb1f1e87b$var$backlogList
    };
    const cardOrder = {};
    const cardListOrder = [];
    let issueIdInSprints = [];
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    response.sprints.forEach((sprint)=>{
        const sprintIssueIds = $5f4cd5ebb1f1e87b$var$transformIssueIdsBySprint(response.issues, sprint.id);
        cardList[sprint.id] = $5f4cd5ebb1f1e87b$var$transformSprint(sprint);
        cardOrder[sprint.id] = sprintIssueIds;
        cardListOrder.push(String(sprint.id));
        issueIdInSprints = issueIdInSprints.concat(sprintIssueIds);
    });
    cardOrder[0, $guzeq.BACKLOG] = $5f4cd5ebb1f1e87b$export$c53ff095db760b09(response.issues, issueIdInSprints);
    cardListOrder.push((0, $guzeq.BACKLOG));
    return {
        entities: {
            card: $5f4cd5ebb1f1e87b$var$transformCards(response.issues),
            cardOrder: cardOrder,
            cardListOrder: cardListOrder,
            cardList: cardList,
            cardTypes: $5f4cd5ebb1f1e87b$var$extractCardTypes(response.issues),
            project: {
                projects: response.projects
            },
            versions: $5f4cd5ebb1f1e87b$var$transformVersions(response),
            version: {
                versions: $5f4cd5ebb1f1e87b$var$transformVersionsOrder(response)
            }
        },
        config: $5f4cd5ebb1f1e87b$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $5f4cd5ebb1f1e87b$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $5f4cd5ebb1f1e87b$var$transformBoardListWithLimits = (firstColumn)=>{
    if (firstColumn) return {
        ...$5f4cd5ebb1f1e87b$var$boardList,
        name: firstColumn.name,
        minColumnLimit: firstColumn.min,
        maxColumnLimit: firstColumn.max
    };
    return $5f4cd5ebb1f1e87b$var$boardList;
};
const $5f4cd5ebb1f1e87b$var$transformKanbanBacklog = (response, activeQuickFilters)=>{
    const visibleIssues = response.issues.filter((issue)=>!issue.hidden);
    return {
        entities: {
            card: $5f4cd5ebb1f1e87b$var$transformCards(response.issues),
            cardOrder: $5f4cd5ebb1f1e87b$var$transformKanbanCardsOrder(response),
            cardOrderGlobal: response.issues.map((issue)=>issue.id),
            cardListOrder: [
                (0, $guzeq.BOARD),
                (0, $guzeq.BACKLOG)
            ],
            cardList: {
                [(0, $guzeq.BOARD)]: $5f4cd5ebb1f1e87b$var$transformBoardListWithLimits(response.selectedForDevelopmentColumn),
                [(0, $guzeq.BACKLOG)]: $5f4cd5ebb1f1e87b$var$backlogList
            },
            project: {
                projects: response.projects
            },
            versions: $5f4cd5ebb1f1e87b$var$transformVersions(response),
            version: {
                versions: $5f4cd5ebb1f1e87b$var$transformVersionsOrder(response)
            }
        },
        config: $5f4cd5ebb1f1e87b$var$transformConfig(response),
        ui: {
            cards: {
                filteredCards: {
                    isLoading: false,
                    filteredCardsIds: $5f4cd5ebb1f1e87b$var$transformFilteredCardIds(visibleIssues, activeQuickFilters)
                }
            }
        }
    };
};
const $5f4cd5ebb1f1e87b$export$5c1a457e91f81261 = (response, isCompanyManaged, activeQuickFilters = [])=>{
    const metric = isCompanyManaged ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_START));
    const result = (0, $3teSA.isKanbanPlanDataResponse)(response) ? $5f4cd5ebb1f1e87b$var$transformKanbanBacklog(response, activeQuickFilters) : $5f4cd5ebb1f1e87b$var$transformScrumBacklog(response, activeQuickFilters);
    metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_TRANSFORM_CRITICAL_REST_END));
    return result;
};

});
parcelRegister("3teSA", function(module, exports) {

$parcel$export(module.exports, "isKanbanPlanDataResponse", () => $f46b59a8a075e05b$export$489d7cf1df036453);
function $f46b59a8a075e05b$export$489d7cf1df036453(response) {
    if (response !== null && typeof response === 'object') return 'backlogColumn' in response && 'selectedForDevelopmentColumn' in response;
    return false;
}

});



parcelRegister("sRW5v", function(module, exports) {

$parcel$export(module.exports, "getCustomFiltersDebounceTime", () => $f8f506341feac682$export$2ecac126a7851701);
const $f8f506341feac682$export$2ecac126a7851701 = ()=>500;

});


parcelRegister("h6CKH", function(module, exports) {

$parcel$export(module.exports, "filteredCardsRequestEpic", () => $f8059299f5245a9d$export$ee8377ae46706014);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $35NvU = parcelRequire("35NvU");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $9Z18E = parcelRequire("9Z18E");

var $8MHVw = parcelRequire("8MHVw");

var $likqC = parcelRequire("likqC");

var $jG5HW = parcelRequire("jG5HW");

var $sRW5v = parcelRequire("sRW5v");
const $f8059299f5245a9d$var$filterCards = (action, store, dependencies)=>{
    const state = store.getState();
    const { issueIds: issueIds, customFilterIds: customFilterIds } = action.payload;
    const { analyticsEvent: analyticsEvent } = action.meta;
    const ctx = (0, $i4Z8q.makeServiceContext)(state);
    if (!customFilterIds || !customFilterIds.length) return (0, $kVLXA.Observable).from([
        ctx.isCompanyManaged ? (0, $8MHVw.clearFilteredCardsRequest)(analyticsEvent) : (0, $8MHVw.clearFilteredCards)(),
        (0, $9Z18E.cardAutoScrollRequestOnFilter)()
    ]);
    return (0, $35NvU.fetchFilteredCardsService)(ctx, {
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
        storeFieldsActions: dependencies?.storeFieldsActions
    }).flatMap(({ filteredCardIds: filteredCardIds, data: data })=>[
            (0, $8MHVw.filteredCardsSuccess)(filteredCardIds, customFilterIds.length, issueIds.length, analyticsEvent),
            ...data ? [
                (0, $3lZ6i.setAppData)(data)
            ] : [],
            (0, $9Z18E.cardAutoScrollRequestOnFilter)()
        ]).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.filtered-cards.failure', 'Fail to filter cards with custom filters', error);
        return (0, $kVLXA.Observable).of((0, $8MHVw.filteredCardsFailed)(error, analyticsEvent), (0, $likqC.setAllFilters)({}));
    });
};
const $f8059299f5245a9d$export$ee8377ae46706014 = (action$, store, dependencies)=>action$.ofType((0, $8MHVw.FILTERED_CARD_REQUEST)).throttleTime((0, $sRW5v.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$f8059299f5245a9d$var$filterCards(action, store, dependencies));

});
parcelRegister("35NvU", function(module, exports) {

$parcel$export(module.exports, "fetchFilteredCardsService", () => $e0df9b6195c9e771$export$6aa3118e5c68853c);
parcelRequire("d0pqD");

var $4CpQY = parcelRequire("4CpQY");

var $j0SXO = parcelRequire("j0SXO");
function $e0df9b6195c9e771$export$6aa3118e5c68853c(ctx, { issueIds: issueIds, customFilterIds: customFilterIds, epicIssueType: epicIssueType, storeFieldsActions: storeFieldsActions }) {
    if (ctx.isCompanyManaged) return (0, $j0SXO.loadPlanDataService)({
        boardId: ctx.boardId,
        isCompanyManaged: ctx.isCompanyManaged,
        activeQuickFilters: customFilterIds,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((data)=>({
            data: data,
            filteredCardIds: Object.values(data.entities.card).filter((card)=>!card.hidden).map((card)=>String(card.id))
        }));
    return (0, $4CpQY.default)('', ctx.boardId, issueIds, customFilterIds).map((filteredCardIds)=>({
            filteredCardIds: filteredCardIds
        }));
}

});
parcelRegister("4CpQY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f0bbf21dbb8335$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $69f0bbf21dbb8335$var$filteredCardsQuery = 'FilteredCardIds';
const $69f0bbf21dbb8335$export$71eec30d9db46a56 = ()=>`
    query ${$69f0bbf21dbb8335$var$filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
            )
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69f0bbf21dbb8335$export$2e2bcd8739ae039 = (baseUrl, boardId, issueIds, customFilterIds)=>(0, $cBLvH.query$)(baseUrl, $69f0bbf21dbb8335$var$filteredCardsQuery, $69f0bbf21dbb8335$export$71eec30d9db46a56(), {
        boardId: boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds
    }).flatMap(({ boardScope: boardScope })=>(0, $kVLXA.Observable).of(boardScope.filteredCardIds));

});



parcelRegister("S4gg9", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpic", () => $f06427293390e5a3$export$12fb76cfeb5c0ed2);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");
parcelRequire("1oQta");

var $k8IPx = parcelRequire("k8IPx");

var $1sXeC = parcelRequire("1sXeC");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");


var $35NvU = parcelRequire("35NvU");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");

var $ubpiL = parcelRequire("ubpiL");

var $jG5HW = parcelRequire("jG5HW");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f06427293390e5a3$var$isActiveTab = ()=>!document.hidden;
const $f06427293390e5a3$var$getActiveCustomFilterIds = (state)=>state.ui.filters.CUSTOM_FILTER || [];
const $f06427293390e5a3$var$isCustomFiltersActive = (state)=>$f06427293390e5a3$var$getActiveCustomFilterIds(state).length > 0;
const $f06427293390e5a3$export$12fb76cfeb5c0ed2 = (action$, store, dependencies)=>action$.ofType((0, $ubpiL.REALTIME_DISPATCH_EVENT_BATCH)).filter($f06427293390e5a3$var$isActiveTab).filter(()=>$f06427293390e5a3$var$isCustomFiltersActive(store.getState())).switchMap((action)=>{
        const state = store.getState();
        const currentUser = (0, $jG5HW.getAtlassianAccountId)(state);
        const triggerEvents = action.payload.events.filter((event)=>event.payload.atlassianId === currentUser && (event.type === (0, $09d938f04e8899c4$export$b22a14d5dac59664) || event.type === (0, $09d938f04e8899c4$export$b22142e61b3fdbee)));
        if (triggerEvents.length > 0) {
            const customFilterIds = $f06427293390e5a3$var$getActiveCustomFilterIds(state);
            const issueIds = triggerEvents.map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (event)=>event.payload.issueId);
            return (0, $35NvU.fetchFilteredCardsService)((0, $i4Z8q.makeServiceContext)(state), {
                customFilterIds: customFilterIds,
                issueIds: issueIds,
                epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
                storeFieldsActions: dependencies?.storeFieldsActions
            }).mergeMap(({ filteredCardIds: filteredCardIds, data: data })=>{
                const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueIds.map((issueId)=>String(issueId)), filteredCardIds);
                if (excludedCardIds.length) {
                    // we only want to show the flag for created issues
                    const excludedCreatedCardIds = excludedCardIds.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(cardId)).filter((cardId)=>triggerEvents.some((event)=>// @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'EventPayload'.
                            event.payload.issueId === cardId && event.type === (0, $09d938f04e8899c4$export$b22a14d5dac59664)));
                    if (excludedCreatedCardIds.length) return [
                        ...data ? [
                            (0, $3lZ6i.setAppData)(data)
                        ] : [],
                        (0, $hf5c2.cardCreateFilteredV2)(excludedCreatedCardIds),
                        (0, $8MHVw.refilterSuccess)(excludedCardIds, filteredCardIds)
                    ];
                }
                return [
                    ...data ? [
                        (0, $3lZ6i.setAppData)(data)
                    ] : [],
                    (0, $8MHVw.refilterSuccess)(excludedCardIds, filteredCardIds)
                ];
            }).catch((error)=>{
                (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.filtered-cards.refilter.batch.failure', 'Fail to batch re-filter cards with custom filters', error);
                return (0, $kVLXA.Observable).of((0, $8MHVw.refilterFailure)(error));
            });
        }
        return (0, $kVLXA.Observable).empty();
    });

});
const $09d938f04e8899c4$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $09d938f04e8899c4$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $09d938f04e8899c4$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $09d938f04e8899c4$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $09d938f04e8899c4$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $09d938f04e8899c4$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $09d938f04e8899c4$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $09d938f04e8899c4$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';

parcelRegister("ubpiL", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT_BATCH", () => $7097cc282617eb64$export$146c7f09e2af258);
$parcel$export(module.exports, "dispatchRealtimeEventBatch", () => $7097cc282617eb64$export$884fd41fa17b25da);
const $7097cc282617eb64$export$146c7f09e2af258 = 'state.actions.realtime.dispatch.REALTIME_DISPATCH_EVENT_BATCH';
const $7097cc282617eb64$export$884fd41fa17b25da = (event)=>({
        type: $7097cc282617eb64$export$146c7f09e2af258,
        payload: {
            events: event
        }
    });

});



parcelRegister("jQJPl", function(module, exports) {

$parcel$export(module.exports, "issueViewUpdateEpic", () => $af823fc0306b2266$export$f43e66f9c7ce58d1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $hi0S3 = parcelRequire("hi0S3");

var $9zy1T = parcelRequire("9zy1T");

var $17kP6 = parcelRequire("17kP6");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");
const $af823fc0306b2266$export$f43e66f9c7ce58d1 = (action$, store)=>action$.ofType((0, $17kP6.ISSUE_VIEW_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: payload } = action;
        const targetIssueParent = (0, $fmuR9.getIssueParents)(state)[payload.issueId];
        if (targetIssueParent) {
            const actionsFromMappedResponse = (0, $9zy1T.mapResponseToIssueParent)(targetIssueParent, state, payload);
            return actionsFromMappedResponse ? (0, $kVLXA.Observable).from([
                actionsFromMappedResponse
            ]) : (0, $kVLXA.Observable).empty();
        }
        // TODO: Add getIssueChildren(state)[payload.issueId] when issue children is supported in Backlog (CATBUS-2200)
        const targetIssue = (0, $dGljH.getCards)(state)[payload.issueId];
        const actionsFromMappedResponse = (0, $hi0S3.mapResponseToIssue)(targetIssue, state, payload);
        return actionsFromMappedResponse ? (0, $kVLXA.Observable).from([
            actionsFromMappedResponse
        ]) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("hi0S3", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssue", () => $bdd1761ffea1dd72$export$270311cab2abcd0d);

var $FTaAj = parcelRequire("FTaAj");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $6jl1B = parcelRequire("6jl1B");
const $bdd1761ffea1dd72$export$270311cab2abcd0d = (issue, state, payload)=>{
    if (!payload.type || !issue) return null;
    // TODO: To be added when Backlog supports issue children (CATBUS-2200)
    // if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
    //     return setIssueChildrenRank(payload.meta);
    // }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        const isCMPScrum = (0, $jG5HW.isCMPScrumBacklog)(state);
        const sprintFieldId = (0, $jG5HW.getSprintFieldId)(state);
        if (isCMPScrum && payload.meta.fieldId === sprintFieldId) return (0, $3lZ6i.loadAppData)();
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED || payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $3lZ6i.loadAppData)();
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $6jl1B.updateRankOnChildrenOrderChange)(state, payload.meta);
    return null;
};

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("6jl1B", function(module, exports) {

$parcel$export(module.exports, "updateRankOnChildrenOrderChange", () => $13717743638f3d7a$export$d180b3cae3a333fb);

var $6GNN7 = parcelRequire("6GNN7");

var $dGljH = parcelRequire("dGljH");
const $13717743638f3d7a$export$d180b3cae3a333fb = (state, { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>{
    const cardOrder = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const cardListId = (0, $dGljH.makeGetCardListIdByCardId)(state)(rankId);
    if (cardListId == null) return null;
    const cardIds = issueIds.map((id)=>Number(id)).filter((id)=>(cardOrder[cardListId] || []).includes(id));
    const cardsMoveSetPayload = {
        cardIds: cardIds,
        cardListId: cardListId,
        isBetweenLists: false,
        beforeCardId: !isRankAfter ? rankId : null,
        afterCardId: isRankAfter ? rankId : null
    };
    /** cardIds can be an empty list here depending on cardListId.
	 * This check ensures no optimistic ranking updates is triggered in Backlog when the issue ranked (and surrounding issues) in BENTO children panel are from different sections
	 * e.g. one from backlog and another from a sprint etc.
	 */ return cardIds.length ? (0, $6GNN7.cardsMoveSet)(cardsMoveSetPayload) : null;
};

});


parcelRegister("9zy1T", function(module, exports) {

$parcel$export(module.exports, "mapResponseToIssueParent", () => $6d8d50ba60123d1c$export$b4cee4073a723eae);

var $iHPnC = parcelRequire("iHPnC");

var $FTaAj = parcelRequire("FTaAj");

var $hf5c2 = parcelRequire("hf5c2");

var $hqokg = parcelRequire("hqokg");

var $9Pc1U = parcelRequire("9Pc1U");

var $6jl1B = parcelRequire("6jl1B");
const $6d8d50ba60123d1c$export$b4cee4073a723eae = (issueParent, state, payload)=>{
    const epicColorFieldId = (0, $9Pc1U.getEpicColorFieldId)(state);
    if (!payload.type || !issueParent) return null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        if (payload.meta.fieldId !== 'summary' && payload.meta.fieldId !== epicColorFieldId) return null;
        const issueParentContent = payload.meta.fieldId === epicColorFieldId ? {
            color: (0, $iHPnC.asColor)(payload.meta.fieldValue)
        } : {
            [payload.meta.fieldId]: payload.meta.fieldValue
        };
        return (0, $hqokg.issueParentPatch)({
            id: issueParent.id,
            issueParent: issueParentContent
        });
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) return (0, $6jl1B.updateRankOnChildrenOrderChange)(state, payload.meta);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $hf5c2.cardCreateEndOfBacklogOptimistic)(payload);
    return null;
};

});
parcelRegister("hqokg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENT_PATCH", () => $828778a217f635e3$export$e9af2723cb3ed91e);
$parcel$export(module.exports, "issueParentPatch", () => $828778a217f635e3$export$72e99a23ae3ed0b0);
const $828778a217f635e3$export$e9af2723cb3ed91e = 'state.actions.issue-parents.patch.ISSUE_PARENT_PATCH';
const $828778a217f635e3$export$72e99a23ae3ed0b0 = (payload)=>({
        type: $828778a217f635e3$export$e9af2723cb3ed91e,
        payload: payload
    });

});


parcelRegister("17kP6", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_UPDATE", () => $0dba4489a533382f$export$be7899fc700a03e7);
$parcel$export(module.exports, "issueViewUpdate", () => $0dba4489a533382f$export$758415d5f0ecccd0);
const $0dba4489a533382f$export$be7899fc700a03e7 = 'state.actions.issue-view-update.ISSUE_VIEW_UPDATE';
const $0dba4489a533382f$export$758415d5f0ecccd0 = (payload)=>({
        type: $0dba4489a533382f$export$be7899fc700a03e7,
        payload: payload
    });

});


parcelRegister("5z625", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $f8d821d1f878bbaa$export$8134c072fddab6a5);
$parcel$export(module.exports, "loadAgilityGraphqlDataEpic", () => $f8d821d1f878bbaa$export$8976970ef97c8467);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $f6RVN = parcelRequire("f6RVN");

var $72ViA = parcelRequire("72ViA");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");
const $f8d821d1f878bbaa$export$8134c072fddab6a5 = (params)=>{
    const { store: store, prefetchedData: prefetchedData = null, prefetchedAggData: prefetchedAggData, fetchDataFromAGG: fetchDataFromAGG, storeFieldsActions: storeFieldsActions } = params;
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const fieldConfigs = {
        storyPointFieldId: storyPointFieldId
    };
    return (0, $72ViA.default)({
        baseUrl: baseUrl,
        boardId: boardId,
        fieldConfigs: fieldConfigs,
        prefetchedData: prefetchedData,
        prefetchedAggData: prefetchedAggData,
        storeFieldsActions: storeFieldsActions,
        fetchDataFromAGG: fetchDataFromAGG,
        isCompanyManaged: isCompanyManaged
    }).map((0, $3lZ6i.setAppData)).catch((restError)=>{
        const message = (0, $f6RVN.isBacklogWithRelayEnabled)() && fetchDataFromAGG ? 'Failed to load graphql data from AGG' : 'Failed to load graphql data';
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-agility-graphql-data.failure', message, restError);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppDataFailure)());
    });
};
const $f8d821d1f878bbaa$export$8976970ef97c8467 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap((action)=>$f8d821d1f878bbaa$export$8134c072fddab6a5({
            store: store,
            prefetchedData: action.payload.prefetchedData,
            prefetchedAggData: action.payload.prefetchedAggData,
            storeFieldsActions: action.payload.storeFieldsActions
        }));

});
parcelRegister("72ViA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84754d5dceb75031$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $bXPjr = parcelRequire("bXPjr");

var $74daz = parcelRequire("74daz");

var $f6RVN = parcelRequire("f6RVN");

var $aUPmR = parcelRequire("aUPmR");

var $4EjDu = parcelRequire("4EjDu");
function $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, updateFieldsAction) {
    if (updateFieldsAction && fieldConfigs) updateFieldsAction(data, fieldConfigs);
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84754d5dceb75031$export$2e2bcd8739ae039 = ({ baseUrl: baseUrl, boardId: boardId, isCompanyManaged: isCompanyManaged, fieldConfigs: fieldConfigs, prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, storeFieldsActions: storeFieldsActions, fetchDataFromAGG: fetchDataFromAGG })=>{
    if ((0, $f6RVN.isBacklogWithRelayEnabled)()) {
        if (prefetchedAggData) {
            $84754d5dceb75031$var$updateStoreFields(prefetchedAggData, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedAggData);
            return (0, $kVLXA.Observable).of((0, $aUPmR.transformAggData)(prefetchedAggData));
        }
        if (fetchDataFromAGG) return (0, $bXPjr.fromPromise)(fetchDataFromAGG()).map((data)=>{
            $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedAggData);
            return (0, $aUPmR.transformAggData)(data);
        });
        return (0, $74daz.default)(baseUrl, boardId).map((data)=>{
            $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
            return (0, $4EjDu.default)(data, isCompanyManaged);
        });
    }
    const getResponse = ()=>{
        if (prefetchedData) {
            $84754d5dceb75031$var$updateStoreFields(prefetchedData, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
            return (0, $kVLXA.Observable).of(prefetchedData);
        }
        return (0, $74daz.default)(baseUrl, boardId);
    };
    return getResponse().map((data)=>{
        $84754d5dceb75031$var$updateStoreFields(data, fieldConfigs, storeFieldsActions?.storeFieldsFromPrefetchedData);
        return (0, $4EjDu.default)(data, isCompanyManaged);
    });
};

});
parcelRegister("74daz", function(module, exports) {

$parcel$export(module.exports, "fetchAgilityGraphqlData", () => $8125f9503b9f63f0$export$bd0cd61988658475);
$parcel$export(module.exports, "default", () => $8125f9503b9f63f0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cab1K = parcelRequire("cab1K");

var $dJl1T = parcelRequire("dJl1T");

var $cBLvH = parcelRequire("cBLvH");

var $7VysW = parcelRequire("7VysW");

var $drQql = parcelRequire("drQql");
const $8125f9503b9f63f0$var$BACKLOG = 'BACKLOG';
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
const $8125f9503b9f63f0$var$CacheUpdateSubject = new (0, $cab1K.Subject)();
const $8125f9503b9f63f0$var$loadAgilityGraphqlData = (baseUrl, boardId)=>{
    const requestStartTime = new Date().valueOf();
    const query = (0, $drQql.getQuery)();
    (0, $7VysW.setBacklogFetchStart)();
    return (0, $cBLvH.query$)(baseUrl, (0, $drQql.backlogDataOperationName), query, {
        boardId: boardId
    }).flatMap((data)=>{
        const requestEndTime = new Date().valueOf();
        (0, $dJl1T.default).safeInfoWithoutCustomerData(`rest.swag.${(0, $drQql.backlogDataOperationName)}.success`, '', {
            time: requestEndTime - requestStartTime
        });
        // Everytime we fetch this data, we can use it to hydrate the BACKLOG resources-cache
        $8125f9503b9f63f0$var$CacheUpdateSubject.next({
            origin: $8125f9503b9f63f0$var$BACKLOG,
            payload: data
        });
        (0, $7VysW.setBacklogFetchStop)();
        return (0, $kVLXA.Observable).of(data);
    });
};
const $8125f9503b9f63f0$export$bd0cd61988658475 = (baseUrl, boardId)=>$8125f9503b9f63f0$var$loadAgilityGraphqlData(baseUrl, boardId).toPromise().then((response)=>response);
var $8125f9503b9f63f0$export$2e2bcd8739ae039 = $8125f9503b9f63f0$var$loadAgilityGraphqlData;

});
parcelRegister("7VysW", function(module, exports) {

$parcel$export(module.exports, "setBacklogFetchStart", () => $27213b8f5a70f01f$export$98082f6cfce5fbfd);
$parcel$export(module.exports, "setBacklogFetchStop", () => $27213b8f5a70f01f$export$a14619e64801099);

var $jvua8 = parcelRequire("jvua8");
const $27213b8f5a70f01f$export$98082f6cfce5fbfd = ()=>{
    (0, $jvua8.backlogFetch).start();
};
const $27213b8f5a70f01f$export$a14619e64801099 = ()=>{
    (0, $jvua8.backlogFetch).stop();
};

});
parcelRegister("jvua8", function(module, exports) {

$parcel$export(module.exports, "backlogFetch", () => $3b06e90a3e705fa7$export$c37fad154e1f0a06);

var $cHBMC = parcelRequire("cHBMC");
const $3b06e90a3e705fa7$export$c37fad154e1f0a06 = (0, $cHBMC.metrics).interaction({
    key: 'backlog.data-fetch'
});

});


parcelRegister("drQql", function(module, exports) {

$parcel$export(module.exports, "backlogDataOperationName", () => $099f828ded21ecfb$export$2aa160b066ef4bbe);
$parcel$export(module.exports, "getQuery", () => $099f828ded21ecfb$export$71eec30d9db46a56);
/*!
 * ATTENTION
 *
 * This module is used on both the main backlog app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $099f828ded21ecfb$export$2aa160b066ef4bbe = 'BacklogDataQuery';
const $099f828ded21ecfb$export$71eec30d9db46a56 = ()=>`
    query ${$099f828ded21ecfb$export$2aa160b066ef4bbe} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                }
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;

});


parcelRegister("aUPmR", function(module, exports) {

$parcel$export(module.exports, "transformAggData", () => $7ac87cf2c1708f51$export$184ba826956cb720);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $kGsr8 = parcelRequire("kGsr8");

var $dMEgP = parcelRequire("dMEgP");

var $sLb2Q = parcelRequire("sLb2Q");

var $co1wz = parcelRequire("co1wz");

var $g4tDr = parcelRequire("g4tDr");



var $gBj4V = parcelRequire("gBj4V");

var $f01qr = parcelRequire("f01qr");


var $guzeq = parcelRequire("guzeq");

const $7ac87cf2c1708f51$var$storyPointFieldIdTransformer = (estimation)=>{
    const storyPointId = estimation.available.find(({ statisticFieldId: statisticFieldId })=>statisticFieldId !== (0, $guzeq.ORIGINAL_ESTIMATE_FIELD_ID) && statisticFieldId !== (0, $guzeq.ISSUE_COUNT_ID))?.statisticFieldId || '';
    return storyPointId.replace((0, $guzeq.ESTIMATION_TYPE_ID_PREFIX), '') || null;
};
const $7ac87cf2c1708f51$var$isFeatureEnabled = (features, featureKey)=>(features || []).some(({ key: key, status: status })=>String(key) === featureKey && status === (0, $0b986b66d9bedfde$export$e927a5d1b72f0b68));
const $7ac87cf2c1708f51$var$getBacklogStrategy = (features)=>{
    if (!$7ac87cf2c1708f51$var$isFeatureEnabled(features, (0, $guzeq.BACKLOG))) return 0, $guzeq.NONE;
    if ($7ac87cf2c1708f51$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4279f6f79febea0a))) return 0, $guzeq.SPRINT;
    return 0, $guzeq.ISSUE_LIST;
};
const $7ac87cf2c1708f51$var$getJiraTimeUnit = (defaultUnit)=>{
    switch(defaultUnit.toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};
const $7ac87cf2c1708f51$var$getJiraTimeFormat = (format)=>{
    switch(format.toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $7ac87cf2c1708f51$var$cardTypesTransformer = (cardTypes)=>cardTypes.reduce((baseLevelCardTypes, { hierarchyLevelType: hierarchyLevelType, id: id, name: name, iconUrl: iconUrl, hasRequiredFields: hasRequiredFields })=>{
        if (String(hierarchyLevelType) === (0, $g4tDr.BASE_HIERARCHY_TYPE)) baseLevelCardTypes.push({
            id: Number(id),
            name: name,
            iconUrl: iconUrl,
            hasRequiredFields: hasRequiredFields,
            typeHierarchyLevel: (0, $g4tDr.BASE_HIERARCHY_TYPE)
        });
        return baseLevelCardTypes;
    }, []);
const $7ac87cf2c1708f51$var$BACKLOG_LIST = (0, $7uUwQ.freeze)({
    id: (0, $guzeq.BACKLOG),
    type: (0, $guzeq.BACKLOG),
    name: 'Backlog',
    issueListKey: null
});
const $7ac87cf2c1708f51$export$69760b7e76c533f9 = ({ jira: { globalTimeTrackingSettings: globalTimeTrackingSettings }, boardScope: { board: { rankCustomFieldId: rankCustomFieldId }, projectLocation: { name: name }, features: features, currentUser: { permissions: permissions }, estimation: estimation, backlog: backlog } })=>{
    if (!backlog) throw new Error('boardScope.backlog is null');
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredPermissions = permissions.map((permission)=>String(permission));
    const transformedConfig = {
        rankCustomFieldId: Number(rankCustomFieldId),
        requestColumnMigration: backlog.requestColumnMigration,
        name: name,
        permissions: (0, $co1wz.ff)('issue-unarchival_wdpb9') ? {
            [(0, $a33d0dff7e784665$export$d765836bd761b2ee)]: filteredPermissions.includes((0, $guzeq.MANAGE_SPRINT)),
            [(0, $a33d0dff7e784665$export$526c94c551c00291)]: filteredPermissions.includes((0, $guzeq.CREATE_ISSUE)),
            [(0, $a33d0dff7e784665$export$8a1ecb9983951227)]: filteredPermissions.includes((0, $guzeq.EDIT_ISSUE)),
            [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: filteredPermissions.includes((0, $guzeq.EDIT_BOARD_CONFIG)),
            [(0, $e525e6c25695c9df$export$e6bcada406923d66)]: filteredPermissions.includes((0, $guzeq.ARCHIVE_ISSUE))
        } : {
            [(0, $a33d0dff7e784665$export$d765836bd761b2ee)]: filteredPermissions.includes((0, $guzeq.MANAGE_SPRINT)),
            [(0, $a33d0dff7e784665$export$526c94c551c00291)]: filteredPermissions.includes((0, $guzeq.CREATE_ISSUE)),
            [(0, $a33d0dff7e784665$export$8a1ecb9983951227)]: filteredPermissions.includes((0, $guzeq.EDIT_ISSUE)),
            [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: filteredPermissions.includes((0, $guzeq.EDIT_BOARD_CONFIG))
        },
        version: {
            isVersionsFeatureEnabled: $7ac87cf2c1708f51$var$isFeatureEnabled(filteredFeatures, (0, $0b986b66d9bedfde$export$173708eb8a9ba955))
        },
        allFeatures: filteredFeatures,
        backlogStrategy: $7ac87cf2c1708f51$var$getBacklogStrategy(filteredFeatures),
        storyPointFieldId: $7ac87cf2c1708f51$var$storyPointFieldIdTransformer(estimation),
        timeTrackingOptions: {
            workingDaysPerWeek: globalTimeTrackingSettings.workingDaysPerWeek,
            workingHoursPerDay: globalTimeTrackingSettings.workingHoursPerDay,
            defaultUnit: $7ac87cf2c1708f51$var$getJiraTimeUnit(globalTimeTrackingSettings.defaultUnit),
            timeFormat: $7ac87cf2c1708f51$var$getJiraTimeFormat(globalTimeTrackingSettings.defaultFormat)
        }
    };
    return transformedConfig;
};
const $7ac87cf2c1708f51$export$c44fc4642496cd94 = (card, projectAri)=>({
        summary: card.summary,
        id: Number((0, $f01qr.getIdFromAri)(card.id)),
        key: card.key,
        labels: card.labels.filter(Boolean),
        assignee: card.assignee ? {
            id: card.assignee.accountId,
            displayName: card.assignee.name,
            avatarUrl: card.assignee.picture
        } : null,
        icon: card.type.iconUrl,
        isDone: card.done,
        isFlagged: card.flagged,
        typeId: Number(card.type.id),
        issueUrl: `/browse/${card.key}`,
        statusId: card.status.id,
        parentId: card.parentId ? Number((0, $f01qr.getIdFromAri)(card.parentId)) : null,
        priority: card.priority ? {
            name: card.priority.name,
            iconUrl: card.priority.iconUrl
        } : null,
        // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
        dueDate: card.dueDate,
        // @ts-expect-error - Type '{ timeRemainingEstimate: null; originalEstimate: { readonly value: number; readonly valueAsText: string; } | null | undefined; storyPoints: number | null | undefined; } | null' is not assignable to type 'CardEstimate | null'.
        estimate: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(card.estimate) ? null : {
            ...card.estimate,
            timeRemainingEstimate: null
        },
        numCompleteChildren: card.childCardsMetadata ? card.childCardsMetadata.complete : 0,
        numTotalChildren: card.childCardsMetadata ? card.childCardsMetadata.total : 0,
        fixVersions: card.fixVersionsIds.concat(),
        projectId: Number((0, $f01qr.getIdFromAri)(projectAri))
    });
const $7ac87cf2c1708f51$export$56ea715ea3d97dee = (cardParents)=>cardParents.reduce((issueParentsEntityState, cardParent)=>{
        const cardId = (0, $f01qr.getIdFromAri)(cardParent.id);
        const { key: key, summary: summary, cardType: cardType } = cardParent;
        return Object.assign(issueParentsEntityState, {
            [cardId]: {
                id: cardId,
                key: key,
                summary: summary,
                color: cardParent.color ? String(cardParent.color) : null,
                issueType: {
                    id: cardType.id,
                    name: cardType.name,
                    iconUrl: cardType.iconUrl
                }
            }
        });
    }, {});
const $7ac87cf2c1708f51$export$f96dae738e4d5e19 = (isEstimationEnabled, estimation)=>{
    const estimateFieldKey = estimation.current.customFieldId || '';
    if (isEstimationEnabled && estimateFieldKey) return estimateFieldKey === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) ? (0, $guzeq.ORIGINAL_ESTIMATE) : (0, $guzeq.STORY_POINTS);
    return 0, $guzeq.ISSUE_COUNT;
};
const $7ac87cf2c1708f51$export$6b3f2edb57acc06e = (isEstimationEnabled, estimation)=>// @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
    isEstimationEnabled ? estimation.current.customFieldId : null;
const $7ac87cf2c1708f51$export$3bf59b7c6d7e91d9 = (features, estimation)=>{
    const isEstimationFeatureEnabled = $7ac87cf2c1708f51$var$isFeatureEnabled(features, (0, $0b986b66d9bedfde$export$4181c6622414bfdf));
    return {
        isEstimationFeatureEnabled: isEstimationFeatureEnabled,
        estimationType: $7ac87cf2c1708f51$export$f96dae738e4d5e19(isEstimationFeatureEnabled, estimation),
        estimationFieldId: $7ac87cf2c1708f51$export$6b3f2edb57acc06e(isEstimationFeatureEnabled, estimation),
        name: ''
    };
};
const $7ac87cf2c1708f51$export$4055277b2f3e701f = ({ id: id, name: name, goal: goal, startDate: startDate, endDate: endDate, daysRemaining: daysRemaining, sprintState: sprintState }, canUpdateSprint)=>({
        id: (0, $f01qr.getIdFromAri)(id),
        name: name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: goal || '',
            startDate: startDate || '',
            endDate: endDate || '',
            daysRemaining: daysRemaining || 0,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            state: String(sprintState) || (0, $guzeq.SPRINT_STATE_FUTURE),
            canUpdateSprint: canUpdateSprint
        }
    });
const $7ac87cf2c1708f51$export$cfeec69489a32e7d = (allCards)=>({
        versions: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))(allCards).reduce((fixVersions, card)=>card.fixVersions && card.fixVersions.length > 0 ? fixVersions.concat(card.fixVersions) : fixVersions, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []))
    });
const $7ac87cf2c1708f51$var$projectTransformer = (projectLocation)=>({
        projects: [
            {
                id: Number((0, $f01qr.getIdFromAri)(projectLocation.id)),
                isSimplified: true,
                key: projectLocation.key,
                name: projectLocation.name
            }
        ]
    });
const $7ac87cf2c1708f51$var$backlogOnlyTransformer = (data)=>{
    const { backlog: backlog, board: board, cardParents: cardParents, features: features, estimation: estimation, projectLocation: { id: projectAri, cardTypes: cardTypes } } = data.boardScope;
    if (!backlog) throw new Error('boardScope.backlog is null');
    const boardCards = board.cards.filter(Boolean);
    const backlogCards = backlog.cards.filter(Boolean);
    const cards = backlogCards.concat(boardCards);
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredCardParents = cardParents.filter(Boolean);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>(0, $f01qr.getIdFromAri)(id)), cards.map((cardData)=>$7ac87cf2c1708f51$export$c44fc4642496cd94(cardData, projectAri)));
    return {
        entities: {
            cardList: {
                [(0, $guzeq.BOARD)]: {
                    id: (0, $guzeq.BOARD),
                    type: (0, $guzeq.BOARD),
                    name: 'Board',
                    issueListKey: backlog.boardIssueListKey
                },
                [(0, $guzeq.BACKLOG)]: $7ac87cf2c1708f51$var$BACKLOG_LIST
            },
            cardListOrder: [
                (0, $guzeq.BOARD),
                (0, $guzeq.BACKLOG)
            ],
            card: card,
            cardTypes: $7ac87cf2c1708f51$var$cardTypesTransformer(cardTypes.filter(Boolean)),
            cardOrder: {
                [(0, $guzeq.BOARD)]: boardCards.map(({ id: id })=>Number((0, $f01qr.getIdFromAri)(id))),
                [(0, $guzeq.BACKLOG)]: backlogCards.map(({ id: id })=>Number((0, $f01qr.getIdFromAri)(id)))
            },
            issueParents: $7ac87cf2c1708f51$export$56ea715ea3d97dee(filteredCardParents),
            issueParentsOrder: filteredCardParents.map(({ id: id })=>(0, $f01qr.getIdFromAri)(id)),
            estimation: $7ac87cf2c1708f51$export$3bf59b7c6d7e91d9(filteredFeatures, estimation),
            version: $7ac87cf2c1708f51$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: cardTypes.filter(Boolean).map((it)=>Number(it.id))
            },
            project: $7ac87cf2c1708f51$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $7ac87cf2c1708f51$export$69760b7e76c533f9(data)
    };
};
const $7ac87cf2c1708f51$var$backlogWithSprintsTransformer = (data)=>{
    const { currentUser: { permissions: permissions }, sprints: sprints, backlog: backlog, cardParents: cardParents, features: features, estimation: estimation, projectLocation: { id: projectId, cardTypes: cardTypes } } = data.boardScope;
    if (!backlog) throw new Error('boardScope.backlog is null');
    const filteredBacklogCards = backlog.cards.filter(Boolean);
    const filteredCardParents = cardParents.filter(Boolean);
    const filteredFeatures = features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    const filteredSprints = sprints.filter(Boolean);
    const canUpdateSprint = permissions.map(String).includes((0, $guzeq.MANAGE_SPRINT));
    const cardList = {
        [(0, $guzeq.BACKLOG)]: $7ac87cf2c1708f51$var$BACKLOG_LIST
    };
    const cardListOrder = [];
    const cardOrder = {
        [(0, $guzeq.BACKLOG)]: filteredBacklogCards.map(({ id: id })=>Number((0, $f01qr.getIdFromAri)(id)))
    };
    let cards = [];
    filteredSprints.forEach((sprint)=>{
        const sprintId = (0, $f01qr.getIdFromAri)(sprint.id);
        const sprintCards = sprint.cards.filter(Boolean);
        cardList[sprintId] = $7ac87cf2c1708f51$export$4055277b2f3e701f(sprint, canUpdateSprint);
        cardListOrder.push(sprintId);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ BACKLOG: any[]; }'.
        cardOrder[sprintId] = sprintCards.map(({ id: id })=>Number((0, $f01qr.getIdFromAri)(id)));
        cards = cards.concat(sprintCards);
    });
    cardListOrder.push((0, $guzeq.BACKLOG));
    cards = cards.concat(filteredBacklogCards);
    const card = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cards.map(({ id: id })=>(0, $f01qr.getIdFromAri)(id)), cards.map((cardData)=>$7ac87cf2c1708f51$export$c44fc4642496cd94(cardData, projectId)));
    return {
        entities: {
            cardList: cardList,
            cardListOrder: cardListOrder,
            card: card,
            cardTypes: $7ac87cf2c1708f51$var$cardTypesTransformer(cardTypes.filter(Boolean)),
            cardOrder: cardOrder,
            issueParents: $7ac87cf2c1708f51$export$56ea715ea3d97dee(cardParents.filter(Boolean)),
            issueParentsOrder: filteredCardParents.map(({ id: id })=>(0, $f01qr.getIdFromAri)(id)),
            estimation: $7ac87cf2c1708f51$export$3bf59b7c6d7e91d9(filteredFeatures, estimation),
            version: $7ac87cf2c1708f51$export$cfeec69489a32e7d(card),
            inlineCreate: {
                cardTypeIds: cardTypes.filter(Boolean).map((it)=>Number(it.id))
            },
            project: $7ac87cf2c1708f51$var$projectTransformer(data.boardScope.projectLocation)
        },
        config: $7ac87cf2c1708f51$export$69760b7e76c533f9(data)
    };
};
const $7ac87cf2c1708f51$export$184ba826956cb720 = (data)=>{
    const filteredFeatures = data.boardScope.features.filter(Boolean).map(({ key: key, status: status })=>({
            key: String(key),
            status: String(status)
        }));
    if ($7ac87cf2c1708f51$var$isFeatureEnabled(filteredFeatures, (0, $0b986b66d9bedfde$export$4279f6f79febea0a))) return $7ac87cf2c1708f51$var$backlogWithSprintsTransformer(data);
    return $7ac87cf2c1708f51$var$backlogOnlyTransformer(data);
};

});
parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$export$a4982fdb1458274 = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$export$a4982fdb1458274 * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});




parcelRegister("vO8Pq", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfigEpic", () => $a55a2bbb1993897a$export$8772c54f1f4570e1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $2AULr = parcelRequire("2AULr");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");
const $a55a2bbb1993897a$export$8772c54f1f4570e1 = (action$, store, dependencies)=>action$.ofType((0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_REQUEST), (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)).flatMap((action)=>{
        const state = store.getState();
        const jqlQuery = action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS) ? action.payload.config.jqlQuery : (0, $jG5HW.getJqlQuery)(state) || '';
        const analyticsEvent = dependencies && dependencies.createAnalyticsEvent ? dependencies.createAnalyticsEvent({
            action: 'load',
            actionSubject: 'cardCreateConfig'
        }) : undefined;
        return (0, $2AULr.default)(jqlQuery).map((cardConfigResponse)=>(0, $3lZ6i.loadCardCreateConfigSuccess)(cardConfigResponse, analyticsEvent)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-card-create-config.failure', 'Failed to load card create config from REST', error);
            return (0, $kVLXA.Observable).of((0, $3lZ6i.loadCardCreateConfigFailure)(error, analyticsEvent));
        });
    });

});
parcelRegister("2AULr", function(module, exports) {

$parcel$export(module.exports, "default", () => $636153f632b2190a$export$2e2bcd8739ae039);

var $g4tDr = parcelRequire("g4tDr");

var $bJTER = parcelRequire("bJTER");
parcelRequire("d0pqD");
const $636153f632b2190a$export$6b468dcfb64c653c = (response)=>{
    if (!response.issueTypes.successful) return {
        cardTypes: []
    };
    return {
        cardTypes: response.issueTypes.values.map((issueType)=>({
                id: Number(issueType.id),
                name: issueType.name,
                iconUrl: issueType.iconUrl,
                hasRequiredFields: null,
                typeHierarchyLevel: (0, $g4tDr.getHierarchyLevelTypeSplitEpicFromCustom)(issueType.hierarchyLevel)
            }))
    };
};
const $636153f632b2190a$var$loadCardCreateConfigService = (jqlQuery)=>(0, $bJTER.loadCardCreateConfig)(jqlQuery).map($636153f632b2190a$export$6b468dcfb64c653c);
var $636153f632b2190a$export$2e2bcd8739ae039 = $636153f632b2190a$var$loadCardCreateConfigService;

});
parcelRegister("bJTER", function(module, exports) {

$parcel$export(module.exports, "loadCardCreateConfig", () => $6e699de5e1bddbb9$export$149bf88f2a958c35);

var $ebyGx = parcelRequire("ebyGx");

var $487fd = parcelRequire("487fd");
function $6e699de5e1bddbb9$export$149bf88f2a958c35(jqlQuery) {
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        query: jqlQuery
    });
    return (0, $487fd.default)(`/rest/inline-create/1.0/context/bootstrap?${query}`);
}

});



parcelRegister("41ack", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpic", () => $c18b672f1c28d11e$export$cc32ef09edf2b5cb);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $j6Jic = parcelRequire("j6Jic");

var $GtqoM = parcelRequire("GtqoM");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $cPahM = parcelRequire("cPahM");
const $c18b672f1c28d11e$export$cc32ef09edf2b5cb = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $kVLXA.Observable).forkJoin((0, $GtqoM.default)((0, $i4Z8q.makeServiceContext)(store.getState())), (0, $j6Jic.default)(store))).mergeMap(([{ entities: entities, config: config, columns: columns }, additionalBoardData])=>(0, $kVLXA.Observable).from([
            (0, $3lZ6i.setConfigData)((0, $7uUwQ.merge)({
                entities: entities,
                config: config
            }, additionalBoardData)),
            (0, $3lZ6i.loadConfigDataSuccess)(),
            (0, $cPahM.setColumns)(columns)
        ])).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-config-data.failure', 'Failed to load config data', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataFailure)());
    });

});
parcelRegister("j6Jic", function(module, exports) {

$parcel$export(module.exports, "default", () => $1244acb31847e756$export$2e2bcd8739ae039);
parcelRequire("d0pqD");


var $7ZKYz = parcelRequire("7ZKYz");

var $jG5HW = parcelRequire("jG5HW");
const $1244acb31847e756$export$6b468dcfb64c653c = (response, isCompanyManaged)=>({
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $a33d0dff7e784665$export$a20ec683078f5f77)]: response.canDeleteIssues
            } : {},
            isInlineCardCreateEnabled: response.isInlineCardCreateEnabled
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1244acb31847e756$export$2e2bcd8739ae039 = (store)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    return (0, $7ZKYz.default)(baseUrl, rapidViewId).map((response)=>$1244acb31847e756$export$6b468dcfb64c653c(response, isCompanyManaged));
};

});
parcelRegister("7ZKYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $87a0bf6efd4bc3c8$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87a0bf6efd4bc3c8$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $487fd.default)(`${baseUrl}/rest/greenhopper/1.0/xboard/work/additionalBoardData?rapidViewId=${rapidViewId}`);

});


parcelRegister("GtqoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55220375b735463$export$2e2bcd8739ae039);

var $sLb2Q = parcelRequire("sLb2Q");
parcelRequire("d0pqD");

var $gBj4V = parcelRequire("gBj4V");


var $guzeq = parcelRequire("guzeq");

var $cNe1c = parcelRequire("cNe1c");
const $d55220375b735463$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $guzeq.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $guzeq.ISSUE_COUNT_ID);
    return (0, $guzeq.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $guzeq.ISSUE_COUNT);
};
const $d55220375b735463$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response?.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $d55220375b735463$var$transformEstimationType(response),
        estimationFieldId: response?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response?.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $d55220375b735463$export$6b468dcfb64c653c = (resp, isCompanyManaged = false)=>({
        entities: {
            estimation: $d55220375b735463$var$transformEstimation(resp),
            quickFilters: resp?.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            permissions: !isCompanyManaged ? {
                [(0, $a33d0dff7e784665$export$b35e3ebf2c83a499)]: resp.canEdit
            } : {},
            backlogStrategy: resp.backlogStrategy,
            epicIssueType: resp?.globalConfig?.epicConfig?.epicIssueTypeId ? {
                id: resp?.globalConfig?.epicConfig?.epicIssueTypeId,
                name: resp?.globalConfig?.epicConfig?.epicIssueTypeName,
                iconUrl: resp?.globalConfig?.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: resp?.globalConfig?.epicConfig?.epicLinkFieldId ? {
                id: resp?.globalConfig?.epicConfig?.epicLinkFieldId,
                name: resp?.globalConfig?.epicConfig?.epicLinkFieldName
            } : null,
            ...isCompanyManaged ? {
                name: resp.name,
                storyPointFieldId: resp?.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                sprintFieldId: resp?.globalConfig?.sprintConfig?.sprintFieldId,
                timeTrackingOptions: {
                    workingHoursPerDay: resp?.globalConfig?.timeTrackingConfig?.hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: resp?.globalConfig?.timeTrackingConfig?.daysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: resp?.globalConfig?.timeTrackingConfig?.timeFormat || (0, $gBj4V.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    resp?.globalConfig?.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $gBj4V.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: resp?.filterConfig?.query,
            isOrderedByRank: resp?.filterConfig?.isOrderedByRank,
            isBoardCrossProject: resp.isBoardCrossProject,
            parallelSprints: resp.globalConfig.parallelSprints,
            showEpicAsPanel: resp.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(resp.rapidListConfig.mappedColumns.map((column)=>column.id), resp.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d55220375b735463$export$2e2bcd8739ae039 = (serviceContext)=>(0, $cNe1c.default)(serviceContext.boardId).map((response)=>$d55220375b735463$export$6b468dcfb64c653c(response, serviceContext.isCompanyManaged));

});
parcelRegister("cNe1c", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a451a4424baaf29$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a451a4424baaf29$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $487fd.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel?rapidViewId=${rapidViewId}`);

});


parcelRegister("cPahM", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMNS", () => $48820c1d307941ee$export$f7b453d5c91bc422);
$parcel$export(module.exports, "setColumns", () => $48820c1d307941ee$export$cfc099c0be5cff67);
const $48820c1d307941ee$export$f7b453d5c91bc422 = 'state.actions.columns.SET_COLUMNS';
const $48820c1d307941ee$export$cfc099c0be5cff67 = (columns)=>({
        type: $48820c1d307941ee$export$f7b453d5c91bc422,
        payload: {
            columns: columns
        }
    });

});


parcelRegister("9Vyzy", function(module, exports) {

$parcel$export(module.exports, "loadConfigDataEpicCmp", () => $0180c36fc9d74144$export$6c9a22a434be99a2);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $8UYjN = parcelRequire("8UYjN");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");
const $0180c36fc9d74144$export$6c9a22a434be99a2 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST)).mergeMap(()=>(0, $8UYjN.default)((0, $i4Z8q.makeServiceContext)(store.getState()))).mergeMap((response)=>(0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataModelSuccess)(response))).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-config-data-cmp.failure', 'Failed to load config data for CMP', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadConfigDataFailure)());
    });

});
parcelRegister("8UYjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c678f0380b48c4d6$export$2e2bcd8739ae039);

var $sLb2Q = parcelRequire("sLb2Q");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("d0pqD");

var $gBj4V = parcelRequire("gBj4V");

var $guzeq = parcelRequire("guzeq");

var $710AE = parcelRequire("710AE");

var $bDQw3 = parcelRequire("bDQw3");
const $c678f0380b48c4d6$var$transformEstimationType = (resp)=>{
    const currentStatisticFieldPrefix = (0, $guzeq.statisticFieldPrefixes).find((statisticFieldPrefix)=>resp?.estimationStatisticConfig?.currentEstimationStatistic?.id?.startsWith(statisticFieldPrefix) ?? false) ?? (0, $guzeq.ISSUE_COUNT_ID);
    return (0, $guzeq.statisticFieldToEstimateType)[currentStatisticFieldPrefix] ?? (0, $guzeq.ISSUE_COUNT);
};
const $c678f0380b48c4d6$var$transformEstimation = (response)=>({
        isEstimationFeatureEnabled: response.estimationStatisticConfig?.currentEstimationStatistic?.isEnabled ?? false,
        estimationType: $c678f0380b48c4d6$var$transformEstimationType(response),
        estimationFieldId: response.estimationStatisticConfig?.currentEstimationStatistic?.fieldId ?? null,
        name: response.estimationStatisticConfig?.currentEstimationStatistic?.name ?? ''
    });
const $c678f0380b48c4d6$var$transformTracking = (response)=>({
        isEnabled: response.trackingStatisticConfig?.currentTrackingStatistic.isEnabled ?? false,
        typeId: response.trackingStatisticConfig?.currentTrackingStatistic.typeId ?? '',
        fieldId: response.trackingStatisticConfig?.currentTrackingStatistic.fieldId ?? '',
        isValid: response.trackingStatisticConfig?.currentTrackingStatistic.isValid ?? false,
        name: response.trackingStatisticConfig?.currentTrackingStatistic.name ?? ''
    });
const $c678f0380b48c4d6$export$6b468dcfb64c653c = (boardConfig, globalConfig, isCompanyManaged = false)=>({
        entities: {
            estimation: $c678f0380b48c4d6$var$transformEstimation(boardConfig),
            ...isCompanyManaged ? {
                tracking: $c678f0380b48c4d6$var$transformTracking(boardConfig)
            } : {},
            quickFilters: boardConfig.quickFilterConfig?.quickFilters?.map((f)=>({
                    ...f,
                    id: String(f.id)
                })) ?? []
        },
        config: {
            isInlineCardCreateEnabled: boardConfig.isInlineCardCreateEnabled,
            backlogStrategy: boardConfig.backlogStrategy,
            epicIssueType: globalConfig.epicConfig?.epicIssueTypeId ? {
                id: globalConfig.epicConfig?.epicIssueTypeId,
                name: globalConfig.epicConfig?.epicIssueTypeName,
                iconUrl: globalConfig.epicConfig?.epicIssueTypeIconUrl
            } : null,
            epicLinkField: globalConfig.epicConfig?.epicLinkFieldId ? {
                id: globalConfig.epicConfig?.epicLinkFieldId,
                name: globalConfig.epicConfig?.epicLinkFieldName
            } : null,
            ...isCompanyManaged ? {
                name: boardConfig.name,
                epicColorFieldId: globalConfig?.epicConfig?.colorFieldId,
                storyPointFieldId: boardConfig.estimationStatisticConfig?.currentEstimationStatistic?.fieldId || null,
                sprintFieldId: globalConfig.sprintConfig?.sprintFieldId,
                timeTrackingOptions: {
                    workingHoursPerDay: globalConfig.timeTrackingConfig?.hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
                    workingDaysPerWeek: globalConfig.timeTrackingConfig?.daysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
                    timeFormat: globalConfig.timeTrackingConfig?.timeFormat || (0, $gBj4V.TimeFormats).PRETTY,
                    defaultUnit: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    globalConfig.timeTrackingConfig?.defaultUnit?.toLowerCase() || (0, $gBj4V.TimeUnits).MINUTE
                }
            } : undefined,
            jqlQuery: boardConfig.filterConfig?.query,
            isOrderedByRank: boardConfig.filterConfig?.isOrderedByRank,
            isBoardCrossProject: boardConfig.isBoardCrossProject,
            parallelSprints: boardConfig.parallelSprints,
            showEpicAsPanel: boardConfig.showEpicAsPanel
        },
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(boardConfig.rapidListConfig.mappedColumns.map((column)=>column.id), boardConfig.rapidListConfig.mappedColumns.map((column, index)=>({
                id: column.id,
                name: column.name,
                order: index,
                statuses: column.mappedStatuses.map((status)=>({
                        id: status.id,
                        name: status.name,
                        isInitial: status.isInitial,
                        isResolutionDone: status.isResolutionDone,
                        category: status.statusCategory.key
                    }))
            })))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c678f0380b48c4d6$export$2e2bcd8739ae039 = (serviceContext)=>(0, $kVLXA.Observable).forkJoin((0, $710AE.default)(serviceContext.boardId), (0, $bDQw3.default)()).map(([boardConfigResponse, globalConfigResponse])=>$c678f0380b48c4d6$export$6b468dcfb64c653c(boardConfigResponse, globalConfigResponse, serviceContext.isCompanyManaged));

});
parcelRegister("710AE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5ac5d6c5c6afa1a$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5ac5d6c5c6afa1a$export$2e2bcd8739ae039 = (rapidViewId)=>(0, $487fd.default)(`/rest/greenhopper/3/xboard/config?boardId=${rapidViewId}`);

});

parcelRegister("bDQw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c783422664db1d4c$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c783422664db1d4c$export$2e2bcd8739ae039 = ()=>(0, $487fd.default)('/rest/greenhopper/3/globalconfig');

});



parcelRegister("1fqjN", function(module, exports) {

$parcel$export(module.exports, "loadCurrentUserEpic", () => $aae03fc097f92e2d$export$9ce838b1f98e9002);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("1oQta");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $f4Hvj = parcelRequire("f4Hvj");

var $bI3co = parcelRequire("bI3co");

var $jG5HW = parcelRequire("jG5HW");
const $aae03fc097f92e2d$export$9ce838b1f98e9002 = (action$, store)=>action$.ofType((0, $bI3co.REQUEST_CURRENT_USER)).map(()=>(0, $jG5HW.getAtlassianAccountId)(store.getState())).filter((accountId)=>accountId !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .mergeMap((accountId)=>(0, $f4Hvj.default)(store, accountId)).map((appData)=>(0, $bI3co.setCurrentUser)(appData)).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-current-user.failure', 'Failed to load current user data', error);
        // no error flag, as this data is not critical for application
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("f4Hvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec88a097577de3f$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $g6xSt = parcelRequire("g6xSt");

var $jG5HW = parcelRequire("jG5HW");
const $dec88a097577de3f$export$6b468dcfb64c653c = (response)=>({
        id: response.accountId,
        displayName: response.displayName,
        avatarUrl: response.avatarUrls['48x48']
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dec88a097577de3f$export$2e2bcd8739ae039 = (store, accountId)=>{
    const state = store.getState();
    const baseUrl = (0, $jG5HW.getBaseUrl)(state);
    return (0, $g6xSt.default)(baseUrl, accountId).map($dec88a097577de3f$export$6b468dcfb64c653c);
};

});
parcelRegister("g6xSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e11ce5ad8ea8f2$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$66e11ce5ad8ea8f2$export$2e2bcd8739ae039 = (baseUrl, accountId)=>(0, $487fd.default)(`${baseUrl}/rest/api/2/user?accountId=${accountId}`);

});


parcelRegister("bI3co", function(module, exports) {

$parcel$export(module.exports, "REQUEST_CURRENT_USER", () => $985a85ff9b223813$export$23c24718e49aca5d);
$parcel$export(module.exports, "SET_CURRENT_USER", () => $985a85ff9b223813$export$c6dfa1844d1d3b74);
$parcel$export(module.exports, "requestCurrentUser", () => $985a85ff9b223813$export$96fd75d854a9dd1);
$parcel$export(module.exports, "setCurrentUser", () => $985a85ff9b223813$export$64e99e757b084e7c);
const $985a85ff9b223813$export$23c24718e49aca5d = 'state.actions.user.REQUEST_CURRENT_USER';
const $985a85ff9b223813$export$c6dfa1844d1d3b74 = 'state.actions.user.SET_CURRENT_USER';
const $985a85ff9b223813$export$96fd75d854a9dd1 = ()=>({
        type: $985a85ff9b223813$export$23c24718e49aca5d
    });
const $985a85ff9b223813$export$64e99e757b084e7c = (payload)=>({
        type: $985a85ff9b223813$export$c6dfa1844d1d3b74,
        payload: payload
    });

});


parcelRegister("hcyWF", function(module, exports) {

$parcel$export(module.exports, "loadIssueParentsEpic", () => $1485a400a103d00e$export$62d699ac6a7d88af);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $j9Xjk = parcelRequire("j9Xjk");

var $3lZ6i = parcelRequire("3lZ6i");

var $aCC3Y = parcelRequire("aCC3Y");

var $jG5HW = parcelRequire("jG5HW");
const $1485a400a103d00e$var$logFailureKey = 'backlog.load-issue-parents.failure';
const $1485a400a103d00e$export$62d699ac6a7d88af = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST)).flatMap(()=>{
        const state = store.getState();
        const boardId = (0, $jG5HW.getRapidViewId)(state);
        return (0, $j9Xjk.default)(boardId).map((0, $aCC3Y.loadIssueParentsSuccess)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData($1485a400a103d00e$var$logFailureKey, 'Failed to load issue parents from REST', error);
            return (0, $kVLXA.Observable).of((0, $aCC3Y.loadIssueParentsFailure)());
        });
    });

});
parcelRegister("j9Xjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e7ac0e2dbc3db0$export$2e2bcd8739ae039);

var $iHPnC = parcelRequire("iHPnC");

var $iNZ7n = parcelRequire("iNZ7n");
parcelRequire("d0pqD");
const $90e7ac0e2dbc3db0$export$6b468dcfb64c653c = (response)=>response.epics.values.map(({ id: id, key: key, summary: summary, issueTypeDetails: issueTypeDetails, color: color, epicColor: epicColor })=>({
            id: String(id),
            key: key,
            summary: summary,
            issueType: {
                id: issueTypeDetails.id,
                name: issueTypeDetails.name,
                iconUrl: issueTypeDetails.iconUrl
            },
            color: (0, $iHPnC.asColor)(color || epicColor)
        }));
const $90e7ac0e2dbc3db0$var$loadEpicsService = (boardId)=>(0, $iNZ7n.loadIssueParents)(boardId).map($90e7ac0e2dbc3db0$export$6b468dcfb64c653c);
var $90e7ac0e2dbc3db0$export$2e2bcd8739ae039 = $90e7ac0e2dbc3db0$var$loadEpicsService;

});
parcelRegister("iNZ7n", function(module, exports) {

$parcel$export(module.exports, "loadIssueParents", () => $1746a478439ff793$export$ff3ebd776b98f924);

var $487fd = parcelRequire("487fd");
function $1746a478439ff793$export$ff3ebd776b98f924(boardId) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/plan/v2/backlog/epics.json?rapidViewId=${boardId}`);
}

});


parcelRegister("aCC3Y", function(module, exports) {

$parcel$export(module.exports, "LOAD_ISSUE_PARENTS_SUCCESS", () => $078bf955f0868777$export$c4816ca6503594af);
$parcel$export(module.exports, "loadIssueParentsSuccess", () => $078bf955f0868777$export$690a91ea1d3856a7);
$parcel$export(module.exports, "loadIssueParentsFailure", () => $078bf955f0868777$export$a69a6037d2ab7dc4);
const $078bf955f0868777$export$c4816ca6503594af = 'state.actions.app.LOAD_ISSUE_PARENTS_SUCCESS';
const $078bf955f0868777$export$690a91ea1d3856a7 = (issueParents)=>({
        type: $078bf955f0868777$export$c4816ca6503594af,
        payload: {
            issueParents: issueParents
        }
    });
const $078bf955f0868777$export$10fa8c4c0ecf4112 = 'state.actions.app.LOAD_ISSUE_PARENTS_FAILURE';
const $078bf955f0868777$export$a69a6037d2ab7dc4 = ()=>({
        type: $078bf955f0868777$export$10fa8c4c0ecf4112
    });

});


parcelRegister("cZpfH", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsEpic", () => $3813d671af33e4d2$export$f7fed3a68920cb18);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $ihDIX = parcelRequire("ihDIX");

var $3lZ6i = parcelRequire("3lZ6i");

var $fNaAq = parcelRequire("fNaAq");

var $jG5HW = parcelRequire("jG5HW");
const $3813d671af33e4d2$var$loadPermissions = ({ store: store })=>{
    const state = store.getState();
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    return (0, $ihDIX.loadPermissionsService)(boardId).map((0, $fNaAq.fetchPermissionsSuccess)).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-permission.failure', 'Failed to fetch permissions for Company-Managed backlog', error);
        return (0, $kVLXA.Observable).of((0, $fNaAq.fetchPermissionsFailure)());
    });
};
const $3813d671af33e4d2$export$f7fed3a68920cb18 = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(()=>$3813d671af33e4d2$var$loadPermissions({
            store: store
        }));

});
parcelRegister("ihDIX", function(module, exports) {

$parcel$export(module.exports, "loadPermissionsService", () => $ad5d17ab0b633e4f$export$4c653019d1c2f19f);
parcelRequire("d0pqD");

var $jA1Dj = parcelRequire("jA1Dj");

var $dJc1e = parcelRequire("dJc1e");

var $3E9ii = parcelRequire("3E9ii");
const $ad5d17ab0b633e4f$var$toBacklogPermissions = (response)=>(0, $jA1Dj.fromServicePermission)(response.boardPermissions);
const $ad5d17ab0b633e4f$export$4c653019d1c2f19f = (boardId)=>(0, $3E9ii.fetchPermissions)(boardId, (0, $dJc1e.getDefaultCompanyManagedPermissions)()).map($ad5d17ab0b633e4f$var$toBacklogPermissions);

});
parcelRegister("jA1Dj", function(module, exports) {

$parcel$export(module.exports, "fromServicePermission", () => $48c50d3a40c621b4$export$b37c57dce4c43c62);

var $cuHs1 = parcelRequire("cuHs1");

var $co1wz = parcelRequire("co1wz");

var $guzeq = parcelRequire("guzeq");

const $48c50d3a40c621b4$var$serviceToBacklogPermissionsOld = {
    [(0, $guzeq.VIEW_BOARD)]: (0, $a33d0dff7e784665$export$feb9a4de117c162),
    [(0, $guzeq.ADMINISTER_BOARD)]: (0, $a33d0dff7e784665$export$b35e3ebf2c83a499),
    [(0, $guzeq.BULK_CHANGE)]: (0, $a33d0dff7e784665$export$a71edb30f3453bef),
    [(0, $guzeq.MANAGE_SPRINT)]: (0, $a33d0dff7e784665$export$d765836bd761b2ee),
    [(0, $guzeq.CREATE_ISSUE)]: (0, $a33d0dff7e784665$export$526c94c551c00291),
    [(0, $guzeq.EDIT_ISSUE)]: (0, $a33d0dff7e784665$export$8a1ecb9983951227),
    [(0, $guzeq.DELETE_ISSUE)]: (0, $a33d0dff7e784665$export$a20ec683078f5f77),
    [(0, $guzeq.ASSIGN_ISSUE)]: (0, $a33d0dff7e784665$export$9c0523cef5fab15e),
    [(0, $guzeq.TRANSITION_ISSUE)]: (0, $a33d0dff7e784665$export$b5f3bd28b6a935be)
};
const $48c50d3a40c621b4$var$serviceToBacklogPermissionsNew = {
    [(0, $guzeq.VIEW_BOARD)]: (0, $a33d0dff7e784665$export$feb9a4de117c162),
    [(0, $guzeq.ADMINISTER_BOARD)]: (0, $a33d0dff7e784665$export$b35e3ebf2c83a499),
    [(0, $guzeq.BULK_CHANGE)]: (0, $a33d0dff7e784665$export$a71edb30f3453bef),
    [(0, $guzeq.MANAGE_SPRINT)]: (0, $a33d0dff7e784665$export$d765836bd761b2ee),
    [(0, $guzeq.CREATE_ISSUE)]: (0, $a33d0dff7e784665$export$526c94c551c00291),
    [(0, $guzeq.EDIT_ISSUE)]: (0, $a33d0dff7e784665$export$8a1ecb9983951227),
    [(0, $guzeq.DELETE_ISSUE)]: (0, $a33d0dff7e784665$export$a20ec683078f5f77),
    [(0, $guzeq.ASSIGN_ISSUE)]: (0, $a33d0dff7e784665$export$9c0523cef5fab15e),
    [(0, $guzeq.TRANSITION_ISSUE)]: (0, $a33d0dff7e784665$export$b5f3bd28b6a935be),
    [(0, $guzeq.ARCHIVE_ISSUE)]: (0, $a33d0dff7e784665$export$e6bcada406923d66)
};
const $48c50d3a40c621b4$export$b37c57dce4c43c62 = (permissions)=>{
    const serviceToBacklogPermissions = (0, $co1wz.ff)('issue-unarchival_wdpb9') ? $48c50d3a40c621b4$var$serviceToBacklogPermissionsNew : $48c50d3a40c621b4$var$serviceToBacklogPermissionsOld;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))(permissions, (value, key)=>serviceToBacklogPermissions[key]);
};

});

parcelRegister("dJc1e", function(module, exports) {

$parcel$export(module.exports, "getDefaultCompanyManagedPermissions", () => $f3e48a17e0e8f0b7$export$125a09606aa6423a);

var $guzeq = parcelRequire("guzeq");
const $f3e48a17e0e8f0b7$export$125a09606aa6423a = ()=>[
        (0, $guzeq.VIEW_BOARD),
        (0, $guzeq.ADMINISTER_BOARD),
        (0, $guzeq.BULK_CHANGE),
        (0, $guzeq.DELETE_ISSUE),
        (0, $guzeq.EDIT_ISSUE),
        (0, $guzeq.CREATE_ISSUE),
        (0, $guzeq.ASSIGN_ISSUE),
        (0, $guzeq.TRANSITION_ISSUE),
        (0, $guzeq.MANAGE_SPRINT)
    ];

});

parcelRegister("3E9ii", function(module, exports) {

$parcel$export(module.exports, "fetchPermissions", () => $6d5301b501e92c7f$export$4f24ecba11982e9d);

var $487fd = parcelRequire("487fd");
function $6d5301b501e92c7f$export$4f24ecba11982e9d(boardId, permissions = []) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/permissions?boardId=${boardId}&permissions=${permissions.join(',')}`);
}

});


parcelRegister("fNaAq", function(module, exports) {

$parcel$export(module.exports, "FETCH_PERMISSIONS_SUCCESS", () => $b2cf0d2beefc4c2b$export$ba150518109978de);
$parcel$export(module.exports, "fetchPermissionsSuccess", () => $b2cf0d2beefc4c2b$export$9ea81e209e5fa95a);
$parcel$export(module.exports, "fetchPermissionsFailure", () => $b2cf0d2beefc4c2b$export$81c33c1b0d6e16b1);
const $b2cf0d2beefc4c2b$export$ba150518109978de = 'state.actions.permissions.FETCH_PERMISSIONS_SUCCESS';
const $b2cf0d2beefc4c2b$export$9ea81e209e5fa95a = (permissions)=>({
        type: $b2cf0d2beefc4c2b$export$ba150518109978de,
        payload: {
            permissions: permissions
        }
    });
const $b2cf0d2beefc4c2b$export$87e65d60f042b0d0 = 'state.actions.permissions.FETCH_PERMISSIONS_FAILURE';
const $b2cf0d2beefc4c2b$export$81c33c1b0d6e16b1 = ()=>({
        type: $b2cf0d2beefc4c2b$export$87e65d60f042b0d0
    });

});


parcelRegister("3l3iU", function(module, exports) {

$parcel$export(module.exports, "loadPlanDataEpic", () => $3782687796b171ac$export$e0e3208a5652318a);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("93e44");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $dfMzt = parcelRequire("dfMzt");

var $j0SXO = parcelRequire("j0SXO");

var $3qYzN = parcelRequire("3qYzN");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $l9VFH = parcelRequire("l9VFH");
const $3782687796b171ac$var$fetchData = ({ store: store, prefetchedData: prefetchedData, refreshData: refreshData, storeFieldsActions: storeFieldsActions })=>{
    const state = store.getState();
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    const epicIssueType = (0, $jG5HW.getEpicIssueType)(state);
    const activeQuickFilters = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $l9VFH.getAppliedCustomFilters)(state) ?? (0, $dfMzt.getCustomFilterFromUrlQuery)(window.location);
    if (prefetchedData) {
        const refresh$ = refreshData && (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? (0, $kVLXA.Observable).fromPromise(refreshData) : (0, $kVLXA.Observable).empty();
        const refreshAction$ = refresh$.flatMap((data)=>(0, $kVLXA.Observable).of((0, $3lZ6i.setAppData)((0, $3qYzN.transformPlanData)(data, isCompanyManaged, activeQuickFilters))));
        return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of((0, $3lZ6i.setAppData)((0, $3qYzN.transformPlanData)(prefetchedData, isCompanyManaged, activeQuickFilters))), refreshAction$);
    }
    const boardId = (0, $jG5HW.getRapidViewId)(state);
    return (0, $j0SXO.loadPlanDataService)({
        boardId: boardId,
        isCompanyManaged: isCompanyManaged,
        activeQuickFilters: activeQuickFilters,
        epicIssueType: epicIssueType,
        storeFieldsActions: storeFieldsActions
    }).map((0, $3lZ6i.setAppData)).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-plan-data.failure', 'Failed to load plan data from REST', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.loadAppDataFailure)());
    });
};
const $3782687796b171ac$export$e0e3208a5652318a = (action$, store, dependencies)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(({ payload: payload })=>$3782687796b171ac$var$fetchData({
            store: store,
            prefetchedData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? payload.prefetchCmpBacklogData?.result : payload.prefetchedJiraPlanRestData,
            refreshData: (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? payload.prefetchCmpBacklogData?.refresh : null,
            storeFieldsActions: payload.storeFieldsActions || dependencies?.storeFieldsActions
        }));

});

parcelRegister("13hY5", function(module, exports) {

$parcel$export(module.exports, "loadPrioritiesEpic", () => $d30731ea5040493f$export$20ae9bff1fb86dc1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $dJl1T = parcelRequire("dJl1T");

var $5EGHE = parcelRequire("5EGHE");

var $3lZ6i = parcelRequire("3lZ6i");

var $c7Xu8 = parcelRequire("c7Xu8");

var $jG5HW = parcelRequire("jG5HW");
const $d30731ea5040493f$export$20ae9bff1fb86dc1 = (action$, store)=>action$.ofType((0, $3lZ6i.SET_APP_DATA), (0, $c7Xu8.LOAD_PRIORITIES_REQUEST)).flatMap(()=>{
        const state = store.getState();
        const projectIds = (0, $jG5HW.getProjectAris)(state);
        return (0, $5EGHE.fetchAllPriorities)(projectIds).map((0, $c7Xu8.loadPrioritiesSuccess)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.load-priorities.failure', 'Failed to load priorities from REST', error);
            return (0, $kVLXA.Observable).of((0, $c7Xu8.loadPrioritiesFailure)());
        });
    });

});
parcelRegister("5EGHE", function(module, exports) {

$parcel$export(module.exports, "fetchAllPriorities", () => $19029c30a6fee69a$export$910988adc9be7f87);
parcelRequire("9IWoG");
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");

const $19029c30a6fee69a$export$6b468dcfb64c653c = (priorities)=>{
    const allPriorities = priorities.data.jira.jiraProjects.map((project)=>project.priorityScheme.priorities.edges.map((edge)=>({
                id: edge.node.priorityId,
                name: edge.node.name,
                iconUrl: edge.node.iconUrl
            })));
    const intersectingPriorities = allPriorities.reduce((prioritiesA, prioritiesB)=>prioritiesA.filter((priorityA)=>prioritiesB.some((priorityB)=>priorityA.id === priorityB.id)));
    return intersectingPriorities;
};
const $19029c30a6fee69a$export$910988adc9be7f87 = (projectIds)=>(0, $487fd.default)(`${(0, $d9b8a0aa13e64ddd$export$4159899b2a5c63f2)}?operation=${(0, $d9b8a0aa13e64ddd$export$21c589a2cbb3ede0)}`, {
        method: 'post',
        body: JSON.stringify({
            query: (0, $d9b8a0aa13e64ddd$export$4459165bea9549c9),
            variables: {
                projectIds: projectIds
            }
        })
    }).map($19029c30a6fee69a$export$6b468dcfb64c653c);

});
// To support the priorities per project feature we need to use the /rest/api/3/priority/search endpoint instead: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-priorities/#api-rest-api-3-priority-search-get
const $d9b8a0aa13e64ddd$export$4159899b2a5c63f2 = '/rest/gira/1/';
const $d9b8a0aa13e64ddd$export$21c589a2cbb3ede0 = 'BacklogCardListPrioritiesQuery';
const $d9b8a0aa13e64ddd$export$4459165bea9549c9 = `
query ${$d9b8a0aa13e64ddd$export$21c589a2cbb3ede0} ($projectIds: [ID!]!) {
    jira {
        jiraProjects(ids: $projectIds) {
          priorityScheme {
            priorities {
              edges {
                node {
                  priorityId
                  name
                  iconUrl
                }
              }
            }
          }
        }
      }
}
`;


parcelRegister("c7Xu8", function(module, exports) {

$parcel$export(module.exports, "LOAD_PRIORITIES_REQUEST", () => $b6059f88a1f974a0$export$ec0e161fbc75b17);
$parcel$export(module.exports, "loadPriorities", () => $b6059f88a1f974a0$export$298a3cca1db04fc7);
$parcel$export(module.exports, "LOAD_PRIORITIES_SUCCESS", () => $b6059f88a1f974a0$export$8e601591d139ea1e);
$parcel$export(module.exports, "loadPrioritiesSuccess", () => $b6059f88a1f974a0$export$8c198db10c34eeae);
$parcel$export(module.exports, "loadPrioritiesFailure", () => $b6059f88a1f974a0$export$db7c0221961bec8a);
$parcel$export(module.exports, "CARD_PRIORITY_SET", () => $b6059f88a1f974a0$export$81f23650b1079e);
$parcel$export(module.exports, "cardPrioritySet", () => $b6059f88a1f974a0$export$2054774d4090891c);
$parcel$export(module.exports, "CARD_PRIORITY_SET_OPTIMISTIC", () => $b6059f88a1f974a0$export$2357c19e39838a71);
$parcel$export(module.exports, "cardPrioritySetOptimistic", () => $b6059f88a1f974a0$export$df682081f15f18be);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $b6059f88a1f974a0$export$ec0e161fbc75b17 = 'state.actions.priorities.LOAD_PRIORITIES_REQUEST';
const $b6059f88a1f974a0$export$298a3cca1db04fc7 = ()=>({
        type: $b6059f88a1f974a0$export$ec0e161fbc75b17
    });
const $b6059f88a1f974a0$export$8e601591d139ea1e = 'state.actions.priorities.LOAD_PRIORITY_SUCCESS';
const $b6059f88a1f974a0$export$8c198db10c34eeae = (response)=>({
        type: $b6059f88a1f974a0$export$8e601591d139ea1e,
        payload: response
    });
const $b6059f88a1f974a0$export$9f00fd43080ad118 = 'state.actions.priorities.LOAD_PRIORITY_FAILURE';
const $b6059f88a1f974a0$export$db7c0221961bec8a = ()=>({
        type: $b6059f88a1f974a0$export$9f00fd43080ad118
    });
const $b6059f88a1f974a0$export$81f23650b1079e = 'state.actions.priorities.CARD_PRIORITY_SET';
const $b6059f88a1f974a0$export$2054774d4090891c = (payload)=>({
        type: $b6059f88a1f974a0$export$81f23650b1079e,
        payload: payload
    });
const $b6059f88a1f974a0$export$2357c19e39838a71 = 'state.actions.priorities.CARD_PRIORITY_SET_OPTIMISTIC';
const $b6059f88a1f974a0$export$df682081f15f18be = (payload, issueKey, analyticsEvent)=>({
        type: $b6059f88a1f974a0$export$2357c19e39838a71,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                fieldId: (0, $5fc53.PRIORITY_TYPE),
                issueKey: issueKey,
                newValue: payload.priority,
                retryAction: ()=>$b6059f88a1f974a0$export$df682081f15f18be(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});


parcelRegister("jRnbG", function(module, exports) {

$parcel$export(module.exports, "onCloseInsightsEpic", () => $c585c90bf40533f4$export$89929865228bcbd8);
$parcel$export(module.exports, "onTogglePanelEpic", () => $c585c90bf40533f4$export$f59322268512fa6c);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $f6RVN = parcelRequire("f6RVN");



var $3FUwR = parcelRequire("3FUwR");

var $h9NU3 = parcelRequire("h9NU3");

var $7SF9g = parcelRequire("7SF9g");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $l89dM = parcelRequire("l89dM");
const $c585c90bf40533f4$export$89929865228bcbd8 = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $9g0YE.CLOSE_INSIGHTS_PANEL)).mergeMap((action)=>{
            const state = store.getState();
            if (action.payload && action.payload.shouldUpdateLocation) // We only set the URL if this action is called with `shouldUpdateLocation`
            // Mainly because there is a case user will click on an issue and it auto close the insights panel
            // In this action we will fire two actions.
            // 1. Update the URL selected issue,
            // 2. Update the URL for insights panel.
            // However, these two actions fire at one cycle, and we can't get the updated route location if we fire both actions
            // at the same time. Therefore, the second push action (here) which update the URL will override the first push action,
            // it cause the URL is not changed after we select an issue.
            // Therefore, we will fire all the update to the URL in one push on when the issue card is clicked.
            replace((0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), false, getLocation()));
            // Make sure Insights is removed from the local storage
            (0, $3FUwR.unsetPanelState)((0, $c35fd6591a78fffe$export$29d7f2210b16d662), (0, $jG5HW.getRapidViewId)(state));
            return (0, $kVLXA.Observable).empty();
        });
const $c585c90bf40533f4$export$f59322268512fa6c = (getLocation, replace)=>(action$, store)=>action$.ofType((0, $9g0YE.TOGGLE_PANEL)).mergeMap((action)=>{
            const { panel: panel } = action.payload;
            const state = store.getState();
            if (panel === (0, $c35fd6591a78fffe$export$29d7f2210b16d662)) {
                const isInsightsOpen = (0, $h9NU3.isInsightsPanelOpen)();
                const isViewSettingsPanelOpen = (0, $l89dM.getViewSettingsPanel)(state);
                replace((0, $7SF9g.setPanelsUrl)((0, $4f4a02cead13bb5a$export$61119f100c357d06), !isInsightsOpen, getLocation()));
                if ((0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen) return (0, $kVLXA.Observable).of((0, $9g0YE.closeViewSettingsPanel)());
            }
            if ((0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && panel === (0, $c35fd6591a78fffe$export$ba1da943283b9900)) return (0, $kVLXA.Observable).of((0, $9g0YE.closeInsightsPanel)(true));
            return (0, $kVLXA.Observable).empty();
        });

});
const $c35fd6591a78fffe$export$a10c132b86ae798b = 'ISSUE_PARENT_PANEL';
const $c35fd6591a78fffe$export$41073ac826c57195 = 'VERSION_PANEL';
const $c35fd6591a78fffe$export$29d7f2210b16d662 = 'INSIGHTS_PANEL';
const $c35fd6591a78fffe$export$ba1da943283b9900 = 'VIEW_SETTINGS_PANEL';

parcelRegister("h9NU3", function(module, exports) {

$parcel$export(module.exports, "isIssueParentPanelOpen", () => $0ef21687ba992671$export$aba8540b0819f844);
$parcel$export(module.exports, "isVersionPanelOpen", () => $0ef21687ba992671$export$6387d97dce325d43);
$parcel$export(module.exports, "isInsightsPanelOpen", () => $0ef21687ba992671$export$597778e52dd2f97b);

var $ebyGx = parcelRequire("ebyGx");


var $3FUwR = parcelRequire("3FUwR");
const $0ef21687ba992671$export$d4d8b30943776734 = (currentPanel, panelFromLocalStorage)=>currentPanel === panelFromLocalStorage ? null : currentPanel;
const $0ef21687ba992671$export$b057090d6eb17ec2 = (currentPanel, boardId)=>{
    if (boardId) {
        const panelStateFromLocalStorage = (0, $3FUwR.getPanelState)(boardId);
        panelStateFromLocalStorage?.includes(currentPanel) ? (0, $3FUwR.unsetPanelState)(currentPanel, boardId) : (0, $3FUwR.setPanelState)(currentPanel, boardId);
    } else {
        const panelStateFromLocalStorage = (0, $3FUwR.getPanelStateOld)();
        (0, $3FUwR.setPanelStateOld)($0ef21687ba992671$export$d4d8b30943776734(currentPanel, panelStateFromLocalStorage));
    }
};
const $0ef21687ba992671$export$aba8540b0819f844 = (location)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(location ? location.search : window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$ec3c43b997309252] === 'visible';
};
const $0ef21687ba992671$export$6387d97dce325d43 = (location)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(location ? location.search : window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$a86c1a6dde9da34f] === 'visible';
};
const $0ef21687ba992671$export$597778e52dd2f97b = ()=>{
    // This is used in the old version and new version
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = (0, $ebyGx.parse)(window.location.search);
    return queryParams[0, $4f4a02cead13bb5a$export$61119f100c357d06] === 'true';
};

});

parcelRegister("l89dM", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $6d33d2146617bd6f$export$be078297eeb6e8a2);
$parcel$export(module.exports, "getEpicPanel", () => $6d33d2146617bd6f$export$9680a3ff98a72c33);
$parcel$export(module.exports, "getInsightsPanel", () => $6d33d2146617bd6f$export$806d34b644f1954d);
$parcel$export(module.exports, "getViewSettingsPanel", () => $6d33d2146617bd6f$export$a0b20e22a1f77091);

var $f6RVN = parcelRequire("f6RVN");

const $6d33d2146617bd6f$export$be078297eeb6e8a2 = (state)=>state.ui.panels;
const $6d33d2146617bd6f$export$9680a3ff98a72c33 = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$a10c132b86ae798b] || false;
const $6d33d2146617bd6f$export$893e9e519770bdb0 = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$41073ac826c57195] || false;
const $6d33d2146617bd6f$export$806d34b644f1954d = (state)=>state.ui.panels[0, $c35fd6591a78fffe$export$29d7f2210b16d662] || false;
const $6d33d2146617bd6f$export$a0b20e22a1f77091 = (state)=>(0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && state.ui.panels[0, $c35fd6591a78fffe$export$ba1da943283b9900] || false;

});


parcelRegister("1JXN4", function(module, exports) {

$parcel$export(module.exports, "selectIssueParentEpic", () => $0de65fa931148179$export$f716b183f4055d82);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $fmuR9 = parcelRequire("fmuR9");
const $0de65fa931148179$export$f716b183f4055d82 = (getLocation, push)=>(action$, store)=>action$.ofType((0, $4mqko.PARENT_CLICK)).mergeMap((action)=>{
            const state = store.getState();
            const { cardId: cardId } = action.payload;
            const issueParents = (0, $fmuR9.getIssueParents)(state);
            const parentCardId = issueParents[String(cardId)] ? issueParents[String(cardId)].key : null;
            if (!parentCardId) return (0, $kVLXA.Observable).empty();
            const actions = [
                (0, $4mqko.cardSingleSelect)(cardId),
                (0, $38qhf.openDetailView)(cardId)
            ];
            push((0, $cik5h.addSelectedIssueToUrl)(parentCardId, getLocation()));
            return (0, $kVLXA.Observable).from(actions);
        });

});

parcelRegister("8Z17A", function(module, exports) {

$parcel$export(module.exports, "postLoadCleanDataEpic", () => $4e3a040cc13a03d7$export$6404a6651653bf5a);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3lZ6i = parcelRequire("3lZ6i");

var $4mqko = parcelRequire("4mqko");

var $dGljH = parcelRequire("dGljH");
const $4e3a040cc13a03d7$export$6404a6651653bf5a = (action$, store)=>// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.cards.selection.CARD_MULTI_SELECT' is not assignable to type 'state.actions.cards.selection.CARD_EMPTY_SELECTION'.
    action$.ofType((0, $3lZ6i.SET_APP_DATA)).flatMap(()=>{
        const state = store.getState();
        const actions = [];
        // remove deleted issues from the list
        const cardIds = Object.keys((0, $dGljH.getCards)(state)).map((id)=>Number(id));
        const selectedCards = (0, $dGljH.getSelectedCards)(state);
        if (selectedCards.length === 0) return (0, $kVLXA.Observable).empty();
        const existingSelectedCards = selectedCards.filter((cardId)=>cardIds.includes(cardId));
        const relativeCard = (0, $dGljH.getListSelectionRelativeCard)(state);
        if (existingSelectedCards.length !== selectedCards.length) {
            if (existingSelectedCards.length === 0) return (0, $kVLXA.Observable).of((0, $4mqko.cardEmptySelection)());
            actions.push((0, $4mqko.cardMultiSelect)(existingSelectedCards));
        }
        if (relativeCard && existingSelectedCards.length > 0 && !existingSelectedCards.includes(relativeCard)) actions.push((0, $4mqko.cardClearRelativeCard)());
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("2sQbO", function(module, exports) {

$parcel$export(module.exports, "refetchVersionsEpic", () => $c8d3330bab3cfd1c$export$4c96c86475a36738);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6hSeW");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $63Y57 = parcelRequire("63Y57");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");
const $c8d3330bab3cfd1c$export$4c96c86475a36738 = (action$, store, dependencies)=>action$.ofType((0, $gwOHY.REFETCH_VERSIONS)).mergeMap(()=>{
        const state = store.getState();
        const cloudId = (0, $jG5HW.getCloudId)(state);
        const projectIds = (0, $jG5HW.getProjectIds)(state);
        if (!projectIds.length || !dependencies || !dependencies.refetchVersionsForProjects) return (0, $kVLXA.Observable).empty();
        const refetchVersions = dependencies.refetchVersionsForProjects;
        const jiraProjectIds = projectIds.map((id)=>(0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: String(id)
            }));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $63Y57.fromRelayObservable)(()=>refetchVersions(jiraProjectIds)).flatMap((data)=>{
            const versions = data?.jira?.versionsForProjects;
            return (0, $kVLXA.Observable).of((0, $gwOHY.setVersions)({
                versions: versions?.edges?.map((edge)=>edge?.node?.versionId)?.filter(Boolean) ?? []
            }));
        }).catch((error)=>(0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'refetchVersionsQuery',
                    packageName: 'jiraSoftwareBacklog',
                    teamName: 'a4t-tanuki'
                }
            }));
    });

});

parcelRegister("gnmD3", function(module, exports) {

$parcel$export(module.exports, "refreshDataEpic", () => $b4e8a371a56793e6$export$c5e96b1fc124b3e);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");
parcelRequire("7qVV7");
parcelRequire("76ueo");
parcelRequire("bZiwb");
parcelRequire("c66Ur");
parcelRequire("1oQta");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $dJl1T = parcelRequire("dJl1T");

var $guzeq = parcelRequire("guzeq");

var $i4Z8q = parcelRequire("i4Z8q");

var $3lZ6i = parcelRequire("3lZ6i");

var $5Eoed = parcelRequire("5Eoed");

var $c7Xu8 = parcelRequire("c7Xu8");

var $lDDqj = parcelRequire("lDDqj");

var $jhRgJ = parcelRequire("jhRgJ");

var $5z625 = parcelRequire("5z625");
const $b4e8a371a56793e6$var$hasSprintCompleteSource = (actions)=>actions.some((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_SPRINT_COMPLETE));
const $b4e8a371a56793e6$export$74060531d4970975 = (refreshActions, resultActions)=>$b4e8a371a56793e6$var$hasSprintCompleteSource(refreshActions) ? [
        ...resultActions,
        (0, $5Eoed.closeModal)()
    ] : resultActions;
const $b4e8a371a56793e6$var$getGlobalIssueCreateSource = (actions)=>actions.find((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE));
const $b4e8a371a56793e6$export$7a1171f81211a01b = (refreshActions, resultActions)=>{
    const globalIssueCreateAction = $b4e8a371a56793e6$var$getGlobalIssueCreateSource(refreshActions);
    if (globalIssueCreateAction === undefined) return resultActions;
    const globalIssues = globalIssueCreateAction?.payload?.issues;
    return globalIssues === undefined ? [
        ...resultActions
    ] : [
        ...resultActions,
        (0, $3lZ6i.checkGlobalIssueCreate)(globalIssues)
    ];
};
const $b4e8a371a56793e6$var$isOptimitsticOrDragging = (store)=>{
    const state = store.getState();
    return (0, $jhRgJ.hasAnyActiveOptimistic)(state) || (0, $lDDqj.isDragging)(state);
};
const $b4e8a371a56793e6$var$shouldCloseBuffer = (action$, store)=>action$.filter(()=>!$b4e8a371a56793e6$var$isOptimitsticOrDragging(store));
const $b4e8a371a56793e6$var$shouldAbort = (action$, store)=>action$.filter(()=>$b4e8a371a56793e6$var$isOptimitsticOrDragging(store));
const $b4e8a371a56793e6$export$98174b963acaea1d = (actions)=>actions.some((action)=>action.payload.source === (0, $guzeq.REFRESH_SOURCE_ON_MOUNT));
const $b4e8a371a56793e6$export$c5e96b1fc124b3e = (action$, store, dependencies)=>action$.ofType((0, $3lZ6i.REFRESH_DATA_REQUEST)).bufferWhen(()=>$b4e8a371a56793e6$var$shouldCloseBuffer(action$, store)).filter((buffer)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(buffer)).exhaustMap((refreshActions)=>{
        const serviceContext = (0, $i4Z8q.makeServiceContext)(store.getState());
        const gicSourceRefreshAction = $b4e8a371a56793e6$var$getGlobalIssueCreateSource(refreshActions);
        if (serviceContext.isCompanyManaged) {
            const loadAppDataAction = gicSourceRefreshAction !== undefined ? (0, $3lZ6i.loadAppData)({
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }) : (0, $3lZ6i.loadAppData)();
            const actions = [
                loadAppDataAction,
                (0, $3lZ6i.loadConfigData)()
            ];
            return (0, $kVLXA.Observable).from([
                ...$b4e8a371a56793e6$export$74060531d4970975(refreshActions, []),
                ...$b4e8a371a56793e6$export$7a1171f81211a01b(refreshActions, []),
                ...actions,
                (0, $c7Xu8.loadPriorities)()
            ]).takeUntil($b4e8a371a56793e6$var$shouldAbort(action$, store));
        }
        const fetchDataFromAGG = dependencies?.fetchDataFromAGG;
        return (0, $5z625.fetchData)({
            store: store,
            ...$b4e8a371a56793e6$export$98174b963acaea1d(refreshActions) && fetchDataFromAGG && {
                fetchDataFromAGG: ()=>fetchDataFromAGG(true)
            },
            ...gicSourceRefreshAction && gicSourceRefreshAction.payload.storeFieldsActions && {
                storeFieldsActions: gicSourceRefreshAction.payload.storeFieldsActions
            }
        }).flatMap((resultAction)=>[
                ...$b4e8a371a56793e6$export$74060531d4970975(refreshActions, [
                    resultAction
                ]),
                ...$b4e8a371a56793e6$export$7a1171f81211a01b(refreshActions, [
                    resultAction
                ])
            ]).takeUntil($b4e8a371a56793e6$var$shouldAbort(action$, store));
    }).catch((error)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.refresh-data.failure', 'Fail to refresh data.', error);
        return (0, $kVLXA.Observable).of((0, $3lZ6i.refreshDataFailure)());
    });

});
parcelRegister("lDDqj", function(module, exports) {

$parcel$export(module.exports, "isDragging", () => $5c1e30b3ded0b001$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "getSourceDroppableType", () => $5c1e30b3ded0b001$export$e2d19a990d0e9f1c);
$parcel$export(module.exports, "getSourceCardListId", () => $5c1e30b3ded0b001$export$3c7985ea201cdfef);
$parcel$export(module.exports, "getIsSubtaskDrag", () => $5c1e30b3ded0b001$export$fa75a25bcebce8f1);
const $5c1e30b3ded0b001$export$9e9bc3c487fccc00 = (state)=>state.ui.drag.isDragging;
const $5c1e30b3ded0b001$export$e2d19a990d0e9f1c = (state)=>state.ui.drag.sourceCardGroupType;
const $5c1e30b3ded0b001$export$3c7985ea201cdfef = (state)=>state.ui.drag.sourceCardListId;
const $5c1e30b3ded0b001$export$fa75a25bcebce8f1 = (state)=>state.ui.drag.isSubtask;
const $5c1e30b3ded0b001$export$376f09b67fc96920 = (state)=>state.ui.drag.sourceParentId;
const $5c1e30b3ded0b001$export$158fcd85e87a52bd = (state)=>state.ui.drag.isOverTransitionZone;

});

parcelRegister("jhRgJ", function(module, exports) {

$parcel$export(module.exports, "hasAnyActiveOptimistic", () => $5584ea5159bebe6f$export$5c9c2a640adc17da);
const $5584ea5159bebe6f$export$5c9c2a640adc17da = (state)=>{
    const beforeState = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.entities && state.entities.beforeState;
    return beforeState !== undefined;
};

});


parcelRegister("h34Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad47d927a2ea593e$export$2e2bcd8739ae039);
parcelRequire("9IWoG");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("8vsXW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $cik5h = parcelRequire("cik5h");

var $3lZ6i = parcelRequire("3lZ6i");

var $9Z18E = parcelRequire("9Z18E");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $aCC3Y = parcelRequire("aCC3Y");

var $dGljH = parcelRequire("dGljH");
const $ad47d927a2ea593e$var$performSelectedKeyCheck = (store, location, push)=>()=>{
        const state = store.getState();
        const lastSelectedCardKeyFromUrl = (0, $dGljH.getLastSelectedCardKey)(state);
        if (lastSelectedCardKeyFromUrl) {
            const cardId = (0, $dGljH.getIdByKeyForAllIssueTypes)(state)(lastSelectedCardKeyFromUrl);
            if (cardId) return (0, $kVLXA.Observable).from([
                (0, $4mqko.cardSingleSelect)(cardId),
                (0, $38qhf.openDetailView)(cardId),
                (0, $9Z18E.cardAutoScroll)(cardId)
            ]);
            push((0, $cik5h.removeSelectedIssueFromUrl)(location));
        }
        return (0, $kVLXA.Observable).empty();
    };
// there are two cases, when we need to read lastSelectedCardKey from URL and open Bento on Backlog init
// 1) When critical path data is loaded before App routing initialised (with SSR/SPA) -> postLocationSetEpic
// 2) When critical path data is loaded after App routing initialised (without SSR) -> setSelectedIssueFromUrlEpic
const $ad47d927a2ea593e$var$observables = (action$, isCompanyManaged)=>isCompanyManaged ? [
        action$.ofType((0, $4mqko.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $3lZ6i.SET_APP_DATA)).first(),
        action$.ofType((0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS)).first()
    ] : [
        action$.ofType((0, $4mqko.SET_LAST_SELECTED_CARD_KEY)).first(),
        action$.ofType((0, $3lZ6i.SET_APP_DATA)).first()
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad47d927a2ea593e$export$2e2bcd8739ae039 = (getLocation, push, isCompanyManaged)=>(action$, store)=>(0, $kVLXA.Observable).forkJoin($ad47d927a2ea593e$var$observables(action$, isCompanyManaged)).mergeMap($ad47d927a2ea593e$var$performSelectedKeyCheck(store, getLocation(), push)).catch(()=>(0, $kVLXA.Observable).empty());

});

parcelRegister("83JtA", function(module, exports) {

$parcel$export(module.exports, "sprintCreateEpic", () => $1535a80ded97b3da$export$fd754fd9ce87f92b);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $dJl1T = parcelRequire("dJl1T");

var $guzeq = parcelRequire("guzeq");

var $gz7B4 = parcelRequire("gz7B4");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $jG5HW = parcelRequire("jG5HW");
const $1535a80ded97b3da$export$fd754fd9ce87f92b = (action$, store)=>action$.ofType((0, $jkFPs.SPRINT_CREATE_REQUEST)).mergeMap((action)=>{
        const { meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent }, payload: { temporaryCardListId: temporaryCardListId } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
        return (0, $gz7B4.default)(baseUrl, rapidViewId).map((sprint)=>(0, $jkFPs.sprintCreateSuccess)(sprint, temporaryCardListId, optimisticId, analyticsEvent)).catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.sprint-create.failure', 'Failed to create sprint', error);
            return (0, $kVLXA.Observable).from([
                (0, $jkFPs.sprintCreateFailure)(temporaryCardListId, optimisticId, analyticsEvent),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("gz7B4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c848cd8159d0472$export$2e2bcd8739ae039);
parcelRequire("d0pqD");

var $guzeq = parcelRequire("guzeq");

var $9Fk0e = parcelRequire("9Fk0e");
const $3c848cd8159d0472$var$transformer = (response)=>({
        id: String(response.id),
        name: response.name,
        type: (0, $guzeq.SPRINT),
        issueListKey: null,
        sprintData: {
            goal: '',
            startDate: response.isoStartDate,
            endDate: response.isoEndDate,
            daysRemaining: response.daysRemaining,
            state: response.state,
            canUpdateSprint: response.canUpdateSprint
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3c848cd8159d0472$export$2e2bcd8739ae039 = (baseUrl, rapidViewId)=>(0, $9Fk0e.default)(baseUrl, rapidViewId).map($3c848cd8159d0472$var$transformer);

});
parcelRegister("9Fk0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9bc8011977a9010$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $6iJbJ = parcelRequire("6iJbJ");
const $b9bc8011977a9010$var$MUTATION_NAME = 'BacklogCreateSprint';
const $b9bc8011977a9010$export$e904bac7f43ed94a = (boardId)=>`mutation ${$b9bc8011977a9010$var$MUTATION_NAME} {
        createSprint(input: { 
            boardId: ${boardId}
        }) {
            sprint {
                id,
                name,
                daysRemaining,
                startDate,
                endDate,
                sprintState,
                canUpdateSprint
            }
        }
    }`;
const $b9bc8011977a9010$export$9c68d69a4c5bbcf9 = (result)=>{
    const { sprintState: sprintState, endDate: endDate, startDate: startDate, ...rest } = result.createSprint.sprint;
    const createdSprint = {
        ...rest,
        state: sprintState,
        isoEndDate: endDate === 'None' ? '' : endDate,
        isoStartDate: startDate === 'None' ? '' : startDate
    };
    return (0, $kVLXA.Observable).of(createdSprint);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b9bc8011977a9010$export$2e2bcd8739ae039 = (baseUrl, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $b9bc8011977a9010$var$MUTATION_NAME, $b9bc8011977a9010$export$e904bac7f43ed94a(boardId)).flatMap($b9bc8011977a9010$export$9c68d69a4c5bbcf9);

});


parcelRegister("jkFPs", function(module, exports) {

$parcel$export(module.exports, "SPRINT_CREATE_REQUEST", () => $be47e9ec4954e21f$export$d59013ccc191ced6);
$parcel$export(module.exports, "sprintCreateRequest", () => $be47e9ec4954e21f$export$6a8c5a7f76e28862);
$parcel$export(module.exports, "SPRINT_CREATE_SUCCESS", () => $be47e9ec4954e21f$export$4e82b88c987fbfcb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $be47e9ec4954e21f$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "SPRINT_CREATE_FAILURE", () => $be47e9ec4954e21f$export$fe11ca1e4db494a);
$parcel$export(module.exports, "sprintCreateFailure", () => $be47e9ec4954e21f$export$cb20bc93da1235f7);

var $c0irb = parcelRequire("c0irb");
let $be47e9ec4954e21f$var$lastSprintId = 0;
const $be47e9ec4954e21f$var$generateId = ()=>{
    $be47e9ec4954e21f$var$lastSprintId -= 1;
    return $be47e9ec4954e21f$var$lastSprintId;
};
const $be47e9ec4954e21f$export$d59013ccc191ced6 = 'state.actions.sprints.create.SPRINT_CREATE_REQUEST';
const $be47e9ec4954e21f$export$6a8c5a7f76e28862 = (analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$d59013ccc191ced6,
        payload: {
            temporaryCardListId: String($be47e9ec4954e21f$var$generateId())
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $be47e9ec4954e21f$export$4e82b88c987fbfcb = 'state.actions.sprints.create.SPRINT_CREATE_SUCCESS';
const $be47e9ec4954e21f$export$4bedc2fcbe2138bd = (sprint, temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$4e82b88c987fbfcb,
        payload: {
            sprint: sprint,
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $c0irb.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $be47e9ec4954e21f$export$fe11ca1e4db494a = 'state.actions.sprints.create.SPRINT_CREATE_FAILURE';
const $be47e9ec4954e21f$export$cb20bc93da1235f7 = (temporaryCardListId, optimisticId, analyticsEvent)=>({
        type: $be47e9ec4954e21f$export$fe11ca1e4db494a,
        payload: {
            temporaryCardListId: temporaryCardListId
        },
        meta: {
            ...(0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId),
            ...analyticsEvent ? {
                analyticsEvent: analyticsEvent
            } : {}
        }
    });

});


parcelRegister("dZEjB", function(module, exports) {

$parcel$export(module.exports, "sprintDeleteEpic", () => $497e2c3e192c01a2$export$5ffc2a46229f98c0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $guzeq = parcelRequire("guzeq");

var $9aEBE = parcelRequire("9aEBE");

var $3lZ6i = parcelRequire("3lZ6i");

var $d09wv = parcelRequire("d09wv");

var $jG5HW = parcelRequire("jG5HW");
const $497e2c3e192c01a2$export$5ffc2a46229f98c0 = (action$, store)=>action$.ofType((0, $d09wv.SPRINT_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const rapidViewId = (0, $jG5HW.getRapidViewId)(state);
        return (0, $9aEBE.default)(baseUrl, sprintId, rapidViewId).flatMap(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'sprint deleted');
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
                task: 'deleteSprint'
            });
            return (0, $kVLXA.Observable).of((0, $d09wv.sprintDeleteSuccess)(sprintId, optimisticId));
        }).catch((error)=>{
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'deleteSprint',
                isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                errorMessage: error.message
            });
            return (0, $kVLXA.Observable).from([
                (0, $d09wv.sprintDeleteFailure)(sprintId, optimisticId),
                (0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_FAILURE))
            ]);
        });
    });

});
parcelRegister("9aEBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $068a1ffb704f2871$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $068a1ffb704f2871$var$MUTATION_NAME = 'BacklogDeleteSprint';
const $068a1ffb704f2871$export$e904bac7f43ed94a = (boardId, sprintId)=>`mutation ${$068a1ffb704f2871$var$MUTATION_NAME} {
        deleteSprint(input: { boardId: ${boardId}, sprintId: ${sprintId} }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$068a1ffb704f2871$export$2e2bcd8739ae039 = (baseUrl, sprintId, boardId)=>(0, $6iJbJ.mutation$)(baseUrl, $068a1ffb704f2871$var$MUTATION_NAME, $068a1ffb704f2871$export$e904bac7f43ed94a(boardId, sprintId));

});

parcelRegister("d09wv", function(module, exports) {

$parcel$export(module.exports, "SPRINT_DELETE_REQUEST", () => $4118be0dc04226a7$export$6b303f66a5e5797e);
$parcel$export(module.exports, "sprintDeleteRequest", () => $4118be0dc04226a7$export$35fe698532b74175);
$parcel$export(module.exports, "SPRINT_DELETE_SUCCESS", () => $4118be0dc04226a7$export$834703750976df63);
$parcel$export(module.exports, "sprintDeleteSuccess", () => $4118be0dc04226a7$export$83b0e54db46bc14c);
$parcel$export(module.exports, "sprintDeleteFailure", () => $4118be0dc04226a7$export$f3bca19c58d95d7a);

var $c0irb = parcelRequire("c0irb");
const $4118be0dc04226a7$export$6b303f66a5e5797e = 'state.actions.sprints.delete.SPRINT_DELETE_REQUEST';
const $4118be0dc04226a7$export$35fe698532b74175 = (sprintId, nextCardListId, analyticsEvent)=>({
        type: $4118be0dc04226a7$export$6b303f66a5e5797e,
        payload: {
            sprintId: sprintId,
            nextCardListId: nextCardListId
        },
        meta: {
            ...(0, $c0irb.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $4118be0dc04226a7$export$834703750976df63 = 'state.actions.sprints.delete.SPRINT_DELETE_SUCCESS';
const $4118be0dc04226a7$export$83b0e54db46bc14c = (sprintId, optimisticId)=>({
        type: $4118be0dc04226a7$export$834703750976df63,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $4118be0dc04226a7$export$b96bc6bf6780477 = 'state.actions.sprints.delete.SPRINT_DELETE_FAILURE';
const $4118be0dc04226a7$export$f3bca19c58d95d7a = (sprintId, optimisticId)=>({
        type: $4118be0dc04226a7$export$b96bc6bf6780477,
        payload: {
            sprintId: sprintId
        },
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("6BlmG", function(module, exports) {

$parcel$export(module.exports, "sprintMoveEpic", () => $09ac061b60d08e43$export$aee7bffc312e2d9d);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $94PWq = parcelRequire("94PWq");

var $jWMwu = parcelRequire("jWMwu");

var $3lZ6i = parcelRequire("3lZ6i");

var $dkxyn = parcelRequire("dkxyn");

var $jG5HW = parcelRequire("jG5HW");
const $09ac061b60d08e43$export$aee7bffc312e2d9d = (action$, store)=>action$.ofType((0, $dkxyn.SPRINT_MOVE_REQUEST)).mergeMap((action)=>{
        const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, analyticsEvent: analyticsEvent }, meta: { optimistic: { id: optimisticId } } } = action;
        const state = store.getState();
        const baseUrl = (0, $jG5HW.getBaseUrl)(state);
        const boardId = (0, $jG5HW.getRapidViewId)(state);
        (0, $jWMwu.setMoveSprintInteractionStartMark)();
        return (0, $94PWq.default)(baseUrl, boardId, sprintId, targetSprintId).flatMap(()=>{
            (0, $jWMwu.stopMoveSprintInteraction)();
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'sprint moved');
            return (0, $kVLXA.Observable).of((0, $dkxyn.sprintMoveSuccess)(optimisticId));
        }).catch((error)=>{
            (0, $jWMwu.cancelMoveSprintInteraction)();
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'sprint moveFailed', {
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            });
            return (0, $kVLXA.Observable).from([
                (0, $dkxyn.sprintMoveFailure)(optimisticId),
                (0, $3lZ6i.loadAppData)()
            ]);
        });
    });

});
parcelRegister("94PWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b744e7748e5e5e9$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");
const $5b744e7748e5e5e9$var$MUTATION_NAME = 'BacklogMoveSprint';
const $5b744e7748e5e5e9$export$e904bac7f43ed94a = (boardId, sprintId, targetSprintId)=>`mutation ${$5b744e7748e5e5e9$var$MUTATION_NAME} {
        moveSprint (input: {
            boardId: ${boardId},
            sprintId: ${sprintId},
            targetSprintId: ${targetSprintId},
        }) {
            success
        }
    }`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b744e7748e5e5e9$export$2e2bcd8739ae039 = (baseUrl, boardId, sprintId, targetSprintId)=>(0, $6iJbJ.mutation$)(baseUrl, $5b744e7748e5e5e9$var$MUTATION_NAME, $5b744e7748e5e5e9$export$e904bac7f43ed94a(boardId, sprintId, targetSprintId));

});

parcelRegister("jWMwu", function(module, exports) {

$parcel$export(module.exports, "setMoveSprintInteractionStartMark", () => $3fa3a3efc5209706$export$f22a6d0772829be2);
$parcel$export(module.exports, "cancelMoveSprintInteraction", () => $3fa3a3efc5209706$export$24d4fe151992bf19);
$parcel$export(module.exports, "stopMoveSprintInteraction", () => $3fa3a3efc5209706$export$a76821761124e4d4);

var $8hVbJ = parcelRequire("8hVbJ");
const $3fa3a3efc5209706$export$f22a6d0772829be2 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).start();
};
const $3fa3a3efc5209706$export$24d4fe151992bf19 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).cancel();
};
const $3fa3a3efc5209706$export$a76821761124e4d4 = ()=>{
    (0, $8hVbJ.moveSprintInteraction).stop();
};

});

parcelRegister("dkxyn", function(module, exports) {

$parcel$export(module.exports, "SPRINT_MOVE_REQUEST", () => $af4860f05ea864cc$export$af51e9f0383af197);
$parcel$export(module.exports, "sprintMoveRequest", () => $af4860f05ea864cc$export$3f8b743cac3b0a79);
$parcel$export(module.exports, "sprintMoveSuccess", () => $af4860f05ea864cc$export$604066b4fdce8da8);
$parcel$export(module.exports, "sprintMoveFailure", () => $af4860f05ea864cc$export$62075de456e485a);

var $c0irb = parcelRequire("c0irb");
const $af4860f05ea864cc$export$af51e9f0383af197 = 'state.actions.sprints.move.SPRINT_MOVE_REQUEST';
const $af4860f05ea864cc$export$3f8b743cac3b0a79 = (payload)=>({
        type: $af4860f05ea864cc$export$af51e9f0383af197,
        payload: payload,
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $af4860f05ea864cc$export$404f9f04f93189f = 'state.actions.sprints.move.SPRINT_MOVE_SUCCESS';
const $af4860f05ea864cc$export$604066b4fdce8da8 = (optimisticId)=>({
        type: $af4860f05ea864cc$export$404f9f04f93189f,
        meta: (0, $c0irb.commitOptimisticUiMeta)(optimisticId)
    });
const $af4860f05ea864cc$export$512be0ad1cebb005 = 'state.actions.sprints.move.SPRINT_MOVE_FAILURE';
const $af4860f05ea864cc$export$62075de456e485a = (optimisticId)=>({
        type: $af4860f05ea864cc$export$512be0ad1cebb005,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("7ixW2", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentEpic", () => $e2f24da0a13c0e0c$export$217e0b1862428616);

var $e1AU2 = parcelRequire("e1AU2");

var $bEhdv = parcelRequire("bEhdv");

var $gJeI6 = parcelRequire("gJeI6");

var $d5cBt = parcelRequire("d5cBt");
const $e2f24da0a13c0e0c$export$217e0b1862428616 = (0, $e1AU2.combineEpics)((0, $bEhdv.loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic), (0, $gJeI6.loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic), (0, $d5cBt.loadHasViewedPulseEpic), (0, $d5cBt.setHasViewedPulseEpic));

});
parcelRegister("bEhdv", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic", () => $865cb9571da9fcb4$export$91a6d9d97eec2a49);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $eN6O2 = parcelRequire("eN6O2");

var $3lZ6i = parcelRequire("3lZ6i");

var $5uBAa = parcelRequire("5uBAa");
const $865cb9571da9fcb4$var$loadHasAccessToConfluence = ()=>(0, $eN6O2.loadConfluencePermissionsService)().map((0, $5uBAa.hasConfluenceAccessEstablished));
const $865cb9571da9fcb4$export$91a6d9d97eec2a49 = (action$)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(()=>$865cb9571da9fcb4$var$loadHasAccessToConfluence());

});
parcelRegister("eN6O2", function(module, exports) {

$parcel$export(module.exports, "loadConfluencePermissionsService", () => $200fb04df21782d7$export$560aec87fc57f4f8);
$parcel$export(module.exports, "loadConfluenceSpaceService", () => $200fb04df21782d7$export$2a575dd4a8df50c9);
$parcel$export(module.exports, "loadHasViewedPulseService", () => $200fb04df21782d7$export$e4e71ae896d4c436);
$parcel$export(module.exports, "setHasViewedPulseService", () => $200fb04df21782d7$export$50e2ed7f4b84c09f);
parcelRequire("d0pqD");

var $aq199 = parcelRequire("aq199");

var $jjMJk = parcelRequire("jjMJk");

var $jcw0u = parcelRequire("jcw0u");

var $kBXQ9 = parcelRequire("kBXQ9");

var $5uBAa = parcelRequire("5uBAa");

var $jG5HW = parcelRequire("jG5HW");
const $200fb04df21782d7$export$560aec87fc57f4f8 = ()=>(0, $kBXQ9.fetchConfluencePermissions)().pipe((0, $jjMJk.map)((response)=>!!response.operations && response.operations.length > 0), (0, $jjMJk.catchError)(()=>(0, $aq199.of)(false)));
const $200fb04df21782d7$export$2a575dd4a8df50c9 = ()=>(0, $kBXQ9.fetchConfluenceSpace)().pipe((0, $jjMJk.map)((response)=>!!response.results && response.results.length > 0), (0, $jjMJk.catchError)(()=>(0, $aq199.of)(false)));
const $200fb04df21782d7$export$e4e71ae896d4c436 = (accountId)=>(0, $kBXQ9.fetchUserProperties)(accountId).pipe((0, $jjMJk.map)((res)=>res.value), (0, $jjMJk.catchError)((error)=>{
        // 404: API deliberately returns 404 if user property is not found
        if (error.statusCode === 404) return (0, $aq199.of)(false);
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'backlog.load-has-viewed-pulse-service.failure',
                packageName: 'jiraSoftwareBacklog',
                teamName: 'a4t-tanuki'
            }
        });
        return (0, $aq199.of)(true);
    }));
const $200fb04df21782d7$export$50e2ed7f4b84c09f = ({ store: store })=>{
    const accountId = (0, $jG5HW.getAtlassianAccountId)(store.getState());
    return (0, $kBXQ9.setUserProperties)(accountId ?? '', true).pipe((0, $jjMJk.map)(()=>(0, $5uBAa.setHasViewedPulseSuccess)(true)), (0, $jjMJk.catchError)(()=>(0, $aq199.of)((0, $5uBAa.setHasViewedPulseFailure)())));
};

});
parcelRegister("jjMJk", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $e1059775f18d6292$export$3dede90624df3ba9, (v) => $e1059775f18d6292$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "map", () => $e1059775f18d6292$export$871de8747c9eaa88, (v) => $e1059775f18d6292$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mergeMap", () => $e1059775f18d6292$export$6b9f6c0d32c093f9, (v) => $e1059775f18d6292$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "switchMap", () => $e1059775f18d6292$export$9f6ea8e48bc26eab, (v) => $e1059775f18d6292$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "throttleTime", () => $e1059775f18d6292$export$4efe28f192921dd4, (v) => $e1059775f18d6292$export$4efe28f192921dd4 = v);
var $e1059775f18d6292$export$d779b02e6b68c3e8;
var $e1059775f18d6292$export$719c70722b10e5ff;
var $e1059775f18d6292$export$ab1029bcae9ddb4a;
var $e1059775f18d6292$export$8916d2c8119541bb;
var $e1059775f18d6292$export$d6b40c95035461c7;
var $e1059775f18d6292$export$91115bdd8709945f;
var $e1059775f18d6292$export$9e55760d3282e08c;
var $e1059775f18d6292$export$3dede90624df3ba9;
var $e1059775f18d6292$export$29ae691b7de52fe3;
var $e1059775f18d6292$export$77fa7d86f5204e8a;
var $e1059775f18d6292$export$ee1b3e54f0441b22;
var $e1059775f18d6292$export$b314777ae20abca9;
var $e1059775f18d6292$export$c28c8388be0ab31a;
var $e1059775f18d6292$export$82fbd7a2841d2484;
var $e1059775f18d6292$export$85b9a36db797e02b;
var $e1059775f18d6292$export$61fc7d43ac8f84b0;
var $e1059775f18d6292$export$7843a4469d64c07e;
var $e1059775f18d6292$export$e4ca6d7b7a6dcf9b;
var $e1059775f18d6292$export$1391212d75b2ee65;
var $e1059775f18d6292$export$286ca829307725c9;
var $e1059775f18d6292$export$ab9a5985b741fa7a;
var $e1059775f18d6292$export$983a3b5fb2f7202e;
var $e1059775f18d6292$export$779c5fb865a0172e;
var $e1059775f18d6292$export$571da16e28367bde;
var $e1059775f18d6292$export$91d69c7761a17bbc;
var $e1059775f18d6292$export$7ecc1a3b11b57dab;
var $e1059775f18d6292$export$31039f1fbd797b9c;
var $e1059775f18d6292$export$d70d492cd31004c0;
var $e1059775f18d6292$export$9f77e0932fb78f72;
var $e1059775f18d6292$export$3dea766d36a8935f;
var $e1059775f18d6292$export$578723aef62d92f5;
var $e1059775f18d6292$export$71aa6c912b956294;
var $e1059775f18d6292$export$de3a4d4a0d731119;
var $e1059775f18d6292$export$43128fadae87b74a;
var $e1059775f18d6292$export$3f063810d7bf01bd;
var $e1059775f18d6292$export$6953b97c7d866605;
var $e1059775f18d6292$export$dd1bc94b04021eeb;
var $e1059775f18d6292$export$4c7897fafd92b108;
var $e1059775f18d6292$export$871de8747c9eaa88;
var $e1059775f18d6292$export$e0eaf3a86c03b2ad;
var $e1059775f18d6292$export$76dbd6ffd832405d;
var $e1059775f18d6292$export$8960430cfd85939f;
var $e1059775f18d6292$export$4950aa0f605343fb;
var $e1059775f18d6292$export$18aef43295bbe906;
var $e1059775f18d6292$export$6b9f6c0d32c093f9;
var $e1059775f18d6292$export$5b8affa63fc6df16;
var $e1059775f18d6292$export$bd7cfc9a42b8a412;
var $e1059775f18d6292$export$c1fc905202bced53;
var $e1059775f18d6292$export$96ec731ed4dcb222;
var $e1059775f18d6292$export$1364843af8d5a963;
var $e1059775f18d6292$export$9007f49c319d1ac7;
var $e1059775f18d6292$export$5fba66d61591f42;
var $e1059775f18d6292$export$8f9d79d42bff1aac;
var $e1059775f18d6292$export$b29f828819edca8d;
var $e1059775f18d6292$export$c44985b87d605eff;
var $e1059775f18d6292$export$89b472e03be495df;
var $e1059775f18d6292$export$16ae46fda9567053;
var $e1059775f18d6292$export$42d9b6b38c68d989;
var $e1059775f18d6292$export$1f3342bf81d92d52;
var $e1059775f18d6292$export$236c05de452bec2;
var $e1059775f18d6292$export$533b26079ad0b4b;
var $e1059775f18d6292$export$76d90c956114f2c2;
var $e1059775f18d6292$export$b39ac5b4ffd1415a;
var $e1059775f18d6292$export$9369b12211e1fce4;
var $e1059775f18d6292$export$1281551253cfee02;
var $e1059775f18d6292$export$18d0766d894cba0c;
var $e1059775f18d6292$export$4812e460280c6ef2;
var $e1059775f18d6292$export$fe33c7b2002d97b0;
var $e1059775f18d6292$export$c87d910e63d22ed6;
var $e1059775f18d6292$export$d0a07e60ae428313;
var $e1059775f18d6292$export$ed80d9de1d9df928;
var $e1059775f18d6292$export$db61d692014e534e;
var $e1059775f18d6292$export$863d7ca51b416cee;
var $e1059775f18d6292$export$955fc4a6c4be454d;
var $e1059775f18d6292$export$635f6273df29ea1c;
var $e1059775f18d6292$export$facc584867c26fde;
var $e1059775f18d6292$export$175dedd748069215;
var $e1059775f18d6292$export$a4fe86229b0e9bdd;
var $e1059775f18d6292$export$6a45284a4b0bf33a;
var $e1059775f18d6292$export$9f6ea8e48bc26eab;
var $e1059775f18d6292$export$a439dc30c845238;
var $e1059775f18d6292$export$b7df5d561049483a;
var $e1059775f18d6292$export$1b47ad771ce5af5e;
var $e1059775f18d6292$export$ac8dfd3a7ad06e80;
var $e1059775f18d6292$export$9384c7afe4015e42;
var $e1059775f18d6292$export$3f23594af5f37336;
var $e1059775f18d6292$export$de363e709c412c8a;
var $e1059775f18d6292$export$4efe28f192921dd4;
var $e1059775f18d6292$export$1a539c8b2950ab40;
var $e1059775f18d6292$export$83e74882c5df8fe1;
var $e1059775f18d6292$export$86fe999fba7953f2;
var $e1059775f18d6292$export$fc00ee57782020aa;
var $e1059775f18d6292$export$45b10814cc054894;
var $e1059775f18d6292$export$8291e5b88f90ce4;
var $e1059775f18d6292$export$f3a19e933f377396;
var $e1059775f18d6292$export$1284415effa79ee0;
var $e1059775f18d6292$export$3182be990e0eeaad;
var $e1059775f18d6292$export$6a5dea797879f644;
var $e1059775f18d6292$export$d449030e5c10edf7;
var $e1059775f18d6292$export$8901015135f2fb22;
var $e1059775f18d6292$export$adddb6a2fa3864e9;
"use strict";

var $eqNaQ = parcelRequire("eqNaQ");
$e1059775f18d6292$export$d779b02e6b68c3e8 = $eqNaQ.audit;

var $imTmw = parcelRequire("imTmw");
$e1059775f18d6292$export$719c70722b10e5ff = $imTmw.auditTime;

var $icZql = parcelRequire("icZql");
$e1059775f18d6292$export$ab1029bcae9ddb4a = $icZql.buffer;

var $9RLLl = parcelRequire("9RLLl");
$e1059775f18d6292$export$8916d2c8119541bb = $9RLLl.bufferCount;

var $34zHs = parcelRequire("34zHs");
$e1059775f18d6292$export$d6b40c95035461c7 = $34zHs.bufferTime;

var $aWZX4 = parcelRequire("aWZX4");
$e1059775f18d6292$export$91115bdd8709945f = $aWZX4.bufferToggle;

var $kkXTB = parcelRequire("kkXTB");
$e1059775f18d6292$export$9e55760d3282e08c = $kkXTB.bufferWhen;

var $e6C7w = parcelRequire("e6C7w");
$e1059775f18d6292$export$3dede90624df3ba9 = $e6C7w.catchError;

var $kKZko = parcelRequire("kKZko");
$e1059775f18d6292$export$29ae691b7de52fe3 = $kKZko.combineAll;

var $cuNVo = parcelRequire("cuNVo");
$e1059775f18d6292$export$77fa7d86f5204e8a = $cuNVo.combineLatest;

var $azHuT = parcelRequire("azHuT");
$e1059775f18d6292$export$ee1b3e54f0441b22 = $azHuT.concat;

var $6moha = parcelRequire("6moha");
$e1059775f18d6292$export$b314777ae20abca9 = $6moha.concatAll;

var $ib0Rz = parcelRequire("ib0Rz");
$e1059775f18d6292$export$c28c8388be0ab31a = $ib0Rz.concatMap;

var $i1FL0 = parcelRequire("i1FL0");
$e1059775f18d6292$export$82fbd7a2841d2484 = $i1FL0.concatMapTo;

var $dKj3R = parcelRequire("dKj3R");
$e1059775f18d6292$export$85b9a36db797e02b = $dKj3R.count;

var $7aklh = parcelRequire("7aklh");
$e1059775f18d6292$export$61fc7d43ac8f84b0 = $7aklh.debounce;

var $5tEcX = parcelRequire("5tEcX");
$e1059775f18d6292$export$7843a4469d64c07e = $5tEcX.debounceTime;

var $dd7Pj = parcelRequire("dd7Pj");
$e1059775f18d6292$export$e4ca6d7b7a6dcf9b = $dd7Pj.defaultIfEmpty;

var $8EnuM = parcelRequire("8EnuM");
$e1059775f18d6292$export$1391212d75b2ee65 = $8EnuM.delay;

var $2cpnk = parcelRequire("2cpnk");
$e1059775f18d6292$export$286ca829307725c9 = $2cpnk.delayWhen;

var $cmRJk = parcelRequire("cmRJk");
$e1059775f18d6292$export$ab9a5985b741fa7a = $cmRJk.dematerialize;

var $1bPST = parcelRequire("1bPST");
$e1059775f18d6292$export$983a3b5fb2f7202e = $1bPST.distinct;

var $gIcfQ = parcelRequire("gIcfQ");
$e1059775f18d6292$export$779c5fb865a0172e = $gIcfQ.distinctUntilChanged;

var $kUQOu = parcelRequire("kUQOu");
$e1059775f18d6292$export$571da16e28367bde = $kUQOu.distinctUntilKeyChanged;

var $hLOVc = parcelRequire("hLOVc");
$e1059775f18d6292$export$91d69c7761a17bbc = $hLOVc.elementAt;

var $6bgMW = parcelRequire("6bgMW");
$e1059775f18d6292$export$7ecc1a3b11b57dab = $6bgMW.every;

var $86pSk = parcelRequire("86pSk");
$e1059775f18d6292$export$31039f1fbd797b9c = $86pSk.exhaust;

var $4mCND = parcelRequire("4mCND");
$e1059775f18d6292$export$d70d492cd31004c0 = $4mCND.exhaustMap;

var $iG5sS = parcelRequire("iG5sS");
$e1059775f18d6292$export$9f77e0932fb78f72 = $iG5sS.expand;

var $4cJXk = parcelRequire("4cJXk");
$e1059775f18d6292$export$3dea766d36a8935f = $4cJXk.filter;

var $k4nsZ = parcelRequire("k4nsZ");
$e1059775f18d6292$export$578723aef62d92f5 = $k4nsZ.finalize;

var $5c9n9 = parcelRequire("5c9n9");
$e1059775f18d6292$export$71aa6c912b956294 = $5c9n9.find;

var $c12op = parcelRequire("c12op");
$e1059775f18d6292$export$de3a4d4a0d731119 = $c12op.findIndex;

var $fVAsD = parcelRequire("fVAsD");
$e1059775f18d6292$export$43128fadae87b74a = $fVAsD.first;

var $kUcWn = parcelRequire("kUcWn");
$e1059775f18d6292$export$3f063810d7bf01bd = $kUcWn.groupBy;

var $iSACE = parcelRequire("iSACE");
$e1059775f18d6292$export$6953b97c7d866605 = $iSACE.ignoreElements;

var $2zIk2 = parcelRequire("2zIk2");
$e1059775f18d6292$export$dd1bc94b04021eeb = $2zIk2.isEmpty;

var $jYVp8 = parcelRequire("jYVp8");
$e1059775f18d6292$export$4c7897fafd92b108 = $jYVp8.last;

var $cVFxd = parcelRequire("cVFxd");
$e1059775f18d6292$export$871de8747c9eaa88 = $cVFxd.map;

var $bAfvi = parcelRequire("bAfvi");
$e1059775f18d6292$export$e0eaf3a86c03b2ad = $bAfvi.mapTo;

var $5krLg = parcelRequire("5krLg");
$e1059775f18d6292$export$76dbd6ffd832405d = $5krLg.materialize;

var $iE370 = parcelRequire("iE370");
$e1059775f18d6292$export$8960430cfd85939f = $iE370.max;

var $kO8p6 = parcelRequire("kO8p6");
$e1059775f18d6292$export$4950aa0f605343fb = $kO8p6.merge;

var $f62NZ = parcelRequire("f62NZ");
$e1059775f18d6292$export$18aef43295bbe906 = $f62NZ.mergeAll;

var $80gxR = parcelRequire("80gxR");
$e1059775f18d6292$export$6b9f6c0d32c093f9 = $80gxR.mergeMap;

var $80gxR = parcelRequire("80gxR");
$e1059775f18d6292$export$5b8affa63fc6df16 = $80gxR.mergeMap;

var $jUshS = parcelRequire("jUshS");
$e1059775f18d6292$export$bd7cfc9a42b8a412 = $jUshS.mergeMapTo;

var $a4CFW = parcelRequire("a4CFW");
$e1059775f18d6292$export$c1fc905202bced53 = $a4CFW.mergeScan;

var $bsM3P = parcelRequire("bsM3P");
$e1059775f18d6292$export$96ec731ed4dcb222 = $bsM3P.min;

var $eGi4b = parcelRequire("eGi4b");
$e1059775f18d6292$export$1364843af8d5a963 = $eGi4b.multicast;

var $9plom = parcelRequire("9plom");
$e1059775f18d6292$export$9007f49c319d1ac7 = $9plom.observeOn;

var $9YhCb = parcelRequire("9YhCb");
$e1059775f18d6292$export$5fba66d61591f42 = $9YhCb.onErrorResumeNext;

var $kN9sY = parcelRequire("kN9sY");
$e1059775f18d6292$export$8f9d79d42bff1aac = $kN9sY.pairwise;

var $hU4zQ = parcelRequire("hU4zQ");
$e1059775f18d6292$export$b29f828819edca8d = $hU4zQ.partition;

var $98ptb = parcelRequire("98ptb");
$e1059775f18d6292$export$c44985b87d605eff = $98ptb.pluck;

var $dZ4Ky = parcelRequire("dZ4Ky");
$e1059775f18d6292$export$89b472e03be495df = $dZ4Ky.publish;

var $gqcmX = parcelRequire("gqcmX");
$e1059775f18d6292$export$16ae46fda9567053 = $gqcmX.publishBehavior;

var $4J0vA = parcelRequire("4J0vA");
$e1059775f18d6292$export$42d9b6b38c68d989 = $4J0vA.publishLast;

var $18m9t = parcelRequire("18m9t");
$e1059775f18d6292$export$1f3342bf81d92d52 = $18m9t.publishReplay;

var $k9N6P = parcelRequire("k9N6P");
$e1059775f18d6292$export$236c05de452bec2 = $k9N6P.race;

var $1hf9S = parcelRequire("1hf9S");
$e1059775f18d6292$export$533b26079ad0b4b = $1hf9S.reduce;

var $eytwZ = parcelRequire("eytwZ");
$e1059775f18d6292$export$76d90c956114f2c2 = $eytwZ.repeat;

var $dy5FK = parcelRequire("dy5FK");
$e1059775f18d6292$export$b39ac5b4ffd1415a = $dy5FK.repeatWhen;

var $cy6Ro = parcelRequire("cy6Ro");
$e1059775f18d6292$export$9369b12211e1fce4 = $cy6Ro.retry;

var $5v6N2 = parcelRequire("5v6N2");
$e1059775f18d6292$export$1281551253cfee02 = $5v6N2.retryWhen;

var $6UJhT = parcelRequire("6UJhT");
$e1059775f18d6292$export$18d0766d894cba0c = $6UJhT.refCount;

var $cv9dl = parcelRequire("cv9dl");
$e1059775f18d6292$export$4812e460280c6ef2 = $cv9dl.sample;

var $9Blm5 = parcelRequire("9Blm5");
$e1059775f18d6292$export$fe33c7b2002d97b0 = $9Blm5.sampleTime;

var $9Fl1U = parcelRequire("9Fl1U");
$e1059775f18d6292$export$c87d910e63d22ed6 = $9Fl1U.scan;

var $eeEii = parcelRequire("eeEii");
$e1059775f18d6292$export$d0a07e60ae428313 = $eeEii.sequenceEqual;

var $7UXWF = parcelRequire("7UXWF");
$e1059775f18d6292$export$ed80d9de1d9df928 = $7UXWF.share;

var $cmzwd = parcelRequire("cmzwd");
$e1059775f18d6292$export$db61d692014e534e = $cmzwd.shareReplay;

var $8n116 = parcelRequire("8n116");
$e1059775f18d6292$export$863d7ca51b416cee = $8n116.single;

var $3ZBte = parcelRequire("3ZBte");
$e1059775f18d6292$export$955fc4a6c4be454d = $3ZBte.skip;

var $eDK1x = parcelRequire("eDK1x");
$e1059775f18d6292$export$635f6273df29ea1c = $eDK1x.skipLast;

var $eZ5AN = parcelRequire("eZ5AN");
$e1059775f18d6292$export$facc584867c26fde = $eZ5AN.skipUntil;

var $bLNAF = parcelRequire("bLNAF");
$e1059775f18d6292$export$175dedd748069215 = $bLNAF.skipWhile;

var $hOuOc = parcelRequire("hOuOc");
$e1059775f18d6292$export$a4fe86229b0e9bdd = $hOuOc.startWith;

var $2GSzx = parcelRequire("2GSzx");
$e1059775f18d6292$export$6a45284a4b0bf33a = $2GSzx.switchAll;

var $jEfnV = parcelRequire("jEfnV");
$e1059775f18d6292$export$9f6ea8e48bc26eab = $jEfnV.switchMap;

var $ixMxd = parcelRequire("ixMxd");
$e1059775f18d6292$export$a439dc30c845238 = $ixMxd.switchMapTo;

var $cQZy3 = parcelRequire("cQZy3");
$e1059775f18d6292$export$b7df5d561049483a = $cQZy3.take;

var $1Zayq = parcelRequire("1Zayq");
$e1059775f18d6292$export$1b47ad771ce5af5e = $1Zayq.takeLast;

var $d98nf = parcelRequire("d98nf");
$e1059775f18d6292$export$ac8dfd3a7ad06e80 = $d98nf.takeUntil;

var $dqok3 = parcelRequire("dqok3");
$e1059775f18d6292$export$9384c7afe4015e42 = $dqok3.takeWhile;

var $j7Dz8 = parcelRequire("j7Dz8");
$e1059775f18d6292$export$3f23594af5f37336 = $j7Dz8.tap;

var $kBrBP = parcelRequire("kBrBP");
$e1059775f18d6292$export$de363e709c412c8a = $kBrBP.throttle;

var $hhdWx = parcelRequire("hhdWx");
$e1059775f18d6292$export$4efe28f192921dd4 = $hhdWx.throttleTime;

var $cvLsC = parcelRequire("cvLsC");
$e1059775f18d6292$export$1a539c8b2950ab40 = $cvLsC.timeInterval;

var $imafm = parcelRequire("imafm");
$e1059775f18d6292$export$83e74882c5df8fe1 = $imafm.timeout;

var $aWA2c = parcelRequire("aWA2c");
$e1059775f18d6292$export$86fe999fba7953f2 = $aWA2c.timeoutWith;

var $21QZF = parcelRequire("21QZF");
$e1059775f18d6292$export$fc00ee57782020aa = $21QZF.timestamp;

var $iQUbM = parcelRequire("iQUbM");
$e1059775f18d6292$export$45b10814cc054894 = $iQUbM.toArray;

var $aJFCj = parcelRequire("aJFCj");
$e1059775f18d6292$export$8291e5b88f90ce4 = $aJFCj.window;

var $1e4sA = parcelRequire("1e4sA");
$e1059775f18d6292$export$f3a19e933f377396 = $1e4sA.windowCount;

var $9nNIL = parcelRequire("9nNIL");
$e1059775f18d6292$export$1284415effa79ee0 = $9nNIL.windowTime;

var $d327T = parcelRequire("d327T");
$e1059775f18d6292$export$3182be990e0eeaad = $d327T.windowToggle;

var $2evIr = parcelRequire("2evIr");
$e1059775f18d6292$export$6a5dea797879f644 = $2evIr.windowWhen;

var $huLMT = parcelRequire("huLMT");
$e1059775f18d6292$export$d449030e5c10edf7 = $huLMT.withLatestFrom;

var $cKFwQ = parcelRequire("cKFwQ");
$e1059775f18d6292$export$8901015135f2fb22 = $cKFwQ.zip;

var $050GT = parcelRequire("050GT");
$e1059775f18d6292$export$adddb6a2fa3864e9 = $050GT.zipAll;

});
parcelRegister("eqNaQ", function(module, exports) {
"use strict";
var $a819a3507909eb98$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $a819a3507909eb98$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $a819a3507909eb98$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $a819a3507909eb98$var$audit;
var $a819a3507909eb98$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a819a3507909eb98$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a819a3507909eb98$var$AuditSubscriber = function(_super) {
    $a819a3507909eb98$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $5PCwK.tryCatch(this.durationSelector)(value);
            if (duration === $iZPYv.errorObject) this.destination.error($iZPYv.errorObject.e);
            else {
                var innerSubscription = $558qb.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("imTmw", function(module, exports) {

$parcel$export(module.exports, "auditTime", () => $d5f539d78db073f3$export$719c70722b10e5ff, (v) => $d5f539d78db073f3$export$719c70722b10e5ff = v);
var $d5f539d78db073f3$export$719c70722b10e5ff;
"use strict";

var $hSQIY = parcelRequire("hSQIY");

var $eqNaQ = parcelRequire("eqNaQ");

var $jKX30 = parcelRequire("jKX30");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $d5f539d78db073f3$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return $eqNaQ.audit(function() {
        return $jKX30.timer(duration, scheduler);
    });
}
$d5f539d78db073f3$export$719c70722b10e5ff = $d5f539d78db073f3$var$auditTime;

});

parcelRegister("kKZko", function(module, exports) {

$parcel$export(module.exports, "combineAll", () => $f1c7acf7b8f94afc$export$29ae691b7de52fe3, (v) => $f1c7acf7b8f94afc$export$29ae691b7de52fe3 = v);
var $f1c7acf7b8f94afc$export$29ae691b7de52fe3;
"use strict";

var $cuNVo = parcelRequire("cuNVo");
function $f1c7acf7b8f94afc$var$combineAll(project) {
    return function(source) {
        return source.lift(new $cuNVo.CombineLatestOperator(project));
    };
}
$f1c7acf7b8f94afc$export$29ae691b7de52fe3 = $f1c7acf7b8f94afc$var$combineAll;

});

parcelRegister("i1FL0", function(module, exports) {

$parcel$export(module.exports, "concatMapTo", () => $d1f8b612dc7f744d$export$82fbd7a2841d2484, (v) => $d1f8b612dc7f744d$export$82fbd7a2841d2484 = v);
var $d1f8b612dc7f744d$export$82fbd7a2841d2484;
"use strict";

var $ib0Rz = parcelRequire("ib0Rz");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $d1f8b612dc7f744d$var$concatMapTo(innerObservable, resultSelector) {
    return $ib0Rz.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$d1f8b612dc7f744d$export$82fbd7a2841d2484 = $d1f8b612dc7f744d$var$concatMapTo;

});

parcelRegister("dKj3R", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("2cpnk", function(module, exports) {
"use strict";
var $19a062c4cc2da585$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $kVLXA = parcelRequire("kVLXA");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $19a062c4cc2da585$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $19a062c4cc2da585$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $19a062c4cc2da585$var$delayWhen;
var $19a062c4cc2da585$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $19a062c4cc2da585$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$DelayWhenSubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $558qb.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($RlQRN.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelayObservable = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $19a062c4cc2da585$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($kVLXA.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelaySubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("cmRJk", function(module, exports) {
"use strict";
var $901137cd6740bf13$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $901137cd6740bf13$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $901137cd6740bf13$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $901137cd6740bf13$var$dematerialize;
var $901137cd6740bf13$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $901137cd6740bf13$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $901137cd6740bf13$var$DeMaterializeSubscriber = function(_super) {
    $901137cd6740bf13$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("1bPST", function(module, exports) {
"use strict";
var $0ddf10adfec7988e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");

var $dwKPr = parcelRequire("dwKPr");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $0ddf10adfec7988e$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $0ddf10adfec7988e$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $0ddf10adfec7988e$var$distinct;
var $0ddf10adfec7988e$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0ddf10adfec7988e$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0ddf10adfec7988e$var$DistinctSubscriber = function(_super) {
    $0ddf10adfec7988e$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $dwKPr.Set();
        if (flushes) this.add($558qb.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.DistinctSubscriber = $0ddf10adfec7988e$var$DistinctSubscriber;

});
parcelRegister("dwKPr", function(module, exports) {

$parcel$export(module.exports, "Set", () => $9d9296b95471d13c$export$bdf4ff5a442cbbc5, (v) => $9d9296b95471d13c$export$bdf4ff5a442cbbc5 = v);
var $9d9296b95471d13c$export$ac57f2e66ff143c0;
var $9d9296b95471d13c$export$bdf4ff5a442cbbc5;
"use strict";

var $hdgV4 = parcelRequire("hdgV4");
function $9d9296b95471d13c$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$9d9296b95471d13c$export$ac57f2e66ff143c0 = $9d9296b95471d13c$var$minimalSetImpl;
$9d9296b95471d13c$export$bdf4ff5a442cbbc5 = $hdgV4.root.Set || $9d9296b95471d13c$var$minimalSetImpl();

});


parcelRegister("kUQOu", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $f3a2013de9cd2068$export$571da16e28367bde, (v) => $f3a2013de9cd2068$export$571da16e28367bde = v);
var $f3a2013de9cd2068$export$571da16e28367bde;
"use strict";

var $gIcfQ = parcelRequire("gIcfQ");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $f3a2013de9cd2068$var$distinctUntilKeyChanged(key, compare) {
    return $gIcfQ.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$f3a2013de9cd2068$export$571da16e28367bde = $f3a2013de9cd2068$var$distinctUntilKeyChanged;

});

parcelRegister("hLOVc", function(module, exports) {
"use strict";
var $cefe537100800401$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cRqdv = parcelRequire("cRqdv");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $cefe537100800401$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $cefe537100800401$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $cefe537100800401$var$elementAt;
var $cefe537100800401$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $cRqdv.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cefe537100800401$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cefe537100800401$var$ElementAtSubscriber = function(_super) {
    $cefe537100800401$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $cRqdv.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("6bgMW", function(module, exports) {
"use strict";
var $4800caf82bf1be15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $4800caf82bf1be15$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $4800caf82bf1be15$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $4800caf82bf1be15$var$every;
var $4800caf82bf1be15$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $4800caf82bf1be15$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4800caf82bf1be15$var$EverySubscriber = function(_super) {
    $4800caf82bf1be15$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("86pSk", function(module, exports) {
"use strict";
var $5e62f491e8caf9f6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $5e62f491e8caf9f6$var$exhaust() {
    return function(source) {
        return source.lift(new $5e62f491e8caf9f6$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $5e62f491e8caf9f6$var$exhaust;
var $5e62f491e8caf9f6$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5e62f491e8caf9f6$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5e62f491e8caf9f6$var$SwitchFirstSubscriber = function(_super) {
    $5e62f491e8caf9f6$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($558qb.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("iG5sS", function(module, exports) {
"use strict";
var $d9906367a8064856$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $d9906367a8064856$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $d9906367a8064856$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $d9906367a8064856$var$expand;
var $d9906367a8064856$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d9906367a8064856$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $d9906367a8064856$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d9906367a8064856$var$ExpandSubscriber = function(_super) {
    $d9906367a8064856$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $5PCwK.tryCatch(this.project)(value, index);
            if (result === $iZPYv.errorObject) destination.error($iZPYv.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($558qb.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.ExpandSubscriber = $d9906367a8064856$var$ExpandSubscriber;

});

parcelRegister("5c9n9", function(module, exports) {
"use strict";
var $3c8557ea635e24ec$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $3c8557ea635e24ec$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $3c8557ea635e24ec$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $3c8557ea635e24ec$var$find;
var $3c8557ea635e24ec$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $3c8557ea635e24ec$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $3c8557ea635e24ec$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3c8557ea635e24ec$var$FindValueSubscriber = function(_super) {
    $3c8557ea635e24ec$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($ggvKU.Subscriber);
module.exports.FindValueSubscriber = $3c8557ea635e24ec$var$FindValueSubscriber;

});

parcelRegister("c12op", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $8bf76f276d4706d4$export$de3a4d4a0d731119, (v) => $8bf76f276d4706d4$export$de3a4d4a0d731119 = v);
var $8bf76f276d4706d4$export$de3a4d4a0d731119;
"use strict";

var $5c9n9 = parcelRequire("5c9n9");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $8bf76f276d4706d4$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $5c9n9.FindValueOperator(predicate, source, true, thisArg));
    };
}
$8bf76f276d4706d4$export$de3a4d4a0d731119 = $8bf76f276d4706d4$var$findIndex;

});

parcelRegister("2zIk2", function(module, exports) {
"use strict";
var $1e013b1fb62a8872$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
function $1e013b1fb62a8872$var$isEmpty() {
    return function(source) {
        return source.lift(new $1e013b1fb62a8872$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $1e013b1fb62a8872$var$isEmpty;
var $1e013b1fb62a8872$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $1e013b1fb62a8872$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1e013b1fb62a8872$var$IsEmptySubscriber = function(_super) {
    $1e013b1fb62a8872$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("5krLg", function(module, exports) {
"use strict";
var $3e145ad44b0c8f28$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cigS2 = parcelRequire("cigS2");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $3e145ad44b0c8f28$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $3e145ad44b0c8f28$var$MaterializeOperator());
    };
}
module.exports.materialize = $3e145ad44b0c8f28$var$materialize;
var $3e145ad44b0c8f28$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3e145ad44b0c8f28$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3e145ad44b0c8f28$var$MaterializeSubscriber = function(_super) {
    $3e145ad44b0c8f28$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($cigS2.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($cigS2.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($cigS2.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("iE370", function(module, exports) {

$parcel$export(module.exports, "max", () => $d92e606630772716$export$8960430cfd85939f, (v) => $d92e606630772716$export$8960430cfd85939f = v);
var $d92e606630772716$export$8960430cfd85939f;
"use strict";

var $1hf9S = parcelRequire("1hf9S");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $d92e606630772716$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $1hf9S.reduce(max);
}
$d92e606630772716$export$8960430cfd85939f = $d92e606630772716$var$max;

});

parcelRegister("jUshS", function(module, exports) {
"use strict";
var $e7e9308f95d0e13e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $e7e9308f95d0e13e$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $e7e9308f95d0e13e$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $e7e9308f95d0e13e$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $e7e9308f95d0e13e$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $e7e9308f95d0e13e$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $e7e9308f95d0e13e$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e7e9308f95d0e13e$var$MergeMapToSubscriber = function(_super) {
    $e7e9308f95d0e13e$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($558qb.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.MergeMapToSubscriber = $e7e9308f95d0e13e$var$MergeMapToSubscriber;

});

parcelRegister("a4CFW", function(module, exports) {
"use strict";
var $755847397ce7390d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $558qb = parcelRequire("558qb");

var $RlQRN = parcelRequire("RlQRN");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $755847397ce7390d$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $755847397ce7390d$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $755847397ce7390d$var$mergeScan;
var $755847397ce7390d$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $755847397ce7390d$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $755847397ce7390d$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $755847397ce7390d$var$MergeScanSubscriber = function(_super) {
    $755847397ce7390d$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $5PCwK.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $iZPYv.errorObject) destination.error($iZPYv.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($558qb.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.MergeScanSubscriber = $755847397ce7390d$var$MergeScanSubscriber;

});

parcelRegister("bsM3P", function(module, exports) {

$parcel$export(module.exports, "min", () => $8587971a238a0187$export$96ec731ed4dcb222, (v) => $8587971a238a0187$export$96ec731ed4dcb222 = v);
var $8587971a238a0187$export$96ec731ed4dcb222;
"use strict";

var $1hf9S = parcelRequire("1hf9S");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $8587971a238a0187$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $1hf9S.reduce(min);
}
$8587971a238a0187$export$96ec731ed4dcb222 = $8587971a238a0187$var$min;

});

parcelRegister("9YhCb", function(module, exports) {
"use strict";
var $7427619b50d20877$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b2CJi = parcelRequire("b2CJi");

var $8hxVz = parcelRequire("8hxVz");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $7427619b50d20877$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $8hxVz.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $7427619b50d20877$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $7427619b50d20877$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $7427619b50d20877$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $8hxVz.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $b2CJi.FromObservable(source, null).lift(new $7427619b50d20877$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $7427619b50d20877$var$onErrorResumeNextStatic;
var $7427619b50d20877$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7427619b50d20877$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $7427619b50d20877$var$OnErrorResumeNextSubscriber = function(_super) {
    $7427619b50d20877$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($558qb.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("hU4zQ", function(module, exports) {

$parcel$export(module.exports, "partition", () => $d08b378cea94b111$export$b29f828819edca8d, (v) => $d08b378cea94b111$export$b29f828819edca8d = v);
var $d08b378cea94b111$export$b29f828819edca8d;
"use strict";

var $226Ym = parcelRequire("226Ym");

var $4cJXk = parcelRequire("4cJXk");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $d08b378cea94b111$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $4cJXk.filter(predicate, thisArg)(source),
            $4cJXk.filter($226Ym.not(predicate, thisArg))(source)
        ];
    };
}
$d08b378cea94b111$export$b29f828819edca8d = $d08b378cea94b111$var$partition;

});
parcelRegister("226Ym", function(module, exports) {

$parcel$export(module.exports, "not", () => $17b12d47d6027eff$export$6003a5f097c73977, (v) => $17b12d47d6027eff$export$6003a5f097c73977 = v);
var $17b12d47d6027eff$export$6003a5f097c73977;
"use strict";
function $17b12d47d6027eff$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$17b12d47d6027eff$export$6003a5f097c73977 = $17b12d47d6027eff$var$not;

});


parcelRegister("dZ4Ky", function(module, exports) {

$parcel$export(module.exports, "publish", () => $a2e4a81c568bee89$export$89b472e03be495df, (v) => $a2e4a81c568bee89$export$89b472e03be495df = v);
var $a2e4a81c568bee89$export$89b472e03be495df;
"use strict";

var $cab1K = parcelRequire("cab1K");

var $eGi4b = parcelRequire("eGi4b");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $a2e4a81c568bee89$var$publish(selector) {
    return selector ? $eGi4b.multicast(function() {
        return new $cab1K.Subject();
    }, selector) : $eGi4b.multicast(new $cab1K.Subject());
}
$a2e4a81c568bee89$export$89b472e03be495df = $a2e4a81c568bee89$var$publish;

});

parcelRegister("gqcmX", function(module, exports) {

$parcel$export(module.exports, "publishBehavior", () => $bf48ab57968dc8ce$export$16ae46fda9567053, (v) => $bf48ab57968dc8ce$export$16ae46fda9567053 = v);
var $bf48ab57968dc8ce$export$16ae46fda9567053;
"use strict";

var $dOAU7 = parcelRequire("dOAU7");

var $eGi4b = parcelRequire("eGi4b");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $bf48ab57968dc8ce$var$publishBehavior(value) {
    return function(source) {
        return $eGi4b.multicast(new $dOAU7.BehaviorSubject(value))(source);
    };
}
$bf48ab57968dc8ce$export$16ae46fda9567053 = $bf48ab57968dc8ce$var$publishBehavior;

});

parcelRegister("4J0vA", function(module, exports) {

$parcel$export(module.exports, "publishLast", () => $370bc2605c2c0a12$export$42d9b6b38c68d989, (v) => $370bc2605c2c0a12$export$42d9b6b38c68d989 = v);
var $370bc2605c2c0a12$export$42d9b6b38c68d989;
"use strict";

var $iHuWn = parcelRequire("iHuWn");

var $eGi4b = parcelRequire("eGi4b");
function $370bc2605c2c0a12$var$publishLast() {
    return function(source) {
        return $eGi4b.multicast(new $iHuWn.AsyncSubject())(source);
    };
}
$370bc2605c2c0a12$export$42d9b6b38c68d989 = $370bc2605c2c0a12$var$publishLast;

});
parcelRegister("iHuWn", function(module, exports) {
"use strict";
var $d9d43e498bd4a03b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $aZdZn = parcelRequire("aZdZn");
/**
 * @class AsyncSubject<T>
 */ var $d9d43e498bd4a03b$var$AsyncSubject = function(_super) {
    $d9d43e498bd4a03b$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aZdZn.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $aZdZn.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($cab1K.Subject);
module.exports.AsyncSubject = $d9d43e498bd4a03b$var$AsyncSubject;

});


parcelRegister("18m9t", function(module, exports) {

$parcel$export(module.exports, "publishReplay", () => $0d37b8adb7daa492$export$1f3342bf81d92d52, (v) => $0d37b8adb7daa492$export$1f3342bf81d92d52 = v);
var $0d37b8adb7daa492$export$1f3342bf81d92d52;
"use strict";

var $dZ0DN = parcelRequire("dZ0DN");

var $eGi4b = parcelRequire("eGi4b");
/* tslint:enable:max-line-length */ function $0d37b8adb7daa492$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $dZ0DN.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $eGi4b.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$0d37b8adb7daa492$export$1f3342bf81d92d52 = $0d37b8adb7daa492$var$publishReplay;

});

parcelRegister("k9N6P", function(module, exports) {

$parcel$export(module.exports, "race", () => $eacabdf976c32cd1$export$236c05de452bec2, (v) => $eacabdf976c32cd1$export$236c05de452bec2 = v);
var $eacabdf976c32cd1$export$236c05de452bec2;
"use strict";

var $8hxVz = parcelRequire("8hxVz");

var $k4aBr = parcelRequire("k4aBr");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $eacabdf976c32cd1$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $8hxVz.isArray(observables[0])) observables = observables[0];
        return source.lift.call($k4aBr.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$eacabdf976c32cd1$export$236c05de452bec2 = $eacabdf976c32cd1$var$race;

});
parcelRegister("k4aBr", function(module, exports) {
"use strict";
var $e9bc67e14bd0a7e5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8hxVz = parcelRequire("8hxVz");

var $dY7et = parcelRequire("dY7et");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
function $e9bc67e14bd0a7e5$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($8hxVz.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $dY7et.ArrayObservable(observables).lift(new $e9bc67e14bd0a7e5$var$RaceOperator());
}
module.exports.race = $e9bc67e14bd0a7e5$var$race;
var $e9bc67e14bd0a7e5$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e9bc67e14bd0a7e5$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $e9bc67e14bd0a7e5$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e9bc67e14bd0a7e5$var$RaceSubscriber = function(_super) {
    $e9bc67e14bd0a7e5$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $558qb.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.RaceSubscriber = $e9bc67e14bd0a7e5$var$RaceSubscriber;

});


parcelRegister("eytwZ", function(module, exports) {
"use strict";
var $a98b25f15eca4f40$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $48SuO = parcelRequire("48SuO");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $a98b25f15eca4f40$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $48SuO.EmptyObservable();
        else if (count < 0) return source.lift(new $a98b25f15eca4f40$var$RepeatOperator(-1, source));
        else return source.lift(new $a98b25f15eca4f40$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $a98b25f15eca4f40$var$repeat;
var $a98b25f15eca4f40$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a98b25f15eca4f40$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a98b25f15eca4f40$var$RepeatSubscriber = function(_super) {
    $a98b25f15eca4f40$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("dy5FK", function(module, exports) {
"use strict";
var $9dd2d9b93d3bba53$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $9dd2d9b93d3bba53$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $9dd2d9b93d3bba53$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $9dd2d9b93d3bba53$var$repeatWhen;
var $9dd2d9b93d3bba53$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9dd2d9b93d3bba53$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9dd2d9b93d3bba53$var$RepeatWhenSubscriber = function(_super) {
    $9dd2d9b93d3bba53$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $cab1K.Subject();
        var retries = $5PCwK.tryCatch(this.notifier)(this.notifications);
        if (retries === $iZPYv.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $558qb.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("9Blm5", function(module, exports) {
"use strict";
var $6fd82278c235c8da$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $hSQIY = parcelRequire("hSQIY");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $6fd82278c235c8da$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        return source.lift(new $6fd82278c235c8da$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $6fd82278c235c8da$var$sampleTime;
var $6fd82278c235c8da$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6fd82278c235c8da$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6fd82278c235c8da$var$SampleTimeSubscriber = function(_super) {
    $6fd82278c235c8da$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($6fd82278c235c8da$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($ggvKU.Subscriber);
function $6fd82278c235c8da$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});

parcelRegister("eeEii", function(module, exports) {
"use strict";
var $a5d1a111eaafe481$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $a5d1a111eaafe481$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $a5d1a111eaafe481$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $a5d1a111eaafe481$var$sequenceEqual;
var $a5d1a111eaafe481$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5d1a111eaafe481$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $a5d1a111eaafe481$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5d1a111eaafe481$var$SequenceEqualSubscriber = function(_super) {
    $a5d1a111eaafe481$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $a5d1a111eaafe481$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $5PCwK.tryCatch(comparor)(a, b);
                if (areEqual === $iZPYv.errorObject) this.destination.error($iZPYv.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($ggvKU.Subscriber);
module.exports.SequenceEqualSubscriber = $a5d1a111eaafe481$var$SequenceEqualSubscriber;
var $a5d1a111eaafe481$var$SequenceEqualCompareToSubscriber = function(_super) {
    $a5d1a111eaafe481$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("cmzwd", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $90031758facaa8d9$export$db61d692014e534e, (v) => $90031758facaa8d9$export$db61d692014e534e = v);
var $90031758facaa8d9$export$db61d692014e534e;
"use strict";

var $dZ0DN = parcelRequire("dZ0DN");
/**
 * @method shareReplay
 * @owner Observable
 */ function $90031758facaa8d9$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($90031758facaa8d9$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$90031758facaa8d9$export$db61d692014e534e = $90031758facaa8d9$var$shareReplay;
function $90031758facaa8d9$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $dZ0DN.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});

parcelRegister("8n116", function(module, exports) {
"use strict";
var $6181429aead68e3f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $bZBGW = parcelRequire("bZBGW");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $6181429aead68e3f$var$single(predicate) {
    return function(source) {
        return source.lift(new $6181429aead68e3f$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $6181429aead68e3f$var$single;
var $6181429aead68e3f$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6181429aead68e3f$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6181429aead68e3f$var$SingleSubscriber = function(_super) {
    $6181429aead68e3f$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $bZBGW.EmptyError);
    };
    return SingleSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("3ZBte", function(module, exports) {
"use strict";
var $2e84226f7a2e14b9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $2e84226f7a2e14b9$var$skip(count) {
    return function(source) {
        return source.lift(new $2e84226f7a2e14b9$var$SkipOperator(count));
    };
}
module.exports.skip = $2e84226f7a2e14b9$var$skip;
var $2e84226f7a2e14b9$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2e84226f7a2e14b9$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e84226f7a2e14b9$var$SkipSubscriber = function(_super) {
    $2e84226f7a2e14b9$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("eDK1x", function(module, exports) {
"use strict";
var $aa88688eacca56e4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cRqdv = parcelRequire("cRqdv");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $aa88688eacca56e4$var$skipLast(count) {
    return function(source) {
        return source.lift(new $aa88688eacca56e4$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $aa88688eacca56e4$var$skipLast;
var $aa88688eacca56e4$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $cRqdv.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $ggvKU.Subscriber(subscriber));
        else return source.subscribe(new $aa88688eacca56e4$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $aa88688eacca56e4$var$SkipLastSubscriber = function(_super) {
    $aa88688eacca56e4$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("eZ5AN", function(module, exports) {
"use strict";
var $ae8b19bf9da600d2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $ae8b19bf9da600d2$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $ae8b19bf9da600d2$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $ae8b19bf9da600d2$var$skipUntil;
var $ae8b19bf9da600d2$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ae8b19bf9da600d2$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ae8b19bf9da600d2$var$SkipUntilSubscriber = function(_super) {
    $ae8b19bf9da600d2$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($558qb.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("bLNAF", function(module, exports) {
"use strict";
var $891a8d1da4eedcb9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $891a8d1da4eedcb9$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $891a8d1da4eedcb9$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $891a8d1da4eedcb9$var$skipWhile;
var $891a8d1da4eedcb9$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $891a8d1da4eedcb9$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $891a8d1da4eedcb9$var$SkipWhileSubscriber = function(_super) {
    $891a8d1da4eedcb9$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("2GSzx", function(module, exports) {

$parcel$export(module.exports, "switchAll", () => $1f59d5e853eec281$export$6a45284a4b0bf33a, (v) => $1f59d5e853eec281$export$6a45284a4b0bf33a = v);
var $1f59d5e853eec281$export$6a45284a4b0bf33a;
"use strict";

var $jEfnV = parcelRequire("jEfnV");

var $4v1QD = parcelRequire("4v1QD");
function $1f59d5e853eec281$var$switchAll() {
    return $jEfnV.switchMap($4v1QD.identity);
}
$1f59d5e853eec281$export$6a45284a4b0bf33a = $1f59d5e853eec281$var$switchAll;

});

parcelRegister("cvLsC", function(module, exports) {
"use strict";
var $91bd31fba290f269$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $hSQIY = parcelRequire("hSQIY");
function $91bd31fba290f269$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        return source.lift(new $91bd31fba290f269$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $91bd31fba290f269$var$timeInterval;
var $91bd31fba290f269$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $91bd31fba290f269$var$TimeInterval;
var $91bd31fba290f269$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $91bd31fba290f269$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $91bd31fba290f269$var$TimeIntervalSubscriber = function(_super) {
    $91bd31fba290f269$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $91bd31fba290f269$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("imafm", function(module, exports) {
"use strict";
var $d5d23adf7cd1097c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hSQIY = parcelRequire("hSQIY");

var $3Oax8 = parcelRequire("3Oax8");

var $ggvKU = parcelRequire("ggvKU");

var $wboEv = parcelRequire("wboEv");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $d5d23adf7cd1097c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    var absoluteTimeout = $3Oax8.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $d5d23adf7cd1097c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $wboEv.TimeoutError()));
    };
}
module.exports.timeout = $d5d23adf7cd1097c$var$timeout;
var $d5d23adf7cd1097c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5d23adf7cd1097c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5d23adf7cd1097c$var$TimeoutSubscriber = function(_super) {
    $d5d23adf7cd1097c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($ggvKU.Subscriber);

});
parcelRegister("wboEv", function(module, exports) {
"use strict";
var $060bd46798dfd391$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $060bd46798dfd391$var$TimeoutError = function(_super) {
    $060bd46798dfd391$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $060bd46798dfd391$var$TimeoutError;

});


parcelRegister("aWA2c", function(module, exports) {
"use strict";
var $7f7b45db3fbc039d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hSQIY = parcelRequire("hSQIY");

var $3Oax8 = parcelRequire("3Oax8");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $7f7b45db3fbc039d$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        var absoluteTimeout = $3Oax8.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $7f7b45db3fbc039d$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $7f7b45db3fbc039d$var$timeoutWith;
var $7f7b45db3fbc039d$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7f7b45db3fbc039d$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7f7b45db3fbc039d$var$TimeoutWithSubscriber = function(_super) {
    $7f7b45db3fbc039d$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($558qb.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("21QZF", function(module, exports) {
"use strict";

var $hSQIY = parcelRequire("hSQIY");

var $cVFxd = parcelRequire("cVFxd");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return $cVFxd.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});

parcelRegister("1e4sA", function(module, exports) {
"use strict";
var $0e4a8eee8029db54$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cab1K = parcelRequire("cab1K");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $0e4a8eee8029db54$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $0e4a8eee8029db54$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $0e4a8eee8029db54$var$windowCount;
var $0e4a8eee8029db54$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0e4a8eee8029db54$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0e4a8eee8029db54$var$WindowCountSubscriber = function(_super) {
    $0e4a8eee8029db54$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $cab1K.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $cab1K.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("9nNIL", function(module, exports) {
"use strict";
var $6d4cd492ea733e7f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $hSQIY = parcelRequire("hSQIY");

var $ggvKU = parcelRequire("ggvKU");

var $kKyYR = parcelRequire("kKyYR");

var $4zTe9 = parcelRequire("4zTe9");
function $6d4cd492ea733e7f$var$windowTime(windowTimeSpan) {
    var scheduler = $hSQIY.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($4zTe9.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($4zTe9.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($kKyYR.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($4zTe9.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($kKyYR.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $6d4cd492ea733e7f$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $6d4cd492ea733e7f$var$windowTime;
var $6d4cd492ea733e7f$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6d4cd492ea733e7f$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $6d4cd492ea733e7f$var$CountedSubject = function(_super) {
    $6d4cd492ea733e7f$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($cab1K.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6d4cd492ea733e7f$var$WindowTimeSubscriber = function(_super) {
    $6d4cd492ea733e7f$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $6d4cd492ea733e7f$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($ggvKU.Subscriber);
function $6d4cd492ea733e7f$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $6d4cd492ea733e7f$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $6d4cd492ea733e7f$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});

parcelRegister("d327T", function(module, exports) {
"use strict";
var $97fd34677c87a2d0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $aZdZn = parcelRequire("aZdZn");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $97fd34677c87a2d0$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $97fd34677c87a2d0$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $97fd34677c87a2d0$var$windowToggle;
var $97fd34677c87a2d0$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $97fd34677c87a2d0$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $97fd34677c87a2d0$var$WindowToggleSubscriber = function(_super) {
    $97fd34677c87a2d0$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $558qb.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $5PCwK.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $iZPYv.errorObject) return this.error($iZPYv.errorObject.e);
            else {
                var window_1 = new $cab1K.Subject();
                var subscription = new $aZdZn.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $558qb.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("2evIr", function(module, exports) {
"use strict";
var $1a057dae5e829efd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $1a057dae5e829efd$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $1a057dae5e829efd$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $1a057dae5e829efd$var$windowWhen;
var $1a057dae5e829efd$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1a057dae5e829efd$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1a057dae5e829efd$var$WindowSubscriber = function(_super) {
    $1a057dae5e829efd$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $cab1K.Subject();
        this.destination.next(window);
        var closingNotifier = $5PCwK.tryCatch(this.closingSelector)();
        if (closingNotifier === $iZPYv.errorObject) {
            var err = $iZPYv.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $558qb.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("050GT", function(module, exports) {

$parcel$export(module.exports, "zipAll", () => $00f100e8dd191728$export$adddb6a2fa3864e9, (v) => $00f100e8dd191728$export$adddb6a2fa3864e9 = v);
var $00f100e8dd191728$export$adddb6a2fa3864e9;
"use strict";

var $cKFwQ = parcelRequire("cKFwQ");
function $00f100e8dd191728$var$zipAll(project) {
    return function(source) {
        return source.lift(new $cKFwQ.ZipOperator(project));
    };
}
$00f100e8dd191728$export$adddb6a2fa3864e9 = $00f100e8dd191728$var$zipAll;

});


parcelRegister("kBXQ9", function(module, exports) {

$parcel$export(module.exports, "fetchConfluencePermissions", () => $62b35d6aa06ad41f$export$332e821aef1400f5);
$parcel$export(module.exports, "fetchConfluenceSpace", () => $62b35d6aa06ad41f$export$41d2a3af49f11b2d);
$parcel$export(module.exports, "fetchUserProperties", () => $62b35d6aa06ad41f$export$71dedae73ec3e04c);
$parcel$export(module.exports, "setUserProperties", () => $62b35d6aa06ad41f$export$d0e176862bf869b8);

var $aq199 = parcelRequire("aq199");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");
function $62b35d6aa06ad41f$export$332e821aef1400f5() {
    return (0, $487fd.default)('/wiki/rest/api/user/current?expand=operations');
}
function $62b35d6aa06ad41f$export$41d2a3af49f11b2d() {
    return (0, $487fd.default)('/wiki/api/v2/spaces?limit=1');
}
function $62b35d6aa06ad41f$export$71dedae73ec3e04c(accountId) {
    return (0, $487fd.default)(`/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`);
}
function $62b35d6aa06ad41f$export$d0e176862bf869b8(accountId, value) {
    const url = `/rest/api/3/user/properties/viewedJswWhiteboardPulse?accountId=${encodeURIComponent(accountId)}`;
    return (0, $aq199.of)(url).mergeMap(()=>fetch(url, {
            method: 'PUT',
            body: JSON.stringify(value)
        })).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
            return (0, $aq199.of)(false);
        }
        return (0, $aq199.of)(value);
    });
}

});

parcelRegister("5uBAa", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_ACCESS_ESTABLISHED", () => $2eb5d524e057b09d$export$86ff0b70bde2d576);
$parcel$export(module.exports, "hasConfluenceAccessEstablished", () => $2eb5d524e057b09d$export$c02c656c5dc2a2ee);
$parcel$export(module.exports, "HAS_CONFLUENCE_SPACES", () => $2eb5d524e057b09d$export$a78459aed6412fc9);
$parcel$export(module.exports, "hasConfluenceSpacesEstablished", () => $2eb5d524e057b09d$export$bcddac2aa11c03a1);
$parcel$export(module.exports, "PULSE_VIEWED_ESTABLISHED", () => $2eb5d524e057b09d$export$aff843e6dd79f5fd);
$parcel$export(module.exports, "hasPulseViewedEstablished", () => $2eb5d524e057b09d$export$1aa51b12785e9723);
$parcel$export(module.exports, "SET_HAS_PULSE_VIEWED_REQUEST", () => $2eb5d524e057b09d$export$af0269ca30d614b8);
$parcel$export(module.exports, "setHasViewedPulseRequest", () => $2eb5d524e057b09d$export$6fa3906ec8cd7234);
$parcel$export(module.exports, "SET_HAS_PULSE_VIEWED_SUCCESS", () => $2eb5d524e057b09d$export$87ad89501ab41856);
$parcel$export(module.exports, "setHasViewedPulseSuccess", () => $2eb5d524e057b09d$export$2b30b32270ccf7af);
$parcel$export(module.exports, "setHasViewedPulseFailure", () => $2eb5d524e057b09d$export$bc640b3001815bc);
$parcel$export(module.exports, "SET_WHITEBOARD_ELIGIBILITY", () => $2eb5d524e057b09d$export$4d0a6a14430368e6);
$parcel$export(module.exports, "setWhiteboardEligibility", () => $2eb5d524e057b09d$export$e965b613697e9fbe);
const $2eb5d524e057b09d$export$86ff0b70bde2d576 = 'state.actions.permissions.CONFLUENCE_ACCESS_ESTABLISHED';
const $2eb5d524e057b09d$export$c02c656c5dc2a2ee = (hasConfluenceAccess)=>({
        type: $2eb5d524e057b09d$export$86ff0b70bde2d576,
        payload: {
            hasConfluenceAccess: hasConfluenceAccess
        }
    });
const $2eb5d524e057b09d$export$a78459aed6412fc9 = 'state.actions.HAS_CONFLUENCE_SPACES';
const $2eb5d524e057b09d$export$bcddac2aa11c03a1 = (hasConfluenceSpaces)=>({
        type: $2eb5d524e057b09d$export$a78459aed6412fc9,
        payload: {
            hasConfluenceSpaces: hasConfluenceSpaces
        }
    });
const $2eb5d524e057b09d$export$aff843e6dd79f5fd = 'state.actions.permissions.PULSE_VIEWED_ESTABLISHED';
const $2eb5d524e057b09d$export$1aa51b12785e9723 = (hasViewedPulse)=>({
        type: $2eb5d524e057b09d$export$aff843e6dd79f5fd,
        payload: {
            hasViewedPulse: hasViewedPulse
        }
    });
const $2eb5d524e057b09d$export$af0269ca30d614b8 = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_REQUEST';
const $2eb5d524e057b09d$export$6fa3906ec8cd7234 = ()=>({
        type: $2eb5d524e057b09d$export$af0269ca30d614b8
    });
const $2eb5d524e057b09d$export$87ad89501ab41856 = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_SUCCESS';
const $2eb5d524e057b09d$export$2b30b32270ccf7af = (hasViewedPulse)=>({
        type: $2eb5d524e057b09d$export$87ad89501ab41856,
        payload: {
            hasViewedPulse: hasViewedPulse
        }
    });
const $2eb5d524e057b09d$export$d8f506a9cdc0255f = 'state.actions.permissions.SET_HAS_PULSE_VIEWED_FAILURE';
const $2eb5d524e057b09d$export$bc640b3001815bc = ()=>({
        type: $2eb5d524e057b09d$export$d8f506a9cdc0255f
    });
const $2eb5d524e057b09d$export$4d0a6a14430368e6 = 'state.actions.permissions.SET_WHITEBOARD_ELIGIBILITY';
const $2eb5d524e057b09d$export$e965b613697e9fbe = ({ flow: flow, cohort: cohort })=>({
        type: $2eb5d524e057b09d$export$4d0a6a14430368e6,
        payload: {
            flow: flow,
            cohort: cohort
        }
    });

});



parcelRegister("gJeI6", function(module, exports) {

$parcel$export(module.exports, "loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic", () => $dee6ada907c443dc$export$f26c26528292651d);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $eN6O2 = parcelRequire("eN6O2");

var $3lZ6i = parcelRequire("3lZ6i");

var $5uBAa = parcelRequire("5uBAa");
const $dee6ada907c443dc$var$loadHasConfluenceSpaces = ()=>(0, $eN6O2.loadConfluenceSpaceService)().map((0, $5uBAa.hasConfluenceSpacesEstablished));
const $dee6ada907c443dc$export$f26c26528292651d = (action$)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(()=>$dee6ada907c443dc$var$loadHasConfluenceSpaces());

});

parcelRegister("d5cBt", function(module, exports) {

$parcel$export(module.exports, "loadHasViewedPulseEpic", () => $64ab000c1c7139d9$export$f180856742fe6c9c);
$parcel$export(module.exports, "setHasViewedPulseEpic", () => $64ab000c1c7139d9$export$b20cea5fdc1cf5e2);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $eN6O2 = parcelRequire("eN6O2");

var $3lZ6i = parcelRequire("3lZ6i");

var $5uBAa = parcelRequire("5uBAa");

var $jG5HW = parcelRequire("jG5HW");
const $64ab000c1c7139d9$var$loadHasViewedPulse = ({ store: store })=>{
    const accountId = (0, $jG5HW.getAtlassianAccountId)(store.getState());
    return (0, $eN6O2.loadHasViewedPulseService)(accountId ?? '').map((0, $5uBAa.hasPulseViewedEstablished));
};
const $64ab000c1c7139d9$export$f180856742fe6c9c = (action$, store)=>action$.ofType((0, $3lZ6i.LOAD_APP_DATA_REQUEST)).flatMap(()=>$64ab000c1c7139d9$var$loadHasViewedPulse({
            store: store
        }));
const $64ab000c1c7139d9$export$b20cea5fdc1cf5e2 = (action$, store)=>action$.ofType((0, $5uBAa.SET_HAS_PULSE_VIEWED_REQUEST)).flatMap(()=>(0, $eN6O2.setHasViewedPulseService)({
            store: store
        }));

});


parcelRegister("51zzD", function(module, exports) {

$parcel$export(module.exports, "refreshBacklog", () => $c0653de01764c7a5$export$d182fa418f4f1d16);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("2JdQp");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("iQCJJ");
parcelRequire("ihPQR");
parcelRequire("1oQta");
parcelRequire("kxK5F");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");

var $gSIcW = parcelRequire("gSIcW");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $jhRgJ = parcelRequire("jhRgJ");
const $c0653de01764c7a5$export$4bac01e56d750d42 = Symbol('STREAM_START_MARKER');
const $c0653de01764c7a5$var$DEBOUNCE_TIME = 1000;
const $c0653de01764c7a5$var$POLLIG_INTERVAL = 600000;
const $c0653de01764c7a5$export$d182fa418f4f1d16 = (debounceScheduler, intervalScheduler, throttleScheduler)=>(action$, store)=>(0, $gSIcW.default)().distinctUntilChanged().debounceTime($c0653de01764c7a5$var$DEBOUNCE_TIME, debounceScheduler) // prevent multiple requests when switching tabs within 1s
        .switchMap((isTabVisible, idx)=>{
            if (!isTabVisible) return (0, $kVLXA.Observable).empty();
            const refreshStream$ = (0, $kVLXA.Observable).interval($c0653de01764c7a5$var$POLLIG_INTERVAL, intervalScheduler).mapTo((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_POLLING))).filter(()=>isTabVisible).filter(()=>!(0, $jhRgJ.hasAnyActiveOptimistic)(store.getState())).filter(()=>(0, $jG5HW.getIsCompanyManaged)(store.getState()));
            return idx === 0 ? refreshStream$.startWith($c0653de01764c7a5$export$4bac01e56d750d42) : refreshStream$.startWith((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_ACTIVE_TAB)));
        }).throttleTime($c0653de01764c7a5$var$POLLIG_INTERVAL, throttleScheduler).filter((action)=>action !== $c0653de01764c7a5$export$4bac01e56d750d42);

});
parcelRegister("gSIcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d01e218c271471$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("iQCJJ");
parcelRequire("d0pqD");

var $laTox = parcelRequire("laTox");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $63d01e218c271471$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $kVLXA.Observable).fromEvent(document, (0, $laTox.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $laTox.isPageVisible)) : new (0, $cab1K.Subject)().startWith(null);
var $63d01e218c271471$export$2e2bcd8739ae039 = $63d01e218c271471$var$getVisibility$;

});


parcelRegister("9kHz3", function(module, exports) {

$parcel$export(module.exports, "workloadModalSubtaskToggleEpic", () => $df37297fbb62cf4c$export$79647fc8c74209a6);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $3FUwR = parcelRequire("3FUwR");

var $lHBhO = parcelRequire("lHBhO");

var $62nZT = parcelRequire("62nZT");
const $df37297fbb62cf4c$export$79647fc8c74209a6 = (action$, store)=>action$.ofType((0, $lHBhO.TOGGLE_INCLUDE_SUBTASKS)).flatMap(()=>{
        const state = store.getState();
        const includeSubtasks = (0, $62nZT.getIncludeSubtasks)(state);
        (0, $3FUwR.setWorkloadSubtaskSettings)(includeSubtasks);
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("lHBhO", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_INCLUDE_SUBTASKS", () => $b05b254e887fdc1d$export$9e8abc0f766522c0);
$parcel$export(module.exports, "SET_INCLUDE_SUBTASKS", () => $b05b254e887fdc1d$export$2bb50ef8dfae1cac);
$parcel$export(module.exports, "toggleIncludeSubtasks", () => $b05b254e887fdc1d$export$4010b3772248a658);
$parcel$export(module.exports, "setIncludeSubtasksAction", () => $b05b254e887fdc1d$export$1c3dc37b8734dfc3);
const $b05b254e887fdc1d$export$9e8abc0f766522c0 = 'state.actions.workload-modal.TOGGLE_INCLUDE_SUBTASKS';
const $b05b254e887fdc1d$export$2bb50ef8dfae1cac = 'state.actions.workload-modal.SET_INCLUDE_SUBTASKS';
const $b05b254e887fdc1d$export$4010b3772248a658 = ()=>({
        type: $b05b254e887fdc1d$export$9e8abc0f766522c0
    });
const $b05b254e887fdc1d$export$1c3dc37b8734dfc3 = (includeSubtasks)=>({
        type: $b05b254e887fdc1d$export$2bb50ef8dfae1cac,
        payload: {
            includeSubtasks: includeSubtasks
        }
    });

});

parcelRegister("62nZT", function(module, exports) {

$parcel$export(module.exports, "getIncludeSubtasks", () => $8bdfa4f07af83349$export$2ada7f35c22b42ed);
$parcel$export(module.exports, "makeWorkLoadByAssignee", () => $8bdfa4f07af83349$export$cfa0f2c87d880353);

var $dGvGJ = parcelRequire("dGvGJ");

var $fn8B5 = parcelRequire("fn8B5");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $dGljH = parcelRequire("dGljH");
const $8bdfa4f07af83349$export$2ada7f35c22b42ed = (state)=>state.ui.workloadModal.includeSubtasks;
const $8bdfa4f07af83349$export$cfa0f2c87d880353 = (0, $dGvGJ.createSelector)([
    (0, $dGljH.makeOrderedVisibleCardsForCardList),
    $8bdfa4f07af83349$export$2ada7f35c22b42ed
], (getOrderedVisibleCardsForCardList, includeSubtasks)=>{
    const getWorkLoadByAssignee = (cardListId)=>{
        let listOfVisibleCards = getOrderedVisibleCardsForCardList(cardListId);
        if (!includeSubtasks) listOfVisibleCards = listOfVisibleCards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel));
        const cardsGroupedByAssigned = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(listOfVisibleCards, (card)=>card.assignee?.id ?? 'unassigned');
        const assignees = Object.values(cardsGroupedByAssigned).map((cardList)=>{
            const initial = {
                name: undefined,
                profilePicture: undefined,
                storyPoints: 0,
                remainingTimeEstimateInSeconds: 0,
                originalTimeEstimateInSeconds: 0,
                issueCount: 0,
                subtaskCount: 0
            };
            return cardList.reduce((prev, card)=>{
                const storyPointIncrement = card.estimate?.storyPoints ?? 0;
                const timeEstimateIncrement = card.estimate?.originalEstimate?.value ?? 0;
                const timeRemainingIncrement = card.estimate?.timeRemainingEstimate?.value ?? 0;
                return {
                    name: card.assignee?.displayName ?? prev.name,
                    profilePicture: card.assignee?.avatarUrl ?? prev.name,
                    storyPoints: prev.storyPoints + storyPointIncrement,
                    originalTimeEstimateInSeconds: prev.originalTimeEstimateInSeconds + timeEstimateIncrement,
                    remainingTimeEstimateInSeconds: prev.remainingTimeEstimateInSeconds + timeRemainingIncrement,
                    issueCount: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? prev.issueCount : prev.issueCount + 1,
                    subtaskCount: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) ? (prev.subtaskCount ?? 0) + 1 : prev.subtaskCount
                };
            }, initial);
        });
        return assignees;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getWorkLoadByAssignee);
});

});



parcelRegister("81CEh", function(module, exports) {

$parcel$export(module.exports, "getHideEpics", () => $20551ed6a1672a5b$export$344e252cb642fb56);
$parcel$export(module.exports, "getHideStatuses", () => $20551ed6a1672a5b$export$d3997e0a815ec9a9);
$parcel$export(module.exports, "getHideVersions", () => $20551ed6a1672a5b$export$bccf76194364adbb);
const $20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX = 'gh.epicShownOnRapidBoard.';
const $20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX = 'gh.statusShownOnRapidBoard.';
const $20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX = 'gh.versionShownOnRapidBoard.';
const $20551ed6a1672a5b$export$344e252cb642fb56 = (boardId)=>localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`) === 'false';
const $20551ed6a1672a5b$export$c9ac14c6e06788a3 = (boardId, hideEpics)=>localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString());
const $20551ed6a1672a5b$export$d3997e0a815ec9a9 = (boardId)=>localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`) === 'false';
const $20551ed6a1672a5b$export$66dad339f6bd60a0 = (boardId, hideStatuses)=>localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString());
const $20551ed6a1672a5b$export$bccf76194364adbb = (boardId)=>localStorage.getItem(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`) === 'false';
const $20551ed6a1672a5b$export$828020f0cfbd3e66 = (boardId, hideVersions)=>localStorage.setItem(`${$20551ed6a1672a5b$var$HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString());

});

parcelRegister("5qbje", function(module, exports) {

$parcel$export(module.exports, "removeLocationLegacyPanelQueryParameters", () => $a12f49547554404b$export$1c4bddcdc8213ef1);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $dJl1T = parcelRequire("dJl1T");

const $a12f49547554404b$export$1c4bddcdc8213ef1 = (location, push)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    const searchValue = search.value();
    let legacyPanelQueryParamRemoved = false;
    const { versionPanel: versionPanel, issueParentPanel: issueParentPanel } = searchValue;
    if (versionPanel) {
        search.unset((0, $4f4a02cead13bb5a$export$9c304e612707f622));
        legacyPanelQueryParamRemoved = true;
    }
    if (issueParentPanel) {
        search.unset((0, $4f4a02cead13bb5a$export$7f765927237d6fb0));
        legacyPanelQueryParamRemoved = true;
    }
    if (legacyPanelQueryParamRemoved) {
        const routerPayload = {
            ...location,
            search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
        };
        (0, $dJl1T.default).safeInfoWithoutCustomerData('backlog.services.routing.legacy-panel-query-parameters', 'Removed legacy panel query parameter(s)', {
            versionPanel: versionPanel,
            issueParentPanel: issueParentPanel
        });
        push(routerPayload);
    }
};

});

parcelRegister("gUpx5", function(module, exports) {

$parcel$export(module.exports, "getCustomDataForMemoryAnalyticsFromUrl", () => $7e5eaaee945296ad$export$f0fe5d1ef77b9f92);

const $7e5eaaee945296ad$export$f0fe5d1ef77b9f92 = ()=>{
    // use the URL parameters to determine whether any panels are open
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const queryParams = new URL(window.location.href).searchParams;
    return {
        isEpicPanelOpen: queryParams.has((0, $4f4a02cead13bb5a$export$ec3c43b997309252)),
        isVersionPanelOpen: queryParams.has((0, $4f4a02cead13bb5a$export$a86c1a6dde9da34f)),
        isIssueViewOpen: queryParams.has((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa))
    };
};

});

parcelRegister("c1MAf", function(module, exports) {

$parcel$export(module.exports, "createStoreWithCache", () => $2c6815b54d8c8758$export$96feb51b037b866);
$parcel$export(module.exports, "unmountCachedStore", () => $2c6815b54d8c8758$export$a0196b1023d1dffd);
$parcel$export(module.exports, "BacklogReduxProvider", () => $2c6815b54d8c8758$export$ab832ec0f3793a0b);
$parcel$export(module.exports, "useBacklogStore", () => $2c6815b54d8c8758$export$bd6baa7168fb537b);
$parcel$export(module.exports, "useBacklogSelector", () => $2c6815b54d8c8758$export$3f6a924af1f755b6);
$parcel$export(module.exports, "useBacklogDispatch", () => $2c6815b54d8c8758$export$230b86ce3b02444b);
$parcel$export(module.exports, "useBacklogActionCreator", () => $2c6815b54d8c8758$export$d20547f842c968f1);
parcelRequire("korqb");

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");

var $5Ue2S = parcelRequire("5Ue2S");

var $46ha9 = parcelRequire("46ha9");

var $guzeq = parcelRequire("guzeq");


var $8HBV0 = parcelRequire("8HBV0");

var $3olna = parcelRequire("3olna");

var $6j9F6 = parcelRequire("6j9F6");
function $2c6815b54d8c8758$export$2e2bcd8739ae039(preloadedState, { rootEpic: rootEpic, dependencies: dependencies }) {
    const middlewares = [
        (0, $8HBV0.default)(dependencies),
        (0, $g3qyq.default)((0, $guzeq.APP_ID)),
        (0, $3olna.default)
    ];
    var _getState, action;
    return (0, $F2Mxm.default)({
        appName: 'backlog',
        rootReducer: $6j9F6.default,
        initialState: preloadedState ?? undefined,
        rootEpic: rootEpic,
        middlewares: middlewares,
        rootEpicDependencies: dependencies
    });
}
const $2c6815b54d8c8758$export$a6385bddcc8e6b77 = new (0, $5Ue2S.CachedStoreManager)({
    storeFactory: $2c6815b54d8c8758$export$2e2bcd8739ae039,
    mergeCachedState: (cachedState, _preloadedState)=>cachedState
});
function $2c6815b54d8c8758$export$96feb51b037b866(boardId, initialState, options) {
    return $2c6815b54d8c8758$export$a6385bddcc8e6b77.createStore(boardId, initialState, options);
}
const $2c6815b54d8c8758$export$a0196b1023d1dffd = ()=>{
    $2c6815b54d8c8758$export$a6385bddcc8e6b77.unmount();
};
const { Provider: $2c6815b54d8c8758$export$ab832ec0f3793a0b, useStore: $2c6815b54d8c8758$export$bd6baa7168fb537b, useSelector: $2c6815b54d8c8758$export$3f6a924af1f755b6, useDispatch: $2c6815b54d8c8758$export$230b86ce3b02444b, useActionCreator: $2c6815b54d8c8758$export$d20547f842c968f1 } = (0, $46ha9.createJiraSoftwareStoreContext)();

});
parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $iR96x = parcelRequire("iR96x");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $dJl1T.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $iR96x.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("5Ue2S", function(module, exports) {

$parcel$export(module.exports, "CachedStoreManager", () => $8f61412efdaebad3$export$519eb0cf9e49db0c);

var $91VA7 = parcelRequire("91VA7");
class $8f61412efdaebad3$export$519eb0cf9e49db0c {
    constructor({ storeFactory: storeFactory, mergeCachedState: mergeCachedState }){
        this.cache = null;
        this.storeFactory = storeFactory;
        this.mergeCachedState = mergeCachedState;
    }
    /**
	 * Return true if the redux state was in cache. In this case, we won't consider
	 * the resources' data.
	 */ hasCachedState(boardId) {
        return Boolean(this.cache && this.cache.boardId === boardId);
    }
    getCachedState(boardId) {
        if (this.cache && this.cache.boardId === boardId) return this.cache.state;
        return null;
    }
    /**
	 * Create a new store, merging a preloadedState with any cached state that was
	 * previously held in memory.
	 */ createStore(boardId, preloadedStateParam, options) {
        // Cast to get rid of Omit<...>. Both types are partial so this is valid
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let preloadedState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(preloadedStateParam);
        const cachedState = this.getCachedState(boardId);
        if (!options.disableStoreCaches && cachedState) preloadedState = this.mergeCachedState(cachedState, preloadedState);
        const store = this.storeFactory(preloadedState, options);
        if (options.disableStoreCaches) return store;
        // On every change copy a reference to the redux state to this
        // `cachedStoreState` object.
        this.unmount();
        this.cache = {
            boardId: boardId,
            state: store.getState(),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unsubscribe: ()=>{}
        };
        this.cache.unsubscribe = store.subscribe(()=>{
            if (this.cache) this.cache.state = store.getState();
        });
        return store;
    }
    /**
	 * Clean-up redux store subscriptions.
	 */ unmount() {
        this.cache?.unsubscribe();
    }
    /**
	 * FOR TESTING ONLY
	 */ getCacheForTesting() {
        return this.cache;
    }
}

});
parcelRegister("91VA7", function(module, exports) {

var $7MmCC = parcelRequire("7MmCC");
/** Used to compose bitmasks for cloning. */ var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $6930df867851495d$var$clone(value) {
    return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $6930df867851495d$var$clone;

});


parcelRegister("46ha9", function(module, exports) {

$parcel$export(module.exports, "createJiraSoftwareStoreContext", () => $b414fa8c478f8909$export$884b1d3e4c97abdd);

var $5uXOq = parcelRequire("5uXOq");

var $bDWQ3 = parcelRequire("bDWQ3");

var $7D59a = parcelRequire("7D59a");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b414fa8c478f8909$var$refEquality = (a, b)=>a === b;
function $b414fa8c478f8909$export$884b1d3e4c97abdd() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
    const useStore = ()=>{
        const store = (0, $5uXOq.useContext)(ctx);
        if (!store) throw new Error('useStore called outside of redux JiraSoftwareStoreContext tree');
        return store;
    };
    function useSelector(selector, equalityFn = $b414fa8c478f8909$var$refEquality) {
        const store = useStore();
        const result = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, // Server state probably wont exist but we can use store.getState in case it does work.
        store.getState, selector, equalityFn);
        return result;
    }
    function useDispatch() {
        const store = useStore();
        return store.dispatch;
    }
    function useActionCreator(actionCreator) {
        const dispatch = useDispatch();
        return (0, $7D59a.useEvent)((...args)=>{
            const action = actionCreator(...args);
            dispatch(action);
        });
    }
    function ReduxProvider(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ctx.Provider, {
            value: props.store
        }, props.children);
    }
    return {
        Provider: ReduxProvider,
        useSelector: useSelector,
        useStore: useStore,
        useDispatch: useDispatch,
        useActionCreator: useActionCreator
    };
}

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});


parcelRegister("8HBV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $633621fea0af4ff8$export$2e2bcd8739ae039);

var $4RHcR = parcelRequire("4RHcR");

var $gccSB = parcelRequire("gccSB");

var $hhweD = parcelRequire("hhweD");

var $f2NGE = parcelRequire("f2NGE");

var $8zOmE = parcelRequire("8zOmE");

var $jG5HW = parcelRequire("jG5HW");

var $3Uc50 = parcelRequire("3Uc50");

var $1wOVq = parcelRequire("1wOVq");
const $633621fea0af4ff8$var$APP_ANALYTICS_PREFIX = 'software-plan-view';
// @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
const $633621fea0af4ff8$var$shouldTriggerAnalytics = ({ type: type } = {})=>(0, $3Uc50.default)()[type] !== undefined;
const $633621fea0af4ff8$var$getAnalyticsForAction = (preActionState, postActionState, action, dependencies)=>(0, $3Uc50.default)()[action.type].map((createAnalytic)=>createAnalytic((0, $3Uc50.ANALYTIC_PREFIX))(preActionState, postActionState, action, dependencies)).filter((analyticEvent)=>analyticEvent != null);
const $633621fea0af4ff8$var$triggerAnalyticsForAction = (analyticEvents, state)=>{
    const triggerSoftwareAnalytics = (0, $1wOVq.triggerAnalytics)($633621fea0af4ff8$var$APP_ANALYTICS_PREFIX);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(analyticEvents)) return;
    analyticEvents.forEach(({ name: name, data: data = {}, trackEvents: trackEvents = [] })=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($4RHcR)))(data, {
            rapidViewId: (0, $jG5HW.getRapidViewId)(state),
            projectId: (0, $jG5HW.projectIdSelector)(state),
            isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state)
        });
        // This is not doing anything, we can remove it as part of
        // https://hello.atlassian.net/browse/CATB-418
        triggerSoftwareAnalytics(name, data);
        trackEvents.forEach((trackEvent)=>{
            const { payload: payload } = trackEvent;
            const { action: action, actionSubject: actionSubject, card: card, ...otherProperties } = payload;
            /**
			 * Fields inputted by the user. When this was created, there was no ability to
			 * add in extra fields in the inline create, so we'll assume it's ONLY summary.
			 */ const issueCreateFieldsUsed = payload.issueCreateFieldsUsed ?? [
                {
                    gqlType: 'JiraSingleLineTextField',
                    issueFieldId: 'summary',
                    issueFieldType: 'summary',
                    isPopulated: true
                }
            ];
            let fieldsPopulated = {};
            if (payload.sessionId !== undefined && !!card) // Fields that can be populated automatically e.g. by filters, swimlanes, postfunctions
            fieldsPopulated = {
                ASSIGNEE: !!card.assignee,
                PARENT: !!card.parentId,
                PRIORITY: !!card.priority,
                FIX_VERSIONS: (0, $f2NGE.getFieldLengthForAnalytics)(card.fixVersions?.length),
                LABELS: (0, $f2NGE.getFieldLengthForAnalytics)(card.labels?.length)
            };
            /**
			 * Facilitate CMP instrumentation for inline creation analytics.
			 *
			 * https://hello.atlassian.net/wiki/spaces/SQE/pages/2613558743/Instrumentation+Spec+Inline+Create+CMP+Boards - ERAI-1376
			 *
			 * The following assumptions are made due to how inline creation is made;
			 * - the only issue create field that is present: summary
			 * - It has to be "backlog" for the source of inline creation, if this is altered in the future, this will not track other sources.
			 */ const additionalPayloads = {
                ...otherProperties,
                isCompanyManaged: (0, $jG5HW.getIsCompanyManaged)(state),
                issueCreateFieldsUsed: issueCreateFieldsUsed,
                fieldsPopulated: fieldsPopulated
            };
            /**
			 * NOTE
			 *
			 * This is a temporary fix for https://hello.atlassian.net/browse/CATB-415
			 *
			 * It should be cleaned up by https://hello.atlassian.net/browse/CATB-418
			 */ if (action && actionSubject) (0, $8zOmE.fireTrackAnalytics)(trackEvent, `${actionSubject} ${action}`, {
                ...additionalPayloads
            });
            else (0, $hhweD.fireTrackAnalytics)(trackEvent, {
                action: payload.action,
                attributes: {
                    ...additionalPayloads
                }
            });
        });
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$633621fea0af4ff8$export$2e2bcd8739ae039 = (dependencies)=>(store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (next)=>(action)=>{
                if (!$633621fea0af4ff8$var$shouldTriggerAnalytics(action)) {
                    next(action);
                    return;
                }
                const preActionState = store.getState();
                next(action);
                const postActionState = store.getState();
                const analyticEvents = $633621fea0af4ff8$var$getAnalyticsForAction(preActionState, postActionState, action, dependencies);
                $633621fea0af4ff8$var$triggerAnalyticsForAction(analyticEvents, postActionState);
            };

});
parcelRegister("4RHcR", function(module, exports) {

var $4NkAS = parcelRequire("4NkAS");

var $9MM2g = parcelRequire("9MM2g");

var $lbyKY = parcelRequire("lbyKY");
/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var $38ada0910bc35ca9$var$assignIn = $9MM2g(function(object, source) {
    $4NkAS(source, $lbyKY(source), object);
});
module.exports = $38ada0910bc35ca9$var$assignIn;

});

parcelRegister("f2NGE", function(module, exports) {

$parcel$export(module.exports, "getFieldLengthForAnalytics", () => $b46d240c3082c919$export$e337040f61dd6dff);
const $b46d240c3082c919$export$e337040f61dd6dff = (length)=>{
    if (!length) return '0';
    if (length > 3) return '>3';
    return String(length);
};

});

parcelRegister("3Uc50", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_PREFIX", () => $922e25649c340829$export$c88107e5c6decd92);
$parcel$export(module.exports, "default", () => $922e25649c340829$export$2e2bcd8739ae039);

var $aB8eX = parcelRequire("aB8eX");

var $3lZ6i = parcelRequire("3lZ6i");

var $3qXBy = parcelRequire("3qXBy");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $8MHVw = parcelRequire("8MHVw");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $likqC = parcelRequire("likqC");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $j0q3O = parcelRequire("j0q3O");

var $36SBa = parcelRequire("36SBa");

var $65Uph = parcelRequire("65Uph");

var $iEYCH = parcelRequire("iEYCH");

var $lASqM = parcelRequire("lASqM");

var $hchCX = parcelRequire("hchCX");

var $9kmfU = parcelRequire("9kmfU");

var $1kERf = parcelRequire("1kERf");

var $f9vTq = parcelRequire("f9vTq");
const $922e25649c340829$export$c88107e5c6decd92 = 'plan-view';
const $922e25649c340829$var$actionAnalyticsMap = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        [(0, $3lZ6i.BACKLOG_VIEW)]: [
            (0, $j0q3O.backlogView)
        ],
        [(0, $3lZ6i.LOAD_APP_DATA_FAILURE)]: [
            (0, $j0q3O.backlogLoadAppDataFailure)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_FAILURE)]: [
            (0, $j0q3O.backlogLoadConfigDataFailure)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_SUCCESS)]: [
            (0, $j0q3O.backlogLoadConfigDataSuccess)
        ],
        [(0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)]: [
            (0, $j0q3O.backlogLoadConfigDataSuccess)
        ],
        [(0, $3lZ6i.REFRESH_DATA_REQUEST)]: [
            (0, $j0q3O.refreshDataRequest)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_SHOW)]: [
            (0, $36SBa.boardIssueMoveShow)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL)]: [
            (0, $36SBa.boardIssueMoveCancel)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE)]: [
            (0, $36SBa.boardIssueMoveExecute)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE_FAILURE)]: [
            (0, $36SBa.boardIssueMoveExecuteFailure)
        ],
        [(0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE_SUCCESS)]: [
            (0, $36SBa.boardIssueMoveExecuteSuccess)
        ],
        [(0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST)]: [
            (0, $65Uph.cardCreateMultipleRequestPerformance)
        ],
        [(0, $hf5c2.CARD_CREATE_SUCCESS)]: [
            (0, $65Uph.cardCreateSuccess),
            (0, $65Uph.cardCreateSuccessPerformance)
        ],
        [(0, $hf5c2.CARD_CREATE_FAILURE)]: [
            (0, $65Uph.cardCreateFailure)
        ],
        [(0, $hf5c2.CARD_CREATE_FILTERED)]: [
            (0, $65Uph.cardCreateFiltered)
        ],
        [(0, $hf5c2.CARD_CREATE_FILTERED_V2)]: [
            (0, $65Uph.cardCreateFilteredV2)
        ],
        [(0, $legw4.CARD_DELETE_REQUEST)]: [
            (0, $65Uph.cardDeleteRequestPerformance)
        ],
        [(0, $legw4.CARD_DELETE_SUCCESS)]: [
            (0, $65Uph.cardDeleteSuccess)
        ],
        [(0, $legw4.CARD_DELETE_FAILURE)]: [
            (0, $65Uph.cardDeleteFailure)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST)]: [
            (0, $65Uph.cardsFlagRequestPerformance)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_SUCCESS)]: [
            (0, $65Uph.cardsFlagSuccess)
        ],
        [(0, $aKajY.CARDS_FLAG_WITH_COMMENT_FAILURE)]: [
            (0, $65Uph.cardsFlagFailure)
        ],
        [(0, $et6P7.CARDS_PARENT_SET_SUCCESS)]: [
            (0, $65Uph.cardsParentSetSuccess)
        ],
        [(0, $et6P7.CARDS_PARENT_SET_FAILURE)]: [
            (0, $65Uph.cardsParentSetFailure)
        ],
        [(0, $likqC.SET_ALL_FILTERS)]: [
            (0, $hchCX.setAllFilters),
            (0, $hchCX.setAllFiltersPerformance)
        ],
        [(0, $38qhf.OPEN_DETAIL_VIEW)]: [
            (0, $65Uph.cardOpenDetailView)
        ],
        [(0, $6GNN7.CARDS_MOVE)]: [
            (0, $65Uph.cardRankRequestPerformance)
        ],
        [(0, $6GNN7.CARDS_MOVE_SUCCESS)]: [
            (0, $65Uph.cardsMoveSuccess)
        ],
        [(0, $6GNN7.CARDS_MOVE_FAILURE)]: [
            (0, $65Uph.cardsMoveFailure)
        ],
        [(0, $jkFPs.SPRINT_CREATE_REQUEST)]: [
            (0, $f9vTq.sprintCreateRequestPerformance)
        ],
        [(0, $jkFPs.SPRINT_CREATE_SUCCESS)]: [
            (0, $f9vTq.sprintCreateSuccess),
            (0, $f9vTq.sprintCreateSuccessPerformance)
        ],
        [(0, $jkFPs.SPRINT_CREATE_FAILURE)]: [
            (0, $f9vTq.sprintCreateFailure)
        ],
        [(0, $d09wv.SPRINT_DELETE_REQUEST)]: [
            (0, $f9vTq.sprintDeleteRequestPerformance)
        ],
        [(0, $d09wv.SPRINT_DELETE_SUCCESS)]: [
            (0, $f9vTq.sprintDeleteSuccessPerformance)
        ],
        [(0, $4mqko.CARD_CLICK)]: [
            (0, $9kmfU.issueViewOpenPerformance)
        ],
        [(0, $8MHVw.FILTERED_CARD_SUCCESS)]: [
            (0, $lASqM.setCustomFiltersPerformance),
            (0, $lASqM.setCustomFiltersSuccess)
        ],
        [(0, $8MHVw.FILTERED_CARD_FAILURE)]: [
            (0, $lASqM.setCustomFiltersFailure)
        ],
        [(0, $8MHVw.REFILTER_SUCCESS)]: [
            (0, $lASqM.setCustomFiltersRefilterSuccess)
        ],
        [(0, $8MHVw.REFILTER_FAILURE)]: [
            (0, $lASqM.setCustomFiltersRefilterFailure)
        ],
        [(0, $8MHVw.FILTERED_CARD_CLEAR_SUCCESS)]: [
            (0, $lASqM.setClearCustomFiltersPerformance),
            (0, $lASqM.setClearCustomFiltersSuccess)
        ],
        [(0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE)]: [
            (0, $lASqM.setClearCustomFiltersFailure)
        ],
        [(0, $aB8eX.BATCH)]: [
            (0, $iEYCH.setCardRequestIndividualResponse)
        ],
        [(0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS)]: [
            (0, $1kERf.cardCreateConfigLoadSuccess)
        ],
        [(0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_FAILURE)]: [
            (0, $1kERf.cardCreateConfigLoadFailure)
        ]
    });
var $922e25649c340829$export$2e2bcd8739ae039 = $922e25649c340829$var$actionAnalyticsMap;

});
parcelRegister("j0q3O", function(module, exports) {

$parcel$export(module.exports, "backlogView", () => $7ba94140e53271d3$export$4696f1f49cfb7d46);
$parcel$export(module.exports, "backlogLoadAppDataFailure", () => $7ba94140e53271d3$export$326068e951e3c300);
$parcel$export(module.exports, "backlogLoadConfigDataFailure", () => $7ba94140e53271d3$export$159273fe78e3d429);
$parcel$export(module.exports, "refreshDataRequest", () => $7ba94140e53271d3$export$7245a5bb55cf1c);
$parcel$export(module.exports, "backlogLoadConfigDataSuccess", () => $7ba94140e53271d3$export$3d70f256a15041c6);

var $hhweD = parcelRequire("hhweD");

var $8zOmE = parcelRequire("8zOmE");

var $6uzgj = parcelRequire("6uzgj");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");

var $h9NU3 = parcelRequire("h9NU3");

var $9MUCL = parcelRequire("9MUCL");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $l89dM = parcelRequire("l89dM");
const $7ba94140e53271d3$export$4696f1f49cfb7d46 = (eventPrefix)=>(preState, state, action)=>{
        const numCards = Object.keys((0, $dGljH.getCards)(state)).length;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const visibleCardIds = (0, $dGljH.getVisibleCardIds)(state);
        const orderedLabels = (0, $dGljH.getOrderedLabels)(state);
        const sprints = (0, $dGljH.getVisibleSprintCardLists)(state);
        const unscheduledSprints = sprints.filter((sprint)=>!sprint.sprintData?.startDate && !sprint.sprintData?.endDate);
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        const boardId = Number((0, $jG5HW.getRapidViewId)(state));
        const isQuickFiltersBarToggled = (0, $8zmNw.getViewSettings)({
            boardId: boardId,
            view: (0, $a4XJc.View).BACKLOG
        })?.showQuickFilters;
        const cmpAttributes = isCompanyManaged && {
            isQuickFiltersBarToggled: isQuickFiltersBarToggled
        };
        const extra = {
            numCards: numCards,
            numSprints: sprints.length,
            numUnscheduledSprints: unscheduledSprints.length,
            hasFilteredIssues: visibleCardIds.length !== numCards,
            numLabels: orderedLabels.length,
            issueResultProjectIds: (0, $jG5HW.getProjectIds)(state)
        };
        const featureAttributes = (0, $6uzgj.getFeatureAnalyticsAttributes)((0, $9Pc1U.getAllFeatures)(state));
        (0, $hhweD.fireTrackAnalytics)(analyticsEvent, {
            action: 'viewed',
            attributes: {
                ...featureAttributes,
                isEpicPanelOpen: (0, $l89dM.getEpicPanel)(state),
                isVersionPanelOpen: (0, $h9NU3.isVersionPanelOpen)(),
                ...extra,
                ...cmpAttributes
            }
        });
        return {
            name: `${eventPrefix}.view`,
            data: {
                ...extra
            }
        };
    };
const $7ba94140e53271d3$export$326068e951e3c300 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-app-data.failure`,
            data: {}
        });
const $7ba94140e53271d3$export$159273fe78e3d429 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load-config-data.failure`,
            data: {}
        });
const $7ba94140e53271d3$export$7245a5bb55cf1c = (eventPrefix)=>(preState, state, action, dependencies)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = dependencies || {};
        if (createAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'backlog refreshed', {
            ...(0, $9MUCL.getAttributes)(state),
            source: action.payload.source
        });
        return {
            name: `${eventPrefix}.refresh`,
            data: {
                source: action.payload.source
            }
        };
    };
const $7ba94140e53271d3$export$3d70f256a15041c6 = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.load-config-data.success`,
            data: {
                numIssueTypes: (0, $74oBv.getBaseLevelCardTypes)(state).length
            }
        });

});
parcelRegister("6uzgj", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $130d3cc5b8e064da$export$ac70e171fbeaebce);
const $130d3cc5b8e064da$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $130d3cc5b8e064da$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$130d3cc5b8e064da$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});

parcelRegister("a4XJc", function(module, exports) {

$parcel$export(module.exports, "View", () => $3338322e4425e825$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $3338322e4425e825$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $3338322e4425e825$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $3338322e4425e825$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $3338322e4425e825$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $3338322e4425e825$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $3338322e4425e825$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $3338322e4425e825$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $3338322e4425e825$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $3338322e4425e825$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $3338322e4425e825$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $3338322e4425e825$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $3338322e4425e825$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $3338322e4425e825$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $3338322e4425e825$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $3338322e4425e825$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $3338322e4425e825$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $3338322e4425e825$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $3338322e4425e825$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $3338322e4425e825$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $3338322e4425e825$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "Panels", () => $3338322e4425e825$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $3338322e4425e825$export$ad46e765f851721f);
const $3338322e4425e825$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $3338322e4425e825$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $3338322e4425e825$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $3338322e4425e825$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $3338322e4425e825$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $3338322e4425e825$export$41073ac826c57195 = 'VERSION_PANEL';
const $3338322e4425e825$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $3338322e4425e825$export$59191afd909777e0 = 'QUICK_FILTERS';
const $3338322e4425e825$export$abd09d2531440e47 = 'COMPACT_MODE';
const $3338322e4425e825$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $3338322e4425e825$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $3338322e4425e825$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $3338322e4425e825$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $3338322e4425e825$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $3338322e4425e825$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $3338322e4425e825$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $3338322e4425e825$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $3338322e4425e825$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $3338322e4425e825$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $3338322e4425e825$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $3338322e4425e825$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $3338322e4425e825$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $3338322e4425e825$export$63993996bfd99919 = 'SHOW_LABELS';
const $3338322e4425e825$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $3338322e4425e825$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $3338322e4425e825$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $3338322e4425e825$export$b94e9de8950563ef = {
    VERSION_PANEL: $3338322e4425e825$export$41073ac826c57195,
    EPIC_PANEL: $3338322e4425e825$export$86bfe5c9d2cf6b7c
};
const $3338322e4425e825$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $3338322e4425e825$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $3338322e4425e825$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $3338322e4425e825$export$79b3cada7e291288
};

});

parcelRegister("8zmNw", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $a5d579bc47cfed7a$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $a5d579bc47cfed7a$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $a5d579bc47cfed7a$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $a5d579bc47cfed7a$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $a5d579bc47cfed7a$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $a5d579bc47cfed7a$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $a5d579bc47cfed7a$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $a5d579bc47cfed7a$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $a5d579bc47cfed7a$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $a5d579bc47cfed7a$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $a5d579bc47cfed7a$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$67e6bba1326e537a);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");

var $duOMW = parcelRequire("duOMW");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $a5d579bc47cfed7a$var$browserLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $duOMW.VIEW_SETTINGS_LOCAL_STORAGE));
const $a5d579bc47cfed7a$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $a4XJc.View).BACKLOG:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BACKLOG}`;
        case (0, $a4XJc.View).BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BOARD}`;
        case (0, $a4XJc.View).JSM_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).JSM_BOARD}`;
        default:
            return 0, $duOMW.VIEW_SETTINGS;
    }
    return 0, $duOMW.VIEW_SETTINGS;
};
const $a5d579bc47cfed7a$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.get(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`) || $a5d579bc47cfed7a$var$browserLocalStorage.get(`${(0, $duOMW.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $a5d579bc47cfed7a$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $a5d579bc47cfed7a$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $duOMW.initialState).isFullscreen;
};
const $a5d579bc47cfed7a$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $duOMW.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $duOMW.initialState).showVersionPanel
    };
};
const $a5d579bc47cfed7a$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, state);
const $a5d579bc47cfed7a$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $a5d579bc47cfed7a$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $a4XJc.Panels).EPIC_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $a4XJc.Panels).VERSION_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $a5d579bc47cfed7a$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $duOMW.initialState).showQuickFilters;
};
const $a5d579bc47cfed7a$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $a5d579bc47cfed7a$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $duOMW.initialState).showCompactMode;
};
const $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $a5d579bc47cfed7a$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    const defaultState = (0, $4R6GH.fg)('jsw_card_cover_image_default_on') ? (0, $duOMW.initialStateNew) : (0, $duOMW.initialState);
    return {
        SHOW_EPICS: state?.showEpics ?? defaultState.showEpics,
        SHOW_STATUSES: state?.showStatuses ?? defaultState.showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? defaultState.showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? defaultState.showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? defaultState.showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? defaultState.showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? defaultState.showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : defaultState.showPriority) ?? defaultState.showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? defaultState.showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : defaultState.showEstimate) ?? defaultState.showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : defaultState.showDaysInColumn) ?? defaultState.showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : defaultState.showDueDate) ?? defaultState.showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : defaultState.showLabels) ?? defaultState.showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? defaultState.showCardCovers
    };
};
const $a5d579bc47cfed7a$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS
    });
};
const $a5d579bc47cfed7a$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $a5d579bc47cfed7a$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $a5d579bc47cfed7a$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $a5d579bc47cfed7a$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $a5d579bc47cfed7a$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $a5d579bc47cfed7a$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $a5d579bc47cfed7a$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $duOMW.initialState).showUnscheduledColumn;
};
const $a5d579bc47cfed7a$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $a5d579bc47cfed7a$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $a5d579bc47cfed7a$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $a5d579bc47cfed7a$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $a5d579bc47cfed7a$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $a5d579bc47cfed7a$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $a5d579bc47cfed7a$export$32c01395d25dfdcc = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $duOMW.initialState).showOfftrackDependencyLines;
};
const $a5d579bc47cfed7a$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $a5d579bc47cfed7a$export$67e6bba1326e537a = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $duOMW.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("duOMW", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $6350b42865dc529c$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $6350b42865dc529c$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $6350b42865dc529c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "initialStateNew", () => $6350b42865dc529c$export$d85d94032b13e11a);
$parcel$export(module.exports, "boardViewTestIds", () => $6350b42865dc529c$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $6350b42865dc529c$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $6350b42865dc529c$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $6350b42865dc529c$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $6350b42865dc529c$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $6350b42865dc529c$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $6350b42865dc529c$export$c0d46007b8549aca);
const $6350b42865dc529c$export$f900da9acbf1ac33 = 'view-settings';
const $6350b42865dc529c$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $6350b42865dc529c$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: false,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$d85d94032b13e11a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: true,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $6350b42865dc529c$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
};
const $6350b42865dc529c$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $6350b42865dc529c$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $6350b42865dc529c$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $6350b42865dc529c$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $6350b42865dc529c$export$c0d46007b8549aca = 'on';
const $6350b42865dc529c$export$788a94e8107fb947 = 'off';

});


parcelRegister("9MUCL", function(module, exports) {

$parcel$export(module.exports, "getAttributes", () => $2e8c6c3e19cea0f9$export$fe94072fee8a6976);

var $2vSU6 = parcelRequire("2vSU6");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");
const $2e8c6c3e19cea0f9$export$fe94072fee8a6976 = (state)=>({
        /*
	 * isIssueDetailVisible prop is being equated with it showing in the future
	 *  because the backlog screen event is fired before the issue details
	 *  actually show, but it showing is conditional on there being a last
	 *  selected issue key
	 */ isIssueDetailVisible: (0, $dGljH.willDetailViewShow)(state),
        boardType: (0, $jG5HW.getBoardType)(state),
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        boardId: (0, $jG5HW.getRapidViewId)(state),
        projectId: (0, $jG5HW.projectIdSelector)(state),
        isReactifiedBacklog: true,
        numSubtasks: (0, $dGljH.numTotalIssueChildren)(state),
        numCompleteSubtasks: (0, $dGljH.numCompleteIssueChildren)(state),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        isInactiveTab: document.hidden,
        estimationStatistic: (0, $45Qwd.getEstimationType)(state),
        isProjectAdmin: (0, $1z1J7.canEditBoardConfig)(state),
        isUIF: true,
        isClassic: (0, $jG5HW.getIsCompanyManaged)(state)
    });

});


parcelRegister("36SBa", function(module, exports) {

$parcel$export(module.exports, "boardIssueMoveShow", () => $220ff2145410d5b4$export$afe8c48481994c25);
$parcel$export(module.exports, "boardIssueMoveCancel", () => $220ff2145410d5b4$export$21c319cd4bbf2b2f);
$parcel$export(module.exports, "boardIssueMoveExecute", () => $220ff2145410d5b4$export$47de1859c695eca7);
$parcel$export(module.exports, "boardIssueMoveExecuteSuccess", () => $220ff2145410d5b4$export$403d172f0e549eb1);
$parcel$export(module.exports, "boardIssueMoveExecuteFailure", () => $220ff2145410d5b4$export$3c31c79b76c3db3b);
const $220ff2145410d5b4$export$afe8c48481994c25 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.show`
        });
const $220ff2145410d5b4$export$21c319cd4bbf2b2f = (eventPrefix)=>()=>({
            name: `${eventPrefix}.board-issue-move.cancel`
        });
const $220ff2145410d5b4$export$47de1859c695eca7 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $220ff2145410d5b4$export$403d172f0e549eb1 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.success`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $220ff2145410d5b4$export$3c31c79b76c3db3b = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.board-issue-move.execute.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });

});

parcelRegister("65Uph", function(module, exports) {

$parcel$export(module.exports, "cardCreateSuccess", () => $3895e17f29bd590b$export$b70c18d8546382b2);
$parcel$export(module.exports, "cardCreateFailure", () => $3895e17f29bd590b$export$151deebc0c103b3c);
$parcel$export(module.exports, "cardCreateFiltered", () => $3895e17f29bd590b$export$f069b59557af9611);
$parcel$export(module.exports, "cardCreateFilteredV2", () => $3895e17f29bd590b$export$f1c368b5cfb9b941);
$parcel$export(module.exports, "cardDeleteSuccess", () => $3895e17f29bd590b$export$abf29851b85a5dc);
$parcel$export(module.exports, "cardDeleteFailure", () => $3895e17f29bd590b$export$14995a1d9fdd27aa);
$parcel$export(module.exports, "cardsFlagSuccess", () => $3895e17f29bd590b$export$656497d228a51fa0);
$parcel$export(module.exports, "cardsFlagFailure", () => $3895e17f29bd590b$export$a54ef1c368494a58);
$parcel$export(module.exports, "cardOpenDetailView", () => $3895e17f29bd590b$export$acfe54087abfec17);
$parcel$export(module.exports, "cardCreateMultipleRequestPerformance", () => $3895e17f29bd590b$export$13e8b731273e5b62);
$parcel$export(module.exports, "cardCreateSuccessPerformance", () => $3895e17f29bd590b$export$496eebfe0f44eeed);
$parcel$export(module.exports, "cardRankRequestPerformance", () => $3895e17f29bd590b$export$195ac2f6e1a95c77);
$parcel$export(module.exports, "cardDeleteRequestPerformance", () => $3895e17f29bd590b$export$d3ff2e6ac38e63d6);
$parcel$export(module.exports, "cardsMoveSuccess", () => $3895e17f29bd590b$export$d9bd27fc2155921d);
$parcel$export(module.exports, "cardsMoveFailure", () => $3895e17f29bd590b$export$418f4abeb5fa5e63);
$parcel$export(module.exports, "cardsFlagRequestPerformance", () => $3895e17f29bd590b$export$dc3005aa374f7956);
$parcel$export(module.exports, "cardsParentSetSuccess", () => $3895e17f29bd590b$export$30fe913aeacc7d4c);
$parcel$export(module.exports, "cardsParentSetFailure", () => $3895e17f29bd590b$export$24c3df942a1f1dd5);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $8zOmE = parcelRequire("8zOmE");

var $4G04L = parcelRequire("4G04L");

var $f01qr = parcelRequire("f01qr");


var $gZhS0 = parcelRequire("gZhS0");

var $8hVbJ = parcelRequire("8hVbJ");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $k35me = parcelRequire("k35me");
const $3895e17f29bd590b$export$d516175c274e4e4b = (cardId, issueTypeId, createdWithRank)=>({
        actionSubjectId: cardId,
        objectType: 'issue',
        objectId: cardId,
        issueTypeId: issueTypeId,
        createdWithRank: createdWithRank
    });
const $3895e17f29bd590b$export$b70c18d8546382b2 = (eventPrefix)=>(preState, state, action)=>{
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        const cardId = action.payload.card.id;
        const issueTypeId = action.payload.card.typeId;
        const { createdWithRank: createdWithRank } = action.payload;
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        const trackEvents = [];
        const event = analyticsEvent?.clone();
        if (event != null) trackEvents.push(event.update({
            ...$3895e17f29bd590b$export$d516175c274e4e4b(cardId, issueTypeId, createdWithRank),
            appliedFilters: Object.keys(filterValues),
            card: action.payload.card
        }));
        return {
            name: `${eventPrefix}.card.create.success`,
            data: {
                cardId: cardId,
                issueTypeId: issueTypeId,
                transactionId: action.meta.optimistic.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            },
            trackEvents: trackEvents
        };
    };
const $3895e17f29bd590b$export$151deebc0c103b3c = (eventPrefix)=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { errorMessage: errorMessage, statusCode: statusCode, numCards: numCards, isClientFetchError: isClientFetchError } } = action;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        if (analyticsEvent) for(let i = 0; i < numCards; i += 1){
            const clonedAnalyticsEvent = analyticsEvent.clone();
            // Will be null if it's already been fired
            if (clonedAnalyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(clonedAnalyticsEvent, 'issue createdFailed', {
                errorMessage: errorMessage,
                isClientFetchError: isClientFetchError,
                statusCode: statusCode,
                isCompanyManaged: isCompanyManaged
            });
        }
        return {
            name: `${eventPrefix}.card.create.failure`,
            data: {
                transactionId: action.meta.optimistic.id,
                isCompanyManaged: isCompanyManaged
            }
        };
    };
const $3895e17f29bd590b$export$f069b59557af9611 = (eventPrefix)=>(preState, state, action)=>{
        const card = action.payload;
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardId: card.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $3895e17f29bd590b$export$f1c368b5cfb9b941 = (eventPrefix)=>(preState, state, action)=>{
        const cardIds = action.payload;
        const filterValues = (0, $l9VFH.getFilters)(state);
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-card-filtered.shown`,
            data: {
                cardIds: cardIds,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $3895e17f29bd590b$export$abf29851b85a5dc = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).stop({
            customData: {
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
        return {
            name: `${eventPrefix}.card.delete.success`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $3895e17f29bd590b$export$14995a1d9fdd27aa = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).cancel();
        return {
            name: `${eventPrefix}.card.delete.failure`,
            data: {
                cardId: action.payload.cardId
            }
        };
    };
const $3895e17f29bd590b$export$656497d228a51fa0 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).stop({
            customData: {
                ...(0, $gZhS0.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        const { cards: cards } = action.payload;
        const flagDirection = (0, $dGljH.getCards)(state)[String(cards[0])].isFlagged ? 'added' : 'removed';
        return {
            name: `${eventPrefix}.cards.flag.${flagDirection}`,
            data: {
                numCards: cards.length
            }
        };
    };
const $3895e17f29bd590b$export$a54ef1c368494a58 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).cancel();
        const { cards: cards } = action.payload;
        return {
            name: `${eventPrefix}.cards.flag.failure`,
            data: {
                numCards: cards.length
            }
        };
    };
const $3895e17f29bd590b$export$acfe54087abfec17 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.card.open-detail-view`,
            data: {
                cardId: action.payload.cardId
            }
        });
const $3895e17f29bd590b$export$13e8b731273e5b62 = ()=>(preState, state, action)=>{
        const concurrentIds = action.payload.tempIds;
        concurrentIds.forEach((concurrentId)=>{
            (0, $8hVbJ.issueCreateInteraction)(String(concurrentId)).start();
        });
        (0, $4G04L.scheduleAfterRender)(()=>{
            concurrentIds.forEach((concurrentId)=>{
                (0, $8hVbJ.issueCreateInteraction)(String(concurrentId)).mark('feedback');
            });
        });
        return null;
    };
const $3895e17f29bd590b$export$496eebfe0f44eeed = ()=>(preState, state, action)=>{
        const { payload: { temporaryCardId: temporaryCardId, listId: listId, createdWithBulk: createdWithBulk } } = action;
        const concurrentId = String(temporaryCardId);
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        // listId potential values: 'BOARD', 'BACKLOG' or sprintId e.g. '155'
        const cardListType = Number.isInteger(Number(listId)) ? 'SPRINT' : listId;
        (0, $8hVbJ.issueCreateInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state),
                cardListType: cardListType,
                createdWithBulk: createdWithBulk,
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $3895e17f29bd590b$export$195ac2f6e1a95c77 = ()=>()=>{
        (0, $8hVbJ.issueRankInteraction).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.issueRankInteraction).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$d3ff2e6ac38e63d6 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.issueDeleteInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.issueDeleteInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$d9bd27fc2155921d = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        const isActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state);
        cardIds.forEach((id)=>(0, $f01qr.sendSuccessToMoveAnalytic)(id, // @ts-expect-error Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent.clone(), cardListId, isActiveSprint));
        (0, $8hVbJ.issueRankInteraction).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state),
                isCompanyManaged: isCompanyManaged
            }
        });
        return null;
    };
const $3895e17f29bd590b$export$418f4abeb5fa5e63 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent }, payload: { error: error, cardIds: cardIds, cardListId: cardListId } } = action;
        if (!analyticsEvent) return null;
        const isActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state);
        (0, $f01qr.sendFailToMoveAnalytic)(analyticsEvent, cardIds, error, cardListId, isActiveSprint);
        (0, $8hVbJ.issueRankInteraction).cancel();
        return null;
    };
const $3895e17f29bd590b$export$dc3005aa374f7956 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $8hVbJ.flagToggleInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.flagToggleInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $3895e17f29bd590b$export$30fe913aeacc7d4c = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.success`
        });
const $3895e17f29bd590b$export$24c3df942a1f1dd5 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.cards.parent-set.failure`
        });

});
parcelRegister("k12ix", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $c2cbddd7f2605816$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $c2cbddd7f2605816$export$de03840ff3eb49a4);

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
const $c2cbddd7f2605816$var$PERF_FF_PREFIX = 'jsw.perf.';
const $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST = new Set([
    'fe.platform.error.tracking.enabled',
    'jsw-epic-panel-performance-async-epic-details'
]);
const $c2cbddd7f2605816$var$getPerformanceFFs = (0, $8QpSo.default)(()=>{
    const featureFlags = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($c2cbddd7f2605816$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($c2cbddd7f2605816$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(featureFlags);
});
const $c2cbddd7f2605816$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $c2cbddd7f2605816$export$448575db1388a8e6 = (0, $8QpSo.default)((whitelist = $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($c2cbddd7f2605816$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $c2cbddd7f2605816$export$c983ad7dc5517558 = (0, $8QpSo.default)(()=>JSON.stringify($c2cbddd7f2605816$var$getPerformanceFFs()));
const $c2cbddd7f2605816$export$de03840ff3eb49a4 = (0, $8QpSo.default)(()=>{
    const featureEntries = Object.entries({
        ...$c2cbddd7f2605816$var$getPerformanceFFs(),
        ...$c2cbddd7f2605816$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("gZhS0", function(module, exports) {

$parcel$export(module.exports, "getBacklogCardCount", () => $3f1c907b3819a10a$export$b90897b496813c20);

var $dGljH = parcelRequire("dGljH");
const $3f1c907b3819a10a$export$b90897b496813c20 = (state)=>({
        cardsCount: Object.keys((0, $dGljH.getCards)(state)).length,
        visibleCardsCount: (0, $dGljH.getVisibleCardIds)(state).length
    });

});


parcelRegister("iEYCH", function(module, exports) {

$parcel$export(module.exports, "setCardRequestIndividualResponse", () => $da7cf263c2da6fe9$export$b8a62aa106707ded);

var $8zOmE = parcelRequire("8zOmE");

var $js96S = parcelRequire("js96S");
const $da7cf263c2da6fe9$export$b8a62aa106707ded = (eventPrefix)=>(preState, state, action)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const successActions = action.payload.filter((innerAction)=>innerAction.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_SUCCESS));
        const commonAttributes = {
            isContextualEditing: true
        };
        if (successActions.length) (0, $8zOmE.fireTrackAnalytics)(successActions[0].meta.analyticsEvent, 'field updated', commonAttributes);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const failureActions = action.payload.filter((innerAction)=>innerAction.type === (0, $js96S.CARD_SET_INDIVIDUAL_REQUEST_FAILURE));
        if (failureActions.length) (0, $8zOmE.fireOperationalAnalytics)(failureActions[0].meta.analyticsEvent, 'field updateFailed', {
            ...commonAttributes,
            successCount: successActions.length,
            failureCount: failureActions.length,
            statusCode: failureActions[0].payload.statusCode
        });
        return {
            name: `${eventPrefix}.set-card-request.execute-individual.response`
        };
    };

});

parcelRegister("lASqM", function(module, exports) {

$parcel$export(module.exports, "setCustomFiltersPerformance", () => $b33ffd7246c68f9a$export$a4497c4897069a2b);
$parcel$export(module.exports, "setCustomFiltersFailure", () => $b33ffd7246c68f9a$export$b6336fdfea9c7130);
$parcel$export(module.exports, "setCustomFiltersSuccess", () => $b33ffd7246c68f9a$export$807bc3d6fd05a3f8);
$parcel$export(module.exports, "setClearCustomFiltersFailure", () => $b33ffd7246c68f9a$export$8390cb5d2e786615);
$parcel$export(module.exports, "setClearCustomFiltersSuccess", () => $b33ffd7246c68f9a$export$7705547b216dde);
$parcel$export(module.exports, "setClearCustomFiltersPerformance", () => $b33ffd7246c68f9a$export$c95dc6c32e218669);
$parcel$export(module.exports, "setCustomFiltersRefilterSuccess", () => $b33ffd7246c68f9a$export$be433321d98a3ffa);
$parcel$export(module.exports, "setCustomFiltersRefilterFailure", () => $b33ffd7246c68f9a$export$d76e8115781031ba);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $4G04L = parcelRequire("4G04L");

var $hJnrC = parcelRequire("hJnrC");

var $jG5HW = parcelRequire("jG5HW");
const $b33ffd7246c68f9a$export$a4497c4897069a2b = ()=>(preState, state, action)=>{
        const { meta: { numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hJnrC.stopCustomFilterInteraction)(numCustomFiltersApplied, numIssueIds, isCompanyManaged);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$b6336fdfea9c7130 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'customFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $hJnrC.cancelCustomFilterInteraction)();
        return null;
    };
const $b33ffd7246c68f9a$export$807bc3d6fd05a3f8 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'customFilters applied', {
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        });
        return null;
    };
const $b33ffd7246c68f9a$export$8390cb5d2e786615 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'clearCustomFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $hJnrC.cancelClearCustomFilterInteraction)();
        return null;
    };
const $b33ffd7246c68f9a$export$7705547b216dde = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'clearCustomFilters applied');
        return null;
    };
const $b33ffd7246c68f9a$export$c95dc6c32e218669 = ()=>(preState, state)=>{
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hJnrC.stopClearCustomFilterInteraction)(isCompanyManaged);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$be433321d98a3ffa = ()=>(preState, state, action)=>{
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'applied',
                attributes: {
                    excludedCards: excludedCardIds.length,
                    filteredCards: filteredCardIds.length
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };
const $b33ffd7246c68f9a$export$d76e8115781031ba = ()=>(preState, state, action)=>{
        const { error: error } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'backlog',
                actionSubject: 'customFiltersRefilter',
                action: 'failed',
                attributes: {
                    isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                    errorMessage: error?.message
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return null;
    };

});
parcelRegister("hJnrC", function(module, exports) {

$parcel$export(module.exports, "setCustomFilterInteractionFeedbackMark", () => $df84e2ee7edada30$export$5dd87a22b8e2c81c);
$parcel$export(module.exports, "setCustomFilterInteractionStartMark", () => $df84e2ee7edada30$export$600569a4fb9e5675);
$parcel$export(module.exports, "cancelCustomFilterInteraction", () => $df84e2ee7edada30$export$178f6b8399be6909);
$parcel$export(module.exports, "stopCustomFilterInteraction", () => $df84e2ee7edada30$export$90db63ac5c02197a);
$parcel$export(module.exports, "setClearCustomFilterInteractionStartMark", () => $df84e2ee7edada30$export$962ac6dbaf359610);
$parcel$export(module.exports, "stopClearCustomFilterInteraction", () => $df84e2ee7edada30$export$6960edeeed3db8b2);
$parcel$export(module.exports, "cancelClearCustomFilterInteraction", () => $df84e2ee7edada30$export$9ff508c2f230f886);

var $k12ix = parcelRequire("k12ix");

var $8hVbJ = parcelRequire("8hVbJ");
const $df84e2ee7edada30$export$5dd87a22b8e2c81c = ()=>{
    (0, $8hVbJ.customFilterInteraction).mark('feedback');
};
const $df84e2ee7edada30$export$600569a4fb9e5675 = ()=>{
    (0, $8hVbJ.customFilterInteraction).start();
};
const $df84e2ee7edada30$export$178f6b8399be6909 = ()=>{
    (0, $8hVbJ.customFilterInteraction).cancel();
};
const $df84e2ee7edada30$export$90db63ac5c02197a = (numCustomFiltersApplied, numIssueIds, isCompanyManaged)=>{
    (0, $8hVbJ.customFilterInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds,
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $df84e2ee7edada30$export$962ac6dbaf359610 = ()=>{
    (0, $8hVbJ.clearCustomFilterInteraction).start();
};
const $df84e2ee7edada30$export$6960edeeed3db8b2 = (isCompanyManaged)=>{
    (0, $8hVbJ.clearCustomFilterInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $df84e2ee7edada30$export$9ff508c2f230f886 = ()=>{
    (0, $8hVbJ.clearCustomFilterInteraction).cancel();
};

});


parcelRegister("hchCX", function(module, exports) {

$parcel$export(module.exports, "setAllFilters", () => $eca15b66a6aed40e$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setAllFiltersPerformance", () => $eca15b66a6aed40e$export$338d2cd01a36c93d);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");


var $8hVbJ = parcelRequire("8hVbJ");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $9ZuIF = parcelRequire("9ZuIF");
const $eca15b66a6aed40e$export$c48d1dabfffb8ec0 = (eventPrefix)=>(preState, state)=>{
        const totalAssigneeCount = (0, $dGljH.getOrderedAssignees)(state).length;
        return {
            name: `${eventPrefix}.filters.show`,
            data: {
                numAvatarsDisplayed: totalAssigneeCount > (0, $41ce9b5576b92b7a$export$360e7ca29749d455) ? (0, $41ce9b5576b92b7a$export$360e7ca29749d455) : totalAssigneeCount
            }
        };
    };
const $eca15b66a6aed40e$export$556a5ff7bd7ac86 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.filters.search-field.focus`,
            data: {}
        });
const $eca15b66a6aed40e$export$5845d1911d8d06dd = (eventPrefix)=>(preState)=>{
        const selectedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $l9VFH.getFilters)(preState), [
            'values'
        ]);
        return {
            name: `${eventPrefix}.filters.clear-button.click`,
            data: {
                numSelectedAvatars: (selectedFilters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] || []).length
            }
        };
    };
const $eca15b66a6aed40e$var$getFilterAnalyticsData = (state)=>{
    const filters = (0, $l9VFH.getFilters)(state);
    const assigneeFilters = filters[0, $41ce9b5576b92b7a$export$f8f7545d2bb78afb] || [];
    const labelFilters = filters[0, $41ce9b5576b92b7a$export$37aee82a3cb1e8f7] || [];
    const issueParentFilters = filters[0, $41ce9b5576b92b7a$export$2a4f270075a033de] || [];
    const versionFilters = filters[0, $41ce9b5576b92b7a$export$a4ad2735b021c132] || [];
    const issueTypeFilters = filters[0, $41ce9b5576b92b7a$export$ebb48b08205007c5] || [];
    const currentUser = (0, $9ZuIF.getCurrentUser)(state);
    return {
        numSelectedAvatars: assigneeFilters.length,
        isAssignedToMeSelected: currentUser ? assigneeFilters.indexOf(currentUser.id) > -1 : false,
        numSelectedLabels: labelFilters.length,
        numVisibleIssues: (0, $dGljH.getVisibleCardIds)(state).length,
        numSelectedIssueParents: issueParentFilters.length,
        numSelectedVersions: versionFilters.length,
        numSelectedIssueTypes: issueTypeFilters.length
    };
};
const $eca15b66a6aed40e$export$1e6b2e9f0ff84131 = (eventPrefix)=>(preState, state, action)=>{
        const { filterType: filterType } = action.meta;
        if (filterType) {
            let actionName = 'select';
            const filters = (0, $l9VFH.getFilters)(state);
            if (filterType === (0, $41ce9b5576b92b7a$export$d597759d33be802e) && !filters[0, $41ce9b5576b92b7a$export$d597759d33be802e]) actionName = 'deselect';
            else {
                const preFilters = (0, $l9VFH.getFilters)(preState);
                actionName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
                    filterType
                ], []).length < (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(preFilters, [
                    filterType
                ], []).length ? 'deselect' : actionName;
            }
            return {
                name: `${eventPrefix}.filters.${filterType}.${actionName}`,
                data: $eca15b66a6aed40e$var$getFilterAnalyticsData(state)
            };
        }
        return null;
    };
const $eca15b66a6aed40e$export$338d2cd01a36c93d = ()=>(preState, state, action)=>{
        const { filters: filters } = action.payload;
        const filterType = Object.keys(filters || {});
        const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
        filterType.sort();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.filterInteraction).stop({
                customData: {
                    ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                    filterType: filterType.join(',') || 'CLEAR',
                    isCompanyManaged: isCompanyManaged
                }
            });
        });
        return null;
    };

});

parcelRegister("9kmfU", function(module, exports) {

$parcel$export(module.exports, "issueViewOpenPerformance", () => $5527b94c194d23b8$export$2da4dabf4eeee402);

var $3iMqq = parcelRequire("3iMqq");

var $8hVbJ = parcelRequire("8hVbJ");
const $5527b94c194d23b8$export$2da4dabf4eeee402 = ()=>(prevState, state, action)=>{
        if (!action.payload.withCmd && !action.payload.withShift) {
            (0, $3iMqq.default)('backlog.issue-view-opened');
            (0, $8hVbJ.issueViewOpenInteraction).start();
        }
        return null;
    };

});

parcelRegister("1kERf", function(module, exports) {

$parcel$export(module.exports, "cardCreateConfigLoadFailure", () => $2118f0cebbe48a34$export$55f7f50ae5d386e);
$parcel$export(module.exports, "cardCreateConfigLoadSuccess", () => $2118f0cebbe48a34$export$30b096da81e0022e);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");
const $2118f0cebbe48a34$export$55f7f50ae5d386e = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message,
            statusCode: error?.statusCode
        });
        return null;
    };
const $2118f0cebbe48a34$export$30b096da81e0022e = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCreateConfigLoad success');
        return null;
    };

});

parcelRegister("f9vTq", function(module, exports) {

$parcel$export(module.exports, "sprintCreateRequestPerformance", () => $1bb8e5aebc1865f7$export$a2c86d07fe1585ea);
$parcel$export(module.exports, "sprintCreateSuccessPerformance", () => $1bb8e5aebc1865f7$export$ffb3b8195785fb3e);
$parcel$export(module.exports, "sprintDeleteRequestPerformance", () => $1bb8e5aebc1865f7$export$ffd831d4c6f0494);
$parcel$export(module.exports, "sprintDeleteSuccessPerformance", () => $1bb8e5aebc1865f7$export$795344b111af47fb);
$parcel$export(module.exports, "sprintCreateSuccess", () => $1bb8e5aebc1865f7$export$4bedc2fcbe2138bd);
$parcel$export(module.exports, "sprintCreateFailure", () => $1bb8e5aebc1865f7$export$cb20bc93da1235f7);

var $k12ix = parcelRequire("k12ix");

var $8zOmE = parcelRequire("8zOmE");

var $4G04L = parcelRequire("4G04L");

var $gZhS0 = parcelRequire("gZhS0");

var $8hVbJ = parcelRequire("8hVbJ");
const $1bb8e5aebc1865f7$export$a2c86d07fe1585ea = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.temporaryCardListId;
        (0, $8hVbJ.createSprintInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.createSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$ffb3b8195785fb3e = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryCardListId);
        (0, $8hVbJ.createSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$ffd831d4c6f0494 = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $8hVbJ.deleteSprintInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $8hVbJ.deleteSprintInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$795344b111af47fb = ()=>(preState, state, action)=>{
        const concurrentId = action.payload.sprintId;
        (0, $8hVbJ.deleteSprintInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $gZhS0.getBacklogCardCount)(state)
            }
        });
    };
const $1bb8e5aebc1865f7$export$4bedc2fcbe2138bd = ()=>(preState, state, action)=>{
        const { payload: payload, meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const trackEvent = analyticsEvent.clone();
        if (trackEvent) {
            const didSprintCreateWithDefaultDates = Boolean(payload.sprint.sprintData?.startDate);
            (0, $8zOmE.fireTrackAnalytics)(trackEvent, 'sprint created', {
                didSprintCreateWithDefaultDates: didSprintCreateWithDefaultDates
            });
        }
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $8zOmE.fireOperationalAnalytics)(opEvent, 'ui taskSuccess', {
            task: 'createSprint'
        });
        return null;
    };
const $1bb8e5aebc1865f7$export$cb20bc93da1235f7 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent } } = action;
        if (!analyticsEvent) return null;
        const opEvent = analyticsEvent.clone();
        if (opEvent) (0, $8zOmE.fireOperationalAnalytics)(opEvent, 'ui taskFail', {
            task: 'createSprint'
        });
        return null;
    };

});


parcelRegister("1wOVq", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $d61bdc31368fd475$export$2c57de8a70f64057);
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $d61bdc31368fd475$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);

});


parcelRegister("3olna", function(module, exports) {

$parcel$export(module.exports, "default", () => $2049d23ef66afe52$export$2e2bcd8739ae039);


var $hi6AJ = parcelRequire("hi6AJ");

var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $8MHVw = parcelRequire("8MHVw");

var $lReb9 = parcelRequire("lReb9");

var $cscVG = parcelRequire("cscVG");

var $fdAim = parcelRequire("fdAim");

var $9tZuw = parcelRequire("9tZuw");

var $4mqko = parcelRequire("4mqko");

var $cPahM = parcelRequire("cPahM");

var $38qhf = parcelRequire("38qhf");

var $eMLHT = parcelRequire("eMLHT");

var $likqC = parcelRequire("likqC");

var $5Eoed = parcelRequire("5Eoed");

var $9g0YE = parcelRequire("9g0YE");

var $c7Xu8 = parcelRequire("c7Xu8");

var $ubpiL = parcelRequire("ubpiL");

var $bI3co = parcelRequire("bI3co");

var $gwOHY = parcelRequire("gwOHY");
// We ignore the success and failure mutations, we just invalidate them as soon as the request
// is fired. That way if someone navigates away before the SUCCESS/FAILURE mutation returns they
// won't get an incorrect cached version
const $2049d23ef66afe52$var$BACKLOG_IGNORE_REGEX = /^(state\.actions\.).+(_SUCCESS|_FAILURE)$/;
// This one helps us ignore junk like COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION
const $2049d23ef66afe52$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.actions\.).+$/;
const $2049d23ef66afe52$export$d4b7dead01a52ae = ({ type: type })=>{
    switch(type){
        case 0, $3lZ6i.REFRESH_DATA_REQUEST:
        case 0, $3lZ6i.LOAD_APP_DATA_REQUEST:
        case 0, $3lZ6i.LOAD_CONFIG_DATA_REQUEST:
        case 0, $c7Xu8.LOAD_PRIORITIES_REQUEST:
        case 0, $3lZ6i.SET_CONFIG_DATA:
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
        case 0, $3lZ6i.SET_APP_DATA:
        case 0, $bI3co.REQUEST_CURRENT_USER:
        case 0, $bI3co.SET_CURRENT_USER:
        case 0, $3lZ6i.INITIALIZE_APP_PROPS:
        case 0, $3lZ6i.BACKLOG_VIEW:
        case 0, $likqC.SET_ALL_FILTERS:
        case 0, $cPahM.SET_COLUMNS:
        case 0, $cscVG.CARD_PREV:
        case 0, $cscVG.CARD_NEXT:
        case 0, $lReb9.CARD_FOCUS:
        case 0, $lReb9.CARD_BLUR:
        case 0, $9tZuw.SET_RICH_ACTIVE_CARD:
        case 0, $4mqko.CARD_CLICK:
        case 0, $4mqko.CARD_SINGLE_SELECT:
        case 0, $4mqko.SET_LAST_SELECTED_CARD_KEY:
        case 0, $a7yHf.CARD_LIST_TOGGLE:
        case 0, $a7yHf.SET_COLLAPSED_CARD_LIST:
        case 0, $38qhf.OPEN_DETAIL_VIEW:
        case 0, $38qhf.CLOSE_DETAIL_VIEW:
        case 0, $5Eoed.OPEN_MODAL:
        case 0, $5Eoed.CLOSE_MODAL:
        case 0, $ubpiL.REALTIME_DISPATCH_EVENT_BATCH:
        case 0, $9tZuw.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
        case 0, $fdAim.CARD_REFRESH_REQUEST:
        case 0, $eMLHT.DRAG_START:
        case 0, $eMLHT.DRAG_END:
        case 0, $38qhf.UPDATE_DETAIL_VIEW:
        case 0, $4mqko.CARD_EMPTY_SELECTION:
        case 0, $4mqko.PARENT_CLICK:
        case 0, $a7yHf.CARD_LISTS_ENABLE_ALL:
        case 0, $4mqko.CARD_TOGGLE_SELECTION:
        case 0, $8MHVw.FILTERED_CARD_CLEAR:
        case 0, $a7yHf.CARD_LISTS_DISABLE:
        case 0, $38qhf.OPEN_DETAIL_VIEW_DEBOUNCED:
        case 0, $4mqko.CARD_MULTI_SELECT:
        case 0, $9g0YE.CLOSE_INSIGHTS_PANEL:
        case 0, $gwOHY.SET_VERSIONS:
        case 0, $9g0YE.SET_ALL_PANELS:
        case 0, $9g0YE.SET_ALL_PANELS_SUCCESS:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable to the board (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    // Test against board specific actions
    if (!$2049d23ef66afe52$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $2049d23ef66afe52$var$BACKLOG_IGNORE_REGEX.exec(type)) return false;
    // DEFAULT TO TRUE. It's better to forcibly refresh the cache if someone forgets to add
    // their mutation here
    return true;
};
var $2049d23ef66afe52$export$2e2bcd8739ae039 = (0, $hi6AJ.default)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), $2049d23ef66afe52$export$d4b7dead01a52ae);

});
parcelRegister("hi6AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1904eee7acf3b502$export$2e2bcd8739ae039);

var $b0yad = parcelRequire("b0yad");
const $1904eee7acf3b502$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $b0yad.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $1904eee7acf3b502$export$2e2bcd8739ae039 = $1904eee7acf3b502$export$41c940a04807c68c((0, $b0yad.default));

});

parcelRegister("9tZuw", function(module, exports) {

$parcel$export(module.exports, "SET_RICH_ACTIVE_CARD", () => $a3e6803fcd7c890e$export$4c9169a58b37875e);
$parcel$export(module.exports, "setRichActiveCard", () => $a3e6803fcd7c890e$export$64729d240866f3ef);
$parcel$export(module.exports, "SET_CARD_ID_WITH_ABOVE_ICC_OPEN", () => $a3e6803fcd7c890e$export$ec2969f9f94bf260);
$parcel$export(module.exports, "setCardIdWithAboveICCOpen", () => $a3e6803fcd7c890e$export$77d156de930b02f2);
const $a3e6803fcd7c890e$export$4c9169a58b37875e = 'state.actions.cards.rich-card.SET_RICH_ACTIVE_CARD';
const $a3e6803fcd7c890e$export$64729d240866f3ef = (cardId)=>({
        type: $a3e6803fcd7c890e$export$4c9169a58b37875e,
        payload: {
            cardId: cardId
        }
    });
const $a3e6803fcd7c890e$export$ec2969f9f94bf260 = 'state.actions.cards.rich-card.SET_CARD_ID_WITH_ABOVE_ICC_OPEN';
const $a3e6803fcd7c890e$export$77d156de930b02f2 = (cardId)=>({
        type: $a3e6803fcd7c890e$export$ec2969f9f94bf260,
        payload: {
            cardId: cardId
        }
    });

});

parcelRegister("eMLHT", function(module, exports) {

$parcel$export(module.exports, "DRAG_START", () => $cd7b4e6c2d61a9be$export$56a2165aef3d890f);
$parcel$export(module.exports, "dragStart", () => $cd7b4e6c2d61a9be$export$c34730c351bf3a09);
$parcel$export(module.exports, "DRAG_END", () => $cd7b4e6c2d61a9be$export$fc1141357993c252);
$parcel$export(module.exports, "dragEnd", () => $cd7b4e6c2d61a9be$export$5d38b0bd4bef40ba);
$parcel$export(module.exports, "BEFORE_CAPTURE", () => $cd7b4e6c2d61a9be$export$243992ddf18a3626);
$parcel$export(module.exports, "beforeCapture", () => $cd7b4e6c2d61a9be$export$f9e12102ea5efb98);
$parcel$export(module.exports, "TRANSITION_ZONE_ENTER", () => $cd7b4e6c2d61a9be$export$204c8582fbaab1b9);
$parcel$export(module.exports, "transitionZoneEnter", () => $cd7b4e6c2d61a9be$export$105dc40c43a094f8);
$parcel$export(module.exports, "TRANSITION_ZONE_LEAVE", () => $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d);
$parcel$export(module.exports, "transitionZoneLeave", () => $cd7b4e6c2d61a9be$export$a9aed1d92a4d13b4);
const $cd7b4e6c2d61a9be$export$56a2165aef3d890f = 'state.actions.drag.DRAG_START';
const $cd7b4e6c2d61a9be$export$c34730c351bf3a09 = ()=>({
        type: $cd7b4e6c2d61a9be$export$56a2165aef3d890f
    });
const $cd7b4e6c2d61a9be$export$fc1141357993c252 = 'state.actions.drag.DRAG_END';
const $cd7b4e6c2d61a9be$export$5d38b0bd4bef40ba = ()=>({
        type: $cd7b4e6c2d61a9be$export$fc1141357993c252
    });
const $cd7b4e6c2d61a9be$export$243992ddf18a3626 = 'state.actions.drag.BEFORE_CAPTURE';
const $cd7b4e6c2d61a9be$export$f9e12102ea5efb98 = (sourceCardGroupType, sourceCardListId, isSubtask, sourceParentId)=>({
        type: $cd7b4e6c2d61a9be$export$243992ddf18a3626,
        payload: {
            sourceCardGroupType: sourceCardGroupType,
            sourceCardListId: sourceCardListId,
            isSubtask: isSubtask,
            sourceParentId: sourceParentId
        }
    });
const $cd7b4e6c2d61a9be$export$204c8582fbaab1b9 = 'state.actions.drag.TRANSITION_ZONE_ENTER';
const $cd7b4e6c2d61a9be$export$105dc40c43a094f8 = ()=>({
        type: $cd7b4e6c2d61a9be$export$204c8582fbaab1b9
    });
const $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d = 'state.actions.drag.TRANSITION_ZONE_LEAVE';
const $cd7b4e6c2d61a9be$export$a9aed1d92a4d13b4 = ()=>({
        type: $cd7b4e6c2d61a9be$export$b6bb144f1db68c2d
    });

});


parcelRegister("6j9F6", function(module, exports) {

$parcel$export(module.exports, "default", () => $736b3bfcb1b5ed36$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $heEMQ = parcelRequire("heEMQ");

var $li1vk = parcelRequire("li1vk");

var $dN8hL = parcelRequire("dN8hL");
var $736b3bfcb1b5ed36$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    ui: $dN8hL.default,
    // Need cast to open-up store to | type that isn't only handling optimistic
    // state. This is due to `optimistic(...)` from redux-optimistic-ui not
    // being fully type-safe.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    entities: (0, $li1vk.default),
    config: $heEMQ.default
});

});
parcelRegister("heEMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb17f8a619b8d234$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $7Jxgt = parcelRequire("7Jxgt");

var $lzeFL = parcelRequire("lzeFL");

var $l2T6l = parcelRequire("l2T6l");

var $gBj4V = parcelRequire("gBj4V");

var $3lZ6i = parcelRequire("3lZ6i");

var $dzRFd = parcelRequire("dzRFd");

var $hseEV = parcelRequire("hseEV");

var $fNaAq = parcelRequire("fNaAq");

var $5uBAa = parcelRequire("5uBAa");

var $1Xr8M = parcelRequire("1Xr8M");
const $cb17f8a619b8d234$var$defaultState = {
    locale: (0, $lzeFL.defaultLocale),
    baseUrl: '',
    rapidViewId: '',
    isCompanyManaged: false,
    projectKey: '',
    projectId: 1,
    projectName: '',
    rankCustomFieldId: 0,
    // @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'Permissions': CAN_CREATE_ISSUES, CAN_DELETE_ISSUES, CAN_MANAGE_SPRINTS, CAN_EDIT_ISSUES, CAN_EDIT_BOARD_CONFIG
    permissions: {},
    timeTrackingOptions: (0, $gBj4V.defaultTimeTrackingOptions),
    cloudId: '',
    atlassianAccountId: null,
    xsrfToken: '',
    backlogStrategy: 'NONE',
    name: '',
    sprintFieldId: null,
    storyPointFieldId: null,
    epicIssueType: null,
    epicLinkField: null,
    jqlQuery: null,
    isInlineCardCreateEnabled: false,
    requestColumnMigration: false,
    extension: {
        operations: []
    },
    allFeatures: [],
    version: {
        isVersionsFeatureEnabled: false
    },
    sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
    kanbanBoardColumnId: null,
    kanbanBacklogColumnId: null,
    isOrderedByRank: true,
    showEpicAsPanel: false,
    canInviteOthersToProject: false,
    whiteboardsEntrypointExperimentConfig: {
        hasConfluenceAccess: false,
        hasConfluenceSpaces: false,
        hasViewedPulse: true,
        eligibility: {
            flow: null,
            cohort: 'not-enrolled'
        }
    }
};
function $cb17f8a619b8d234$export$2e2bcd8739ae039(state = $cb17f8a619b8d234$var$defaultState, action) {
    switch(action.type){
        case 0, $3lZ6i.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload,
                sessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4()
            };
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return (0, $7uUwQ.merge)((0, $7uUwQ.merge)(state, action.payload.config), {
                permissions: state.permissions
            });
        case 0, $3lZ6i.SET_APP_DATA:
        case 0, $3lZ6i.SET_CONFIG_DATA:
            return (0, $7uUwQ.merge)((0, $7uUwQ.merge)(state, action.payload.config), {
                permissions: (0, $7uUwQ.merge)(state.permissions, action.payload.config.permissions)
            });
        case 0, $fNaAq.FETCH_PERMISSIONS_SUCCESS:
            return (0, $7uUwQ.merge)(state, {
                permissions: (0, $7uUwQ.merge)(state.permissions, action.payload.permissions)
            });
        case 0, $hseEV.EXTENSION_FETCH_SUCCESS:
            return (0, $l2T6l.chainUnsafe)(state).set('extension', (0, $1Xr8M.default)(state.extension, action)).value();
        case 0, $dzRFd.SET_CAN_USER_INVITE:
            return (0, $7uUwQ.merge)(state, {
                canInviteOthersToProject: action.payload.canInviteOthersToProject
            });
        case 0, $5uBAa.CONFLUENCE_ACCESS_ESTABLISHED:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasConfluenceAccess: action.payload.hasConfluenceAccess
                }
            });
        case 0, $5uBAa.HAS_CONFLUENCE_SPACES:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasConfluenceSpaces: action.payload.hasConfluenceSpaces
                }
            });
        case 0, $5uBAa.PULSE_VIEWED_ESTABLISHED:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasViewedPulse: action.payload.hasViewedPulse
                }
            });
        case 0, $5uBAa.SET_HAS_PULSE_VIEWED_SUCCESS:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    hasViewedPulse: action.payload.hasViewedPulse
                }
            });
        case 0, $5uBAa.SET_WHITEBOARD_ELIGIBILITY:
            return (0, $7uUwQ.merge)(state, {
                whiteboardsEntrypointExperimentConfig: {
                    ...state.whiteboardsEntrypointExperimentConfig,
                    eligibility: {
                        flow: action.payload.flow,
                        cohort: action.payload.cohort
                    }
                }
            });
        default:
            return state;
    }
}

});
parcelRegister("l2T6l", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $10cc07b888293773$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $10cc07b888293773$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $10cc07b888293773$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $10cc07b888293773$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $10cc07b888293773$export$181c753256d1c9a0);

var $7uUwQ = parcelRequire("7uUwQ");
const $10cc07b888293773$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assoc(collection, key, value);
const $10cc07b888293773$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.set(collection, key, value);
const $10cc07b888293773$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.dissoc(collection, key);
const $10cc07b888293773$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.unset(collection, key);
const $10cc07b888293773$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assocIn(collection, path, value);
const $10cc07b888293773$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.setIn(collection, path, value);
const $10cc07b888293773$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.getIn(collection, path);
const $10cc07b888293773$export$f920b8c255ec1192 = (collection, path, callback)=>$7uUwQ.updateIn(collection, path, callback);
class $10cc07b888293773$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $7uUwQ.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $10cc07b888293773$export$181c753256d1c9a0 = (collection)=>new $10cc07b888293773$var$IcepickUnsafeWrapper(collection);

});

parcelRegister("1Xr8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ded37837b2ccf8$export$2e2bcd8739ae039);

var $hseEV = parcelRequire("hseEV");
const $98ded37837b2ccf8$var$initialState = {
    operations: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$98ded37837b2ccf8$export$2e2bcd8739ae039 = (state = $98ded37837b2ccf8$var$initialState, action)=>{
    if (action.type === (0, $hseEV.EXTENSION_FETCH_SUCCESS)) return action.payload.extension;
    return state;
};

});


parcelRegister("li1vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e7c4b16e186663$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $alNv9 = parcelRequire("alNv9");

var $3mKMp = parcelRequire("3mKMp");

var $bgMYY = parcelRequire("bgMYY");

var $vE7h8 = parcelRequire("vE7h8");

var $9yRWt = parcelRequire("9yRWt");

var $aLuWu = parcelRequire("aLuWu");

var $5nW8W = parcelRequire("5nW8W");

var $cj2CS = parcelRequire("cj2CS");

var $3Ek8N = parcelRequire("3Ek8N");

var $hDT0g = parcelRequire("hDT0g");

var $d74Q9 = parcelRequire("d74Q9");

var $lRpaB = parcelRequire("lRpaB");

var $aQATd = parcelRequire("aQATd");

var $bA8dH = parcelRequire("bA8dH");

var $bgxMB = parcelRequire("bgxMB");

var $3zbT1 = parcelRequire("3zbT1");

var $9tayK = parcelRequire("9tayK");

var $7k9YH = parcelRequire("7k9YH");

var $4Q0MU = parcelRequire("4Q0MU");

var $4lJeG = parcelRequire("4lJeG");
var $44e7c4b16e186663$export$2e2bcd8739ae039 = (0, $alNv9.optimistic)((0, $3f2cs.combineReducers)({
    card: (0, $5nW8W.default),
    cardList: (0, $bgMYY.default),
    cardListOrder: (0, $3mKMp.default),
    cardOrder: (0, $9yRWt.default),
    cardOrderGlobal: (0, $vE7h8.default),
    column: (0, $cj2CS.default),
    currentUser: (0, $3Ek8N.default),
    customFilters: (0, $hDT0g.customFiltersReducer),
    cardTypes: (0, $aLuWu.default),
    estimation: (0, $d74Q9.default),
    tracking: (0, $7k9YH.trackingReducer),
    inlineCreate: (0, $lRpaB.default),
    issueParents: (0, $bA8dH.default),
    issueParentsOrder: (0, $aQATd.default),
    priorities: (0, $3zbT1.default),
    project: (0, $9tayK.default),
    versions: (0, $4lJeG.versionsReducer),
    version: (0, $4Q0MU.default),
    lastCreatedCardId: (0, $bgxMB.default)
}));

});
parcelRegister("3mKMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4048878690a248f$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $dkxyn = parcelRequire("dkxyn");
const $c4048878690a248f$var$defaultState = [];
const $c4048878690a248f$var$cardListOrderReducer = (state = $c4048878690a248f$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardListOrder;
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            {
                const backlogIndex = state.indexOf((0, $guzeq.BACKLOG));
                return (0, $7uUwQ.splice)(state, backlogIndex, 0, action.payload.temporaryCardListId);
            }
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            {
                const tempIndex = state.indexOf(action.payload.temporaryCardListId);
                return (0, $7uUwQ.splice)(state, tempIndex, 1, action.payload.sprint.id);
            }
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            return (0, $7uUwQ.splice)(state, state.indexOf(action.payload.sprintId), 1);
        case 0, $dkxyn.SPRINT_MOVE_REQUEST:
            {
                const { payload: { sprintId: sprintId, targetSprintId: targetSprintId, direction: direction } } = action;
                const sprintIndex = state.indexOf(sprintId);
                const otherSprintIndex = state.indexOf(targetSprintId);
                if (direction === (0, $guzeq.SPRINT_MOVE_TO_TOP)) {
                    const activeSprints = state.slice(0, otherSprintIndex);
                    const inactiveSprints = state.slice(otherSprintIndex);
                    inactiveSprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinInactives = inactiveSprints.indexOf(sprintId);
                    // move sprint to the top of targetSprintId, but below active sprints
                    return [
                        ...activeSprints,
                        sprintId,
                        ...(0, $7uUwQ.splice)(inactiveSprints, sprintIndexWithinInactives, 1),
                        (0, $guzeq.BACKLOG)
                    ];
                }
                if (direction === (0, $guzeq.SPRINT_MOVE_TO_BOTTOM)) {
                    const sprints = state;
                    sprints.pop(); // pop the "BACKLOG" sprint
                    const sprintIndexWithinSprints = sprints.indexOf(sprintId);
                    return [
                        ...(0, $7uUwQ.splice)(sprints, sprintIndexWithinSprints, 1),
                        sprintId,
                        (0, $guzeq.BACKLOG)
                    ];
                }
                return (0, $7uUwQ.chain)(state).set(sprintIndex, targetSprintId).set(otherSprintIndex, sprintId).value();
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $c4048878690a248f$export$2e2bcd8739ae039 = $c4048878690a248f$var$cardListOrderReducer;

});

parcelRegister("bgMYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4a2668b04c6af0$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $l2T6l = parcelRequire("l2T6l");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");

var $ksKI7 = parcelRequire("ksKI7");
const $9d4a2668b04c6af0$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d4a2668b04c6af0$export$2e2bcd8739ae039 = (state = $9d4a2668b04c6af0$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardList;
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            return (0, $7uUwQ.assign)(state, {
                [action.payload.temporaryCardListId]: {
                    id: String(action.payload.temporaryCardListId),
                    name: 'Sprint',
                    type: (0, $guzeq.SPRINT),
                    issueListKey: null,
                    isOptimistic: true,
                    sprintData: {
                        goal: '',
                        startDate: '',
                        endDate: '',
                        daysRemaining: 0,
                        state: 'FUTURE',
                        canUpdateSprint: true
                    }
                }
            });
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            return (0, $l2T6l.chainUnsafe)(state).set(action.payload.sprint.id, action.payload.sprint).unset(action.payload.temporaryCardListId).value();
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            return (0, $7uUwQ.unset)(state, action.payload.sprintId);
        case 0, $ksKI7.EDIT_SPRINT_REQUEST:
            return (0, $l2T6l.chainUnsafe)(state).setIn([
                String(action.payload.id),
                'name'
            ], action.payload.name).setIn([
                String(action.payload.id),
                'sprintData',
                'goal'
            ], action.payload.goal).setIn([
                String(action.payload.id),
                'sprintData',
                'startDate'
            ], action.payload.startDate).setIn([
                String(action.payload.id),
                'sprintData',
                'endDate'
            ], action.payload.endDate).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("ksKI7", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_REQUEST", () => $af6e991d87d504d7$export$123abdbc4d2e52b2);
$parcel$export(module.exports, "editSprintRequest", () => $af6e991d87d504d7$export$f1ede94f3f629cd9);
$parcel$export(module.exports, "editSprintSuccess", () => $af6e991d87d504d7$export$3b274a040443f185);
$parcel$export(module.exports, "editSprintFailure", () => $af6e991d87d504d7$export$193b8520faf6f6b0);

var $c0irb = parcelRequire("c0irb");
const $af6e991d87d504d7$export$123abdbc4d2e52b2 = 'state.actions.sprints.edit.EDIT_SPRINT_REQUEST';
const $af6e991d87d504d7$export$f1ede94f3f629cd9 = (id, name, goal, startDate, endDate)=>({
        type: $af6e991d87d504d7$export$123abdbc4d2e52b2,
        payload: {
            id: id,
            name: name,
            goal: goal,
            startDate: startDate,
            endDate: endDate
        },
        meta: (0, $c0irb.beginOptimisticUiMeta)()
    });
const $af6e991d87d504d7$export$e043c26cf23a5c18 = 'state.actions.sprints.edit.EDIT_SPRINT_SUCCESS';
const $af6e991d87d504d7$export$3b274a040443f185 = (txId)=>({
        type: $af6e991d87d504d7$export$e043c26cf23a5c18,
        meta: (0, $c0irb.commitOptimisticUiMeta)(txId)
    });
const $af6e991d87d504d7$export$c58baca64c75a779 = 'state.actions.sprints.edit.EDIT_SPRINT_FAILURE';
const $af6e991d87d504d7$export$193b8520faf6f6b0 = (txId)=>({
        type: $af6e991d87d504d7$export$c58baca64c75a779,
        meta: (0, $c0irb.revertOptimisticUiWithFlagMeta)(txId)
    });

});


parcelRegister("vE7h8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c47088fbae861226$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $a1ybZ = parcelRequire("a1ybZ");

var $6GNN7 = parcelRequire("6GNN7");
const $c47088fbae861226$var$cardOrderGlobalReducer = (state = [], action)=>{
    if (action.type === (0, $3lZ6i.SET_APP_DATA)) return action.payload.entities.cardOrderGlobal || state;
    if (action.type === (0, $a1ybZ.SET_CARD_ORDER_GLOBAL)) return action.payload;
    if (action.type === (0, $6GNN7.CARDS_MOVE_REQUEST)) return action.payload.newCardOrderGlobal || state;
    return state;
};
var $c47088fbae861226$export$2e2bcd8739ae039 = $c47088fbae861226$var$cardOrderGlobalReducer;

});

parcelRegister("9yRWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $78835702a3680988$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $sLb2Q = parcelRequire("sLb2Q");

var $FTaAj = parcelRequire("FTaAj");

var $2lpqS = parcelRequire("2lpqS");

var $f01qr = parcelRequire("f01qr");

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $6GNN7 = parcelRequire("6GNN7");

var $jkFPs = parcelRequire("jkFPs");

var $d09wv = parcelRequire("d09wv");
const $78835702a3680988$var$defaultState = {};
const $78835702a3680988$var$getNewCardOrder = (action)=>{
    if (action.type === (0, $6GNN7.CARDS_MOVE_REQUEST)) return action.payload.newCardOrder;
    return undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$78835702a3680988$export$2e2bcd8739ae039 = (state = $78835702a3680988$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.cardOrder;
        case 0, $6GNN7.CARDS_MOVE_SET:
        case 0, $6GNN7.CARDS_MOVE_REQUEST:
            {
                const newState = (0, $7uUwQ.chain)(state);
                const { payload: { cardIds: cardIds, beforeCardId: beforeCardId, afterCardId: afterCardId, cardListId: cardListId } } = action;
                const derivedCardListId = (0, $f01qr.getCardListId)(cardListId);
                if (cardListId === String((0, $2lpqS.UNASSIGNED_EPIC_ID))) return state;
                // Remove the moved cardIds from all cardlists, to be
                // returned to their new location below
                Object.keys(state).forEach((key)=>newState.setIn([
                        key
                    ], state[key].filter((cardId)=>!cardIds.includes(cardId))));
                if ($78835702a3680988$var$getNewCardOrder(action)) return newState.setIn([
                    derivedCardListId
                ], $78835702a3680988$var$getNewCardOrder(action)).value();
                const cardIdList = newState.value()[derivedCardListId];
                const insertIndex = beforeCardId ? cardIdList.indexOf(beforeCardId) : cardIdList.indexOf(afterCardId || 0) + 1;
                newState.setIn([
                    derivedCardListId
                ], (0, $7uUwQ.splice)(cardIdList, insertIndex, 0, ...cardIds));
                return newState.value();
            }
        case 0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, listId: listId, insertBefore: insertBefore } = action.payload;
                if (!insertBefore) {
                    let updatedState = state[listId];
                    tempIds.forEach((tempId)=>{
                        updatedState = (0, $7uUwQ.push)(updatedState, tempId);
                    });
                    return (0, $7uUwQ.set)(state, listId, updatedState);
                }
                const insertIndex = state[listId].indexOf(insertBefore);
                return (0, $7uUwQ.set)(state, listId, (0, $7uUwQ.splice)(state[listId], insertIndex, 0, ...tempIds));
            }
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            {
                const { card: card, listId: listId, temporaryCardId: temporaryCardId } = action.payload;
                const index = state[listId].indexOf(temporaryCardId);
                return (0, $7uUwQ.setIn)(state, [
                    listId,
                    index
                ], card.id);
            }
        case 0, $legw4.CARD_DELETE:
        case 0, $legw4.CARD_DELETE_REQUEST:
            {
                const cardListIds = Object.keys(state);
                const { cardId: deletedCardId } = action.payload;
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>cardId !== deletedCardId));
                return (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cardListIds, filteredLists);
            }
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const cardListIds = Object.keys(state);
                const deletedCardIds = action.payload.cardsIdentifiers.map((cardIds)=>cardIds.id);
                const filteredLists = cardListIds.map((cardListId)=>state[cardListId].filter((cardId)=>!deletedCardIds.includes(cardId)));
                return (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(cardListIds, filteredLists);
            }
        case 0, $jkFPs.SPRINT_CREATE_REQUEST:
            return (0, $7uUwQ.set)(state, action.payload.temporaryCardListId, []);
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            return (0, $7uUwQ.chain)(state).unset(action.payload.temporaryCardListId).set(action.payload.sprint.id, []).value();
        case 0, $d09wv.SPRINT_DELETE_REQUEST:
            {
                const { payload: { nextCardListId: nextCardListId, sprintId: sprintId } } = action;
                if (!nextCardListId) return (0, $7uUwQ.unset)(state, sprintId);
                return (0, $7uUwQ.chain)(state).set(nextCardListId, state[sprintId].concat(state[nextCardListId])).unset(sprintId).value();
            }
        case 0, $hf5c2.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const { meta: { childIssue: { id: id } } } = changeEvent;
                    return {
                        ...state,
                        [(0, $guzeq.BACKLOG)]: [
                            ...state[0, $guzeq.BACKLOG],
                            Number(id)
                        ]
                    };
                }
                return state;
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("aLuWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47007ce3481c726$export$2e2bcd8739ae039);

var $3JOCw = parcelRequire("3JOCw");

var $3lZ6i = parcelRequire("3lZ6i");
const $e47007ce3481c726$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e47007ce3481c726$export$2e2bcd8739ae039 = (state = $e47007ce3481c726$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            // cardTypes will not be provided in the payload for CMP
            return action.payload.entities.cardTypes || state;
        case 0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
                ...action.payload.cardTypes,
                ...state
            ], 'id');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5nW8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5adb40fb42e31da$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $gULOk = parcelRequire("gULOk");

var $FTaAj = parcelRequire("FTaAj");

var $3lZ6i = parcelRequire("3lZ6i");

var $2HxVZ = parcelRequire("2HxVZ");

var $g4P00 = parcelRequire("g4P00");

var $eSSqy = parcelRequire("eSSqy");

var $hf5c2 = parcelRequire("hf5c2");

var $legw4 = parcelRequire("legw4");

var $aKajY = parcelRequire("aKajY");

var $6GNN7 = parcelRequire("6GNN7");

var $et6P7 = parcelRequire("et6P7");

var $fdAim = parcelRequire("fdAim");

var $3EtSK = parcelRequire("3EtSK");

var $gkSeR = parcelRequire("gkSeR");

var $c7Xu8 = parcelRequire("c7Xu8");

var $czUNp = parcelRequire("czUNp");

var $kB9og = parcelRequire("kB9og");

var $ksTa3 = parcelRequire("ksTa3");
const $c5adb40fb42e31da$var$defaultState = {};
const $c5adb40fb42e31da$var$updateCardFlags = (state, { payload: { cards: cards, flag: flag } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    cards.forEach((id)=>chainedState.assocIn([
            String(id),
            'isFlagged'
        ], flag));
    return chainedState.value();
};
const $c5adb40fb42e31da$var$updateCardsParent = (state, { payload: { cards: cards, parentId: parentId } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    cards.forEach((card)=>chainedState.assocIn([
            String(card.id),
            'parentId'
        ], parentId));
    return chainedState.value();
};
const $c5adb40fb42e31da$var$updateCardsDetails = (state, payload)=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    payload.forEach(({ cardIds: cardIds, data: data })=>{
        const dataTransformer = (0, $ksTa3.transformBulkOperationsData)(data);
        cardIds.forEach((cardId)=>{
            const id = String(cardId);
            const newData = dataTransformer(state[id]);
            const newCardData = (0, $7uUwQ.chain)(state[id]).assign(newData);
            chainedState.assoc(id, newCardData.value());
        });
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardStatus = (state, { payload: { cardId: cardId, statusId: statusId, statusCategory: statusCategory, isCMP: isCMP } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'statusId'
    ], statusId);
    // We use `isDone` to show issue key strikethrough as an indicator of issue resolution.
    // Only for TMP, status' category equaling `Done` means the issue is resolved.
    // For CMP, we cannot determine an issue's resolution completely client-side due to the complexities of non-simplified workflows.
    // As we're fire a data refresh request on each issue transition for CMP, the correct `isDone` value will be pulled from the server anyway with a slight delay.
    if (!isCMP) {
        const isDone = (0, $gULOk.StatusCategoryIds)[statusCategory] === (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE];
        chainedState.assocIn([
            String(cardId),
            'isDone'
        ], isDone);
    }
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardEstimate = (state, { payload: { cardId: cardId, estimate: estimate } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.merge({
        [String(cardId)]: {
            estimate: estimate
        }
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardAssignee = (state, { payload: { cardId: cardId, assignee: assignee } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'assignee'
    ], assignee);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardSummary = (state, { payload: { cardId: cardId, summary: summary } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'summary'
    ], summary);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardParentId = (state, { payload: { cardId: cardId, parentId: parentId } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], parentId);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardParent = (state, { payload: { cardId: cardId, parent: parent } })=>{
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'parentId'
    ], (parent?.id && Number(parent.id)) ?? null).assocIn([
        String(cardId),
        'parentKey'
    ], parent?.key ?? null);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardTargetStatusId = (state, { payload: { cardIds: cardIds, targetStatusId: targetStatusId } })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(cardIds) || targetStatusId === undefined) return state;
    const chainedState = (0, $7uUwQ.chain)(state);
    cardIds.forEach((cardId)=>{
        chainedState.assocIn([
            String(cardId),
            'statusId'
        ], targetStatusId);
    });
    return chainedState.value();
};
const $c5adb40fb42e31da$var$setCardPriority = (state, { payload: { cardId: cardId, priority: priority } })=>{
    const { id: id, ...cardPriority } = priority;
    const chainedState = (0, $7uUwQ.chain)(state);
    chainedState.assocIn([
        String(cardId),
        'priority'
    ], cardPriority);
    return chainedState.value();
};
const $c5adb40fb42e31da$var$cardReducer = (state = $c5adb40fb42e31da$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.card;
        case 0, $hf5c2.CARD_CREATE_MULTIPLE_REQUEST:
            {
                const { tempIds: tempIds, summaries: summaries, typeId: typeId, typeIcon: typeIcon } = action.payload;
                const chainState = (0, $7uUwQ.chain)(state);
                const defaultCardProps = {
                    key: '',
                    labels: [],
                    assignee: null,
                    isDone: false,
                    isFlagged: false,
                    issueUrl: '',
                    statusId: '',
                    parentId: null,
                    priority: null,
                    dueDate: null,
                    estimate: null,
                    numCompleteChildren: 0,
                    numTotalChildren: 0,
                    fixVersions: []
                };
                for(let i = 0; i < tempIds.length; i += 1){
                    const tempId = tempIds[i];
                    const summary = summaries[i];
                    chainState.set(String(tempId), {
                        ...defaultCardProps,
                        summary: summary,
                        id: tempId,
                        icon: typeIcon,
                        typeId: typeId
                    });
                }
                return chainState.value();
            }
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            {
                const { card: card, temporaryCardId: temporaryCardId } = action.payload;
                return (0, $7uUwQ.chain)(state).unset(String(temporaryCardId)).set(String(card.id), card).value();
            }
        case 0, $6GNN7.CARDS_MOVE_REQUEST:
        case 0, $6GNN7.CARDS_MOVE_SUCCESS:
            return $c5adb40fb42e31da$var$setCardTargetStatusId(state, action);
        case 0, $aKajY.CARDS_FLAG_WITH_COMMENT_REQUEST:
            return $c5adb40fb42e31da$var$updateCardFlags(state, action);
        case 0, $legw4.CARD_DELETE_REQUEST:
        case 0, $legw4.CARD_DELETE:
            return (0, $7uUwQ.unset)(state, String(action.payload.cardId));
        case 0, $hf5c2.CARD_CREATE_UNMAPPED_WITH_ISSUE_LINK:
            {
                const stateChain = (0, $7uUwQ.chain)(state);
                action.payload.cardsIdentifiers.forEach(({ id: id })=>{
                    stateChain.unset(String(id));
                });
                return stateChain.value();
            }
        case 0, $fdAim.CARD_REFRESH_REQUEST:
            {
                const { cardId: cardId, changeEvent: changeEvent } = action.payload;
                if (cardId == null || !changeEvent) return state;
                const cardIdStr = String(cardId);
                const oldCard = state[cardIdStr];
                if (!oldCard) // This should only happen when the updated card is a subtask which doesn't exist in the state
                return state;
                const optimisticCard = (0, $ksTa3.updateCardWithChangeEvent)(oldCard, changeEvent);
                return (0, $7uUwQ.set)(state, cardIdStr, optimisticCard);
            }
        case 0, $fdAim.CARD_REFRESH_SUCCESS:
            return (0, $7uUwQ.set)(state, String(action.payload.id), action.payload);
        case 0, $et6P7.CARDS_PARENT_SET_OPTIMISTIC:
            return $c5adb40fb42e31da$var$updateCardsParent(state, action);
        case 0, $hf5c2.CARD_CREATE_END_OF_BACKLOG_OPTIMISTIC:
            {
                const { changeEvent: changeEvent } = action.payload;
                if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) {
                    const [cardId, newCard] = (0, $ksTa3.buildCardFromEvent)(changeEvent);
                    return (0, $7uUwQ.set)(state, cardId, newCard);
                }
                return state;
            }
        case 0, $czUNp.CARD_STATUS_SET:
            return $c5adb40fb42e31da$var$setCardStatus(state, action);
        case 0, $3EtSK.CARD_ESTIMATE_SET_OPTIMISTIC:
        case 0, $3EtSK.CARD_ESTIMATE_SET:
            return $c5adb40fb42e31da$var$setCardEstimate(state, action);
        case 0, $2HxVZ.CARD_ASSIGNEE_SET_OPTIMISTIC:
        case 0, $g4P00.ASSIGN_TO_ME_REQUEST:
        case 0, $2HxVZ.CARD_ASSIGNEE_SET:
            return $c5adb40fb42e31da$var$setCardAssignee(state, action);
        case 0, $kB9og.CARD_SUMMARY_SET:
            return $c5adb40fb42e31da$var$setCardSummary(state, action);
        case 0, $gkSeR.CARD_PARENT_ID_SET:
            return $c5adb40fb42e31da$var$setCardParentId(state, action);
        case 0, $gkSeR.CARD_PARENT_SET_OPTIMISTIC:
            return $c5adb40fb42e31da$var$setCardParent(state, action);
        case 0, $c7Xu8.CARD_PRIORITY_SET_OPTIMISTIC:
        case 0, $c7Xu8.CARD_PRIORITY_SET:
            return $c5adb40fb42e31da$var$setCardPriority(state, action);
        case 0, $eSSqy.CARDS_BULK_OPERATIONS_REQUESTS:
            return $c5adb40fb42e31da$var$updateCardsDetails(state, action.payload);
        default:
            return state;
    }
};
var $c5adb40fb42e31da$export$2e2bcd8739ae039 = $c5adb40fb42e31da$var$cardReducer;

});
parcelRegister("2HxVZ", function(module, exports) {

$parcel$export(module.exports, "CARD_ASSIGNEE_SET", () => $3fac26e3bede51bd$export$8592163118330a98);
$parcel$export(module.exports, "cardAssigneeSet", () => $3fac26e3bede51bd$export$6b6e5f1997c8a08c);
$parcel$export(module.exports, "CARD_ASSIGNEE_SET_OPTIMISTIC", () => $3fac26e3bede51bd$export$b43ad5b0028f1504);
$parcel$export(module.exports, "cardAssigneeSetOptimistic", () => $3fac26e3bede51bd$export$dfd208865fa6a432);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $3fac26e3bede51bd$export$8592163118330a98 = 'state.actions.assignee.CARD_ASSIGNEE_SET';
const $3fac26e3bede51bd$export$6b6e5f1997c8a08c = (cardId, assignee)=>({
        type: $3fac26e3bede51bd$export$8592163118330a98,
        payload: {
            cardId: cardId,
            assignee: assignee
        }
    });
const $3fac26e3bede51bd$export$b43ad5b0028f1504 = 'state.actions.assignee.CARD_ASSIGNEE_SET_OPTIMISTIC';
const $3fac26e3bede51bd$export$dfd208865fa6a432 = (payload, issueKey, analyticsEvent)=>({
        type: $3fac26e3bede51bd$export$b43ad5b0028f1504,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                issueKey: issueKey,
                fieldId: (0, $5fc53.ASSIGNEE_TYPE),
                newValue: payload.assignee,
                retryAction: ()=>$3fac26e3bede51bd$export$dfd208865fa6a432(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("3EtSK", function(module, exports) {

$parcel$export(module.exports, "CARD_ESTIMATE_SET", () => $00f2538e16fb2889$export$3b7d1bc5ea31bea3);
$parcel$export(module.exports, "cardEstimateSet", () => $00f2538e16fb2889$export$a8708880a95d91af);
$parcel$export(module.exports, "CARD_ESTIMATE_SET_OPTIMISTIC", () => $00f2538e16fb2889$export$c1b2b9b852128ca2);
$parcel$export(module.exports, "cardEstimateSetOptimistic", () => $00f2538e16fb2889$export$7f4e1182c4ce5ed4);

var $6JzCg = parcelRequire("6JzCg");
const $00f2538e16fb2889$export$3b7d1bc5ea31bea3 = 'state.actions.estimate.CARD_ESTIMATE_SET';
const $00f2538e16fb2889$export$a8708880a95d91af = (cardId, estimate)=>({
        type: $00f2538e16fb2889$export$3b7d1bc5ea31bea3,
        payload: {
            cardId: cardId,
            estimate: estimate
        }
    });
const $00f2538e16fb2889$export$c1b2b9b852128ca2 = 'state.actions.estimate.CARD_ESTIMATE_SET_OPTIMISTIC';
const $00f2538e16fb2889$export$7f4e1182c4ce5ed4 = (payload, cardSet, analyticsEvent)=>({
        type: $00f2538e16fb2889$export$c1b2b9b852128ca2,
        payload: payload,
        meta: (0, $6JzCg.setCardSetMeta)({
            issueKey: cardSet.issueKey,
            fieldId: cardSet.estimationFieldId,
            newValue: payload.estimate.originalEstimate ? {
                originalEstimate: payload.estimate.originalEstimate.valueAsText
            } : payload.estimate.storyPoints,
            retryAction: ()=>$00f2538e16fb2889$export$7f4e1182c4ce5ed4(payload, cardSet, analyticsEvent)
        }, analyticsEvent)
    });

});

parcelRegister("gkSeR", function(module, exports) {

$parcel$export(module.exports, "CARD_PARENT_ID_SET", () => $e2205286ea0004b9$export$765aff4d74f630ef);
$parcel$export(module.exports, "cardParentIdSet", () => $e2205286ea0004b9$export$8e5862c35c9d4ec6);
$parcel$export(module.exports, "CARD_PARENT_SET_OPTIMISTIC", () => $e2205286ea0004b9$export$e771cf2ac685cb14);
$parcel$export(module.exports, "cardParentSetOptimistic", () => $e2205286ea0004b9$export$f5008334a98f6790);

var $5fc53 = parcelRequire("5fc53");

var $6JzCg = parcelRequire("6JzCg");
const $e2205286ea0004b9$export$765aff4d74f630ef = 'state.actions.parent.CARD_PARENT_ID_SET';
const $e2205286ea0004b9$export$8e5862c35c9d4ec6 = (cardId, parentId)=>({
        type: $e2205286ea0004b9$export$765aff4d74f630ef,
        payload: {
            cardId: cardId,
            parentId: parentId
        }
    });
const $e2205286ea0004b9$export$e771cf2ac685cb14 = 'state.actions.priorities.CARD_PARENT_SET_OPTIMISTIC';
const $e2205286ea0004b9$export$f5008334a98f6790 = (payload, issueKey, analyticsEvent)=>({
        type: $e2205286ea0004b9$export$e771cf2ac685cb14,
        payload: payload,
        meta: {
            ...(0, $6JzCg.setCardSetMeta)({
                fieldId: (0, $5fc53.PARENT_TYPE),
                issueKey: issueKey,
                newValue: payload.parent,
                retryAction: ()=>$e2205286ea0004b9$export$f5008334a98f6790(payload, issueKey, analyticsEvent)
            }, analyticsEvent)
        }
    });

});

parcelRegister("kB9og", function(module, exports) {

$parcel$export(module.exports, "CARD_SUMMARY_SET", () => $1550bb03b278d689$export$447c8cffca6dd3a0);
$parcel$export(module.exports, "cardSummarySet", () => $1550bb03b278d689$export$4584175580349cb0);
const $1550bb03b278d689$export$447c8cffca6dd3a0 = 'state.actions.summary.CARD_SUMMARY_SET';
const $1550bb03b278d689$export$4584175580349cb0 = (cardId, summary)=>({
        type: $1550bb03b278d689$export$447c8cffca6dd3a0,
        payload: {
            cardId: cardId,
            summary: summary
        }
    });

});

parcelRegister("ksTa3", function(module, exports) {

$parcel$export(module.exports, "updateCardWithChangeEvent", () => $d2513729104fe39d$export$55ea42a298d73e4f);
$parcel$export(module.exports, "buildCardFromEvent", () => $d2513729104fe39d$export$818d870b4da795a8);
$parcel$export(module.exports, "transformBulkOperationsData", () => $d2513729104fe39d$export$bbf3856ca410a627);
/* NOTE:
 * This module is mapping bento change events onto card updates for backlog optimistic state updates.
 * Handling is separated onto different functions to improve documentation.
 */ 
var $dPSWJ = parcelRequire("dPSWJ");

var $FTaAj = parcelRequire("FTaAj");

const $d2513729104fe39d$export$6232590629abe6b = (oldCard, changeEvent)=>({
        ...oldCard,
        summary: changeEvent.meta.fieldValue || ''
    });
/**
 * Apply a bento labels change event onto a card.
 * We assume that fieldValue will be an array of strings.
 */ const $d2513729104fe39d$var$updateCardWithLabelsChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        labels: changeEvent.meta.fieldValue
    });
const $d2513729104fe39d$var$updateCardWithParentChangeEvent = (oldCard, changeEvent)=>({
        ...oldCard,
        parentId: Number(changeEvent.meta.newParentIssueId)
    });
const $d2513729104fe39d$export$55ea42a298d73e4f = (oldCard, changeEvent)=>{
    if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return $d2513729104fe39d$var$updateCardWithParentChangeEvent(oldCard, changeEvent);
    if (changeEvent.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED || changeEvent.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) switch(changeEvent.meta.fieldId){
        case 0, $e9be48d6d2c01760$export$e7cf1830fe735d1f:
            return $d2513729104fe39d$export$6232590629abe6b(oldCard, changeEvent);
        case 0, $e9be48d6d2c01760$export$93605f2a09aa8d26:
            return $d2513729104fe39d$var$updateCardWithLabelsChangeEvent(oldCard, changeEvent);
        default:
            return oldCard;
    }
    return oldCard;
};
const $d2513729104fe39d$export$818d870b4da795a8 = (changeEvent)=>{
    const { issueId: issueId, meta: { childIssue: { id: id, issueKey: issueKey, issueLink: issueLink, issueSummary: issueSummary, issueTypeIconUrl: issueTypeIconUrl } } } = changeEvent;
    const card = {
        id: Number(id),
        key: issueKey || '',
        statusId: '',
        issueUrl: issueLink || '',
        summary: issueSummary || '',
        icon: issueTypeIconUrl || '',
        typeId: 0,
        labels: [],
        assignee: null,
        parentId: Number(issueId),
        priority: null,
        dueDate: null,
        estimate: null,
        fixVersions: [],
        numCompleteChildren: 0,
        numTotalChildren: 0,
        isDone: false,
        isFlagged: false,
        projectId: 0
    };
    return [
        String(id),
        card
    ];
};
const $d2513729104fe39d$export$5a286d741e9c601b = (input, action, data)=>{
    if (action === 'add') {
        const filtered = data.filter((value)=>!input.includes(value));
        return [
            ...input,
            ...filtered
        ];
    }
    if (action === 'remove') return input.filter((value)=>!data.includes(value));
    if (action === 'set') return data;
    return input;
};
const $d2513729104fe39d$var$transformData = (cardData)=>(data, key)=>{
        if (key === 'labels') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $d2513729104fe39d$export$5a286d741e9c601b(cardData.labels, action, value);
        }
        if (key === 'fixVersions' && cardData.fixVersions) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-non-null-assertion
            const { action: action, value: value } = data;
            return $d2513729104fe39d$export$5a286d741e9c601b(cardData.fixVersions, action, value);
        }
        return data;
    };
const $d2513729104fe39d$export$bbf3856ca410a627 = (data)=>(cardData)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(data, $d2513729104fe39d$var$transformData(cardData));

});


parcelRegister("cj2CS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5af50e815cc815$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $cPahM = parcelRequire("cPahM");
const $6d5af50e815cc815$var$defaultState = null;
function $6d5af50e815cc815$export$2e2bcd8739ae039(state = $6d5af50e815cc815$var$defaultState, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return action.payload.columns;
        case 0, $cPahM.SET_COLUMNS:
            return action.payload.columns;
        default:
            return state;
    }
}

});

parcelRegister("3Ek8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6da2bf71e72d802$export$2e2bcd8739ae039);

var $bI3co = parcelRequire("bI3co");
const $c6da2bf71e72d802$var$defaultState = null;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6da2bf71e72d802$export$2e2bcd8739ae039 = (state = $c6da2bf71e72d802$var$defaultState, action)=>{
    switch(action.type){
        case 0, $bI3co.SET_CURRENT_USER:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("hDT0g", function(module, exports) {

$parcel$export(module.exports, "customFiltersReducer", () => $2ef1369b2c794365$export$dbd98ee5f91df1a);

var $3lZ6i = parcelRequire("3lZ6i");

var $DBM4S = parcelRequire("DBM4S");
const $2ef1369b2c794365$var$initialState = {
    filters: []
};
function $2ef1369b2c794365$export$dbd98ee5f91df1a(state = $2ef1369b2c794365$var$initialState, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            {
                const filters = action.payload.entities.quickFilters;
                return {
                    filters: filters
                };
            }
        case 0, $DBM4S.SET_CUSTOM_FILTERS:
            return {
                filters: action.payload
            };
        default:
            return state;
    }
}

});
parcelRegister("DBM4S", function(module, exports) {

$parcel$export(module.exports, "SET_CUSTOM_FILTERS", () => $657cbfa22776c80f$export$6388e83e9b720843);
const $657cbfa22776c80f$export$6388e83e9b720843 = 'state.actions.custom-filters.SET_CUSTOM_FILTERS';
function $657cbfa22776c80f$export$5500f63fa8214463(customFilters) {
    return {
        type: $657cbfa22776c80f$export$6388e83e9b720843,
        payload: customFilters
    };
}

});


parcelRegister("d74Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27226ad5e664250$export$2e2bcd8739ae039);

var $guzeq = parcelRequire("guzeq");

var $3lZ6i = parcelRequire("3lZ6i");
const $a27226ad5e664250$var$defaultState = {
    isEstimationFeatureEnabled: false,
    estimationType: (0, $guzeq.ISSUE_COUNT),
    estimationFieldId: null,
    name: ''
};
function $a27226ad5e664250$export$2e2bcd8739ae039(state = $a27226ad5e664250$var$defaultState, action) {
    if (action.type === (0, $3lZ6i.SET_APP_DATA) || action.type === (0, $3lZ6i.SET_CONFIG_DATA) || action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if (!action.payload.entities.estimation) return state;
        const { isEstimationFeatureEnabled: isEstimationFeatureEnabled, estimationType: estimationType, estimationFieldId: estimationFieldId, name: name } = action.payload.entities.estimation || {};
        return {
            isEstimationFeatureEnabled: isEstimationFeatureEnabled || false,
            estimationType: estimationType || (0, $guzeq.ISSUE_COUNT),
            estimationFieldId: estimationFieldId || null,
            name: name || ''
        };
    }
    return state;
}

});

parcelRegister("lRpaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $057994c0da7e174b$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $7zF3i = parcelRequire("7zF3i");
const $057994c0da7e174b$var$defaultState = {
    sessionId: undefined,
    cardTypeIds: []
};
const $057994c0da7e174b$var$projectReducer = (state = $057994c0da7e174b$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            if (!action.payload.entities.inlineCreate?.cardTypeIds) return state;
            return {
                ...state,
                cardTypeIds: action.payload.entities.inlineCreate.cardTypeIds
            };
        case 0, $7zF3i.SET_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload.sessionId
            };
        case 0, $7zF3i.CLEAR_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: undefined
            };
        case 0, $3lZ6i.LOAD_CARD_CREATE_CONFIG_SUCCESS:
            return {
                ...state,
                cardTypeIds: action.payload.cardTypes.map((t)=>t.id)
            };
        default:
            return state;
    }
};
var $057994c0da7e174b$export$2e2bcd8739ae039 = $057994c0da7e174b$var$projectReducer;

});
parcelRegister("7zF3i", function(module, exports) {

$parcel$export(module.exports, "SET_INLINE_CREATE_SESSION_ID", () => $59a43373b6293d31$export$b7afd69edc8efc16);
$parcel$export(module.exports, "setInlineCreateSessionId", () => $59a43373b6293d31$export$69abc158578163fc);
$parcel$export(module.exports, "CLEAR_INLINE_CREATE_SESSION_ID", () => $59a43373b6293d31$export$932498ee6899f22a);
const $59a43373b6293d31$export$b7afd69edc8efc16 = 'state.actions.inline-create.SET_INLINE_CREATE_SESSION_ID';
const $59a43373b6293d31$export$69abc158578163fc = ({ sessionId: sessionId })=>({
        type: $59a43373b6293d31$export$b7afd69edc8efc16,
        payload: {
            sessionId: sessionId
        }
    });
const $59a43373b6293d31$export$932498ee6899f22a = 'state.actions.inline-create.CLEAR_INLINE_CREATE_SESSION_ID';
const $59a43373b6293d31$export$138f7b7b7eb9ceaa = ()=>({
        type: $59a43373b6293d31$export$932498ee6899f22a
    });

});


parcelRegister("aQATd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd31245ddc321836$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");

var $c2Ik2 = parcelRequire("c2Ik2");

var $aCC3Y = parcelRequire("aCC3Y");
const $bd31245ddc321836$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bd31245ddc321836$export$2e2bcd8739ae039 = (state = $bd31245ddc321836$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            {
                const { payload: { entities: { issueParentsOrder: issueParentsOrder } } } = action;
                return issueParentsOrder || state;
            }
        case 0, $c2Ik2.ISSUE_PARENTS_CREATE_SET:
            {
                const issueParentIds = action.payload.issueParents.map((issueParent)=>issueParent.id);
                return [
                    ...state,
                    ...issueParentIds
                ];
            }
        case 0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS:
            return action.payload.issueParents.map((issueParent)=>issueParent.id);
        default:
            return state;
    }
};

});
parcelRegister("c2Ik2", function(module, exports) {

$parcel$export(module.exports, "ISSUE_PARENTS_CREATE_SET", () => $26e306c666ef0951$export$3491dc76ca1d517c);
$parcel$export(module.exports, "issueParentsCreateSet", () => $26e306c666ef0951$export$55d568aa4e952be5);
const $26e306c666ef0951$export$3491dc76ca1d517c = 'state.actions.issue-parents.create.ISSUE_PARENTS_CREATE_SET';
const $26e306c666ef0951$export$55d568aa4e952be5 = (payload)=>({
        type: $26e306c666ef0951$export$3491dc76ca1d517c,
        payload: payload
    });

});


parcelRegister("bA8dH", function(module, exports) {

$parcel$export(module.exports, "default", () => $411ecc0d42c08102$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $c2Ik2 = parcelRequire("c2Ik2");

var $aCC3Y = parcelRequire("aCC3Y");

var $hqokg = parcelRequire("hqokg");
const $411ecc0d42c08102$var$defaultState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$411ecc0d42c08102$export$2e2bcd8739ae039 = (state = $411ecc0d42c08102$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            {
                const { payload: { entities: { issueParents: issueParents } } } = action;
                return issueParents ? (0, $7uUwQ.freeze)(issueParents) : state;
            }
        case 0, $c2Ik2.ISSUE_PARENTS_CREATE_SET:
        case 0, $aCC3Y.LOAD_ISSUE_PARENTS_SUCCESS:
            {
                const { issueParents: issueParents } = action.payload;
                const chainedState = (0, $7uUwQ.chain)(state);
                issueParents.forEach((issueParent)=>{
                    chainedState.set(String(issueParent.id), issueParent);
                });
                return chainedState.value();
            }
        case 0, $hqokg.ISSUE_PARENT_PATCH:
            {
                const { issueParent: issueParent, id: id } = action.payload;
                const oldParent = state[id];
                if (!oldParent) return state;
                return (0, $7uUwQ.set)(state, id, (0, $7uUwQ.merge)(oldParent, issueParent));
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("bgxMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbf3f4ba538b658$export$2e2bcd8739ae039);

var $hf5c2 = parcelRequire("hf5c2");
function $bbbf3f4ba538b658$export$2e2bcd8739ae039(state = null, action) {
    switch(action.type){
        case 0, $hf5c2.CARD_CREATE_SUCCESS:
            return action.payload.card.id;
        default:
            return state;
    }
}

});

parcelRegister("3zbT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f18bed784cbf1cd6$export$2e2bcd8739ae039);

var $c7Xu8 = parcelRequire("c7Xu8");
const $f18bed784cbf1cd6$var$defaultState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f18bed784cbf1cd6$export$2e2bcd8739ae039 = (state = $f18bed784cbf1cd6$var$defaultState, action)=>{
    switch(action.type){
        case 0, $c7Xu8.LOAD_PRIORITIES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};

});

parcelRegister("9tayK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7ee976f15e1210$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
const $2f7ee976f15e1210$var$defaultState = {
    projects: []
};
const $2f7ee976f15e1210$var$projectReducer = (state = $2f7ee976f15e1210$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.project ?? $2f7ee976f15e1210$var$defaultState;
        default:
            return state;
    }
};
var $2f7ee976f15e1210$export$2e2bcd8739ae039 = $2f7ee976f15e1210$var$projectReducer;

});

parcelRegister("7k9YH", function(module, exports) {

$parcel$export(module.exports, "trackingReducer", () => $b208c9e23d8eb089$export$9dc75892c8308f9d);

var $gccSB = parcelRequire("gccSB");

var $3lZ6i = parcelRequire("3lZ6i");
const $b208c9e23d8eb089$var$defaultState = {
    name: '',
    typeId: '',
    fieldId: '',
    isValid: false,
    isEnabled: false
};
const $b208c9e23d8eb089$export$9dc75892c8308f9d = (state = $b208c9e23d8eb089$var$defaultState, action)=>{
    if (action.type === (0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS)) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(action?.payload?.entities?.tracking)) return state;
        return action.payload.entities.tracking;
    }
    return state;
};

});

parcelRegister("4Q0MU", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c4a7c489606dff$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $gwOHY = parcelRequire("gwOHY");
const $80c4a7c489606dff$var$defaultState = {
    versions: []
};
const $80c4a7c489606dff$var$versionReducer = (state = $80c4a7c489606dff$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.version;
        case 0, $gwOHY.SET_VERSIONS:
            return action.payload;
        case 0, $gwOHY.UPDATE_VERSION:
            if (state.versions.includes(String(action.payload.version.id))) return state;
            return (0, $7uUwQ.chain)(state).setIn([
                'versions'
            ], (0, $7uUwQ.push)(state.versions, String(action.payload.version.id))).value();
        default:
            {
                // @ts-expect-error - TS2322: Type 'BatchAction | ShowErrorFlagAction | InitializeAppPropsAction | LoadAppDataAction | LoadAppDataFailureAction | ... 173 more ... | SetIncludeSubtasksAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $80c4a7c489606dff$export$2e2bcd8739ae039 = $80c4a7c489606dff$var$versionReducer;

});

parcelRegister("4lJeG", function(module, exports) {

$parcel$export(module.exports, "versionsReducer", () => $5dce534f3702af64$export$3616d11dc800f8ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $3lZ6i = parcelRequire("3lZ6i");

var $gwOHY = parcelRequire("gwOHY");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $5dce534f3702af64$var$defaultState = (0, $7uUwQ.freeze)({});
const $5dce534f3702af64$export$3616d11dc800f8ee = (state = $5dce534f3702af64$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return action.payload.entities.versions ? (0, $7uUwQ.freeze)(action.payload.entities.versions) : state;
        case 0, $gwOHY.UPDATE_VERSION:
            return (0, $7uUwQ.chain)(state).setIn([
                String(action.payload.version.id)
            ], action.payload.version).value();
        default:
            return state;
    }
};

});


parcelRegister("dN8hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6916925f142bc836$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $BsLUY = parcelRequire("BsLUY");

var $5c4HU = parcelRequire("5c4HU");

var $gWsfQ = parcelRequire("gWsfQ");

var $eNpIX = parcelRequire("eNpIX");

var $9wNs2 = parcelRequire("9wNs2");

var $70ywa = parcelRequire("70ywa");

var $bwP9g = parcelRequire("bwP9g");

var $cjd7v = parcelRequire("cjd7v");

var $jcM6E = parcelRequire("jcM6E");

var $e03Tz = parcelRequire("e03Tz");

var $6oZez = parcelRequire("6oZez");

var $fxbtA = parcelRequire("fxbtA");
var $6916925f142bc836$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    boardIssueMoveDialog: (0, $BsLUY.default),
    cardList: (0, $5c4HU.default),
    cards: (0, $gWsfQ.default),
    detailView: (0, $eNpIX.detailViewReducer),
    issueTransitionModal: (0, $jcM6E.default),
    filters: (0, $70ywa.default),
    panels: (0, $6oZez.default),
    isConfigLoaded: (0, $bwP9g.default),
    isCriticalDataLoaded: (0, $cjd7v.default),
    modals: (0, $e03Tz.modalsReducer),
    drag: (0, $9wNs2.default),
    workloadModal: (0, $fxbtA.default)
});

});
parcelRegister("BsLUY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b74dcf9b47c6bd2$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $3qXBy = parcelRequire("3qXBy");
const $4b74dcf9b47c6bd2$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $4b74dcf9b47c6bd2$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b74dcf9b47c6bd2$export$2e2bcd8739ae039 = (state = $4b74dcf9b47c6bd2$var$closedState, action)=>{
    switch(action.type){
        case 0, $3qXBy.BOARD_ISSUE_MOVE_SHOW:
            return $4b74dcf9b47c6bd2$var$openState;
        case 0, $3qXBy.BOARD_ISSUE_MOVE_CANCEL:
            return $4b74dcf9b47c6bd2$var$closedState;
        case 0, $3qXBy.BOARD_ISSUE_MOVE_EXECUTE:
            return $4b74dcf9b47c6bd2$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("5c4HU", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f0d1bc673341fc$export$2e2bcd8739ae039);

var $fr1K2 = parcelRequire("fr1K2");

var $sLb2Q = parcelRequire("sLb2Q");

var $a7yHf = parcelRequire("a7yHf");

var $jkFPs = parcelRequire("jkFPs");
const $40f0d1bc673341fc$var$defaultState = {
    collapsed: {},
    disabled: {},
    recentCreatedId: undefined,
    dragState: {},
    isDragging: false,
    isDraggingSubtask: false,
    cardGroupCollapsed: {},
    cardGroupExpanded: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40f0d1bc673341fc$export$2e2bcd8739ae039 = (state = $40f0d1bc673341fc$var$defaultState, action)=>{
    switch(action.type){
        case 0, $a7yHf.CARD_LIST_TOGGLE:
            {
                const { cardListId: cardListId } = action.payload;
                if (state.collapsed[cardListId]) return {
                    ...state,
                    collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.collapsed, cardListId)
                };
                return {
                    ...state,
                    collapsed: {
                        ...state.collapsed,
                        [cardListId]: true
                    }
                };
            }
        case 0, $a7yHf.SET_COLLAPSED_CARD_LIST:
            return {
                ...state,
                collapsed: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(action.payload.cardListIds, Array(action.payload.cardListIds.length).fill(true))
            };
        case 0, $a7yHf.CARD_LISTS_DISABLE:
            {
                const newDisabled = action.payload.cardListIds.reduce(// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                (disabled, cardListId)=>({
                        ...disabled,
                        [cardListId]: true
                    }), {
                    ...state.disabled
                });
                return {
                    ...state,
                    disabled: newDisabled
                };
            }
        case 0, $a7yHf.CARD_LISTS_ENABLE_ALL:
            return {
                ...state,
                disabled: {}
            };
        case 0, $jkFPs.SPRINT_CREATE_SUCCESS:
            {
                const { payload: { sprint: { id: id } } } = action;
                return {
                    ...state,
                    recentCreatedId: id
                };
            }
        case 0, $a7yHf.CARD_LIST_DRAG_START:
            {
                const newDragInProgress = action.payload.cardListIds.reduce((dragInProgress, cardListId)=>Object.assign(dragInProgress, {
                        [cardListId]: cardListId === action.payload.sourceCardListId
                    }), {
                    ...state.dragState
                });
                return {
                    ...state,
                    dragState: newDragInProgress,
                    isDragging: true,
                    isDraggingSubtask: action.payload.sourceCardGroupId !== undefined
                };
            }
        case 0, $a7yHf.CARD_LIST_DRAG_END:
            return {
                ...state,
                dragState: {},
                isDragging: false,
                isDraggingSubtask: false
            };
        case 0, $a7yHf.CARD_GROUP_TOGGLE:
            {
                const { parentId: parentId } = action.payload;
                if (state.cardGroupExpanded[parentId]) return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupExpanded, parentId)
                };
                return {
                    ...state,
                    cardGroupExpanded: {
                        ...state.cardGroupExpanded,
                        [parentId]: true
                    }
                };
            }
        case 0, $a7yHf.SET_COLLAPSED_CARD_GROUP:
            return {
                ...state,
                cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(action.payload.parentIds, Array(action.payload.parentIds.length).fill(true))
            };
        case 0, $a7yHf.CLEAR_COLLAPSED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupCollapsed, parentId)
                };
            }
        case 0, $a7yHf.SET_EXPANDED_CARD_GROUP:
            {
                const expandedCardGroup = [
                    ...Object.keys(state.cardGroupExpanded),
                    ...action.payload.parentIds
                ];
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(expandedCardGroup, Array(expandedCardGroup.length).fill(true))
                };
            }
        case 0, $a7yHf.CLEAR_EXPANDED_CARD_GROUP:
            {
                const { parentId: parentId } = action.payload;
                return {
                    ...state,
                    cardGroupExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(state.cardGroupExpanded, parentId)
                };
            }
        case 0, $a7yHf.COLLAPSE_ALL_CARD_GROUPS:
            return {
                ...state,
                cardGroupExpanded: {}
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("gWsfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9d90186d2b3ab1$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $2h5Y8 = parcelRequire("2h5Y8");

var $l7QHW = parcelRequire("l7QHW");

var $k2nID = parcelRequire("k2nID");

var $a1yUO = parcelRequire("a1yUO");

var $2XYpA = parcelRequire("2XYpA");

var $bFper = parcelRequire("bFper");

var $5i1vv = parcelRequire("5i1vv");

var $8PUI4 = parcelRequire("8PUI4");

var $6MSgp = parcelRequire("6MSgp");
var $4b9d90186d2b3ab1$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    richCard: (0, $8PUI4.richCardReducer),
    selected: (0, $6MSgp.selectedReducer),
    lastSelectedCardKey: (0, $bFper.lastSelectedCardKeyReducer),
    listSelectionRelativeCard: (0, $5i1vv.listSelectionRelativeCardReducer),
    focused: (0, $2XYpA.focusedReducer),
    filteredCards: (0, $a1yUO.filteredCardsReducer),
    fields: (0, $k2nID.fieldsReducer),
    isCheckboxSelectionMode: (0, $l7QHW.checkboxSelectionModeReducer),
    autoScroll: (0, $2h5Y8.cardAutoScrollReducer)
});

});
parcelRegister("2h5Y8", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollReducer", () => $3b7bea4a66c1582d$export$d9b2c10f6d8f7f96);

var $9Z18E = parcelRequire("9Z18E");
const $3b7bea4a66c1582d$var$initialAutoScrollState = {
    cardId: null
};
const $3b7bea4a66c1582d$export$d9b2c10f6d8f7f96 = (state = $3b7bea4a66c1582d$var$initialAutoScrollState, action)=>{
    if (action.type === (0, $9Z18E.CARD_AUTO_SCROLL)) return {
        cardId: action.payload.cardId
    };
    return state;
};

});

parcelRegister("l7QHW", function(module, exports) {

$parcel$export(module.exports, "checkboxSelectionModeReducer", () => $6dd7a18bc29aa366$export$23fed535413aadfa);

var $8SI0F = parcelRequire("8SI0F");
const $6dd7a18bc29aa366$var$initialState = false;
const $6dd7a18bc29aa366$export$23fed535413aadfa = (state = $6dd7a18bc29aa366$var$initialState, action)=>{
    if (action.type === (0, $8SI0F.CHECKBOX_SELECTION_MODE)) return action.payload.isCheckboxSelectionMode;
    return state;
};

});

parcelRegister("k2nID", function(module, exports) {

$parcel$export(module.exports, "fieldsReducer", () => $81a3114735971ae9$export$570db622a488cbe7);

var $bNDq8 = parcelRequire("bNDq8");
const $81a3114735971ae9$var$initialState = {
    isStatusFieldsHidden: false,
    isVersionFieldsHidden: false,
    isEpicFieldsHidden: false
};
const $81a3114735971ae9$export$570db622a488cbe7 = (state = $81a3114735971ae9$var$initialState, action)=>{
    if (action.type === (0, $bNDq8.TOGGLE_STATUS_FIELDS)) return {
        ...state,
        isStatusFieldsHidden: action.payload.hideStatusFields
    };
    if (action.type === (0, $bNDq8.TOGGLE_VERSION_FIELDS)) return {
        ...state,
        isVersionFieldsHidden: action.payload.hideVersionFields
    };
    if (action.type === (0, $bNDq8.TOGGLE_EPIC_FIELDS)) return {
        ...state,
        isEpicFieldsHidden: action.payload.hideEpicFields
    };
    return state;
};

});
parcelRegister("bNDq8", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_STATUS_FIELDS", () => $316d359c1f4dfb27$export$4dd62b8143c11245);
$parcel$export(module.exports, "toggleCardStatusFields", () => $316d359c1f4dfb27$export$8c139077a3243812);
$parcel$export(module.exports, "TOGGLE_VERSION_FIELDS", () => $316d359c1f4dfb27$export$afb58370a9942348);
$parcel$export(module.exports, "toggleCardVersionFields", () => $316d359c1f4dfb27$export$2f4945efdaceca5a);
$parcel$export(module.exports, "TOGGLE_EPIC_FIELDS", () => $316d359c1f4dfb27$export$b480e0a6893627bb);
$parcel$export(module.exports, "toggleCardEpicFields", () => $316d359c1f4dfb27$export$f47236aa9e8486c);
const $316d359c1f4dfb27$export$4dd62b8143c11245 = 'state.actions.cards.fields.TOGGLE_STATUS_FIELDS';
const $316d359c1f4dfb27$export$8c139077a3243812 = (hideStatusFields)=>({
        type: $316d359c1f4dfb27$export$4dd62b8143c11245,
        payload: {
            hideStatusFields: hideStatusFields
        }
    });
const $316d359c1f4dfb27$export$afb58370a9942348 = 'state.actions.cards.fields.TOGGLE_VERSION_FIELDS';
const $316d359c1f4dfb27$export$2f4945efdaceca5a = (hideVersionFields)=>({
        type: $316d359c1f4dfb27$export$afb58370a9942348,
        payload: {
            hideVersionFields: hideVersionFields
        }
    });
const $316d359c1f4dfb27$export$b480e0a6893627bb = 'state.actions.cards.fields.TOGGLE_EPIC_FIELDS';
const $316d359c1f4dfb27$export$f47236aa9e8486c = (hideEpicFields)=>({
        type: $316d359c1f4dfb27$export$b480e0a6893627bb,
        payload: {
            hideEpicFields: hideEpicFields
        }
    });

});


parcelRegister("a1yUO", function(module, exports) {

$parcel$export(module.exports, "filteredCardsReducer", () => $9a637eafccb10984$export$a42af41a01ab9b7a);

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $8MHVw = parcelRequire("8MHVw");
const $9a637eafccb10984$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filteredCardsIds: null
};
const $9a637eafccb10984$export$a42af41a01ab9b7a = (state = $9a637eafccb10984$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $3lZ6i.SET_APP_DATA)) return action.payload.ui?.cards?.filteredCards ? action.payload.ui.cards.filteredCards : state;
    if (action.type === (0, $8MHVw.FILTERED_CARD_REQUEST) || action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_REQUEST)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_SUCCESS)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload)
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_FAILURE)) return {
        ...state,
        isLoading: false
    };
    if (action.type === (0, $8MHVw.FILTERED_CARD_CLEAR) || action.type === (0, $8MHVw.FILTERED_CARD_CLEAR_SUCCESS) || action.type === (0, $8MHVw.FILTERED_CARD_FAILURE)) return $9a637eafccb10984$export$d4c72bab9d6cc13a;
    if (action.type === (0, $8MHVw.REFILTER_SUCCESS)) {
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            ...filteredCardIds
        ]);
        excludedCardIds.forEach((cardId)=>updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    if (action.type === (0, $hf5c2.CARD_CREATE_SUCCESS)) {
        const { card: card } = action.payload;
        if (card?.hidden) return state;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            String(card.id)
        ]);
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    return state;
};

});

parcelRegister("2XYpA", function(module, exports) {

$parcel$export(module.exports, "focusedReducer", () => $c5f082a10a26cabc$export$d95915a76998fdf);

var $lReb9 = parcelRequire("lReb9");
const $c5f082a10a26cabc$var$initialState = null;
const $c5f082a10a26cabc$export$d95915a76998fdf = (state = $c5f082a10a26cabc$var$initialState, action)=>{
    if (action.type === (0, $lReb9.CARD_FOCUS)) return action.payload.cardId;
    if (action.type === (0, $lReb9.CARD_BLUR)) return null;
    return state;
};

});

parcelRegister("bFper", function(module, exports) {

$parcel$export(module.exports, "lastSelectedCardKeyReducer", () => $62c70271f65aeb86$export$9db40db2e7ad7222);

var $4mqko = parcelRequire("4mqko");
const $62c70271f65aeb86$var$initialState = '';
const $62c70271f65aeb86$export$9db40db2e7ad7222 = (state = $62c70271f65aeb86$var$initialState, action)=>{
    if (action.type === (0, $4mqko.SET_LAST_SELECTED_CARD_KEY)) {
        const { cardKey: cardKey } = action.payload;
        return cardKey;
    }
    return state;
};

});

parcelRegister("5i1vv", function(module, exports) {

$parcel$export(module.exports, "listSelectionRelativeCardReducer", () => $7febb523d89aeee1$export$4c9c80b017b58fa6);

var $4mqko = parcelRequire("4mqko");
const $7febb523d89aeee1$var$initialState = null;
const $7febb523d89aeee1$export$4c9c80b017b58fa6 = (state = $7febb523d89aeee1$var$initialState, action)=>{
    if (action.type === (0, $4mqko.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $4mqko.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        return cardId;
    }
    if (action.type === (0, $4mqko.CARD_EMPTY_SELECTION) || action.type === (0, $4mqko.CARD_CLEAR_RELATIVE_CARD)) return null;
    return state;
};

});

parcelRegister("8PUI4", function(module, exports) {

$parcel$export(module.exports, "richCardReducer", () => $66c15fc17e9d7cef$export$a3aea80312727ab4);

var $9tZuw = parcelRequire("9tZuw");
const $66c15fc17e9d7cef$export$d4c72bab9d6cc13a = {
    mainActiveCard: null,
    cardIdWithAboveIccOpen: null
};
const $66c15fc17e9d7cef$export$a3aea80312727ab4 = (state, action)=>{
    switch(action.type){
        case 0, $9tZuw.SET_RICH_ACTIVE_CARD:
            return {
                ...state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a,
                mainActiveCard: action.payload.cardId
            };
        case 0, $9tZuw.SET_CARD_ID_WITH_ABOVE_ICC_OPEN:
            return {
                ...state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a,
                cardIdWithAboveIccOpen: action.payload.cardId
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state || $66c15fc17e9d7cef$export$d4c72bab9d6cc13a;
            }
    }
};

});

parcelRegister("6MSgp", function(module, exports) {

$parcel$export(module.exports, "selectedReducer", () => $22e2fb32610eb274$export$7c705be79fc8c698);

var $7uUwQ = parcelRequire("7uUwQ");

var $legw4 = parcelRequire("legw4");

var $4mqko = parcelRequire("4mqko");
const $22e2fb32610eb274$var$initialState = (0, $7uUwQ.freeze)([]);
const $22e2fb32610eb274$export$7c705be79fc8c698 = (state = $22e2fb32610eb274$var$initialState, action)=>{
    if (action.type === (0, $4mqko.CARD_TOGGLE_SELECTION)) {
        const { cardId: cardId } = action.payload;
        const selectedCardIndex = state.indexOf(cardId);
        return selectedCardIndex === -1 ? (0, $7uUwQ.push)(state, cardId) : (0, $7uUwQ.splice)(state, selectedCardIndex, 1);
    }
    if (action.type === (0, $4mqko.CARD_SINGLE_SELECT)) {
        const { cardId: cardId } = action.payload;
        return [
            cardId
        ];
    }
    if (action.type === (0, $4mqko.CARD_MULTI_SELECT)) return action.payload.cardIds;
    if (action.type === (0, $4mqko.CARD_EMPTY_SELECTION)) return $22e2fb32610eb274$var$initialState;
    if (action.type === (0, $legw4.CARD_DELETE_REQUEST) || action.type === (0, $legw4.CARD_DELETE)) {
        const { cardId: deletedCardId } = action.payload;
        return state.filter((cardId)=>cardId !== deletedCardId);
    }
    if (action.type === (0, $4mqko.CARD_MULTI_SELECT_EXTEND)) {
        const { cardIds: cardIds } = action.payload;
        return [
            ...new Set([
                ...state,
                ...cardIds
            ])
        ];
    }
    if (action.type === (0, $4mqko.CARD_MULTI_REMOVE)) {
        const { cardIds: cardIds } = action.payload;
        return state.filter((cardId)=>!cardIds.includes(cardId));
    }
    return state;
};

});


parcelRegister("eNpIX", function(module, exports) {

$parcel$export(module.exports, "detailViewReducer", () => $4cff5e06bd7b728d$export$574c967e85ca2750);

var $legw4 = parcelRequire("legw4");

var $38qhf = parcelRequire("38qhf");
const $4cff5e06bd7b728d$export$574c967e85ca2750 = (state = null, action)=>{
    switch(action.type){
        case 0, $38qhf.OPEN_DETAIL_VIEW:
            if (!state || action.payload.cardId !== state.cardId) return {
                timestamp: state ? state.timestamp : Date.now(),
                cardId: action.payload.cardId,
                externalAction: action.payload.externalAction
            };
            return state;
        case 0, $38qhf.UPDATE_DETAIL_VIEW:
            return state ? {
                cardId: state.cardId,
                timestamp: Date.now()
            } : null;
        case 0, $38qhf.CLOSE_DETAIL_VIEW:
            return null;
        case 0, $legw4.CARD_DELETE_REQUEST:
            if (state && state.cardId === action.payload.cardId) return null;
            return state;
        default:
            return state;
    }
};

});

parcelRegister("9wNs2", function(module, exports) {

$parcel$export(module.exports, "default", () => $761cdeded7b26b68$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $eMLHT = parcelRequire("eMLHT");
const $761cdeded7b26b68$var$initialState = {
    isDragging: false,
    isSubtask: false,
    isOverTransitionZone: false,
    sourceCardGroupType: '',
    sourceCardListId: '',
    sourceParentId: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$761cdeded7b26b68$export$2e2bcd8739ae039 = (state = $761cdeded7b26b68$var$initialState, action)=>{
    switch(action.type){
        case 0, $eMLHT.DRAG_START:
            return (0, $7uUwQ.setIn)(state, [
                'isDragging'
            ], true);
        case 0, $eMLHT.DRAG_END:
            return (0, $7uUwQ.setIn)(state, [
                'isDragging'
            ], false);
        case 0, $eMLHT.TRANSITION_ZONE_ENTER:
            return (0, $7uUwQ.setIn)(state, [
                'isOverTransitionZone'
            ], true);
        case 0, $eMLHT.TRANSITION_ZONE_LEAVE:
            return (0, $7uUwQ.setIn)(state, [
                'isOverTransitionZone'
            ], false);
        case 0, $eMLHT.BEFORE_CAPTURE:
            return {
                ...state,
                sourceCardGroupType: action.payload.sourceCardGroupType,
                sourceCardListId: action.payload.sourceCardListId,
                isSubtask: action.payload.isSubtask,
                sourceParentId: action.payload.sourceParentId
            };
        default:
            return state;
    }
};

});

parcelRegister("70ywa", function(module, exports) {

$parcel$export(module.exports, "default", () => $733bf018efec9975$export$2e2bcd8739ae039);

var $likqC = parcelRequire("likqC");
const $733bf018efec9975$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$733bf018efec9975$export$2e2bcd8739ae039 = (state = $733bf018efec9975$var$initialState, action)=>{
    if (action.type === (0, $likqC.SET_ALL_FILTERS)) return action.payload.filters;
    return state;
};

});

parcelRegister("bwP9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23b324b1a2c851a$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
function $b23b324b1a2c851a$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $3lZ6i.LOAD_CONFIG_DATA_MODEL_SUCCESS:
            return true;
        case 0, $3lZ6i.SET_CONFIG_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("cjd7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $52bea3269328f7eb$export$2e2bcd8739ae039);

var $3lZ6i = parcelRequire("3lZ6i");
function $52bea3269328f7eb$export$2e2bcd8739ae039(state = false, action) {
    switch(action.type){
        case 0, $3lZ6i.SET_APP_DATA:
            return true;
        default:
            return state;
    }
}

});

parcelRegister("jcM6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $f786369fe958bf99$export$2e2bcd8739ae039);

var $6zjUi = parcelRequire("6zjUi");
const $f786369fe958bf99$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f786369fe958bf99$export$2e2bcd8739ae039 = (state = $f786369fe958bf99$var$defaultState, action)=>{
    if (action.type === (0, $6zjUi.OPEN_ISSUE_TRANSITION_MODAL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $6zjUi.CLOSE_ISSUE_TRANSITION_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("e03Tz", function(module, exports) {

$parcel$export(module.exports, "modalsReducer", () => $5135aac88c82c9e3$export$c732e1f962e199dd);

var $5Eoed = parcelRequire("5Eoed");
const $5135aac88c82c9e3$export$c732e1f962e199dd = (state = null, action)=>{
    switch(action.type){
        case 0, $5Eoed.OPEN_MODAL:
            return action.payload;
        case 0, $5Eoed.CLOSE_MODAL:
            return null;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("6oZez", function(module, exports) {

$parcel$export(module.exports, "default", () => $484d2bd8c5200dac$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $h9NU3 = parcelRequire("h9NU3");

var $9g0YE = parcelRequire("9g0YE");
const $484d2bd8c5200dac$var$initialState = ()=>({
        [(0, $c35fd6591a78fffe$export$a10c132b86ae798b)]: (0, $h9NU3.isIssueParentPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$41073ac826c57195)]: (0, $h9NU3.isVersionPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$29d7f2210b16d662)]: (0, $h9NU3.isInsightsPanelOpen)(),
        [(0, $c35fd6591a78fffe$export$ba1da943283b9900)]: false
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$484d2bd8c5200dac$export$2e2bcd8739ae039 = (state = $484d2bd8c5200dac$var$initialState(), action)=>{
    switch(action.type){
        case 0, $9g0YE.TOGGLE_PANEL:
            {
                const { payload: { panel: panel } } = action;
                return state[panel] === true ? (0, $7uUwQ.unset)(state, panel) : (0, $7uUwQ.chain)(state).set(panel, true).value();
            }
        case 0, $9g0YE.CLOSE_INSIGHTS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $c35fd6591a78fffe$export$29d7f2210b16d662));
        case 0, $9g0YE.CLOSE_VIEW_SETTINGS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $c35fd6591a78fffe$export$ba1da943283b9900));
        case 0, $9g0YE.SET_ALL_PANELS_SUCCESS:
            return action.payload.panels;
        default:
            return state;
    }
};

});

parcelRegister("fxbtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $260ae5bea4fbca2a$export$2e2bcd8739ae039);

var $lHBhO = parcelRequire("lHBhO");
const $260ae5bea4fbca2a$var$initialState = {
    includeSubtasks: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$260ae5bea4fbca2a$export$2e2bcd8739ae039 = (state = $260ae5bea4fbca2a$var$initialState, action)=>{
    switch(action.type){
        case 0, $lHBhO.TOGGLE_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: !state.includeSubtasks
            };
        case 0, $lHBhO.SET_INCLUDE_SUBTASKS:
            return {
                includeSubtasks: action.payload.includeSubtasks
            };
        default:
            return state;
    }
};

});




parcelRegister("9OvEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4dbe1b645c1b407$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $fpTxz = parcelRequire("fpTxz");

var $jzjy1 = parcelRequire("jzjy1");

var $8lxl7 = parcelRequire("8lxl7");

var $x9xyg = parcelRequire("x9xyg");

var $bC2fB = parcelRequire("bC2fB");



var $3lZ6i = parcelRequire("3lZ6i");

var $a7yHf = parcelRequire("a7yHf");

var $4mqko = parcelRequire("4mqko");

var $9g0YE = parcelRequire("9g0YE");

var $9MUCL = parcelRequire("9MUCL");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $8YYZB = parcelRequire("8YYZB");
const $b4dbe1b645c1b407$export$c31df4bd766f9c35 = (state)=>({
        storyPointFieldId: (0, $jG5HW.getStoryPointFieldId)(state),
        epicIssueType: (0, $jG5HW.getEpicIssueType)(state),
        cardListIds: (0, $dGljH.getVisibleCardListIds)(state),
        cardLists: (0, $dGljH.getCardLists)(state),
        selectedCards: (0, $dGljH.getSelectedCards)(state),
        isDetailViewVisible: (0, $dGljH.shouldShowDetailView)(state),
        getCardKeyFromCardId: (0, $dGljH.makeCardKeyFromCardId)(state),
        collapsedCardLists: (0, $dGljH.getCollapsedCardLists)(state),
        boardId: Number((0, $jG5HW.getRapidViewId)(state)),
        baseUrl: (0, $jG5HW.getBaseUrl)(state),
        projectKey: (0, $jG5HW.getProjectKey)(state),
        backlogSessionId: (0, $jG5HW.getSessionId)(state),
        issueHierarchyLevel: (0, $fmuR9.issueHierarchyLevelSelector)(state)(),
        getSourceCardListId: (0, $dGljH.makeGetSourceCardListId)(state),
        getSourceCardGroupId: (0, $dGljH.makeGetSourceCardGroupId)(state),
        getCardHierarchyLevel: (0, $dGljH.makeGetCardHierarchyLevel)(state)
    });
const $b4dbe1b645c1b407$export$9e6a17cf56877796 = (dispatch)=>({
        onBacklogView: (analyticsEvent)=>{
            dispatch((0, $3lZ6i.backlogView)(analyticsEvent));
        },
        onCardListsDisable: (cardListIds)=>{
            dispatch((0, $a7yHf.cardListsDisable)(cardListIds));
        },
        onCardListsEnableAll: ()=>{
            dispatch((0, $a7yHf.cardListsEnableAll)());
        },
        onCardSingleSelect: (cardId)=>{
            dispatch((0, $4mqko.cardSingleSelect)(cardId));
        },
        onTogglePanel: (panel)=>{
            dispatch((0, $9g0YE.togglePanel)(panel));
        }
    });
const $b4dbe1b645c1b407$var$onPanelClose = ({ onTogglePanel: onTogglePanel }, panelType)=>()=>{
        onTogglePanel(panelType);
    };
const $b4dbe1b645c1b407$var$onBacklogViewFactory = (0, $8QpSo.default)((onBacklogView)=>(analyticsEvent)=>{
        (0, $x9xyg.setMark)((0, $4cb373726ed9c2f0$export$82147bdd117dc85a));
        (0, $x9xyg.setMark)((0, $4cb373726ed9c2f0$export$e9a67bcd28a7fa89));
        onBacklogView(analyticsEvent);
    });
const $b4dbe1b645c1b407$var$onEpicPanelCloseFactory = (0, $8QpSo.default)((onTogglePanel, panelType)=>$b4dbe1b645c1b407$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $b4dbe1b645c1b407$var$onVersionPanelCloseFactory = (0, $8QpSo.default)((onTogglePanel, panelType)=>$b4dbe1b645c1b407$var$onPanelClose({
        onTogglePanel: onTogglePanel
    }, panelType));
const $b4dbe1b645c1b407$export$9d1611c77c2fe928 = ({ storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, cardListIds: cardListIds, isDetailViewVisible: isDetailViewVisible, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, issueHierarchyLevel: issueHierarchyLevel }, { onBacklogView: onBacklogView, onTogglePanel: onTogglePanel }, { isCacheHit: isCacheHit, prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, prefetchedPlanData: prefetchedPlanData, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>({
        isCacheHit: isCacheHit,
        prefetchedData: prefetchedData,
        prefetchedAggData: prefetchedAggData,
        prefetchedPlanData: prefetchedPlanData,
        storyPointFieldId: storyPointFieldId,
        epicIssueType: epicIssueType,
        cardListIds: cardListIds,
        isDetailViewVisible: isDetailViewVisible,
        boardId: boardId,
        baseUrl: baseUrl,
        projectKey: projectKey,
        issueHierarchyLevel: issueHierarchyLevel,
        onBacklogView: $b4dbe1b645c1b407$var$onBacklogViewFactory(onBacklogView),
        onEpicPanelClose: $b4dbe1b645c1b407$var$onEpicPanelCloseFactory(onTogglePanel, (0, $c35fd6591a78fffe$export$a10c132b86ae798b)),
        onVersionPanelClose: $b4dbe1b645c1b407$var$onVersionPanelCloseFactory(onTogglePanel, (0, $c35fd6591a78fffe$export$41073ac826c57195)),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
var $b4dbe1b645c1b407$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $fpTxz.default)(), (0, $8lxl7.default)((state)=>({
        attributes: (0, $9MUCL.getAttributes)(state)
    })), (0, $jzjy1.AnalyticsSubject)('backlog'), (0, $bC2fB.connect)($b4dbe1b645c1b407$export$c31df4bd766f9c35, $b4dbe1b645c1b407$export$9e6a17cf56877796, $b4dbe1b645c1b407$export$9d1611c77c2fe928))((0, $8YYZB.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $bYdUR = parcelRequire("bYdUR");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYdUR.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


const $4cb373726ed9c2f0$export$82147bdd117dc85a = 'BACKLOG_READY_FOR_USER_MARK';
const $4cb373726ed9c2f0$export$e9a67bcd28a7fa89 = 'BACKLOG_INTERACTIVE_MARK';

parcelRegister("8YYZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $083bc8c563c121c0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $34ck9 = parcelRequire("34ck9");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $jKXHg = parcelRequire("jKXHg");

var $5ZW09 = parcelRequire("5ZW09");

var $hP2lu = parcelRequire("hP2lu");

var $hZHze = parcelRequire("hZHze");

var $iAbh9 = parcelRequire("iAbh9");

var $acDhY = parcelRequire("acDhY");

var $5vJHu = parcelRequire("5vJHu");

var $44v1T = parcelRequire("44v1T");

var $7wqBZ = parcelRequire("7wqBZ");

var $dhsbO = parcelRequire("dhsbO");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $8CVvd = parcelRequire("8CVvd");

var $3HwlS = parcelRequire("3HwlS");

var $2Z6La = parcelRequire("2Z6La");

var $iXVV6 = parcelRequire("iXVV6");
var $95EVP = parcelRequire("95EVP");

var $5Nutl = parcelRequire("5Nutl");

var $aJzGl = parcelRequire("aJzGl");

var $5fQw9 = parcelRequire("5fQw9");

var $9hLEH = parcelRequire("9hLEH");

var $7D59a = parcelRequire("7D59a");

var $3U6yu = parcelRequire("3U6yu");

var $baPf2 = parcelRequire("baPf2");

var $dFfIn = parcelRequire("dFfIn");

var $dCm1o = parcelRequire("dCm1o");


var $10Ngv = parcelRequire("10Ngv");

var $f6RVN = parcelRequire("f6RVN");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $1wpyB = parcelRequire("1wpyB");

var $4APWT = parcelRequire("4APWT");

var $gFU0Q = parcelRequire("gFU0Q");

var $2jVnP = parcelRequire("2jVnP");

var $gz0if = parcelRequire("gz0if");

var $ab9TP = parcelRequire("ab9TP");

var $5A42o = parcelRequire("5A42o");

var $X8Rcv = parcelRequire("X8Rcv");

var $d08vq = parcelRequire("d08vq");

var $aPfpu = parcelRequire("aPfpu");

var $bzlhL = parcelRequire("bzlhL");

var $aammX = parcelRequire("aammX");

var $emFUM = parcelRequire("emFUM");

var $b75A0 = parcelRequire("b75A0");

var $h7RbI = parcelRequire("h7RbI");

var $9HRx0 = parcelRequire("9HRx0");

var $gz8lb = parcelRequire("gz8lb");

var $1UKUc = parcelRequire("1UKUc");

var $4MJfo = parcelRequire("4MJfo");
const $083bc8c563c121c0$var$BacklogComponent = ({ isCacheHit: isCacheHit, boardId: boardId, baseUrl: baseUrl, projectKey: projectKey, isDetailViewVisible: isDetailViewVisible, issueHierarchyLevel: issueHierarchyLevel = (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE), cardListIds: cardListIds, onBacklogView: onBacklogViewProp, onEpicPanelClose: onEpicPanelCloseProp, onVersionPanelClose: onVersionPanelCloseProp, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const isViewEventSent = (0, $5uXOq.useRef)(false);
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [openSidebar, setOpenSidebar] = (0, $5uXOq.useState)(false);
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const shouldShowAdminInaccessibleBoard = (0, $hP2lu.useShouldShowAdminInaccessibleBoard)((0, $5Nutl.uifBacklogResource));
    const onBacklogView = (0, $7D59a.useEvent)(onBacklogViewProp);
    const onEpicPanelClose = (0, $7D59a.useEvent)(onEpicPanelCloseProp);
    const onVersionPanelClose = (0, $7D59a.useEvent)(onVersionPanelCloseProp);
    const onOpenSidebar = (0, $5uXOq.useCallback)(()=>{
        setOpenSidebar(true);
    }, []);
    const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
        setOpenSidebar(false);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const timer = setTimeout(()=>{
            (0, $7wqBZ.getLongTasksMetrics)('filter').stop((0, $dhsbO.filterReporter));
        }, 1);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.add('spb');
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.classList.remove('spb');
            clearTimeout(timer);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!isViewEventSent.current && cardListIds.length > 0) {
            isViewEventSent.current = true;
            const analyticsEvent = createAnalyticsEvent({});
            onBacklogView(analyticsEvent);
        }
    }, [
        onBacklogView,
        cardListIds.length,
        createAnalyticsEvent
    ]);
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const bulkOperationsToolbarOld = !(0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5vJHu.useReferenceLoader)() : undefined;
    const bulkOperationsForm = (0, $5vJHu.useReferenceLoader)();
    const issueCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardsCount));
    const userCanEditBoardConfig = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.getPermissions))[0, $a33d0dff7e784665$export$b35e3ebf2c83a499];
    const backlogContainerIssueCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId)).BACKLOG?.length;
    const isScrumBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isScrumBacklogStrategy));
    const getIssueLimitFlagViews = ()=>{
        if (isCMPBoard) return [
            {
                view: 'BACKLOG',
                issueCount: issueCount
            }
        ];
        return [
            {
                view: 'BACKLOG',
                issueCount: backlogContainerIssueCount
            },
            {
                view: isScrumBacklog ? 'SPRINTS' : 'BOARD',
                issueCount: issueCount - backlogContainerIssueCount
            }
        ];
    };
    const isBulkOpsAvailable = (0, $3VzmQ.useShowCheckbox)();
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $083bc8c563c121c0$var$pageHeaderStyles,
        testId: "software-backlog.page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aammX.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }));
    const oldHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$PageHeaderWrapper, {
        "data-test-id": "software-backlog.page-header",
        "data-testid": "software-backlog.page-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aammX.default), {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }));
    const ContainerComponent = (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $083bc8c563c121c0$var$HeightlessContainer : $083bc8c563c121c0$var$Container;
    // created to avoid duplication and will be moved back when cleaning up the FF.
    const backlogContainerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
        "data-test-id": "software-backlog.backlog",
        "data-testid": "software-backlog.backlog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $X8Rcv.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3U6yu.StorageLimitsBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $baPf2.UpFlowPersistentUpgradeBanner), {
        isBannerEnabled: true
    }), (0, $dCm1o.isVisualRefreshEnabled)() ? header : oldHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$SizeDetectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gz8lb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKXHg.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4APWT.default), {
        isDetailViewVisible: isDetailViewVisible,
        parentWidth: width || 0,
        boardId: boardId,
        cardListIds: cardListIds,
        DetailView: (0, $5A42o.default),
        SubmitApdex: (0, $1UKUc.default),
        isCacheHit: isCacheHit,
        CardList: (0, $ab9TP.default),
        BoardIssueMoveDialog: (0, $h7RbI.default),
        onEpicPanelClose: onEpicPanelClose,
        onVersionPanelClose: onVersionPanelClose,
        issueHierarchyLevel: issueHierarchyLevel,
        ...!(0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && {
            bulkOperationsToolbarOld: bulkOperationsToolbarOld
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9HRx0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b75A0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d08vq.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dFfIn.default), {
        baseUrl: baseUrl,
        boardId: String(boardId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MJfo.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $emFUM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpyB.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aPfpu.FiltersStorage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fQw9.default), {
        boardId: boardId,
        isCMP: isCMPBoard,
        isProjectAdmin: userCanEditBoardConfig,
        projectKey: projectKey,
        views: getIssueLimitFlagViews()
    }));
    // Show a message to admin users if the board is inaccessible due to filter permissions and how to update it
    if (shouldShowAdminInaccessibleBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZW09.AsyncAdminInaccessibleBoard), {
        rapidViewId: boardId.toString(),
        skeleton: (0, $aJzGl.NextGenBacklogSkeleton)
    });
    const BulkOpsWrapperComponent = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? (0, $acDhY.BulkOpsWrapper) : (0, $iAbh9.BulkOpsAnalyticsProvider);
    const WrapperComponent = (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $083bc8c563c121c0$var$ConstrainedWrapper : $083bc8c563c121c0$var$Wrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "backlog"
    }, isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.CmpBacklogSlaTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bzlhL.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BulkOpsWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$var$MainContent, null, backlogContainerContent), isBulkOpsAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gz0if.BulkOperationsSidebar), {
        parentWidth: width || 0,
        isOpen: openSidebar,
        bulkOperationsForm: bulkOperationsForm
    })), (isBulkOpsAvailable || (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jVnP.BulkOperationsLoader), {
        bulkOperationsForm: bulkOperationsForm,
        onCloseSidebar: onCloseSidebar,
        onOpenSidebar: onOpenSidebar,
        ...!(0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && {
            bulkOperationsToolbarOld: bulkOperationsToolbarOld
        }
    })), (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        boardId: boardId,
        projectKey: projectKey,
        isCMPBoard: isCMPBoard
    })));
};
const $083bc8c563c121c0$export$2532845c810cfaa1 = /*#__PURE__*/ (0, $5uXOq.memo)($083bc8c563c121c0$var$BacklogComponent);
var // TODO: This is a flaky design. We shouldn't depend on prefetched data being available at certain points.
// As of current if prefetched data is null (which is a valid state), then the issue fields won't be initialized correctly.
// While there is sync. for lots of values, there is not sync for certain required values, such as `HIERARCHY...` fields. On
// that case, switching into the issue fields epic renderers will hide epics.
// In particular, src/packages/issue/fields/parent-switcher/src/controllers/with-sweet-state-parent-switcher/index.tsx
// won't render the field.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$083bc8c563c121c0$export$2e2bcd8739ae039 = ({ prefetchedData: prefetchedData, prefetchedAggData: prefetchedAggData, prefetchedPlanData: prefetchedPlanData, storyPointFieldId: storyPointFieldId, epicIssueType: epicIssueType, ...rest })=>{
    const { storeFieldsFromPrefetchedData: storeFieldsFromPrefetchedData, storeFieldsFromPrefetchedAggData: storeFieldsFromPrefetchedAggData, storeFieldsFromPrefetchedPlanData: storeFieldsFromPrefetchedPlanData } = (0, $10Ngv.useStoreFields)();
    // Initialise extracted fields (Sweet State) using prefetched data (SSR)
    (0, $5uXOq.useEffect)(()=>{
        const fieldConfigs = {
            storyPointFieldId: storyPointFieldId
        };
        if (prefetchedPlanData) storeFieldsFromPrefetchedPlanData(prefetchedPlanData, epicIssueType);
        else if ((0, $f6RVN.isBacklogWithRelayEnabled)() && prefetchedAggData) storeFieldsFromPrefetchedAggData(prefetchedAggData, fieldConfigs);
        else if (prefetchedData) storeFieldsFromPrefetchedData(prefetchedData, fieldConfigs);
    }, [
        prefetchedData,
        prefetchedAggData,
        prefetchedPlanData,
        storeFieldsFromPrefetchedData,
        storeFieldsFromPrefetchedAggData,
        storeFieldsFromPrefetchedPlanData,
        storyPointFieldId,
        epicIssueType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($083bc8c563c121c0$export$2532845c810cfaa1, rest);
};
const $083bc8c563c121c0$var$ConstrainedWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $083bc8c563c121c0$var$constrainedWrapperStyles
    }, children);
const $083bc8c563c121c0$var$HeightlessContainer = ({ children: children, 'data-testid': testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $083bc8c563c121c0$var$heightlessContainerStyles,
        testId: testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $083bc8c563c121c0$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $lD23V.default)((0, $44v1T.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1l47 _4t3i1l47 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$MainContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _1reo15vq _18m915vq _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$SizeDetectorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1osq _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _10pb1h90 _6ndb1osq",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$PageHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp",
            __cmplp.className
        ])
    });
});
const $083bc8c563c121c0$var$pageHeaderStyles = (0, $jJ1Sb.xcss)({
    paddingInline: 'space.300'
});
const $083bc8c563c121c0$var$constrainedWrapperStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    height: '100%',
    overflow: 'hidden'
});
const $083bc8c563c121c0$var$heightlessContainerStyles = (0, $jJ1Sb.xcss)({
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    outline: 'none'
});

});
parcelRegister("5ZW09", function(module, exports) {

$parcel$export(module.exports, "AsyncAdminInaccessibleBoard", () => $bcf1c6c59cc68dbc$export$516550003e785216);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bcf1c6c59cc68dbc$var$AdminInaccessibleBoard = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("6f7T6")), {
    ssr: false,
    moduleId: "./src/packages/software/admin-inaccessible-board/src/ui/main.tsx"
});
const $bcf1c6c59cc68dbc$export$516550003e785216 = (props)=>{
    const Skeleton = props.skeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        packageName: "jiraAdminInaccessibleBoard",
        id: "async-admin-inaccessible-board",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "admin-inaccessible-board",
        fallback: Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bcf1c6c59cc68dbc$var$AdminInaccessibleBoard, props)));
};

});
parcelRegister("6f7T6", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("iDEgf").then(()=>parcelRequire('2Bz5k'));

});


parcelRegister("hP2lu", function(module, exports) {

$parcel$export(module.exports, "useShouldShowAdminInaccessibleBoard", () => $7a289048e0431de9$export$1a15223f3cf409b4);

var $3vXOY = parcelRequire("3vXOY");

var $itmJb = parcelRequire("itmJb");

var $dIdda = parcelRequire("dIdda");
const $7a289048e0431de9$export$1a15223f3cf409b4 = (resource)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const data = (0, $dIdda.useResource)(resource);
    const statusCode = data.error ? (0, $3vXOY.extractStatusCode)(data.error) : null;
    return isAdmin && statusCode === 404;
};

});

parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $g6zRF = parcelRequire("g6zRF");
var $fpTxz = parcelRequire("fpTxz");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $g6zRF.default)({
    componentName: 'view-tracker'
})((0, $fpTxz.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("iAbh9", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $477c8df705ed825f$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $477c8df705ed825f$export$95271787b6ae4d3c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $8p26c = parcelRequire("8p26c");
const $477c8df705ed825f$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $477c8df705ed825f$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $5uXOq.useState)(new (0, $8p26c.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $5uXOq.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($477c8df705ed825f$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $477c8df705ed825f$export$95271787b6ae4d3c = ()=>(0, $5uXOq.useContext)($477c8df705ed825f$var$BulkOpsAnalyticsContext);

});
parcelRegister("8p26c", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $66219c4f12f760b8$export$74bf75c57acfbb74);

var $7Jxgt = parcelRequire("7Jxgt");
class $66219c4f12f760b8$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("acDhY", function(module, exports) {

$parcel$export(module.exports, "useBulkOpsEntryPoint", () => $9114dbe32a67b4e4$export$f263bc273a3aa10f);
$parcel$export(module.exports, "BulkOpsWrapper", () => $9114dbe32a67b4e4$export$e2a60475ecfbe3cf);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $fvbIR = parcelRequire("fvbIR");
const $9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext = (0, $l37qh.createUseEntryPointContext)();
const $9114dbe32a67b4e4$var$emptyObject = {};
const $9114dbe32a67b4e4$var$BulkOpsCoreEntryPointProvider = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $9114dbe32a67b4e4$var$emptyObject);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext.Provider, {
        value: entryPointResult
    }, children);
};
const $9114dbe32a67b4e4$export$f263bc273a3aa10f = ()=>(0, $5uXOq.useContext)($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointContext);
const $9114dbe32a67b4e4$export$e2a60475ecfbe3cf = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAbh9.BulkOpsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9114dbe32a67b4e4$var$BulkOpsCoreEntryPointProvider, null, children));

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("fvbIR", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $187b82d9aad4ec6a$export$d90d57132636bb1);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("aan64")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("aan64", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hXddo")
]).then(()=>parcelRequire('k9wdm'));

});



parcelRegister("5vJHu", function(module, exports) {

$parcel$export(module.exports, "useReferenceLoader", () => $6eeb97186bbafb10$export$727d936bc4a88f4e);

var $5uXOq = parcelRequire("5uXOq");
const $6eeb97186bbafb10$export$727d936bc4a88f4e = ()=>{
    const [ref, setRef] = (0, $5uXOq.useState)(null);
    return (0, $5uXOq.useMemo)(()=>({
            setRef: setRef,
            ref: ref
        }), [
        setRef,
        ref
    ]);
};

});

parcelRegister("7wqBZ", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $f85af650a825558e$export$b092a8653a66aa5e);

var $gJBT6 = parcelRequire("gJBT6");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $cJpFl = parcelRequire("cJpFl");
let $f85af650a825558e$var$observer = null;
const $f85af650a825558e$var$stopObserver = ()=>{
    if ($f85af650a825558e$var$observer) {
        $f85af650a825558e$var$observer.disconnect();
        $f85af650a825558e$var$observer = null;
    }
};
const $f85af650a825558e$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $6RCeq.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $f85af650a825558e$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $f85af650a825558e$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $f85af650a825558e$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $6RCeq.default).now && isStarted) {
                const stopTimestamp = (0, $6RCeq.default).now();
                setTimeout(()=>{
                    $f85af650a825558e$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($f85af650a825558e$var$observer && performanceMark) {
                const perfMark = (0, $x9xyg.getMark)(performanceMark);
                if (!perfMark) {
                    $f85af650a825558e$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("cJpFl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $3e1de7ace69512d1$export$3d38a87309e205a4);
const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("dhsbO", function(module, exports) {

$parcel$export(module.exports, "filterReporter", () => $f7989144fec0a9cf$export$facf842185aa645c);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $f7989144fec0a9cf$export$facf842185aa645c = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('filter', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags,
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-filter', analyticsData);
        try {
            performance.measure('filterBarResponsiveness', 'filterBarStart', 'filterBarStop');
            triggerSoftwareAnalytics('performance-filter-bar', performance.getEntriesByName('filterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        try {
            performance.measure('oldFilterBarResponsiveness', 'oldFilterBarStart', 'oldFilterBarStop');
            triggerSoftwareAnalytics('performance-old-filter-bar', performance.getEntriesByName('oldFilterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        performance.clearMeasures();
    }
};

});
parcelRegister("if7bx", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $3a39af364070fc96$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $3a39af364070fc96$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $3a39af364070fc96$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $3a39af364070fc96$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $3a39af364070fc96$export$7e5f2df95eca342a);

var $gZFbt = parcelRequire("gZFbt");

var $iThRn = parcelRequire("iThRn");

var $6oxJH = parcelRequire("6oxJH");
const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("gZFbt", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $520Yb = parcelRequire("520Yb");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
    return $520Yb(array, $bxDef(iteratee, 2));
}
module.exports = $c5f24a2590a3cbef$var$meanBy;

});
parcelRegister("520Yb", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");
/** Used as references for various `Number` constants. */ var $3a9de433504d679a$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $3a9de433504d679a$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
}
module.exports = $3a9de433504d679a$var$baseMean;

});


parcelRegister("6oxJH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $gBzAF = parcelRequire("gBzAF");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
    return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
}
module.exports = $4a7f273a61dd10a7$var$sumBy;

});



parcelRegister("2Z6La", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $093fa356b2a966b6$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $093fa356b2a966b6$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $093fa356b2a966b6$export$4a7497397d7465fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cSD7y = parcelRequire("cSD7y");
const $093fa356b2a966b6$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
});
const $093fa356b2a966b6$export$f7b8d088c9ea045e = ()=>(0, $5uXOq.useContext)($093fa356b2a966b6$export$2f62d2dfd027123d);
// eslint-disable-next-line jira/react/no-class-components
class $093fa356b2a966b6$var$IccProviderOld extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
            value: {
                initialSummary: this.state.initialSummary,
                initialCardTypeId: this.state.initialCardTypeId,
                initialFieldValues: this.state.initialFieldValues,
                initialProjectId: this.state.initialProjectId,
                onChangeCardType: this.onChangeCardType,
                onChangeSummary: this.onChangeSummary,
                onChangeFieldValue: this.onChangeFieldValue,
                onChangeProject: this.onChangeProject,
                onCancel: this.onCancel,
                onCreate: this.onCreate
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            initialSummary: '',
            initialCardTypeId: null,
            initialFieldValues: new Map(),
            initialProjectId: null
        };
        this.onChangeSummary = (summary)=>{
            this.setState({
                initialSummary: summary
            });
        };
        this.onChangeProject = (projectId)=>{
            this.setState({
                initialProjectId: projectId
            });
        };
        this.onChangeCardType = (cardTypeId)=>{
            this.setState({
                initialCardTypeId: cardTypeId
            });
        };
        this.onChangeFieldValue = (fieldKey, fieldValue)=>{
            this.setState(({ initialFieldValues: initialFieldValues })=>({
                    initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
                }));
        };
        this.onCancel = ()=>{
            this.setState({
                initialSummary: '',
                initialCardTypeId: null
            });
        };
        this.onCreate = ()=>{
            this.setState({
                initialSummary: ''
            });
        };
    }
}
const $093fa356b2a966b6$var$IccProviderNew = (props)=>{
    const [state, setState] = (0, $5uXOq.useState)({
        initialSummary: '',
        initialCardTypeId: null,
        initialFieldValues: new Map(),
        initialProjectId: null
    });
    const onChangeSummary = (0, $5uXOq.useCallback)((summary)=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: summary
            }));
    }, []);
    const onChangeProject = (0, $5uXOq.useCallback)((projectId)=>{
        setState((prevState)=>({
                ...prevState,
                initialProjectId: projectId
            }));
    }, []);
    const onChangeCardType = (0, $5uXOq.useCallback)((cardTypeId)=>{
        setState((prevState)=>({
                ...prevState,
                initialCardTypeId: cardTypeId
            }));
    }, []);
    const onChangeFieldValue = (0, $5uXOq.useCallback)((fieldKey, fieldValue)=>{
        setState(({ initialFieldValues: initialFieldValues, ...prevState })=>({
                ...prevState,
                initialFieldValues: initialFieldValues.set(fieldKey, fieldValue)
            }));
    }, []);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: '',
                initialCardTypeId: null
            }));
    }, []);
    const onCreate = (0, $5uXOq.useCallback)(()=>{
        setState((prevState)=>({
                ...prevState,
                initialSummary: ''
            }));
    }, []);
    const values = (0, $5uXOq.useMemo)(()=>({
            initialSummary: state.initialSummary,
            initialCardTypeId: state.initialCardTypeId,
            initialFieldValues: state.initialFieldValues,
            initialProjectId: state.initialProjectId,
            onChangeCardType: onChangeCardType,
            onChangeSummary: onChangeSummary,
            onChangeFieldValue: onChangeFieldValue,
            onChangeProject: onChangeProject,
            onCancel: onCancel,
            onCreate: onCreate
        }), [
        state,
        onChangeCardType,
        onChangeSummary,
        onChangeFieldValue,
        onChangeProject,
        onCancel,
        onCreate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
        value: values
    }, props.children);
};
const $093fa356b2a966b6$export$4a7497397d7465fc = (0, $cSD7y.componentWithFG)('board_rendering_optimisations', $093fa356b2a966b6$var$IccProviderNew, $093fa356b2a966b6$var$IccProviderOld);

});

parcelRegister("5fQw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbb5d72cb5df9c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $ijYb7 = parcelRequire("ijYb7");
const $9cbb5d72cb5df9c7$var$App = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "app",
        packageName: "jiraSoftwareIssueLimitFlags",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijYb7.IssueLimitFlags), props));
var $9cbb5d72cb5df9c7$export$2e2bcd8739ae039 = $9cbb5d72cb5df9c7$var$App;

});
parcelRegister("ijYb7", function(module, exports) {

$parcel$export(module.exports, "IssueLimitFlags", () => $07c13de1d345d403$export$739da16e22409e4d);

var $5uXOq = parcelRequire("5uXOq");

var $e2T54 = parcelRequire("e2T54");

var $ir9Ry = parcelRequire("ir9Ry");
const $07c13de1d345d403$var$ISSUE_APPROACHING_LIMIT = 4500;
const $07c13de1d345d403$var$ISSUE_REACHED_LIMIT = 5000;
const $07c13de1d345d403$export$739da16e22409e4d = ({ isProjectAdmin: isProjectAdmin, ...flagProps })=>{
    const [limitReachedFlagShown, setLimitReachedFlagShown] = (0, $5uXOq.useState)(false);
    const limitReachedViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const limitApproachingViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_APPROACHING_LIMIT && view.issueCount < $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const shouldShowLimitReachedFlag = limitReachedViews.length > 0;
    const shouldShowLimitApproachingFlag = limitApproachingViews.length > 0 && !limitReachedFlagShown;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowLimitReachedFlag && !limitReachedFlagShown) setLimitReachedFlagShown(true);
    }, [
        limitReachedFlagShown,
        shouldShowLimitReachedFlag
    ]);
    // Check to ensure permission is defined. If value is not boolean, then it likely
    // means it has not yet been loaded
    if (typeof isProjectAdmin !== 'boolean') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowLimitApproachingFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2T54.LimitApproachingFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitApproachingViews
    }), shouldShowLimitReachedFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir9Ry.LimitReachedFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitReachedViews
    }));
};

});
parcelRegister("e2T54", function(module, exports) {

$parcel$export(module.exports, "LimitApproachingFlag", () => $da6681a9a2d62d46$export$c8f47c0b0c12451c);

var $5uXOq = parcelRequire("5uXOq");

var $itVjj = parcelRequire("itVjj");


var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $8g67F = parcelRequire("8g67F");

var $bvUMO = parcelRequire("bvUMO");
const $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID = 'jsw-issue-approaching-reached-flag';
const $da6681a9a2d62d46$export$c8f47c0b0c12451c = ({ isCMP: isCMP, isProjectAdmin: isProjectAdmin, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'approaching'
    });
    const views = flagViews.map((v)=>v.view);
    (0, $5uXOq.useEffect)(()=>{
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $bvUMO.default).boardLimitApproachingFlagTitle : (0, $bvUMO.default).backlogLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagTitle;
            if (views.includes('BACKLOG')) return (0, $bvUMO.default).tmpBacklogLimitApproachingFlagTitle;
            if (views.includes('SPRINTS')) return (0, $bvUMO.default).tmpSprintsLimitApproachingFlagTitle;
            if (views.includes('BOARD')) return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
            return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingAdminFlagBody;
                    const boardLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingEndUserFlagBody;
                    return isProjectAdmin ? boardLimitApproachingAdminFlagBodyMessage : boardLimitApproachingEndUserFlagBodyMessage;
                }
                const backlogLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingAdminFlagBody;
                const backlogLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBody;
                return isProjectAdmin ? backlogLimitApproachingAdminFlagBodyMessage : backlogLimitApproachingEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID,
                type: 'info',
                title: flagTitle,
                description: flagDescription,
                isAutoDismiss: false,
                actions: flagActions,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itVjj))), {
                    primaryColor: `var(--ds-icon-information, ${(0, $5e0c0d4e15efb4a6$exports).B300})`,
                    label: ""
                }),
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitApproachingFlag');
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitApproachingFlag');
        }
        setFlagShown(true);
    }, [
        showFlag,
        isProjectAdmin,
        flagActions,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        views
    ]);
    return null;
};

});
parcelRegister("8g67F", function(module, exports) {

$parcel$export(module.exports, "useFlagActions", () => $fc75b95d4a7d68f1$export$38e4a892c359139d);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");

var $fR4iU = parcelRequire("fR4iU");
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/issue-limits-in-company-managed-projects/';
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID = '1KMwTxMBNiDPhaHMDlfT4u';
function $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource) {
    return {
        content: (0, $fR4iU.default).editFilterCta,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.pathname}?config=filter`,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'editBoardFilter', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        href: $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL,
        target: '_blank',
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitSupportArticle', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        onClick: (_, analyticsEvent)=>{
            setIPHArticleId?.($fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID);
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitIph', {
                flagSource: flagSource
            });
        }
    };
}
const $fc75b95d4a7d68f1$export$226a1330ff7e389b = (projectKey)=>({
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).seeIssuesInSearchCtaIssueTermRefresh : (0, $fR4iU.default).seeIssuesInSearchCta,
        href: `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`
    });
const $fc75b95d4a7d68f1$var$selector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh,
        href: 'TBD'
    }), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCta,
        href: 'TBD'
    }));
const $fc75b95d4a7d68f1$export$2ca20f1de5f009d2 = $fc75b95d4a7d68f1$var$selector();
const $fc75b95d4a7d68f1$export$38e4a892c359139d = ({ isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, flagType: flagType })=>{
    const setIPHArticleId = (0, $5Zxxp.useHelpPanelLink)();
    const flagSource = flagType === 'approaching' ? 'jswIssueLimitApproachingFlag' : 'jswIssueLimitReachedFlag';
    return (0, $5uXOq.useMemo)(()=>{
        if (isCMP) {
            if (isProjectAdmin) return [
                $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource),
                $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId)
            ];
            return [
                $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource)
            ];
        }
        return [
            $fc75b95d4a7d68f1$export$226a1330ff7e389b(projectKey),
            $fc75b95d4a7d68f1$export$2ca20f1de5f009d2
        ];
    }, [
        isCMP,
        projectKey,
        isProjectAdmin,
        flagSource,
        setIPHArticleId
    ]);
};

});
parcelRegister("fR4iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a85e2fb64f1664f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a85e2fb64f1664f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editFilterCta: {
        "id": "software-issue-limit-flags.common.edit-filter-cta",
        "defaultMessage": "Edit filter"
    },
    viewMoreInfoCta: {
        "id": "software-issue-limit-flags.common.view-more-info-cta",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCta: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta",
        "defaultMessage": "See issues in search"
    },
    viewMoreInfoCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.view-more-info-cta-issue-term-refresh",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta-issue-term-refresh",
        "defaultMessage": "See issues in search"
    }
});

});


parcelRegister("bvUMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0496ade39ae6cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae0496ade39ae6cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    backlogLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-flag-title",
        "defaultMessage": "Your board is almost full"
    },
    boardLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBacklogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    tmpSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your sprint section is almost full"
    },
    tmpBacklogSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and sprint sections are almost full"
    },
    tmpBacklogBoardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and board sections are almost full"
    },
    tmpBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    backlogLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    }
});

});


parcelRegister("ir9Ry", function(module, exports) {

$parcel$export(module.exports, "LimitReachedFlag", () => $48372b37d055d7b1$export$b4f3bdfaaded5337);

var $a6ceQ = parcelRequire("a6ceQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k24Fu = parcelRequire("k24Fu");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $9OXo1 = parcelRequire("9OXo1");

var $8g67F = parcelRequire("8g67F");

var $lSfuc = parcelRequire("lSfuc");
const $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID = 'jsw-issue-limit-reached-flag';
const $48372b37d055d7b1$export$b4f3bdfaaded5337 = ({ boardId: boardId, isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const views = flagViews.map((flagView)=>flagView.view);
    const shouldFetchTotalCount = views.length === 1 && [
        'BACKLOG',
        'BOARD'
    ].includes(views[0]);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $a6ceQ.default), {
        cloudId: cloudId,
        issueSearchInput: {
            customInput: {
                jiraSoftwareInput: {
                    context: views[0] === 'BOARD' ? 'BOARD' : 'BACKLOG',
                    jiraEntityId: (0, $k24Fu.JiraSoftwareBoardAri).create({
                        boardId: boardId.toString(),
                        siteId: cloudId
                    }).toString()
                }
            }
        },
        skip: !shouldFetchTotalCount
    }, {
        fetchPolicy: 'network-only'
    });
    const totalCount = data.jira?.issueSearchTotalCount;
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'reached'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchTotalCount && typeof totalCount !== 'number') return;
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $lSfuc.default).boardLimitReachedFlagTitle : (0, $lSfuc.default).backlogLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagTitle;
            if (views.includes('BACKLOG')) return (0, $lSfuc.default).tmpBacklogLimitReachedFlagTitle;
            if (views.includes('SPRINTS')) return (0, $lSfuc.default).tmpSprintsLimitReachedFlagTitle;
            if (views.includes('BOARD')) return (0, $lSfuc.default).boardLimitReachedFlagTitle;
            return (0, $lSfuc.default).boardLimitReachedFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedAdminFlagBody;
                    const boardLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedEndUserFlagBody;
                    return isProjectAdmin ? boardLimitReachedAdminFlagBodyMessage : boardLimitReachedEndUserFlagBodyMessage;
                }
                const backlogLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedAdminFlagBody;
                const backlogLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedEndUserFlagBody;
                return isProjectAdmin ? backlogLimitReachedAdminFlagBodyMessage : backlogLimitReachedEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogLimitReachedFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpSprintsLimitReachedFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                id: $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID,
                type: 'warning',
                title: flagTitle,
                description: formatMessage(flagDescription, {
                    issueCount: totalCount
                }),
                isAutoDismiss: false,
                actions: flagActions,
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitReachedFlag', {
                        totalIssueCount: totalCount
                    });
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitReachedFlag', {
                totalIssueCount: totalCount
            });
            setFlagShown(true);
        }
    }, [
        formatMessage,
        showFlag,
        isProjectAdmin,
        flagActions,
        totalCount,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        shouldFetchTotalCount,
        views
    ]);
    return null;
};

});
parcelRegister("a6ceQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6258a09992b1b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5081ebe1b7c763d83be8f11da4336340>>
 * @relayHash 16968863187b798a94c81fb2f3c02587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256
const $e6258a09992b1b59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "issueSearchTotalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256",
            "metadata": {},
            "name": "limitReachedFlagTotalIssueCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6258a09992b1b59$var$node.hash = "1b2bcb6691b0c1b0f0f93eb3b32f4323";
var $e6258a09992b1b59$export$2e2bcd8739ae039 = $e6258a09992b1b59$var$node;

});

parcelRegister("lSfuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cabc45eb3d95785$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3cabc45eb3d95785$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    backlogLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-flag-title",
        "defaultMessage": "Your board is full"
    },
    boardLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBacklogSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-title",
        "defaultMessage": "Your backlog and sprint sections are full"
    },
    tmpSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-title",
        "defaultMessage": "Your sprint section is full"
    },
    tmpBacklogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    tmpBacklogBoardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-title",
        "defaultMessage": "Your backlog and board sections are full"
    },
    tmpBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    },
    backlogLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    }
});

});




parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $hPtZI.lazy)(()=>(parcelRequire("fVxX7")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("fVxX7", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("3gkNR")
]).then(()=>parcelRequire('9pQJj'));

});


parcelRegister("3U6yu", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $281484b8f4d3a170$export$3250e2c90ae56dd9);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $281484b8f4d3a170$var$LazyStorageLimitBanner = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("54Nx6")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $281484b8f4d3a170$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: (0, $59503b90ac06f221$export$5dec3c05c01dac30),
        packageName: (0, $59503b90ac06f221$export$b8b9d90f9e5bd72b),
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($281484b8f4d3a170$var$LazyStorageLimitBanner, props)));

});
const $59503b90ac06f221$export$bab748d4654ac4a5 = 0.9;
const $59503b90ac06f221$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $59503b90ac06f221$export$df9953733f41292a = 'storageLimitsBanner';
const $59503b90ac06f221$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $59503b90ac06f221$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("54Nx6", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8o7lR").then(()=>parcelRequire('iMYa9'));

});


parcelRegister("baPf2", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $56fd693f7a702d43$export$39832316603e4613);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $eSynq = parcelRequire("eSynq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $56fd693f7a702d43$var$LazyUpFlowPersistentUpgradeBanner = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("8QRNO")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $56fd693f7a702d43$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: (0, $eSynq.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $eSynq.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56fd693f7a702d43$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("eSynq", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $4cf197dc11aa7836$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $4cf197dc11aa7836$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $4cf197dc11aa7836$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $4cf197dc11aa7836$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $4cf197dc11aa7836$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $4cf197dc11aa7836$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $4cf197dc11aa7836$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $4cf197dc11aa7836$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $4cf197dc11aa7836$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $4cf197dc11aa7836$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $4cf197dc11aa7836$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $4cf197dc11aa7836$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $4cf197dc11aa7836$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $4cf197dc11aa7836$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $4cf197dc11aa7836$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $4cf197dc11aa7836$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $4cf197dc11aa7836$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $4cf197dc11aa7836$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $4cf197dc11aa7836$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $4cf197dc11aa7836$export$55aa1fd7f74b53);
const $4cf197dc11aa7836$export$75e961f06f21e171 = 'pre-trial';
const $4cf197dc11aa7836$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $4cf197dc11aa7836$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $4cf197dc11aa7836$export$a2684b22124cc502 = 'persistent-upgrade';
const $4cf197dc11aa7836$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $4cf197dc11aa7836$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $4cf197dc11aa7836$export$b8743c23616e54ee = 3;
const $4cf197dc11aa7836$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $4cf197dc11aa7836$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $4cf197dc11aa7836$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $4cf197dc11aa7836$export$8b4682bf35504518 = 'sendOperationalEvent';
const $4cf197dc11aa7836$export$6d01cae610456af2 = 'success';
const $4cf197dc11aa7836$export$6a238c78062d3b8d = 'failed';
const $4cf197dc11aa7836$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $4cf197dc11aa7836$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $4cf197dc11aa7836$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $4cf197dc11aa7836$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $4cf197dc11aa7836$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $4cf197dc11aa7836$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $4cf197dc11aa7836$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("8QRNO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("PpXIG").then(()=>parcelRequire('iLKFx'));

});


parcelRegister("dFfIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54faa42ed76e90b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $cACkL = parcelRequire("cACkL");
const $c54faa42ed76e90b$var$AddBoardToHistory = ({ baseUrl: baseUrl, boardId: boardId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: ()=>(0, $cACkL.addBoardToHistory)(baseUrl, boardId)
    });
var $c54faa42ed76e90b$export$2e2bcd8739ae039 = $c54faa42ed76e90b$var$AddBoardToHistory;

});
parcelRegister("cACkL", function(module, exports) {

$parcel$export(module.exports, "addBoardToHistory", () => $350fcc2e90657d19$export$eef897770c591084);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
const $350fcc2e90657d19$export$eef897770c591084 = (baseUrl, boardId)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/greenhopper/1.0/rapidview/addtohistory`, {
        body: JSON.stringify({
            rapidViewId: boardId
        })
    }).catch((e)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('software.view-history.src.services', 'Cannot add board to recent history', e);
    });

});


parcelRegister("fSgHa", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBacklog", () => $917a155ff75b7326$export$7154dac79ee0a0dc);
$parcel$export(module.exports, "useIsCMPKanbanBacklog", () => $917a155ff75b7326$export$fedd46f53876dc1c);

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $917a155ff75b7326$export$7154dac79ee0a0dc = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
const $917a155ff75b7326$export$fedd46f53876dc1c = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));

});

parcelRegister("3VzmQ", function(module, exports) {

$parcel$export(module.exports, "useShowCheckbox", () => $d1a4e58dde96d894$export$78efc2489ae380a9);

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $d1a4e58dde96d894$export$78efc2489ae380a9 = ()=>{
    const isCheckboxSelection = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCheckboxSelectionMode));
    const hasMoreThanOneSelectedCard = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards)).length > 1;
    return isCheckboxSelection || hasMoreThanOneSelectedCard;
};

});

parcelRegister("1wpyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b0304ef56de034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $3f70T = parcelRequire("3f70T");
const $58b0304ef56de034$var$AllFieldsSync = ()=>{
    const cardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIds));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, cardIds.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f70T.default), {
            key: id,
            cardId: id
        })));
};
var $58b0304ef56de034$export$2e2bcd8739ae039 = $58b0304ef56de034$var$AllFieldsSync;

});
parcelRegister("3f70T", function(module, exports) {

$parcel$export(module.exports, "default", () => $371a2c6df5a70765$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $6NpRl = parcelRequire("6NpRl");

var $6ObdQ = parcelRequire("6ObdQ");

var $iw4r6 = parcelRequire("iw4r6");

var $hAlb7 = parcelRequire("hAlb7");

var $jsuz0 = parcelRequire("jsuz0");

var $74GNh = parcelRequire("74GNh");

var $diays = parcelRequire("diays");
const $371a2c6df5a70765$var$FieldSync = ({ cardId: cardId })=>{
    const shouldSync = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(cardId) || (0, $dGljH.shouldRenderRichElements)(state, {
            cardId: cardId
        }));
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[String(cardId)]);
    const intl = (0, $koVbs.default)();
    // don't unmount syncing if once enabled
    const [sync, setSync] = (0, $5uXOq.useState)(shouldSync);
    (0, $5uXOq.useEffect)(()=>{
        if (!sync && shouldSync) setSync(true);
    }, [
        sync,
        shouldSync
    ]);
    // don't sync if card is not fetched from state correctly
    if (!card) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (sync || shouldSync) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ObdQ.default), {
        card: card,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74GNh.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsuz0.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NpRl.default), {
        card: card
    }), !(0, $co1wz.ff)('relay-migration-issue-fields-summary_eog1v') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $diays.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iw4r6.default), {
        card: card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hAlb7.default), {
        card: card
    })));
};
var $371a2c6df5a70765$export$2e2bcd8739ae039 = $371a2c6df5a70765$var$FieldSync;

});
parcelRegister("6NpRl", function(module, exports) {

$parcel$export(module.exports, "default", () => $55247a924c44482a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fhSLy = parcelRequire("fhSLy");

var $3fAi8 = parcelRequire("3fAi8");


var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $2HxVZ = parcelRequire("2HxVZ");
const $55247a924c44482a$var$FieldSyncAssignee = ({ card: { key: key, id: id, assignee: assigneeFromBacklog } })=>{
    const { id: assigneeIdFromBacklog, displayName: assigneeNameFromBacklog, avatarUrl: assigneeAvatarUrlFromBacklog } = assigneeFromBacklog || {};
    const [assigneeFromExtractedFields, { setFieldValue: setAssigneeInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const { accountId: assigneeIdFromExtractedFields, displayName: assigneeNameFromExtractedFields } = assigneeFromExtractedFields || {};
    const assigneeAvatarUrlFromExtractedFields = assigneeFromExtractedFields?.avatarUrls?.['48x48'];
    const assigneeFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        assigneeIdFromBacklog
    ]);
    const assigneeFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        assigneeIdFromExtractedFields
    ]);
    const setAssigneeInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $2HxVZ.cardAssigneeSet));
    const storesNeedToSync = assigneeIdFromBacklog !== assigneeIdFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const assigneeFromBacklogIsDefined = assigneeFromBacklog !== undefined;
        // ASSIGNEE SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (assigneeFromBacklogIsDefined && assigneeFromBacklogChanged && storesNeedToSync) setAssigneeInExtractedFields(key, (0, $e9be48d6d2c01760$export$e18419056f3d184a), // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromBacklog ? (0, $fhSLy.getUserShape)(assigneeIdFromBacklog, // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        assigneeNameFromBacklog, assigneeAvatarUrlFromBacklog) : null);
    }, [
        key,
        assigneeFromBacklog,
        assigneeIdFromBacklog,
        assigneeNameFromBacklog,
        assigneeAvatarUrlFromBacklog,
        assigneeFromBacklogChanged,
        storesNeedToSync,
        setAssigneeInExtractedFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const assigneeFromExtractedFieldsIsDefined = assigneeFromExtractedFields !== undefined;
        // ASSIGNEE SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline assignee edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !assigneeFromBacklogChanged && assigneeFromExtractedFieldsIsDefined && assigneeFromExtractedFieldsChanged && storesNeedToSync) setAssigneeInBacklog(id, // if assignee id is '', null or undefined => set assignee to null
        assigneeIdFromExtractedFields ? {
            id: assigneeIdFromExtractedFields,
            displayName: assigneeNameFromExtractedFields,
            avatarUrl: assigneeAvatarUrlFromExtractedFields
        } : null);
    }, [
        id,
        assigneeFromBacklogChanged,
        assigneeFromExtractedFields,
        assigneeIdFromExtractedFields,
        assigneeNameFromExtractedFields,
        assigneeAvatarUrlFromExtractedFields,
        assigneeFromExtractedFieldsChanged,
        storesNeedToSync,
        setAssigneeInBacklog
    ]);
    return null;
};
var $55247a924c44482a$export$2e2bcd8739ae039 = $55247a924c44482a$var$FieldSyncAssignee;

});
parcelRegister("iefb6", function(module, exports) {

$parcel$export(module.exports, "useDiffCheck", () => $244ab56ac6cb1c50$export$5ade32966816005f);

var $5uXOq = parcelRequire("5uXOq");
const $244ab56ac6cb1c50$export$5ade32966816005f = (nextValues = [])=>{
    const ref = (0, $5uXOq.useRef)([]);
    const prevValues = ref.current;
    ref.current = nextValues;
    return prevValues.length ? prevValues.some((value, i)=>nextValues[i] !== value) : false;
};

});


parcelRegister("6ObdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8a76a3e9026e6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");


var $etKNj = parcelRequire("etKNj");

var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $3EtSK = parcelRequire("3EtSK");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");
const $fe8a76a3e9026e6a$var$FieldSyncOriginalEstimate = ({ card: { id: id, key: key, estimate: estimate }, intl: intl })=>{
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isOriginalEstimateType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.isOriginalEstimateTypeSelector));
    const setOriginalEstimateInBacklog = (0, $c1MAf.useBacklogActionCreator)((cardId, value)=>{
        const originalEstimate = value === null ? null : {
            value: value,
            valueAsText: (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, intl)
        };
        return (0, $3EtSK.cardEstimateSet)(cardId, {
            originalEstimate: originalEstimate
        });
    });
    const estimateFromBacklog = estimate?.originalEstimate;
    const originalEstimateFromBacklog = estimateFromBacklog?.value ?? null;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the original estimate changes from elsewhere in the backlog
    const [originalEstimateFromExtractedFields, { setFieldValue: setOriginalEstimateInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)
    });
    const originalEstimateFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        originalEstimateFromBacklog
    ]);
    const originalEstimateFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        originalEstimateFromExtractedFields
    ]);
    const storesNeedToSync = originalEstimateFromBacklog !== originalEstimateFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const originalEstimateFromBacklogIsDefined = estimateFromBacklog !== undefined;
        const shouldSync = originalEstimateFromBacklogIsDefined && originalEstimateFromBacklogChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the original estimate value changes elsewhere or the card is initially rendered
        if (shouldSync) setOriginalEstimateInExtractedFields(key, (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2), originalEstimateFromBacklog);
    }, [
        key,
        estimateFromBacklog,
        originalEstimateFromBacklog,
        originalEstimateFromBacklogChanged,
        storesNeedToSync,
        setOriginalEstimateInExtractedFields,
        isOriginalEstimateType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const originalEstimateFromExtractedFieldsIsDefined = originalEstimateFromExtractedFields !== undefined;
        const shouldSync = !originalEstimateFromBacklogChanged && originalEstimateFromExtractedFieldsIsDefined && originalEstimateFromExtractedFieldsChanged && storesNeedToSync && isOriginalEstimateType;
        // ORIGINAL ESTIMATE SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the original estimate is changed within extracted fields
        if (shouldSync) setOriginalEstimateInBacklog(id, originalEstimateFromExtractedFields);
    }, [
        id,
        originalEstimateFromBacklogChanged,
        originalEstimateFromExtractedFields,
        originalEstimateFromExtractedFieldsChanged,
        storesNeedToSync,
        setOriginalEstimateInBacklog,
        isOriginalEstimateType
    ]);
    return null;
};
var $fe8a76a3e9026e6a$export$2e2bcd8739ae039 = $fe8a76a3e9026e6a$var$FieldSyncOriginalEstimate;

});
parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});



parcelRegister("iw4r6", function(module, exports) {

$parcel$export(module.exports, "default", () => $24811e058ab38ecc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $5fc53 = parcelRequire("5fc53");

var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $gkSeR = parcelRequire("gkSeR");

var $fmuR9 = parcelRequire("fmuR9");
const $24811e058ab38ecc$var$FieldSyncParent = ({ card: { key: key, id: id, parentId: parentIdFromBacklog } })=>{
    const [parentFromExtractedFields, { setFieldValue: setParentInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    // parentId in cards is number | null
    const parentIdFromExtractedFields = parentFromExtractedFields?.id ? Number(parentFromExtractedFields.id) : null;
    const parentNameFromExtractedFields = parentFromExtractedFields?.fields?.summary ?? null;
    const parentColorFromExtractedFields = parentFromExtractedFields?.color ?? null;
    const parentIdFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        parentIdFromBacklog
    ]);
    const parentIdFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        parentIdFromExtractedFields
    ]);
    const storesNeedToSync = parentIdFromBacklog !== parentIdFromExtractedFields;
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const setParentInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $gkSeR.cardParentIdSet));
    (0, $5uXOq.useEffect)(()=>{
        const parentIdFromBacklogIsDefined = parentIdFromBacklog !== undefined;
        // PARENT SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (parentIdFromBacklogIsDefined && parentIdFromBacklogChanged && storesNeedToSync) {
            const parent = issueParents.length && parentIdFromBacklog && issueParents.find((p)=>Number(p.id) === Number(parentIdFromBacklog));
            setParentInExtractedFields(key, (0, $5fc53.PARENT_TYPE), parentIdFromBacklogIsDefined && parent ? (0, $7Fute.getParentShape)(parent.id, parent.key, parent.summary, {
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            }) : null);
        }
    }, [
        key,
        storesNeedToSync,
        setParentInExtractedFields,
        parentIdFromBacklog,
        parentIdFromBacklogChanged,
        issueParents
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parentIdFromExtractedFieldsIsDefined = parentIdFromExtractedFields !== undefined;
        // PARENT SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline parent edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !parentIdFromBacklogChanged && parentIdFromExtractedFieldsIsDefined && parentIdFromExtractedFieldsChanged && storesNeedToSync) setParentInBacklog(id, parentIdFromExtractedFields);
    }, [
        id,
        storesNeedToSync,
        setParentInBacklog,
        parentIdFromExtractedFields,
        parentIdFromBacklogChanged,
        parentIdFromExtractedFieldsChanged
    ]);
    // update epic summary/color if it has been changed in the issue view
    (0, $5uXOq.useEffect)(()=>{
        const parent = issueParents.length && parentIdFromExtractedFields && issueParents.find((p)=>Number(p.id) === Number(parentIdFromExtractedFields));
        if (parent && (parentNameFromExtractedFields !== parent.summary || parentColorFromExtractedFields !== parent.color)) setParentInExtractedFields(key, (0, $5fc53.PARENT_TYPE), (0, $7Fute.getParentShape)(parent.id, parent.key, parent.summary, {
            id: parent.issueType.id,
            name: parent.issueType.name,
            iconUrl: parent.issueType.iconUrl
        }, parent.color));
    }, [
        issueParents,
        key,
        parentColorFromExtractedFields,
        parentIdFromExtractedFields,
        parentNameFromExtractedFields,
        setParentInExtractedFields
    ]);
    return null;
};
var $24811e058ab38ecc$export$2e2bcd8739ae039 = $24811e058ab38ecc$var$FieldSyncParent;

});

parcelRegister("hAlb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d056ec667262cb2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $c7Xu8 = parcelRequire("c7Xu8");
const $8d056ec667262cb2$export$32a891753e1d9d91 = ({ card: { id: id, key: key, priority: priorityFromBacklog } })=>{
    const setPriorityInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $c7Xu8.cardPrioritySet));
    const [priorityFromExtractedField, { setFieldValue: setPriorityInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    const priorityFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        priorityFromBacklog?.name
    ]);
    const priorityFromExtractedFieldChanged = (0, $iefb6.useDiffCheck)([
        priorityFromExtractedField?.name
    ]);
    const storesNeedToSync = priorityFromBacklog !== priorityFromExtractedField;
    (0, $5uXOq.useEffect)(()=>{
        const priorityFromBacklogIsDefined = priorityFromBacklog !== undefined;
        if (priorityFromBacklogIsDefined && priorityFromBacklogChanged && storesNeedToSync) setPriorityInExtractedField(key, (0, $5fc53.PRIORITY_TYPE), priorityFromBacklog);
    }, [
        key,
        priorityFromBacklogChanged,
        storesNeedToSync,
        setPriorityInExtractedField,
        priorityFromBacklog
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const priorityFromExtractedFieldIsDefined = priorityFromExtractedField !== undefined;
        if (!priorityFromBacklogChanged && priorityFromExtractedFieldIsDefined && priorityFromExtractedFieldChanged && storesNeedToSync) setPriorityInBacklog({
            cardId: id,
            priority: priorityFromExtractedField
        });
    }, [
        id,
        priorityFromBacklogChanged,
        priorityFromExtractedField,
        priorityFromExtractedFieldChanged,
        storesNeedToSync,
        setPriorityInBacklog
    ]);
    return null;
};
var $8d056ec667262cb2$export$2e2bcd8739ae039 = $8d056ec667262cb2$export$32a891753e1d9d91;

});

parcelRegister("jsuz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $850a9cb0391bfc75$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");

var $44VbI = parcelRequire("44VbI");


var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $czUNp = parcelRequire("czUNp");

var $jG5HW = parcelRequire("jG5HW");

var $bAfUr = parcelRequire("bAfUr");
const $850a9cb0391bfc75$var$FieldSyncStatus = ({ card: card })=>{
    const statusFromBacklog = (0, $c1MAf.useBacklogSelector)((state)=>card ? (0, $bAfUr.getColumnStatusByStatusId)(card.statusId)(state) : null);
    const isCMP = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const { key: cardKey, id: cardId, statusId: cardStatusId } = card;
    const setStatusInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $czUNp.cardStatusSet));
    const { id: statusIdFromBacklog, name: statusNameFromBacklog, category: statusCategoryFromBacklog } = statusFromBacklog || {};
    const [statusFromExtractedFields, { setFieldValue: setStatusInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: cardKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const { id: statusIdFromExtractedFields, statusCategory: statusCategoryFromExtractedFields } = statusFromExtractedFields || {};
    const statusFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        statusIdFromBacklog
    ]);
    const statusFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        statusIdFromExtractedFields
    ]);
    const storesNeedToSync = statusIdFromBacklog !== statusIdFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const statusFromBacklogIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFromBacklog) && Boolean(statusIdFromBacklog);
        // STATUS SYNC: BACKLOG -> EXTRACTED FIELDS
        // initial value, realtime...
        if (statusFromBacklogIsDefined && statusFromBacklogChanged && storesNeedToSync) setStatusInExtractedFields(cardKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), (0, $44VbI.getStatusShape)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        statusIdFromBacklog, statusNameFromBacklog, statusCategoryFromBacklog));
    }, [
        cardKey,
        statusFromBacklog,
        statusIdFromBacklog,
        statusNameFromBacklog,
        statusCategoryFromBacklog,
        statusFromBacklogChanged,
        storesNeedToSync,
        setStatusInExtractedFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const statusFromExtractedFieldsIsDefined = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFromExtractedFields) && Boolean(statusIdFromExtractedFields);
        // STATUS SYNC: EXTRACTED FIELDS -> BACKLOG REDUX
        // issue view updates, inline status edit...
        if (// Ensure no sync will be called by Backlog as Backlog is the driver
        !statusFromBacklogChanged && statusFromExtractedFieldsIsDefined && statusFromExtractedFieldsChanged && storesNeedToSync) setStatusInBacklog(cardId, cardStatusId, statusIdFromExtractedFields, // @ts-expect-error TS2345: Argument of type 'string' is not assignable to parameter of type 'StatusCategoryKeys'.
        (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusCategoryFromExtractedFields.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED, isCMP);
    }, [
        cardId,
        cardStatusId,
        statusFromBacklogChanged,
        statusFromExtractedFields,
        statusIdFromExtractedFields,
        statusCategoryFromExtractedFields,
        statusFromExtractedFieldsChanged,
        storesNeedToSync,
        setStatusInBacklog,
        isCMP
    ]);
    return null;
};
var $850a9cb0391bfc75$export$2e2bcd8739ae039 = $850a9cb0391bfc75$var$FieldSyncStatus;

});

parcelRegister("74GNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4321c2b9a622196$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $3EtSK = parcelRequire("3EtSK");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");
const $e4321c2b9a622196$var$FieldSyncStoryPoint = ({ card: { id: id, key: key, estimate: estimate } })=>{
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const isNumericEstimateType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.isNumericEstimateTypeSelector));
    const setStoryPointInBacklog = (0, $c1MAf.useBacklogActionCreator)((cardId, storyPoints)=>(0, $3EtSK.cardEstimateSet)(cardId, {
            storyPoints: storyPoints
        }));
    const StoryPointKey = storyPointFieldId || '';
    const storyPointFromBacklog = estimate?.storyPoints;
    // This hook updates the state used by bento in the field value service. It's necessary to provide the initial value
    // and to update the bento store when the story point changes from elsewhere in the backlog
    const [storyPointFromExtractedFields, { setFieldValue: setStoryPointInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: StoryPointKey
    });
    const storyPointFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        storyPointFromBacklog
    ]);
    const storyPointFromExtractedFieldsChanged = (0, $iefb6.useDiffCheck)([
        storyPointFromExtractedFields
    ]);
    const storesNeedToSync = storyPointFromBacklog !== storyPointFromExtractedFields;
    (0, $5uXOq.useEffect)(()=>{
        const storyPointFromBacklogIsDefined = storyPointFromBacklog !== undefined;
        const shouldSync = StoryPointKey && storyPointFromBacklogIsDefined && storyPointFromBacklogChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: BACKLOG -> EXTRACTED FIELDS
        // Update sweet state (extracted field) when the story point value changes elsewhere or the card is initially rendered
        if (shouldSync) setStoryPointInExtractedFields(key, StoryPointKey, storyPointFromBacklog);
    }, [
        StoryPointKey,
        key,
        storyPointFromBacklog,
        storyPointFromBacklogChanged,
        storesNeedToSync,
        setStoryPointInExtractedFields,
        isNumericEstimateType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const storyPointFromExtractedFieldsIsDefined = storyPointFromExtractedFields !== undefined;
        const shouldSync = !storyPointFromBacklogChanged && storyPointFromExtractedFieldsIsDefined && storyPointFromExtractedFieldsChanged && storesNeedToSync && isNumericEstimateType;
        // STORY POINT SYNC: EXTRACTED FIELDS -> BACKLOG
        // Update the backlog store if the value of the story point is changed within extracted fields
        if (shouldSync) setStoryPointInBacklog(id, storyPointFromExtractedFields);
    }, [
        id,
        storyPointFromBacklogChanged,
        storyPointFromExtractedFields,
        storyPointFromExtractedFieldsChanged,
        storesNeedToSync,
        setStoryPointInBacklog,
        isNumericEstimateType
    ]);
    return null;
};
var $e4321c2b9a622196$export$2e2bcd8739ae039 = $e4321c2b9a622196$var$FieldSyncStoryPoint;

});

parcelRegister("diays", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ced2c1f60aaba6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");


var $iefb6 = parcelRequire("iefb6");

var $c1MAf = parcelRequire("c1MAf");

var $kB9og = parcelRequire("kB9og");
const $99ced2c1f60aaba6$export$e5eb14bcd03ae390 = ({ card: { id: id, key: key, summary: summaryFromBacklog } })=>{
    const setSummaryInBacklog = (0, $c1MAf.useBacklogActionCreator)((0, $kB9og.cardSummarySet));
    const [summaryFromExtractedField, { setFieldValue: setSummaryInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f)
    });
    const summaryFromBacklogChanged = (0, $iefb6.useDiffCheck)([
        summaryFromBacklog
    ]);
    const summaryFromExtractedFieldChanged = (0, $iefb6.useDiffCheck)([
        summaryFromExtractedField
    ]);
    const storesNeedToSync = summaryFromBacklog !== summaryFromExtractedField;
    // Fixes creating issues from GIC where redux isn't synced with React Sweet
    // State. This is a workaround to unblock me. There is a more permanent
    // solution being investigated here
    // https://hello.atlassian.net/browse/DEE-923
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        const summaryFromExtractedFieldIsUndefined = summaryFromExtractedField === undefined;
        if (summaryFromBacklogIsDefined && summaryFromExtractedFieldIsUndefined) setSummaryInExtractedField(key, (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        setSummaryInExtractedField,
        summaryFromBacklog,
        summaryFromExtractedField
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromBacklogIsDefined = summaryFromBacklog !== undefined;
        if (summaryFromBacklogIsDefined && summaryFromBacklogChanged && storesNeedToSync) setSummaryInExtractedField(key, (0, $e9be48d6d2c01760$export$e7cf1830fe735d1f), summaryFromBacklog);
    }, [
        key,
        summaryFromBacklog,
        summaryFromBacklogChanged,
        storesNeedToSync,
        setSummaryInExtractedField
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const summaryFromExtractedFieldIsDefined = summaryFromExtractedField !== undefined;
        if (!summaryFromBacklogChanged && summaryFromExtractedFieldIsDefined && summaryFromExtractedFieldChanged && storesNeedToSync) setSummaryInBacklog(id, summaryFromExtractedField);
    }, [
        id,
        summaryFromBacklogChanged,
        summaryFromExtractedField,
        summaryFromExtractedFieldChanged,
        storesNeedToSync,
        setSummaryInBacklog
    ]);
    return null;
};
var $99ced2c1f60aaba6$export$2e2bcd8739ae039 = $99ced2c1f60aaba6$export$e5eb14bcd03ae390;

});



parcelRegister("4APWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c3b0ca80e674de$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $et6P7 = parcelRequire("et6P7");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $c2Ik2 = parcelRequire("c2Ik2");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $fSgHa = parcelRequire("fSgHa");

var $87wCD = parcelRequire("87wCD");

var $jV4Wh = parcelRequire("jV4Wh");

var $f8qNM = parcelRequire("f8qNM");
const $46c3b0ca80e674de$var$BacklogContentContainerInner = (props)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.selectedCardsForVersionsPanelSelector));
    const lastFilteredIssueTypeId = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getLastFilteredIssueTypeId));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const epicLinkFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getEpicLinkFieldId));
    const firstNonEmptyCardListId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getFirstNonEmptyCardListId));
    const lastNonEmptyCardListId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getLastNonEmptyCardListId));
    const pushEvent = (0, $jV4Wh.useBatchOnReceive)();
    const onCardDetailClick = (0, $c1MAf.useBacklogActionCreator)((0, $4mqko.parentClick));
    const onEpicCreate = (0, $c1MAf.useBacklogActionCreator)((issueParents)=>(0, $c2Ik2.issueParentsCreateSet)({
            issueParents: issueParents
        }));
    const onVersionAltered = (0, $5uXOq.useCallback)((version)=>{
        if (isCompanyManaged) dispatch((0, $gwOHY.updateVersion)({
            id: version.versionId,
            name: version.name,
            projectId: Number(version.projectId)
        }));
        dispatch((0, $38qhf.updateDetailView)());
    }, [
        dispatch,
        isCompanyManaged
    ]);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const onEpicAssign = (0, $c1MAf.useBacklogActionCreator)((cards, parentId, requestPromise)=>(0, $et6P7.cardsParentSetOptimistic)({
            cards: cards,
            parentId: parentId,
            requestPromise: requestPromise
        }));
    const onReceive = (0, $5uXOq.useCallback)((eventType, payload)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        pushEvent(event);
    }, [
        pushEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8qNM.default), {
        ...props,
        selectedCards: selectedCards,
        selectedCardTypeId: lastFilteredIssueTypeId,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        onIssueVersionsUpdated: onIssueVersionsUpdated,
        onVersionAltered: onVersionAltered,
        onReceive: onReceive,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        firstNonEmptyCardListId: firstNonEmptyCardListId,
        lastNonEmptyCardListId: lastNonEmptyCardListId,
        issueHierarchyLevel: props.issueHierarchyLevel
    });
};
const $46c3b0ca80e674de$var$BacklogContentContainer = /*#__PURE__*/ (0, $5uXOq.memo)($46c3b0ca80e674de$var$BacklogContentContainerInner);
var $46c3b0ca80e674de$export$2e2bcd8739ae039 = $46c3b0ca80e674de$var$BacklogContentContainer;

});
parcelRegister("87wCD", function(module, exports) {

$parcel$export(module.exports, "useOnIssueVersionsUpdated", () => $7c82466ffb9b2c1f$export$4b98876a65f85873);

var $5uXOq = parcelRequire("5uXOq");

var $fdAim = parcelRequire("fdAim");

var $38qhf = parcelRequire("38qhf");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $7c82466ffb9b2c1f$export$4b98876a65f85873 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isDetailViewOpenWithAnySelectedCard = (0, $c1MAf.useBacklogSelector)((0, $dGljH.isDetailViewOpenWithAnySelectedCardSelector));
    return (0, $5uXOq.useCallback)((cardIds)=>{
        cardIds.forEach((id)=>dispatch((0, $fdAim.cardRefreshRequest)(id)));
        if (isDetailViewOpenWithAnySelectedCard) dispatch((0, $38qhf.updateDetailView)());
    }, [
        dispatch,
        isDetailViewOpenWithAnySelectedCard
    ]);
};

});

parcelRegister("jV4Wh", function(module, exports) {

$parcel$export(module.exports, "useBatchOnReceive", () => $cc5b5b5389b73340$export$b02b538e3e12eaf4);

var $5uXOq = parcelRequire("5uXOq");

var $cab1K = parcelRequire("cab1K");
parcelRequire("a2e6K");
parcelRequire("eSGL3");
parcelRequire("1oQta");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $3lZ6i = parcelRequire("3lZ6i");

var $ubpiL = parcelRequire("ubpiL");

var $jG5HW = parcelRequire("jG5HW");
const $cc5b5b5389b73340$export$23831c9717212b2 = 500;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $cc5b5b5389b73340$var$isActiveTab = ()=>!document.hidden;
const $cc5b5b5389b73340$export$b02b538e3e12eaf4 = ()=>{
    const subjectRef = (0, $5uXOq.useRef)(new (0, $cab1K.Subject)());
    const currentUser = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getAtlassianAccountId));
    const refreshData = (0, $c1MAf.useBacklogActionCreator)((0, $3lZ6i.refreshDataRequest));
    const dispatch = (0, $c1MAf.useBacklogActionCreator)((0, $ubpiL.dispatchRealtimeEventBatch));
    const pushEvent = (0, $5uXOq.useCallback)((event)=>{
        if (!subjectRef.current.closed) subjectRef.current.next(event);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        const subject = subjectRef.current;
        subject.buffer(subject.debounceTime($cc5b5b5389b73340$export$23831c9717212b2)).filter($cc5b5b5389b73340$var$isActiveTab).subscribe((events)=>{
            if (!subjectRef.current.closed) {
                dispatch(events);
                const hasEventsFromOthers = events.filter((s)=>s.payload.atlassianId !== currentUser).length > 0;
                if (hasEventsFromOthers) refreshData((0, $guzeq.REFRESH_SOURCE_REALTIME));
            }
        });
        return ()=>{
            subject.unsubscribe();
        };
    }, [
        currentUser,
        dispatch,
        refreshData
    ]);
    return pushEvent;
};

});
parcelRegister("a2e6K", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $1tgji = parcelRequire("1tgji");
$kVLXA.Observable.prototype.buffer = $1tgji.buffer;

});
parcelRegister("1tgji", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $112526bf5dc8d152$export$ab1029bcae9ddb4a, (v) => $112526bf5dc8d152$export$ab1029bcae9ddb4a = v);
var $112526bf5dc8d152$export$ab1029bcae9ddb4a;
"use strict";

var $icZql = parcelRequire("icZql");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $112526bf5dc8d152$var$buffer(closingNotifier) {
    return $icZql.buffer(closingNotifier)(this);
}
$112526bf5dc8d152$export$ab1029bcae9ddb4a = $112526bf5dc8d152$var$buffer;

});



parcelRegister("f8qNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8428b7783d52b361$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $k12ix = parcelRequire("k12ix");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $3HwlS = parcelRequire("3HwlS");

var $2Z6La = parcelRequire("2Z6La");

var $1XJ20 = parcelRequire("1XJ20");

var $b32lf = parcelRequire("b32lf");

var $a5Tut = parcelRequire("a5Tut");

var $9Ik53 = parcelRequire("9Ik53");

var $g3RsK = parcelRequire("g3RsK");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");


var $3eS6S = parcelRequire("3eS6S");

var $8hVbJ = parcelRequire("8hVbJ");

var $6MzeB = parcelRequire("6MzeB");

var $kvuh4 = parcelRequire("kvuh4");

var $dT4zr = parcelRequire("dT4zr");

var $6e1e1 = parcelRequire("6e1e1");

var $lmlf0 = parcelRequire("lmlf0");

var $e2Elo = parcelRequire("e2Elo");

var $jg0aS = parcelRequire("jg0aS");

var $eX9XD = parcelRequire("eX9XD");

var $fDXV9 = parcelRequire("fDXV9");

var $5eblm = parcelRequire("5eblm");

var $cc2av = parcelRequire("cc2av");
const $8428b7783d52b361$var$RenderEndMark = ()=>{
    const metric = (0, $6MzeB.usePerformanceMetric)();
    (0, $5uXOq.useEffect)(()=>{
        metric.mark((0, $8hVbJ.PAGE_LOAD_MARK_RENDER_END));
    }, [
        metric
    ]);
    return null;
};
const $8428b7783d52b361$var$BacklogContentInner = ({ isCacheHit: isCacheHit, boardId: boardId, issueHierarchyLevel: issueHierarchyLevel, isDetailViewVisible: isDetailViewVisible, isCompanyManaged: isCompanyManaged = false, parentWidth: parentWidth, CardList: CardList, cardListIds: cardListIds, selectedCards: selectedCards, SubmitApdex: SubmitApdex, BoardIssueMoveDialog: BoardIssueMoveDialog, selectedCardTypeId: selectedCardTypeId, epicLinkFieldId: epicLinkFieldId, firstNonEmptyCardListId: firstNonEmptyCardListId, lastNonEmptyCardListId: lastNonEmptyCardListId, bulkOperationsToolbarOld: bulkOperationsToolbarOld, onEpicAssign: // remove this on bulk_operations_floating_toolbar cleanup
onEpicAssign, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onIssueVersionsUpdated: onIssueVersionsUpdated, onVersionAltered: onVersionAltered, onReceive: onReceive })=>{
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const { onChangeCardType: onChangeCardType } = (0, $5uXOq.useContext)((0, $2Z6La.IccContext));
    // NOTE: Update the selected issue type in ICC when the issue type filter is changed. Doing it here to avoid unnecessary update
    (0, $5uXOq.useEffect)(()=>{
        if (selectedCardTypeId !== undefined) onChangeCardType(selectedCardTypeId);
    }, [
        onChangeCardType,
        selectedCardTypeId
    ]);
    const previousCardListIds = (0, $1XJ20.usePrevious)(cardListIds);
    const isNewCardListAdded = (id)=>{
        if (!previousCardListIds) return false;
        return !previousCardListIds.includes(id);
    };
    (0, $eX9XD.useAutoScroller)();
    (0, $fDXV9.useDragAnalytics)(issueHierarchyLevel);
    (0, $a5Tut.useCloseMenuOnScroll)(scrollElementRef);
    (0, $dT4zr.useBulkActionsBarOverlay)(scrollElementRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4R6GH.fg)('jsw_epic_panel_paginated_fetch') && (0, $5eblm.useInitEpicData)(boardId);
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const handleVersionPanelClose = (0, $5uXOq.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    const handleEpicPanelClose = (0, $5uXOq.useCallback)(()=>{
        toggleViewSetting({
            boardId: boardId,
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "backlog-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cc2av.VersionsPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        onClose: handleVersionPanelClose,
        onVersionAltered: onVersionAltered,
        onVersionAssigned: onIssueVersionsUpdated,
        onVersionsUnassigned: onIssueVersionsUpdated,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2Elo.EpicPanelWithErrorBoundary), {
        boardId: boardId,
        selectedIssues: selectedCards,
        issueHierarchyLevel: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
        epicLinkFieldId: epicLinkFieldId,
        onEpicPanelClose: handleEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$Scrollable, {
        "data-test-id": "software-backlog.backlog-content.scrollable",
        "data-testid": "software-backlog.backlog-content.scrollable",
        ref: scrollElementRef
    }, !(0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kvuh4.BulkActionsBar), {
        bulkOperationsToolbarOld: bulkOperationsToolbarOld
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardIssueMoveDialog, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
        scrollRef: scrollElementRef
    }, cardListIds.map((id, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CardList, {
            key: id,
            id: id,
            isFirstList: index === 0,
            isFirstNonEmptyList: firstNonEmptyCardListId === id,
            isLastNonEmptyList: lastNonEmptyCardListId === id,
            justCreated: isNewCardListAdded(id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jg0aS.MoreResults), {
        scrollableParentRef: scrollElementRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6e1e1.default), null), (0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
        appName: (0, $a9c483c0d986286a$export$840e3848643f7781),
        scrollElRef: scrollElementRef,
        attributes: (0, $k12ix.getNormalisedPerformanceFFs)()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
        appName: (0, $a9c483c0d986286a$export$840e3848643f7781),
        scrollEl: scrollElementRef.current
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lmlf0.DetailViewPanelWithErrorBoundary), {
        boardId: boardId,
        parentWidth: parentWidth,
        isDetailViewVisible: isDetailViewVisible
    }), cardListIds.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$RenderEndMark, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubmitApdex, {
        isCacheHit: isCacheHit
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
        events: (0, $3eS6S.REALTIME_EVENTS),
        onReceive: onReceive
    }));
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        "data-onboarding-observer-id": "backlog-wrapper",
        xcss: $8428b7783d52b361$var$wrapperStyles
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8428b7783d52b361$var$PageWrapper, {
        "data-onboarding-observer-id": "backlog-wrapper"
    }, content);
};
const $8428b7783d52b361$var$BacklogContent = /*#__PURE__*/ (0, $5uXOq.memo)($8428b7783d52b361$var$BacklogContentInner);
var $8428b7783d52b361$export$2e2bcd8739ae039 = $8428b7783d52b361$var$BacklogContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b7783d52b361$var$PageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1jfw _1e0c1txw _2lx2vrvc _4t3i1osq _c71l1osq _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $8428b7783d52b361$var$wrapperStyles = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    flex: 1
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b7783d52b361$var$Scrollable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_q3kg9j": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0 ${(0, $dCm1o.isVisualRefreshEnabled)() ? "var(--ds-space-300, 24px)" : "var(--ds-space-400, 32px)"} ${"var(--ds-space-600, 48px)"} 0`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41a7k _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _c71l1osq _1reo1wug _uiztglyw _kqswh2mm _m6k4brmi _1pbyb4wl",
            (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? "_18m91wug" : "_18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b32lf", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $89de761bbc8dc49a$export$e680ceb7b9fcc184);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $50Ssb = parcelRequire("50Ssb");

var $iwG6l = parcelRequire("iwG6l");
// eslint-disable-next-line jira/react/no-class-components
class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.onReceiveEvent = (event, payload)=>{
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        };
        this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        };
        this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        };
        this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        };
        this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $89de761bbc8dc49a$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, $iwG6l.withPubSubClient), (0, $50Ssb.asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;

});
parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $fpTxz = parcelRequire("fpTxz");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $fpTxz.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("50Ssb", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $ccf1df230f4f0e4b$export$95cd02374de3431);

var $5uXOq = parcelRequire("5uXOq");
function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;

});

parcelRegister("iwG6l", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $9fb4f4e8a5d3670b$export$32d968d4900ae3cd);

var $5uXOq = parcelRequire("5uXOq");

var $bYYrF = parcelRequire("bYYrF");
function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;

});
parcelRegister("bYYrF", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $9398e66c20b16e31$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $9398e66c20b16e31$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
const $9398e66c20b16e31$var$defaultContext = {
    client: null
};
const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);

});



parcelRegister("a5Tut", function(module, exports) {

$parcel$export(module.exports, "useCloseMenuOnScroll", () => $c7ad992979caef8c$export$2cf190faca0f2491);

var $5uXOq = parcelRequire("5uXOq");

var $ewaBk = parcelRequire("ewaBk");
const $c7ad992979caef8c$export$2cf190faca0f2491 = (ref)=>{
    const { reset: reset } = (0, $ewaBk.useContextMenuActions)();
    const isAnyMenuOpen = (0, $ewaBk.useIsAnyMenuOpen)();
    const added = (0, $5uXOq.useRef)(false);
    const handleScroll = (0, $5uXOq.useCallback)(()=>{
        reset({
            action: 'closeMenu'
        });
    }, [
        reset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (ref.current) {
            if (isAnyMenuOpen) {
                if (!added.current) {
                    ref.current.addEventListener('scroll', handleScroll);
                    added.current = true;
                }
                return;
            }
            if (added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }
    }, [
        handleScroll,
        ref,
        isAnyMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (ref.current && added.current) {
                ref.current.removeEventListener('scroll', handleScroll);
                added.current = false;
            }
        }, [
        ref,
        handleScroll
    ]);
};

});
parcelRegister("ewaBk", function(module, exports) {

$parcel$export(module.exports, "useContextMenuStore", () => $1b2687c2318490cf$export$d1b2e16030b3efbf);
$parcel$export(module.exports, "useContextMenuActions", () => $1b2687c2318490cf$export$fb508b9bcc816326);
$parcel$export(module.exports, "ContextMenuContainer", () => $1b2687c2318490cf$export$4f48a5067cf73390);
$parcel$export(module.exports, "useMenuItemCheckOpen", () => $1b2687c2318490cf$export$60c643cac8887fbe);
$parcel$export(module.exports, "useShouldForceFocus", () => $1b2687c2318490cf$export$ac348ec4828a6056);
$parcel$export(module.exports, "useIsMenuOpen", () => $1b2687c2318490cf$export$3eef7351bd308de1);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $1b2687c2318490cf$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAnalyticsMapping", () => $1b2687c2318490cf$export$aeb28cc7c774c3ed);
$parcel$export(module.exports, "useIsAnyMenuOpen", () => $1b2687c2318490cf$export$91d90cb66ff7a71e);
$parcel$export(module.exports, "useIsPersistentFocus", () => $1b2687c2318490cf$export$1e85791d95627e79);

var $7JoAD = parcelRequire("7JoAD");

var $jwhNt = parcelRequire("jwhNt");

var $f19dW = parcelRequire("f19dW");

var $5tijM = parcelRequire("5tijM");
const $1b2687c2318490cf$var$ContextMenuStore = (0, $7JoAD.createStore)({
    name: 'software-context-menu',
    initialState: (0, $f19dW.getInitialState)(),
    actions: $f19dW.actions
});
const $1b2687c2318490cf$export$d1b2e16030b3efbf = (0, $7JoAD.createHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$fb508b9bcc816326 = (0, $7JoAD.createActionsHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$4f48a5067cf73390 = (0, $7JoAD.createContainer)($1b2687c2318490cf$var$ContextMenuStore, {
    onInit: (0, $5tijM.onContainerInit),
    onUpdate: (0, $5tijM.onContainerUpdate)
});
const $1b2687c2318490cf$var$getMenuItemOpen = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.openPath?.startsWith(menuItem.id);
const $1b2687c2318490cf$export$60c643cac8887fbe = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getMenuItemOpen
});
const $1b2687c2318490cf$var$getIsFocusForced = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.forcedFocusPath === menuItem.id;
const $1b2687c2318490cf$export$ac348ec4828a6056 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsFocusForced
});
const $1b2687c2318490cf$var$getIsMenuOpen = (state, { scope: scope })=>state.openMenu === scope;
const $1b2687c2318490cf$export$3eef7351bd308de1 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsMenuOpen
});
const $1b2687c2318490cf$var$getAnalyticsAttributes = (state, { scope: scope, cardId: cardId })=>{
    const isMenuOpen = $1b2687c2318490cf$var$getIsMenuOpen(state, {
        scope: scope
    });
    const { analytics: { selectedCardIds: selectedCardIds } } = state;
    return (0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, isMenuOpen);
};
const $1b2687c2318490cf$export$1fd8522aeddaccda = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsAttributes
});
const $1b2687c2318490cf$var$getAnalyticsMapping = (state)=>state.analytics.analyticsMapping;
const $1b2687c2318490cf$export$aeb28cc7c774c3ed = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsMapping
});
const $1b2687c2318490cf$export$d8b7614abf2894d6 = (state)=>!!state.openMenu;
const $1b2687c2318490cf$export$91d90cb66ff7a71e = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$export$d8b7614abf2894d6
});
const $1b2687c2318490cf$var$getIsPersistentFocus = (state)=>!!state?.persistentFocus;
const $1b2687c2318490cf$export$1e85791d95627e79 = (0, $7JoAD.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsPersistentFocus
});

});
parcelRegister("jwhNt", function(module, exports) {

$parcel$export(module.exports, "hasUserStartedSelecting", () => $17a2da3770fdd915$export$5195d9082487fa42);
$parcel$export(module.exports, "hasUserUnselectedAll", () => $17a2da3770fdd915$export$3b8cd3ffacc95e4f);
$parcel$export(module.exports, "getCardSelectionAnalytics", () => $17a2da3770fdd915$export$f96eca8ded123f8b);
$parcel$export(module.exports, "shouldFlowBeEnded", () => $17a2da3770fdd915$export$539307982a715ea8);
const $17a2da3770fdd915$export$5195d9082487fa42 = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length === 0 && contextMenuContainerAnalytics.selectedCardIds.length > 0;
const $17a2da3770fdd915$export$3b8cd3ffacc95e4f = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length > 0 && contextMenuContainerAnalytics.selectedCardIds.length === 0;
const $17a2da3770fdd915$export$f96eca8ded123f8b = (selectedCardIds, cardId, isMenuOpen)=>{
    let cardIds;
    if (isMenuOpen) cardIds = selectedCardIds.includes(cardId) ? selectedCardIds : [
        cardId
    ];
    else cardIds = selectedCardIds;
    const numSelectedCards = cardIds.length;
    return {
        numSelectedCards: numSelectedCards,
        issue_ids: cardIds,
        issue_id: cardId
    };
};
const $17a2da3770fdd915$export$539307982a715ea8 = (analytics, contextMenuContainerAnalytics, bulkOpsFlow)=>{
    const sessionID = !!bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID;
    return sessionID && contextMenuContainerAnalytics.selectedCardIds.length === 0;
};

});

parcelRegister("f19dW", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $c2d99694a10aebe1$export$53ac33307b5acee9);
$parcel$export(module.exports, "actions", () => $c2d99694a10aebe1$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $5tijM = parcelRequire("5tijM");
const $c2d99694a10aebe1$export$53ac33307b5acee9 = ()=>({
        menus: {},
        openMenu: null,
        analytics: {
            selectedCardIds: []
        },
        lastAction: {
            action: 'init',
            scope: undefined
        }
    });
const $c2d99694a10aebe1$export$aad8462122ac592b = (lastAction)=>({ setState: setState })=>{
        const { analytics: analytics, ...initialState } = $c2d99694a10aebe1$export$53ac33307b5acee9();
        initialState.lastAction = lastAction || {
            action: 'reset'
        };
        setState(initialState);
    };
const $c2d99694a10aebe1$var$setPersistentFocus = (persistentFocus)=>({ setState: setState })=>{
        setState({
            persistentFocus: persistentFocus
        });
    };
const $c2d99694a10aebe1$var$openMenu = ({ position: position, scope: scope, analyticsEvent: analyticsEvent, persistentFocus: persistentFocus, openedFrom: openedFrom })=>({ setState: setState }, { selectedCardIds: selectedCardIds, cardId: cardId })=>{
        (0, $5tijM.fireOpenMenuAnalyticsEvent)({
            event: analyticsEvent,
            selectedCardIds: selectedCardIds,
            cardId: cardId,
            openedFrom: openedFrom
        });
        setState({
            openMenu: scope,
            persistentFocus: persistentFocus,
            menus: {
                [scope]: {
                    openPath: undefined,
                    scope: scope,
                    position: position,
                    forcedFocusPath: undefined
                }
            },
            lastAction: {
                action: 'openMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$11ed9b7b8045d408 = (scope, menuItem)=>({ setState: setState, getState: getState })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-open-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: menuItem.id
                }
            },
            lastAction: {
                action: 'openSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$69ff42680518db68 = (scope)=>({ getState: getState, dispatch: dispatch })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        dispatch($c2d99694a10aebe1$export$aad8462122ac592b({
            action: 'closeMenu',
            scope: scope
        }));
    };
const $c2d99694a10aebe1$var$closeSubMenu = (scope)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: undefined
                }
            },
            lastAction: {
                action: 'closeSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$var$setForcedFocusPath = (scope, id)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope}`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-set-focused-path-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    forcedFocusPath: id
                }
            },
            lastAction: {
                action: 'setForcedFocusPath',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$e324594224ef24da = {
    openMenu: $c2d99694a10aebe1$var$openMenu,
    closeMenu: $c2d99694a10aebe1$export$69ff42680518db68,
    openSubMenu: $c2d99694a10aebe1$export$11ed9b7b8045d408,
    closeSubMenu: $c2d99694a10aebe1$var$closeSubMenu,
    setForcedFocusPath: $c2d99694a10aebe1$var$setForcedFocusPath,
    reset: $c2d99694a10aebe1$export$aad8462122ac592b,
    setPersistentFocus: $c2d99694a10aebe1$var$setPersistentFocus
};

});
parcelRegister("5tijM", function(module, exports) {

$parcel$export(module.exports, "onContainerInit", () => $61c942cebc868b99$export$34f4621b58d3fbc8);
$parcel$export(module.exports, "onContainerUpdate", () => $61c942cebc868b99$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "fireOpenMenuAnalyticsEvent", () => $61c942cebc868b99$export$d4ad71c555abd3c8);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $1phoV = parcelRequire("1phoV");

var $jwhNt = parcelRequire("jwhNt");
const $61c942cebc868b99$export$34f4621b58d3fbc8 = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        setState({
            analytics: {
                ...analyticsContainerProps
            }
        });
        if (bulkOpsFlow && (0, $jwhNt.shouldFlowBeEnded)(analytics, analyticsContainerProps, bulkOpsFlow)) bulkOpsFlow?.end();
        else if (bulkOpsFlow && (0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) bulkOpsFlow?.start();
    };
const $61c942cebc868b99$export$ab8f0de40a3a2d2d = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to start a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.start();
        } else if ((0, $jwhNt.hasUserUnselectedAll)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to end a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-end-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.end();
        }
        setState({
            analytics: {
                ...analytics,
                ...analyticsContainerProps
            }
        });
    };
const $61c942cebc868b99$export$d4ad71c555abd3c8 = ({ event: event, cardId: cardId, selectedCardIds: selectedCardIds, openedFrom: openedFrom })=>{
    const attributes = {
        ...(0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, true),
        isLinkIssueFromBoardCardEnabled: true,
        jswCmpCardCoverExpCohort: (0, $1phoV.getJswCmpCardCoversExpCohort)(event),
        openedFrom: openedFrom
    };
    // Attributes normally get merged together. We want to override the issue_ids attribute instead
    event.context.push({
        attributes: {
            issue_ids: null
        }
    });
    (0, $8zOmE.fireUIAnalytics)(event, 'cardActions', attributes);
};

});
parcelRegister("1phoV", function(module, exports) {

$parcel$export(module.exports, "getJswCmpCardCoversExpCohort", () => $1f09e6268def8d8a$export$e9d8735c68972d71);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $39ajt = parcelRequire("39ajt");
const $1f09e6268def8d8a$export$e9d8735c68972d71 = (event)=>{
    if (!(0, $4R6GH.fg)('jsw_cmp_card_cover_images')) return 'feature-hidden';
    const { projectType: projectType, isClassic: isClassic } = (0, $39ajt.getAttributes)(event);
    const source = (0, $39ajt.getSource)(event);
    if (!(projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isClassic && source === 'boardScreen')) return 'feature-hidden';
    if (!(0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding')) return 'changeboarding-disabled';
    return (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false) ? 'experiment' : 'feature-hidden';
};

});





parcelRegister("9Ik53", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $c77424cc0be42400$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $c77424cc0be42400$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $c77424cc0be42400$export$50b6b7783d156e1b = 200;
const $c77424cc0be42400$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $c77424cc0be42400$var$ScrollStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($c77424cc0be42400$var$INITIAL_SCROLL_STATE);
const $c77424cc0be42400$export$98084ad349e2edae = ()=>(0, $5uXOq.useContext)($c77424cc0be42400$var$ScrollStateContext);
const $c77424cc0be42400$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $c77424cc0be42400$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $5uXOq.useState)($c77424cc0be42400$var$INITIAL_SCROLL_STATE);
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $c77424cc0be42400$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $c77424cc0be42400$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $c77424cc0be42400$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c77424cc0be42400$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("g3RsK", function(module, exports) {

$parcel$export(module.exports, "LongTasksScrollObserver", () => $fe64e9d70a250807$export$55bf40af27443842);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $4R6GH = parcelRequire("4R6GH");

var $bv8GQ = parcelRequire("bv8GQ");

var $gi25H = parcelRequire("gi25H");
/**
 * Tracks long-tasks that happen while scrolling on a certain 'scrollEl'.
 */ const $fe64e9d70a250807$var$LongTasksScrollObserverBase = ({ observationType: observationType, attributes: attributes, appName: appName, ...rest })=>{
    const onScrollStart = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).start(appName, undefined, attributes);
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) performance.mark(`${appName}:scrolling-task:start`);
    }, [
        attributes,
        appName,
        observationType
    ]);
    const onScrollEnd = (0, $5uXOq.useCallback)((lastScrollTime)=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).stop((0, $bv8GQ.softwareGenericLongTasksReporter)('scroll', lastScrollTime));
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            performance.mark(`${appName}:scrolling-task:end`);
            performance.measure(`${appName}:scrolling-task`, `${appName}:scrolling-task:start`, `${appName}:scrolling-task:end`);
        }
    }, [
        observationType,
        appName
    ]);
    (0, $gi25H.useScrollStateObserver)({
        ...rest,
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd
    });
    return null;
};
$fe64e9d70a250807$var$LongTasksScrollObserverBase.defaultProps = {
    observationType: 'scroll',
    attributes: {}
};
const $fe64e9d70a250807$export$55bf40af27443842 = /*#__PURE__*/ (0, $5uXOq.memo)($fe64e9d70a250807$var$LongTasksScrollObserverBase);

});
parcelRegister("bv8GQ", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $2795c9afa9443b8c$export$b78c92c0ba709033);

var $gZFbt = parcelRequire("gZFbt");

var $if7bx = parcelRequire("if7bx");

var $cJpFl = parcelRequire("cJpFl");

var $4R6GH = parcelRequire("4R6GH");


var $fjcgS = parcelRequire("fjcgS");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2795c9afa9443b8c$var$aggregatedDataTimeout = {};
const $2795c9afa9443b8c$export$b78c92c0ba709033 = (observationType, observationEndTime)=>(observationData)=>{
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary
                        }
                    }
                });
            });
        } else {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $if7bx.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan')
                                }
                            }
                        });
                        delete $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});

parcelRegister("gi25H", function(module, exports) {

$parcel$export(module.exports, "useScrollStateObserver", () => $5c14c3e1741ffda3$export$51374614020e4579);

var $5uXOq = parcelRequire("5uXOq");
const $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS = 500;
const $5c14c3e1741ffda3$export$53d63bb2b7d56f77 = ({ onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollStopIntervalMs: scrollStopIntervalMs })=>{
    const isScrollingRef = (0, $5uXOq.useRef)(false);
    const scrollStopTimerRef = (0, $5uXOq.useRef)(null);
    const onScroll = (0, $5uXOq.useCallback)(()=>{
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            onScrollStart();
        }
        const lastScrollTime = performance.now();
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(scrollStopTimerRef.current);
        scrollStopTimerRef.current = setTimeout(()=>{
            isScrollingRef.current = false;
            onScrollEnd(lastScrollTime);
        }, scrollStopIntervalMs);
        return ()=>{
            if (isScrollingRef.current) onScrollEnd(lastScrollTime);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(scrollStopTimerRef.current);
        };
    }, [
        isScrollingRef,
        scrollStopTimerRef,
        scrollStopIntervalMs,
        onScrollStart,
        onScrollEnd
    ]);
    return {
        onScroll: onScroll,
        isScrollingRef: isScrollingRef
    };
};
const $5c14c3e1741ffda3$export$51374614020e4579 = ({ scrollStopIntervalMs: scrollStopIntervalMs, scrollElRef: scrollElRef, scrollEl: scrollEl, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd })=>{
    const { onScroll: onScroll, isScrollingRef: isScrollingRef } = $5c14c3e1741ffda3$export$53d63bb2b7d56f77({
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd,
        scrollStopIntervalMs: scrollStopIntervalMs ?? $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS
    });
    (0, $5uXOq.useEffect)(()=>{
        const el = scrollEl ?? scrollElRef?.current;
        if (!el) return undefined;
        el.addEventListener('scroll', onScroll);
        return ()=>{
            el.removeEventListener('scroll', onScroll);
        };
    }, [
        scrollEl,
        scrollElRef,
        isScrollingRef,
        onScroll,
        onScrollEnd
    ]);
};

});


parcelRegister("9pP0g", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $23bab0da4eba41c6$export$b6da678b61e4982c);

var $a4XJc = parcelRequire("a4XJc");

var $iJgHp = parcelRequire("iJgHp");
const $23bab0da4eba41c6$export$b6da678b61e4982c = {
    ...(0, $a4XJc.Panels),
    ...(0, $iJgHp.CardDetails),
    ...(0, $a4XJc.IncrementPlanningSettings),
    QUICK_FILTERS: $a4XJc.QUICK_FILTERS,
    COMPACT_MODE: $a4XJc.COMPACT_MODE
};

});
parcelRegister("iJgHp", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $a1cb757db25241b3$export$741386389156bf07);

var $a4XJc = parcelRequire("a4XJc");
const $a1cb757db25241b3$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $a4XJc.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $a4XJc.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $a4XJc.SHOW_EPICS,
    SHOW_STATUSES: $a4XJc.SHOW_STATUSES,
    SHOW_VERSIONS: $a4XJc.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $a4XJc.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $a4XJc.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $a4XJc.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $a4XJc.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $a4XJc.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $a4XJc.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $a4XJc.SHOW_DUE_DATE,
    SHOW_LABELS: $a4XJc.SHOW_LABELS,
    SHOW_CARD_COVERS: $a4XJc.SHOW_CARD_COVERS
};

});


parcelRegister("iDGXn", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $ca78323127435ce7$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $ca78323127435ce7$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $ca78323127435ce7$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $ca78323127435ce7$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $ca78323127435ce7$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $ca78323127435ce7$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $ca78323127435ce7$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $ca78323127435ce7$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $ca78323127435ce7$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $ca78323127435ce7$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $ca78323127435ce7$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $ca78323127435ce7$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $ca78323127435ce7$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $ca78323127435ce7$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $ca78323127435ce7$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $ca78323127435ce7$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $ca78323127435ce7$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $ca78323127435ce7$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $ca78323127435ce7$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $ca78323127435ce7$export$b6fb171038a9e77e);

var $7JoAD = parcelRequire("7JoAD");

var $duOMW = parcelRequire("duOMW");

var $6zihU = parcelRequire("6zihU");

var $ffHmx = parcelRequire("ffHmx");
const $ca78323127435ce7$var$Store = (0, $7JoAD.createStore)({
    name: 'ViewSettings',
    initialState: $duOMW.initialState,
    actions: $6zihU.actions
});
const $ca78323127435ce7$export$920204d7413f6fe1 = (0, $7JoAD.createContainer)($ca78323127435ce7$var$Store, {
    onInit: (0, $6zihU.actions).initState
});
const $ca78323127435ce7$export$704cffd05c51e2b6 = (0, $7JoAD.createHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d6a70239aff099b8 = (0, $7JoAD.createActionsHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d397eccea5f37b0a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIsFullscreen)
});
const $ca78323127435ce7$export$459b400687bc0f20 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersionPanel)
});
const $ca78323127435ce7$export$203c9a05aebea04a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpicPanel)
});
const $ca78323127435ce7$export$714ba21e90859f45 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowQuickFilters)
});
const $ca78323127435ce7$export$8a591bb42a805814 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCompactMode)
});
const $ca78323127435ce7$export$736bfa164a60e240 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPanels)
});
const $ca78323127435ce7$export$ecaca052f9755b4e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpics)
});
const $ca78323127435ce7$export$10178a1fc177e27a = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersions)
});
const $ca78323127435ce7$export$7a14d92e68e42de1 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowStatuses)
});
const $ca78323127435ce7$export$afb23457b0007ce7 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowUnscheduledColumn)
});
const $ca78323127435ce7$export$1d584d816be8e0fd = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueLinksStats)
});
const $ca78323127435ce7$export$c94c02788702c7e4 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueType)
});
const $ca78323127435ce7$export$8007ae8b25a75629 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueKey)
});
const $ca78323127435ce7$export$75223d65852dc3c0 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPriority)
});
const $ca78323127435ce7$export$eac20fb60c7f35ac = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDevelopment)
});
const $ca78323127435ce7$export$be6bf1e24771efde = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowAssignee)
});
const $ca78323127435ce7$export$b5a76590347456cc = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEstimate)
});
const $ca78323127435ce7$export$5e8e69c97a3cd45b = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardExtraField)
});
const $ca78323127435ce7$export$a53839ab3a916ce3 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDaysInColumn)
});
const $ca78323127435ce7$export$77ff271d002b6f7e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardCovers)
});
const $ca78323127435ce7$export$9e1ece2ef34a030 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getHasCardExtraFields)
});
const $ca78323127435ce7$export$e41d531469117029 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getCardFieldsSettings)
});
const $ca78323127435ce7$export$e709b26074f3a4a5 = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowOfftrackDependencyLines)
});
const $ca78323127435ce7$export$b6fb171038a9e77e = (0, $7JoAD.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIssueIdsToShowDependencies)
});

});
parcelRegister("6zihU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $718ecccac1489fb2$export$e324594224ef24da);

var $3whhk = parcelRequire("3whhk");
const $718ecccac1489fb2$export$e324594224ef24da = {
    setViewSettings: $3whhk.setViewSettings,
    setIsFullscreen: $3whhk.setIsFullscreen,
    setViewSettingsPanels: $3whhk.setViewSettingsPanels,
    setViewSettingsQuickFilters: $3whhk.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $3whhk.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $3whhk.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $3whhk.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $3whhk.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $3whhk.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $3whhk.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $3whhk.setViewSettingsShowCardCovers,
    toggleViewSetting: $3whhk.toggleViewSetting,
    toggleShowEpics: $3whhk.toggleShowEpics,
    toggleShowVersions: $3whhk.toggleShowVersions,
    toggleShowStatuses: $3whhk.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $3whhk.toggleShowLinkedIssuesStats,
    toggleExtraField: $3whhk.toggleExtraField,
    toggleShowDaysInColumn: $3whhk.toggleShowDaysInColumn,
    toggleShowDueDate: $3whhk.toggleShowDueDate,
    toggleShowLabels: $3whhk.toggleShowLabels,
    initState: $3whhk.initState
};

});
parcelRegister("3whhk", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b6bf5ef387c9e297$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b6bf5ef387c9e297$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b6bf5ef387c9e297$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b6bf5ef387c9e297$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b6bf5ef387c9e297$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b6bf5ef387c9e297$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b6bf5ef387c9e297$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b6bf5ef387c9e297$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b6bf5ef387c9e297$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b6bf5ef387c9e297$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b6bf5ef387c9e297$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b6bf5ef387c9e297$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b6bf5ef387c9e297$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b6bf5ef387c9e297$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b6bf5ef387c9e297$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b6bf5ef387c9e297$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b6bf5ef387c9e297$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b6bf5ef387c9e297$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b6bf5ef387c9e297$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b6bf5ef387c9e297$export$f7b68cb584e33d77);

var $9pP0g = parcelRequire("9pP0g");

var $8zmNw = parcelRequire("8zmNw");
const $b6bf5ef387c9e297$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b6bf5ef387c9e297$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b6bf5ef387c9e297$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b6bf5ef387c9e297$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b6bf5ef387c9e297$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b6bf5ef387c9e297$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS
        });
    };
const $b6bf5ef387c9e297$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b6bf5ef387c9e297$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $8zmNw.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b6bf5ef387c9e297$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $8zmNw.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $9pP0g.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $9pP0g.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            default:
                break;
        }
    };
const $b6bf5ef387c9e297$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b6bf5ef387c9e297$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b6bf5ef387c9e297$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b6bf5ef387c9e297$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b6bf5ef387c9e297$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b6bf5ef387c9e297$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b6bf5ef387c9e297$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b6bf5ef387c9e297$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b6bf5ef387c9e297$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $8zmNw.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b6bf5ef387c9e297$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b6bf5ef387c9e297$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});


parcelRegister("ffHmx", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $fc378329dceca517$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $fc378329dceca517$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $fc378329dceca517$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $fc378329dceca517$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $fc378329dceca517$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $fc378329dceca517$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $fc378329dceca517$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $fc378329dceca517$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $fc378329dceca517$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $fc378329dceca517$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $fc378329dceca517$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $fc378329dceca517$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $fc378329dceca517$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $fc378329dceca517$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $fc378329dceca517$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $fc378329dceca517$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $fc378329dceca517$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $fc378329dceca517$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $fc378329dceca517$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $fc378329dceca517$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $fc378329dceca517$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $fc378329dceca517$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $fc378329dceca517$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $fc378329dceca517$export$1e24fae4497ff7e0);
const $fc378329dceca517$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $fc378329dceca517$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $fc378329dceca517$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $fc378329dceca517$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $fc378329dceca517$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $fc378329dceca517$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $fc378329dceca517$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $fc378329dceca517$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $fc378329dceca517$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $fc378329dceca517$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $fc378329dceca517$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $fc378329dceca517$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $fc378329dceca517$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $fc378329dceca517$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $fc378329dceca517$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $fc378329dceca517$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $fc378329dceca517$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $fc378329dceca517$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $fc378329dceca517$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $fc378329dceca517$export$983376245b8547dc = (state)=>state.showCardCovers;
const $fc378329dceca517$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $fc378329dceca517$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $fc378329dceca517$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers
    });
const $fc378329dceca517$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("3eS6S", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $b9727070b384e890$export$a45e758f2a5806e6);

const $b9727070b384e890$export$a45e758f2a5806e6 = [
    (0, $09d938f04e8899c4$export$86d416e8d15777d),
    (0, $09d938f04e8899c4$export$b22a14d5dac59664),
    (0, $09d938f04e8899c4$export$25fa37e5059c5a99),
    (0, $09d938f04e8899c4$export$d9bc8850eeef9f60),
    (0, $09d938f04e8899c4$export$b22142e61b3fdbee),
    (0, $09d938f04e8899c4$export$6b7e46ea0442b66c)
];

});

parcelRegister("6MzeB", function(module, exports) {

$parcel$export(module.exports, "usePerformanceMetric", () => $f3f14da65b3c231d$export$8c654db610e68aa9);

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $f3f14da65b3c231d$export$8c654db610e68aa9 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged)) ? (0, $8hVbJ.uifBacklogNewUiPageLoad) : (0, $8hVbJ.nextGenBacklogPageLoad);

});

parcelRegister("kvuh4", function(module, exports) {

$parcel$export(module.exports, "BulkActionsBar", () => $ee65109f847e3bac$export$96e554270f6fba00);

var $47bDC = parcelRequire("47bDC");

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");


var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $3VzmQ = parcelRequire("3VzmQ");

var $bb9Ea = parcelRequire("bb9Ea");

var $aIDAv = parcelRequire("aIDAv");


var $4191y = parcelRequire("4191y");
const $ee65109f847e3bac$export$26984d4d64da8edf = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
var $ee65109f847e3bac$var$_StyledStaticContainer = /*#__PURE__*/ (0, $47bDC.default)((0, $4191y.StaticContainer)).withConfig({
    componentId: "sc-14ml6s9-0"
})`${(p)=>p._css}`;
const $ee65109f847e3bac$export$96e554270f6fba00 = ({ bulkOperationsToolbarOld: bulkOperationsToolbarOld })=>{
    const showCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const selectedCardIds = $ee65109f847e3bac$export$26984d4d64da8edf();
    const [{ isOverlaid: isOverlaid }, { setIsOpen: setIsOpen }] = (0, $bb9Ea.useBulkActionsBar)();
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(showCheckbox);
    }, [
        showCheckbox,
        setIsOpen
    ]);
    const componentStyles = (0, $aIDAv.useCloseGracefully)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ee65109f847e3bac$var$_StyledStaticContainer, {
        isOverlaid: isOverlaid && showCheckbox,
        _css: componentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4191y.BulkActionsBarWrapper), {
        "data-testid": (0, $aba835766eeafb32$export$8590613bf6f86e6a),
        isVisible: !!selectedCardIds.length && showCheckbox
    }, showCheckbox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-backlog.header.bulk-actions-bar.bulkops-toolbar-container",
        ref: bulkOperationsToolbarOld?.setRef
    }))));
};

});
parcelRegister("bb9Ea", function(module, exports) {

$parcel$export(module.exports, "useBulkActionsBar", () => $6762723dd8051314$export$b8986d1c49ec5db1);
// TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

var $7JoAD = parcelRequire("7JoAD");
const $6762723dd8051314$var$initialState = {
    isOpen: false,
    isOverlaid: false,
    shouldCloseGracefully: false
};
const $6762723dd8051314$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setIsOverlaid: (isOverlaid)=>({ setState: setState })=>{
            setState({
                isOverlaid: isOverlaid
            });
        },
    setShouldCloseGracefully: (shouldCloseGracefully)=>({ setState: setState })=>{
            setState({
                shouldCloseGracefully: shouldCloseGracefully
            });
        },
    setHasClosedGracefully: ()=>({ setState: setState, getState: getState })=>{
            const { isOpen: isOpen } = getState();
            if (!isOpen) setState({
                shouldCloseGracefully: false,
                isOverlaid: false
            });
        }
};
const $6762723dd8051314$var$store = (0, $7JoAD.createStore)({
    initialState: $6762723dd8051314$var$initialState,
    actions: $6762723dd8051314$var$actions,
    name: 'backlog-bulk-actions-bar'
});
const $6762723dd8051314$export$b8986d1c49ec5db1 = (0, $7JoAD.createHook)($6762723dd8051314$var$store);
const $6762723dd8051314$export$8d2298101520e52c = (0, $7JoAD.createActionsHook)($6762723dd8051314$var$store);

});

parcelRegister("aIDAv", function(module, exports) {

$parcel$export(module.exports, "useCloseGracefully", () => $56651260926bf783$export$c8b83f6b88bb6bf5);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

var $5uXOq = parcelRequire("5uXOq");

var $bb9Ea = parcelRequire("bb9Ea");

var $4MKch = parcelRequire("4MKch");
const $56651260926bf783$export$c8b83f6b88bb6bf5 = ()=>{
    const [{ isOpen: isOpen, shouldCloseGracefully: shouldCloseGracefully }, { setHasClosedGracefully: setHasClosedGracefully }] = (0, $bb9Ea.useBulkActionsBar)();
    const timeout = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen && shouldCloseGracefully) // We need to wait for the height animation to finish before we can set the visibility to hidden.
        timeout.current = setTimeout(setHasClosedGracefully, (0, $4MKch.ANIMATION_DURATION_MS) + (0, $4MKch.OFFSET));
        return ()=>{
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, [
        setHasClosedGracefully,
        timeout,
        isOpen,
        shouldCloseGracefully
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            visibility: isOpen ? 'visible' : 'hidden',
            transition: shouldCloseGracefully ? `height ${0, $4MKch.HEIGHT_ANIMATION_DURATION_SECONDS}s ease-in, visibility ${0, $4MKch.VISIBILITY_ANIMATION_DURATION_SECONDS}s ease-in` : 'none',
            ...!isOpen ? {
                height: '0px !important'
            } : {}
        }), [
        isOpen,
        shouldCloseGracefully
    ]);
};

});
parcelRegister("4MKch", function(module, exports) {

$parcel$export(module.exports, "ANIMATION_DURATION_MS", () => $675958e3ba8e5b1b$export$381bd857552f2380);
$parcel$export(module.exports, "OFFSET", () => $675958e3ba8e5b1b$export$3231e969238304f3);
$parcel$export(module.exports, "HEIGHT_ANIMATION_DURATION_SECONDS", () => $675958e3ba8e5b1b$export$697d389d05b85445);
$parcel$export(module.exports, "VISIBILITY_ANIMATION_DURATION_SECONDS", () => $675958e3ba8e5b1b$export$3ad3b33c1276dee);
const $675958e3ba8e5b1b$export$381bd857552f2380 = 100;
const $675958e3ba8e5b1b$export$3231e969238304f3 = 10;
const $675958e3ba8e5b1b$export$697d389d05b85445 = $675958e3ba8e5b1b$export$381bd857552f2380 / 1000;
const $675958e3ba8e5b1b$export$3ad3b33c1276dee = ($675958e3ba8e5b1b$export$381bd857552f2380 - $675958e3ba8e5b1b$export$3231e969238304f3) / 1000;

});


const $aba835766eeafb32$export$8590613bf6f86e6a = 'software-bulk-actions-toolbar.wrapper';
const $aba835766eeafb32$export$c6546257491ca185 = 32;
const $aba835766eeafb32$export$e2842b8fe51e8a19 = 17;

parcelRegister("4191y", function(module, exports) {

$parcel$export(module.exports, "BulkActionsBarWrapper", () => $d75a36f9f2056c91$export$5faed9c94d4db8d1);
$parcel$export(module.exports, "StaticContainer", () => $d75a36f9f2056c91$export$bc786390a2506ac7);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d75a36f9f2056c91$export$5faed9c94d4db8d1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvl52n _n3tdutpp _ca0q1b66 _bfhkvuon _4t3izwfg _3um0n7od _1pby1nn1 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $d75a36f9f2056c91$export$bc786390a2506ac7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlaid: isOverlaid, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _1ul9cs0k _1bsb1osq _1pby1nn1 _4t3i1c5z",
            __cmplp.isOverlaid ? "_16qs7bxk" : "_16qsglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dT4zr", function(module, exports) {

$parcel$export(module.exports, "useBulkActionsBarOverlay", () => $4346bda42d3c1bc3$export$bda6f8ee2db20273);
// TODO: delete this folder when cleaning up bulk_operations_floating_toolbar

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $kh4KP = parcelRequire("kh4KP");

var $bb9Ea = parcelRequire("bb9Ea");

const $4346bda42d3c1bc3$var$OFFSET = (parseInt((0, $kh4KP.default)('space.150', '12px'), 10) || 12) + (0, $aba835766eeafb32$export$c6546257491ca185);
const $4346bda42d3c1bc3$export$bda6f8ee2db20273 = (ref)=>{
    const [{ isOpen: isOpen }, { setIsOverlaid: setIsOverlaid, setShouldCloseGracefully: setShouldCloseGracefully }] = (0, $bb9Ea.useBulkActionsBar)();
    const handleScroll = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            if (ref.current) {
                const currentScrollPosition = ref.current.scrollTop;
                const isOverlaid = currentScrollPosition > 0;
                const shouldCloseGracefully = currentScrollPosition < $4346bda42d3c1bc3$var$OFFSET;
                setIsOverlaid(isOverlaid);
                setShouldCloseGracefully(shouldCloseGracefully);
            }
        }, 100), [
        ref,
        setIsOverlaid,
        setShouldCloseGracefully
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const currentRef = ref.current;
        if (currentRef) {
            if (isOpen) currentRef.addEventListener('scroll', handleScroll);
            else currentRef.removeEventListener('scroll', handleScroll);
        }
        return ()=>{
            if (currentRef) currentRef.removeEventListener('scroll', handleScroll);
        };
    }, [
        handleScroll,
        isOpen,
        ref,
        setIsOverlaid,
        setShouldCloseGracefully
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const currentRef = ref.current;
        if (currentRef) {
            const currentScrollPosition = currentRef.scrollTop;
            if (currentScrollPosition === 0) {
                if (isOpen) {
                    currentRef.scrollTop = currentScrollPosition + $4346bda42d3c1bc3$var$OFFSET;
                    setIsOverlaid(true);
                } else currentRef.scrollTop = currentScrollPosition - $4346bda42d3c1bc3$var$OFFSET;
            }
        }
    }, [
        isOpen,
        ref,
        setIsOverlaid
    ]);
};

});

parcelRegister("6e1e1", function(module, exports) {

$parcel$export(module.exports, "default", () => $38f15258199c4b76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $687vG = parcelRequire("687vG");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $38f15258199c4b76$export$48dddccb48daa6d7 = ()=>{
    // track card lists being expanded and collapsed
    const collapsedCardLists = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCollapsedCardLists));
    // track sprint containers being created and deleted
    const cardListCount = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListCount));
    // track sprint containers moving up and down from ... menu
    const cardListOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardListIds));
    // track cards moving up and down by draggable divider
    const cardOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        collapsedCardLists,
        cardListCount,
        cardListOrder,
        cardOrder
    ]);
    return null;
};
var $38f15258199c4b76$export$2e2bcd8739ae039 = $38f15258199c4b76$export$48dddccb48daa6d7;

});
parcelRegister("687vG", function(module, exports) {

$parcel$export(module.exports, "runRecalculateSubscribers", () => $c63364c275b5d8f7$export$c385874db128c328);
$parcel$export(module.exports, "useElementOffset", () => $c63364c275b5d8f7$export$35f58fcda6094144);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $iASWI = parcelRequire("iASWI");

var $9Ik53 = parcelRequire("9Ik53");
const $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF = 0.05;
const $c63364c275b5d8f7$export$658605f405ffebd5 = new Set();
const $c63364c275b5d8f7$export$c385874db128c328 = ()=>{
    const recalculateSubscribersArr = Array.from($c63364c275b5d8f7$export$658605f405ffebd5);
    const changes = recalculateSubscribersArr.map((subscriber)=>({
            newOffsetTop: subscriber.measureOffsetTop(),
            subscriber: subscriber
        })).filter(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>Math.abs((subscriber.offsetTopRef.current ?? 0) - newOffsetTop) > $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF);
    if (!changes.length) return 0;
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        changes.forEach(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>{
            subscriber.onChange(newOffsetTop);
        });
    });
    return changes.length;
};
// Debounced version of the call used because during DND, the ResizeObserver can
// crash due to being triggered too much
const $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($c63364c275b5d8f7$export$c385874db128c328, 50);
let $c63364c275b5d8f7$var$resizeObserver = null;
if (typeof ResizeObserver !== 'undefined') $c63364c275b5d8f7$var$resizeObserver = new ResizeObserver($c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers);
let $c63364c275b5d8f7$var$intersectionObserver = null;
if (typeof IntersectionObserver !== 'undefined') $c63364c275b5d8f7$var$intersectionObserver = new IntersectionObserver($c63364c275b5d8f7$export$c385874db128c328, {
    // Will fire every 1/5000 size visibility change.
    // A list with more than 5000 rows will fail to detect single row
    // changes.
    // A list with 5000 rows will only detect 1 row shifts at a time.
    threshold: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(5000).map((i, _, arr)=>i / arr.length)
});
function $c63364c275b5d8f7$export$99c4e73123d23bda({ initialOffset: initialOffset, ref: ref }) {
    const [offsetTop, setOffsetTop] = (0, $5uXOq.useState)(initialOffset);
    const previousOffsetTopRef = (0, $5uXOq.useRef)(initialOffset);
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) throw new Error('Invariant failed, observed element is null on mount');
        const onChange = (size)=>{
            setOffsetTop(size);
            previousOffsetTopRef.current = size;
        };
        const measureOffsetTop = ()=>{
            if (!el || !scrollElement) return previousOffsetTopRef.current;
            // scrollElement defaults to Window.
            // This default value is normally only seen in Storybook.
            if (scrollElement instanceof Window || // FIXME JIV-14148 - unclear behavior in Storybook mount strict - Window is not Window
            !scrollElement.getBoundingClientRect) return 0;
            return el.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop;
        };
        onChange(measureOffsetTop());
        const recalculateGroup = {
            measureOffsetTop: measureOffsetTop,
            onChange: onChange,
            offsetTop: previousOffsetTopRef.current,
            offsetTopRef: previousOffsetTopRef
        };
        $c63364c275b5d8f7$export$658605f405ffebd5.add(recalculateGroup);
        $c63364c275b5d8f7$var$resizeObserver?.observe(el);
        $c63364c275b5d8f7$var$intersectionObserver?.observe(el);
        const onResize = ()=>{
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
        if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 1) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResize);
        return ()=>{
            $c63364c275b5d8f7$export$658605f405ffebd5.delete(recalculateGroup);
            $c63364c275b5d8f7$var$resizeObserver?.unobserve(el);
            $c63364c275b5d8f7$var$intersectionObserver?.unobserve(el);
            if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 0) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
            // Fire once when we clean this up since when we unmount an element we also
            // want to trigger the callback (e.g. removing a column or cardlist)
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
    }, [
        ref,
        scrollElement
    ]);
    return offsetTop;
}
function $c63364c275b5d8f7$export$35f58fcda6094144({ initialOffset: initialOffset }) {
    const ref = (0, $5uXOq.useRef)(null);
    const offsetTop = $c63364c275b5d8f7$export$99c4e73123d23bda({
        initialOffset: initialOffset,
        ref: ref
    });
    return {
        ref: ref,
        offsetTop: offsetTop
    };
}

});
parcelRegister("iASWI", function(module, exports) {

var $irTmi = parcelRequire("irTmi");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d89635f071f7433a$var$range = $irTmi();
module.exports = $d89635f071f7433a$var$range;

});
parcelRegister("irTmi", function(module, exports) {

var $7DMj9 = parcelRequire("7DMj9");

var $4rDUz = parcelRequire("4rDUz");

var $kJ0Lf = parcelRequire("kJ0Lf");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $d6e5b0af0cc26ead$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $kJ0Lf(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $kJ0Lf(end);
        step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
        return $7DMj9(start, end, step, fromRight);
    };
}
module.exports = $d6e5b0af0cc26ead$var$createRange;

});
parcelRegister("7DMj9", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $5901a5dd7694a169$var$baseRange;

});





parcelRegister("lmlf0", function(module, exports) {

$parcel$export(module.exports, "DetailViewPanelWithErrorBoundary", () => $3c6dd45075bfccb0$export$8dcd12fa4f8f9bff);

var $5uXOq = parcelRequire("5uXOq");

var $hqTkp = parcelRequire("hqTkp");

var $39xOx = parcelRequire("39xOx");

var $88tXZ = parcelRequire("88tXZ");

var $f6RVN = parcelRequire("f6RVN");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $5A42o = parcelRequire("5A42o");
const $3c6dd45075bfccb0$export$eec5a61ba1791f2b = ({ boardId: boardId, parentWidth: parentWidth, isDetailViewVisible: isDetailViewVisible })=>{
    const isInsightsPanelOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const [epicFilters, { setEpicFilters: setEpicFilters }] = (0, $88tXZ.useEpicFilters)();
    const onBentoDelete = (0, $5uXOq.useCallback)((issueId)=>{
        if (epicFilters && epicFilters.includes(issueId)) setEpicFilters((0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(epicFilters, issueId));
    }, [
        epicFilters,
        setEpicFilters
    ]);
    return isDetailViewVisible || isInsightsPanelOpen || (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5A42o.default), {
        parentWidth: parentWidth,
        onDelete: onBentoDelete,
        boardId: boardId
    }) : null;
};
const $3c6dd45075bfccb0$export$8dcd12fa4f8f9bff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "backlogContentDetailView",
        packageName: "software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6dd45075bfccb0$export$eec5a61ba1791f2b, props));

});
parcelRegister("88tXZ", function(module, exports) {

$parcel$export(module.exports, "FiltersStore", () => $a707d54d22dd5787$export$83881a29077d5ffe);
$parcel$export(module.exports, "useFilters", () => $a707d54d22dd5787$export$973ca22476b0e05f);
$parcel$export(module.exports, "useEpicFilters", () => $a707d54d22dd5787$export$d840a10da638967b);
$parcel$export(module.exports, "useFixVersionFilters", () => $a707d54d22dd5787$export$55f8e6f74a492d36);

var $7JoAD = parcelRequire("7JoAD");


var $6hsVv = parcelRequire("6hsVv");

var $kNguL = parcelRequire("kNguL");

var $btxt2 = parcelRequire("btxt2");

var $cxBEo = parcelRequire("cxBEo");
const $a707d54d22dd5787$var$initialState = {
    filters: {}
};
const $a707d54d22dd5787$export$83881a29077d5ffe = (0, $7JoAD.createStore)({
    name: (0, $0904d0fa958edff5$export$37f04a6502d23030),
    initialState: $a707d54d22dd5787$var$initialState,
    actions: $6hsVv.actions
});
const $a707d54d22dd5787$export$973ca22476b0e05f = (0, $7JoAD.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $btxt2.getFilters)
});
const $a707d54d22dd5787$export$d840a10da638967b = (0, $7JoAD.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $kNguL.getEpic)
});
const $a707d54d22dd5787$export$55f8e6f74a492d36 = (0, $7JoAD.createHook)($a707d54d22dd5787$export$83881a29077d5ffe, {
    selector: (0, $cxBEo.getFixVersion)
});

});
const $0904d0fa958edff5$export$37f04a6502d23030 = 'next-gen/backlog-filters-state';
const $0904d0fa958edff5$export$d597759d33be802e = 'TEXT';
const $0904d0fa958edff5$export$a6b9aaee40d49fd0 = 'SEARCH';
const $0904d0fa958edff5$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $0904d0fa958edff5$export$37aee82a3cb1e8f7 = 'LABEL';
const $0904d0fa958edff5$export$2a4f270075a033de = 'ISSUE_PARENT';
const $0904d0fa958edff5$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $0904d0fa958edff5$export$a4ad2735b021c132 = 'VERSION';
const $0904d0fa958edff5$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $0904d0fa958edff5$export$e39925d10cebc0b = 'text';
const $0904d0fa958edff5$export$a181206198b7f50c = 'search';
const $0904d0fa958edff5$export$f78d8c81fcad32a2 = 'assignee';
const $0904d0fa958edff5$export$e729d951ab128c3b = 'label';
const $0904d0fa958edff5$export$8a2cab795731dc42 = 'issueParent';
const $0904d0fa958edff5$export$fa7b72626a2e0090 = 'issueType';
const $0904d0fa958edff5$export$392308739e657b75 = 'version';
const $0904d0fa958edff5$export$cb08ebea4a46cd29 = 'customFilter';
const $0904d0fa958edff5$export$163cc317352fc53e = 'quickFilter';

parcelRegister("6hsVv", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6a94a68519fb849e$export$e324594224ef24da);

var $cQhWs = parcelRequire("cQhWs");

var $86mek = parcelRequire("86mek");

var $e7Dvb = parcelRequire("e7Dvb");
const $6a94a68519fb849e$export$e324594224ef24da = {
    setFilters: $86mek.setFilters,
    setEpicFilters: $cQhWs.setEpicFilters,
    setVersionFilters: $e7Dvb.setVersionFilters
};

});
parcelRegister("cQhWs", function(module, exports) {

$parcel$export(module.exports, "setEpicFilters", () => $b859b1e97bc1ccf8$export$e24537ba01fbbff1);


var $bbNss = parcelRequire("bbNss");
const $b859b1e97bc1ccf8$export$e24537ba01fbbff1 = (0, $bbNss.setFilter)((0, $0904d0fa958edff5$export$2a4f270075a033de));

});
parcelRegister("bbNss", function(module, exports) {

$parcel$export(module.exports, "setFilter", () => $8fa8f4b7b2e1add9$export$939370273cf4a757);

var $gccSB = parcelRequire("gccSB");

var $86mek = parcelRequire("86mek");
const $8fa8f4b7b2e1add9$export$939370273cf4a757 = (filterKey)=>(newFilterValue)=>({ getState: getState, dispatch: dispatch })=>{
            const state = getState();
            const filters = {
                ...state.filters
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(newFilterValue)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            delete filters[filterKey];
            else // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
            filters[filterKey] = newFilterValue;
            dispatch((0, $86mek.setFilters)(filters));
        };

});
parcelRegister("86mek", function(module, exports) {

$parcel$export(module.exports, "setFilters", () => $00f9303a0e206c58$export$90e9b0558f0311af);

var $ajpes = parcelRequire("ajpes");
const $00f9303a0e206c58$export$90e9b0558f0311af = (filters)=>({ getState: getState, setState: setState }, { onFiltersChange: onFiltersChange })=>{
        const state = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(state, filters)) {
            setState({
                filters: filters
            });
            onFiltersChange && onFiltersChange(filters);
        }
    };

});



parcelRegister("e7Dvb", function(module, exports) {

$parcel$export(module.exports, "setVersionFilters", () => $7d05b54ba202350e$export$2dd46fe22cb52ed5);


var $bbNss = parcelRequire("bbNss");
const $7d05b54ba202350e$export$2dd46fe22cb52ed5 = (0, $bbNss.setFilter)((0, $0904d0fa958edff5$export$a4ad2735b021c132));

});


parcelRegister("kNguL", function(module, exports) {

$parcel$export(module.exports, "getEpic", () => $4f0dfad7edbcb0d4$export$73171e65af38eb92);
const $4f0dfad7edbcb0d4$export$73171e65af38eb92 = (state)=>state.filters ? state.filters.ISSUE_PARENT : null;

});

parcelRegister("btxt2", function(module, exports) {

$parcel$export(module.exports, "getFilters", () => $dbd96765a8e1bc68$export$1933a9fe712fc1fd);
const $dbd96765a8e1bc68$export$1933a9fe712fc1fd = (state)=>state.filters;

});

parcelRegister("cxBEo", function(module, exports) {

$parcel$export(module.exports, "getFixVersion", () => $c7a4982693da9d44$export$f234b291359ecd8b);
const $c7a4982693da9d44$export$f234b291359ecd8b = (state)=>state.filters ? state.filters.VERSION : null;

});


parcelRegister("czw5V", function(module, exports) {

$parcel$export(module.exports, "useIsInsightsPanelOpen", () => $daf962c06fa7300b$export$b1fef7718462a5cf);

var $c1MAf = parcelRequire("c1MAf");

var $l89dM = parcelRequire("l89dM");

var $k35me = parcelRequire("k35me");
const $daf962c06fa7300b$export$b1fef7718462a5cf = ()=>{
    const isInsightsPanelVisible = (0, $c1MAf.useBacklogSelector)((0, $l89dM.getInsightsPanel));
    const hasSprints = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    return hasSprints && isInsightsPanelVisible;
};

});

parcelRegister("c060Z", function(module, exports) {

$parcel$export(module.exports, "useIsViewSettingsPanelOpen", () => $88c5cab41202b5fa$export$b9d31f582c2f1d3f);

var $c1MAf = parcelRequire("c1MAf");

var $l89dM = parcelRequire("l89dM");
const $88c5cab41202b5fa$export$b9d31f582c2f1d3f = ()=>{
    const isViewSettingsPanelVisible = (0, $c1MAf.useBacklogSelector)((0, $l89dM.getViewSettingsPanel));
    return isViewSettingsPanelVisible;
};

});

parcelRegister("5A42o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f381a0939c145c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $g4tDr = parcelRequire("g4tDr");

var $FTaAj = parcelRequire("FTaAj");


var $bC2fB = parcelRequire("bC2fB");

var $10Ngv = parcelRequire("10Ngv");

var $1cUba = parcelRequire("1cUba");

var $c1MAf = parcelRequire("c1MAf");

var $legw4 = parcelRequire("legw4");

var $fdAim = parcelRequire("fdAim");

var $38qhf = parcelRequire("38qhf");

var $17kP6 = parcelRequire("17kP6");

var $9g0YE = parcelRequire("9g0YE");

var $czUNp = parcelRequire("czUNp");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $ixZA4 = parcelRequire("ixZA4");

var $kGoMd = parcelRequire("kGoMd");
const $e3f381a0939c145c$var$mapStateToProps = (state)=>{
    const { cardId: cardId, timestamp: timestamp, externalAction: externalAction } = (0, $dGljH.getDetailViewData)(state) || {};
    const getIssueKey = (0, $dGljH.getKeyByIdForAllIssueTypes)(state);
    const cardKey = getIssueKey(cardId);
    const storyPointFieldId = (0, $jG5HW.getStoryPointFieldId)(state);
    const isEpic = cardId ? (0, $dGljH.makeGetCardTypeHierarchyLevel)(state)(cardId) === (0, $g4tDr.PARENT_HIERARCHY_TYPE) : false;
    return {
        cardKey: cardKey,
        cardId: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        cardId,
        isEpic: isEpic,
        externalAction: externalAction,
        timestamp: // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
        timestamp,
        rapidViewId: (0, $jG5HW.getRapidViewId)(state),
        isBacklogWithSprints: (0, $k35me.isBacklogWithSprints)(state),
        backlogSessionId: (0, $jG5HW.getSessionId)(state),
        storyPointFieldId: storyPointFieldId
    };
};
const $e3f381a0939c145c$var$mapDispatchToProps = {
    onTogglePanel: (0, $9g0YE.togglePanel),
    onCloseInsightsPanel: ()=>(0, $9g0YE.closeInsightsPanel)(),
    onCloseViewSettingsPanel: ()=>(0, $9g0YE.closeViewSettingsPanel)(),
    onDelete: (0, $legw4.cardDelete),
    onIssueViewUpdate: (0, $17kP6.issueViewUpdate),
    onCardRefreshRequest: (0, $fdAim.cardRefreshRequest),
    onCardStatusCheck: (0, $czUNp.cardStatusCheck)
};
const $e3f381a0939c145c$var$onCloseFactory = (0, $8QpSo.default)((cardId, onCloseWithIssueId)=>()=>onCloseWithIssueId(cardId));
const $e3f381a0939c145c$var$onChangeFactory = (0, $8QpSo.default)((storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest)=>(event)=>{
        // NOTE: Updates for version panel are handled separately (owned by Fusion team: src/packages/software/version-backlog-panel/package.json)
        if (event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
            // Cannot remove StatusKey here as the fixed versions panel uses it
            // see https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/32152/overview?commentId=2346562
            const versionsRefetchEventTypes = [
                (0, $e9be48d6d2c01760$export$4420b7468f889692),
                (0, $e9be48d6d2c01760$export$a68dbc90211df1a8),
                (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
                storyPointFieldId || ''
            ];
            if (versionsRefetchEventTypes.includes(event.fieldId)) onRefetchVersions();
            if (event.meta.fieldId === 'summary') {
                const { issueId: issueId } = event;
                if (isEpic) onUpdateEpicSummary(Number(rapidViewId), issueId, event.meta.fieldValue);
            }
            // with Unmapped status feature, an issue can be moved back to backlog, if status is updated to mapped status
            // In that case backlog need to refresh the data so that issue can reappear on backlog.
            if (event.meta.fieldId === (0, $e9be48d6d2c01760$export$4420b7468f889692)) onCardStatusCheck(event);
        }
        // NOTE: Updates for extracted fields are managed by Sweet State and handled by field sync (src/packages/software/backlog/src/view/all-fields-sync/field-sync)
        const extractedFields = (0, $10Ngv.getExtractedFields)({
            storyPointFieldId: storyPointFieldId
        });
        if ((event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED || event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED || event.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED) && extractedFields.includes(event.meta.fieldId) || event.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return;
        // Handles updates for epics or subtasks by updating only relevant parts of the Redux store (non-trivial for Backlog card UI but impact the issue hierarchy relationship)
        onIssueViewUpdate(event);
        const refreshIssueId = event.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED ? Number(event.meta.childIssue.id) : Number(event.issueId);
        // Handles updates for base-level issues by refetching the card (impact Backlog card UI directly)
        onCardRefreshRequest(refreshIssueId, event);
    });
const $e3f381a0939c145c$var$onDeleteFactory = (0, $8QpSo.default)((ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest)=>({ issueId: issueId })=>{
        if (ownPropsOnDelete) ownPropsOnDelete(issueId);
        onDelete(Number(issueId));
        if (issueId && Number(issueId) !== cardId) onCardRefreshRequest();
    });
const $e3f381a0939c145c$export$9d1611c77c2fe928 = ({ rapidViewId: rapidViewId, backlogSessionId: backlogSessionId, storyPointFieldId: storyPointFieldId, cardId: cardId, cardKey: cardKey, isEpic: isEpic, timestamp: timestamp, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction }, { onCloseInsightsPanel: onCloseInsightsPanel, onCloseViewSettingsPanel: onCloseViewSettingsPanel, onDelete: onDelete, onIssueViewUpdate: onIssueViewUpdate, onCardRefreshRequest: onCardRefreshRequest, onCardStatusCheck: onCardStatusCheck }, { parentWidth: parentWidth, onDelete: ownPropsOnDelete, onRefetchVersions: onRefetchVersions, onUpdateEpicSummary: onUpdateEpicSummary, onCloseWithIssueId: onCloseWithIssueId })=>({
        parentWidth: parentWidth,
        cardKey: cardKey,
        timestamp: timestamp,
        rapidViewId: rapidViewId,
        isBacklogWithSprints: isBacklogWithSprints,
        externalAction: externalAction,
        backlogSessionId: backlogSessionId,
        // extra method to avoid arguments in action creator
        onClose: $e3f381a0939c145c$var$onCloseFactory(cardId, onCloseWithIssueId),
        onCloseInsightsClick: onCloseInsightsPanel,
        onCloseViewSettingsPanelClick: onCloseViewSettingsPanel,
        onChange: $e3f381a0939c145c$var$onChangeFactory(storyPointFieldId, onRefetchVersions, isEpic, onUpdateEpicSummary, rapidViewId, onCardStatusCheck, onIssueViewUpdate, onCardRefreshRequest),
        onDelete: $e3f381a0939c145c$var$onDeleteFactory(ownPropsOnDelete, onDelete, cardId, onCardRefreshRequest),
        IssueWrapper: (0, $ixZA4.default)
    });
const $e3f381a0939c145c$export$812e801c43ce71e3 = (0, $bC2fB.connect)($e3f381a0939c145c$var$mapStateToProps, $e3f381a0939c145c$var$mapDispatchToProps, $e3f381a0939c145c$export$9d1611c77c2fe928)((0, $kGoMd.default));
const $e3f381a0939c145c$export$335ea2193bcd128b = ({ boardId: boardId, ...props })=>{
    const { updateEpicSummary: updateEpicSummary } = (0, $1cUba.useUpdateEpicSummary)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const refetch = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $gwOHY.refetchVersions)());
    }, [
        dispatch
    ]);
    const onCloseWithIssueId = (0, $5uXOq.useCallback)((cardId)=>{
        dispatch((0, $38qhf.closeDetailView)(cardId));
        return (0, $38qhf.closeDetailView)(cardId);
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e3f381a0939c145c$export$812e801c43ce71e3, {
        ...props,
        onRefetchVersions: refetch,
        onUpdateEpicSummary: updateEpicSummary,
        onCloseWithIssueId: onCloseWithIssueId
    });
};
var $e3f381a0939c145c$export$2e2bcd8739ae039 = $e3f381a0939c145c$export$335ea2193bcd128b;

});
parcelRegister("1cUba", function(module, exports) {

$parcel$export(module.exports, "useUpdateEpicSummary", () => $ca0fc3bef8b980b6$export$1fa1c6b4dbf736ff);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $ksXL1 = parcelRequire("ksXL1");

var $4R6GH = parcelRequire("4R6GH");

var $kGkjZ = parcelRequire("kGkjZ");

var $fSgHa = parcelRequire("fSgHa");
const $ca0fc3bef8b980b6$export$cb085029733a197f = (0, $5cllN.default)`
    ${(0, $kGkjZ.epicFragment)}
    query BacklogEpicsCache($boardId: ID!, $isCompanyManaged: Boolean!) {
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            issueParents {
                ...EpicPanelIssueParentFragment
            }
        }
    }
`;
const $ca0fc3bef8b980b6$export$1fa1c6b4dbf736ff = ()=>{
    const apolloClient = (0, $5tTFS.useApolloClient)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [, { updateEpicAttributes: updateEpicAttributes }] = (0, $ksXL1.useEpicsStoreActions)();
    const updateEpicSummary = (boardId, issueId, summary)=>{
        if ((0, $4R6GH.fg)('jsw_epic_panel_paginated_fetch')) {
            updateEpicAttributes(issueId, {
                name: summary
            });
            return;
        }
        const board = apolloClient.readQuery({
            query: $ca0fc3bef8b980b6$export$cb085029733a197f,
            variables: {
                boardId: boardId,
                isCompanyManaged: isCompanyManaged
            }
        });
        if (board?.boardScope?.issueParents) {
            const issueParents = board.boardScope.issueParents.map((epic)=>{
                if (epic.id === issueId) return {
                    ...epic,
                    summary: summary
                };
                return epic;
            });
            apolloClient.writeQuery({
                query: $ca0fc3bef8b980b6$export$cb085029733a197f,
                variables: {
                    boardId: boardId,
                    isCompanyManaged: isCompanyManaged
                },
                data: {
                    boardScope: {
                        ...board.boardScope,
                        issueParents: [
                            ...issueParents
                        ]
                    }
                }
            });
        }
    };
    return {
        updateEpicSummary: updateEpicSummary
    };
};

});
parcelRegister("ksXL1", function(module, exports) {

$parcel$export(module.exports, "useEpicsStoreActions", () => $f3cf61f3dba099db$export$cc607320af4fa537);
$parcel$export(module.exports, "useEpicsStoreIsInitialised", () => $f3cf61f3dba099db$export$9ddd8d2fb828030f);
$parcel$export(module.exports, "useColumnCounts", () => $f3cf61f3dba099db$export$a1adfbf5b4219803);
$parcel$export(module.exports, "useEpicIssueType", () => $f3cf61f3dba099db$export$acd1723f083afb7c);
$parcel$export(module.exports, "useEpicIssueTypeName", () => $f3cf61f3dba099db$export$1392ad62b696a2fd);
$parcel$export(module.exports, "useTimeTrackingOptions", () => $f3cf61f3dba099db$export$cfd3a8034358ba8f);
$parcel$export(module.exports, "useIsRankingEnabled", () => $f3cf61f3dba099db$export$f2905104781f6877);
$parcel$export(module.exports, "useEpicCardsState", () => $f3cf61f3dba099db$export$a1a694f17da9b27c);
$parcel$export(module.exports, "useEpicsFilterData", () => $f3cf61f3dba099db$export$9162a71a3e0d59c1);

var $7JoAD = parcelRequire("7JoAD");

var $16n1o = parcelRequire("16n1o");
const $f3cf61f3dba099db$export$cc607320af4fa537 = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: null
});
const $f3cf61f3dba099db$var$getEpicsStoreIsInitialised = (state)=>state.isInitialised;
const $f3cf61f3dba099db$export$9ddd8d2fb828030f = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$var$getEpicsStoreIsInitialised
});
const $f3cf61f3dba099db$export$7511c66023e8a822 = (state)=>state.columnCounts;
const $f3cf61f3dba099db$export$a1adfbf5b4219803 = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$7511c66023e8a822
});
const $f3cf61f3dba099db$export$c58dde3f1e86a4e4 = (state)=>state.epicIssueType;
const $f3cf61f3dba099db$export$acd1723f083afb7c = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$c58dde3f1e86a4e4
});
const $f3cf61f3dba099db$export$d30c1ce996fed20b = (state)=>state.epicIssueTypeName;
const $f3cf61f3dba099db$export$1392ad62b696a2fd = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$d30c1ce996fed20b
});
const $f3cf61f3dba099db$export$cb06173d4516a1bf = (state)=>state.timeTrackingOptions;
const $f3cf61f3dba099db$export$cfd3a8034358ba8f = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$cb06173d4516a1bf
});
const $f3cf61f3dba099db$export$c8d7f1b90bd94368 = (state)=>state.isRankingEnabled;
const $f3cf61f3dba099db$export$f2905104781f6877 = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$c8d7f1b90bd94368
});
const $f3cf61f3dba099db$export$f138f9cd4309615d = (state)=>({
        cards: state.cards,
        loading: state.loading,
        error: state.error,
        refetchError: state.refetchError
    });
const $f3cf61f3dba099db$export$a1a694f17da9b27c = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$f138f9cd4309615d
});
const $f3cf61f3dba099db$export$cb007e11c4f92b94 = (state)=>({
        cards: state.cards,
        epicIssueTypeName: state.epicIssueTypeName,
        isEpicIssueTypeAvailable: state.isEpicIssueTypeAvailable
    });
const $f3cf61f3dba099db$export$9162a71a3e0d59c1 = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$cb007e11c4f92b94
});
const $f3cf61f3dba099db$export$b2da883a667e9881 = (state)=>state.isEpicIssueTypeAvailable;
const $f3cf61f3dba099db$export$9f53fc27477100a8 = (0, $7JoAD.createHook)((0, $16n1o.EpicsStore), {
    selector: $f3cf61f3dba099db$export$b2da883a667e9881
});

});
parcelRegister("16n1o", function(module, exports) {

$parcel$export(module.exports, "EpicsStore", () => $45e2ae73c35abc39$export$718386d323810d5b);

var $7JoAD = parcelRequire("7JoAD");

var $1mWpL = parcelRequire("1mWpL");

var $7pLfz = parcelRequire("7pLfz");
const $45e2ae73c35abc39$export$718386d323810d5b = (0, $7JoAD.createStore)({
    name: 'EpicsStore',
    initialState: (0, $7pLfz.INITIAL_STATE),
    actions: $1mWpL.actions
});
const $45e2ae73c35abc39$export$2eb948e5227270ad = (0, $7JoAD.createHook)($45e2ae73c35abc39$export$718386d323810d5b);
const $45e2ae73c35abc39$export$e7d232b78090ef52 = (0, $7JoAD.createContainer)($45e2ae73c35abc39$export$718386d323810d5b, {
    onInit: (0, $1mWpL.actions).initContainer
});

});
parcelRegister("1mWpL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0b74ab6d58eeb130$export$e324594224ef24da);

var $3JOCw = parcelRequire("3JOCw");

var $7pLfz = parcelRequire("7pLfz");
const $0b74ab6d58eeb130$export$57d319145ef8fcba = ()=>({ setState: setState }, initProps)=>{
        setState({
            ...initProps,
            isInitialised: true
        });
    };
const $0b74ab6d58eeb130$export$f6196a6c6bb539b4 = (initProps)=>({ setState: setState })=>{
        setState({
            ...initProps,
            isInitialised: true
        });
    };
const $0b74ab6d58eeb130$export$8e84bad0b35de9e8 = ()=>({ setState: setState })=>{
        setState((0, $7pLfz.INITIAL_STATE));
    };
const $0b74ab6d58eeb130$export$de1bc8024bd89034 = (newQueryState = {})=>({ setState: setState })=>{
        setState({
            ...newQueryState
        });
    };
const $0b74ab6d58eeb130$export$c27415602243c7a5 = (epics, optimisticIds = [])=>({ setState: setState, getState: getState })=>{
        // There is an implicit assumption that the optimisticIds match up 1-1 with the epics provided
        const { cards: cards } = getState();
        if (!optimisticIds.length) {
            setState({
                cards: [
                    ...cards,
                    ...epics
                ]
            });
            return;
        }
        const firstIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[0] === id);
        const lastIndex = cards.findIndex(({ epic: { id: id } })=>optimisticIds[optimisticIds.length - 1] === id);
        setState({
            cards: [
                ...cards.slice(0, firstIndex),
                ...epics,
                ...cards.slice(lastIndex + 1)
            ]
        });
    };
const $0b74ab6d58eeb130$export$843544102309bcdc = (epicIds, newPosition)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cardsNotMoved = existingCards.filter(({ epic: { id: id } })=>!epicIds.includes(Number(id)));
        const cardsMoved = existingCards.filter(({ epic: { id: id } })=>epicIds.includes(Number(id)));
        setState({
            cards: [
                ...cardsNotMoved.slice(0, newPosition),
                ...cardsMoved,
                ...cardsNotMoved.slice(newPosition)
            ]
        });
    };
const $0b74ab6d58eeb130$export$d122bcc694b92bff = ({ updatedCards: updatedCards, startIndex: startIndex = 0, hasNextPage: hasNextPage })=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        cards.splice(startIndex, hasNextPage ? updatedCards.length : cards.length - startIndex, ...updatedCards);
        setState({
            cards: (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(cards, (card)=>card.epic.id)
        });
    };
const $0b74ab6d58eeb130$export$71b128798a3cdc4b = (epicId, attributes)=>({ setState: setState, getState: getState })=>{
        const { cards: cards } = getState();
        const updatedCards = cards.map((card)=>{
            if (card.epic.id === Number(epicId)) return {
                ...card,
                epic: {
                    ...card.epic,
                    ...attributes
                }
            };
            return card;
        });
        setState({
            cards: updatedCards
        });
    };
const $0b74ab6d58eeb130$export$3293922453e4d4c = (attributes, startIndex = 0)=>({ setState: setState, getState: getState })=>{
        const { cards: existingCards } = getState();
        const cards = existingCards.map((card, index)=>({
                ...card,
                epic: {
                    ...card.epic,
                    ...index >= startIndex && attributes
                }
            }));
        setState({
            cards: cards
        });
    };
const $0b74ab6d58eeb130$export$e324594224ef24da = {
    initContainer: $0b74ab6d58eeb130$export$57d319145ef8fcba,
    initState: $0b74ab6d58eeb130$export$f6196a6c6bb539b4,
    resetState: $0b74ab6d58eeb130$export$8e84bad0b35de9e8,
    updateQueryState: $0b74ab6d58eeb130$export$de1bc8024bd89034,
    addEpics: $0b74ab6d58eeb130$export$c27415602243c7a5,
    rankEpics: $0b74ab6d58eeb130$export$843544102309bcdc,
    updateEpics: $0b74ab6d58eeb130$export$d122bcc694b92bff,
    updateEpicAttributes: $0b74ab6d58eeb130$export$71b128798a3cdc4b,
    updateEpicsAttributes: $0b74ab6d58eeb130$export$3293922453e4d4c
};

});
parcelRegister("7pLfz", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $a7be206ef5b19981$export$36d128238e6b60f5);
$parcel$export(module.exports, "STORY_POINTS", () => $a7be206ef5b19981$export$405b6d72f2d243a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $a7be206ef5b19981$export$bfb354504bb547a0);

var $gBj4V = parcelRequire("gBj4V");
const $a7be206ef5b19981$export$36d128238e6b60f5 = {
    cards: [],
    columnCounts: {
        toDo: 0,
        inProgress: 0,
        done: 0
    },
    isEpicIssueTypeAvailable: false,
    epicIssueType: {
        id: 0,
        name: 'Epic',
        hasRequiredFields: false
    },
    epicIssueTypeName: 'Epic',
    timeTrackingOptions: (0, $gBj4V.defaultTimeTrackingOptions),
    isRankingEnabled: false,
    isInitialised: false,
    loading: false
};
const $a7be206ef5b19981$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $a7be206ef5b19981$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $a7be206ef5b19981$export$43cafe5ec3ffdbf5 = 'CUSTOM_NUMBER_FIELD';
const $a7be206ef5b19981$export$8775696968c9b13c = 'ISSUE_COUNT';

});




parcelRegister("kGkjZ", function(module, exports) {

$parcel$export(module.exports, "epicFragment", () => $3d3e864e78b9ac81$export$cb2dabc00ff80765);
$parcel$export(module.exports, "estimationInfoFragment", () => $3d3e864e78b9ac81$export$6ac7dc3c00d264bc);
$parcel$export(module.exports, "createEpicFragment", () => $3d3e864e78b9ac81$export$c627d203a3aa0338);
$parcel$export(module.exports, "currentUserFragment", () => $3d3e864e78b9ac81$export$b4896d53c7f4d9c4);
$parcel$export(module.exports, "boardLocationFragment", () => $3d3e864e78b9ac81$export$1be26ac8ab064941);
$parcel$export(module.exports, "timeTrackingOptionsFragment", () => $3d3e864e78b9ac81$export$ad6d7391facb841b);
$parcel$export(module.exports, "epicLiteFragment", () => $3d3e864e78b9ac81$export$ee1de0b7a9498416);
$parcel$export(module.exports, "projectLocationFragment", () => $3d3e864e78b9ac81$export$25c256efca3597d1);
$parcel$export(module.exports, "issueParentTypeConfigFragment", () => $3d3e864e78b9ac81$export$9d88616d202f6817);
$parcel$export(module.exports, "columnFragment", () => $3d3e864e78b9ac81$export$6fed28a6f51b8228);
$parcel$export(module.exports, "boardFragment", () => $3d3e864e78b9ac81$export$e1c6fa95c54eabf5);

var $5cllN = parcelRequire("5cllN");
const $3d3e864e78b9ac81$export$cb2dabc00ff80765 = (0, $5cllN.default)`
    fragment EpicPanelIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $3d3e864e78b9ac81$export$6ac7dc3c00d264bc = (0, $5cllN.default)`
    fragment EstimationInfoFragment on EstimationInfo {
        details {
            estimationType
            name
        }
        childrenEstimationStats {
            doneEstimate
            totalEstimate
            percentageCompleted
            notEstimated
        }
    }
`;
const $3d3e864e78b9ac81$export$c627d203a3aa0338 = (0, $5cllN.default)`
    fragment CreateIssueParentFragment on IssueParent {
        id
        key
        summary
        color
        issueType {
            id
            name
            iconUrl
        }
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $3d3e864e78b9ac81$export$b4896d53c7f4d9c4 = (0, $5cllN.default)`
    fragment CurrentUserFragment on CurrentUser {
        permissions
    }
`;
const $3d3e864e78b9ac81$export$1be26ac8ab064941 = (0, $5cllN.default)`
    fragment BoardLocationFragment on Project {
        id
        name
        key
    }
`;
const $3d3e864e78b9ac81$export$ad6d7391facb841b = (0, $5cllN.default)`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;
const $3d3e864e78b9ac81$export$ee1de0b7a9498416 = (0, $5cllN.default)`
    fragment EpicPanelIssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
        issueTypeDetails @include(if: $includeIssueTypes) {
            id
            name
            iconUrl
        }
    }
`;
const $3d3e864e78b9ac81$export$25c256efca3597d1 = (0, $5cllN.default)`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;
const $3d3e864e78b9ac81$export$9d88616d202f6817 = (0, $5cllN.default)`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;
const $3d3e864e78b9ac81$export$6fed28a6f51b8228 = (0, $5cllN.default)`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;
const $3d3e864e78b9ac81$export$e1c6fa95c54eabf5 = (0, $5cllN.default)`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;

});


parcelRegister("ixZA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e0f46b92431375$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");


var $dG9Wy = parcelRequire("dG9Wy");

var $7wqBZ = parcelRequire("7wqBZ");

var $hUXfN = parcelRequire("hUXfN");

var $fOGZN = parcelRequire("fOGZN");

var $7eqRV = parcelRequire("7eqRV");


var $hPtZI = parcelRequire("hPtZI");


var $gZhS0 = parcelRequire("gZhS0");

var $gKgRy = parcelRequire("gKgRy");

var $c1MAf = parcelRequire("c1MAf");

var $fSgHa = parcelRequire("fSgHa");

var $56RoY = parcelRequire("56RoY");

const $95e0f46b92431375$export$35dd9ab573b87c3f = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("82uFl")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $95e0f46b92431375$var$IssueWrapper = (props)=>{
    const backlogCardCount = (0, $c1MAf.useBacklogSelector)((0, $gZhS0.getBacklogCardCount));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)(); // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $5uXOq.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && props.externalAction) dispatchExternalActionRef(props.externalAction);
    }, [
        props.externalAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $gKgRy.setIssueViewOpenFeedbackMark)();
    }, [
        props.issueKey
    ]);
    const isAgilityBoardForIssue = props.isAgilityBoard !== undefined ? props.isAgilityBoard : (0, $dG9Wy.isAgilityBoard);
    const configWithAppKey = isAgilityBoardForIssue ? (0, $fOGZN.simpleSoftwareBoardConfiguration)() : (0, $fOGZN.softwareConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e0f46b92431375$var$BacklogIssueContainer, {
        "data-testid": "software-backlog.detail-view.issue-wrapper.backlog-issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56RoY.PreIssueViewMountFeedbackMark), {
        issueKey: props.issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e0f46b92431375$export$35dd9ab573b87c3f, {
        ...configWithoutAppKey,
        analyticsSource: (0, $fcf97b7a09088940$export$53d41ff2666118e1),
        isLoadedWithPage: true,
        issueKey: props.issueKey,
        onChange: props.onChange,
        onClose: props.onClose,
        rapidViewId: props.rapidViewId,
        viewModeOptions: {
            viewModeSwitchEnabled: false,
            viewMode: 'SIDEBAR'
        },
        onIssueDeleteSuccess: props.onIssueDeleteSuccess,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        metrics: {
            onReadyForUser: ()=>{
                (0, $7wqBZ.getLongTasksMetrics)('bento').stop((0, $hUXfN.bentoReporter), {
                    type: 'sidebar',
                    backlogSessionId: props.backlogSessionId
                });
            },
            onInteractive: ()=>{
                (0, $gKgRy.setIssueViewOpenFinishMark)(true, backlogCardCount, isCompanyManaged);
            }
        },
        onIssueKeyChange: props.onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef
    })));
};
var $95e0f46b92431375$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSource)((0, $fcf97b7a09088940$export$53d41ff2666118e1), (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)))($95e0f46b92431375$var$IssueWrapper);
const $95e0f46b92431375$var$BacklogIssueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("dG9Wy", function(module, exports) {

$parcel$export(module.exports, "isAgilityBoard", () => $a8e7e70c49421eb3$export$f5c021765283e8bd);

var $j8DrX = parcelRequire("j8DrX");
const $a8e7e70c49421eb3$export$f5c021765283e8bd = // this meta actually checks if backlog is using issueLists
(0, $j8DrX.default)('ghx-simply-filters-enabled') === 'true';

});

parcelRegister("hUXfN", function(module, exports) {

$parcel$export(module.exports, "bentoReporter", () => $6bde48e393b34dc9$export$b4ea9d181d8adab2);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $6bde48e393b34dc9$export$b4ea9d181d8adab2 = (observationData, extra)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...extra,
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('bento', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            type: extra.type || 'unknown',
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-bento', analyticsData);
    }
};

});

parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$203643a6fd9496a0 = 'KNOWLEDGE_BASE';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $e3c8771effba3477$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $c65JB = parcelRequire("c65JB");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c65JB.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c65JB.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("gjEtj", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $c322f875acea1654$export$c3f500e812fb1bb3);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $iqr2y = parcelRequire("iqr2y");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");
const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $5uXOq.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("gKgRy", function(module, exports) {

$parcel$export(module.exports, "setIssueViewOpenFeedbackMark", () => $5bcb7ccbda2dac65$export$2c1211bae6c14a9);
$parcel$export(module.exports, "setIssueViewOpenFinishMark", () => $5bcb7ccbda2dac65$export$74c6496311688a4d);

var $k12ix = parcelRequire("k12ix");

var $8hVbJ = parcelRequire("8hVbJ");
const $5bcb7ccbda2dac65$export$2c1211bae6c14a9 = ()=>{
    (0, $8hVbJ.issueViewOpenInteraction).mark('feedback');
};
const $5bcb7ccbda2dac65$export$74c6496311688a4d = (isSideBar, backlogCardCount, isCompanyManaged)=>{
    (0, $8hVbJ.issueViewOpenInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            ...backlogCardCount,
            isSideBar: isSideBar,
            isCompanyManaged: isCompanyManaged
        }
    });
};

});

parcelRegister("56RoY", function(module, exports) {

$parcel$export(module.exports, "PreIssueViewMountFeedbackMark", () => $f7b36c748e55dc2e$export$e17cfe6a40740e70);

var $5uXOq = parcelRequire("5uXOq");

var $8hVbJ = parcelRequire("8hVbJ");
const $f7b36c748e55dc2e$export$e17cfe6a40740e70 = ({ issueKey: issueKey })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $8hVbJ.issueViewOpenInteraction).mark('feedbackPreMountEnd');
    }, [
        issueKey
    ]);
    return null;
};

});

parcelRegister("82uFl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("92sUi"),
    $6fhBS("i5RRW"),
    $6fhBS("dsiAd"),
    $6fhBS("kWrFZ"),
    $6fhBS("2Lfdl"),
    $6fhBS("eNmuD"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});


parcelRegister("kGoMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a52c2d89f45d4a6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $FTaAj = parcelRequire("FTaAj");

var $9PAwV = parcelRequire("9PAwV");

var $lfTZh = parcelRequire("lfTZh");

var $3bPZM = parcelRequire("3bPZM");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $f6RVN = parcelRequire("f6RVN");


var $fSgHa = parcelRequire("fSgHa");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $lXGRu = parcelRequire("lXGRu");

var $64dTY = parcelRequire("64dTY");

var $5KJMz = parcelRequire("5KJMz");
const $6a52c2d89f45d4a6$var$REFETCH_EPIC_PANELS_EVENTS = [
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED,
    (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED
];
const $6a52c2d89f45d4a6$export$d51fb174c0dd91e9 = ({ parentWidth: parentWidth, cardKey: cardKey, rapidViewId: rapidViewId, onClose: onClose, onChange: onChange, onDelete: onDelete, timestamp: timestamp, onCloseInsightsClick: onCloseInsightsClick, onCloseViewSettingsPanelClick: onCloseViewSettingsPanelClick, isBacklogWithSprints: isBacklogWithSprints, externalAction: externalAction, backlogSessionId: backlogSessionId, IssueWrapper: IssueWrapper })=>{
    const [issueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)((0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa));
    const issueKeyOrCardKey = issueKey || cardKey;
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setIssueKey(toIssueKey), [
        setIssueKey
    ]);
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingsPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        onChange(event);
        if (isCompanyManaged && $6a52c2d89f45d4a6$var$REFETCH_EPIC_PANELS_EVENTS.includes(event.type)) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onChange,
        triggerEpicPanelRefetch
    ]);
    const handleIssueDelete = (0, $5uXOq.useCallback)((data)=>{
        onDelete(data);
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        onDelete,
        triggerEpicPanelRefetch
    ]);
    const getBacklogInsightsPanel = (0, $5uXOq.useCallback)(()=>isInsightsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a52c2d89f45d4a6$var$DetailsPanelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "backlog-insights-panel",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXGRu.AsyncBacklogInsightsPanel), {
            isOpen: isInsightsOpen,
            onClose: onCloseInsightsClick
        })))) : null, [
        isInsightsOpen,
        onCloseInsightsClick
    ]);
    const getBacklogViewSettingsPanel = (0, $5uXOq.useCallback)(()=>isViewSettingsPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $6a52c2d89f45d4a6$var$ViewSettingsPanelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KJMz.ViewSettingsPanel), {
            isPanelOpen: isViewSettingsPanelOpen,
            onPanelClose: onCloseViewSettingsPanelClick
        })) : null, [
        isViewSettingsPanelOpen,
        onCloseViewSettingsPanelClick
    ]);
    return (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingsPanelOpen ? getBacklogViewSettingsPanel() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64dTY.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth
        }, issueKeyOrCardKey !== null && issueKeyOrCardKey !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a52c2d89f45d4a6$var$DetailsWrapper, {
            hide: isInsightsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueWrapper, {
            key: issueKeyOrCardKey + timestamp,
            issueKey: issueKeyOrCardKey,
            onClose: onClose,
            onChange: handleChange,
            onIssueDeleteSuccess: handleIssueDelete,
            rapidViewId: Number(rapidViewId),
            isAgilityBoard: true,
            isLoadedWithPage: true,
            onIssueKeyChange: onIssueKeyChange,
            history: null,
            externalAction: externalAction,
            backlogSessionId: backlogSessionId
        })), isBacklogWithSprints && getBacklogInsightsPanel()));
};
var $6a52c2d89f45d4a6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a52c2d89f45d4a6$export$d51fb174c0dd91e9);
const $6a52c2d89f45d4a6$var$ViewSettingsPanelContainerStyles = (0, $jJ1Sb.xcss)({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: 'space.500',
    paddingLeft: 'space.300',
    paddingBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $6a52c2d89f45d4a6$var$DetailsWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-10sh35q-0"
})((props)=>({
        flex: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.hide ? 'none' : undefined,
        height: '100%',
        overflowX: 'hidden'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a52c2d89f45d4a6$var$DetailsWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1reo15vq",
            __cmplp.hide && "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $6a52c2d89f45d4a6$var$DetailsWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $6a52c2d89f45d4a6$var$DetailsWrapperExperiment, $6a52c2d89f45d4a6$var$DetailsWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a52c2d89f45d4a6$var$DetailsPanelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _4t3i1osq _1reo15vq _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gSExi", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $cd06fcc13efa32a5$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("9PAwV", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $90f8c6fec93ae563$export$93acb63f4e179357);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $heNNl = parcelRequire("heNNl");

var $5e5zm = parcelRequire("5e5zm");
const $90f8c6fec93ae563$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $90f8c6fec93ae563$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90f8c6fec93ae563$var$DetailPanel, props));

});

parcelRegister("lXGRu", function(module, exports) {

$parcel$export(module.exports, "AsyncBacklogInsightsPanel", () => $7e3676499c49c6c4$export$ad767ebad8b61f5b);

var $hPtZI = parcelRequire("hPtZI");

const $7e3676499c49c6c4$export$ad767ebad8b61f5b = (0, $hPtZI.lazy)(()=>(parcelRequire("b2Xmy")).then((module)=>module.default), {
    moduleId: "./src/packages/software/backlog/src/view/backlog-content/insights-panel/index.tsx"
});

});
parcelRegister("b2Xmy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("gVYP2")
]).then(()=>parcelRequire('jWG5D'));

});


parcelRegister("64dTY", function(module, exports) {

$parcel$export(module.exports, "Resizer", () => $3746486a9e6a787e$export$48a76196cafe3b93);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $7wqBZ = parcelRequire("7wqBZ");

var $bv8GQ = parcelRequire("bv8GQ");

var $7D59a = parcelRequire("7D59a");

var $3FUwR = parcelRequire("3FUwR");

var $d08vq = parcelRequire("d08vq");
const $3746486a9e6a787e$export$b4e0432c87affda2 = 440;
const $3746486a9e6a787e$export$177615fff7f0b5c6 = 440;
function $3746486a9e6a787e$export$48a76196cafe3b93({ setWidth: widthProp, onResize: onResize, children: children, parentWidth: parentWidth, onResizeEnd: onResizeEnd }) {
    const [width, setWidth] = (0, $5uXOq.useState)(()=>{
        const initValue = (0, $3FUwR.getDetailViewWidthRatio)();
        return Math.max(parentWidth * initValue, $3746486a9e6a787e$export$b4e0432c87affda2);
    });
    const startX = (0, $5uXOq.useRef)(0);
    const extraWidth = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        const initValue = (0, $3FUwR.getDetailViewWidthRatio)();
        setWidth(Math.max(parentWidth * initValue, $3746486a9e6a787e$export$b4e0432c87affda2));
    }, [
        parentWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onResize?.(widthProp !== undefined && widthProp !== 0 ? widthProp : width);
    }, [
        onResize,
        width,
        widthProp
    ]);
    const onMouseUp = (0, $7D59a.useEvent)(()=>{
        startX.current = 0;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', onMouseUp);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.remove((0, $d08vq.IS_DRAGGING_CLASS_NAME));
        const widthRatio = width === $3746486a9e6a787e$export$b4e0432c87affda2 ? 0 : width / parentWidth;
        (0, $3FUwR.setDetailViewWidthRatio)(widthRatio);
        (0, $7wqBZ.getLongTasksMetrics)('detail-view-resizer').stop((0, $bv8GQ.softwareGenericLongTasksReporter)('detail-view-resizer'));
        onResizeEnd && onResizeEnd(width / parentWidth);
    });
    const onMouseDown = (0, $7D59a.useEvent)((e)=>{
        startX.current = e.clientX + (width - $3746486a9e6a787e$export$b4e0432c87affda2);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousemove', onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', onMouseUp);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.add((0, $d08vq.IS_DRAGGING_CLASS_NAME));
        (0, $7wqBZ.getLongTasksMetrics)('detail-view-resizer').start('jira-backlog-detail-view-resizer');
    });
    const onMouseMove = (0, $7D59a.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newValue = Math.min($3746486a9e6a787e$export$b4e0432c87affda2 + extraWidth.current, parentWidth / 2);
        if (newValue === width) return;
        setWidth(newValue);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $3746486a9e6a787e$var$containerStyle,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: widthProp != null && widthProp !== 0 ? widthProp : width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $3746486a9e6a787e$var$resizeHandleStyle,
        onMouseDown: onMouseDown,
        testId: "software-backlog.detail-view.resizer.resize-handle"
    }), children);
}
const $3746486a9e6a787e$var$containerStyle = (0, $jJ1Sb.xcss)({
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
});
const $3746486a9e6a787e$var$resizeHandleStyle = (0, $jJ1Sb.xcss)({
    width: "var(--ds-space-100, 8px)",
    cursor: 'ew-resize',
    borderLeftStyle: 'solid',
    borderLeftWidth: '2px',
    borderLeftColor: 'transparent',
    alignSelf: 'stretch',
    ':hover': {
        borderLeftColor: 'color.border.focused'
    },
    ':focus': {
        borderLeftColor: 'color.border.focused'
    },
    transition: 'border-color 0.5s'
});

});
parcelRegister("d08vq", function(module, exports) {

$parcel$export(module.exports, "IS_DRAGGING_CLASS_NAME", () => $3370814bef9f491a$export$373c1b4ae027de04);
$parcel$export(module.exports, "default", () => $3370814bef9f491a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $3370814bef9f491a$export$373c1b4ae027de04 = 'ak-dnd-is-dragging';
function $3370814bef9f491a$export$2e2bcd8739ae039() {
    // Note that react-beautiful-dnd actually handles body styles when dragging
    // BUT it doesn't prevent the ICC placeholder from triggering on the board and backlog
    // and as a result we need this class here to prevent that behaviour
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                            /* disable hover events during drag */
                            body.${$3370814bef9f491a$export$373c1b4ae027de04} * {
                                pointer-events: none;
                            }
                        `
        }
    }));
}

});


parcelRegister("5KJMz", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanel", () => $715312da2e3c3528$export$3a81a9760a380951);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $6s1PB = parcelRequire("6s1PB");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $c1MAf = parcelRequire("c1MAf");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $l9VFH = parcelRequire("l9VFH");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $le1bQ = parcelRequire("le1bQ");
const $715312da2e3c3528$export$3a81a9760a380951 = ({ isPanelOpen: isPanelOpen, onPanelClose: onPanelClose })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCMPBoard = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const showEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const isQuickFiltersAvailable = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters)).length > 0;
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const showFilterBarToggle = isCMPBoard && isQuickFiltersAvailable;
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditBoardConfig));
    const canInvite = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getCanInviteOthersToProject));
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $a7yHf.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString())));
    const handleCollapseSubtasks = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $a7yHf.collapseAllCardGroups)());
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const isPriorityEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        isViewPanelOpen: isPanelOpen,
        onViewPanelClose: onPanelClose,
        boardId: Number(boardId),
        isClassic: isCMPBoard,
        areSubtasksEnabled: isCMPBoard && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        isDueDateEnabled: !isCMPBoard && isDueDateEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isAddPeopleButtonEnabled: canEdit || canInvite && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment')
    });
};

});
parcelRegister("jB6yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c97328c4dc150e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lm9d2 = parcelRequire("lm9d2");

var $6T4rd = parcelRequire("6T4rd");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $02beV = parcelRequire("02beV");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $hchBL = parcelRequire("hchBL");

var $duOMW = parcelRequire("duOMW");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $lngWe = parcelRequire("lngWe");

var $cYeCp = parcelRequire("cYeCp");

var $3uPqt = parcelRequire("3uPqt");

var $iDGXn = parcelRequire("iDGXn");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $1wxxD = parcelRequire("1wxxD");

var $8vQbt = parcelRequire("8vQbt");

var $3ykoc = parcelRequire("3ykoc");

var $38RF4 = parcelRequire("38RF4");

var $2ucDS = parcelRequire("2ucDS");

const $36c97328c4dc150e$var$ViewSettings = ({ view: view, boardId: boardId, isClassic: isClassic, epicCustomName: epicCustomName, showEpicAsPanel: showEpicAsPanel = false, showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, isVersionsEnabled: isVersionsEnabled = false, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, isViewPanelOpen: isViewPanelOpen = false, onViewPanelClose: onViewPanelClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), areSubtasksEnabled: areSubtasksEnabled, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, dependencyIssueOptions: dependencyIssueOptions = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const panelRef = (0, $5uXOq.useRef)(null);
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight }, { setOpenViewSettings: setOpenViewSettings, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $02beV.useNextBestTaskContainer)();
    const handleViewPanelClose = ()=>{
        onViewPanelClose();
    };
    const handleClose = ()=>{
        setIsOpen(false);
        if (activeViewSettingsSpotlight === 1 && onViewSettingsSpotlightEnd) // To end the spotlight if the popup is closed
        onViewSettingsSpotlightEnd();
    };
    const handleClick = ()=>{
        setIsOpen(!isOpen);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    };
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        setIsOpen(true);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    }, [
        sendAnalyticsEvent,
        isClassic,
        view,
        viewAs,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const viewSettingsBtnLG = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_LG))[0];
    const viewSettingsBtnSM = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_SM))[0];
    const viewSettingsBtnResponsive = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE))[0];
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // register view settings panel global ref
        register((0, $3795a016b6403547$export$989661c424340ff8), panelRef.current);
        const focusOnCloseButton = ()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const closeButton = panelRef.current?.querySelector(`[data-testid="${(0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)}"]`);
            closeButton?.focus();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnLG) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnLG?.focus();
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnSM) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnSM?.focus();
        }
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.activeElement === viewSettingsBtnResponsive && (0, $4R6GH.fg)('view_settings_focus_for_responsive_button')) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnResponsive?.focus();
        }
    }, [
        register,
        viewSettingsBtnLG,
        viewSettingsBtnResponsive,
        viewSettingsBtnSM
    ]);
    const conditionallyRenderViewSettingsButtonWithAria = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isOpen,
            onClick: handleClick,
            ...props
        });
    const viewAsPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.Popup), {
        "data-testid": "software-view-settings.ui.popup",
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        content: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
                view: view,
                viewAs: (0, $a4XJc.ViewAs).POPUP,
                boardId: boardId,
                isClassic: isClassic,
                showFilterBarToggle: showFilterBarToggle,
                showEpicAsPanel: showEpicAsPanel,
                epicCustomName: epicCustomName,
                showCardDetails: showCardDetails,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                showWorkSuggestions: showWorkSuggestions,
                isVersionsEnabled: isVersionsEnabled,
                areSubtasksEnabled: areSubtasksEnabled,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn,
                dependencyIssueOptions: dependencyIssueOptions,
                onUpdate: props.update
            });
        },
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
                ref: ref
            }, conditionallyRenderViewSettingsButtonWithAria({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }))
    });
    const viewAsPanel = isViewPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: panelRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lngWe.Panel), {
        title: formatMessage((0, $3ykoc.default).panelTitle),
        onClose: handleViewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
        view: view,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        boardId: boardId,
        isClassic: isClassic,
        showFilterBarToggle: showFilterBarToggle,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isVersionsEnabled: isVersionsEnabled,
        isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
        showWorkSuggestions: showWorkSuggestions,
        areSubtasksEnabled: areSubtasksEnabled,
        onSubtasksExpandAll: onSubtasksExpandAll,
        onSubtasksCollapseAll: onSubtasksCollapseAll,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        isSwimlanesEnabled: isSwimlanesEnabled,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: isEstimateEnabled,
        isDueDateEnabled: isDueDateEnabled,
        isLabelsEnabled: isLabelsEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn,
        dependencyIssueOptions: dependencyIssueOptions
    })));
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    // Initialise local storage for Increment Planning board
    (0, $1wxxD.useOnIncrementPlanningBoard)(boardId, view, dependencyIssueOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: viewAs === (0, $a4XJc.ViewAs).PANEL ? 'viewSettingsPanel' : 'viewSettingsMenu',
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDGXn.ViewSettingsContainer), {
        view: view,
        isGlobal: true
    }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? viewAsPanel : viewAsPopup));
};
const $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "errorBoundary",
        packageName: "jiraSoftwareViewSettings",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c97328c4dc150e$var$ViewSettings, props));
var $36c97328c4dc150e$export$2e2bcd8739ae039 = $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary;

});
parcelRegister("02beV", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskContainer", () => $b515259196675246$export$d36ece0b77b25b77);
$parcel$export(module.exports, "useNextBestTaskContainer", () => $b515259196675246$export$4e9c40fce9aa102);
$parcel$export(module.exports, "useNextBestTaskActions", () => $b515259196675246$export$7f6f764b43177343);

var $7JoAD = parcelRequire("7JoAD");

var $5VKYm = parcelRequire("5VKYm");
const $b515259196675246$export$7dd0e8f7db9f5f6f = [];
// This is the value of the store on initialisation
const $b515259196675246$var$initialState = {
    sprints: $b515259196675246$export$7dd0e8f7db9f5f6f,
    isAutoOpened: false,
    isNbtToggleButtonVisible: false,
    isOnlyCurrentUserSelected: false,
    isHiddenByUser: false,
    queryGithubOnboardingRef: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{},
    activeViewSettingsSpotlight: null,
    hasViewedViewSettingsSpotlight: true,
    openViewSettings: null,
    viewSettingsTogglePulses: false
};
const $b515259196675246$var$Store = (0, $7JoAD.createStore)({
    initialState: $b515259196675246$var$initialState,
    actions: $5VKYm.actions,
    name: 'jira.insights.next-best-task-store'
});
const $b515259196675246$export$78c85c0bf5f7e99b = ()=>(0, $7JoAD.defaultRegistry).deleteStore($b515259196675246$var$Store);
const $b515259196675246$var$handlePropsChange = ()=>({ setState: setState }, { accountId: accountId, boardId: boardId, isCMPBoard: isCMPBoard, sprints: sprints, onIssueOpen: onIssueOpen })=>{
        setState({
            accountId: accountId,
            boardId: boardId,
            isCMPBoard: isCMPBoard,
            sprints: sprints,
            onIssueOpen: onIssueOpen
        });
    };
const $b515259196675246$export$e26874c6341f398 = (0, $7JoAD.createHook)($b515259196675246$var$Store, {
    selector: (state)=>state.sprints || $b515259196675246$export$7dd0e8f7db9f5f6f
});
const $b515259196675246$export$d36ece0b77b25b77 = (0, $7JoAD.createContainer)($b515259196675246$var$Store, {
    onInit: $b515259196675246$var$handlePropsChange,
    onUpdate: $b515259196675246$var$handlePropsChange
});
const $b515259196675246$export$4e9c40fce9aa102 = (0, $7JoAD.createHook)($b515259196675246$var$Store);
const $b515259196675246$export$7f6f764b43177343 = (0, $7JoAD.createActionsHook)($b515259196675246$var$Store);

});
parcelRegister("5VKYm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c86e62d820c3f13d$export$e324594224ef24da);
const $c86e62d820c3f13d$export$e324594224ef24da = {
    setIsAutoOpened: (isAutoOpened)=>({ setState: setState })=>{
            setState({
                isAutoOpened: isAutoOpened
            });
        },
    setIsNbtToggleButtonVisible: (isNbtToggleButtonVisible)=>({ setState: setState })=>{
            setState({
                isNbtToggleButtonVisible: isNbtToggleButtonVisible
            });
        },
    setIsOnlyCurrentUserSelected: (isOnlyCurrentUserSelected)=>({ setState: setState })=>{
            if (!isOnlyCurrentUserSelected) setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected,
                isAutoOpened: false,
                isHiddenByUser: false
            });
            else setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
            });
        },
    setQueryGithubOnboardingRef: (queryGithubOnboardingRef)=>({ getState: getState, setState: setState })=>{
            if (getState().queryGithubOnboardingRef == null) setState({
                queryGithubOnboardingRef: queryGithubOnboardingRef
            });
        },
    onViewSettingsSpotlightInit: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: false
            });
        },
    onViewSettingsSpotlightStart: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 0
            });
        },
    onViewSettingsSpotlightNext: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 1
            });
        },
    onViewSettingsSpotlightEnd: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: true,
                activeViewSettingsSpotlight: null
            });
        },
    setOpenViewSettings: (openViewSettingsCallback)=>({ getState: getState, setState: setState })=>{
            if (!getState().openViewSettings) setState({
                openViewSettings: openViewSettingsCallback
            });
        },
    setViewSettingsTogglePulses: (viewSettingsTogglePulses)=>({ setState: setState })=>{
            setState({
                viewSettingsTogglePulses: viewSettingsTogglePulses
            });
        },
    setIsHiddenByUser: (isHiddenByUser)=>({ setState: setState })=>{
            setState({
                isHiddenByUser: isHiddenByUser
            });
        }
};

});


parcelRegister("hchBL", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $b03364e48d8512c5$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $b03364e48d8512c5$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $b03364e48d8512c5$export$6b4b878b04fd3017);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");
const $b03364e48d8512c5$var$store = (0, $7JoAD.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $b03364e48d8512c5$export$4beaa3baa53198e4 = (0, $7JoAD.createContainer)($b03364e48d8512c5$var$store);
const $b03364e48d8512c5$var$useGlobalRefStateSelector = (0, $7JoAD.createStateHook)($b03364e48d8512c5$var$store, {
    selector: (state, key)=>state[key]
});
const $b03364e48d8512c5$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $b03364e48d8512c5$var$useGlobalRefStateSelector(key)
    ];
const $b03364e48d8512c5$export$3c6c6911d09d7d8a = (0, $7JoAD.createHook)($b03364e48d8512c5$var$store, {
    selector: null
});
const $b03364e48d8512c5$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $b03364e48d8512c5$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("4cYhQ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9022cae0997d5594$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $9022cae0997d5594$export$7f97440769de1377);
$parcel$export(module.exports, "AnalyticsEvent", () => $9022cae0997d5594$export$30b7662faa307ee);
$parcel$export(module.exports, "ToggleKey", () => $9022cae0997d5594$export$3679582258ad0fad);
$parcel$export(module.exports, "IncrementPlanningAnalyticsKey", () => $9022cae0997d5594$export$75cb7f2b113e0230);
const $9022cae0997d5594$export$e19cd5f9376f8cee = {
    CLICKED: 'clicked',
    CHANGED: 'changed'
};
const $9022cae0997d5594$export$7f97440769de1377 = {
    BUTTON: 'button',
    TOGGLE: 'toggle',
    SELECT: 'select'
};
const $9022cae0997d5594$export$30b7662faa307ee = {
    UI_EVENT: 'UI_EVENT',
    OPERATIONAL_EVENT: 'OPERATIONAL_EVENT',
    TRACK_EVENT: 'TRACK_EVENT'
};
const $9022cae0997d5594$export$3679582258ad0fad = {
    VERSION_PANEL_TOGGLE: 'versionPanel',
    EPIC_PANEL_TOGGLE: 'epicPanel',
    QUICK_FILTERS_TOGGLE: 'quickFilters',
    COMPACT_MODE_TOGGLE: 'compactMode',
    CARD_DENSITY: 'cardDensity',
    SHOW_VERSIONS_TOGGLE: 'showVersions',
    SHOW_EPICS_TOGGLE: 'showEpics',
    SHOW_STATUSES_TOGGLE: 'showStatuses',
    SHOW_ISSUE_TYPE: 'showIssueType',
    SHOW_ISSUE_KEY: 'showIssueKey',
    SHOW_ESTIMATE: 'showEstimate',
    SHOW_PRIORITY: 'showPriority',
    SHOW_DEVELOPMENT: 'showDevelopment',
    SHOW_ASSIGNEE: 'showAssignee',
    SHOW_ISSUE_LINKS_STATS: 'showIssueLinksStats',
    OPEN_ISSUES_IN_SIDEBAR_TOGGLE: 'openIssuesInSidebar',
    SUBTASKS_EXPAND_ALL: 'subtasksExpandAll',
    SUBTASKS_COLLAPSE_ALL: 'subtasksCollapseAll',
    SWIMLANE_EXPAND_ALL: 'swimlaneExpandAll',
    SWIMLANE_COLLAPSE_ALL: 'swimlaneCollapseAll',
    SHOW_DAYS_IN_COLUMN: 'showDaysInColumn',
    SHOW_DUE_DATE: 'showDueDate',
    SHOW_LABELS: 'showLabels',
    SHOW_EXTRA_FIELD: 'showExtraField',
    WORK_SUGGESTIONS_TOGGLE: 'workSuggestions',
    SHOW_CARD_COVERS: 'showCardCovers'
};
const $9022cae0997d5594$export$75cb7f2b113e0230 = {
    UNSCHEDULED_COLUMN_TOGGLE: 'unscheduledColumnToggle',
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: 'issueIdsToShowDependencies',
    SHOW_OFFTRACK_DEPENDENCY_LINES: 'showOfftrackDependencyLines'
};
const $9022cae0997d5594$export$d87506c7d891276d = {
    ...$9022cae0997d5594$export$3679582258ad0fad,
    ...$9022cae0997d5594$export$75cb7f2b113e0230
};

});

parcelRegister("lngWe", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $a08ab407f5b09128$export$2ddb90ad54e5f587);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $53KbV = parcelRequire("53KbV");

var $1o1sA = parcelRequire("1o1sA");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $2MVcM = parcelRequire("2MVcM");
var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $duOMW = parcelRequire("duOMW");

var $jvrqw = parcelRequire("jvrqw");
const $a08ab407f5b09128$export$2ddb90ad54e5f587 = ({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $a08ab407f5b09128$var$panelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $a08ab407f5b09128$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        size: "medium",
        as: "h2"
    }, title || formatMessage((0, $jvrqw.default).defaultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $a08ab407f5b09128$var$ButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: (0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $a08ab407f5b09128$var$IconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1o1sA))), {
        label: formatMessage((0, $jvrqw.default).closeButtonLabel)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), null, children)));
};
const $a08ab407f5b09128$var$headerStyles = (0, $jJ1Sb.xcss)({
    marginBottom: 'space.100'
});
const $a08ab407f5b09128$var$panelStyles = (0, $jJ1Sb.xcss)({
    border: `1px solid ${"var(--ds-border, #091E42)"}`,
    borderRadius: 'border.radius.200',
    width: '280px',
    padding: 'space.300',
    [(0, $2MVcM.media).above.lg]: {
        width: '300px'
    }
});
const $a08ab407f5b09128$var$ButtonWrapperStyles = (0, $jJ1Sb.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$IconWrapperStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});

});
parcelRegister("jvrqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12af5ef45aa68e18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12af5ef45aa68e18$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultTitle: {
        "id": "software-view-settings.common.panel.default-title",
        "defaultMessage": "View settings"
    },
    closeButtonLabel: {
        "id": "software-view-settings.common.panel.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("3uPqt", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvent", () => $2125a8f3d8eb70be$export$4b1735907ca3ab2f);

var $fjcgS = parcelRequire("fjcgS");

var $4cYhQ = parcelRequire("4cYhQ");
const $2125a8f3d8eb70be$export$7d2f3f483d8e6742 = 'viewSettings';
const $2125a8f3d8eb70be$export$4b1735907ca3ab2f = ()=>{
    const sendAnalyticsEvent = (action, actionSubject, eventType, attributes = {}, source)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return Promise.resolve();
            const event = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: $2125a8f3d8eb70be$export$7d2f3f483d8e6742,
                attributes: {
                    ...attributes
                },
                source: source
            };
            switch(eventType){
                case (0, $4cYhQ.AnalyticsEvent).UI_EVENT:
                    return analyticsClient.sendUIEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).OPERATIONAL_EVENT:
                    return analyticsClient.sendOperationalEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).TRACK_EVENT:
                    return analyticsClient.sendTrackEvent(event);
                default:
            }
            return undefined;
        });
    };
    return sendAnalyticsEvent;
};

});

parcelRegister("5iXkq", function(module, exports) {

$parcel$export(module.exports, "useCardDetailsInitialState", () => $fd36b5bdce43621b$export$2e9f932053c78b66);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $dIdda = parcelRequire("dIdda");

var $duOMW = parcelRequire("duOMW");

var $9pP0g = parcelRequire("9pP0g");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $fd36b5bdce43621b$export$428c87746d3e32da = {
    [(0, $9pP0g.ViewSetting).SHOW_EPICS]: 'showEpics',
    [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: 'showStatuses',
    [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: 'showVersions',
    [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: 'showAssignee',
    [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: 'showDaysInColumn',
    [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: 'showEstimate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: 'showIssueKey',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: 'showIssueLinksStats',
    [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: 'showDueDate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: 'showIssueType',
    [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: 'showPriority',
    [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: 'showDevelopment',
    [(0, $9pP0g.ViewSetting).SHOW_LABELS]: 'showLabels',
    [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: 'showCardCovers'
};
const $fd36b5bdce43621b$export$2e9f932053c78b66 = (boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $dIdda.useRouter)();
    const { setViewSettingsCardDetails: setViewSettingsCardDetails } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() || !query) return;
        const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
            boardId: boardId,
            view: view,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        });
        const getInitialCardValue = (stateKey)=>{
            const queryKey = $fd36b5bdce43621b$export$428c87746d3e32da[stateKey];
            return query[queryKey] ? query[queryKey] === (0, $duOMW.QUERY_ENABLED_VALUE) : cardDetailsFromLocalStorage[stateKey];
        };
        const cardDetailsState = {
            [(0, $9pP0g.ViewSetting).SHOW_EPICS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_EPICS),
            [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_STATUSES),
            [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_VERSIONS),
            [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ASSIGNEE),
            [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN),
            [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ESTIMATE),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE),
            [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_PRIORITY),
            [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT),
            [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DUE_DATE),
            [(0, $9pP0g.ViewSetting).SHOW_LABELS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_LABELS),
            [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_CARD_COVERS)
        };
        setViewSettingsCardDetails({
            boardId: boardId,
            view: view,
            cardDetailsState: cardDetailsState
        });
        // remove card view initial settings param
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, Object.values($fd36b5bdce43621b$export$428c87746d3e32da))).toString()
        });
    // we want to run this hook on initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});

parcelRegister("jCs82", function(module, exports) {

$parcel$export(module.exports, "useOnBacklog", () => $39756d5f22d21cd8$export$9c6bcc9d56a57470);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $39756d5f22d21cd8$export$9c6bcc9d56a57470 = (boardId, view, showEpicAsPanel = false, isVersionsEnabled = false)=>{
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const showPanels = (0, $iDGXn.useShowPanels)();
    const { setViewSettingsPanels: setViewSettingsPanels } = (0, $iDGXn.useViewSettingsActions)();
    const { replace: replace } = (0, $dIdda.useRouterActions)();
    // Sync react-sweet-state store with URL or localStorage state on mount.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const panelsFromQuery = (0, $cYeCp.parseSearchQuery)(location.search);
        const panelsFromLocalStorage = (0, $8zmNw.getViewSettingsPanels)({
            boardId: boardId,
            view: view
        });
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are panels from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        let panelState = panelsFromLocalStorage;
        if (Object.values(panelsFromQuery).filter(Boolean).length !== 0) {
            const queryPanelState = {
                EPIC_PANEL: panelsFromQuery.EPIC_PANEL ?? false,
                VERSION_PANEL: panelsFromQuery.VERSION_PANEL ?? false
            };
            panelState = queryPanelState;
        }
        setViewSettingsPanels({
            boardId: boardId,
            view: view,
            panelState: panelState
        });
    // Removed `location.search` from the dependency array since we only want this hook to fire once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        isVersionsEnabled,
        setViewSettingsPanels,
        showEpicAsPanel,
        view
    ]);
    // Sync URL with react-sweet-state store on mount and when react-sweet-state store changes.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const url = (0, $cYeCp.setPanels)(showPanels, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        showPanels,
        replace,
        view
    ]);
};

});

parcelRegister("1wxxD", function(module, exports) {

$parcel$export(module.exports, "useOnIncrementPlanningBoard", () => $c2daf95593322126$export$14539b3beca7ada3);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $dIdda = parcelRequire("dIdda");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $c2daf95593322126$export$14539b3beca7ada3 = (boardId, view, dependencyIssueOptions)=>{
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const { replace: replace } = (0, $dIdda.useRouterActions)();
    const isUnscheduledColumnVisible = (0, $iDGXn.useShowUnscheduledColumn)();
    const isOfftrackDependencyLinesVisible = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const unscheduledColumnFromLocalStorage = (0, $8zmNw.getShowUnscheduledColumn)(boardId);
        const settingsFromQuery = (0, $cYeCp.parseSearchQueryForIPBoard)(location.search);
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are IP board settings from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        const showUnscheduledColumn = settingsFromQuery.SHOW_UNSCHEDULED_COLUMN !== undefined ? settingsFromQuery.SHOW_UNSCHEDULED_COLUMN : unscheduledColumnFromLocalStorage;
        setShowUnscheduledColumn(boardId, showUnscheduledColumn);
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
            const offtrackDependencyLinesFromLocalStorage = (0, $8zmNw.getShowOfftrackDependencyLines)(boardId);
            const issueIdsToShowDependenciesFromLocalStorage = (0, $8zmNw.getIssueIdsToShowDependencies)(boardId);
            const showOfftrackDependencyLines = settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES !== undefined ? settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES : offtrackDependencyLinesFromLocalStorage;
            setShowOfftrackDependencyLines(boardId, showOfftrackDependencyLines);
            const issuesIdsToShowDependencies = settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES && settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length ? settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES : issueIdsToShowDependenciesFromLocalStorage;
            const filteredIssueIds = Array.isArray(issuesIdsToShowDependencies) ? issuesIdsToShowDependencies.filter((issueId)=>dependencyIssueOptions[issueId] !== undefined) : [];
            setIssueIdsToShowDependencies(boardId, filteredIssueIds);
        }
    }, [
        boardId,
        view,
        dependencyIssueOptions,
        location.search,
        setShowUnscheduledColumn,
        setShowOfftrackDependencyLines,
        setIssueIdsToShowDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        let url;
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: isOfftrackDependencyLinesVisible,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
        }, location);
        else url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: false,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
        }, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        view,
        isUnscheduledColumnVisible,
        isOfftrackDependencyLinesVisible,
        issueIdsToShowDependencies,
        location.search,
        replace
    ]);
};

});

parcelRegister("8vQbt", function(module, exports) {

$parcel$export(module.exports, "useSyncFromLocalStorage", () => $9a1dab6fcae5bc71$export$88f2270d613c342b);

var $5uXOq = parcelRequire("5uXOq");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $9a1dab6fcae5bc71$export$88f2270d613c342b = (boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const { setIsFullscreen: setIsFullscreen, setViewSettingsCardDetails: setViewSettingsCardDetails, setViewSettingsQuickFilters: setViewSettingsQuickFilters, setViewSettingsCompactMode: setViewSettingsCompactMode, setViewSettingsCardExtraFields: setViewSettingsCardExtraFields } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        // card details initial state moved to `useCardDetailsInitialState`
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        isDaysInColumnEnabled,
        isDueDateEnabled,
        isLabelsEnabled,
        isEstimateEnabled,
        isPriorityEnabled,
        setIsFullscreen,
        setViewSettingsCardDetails,
        setViewSettingsCompactMode,
        setViewSettingsQuickFilters,
        setViewSettingsCardExtraFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const cardExtraFieldsFromLocalStorage = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        cardExtraFields,
        setViewSettingsCardExtraFields
    ]);
};

});

parcelRegister("3ykoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98a1024295d65c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a98a1024295d65c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelTitle: {
        "id": "software-view-settings.panel-title",
        "defaultMessage": "View settings"
    }
});

});

parcelRegister("38RF4", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSyncFromLocalStorageWrapper", () => $434e13d035e4d1d0$export$8c976c7ba46200ff);
$parcel$export(module.exports, "ViewSettingsButton", () => $434e13d035e4d1d0$export$805802ea39f3d804);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $e8HsV = parcelRequire("e8HsV");

var $5P8N8 = parcelRequire("5P8N8");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $c0SO4 = parcelRequire("c0SO4");


var $MGmIU = parcelRequire("MGmIU");

var $2LJt5 = parcelRequire("2LJt5");

var $R2cA9 = parcelRequire("R2cA9");

var $4R6GH = parcelRequire("4R6GH");

var $02beV = parcelRequire("02beV");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $duOMW = parcelRequire("duOMW");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $8vQbt = parcelRequire("8vQbt");

var $iIMX5 = parcelRequire("iIMX5");
const $434e13d035e4d1d0$export$8c976c7ba46200ff = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields = [], isDaysInColumnEnabled: isDaysInColumnEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isEstimateEnabled: isEstimateEnabled = false, children: children, showEpicAsPanel: showEpicAsPanel = false, isVersionsEnabled: isVersionsEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $434e13d035e4d1d0$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), removeMargins: removeMargins, ShowDI: ShowDI = (0, $c0SO4.Show), isThemedButton: isThemedButton = false, ...restProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isSelected);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(!isOpen);
        onClick(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onClick
    ]);
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(true);
        setTimeout(()=>onClick(true));
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const { setOpenViewSettings: setOpenViewSettings } = (0, $02beV.useNextBestTaskActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isSelected);
    }, [
        isSelected
    ]);
    const iconColor = isSelected ? `var(--ds-icon-selected, ${(0, $5e0c0d4e15efb4a6$exports).B400})` : `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N300})`;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return isThemedButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $R2cA9.ThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e8HsV))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        testId: "software-view-settings.ui.view-settings-button.icon-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e8HsV))),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    });
    if ((0, $4R6GH.fg)('jira-calendar-business-theme')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2LJt5.ResponsiveThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5P8N8))), {
            label: ""
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5P8N8))),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: removeMargins ? undefined : $434e13d035e4d1d0$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ShowDI, {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        testId: "software-view-settings.ui.view-settings-button.large-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonLarge,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e8HsV))), {
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            color: iconColor,
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5P8N8))),
            LEGACY_primaryColor: iconColor
        }),
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, formatMessage((0, $iIMX5.default).buttonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ShowDI, {
        below: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: formatMessage((0, $iIMX5.default).buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        testId: "software-view-settings.ui.view-settings-button.small-button",
        appearance: "default",
        isSelected: isOpen,
        onClick: handleClick,
        spacing: "none",
        ref: onRefButtonSmall,
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $434e13d035e4d1d0$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e8HsV))), {
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        color: iconColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5P8N8))),
        LEGACY_primaryColor: iconColor
    })))))));
};
const $434e13d035e4d1d0$var$iconWrapperStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px'
});
const $434e13d035e4d1d0$var$buttonWrapperStyles = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("e8HsV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78335b71c0abb01e55fd286b4fa17edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4b38767e51dee46$var$_react = $a4b38767e51dee46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a4b38767e51dee46$var$_UNSAFE_baseNew = $a4b38767e51dee46$var$_interopRequireDefault((parcelRequire("huIZN")));
function $a4b38767e51dee46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4b38767e51dee46$var$CustomizeIcon = (props)=>/*#__PURE__*/ $a4b38767e51dee46$var$_react.default.createElement($a4b38767e51dee46$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$a4b38767e51dee46$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $a4b38767e51dee46$var$_default = module.exports.default = $a4b38767e51dee46$var$CustomizeIcon;

});

parcelRegister("5P8N8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43d888fdcb07211b$var$_react = $43d888fdcb07211b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $43d888fdcb07211b$var$_customize = $43d888fdcb07211b$var$_interopRequireDefault((parcelRequire("e8HsV")));
function $43d888fdcb07211b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $43d888fdcb07211b$var$PreferencesIcon = (props)=>/*#__PURE__*/ $43d888fdcb07211b$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $43d888fdcb07211b$var$_customize.default
    }));
$43d888fdcb07211b$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $43d888fdcb07211b$var$_default = module.exports.default = $43d888fdcb07211b$var$PreferencesIcon;

});

parcelRegister("c0SO4", function(module, exports) {

$parcel$export(module.exports, "Show", () => $88ec72672b6cbc12$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $jJ1Sb = parcelRequire("jJ1Sb");

var $bdmUH = parcelRequire("bdmUH");
function $88ec72672b6cbc12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88ec72672b6cbc12$var$showAboveQueries = (0, $bdmUH.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $88ec72672b6cbc12$var$showBelowQueries = (0, $bdmUH.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $88ec72672b6cbc12$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $88ec72672b6cbc12$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $jJ1Sb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $88ec72672b6cbc12$var$defaultHiddenStyles,
            above && $88ec72672b6cbc12$var$showAboveQueries[above],
            below && $88ec72672b6cbc12$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("bdmUH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $f3c940eadc06d22e$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $f3c940eadc06d22e$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eJ6Kt = parcelRequire("eJ6Kt");

var $2MVcM = parcelRequire("2MVcM");
const $f3c940eadc06d22e$export$918f8818cfbbeb2c = (input)=>{
    return (0, $eJ6Kt.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $2MVcM.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $f3c940eadc06d22e$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $eJ6Kt.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $2MVcM.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("eJ6Kt", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $55f765fb65cd45d0$export$2d293d9871c38e91);
const $55f765fb65cd45d0$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $55f765fb65cd45d0$export$2d293d9871c38e91 = Object.keys($55f765fb65cd45d0$export$e5ee4fe8b989fd09);
const $55f765fb65cd45d0$export$b7ed752a57b4177b = $55f765fb65cd45d0$export$2d293d9871c38e91[0];

});



parcelRegister("2LJt5", function(module, exports) {

$parcel$export(module.exports, "ResponsiveThemedButton", () => $02bb146a9ef97065$export$6f42949f4ea1e733);
/* ResponsiveThemedButton.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $h5xtL = parcelRequire("h5xtL");

var $dsFR3 = parcelRequire("dsFR3");

var $c0SO4 = parcelRequire("c0SO4");
var $d4KoR = parcelRequire("d4KoR");

var $MGmIU = parcelRequire("MGmIU");
const $02bb146a9ef97065$export$4161299bcae84c4f = 'responsive-themed-button';
const $02bb146a9ef97065$export$6f42949f4ea1e733 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>{
    const { icon: icon, label: label, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $d4KoR.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02bb146a9ef97065$var$CustomButton, {
        ...restProps,
        as: as,
        ref: !isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $02bb146a9ef97065$export$4161299bcae84c4f}.collapsed`,
        "aria-label": ariaLabel || label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($02bb146a9ef97065$var$CustomButton, {
        ...restProps,
        as: as,
        ref: isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $02bb146a9ef97065$export$4161299bcae84c4f}.expanded`,
        "aria-label": ariaLabel || label
    }, label)));
}));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02bb146a9ef97065$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $h5xtL.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _jeie1c2q _nkzo63lg _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("R2cA9", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $cdc83396530b8aef$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $h5xtL = parcelRequire("h5xtL");
const $cdc83396530b8aef$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cdc83396530b8aef$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cdc83396530b8aef$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $h5xtL.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt31mi8 _1g9hu0za _1umftrgn _6l8rsb7u _9se51pfj _12ra13cp _zk5ur2ew _18vg1w6j _192e1czd _fnp71tko _1xjgkwex _1u0u1y8w _17z21063 _7n831c2q _n2ulgr9p _1cf15clp _1d7c63lg _nwukkwex _fsjdky8x _z1i3tvsq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $dHJL9 = parcelRequire("dHJL9");
var $e0OK7 = parcelRequire("e0OK7");
var $4UoAC = parcelRequire("4UoAC");
var $bxqWy = parcelRequire("bxqWy");

var $dsFR3 = parcelRequire("dsFR3");

var $c0SO4 = parcelRequire("c0SO4");
var $d4KoR = parcelRequire("d4KoR");

var $MGmIU = parcelRequire("MGmIU");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $d4KoR.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $d4KoR.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxqWy.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UoAC.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("4UoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2280edfe0f85b738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kDFVt = parcelRequire("kDFVt");

var $2Tkjt = parcelRequire("2Tkjt");
const $2280edfe0f85b738$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $2Tkjt.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kDFVt.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $2280edfe0f85b738$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($2280edfe0f85b738$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $2280edfe0f85b738$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.memo)($2280edfe0f85b738$var$WithRef);
var $2280edfe0f85b738$export$2e2bcd8739ae039 = $2280edfe0f85b738$var$LinkButton;

});

const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("iIMX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $77495ee3efb7180c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77495ee3efb7180c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.view-settings-button.button-label",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("2ucDS", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsMenu", () => $24ad572d0ea302a2$export$14138a347411ebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $3uPqt = parcelRequire("3uPqt");

var $jlxRF = parcelRequire("jlxRF");

var $140hX = parcelRequire("140hX");

var $1ESRw = parcelRequire("1ESRw");
const $24ad572d0ea302a2$export$14138a347411ebf = ({ boardId: boardId, isClassic: isClassic, view: view, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, epicCustomName: epicCustomName = 'Epic', showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, areSubtasksEnabled: areSubtasksEnabled = false, showWorkSuggestions: showWorkSuggestions = false, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: onUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const handleChange = (actionSubject, attributes)=>{
        sendAnalyticsEvent((0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    const incrementPlanningHandleChange = (actionSubject, attributes, action)=>{
        sendAnalyticsEvent(action ?? (0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    switch(view){
        case (0, $a4XJc.View).BACKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlxRF.BacklogMenu), {
                viewAs: viewAs,
                boardId: boardId,
                onHandleChange: handleChange,
                showCardDetails: showCardDetails,
                isClassic: isClassic,
                isVersionsEnabled: isVersionsEnabled,
                showEpicAsPanel: showEpicAsPanel,
                showFilterBarToggle: showFilterBarToggle,
                epicCustomName: epicCustomName,
                areSubtasksEnabled: areSubtasksEnabled,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isPriorityEnabled: isPriorityEnabled
            });
        case (0, $a4XJc.View).BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isClassic: isClassic,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                showFilterBarToggle: showFilterBarToggle,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                showCardDetails: showCardDetails,
                epicCustomName: epicCustomName,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isDevelopmentEnabled: isDevelopmentEnabled,
                showWorkSuggestions: showWorkSuggestions,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn
            });
        case (0, $a4XJc.View).JSM_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                showFilterBarToggle: showFilterBarToggle,
                showCardDetails: false,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ESRw.IncrementPlanningBoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                dependencyIssueOptions: dependencyIssueOptions,
                onHandleChange: incrementPlanningHandleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onUpdate: onUpdate,
                epicCustomName: epicCustomName
            });
        default:
            return null;
    }
};

});
parcelRegister("jlxRF", function(module, exports) {

$parcel$export(module.exports, "BacklogMenu", () => $61210b60d484d0b3$export$baf646a48a139934);

var $5uXOq = parcelRequire("5uXOq");

var $6PItG = parcelRequire("6PItG");
var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $9EmtZ = parcelRequire("9EmtZ");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");

var $evv5v = parcelRequire("evv5v");

var $lWTHR = parcelRequire("lWTHR");
const $61210b60d484d0b3$export$baf646a48a139934 = ({ viewAs: viewAs, boardId: boardId, isClassic: isClassic, isVersionsEnabled: isVersionsEnabled, showEpicAsPanel: showEpicAsPanel, showFilterBarToggle: showFilterBarToggle = false, epicCustomName: epicCustomName = 'Epic', areSubtasksEnabled: areSubtasksEnabled = false, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, showCardDetails: showCardDetails = true, isEstimateEnabled: isEstimateEnabled = false, onHandleChange: onHandleChange, onSubtasksExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, cardExtraFields: cardExtraFields = [], isDueDateEnabled: isDueDateEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $Hi7fY.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $7df7o.default);
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowStatuses: toggleShowStatuses, toggleShowVersions: toggleShowVersions, setViewSettingsCompactMode: setViewSettingsCompactMode, toggleExtraField: toggleExtraField, toggleShowDueDate: toggleShowDueDate } = actions;
    const hasCardExtraFields = cardExtraFields.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, isVersionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionPanelToggle,
        title: formatMessage((0, $cACY7.default).versionPanel),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).VERSION_PANEL_TOGGLE,
                state: !state.showVersionPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).VERSION_PANEL_SHORTCUT,
        isChecked: state.showVersionPanel,
        viewAs: viewAs
    }), showEpicAsPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicPanelToggle,
        title: formatMessage((0, $cACY7.default).epicPanel, {
            epicName: epicCustomName
        }),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).EPIC_PANEL_TOGGLE,
                state: !state.showEpicPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).ISSUE_PARENT_PANEL_SHORTCUT,
        isChecked: state.showEpicPanel,
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), viewAs === (0, $a4XJc.ViewAs).PANEL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).cardDensity),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).cardLayoutSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EmtZ.ViewSettingsRadioGroup), {
        testId: (0, $duOMW.backlogViewTestIds).cardLayoutRadioGroup,
        onSelect: (value)=>{
            setViewSettingsCompactMode({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                showCompactMode: value === 'compact'
            });
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).CARD_DENSITY,
                state: value
            });
        },
        value: state.showCompactMode ? 'compact' : 'default',
        options: [
            {
                name: 'card-layout',
                value: 'default',
                label: 'Default',
                icon: (0, $lWTHR.CardLayoutDefaultIcon)
            },
            {
                name: 'card-layout',
                value: 'compact',
                label: 'Compact',
                icon: (0, $evv5v.CardLayoutCompactIcon)
            }
        ],
        viewAs: viewAs,
        ariaLabel: formatMessage((0, $cACY7.default).cardDensity)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showCompactModeToggle,
        title: formatMessage((0, $cACY7.default).compactMode),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).COMPACT_MODE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).COMPACT_MODE_TOGGLE,
                state: !state.showCompactMode
            });
        },
        isChecked: state.showCompactMode,
        viewAs: viewAs
    })), areSubtasksEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAllSubtasks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).cardDetailsSection,
        title: viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails),
        hasSeparator: true
    }, (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), isVersionsEnabled && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionsToggle,
        title: formatMessage((0, $cACY7.default).cardDetailVersion),
        onChange: ()=>{
            toggleShowVersions({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_VERSIONS_TOGGLE,
                state: !state.showVersions
            });
        },
        isChecked: state.showVersions,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && isDueDateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showStatusToggle,
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleShowStatuses({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            });
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEstimateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.backlog.show-${field.id}-toggle-backlog`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BACKLOG,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), areSubtasksEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAllSubtasks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles = (0, $jJ1Sb.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("cACY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $32380dcb5ffcf2df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $32380dcb5ffcf2df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.common.button-label",
        "defaultMessage": "View settings"
    },
    panelSection: {
        "id": "software-view-settings.common.panel-section",
        "defaultMessage": "Panels"
    },
    versionPanel: {
        "id": "software-view-settings.common.version-panel",
        "defaultMessage": "Version panel"
    },
    epicPanel: {
        "id": "software-view-settings.common.epic-panel",
        "defaultMessage": "{epicName} panel"
    },
    quickFilters: {
        "id": "software-view-settings.common.quick-filters",
        "defaultMessage": "Quick filters"
    },
    workSuggestions: {
        "id": "software-view-settings.common.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    compactMode: {
        "id": "software-view-settings.common.compact-mode",
        "defaultMessage": "Compact mode"
    },
    cardDetails: {
        "id": "software-view-settings.common.card-details",
        "defaultMessage": "Card details"
    },
    cardFields: {
        "id": "software-view-settings.common.card-fields",
        "defaultMessage": "Fields"
    },
    cardDetailVersion: {
        "id": "software-view-settings.common.card-detail-version",
        "defaultMessage": "Version"
    },
    cardDetailStatus: {
        "id": "software-view-settings.common.card-detail-status",
        "defaultMessage": "Status"
    },
    cardDetailIssueType: {
        "id": "software-view-settings.common.card-detail-issue-type",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKey: {
        "id": "software-view-settings.common.card-detail-issue-key",
        "defaultMessage": "Issue key"
    },
    cardDetailEstimate: {
        "id": "software-view-settings.common.card-detail-estimate",
        "defaultMessage": "Estimate"
    },
    cardDetailPriority: {
        "id": "software-view-settings.common.card-detail-priority",
        "defaultMessage": "Priority"
    },
    cardDetailDevelopment: {
        "id": "software-view-settings.common.card-detail-development",
        "defaultMessage": "Development"
    },
    cardDetailAssignee: {
        "id": "software-view-settings.common.card-detail-assignee",
        "defaultMessage": "Assignee"
    },
    swimlanes: {
        "id": "software-view-settings.common.swimlanes",
        "defaultMessage": "Swimlanes"
    },
    expandAll: {
        "id": "software-view-settings.common.expand-all",
        "defaultMessage": "Expand all"
    },
    collapseAll: {
        "id": "software-view-settings.common.collapse-all",
        "defaultMessage": "Collapse all"
    },
    openIssuesInSidebar: {
        "id": "software-view-settings.common.open-issues-in-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    subtasks: {
        "id": "software-view-settings.common.subtasks",
        "defaultMessage": "Subtasks"
    },
    expandAllSubtasks: {
        "id": "software-view-settings.common.expand-all-subtasks",
        "defaultMessage": "Expand all"
    },
    collapseAllSubtasks: {
        "id": "software-view-settings.common.collapse-all-subtasks",
        "defaultMessage": "Collapse all"
    },
    showUnscheduledWork: {
        "id": "software-view-settings.common.show-unscheduled-work",
        "defaultMessage": "Show unscheduled work"
    },
    cardLayout: {
        "id": "software-view-settings.common.card-layout",
        "defaultMessage": "Card layout"
    },
    cardDensity: {
        "id": "software-view-settings.common.card-density",
        "defaultMessage": "Density"
    },
    daysInColumn: {
        "id": "software-view-settings.common.days-in-column",
        "defaultMessage": "Days in column"
    },
    dueDate: {
        "id": "software-view-settings.common.due-date",
        "defaultMessage": "Due date"
    },
    labels: {
        "id": "software-view-settings.common.labels",
        "defaultMessage": "Labels"
    },
    linkedIssues: {
        "id": "software-view-settings.common.linked-issues",
        "defaultMessage": "Linked issues"
    },
    cardCovers: {
        "id": "software-view-settings.common.card-covers",
        "defaultMessage": "Cover images"
    },
    toggleHint: {
        "id": "software-view-settings.common.toggle-hint",
        "defaultMessage": "Press {key} to open and close {panel}"
    },
    beta: {
        "id": "software-view-settings.common.beta",
        "defaultMessage": "Beta"
    },
    maxDependenciesError: {
        "id": "software-view-settings.common.max-dependencies-error",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    maxDependenciesErrorIssueTermRefresh: {
        "id": "software-view-settings.common.max-dependencies-error-issue-term-refresh",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    cardDetailIssueTypeIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-type-issue-term-refresh",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKeyIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-key-issue-term-refresh",
        "defaultMessage": "Issue key"
    },
    openIssuesInSidebarIssueTermRefresh: {
        "id": "software-view-settings.common.open-issues-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open issues in sidebar"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "software-view-settings.common.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked issues"
    }
});

});

parcelRegister("1wNfX", function(module, exports) {

$parcel$export(module.exports, "PanelGroup", () => $95e55479a51ab212$export$1d05749f6f573bb);

var $5uXOq = parcelRequire("5uXOq");
const $95e55479a51ab212$export$1d05749f6f573bb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("e2hHN", function(module, exports) {

$parcel$export(module.exports, "PanelSection", () => $52c1e5c9c03f984a$export$15906978feb79aa6);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $52c1e5c9c03f984a$export$15906978feb79aa6 = ({ title: title, hasSeparator: hasSeparator, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        paddingBlockEnd: title ? 'space.0' : 'space.050',
        testId: testId
    }, hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($52c1e5c9c03f984a$var$Separator, null), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $52c1e5c9c03f984a$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        as: "strong"
    }, title)), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52c1e5c9c03f984a$var$Separator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dopdki _19pk12x7 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $52c1e5c9c03f984a$var$textStyles = (0, $jJ1Sb.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});

parcelRegister("9EmtZ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsRadioGroup", () => $4233393bcdedbcd3$export$1e1eee2ec7833bf1);

var $5uXOq = parcelRequire("5uXOq");

var $51H8P = parcelRequire("51H8P");

var $gDyTC = parcelRequire("gDyTC");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $p4h3d = parcelRequire("p4h3d");

var $a4XJc = parcelRequire("a4XJc");
const $4233393bcdedbcd3$export$1e1eee2ec7833bf1 = ({ options: options, value: value, onSelect: onSelect, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, ariaLabel: ariaLabel })=>{
    const onChange = (0, $5uXOq.useCallback)((e)=>{
        onSelect(e.target.value);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL ? $4233393bcdedbcd3$var$panelContainerStyles : $4233393bcdedbcd3$var$popupContainerStyles,
        testId: testId,
        role: "radiogroup",
        "aria-label": ariaLabel
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            xcss: $4233393bcdedbcd3$var$radioOptionContainerStyles,
            key: option.value
        }, option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $p4h3d.default), {
            isChecked: option.value === value,
            onChange: onChange,
            name: option.name,
            label: option.label,
            value: option.value
        }), option.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $4233393bcdedbcd3$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
            glyph: option.icon,
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $51H8P.N300)})`
        })))));
};
const $4233393bcdedbcd3$var$popupContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: '0',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$panelContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$radioOptionContainerStyles = (0, $jJ1Sb.xcss)({
    paddingBlock: 'space.075',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4233393bcdedbcd3$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    opacity: 0.3
});

});
parcelRegister("51H8P", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a8e82bcbd673dd1$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a8e82bcbd673dd1$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a8e82bcbd673dd1$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $3a8e82bcbd673dd1$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a8e82bcbd673dd1$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a8e82bcbd673dd1$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $3a8e82bcbd673dd1$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a8e82bcbd673dd1$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a8e82bcbd673dd1$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $3a8e82bcbd673dd1$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a8e82bcbd673dd1$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a8e82bcbd673dd1$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a8e82bcbd673dd1$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a8e82bcbd673dd1$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a8e82bcbd673dd1$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a8e82bcbd673dd1$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a8e82bcbd673dd1$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a8e82bcbd673dd1$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a8e82bcbd673dd1$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a8e82bcbd673dd1$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a8e82bcbd673dd1$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a8e82bcbd673dd1$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a8e82bcbd673dd1$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a8e82bcbd673dd1$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a8e82bcbd673dd1$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a8e82bcbd673dd1$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a8e82bcbd673dd1$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a8e82bcbd673dd1$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a8e82bcbd673dd1$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a8e82bcbd673dd1$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a8e82bcbd673dd1$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a8e82bcbd673dd1$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a8e82bcbd673dd1$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a8e82bcbd673dd1$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a8e82bcbd673dd1$export$9665a07d9187b414);

var $3nnJa = parcelRequire("3nnJa");
const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
        else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
    if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("3nnJa", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("p4h3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $489184c7d940aa7c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");

const $489184c7d940aa7c$var$packageName = "platform-pkg";
const $489184c7d940aa7c$var$packageVersion = "0.0.0-use.local";
const $489184c7d940aa7c$var$noop = (0, $ePBXU.default);
const $489184c7d940aa7c$var$labelPaddingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $489184c7d940aa7c$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $489184c7d940aa7c$var$radioStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`
    }
});
const $489184c7d940aa7c$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $489184c7d940aa7c$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $489184c7d940aa7c$var$packageName,
        packageVersion: $489184c7d940aa7c$var$packageVersion
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $489184c7d940aa7c$var$labelStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $489184c7d940aa7c$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $489184c7d940aa7c$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $489184c7d940aa7c$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($489184c7d940aa7c$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $489184c7d940aa7c$export$2e2bcd8739ae039 = $489184c7d940aa7c$var$Radio;

});


parcelRegister("htuq0", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsToggle", () => $5bf54757b2a57348$export$aacc18ae911f8e05);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $as51G = parcelRequire("as51G");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cACY7 = parcelRequire("cACY7");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $5bf54757b2a57348$export$aacc18ae911f8e05 = ({ title: title, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, keyboardShortcut: keyboardShortcut, subtitleLozenge: subtitleLozenge, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, footer: footer })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const descriptionId = `${id}-description`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $5bf54757b2a57348$var$panelContainerStyles : $5bf54757b2a57348$var$popupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.200",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        "data-testid": testId,
        htmlFor: id
    }, title), subtitleLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        appearance: "new"
    }, subtitleLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5bf54757b2a57348$var$tooltipContainerStyles
    }, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), null, keyboardShortcut), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as51G.default), {
        id: id,
        isChecked: isChecked,
        onChange: onChange,
        isDisabled: isDisabled,
        ...keyboardShortcut && {
            descriptionId: descriptionId
        }
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: descriptionId
    }, formatMessage((0, $cACY7.default).toggleHint, {
        key: keyboardShortcut,
        panel: title
    })))), (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && footer);
};
const $5bf54757b2a57348$var$popupContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: 'space.100',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$panelContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$tooltipContainerStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    lineHeight: 0
});

});
parcelRegister("as51G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3eb7951d2da3761$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $ePBXU = parcelRequire("ePBXU");

var $3QrEQ = parcelRequire("3QrEQ");

var $gEL7H = parcelRequire("gEL7H");

var $8pcok = parcelRequire("8pcok");

var $7BQ2p = parcelRequire("7BQ2p");

var $7DrcK = parcelRequire("7DrcK");
const $c3eb7951d2da3761$var$noop = (0, $ePBXU.default);
const $c3eb7951d2da3761$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $c3eb7951d2da3761$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $c3eb7951d2da3761$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $c3eb7951d2da3761$var$noop, onChange: providedChange = $c3eb7951d2da3761$var$noop, onFocus: providedFocus = $c3eb7951d2da3761$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const handleBlur = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$c3eb7951d2da3761$var$analyticsAttributes
    });
    const handleFocus = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$c3eb7951d2da3761$var$analyticsAttributes
    });
    const handleChange = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$c3eb7951d2da3761$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, $7DrcK.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $c3eb7951d2da3761$var$iconSizeMap[size];
    const labelId = (0, $3QrEQ.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7BQ2p.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEL7H))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7BQ2p.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8pcok))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$c3eb7951d2da3761$var$Toggle.displayName = 'Toggle';
var $c3eb7951d2da3761$export$2e2bcd8739ae039 = $c3eb7951d2da3761$var$Toggle;

});
parcelRegister("gEL7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c204ef7244779fb8$var$_react = $c204ef7244779fb8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c204ef7244779fb8$var$_checkMark = $c204ef7244779fb8$var$_interopRequireDefault((parcelRequire("5m6aI")));

var $c204ef7244779fb8$var$_done = $c204ef7244779fb8$var$_interopRequireDefault((parcelRequire("hgWRI")));
function $c204ef7244779fb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c204ef7244779fb8$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c204ef7244779fb8$var$_react.default.createElement($c204ef7244779fb8$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c204ef7244779fb8$var$_done.default
    }, props));
$c204ef7244779fb8$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c204ef7244779fb8$var$_default = module.exports.default = $c204ef7244779fb8$var$CheckMarkIcon;

});
parcelRegister("5m6aI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e63cb702ee08405$var$_react = $3e63cb702ee08405$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3e63cb702ee08405$var$_UNSAFE_baseNew = $3e63cb702ee08405$var$_interopRequireDefault((parcelRequire("huIZN")));
function $3e63cb702ee08405$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e63cb702ee08405$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $3e63cb702ee08405$var$_react.default.createElement($3e63cb702ee08405$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$3e63cb702ee08405$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $3e63cb702ee08405$var$_default = module.exports.default = $3e63cb702ee08405$var$CheckMarkIcon;

});

parcelRegister("hgWRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93197b8020ff9a3$var$_react = $c93197b8020ff9a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $c93197b8020ff9a3$var$_checkMark = $c93197b8020ff9a3$var$_interopRequireDefault((parcelRequire("f7Vgg")));
function $c93197b8020ff9a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93197b8020ff9a3$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $c93197b8020ff9a3$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $c93197b8020ff9a3$var$_checkMark.default
    }));
$c93197b8020ff9a3$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $c93197b8020ff9a3$var$_default = module.exports.default = $c93197b8020ff9a3$var$EditorDoneIcon;

});
parcelRegister("f7Vgg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b033ed580f634312$var$_react = $b033ed580f634312$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b033ed580f634312$var$_UNSAFE_baseNew = $b033ed580f634312$var$_interopRequireDefault((parcelRequire("huIZN")));
function $b033ed580f634312$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b033ed580f634312$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $b033ed580f634312$var$_react.default.createElement($b033ed580f634312$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$b033ed580f634312$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $b033ed580f634312$var$_default = module.exports.default = $b033ed580f634312$var$CheckMarkIcon;

});



parcelRegister("8pcok", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61ea4536057ce79d$var$_react = $61ea4536057ce79d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61ea4536057ce79d$var$_cross = $61ea4536057ce79d$var$_interopRequireDefault((parcelRequire("8zEy7")));

var $61ea4536057ce79d$var$_close = $61ea4536057ce79d$var$_interopRequireDefault((parcelRequire("cbTaZ")));
function $61ea4536057ce79d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61ea4536057ce79d$var$CrossIcon = (props)=>/*#__PURE__*/ $61ea4536057ce79d$var$_react.default.createElement($61ea4536057ce79d$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $61ea4536057ce79d$var$_close.default
    }, props));
$61ea4536057ce79d$var$CrossIcon.Name = 'CrossIconMigration';
var $61ea4536057ce79d$var$_default = module.exports.default = $61ea4536057ce79d$var$CrossIcon;

});
parcelRegister("8zEy7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $63e10bd7abfd6fa8$var$_react = $63e10bd7abfd6fa8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $63e10bd7abfd6fa8$var$_UNSAFE_baseNew = $63e10bd7abfd6fa8$var$_interopRequireDefault((parcelRequire("huIZN")));
function $63e10bd7abfd6fa8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $63e10bd7abfd6fa8$var$CrossIcon = (props)=>/*#__PURE__*/ $63e10bd7abfd6fa8$var$_react.default.createElement($63e10bd7abfd6fa8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$63e10bd7abfd6fa8$var$CrossIcon.displayName = 'CrossIcon';
var $63e10bd7abfd6fa8$var$_default = module.exports.default = $63e10bd7abfd6fa8$var$CrossIcon;

});

parcelRegister("cbTaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e014ff321002913$var$_react = $8e014ff321002913$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $8e014ff321002913$var$_close = $8e014ff321002913$var$_interopRequireDefault((parcelRequire("3nMUH")));
function $8e014ff321002913$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8e014ff321002913$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $8e014ff321002913$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $8e014ff321002913$var$_close.default
    }));
$8e014ff321002913$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $8e014ff321002913$var$_default = module.exports.default = $8e014ff321002913$var$EditorCloseIcon;

});


parcelRegister("7BQ2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $935a7b69246d3e96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $294ns = parcelRequire("294ns");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $935a7b69246d3e96$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $935a7b69246d3e96$var$iconContainerRegularStyles = (0, $jJ1Sb.xcss)({
    width: '16px',
    height: '16px'
});
const $935a7b69246d3e96$var$iconContainerLargeStyles = (0, $jJ1Sb.xcss)({
    width: '20px',
    height: '20px'
});
const $935a7b69246d3e96$var$hiddenStyles = (0, $jJ1Sb.xcss)({
    opacity: 0
});
const $935a7b69246d3e96$var$leftStyles = (0, $jJ1Sb.xcss)({
    insetInlineStart: '3px'
});
const $935a7b69246d3e96$var$rightStyles = (0, $jJ1Sb.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $935a7b69246d3e96$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "span",
        xcss: [
            $935a7b69246d3e96$var$iconContainerStyles,
            isHidden && (0, $294ns.fg)('platform-visual-refresh-icons') && $935a7b69246d3e96$var$hiddenStyles,
            size === 'regular' && $935a7b69246d3e96$var$iconContainerRegularStyles,
            size === 'large' && $935a7b69246d3e96$var$iconContainerLargeStyles,
            position === 'left' && $935a7b69246d3e96$var$leftStyles,
            position === 'right' && $935a7b69246d3e96$var$rightStyles
        ]
    }, children);
};
var $935a7b69246d3e96$export$2e2bcd8739ae039 = $935a7b69246d3e96$var$IconContainer;

});

parcelRegister("7DrcK", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $7b468cc38c9f0490$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $294ns = parcelRequire("294ns");

var $dtXUS = parcelRequire("dtXUS");

var $1G2Jo = parcelRequire("1G2Jo");
const $7b468cc38c9f0490$var$globalGridSize = (0, $dtXUS.gridSize)();
const $7b468cc38c9f0490$var$dimensions = {
    regular: {
        height: $7b468cc38c9f0490$var$globalGridSize * 2,
        width: $7b468cc38c9f0490$var$globalGridSize * 4
    },
    large: {
        height: $7b468cc38c9f0490$var$globalGridSize * 2 + $7b468cc38c9f0490$var$globalGridSize / 2,
        width: $7b468cc38c9f0490$var$globalGridSize * 5
    }
};
const $7b468cc38c9f0490$var$getHeight = ({ size: size })=>$7b468cc38c9f0490$var$dimensions[size].height;
const $7b468cc38c9f0490$var$getWidth = ({ size: size })=>$7b468cc38c9f0490$var$dimensions[size].width;
const $7b468cc38c9f0490$var$borderWidth = 2;
const $7b468cc38c9f0490$var$paddingUnitless = $7b468cc38c9f0490$var$globalGridSize / 4;
const $7b468cc38c9f0490$var$transition = 'transform 0.2s ease';
const $7b468cc38c9f0490$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $1G2Jo.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $f8Sb3.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $7b468cc38c9f0490$var$borderWidth,
        margin: $7b468cc38c9f0490$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$7b468cc38c9f0490$var$getHeight({
            size: size
        })}px`,
        border: `${$7b468cc38c9f0490$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$7b468cc38c9f0490$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$7b468cc38c9f0490$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$7b468cc38c9f0490$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$7b468cc38c9f0490$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $7b468cc38c9f0490$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $7b468cc38c9f0490$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$7b468cc38c9f0490$var$getHeight({
                size: size
            }) - $7b468cc38c9f0490$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$7b468cc38c9f0490$var$getHeight({
                size: size
            }) - $7b468cc38c9f0490$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $7b468cc38c9f0490$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$7b468cc38c9f0490$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $294ns.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("1G2Jo", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $678f58bf97e6b278$export$6cee60e8aa85e528);

const $678f58bf97e6b278$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`
};
const $678f58bf97e6b278$export$6cee60e8aa85e528 = ()=>$678f58bf97e6b278$var$colorMap;

});



parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("evv5v", function(module, exports) {

$parcel$export(module.exports, "CardLayoutCompactIcon", () => $ca4072fbbcba385a$export$73c305db8d999c47);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $ca4072fbbcba385a$export$73c305db8d999c47 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "28",
        viewBox: "0 0 58 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V9.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57 10V18H59V10H57ZM1 18V10H-1V18H1Z",
        fill: "currentColor",
        mask: "url(#path-2-inside-1_1311_59)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 18.5H57.5V26C57.5 26.8284 56.8284 27.5 56 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V18.5Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "3",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "12",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "21",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "4",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "13",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "22",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("lWTHR", function(module, exports) {

$parcel$export(module.exports, "CardLayoutDefaultIcon", () => $f330d0d9ada9ffbb$export$b1c73e945668f4c2);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $f330d0d9ada9ffbb$export$b1c73e945668f4c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "27",
        viewBox: "0 0 58 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 14H58H0ZM59 25C59 26.6569 57.6569 28 56 28H2C0.343146 28 -1 26.6569 -1 25H1C1 25.5523 1.44772 26 2 26H56C56.5523 26 57 25.5523 57 25H59ZM2 28C0.343146 28 -1 26.6569 -1 25V14H1V25C1 25.5523 1.44772 26 2 26V28ZM59 14V25C59 26.6569 57.6569 28 56 28V26C56.5523 26 57 25.5523 57 25V14H59Z",
        fill: "currentColor",
        mask: "url(#path-1-inside-1_1311_46)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V13.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "5",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "18",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "6",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "19",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});


parcelRegister("140hX", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $0229f37a37892c4a$export$17445232de9c085a);

var $5uXOq = parcelRequire("5uXOq");

var $6PItG = parcelRequire("6PItG");
var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $47htk = parcelRequire("47htk");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $1WqFo = parcelRequire("1WqFo");

var $6s1PB = parcelRequire("6s1PB");

var $axmY8 = parcelRequire("axmY8");

var $2DjOQ = parcelRequire("2DjOQ");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");
const $0229f37a37892c4a$export$17445232de9c085a = ({ viewAs: viewAs, boardId: boardId, showFilterBarToggle: showFilterBarToggle = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, isSwimlanesEnabled: isSwimlanesEnabled = false, showCardDetails: showCardDetails = true, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isClassic: isClassic = false, isDaysInColumnEnabled: isDaysInColumnEnabled = false, isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, cardExtraFields: cardExtraFields = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { view: view } = state;
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowLinkedIssuesStats: toggleShowLinkedIssuesStats, toggleShowDaysInColumn: toggleShowDaysInColumn, toggleShowDueDate: toggleShowDueDate, toggleExtraField: toggleExtraField, toggleShowLabels: toggleShowLabels } = actions;
    const viewMode = (0, $2gCtH.useViewMode)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $Hi7fY.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $7df7o.default);
    const handleBoardViewModeClick = ()=>{
        if (viewMode === 'SIDEBAR') setDetailViewAsModal();
        else setDetailViewAsSidebar();
    };
    const hasCardExtraFields = cardExtraFields.length > 0;
    const handleLinkedIssuesStatsToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showIssueLinksStatsState = state.showIssueLinksStats;
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !showIssueLinksStatsState
        });
        // start fetching issue links stats if the user turned on toggle
        if (!showIssueLinksStatsState) onLinkedIssuesStatsToggledOn();
    }, [
        boardId,
        onHandleChange,
        onLinkedIssuesStatsToggledOn,
        state.showIssueLinksStats,
        toggleShowLinkedIssuesStats
    ]);
    const handleShowCardCoversToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showCardCoversState = state.showCardCovers;
        toggleViewSetting({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_CARD_COVERS,
            state: !state.showCardCovers
        });
        // start fetching card cover data if the user turned on toggle
        if (!showCardCoversState) onShowCardCoversToggledOn();
    }, [
        boardId,
        onHandleChange,
        onShowCardCoversToggledOn,
        state.showCardCovers,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
        "data-testId": (0, $duOMW.boardViewTestIds).viewSettingsBoardMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).openIssuesInSidebarToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).openIssuesInSidebarIssueTermRefresh : (0, $cACY7.default).openIssuesInSidebar),
        onChange: ()=>{
            handleBoardViewModeClick();
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).OPEN_ISSUES_IN_SIDEBAR_TOGGLE,
                state: viewMode === 'SIDEBAR' ? (0, $a4XJc.ViewLocation).MODAL : (0, $a4XJc.ViewLocation).SIDEBAR
            });
        },
        isChecked: viewMode === 'SIDEBAR',
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), !(0, $1WqFo.isFedRamp)() && showWorkSuggestions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DjOQ.ViewSettingsTogglePulse), {
        isPanelView: viewAs === (0, $a4XJc.ViewAs).PANEL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showWorkSuggestionsToggle,
        title: formatMessage((0, $cACY7.default).workSuggestions),
        onChange: (_, analyticsEvent)=>{
            onToggleWorkSuggestions(analyticsEvent);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).WORK_SUGGESTIONS_TOGGLE,
                state: !isWorkSuggestionsEnabled
            });
        },
        isChecked: isWorkSuggestionsEnabled,
        viewAs: viewAs
    })))), isSwimlanesEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).cardDetailsSection,
        title: viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails),
        hasSeparator: true
    }, view === (0, $a4XJc.View).BOARD && isClassic && (0, $6s1PB.expVal)('jsw_cmp_card_cover_images_experiment', 'isCardCoverFeatureEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showCardCoversToggle,
        title: formatMessage((0, $cACY7.default).cardCovers),
        onChange: handleShowCardCoversToggleChange,
        isChecked: state.showCardCovers,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), isDueDateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), isLabelsEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLabelsToggle,
        title: formatMessage((0, $cACY7.default).labels),
        onChange: ()=>{
            toggleShowLabels({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_LABELS,
                state: !state.showLabels
            });
        },
        isChecked: state.showLabels,
        viewAs: viewAs
    }), isEstimateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isDaysInColumnEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDaysInColumnToggle,
        title: formatMessage((0, $cACY7.default).daysInColumn),
        onChange: ()=>{
            toggleShowDaysInColumn({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DAYS_IN_COLUMN,
                state: !state.showDaysInColumn
            });
        },
        isChecked: state.showDaysInColumn,
        viewAs: viewAs
    }), showLinkedIssueStatsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLinkedIssueStatsToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).linkedIssuesIssueTermRefresh : (0, $cACY7.default).linkedIssues),
        onChange: handleLinkedIssuesStatsToggleChange,
        isChecked: state.showIssueLinksStats,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDevelopmentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDevelopmentToggle,
        title: formatMessage((0, $cACY7.default).cardDetailDevelopment),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DEVELOPMENT,
                state: !state.showDevelopment
            });
        },
        isChecked: state.showDevelopment,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }))), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.board.show-${field.id}-toggle-board`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BOARD,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), isSwimlanesEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAll)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME)
    }, children);
const $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles = (0, $jJ1Sb.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("axmY8", function(module, exports) {

$parcel$export(module.exports, "NBT_TASK_TYPES", () => $1c70475fc99a2c16$export$c57a079f40d2a99d);
$parcel$export(module.exports, "WORK_SUGGESTIONS_TASK_TYPES", () => $1c70475fc99a2c16$export$3fee72c065a0af0e);
$parcel$export(module.exports, "ITEMS_PER_BATCH", () => $1c70475fc99a2c16$export$9e952e4d801fa8ed);
$parcel$export(module.exports, "NEXT_BEST_TASK_ANALYTICS", () => $1c70475fc99a2c16$export$55230ca85072e545);
$parcel$export(module.exports, "ERROR_BOUNDARY_PACKAGE", () => $1c70475fc99a2c16$export$e6c43e0cbc9a213a);
$parcel$export(module.exports, "PANEL_WIDTH", () => $1c70475fc99a2c16$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PANEL_WIDTH_WITH_MARGIN", () => $1c70475fc99a2c16$export$8603bff3dda8aaad);
$parcel$export(module.exports, "PANEL_HEADER_HEIGHT", () => $1c70475fc99a2c16$export$c33dba4345ee2db8);
$parcel$export(module.exports, "ANIMATION_TIMEOUT", () => $1c70475fc99a2c16$export$fdd30d204cbe80e6);
$parcel$export(module.exports, "ARTICLE_ID", () => $1c70475fc99a2c16$export$7147685613ef9998);
$parcel$export(module.exports, "DEV_DETAILS_DIALOG_SCOPE_ID", () => $1c70475fc99a2c16$export$6bc465585d114926);
$parcel$export(module.exports, "DEV_DETAILS_DEPLOYMENT_PANEL_TYPE", () => $1c70475fc99a2c16$export$5653d49c1e9688e9);
$parcel$export(module.exports, "DEV_DETAILS_BUILD_PANEL_TYPE", () => $1c70475fc99a2c16$export$43925e5456315f);
$parcel$export(module.exports, "NEXT_BEST_TASK_USER_PROPERTIES_SCOPE", () => $1c70475fc99a2c16$export$ec5e18bceb05348c);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME", () => $1c70475fc99a2c16$export$a038bf8f85264e8b);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME", () => $1c70475fc99a2c16$export$3a12d4773adf4b46);
$parcel$export(module.exports, "GITHUB_ONBOARDING_LOCAL_STORAGE_FINISHED_NAMESPACE", () => $1c70475fc99a2c16$export$a95989662296427);
$parcel$export(module.exports, "GITHUB_ONBOARDING_FINISHED_LOCAL_STORAGE_TTL_IN_MS", () => $1c70475fc99a2c16$export$4a742eb709905e27);
$parcel$export(module.exports, "WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID", () => $1c70475fc99a2c16$export$7d212d7793dfc186);


const $1c70475fc99a2c16$export$8b57ff3b8c315540 = {
    PULL_REQUEST_REVIEW: 'PR_REVIEW',
    PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
    FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
    FAILED_BUILD: 'BUILD_FAILED',
    CRIT_VULN: 'CRIT_VULN',
    BLOCKING_ISSUE: 'BLOCKING_ISSUE',
    PR_DRAFT: 'PR_DRAFT',
    PR_STALE: 'PR_STALE',
    PR_MERGEABLE: 'PR_MERGEABLE',
    PR_COMMENTS: 'PR_COMMENTS'
};
const $1c70475fc99a2c16$export$c57a079f40d2a99d = {
    InsightsBuildTask: 'BUILD_FAILED',
    InsightsDeploymentTask: 'DEPLOYMENT_FAILED',
    InsightsPullRequestReviewTask: 'PR_REVIEW',
    InsightsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    InsightsCriticalVulnerabilityTask: 'CRIT_VULN',
    InsightsBlockingIssueTask: 'BLOCKING_ISSUE'
};
const $1c70475fc99a2c16$export$3fee72c065a0af0e = {
    WorkSuggestionsBuildTask: 'BUILD_FAILED',
    WorkSuggestionsDeploymentTask: 'DEPLOYMENT_FAILED',
    WorkSuggestionsPullRequestReviewTask: 'PR_REVIEW',
    WorkSuggestionsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    WorkSuggestionsCriticalVulnerabilityTask: 'CRIT_VULN',
    WorkSuggestionsBlockingIssueTask: 'BLOCKING_ISSUE',
    WorkSuggestionsPullRequestDraftTask: 'PR_DRAFT',
    WorkSuggestionsPullRequestInactiveTask: 'PR_STALE',
    WorkSuggestionsPRMergeableTask: 'PR_MERGEABLE',
    WorkSuggestionsPRCommentsTask: 'PR_COMMENTS'
};
const $1c70475fc99a2c16$export$206ba94a466bfde8 = {
    REPO: 'repo',
    APPROVALS: 'approvals',
    COMMENT: 'comment',
    ISSUEKEY: 'issuekey',
    ENVIRONMENT: 'environment',
    UPDATED: 'updated',
    SECURITY_CONTAINER_NAME: 'securityContainerName',
    STATUS: 'status',
    TITLE: 'title',
    INTRODUCED_DATE: 'introducedDate'
};
const $1c70475fc99a2c16$export$b8b9d90f9e5bd72b = 'jiraInsightsNextBestTask';
const $1c70475fc99a2c16$export$9e952e4d801fa8ed = 3;
const $1c70475fc99a2c16$export$b3f5ac625a3b4df0 = 'nextBestTask';
const $1c70475fc99a2c16$export$55230ca85072e545 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${$1c70475fc99a2c16$export$b3f5ac625a3b4df0}`;
const $1c70475fc99a2c16$export$a03b7ee31a7850cc = {
    ACTION_SUBJECT: `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}`,
    ACTION_SUBJECT_ID: `${$1c70475fc99a2c16$export$b3f5ac625a3b4df0}`
};
const $1c70475fc99a2c16$export$8dfcc2329f051083 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.next-best-task`;
const $1c70475fc99a2c16$export$e6c43e0cbc9a213a = $1c70475fc99a2c16$export$8dfcc2329f051083;
const $1c70475fc99a2c16$export$e05cfff20e9274e6 = 272;
const $1c70475fc99a2c16$export$91fd62fa237e57ae = 450;
const $1c70475fc99a2c16$export$8603bff3dda8aaad = $1c70475fc99a2c16$export$e05cfff20e9274e6 + 2;
const $1c70475fc99a2c16$export$ea74a331a4211d3f = 49; // extra 1px for top border
const $1c70475fc99a2c16$export$c33dba4345ee2db8 = $1c70475fc99a2c16$export$ea74a331a4211d3f;
const $1c70475fc99a2c16$export$fdd30d204cbe80e6 = 600;
const $1c70475fc99a2c16$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $1c70475fc99a2c16$export$6bc465585d114926 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$5653d49c1e9688e9 = (0, $61a2cd6236d50c20$export$90cac6260ae9ced5);
const $1c70475fc99a2c16$export$43925e5456315f = (0, $61a2cd6236d50c20$export$74a388a09f2a004e);
const $1c70475fc99a2c16$export$677d2c355966ef8d = 'jira.insights.next-best-task.last-opened-task-ids';
const $1c70475fc99a2c16$export$ec5e18bceb05348c = 'jira.insights.next-best-task.user-properties';
const $1c70475fc99a2c16$export$8217db641c4c0a89 = 86400000;
const $1c70475fc99a2c16$export$6610ba860f2307cd = 14 * $1c70475fc99a2c16$export$8217db641c4c0a89;
const $1c70475fc99a2c16$export$b504dbc209245786 = 180 * $1c70475fc99a2c16$export$8217db641c4c0a89;
const $1c70475fc99a2c16$export$75cf347d8d9fe592 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$b94951a11282ae6a = 'work-suggestions-github-onboarding-hidden';
const $1c70475fc99a2c16$export$a038bf8f85264e8b = 'workSuggestionsViewSettingsSpotlightPanel';
const $1c70475fc99a2c16$export$3a12d4773adf4b46 = 'workSuggestionsViewSettingsSpotlightViewSettings';
const $1c70475fc99a2c16$export$a95989662296427 = 'work-suggestions-github-onboarding-finished';
const $1c70475fc99a2c16$export$4a742eb709905e27 = 259200000; // 3 days
const $1c70475fc99a2c16$export$7d212d7793dfc186 = 'jira-work-suggestions-spotlight';

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';
const $61a2cd6236d50c20$export$74189cec821240a6 = 'development.details.remote-links';

const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("2DjOQ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsTogglePulse", () => $1beb4c3f15b5459d$export$1cb4eacfdb188bc8);

var $5uXOq = parcelRequire("5uXOq");

var $4dc4s = parcelRequire("4dc4s");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $02beV = parcelRequire("02beV");
const $1beb4c3f15b5459d$var$PULSE_DURATION = 7950;
const $1beb4c3f15b5459d$export$1cb4eacfdb188bc8 = ({ children: children, isPanelView: isPanelView })=>{
    const [{ viewSettingsTogglePulses: viewSettingsTogglePulses }, { setViewSettingsTogglePulses: setViewSettingsTogglePulses }] = (0, $02beV.useNextBestTaskContainer)();
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setViewSettingsTogglePulses(false);
        }, $1beb4c3f15b5459d$var$PULSE_DURATION);
        return ()=>{
            clearTimeout(timeoutId);
            setViewSettingsTogglePulses(false);
        };
    }, [
        setViewSettingsTogglePulses
    ]);
    if (!viewSettingsTogglePulses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return isPanelView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dc4s.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dc4s.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, children)));
};
const $1beb4c3f15b5459d$var$negativePadding = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $1beb4c3f15b5459d$var$positivePadding = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});


parcelRegister("1ESRw", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningBoardMenu", () => $6f58092168c61151$export$9a207652c43c8852);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $e0OK7 = parcelRequire("e0OK7");

var $5eN06 = parcelRequire("5eN06");

var $hixTL = parcelRequire("hixTL");

var $29ctK = parcelRequire("29ctK");

var $6PItG = parcelRequire("6PItG");
var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $4jAPy = parcelRequire("4jAPy");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $kfO2I = parcelRequire("kfO2I");

var $htuq0 = parcelRequire("htuq0");

var $iDGXn = parcelRequire("iDGXn");

var $bkrRB = parcelRequire("bkrRB");
const $6f58092168c61151$var$MAX_OPTIONS_LENGTH = 20;
const $6f58092168c61151$var$InfoIconWithTooltip = ({ tooltipContent: tooltipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6f58092168c61151$var$infoIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5eN06))),
        label: tooltipContent,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact"
    }));
const $6f58092168c61151$var$MAX_SELECTED_ISSUES = 10;
const $6f58092168c61151$export$9a207652c43c8852 = ({ viewAs: viewAs, boardId: boardId, isSwimlanesEnabled: isSwimlanesEnabled = false, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: // eslint-disable-next-line @typescript-eslint/no-empty-function
onUpdate = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const rightPanelState = (0, $hsmeR.useActiveRightSidebarState)();
    const issueOptions = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) return Object.values(dependencyIssueOptions).map((issue)=>({
                value: issue.id,
                label: `${issue.key} ${issue.summary}`,
                iconUrl: issue.typeUrl
            }));
        return [];
    }, [
        dependencyIssueOptions
    ]);
    const [slicedOptions, setSlicedOptions] = (0, $5uXOq.useState)(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightPanelState?.panelId) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) onUpdate();
    }, [
        rightPanelState?.panelId,
        onUpdate
    ]);
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies, toggleViewSetting: toggleViewSetting } = actions;
    const onFormatOptionLabel = (option, formatOptionLabelMeta)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
            space: "space.050",
            alignBlock: "start"
        }, option.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: formatOptionLabelMeta.context === 'menu' ? $6f58092168c61151$var$menuIconStyles : $6f58092168c61151$var$valueIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hixTL.default), {
            src: option.iconUrl,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, option.label));
    };
    const selectedIssueOptions = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(state.issueIdsToShowDependencies) && (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) {
            const tempDefaultIssueOptions = [];
            state.issueIdsToShowDependencies.forEach((issueId)=>{
                const issue = dependencyIssueOptions[issueId];
                if (issue) tempDefaultIssueOptions.push({
                    value: issue.id,
                    label: `${issue.key} ${issue.summary}`,
                    iconUrl: issue.typeUrl
                });
            });
            return tempDefaultIssueOptions;
        }
        return [];
    }, [
        state.issueIdsToShowDependencies,
        dependencyIssueOptions
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            if (newValue.trim().length === 0) setSlicedOptions(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            else {
                const filteredInOptions = issueOptions.filter((o)=>(o?.label || '').includes(newValue));
                setSlicedOptions(filteredInOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            }
        }
    }, [
        issueOptions,
        setSlicedOptions
    ]);
    const getViewSettingsValidationMessage = ()=>{
        if (state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).maxDependenciesErrorIssueTermRefresh : (0, $cACY7.default).maxDependenciesError, {
            maxDeps: $6f58092168c61151$var$MAX_SELECTED_ISSUES
        });
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7df7o.default), {
        "data-testId": "software-view-settings.ui.view-settings-menu.menu-increment-planning-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle",
        title: formatMessage((0, $cACY7.default).showUnscheduledWork),
        onChange: ()=>{
            setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).UNSCHEDULED_COLUMN_TOGGLE,
                state: !state.showUnscheduledColumn
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showUnscheduledColumn,
        viewAs: viewAs
    })), isSwimlanesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all",
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all",
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        title: formatMessage((0, $cACY7.default).cardFields),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-type-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-issue-key-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-epics-toggle",
        title: epicCustomName,
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_EPICS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-estimate-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    })), (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        title: formatMessage((0, $bkrRB.default).dependencyLinesSection),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.offtrack-dependencies-toggle",
        title: formatMessage((0, $bkrRB.default).showOfftrackDependencyLines),
        onChange: ()=>{
            setShowOfftrackDependencyLines(boardId, !state.showOfftrackDependencyLines);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).SHOW_OFFTRACK_DEPENDENCY_LINES,
                state: !state.showOfftrackDependencyLines
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showOfftrackDependencyLines,
        viewAs: viewAs,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            articleId: (0, $4jAPy.IPH_IDS).OFFTRACK_DEPENDENCIES,
            appearance: "link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29ctK.default), {
                href: (0, $4jAPy.DOC_LINKS).OFFTRACK_DEPENDENCIES,
                target: "_blank"
            }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
            color: "color.text.accent.blue"
        }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6f58092168c61151$var$selectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfO2I.ViewSettingsSelect), {
        title: formatMessage((0, $bkrRB.default).showDependenciesOnIssues),
        titleIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f58092168c61151$var$InfoIconWithTooltip, {
            tooltipContent: formatMessage((0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltip)
        }),
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.dependency-lines-select",
        isMulti: true,
        isSearchable: true,
        options: slicedOptions,
        formatOptionLabel: onFormatOptionLabel,
        viewAs: viewAs,
        ...(0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? {
            value: selectedIssueOptions
        } : {
            defaultValue: selectedIssueOptions
        },
        placeholder: formatMessage((0, $bkrRB.default).chooseIssue),
        isInvalid: state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES,
        validationErrorMessage: getViewSettingsValidationMessage(),
        menuIsOpen: // undefined is default value for menuIsOpen prop where it's controlled by the click. Setting it to false will prevent the menu from opening
        state.issueIdsToShowDependencies.length <= $6f58092168c61151$var$MAX_SELECTED_ISSUES ? undefined : false,
        onInputChange: onInputChange,
        onChange: (selectedOptions)=>{
            let selectedIssueIds = [];
            if (Array.isArray(selectedOptions)) selectedIssueIds = selectedOptions.map((option)=>option.value);
            else if (selectedOptions && 'value' in selectedOptions) selectedIssueIds = selectedOptions ? [
                selectedOptions.value
            ] : [];
            setIssueIdsToShowDependencies(boardId, selectedIssueIds);
            onHandleChange((0, $4cYhQ.ActionSubject).SELECT, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
                count: selectedIssueIds.length
            }, (0, $4cYhQ.Action).CHANGED);
        }
    }))));
};
const $6f58092168c61151$var$menuIconStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.025',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$valueIconStyles = (0, $jJ1Sb.xcss)({
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$selectWrapper = (0, $jJ1Sb.xcss)({
    width: '450px'
});
const $6f58092168c61151$var$infoIconWrapperStyles = (0, $jJ1Sb.xcss)({
    height: '24px',
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("5eN06", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8b47c8580de559edd6a7f4245d87179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d04451415f81a12$var$_react = $3d04451415f81a12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3d04451415f81a12$var$_information = $3d04451415f81a12$var$_interopRequireDefault((parcelRequire("ekjWg")));

var $3d04451415f81a12$var$_panel = $3d04451415f81a12$var$_interopRequireDefault((parcelRequire("aVgAK")));
function $3d04451415f81a12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3d04451415f81a12$var$InformationIcon = (props)=>/*#__PURE__*/ $3d04451415f81a12$var$_react.default.createElement($3d04451415f81a12$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $3d04451415f81a12$var$_panel.default
    }, props));
$3d04451415f81a12$var$InformationIcon.Name = 'InformationIconMigration';
var $3d04451415f81a12$var$_default = module.exports.default = $3d04451415f81a12$var$InformationIcon;

});
parcelRegister("ekjWg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e9b091e24458ded7dee3b5ff897b055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6e2665d7c6ebf05$var$_react = $a6e2665d7c6ebf05$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a6e2665d7c6ebf05$var$_UNSAFE_baseNew = $a6e2665d7c6ebf05$var$_interopRequireDefault((parcelRequire("huIZN")));
function $a6e2665d7c6ebf05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6e2665d7c6ebf05$var$InformationIcon = (props)=>/*#__PURE__*/ $a6e2665d7c6ebf05$var$_react.default.createElement($a6e2665d7c6ebf05$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$a6e2665d7c6ebf05$var$InformationIcon.displayName = 'InformationIcon';
var $a6e2665d7c6ebf05$var$_default = module.exports.default = $a6e2665d7c6ebf05$var$InformationIcon;

});

parcelRegister("aVgAK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f3c1903e9d49e74$var$_react = $7f3c1903e9d49e74$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $7f3c1903e9d49e74$var$_information = $7f3c1903e9d49e74$var$_interopRequireDefault((parcelRequire("lrYDv")));
function $7f3c1903e9d49e74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f3c1903e9d49e74$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f3c1903e9d49e74$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f3c1903e9d49e74$var$_information.default
    }));
$7f3c1903e9d49e74$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f3c1903e9d49e74$var$_default = module.exports.default = $7f3c1903e9d49e74$var$EditorPanelIcon;

});


parcelRegister("4jAPy", function(module, exports) {

$parcel$export(module.exports, "SCRUM_TEAM", () => $acaa4e836b6925cd$export$103a728db4a941f8);
$parcel$export(module.exports, "KANBAN_TEAM", () => $acaa4e836b6925cd$export$f43662b315e78f32);
$parcel$export(module.exports, "BOARD_ISSUE_SOURCE", () => $acaa4e836b6925cd$export$4c4602fa98384024);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $acaa4e836b6925cd$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $acaa4e836b6925cd$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $acaa4e836b6925cd$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $acaa4e836b6925cd$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $acaa4e836b6925cd$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $acaa4e836b6925cd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DOC_LINKS", () => $acaa4e836b6925cd$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $acaa4e836b6925cd$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $acaa4e836b6925cd$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $acaa4e836b6925cd$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $acaa4e836b6925cd$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $acaa4e836b6925cd$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $acaa4e836b6925cd$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $acaa4e836b6925cd$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $acaa4e836b6925cd$export$df2129225b939441);
$parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", () => $acaa4e836b6925cd$export$8400d4ac050fc755);
$parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", () => $acaa4e836b6925cd$export$b83f977709573647);
$parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", () => $acaa4e836b6925cd$export$f16a2b8db5d397c);
$parcel$export(module.exports, "SWIMLANE_TEAMLESS", () => $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c);
const $acaa4e836b6925cd$export$103a728db4a941f8 = 'Scrum';
const $acaa4e836b6925cd$export$f43662b315e78f32 = 'Kanban';
const $acaa4e836b6925cd$export$4c4602fa98384024 = 'Board';
const $acaa4e836b6925cd$export$ab08f53e1080ee4f = 'Project';
const $acaa4e836b6925cd$export$e5b9ed989e245a1a = 'Filter';
const $acaa4e836b6925cd$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $acaa4e836b6925cd$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $acaa4e836b6925cd$export$84bf4e4e31fe4475 = 'labels';
const $acaa4e836b6925cd$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $acaa4e836b6925cd$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $acaa4e836b6925cd$export$70493a18b15fa2cc = 2;
const $acaa4e836b6925cd$export$e2ffaae341a16c5e = 'StoryPoints';
const $acaa4e836b6925cd$export$9a6e823d5b9e62be = 'Hours';
const $acaa4e836b6925cd$export$ad92792f1d38ffba = 'Days';
const $acaa4e836b6925cd$export$cfeee2ee86ead336 = 'axolotl';
const $acaa4e836b6925cd$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $acaa4e836b6925cd$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
    CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
    OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/'
};
const $acaa4e836b6925cd$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
    CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
    OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF'
};
const $acaa4e836b6925cd$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $acaa4e836b6925cd$export$1bb2633f6c6f66d1 = `${$acaa4e836b6925cd$export$c78721cd39b97424}start`;
const $acaa4e836b6925cd$export$9583c6ba8c6caee3 = `${$acaa4e836b6925cd$export$c78721cd39b97424}end`;
const $acaa4e836b6925cd$export$f2ee1113933b4540 = 'none';
const $acaa4e836b6925cd$export$3212503575d06ffd = 'label';
const $acaa4e836b6925cd$export$ba991b7dc2732ca3 = 'select';
const $acaa4e836b6925cd$export$df2129225b939441 = 'multiselect';
const $acaa4e836b6925cd$export$8400d4ac050fc755 = 2;
const $acaa4e836b6925cd$export$b83f977709573647 = 6;
const $acaa4e836b6925cd$export$f16a2b8db5d397c = [
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '7',
        value: 7
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '9',
        value: 9
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '11',
        value: 11
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    }
];
const $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c = '$teamless$';

});

parcelRegister("kfO2I", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSelect", () => $3769930931d22483$export$88e7b5a47d581b96);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $8bXez = parcelRequire("8bXez");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $j6ZuL = parcelRequire("j6ZuL");

var $gwIPs = parcelRequire("gwIPs");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $3769930931d22483$export$88e7b5a47d581b96 = ({ title: title, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, validationErrorMessage: validationErrorMessage, titleIcon: titleIcon, ...restProps })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const errorId = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}-error`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $3769930931d22483$var$panelContainerStyles : $3769930931d22483$var$popupContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $3769930931d22483$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, title), titleIcon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6ZuL.default), {
        inputId: id,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).layer
                })
        },
        "aria-invalid": !!validationErrorMessage,
        "aria-errormessage": errorId,
        ...restProps
    }), validationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        as: "span",
        id: errorId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bXez.ErrorMessage), null, validationErrorMessage)));
};
const $3769930931d22483$var$labelWrapperStyles = (0, $jJ1Sb.xcss)({
    marginBottom: 'space.050'
});
const $3769930931d22483$var$popupContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: 'space.200',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $3769930931d22483$var$panelContainerStyles = (0, $jJ1Sb.xcss)({
    marginBlock: 'space.200',
    marginInline: 'auto',
    minWidth: '200px'
});

});
parcelRegister("8bXez", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $4e3d8c01d2a81fb6$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $4e3d8c01d2a81fb6$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $4e3d8c01d2a81fb6$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $4e3d8c01d2a81fb6$export$ec445f12f63100a5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jCvxE = parcelRequire("jCvxE");

var $2RHN3 = parcelRequire("2RHN3");


var $dfjsA = parcelRequire("dfjsA");
function $4e3d8c01d2a81fb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4e3d8c01d2a81fb6$var$messageStyles = {
    name: "drnq1s",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $4e3d8c01d2a81fb6$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $f8Sb3.css)({
        color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $4e3d8c01d2a81fb6$var$iconWrapperStyles = {
    name: "x5c876",
    styles: "display:flex;height:16px;align-items:center"
};
const $4e3d8c01d2a81fb6$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $4e3d8c01d2a81fb6$var$iconWrapperStyles
    }, children);
};
const $4e3d8c01d2a81fb6$var$messageIcons = {
    error: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jCvxE))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2RHN3))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $4e3d8c01d2a81fb6$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $4e3d8c01d2a81fb6$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($4e3d8c01d2a81fb6$export$579aef2c392a54d4);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $4e3d8c01d2a81fb6$var$messageStyles,
            $4e3d8c01d2a81fb6$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$IconWrapper, null, icon), content);
};
const $4e3d8c01d2a81fb6$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dfjsA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $4e3d8c01d2a81fb6$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $4e3d8c01d2a81fb6$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($4e3d8c01d2a81fb6$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("jCvxE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0499610e65a8e7f9250a345ef46c32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e48a08784a3e0842$var$_react = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e48a08784a3e0842$var$_error = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("cNpa3")));

var $e48a08784a3e0842$var$_error2 = $e48a08784a3e0842$var$_interopRequireDefault((parcelRequire("2OiHg")));
function $e48a08784a3e0842$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e48a08784a3e0842$var$ErrorIcon = (props)=>/*#__PURE__*/ $e48a08784a3e0842$var$_react.default.createElement($e48a08784a3e0842$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $e48a08784a3e0842$var$_error2.default
    }, props));
$e48a08784a3e0842$var$ErrorIcon.Name = 'ErrorIconMigration';
var $e48a08784a3e0842$var$_default = module.exports.default = $e48a08784a3e0842$var$ErrorIcon;

});
parcelRegister("cNpa3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbdb3f80d4bcdf634ad3eb6ad4125bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950d941f0f78ad03$var$_react = $950d941f0f78ad03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $950d941f0f78ad03$var$_UNSAFE_baseNew = $950d941f0f78ad03$var$_interopRequireDefault((parcelRequire("huIZN")));
function $950d941f0f78ad03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950d941f0f78ad03$var$ErrorIcon = (props)=>/*#__PURE__*/ $950d941f0f78ad03$var$_react.default.createElement($950d941f0f78ad03$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$950d941f0f78ad03$var$ErrorIcon.displayName = 'ErrorIcon';
var $950d941f0f78ad03$var$_default = module.exports.default = $950d941f0f78ad03$var$ErrorIcon;

});


parcelRegister("2RHN3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c91b2071a3b78298cdb1ab35dcf13197>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21627fd92ef76332$var$_react = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21627fd92ef76332$var$_success = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("kRI53")));

var $21627fd92ef76332$var$_success2 = $21627fd92ef76332$var$_interopRequireDefault((parcelRequire("gwvLf")));
function $21627fd92ef76332$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21627fd92ef76332$var$SuccessIcon = (props)=>/*#__PURE__*/ $21627fd92ef76332$var$_react.default.createElement($21627fd92ef76332$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $21627fd92ef76332$var$_success2.default
    }, props));
$21627fd92ef76332$var$SuccessIcon.Name = 'SuccessIconMigration';
var $21627fd92ef76332$var$_default = module.exports.default = $21627fd92ef76332$var$SuccessIcon;

});
parcelRegister("kRI53", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f46e0408994ee0eebe07fdde2651636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f30af3557ea4f8de$var$_react = $f30af3557ea4f8de$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f30af3557ea4f8de$var$_UNSAFE_baseNew = $f30af3557ea4f8de$var$_interopRequireDefault((parcelRequire("huIZN")));
function $f30af3557ea4f8de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f30af3557ea4f8de$var$SuccessIcon = (props)=>/*#__PURE__*/ $f30af3557ea4f8de$var$_react.default.createElement($f30af3557ea4f8de$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$f30af3557ea4f8de$var$SuccessIcon.displayName = 'SuccessIcon';
var $f30af3557ea4f8de$var$_default = module.exports.default = $f30af3557ea4f8de$var$SuccessIcon;

});


parcelRegister("dfjsA", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $586a02cb9f4a5e18$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $586a02cb9f4a5e18$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("j6ZuL", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $8a4ed93e09c7e2cd$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2JyZq = parcelRequire("2JyZq");
var $g6zRF = parcelRequire("g6zRF");
var $fpTxz = parcelRequire("fpTxz");

var $1DGxv = parcelRequire("1DGxv");

var $8QBfu = parcelRequire("8QBfu");
const $8a4ed93e09c7e2cd$var$packageName = "platform-pkg";
const $8a4ed93e09c7e2cd$var$packageVersion = "0.0.0-use.local";
const $8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3 = (0, $8QBfu.default)((0, $1DGxv.default));
const $8a4ed93e09c7e2cd$var$createAndFireEventOnAtlaskit = (0, $2JyZq.default)('atlaskit');
const $8a4ed93e09c7e2cd$var$Select = (0, $g6zRF.default)({
    componentName: 'select',
    packageName: $8a4ed93e09c7e2cd$var$packageName,
    packageVersion: $8a4ed93e09c7e2cd$var$packageVersion
})((0, $fpTxz.default)({
    onChange: $8a4ed93e09c7e2cd$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $8a4ed93e09c7e2cd$var$packageName,
            packageVersion: $8a4ed93e09c7e2cd$var$packageVersion
        }
    })
})($8a4ed93e09c7e2cd$export$d1de3b251ccaa8a3));
var $8a4ed93e09c7e2cd$export$2e2bcd8739ae039 = $8a4ed93e09c7e2cd$var$Select;

});
parcelRegister("1DGxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c8a0440cd263e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1vboO = parcelRequire("1vboO");

var $3y3Bw = parcelRequire("3y3Bw");
const $c5c8a0440cd263e7$var$StateManagedSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $3y3Bw.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vboO.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $c5c8a0440cd263e7$export$2e2bcd8739ae039 = $c5c8a0440cd263e7$var$StateManagedSelect;

});
parcelRegister("1vboO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bbd2b206e48247$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Ca0Y = parcelRequire("8Ca0Y");

var $4Ov3p = parcelRequire("4Ov3p");

var $32eUr = parcelRequire("32eUr");

var $83Qqt = parcelRequire("83Qqt");
var $7Nyq8 = parcelRequire("7Nyq8");
var $ogJTl = parcelRequire("ogJTl");

var $6l9x6 = parcelRequire("6l9x6");

var $gG9Gj = parcelRequire("gG9Gj");

var $eB7nO = parcelRequire("eB7nO");

var $8dMtY = parcelRequire("8dMtY");

var $7eDU2 = parcelRequire("7eDU2");

var $8X8Oy = parcelRequire("8X8Oy");
const $a4bbd2b206e48247$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $8X8Oy.isTouchCapable)(),
    captureMenuScroll: !(0, $8X8Oy.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $eB7nO.createFilter)(),
    formatGroupLabel: (0, $4Ov3p.formatGroupLabel),
    getOptionLabel: (0, $4Ov3p.getOptionLabel),
    getOptionValue: (0, $4Ov3p.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $4Ov3p.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $8X8Oy.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $a4bbd2b206e48247$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $a4bbd2b206e48247$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $a4bbd2b206e48247$var$isOptionSelected(props, option, selectValue);
    const label = $a4bbd2b206e48247$var$getOptionLabel(props, option);
    const value = $a4bbd2b206e48247$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$a4bbd2b206e48247$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$a4bbd2b206e48247$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $a4bbd2b206e48247$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $a4bbd2b206e48247$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $8X8Oy.notNullish));
}
function $a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $a4bbd2b206e48247$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $a4bbd2b206e48247$var$buildFocusableOptions(props, selectValue) {
    return $a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions($a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue));
}
function $a4bbd2b206e48247$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$a4bbd2b206e48247$var$shouldHideSelectedOptions(props) || !isSelected) && $a4bbd2b206e48247$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $a4bbd2b206e48247$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $a4bbd2b206e48247$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $a4bbd2b206e48247$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $a4bbd2b206e48247$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $a4bbd2b206e48247$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $a4bbd2b206e48247$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $a4bbd2b206e48247$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $a4bbd2b206e48247$var$getOptionValue(props, option);
    return selectValue.some((i)=>$a4bbd2b206e48247$var$getOptionValue(props, i) === candidate);
}
function $a4bbd2b206e48247$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $a4bbd2b206e48247$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $a4bbd2b206e48247$var$instanceId = 1;
class $a4bbd2b206e48247$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $a4bbd2b206e48247$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $8Ca0Y.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $8X8Oy.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $8X8Oy.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $8X8Oy.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $8X8Oy.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $8X8Oy.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $8X8Oy.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $8X8Oy.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $a4bbd2b206e48247$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $a4bbd2b206e48247$var$buildFocusableOptionsWithIds($a4bbd2b206e48247$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $8X8Oy.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $a4bbd2b206e48247$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $a4bbd2b206e48247$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $8dMtY.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $32eUr.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$a4bbd2b206e48247$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$a4bbd2b206e48247$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $8X8Oy.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $a4bbd2b206e48247$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$a4bbd2b206e48247$var$instanceId);
        this.state.selectValue = (0, $8X8Oy.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $a4bbd2b206e48247$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $8X8Oy.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $a4bbd2b206e48247$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $a4bbd2b206e48247$var$buildFocusableOptionsWithIds($a4bbd2b206e48247$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $a4bbd2b206e48247$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $a4bbd2b206e48247$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $a4bbd2b206e48247$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $8X8Oy.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $8X8Oy.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $8X8Oy.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $7eDU2.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $7eDU2.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $7eDU2.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $a4bbd2b206e48247$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $a4bbd2b206e48247$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $a4bbd2b206e48247$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId ? this.state.focusedOptionId : undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83Qqt.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $8X8Oy.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gG9Gj.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ogJTl.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nyq8.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6l9x6.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("8Ca0Y", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $5b4f1b27f0a81990$export$e1865c3bedcd822b);
function $5b4f1b27f0a81990$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $5b4f1b27f0a81990$export$186c6964ca17d99() {
    return $5b4f1b27f0a81990$var$testPlatform(/^iPhone/i);
}
function $5b4f1b27f0a81990$export$9ac100e40613ea10() {
    return $5b4f1b27f0a81990$var$testPlatform(/^Mac/i);
}
function $5b4f1b27f0a81990$export$7bef049ce92e4224() {
    return $5b4f1b27f0a81990$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $5b4f1b27f0a81990$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $5b4f1b27f0a81990$export$fedb369cb70207f1() {
    return $5b4f1b27f0a81990$export$186c6964ca17d99() || $5b4f1b27f0a81990$export$7bef049ce92e4224();
}
function $5b4f1b27f0a81990$export$e1865c3bedcd822b() {
    return $5b4f1b27f0a81990$export$9ac100e40613ea10() || $5b4f1b27f0a81990$export$fedb369cb70207f1();
}

});

parcelRegister("4Ov3p", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $f87a73dff4e4d6a9$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $f87a73dff4e4d6a9$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $f87a73dff4e4d6a9$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $f87a73dff4e4d6a9$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $f87a73dff4e4d6a9$export$f4da216a6ca54656 = (group)=>group.label;
const $f87a73dff4e4d6a9$export$dac6ace3020563ca = (option)=>option.label;
const $f87a73dff4e4d6a9$export$40be908210c5a79c = (option)=>option.value;
const $f87a73dff4e4d6a9$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("32eUr", function(module, exports) {

$parcel$export(module.exports, "components", () => $dbf96e1ea5b73ca1$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $dbf96e1ea5b73ca1$export$71abc632aa29e6fe);

var $eYvcR = parcelRequire("eYvcR");

var $6PDm2 = parcelRequire("6PDm2");

var $fAKLF = parcelRequire("fAKLF");

var $amcTK = parcelRequire("amcTK");

var $gXTA4 = parcelRequire("gXTA4");

var $gG9Gj = parcelRequire("gG9Gj");

var $fIxnT = parcelRequire("fIxnT");

var $2HYPe = parcelRequire("2HYPe");

var $aAmAU = parcelRequire("aAmAU");

var $5mFvf = parcelRequire("5mFvf");
const $dbf96e1ea5b73ca1$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $amcTK.ClearIndicator),
    Control: (0, $6PDm2.default),
    DropdownIndicator: (0, $amcTK.DropdownIndicator),
    DownChevron: (0, $amcTK.DownChevron),
    CrossIcon: (0, $amcTK.CrossIcon),
    Group: (0, $fAKLF.default),
    GroupHeading: (0, $fAKLF.GroupHeading),
    IndicatorsContainer: (0, $eYvcR.IndicatorsContainer),
    IndicatorSeparator: (0, $amcTK.IndicatorSeparator),
    Input: (0, $gXTA4.default),
    LoadingIndicator: (0, $amcTK.LoadingIndicator),
    Menu: (0, $gG9Gj.default),
    MenuList: (0, $gG9Gj.MenuList),
    MenuPortal: (0, $gG9Gj.MenuPortal),
    LoadingMessage: (0, $gG9Gj.LoadingMessage),
    NoOptionsMessage: (0, $gG9Gj.NoOptionsMessage),
    MultiValue: (0, $fIxnT.default),
    MultiValueContainer: (0, $fIxnT.MultiValueContainer),
    MultiValueLabel: (0, $fIxnT.MultiValueLabel),
    MultiValueRemove: (0, $fIxnT.MultiValueRemove),
    Option: (0, $2HYPe.default),
    Placeholder: (0, $aAmAU.default),
    SelectContainer: (0, $eYvcR.SelectContainer),
    SingleValue: (0, $5mFvf.default),
    ValueContainer: (0, $eYvcR.ValueContainer)
};
const $dbf96e1ea5b73ca1$export$71abc632aa29e6fe = (props)=>({
        ...$dbf96e1ea5b73ca1$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("eYvcR", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $b6dff7f2cc3f8428$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $b6dff7f2cc3f8428$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $b6dff7f2cc3f8428$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $b6dff7f2cc3f8428$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $b6dff7f2cc3f8428$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $b6dff7f2cc3f8428$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b6dff7f2cc3f8428$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $b6dff7f2cc3f8428$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $b6dff7f2cc3f8428$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $b6dff7f2cc3f8428$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $8X8Oy.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $b6dff7f2cc3f8428$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $b6dff7f2cc3f8428$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("8X8Oy", function(module, exports) {

$parcel$export(module.exports, "noop", () => $5badd6cb6d07d680$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $5badd6cb6d07d680$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $5badd6cb6d07d680$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $5badd6cb6d07d680$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $5badd6cb6d07d680$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $5badd6cb6d07d680$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $5badd6cb6d07d680$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $5badd6cb6d07d680$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $5badd6cb6d07d680$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $5badd6cb6d07d680$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $5badd6cb6d07d680$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $5badd6cb6d07d680$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $5badd6cb6d07d680$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $5badd6cb6d07d680$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $5badd6cb6d07d680$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $5badd6cb6d07d680$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $5badd6cb6d07d680$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $5badd6cb6d07d680$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $5badd6cb6d07d680$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $5badd6cb6d07d680$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $5badd6cb6d07d680$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $5badd6cb6d07d680$export$4213b25a1c4e877);
const $5badd6cb6d07d680$export$8793edee2d425525 = ()=>{};
const $5badd6cb6d07d680$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $5badd6cb6d07d680$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $5badd6cb6d07d680$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$5badd6cb6d07d680$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $5badd6cb6d07d680$export$33f062f47f21a01 = (value)=>{
    if ($5badd6cb6d07d680$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $5badd6cb6d07d680$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $5badd6cb6d07d680$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $5badd6cb6d07d680$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $5badd6cb6d07d680$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $5badd6cb6d07d680$export$2e0654fad740d2e4(el) {
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $5badd6cb6d07d680$export$c4a223a8ba9e4ea5(el) {
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $5badd6cb6d07d680$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($5badd6cb6d07d680$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $5badd6cb6d07d680$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $5badd6cb6d07d680$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $5badd6cb6d07d680$export$858c30343199f3af(element, to, duration = 200, callback = $5badd6cb6d07d680$export$8793edee2d425525) {
    const start = $5badd6cb6d07d680$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $5badd6cb6d07d680$var$easeOutCubic(currentTime, start, change, duration);
        $5badd6cb6d07d680$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $5badd6cb6d07d680$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $5badd6cb6d07d680$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $5badd6cb6d07d680$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $5badd6cb6d07d680$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $5badd6cb6d07d680$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $5badd6cb6d07d680$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $5badd6cb6d07d680$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $5badd6cb6d07d680$var$passiveOptionAccessed = false;
const $5badd6cb6d07d680$var$options = {
    get passive () {
        return $5badd6cb6d07d680$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $5badd6cb6d07d680$var$w = typeof window !== 'undefined' ? window : {};
if ($5badd6cb6d07d680$var$w.addEventListener && $5badd6cb6d07d680$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $5badd6cb6d07d680$var$w.addEventListener('p', $5badd6cb6d07d680$export$8793edee2d425525, $5badd6cb6d07d680$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $5badd6cb6d07d680$var$w.removeEventListener('p', $5badd6cb6d07d680$export$8793edee2d425525, false);
}
const $5badd6cb6d07d680$export$b0622a6911dbeaf5 = $5badd6cb6d07d680$var$passiveOptionAccessed;
function $5badd6cb6d07d680$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $5badd6cb6d07d680$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $5badd6cb6d07d680$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $5badd6cb6d07d680$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $5badd6cb6d07d680$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $5badd6cb6d07d680$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("6PDm2", function(module, exports) {

$parcel$export(module.exports, "css", () => $277eb029e90c40a5$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $277eb029e90c40a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $277eb029e90c40a5$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $277eb029e90c40a5$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $8X8Oy.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$277eb029e90c40a5$export$2e2bcd8739ae039 = $277eb029e90c40a5$var$Control;

});

parcelRegister("fAKLF", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $1607f6fc8c4ecdaf$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $1607f6fc8c4ecdaf$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $1607f6fc8c4ecdaf$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $1607f6fc8c4ecdaf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $1607f6fc8c4ecdaf$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $1607f6fc8c4ecdaf$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $1607f6fc8c4ecdaf$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $1607f6fc8c4ecdaf$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $8X8Oy.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1607f6fc8c4ecdaf$export$2e2bcd8739ae039 = $1607f6fc8c4ecdaf$var$Group;

});

parcelRegister("amcTK", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $bb7f88a72976b3e0$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $bb7f88a72976b3e0$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $bb7f88a72976b3e0$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $bb7f88a72976b3e0$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $bb7f88a72976b3e0$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $bb7f88a72976b3e0$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $bb7f88a72976b3e0$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $bb7f88a72976b3e0$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $bb7f88a72976b3e0$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $bb7f88a72976b3e0$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
function $bb7f88a72976b3e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $bb7f88a72976b3e0$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $bb7f88a72976b3e0$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $bb7f88a72976b3e0$var$styles,
        ...props
    });
const $bb7f88a72976b3e0$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $bb7f88a72976b3e0$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $bb7f88a72976b3e0$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $bb7f88a72976b3e0$export$e1687335805e1230 = $bb7f88a72976b3e0$var$baseCSS;
const $bb7f88a72976b3e0$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$export$c5cbe1656ba71e6c, null));
};
const $bb7f88a72976b3e0$export$9c0419fd944c1def = $bb7f88a72976b3e0$var$baseCSS;
const $bb7f88a72976b3e0$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$export$3b621d86b1566b2, null));
};
const $bb7f88a72976b3e0$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $bb7f88a72976b3e0$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...innerProps,
        ...(0, $8X8Oy.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $bb7f88a72976b3e0$var$loadingDotAnimations = (0, $f8Sb3.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $bb7f88a72976b3e0$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $bb7f88a72976b3e0$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $f8Sb3.css)({
            animation: `${$bb7f88a72976b3e0$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $bb7f88a72976b3e0$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($bb7f88a72976b3e0$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("gXTA4", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $36de8f31aa0ca4d0$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $36de8f31aa0ca4d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $36de8f31aa0ca4d0$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$36de8f31aa0ca4d0$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $36de8f31aa0ca4d0$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $36de8f31aa0ca4d0$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$36de8f31aa0ca4d0$var$spacingStyle
    }
};
const $36de8f31aa0ca4d0$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$36de8f31aa0ca4d0$var$spacingStyle
    });
const $36de8f31aa0ca4d0$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $8X8Oy.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $36de8f31aa0ca4d0$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$36de8f31aa0ca4d0$export$2e2bcd8739ae039 = $36de8f31aa0ca4d0$var$Input;

});

parcelRegister("gG9Gj", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $ce0772d67728ab16$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $ce0772d67728ab16$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $ce0772d67728ab16$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $ce0772d67728ab16$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $ce0772d67728ab16$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $ce0772d67728ab16$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $ce0772d67728ab16$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $ce0772d67728ab16$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $ce0772d67728ab16$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $ce0772d67728ab16$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $ce0772d67728ab16$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ktgnN = parcelRequire("ktgnN");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $8X8Oy = parcelRequire("8X8Oy");
function $ce0772d67728ab16$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $8X8Oy.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $8X8Oy.normalizedHeight)(scrollParent);
    const scrollTop = (0, $8X8Oy.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $8X8Oy.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $8X8Oy.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $ce0772d67728ab16$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $ce0772d67728ab16$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $ce0772d67728ab16$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$ce0772d67728ab16$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $ce0772d67728ab16$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $ce0772d67728ab16$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($ce0772d67728ab16$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $ce0772d67728ab16$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $ce0772d67728ab16$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $ce0772d67728ab16$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ce0772d67728ab16$export$2e2bcd8739ae039 = $ce0772d67728ab16$var$Menu;
const $ce0772d67728ab16$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $ce0772d67728ab16$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $ce0772d67728ab16$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $ce0772d67728ab16$export$cf0e22534d8b0074 = $ce0772d67728ab16$var$noticeCSS;
const $ce0772d67728ab16$export$98ec46397a8cb3cd = $ce0772d67728ab16$var$noticeCSS;
const $ce0772d67728ab16$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children);
};
const $ce0772d67728ab16$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $ce0772d67728ab16$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $ce0772d67728ab16$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($ce0772d67728ab16$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $8X8Oy.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $ktgnN.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $8X8Oy.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($ce0772d67728ab16$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("ktgnN", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $ee7339595cce6cb1$export$deee3a793edee05f);

var $62nHC = parcelRequire("62nHC");
function $ee7339595cce6cb1$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $ee7339595cce6cb1$var$o(t) {
    return $ee7339595cce6cb1$var$n(t).getComputedStyle(t);
}
function $ee7339595cce6cb1$var$i(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Node;
}
function $ee7339595cce6cb1$var$r(t) {
    return $ee7339595cce6cb1$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $ee7339595cce6cb1$var$l;
function $ee7339595cce6cb1$var$c() {
    if ($ee7339595cce6cb1$var$l) return $ee7339595cce6cb1$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($ee7339595cce6cb1$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $ee7339595cce6cb1$var$l) : navigator.userAgent;
}
function $ee7339595cce6cb1$var$s(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).HTMLElement;
}
function $ee7339595cce6cb1$var$f(t) {
    return t instanceof $ee7339595cce6cb1$var$n(t).Element;
}
function $ee7339595cce6cb1$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $ee7339595cce6cb1$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $ee7339595cce6cb1$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $ee7339595cce6cb1$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $ee7339595cce6cb1$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($ee7339595cce6cb1$var$r(t));
}
function $ee7339595cce6cb1$var$h(t) {
    const e = /firefox/i.test($ee7339595cce6cb1$var$c()), n = $ee7339595cce6cb1$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $ee7339595cce6cb1$var$p() {
    return /^((?!chrome|android).)*safari/i.test($ee7339595cce6cb1$var$c());
}
function $ee7339595cce6cb1$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ee7339595cce6cb1$var$r(t));
}
const $ee7339595cce6cb1$var$m = Math.min, $ee7339595cce6cb1$var$y = Math.max, $ee7339595cce6cb1$var$x = Math.round;
function $ee7339595cce6cb1$var$w(t) {
    const e = $ee7339595cce6cb1$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $ee7339595cce6cb1$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $ee7339595cce6cb1$var$x(n) !== l || $ee7339595cce6cb1$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $ee7339595cce6cb1$var$v(t) {
    return $ee7339595cce6cb1$var$f(t) ? t : t.contextElement;
}
const $ee7339595cce6cb1$var$b = {
    x: 1,
    y: 1
};
function $ee7339595cce6cb1$var$L(t) {
    const e = $ee7339595cce6cb1$var$v(t);
    if (!$ee7339595cce6cb1$var$s(e)) return $ee7339595cce6cb1$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $ee7339595cce6cb1$var$w(e);
    let l = (r ? $ee7339595cce6cb1$var$x(n.width) : n.width) / o, c = (r ? $ee7339595cce6cb1$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $ee7339595cce6cb1$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $ee7339595cce6cb1$var$v(e);
    let a = $ee7339595cce6cb1$var$b;
    o && (r ? $ee7339595cce6cb1$var$f(r) && (a = $ee7339595cce6cb1$var$L(r)) : a = $ee7339595cce6cb1$var$L(e));
    const d = u ? $ee7339595cce6cb1$var$n(u) : window, h = $ee7339595cce6cb1$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $ee7339595cce6cb1$var$n(u), e = r && $ee7339595cce6cb1$var$f(r) ? $ee7339595cce6cb1$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $ee7339595cce6cb1$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $ee7339595cce6cb1$var$n(o).frameElement;
        }
    }
    return (0, $62nHC.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $ee7339595cce6cb1$var$T(t) {
    return (($ee7339595cce6cb1$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $ee7339595cce6cb1$var$R(t) {
    return $ee7339595cce6cb1$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $ee7339595cce6cb1$var$C(t) {
    return $ee7339595cce6cb1$var$E($ee7339595cce6cb1$var$T(t)).left + $ee7339595cce6cb1$var$R(t).scrollLeft;
}
function $ee7339595cce6cb1$var$F(t) {
    if ("html" === $ee7339595cce6cb1$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $ee7339595cce6cb1$var$u(t) && t.host || $ee7339595cce6cb1$var$T(t);
    return $ee7339595cce6cb1$var$u(e) ? e.host : e;
}
function $ee7339595cce6cb1$var$W(t) {
    const e = $ee7339595cce6cb1$var$F(t);
    return $ee7339595cce6cb1$var$g(e) ? e.ownerDocument.body : $ee7339595cce6cb1$var$s(e) && $ee7339595cce6cb1$var$a(e) ? e : $ee7339595cce6cb1$var$W(e);
}
function $ee7339595cce6cb1$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $ee7339595cce6cb1$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $ee7339595cce6cb1$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $ee7339595cce6cb1$var$a(i) ? i : []) : e.concat(i, $ee7339595cce6cb1$export$3b57c1601291186b(i));
}
function $ee7339595cce6cb1$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $ee7339595cce6cb1$var$n(t), i = $ee7339595cce6cb1$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $ee7339595cce6cb1$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $ee7339595cce6cb1$var$T(t), n = $ee7339595cce6cb1$var$R(t), i = t.ownerDocument.body, r = $ee7339595cce6cb1$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $ee7339595cce6cb1$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $ee7339595cce6cb1$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $ee7339595cce6cb1$var$o(i).direction && (c += $ee7339595cce6cb1$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($ee7339595cce6cb1$var$T(e));
    else if ($ee7339595cce6cb1$var$f(i)) l = function(t, e) {
        const n = $ee7339595cce6cb1$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $ee7339595cce6cb1$var$s(t) ? $ee7339595cce6cb1$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($ee7339595cce6cb1$var$p()) {
            var c, u;
            const o = $ee7339595cce6cb1$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $62nHC.rectToClientRect)(l);
}
function $ee7339595cce6cb1$var$A(t, e) {
    return $ee7339595cce6cb1$var$s(t) && "fixed" !== $ee7339595cce6cb1$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $ee7339595cce6cb1$var$H(t, e) {
    const i = $ee7339595cce6cb1$var$n(t);
    if (!$ee7339595cce6cb1$var$s(t)) return i;
    let l = $ee7339595cce6cb1$var$A(t, e);
    for(; l && $ee7339595cce6cb1$var$d(l) && "static" === $ee7339595cce6cb1$var$o(l).position;)l = $ee7339595cce6cb1$var$A(l, e);
    return l && ("html" === $ee7339595cce6cb1$var$r(l) || "body" === $ee7339595cce6cb1$var$r(l) && "static" === $ee7339595cce6cb1$var$o(l).position && !$ee7339595cce6cb1$var$h(l)) ? i : l || function(t) {
        let e = $ee7339595cce6cb1$var$F(t);
        for(; $ee7339595cce6cb1$var$s(e) && !$ee7339595cce6cb1$var$g(e);){
            if ($ee7339595cce6cb1$var$h(e)) return e;
            e = $ee7339595cce6cb1$var$F(e);
        }
        return null;
    }(t) || i;
}
function $ee7339595cce6cb1$var$V(t, e, n) {
    const o = $ee7339595cce6cb1$var$s(e), i = $ee7339595cce6cb1$var$T(e), l = $ee7339595cce6cb1$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $ee7339595cce6cb1$var$r(e) || $ee7339595cce6cb1$var$a(i)) && (c = $ee7339595cce6cb1$var$R(e)), $ee7339595cce6cb1$var$s(e)) {
            const t = $ee7339595cce6cb1$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $ee7339595cce6cb1$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $ee7339595cce6cb1$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $ee7339595cce6cb1$export$3b57c1601291186b(t).filter((t)=>$ee7339595cce6cb1$var$f(t) && "body" !== $ee7339595cce6cb1$var$r(t)), l = null;
            const c = "fixed" === $ee7339595cce6cb1$var$o(t).position;
            let s = c ? $ee7339595cce6cb1$var$F(t) : t;
            for(; $ee7339595cce6cb1$var$f(s) && !$ee7339595cce6cb1$var$g(s);){
                const t = $ee7339595cce6cb1$var$o(s), e = $ee7339595cce6cb1$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $ee7339595cce6cb1$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $ee7339595cce6cb1$var$S(e, n, l);
            return t.top = $ee7339595cce6cb1$var$y(o.top, t.top), t.right = $ee7339595cce6cb1$var$m(o.right, t.right), t.bottom = $ee7339595cce6cb1$var$m(o.bottom, t.bottom), t.left = $ee7339595cce6cb1$var$y(o.left, t.left), t;
        }, $ee7339595cce6cb1$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $ee7339595cce6cb1$var$s(n), l = $ee7339595cce6cb1$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $ee7339595cce6cb1$var$r(n) || $ee7339595cce6cb1$var$a(l)) && (c = $ee7339595cce6cb1$var$R(n)), $ee7339595cce6cb1$var$s(n))) {
            const t = $ee7339595cce6cb1$var$E(n);
            f = $ee7339595cce6cb1$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $ee7339595cce6cb1$var$f,
    getDimensions: function(t) {
        return $ee7339595cce6cb1$var$w(t);
    },
    getOffsetParent: $ee7339595cce6cb1$var$H,
    getDocumentElement: $ee7339595cce6cb1$var$T,
    getScale: $ee7339595cce6cb1$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $ee7339595cce6cb1$var$H, r = this.getDimensions;
        return {
            reference: $ee7339595cce6cb1$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $ee7339595cce6cb1$var$o(t).direction
};
function $ee7339595cce6cb1$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$ee7339595cce6cb1$var$f(t) ? $ee7339595cce6cb1$export$3b57c1601291186b(t) : t.contextElement ? $ee7339595cce6cb1$export$3b57c1601291186b(t.contextElement) : [],
        ...$ee7339595cce6cb1$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $ee7339595cce6cb1$var$f(t) && !c && d.observe(t), $ee7339595cce6cb1$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $ee7339595cce6cb1$var$E(t) : null;
    return c && function e() {
        const o = $ee7339595cce6cb1$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $ee7339595cce6cb1$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $ee7339595cce6cb1$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $62nHC.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("62nHC", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $465550d5da2db0f1$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $465550d5da2db0f1$export$ee05aea0aeecbad4);
function $465550d5da2db0f1$var$t(t) {
    return t.split("-")[1];
}
function $465550d5da2db0f1$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $465550d5da2db0f1$var$n(t) {
    return t.split("-")[0];
}
function $465550d5da2db0f1$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($465550d5da2db0f1$var$n(t)) ? "x" : "y";
}
function $465550d5da2db0f1$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $465550d5da2db0f1$var$o(r), u = $465550d5da2db0f1$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($465550d5da2db0f1$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($465550d5da2db0f1$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $465550d5da2db0f1$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $465550d5da2db0f1$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $465550d5da2db0f1$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $465550d5da2db0f1$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $465550d5da2db0f1$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $465550d5da2db0f1$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $465550d5da2db0f1$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $465550d5da2db0f1$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $465550d5da2db0f1$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $465550d5da2db0f1$var$c = Math.min, $465550d5da2db0f1$var$f = Math.max;
function $465550d5da2db0f1$var$m(t, e, n) {
    return $465550d5da2db0f1$var$f(t, $465550d5da2db0f1$var$c(e, n));
}
const $465550d5da2db0f1$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $465550d5da2db0f1$var$a(l), h = {
                x: s,
                y: c
            }, y = $465550d5da2db0f1$var$o(f), x = $465550d5da2db0f1$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $465550d5da2db0f1$var$m(k, B, O), H = null != $465550d5da2db0f1$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $465550d5da2db0f1$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $465550d5da2db0f1$var$d = $465550d5da2db0f1$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $465550d5da2db0f1$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $465550d5da2db0f1$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$465550d5da2db0f1$var$p[t]);
}
function $465550d5da2db0f1$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $465550d5da2db0f1$var$t(n), l = $465550d5da2db0f1$var$o(n), s = $465550d5da2db0f1$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $465550d5da2db0f1$var$h(c)), {
        main: c,
        cross: $465550d5da2db0f1$var$h(c)
    };
}
const $465550d5da2db0f1$var$x = {
    start: "end",
    end: "start"
};
function $465550d5da2db0f1$var$w(t) {
    return t.replace(/start|end/g, (t)=>$465550d5da2db0f1$var$x[t]);
}
const $465550d5da2db0f1$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $465550d5da2db0f1$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $465550d5da2db0f1$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) === e),
                    ...i.filter((n)=>$465550d5da2db0f1$var$t(n) !== e)
                ] : i.filter((t)=>$465550d5da2db0f1$var$n(t) === t)).filter((n)=>!e || $465550d5da2db0f1$var$t(n) === e || !!o && $465550d5da2db0f1$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $465550d5da2db0f1$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$465550d5da2db0f1$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $465550d5da2db0f1$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $465550d5da2db0f1$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $465550d5da2db0f1$var$n(r), R = $465550d5da2db0f1$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $465550d5da2db0f1$var$h(c)
            ] : function(t) {
                const e = $465550d5da2db0f1$var$h(t);
                return [
                    $465550d5da2db0f1$var$w(t),
                    e,
                    $465550d5da2db0f1$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $465550d5da2db0f1$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($465550d5da2db0f1$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($465550d5da2db0f1$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $465550d5da2db0f1$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $465550d5da2db0f1$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $465550d5da2db0f1$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $465550d5da2db0f1$var$R(t) {
    return $465550d5da2db0f1$var$g.some((e)=>t[e] >= 0);
}
const $465550d5da2db0f1$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $465550d5da2db0f1$var$A(await $465550d5da2db0f1$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $465550d5da2db0f1$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $465550d5da2db0f1$var$E(t) {
    const e = $465550d5da2db0f1$var$c(...t.map((t)=>t.left)), n = $465550d5da2db0f1$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $465550d5da2db0f1$var$f(...t.map((t)=>t.right)) - e,
        height: $465550d5da2db0f1$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $465550d5da2db0f1$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(t)));
            }(h), x = $465550d5da2db0f1$export$ee05aea0aeecbad4($465550d5da2db0f1$var$E(h)), w = $465550d5da2db0f1$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $465550d5da2db0f1$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $465550d5da2db0f1$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $465550d5da2db0f1$var$n(i), e = $465550d5da2db0f1$var$f(...y.map((t)=>t.right)), r = $465550d5da2db0f1$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $465550d5da2db0f1$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $465550d5da2db0f1$var$n(r), f = $465550d5da2db0f1$var$t(r), m = "x" === $465550d5da2db0f1$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $465550d5da2db0f1$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $465550d5da2db0f1$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(e, u), p = $465550d5da2db0f1$var$o($465550d5da2db0f1$var$n(a)), h = $465550d5da2db0f1$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $465550d5da2db0f1$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $465550d5da2db0f1$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $465550d5da2db0f1$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $465550d5da2db0f1$var$o(a), d = $465550d5da2db0f1$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($465550d5da2db0f1$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $465550d5da2db0f1$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $465550d5da2db0f1$export$37b6bde19b108ecc(i, g), p = $465550d5da2db0f1$var$n(r), h = $465550d5da2db0f1$var$t(r), y = "x" === $465550d5da2db0f1$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $465550d5da2db0f1$var$c(x - d.right - d.left, R) : P = $465550d5da2db0f1$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $465550d5da2db0f1$var$f(d.left, 0), e = $465550d5da2db0f1$var$f(d.right, 0), n = $465550d5da2db0f1$var$f(d.top, 0), o = $465550d5da2db0f1$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $465550d5da2db0f1$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $465550d5da2db0f1$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;

});


parcelRegister("fIxnT", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $7a3c005dfa92d2c8$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $7a3c005dfa92d2c8$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $7a3c005dfa92d2c8$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $7a3c005dfa92d2c8$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $7a3c005dfa92d2c8$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $7a3c005dfa92d2c8$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $7a3c005dfa92d2c8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");

var $amcTK = parcelRequire("amcTK");
const $7a3c005dfa92d2c8$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $7a3c005dfa92d2c8$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $7a3c005dfa92d2c8$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $7a3c005dfa92d2c8$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $7a3c005dfa92d2c8$export$cf9cf2a30a59265c = $7a3c005dfa92d2c8$export$e1de505c1242dc1a;
const $7a3c005dfa92d2c8$export$544aeea2a5ce08ee = $7a3c005dfa92d2c8$export$e1de505c1242dc1a;
function $7a3c005dfa92d2c8$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $amcTK.CrossIcon), {
        size: 14
    }));
}
const $7a3c005dfa92d2c8$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $8X8Oy.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a3c005dfa92d2c8$export$2e2bcd8739ae039 = $7a3c005dfa92d2c8$var$MultiValue;

});

parcelRegister("2HYPe", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $b7cbb2597aec3d7c$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $b7cbb2597aec3d7c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b7cbb2597aec3d7c$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $b7cbb2597aec3d7c$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7cbb2597aec3d7c$export$2e2bcd8739ae039 = $b7cbb2597aec3d7c$var$Option;

});

parcelRegister("aAmAU", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $b3bce4aa0db58477$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $b3bce4aa0db58477$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $b3bce4aa0db58477$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $b3bce4aa0db58477$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3bce4aa0db58477$export$2e2bcd8739ae039 = $b3bce4aa0db58477$var$Placeholder;

});

parcelRegister("5mFvf", function(module, exports) {

$parcel$export(module.exports, "css", () => $15b2e67a571b7b71$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $15b2e67a571b7b71$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $15b2e67a571b7b71$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $15b2e67a571b7b71$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $8X8Oy.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$15b2e67a571b7b71$export$2e2bcd8739ae039 = $15b2e67a571b7b71$var$SingleValue;

});


parcelRegister("83Qqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $279f17c834f20bd7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8X8Oy = parcelRequire("8X8Oy");
const $279f17c834f20bd7$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $279f17c834f20bd7$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $8X8Oy.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $279f17c834f20bd7$var$dummyInputStyles
    });
}

});

parcelRegister("7Nyq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b117f389d2d1f0ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $ePBXU = parcelRequire("ePBXU");
function $b117f389d2d1f0ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b117f389d2d1f0ea$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $b117f389d2d1f0ea$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $b117f389d2d1f0ea$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $ePBXU.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b117f389d2d1f0ea$export$2e2bcd8739ae039 = $b117f389d2d1f0ea$var$RequiredInput;

});

parcelRegister("ogJTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $529162e91ee687b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1UMhw = parcelRequire("1UMhw");

var $eyEhQ = parcelRequire("eyEhQ");
function $529162e91ee687b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $529162e91ee687b9$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $529162e91ee687b9$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $529162e91ee687b9$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $1UMhw.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $eyEhQ.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onClick: $529162e91ee687b9$var$blurSelectInput,
        css: $529162e91ee687b9$var$styles
    }), children(targetRef));
}

});
parcelRegister("1UMhw", function(module, exports) {

$parcel$export(module.exports, "default", () => $80662ca60abf2046$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8X8Oy = parcelRequire("8X8Oy");
const $80662ca60abf2046$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $80662ca60abf2046$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $80662ca60abf2046$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $8X8Oy.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("eyEhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5be83c0b4e57860$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $f5be83c0b4e57860$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $f5be83c0b4e57860$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $f5be83c0b4e57860$var$preventTouchMove(e) {
    e.preventDefault();
}
function $f5be83c0b4e57860$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $f5be83c0b4e57860$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $f5be83c0b4e57860$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $f5be83c0b4e57860$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f5be83c0b4e57860$var$activeScrollLocks = 0;
const $f5be83c0b4e57860$var$listenerOptions = {
    capture: false,
    passive: false
};
function $f5be83c0b4e57860$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$f5be83c0b4e57860$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $f5be83c0b4e57860$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $f5be83c0b4e57860$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($f5be83c0b4e57860$var$LOCK_STYLES).forEach((key)=>{
                const val = $f5be83c0b4e57860$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $f5be83c0b4e57860$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $f5be83c0b4e57860$var$preventTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $f5be83c0b4e57860$var$preventInertiaScroll, $f5be83c0b4e57860$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $f5be83c0b4e57860$var$allowTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $f5be83c0b4e57860$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$f5be83c0b4e57860$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $f5be83c0b4e57860$var$activeScrollLocks = Math.max($f5be83c0b4e57860$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $f5be83c0b4e57860$var$activeScrollLocks < 1) $f5be83c0b4e57860$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $f5be83c0b4e57860$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $f5be83c0b4e57860$var$preventTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $f5be83c0b4e57860$var$preventInertiaScroll, $f5be83c0b4e57860$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $f5be83c0b4e57860$var$allowTouchMove, $f5be83c0b4e57860$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("6l9x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe20070fa417846c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9kIMy = parcelRequire("9kIMy");

var $jJN0q = parcelRequire("jJN0q");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $fe20070fa417846c$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $9kIMy.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jJN0q.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jJN0q.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe20070fa417846c$export$2e2bcd8739ae039 = $fe20070fa417846c$var$LiveRegion;

});
parcelRegister("9kIMy", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $8c694a6db1787d72$export$a7265767c78f9bae);
const $8c694a6db1787d72$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("jJN0q", function(module, exports) {

$parcel$export(module.exports, "default", () => $370fb6e87137021b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $370fb6e87137021b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $370fb6e87137021b$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $370fb6e87137021b$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $370fb6e87137021b$var$styles,
        ...props
    });
var $370fb6e87137021b$export$2e2bcd8739ae039 = $370fb6e87137021b$var$A11yText;

});


parcelRegister("eB7nO", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $8cb91475fe098e16$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $6L0Jj = parcelRequire("6L0Jj");
const $8cb91475fe098e16$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $6L0Jj.stripDiacritics));
const $8cb91475fe098e16$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $8cb91475fe098e16$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $8cb91475fe098e16$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $8cb91475fe098e16$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $8cb91475fe098e16$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $8cb91475fe098e16$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $8cb91475fe098e16$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $6L0Jj.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("6L0Jj", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $21a9f59d8b4d431c$export$b5bee4b27048330b);
const $21a9f59d8b4d431c$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $21a9f59d8b4d431c$var$anyDiacritic = new RegExp('[' + $21a9f59d8b4d431c$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $21a9f59d8b4d431c$var$diacriticToBase = {};
for(let i = 0; i < $21a9f59d8b4d431c$var$diacritics.length; i++){
    let diacritic = $21a9f59d8b4d431c$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$21a9f59d8b4d431c$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $21a9f59d8b4d431c$export$b5bee4b27048330b = (str)=>{
    return str.replace($21a9f59d8b4d431c$var$anyDiacritic, (match)=>$21a9f59d8b4d431c$var$diacriticToBase[match]);
};

});


parcelRegister("8dMtY", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $d801b3e95f64128a$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $d801b3e95f64128a$export$e618dc39ac9ad607);

var $eYvcR = parcelRequire("eYvcR");

var $6PDm2 = parcelRequire("6PDm2");

var $fAKLF = parcelRequire("fAKLF");

var $amcTK = parcelRequire("amcTK");

var $gXTA4 = parcelRequire("gXTA4");

var $gG9Gj = parcelRequire("gG9Gj");

var $fIxnT = parcelRequire("fIxnT");

var $2HYPe = parcelRequire("2HYPe");

var $aAmAU = parcelRequire("aAmAU");

var $5mFvf = parcelRequire("5mFvf");
const $d801b3e95f64128a$export$214b055320e0bf32 = {
    clearIndicator: (0, $amcTK.clearIndicatorCSS),
    container: (0, $eYvcR.containerCSS),
    control: (0, $6PDm2.css),
    dropdownIndicator: (0, $amcTK.dropdownIndicatorCSS),
    group: (0, $fAKLF.groupCSS),
    groupHeading: (0, $fAKLF.groupHeadingCSS),
    indicatorsContainer: (0, $eYvcR.indicatorsContainerCSS),
    indicatorSeparator: (0, $amcTK.indicatorSeparatorCSS),
    input: (0, $gXTA4.inputCSS),
    loadingIndicator: (0, $amcTK.loadingIndicatorCSS),
    loadingMessage: (0, $gG9Gj.loadingMessageCSS),
    menu: (0, $gG9Gj.menuCSS),
    menuList: (0, $gG9Gj.menuListCSS),
    menuPortal: (0, $gG9Gj.menuPortalCSS),
    multiValue: (0, $fIxnT.multiValueCSS),
    multiValueLabel: (0, $fIxnT.multiValueLabelCSS),
    multiValueRemove: (0, $fIxnT.multiValueRemoveCSS),
    noOptionsMessage: (0, $gG9Gj.noOptionsMessageCSS),
    option: (0, $2HYPe.optionCSS),
    placeholder: (0, $aAmAU.placeholderCSS),
    singleValue: (0, $5mFvf.css),
    valueContainer: (0, $eYvcR.valueContainerCSS)
};
function $d801b3e95f64128a$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("7eDU2", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $b146b759e2f32e72$export$164de7ab8df77ef0);
const $b146b759e2f32e72$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $b146b759e2f32e72$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $b146b759e2f32e72$var$baseUnit = 4;
// The minimum height of the control
const $b146b759e2f32e72$var$controlHeight = 38;
// The amount of space between the control and menu */
const $b146b759e2f32e72$var$menuGutter = $b146b759e2f32e72$var$baseUnit * 2;
const $b146b759e2f32e72$export$5458b64234d1333c = {
    baseUnit: $b146b759e2f32e72$var$baseUnit,
    controlHeight: $b146b759e2f32e72$var$controlHeight,
    menuGutter: $b146b759e2f32e72$var$menuGutter
};
const $b146b759e2f32e72$export$164de7ab8df77ef0 = {
    borderRadius: $b146b759e2f32e72$var$borderRadius,
    colors: $b146b759e2f32e72$export$8f45430ccf837300,
    spacing: $b146b759e2f32e72$export$5458b64234d1333c
};

});


parcelRegister("3y3Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af71877eb418622$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $7af71877eb418622$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("8QBfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $898f4e606177aa8e$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5uXOq = parcelRequire("5uXOq");

var $8dMtY = parcelRequire("8dMtY");

var $8gxSq = parcelRequire("8gxSq");
var $4JSbr = parcelRequire("4JSbr");

var $hUvN1 = parcelRequire("hUvN1");

var $7SD1Y = parcelRequire("7SD1Y");

var $i4Azc = parcelRequire("i4Azc");

var $fw6Sj = parcelRequire("fw6Sj");
function $898f4e606177aa8e$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        const components = (0, $5uXOq.useMemo)(()=>({
                ClearIndicator: $8gxSq.ClearIndicator,
                DropdownIndicator: $8gxSq.DropdownIndicator,
                LoadingIndicator: $8gxSq.LoadingIndicator,
                MultiValueRemove: $4JSbr.MultiValueRemove,
                IndicatorSeparator: $4JSbr.IndicatorSeparator,
                Input: $hUvN1.Input,
                NoOptionsMessage: $7SD1Y.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $fw6Sj.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $fw6Sj.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $8dMtY.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $i4Azc.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("8gxSq", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $1cb2ad07eac9a6a4$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $1cb2ad07eac9a6a4$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $1cb2ad07eac9a6a4$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eSI7k = parcelRequire("eSI7k");

var $2S8Eh = parcelRequire("2S8Eh");

var $dsFR3 = parcelRequire("dsFR3");
var $9nD7C = parcelRequire("9nD7C");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");

var $9MjbF = parcelRequire("9MjbF");
const $1cb2ad07eac9a6a4$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $1cb2ad07eac9a6a4$var$dropdownWrapperStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.075'
});
const $1cb2ad07eac9a6a4$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9nD7C.default), {
        xcss: $1cb2ad07eac9a6a4$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2S8Eh))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $1cb2ad07eac9a6a4$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).DropdownIndicator, props, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsFR3.default), {
        as: "span",
        xcss: $1cb2ad07eac9a6a4$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eSI7k))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $1cb2ad07eac9a6a4$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $f8Sb3.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MjbF.default), {
        size: "small"
    })));
};

});
parcelRegister("2S8Eh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21775561ba689a9d$var$_react = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21775561ba689a9d$var$_crossCircle = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("5y49s")));

var $21775561ba689a9d$var$_selectClear = $21775561ba689a9d$var$_interopRequireDefault((parcelRequire("0q6NC")));
function $21775561ba689a9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21775561ba689a9d$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $21775561ba689a9d$var$_react.default.createElement($21775561ba689a9d$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $21775561ba689a9d$var$_selectClear.default
    }, props));
$21775561ba689a9d$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $21775561ba689a9d$var$_default = module.exports.default = $21775561ba689a9d$var$CrossCircleIcon;

});
parcelRegister("5y49s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40a35920732ae269$var$_react = $40a35920732ae269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $40a35920732ae269$var$_UNSAFE_baseNew = $40a35920732ae269$var$_interopRequireDefault((parcelRequire("huIZN")));
function $40a35920732ae269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $40a35920732ae269$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $40a35920732ae269$var$_react.default.createElement($40a35920732ae269$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$40a35920732ae269$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $40a35920732ae269$var$_default = module.exports.default = $40a35920732ae269$var$CrossCircleIcon;

});

parcelRegister("0q6NC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $001440d6cab67792$var$_react = $001440d6cab67792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $001440d6cab67792$var$_crossCircle = $001440d6cab67792$var$_interopRequireDefault((parcelRequire("1YMh4")));
function $001440d6cab67792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $001440d6cab67792$var$SelectClearIcon = (props)=>/*#__PURE__*/ $001440d6cab67792$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $001440d6cab67792$var$_crossCircle.default
    }));
$001440d6cab67792$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $001440d6cab67792$var$_default = module.exports.default = $001440d6cab67792$var$SelectClearIcon;

});
parcelRegister("1YMh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1710d74ae21b1552$var$_react = $1710d74ae21b1552$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1710d74ae21b1552$var$_UNSAFE_baseNew = $1710d74ae21b1552$var$_interopRequireDefault((parcelRequire("huIZN")));
function $1710d74ae21b1552$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1710d74ae21b1552$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $1710d74ae21b1552$var$_react.default.createElement($1710d74ae21b1552$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$1710d74ae21b1552$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $1710d74ae21b1552$var$_default = module.exports.default = $1710d74ae21b1552$var$CrossCircleIcon;

});




parcelRegister("4JSbr", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $0153da45dac65b9d$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $0153da45dac65b9d$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $0q6NC = parcelRequire("0q6NC");

var $8zEy7 = parcelRequire("8zEy7");

var $294ns = parcelRequire("294ns");

var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");

var $8gxSq = parcelRequire("8gxSq");
function $0153da45dac65b9d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0153da45dac65b9d$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $0153da45dac65b9d$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $0153da45dac65b9d$var$iconWrapperStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.025'
});
const $0153da45dac65b9d$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $294ns.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8zEy7))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $294ns.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsFR3.default), {
            xcss: $0153da45dac65b9d$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8zEy7))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0q6NC))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).MultiValueRemove, props, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $0153da45dac65b9d$var$disabledStyles : $0153da45dac65b9d$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $0153da45dac65b9d$export$bd638c2ba7915668 = null;

});

parcelRegister("hUvN1", function(module, exports) {

$parcel$export(module.exports, "Input", () => $9750d8536a9a9c8e$export$f5b8910cec6cf069);

var $5uXOq = parcelRequire("5uXOq");

var $32eUr = parcelRequire("32eUr");
function $9750d8536a9a9c8e$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("7SD1Y", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $437e31a7ed0fe2ce$export$d58b72b7d3c4072c);

var $5uXOq = parcelRequire("5uXOq");

var $1m92z = parcelRequire("1m92z");

var $32eUr = parcelRequire("32eUr");
const $437e31a7ed0fe2ce$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("i4Azc", function(module, exports) {

$parcel$export(module.exports, "default", () => $420fec5a5b07fd33$export$2e2bcd8739ae039);

var $294ns = parcelRequire("294ns");

function $420fec5a5b07fd33$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $294ns.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $5e0c0d4e15efb4a6$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $294ns.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("fw6Sj", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $3e8e0fe1c9158c20$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $3e8e0fe1c9158c20$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $3e8e0fe1c9158c20$export$8ee33f304118fce4);
function $3e8e0fe1c9158c20$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $3e8e0fe1c9158c20$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $3e8e0fe1c9158c20$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});




parcelRegister("bkrRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $edba0a4edd60a46b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edba0a4edd60a46b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dependencyLinesSection: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.dependency-lines-section",
        "defaultMessage": "Dependency lines"
    },
    showOfftrackDependencyLines: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-offtrack-dependency-lines",
        "defaultMessage": "Show lines for all off-track dependency lines"
    },
    offtrackDependenciesHelpLink: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.offtrack-dependencies-help-link",
        "defaultMessage": "What are off-track dependencies?"
    },
    showDependenciesOnIssues: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-dependencies-on-issues",
        "defaultMessage": "Show lines for dependencies linked to"
    },
    chooseIssue: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue",
        "defaultMessage": "Choose issue..."
    },
    onlyShowScheduledIssueDependencyLinesTooltip: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip",
        "defaultMessage": "Lines only show once an issue has been scheduled"
    }
});

});



const $3795a016b6403547$export$8be246eeba922980 = 'jsw-tailored-board-view-onboarding';
const $3795a016b6403547$export$a57856d4380e4bb8 = 'viewSettingsButtonTarget';
const $3795a016b6403547$export$989661c424340ff8 = 'viewSettingsPanelTarget';
const $3795a016b6403547$export$4a16d41d3ff730bf = 'addPeopleButtonTarget';


parcelRegister("le1bQ", function(module, exports) {

$parcel$export(module.exports, "useAllCardGroups", () => $a48f57b5dc3a0ae9$export$c3f5757fe39cf802);

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $a48f57b5dc3a0ae9$export$c3f5757fe39cf802 = ()=>{
    const allCardGroups = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetAllAttachedToParentCardGroupEntries))();
    return allCardGroups;
};

});





parcelRegister("e2Elo", function(module, exports) {

$parcel$export(module.exports, "PanelWrapper", () => $7b02c43f9e7d11dc$export$f537a9b13aef4d02);
$parcel$export(module.exports, "EpicPanelWithErrorBoundary", () => $7b02c43f9e7d11dc$export$852c474275ac8b90);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $39xOx = parcelRequire("39xOx");

var $iXVV6 = parcelRequire("iXVV6");

var $5NBkv = parcelRequire("5NBkv");

var $dZggJ = parcelRequire("dZggJ");

var $eSUJA = parcelRequire("eSUJA");

var $c1MAf = parcelRequire("c1MAf");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $lDDqj = parcelRequire("lDDqj");

var $f9Swb = parcelRequire("f9Swb");

var $1z1J7 = parcelRequire("1z1J7");

var $fSgHa = parcelRequire("fSgHa");

var $zM1Qq = parcelRequire("zM1Qq");

var $dM9vk = parcelRequire("dM9vk");
const $7b02c43f9e7d11dc$export$f69665587e333870 = ({ boardId: boardId, selectedIssues: selectedIssues, issueHierarchyLevel: issueHierarchyLevel, epicLinkFieldId: epicLinkFieldId, onEpicPanelClose: onEpicPanelClose, onCardDetailClick: onCardDetailClick, onEpicCreate: onEpicCreate, onEpicAssign: onEpicAssign, isCompanyManaged: isCompanyManaged })=>{
    const isEpicPanelOpen = (0, $zM1Qq.useIsEpicPanelOpen)();
    const baseLevelCardTypes = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getBaseLevelCardTypes));
    const selectedIssuesWithTypeHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.selectedPartialCardsWithTypeHierarchyLevelSelector));
    const canCreate = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canCreateIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const isCmpManaged = (0, $fSgHa.useIsCMPBacklog)();
    const sourceDroppableType = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getSourceDroppableType));
    return isEpicPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "epic panel",
        experienceTargetId: `${boardId}`,
        experienceSource: (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $dZggJ.ANALYTICS_SOURCE_EPIC_PANEL),
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b02c43f9e7d11dc$export$f537a9b13aef4d02, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSUJA.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        boardId: boardId,
        isCompanyManaged: isCmpManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NBkv.default), {
        selectedIssues: isCompanyManaged ? selectedIssuesWithTypeHierarchyLevel : selectedIssues,
        defaultIssueCreateIssueTypeId: baseLevelCardTypes[0]?.id.toString(),
        onClose: onEpicPanelClose,
        onCardDetailClick: onCardDetailClick,
        onEpicCreate: onEpicCreate,
        onEpicAssign: onEpicAssign,
        isCompanyManaged: isCompanyManaged,
        epicLinkFieldId: epicLinkFieldId,
        hierarchyName: firstLevelHierarchyName,
        canCreate: canCreate,
        canEdit: canEdit
    }))))) : null;
};
const $7b02c43f9e7d11dc$export$852c474275ac8b90 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "backlogContentEpicPanel",
        teamName: "a4t-tanuki",
        packageName: "jiraSoftwareBacklog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b02c43f9e7d11dc$export$f69665587e333870, props));
const $7b02c43f9e7d11dc$export$f537a9b13aef4d02 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1yt41c8u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5NBkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $339fc654e2f8db18$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $3aqXA = parcelRequire("3aqXA");

const $339fc654e2f8db18$export$f69665587e333870 = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("1VvzR")), {
    ssr: false,
    moduleId: "./src/packages/software/backlog-panel/src/ui/epic/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$339fc654e2f8db18$export$2e2bcd8739ae039 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $3aqXA.useViewEpicPanelExperienceTracker)({
        isClassic: props.isCompanyManaged || false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async.jira.backlog.panel",
        packageName: "jiraSoftwareBacklogPanel",
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "backlog-panel-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($339fc654e2f8db18$export$f69665587e333870, props)));
};

});
parcelRegister("3aqXA", function(module, exports) {

$parcel$export(module.exports, "useViewEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$c1017fffc722d968);
$parcel$export(module.exports, "useInlineIssueCreateEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$7ab965f5d69be412);
$parcel$export(module.exports, "useGlobalIssueCreateEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$dff71c2c64b5caea);
$parcel$export(module.exports, "useAssignEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$98afccaa5b17be1);
$parcel$export(module.exports, "useUnassignEpicPanelExperienceTracker", () => $76790e6e87ec47c2$export$51f7a79bb0e6c44e);
$parcel$export(module.exports, "useRankExperienceTracker", () => $76790e6e87ec47c2$export$8942fc10da43a00a);

var $a6ebl = parcelRequire("a6ebl");

var $dZggJ = parcelRequire("dZggJ");
const $76790e6e87ec47c2$export$c1017fffc722d968 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_VIEW_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$7ab965f5d69be412 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$dff71c2c64b5caea = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$98afccaa5b17be1 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_ASSIGN_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$51f7a79bb0e6c44e = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_UNASSIGN_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);
const $76790e6e87ec47c2$export$8942fc10da43a00a = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $dZggJ.APP_ID), (0, $dZggJ.EPIC_PANEL_RANK_EXPERIENCE), (0, $dZggJ.EXPERIENCE_TRACKER_PROVIDER_SOURCE), attributes);

});
parcelRegister("a6ebl", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $ff81be28c31601ee$export$cdefb2a8b53f879f);

var $5uXOq = parcelRequire("5uXOq");

var $8dXDG = parcelRequire("8dXDG");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");


var $gk7Z3 = parcelRequire("gk7Z3");
const $ff81be28c31601ee$export$cdefb2a8b53f879f = (experienceId, experience, analyticsSource, attributes = {})=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const fireExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: experienceId,
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
    const commonAttributes = (0, $5uXOq.useMemo)(()=>(0, $gk7Z3.createCommonAttributes)(attributes), [
        attributes
    ]);
    const fireExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceAbort = (0, $8dXDG.useExperienceAbort)({
        experience: experience,
        attributes: commonAttributes
    });
    const fireExperienceError = (0, $5uXOq.useCallback)((error, errorAttributes = {})=>{
        if ((0, $gk7Z3.isSloFailure)(error)) fireExperienceFail(experienceId, error, {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
        else fireExperienceAbort((0, $463a875e77767855$export$e6589edd1f8a04af), {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
    }, [
        experienceId,
        fireExperienceAbort,
        fireExperienceFail
    ]);
    const fireErrorBoundaryExperienceFail = (0, $5uXOq.useCallback)((location, error, errorAttributes = {})=>{
        fireExperienceFail(location || experienceId, error, {
            ...(0, $gk7Z3.getErrorAttributes)(error),
            ...errorAttributes
        });
    }, [
        experienceId,
        fireExperienceFail
    ]);
    return {
        fireExperienceStart: fireExperienceStart,
        fireExperienceSuccess: fireExperienceSuccess,
        fireExperienceError: fireExperienceError,
        fireExperienceFail: fireExperienceFail,
        fireExperienceAbort: fireExperienceAbort,
        fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail
    };
};

});
const $463a875e77767855$export$ba068cc3610b559d = 'NOT_PRESENT';
const $463a875e77767855$export$78244dbb77cfa6b6 = 'unknown';
const $463a875e77767855$export$d441f436c87942f5 = '1xx';
const $463a875e77767855$export$b29a3bb66f63d888 = '3xx';
const $463a875e77767855$export$16e7f409a0d3529f = '4xx';
const $463a875e77767855$export$549a32621a554e7c = '5xx';
const $463a875e77767855$export$e6589edd1f8a04af = 'Aborting due to non SLO failures';

parcelRegister("gk7Z3", function(module, exports) {

$parcel$export(module.exports, "extractStatusCode", () => $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "getErrorAttributes", () => $b10dba156c9c5dc5$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "isSloFailure", () => $b10dba156c9c5dc5$export$2ab75c18c9535885);
$parcel$export(module.exports, "isHttpConflictRequestResponse", () => $b10dba156c9c5dc5$export$35ef4ce2961027c7);
$parcel$export(module.exports, "createCommonAttributes", () => $b10dba156c9c5dc5$export$7916ec13418094a3);

var $9XE6b = parcelRequire("9XE6b");

var $fZneA = parcelRequire("fZneA");

var $eXLLu = parcelRequire("eXLLu");

const $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName = (error)=>{
    const graphqlErrorExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions'
    ], null);
    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphqlErrorExtensions, [
        'errorType'
    ]);
    if (errorType) return errorType;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphqlErrorExtensions, [
        'operationName'
    ]);
};
const $b10dba156c9c5dc5$var$extractErrorName = (error)=>{
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ]);
    if (networkError) return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'name'
    ], (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], (0, $463a875e77767855$export$ba068cc3610b559d)));
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], []);
    if (graphQLErrors && graphQLErrors.length > 0) {
        const graphqlErrorExtensionsName = $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0
        ]));
        if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    }
    const graphqlErrorExtensionsName = $b10dba156c9c5dc5$var$extractGraphQLExtensionErrorName(error);
    if (graphqlErrorExtensionsName) return graphqlErrorExtensionsName;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
};
const $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors',
        0,
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'status'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'status'
    ]) || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$export$f3626cbbcad37421 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    if (!statusCode) return 0, $463a875e77767855$export$ba068cc3610b559d;
    if (statusCode >= 100 && statusCode < 200) return 0, $463a875e77767855$export$d441f436c87942f5;
    if (statusCode >= 300 && statusCode < 400) return 0, $463a875e77767855$export$b29a3bb66f63d888;
    if (statusCode >= 400 && statusCode < 500) return 0, $463a875e77767855$export$16e7f409a0d3529f;
    if (statusCode >= 500 && statusCode < 600) return 0, $463a875e77767855$export$549a32621a554e7c;
    return 0, $463a875e77767855$export$78244dbb77cfa6b6;
};
const $b10dba156c9c5dc5$var$extractTraceId = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'traceId'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'request_id'
    ], (0, $463a875e77767855$export$ba068cc3610b559d)) || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$var$extractErrorMessage = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'message'
    ]) || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'extensions',
        'userMessage'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
const $b10dba156c9c5dc5$var$extractErrorStack = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'stack'
    ], (0, $463a875e77767855$export$ba068cc3610b559d));
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b10dba156c9c5dc5$var$getBuildKey = ()=>window.BUILD_KEY || (0, $463a875e77767855$export$ba068cc3610b559d);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $b10dba156c9c5dc5$var$getSsrBuildKey = ()=>window.SSR_BUILD_KEY || (0, $463a875e77767855$export$ba068cc3610b559d);
const $b10dba156c9c5dc5$export$6ad9e7706a4ee0f8 = (error)=>({
        errorName: $b10dba156c9c5dc5$var$extractErrorName(error),
        errorMessage: $b10dba156c9c5dc5$var$extractErrorMessage(error),
        errorStack: $b10dba156c9c5dc5$var$extractErrorStack(error),
        statusCode: $b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error),
        statusCodeGroup: $b10dba156c9c5dc5$export$f3626cbbcad37421(error),
        traceId: $b10dba156c9c5dc5$var$extractTraceId(error),
        buildKey: $b10dba156c9c5dc5$var$getBuildKey(),
        ssrBuildKey: $b10dba156c9c5dc5$var$getSsrBuildKey()
    });
const $b10dba156c9c5dc5$export$2b62e563f0fadcee = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode >= 400 && statusCode < 500;
};
const $b10dba156c9c5dc5$export$dc0d2c5fff67f524 = (error)=>(0, $fZneA.isClientFetchError)(error);
const $b10dba156c9c5dc5$export$2ab75c18c9535885 = (error)=>!$b10dba156c9c5dc5$export$dc0d2c5fff67f524(error) && !$b10dba156c9c5dc5$export$2b62e563f0fadcee(error);
const $b10dba156c9c5dc5$export$9d73d6caff63cf52 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 429;
};
const $b10dba156c9c5dc5$export$35ef4ce2961027c7 = (error)=>{
    const statusCode = Number($b10dba156c9c5dc5$export$1fdf7c1c0741a7e7(error));
    return Number.isNaN(statusCode) ? false : statusCode === 409;
};
const $b10dba156c9c5dc5$export$7916ec13418094a3 = (attributes = {})=>({
        synthetic: (0, $eXLLu.isPollinatorTenant)(),
        isUIF: true,
        isClassic: false,
        ...attributes
    });

});
parcelRegister("eXLLu", function(module, exports) {

$parcel$export(module.exports, "isPollinatorTenant", () => $4b0551c65984b18f$export$f59b7b56b5cada61);

var $co1wz = parcelRequire("co1wz");
const $4b0551c65984b18f$export$f59b7b56b5cada61 = ()=>(0, $co1wz.ff)('jsw.pollinator.tenants');

});



parcelRegister("dZggJ", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $24ba128e04401c75$export$d76071d5de2774fc);
$parcel$export(module.exports, "DIVIDER_DRAGGABLE_ID_PREFIX", () => $24ba128e04401c75$export$ed2b0386b406afb8);
$parcel$export(module.exports, "ANALYTICS_SOURCE_EPIC_PANEL", () => $24ba128e04401c75$export$f1fdbf1399e060a9);
$parcel$export(module.exports, "EXPERIENCE_TRACKER_PROVIDER_SOURCE", () => $24ba128e04401c75$export$d91023b42bd42fec);
$parcel$export(module.exports, "EPIC_PANEL_VIEW_EXPERIENCE", () => $24ba128e04401c75$export$226ec0e287da7094);
$parcel$export(module.exports, "EPIC_PANEL_INLINE_ISSUE_CREATE_EXPERIENCE", () => $24ba128e04401c75$export$c7ce0888e908ec32);
$parcel$export(module.exports, "EPIC_PANEL_GLOBAL_ISSUE_CREATE_EXPERIENCE", () => $24ba128e04401c75$export$64c0a8fb162be663);
$parcel$export(module.exports, "EPIC_PANEL_ASSIGN_EXPERIENCE", () => $24ba128e04401c75$export$562f3a50ddeda12d);
$parcel$export(module.exports, "EPIC_PANEL_UNASSIGN_EXPERIENCE", () => $24ba128e04401c75$export$95ac924aa931f0a6);
$parcel$export(module.exports, "EPIC_PANEL_RANK_EXPERIENCE", () => $24ba128e04401c75$export$28fe94147fbd3844);
$parcel$export(module.exports, "ABORT_EXPERIENCE_MISSING_REQUIRED_FIELD_REASON", () => $24ba128e04401c75$export$681650f90e45ec69);
$parcel$export(module.exports, "ABORT_EXPERIENCE_CANCELED_BY_USE_REASON", () => $24ba128e04401c75$export$7087cf857048f677);
$parcel$export(module.exports, "DEFAULT_PARENT_ISSUE_TYPE_NAME", () => $24ba128e04401c75$export$cb17e3c17bc50301);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $24ba128e04401c75$export$794f07be04aca3fe);
$parcel$export(module.exports, "UNASSIGNED_EPIC_ISSUE_KEY", () => $24ba128e04401c75$export$7766a7962c866d1a);
$parcel$export(module.exports, "CREATE_ISSUE_PERMISSION", () => $24ba128e04401c75$export$80936eba88d0cae);
$parcel$export(module.exports, "EDIT_ISSUE_PERMISSION", () => $24ba128e04401c75$export$762e6520d5274be2);
$parcel$export(module.exports, "REALTIME_EVENTS", () => $24ba128e04401c75$export$a45e758f2a5806e6);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_SET", () => $24ba128e04401c75$export$41f0d8a4d1ec169b);
$parcel$export(module.exports, "DND_OPERATION_CARD_PARENT_UNSET", () => $24ba128e04401c75$export$5fd94e0ea08b5e7);
$parcel$export(module.exports, "DND_OPERATION_EPIC_RANK_UPDATE", () => $24ba128e04401c75$export$bc493dacb9d33787);
$parcel$export(module.exports, "EPIC_CARD_DESCRIPTION_ID", () => $24ba128e04401c75$export$5511b715832e28a2);
$parcel$export(module.exports, "PAGE_SIZE", () => $24ba128e04401c75$export$8ec3d08588d2eeda);

const $24ba128e04401c75$export$d76071d5de2774fc = 'software.backlog-panel';
const $24ba128e04401c75$export$ed2b0386b406afb8 = 'DIVIDER_DRAGGABLE_ID';
const $24ba128e04401c75$export$f1fdbf1399e060a9 = 'epic panel';
const $24ba128e04401c75$export$d91023b42bd42fec = 'epicPanel';
const $24ba128e04401c75$export$226ec0e287da7094 = 'viewEpicPanel';
const $24ba128e04401c75$export$c7ce0888e908ec32 = 'createInlineIssueEpicPanel';
const $24ba128e04401c75$export$64c0a8fb162be663 = 'createGlobalIssueEpicPanel';
const $24ba128e04401c75$export$562f3a50ddeda12d = 'assignEpicPanel';
const $24ba128e04401c75$export$95ac924aa931f0a6 = 'unassignEpicPanel';
const $24ba128e04401c75$export$28fe94147fbd3844 = 'rankCardEpicPanel';
const $24ba128e04401c75$export$681650f90e45ec69 = 'require-field-missing';
const $24ba128e04401c75$export$7087cf857048f677 = 'global-issue-create-canceled-by-user';
const $24ba128e04401c75$export$c0489c066d9ea3d7 = 'EPIC_DRAGGABLE_ID';
const $24ba128e04401c75$export$90fd9c0c8ddec7d = 'EPIC_PANEL';
const $24ba128e04401c75$export$3db8e82d899e7d2a = 'EPIC_PANEL';
const $24ba128e04401c75$export$1d0e22f9f6b83f8c = 'CARD';
const $24ba128e04401c75$export$849c01670da437ac = 'CARD-GROUP';
const $24ba128e04401c75$export$de67c9c28353ce6e = 'EPIC-';
const $24ba128e04401c75$export$28ad8b364940d9aa = 'VERSION-';
const $24ba128e04401c75$export$cb17e3c17bc50301 = 'Epic';
const $24ba128e04401c75$export$794f07be04aca3fe = 0;
const $24ba128e04401c75$export$7766a7962c866d1a = 'ISK-0';
const $24ba128e04401c75$export$80936eba88d0cae = 'CREATE_ISSUE';
const $24ba128e04401c75$export$762e6520d5274be2 = 'EDIT_ISSUE';
const $24ba128e04401c75$export$a45e758f2a5806e6 = [
    (0, $09d938f04e8899c4$export$86d416e8d15777d),
    (0, $09d938f04e8899c4$export$b22a14d5dac59664),
    (0, $09d938f04e8899c4$export$25fa37e5059c5a99),
    (0, $09d938f04e8899c4$export$d9bc8850eeef9f60),
    (0, $09d938f04e8899c4$export$b22142e61b3fdbee),
    (0, $09d938f04e8899c4$export$6b7e46ea0442b66c)
];
const $24ba128e04401c75$export$dedbdcc35e955187 = 'BACKLOG';
const $24ba128e04401c75$export$9b8283d5878d2491 = 'BOARD';
const $24ba128e04401c75$export$a316570a0dbfd2b0 = 'SPRINT';
const $24ba128e04401c75$export$adbf9ce386bc3037 = 'activeSprint';
const $24ba128e04401c75$export$bb216fa10db6b6bb = 'futureSprint';
const $24ba128e04401c75$export$3df2915b3d2a36e = 'sprint';
const $24ba128e04401c75$export$338b523135b4db48 = 'board';
const $24ba128e04401c75$export$f6bf4fdaad3caf69 = 'backlog';
const $24ba128e04401c75$export$67e35e305110c91d = 'epicPanel';
const $24ba128e04401c75$export$f95492d2a4f371d0 = 'versionPanel';
const $24ba128e04401c75$export$695859afe4db61d7 = 'backlogCard';
const $24ba128e04401c75$export$b1b86bcaf2a12330 = 'epicPanelCard';
const $24ba128e04401c75$export$2e29fc7afa544ab5 = 'versionPanelCard';
const $24ba128e04401c75$export$62679ec8251801eb = 'divider';
const $24ba128e04401c75$export$41f0d8a4d1ec169b = 'cardParentSet';
const $24ba128e04401c75$export$5fd94e0ea08b5e7 = 'cardParentUnset';
const $24ba128e04401c75$export$bc493dacb9d33787 = 'epicRankUpdate';
const $24ba128e04401c75$export$5511b715832e28a2 = 'epicCardDescriptionId';
const $24ba128e04401c75$export$9efe2bc97f2b0faa = 1510;
const $24ba128e04401c75$export$8ec3d08588d2eeda = 100;

});


parcelRegister("1VvzR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("eInVz")
]).then(()=>parcelRequire('8pv3s'));

});


parcelRegister("eSUJA", function(module, exports) {

$parcel$export(module.exports, "PanelDataProvider", () => $7bfe6da32abe9d26$export$3391167f05694d55);
$parcel$export(module.exports, "usePanelData", () => $7bfe6da32abe9d26$export$50f78812a0e4a6ee);

var $5uXOq = parcelRequire("5uXOq");
const $7bfe6da32abe9d26$var$PanelDataContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isCompanyManaged: false,
    boardId: -1,
    sourceDroppableType: ''
});
const $7bfe6da32abe9d26$export$3391167f05694d55 = ({ children: children, isCompanyManaged: isCompanyManaged, boardId: boardId, sourceDroppableType: sourceDroppableType })=>{
    const panelData = (0, $5uXOq.useMemo)(()=>({
            isCompanyManaged: isCompanyManaged,
            boardId: boardId,
            sourceDroppableType: sourceDroppableType
        }), [
        boardId,
        isCompanyManaged,
        sourceDroppableType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bfe6da32abe9d26$var$PanelDataContext.Provider, {
        value: panelData
    }, children);
};
const $7bfe6da32abe9d26$export$50f78812a0e4a6ee = ()=>(0, $5uXOq.useContext)($7bfe6da32abe9d26$var$PanelDataContext);

});

parcelRegister("f9Swb", function(module, exports) {

$parcel$export(module.exports, "getFirstLevelHierarchyName", () => $e53306d45f784739$export$ef3b2d218d80725);

var $9Pc1U = parcelRequire("9Pc1U");
const $e53306d45f784739$export$ef3b2d218d80725 = (state)=>(0, $9Pc1U.getConfig)(state).hierarchyNomenclature?.firstLevelName ?? null;

});

parcelRegister("zM1Qq", function(module, exports) {

$parcel$export(module.exports, "useIsEpicPanelOpen", () => $36715c326826e8ee$export$b8bc95e738a09ae0);

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $9Pc1U = parcelRequire("9Pc1U");
const $36715c326826e8ee$export$b8bc95e738a09ae0 = ()=>{
    const showEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const isEpicsOpen = (0, $iDGXn.useShowEpicPanel)();
    if (!showEpicAsPanel) return false;
    return isEpicsOpen;
};

});

parcelRegister("dM9vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa94a3ab92e4f7fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");

var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $1u3Jv = parcelRequire("1u3Jv");

var $efvDm = parcelRequire("efvDm");

var $gk7Z3 = parcelRequire("gk7Z3");

var $9OXo1 = parcelRequire("9OXo1");


var $fSgHa = parcelRequire("fSgHa");
const $fa94a3ab92e4f7fb$var$SLAExperienceTracker = ({ experienceTarget: experienceTarget = '', experienceTargetId: experienceTargetId = '', experienceSource: experienceSource = (0, $a9c483c0d986286a$export$840e3848643f7781), additionalAttributes: additionalAttributes = {}, children: children })=>{
    const { appEditions: { software: software } } = (0, $9OXo1.useTenantContext)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const experienceTargetKey = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(experienceTarget);
    const experienceId = experienceTargetId ? `${experienceTargetKey}-${experienceTargetId}` : experienceTargetKey;
    const experience = `view${experienceTargetKey.charAt(0).toUpperCase()}${experienceTargetKey.slice(1)}`;
    const experienceLocation = experienceTarget ? `${0, $a9c483c0d986286a$export$b6e4306772e8a60d}-${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(experienceTarget)}` : (0, $a9c483c0d986286a$export$b6e4306772e8a60d);
    const onSuccess = ({ onExperienceSuccess: onExperienceSuccess })=>()=>{
            onExperienceSuccess();
        };
    const onError = ({ onExperienceFailure: onExperienceFailure })=>(location, error)=>{
            onExperienceFailure(undefined, (0, $gk7Z3.getErrorAttributes)(error));
        };
    const viewExperienceTracker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: experienceLocation
    }, (trackerCallbacks)=>typeof children === 'function' ? children({
            onSuccess: onSuccess(trackerCallbacks),
            onError: onError(trackerCallbacks)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
            op: trackerCallbacks.onExperienceSuccess
        })));
    return experienceTarget ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: experienceSource,
        edition: software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isUIF: true,
            isClassic: isCompanyManaged,
            ...additionalAttributes
        }
    }, viewExperienceTracker) : viewExperienceTracker;
};
var $fa94a3ab92e4f7fb$export$2e2bcd8739ae039 = $fa94a3ab92e4f7fb$var$SLAExperienceTracker;

});


parcelRegister("jg0aS", function(module, exports) {

$parcel$export(module.exports, "MoreResults", () => $04dab9ba2b61efe8$export$1f344df69afb392e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable @atlaskit/design-system/no-html-button */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a6JBZ = parcelRequire("a6JBZ");

var $jdGaP = parcelRequire("jdGaP");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $5tMAe = parcelRequire("5tMAe");

var $c1MAf = parcelRequire("c1MAf");

var $l9VFH = parcelRequire("l9VFH");

var $fxK3Z = parcelRequire("fxK3Z");
const $04dab9ba2b61efe8$export$1f344df69afb392e = ({ scrollableParentRef: scrollableParentRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const [{ isLastResultMarkerBelowFold: isLastResultMarkerBelowFold }] = (0, $5tMAe.useMoreResultsStore)();
    const filtersAreApplied = Object.keys(filters).length > 0;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'moreResultsButton'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        if (scrollableParentRef.current) scrollableParentRef.current.scrollTo({
            top: scrollableParentRef.current.scrollTop + scrollableParentRef.current.clientHeight,
            behavior: 'smooth'
        });
    };
    if (!filtersAreApplied || !isLastResultMarkerBelowFold) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04dab9ba2b61efe8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04dab9ba2b61efe8$var$SeeMoreButton, {
        onClick: handleClick,
        tabIndex: -1,
        "aria-hidden": true
    }, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a6JBZ))), {
        label: formatMessage((0, $fxK3Z.default).downArrowIconLabel),
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jdGaP))),
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdGaP))), {
        label: formatMessage((0, $fxK3Z.default).downArrowIconLabel)
    }), formatMessage((0, $fxK3Z.default).moreResults)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04dab9ba2b61efe8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1pbyb4wl _1ltvidpf _1xi2idpf _94n51ejb _1e0c1txw _1bah1h6o _lcxvglyw _4t3iidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04dab9ba2b61efe8$var$SeeMoreButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1ns9 _4t3i1ns9 _1yt41r6r _19itglyw _2rko7vkz _syazjjyb _bfhk1bhr _16qs1mxi _80omtlke _lcxv1wug _19lc134c _9h8h11ce _1di61s8i",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a6JBZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf1bf814ca1500813733301d71932a50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75bdd87a95d0c5d2$var$_react = $75bdd87a95d0c5d2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $75bdd87a95d0c5d2$var$_UNSAFE_baseNew = $75bdd87a95d0c5d2$var$_interopRequireDefault((parcelRequire("huIZN")));
function $75bdd87a95d0c5d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75bdd87a95d0c5d2$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $75bdd87a95d0c5d2$var$_react.default.createElement($75bdd87a95d0c5d2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$75bdd87a95d0c5d2$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $75bdd87a95d0c5d2$var$_default = module.exports.default = $75bdd87a95d0c5d2$var$ArrowDownIcon;

});

parcelRegister("jdGaP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfdff20973f2c036$var$_react = $dfdff20973f2c036$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $dfdff20973f2c036$var$_arrowDown = $dfdff20973f2c036$var$_interopRequireDefault((parcelRequire("a6JBZ")));
function $dfdff20973f2c036$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfdff20973f2c036$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $dfdff20973f2c036$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $dfdff20973f2c036$var$_arrowDown.default
    }));
$dfdff20973f2c036$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $dfdff20973f2c036$var$_default = module.exports.default = $dfdff20973f2c036$var$ArrowDownIcon;

});

parcelRegister("5tMAe", function(module, exports) {

$parcel$export(module.exports, "useMoreResultsStore", () => $8ee95b61ca54be42$export$2562d6b68d41f3d2);

var $7JoAD = parcelRequire("7JoAD");
const $8ee95b61ca54be42$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        isLastResultMarkerBelowFold: false
    },
    actions: {
        setIsLastResultMarkerBelowFold: (isLastResultMarkerBelowFold)=>({ setState: setState })=>{
                setState({
                    isLastResultMarkerBelowFold: isLastResultMarkerBelowFold
                });
            }
    },
    name: 'more-results'
});
const $8ee95b61ca54be42$export$2562d6b68d41f3d2 = (0, $7JoAD.createHook)($8ee95b61ca54be42$var$Store);

});

parcelRegister("fxK3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1344643ed085ae13$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1344643ed085ae13$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreResults: {
        "id": "backlog.backlog-content.more-results.more-results",
        "defaultMessage": "More results"
    },
    downArrowIconLabel: {
        "id": "backlog.backlog-content.more-results.down-arrow-icon-label",
        "defaultMessage": "Down arrow"
    }
});

});


parcelRegister("eX9XD", function(module, exports) {

$parcel$export(module.exports, "useAutoScroller", () => $fb572b128a540b81$export$f9101ea66b86493d);

var $5uXOq = parcelRequire("5uXOq");

var $ebjBl = parcelRequire("ebjBl");

var $7Gk7K = parcelRequire("7Gk7K");
const $fb572b128a540b81$export$ec5b303098bc4b7f = {
    onDragStart: ({ location: location })=>{
        (0, $ebjBl.autoScroller).start({
            input: location.current.input
        });
    },
    onDrop: ()=>{
        (0, $ebjBl.autoScroller).stop();
    },
    onDrag: ({ location: location })=>{
        (0, $ebjBl.autoScroller).updateInput({
            input: location.current.input
        });
    }
};
function $fb572b128a540b81$export$f9101ea66b86493d() {
    (0, $5uXOq.useEffect)(()=>(0, $7Gk7K.monitorForElements)($fb572b128a540b81$export$ec5b303098bc4b7f), []);
}

});
parcelRegister("ebjBl", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $31085a89431353c9$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $31085a89431353c9$export$d19940cfc7560cd8);

var $4T6wq = parcelRequire("4T6wq");
const $31085a89431353c9$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $31085a89431353c9$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $31085a89431353c9$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $4T6wq.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $31085a89431353c9$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $31085a89431353c9$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $31085a89431353c9$export$d19940cfc7560cd8 = $31085a89431353c9$export$fbda4b72e803ec38();

});
parcelRegister("4T6wq", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $328944a3087f33ac$export$209876d7b1ac8f3);
parcelRequire("i58bg");
var $hDTor = parcelRequire("hDTor");

var $2r2Ov = parcelRequire("2r2Ov");

var $a24fo = parcelRequire("a24fo");

var $hm4aU = parcelRequire("hm4aU");

var $0cJb5 = parcelRequire("0cJb5");

var $bDiNO = parcelRequire("bDiNO");
const $328944a3087f33ac$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $bDiNO.default)();
        const windowScrollChange = (0, $0cJb5.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $hDTor.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $2r2Ov.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $a24fo.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $hm4aU.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("i58bg", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("hDTor")).getElementFromPointWithoutHoneypot);

var $hDTor = parcelRequire("hDTor");

});

parcelRegister("2r2Ov", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $6aff7b345261b99a$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $6aff7b345261b99a$var$isEqual = (base)=>(value)=>base === value;
const $6aff7b345261b99a$var$isScroll = $6aff7b345261b99a$var$isEqual('scroll');
const $6aff7b345261b99a$var$isAuto = $6aff7b345261b99a$var$isEqual('auto');
const $6aff7b345261b99a$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $6aff7b345261b99a$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $6aff7b345261b99a$var$isEither(overflow, $6aff7b345261b99a$var$isScroll) || $6aff7b345261b99a$var$isEither(overflow, $6aff7b345261b99a$var$isAuto);
};
const $6aff7b345261b99a$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$6aff7b345261b99a$var$isElementScrollable(el)) // keep recursing
    return $6aff7b345261b99a$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("a24fo", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $a66198291baed816$export$9b7238c949d126e9);

var $3YKxB = parcelRequire("3YKxB");
const $a66198291baed816$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $3YKxB.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("hm4aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4394b5da6a5011$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $bmdQp = parcelRequire("bmdQp");

var $7wcXG = parcelRequire("7wcXG");
var $da4394b5da6a5011$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $7wcXG.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $bmdQp.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("bmdQp", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $0c502e1df626a549$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $0c502e1df626a549$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $iiqlU = parcelRequire("iiqlU");
const $0c502e1df626a549$var$smallestSigned = (0, $iiqlU.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $0c502e1df626a549$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $iiqlU.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $iiqlU.isEqual)(overlap, (0, $iiqlU.origin))) return null;
        return overlap;
    };
})();
const $0c502e1df626a549$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $0c502e1df626a549$var$smallestSigned(change);
    const overlap = $0c502e1df626a549$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $0c502e1df626a549$export$cbd1e6fd5e887f10 = (viewport, change)=>$0c502e1df626a549$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $0c502e1df626a549$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$0c502e1df626a549$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $0c502e1df626a549$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $0c502e1df626a549$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $0c502e1df626a549$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $0c502e1df626a549$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$0c502e1df626a549$export$57c21b61d76c9819(scrollable, change)) return null;
    return $0c502e1df626a549$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("iiqlU", function(module, exports) {

$parcel$export(module.exports, "origin", () => $da94024ef164216f$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $da94024ef164216f$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $da94024ef164216f$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $da94024ef164216f$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $da94024ef164216f$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $da94024ef164216f$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $da94024ef164216f$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $da94024ef164216f$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $da94024ef164216f$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $da94024ef164216f$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("7wcXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b7066c58b46c53a$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $jUgLu = parcelRequire("jUgLu");

var $iiqlU = parcelRequire("iiqlU");

var $c0t8E = parcelRequire("c0t8E");
// will replace -0 and replace with +0
const $0b7066c58b46c53a$var$clean = (0, $iiqlU.apply)((value)=>value === 0 ? 0 : value);
var $0b7066c58b46c53a$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $c0t8E.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $jUgLu.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $c0t8E.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $jUgLu.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $0b7066c58b46c53a$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $iiqlU.isEqual)(required, (0, $iiqlU.origin))) return null;
    return required;
};

});
parcelRegister("jUgLu", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $23f78cd3cd8841d9$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $23f78cd3cd8841d9$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $23f78cd3cd8841d9$export$641ecd0b2bc39508);
const $23f78cd3cd8841d9$export$67e2de1e1e796844 = 1;
const $23f78cd3cd8841d9$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $23f78cd3cd8841d9$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $23f78cd3cd8841d9$export$1a8fc111f6979e7a = [
    $23f78cd3cd8841d9$export$641ecd0b2bc39508.direction,
    $23f78cd3cd8841d9$export$32f8a6eb41d46820.direction
];

});

parcelRegister("c0t8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd4a2b490d72bdf$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $54k8n = parcelRequire("54k8n");

var $4JhFe = parcelRequire("4JhFe");
var $8bd4a2b490d72bdf$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $54k8n.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $4JhFe.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $4JhFe.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("54k8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $185b497164f73ba6$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $5ScPK = parcelRequire("5ScPK");
const $185b497164f73ba6$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $5ScPK.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $5ScPK.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $185b497164f73ba6$export$2e2bcd8739ae039 = $185b497164f73ba6$export$79446fee27934459;

});
parcelRegister("5ScPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $20f94b1fe8f5aa49$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $20f94b1fe8f5aa49$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $20f94b1fe8f5aa49$export$2e2bcd8739ae039 = $20f94b1fe8f5aa49$var$config;

});


parcelRegister("4JhFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb10eec42090a6c$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $jUgLu = parcelRequire("jUgLu");

var $l7DkO = parcelRequire("l7DkO");

var $TxZmK = parcelRequire("TxZmK");
const $8cb10eec42090a6c$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $TxZmK.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $l7DkO.dampenValueByTime)(scroll, dragStartTime), (0, $jUgLu.minScroll));
};
var $8cb10eec42090a6c$export$2e2bcd8739ae039 = $8cb10eec42090a6c$export$bf7199a9ebcb84a9;

});
parcelRegister("l7DkO", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $ff5db7a7cb1a93f7$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $5ScPK = parcelRequire("5ScPK");

var $jUgLu = parcelRequire("jUgLu");

var $8eTEv = parcelRequire("8eTEv");
const $ff5db7a7cb1a93f7$var$accelerateAt = (0, $5ScPK.default).durationDampening.accelerateAt;
const $ff5db7a7cb1a93f7$var$stopAt = (0, $5ScPK.default).durationDampening.stopDampeningAt;
const $ff5db7a7cb1a93f7$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $ff5db7a7cb1a93f7$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $ff5db7a7cb1a93f7$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $ff5db7a7cb1a93f7$var$accelerateAt) return 0, $jUgLu.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $8eTEv.getPercentage)({
        startOfRange: $ff5db7a7cb1a93f7$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $5ScPK.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("8eTEv", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $23ec9370ecb7d9c1$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $23ec9370ecb7d9c1$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("TxZmK", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $cb72d47151424722$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $5ScPK = parcelRequire("5ScPK");

var $jUgLu = parcelRequire("jUgLu");

var $8eTEv = parcelRequire("8eTEv");
const $cb72d47151424722$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $5ScPK.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $jUgLu.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $8eTEv.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $5ScPK.default).maxPixelScroll * (0, $5ScPK.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("0cJb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a867f5eee4a5d185$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $bmdQp = parcelRequire("bmdQp");

var $7wcXG = parcelRequire("7wcXG");
var $a867f5eee4a5d185$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $7wcXG.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $bmdQp.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("bDiNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fd879878b43d3bc$export$2e2bcd8739ae039);

var $3YKxB = parcelRequire("3YKxB");

var $3cYqu = parcelRequire("3cYqu");

var $jfWkt = parcelRequire("jfWkt");
var $3fd879878b43d3bc$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $jfWkt.default)();
    const maxScroll = (0, $3cYqu.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("3cYqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd02e4e7716a3b9$export$2e2bcd8739ae039);

var $hifOU = parcelRequire("hifOU");
var $cfd02e4e7716a3b9$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $hifOU.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("hifOU", function(module, exports) {

$parcel$export(module.exports, "default", () => $29dff2123725517d$export$2e2bcd8739ae039);

var $iiqlU = parcelRequire("iiqlU");
var $29dff2123725517d$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $iiqlU.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("jfWkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de26503826a7194$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$6de26503826a7194$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});





parcelRegister("fDXV9", function(module, exports) {

$parcel$export(module.exports, "useDragAnalytics", () => $5357a3fbb01800a4$export$660832909d6574f);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $7Gk7K = parcelRequire("7Gk7K");

var $8zOmE = parcelRequire("8zOmE");

const $5357a3fbb01800a4$export$5dd4ed888d5b12ca = ({ createAnalyticsEvent: createAnalyticsEvent, defaultIssueHierarchyLevel: defaultIssueHierarchyLevel })=>({
        onDragStart: ({ source: source })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragStarted',
                actionSubject: 'card'
            });
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                isDivider: source.data.type === 'DIVIDER',
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        },
        onDrop: ({ source: source, location: location })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'card'
            });
            const isAbort = location.current.dropTargets.length === 0;
            const isRank = location.current.dropTargets[0]?.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b);
            const isDivider = source.data.type === 'DIVIDER';
            // When moving from card list to epic/version panel cardListId wont exist in location.
            const isListMove = isDivider || typeof location.current.dropTargets[0]?.data.cardListId !== 'undefined' && location.current.dropTargets[0]?.data.cardListId !== source.data.cardListId;
            const isSubtask = !!source.data.cardIsSubtask;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                isDivider: isDivider,
                ...isAbort ? {
                    isAbort: isAbort
                } : {
                    isAbort: isAbort,
                    isRank: isRank,
                    isListMove: isListMove
                },
                issueHierarchyLevel: isSubtask ? -1 : defaultIssueHierarchyLevel
            });
        }
    });
function $5357a3fbb01800a4$export$660832909d6574f(defaultIssueHierarchyLevel) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>(0, $7Gk7K.monitorForElements)($5357a3fbb01800a4$export$5dd4ed888d5b12ca({
            createAnalyticsEvent: createAnalyticsEvent,
            defaultIssueHierarchyLevel: defaultIssueHierarchyLevel
        })), [
        createAnalyticsEvent,
        defaultIssueHierarchyLevel
    ]);
}

});
const $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b = 'CARD_DRAGGABLE_ID';


parcelRegister("5eblm", function(module, exports) {

$parcel$export(module.exports, "useInitEpicData", () => $053ba97b12ac7960$export$be92c37578cc55ba);

var $5uXOq = parcelRequire("5uXOq");

var $ksXL1 = parcelRequire("ksXL1");

var $4R6GH = parcelRequire("4R6GH");

var $4xRpX = parcelRequire("4xRpX");

var $c1MAf = parcelRequire("c1MAf");

var $aCC3Y = parcelRequire("aCC3Y");

var $f9Swb = parcelRequire("f9Swb");

var $fSgHa = parcelRequire("fSgHa");

var $ks5Z4 = parcelRequire("ks5Z4");
const $053ba97b12ac7960$export$be92c37578cc55ba = (boardId)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const [isInitialised, { initState: initState, resetState: resetState, updateQueryState: updateQueryState, updateEpicsAttributes: updateEpicsAttributes }] = (0, $ksXL1.useEpicsStoreIsInitialised)();
    const { data: data, loading: loading, error: error } = (0, $4xRpX.useEpicQueryLite)(boardId, isCompanyManaged);
    const initData = (0, $5uXOq.useMemo)(()=>(0, $ks5Z4.transformLiteQueryData)(data, isCompanyManaged, firstLevelHierarchyName), [
        data,
        firstLevelHierarchyName,
        isCompanyManaged
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) updateEpicsAttributes({
            isLoading: false,
            hasError: true
        });
        updateQueryState({
            loading: loading,
            error: error
        });
    }, [
        loading,
        error,
        updateQueryState,
        updateEpicsAttributes
    ]);
    // Populate redux store with issue parents data
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('jsw_cmp_backlog_remove_epics_request') || isInitialised) return;
        if (error) {
            dispatch((0, $aCC3Y.loadIssueParentsFailure)());
            return;
        }
        const issueParents = (0, $ks5Z4.getIssueParents)(initData.cards);
        issueParents && dispatch((0, $aCC3Y.loadIssueParentsSuccess)(issueParents));
    }, [
        initData,
        isInitialised,
        dispatch,
        error
    ]);
    // Initialise epic store
    (0, $5uXOq.useEffect)(()=>{
        if (data && !loading && !isInitialised) initState({
            ...initData
        });
    }, [
        boardId,
        data,
        initData,
        initState,
        isCompanyManaged,
        isInitialised,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            resetState();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};

});
parcelRegister("4xRpX", function(module, exports) {

$parcel$export(module.exports, "useEpicQueryLite", () => $c29b91030b35fa03$export$8bc41fa6ebe01467);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $hcKre = parcelRequire("hcKre");
const $c29b91030b35fa03$export$446e7345ee07982d = (0, $5cllN.default)`
    ${(0, $hcKre.timeTrackingOptionsFragment)}
    ${(0, $hcKre.epicLiteFragment)}
    ${(0, $hcKre.projectLocationFragment)}
    ${(0, $hcKre.issueParentTypeConfigFragment)}
    ${(0, $hcKre.columnFragment)}
    ${(0, $hcKre.boardFragment)}
    query EpicsLite($boardId: ID!, $isCompanyManaged: Boolean!, $isQueryColumns: Boolean!, $includeIssueTypes: Boolean! = false) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents {
                edges {
                    node {
                        ...IssueParentLiteFragment
                    }
                }
            }
            board @include(if: $isCompanyManaged) {
                columns @include(if: $isQueryColumns) {
                    ...ColumnFragment
                }
                ...BoardFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;
const $c29b91030b35fa03$export$8bc41fa6ebe01467 = (boardId, isCompanyManaged)=>(0, $5tTFS.useQuery)($c29b91030b35fa03$export$446e7345ee07982d, {
        skip: false,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            isQueryColumns: (0, $co1wz.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl'),
            includeIssueTypes: (0, $4R6GH.fg)('jsw_cmp_backlog_remove_epics_request')
        },
        fetchPolicy: 'network-only'
    });

});
parcelRegister("hcKre", function(module, exports) {

$parcel$export(module.exports, "projectLocationFragment", () => $cce6a4edb0555822$export$25c256efca3597d1);
$parcel$export(module.exports, "timeTrackingOptionsFragment", () => $cce6a4edb0555822$export$ad6d7391facb841b);
$parcel$export(module.exports, "epicLiteFragment", () => $cce6a4edb0555822$export$ee1de0b7a9498416);
$parcel$export(module.exports, "issueParentTypeConfigFragment", () => $cce6a4edb0555822$export$9d88616d202f6817);
$parcel$export(module.exports, "columnFragment", () => $cce6a4edb0555822$export$6fed28a6f51b8228);
$parcel$export(module.exports, "boardFragment", () => $cce6a4edb0555822$export$e1c6fa95c54eabf5);

var $5cllN = parcelRequire("5cllN");
const $cce6a4edb0555822$export$cb2dabc00ff80765 = (0, $5cllN.default)`
    fragment IssueParentFragment on IssueParent {
        id
        key
        summary
        issueType {
            id
            name
            iconUrl
        }
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;
const $cce6a4edb0555822$export$25c256efca3597d1 = (0, $5cllN.default)`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;
const $cce6a4edb0555822$export$ad6d7391facb841b = (0, $5cllN.default)`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;
const $cce6a4edb0555822$export$ee1de0b7a9498416 = (0, $5cllN.default)`
    fragment IssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
        issueTypeDetails @include(if: $includeIssueTypes) {
            id
            name
            iconUrl
        }
    }
`;
const $cce6a4edb0555822$export$9d88616d202f6817 = (0, $5cllN.default)`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;
const $cce6a4edb0555822$export$6fed28a6f51b8228 = (0, $5cllN.default)`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;
const $cce6a4edb0555822$export$e1c6fa95c54eabf5 = (0, $5cllN.default)`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;

});


parcelRegister("ks5Z4", function(module, exports) {

$parcel$export(module.exports, "transformLiteQueryData", () => $d53069394b467672$export$af76d046c1d42215);
$parcel$export(module.exports, "getIssueParents", () => $d53069394b467672$export$df9259146e40d32c);

var $dfl35 = parcelRequire("dfl35");

var $kQZsR = parcelRequire("kQZsR");

var $kFsv3 = parcelRequire("kFsv3");

var $g4tDr = parcelRequire("g4tDr");

var $guzeq = parcelRequire("guzeq");
const $d53069394b467672$var$RANK_DISABLED_ID = '0';
const $d53069394b467672$var$EMPTY_ISSUE_TYPE = {
    name: '',
    iconUrl: '',
    id: ''
};
const $d53069394b467672$export$66ccee7e75897cc1 = ({ id: id, key: key, summary: summary, color: color, issueTypeDetails: issueTypeDetails }, { toDo: toDo, inProgress: inProgress, done: done }, defaultIssueType)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(color) ? undefined : color,
        issueType: (0, (/*@__PURE__*/$parcel$interopDefault($dfl35)))({
            name: issueTypeDetails?.name,
            iconUrl: issueTypeDetails?.iconUrl,
            id: issueTypeDetails?.id
        }, {
            name: defaultIssueType?.name,
            iconUrl: defaultIssueType?.iconUrl,
            id: defaultIssueType?.id
        }, $d53069394b467672$var$EMPTY_ISSUE_TYPE),
        isLoading: true,
        hasError: false
    };
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: 0,
                    columnCount: toDo
                },
                inProgress: {
                    issueCount: 0,
                    columnCount: inProgress
                },
                done: {
                    issueCount: 0,
                    columnCount: done
                }
            },
            totalIssues: 0
        }
    };
};
const $d53069394b467672$export$af76d046c1d42215 = (data, isCompanyManaged, firstLevelHierarchyName)=>{
    const globalConfig = data?.globalConfig;
    const board = data?.boardScope?.board;
    const columns = board?.columns ?? [];
    let isEpicIssueTypeAvailable = false;
    let epicIssueType;
    let epicIssueTypeName = (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    const columnCounts = {
        toDo: columns.filter((column)=>column.isInitial).length,
        inProgress: columns.filter((column)=>!column.isInitial && !column.isDone).length,
        done: columns.filter((column)=>column.isDone).length
    };
    const cards = data?.boardScope?.parents?.edges?.flatMap((edge)=>edge?.node ? $d53069394b467672$export$66ccee7e75897cc1(edge.node, columnCounts, globalConfig?.issueParentTypeConfig) : []) ?? [];
    if (isCompanyManaged) {
        isEpicIssueTypeAvailable = globalConfig?.issueParentTypeConfig.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        epicIssueType = globalConfig?.issueParentTypeConfig;
        epicIssueTypeName = firstLevelHierarchyName || globalConfig?.issueParentTypeConfig.name || (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    } else {
        epicIssueType = data?.boardScope?.projectLocation?.issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
        isEpicIssueTypeAvailable = Boolean(epicIssueType);
        if (epicIssueType) epicIssueTypeName = epicIssueType.name;
    }
    return {
        cards: cards,
        columnCounts: columnCounts,
        isEpicIssueTypeAvailable: isEpicIssueTypeAvailable,
        epicIssueType: {
            id: epicIssueType?.id ?? 0,
            name: epicIssueTypeName,
            hasRequiredFields: epicIssueType?.hasRequiredFields ?? false
        },
        epicIssueTypeName: epicIssueTypeName,
        ...data?.jira && {
            timeTrackingOptions: data.jira.timeTrackingOptions
        },
        isRankingEnabled: board?.rankCustomFieldId ? board.rankCustomFieldId !== $d53069394b467672$var$RANK_DISABLED_ID : true
    };
};
const $d53069394b467672$export$df9259146e40d32c = (cards)=>cards.map(({ epic: issueParent })=>{
        return {
            id: String(issueParent.id),
            key: issueParent.key,
            summary: issueParent.name,
            issueType: {
                id: String(issueParent?.issueType?.id) || '',
                name: issueParent?.issueType?.name || '',
                iconUrl: issueParent?.issueType?.iconUrl || ''
            },
            color: issueParent.color || (0, $kFsv3.COLORS)[0]
        };
    });

});
parcelRegister("kQZsR", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $f2e8578be8331871$var$isNull(value) {
    return value === null;
}
module.exports = $f2e8578be8331871$var$isNull;

});



parcelRegister("cc2av", function(module, exports) {

$parcel$export(module.exports, "VersionsPanelWithErrorBoundary", () => $dc3d37d20a3c6e6b$export$d6f535b626aa9a12);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $39xOx = parcelRequire("39xOx");

var $iXVV6 = parcelRequire("iXVV6");

var $eSUJA = parcelRequire("eSUJA");


var $hGRp0 = parcelRequire("hGRp0");

var $iQClv = parcelRequire("iQClv");

var $4GPQ6 = parcelRequire("4GPQ6");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");

var $fSgHa = parcelRequire("fSgHa");

var $kuePT = parcelRequire("kuePT");

var $e2Elo = parcelRequire("e2Elo");
const $dc3d37d20a3c6e6b$export$c91390ee18658a60 = (props)=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $5uXOq.useContext)((0, $4GPQ6.VersionPanelEntrypointContext));
    const isVersionsOpen = (0, $kuePT.useIsVersionsPanelOpen)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ...props,
            onReady: stopMetric
        }), [
        props,
        stopMetric
    ]);
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const sourceDroppableType = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getSourceDroppableType));
    return isVersionsOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2Elo.PanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            analyticsSource: (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSUJA.PanelDataProvider), {
        sourceDroppableType: sourceDroppableType,
        isCompanyManaged: isCompanyManaged,
        boardId: props.boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira.backlog.version.panel",
        packageName: "jiraSoftwareVersionBacklogPanelRelay",
        errorFallback: "flag",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hGRp0.LoadingSkeleton), null),
        runtimeProps: runtimeProps
    })))) : null;
};
const $dc3d37d20a3c6e6b$export$d6f535b626aa9a12 = (props)=>{
    const { fireErrorBoundaryExperienceFail: fireErrorBoundaryExperienceFail } = (0, $iQClv.useViewVersionPanelExperienceTracker)({
        isClassic: props.isCompanyManaged
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iQClv.VersionBacklogPanelExperienceStart), {
        experienceId: `${props.boardId}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "backlogContentVersionsPanel",
        packageName: "software-backlog",
        fallback: "flag",
        onError: fireErrorBoundaryExperienceFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dc3d37d20a3c6e6b$export$c91390ee18658a60, props)));
};

});
const $f9ec0e1408d9f044$export$d76071d5de2774fc = 'version-panel';
const $f9ec0e1408d9f044$export$28ad8b364940d9aa = 'VERSION-';
const $f9ec0e1408d9f044$export$71b7a97b7c858c63 = 'version-panel';
const $f9ec0e1408d9f044$export$b8b9d90f9e5bd72b = 'jiraSoftwareVersionBacklogPanelRelay';

parcelRegister("hGRp0", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $165a74bd05c9838d$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9MjbF = parcelRequire("9MjbF");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $3WsOp = parcelRequire("3WsOp");
const $165a74bd05c9838d$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-version-backlog-panel-relay.common.loading-skeleton.title",
        "defaultMessage": "Versions"
    }
});
const $165a74bd05c9838d$export$44c18d210d5de37b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WsOp.default), {
        title: formatMessage($165a74bd05c9838d$var$messages.title),
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($165a74bd05c9838d$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "medium"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $165a74bd05c9838d$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _ca0qhwvj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3WsOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $87db1608ea208649$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lUMFO = parcelRequire("lUMFO");
const $87db1608ea208649$export$2ddb90ad54e5f587 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87db1608ea208649$var$Container, {
        "data-test-id": "software-backlog-panel.common.ui.panel.container",
        "data-testid": "software-backlog-panel.common.ui.panel.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lUMFO.default), {
        title: title,
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87db1608ea208649$var$Content, {
        ref: ref
    }, children)));
var $87db1608ea208649$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($87db1608ea208649$export$2ddb90ad54e5f587);
const $87db1608ea208649$var$width = 220;
const $87db1608ea208649$var$widthLarge = 270;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87db1608ea208649$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _n3tdv77o _vchhusvi _2rkoftgi _bfhkhri9 _1wpzv2br _c71l1vmz _rq4b1ogy _9szo1ogy _1oba1wdt _1yev1wdt",
            __cmplp.className
        ])
    });
});
const $87db1608ea208649$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1reo15vq _18m91wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lUMFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20f5c482c9df4d8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $89thI = parcelRequire("89thI");

var $53KbV = parcelRequire("53KbV");

var $cbTaZ = parcelRequire("cbTaZ");

var $dqoiX = parcelRequire("dqoiX");

var $gwIPs = parcelRequire("gwIPs");

var $az4zD = parcelRequire("az4zD");

var $dZggJ = parcelRequire("dZggJ");

var $gJwmE = parcelRequire("gJwmE");

var $iGDv7 = parcelRequire("iGDv7");
const $e20f5c482c9df4d8$export$8b251419efc915eb = ({ title: title, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    const label = formatMessage((0, $iGDv7.default).closeButtonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$Container, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$Title, {
        "data-testid": "software-backlog-panel.common.ui.panel.header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        as: "h2",
        size: "xsmall"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: (0, $dZggJ.EPIC_CARD_DESCRIPTION_ID)
    }, formatMessage((0, $iGDv7.default).epicCardDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: "software-backlog-panel.common.ui.panel.header.close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20f5c482c9df4d8$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cbTaZ))), {
        label: label,
        primaryColor: "var(--ds-icon, #44546F)"
    })))));
};
var $e20f5c482c9df4d8$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)(/*#__PURE__*/ (0, $5uXOq.memo)($e20f5c482c9df4d8$export$8b251419efc915eb));
const $e20f5c482c9df4d8$var$ICON_SIZE = (0, $gwIPs.gridSize) * 3; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e20f5c482c9df4d8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1o9zidpf _1yt41a6b",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$TitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _16jlkb7n _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _1bsb1tcg _4t3i1tcg _1ul91tcg _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $e20f5c482c9df4d8$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ol3jx8": (0, $lD23V.default)((0, $gJwmE.cardColor).default.textColorSubtle)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _1reo15vq _18m915vq _1bto1l2s _o5721q9c _k48pbfng _syazqpuq _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gJwmE", function(module, exports) {

$parcel$export(module.exports, "cardColor", () => $a7528499484db0c3$export$7371e516c83e77f1);

const $a7528499484db0c3$var$COLOR_TEXT = `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$exports).N800})`;
const $a7528499484db0c3$var$COLOR_TEXT_INVERSE = `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N40})`;
const $a7528499484db0c3$export$7371e516c83e77f1 = {
    default: {
        textColor: $a7528499484db0c3$var$COLOR_TEXT,
        textColorSubtle: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
        progressBar: {
            textColor: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`
        },
        mouseLeave: {
            backgroundColor: `var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: `var(--ds-surface-raised-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N20})`,
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #DDDFE5)"
        }
    },
    active: {
        progressBar: {
            textColor: $a7528499484db0c3$var$COLOR_TEXT_INVERSE
        },
        mouseLeave: {
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseOver: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            textColor: $a7528499484db0c3$var$COLOR_TEXT
        },
        mouseDown: {
            backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)"
        }
    }
};

});

parcelRegister("iGDv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc7c4bdb8f2ea1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9bc7c4bdb8f2ea1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeButtonLabel: {
        "id": "software-backlog-panel.common.panel.header.close-button-label",
        "defaultMessage": "Close panel"
    },
    epicCardDescription: {
        "id": "software-backlog-panel.common.panel.header.epic-card-description",
        "defaultMessage": "Whatever you select will be shown in the main content"
    }
});

});




parcelRegister("iQClv", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_ABORT_PERMISSION", () => $ccbcd70726f763d5$export$a7086850d534ca7c);
$parcel$export(module.exports, "ASSIGN_ABORT_CROSS_PROJECT", () => $ccbcd70726f763d5$export$2c16bbee73016c79);
$parcel$export(module.exports, "UNASSIGN_ABORT_PERMISSION", () => $ccbcd70726f763d5$export$4a65d324cd30dfb7);
$parcel$export(module.exports, "useViewVersionPanelExperienceTracker", () => $ccbcd70726f763d5$export$aa37233cd44da53c);
$parcel$export(module.exports, "VersionBacklogPanelExperienceStart", () => $ccbcd70726f763d5$export$792847156522cd4d);
$parcel$export(module.exports, "VersionBacklogPanelExperienceSuccessTracker", () => $ccbcd70726f763d5$export$af4d2f7ac24077d1);
$parcel$export(module.exports, "useAssignExperienceTracker", () => $ccbcd70726f763d5$export$e087867f6020c859);
$parcel$export(module.exports, "useUnassignExperienceTracker", () => $ccbcd70726f763d5$export$cb1163ce9c396ad5);

var $5uXOq = parcelRequire("5uXOq");

var $a6ebl = parcelRequire("a6ebl");

var $evKjT = parcelRequire("evKjT");

var $4MGZC = parcelRequire("4MGZC");

const $ccbcd70726f763d5$export$d95354974e5f5020 = 'viewVersionBacklogPanel';
const $ccbcd70726f763d5$export$4669ca9d7c97effc = 'assignVersionPanel';
const $ccbcd70726f763d5$export$a7086850d534ca7c = 'ASSIGN_PERMISSION';
const $ccbcd70726f763d5$export$2c16bbee73016c79 = 'ASSIGN_CROSS_PROJECT';
const $ccbcd70726f763d5$export$1eb1042763fdc7c3 = 'unassignVersionPanel';
const $ccbcd70726f763d5$export$4a65d324cd30dfb7 = 'UNASSIGN_PERMISSION';
const $ccbcd70726f763d5$export$aa37233cd44da53c = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$d95354974e5f5020, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);
const $ccbcd70726f763d5$export$792847156522cd4d = ({ experienceId: experienceId = (0, $f9ec0e1408d9f044$export$d76071d5de2774fc) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evKjT.SoftwareExperienceStart), {
        experienceId: experienceId,
        experience: $ccbcd70726f763d5$export$d95354974e5f5020,
        analyticsSource: (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63)
    });
const $ccbcd70726f763d5$export$af4d2f7ac24077d1 = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MGZC.SoftwareExperienceSuccess), {
        experience: $ccbcd70726f763d5$export$d95354974e5f5020,
        attributes: attributes
    });
const $ccbcd70726f763d5$export$e087867f6020c859 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$4669ca9d7c97effc, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);
const $ccbcd70726f763d5$export$cb1163ce9c396ad5 = (attributes = {})=>(0, $a6ebl.useExperienceTracker)((0, $f9ec0e1408d9f044$export$d76071d5de2774fc), $ccbcd70726f763d5$export$1eb1042763fdc7c3, (0, $f9ec0e1408d9f044$export$71b7a97b7c858c63), attributes);

});
parcelRegister("evKjT", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceStart", () => $b3e565df34dd9264$export$e18be0cd3b92dda1);

var $5uXOq = parcelRequire("5uXOq");

var $kaHBi = parcelRequire("kaHBi");

var $efvDm = parcelRequire("efvDm");

var $k9JTq = parcelRequire("k9JTq");
const $b3e565df34dd9264$export$e18be0cd3b92dda1 = ({ experienceId: experienceId, experience: experience, analyticsSource: analyticsSource })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
        experienceId: experienceId,
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
};

});

parcelRegister("4MGZC", function(module, exports) {

$parcel$export(module.exports, "SoftwareExperienceSuccess", () => $02ad6433b9e23713$export$a06ece3d589f4c88);

var $5uXOq = parcelRequire("5uXOq");

var $3bQtK = parcelRequire("3bQtK");

var $gk7Z3 = parcelRequire("gk7Z3");
const $02ad6433b9e23713$export$a06ece3d589f4c88 = ({ experience: experience, attributes: attributes })=>{
    const experienceAttributes = (0, $5uXOq.useMemo)(()=>(0, $gk7Z3.createCommonAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience,
        attributes: experienceAttributes
    });
};

});


parcelRegister("4GPQ6", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContext", () => $9e33278fdef07516$export$bdb33cd5a96d0170);

var $l37qh = parcelRequire("l37qh");
const $9e33278fdef07516$export$bdb33cd5a96d0170 = (0, $l37qh.createUseEntryPointContext)();

});

parcelRegister("kuePT", function(module, exports) {

$parcel$export(module.exports, "useIsVersionsPanelOpen", () => $952d461d63e3cbc5$export$2b96edcb84157d9);

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $fpDLy = parcelRequire("fpDLy");
const $952d461d63e3cbc5$export$2b96edcb84157d9 = ()=>{
    const isVersionPanelOpen = (0, $iDGXn.useShowVersionPanel)();
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    return isVersionsEnabled && isVersionPanelOpen;
};

});




parcelRegister("gFU0Q", function(module, exports) {

$parcel$export(module.exports, "BacklogSlaTracker", () => $361995e08400e282$export$a34f0231312fddfc);
$parcel$export(module.exports, "CmpBacklogSlaTracker", () => $361995e08400e282$export$836eecf117869739);

var $5uXOq = parcelRequire("5uXOq");

var $iqr2y = parcelRequire("iqr2y");

var $4R6GH = parcelRequire("4R6GH");

var $5Nutl = parcelRequire("5Nutl");

var $01j5n = parcelRequire("01j5n");

var $dIdda = parcelRequire("dIdda");

const $361995e08400e282$export$a34f0231312fddfc = ({ error: error, location: location })=>{
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $01j5n.default)(error, location ?? (0, $a9c483c0d986286a$export$b6e4306772e8a60d)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
        id: location ?? 'next-gen-backlog',
        error: error
    }));
    // return null when no errors
    return null;
};
const $361995e08400e282$export$836eecf117869739 = ()=>{
    const backlogData = (0, $dIdda.useResource)((0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? (0, $5Nutl.uifBacklogResource) : (0, $5Nutl.uifBacklogResourceOld));
    const hasFired = (0, $5uXOq.useRef)(false);
    if (hasFired.current || !backlogData || !backlogData.error || backlogData.data || backlogData.loading) return null;
    hasFired.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($361995e08400e282$export$a34f0231312fddfc, {
        error: backlogData?.error,
        location: (0, $a9c483c0d986286a$export$7858b0b4e02abd78)
    });
};

});

parcelRegister("2jVnP", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsLoader", () => $3a6155dc05042d97$export$3af81192d3c2a190);

var $5uXOq = parcelRequire("5uXOq");

var $6aXrw = parcelRequire("6aXrw");

var $acDhY = parcelRequire("acDhY");

var $6s1PB = parcelRequire("6s1PB");

var $3bmrC = parcelRequire("3bmrC");

var $c1MAf = parcelRequire("c1MAf");

var $eSSqy = parcelRequire("eSSqy");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $3VzmQ = parcelRequire("3VzmQ");

var $4RzmK = parcelRequire("4RzmK");

var $tDHjp = parcelRequire("tDHjp");
const $3a6155dc05042d97$export$3a055e4082f2e2d5 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
const $3a6155dc05042d97$export$fad9b4c285937b2c = ()=>(0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
const $3a6155dc05042d97$export$9af2fbf60e113c02 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardIds));
const $3a6155dc05042d97$export$2b501a9ab802e6f9 = ()=>(0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
const $3a6155dc05042d97$export$70c1fca7746d50c3 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
const $3a6155dc05042d97$export$3af81192d3c2a190 = ({ bulkOperationsToolbarOld: bulkOperationsToolbarOld, bulkOperationsForm: bulkOperationsForm, onOpenSidebar: onOpenSidebar, onCloseSidebar: onCloseSidebar })=>{
    const shouldShowCheckbox = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? (0, $3VzmQ.useShowCheckbox)() : undefined;
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? (0, $acDhY.useBulkOpsEntryPoint)() : {
        entryPointReferenceSubject: undefined,
        entryPointActions: {
            load: ()=>undefined
        }
    };
    const selectedCardIds = $3a6155dc05042d97$export$3a055e4082f2e2d5();
    const hasBulkEditPermission = $3a6155dc05042d97$export$fad9b4c285937b2c();
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const visibleCardIds = $3a6155dc05042d97$export$9af2fbf60e113c02();
    const { selectAllVisible: selectAllVisible, clearAll: clearAll, clearAllVisible: clearAllVisible, extraAnalyticsAttributes: extraAnalyticsAttributes } = (0, $tDHjp.useSelectActions)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const estimationFieldId = $3a6155dc05042d97$export$2b501a9ab802e6f9();
    const isCMP = $3a6155dc05042d97$export$70c1fca7746d50c3();
    const { openIssueView: openIssueView, closeIssueView: closeIssueView } = (0, $3bmrC.useCloseIssueViewOnBulkOpsEdit)();
    const optimisticId = (0, $5uXOq.useRef)();
    const onUpdateStart = (0, $5uXOq.useCallback)((payload)=>{
        const cardsData = payload.map(({ issueIds: issueIds, data: data })=>{
            const issuesData = (0, $4RzmK.getBulkOperationsData)({
                data: data,
                estimationFieldId: estimationFieldId,
                isCMP: isCMP
            });
            return {
                cardIds: issueIds,
                data: issuesData
            };
        });
        const action = (0, $eSSqy.cardsBulkOperationsRequests)(cardsData);
        optimisticId.current = action.meta.optimistic.id;
        dispatch(action);
    }, [
        dispatch,
        estimationFieldId,
        isCMP
    ]);
    /*
    This function is a temporary workaround to open the legacy bulk edit page.
    The Bulk Transition doesn't have support to return the issueKeys so this implementation was done here
    and will be removed when we implement Bulk Transition with multiple workflows.
    Project Plan: https://hello.atlassian.net/wiki/spaces/JSDee/pages/3388755384/Bulk+Transition+Project+Plan
    */ const onLegacyBulkEditRequest = (0, $5uXOq.useCallback)((issueIds)=>{
        const issueKeys = issueIds.map((id)=>cardEntities[String(id)]?.key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    }, [
        cardEntities
    ]);
    const onUpdateError = (0, $5uXOq.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        dispatch((0, $eSSqy.cardsBulkOperationsFailure)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onUpdateSuccess = (0, $5uXOq.useCallback)((cardIds)=>{
        if (!optimisticId.current) return;
        dispatch((0, $eSSqy.cardsBulkOperationsSuccess)(optimisticId.current, cardIds));
    }, [
        dispatch
    ]);
    const onOpenForm = (0, $5uXOq.useCallback)(()=>{
        onOpenSidebar();
        closeIssueView();
    }, [
        closeIssueView,
        onOpenSidebar
    ]);
    const onCloseForm = (0, $5uXOq.useCallback)(()=>{
        onCloseSidebar();
        openIssueView();
    }, [
        openIssueView,
        onCloseSidebar
    ]);
    // TODO Move props to BulkOpsCoreWithToolbar when cleaning up bulk_operations_floating_toolbar
    const props = {
        bulkOperationsForm: bulkOperationsForm,
        onOpenForm: onOpenForm,
        onCloseForm: onCloseForm,
        onUpdateError: onUpdateError,
        onUpdateSuccess: onUpdateSuccess,
        onLegacyBulkEditRequest: onLegacyBulkEditRequest,
        onSelectAll: selectAllVisible,
        selectableIssueIds: visibleCardIds,
        selectedIssueIds: selectedCardIds,
        extraAnalyticsAttributes: extraAnalyticsAttributes,
        onClearAll: clearAll,
        onClearAllVisible: clearAllVisible,
        hasBulkEditPermission: hasBulkEditPermission,
        onUpdateStart: onUpdateStart
    };
    if ((0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false)) {
        // TODO: remove this - https://hello.jira.atlassian.cloud/browse/DEE-6120
        // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (props.selectedIssueIds.length > 0) entryPointActions.load();
        }, [
            entryPointActions,
            props.selectedIssueIds.length
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6aXrw.BulkOpsCoreWithToolbar), {
            shouldHideToolbar: false,
            bulkopsCoreEntryPointReference: entryPointReferenceSubject,
            ...props,
            selectedIssueIds: shouldShowCheckbox ? selectedCardIds : []
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6aXrw.AsyncBulkOpsCore), {
        ...props,
        ...!(0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && {
            bulkOperationsToolbarOld: bulkOperationsToolbarOld
        }
    });
};

});
parcelRegister("6aXrw", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCore", () => $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd);
$parcel$export(module.exports, "BulkOpsCoreWithToolbar", () => $dd195193bf05f4ed$export$e277fa5a9b41268f);

var $5uXOq = parcelRequire("5uXOq");

var $Pdfe3 = parcelRequire("Pdfe3");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $8G5F5 = parcelRequire("8G5F5");

var $fvbIR = parcelRequire("fvbIR");
const $dd195193bf05f4ed$var$entryPointParams = {};
const $dd195193bf05f4ed$export$ac7b39f8b8a9f5cd = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $dd195193bf05f4ed$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core",
        packageName: "jiraBulkOperationsCore",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: props
    });
};
const $dd195193bf05f4ed$export$e277fa5a9b41268f = ({ bulkopsCoreEntryPointReference: bulkopsCoreEntryPointReference, ...props })=>{
    const hasSelectAllButton = Boolean(props.onSelectAll);
    const extraToolbarButtonsSkeleton = props.extraToolbarButtons?.map((button)=>({
            hasIcon: Boolean(button.icon),
            text: button.name
        })) || [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8G5F5.ToolbarWrapper), {
        show: props.selectedIssueIds.length > 0,
        width: "calc(100% - var(--leftSidebarWidth, 0px))"
    }, bulkopsCoreEntryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jiraAsyncBulkOperationsCoreWithToolBar",
        packageName: "jiraBulkOperationsCoreWithToolBar",
        teamName: "deliveroo",
        entryPointReferenceSubject: bulkopsCoreEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pdfe3.BulkOperationsToolbarSkeleton), {
            buttons: extraToolbarButtonsSkeleton,
            hasSelectAllButton: hasSelectAllButton
        }),
        runtimeProps: props
    }));
};

});
parcelRegister("Pdfe3", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsToolbarSkeleton", () => $b74ffcc19e228775$export$59bb23e2f88d002d);

var $5uXOq = parcelRequire("5uXOq");

var $eNciG = parcelRequire("eNciG");

var $koVbs = parcelRequire("koVbs");

var $3a9td = parcelRequire("3a9td");

var $98iV2 = parcelRequire("98iV2");
const $b74ffcc19e228775$export$59bb23e2f88d002d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allButtons = [
        {
            text: formatMessage((0, $98iV2.messages).editFields),
            hasIcon: true
        },
        {
            text: formatMessage((0, $3a9td.messages).changeStatus),
            hasIcon: true
        },
        ...buttons
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNciG.ToolbarSkeleton), {
        hasSelectAllButton: hasSelectAllButton,
        buttons: allButtons
    });
};

});
parcelRegister("eNciG", function(module, exports) {

$parcel$export(module.exports, "ToolbarSkeleton", () => $ff19fad29388fb19$export$5e29225d56ca7c7d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $eBKuY = parcelRequire("eBKuY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eyjpj = parcelRequire("eyjpj");

var $hGxOR = parcelRequire("hGxOR");
const $ff19fad29388fb19$var$SkeletonBase = (props)=>/*#__PURE__*/ $5uXOq.createElement((0, $eBKuY.default), {
        ...props,
        height: "7px",
        isShimmering: true,
        color: "var(--ds-background-accent-gray-subtle, #8590A2)",
        ShimmeringEndColor: "var(--ds-background-accent-gray-bolder, #626F86)",
        width: props.width || '100%',
        "aria-hidden": "true"
    });
const $ff19fad29388fb19$var$SkeletonActionButton = ({ width: width, text: text, hasIcon: hasIcon })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $ff19fad29388fb19$var$skeletonButtonStyles,
        "aria-hidden": "true",
        testId: "floating-toolbar.ui.skeleton.box"
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: width
    }), /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $ff19fad29388fb19$var$invisibleTextStyles
    }, text), /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: hasIcon ? $ff19fad29388fb19$var$iconSpacerStyles : $ff19fad29388fb19$var$noIconSpacerStyles
    })));
};
const $ff19fad29388fb19$var$SkeletonCloseIcon = ()=>/*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $ff19fad29388fb19$var$closeIconContainerStyles
    }, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, {
        width: "16px"
    })); // These props are used to calculate a more appropriate skeleton
const $ff19fad29388fb19$export$5e29225d56ca7c7d = ({ hasSelectAllButton: hasSelectAllButton, buttons: buttons })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContainer), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSideContent), null, /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), null, /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonBase, null), /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), {
        space: "space.050",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $5uXOq.createElement("h2", {
        className: (0, $bwpsq.default)([
            "_11c81oud _1e0c1txw _1n261g80 _4cvr1h6o _ae4v1h6o _3um015vq _4t3iidpf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...(0, $hGxOR.default).selectedItemsLabel,
        values: {
            numberOfSelectedItems: 1,
            numberSelected: /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
                xcss: $ff19fad29388fb19$var$numberSelectedStyles
            }, 1)
        }
    }))))), hasSelectAllButton && /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
        text: formatMessage((0, $hGxOR.default).selectAllButtonLabel),
        hasIcon: true
    }), /*#__PURE__*/ $5uXOq.createElement((0, $eyjpj.FloatingToolbarSeparator), null), /*#__PURE__*/ $5uXOq.createElement((0, $dsFR3.default), {
        alignBlock: "center"
    }, buttons.map((button)=>{
        return /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonActionButton, {
            key: button.text,
            ...button
        });
    }), /*#__PURE__*/ $5uXOq.createElement($ff19fad29388fb19$var$SkeletonCloseIcon, null))));
};
const $ff19fad29388fb19$var$skeletonButtonStyles = (0, $jJ1Sb.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.150'
});
const $ff19fad29388fb19$var$closeIconContainerStyles = (0, $jJ1Sb.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $ff19fad29388fb19$var$selectedContainer = null;
const $ff19fad29388fb19$var$iconSpacerStyles = (0, $jJ1Sb.xcss)({
    width: '26px'
});
const $ff19fad29388fb19$var$noIconSpacerStyles = (0, $jJ1Sb.xcss)({
    width: '4px'
});
const $ff19fad29388fb19$var$invisibleTextStyles = (0, $jJ1Sb.xcss)({
    height: '0',
    visibility: 'hidden'
});
const $ff19fad29388fb19$var$numberSelectedStyles = (0, $jJ1Sb.xcss)({
    width: '24px',
    marginRight: 'space.050'
});

});
parcelRegister("eBKuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $55656459e2d6b9c5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dtXUS = parcelRequire("dtXUS");
const $55656459e2d6b9c5$var$shimmer = (0, $dtXUS.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $55656459e2d6b9c5$var$shimmerKeyframes = (0, $f8Sb3.keyframes)($55656459e2d6b9c5$var$shimmer.keyframes);
const $55656459e2d6b9c5$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$55656459e2d6b9c5$var$shimmer.css
});
const $55656459e2d6b9c5$var$activeShimmerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    animationName: `${$55656459e2d6b9c5$var$shimmerKeyframes}`
});
const $55656459e2d6b9c5$var$getKeyframes = (fromColor, toColor)=>(0, $f8Sb3.keyframes)({
        from: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            backgroundColor: fromColor
        },
        to: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            backgroundColor: toColor
        }
    });
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $55656459e2d6b9c5$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $55656459e2d6b9c5$var$skeletonStyles,
            isShimmering && $55656459e2d6b9c5$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                animationName: color && ShimmeringEndColor ? $55656459e2d6b9c5$var$getKeyframes(color, ShimmeringEndColor) : undefined
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $55656459e2d6b9c5$export$2e2bcd8739ae039 = $55656459e2d6b9c5$var$Skeleton;

});

parcelRegister("eyjpj", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarContainer", () => $65d4363d5da90d3d$export$da9876c16f406ff3);
$parcel$export(module.exports, "FloatingToolbarContent", () => $65d4363d5da90d3d$export$634954b758f92d4);
$parcel$export(module.exports, "FloatingToolbarSeparator", () => $65d4363d5da90d3d$export$e9d27765ebab091b);
$parcel$export(module.exports, "FloatingToolbarSideContent", () => $65d4363d5da90d3d$export$fcfdbfa230cd1442);
$parcel$export(module.exports, "ContentSlider", () => $65d4363d5da90d3d$export$ff7934be9f806b5f);

var $5uXOq = parcelRequire("5uXOq");

var $dtfx6 = parcelRequire("dtfx6");
var $ggYIC = parcelRequire("ggYIC");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $faL1o = parcelRequire("faL1o");
const $65d4363d5da90d3d$export$da9876c16f406ff3 = ({ children: children, onKeyDown: onKeyDown })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        role: "toolbar",
        xcss: $65d4363d5da90d3d$var$floatingContainerStyles,
        "aria-label": formatMessage((0, $faL1o.messages).toolbarName),
        onKeyDown: onKeyDown
    }, children);
};
const $65d4363d5da90d3d$export$634954b758f92d4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        xcss: $65d4363d5da90d3d$var$contentContainerStyles,
        alignBlock: "center"
    }, children);
const $65d4363d5da90d3d$export$e9d27765ebab091b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $65d4363d5da90d3d$var$separatorStyles
    });
const $65d4363d5da90d3d$export$fcfdbfa230cd1442 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $65d4363d5da90d3d$var$sideContentContainer
    }, children);
const $65d4363d5da90d3d$export$ff7934be9f806b5f = ({ children: children, show: show })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dtfx6.default), null, show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ggYIC.default), {
        enterFrom: "bottom",
        fade: "inout"
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", slideInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $65d4363d5da90d3d$var$mainContainerStyles
        }, children))));
const $65d4363d5da90d3d$var$floatingContainerStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.100',
    backgroundColor: 'color.background.neutral.bold.pressed',
    borderRadius: '6px',
    boxShadow: 'elevation.shadow.overlay'
});
const $65d4363d5da90d3d$var$contentContainerStyles = (0, $jJ1Sb.xcss)({
    height: '32px',
    color: 'color.text.inverse',
    fontVariantNumeric: 'tabular-nums'
});
const $65d4363d5da90d3d$var$separatorStyles = (0, $jJ1Sb.xcss)({
    height: '16px',
    width: '1px',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: '2px',
    marginLeft: 'space.100',
    marginRight: 'space.100'
});
const $65d4363d5da90d3d$var$sideContentContainer = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $65d4363d5da90d3d$var$mainContainerStyles = (0, $jJ1Sb.xcss)({
    pointerEvents: 'auto'
});

});
parcelRegister("faL1o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $39ec34d441f2b8b5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $39ec34d441f2b8b5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarName: {
        "id": "floating-toolbar.common.toolbar-name",
        "defaultMessage": "Bulk actions"
    }
});

});


parcelRegister("hGxOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f61683952119ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d5f61683952119ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selectedItemsLabel: {
        "id": "floating-toolbar.selected-items-label",
        "defaultMessage": "{numberSelected} {numberOfSelectedItems, plural, one {selected} other {selected}}"
    },
    clearAllButton: {
        "id": "floating-toolbar.clear-all-button",
        "defaultMessage": "Clear all"
    },
    selectAllButtonLabel: {
        "id": "floating-toolbar.select-all-button-label",
        "defaultMessage": "Select all"
    }
});

});


parcelRegister("3a9td", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7b322b00365a05e1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7b322b00365a05e1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    changeStatus: {
        "id": "bulk-operations-core.toolbar.change-status-button.change-status",
        "defaultMessage": "Change status"
    }
});

});

parcelRegister("98iV2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce2ddaac145135a8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ce2ddaac145135a8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editFields: {
        "id": "bulk-operations-core.toolbar.edit-button.edit-fields",
        "defaultMessage": "Edit fields"
    }
});

});


parcelRegister("8G5F5", function(module, exports) {

$parcel$export(module.exports, "ToolbarWrapper", () => $bb1a9147c120653f$export$b705b0380e6fe1b0);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $eyjpj = parcelRequire("eyjpj");
const $bb1a9147c120653f$export$b705b0380e6fe1b0 = ({ children: children, show: show, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $bb1a9147c120653f$var$floatingPositionerStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute -- width of component can change depending on the consumer
        style: {
            width: width || '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyjpj.ContentSlider), {
        show: show
    }, children));
const $bb1a9147c120653f$var$floatingPositionerStyles = (0, $jJ1Sb.xcss)({
    position: 'fixed',
    bottom: 'space.100',
    zIndex: 'layer',
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)'
});

});


parcelRegister("3bmrC", function(module, exports) {

$parcel$export(module.exports, "useCloseIssueViewOnBulkOpsEdit", () => $69f643f955e59150$export$7c7315d3993c325e);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $c1MAf = parcelRequire("c1MAf");

var $38qhf = parcelRequire("38qhf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");
const $69f643f955e59150$export$7c7315d3993c325e = ()=>{
    const handleCloseIssueView = (0, $c1MAf.useBacklogActionCreator)((0, $38qhf.closeDetailView));
    const handleOpenIssueView = (0, $c1MAf.useBacklogActionCreator)((0, $38qhf.openDetailView));
    const openIssue = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getDetailView));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const lastDetailViewOpen = (0, $5uXOq.useRef)(null);
    const [routerState, { replaceTo: replaceTo }] = (0, $dIdda.useRouter)();
    const closeIssueView = (0, $5uXOq.useCallback)(()=>{
        if (!lastDetailViewOpen.current) {
            lastDetailViewOpen.current = openIssue;
            handleCloseIssueView();
        }
    }, [
        handleCloseIssueView,
        openIssue
    ]);
    const openIssueView = (0, $5uXOq.useCallback)(()=>{
        if (lastDetailViewOpen.current) {
            const { cardId: cardId, externalAction: externalAction } = lastDetailViewOpen.current;
            const selectedIssue = getIssueKey(cardId);
            lastDetailViewOpen.current = null;
            handleOpenIssueView(cardId, externalAction);
            replaceTo(routerState.route, {
                params: routerState.match.params,
                query: {
                    ...routerState.query,
                    selectedIssue: selectedIssue
                }
            });
        }
    }, [
        getIssueKey,
        handleOpenIssueView,
        replaceTo,
        routerState.match.params,
        routerState.query,
        routerState.route
    ]);
    return {
        closeIssueView: closeIssueView,
        openIssueView: openIssueView
    };
};

});

parcelRegister("4RzmK", function(module, exports) {

$parcel$export(module.exports, "getBulkOperationsData", () => $31a707c120f93d10$export$3adfa80a98ae5d22);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");
const $31a707c120f93d10$var$getStoryPointValue = (value)=>{
    if (value === null) return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    const valueAsNumber = Number(value);
    if (Number.isNaN(valueAsNumber)) return undefined;
    return parseFloat(valueAsNumber.toFixed(3));
};
const $31a707c120f93d10$export$3adfa80a98ae5d22 = ({ data: data, estimationFieldId: estimationFieldId, isCMP: isCMP })=>Object.keys(data).reduce((acc, key)=>{
        if (key === (0, $5fc53.ASSIGNEE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.assignee = // TODO: update logic when automatic option is fixed
            // https://hello.atlassian.net/browse/DEE-3217
            value === null ? null : {
                id: value.accountId || '',
                displayName: value.displayName,
                avatarUrl: value.avatarUrls['48x48']
            };
        }
        if (key === (0, $5fc53.LABELS_TYPE)) {
            const labels = data[key];
            if (labels === undefined) return acc;
            const { value: value, action: action } = labels;
            acc.labels = {
                action: action,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                value: Array.isArray(value) ? value.map((label)=>label.label) : [
                    value.label
                ]
            };
        }
        if (key === (0, $5fc53.PRIORITY_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.priority = {
                name: value.label,
                iconUrl: value.iconUrl
            };
        }
        if (key === (0, $5fc53.DUE_DATE_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.dueDate = value;
        }
        if (key === (0, $5fc53.FIX_VERSIONS_TYPE)) {
            const fixVersions = data[key];
            if (fixVersions === undefined) return acc;
            const { value: value, action: action } = fixVersions;
            acc.fixVersions = {
                action: action,
                value: value.map((version)=>version.value)
            };
        }
        if (key === estimationFieldId) {
            // Temporary solution, when estimate field is available in bulk operations
            // conditions needs to be added to check against estimationFieldId
            // value (eg. timeoriginalestimate (TIME_ESTIMATE_TYPE))
            const storyPoints = $31a707c120f93d10$var$getStoryPointValue(data[key]);
            if (storyPoints !== undefined) acc.estimate = {
                storyPoints: storyPoints,
                originalEstimate: null,
                timeRemainingEstimate: null
            };
        }
        if (key === (0, $5fc53.PARENT_TYPE)) {
            const value = data[key];
            if (value === undefined) return acc;
            acc.parentId = value ? Number(value.id) : null;
        }
        if (key === (0, $5fc53.STATUS_TYPE)) {
            const value = data[key];
            if (value !== undefined && value !== null) {
                acc.statusId = value.statusId;
                if (!isCMP) acc.isDone = value.statusCategoryId === `${(0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).DONE]}`;
            }
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});

});

parcelRegister("tDHjp", function(module, exports) {

$parcel$export(module.exports, "useSelectActions", () => $e7b9bdbf67e8248b$export$d419676870909930);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $dGljH = parcelRequire("dGljH");
const $e7b9bdbf67e8248b$export$d419676870909930 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const visibleCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardIds));
    const visibleCardListIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getVisibleCardListIds));
    const selectAllVisible = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiSelectExtend)(visibleCardIds));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const clearAll = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiSelect)([]));
        dispatch((0, $4mqko.cardClearRelativeCard)());
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
    }, [
        dispatch
    ]);
    const clearAllVisible = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $4mqko.cardMultiRemove)(visibleCardIds));
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
    }, [
        dispatch,
        visibleCardIds
    ]);
    const extraAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: visibleCardIds,
                    numSelectedSprints: visibleCardListIds.length,
                    numSelectedCards: visibleCardIds.length
                },
                option: {
                    numSelectedCards: visibleCardIds.length
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedSprints: 0,
                    numSelectedCards: 0
                },
                option: {
                    numSelectedCards: 0
                }
            }
        }), [
        visibleCardIds,
        visibleCardListIds
    ]);
    return {
        selectAllVisible: selectAllVisible,
        clearAll: clearAll,
        clearAllVisible: clearAllVisible,
        extraAnalyticsAttributes: extraAnalyticsAttributes
    };
};

});


parcelRegister("gz0if", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsSidebar", () => $5298899093cded53$export$82c880c0082507d0);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $9PAwV = parcelRequire("9PAwV");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $64dTY = parcelRequire("64dTY");
const $5298899093cded53$export$82c880c0082507d0 = ({ parentWidth: parentWidth, isOpen: isOpen, bulkOperationsForm: bulkOperationsForm })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const fireResizeAnalytics = (0, $5uXOq.useCallback)((ratio)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'resized',
            actionSubject: 'bulkMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkEdit', {
            width: ratio
        });
    }, [
        createAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64dTY.Resizer), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            onResizeEnd: fireResizeAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $5298899093cded53$var$sidebarContainerStyle,
            ref: bulkOperationsForm.setRef,
            testId: "software-backlog.bulk-operations-sidebar.bulkops-sidebar"
        })));
};
const $5298899093cded53$var$sidebarContainerStyle = (0, $jJ1Sb.xcss)({
    width: `calc(100% - ${"var(--ds-space-100, 8px)"})`
});

});

parcelRegister("ab9TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36708e32bf5e8e7c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $91LZJ = parcelRequire("91LZJ");

var $9pe79 = parcelRequire("9pe79");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $fvfVu = parcelRequire("fvfVu");

var $cir2B = parcelRequire("cir2B");

var $f5uwQ = parcelRequire("f5uwQ");

var $c1MAf = parcelRequire("c1MAf");

var $a7yHf = parcelRequire("a7yHf");

var $jkFPs = parcelRequire("jkFPs");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $lDDqj = parcelRequire("lDDqj");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");

var $gTtxS = parcelRequire("gTtxS");

var $ixOVD = parcelRequire("ixOVD");
const $36708e32bf5e8e7c$var$CardListContainer = ({ id: id, isFirstList: isFirstList, isFirstNonEmptyList: isFirstNonEmptyList, isLastNonEmptyList: isLastNonEmptyList, justCreated: justCreated })=>{
    const canEditIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const isBacklogEmpty = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFlattenOrderedCardIds)(state).length === 0);
    const isActiveSprint = (0, $c1MAf.useBacklogSelector)((0, $k35me.makeIsCardListActiveSprint));
    const isIccEnabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $9Pc1U.isInlineIssueCreateAvailableForCurrentUser)(state) && ((0, $jG5HW.getIsCompanyManaged)(state) || (0, $dGljH.hasCardTypesSelector)(state)) && // ICC is disabled for CMP kanban board card list or active sprint
        !((0, $jG5HW.getIsCompanyManaged)(state) && (id === (0, $guzeq.BOARD) || isActiveSprint(id))));
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const isDisabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeIsCardListDisabled)(state)(id)) || isBulkOpsInProgress;
    const isSprintMenuVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsSprintMenuVisible)(state)(id));
    const isCreateSprintButtonDisabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.isAnyOptimisticCardList));
    const isCreateSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCreateSprintVisible)(state)(id));
    const isStartSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsStartSprintVisible)(state)(id, isFirstList));
    const canEditSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeCanEditSprint)(state)(id));
    const canManageSprints = (0, $c1MAf.useBacklogSelector)((state)=>(0, $1z1J7.canManageSprints)(state));
    const isStartSprintEnabled = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsStartSprintEnabled)(state)(id, isFirstList));
    const isCompleteSprintButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCompleteSprintVisible)(state)(id));
    const isCompleteSprintButtonDisabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $k35me.makeCanEditSprint)(state)(id));
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id] : (0, $dGljH.getOrderedCardIdsByCardListId)(state)[id]);
    const isAddSprintDatesButtonVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsAddSprintDatesButtonVisible)(state, {
            cardListId: id
        }));
    const isCollapsed = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeIsCardListCollapsed)(state)(id) || !(0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length && !!(0, $dGljH.getOrderedCardIdsByCardListId)(state)[id].length : (0, $dGljH.makeIsCardListCollapsed)(state)(id));
    const isWorkloadByAssigneeEnabled = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const isDraggingSubtask = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.getIsSubtaskDrag));
    const isCmpKanbanBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const allCardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getOrderedCardIdsByCardListId)(state)[id]);
    const cardListName = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].name);
    const cardListType = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].type);
    const typeForAnalytics = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetCardListAnalyticsTypeById)(state)(id));
    const cardListSprintData = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[id].sprintData, (0, $9pe79.default));
    const isDragging = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getIsDragging));
    const isCurrentCardListDragSource = (0, $c1MAf.useBacklogSelector)((state)=>isDragging ? (0, $dGljH.getIsCardListDragInProgress)(state, id) : false);
    const cardMoveDisabled = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCardMoveDisabled));
    const minColumnLimit = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetMinColumnLimit)(state)(id));
    const maxColumnLimit = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetMaxColumnLimit)(state)(id));
    const isMinLimitReached = !!minColumnLimit && minColumnLimit > allCardIds.length;
    const isMaxLimitReached = !!maxColumnLimit && maxColumnLimit < allCardIds.length;
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        (0, $cir2B.setCardListToggleStart)();
        dispatch((0, $a7yHf.cardListToggle)(id));
        (0, $cir2B.scheduleCardListToggleFinish)();
    }, [
        dispatch,
        id
    ]);
    const onCreateSprint = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        dispatch((0, $jkFPs.sprintCreateRequest)(analyticsEvent));
    }, [
        dispatch
    ]);
    const showTransitionZone = (0, $gTtxS.shouldShowTransitionZone)(isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog);
    const getCardOrderExcludingSubtasks = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderedVisibleCardsExcludingSubtasksForCardListWithLimit)(state) : (0, $dGljH.makeOrderedVisibleCardsExcludingSubtasksForCardList)(state));
    const getTotalCardCountExcludingSubtasks = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderedCardIdsByCardListIdWithLimitExcludingSubtasks)(state) : (0, $dGljH.makeOrderedCardIdsByCardListIdExcludingSubtasks)(state));
    const sprintLifecycleContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            canEditSprint: canEditSprint,
            canManageSprints: canManageSprints,
            isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
            isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
            isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
            isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
            isSprintMenuVisible: isSprintMenuVisible,
            isStartSprintButtonVisible: isStartSprintButtonVisible,
            isStartSprintEnabled: isStartSprintEnabled
        };
    }, [
        canEditSprint,
        canManageSprints,
        isAddSprintDatesButtonVisible,
        isCompleteSprintButtonVisible,
        isCompleteSprintButtonDisabled,
        isCreateSprintButtonDisabled,
        isSprintMenuVisible,
        isStartSprintButtonVisible,
        isStartSprintEnabled
    ]);
    const cardListContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            cardCountExcludingSubtasks: getTotalCardCountExcludingSubtasks(id).length,
            cardIds: cardIds,
            cardListId: id,
            isCollapsed: isCollapsed,
            isFirstList: isFirstList,
            isMaxLimitReached: isMaxLimitReached,
            isMinLimitReached: isMinLimitReached,
            maxColumnLimit: maxColumnLimit ?? undefined,
            minColumnLimit: minColumnLimit ?? undefined,
            listName: cardListName,
            sprintData: cardListSprintData,
            type: cardListType,
            visibleCardAmount: getCardOrderExcludingSubtasks(id).length
        };
    }, [
        cardIds,
        cardListName,
        cardListSprintData,
        cardListType,
        getCardOrderExcludingSubtasks,
        getTotalCardCountExcludingSubtasks,
        id,
        isCollapsed,
        isFirstList,
        isMaxLimitReached,
        isMinLimitReached,
        maxColumnLimit,
        minColumnLimit
    ]);
    // Clean up when visual refresh is removed
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ixOVD.default), {
        cardListId: id,
        type: cardListType,
        typeForAnalytics: typeForAnalytics,
        name: cardListName,
        sprintData: cardListSprintData,
        canEditIssue: canEditIssue,
        canEditSprint: canEditSprint,
        canManageSprints: canManageSprints,
        isBacklogEmpty: isBacklogEmpty,
        isFirstList: isFirstList,
        isFirstNonEmptyList: isFirstNonEmptyList,
        isLastNonEmptyList: isLastNonEmptyList,
        justCreated: justCreated,
        isIccEnabled: isIccEnabled,
        isDisabled: isDisabled,
        isCollapsed: isCollapsed,
        isActiveSprint: isActiveSprint(id),
        isSprintMenuVisible: isSprintMenuVisible,
        isCreateSprintButtonDisabled: isCreateSprintButtonDisabled,
        isCreateSprintButtonVisible: isCreateSprintButtonVisible,
        isStartSprintButtonVisible: isStartSprintButtonVisible,
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled,
        isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible,
        cardIds: cardIds,
        allCardIds: allCardIds,
        cardCountExcludingSubtasks: getTotalCardCountExcludingSubtasks(id).length,
        visibleCardAmount: getCardOrderExcludingSubtasks(id).length,
        onToggle: onToggle,
        onCreateSprint: onCreateSprint,
        isStartSprintEnabled: isStartSprintEnabled,
        showTransitionZone: showTransitionZone,
        minColumnLimit: minColumnLimit,
        maxColumnLimit: maxColumnLimit,
        isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5uwQ.SprintLifecycleContext).Provider, {
        value: sprintLifecycleContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fvfVu.CardListContext).Provider, {
        value: cardListContextValue
    }, content));
    return content;
};
var $36708e32bf5e8e7c$export$2e2bcd8739ae039 = $36708e32bf5e8e7c$var$CardListContainer;

});
parcelRegister("91LZJ", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $655e95f3b81da53e$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $655e95f3b81da53e$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $655e95f3b81da53e$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $655e95f3b81da53e$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $655e95f3b81da53e$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $655e95f3b81da53e$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $655e95f3b81da53e$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $655e95f3b81da53e$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $655e95f3b81da53e$export$8ce7af7b2f8c770);

var $4R6GH = parcelRequire("4R6GH");

var $7JoAD = parcelRequire("7JoAD");

var $5ltfA = parcelRequire("5ltfA");

var $liV8G = parcelRequire("liV8G");
const $655e95f3b81da53e$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined
};
const $655e95f3b81da53e$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
            We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            (0, $4R6GH.fg)('bulk_edit_discoverability') ? setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true
            }) : setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                isSidebarOpen: true
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    /* @deprecated use dismissBulkOperation instead */ closeSidebar: ()=>({ setState: setState })=>{
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        },
    dismissBulkOperation: ()=>({ setState: setState })=>{
            (0, $5ltfA.extraFormDataService).clear();
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        }
};
const $655e95f3b81da53e$export$6f57813fe9f31bf9 = (0, $7JoAD.createStore)({
    initialState: $655e95f3b81da53e$export$d4c72bab9d6cc13a,
    actions: $655e95f3b81da53e$var$actions,
    name: 'bulk-operations-store'
});
const $655e95f3b81da53e$export$940587be18a93fc4 = (0, $7JoAD.createHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$355499dfde532d1a = (0, $7JoAD.createActionsHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$760458c2204457a1 = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $655e95f3b81da53e$export$4a165cf2377f023a = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $655e95f3b81da53e$export$b3afff39a0c663ad = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $655e95f3b81da53e$export$6794339387d6d562 = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $655e95f3b81da53e$export$4289f82da677ffac = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $655e95f3b81da53e$export$babceeeb2408337b = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $655e95f3b81da53e$export$8ce7af7b2f8c770 = (0, $7JoAD.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("5ltfA", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $3546d70b36caa00c$export$3cd9d97d155e8e66);
class $3546d70b36caa00c$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $3546d70b36caa00c$var$extraFormData = new $3546d70b36caa00c$var$ExtraFormData();
const $3546d70b36caa00c$var$addDataByKey = (key, value)=>{
    $3546d70b36caa00c$var$extraFormData.addByKey(key, value);
};
const $3546d70b36caa00c$var$clear = ()=>{
    $3546d70b36caa00c$var$extraFormData.clear();
};
const $3546d70b36caa00c$var$getDataByKey = (key)=>$3546d70b36caa00c$var$extraFormData.getByKey(key);
const $3546d70b36caa00c$var$getData = ()=>$3546d70b36caa00c$var$extraFormData.getAll();
const $3546d70b36caa00c$export$3cd9d97d155e8e66 = {
    addDataByKey: $3546d70b36caa00c$var$addDataByKey,
    getDataByKey: $3546d70b36caa00c$var$getDataByKey,
    clear: $3546d70b36caa00c$var$clear,
    getData: $3546d70b36caa00c$var$getData
};

});

parcelRegister("liV8G", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $41c61f309c49c414$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $41c61f309c49c414$export$a6f51fa6c8971716);
const $41c61f309c49c414$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION'
};
const $41c61f309c49c414$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};

});


parcelRegister("fvfVu", function(module, exports) {

$parcel$export(module.exports, "CardListContext", () => $a186fb45d15514e5$export$7ef917cfa7129eee);
$parcel$export(module.exports, "useCardListContext", () => $a186fb45d15514e5$export$f126ab8a47b4f36c);

var $5uXOq = parcelRequire("5uXOq");
const $a186fb45d15514e5$export$7ef917cfa7129eee = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $a186fb45d15514e5$export$f126ab8a47b4f36c = ()=>{
    const context = (0, $5uXOq.useContext)($a186fb45d15514e5$export$7ef917cfa7129eee);
    if (!context) throw new Error('useCardListContext must be used within a CardListContextProvider');
    return context;
};

});

parcelRegister("cir2B", function(module, exports) {

$parcel$export(module.exports, "setCardListToggleStart", () => $a44b451933bb6186$export$d309e05c8f7a64b2);
$parcel$export(module.exports, "scheduleCardListToggleFinish", () => $a44b451933bb6186$export$de99a97dc0f8d91f);

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");

var $3iMqq = parcelRequire("3iMqq");

var $8hVbJ = parcelRequire("8hVbJ");
const $a44b451933bb6186$export$d309e05c8f7a64b2 = ()=>{
    (0, $3iMqq.default)('backlog-card-list-toggle');
    (0, $8hVbJ.cardListToggleInteraction).start();
};
const $a44b451933bb6186$export$3f196abd7d0c8243 = ()=>{
    (0, $8hVbJ.cardListToggleInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)()
        }
    });
};
const $a44b451933bb6186$export$de99a97dc0f8d91f = ()=>{
    (0, $4G04L.scheduleAfterRender)(()=>{
        $a44b451933bb6186$export$3f196abd7d0c8243();
    });
};

});

parcelRegister("f5uwQ", function(module, exports) {

$parcel$export(module.exports, "SprintLifecycleContext", () => $7edb3e135b52e8ec$export$36f89e977dd8a424);
$parcel$export(module.exports, "useSprintLifecycleContext", () => $7edb3e135b52e8ec$export$5c8c6417162dd990);

var $5uXOq = parcelRequire("5uXOq");
const $7edb3e135b52e8ec$export$36f89e977dd8a424 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $7edb3e135b52e8ec$export$5c8c6417162dd990 = ()=>{
    const context = (0, $5uXOq.useContext)($7edb3e135b52e8ec$export$36f89e977dd8a424);
    if (!context) throw new Error('useSprintLifecycleContext must be used within a SprintLifecycleContext.Provider');
    return context;
};

});

parcelRegister("gTtxS", function(module, exports) {

$parcel$export(module.exports, "darkerButtonTheme", () => $18d2e600ad4c6d51$export$39794a566394c250);
$parcel$export(module.exports, "shouldShowTransitionZone", () => $18d2e600ad4c6d51$export$d2114dbf8a186566);

const $18d2e600ad4c6d51$export$9e32cd4b2f78e398 = (buttonThemeOverrides)=>(currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        const { appearance: appearance, state: state, mode: mode } = themeProps;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"" | Appearance' can't be used to index type 'ButtonTheme'.
        const customThemeAppearance = buttonThemeOverrides[`${appearance || ''}`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let customStyles = {};
        if (customThemeAppearance) // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Record<string, any>'.
        customStyles = Object.keys(customThemeAppearance).reduce((acc, key)=>{
            const value = customThemeAppearance[key];
            if (value[state]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'ThemeTokens'.
            acc[key] = value[state][mode];
            return acc;
        }, // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'CSSObject'. | TS2322 - Type 'null' is not assignable to type 'CSSObject'.
        {
            buttonStyles: null,
            spinnerStyles: null
        });
        return {
            ...rest,
            buttonStyles: {
                ...buttonStyles,
                ...customStyles
            }
        };
    };
const $18d2e600ad4c6d51$var$darkerButtonThemeOverrides = {
    default: {
        background: {
            default: {
                light: `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N30A})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N40A})`
            }
        }
    }
};
const $18d2e600ad4c6d51$export$39794a566394c250 = $18d2e600ad4c6d51$export$9e32cd4b2f78e398($18d2e600ad4c6d51$var$darkerButtonThemeOverrides);
const $18d2e600ad4c6d51$export$64a0edfb15b72dba = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const isBottomOfOtherList = sourceCardList !== destinationCardList && destinationCardIndex === destinationCardListCardOrder.length;
    if (isBottomOfOtherList) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    // Is true when the destinationCardIndex is the last index in the list OR
    // ever card below this index is a selected card
    const isBottomOfSameList = sourceCardList === destinationCardList && (destinationCardIndex === destinationCardListCardOrder.length - 1 || destinationCardListCardOrder.slice(destinationCardIndex + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId)));
    return isBottomOfSameList;
};
const $18d2e600ad4c6d51$export$f9cab8a22421fe72 = (cardGroup, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    const currentCardAtDestinationIndex = destinationCardListCardOrder[destinationCardIndex];
    const isDestinationBottomOfCardGroup = currentCardAtDestinationIndex === cardGroup.cardIds[cardGroup.cardIds.length - 1];
    if (isDestinationBottomOfCardGroup) return true;
    const isMovedFromAbove = sourceCardIndex < destinationCardIndex;
    const destinationCardIndexWithinCardGroup = cardGroup.cardIds.findIndex((id)=>id === currentCardAtDestinationIndex);
    // Is considered bottom of card group when every
    // card beneath destinationCardIndex is selected
    return cardGroup.cardIds.slice(destinationCardIndexWithinCardGroup + (isMovedFromAbove ? 1 : 0)).every((cardId)=>selectedCards.includes(cardId));
};
const $18d2e600ad4c6d51$export$53e40513eb32c9ca = (sourceCardList, destinationCardList, sourceCardIndex, destinationCardIndex, destinationCardListCardOrder, selectedCards)=>{
    let cardIndex = destinationCardIndex;
    const correction = sourceCardList === destinationCardList && sourceCardIndex < destinationCardIndex ? 1 : 0;
    cardIndex = destinationCardListCardOrder.findIndex((cardId, index)=>index < cardIndex + correction ? false : !selectedCards.includes(cardId));
    return destinationCardListCardOrder[cardIndex];
};
const $18d2e600ad4c6d51$export$d2114dbf8a186566 = (isDragging, isCurrentCardListDragSource, cardMoveDisabled, isDraggingSubtask, isCmpKanbanBacklog)=>isDragging && !isCurrentCardListDragSource && (cardMoveDisabled && (!isDraggingSubtask || isCmpKanbanBacklog) || isDraggingSubtask && isCmpKanbanBacklog);

});

parcelRegister("ixOVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc0013909ff1f6e1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $fW62l = parcelRequire("fW62l");

var $bYdUR = parcelRequire("bYdUR");

var $dHJL9 = parcelRequire("dHJL9");

var $53KbV = parcelRequire("53KbV");

var $9ed83 = parcelRequire("9ed83");

var $2xkq3 = parcelRequire("2xkq3");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $7u8mi = parcelRequire("7u8mi");

var $MGmIU = parcelRequire("MGmIU");

var $dqoiX = parcelRequire("dqoiX");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $jDrwg = parcelRequire("jDrwg");

var $8zOmE = parcelRequire("8zOmE");


var $9USr3 = parcelRequire("9USr3");

var $3t5QD = parcelRequire("3t5QD");

var $hZ46s = parcelRequire("hZ46s");

var $emeAH = parcelRequire("emeAH");

var $013U5 = parcelRequire("013U5");

var $4lQkG = parcelRequire("4lQkG");

var $ayaAN = parcelRequire("ayaAN");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $ee1tL = parcelRequire("ee1tL");

var $c1MAf = parcelRequire("c1MAf");

var $9tZuw = parcelRequire("9tZuw");

var $5uBAa = parcelRequire("5uBAa");

var $fSgHa = parcelRequire("fSgHa");

var $2oFWP = parcelRequire("2oFWP");

var $4jqAD = parcelRequire("4jqAD");

var $kARaY = parcelRequire("kARaY");

var $b7YUC = parcelRequire("b7YUC");

var $aJ0IJ = parcelRequire("aJ0IJ");

var $kaE44 = parcelRequire("kaE44");

var $hTJrU = parcelRequire("hTJrU");

var $elctU = parcelRequire("elctU");

var $bs6dR = parcelRequire("bs6dR");


var $3pyss = parcelRequire("3pyss");

var $2dBGm = parcelRequire("2dBGm");

var $l4p68 = parcelRequire("l4p68");

var $9u5My = parcelRequire("9u5My");

var $5iS2L = parcelRequire("5iS2L");

var $3JQPC = parcelRequire("3JQPC");

var $1hEu3 = parcelRequire("1hEu3");

var $ldRVl = parcelRequire("ldRVl");

var $6bzbn = parcelRequire("6bzbn");

var $hkjgs = parcelRequire("hkjgs");

var $cOAVR = parcelRequire("cOAVR");

var $iiJr8 = parcelRequire("iiJr8");

var $gcvrq = parcelRequire("gcvrq");

var $gTtxS = parcelRequire("gTtxS");

var $c4Chf = parcelRequire("c4Chf");
const $cc0013909ff1f6e1$var$BacklogAccordionNudgeAsyncWithFullWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$FullWidthWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZ46s.BacklogAccordionNudgeAsync), null, children)); // for jsw_sprint_planning_whiteboards experiment,
const $cc0013909ff1f6e1$var$SprintPlanningWhiteboards = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const eligibleFlow = (0, $4jqAD.useGetWhiteboardEligibleFlow)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const fireWhiteboardsExposureEvents = (0, $4jqAD.useFireExposureEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (eligibleFlow === 'coUse' || eligibleFlow === 'crossFlow') {
            const cohort = (0, $6s1PB.expVal)('jsw_sprint_planning_whiteboards', 'cohort', 'not-enrolled');
            fireWhiteboardsExposureEvents(cohort);
            dispatch((0, $5uBAa.setWhiteboardEligibility)({
                flow: eligibleFlow,
                cohort: cohort
            }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        eligibleFlow
    ]);
    return null;
});
const $cc0013909ff1f6e1$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.create-sprint-button.a11y-helper-text';
function $cc0013909ff1f6e1$var$CardList({ cardListId: cardListId, type: type, typeForAnalytics: typeForAnalytics, name: name, sprintData: sprintData, isBacklogEmpty: isBacklogEmpty = false, isFirstList: isFirstList = false, isFirstNonEmptyList: isFirstNonEmptyList = false, isLastNonEmptyList: isLastNonEmptyList = false, isIccEnabled: isIccEnabled = false, isDisabled: isDisabled = false, isCollapsed: isCollapsed = false, isActiveSprint: isActiveSprint = false, isSprintMenuVisible: isSprintMenuVisible = false, isStartSprintEnabled: isStartSprintEnabled = false, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled = false, isCreateSprintButtonVisible: isCreateSprintButtonVisible = false, isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible = false, isStartSprintButtonVisible: isStartSprintButtonVisible = false, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible = false, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled = false, canEditIssue: canEditIssue = false, canEditSprint: canEditSprint = false, canManageSprints: canManageSprints = false, visibleCardAmount: visibleCardAmount = 0, justCreated: justCreated = false, onToggle: onToggleProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreateSprint: onCreateSprintProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardIds: cardIds, allCardIds: allCardIds, cardCountExcludingSubtasks: cardCountExcludingSubtasks, minColumnLimit: minColumnLimit, maxColumnLimit: maxColumnLimit, showTransitionZone: showTransitionZone, isWorkloadByAssigneeEnabled: isWorkloadByAssigneeEnabled = false }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const listRef = (0, $5uXOq.useRef)(null);
    const backlogContainerSize = (0, $3JQPC.useBacklogContainerSize)({
        ref: listRef
    });
    const leftSideRef = (0, $5uXOq.useRef)(null);
    const isBacklogCardList = type === (0, $guzeq.BACKLOG);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    (0, $5uXOq.useEffect)(()=>{
        if (justCreated) leftSideRef?.current?.focus();
    }, [
        justCreated
    ]);
    const formatDate = (0, $5iS2L.useFormatDate)();
    const { ref: startSprintButtonNudgeRef } = (0, $9USr3.useRegisterNudgeTarget)('start-sprint-button', isFirstList);
    const isMinLimitReached = !!minColumnLimit && minColumnLimit > allCardIds.length;
    const isMaxLimitReached = !!maxColumnLimit && maxColumnLimit < allCardIds.length;
    const onToggle = (event)=>{
        event.preventDefault();
        onToggleProp();
    };
    const renderRichCardDelay = 300;
    const setRichActiveCard = (0, $c1MAf.useBacklogActionCreator)((0, $9tZuw.setRichActiveCard));
    const [setRichActiveCardDebounced] = (0, $jDrwg.default)((cardID)=>{
        setRichActiveCard(cardID);
    }, renderRichCardDelay);
    const onHeaderKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            onToggleProp();
        }
    };
    const onCreateSprint = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprintProp(analyticsEvent);
    };
    const getListName = ()=>{
        switch(type){
            case 0, $guzeq.BOARD:
                // Only use name if default name is different
                if (isCompanyManaged) return name;
                return formatMessage((0, $6bzbn.default).boardListName);
            case 0, $guzeq.BACKLOG:
                return formatMessage((0, $6bzbn.default).backlogListName);
            case 0, $guzeq.SPRINT:
                return name;
            default:
                return '';
        }
    };
    const getEmptyList = ()=>{
        if (cardIds.length) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyListFilteredIssueTermRefresh : (0, $6bzbn.default).emptyListFiltered);
        switch(type){
            case 0, $guzeq.BOARD:
                return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyBoardIssueTermRefresh : (0, $6bzbn.default).emptyBoard);
            case 0, $guzeq.BACKLOG:
                return formatMessage((0, $6bzbn.default).emptyBacklog);
            case 0, $guzeq.SPRINT:
                if (isActiveSprint) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyStartedSprint);
                if (isFirstList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9u5My.default), null);
                return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).emptyNotStartedSprintIssueTermRefresh : (0, $6bzbn.default).emptyNotStartedSprint);
            default:
                return '';
        }
    };
    const chevronRightIcon = (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
        label: "expand",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))), {
        label: "expand",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    const chevronDownIcon = (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
        label: "expand",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9ed83))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
        label: "collapse",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    const renderIcon = ()=>isCollapsed ? chevronRightIcon : chevronDownIcon;
    const renderNumberOfVisibleCardsText = ()=>{
        const totalCardAmountUntruncated = cardCountExcludingSubtasks;
        const getText = ()=>{
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmountIssueTermRefresh, {
                totalCardAmount: totalCardAmountUntruncated,
                cardAmount: visibleCardAmount
            }) : formatMessage((0, $6bzbn.default).cardAmountIssueTermRefresh, {
                cardAmount: totalCardAmountUntruncated
            });
            return totalCardAmountUntruncated !== visibleCardAmount ? formatMessage((0, $6bzbn.default).visibleCardAmount, {
                totalCardAmount: totalCardAmountUntruncated,
                cardAmount: visibleCardAmount
            }) : formatMessage((0, $6bzbn.default).cardAmount, {
                cardAmount: totalCardAmountUntruncated
            });
        };
        return getText();
    };
    const renderStartSprintButton = ()=>{
        const totalCardAmount = cardIds.length;
        const isEmpty = totalCardAmount === 0;
        const shouldShowPrimaryButton = !isEmpty && isFirstList;
        const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOAVR.default // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
        ), {
            testId: "software-backlog.card-list.start-sprint-button",
            sprintId: cardListId,
            theme: !shouldShowPrimaryButton && !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $gTtxS.darkerButtonTheme) : null,
            appearance: shouldShowPrimaryButton ? 'primary' : 'default',
            isDisabled: (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? isStartSprintButtonDisabled || !canEditSprint : isStartSprintButtonDisabled,
            shouldShowDisabledButtonHelper: !canEditSprint,
            ref: startSprintButtonNudgeRef
        }, formatMessage((0, $6bzbn.default).startSprint)));
        const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: isFirstList,
            Wrapper: (0, $ayaAN.BacklogStartSprintNudgeAsync)
        }, button);
        if ((0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? isStartSprintButtonDisabled && canEditSprint : isStartSprintButtonDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DisabledStartSprintTooltip, null, totalCardAmount === 0 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).disabledStartSprintButtonEmptyIssueTermRefresh : (0, $6bzbn.default).disabledStartSprintButtonEmpty) : formatMessage((0, $6bzbn.default).disabledStartSprintButtonNoParallel))
        }, possiblyNudgeWrappedButton);
        return possiblyNudgeWrappedButton;
    };
    const renderCompleteSprintButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $emeAH.BacklogCompleteSprintNudgeAsync),
            conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw_perf_backlog_complete_sprint_button') ? nudgeStep === (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d) : true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bs6dR.default), {
            theme: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : (0, $gTtxS.darkerButtonTheme),
            sprintId: cardListId,
            testId: "software-backlog.card-list.complete-sprint-button",
            ...isCompleteSprintButtonDisabled && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? {
                isDisabled: true
            } : {}
        }, formatMessage((0, $6bzbn.default).completeSprint))));
    const renderSprintHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
            "data-test-id": "software-backlog.card-list.estimations-and-actions-container",
            "data-testid": "software-backlog.card-list.estimations-and-actions-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2dBGm.default), {
            cardListId: cardListId
        }), (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            alignItems: "center",
            xcss: $cc0013909ff1f6e1$var$cardMenuActionsStyles
        }, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
            cardListId: cardListId,
            cardListType: type,
            cardListName: name
        })), !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardMenuActionsWrapper, null, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
            cardListId: cardListId,
            cardListType: type,
            cardListName: name
        })));
    const renderCreateSprint = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$RightSide, {
            "data-test-id": "software-backlog.card-list.create-sprint-button-container",
            "data-testid": "software-backlog.card-list.create-sprint-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $4lQkG.BacklogCreateSprintNudgeAsync),
            conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw-perf-onboarding-backlog-create-sprint-load') ? nudgeStep === (0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID) : true
        }, !canManageSprints && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), {
            isDisabled: true,
            helpTextId: $cc0013909ff1f6e1$var$A11Y_HELPER_TEXT_ID,
            helpText: formatMessage((0, $6bzbn.default).createSprintButtonDisabledInfoTextNonFinal)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
            "aria-describedby": $cc0013909ff1f6e1$var$A11Y_HELPER_TEXT_ID,
            onClick: onCreateSprint,
            isDisabled: true,
            testId: "software-backlog.card-list.create-sprint-button",
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
        }, formatMessage((0, $6bzbn.default).createSprint))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
            onClick: onCreateSprint,
            isDisabled: isCreateSprintButtonDisabled,
            testId: "software-backlog.card-list.create-sprint-button",
            spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
        }, formatMessage((0, $6bzbn.default).createSprint))));
    const renderAddSprintDatesButton = ()=>{
        const stopPropogation = (e)=>e.stopPropagation();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper, {
            onClick: stopPropogation,
            onKeyDown: stopPropogation,
            "data-test-id": "software-backlog.card-list.add-sprint-date-button-container",
            "data-testid": "software-backlog.card-list.add-sprint-date-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
            cardListId: Number(cardListId)
        }));
    };
    const renderSprintData = ()=>{
        if (!sprintData) return null;
        const { goal: goal } = sprintData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$GoalWrapper, null, goal));
    };
    const renderColumnLimits = ()=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
            "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
            appearance: isMinLimitReached ? 'moved' : 'default',
            isBold: isMinLimitReached
        }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ColumnLimit, {
            "data-testid": (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
            appearance: isMaxLimitReached ? 'removed' : 'default',
            isBold: isMaxLimitReached
        }, `MAX ${maxColumnLimit}`)) : null);
    const renderLeftSide = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$LeftSide, {
            "data-testid": (0, $0226f08d081871ec$export$483ac6106791f695),
            role: "button",
            tabIndex: 0,
            "aria-controls": `backlog-accordion-${cardListId}`,
            onClick: onToggle,
            onKeyDown: onHeaderKeyDown,
            "aria-expanded": !isCollapsed,
            ref: leftSideRef
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $cc0013909ff1f6e1$var$chevronIconStyles
        }, renderIcon()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Icon, null, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            alignItems: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ListName, null, getListName()), sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$DatesWrapper, null, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisibleCardsInCardListHeader, null, "(", renderNumberOfVisibleCardsText(), ")"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "polite",
            role: "status"
        }, getListName(), " ", renderNumberOfVisibleCardsText())), renderColumnLimits())));
    const renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CardListHeaderContainer, {
            isMinLimitReached: isMinLimitReached,
            isMaxLimitReached: isMaxLimitReached,
            isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTJrU.CardListCheckbox), {
            cardListId: cardListId,
            isDisabled: isDisabled,
            ...(0, $4R6GH.fg)('a11y_violations_fixes') ? {
                listName: `${type === (0, $guzeq.SPRINT) ? `${formatMessage((0, $6bzbn.default).sprintListNamePrefix)} ` : ''}${getListName()}`
            } : {}
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: $cc0013909ff1f6e1$var$BacklogAccordionNudgeAsyncWithFullWidth,
            conditionsToApplyWrapper: ((0, $4R6GH.fg)('jsw-perf-backlog-lazy-instrumented-nudge-spotlight') ? !isOnboardingDismissed : true) && type === (0, $guzeq.BACKLOG)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$HeadingWrapper, null, renderLeftSide())), renderSprintHeader(), type === (0, $guzeq.BACKLOG) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2oFWP.BacklogButtonVariant), null), isCreateSprintButtonVisible && renderCreateSprint());
    const renderIccCard = (0, $5uXOq.useCallback)((cardEntry, row, isScrolling)=>{
        if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJ0IJ.CardGroup), {
            key: (0, $ee1tL.getCardEntryGroupKey)(cardEntry, cardListId),
            isScrolling: isScrolling,
            row: row,
            cardListId: cardListId,
            cardGroup: cardEntry,
            setRichActiveCard: setRichActiveCardDebounced
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7YUC.default), {
            cardListId: cardListId,
            cardId: cardEntry.cardId,
            row: row,
            isScrolling: isScrolling,
            isAttachedToParent: false,
            setRichActiveCard: setRichActiveCardDebounced
        });
    }, [
        cardListId,
        setRichActiveCardDebounced
    ]);
    const renderA11yScreenReaderInfo = ()=>justCreated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "assertive",
            id: `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`
        }, formatMessage((0, $6bzbn.default).createdSprintAriaLive, {
            sprintName: getListName()
        })));
    const isHeaderDropDisabled = !isCollapsed || isDisabled;
    const isDividerHidden = !canEditIssue || type === (0, $guzeq.BACKLOG) || isActiveSprint || isCollapsed && type === (0, $guzeq.SPRINT);
    const headerRef = (0, $5uXOq.useRef)(null);
    const transitionZoneElementRef = (0, $5uXOq.useRef)(null);
    const { isDraggingOver: isDraggingOverPragmatic } = (0, $gcvrq.useCardListDropTarget)({
        headerElementRef: headerRef,
        transitionZoneElementRef: transitionZoneElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    });
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CollapsedDropzoneWrapper, {
        ref: headerRef
    }, !isHeaderDropDisabled && isDraggingOverPragmatic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$CollapsedDropzone, null), !(0, $dCm1o.isVisualRefreshEnabled)() && renderHeader(), (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaE44.CardListHeader), {
        isCreateSprintButtonVisible: isCreateSprintButtonVisible,
        isDisabled: isDisabled,
        isMaxLimitReached: isMaxLimitReached,
        isMinLimitReached: isMinLimitReached,
        onCreateSprint: onCreateSprintProp,
        onToggle: onToggleProp
    }));
    const list = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JQPC.ContainerSizeContext).Provider, {
        value: {
            size: backlogContainerSize
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4p68.default), {
        cardListId: cardListId,
        renderCard: renderIccCard,
        isDropDisabled: isDisabled || showTransitionZone,
        emptyList: getEmptyList()
    }));
    const iccAriaLabelledById = `icc-${name.replace(/\s/g, '-')}`.toLowerCase();
    const iccWithNudge = ()=>{
        if (!isIccEnabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $013U5.BacklogCreateIssueNudgeAsync),
            conditionsToApplyWrapper: !!nudgeStep && isBacklogCardList
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hEu3.default), {
            listId: cardListId,
            isOpenByDefault: isFirstList && isBacklogEmpty,
            ariaLabelledBy: iccAriaLabelledById
        }));
    };
    const workloadByAssignee = ()=>!isBacklogCardList && isCompanyManaged && isWorkloadByAssigneeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c4Chf.default), {
            cardListId: cardListId,
            sprintName: name
        }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYdUR.default), {
        data: {
            attributes: {
                cardListType: typeForAnalytics
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$Container, {
        hasSpaceBetweenCardLists: canEditIssue ? isActiveSprint && !isCollapsed : false,
        isBacklogCardList: (0, $dCm1o.isVisualRefreshEnabled)() ? false : isBacklogCardList,
        isVisualRefreshEnabled: (0, $dCm1o.isVisualRefreshEnabled)(),
        isDisabled: isDisabled,
        "aria-controls": `${(0, $2lpqS.HEADER_DROPPABLE_ID_PREFIX)}${cardListId}`,
        "data-testid": `software-backlog.card-list.container.${cardListId}`
    }, renderA11yScreenReaderInfo(), header, isBacklogCardList && (0, $4R6GH.fg)('sprint_planning_whiteboards_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$SprintPlanningWhiteboards, null), !isCollapsed && renderSprintData(), !isCollapsed && workloadByAssignee(), !isCollapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$ListContainer, {
        id: `backlog-accordion-${cardListId}`,
        "data-testid": "software-backlog.card-list.accordion",
        innerRef: listRef,
        isFirstNonEmptyList: isFirstNonEmptyList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiJr8.default), {
        isVisible: showTransitionZone,
        ref: transitionZoneElementRef
    }), list, iccWithNudge(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc0013909ff1f6e1$var$VisuallyHidden, {
        as: "p",
        id: iccAriaLabelledById
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6bzbn.default).inlineCardCreateAriaLabelIssueTermRefresh : (0, $6bzbn.default).inlineCardCreateAriaLabel, {
        sprintName: getListName()
    }))), isLastNonEmptyList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldRVl.LastResultMarker), null)), !isDividerHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3pyss.default), {
        id: cardListId
    }));
}
var $cc0013909ff1f6e1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cc0013909ff1f6e1$var$CardList);
const $cc0013909ff1f6e1$var$ListNameExperiment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        as: "div",
        level: "h400"
    }, children); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasSpaceBetweenCardLists: hasSpaceBetweenCardLists, isDisabled: isDisabled, isBacklogCardList: isBacklogCardList, isVisualRefreshEnabled: isVisualRefreshEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9cs0k _1yt41uce",
            __cmplp.hasSpaceBetweenCardLists ? "_18s81km1" : "_18s861nu",
            __cmplp.isDisabled && "_tzy4105o",
            __cmplp.isDisabled && "_lcxvglyw",
            !__cmplp.isBacklogCardList && "_bfhkhri9",
            __cmplp.isVisualRefreshEnabled ? "_2rko12x7" : "_2rkou2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CardListHeaderControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ahoa2g-0"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $gwIPs.gridSize) * 4}px`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached })=>(isMinLimitReached || isMaxLimitReached) && `
            background-color: ${isMaxLimitReached ? "var(--ds-background-accent-red-subtlest, #FFEDEB)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"};
            /* negative margin to fill out the header correctly */
${''}
            margin: -${0, $gwIPs.gridSize}px -${(0, $gwIPs.gridSize) * 1.5}px;
${''}
            padding: ${0, $gwIPs.gridSize}px ${(0, $gwIPs.gridSize) * 1.5}px;
${''}
            border-top-left-radius: ${0, $gwIPs.gridSize}px;
${''}
            border-top-right-radius: ${0, $gwIPs.gridSize}px;
        `); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cc0013909ff1f6e1$var$CardListHeaderExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefreshEnabled: isVisualRefreshEnabled, isMinLimitReached: isMinLimitReached, isMaxLimitReached: isMaxLimitReached, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1lbjnkk": (0, $lD23V.default)(__cmplp.isMaxLimitReached ? "var(--ds-background-accent-red-subtlest, #FFEDEB)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.isVisualRefreshEnabled ? "_1tke1jfw" : "_1tkezwfg",
            (__cmplp.isMinLimitReached || __cmplp.isMaxLimitReached) && "_bfhk9rs6 _19pk1bs0 _2hwx1vh9 _otyr1bs0 _18u01vh9 _ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _13liftgi _qrwqftgi",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$CardListHeaderContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cc0013909ff1f6e1$var$CardListHeaderExperiment, $cc0013909ff1f6e1$var$CardListHeaderControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CardMenuActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _1e0c1txw _2lx2vrvc _fiawglyw",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$cardMenuActionsStyles = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.100',
    ':empty': {
        display: 'none'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$ListContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ahoa2g-1"
})({
    margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
    position: 'relative'
}, /* to correctly show the spotlight, to be removed when remove UIF changeboarding */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isFirstNonEmptyList: isFirstNonEmptyList })=>isFirstNonEmptyList && `
        *::before,
        *::after {
            z-index: 9;
        }`); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cc0013909ff1f6e1$var$ListContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8v0yc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$ListContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cc0013909ff1f6e1$var$ListContainerExperiment, $cc0013909ff1f6e1$var$ListContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $cc0013909ff1f6e1$var$ListNameControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ahoa2g-2"
})`${(0, $7u8mi).h400()};margin:0;`;
const $cc0013909ff1f6e1$var$ListName = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cc0013909ff1f6e1$var$ListNameExperiment, $cc0013909ff1f6e1$var$ListNameControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$VisibleCardsInCardListHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wyboqnp _syaz1wmz _k48p4jg8 _18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$ColumnLimit = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48p4jg8 _18s8xmni _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CollapsedDropzoneWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CollapsedDropzoneControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ahoa2g-3"
})({
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: `2px dashed ${"var(--ds-border, #dfe1e6)"}`,
    borderRadius: "'3px'"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cc0013909ff1f6e1$var$CollapsedDropzoneExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _19it7lsx _2rko15p7",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$CollapsedDropzone = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $cc0013909ff1f6e1$var$CollapsedDropzoneExperiment, $cc0013909ff1f6e1$var$CollapsedDropzoneControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$LeftSideOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _7ehi1vt6 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$LeftSideNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _80omtlke _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf _2hwxu2gc _otyridpf _18u0idpf _zulp1b66 _1ejj1vt6 _mizu1r31 _ra3xglyw _128m1o36",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$LeftSide = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $cc0013909ff1f6e1$var$LeftSideNew, $cc0013909ff1f6e1$var$LeftSideOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$RightSide = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$DisabledStartSprintTooltip = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt41b66 _y3gn1h6o _vwz410nf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$GoalWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vlj _syaz1wmz _18s8ze3t _19pkv77o _19bvpxbi _u5f3v47k _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$DatesWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wyboqnp _k48p4jg8 _18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$CardListButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$AddSprintDatesButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s8xmni",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$FullWidthWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi _11c8n7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc0013909ff1f6e1$var$VisuallyHidden = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ogtohxbz _mkrz1wmp _4t3it94y _1reo15vq _18m915vq _kqswstnw _o5721q9c _1bsbt94y",
            __cmplp.className
        ])
    });
});
const $cc0013909ff1f6e1$var$chevronIconStyles = (0, $jJ1Sb.xcss)({
    pointerEvents: 'none',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("9USr3", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $1aa5136c8225a4e1$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $1aa5136c8225a4e1$export$74f8d45d75dfda4f);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $44A56 = parcelRequire("44A56");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $1aa5136c8225a4e1$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $1aa5136c8225a4e1$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $1aa5136c8225a4e1$var$useNudgeController = ()=>$1aa5136c8225a4e1$var$NudgeController.instance;
const $1aa5136c8225a4e1$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $1aa5136c8225a4e1$var$useHasNudgeTargetNode = (id)=>{
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $1aa5136c8225a4e1$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
    const frameId = (0, $5uXOq.useRef)(null);
    const controller = $1aa5136c8225a4e1$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $1aa5136c8225a4e1$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            nudgeContainer.current = document.createElement('div');
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $1aa5136c8225a4e1$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $1aa5136c8225a4e1$var$usePortalContainer();
    const hasRefValue = $1aa5136c8225a4e1$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $1aa5136c8225a4e1$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $5uXOq.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44A56.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("3t5QD", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $44a5067dcee1bfd9$export$56d544c4f479b7fb);

var $5uXOq = parcelRequire("5uXOq");
const $44a5067dcee1bfd9$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});

parcelRegister("hZ46s", function(module, exports) {

$parcel$export(module.exports, "BacklogAccordionNudgeAsync", () => $b4a74cc5c51cd8ff$export$42c8a8a359e4c141);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b4a74cc5c51cd8ff$var$BacklogAccordionNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("9STay")).then((exportedModule)=>exportedModule.BacklogAccordionNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-accordion/index.tsx"
});
const $b4a74cc5c51cd8ff$export$42c8a8a359e4c141 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)
        },
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-accordion-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4a74cc5c51cd8ff$var$BacklogAccordionNudgeLazy, null, children)));
$b4a74cc5c51cd8ff$export$42c8a8a359e4c141.displayName = 'BacklogAccordionNudgeAsync';

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("9STay", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("f3hjO").then(()=>parcelRequire('jlBUT'));

});


parcelRegister("emeAH", function(module, exports) {

$parcel$export(module.exports, "BacklogCompleteSprintNudgeAsync", () => $8443c19cd20bb91b$export$ac45d9b04f7ab6cb);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8443c19cd20bb91b$var$BacklogCompleteSprintNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("2wxEW")).then((exportedModule)=>exportedModule.BacklogCompleteSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-complete-sprint/index.tsx"
});
const $8443c19cd20bb91b$export$ac45d9b04f7ab6cb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-complete-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8443c19cd20bb91b$var$BacklogCompleteSprintNudgeLazy, null, children)));
$8443c19cd20bb91b$export$ac45d9b04f7ab6cb.displayName = 'BacklogCompleteSprintNudgeAsync';

});
parcelRegister("2wxEW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("9pusu").then(()=>parcelRequire('llVsO'));

});


parcelRegister("013U5", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateIssueNudgeAsync", () => $dcc531286adcd54b$export$c82c69976e89b06);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dcc531286adcd54b$var$BacklogCreateIssueNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("dVRht")).then((exportedModule)=>exportedModule.BacklogCreateIssueNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-issue/index.tsx"
});
const $dcc531286adcd54b$export$c82c69976e89b06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$64d75060ee6ba425)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-onboarding-backlog-create-issue-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcc531286adcd54b$var$BacklogCreateIssueNudgeLazy, null, children)));
$dcc531286adcd54b$export$c82c69976e89b06.displayName = 'BacklogCreateIssueNudgeAsync';

});
parcelRegister("dVRht", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8ztGo").then(()=>parcelRequire('aafXz'));

});


parcelRegister("4lQkG", function(module, exports) {

$parcel$export(module.exports, "BacklogCreateSprintNudgeAsync", () => $84eda15ec395a74a$export$e8f8b0e825812dde);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $84eda15ec395a74a$var$BacklogCreateSprintNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("dDj73")).then((exportedModule)=>exportedModule.BacklogCreateSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-create-sprint/index.tsx"
});
const $84eda15ec395a74a$export$e8f8b0e825812dde = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$e0197e09cccd4e50)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-create-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84eda15ec395a74a$var$BacklogCreateSprintNudgeLazy, null, children)));
$84eda15ec395a74a$export$e8f8b0e825812dde.displayName = 'BacklogCreateSprintNudgeAsync';

});
parcelRegister("dDj73", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("kzqQi").then(()=>parcelRequire('3ylMW'));

});


parcelRegister("ayaAN", function(module, exports) {

$parcel$export(module.exports, "BacklogStartSprintNudgeAsync", () => $1f1e0a523bf7e02e$export$fa791bd23efa3d8e);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1f1e0a523bf7e02e$var$BacklogStartSprintNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("30IqH")).then((exportedModule)=>exportedModule.BacklogStartSprintNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-start-sprint/index.tsx"
});
const $1f1e0a523bf7e02e$export$fa791bd23efa3d8e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$6770a2081a63fc15)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-start-sprint-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f1e0a523bf7e02e$var$BacklogStartSprintNudgeLazy, null, children)));
$1f1e0a523bf7e02e$export$fa791bd23efa3d8e.displayName = 'BacklogStartSprintNudgeAsync';

});
parcelRegister("30IqH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("h7hha").then(()=>parcelRequire('9hvRa'));

});


parcelRegister("2oFWP", function(module, exports) {

$parcel$export(module.exports, "BacklogButtonVariant", () => $a8aa6c1e461e162e$export$5e6e40810a61fa60);

var $5uXOq = parcelRequire("5uXOq");

var $ar8lZ = parcelRequire("ar8lZ");

var $89thI = parcelRequire("89thI");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $2Lk47 = parcelRequire("2Lk47");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $eoB0b = parcelRequire("eoB0b");

var $3L1UG = parcelRequire("3L1UG");

var $7IKPD = parcelRequire("7IKPD");

var $crgSa = parcelRequire("crgSa");

var $3DKih = parcelRequire("3DKih");
const $a8aa6c1e461e162e$export$5e6e40810a61fa60 = ()=>{
    const { cohort: cohort, flow: flow } = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getWhiteboardEligibility));
    const coUseEligible = flow === 'coUse';
    const crossFlowEligible = flow === 'crossFlow';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const crossflow = (0, $ar8lZ.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $2Lk47.useFireCrossFlowAnalyticsEvents)();
    const url = (0, $3L1UG.useCoUseFlow)(coUseEligible);
    // Extract project name and project id
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const onPlanOnWhiteboard = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'planOnWhiteboardBacklogButton', {
            growthInitiative: 'cross-flow',
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            sourceComponent: 'planOnWhiteboardsButtonCTAScreen',
            sourceContext: 'planOnWhiteboardBacklogButton'
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'planOnWhiteboardBacklogButton'
        }, {
            targetProductId: (0, $ar8lZ.Targets).CONFLUENCE,
            recommendedProductIds: [
                (0, $ar8lZ.Targets).CONFLUENCE
            ],
            source: 'planOnWhiteboardsButtonCTAScreen'
        });
        (0, $3DKih.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: 'planOnWhiteboardsButtonCTAScreen',
            context: 'planOnWhiteboardBacklogButton',
            coUseEligible: coUseEligible,
            url: url
        });
    }, [
        crossFlowEligible,
        coUseEligible,
        projectId,
        projectName,
        crossflow,
        createAnalyticsEvent,
        fireInteractedUIEvent,
        url
    ]);
    if (!flow || cohort !== (0, $7IKPD.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).BACKLOG_BUTTON) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $a8aa6c1e461e162e$var$CTAContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        onClick: onPlanOnWhiteboard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        alignBlock: "center",
        space: "space.050"
    }, formatMessage((0, $crgSa.default).planOnWhiteboard), crossFlowEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        appearance: "new"
    }, formatMessage((0, $crgSa.default).planOnWhiteboardTry)))));
};
const $a8aa6c1e461e162e$var$CTAContainer = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.100'
});

});
parcelRegister("eoB0b", function(module, exports) {

$parcel$export(module.exports, "getHasConfluenceAccess", () => $cd0e8d2bc95119e8$export$6b10e8289feb83ca);
$parcel$export(module.exports, "getHasConfluenceSpaces", () => $cd0e8d2bc95119e8$export$2c012cbcdccebb42);
$parcel$export(module.exports, "getHasViewedPulse", () => $cd0e8d2bc95119e8$export$fa422fe0852b83ec);
$parcel$export(module.exports, "getWhiteboardEligibility", () => $cd0e8d2bc95119e8$export$db95b58c02bd0d3e);
const $cd0e8d2bc95119e8$export$ccc046947a5517f1 = (state)=>state.config.whiteboardsEntrypointExperimentConfig;
const $cd0e8d2bc95119e8$export$6b10e8289feb83ca = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasConfluenceAccess;
const $cd0e8d2bc95119e8$export$2c012cbcdccebb42 = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasConfluenceSpaces;
const $cd0e8d2bc95119e8$export$fa422fe0852b83ec = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).hasViewedPulse;
const $cd0e8d2bc95119e8$export$db95b58c02bd0d3e = (state)=>$cd0e8d2bc95119e8$export$ccc046947a5517f1(state).eligibility;

});

parcelRegister("3L1UG", function(module, exports) {

$parcel$export(module.exports, "useCoUseFlow", () => $6ef631c53c91a5d8$export$69587f2db02847d5);

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $aSijV = parcelRequire("aSijV");
const $6ef631c53c91a5d8$export$69587f2db02847d5 = (coUseEligible)=>{
    // Extract project name and project id
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const spaceKey = (0, $aSijV.useGetSpaceKey)(projectName, coUseEligible);
    const cloudId = (0, $koeKL.useCloudId)();
    return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${spaceKey}&withFallback=True`;
};

});
parcelRegister("aSijV", function(module, exports) {

$parcel$export(module.exports, "useGetSpaceKey", () => $cef2af2fe3579f0b$export$42371466d4d0aa3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $cef2af2fe3579f0b$export$42371466d4d0aa3 = (projectName, coUseEligible)=>{
    const [spaceKey, setSpaceKey] = (0, $5uXOq.useState)('');
    const checkForConfluenceSpace = (0, $5uXOq.useCallback)(async ()=>{
        if (coUseEligible) try {
            const cql = `type = space and title = "${projectName}"`;
            const api = `/wiki/rest/api/search?cql=${cql}`;
            const res = await (0, $eusud.performGetRequest)(api);
            if (res.results?.length) setSpaceKey(res.results[0].space.key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'GetSpaceKey',
                    packageName: 'jiraSoftwareBacklog'
                },
                error: error
            });
            setSpaceKey('');
        }
    }, [
        coUseEligible,
        projectName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        checkForConfluenceSpace();
    }, [
        checkForConfluenceSpace
    ]);
    return spaceKey;
};

});


parcelRegister("7IKPD", function(module, exports) {

$parcel$export(module.exports, "WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS", () => $0398d758657f1eb1$export$ed09d360c28bf9e1);
const $0398d758657f1eb1$export$3d370c33621572df = 'cohort';
const $0398d758657f1eb1$export$5b7423264d48ab04 = 'not-enrolled';
const $0398d758657f1eb1$export$b681d01ca4fade18 = 'jsw_sprint_planning_whiteboards';
const $0398d758657f1eb1$export$ed09d360c28bf9e1 = {
    CONTEXT_MENU: 'variant_contextual_menu',
    BACKLOG_BUTTON: 'variant_backlog_button',
    CONTROL: 'control'
};

});

parcelRegister("crgSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $567878f9577fb49b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567878f9577fb49b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    planOnWhiteboard: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard",
        "defaultMessage": "Plan on whiteboard"
    },
    planOnWhiteboardTry: {
        "id": "backlog.whiteboards-entrypoint-experiment.plan-on-whiteboard-try",
        "defaultMessage": "Try"
    }
});

});

parcelRegister("3DKih", function(module, exports) {

$parcel$export(module.exports, "onClickCTA", () => $6b33359cee0f3410$export$5765570e868a3d49);

var $ar8lZ = parcelRequire("ar8lZ");

var $8zOmE = parcelRequire("8zOmE");
const $6b33359cee0f3410$export$5765570e868a3d49 = ({ createAnalyticsEvent: createAnalyticsEvent, crossFlowEligible: crossFlowEligible, crossflow: crossflow, projectId: projectId, projectName: projectName, component: component, context: context, coUseEligible: coUseEligible, url: url })=>{
    if (crossFlowEligible) {
        if (!crossflow.isEnabled) return;
        if (!!projectId && !!projectName) crossflow.api.open({
            sourceComponent: component,
            sourceContext: context,
            targetProduct: (0, $ar8lZ.Targets).CONFLUENCE,
            journey: (0, $ar8lZ.Journeys).GET_STARTED,
            experimentalOptions: {
                projectId: projectId,
                projectName: projectName
            }
        });
        else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectInfo missing', {
            growthInitiative: 'cross-flow',
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            projectId: projectId,
            projectName: projectName
        });
    } else if (coUseEligible) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(url, '_blank');
};

});


parcelRegister("4jqAD", function(module, exports) {

$parcel$export(module.exports, "useFireExposureEvents", () => $05828c95ab191dbf$export$5659c1a3e6829401);
$parcel$export(module.exports, "useGetWhiteboardEligibleFlow", () => $05828c95ab191dbf$export$80c0213bc3410a42);

var $ar8lZ = parcelRequire("ar8lZ");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $2Lk47 = parcelRequire("2Lk47");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $eoB0b = parcelRequire("eoB0b");
// Checks if the number of issues in the backlog is greater than 2
const $05828c95ab191dbf$var$useIsBacklogCardListSizeGreaterThanTwo = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId))[0, $guzeq.BACKLOG]?.length > 2;
// Checks it the tenant has Confluence site
const $05828c95ab191dbf$var$useTenantHasConfluence = ()=>{
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    return licensedProducts?.confluence === true;
};
const $05828c95ab191dbf$var$useTenantHasProductSuggestionsEnabled = ()=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $9OXo1.useTenantContext)();
    return areProductSuggestionsEnabled;
};
const $05828c95ab191dbf$export$ff76dd1cdd043d2b = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const hasConfluence = $05828c95ab191dbf$var$useTenantHasConfluence();
    return $05828c95ab191dbf$var$useTenantHasProductSuggestionsEnabled() && !hasConfluence && isAdmin;
};
const $05828c95ab191dbf$export$9d3b05f7271c5614 = ()=>{
    const hasAccess = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceAccess));
    const hasSpaces = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasConfluenceSpaces));
    return $05828c95ab191dbf$var$useTenantHasConfluence() && hasAccess && hasSpaces;
};
const $05828c95ab191dbf$export$5659c1a3e6829401 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const crossFlowEligible = $05828c95ab191dbf$export$ff76dd1cdd043d2b();
    const coUseEligible = $05828c95ab191dbf$export$9d3b05f7271c5614();
    const { fireViewedScreenEvent: fireViewedScreenEvent } = (0, $2Lk47.useFireCrossFlowAnalyticsEvents)();
    const fireWhiteboardsExposureEvents = (cohort)=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'jswSprintPlanningWhiteboardsExperiment', {
            flagKey: (0, $f6RVN.JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT),
            cohort: cohort,
            crossFlowEligible: crossFlowEligible,
            coUseEligible: coUseEligible
        });
        // xflow UCIA events
        if (cohort === 'variant_contextual_menu') fireViewedScreenEvent('planOnWhiteboardsContextualCTAScreen', {
            recommendedProductIds: [
                (0, $ar8lZ.Targets).CONFLUENCE
            ]
        });
        else if (cohort === 'variant_backlog_button') fireViewedScreenEvent('planOnWhiteboardsButtonCTAScreen', {
            recommendedProductIds: [
                (0, $ar8lZ.Targets).CONFLUENCE
            ]
        });
        else if (cohort === 'control') (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'component'
        }), 'planOnWhiteboardsControlScreen');
    };
    return fireWhiteboardsExposureEvents;
};
const $05828c95ab191dbf$export$80c0213bc3410a42 = ()=>{
    const isCrossFlowEligible = $05828c95ab191dbf$export$ff76dd1cdd043d2b();
    const isCoUseEligible = $05828c95ab191dbf$export$9d3b05f7271c5614();
    const backlogCardListSizeGreaterThanTwo = $05828c95ab191dbf$var$useIsBacklogCardListSizeGreaterThanTwo();
    if (isCrossFlowEligible && backlogCardListSizeGreaterThanTwo) return 'crossFlow';
    if (isCoUseEligible && backlogCardListSizeGreaterThanTwo) return 'coUse';
    return null;
};

});

parcelRegister("kARaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd299d884dfbf90$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4cUUR = parcelRequire("4cUUR");

var $9gPwM = parcelRequire("9gPwM");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $iKdRC = parcelRequire("iKdRC");

var $93II4 = parcelRequire("93II4");

var $6bzbn = parcelRequire("6bzbn");
const $dbd299d884dfbf90$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR = 'software-backlog-add-sprint-dates-button-icon';
const $dbd299d884dfbf90$var$AddSprintDates = ({ cardListId: cardListId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $5uXOq.useState)(false);
    const onEditSprintClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openAddSprintDates');
        setIsEditSprintModalOpen(true);
    }, []);
    const onEditSprintModalCloseClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closeAddSprintDates');
        setIsEditSprintModalOpen(false);
    }, [
        createAnalyticsEvent
    ]);
    const editIcon = (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4cUUR))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9gPwM))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9gPwM))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93II4.default), {
        cardListId: cardListId,
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        appearance: "subtle",
        spacing: "compact",
        onClick: onEditSprintClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonIcon, {
        "data-component-selector": $dbd299d884dfbf90$var$ADD_SPRINT_DATES_BUTTON_ICON_SELECTOR
    }, editIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dbd299d884dfbf90$var$ButtonText, null, formatMessage((0, $6bzbn.default).addSprintDates))))));
};
var $dbd299d884dfbf90$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dbd299d884dfbf90$var$AddSprintDates;
const $dbd299d884dfbf90$var$ButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbd299d884dfbf90$var$ButtonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _4t3i7vkz _2hwxv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbd299d884dfbf90$var$ButtonContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4djwglyw",
            __cmplp.className
        ])
    });
});
const $dbd299d884dfbf90$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wybutpp _kewe1khi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4cUUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31046ec066064e88$var$_react = $31046ec066064e88$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31046ec066064e88$var$_UNSAFE_baseNew = $31046ec066064e88$var$_interopRequireDefault((parcelRequire("huIZN")));
function $31046ec066064e88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31046ec066064e88$var$EditIcon = (props)=>/*#__PURE__*/ $31046ec066064e88$var$_react.default.createElement($31046ec066064e88$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$31046ec066064e88$var$EditIcon.displayName = 'EditIcon';
var $31046ec066064e88$var$_default = module.exports.default = $31046ec066064e88$var$EditIcon;

});

parcelRegister("9gPwM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bfd93fdeacd3803$var$_react = $6bfd93fdeacd3803$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $6bfd93fdeacd3803$var$_edit = $6bfd93fdeacd3803$var$_interopRequireDefault((parcelRequire("4cUUR")));
function $6bfd93fdeacd3803$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6bfd93fdeacd3803$var$EditFilledIcon = (props)=>/*#__PURE__*/ $6bfd93fdeacd3803$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $6bfd93fdeacd3803$var$_edit.default
    }));
$6bfd93fdeacd3803$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $6bfd93fdeacd3803$var$_default = module.exports.default = $6bfd93fdeacd3803$var$EditFilledIcon;

});

parcelRegister("iKdRC", function(module, exports) {

$parcel$export(module.exports, "ModalTriggerButton", () => $dd7ef71db2053b80$export$f69d15d2f52857d);

var $5uXOq = parcelRequire("5uXOq");

var $8GVAj = parcelRequire("8GVAj");
var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $lu5k0 = parcelRequire("lu5k0");
const $dd7ef71db2053b80$export$f69d15d2f52857d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const internalRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const handleRef = (0, $5uXOq.useCallback)((element)=>{
        if (ref) {
            if (typeof ref === 'function') ref(element);
            else {
                // We need to proxy ref to avoid an eslint error (no-param-reassign)
                const mutableRef = ref;
                mutableRef.current = element;
            }
        }
        internalRef.current = element;
    }, [
        ref
    ]);
    const isIconProp = 'icon' in props;
    const onClickHandler = !isIconProp ? props.onClick : undefined;
    const iconButtonOnClickHandler = isIconProp ? props.onClick : undefined;
    const onClick = (0, $5uXOq.useCallback)((...args)=>{
        if (!isIconProp) {
            onClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        onClickHandler
    ]);
    const onIconButtonClick = (0, $5uXOq.useCallback)((...args)=>{
        if (isIconProp) {
            iconButtonOnClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        iconButtonOnClickHandler
    ]);
    if ('icon' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        ...props,
        ref: handleRef,
        onClick: onIconButtonClick
    });
    if ('theme' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
});

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);

var $7JoAD = parcelRequire("7JoAD");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $7JoAD.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $7JoAD.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $7JoAD.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("93II4", function(module, exports) {

$parcel$export(module.exports, "default", () => $660b345bfa093b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dXq4S = parcelRequire("dXq4S");

var $2WlZM = parcelRequire("2WlZM");

var $3psiG = parcelRequire("3psiG");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $ksKI7 = parcelRequire("ksKI7");

var $jG5HW = parcelRequire("jG5HW");

var $fSgHa = parcelRequire("fSgHa");
const $660b345bfa093b4f$var$EditSprintModalRelay = (props)=>{
    const { cardListId: cardListId, ...rest } = props;
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const cloudId = (0, $koeKL.useCloudId)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $2WlZM.default));
    const boardAri = (0, $5uXOq.useMemo)(()=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }), [
        boardId,
        cloudId
    ]);
    const sprintAri = (0, $5uXOq.useMemo)(()=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'sprint',
            resourceId: String(cardListId)
        }), [
        cloudId,
        cardListId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: boardAri,
            sprintId: sprintAri,
            fetchSprints: false
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        boardAri,
        loadQuery,
        sprintAri
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onSubmit = (data, submitPromise)=>{
        props.onSubmit(data, submitPromise);
        const { name: name, goal: goal, startDate: startDate, endDate: endDate } = data;
        const action = (0, $ksKI7.editSprintRequest)(cardListId, name, goal, startDate, endDate);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        submitPromise.then(()=>{
            dispatch((0, $ksKI7.editSprintSuccess)(optimisticId));
        }).catch(()=>{
            dispatch((0, $ksKI7.editSprintFailure)(optimisticId));
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3psiG.default), {
        ...rest,
        onSubmit: onSubmit,
        boardAri: boardAri,
        queryReference: queryReference,
        isCompanyManaged: isCompanyManaged
    });
};
var $660b345bfa093b4f$export$2e2bcd8739ae039 = $660b345bfa093b4f$var$EditSprintModalRelay;

});
parcelRegister("2WlZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff98ac7fe1a83638$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<deb8dc548bac2381f539e8316cad3232>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b

var $eiowN = parcelRequire("eiowN");
const $ff98ac7fe1a83638$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchSprints"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "sprintId",
            "variableName": "sprintId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v8 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "sprintState"
    }, v11 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprint",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.name"
                                        },
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v10 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprint.sprintState"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.sprint"
                            },
                            {
                                "condition": "fetchSprints",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprints",
                                        "plural": true,
                                        "selections": [
                                            v5 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v6 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.name"
                                            },
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.sprintState"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        },
                        {
                            "condition": "fetchSprints",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": v11 /*: any*/ 
                                }
                            ]
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
            "metadata": {},
            "name": "uiJiraSoftwareEditSprintModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff98ac7fe1a83638$var$node.hash = "c7b9c1c33647526da24d1f5d937ea327";
(0, $eiowN.PreloadableQueryRegistry).set($ff98ac7fe1a83638$var$node.params.id, $ff98ac7fe1a83638$var$node);
var $ff98ac7fe1a83638$export$2e2bcd8739ae039 = $ff98ac7fe1a83638$var$node;

});

parcelRegister("3psiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a40ac7c61cb3ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hPtZI = parcelRequire("hPtZI");

var $cYsq9 = parcelRequire("cYsq9");

const $58a40ac7c61cb3ec$var$LazyEditSprintModal = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("8iejr")), {
    moduleId: "./src/packages/software/edit-sprint-modal-relay/src/index.tsx"
});
const $58a40ac7c61cb3ec$var$EditSprintModal = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onError = ()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            isRelay: true,
            task: 'loadEditSprintModal'
        });
        (0, $cYsq9.editSprintModalLoad).cancel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "edit-sprint-modal",
        packageName: "editSprintModalRelay",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "edit-sprint-modal-relay",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($58a40ac7c61cb3ec$var$LazyEditSprintModal, props)));
};
var $58a40ac7c61cb3ec$export$2e2bcd8739ae039 = $58a40ac7c61cb3ec$var$EditSprintModal;

});
parcelRegister("cYsq9", function(module, exports) {

$parcel$export(module.exports, "clickEditSprintInteraction", () => $c290b89d2730547b$export$9c57106ef5795d9a);
$parcel$export(module.exports, "editSprintModalLoad", () => $c290b89d2730547b$export$c39d6b5415c8a491);

var $cHBMC = parcelRequire("cHBMC");
const $c290b89d2730547b$export$9c57106ef5795d9a = (0, $cHBMC.metrics).interaction({
    key: 'sprint-edit-click'
});
const $c290b89d2730547b$export$c39d6b5415c8a491 = (0, $cHBMC.metrics).interaction({
    key: 'edit-sprint-modal-load'
});

});

parcelRegister("8iejr", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("dtI1p")
]).then(()=>parcelRequire('3emwb'));

});



parcelRegister("6bzbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $99f26848a4b108c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $99f26848a4b108c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogListName: {
        "id": "backlog.card-list.backlog-list-name",
        "defaultMessage": "Backlog"
    },
    boardListName: {
        "id": "backlog.card-list.board-list-name",
        "defaultMessage": "Board"
    },
    cardAmount: {
        "id": "backlog.card-list.card-amount",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    visibleCardAmount: {
        "id": "backlog.card-list.visible-card-amount",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    emptyListFiltered: {
        "id": "backlog.card-list.empty-list-filtered",
        "defaultMessage": "There are no issues that match your current filter."
    },
    emptyBoard: {
        "id": "backlog.card-list.empty-board",
        "defaultMessage": "There are no issues on the board."
    },
    emptyBacklog: {
        "id": "backlog.card-list.empty-backlog",
        "defaultMessage": "Your backlog is empty."
    },
    emptyNotStartedSprint: {
        "id": "backlog.card-list.empty-not-started-sprint",
        "defaultMessage": "Plan a sprint by dragging the sprint footer down below some issues, or by dragging issues here."
    },
    emptyStartedSprint: {
        "id": "backlog.card-list.empty-started-sprint",
        "defaultMessage": "There are no issues in this sprint."
    },
    startSprint: {
        "id": "backlog.card-list.start-sprint",
        "defaultMessage": "Start sprint"
    },
    createSprint: {
        "id": "backlog.card-list.create-sprint",
        "defaultMessage": "Create sprint"
    },
    createSprintButtonDisabledInfoTextNonFinal: {
        "id": "backlog.card-list.create-sprint.create-sprint-button-disabled-info-text-non-final",
        "defaultMessage": "Request permissions from board admin"
    },
    completeSprint: {
        "id": "backlog.card-list.complete-sprint",
        "defaultMessage": "Complete sprint"
    },
    addSprintDates: {
        "id": "backlog.card-list.add-sprint-dates",
        "defaultMessage": "Add dates"
    },
    disabledStartSprintButtonEmpty: {
        "id": "backlog.card-list.disabled-start-sprint-button-empty",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    disabledStartSprintButtonNoParallel: {
        "id": "backlog.card-list.disabled-start-sprint-button-no-parallel",
        "defaultMessage": "Can be planned but not started until the completion of above active sprint"
    },
    createdSprintAriaLive: {
        "id": "backlog.card-list.created-sprint-aria-live",
        "defaultMessage": "{sprintName} created"
    },
    inlineCardCreateAriaLabel: {
        "id": "backlog.card-list.inline-card-create-aria-label",
        "defaultMessage": "Create issue for {sprintName}"
    },
    sprintListNamePrefix: {
        "id": "backlog.card-list.sprint-list-name-prefix",
        "defaultMessage": "sprint"
    },
    emptyListFilteredIssueTermRefresh: {
        "id": "backlog.card-list.empty-list-filtered-issue-term-refresh",
        "defaultMessage": "There are no issues that match your current filter."
    },
    emptyBoardIssueTermRefresh: {
        "id": "backlog.card-list.empty-board-issue-term-refresh",
        "defaultMessage": "There are no issues on the board."
    },
    emptyNotStartedSprintIssueTermRefresh: {
        "id": "backlog.card-list.empty-not-started-sprint-issue-term-refresh",
        "defaultMessage": "Plan a sprint by dragging the sprint footer down below some issues, or by dragging issues here."
    },
    emptyStartedSprintIssueTermRefresh: {
        "id": "backlog.card-list.empty-started-sprint-issue-term-refresh",
        "defaultMessage": "There are no issues in this sprint."
    },
    disabledStartSprintButtonEmptyIssueTermRefresh: {
        "id": "backlog.card-list.disabled-start-sprint-button-empty-issue-term-refresh",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    inlineCardCreateAriaLabelIssueTermRefresh: {
        "id": "backlog.card-list.inline-card-create-aria-label-issue-term-refresh",
        "defaultMessage": "Create issue for {sprintName}"
    },
    visibleCardAmountIssueTermRefresh: {
        "id": "backlog.card-list.visible-card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    cardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("b7YUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $79841489a061bb4b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kLOCW = parcelRequire("kLOCW");

var $iuO0E = parcelRequire("iuO0E");

var $3mWFd = parcelRequire("3mWFd");
const $79841489a061bb4b$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.memo)(({ cardListId: cardListId, cardId: cardId, isScrolling: isScrolling, row: row, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard })=>{
    const renderFullCard = (0, $3mWFd.useRenderFullItem)({
        isVisible: row.isVisible,
        isScrolling: isScrolling
    });
    if (!renderFullCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kLOCW.default), {
        id: typeof cardId === 'string' ? parseInt(cardId, 10) : cardId,
        key: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iuO0E.default), {
        key: cardId,
        cardId: cardId,
        cardListId: cardListId,
        isAttachedToParent: isAttachedToParent,
        forciblyRenderRichCard: forciblyRenderRichCard,
        setRichActiveCard: setRichActiveCard
    });
});
var $79841489a061bb4b$export$2e2bcd8739ae039 = $79841489a061bb4b$var$CardContainer;

});
parcelRegister("kLOCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e7fdcc1d4ad227$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $9ed83 = parcelRequire("9ed83");

var $2xkq3 = parcelRequire("2xkq3");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $fE0Ry = parcelRequire("fE0Ry");

var $g4tDr = parcelRequire("g4tDr");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $c1MAf = parcelRequire("c1MAf");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $ekU0X = parcelRequire("ekU0X");

var $g1Kbb = parcelRequire("g1Kbb");

var $hCPhj = parcelRequire("hCPhj");


var $7q84v = parcelRequire("7q84v");

var $kM28N = parcelRequire("kM28N");

var $khnfQ = parcelRequire("khnfQ");

var $3JQPC = parcelRequire("3JQPC");

var $4w5xH = parcelRequire("4w5xH");

var $1OiOR = parcelRequire("1OiOR");

var $46Lnx = parcelRequire("46Lnx");

var $dzwJA = parcelRequire("dzwJA");

var $MdcUe = parcelRequire("MdcUe");

var $5GU7f = parcelRequire("5GU7f");

var $7eYN2 = parcelRequire("7eYN2");

var $gQmIm = parcelRequire("gQmIm");

var $epPSJ = parcelRequire("epPSJ");
const $a8e7fdcc1d4ad227$var$CardLiteExtended = ({ style: style = {}, id: id, cardListId: cardListId, isAttachedToParent: isAttachedToParent = false })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const card = cards[String(id)] || {};
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { key: cardKey, summary: cardSummary, icon: icon, isDone: isDone, isFlagged: isFlagged, extraFields: extraFields, typeHierarchyLevel: typeHierarchyLevel, parentKey: parentKey } = card; // TODO: Collect these at a higher level and pass them down
    const shouldRenderPriorityColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const shouldRenderEstimatesColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const shouldRenderInlineAddFlag = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasFlaggedCards));
    const orderedVersions = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedVersions));
    const viewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const cardGroup = (0, $c1MAf.useBacklogSelector)((0, $ld0jI.makeGetCardGroupByParentId))(cardListId, id);
    const isCardGroupExpanded = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardGroupExpanded))(id);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const isSelected = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(id));
    const shouldShowChevron = hasLinkedSubtasks;
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(typeHierarchyLevel);
    const hasExtraFields = extraFields ? extraFields?.length > 0 : false;
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    const shouldShowCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const isCompactView = backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    const renderParentKey = ()=>{
        const parentKeyText = parentKey !== undefined ? formatMessage((0, $7q84v.default).parentKeyText, {
            parentKey: parentKey
        }) : '';
        return parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardGroupKey), null, `${parentKeyText}`) : null;
    };
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
            id: card.id
        });
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ExtraFieldsContainer), {
            isSmartCardEnabled: (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true),
            isAttachedToParent: isAttachedToParent && isCompanyManaged
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] ?? true).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1Kbb.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.400';
        if (shouldAddMargin) return 'space.250';
        return 'space.0';
    };
    const getChevronIcon = ()=>{
        if ((0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons')) return isCardGroupExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9ed83))),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))),
            color: "var(--ds-icon, #44546F)"
        });
        return isCardGroupExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))), {
            label: ""
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Container // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        hasExtraFields: hasExtraFields,
        isCompact: showCompactMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
        id: id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: showCompactMode,
        shouldShowChevron: shouldShowChevron,
        isFlagged: isFlagged,
        isDraggable: false,
        isDragHandle: false,
        hasExtraFields: hasExtraFields,
        lowerOpacity: false,
        isSelected: isSelected,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $jJ1Sb.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CheckboxContainer), {
        shouldShowCheckbox: shouldShowCheckbox
    })), renderCardColor(), hasLinkedSubtasks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$IconWrapper, null, getChevronIcon()), viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Icon, {
        src: icon
    })), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.KeyContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Key, {
        done: isDone,
        cardKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a8e7fdcc1d4ad227$var$Summary, {
        cardSummary: cardSummary
    })), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.OptionalFieldsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epPSJ.Versions), {
        card: card,
        isCompanyManaged: isCompanyManaged,
        backlogContainerSize: backlogContainerSize,
        isCardListContainsVersion: !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedVersions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $46Lnx.EpicLiteWrapper), {
        card: card,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eYN2.Status), {
        cardKey: cardKey,
        backlogContainerSize: backlogContainerSize
    }), viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OiOR.DueDate), {
        dueDate: card?.dueDate,
        isDone: isDone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MdcUe.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag
    }), viewSettings.showEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzwJA.EstimateLite), {
        shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQmIm.StoryPointLite), {
        issue: card
    })), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5GU7f.PriorityLite), {
        shouldRenderPriorityColumn: shouldRenderPriorityColumn,
        issueKey: cardKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w5xH.AssigneeLite), {
        issueKey: cardKey
    }))), renderExtraFields()));
};
const $a8e7fdcc1d4ad227$var$CardLiteExtendedMemo = /*#__PURE__*/ (0, $5uXOq.memo)($a8e7fdcc1d4ad227$var$CardLiteExtended);
var $a8e7fdcc1d4ad227$export$2e2bcd8739ae039 = $a8e7fdcc1d4ad227$var$CardLiteExtendedMemo;
const $a8e7fdcc1d4ad227$var$Summary = ({ cardSummary: cardSummary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            color: `${`var(--ds-text, ${(0, $5e0c0d4e15efb4a6$exports).N800})`}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        }
    }, cardSummary);
const $a8e7fdcc1d4ad227$var$Key = ({ cardKey: cardKey, done: done })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #44546F)",
            fontWeight: `${(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? "var(--ds-font-weight-regular, 400)" : "var(--ds-font-weight-semibold, 600)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            outline: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop: '0',
            textDecoration: `${done ? 'line-through' : 'none'}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingRight: "var(--ds-space-100, 0.5rem)"
        }
    }, cardKey);
const $a8e7fdcc1d4ad227$var$Icon = ({ src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
            width: (0, $gwIPs.gridSize) * 2,
            height: (0, $gwIPs.gridSize) * 2,
            verticalAlign: 'text-bottom'
        },
        src: src
    });
const $a8e7fdcc1d4ad227$var$Container = ({ children: children, style: style, hasExtraFields: hasExtraFields, isCompact: isCompact })=>{
    const cardRowHeight = isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-surface-raised, transparent)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            height: `${hasExtraFields ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textDecoration: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexDirection: 'column',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative'
        }
    }, children);
}; // Chevron icon wrapper, keep it consistent with src/packages/software/backlog/src/view/card-list/card/card-contents/view.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a8e7fdcc1d4ad227$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy14f8 _1ii7wtyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fE0Ry", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $7dd7529f3295a136$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $7dd7529f3295a136$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dWTaZ = parcelRequire("dWTaZ");

var $MGmIU = parcelRequire("MGmIU");

var $aWse0 = parcelRequire("aWse0");


var $fhSLy = parcelRequire("fhSLy");

var $evUrF = parcelRequire("evUrF");
const $7dd7529f3295a136$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dd7529f3295a136$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $7dd7529f3295a136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $7dd7529f3295a136$export$7df43f1214c1ab94;
const $7dd7529f3295a136$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1f4h _4t3i1f4h _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("ekU0X", function(module, exports) {

$parcel$export(module.exports, "CardColor", () => $f7387e350322f232$export$d6da217c85de72a2);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $f7387e350322f232$export$d6da217c85de72a2({ id: id }) {
    const color = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardColor)(state, id));
    if (!color) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f7387e350322f232$var$Container, {
        role: "presentation",
        color: color
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7387e350322f232$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1bsb1y44 _bfhk1cj8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g1Kbb", function(module, exports) {

$parcel$export(module.exports, "CardExtraField", () => $9e20187649cdd628$export$29842e7d338e26a1);

var $5uXOq = parcelRequire("5uXOq");

var $eaTAr = parcelRequire("eaTAr");

var $8nQtm = parcelRequire("8nQtm");

var $bwyRv = parcelRequire("bwyRv");

var $XIGKP = parcelRequire("XIGKP");

var $7omaD = parcelRequire("7omaD");

var $lTDsc = parcelRequire("lTDsc");
function $9e20187649cdd628$export$29842e7d338e26a1({ field: field, isLite: isLite }) {
    if ((0, $eaTAr.isExtraFieldThumbnail)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lTDsc.ThumbnailField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldLabel)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XIGKP.LabelsField), {
        field: field,
        isLite: isLite
    });
    if ((0, $eaTAr.isExtraFieldHtml)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bwyRv.HtmlField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldDate)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nQtm.DateField), {
        field: field
    });
    if ((0, $eaTAr.isExtraFieldText)(field)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7omaD.TextField), {
        field: field
    });
    return null;
}

});
parcelRegister("8nQtm", function(module, exports) {

$parcel$export(module.exports, "DateField", () => $4e396ac70e049afc$export$d9781c7894a82487);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $MGmIU = parcelRequire("MGmIU");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $4e396ac70e049afc$export$d9781c7894a82487({ field: field }) {
    let content = (0, $dRBdt.parseContent)(field.html);
    if ((0, $dRBdt.isDefault)(content)) content = (0, $dRBdt.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        as: "time",
        // @ts-expect-error Property 'dateTime' does not exist on type 'IntrinsicAttributes & { isDefault: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps & { ...; }'.
        dateTime: field.text,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        "aria-label": field.label,
        isDefault: (0, $dRBdt.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("hCPhj", function(module, exports) {

$parcel$export(module.exports, "Container", () => $211e50fd69ae0f6d$export$42a852a2b6b56249);
$parcel$export(module.exports, "FieldSeparator", () => $211e50fd69ae0f6d$export$35646e337882f8c7);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $211e50fd69ae0f6d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, isLink: isLink, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1e9r _1ul9idpf _1reo15vq _18m915vq _o5721q9c _rvu71q9c _3l5f15vq _1eex15vq _lyiy1l2s _1b6lhxbz _mfe41wmp _1rnet94y _r07x15vq _6e8f15vq _nd9nstnw _qb0y1q9c _1fy5t94y _1bsk1osq _1y8m1wug _la1rnkob _bqe6nkob _1ci4idpf _1md0idpf _1qwe1ule _qehnidpf _18vridpf _1nlwidpf _12isidpf _gzx61wug _47za1txw _i6cz1kw7 _odtp1b66 _rf3yusvi _153f1txw _x0hj1h6o _1rip1kw7 _19abze3t _xc9z1b66 _13psze3t _1udf15vq _1d0q15vq _121u4cjx _r7d31l2s _1bz61q9c _ufkk15vq _vtsa15vq _1g851fxt _1aaioqnp",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.isLink ? "_19pk1i6y" : "_19pk1kw7",
            __cmplp.isLink ? "_4t3i1ejb" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $211e50fd69ae0f6d$export$35646e337882f8c7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1d1o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dRBdt", function(module, exports) {

$parcel$export(module.exports, "isDefault", () => $28becdc44a135b68$export$75abdbb028a7ab06);
$parcel$export(module.exports, "parseContent", () => $28becdc44a135b68$export$4cf5403beffb0fc1);

var $gccSB = parcelRequire("gccSB");

var $2nvJN = parcelRequire("2nvJN");

const $28becdc44a135b68$export$75abdbb028a7ab06 = (content)=>content === (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7);
const $28becdc44a135b68$var$isNonBreakingSpace = (content)=>content === (0, $7aa9ed31c5ab3869$export$b6fa73900e7ac785);
const $28becdc44a135b68$var$isEmptyOrBlank = (content)=>!content || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(content));
const $28becdc44a135b68$var$isContentInvalid = (content)=>$28becdc44a135b68$var$isNonBreakingSpace(content) || $28becdc44a135b68$var$isEmptyOrBlank(content);
const $28becdc44a135b68$export$4cf5403beffb0fc1 = (content)=>$28becdc44a135b68$var$isContentInvalid(content) ? (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) : (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(content);

});
const $7aa9ed31c5ab3869$export$b6fa73900e7ac785 = '&nbsp;';
const $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7 = 'None';



parcelRegister("bwyRv", function(module, exports) {

$parcel$export(module.exports, "HtmlField", () => $37bb6fa1bfde042a$export$9cda3940184cdf77);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $MGmIU = parcelRequire("MGmIU");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $37bb6fa1bfde042a$export$9cda3940184cdf77({ field: field }) {
    const content = (0, $dRBdt.parseContent)(field.html);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $dRBdt.isDefault)(content),
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});

parcelRegister("XIGKP", function(module, exports) {

$parcel$export(module.exports, "LabelsField", () => $7274ee43ca72500a$export$b5a86c9a622796ff);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $h1hDx = parcelRequire("h1hDx");

var $MGmIU = parcelRequire("MGmIU");

var $55feQ = parcelRequire("55feQ");


var $dRBdt = parcelRequire("dRBdt");
const $7274ee43ca72500a$var$parseLabels = (text)=>{
    const content = (0, $dRBdt.parseContent)(text);
    return (0, $dRBdt.isDefault)(content) ? [] : (0, $55feQ.toLabels)(content);
};
const $7274ee43ca72500a$var$ItemRenderer = ({ item: item, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1hDx.default), {
        "aria-label": label,
        key: item,
        text: item
    });
function $7274ee43ca72500a$export$b5a86c9a622796ff({ field: field, isLite: isLite }) {
    const content = $7274ee43ca72500a$var$parseLabels(field.text);
    const wrap = (children)=>isLite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: field.label
        }, children);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(content)) return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$Container, {
        "aria-hidden": "true",
        isDefault: true
    }, (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7)));
    return wrap(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$Container, {
        "aria-hidden": "true",
        isDefault: false
    }, content.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7274ee43ca72500a$var$ItemRenderer, {
            key: i,
            item: item,
            label: item
        }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7274ee43ca72500a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefault: isDefault, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1e9r _1ul9idpf _p12f1osq _1reo15vq _18m915vq _o5721q9c _kqswh2mm _aetrb3bt _19doidpf _15l2idpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _16r260i3 _e9q69hw4 _1nvfidpf",
            __cmplp.isDefault ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h1hDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f79146db779bb3a0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kaN4O = parcelRequire("kaN4O");

var $38JYq = parcelRequire("38JYq");

var $eSPx4 = parcelRequire("eSPx4");
const $f79146db779bb3a0$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eSPx4.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kaN4O.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $38JYq.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $f79146db779bb3a0$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($f79146db779bb3a0$var$SimpleTagComponent);
var $f79146db779bb3a0$export$2e2bcd8739ae039 = $f79146db779bb3a0$var$SimpleTag;

});
parcelRegister("kaN4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba5339677b6d176$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $294ns = parcelRequire("294ns");

var $fwRsd = parcelRequire("fwRsd");

var $bia6Q = parcelRequire("bia6Q");
function $6ba5339677b6d176$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6ba5339677b6d176$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $fwRsd.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $fwRsd.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $fwRsd.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $fwRsd.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $fwRsd.cssVar).color.text.default})`,
    cursor: 'default'
});
const $6ba5339677b6d176$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $fwRsd.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $fwRsd.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $fwRsd.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6ba5339677b6d176$var$interactiveStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $fwRsd.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $fwRsd.cssVar).color.background.active})`
    }
});
const $6ba5339677b6d176$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6ba5339677b6d176$var$focusRingStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $fwRsd.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $6ba5339677b6d176$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$bia6Q.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6ba5339677b6d176$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $fwRsd.cssVar).color.text.active})`
    }
});
const $6ba5339677b6d176$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $bia6Q.textColors['standardLink'] : $bia6Q.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $bia6Q.backgroundColors[color] : $bia6Q.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $bia6Q.backgroundColors[color] : $bia6Q.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $294ns.fg)('platform-component-visual-refresh') ? $6ba5339677b6d176$var$baseStyles : $6ba5339677b6d176$var$baseStylesOld,
            isInteractive && ((0, $294ns.fg)('platform-component-visual-refresh') ? $6ba5339677b6d176$var$focusRingStyles : $6ba5339677b6d176$var$focusRingStylesOld),
            (0, $294ns.fg)('platform-component-visual-refresh') ? isLink && $6ba5339677b6d176$var$interactiveStyles : undefined,
            !(0, $294ns.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $6ba5339677b6d176$var$nonStandardLinkStyles,
            !(0, $294ns.fg)('platform-component-visual-refresh') && isInteractive && $6ba5339677b6d176$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.borderColor]: $bia6Q.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.text.default]: $bia6Q.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.text.hover]: $bia6Q.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.text.active]: $bia6Q.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.background.default]: $bia6Q.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.focusRing]: $bia6Q.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.removeButton.default]: $bia6Q.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).color.removeButton.hover]: $bia6Q.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $fwRsd.cssVar).borderRadius]: $bia6Q.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6ba5339677b6d176$export$2e2bcd8739ae039 = $6ba5339677b6d176$var$BaseTag;

});
parcelRegister("fwRsd", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $05c4c29bc4054c0c$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $05c4c29bc4054c0c$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $05c4c29bc4054c0c$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $05c4c29bc4054c0c$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $05c4c29bc4054c0c$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $05c4c29bc4054c0c$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $05c4c29bc4054c0c$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $05c4c29bc4054c0c$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $05c4c29bc4054c0c$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $05c4c29bc4054c0c$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $05c4c29bc4054c0c$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $dtXUS = parcelRequire("dtXUS");
const $05c4c29bc4054c0c$var$gridSizeValue = (0, $dtXUS.gridSize)();
const $05c4c29bc4054c0c$var$borderRadiusValue = (0, $dtXUS.borderRadius)();
const $05c4c29bc4054c0c$export$b4d89c3994664204 = 2.5 * $05c4c29bc4054c0c$var$gridSizeValue;
const $05c4c29bc4054c0c$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$05c4c29bc4054c0c$export$b4d89c3994664204}px`})`;
const $05c4c29bc4054c0c$export$c6f3ea2b4cffd0ca = $05c4c29bc4054c0c$export$b4d89c3994664204; // button should be square
const $05c4c29bc4054c0c$export$aba002ef70684916 = $05c4c29bc4054c0c$export$5b2b1030a679f37; // button should be square
const $05c4c29bc4054c0c$export$d5949a2c2ea9dcea = 25 * $05c4c29bc4054c0c$var$gridSizeValue;
const $05c4c29bc4054c0c$export$488fda99655ff65a = `${$05c4c29bc4054c0c$export$d5949a2c2ea9dcea}px`;
const $05c4c29bc4054c0c$export$2e3bcb01bf928995 = $05c4c29bc4054c0c$export$d5949a2c2ea9dcea - $05c4c29bc4054c0c$export$b4d89c3994664204;
const $05c4c29bc4054c0c$export$982d4a1a6de11130 = `${$05c4c29bc4054c0c$export$2e3bcb01bf928995}px`;
const $05c4c29bc4054c0c$export$35d5d1e251b985cf = `${$05c4c29bc4054c0c$var$borderRadiusValue}px`;
const $05c4c29bc4054c0c$export$c49771100fee18c8 = `${$05c4c29bc4054c0c$export$c6f3ea2b4cffd0ca / 2}px`;
const $05c4c29bc4054c0c$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$05c4c29bc4054c0c$var$gridSizeValue / 2}px`})`;
const $05c4c29bc4054c0c$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$05c4c29bc4054c0c$var$gridSizeValue / 2}px`})`;
const $05c4c29bc4054c0c$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $05c4c29bc4054c0c$var$gridSizeValue}px`})`;
const $05c4c29bc4054c0c$export$b824cac86306f7a2 = $05c4c29bc4054c0c$export$5b2b1030a679f37;
const $05c4c29bc4054c0c$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("bia6Q", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $0677aa163c3ceaa8$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $0677aa163c3ceaa8$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $0677aa163c3ceaa8$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $0677aa163c3ceaa8$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $0677aa163c3ceaa8$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $0677aa163c3ceaa8$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $0677aa163c3ceaa8$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $0677aa163c3ceaa8$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $0677aa163c3ceaa8$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $0677aa163c3ceaa8$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $0677aa163c3ceaa8$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $0677aa163c3ceaa8$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $0677aa163c3ceaa8$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $0677aa163c3ceaa8$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $fwRsd = parcelRequire("fwRsd");
const $0677aa163c3ceaa8$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$5e0c0d4e15efb4a6$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
};
const $0677aa163c3ceaa8$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $0677aa163c3ceaa8$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$5e0c0d4e15efb4a6$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$5e0c0d4e15efb4a6$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
};
const $0677aa163c3ceaa8$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$5e0c0d4e15efb4a6$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$5e0c0d4e15efb4a6$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
};
const $0677aa163c3ceaa8$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$5e0c0d4e15efb4a6$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$5e0c0d4e15efb4a6$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$5e0c0d4e15efb4a6$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$5e0c0d4e15efb4a6$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$5e0c0d4e15efb4a6$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$5e0c0d4e15efb4a6$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$5e0c0d4e15efb4a6$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$5e0c0d4e15efb4a6$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$5e0c0d4e15efb4a6$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$5e0c0d4e15efb4a6$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$5e0c0d4e15efb4a6$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`
};
const $0677aa163c3ceaa8$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$5e0c0d4e15efb4a6$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$5e0c0d4e15efb4a6$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$5e0c0d4e15efb4a6$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$5e0c0d4e15efb4a6$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$5e0c0d4e15efb4a6$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$5e0c0d4e15efb4a6$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$5e0c0d4e15efb4a6$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$5e0c0d4e15efb4a6$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$5e0c0d4e15efb4a6$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$5e0c0d4e15efb4a6$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb})`
};
const $0677aa163c3ceaa8$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$5e0c0d4e15efb4a6$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$5e0c0d4e15efb4a6$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$5e0c0d4e15efb4a6$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$5e0c0d4e15efb4a6$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$5e0c0d4e15efb4a6$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$5e0c0d4e15efb4a6$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$5e0c0d4e15efb4a6$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$5e0c0d4e15efb4a6$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$5e0c0d4e15efb4a6$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$5e0c0d4e15efb4a6$export$8754fc7e6d8b3000})`
};
const $0677aa163c3ceaa8$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a})`;
const $0677aa163c3ceaa8$export$7a57f79000377ca2 = {
    default: (0, $fwRsd.defaultBorderRadius),
    rounded: (0, $fwRsd.defaultRoundedBorderRadius)
};
const $0677aa163c3ceaa8$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd})`;
const $0677aa163c3ceaa8$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd})`;
const $0677aa163c3ceaa8$export$17d206ccea111bbb = `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$2837b5a1a71d5c02})`;
const $0677aa163c3ceaa8$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
};
const $0677aa163c3ceaa8$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
};

});


parcelRegister("38JYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24e2ba2c58aa1ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $294ns = parcelRequire("294ns");

var $fwRsd = parcelRequire("fwRsd");
function $a24e2ba2c58aa1ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a24e2ba2c58aa1ed$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $a24e2ba2c58aa1ed$var$beforeElementStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $fwRsd.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $a24e2ba2c58aa1ed$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $294ns.fg)('platform-component-visual-refresh') ? $a24e2ba2c58aa1ed$var$beforeElementStyles : $a24e2ba2c58aa1ed$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a24e2ba2c58aa1ed$export$2e2bcd8739ae039 = $a24e2ba2c58aa1ed$var$Before;

});

parcelRegister("eSPx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec1c23b6a91c8cc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $294ns = parcelRequire("294ns");

var $fwRsd = parcelRequire("fwRsd");
function $ec1c23b6a91c8cc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $ec1c23b6a91c8cc5$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $fwRsd.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $fwRsd.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $fwRsd.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $ec1c23b6a91c8cc5$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $fwRsd.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $ec1c23b6a91c8cc5$var$linkStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $fwRsd.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $fwRsd.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $fwRsd.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $ec1c23b6a91c8cc5$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $ec1c23b6a91c8cc5$var$hasAfterStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $fwRsd.maxTextWidthUnitless) - (0, $fwRsd.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $fwRsd.textPaddingRight)
});
const $ec1c23b6a91c8cc5$var$hasAfterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $fwRsd.maxTextWidthUnitless) - (0, $fwRsd.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $ec1c23b6a91c8cc5$var$hasBeforeStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $fwRsd.textMarginLeft)
});
const $ec1c23b6a91c8cc5$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $f8Sb3.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$baseStyles : $ec1c23b6a91c8cc5$var$baseStylesOld,
            (0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$linkStyles : $ec1c23b6a91c8cc5$var$linkStylesOld,
            !(0, $294ns.fg)('platform-component-visual-refresh') && elemBefore && $ec1c23b6a91c8cc5$var$hasBeforeStyles,
            isRemovable && (0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$hasAfterStyles : undefined,
            isRemovable && !(0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$baseStyles : $ec1c23b6a91c8cc5$var$baseStylesOld,
            !(0, $294ns.fg)('platform-component-visual-refresh') && elemBefore && $ec1c23b6a91c8cc5$var$hasBeforeStyles,
            isRemovable && (0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$hasAfterStyles : undefined,
            isRemovable && !(0, $294ns.fg)('platform-component-visual-refresh') ? $ec1c23b6a91c8cc5$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ec1c23b6a91c8cc5$export$2e2bcd8739ae039 = $ec1c23b6a91c8cc5$var$Content;

});


parcelRegister("55feQ", function(module, exports) {

$parcel$export(module.exports, "toLabels", () => $757bdacfe0ffe1b6$export$c17335eb990c7305);

var $kPH5D = parcelRequire("kPH5D");

var $80afZ = parcelRequire("80afZ");

var $lwKXv = parcelRequire("lwKXv");

var $2nvJN = parcelRequire("2nvJN");

var $2lpqS = parcelRequire("2lpqS");
function $757bdacfe0ffe1b6$var$notEmpty(value) {
    return Boolean(value);
}
const $757bdacfe0ffe1b6$export$c17335eb990c7305 = (content)=>{
    if (!content) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($kPH5D)))((0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, (/*@__PURE__*/$parcel$interopDefault($lwKXv)))(content, (0, $2lpqS.LABELS_FIELD_SEPARATOR)), (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))), $757bdacfe0ffe1b6$var$notEmpty);
};

});
parcelRegister("lwKXv", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $4rDUz = parcelRequire("4rDUz");

var $cErmc = parcelRequire("cErmc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/** Used as references for the maximum length and index of an array. */ var $fac1032dfd313195$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */ function $fac1032dfd313195$var$split(string, separator, limit) {
    if (limit && typeof limit != 'number' && $4rDUz(string, separator, limit)) separator = limit = undefined;
    limit = limit === undefined ? $fac1032dfd313195$var$MAX_ARRAY_LENGTH : limit >>> 0;
    if (!limit) return [];
    string = $jJVtR(string);
    if (string && (typeof separator == 'string' || separator != null && !$cErmc(separator))) {
        separator = $kHBB0(separator);
        if (!separator && $axH2S(string)) return $gvFfr($jx6Tp(string), 0, limit);
    }
    return string.split(separator, limit);
}
module.exports = $fac1032dfd313195$var$split;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});





parcelRegister("7omaD", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $faae5645873154f5$export$2c73285ae9390cec);

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $MGmIU = parcelRequire("MGmIU");

var $6s1PB = parcelRequire("6s1PB");

var $1RMb0 = parcelRequire("1RMb0");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");
function $faae5645873154f5$export$2c73285ae9390cec({ field: field }) {
    const isLink = field.renderer === 'url' && (0, $iZOJ9.isSafeUrl)(field.text) && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true);
    const content = (0, $dRBdt.parseContent)(field.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-label": field.label,
        "aria-hidden": (0, $dRBdt.isDefault)(content) ? 'true' : 'false',
        isDefault: (0, $dRBdt.isDefault)(content),
        isLink: isLink
    }, isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: content
    }) : content));
}

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("bVBtc")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("bVBtc", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("jo8eM")
]).then(()=>parcelRequire('k2J4N'));

});




parcelRegister("lTDsc", function(module, exports) {

$parcel$export(module.exports, "ThumbnailField", () => $357a48b1bf1d8f71$export$1ed5c8a60ea7f0e6);

var $5uXOq = parcelRequire("5uXOq");

var $6k6Kr = parcelRequire("6k6Kr");

var $8QaVO = parcelRequire("8QaVO");

var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $hCPhj = parcelRequire("hCPhj");

var $dRBdt = parcelRequire("dRBdt");

var $35nE2 = parcelRequire("35nE2");
function $357a48b1bf1d8f71$export$1ed5c8a60ea7f0e6({ field: field }) {
    const content = (0, $dRBdt.parseContent)(field.html);
    if ((0, $dRBdt.isDefault)(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: field.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.Container), {
        "aria-hidden": "true",
        isDefault: (0, $dRBdt.isDefault)(content)
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35nE2.Thumbnail), {
            label: field.label,
            content: content
        })
    }, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6k6Kr))), {
        "aria-label": field.label,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8QaVO))),
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8QaVO))), {
        "aria-label": field.label,
        size: "small",
        label: ""
    }));
}

});
parcelRegister("6k6Kr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d81bb6070c9f91ee50032d649348544>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49a9d857b874d3ad$var$_react = $49a9d857b874d3ad$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $49a9d857b874d3ad$var$_UNSAFE_baseNew = $49a9d857b874d3ad$var$_interopRequireDefault((parcelRequire("huIZN")));
function $49a9d857b874d3ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49a9d857b874d3ad$var$AttachmentIcon = (props)=>/*#__PURE__*/ $49a9d857b874d3ad$var$_react.default.createElement($49a9d857b874d3ad$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 4.5 5.75 9a1.414 1.414 0 1 0 2 2l4.5-4.5a2.828 2.828 0 1 0-4-4L3.75 7a4.243 4.243 0 0 0 6 6l2.5-2.5"/>`
    }, props));
$49a9d857b874d3ad$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $49a9d857b874d3ad$var$_default = module.exports.default = $49a9d857b874d3ad$var$AttachmentIcon;

});

parcelRegister("8QaVO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66fba8cc744fb339$var$_react = $66fba8cc744fb339$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $66fba8cc744fb339$var$_attachment = $66fba8cc744fb339$var$_interopRequireDefault((parcelRequire("6k6Kr")));
function $66fba8cc744fb339$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66fba8cc744fb339$var$AttachmentIcon = (props)=>/*#__PURE__*/ $66fba8cc744fb339$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $66fba8cc744fb339$var$_attachment.default
    }));
$66fba8cc744fb339$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $66fba8cc744fb339$var$_default = module.exports.default = $66fba8cc744fb339$var$AttachmentIcon;

});

parcelRegister("35nE2", function(module, exports) {

$parcel$export(module.exports, "Thumbnail", () => $77a779874f565d3f$export$1cd1efc78cb52ca5);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");
function $77a779874f565d3f$export$1cd1efc78cb52ca5({ label: label, content: content }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(content)
        }
    }));
}

});



const $f836df2846e6254b$export$ca45cc072d50480d = 'software-backlog.card-list.card.card-contents.context-menu.menu_placeholder';
const $f836df2846e6254b$export$fb374ae0d58ab29b = 'software-backlog-card-container';

parcelRegister("7q84v", function(module, exports) {

$parcel$export(module.exports, "default", () => $f792d98d36f7133b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f792d98d36f7133b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    cardFocusScreenreaderText: {
        "id": "backlog.card-list.card.card-focus-screenreader-text",
        "defaultMessage": "Use the enter key to load the issue view. Use the space key to move the issue."
    },
    epicLozenge: {
        "id": "backlog.card-list.card.epic-lozenge",
        "defaultMessage": "epic"
    },
    flaggedTooltip: {
        "id": "backlog.card-list.card.flagged-tooltip",
        "defaultMessage": "Flagged"
    },
    addFlagTooltip: {
        "id": "backlog.card-list.card.add-flag-tooltip",
        "defaultMessage": "Add Flag"
    },
    storyPointsTooltip: {
        "id": "backlog.card-list.card.story-points-tooltip",
        "defaultMessage": "Story points"
    },
    storyPointsAriaLabel: {
        "id": "backlog.card-list.card.story-points-aria-label",
        "defaultMessage": "Story points: {storyPointValue}"
    },
    storyPointsAriaLabelNullValue: {
        "id": "backlog.card-list.card.story-points-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    statusTooltip: {
        "id": "backlog.card-list.card.status-tooltip",
        "defaultMessage": "Status"
    },
    numberOfChildrenText: {
        "id": "backlog.card-list.card.number-of-children-text",
        "defaultMessage": "{numberOfChildren} {numberOfChildren, plural, one {subtask} other {subtasks}}"
    },
    parentKeyText: {
        "id": "backlog.card-list.card.parent-key-text",
        "defaultMessage": "Subtask of {parentKey}"
    },
    cardGroupToggleExpandedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-expanded-aria-label",
        "defaultMessage": "Hide subtasks for {issueKey} {summary}"
    },
    cardGroupToggleCollapsedAriaLabel: {
        "id": "backlog.card-list.card.card-group-toggle-collapsed-aria-label",
        "defaultMessage": "Show subtasks for {issueKey} {summary}"
    },
    cardGroupToggleTooltipExpand: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-expand",
        "defaultMessage": "Expand"
    },
    cardGroupToggleTooltipCollapse: {
        "id": "backlog.card-list.card.card-group-toggle-tooltip-collapse",
        "defaultMessage": "Collapse"
    },
    childIssuesMetadataTooltipIssueTermRefresh: {
        "id": "backlog.card-list.card.child-issues-metadata-tooltip-issue-term-refresh",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    cardFocusScreenreaderTextIssueTermRefresh: {
        "id": "backlog.card-list.card.card-focus-screenreader-text-issue-term-refresh",
        "defaultMessage": "Use the enter key to load the issue view. Use the space key to move the issue."
    },
    cardGroupToggleExpandedAriaLabelIssueTermRefresh: {
        "id": "backlog.card-list.card.card-group-toggle-expanded-aria-label-issue-term-refresh",
        "defaultMessage": "Hide subtasks for {issueKey} {summary}"
    },
    cardGroupToggleCollapsedAriaLabelIssueTermRefresh: {
        "id": "backlog.card-list.card.card-group-toggle-collapsed-aria-label-issue-term-refresh",
        "defaultMessage": "Show subtasks for {issueKey} {summary}"
    }
});

});

parcelRegister("kM28N", function(module, exports) {

$parcel$export(module.exports, "Key", () => $7890ada1e2d232ce$export$cd0f44441c3b7719);
$parcel$export(module.exports, "Img", () => $7890ada1e2d232ce$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "CheckboxContainer", () => $7890ada1e2d232ce$export$be6fcc6a7e078caa);
$parcel$export(module.exports, "CardGroupToggle", () => $7890ada1e2d232ce$export$fc8eb8928c84ef7b);
$parcel$export(module.exports, "ImageContainer", () => $7890ada1e2d232ce$export$94026ee33dbabc26);
$parcel$export(module.exports, "KeyContainer", () => $7890ada1e2d232ce$export$87cb5a8bc2c72dc8);
$parcel$export(module.exports, "ScreenReaderKey", () => $7890ada1e2d232ce$export$543895d0ab5334d);
$parcel$export(module.exports, "SummaryAndParentContainer", () => $7890ada1e2d232ce$export$b2027db09cc3f848);
$parcel$export(module.exports, "SummaryWrapper", () => $7890ada1e2d232ce$export$b13648308b87115);
$parcel$export(module.exports, "Summary", () => $7890ada1e2d232ce$export$46453a0401d6cd1a);
$parcel$export(module.exports, "EpicWrapper", () => $7890ada1e2d232ce$export$6dc4dd6105cae5b0);
$parcel$export(module.exports, "ExtraFieldsContainer", () => $7890ada1e2d232ce$export$716284ed33ba9160);
$parcel$export(module.exports, "AssigneeContainer", () => $7890ada1e2d232ce$export$35cb5ad1a5a164c6);
$parcel$export(module.exports, "MenuPlaceholder", () => $7890ada1e2d232ce$export$19dffc35a621b610);
$parcel$export(module.exports, "DragHandleCardsAmount", () => $7890ada1e2d232ce$export$574576b1d7c68429);
$parcel$export(module.exports, "StyledSpinner", () => $7890ada1e2d232ce$export$a7b75c5e23a48343);
$parcel$export(module.exports, "OptionalFieldsContainer", () => $7890ada1e2d232ce$export$2c60bada4ddd3b79);
$parcel$export(module.exports, "CardContainer", () => $7890ada1e2d232ce$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "ContentContainer", () => $7890ada1e2d232ce$export$9d2b4227a95687cc);
$parcel$export(module.exports, "CardGroupKey", () => $7890ada1e2d232ce$export$18c03323864bfda5);
$parcel$export(module.exports, "VersionIconWrapper", () => $7890ada1e2d232ce$export$e010d58e8595e079);
$parcel$export(module.exports, "VersionIconNumber", () => $7890ada1e2d232ce$export$b224c3920d5dc114);
$parcel$export(module.exports, "SubtaskIconWrapper", () => $7890ada1e2d232ce$export$bafafde73fef7397);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $89thI = parcelRequire("89thI");


var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");
// The hex code for the colour is used as that value does not exist in the colors from '@atlaskit/theme'
const $7890ada1e2d232ce$var$cardFlaggedColor = '#FFF7D6';
const $7890ada1e2d232ce$var$cardFlaggedAndHoveredColor = '#F8E6A0';
const $7890ada1e2d232ce$var$cardFlaggedAndSelectedColor = '#F5CD47';
const $7890ada1e2d232ce$export$122b84414b9478ae = (isSelected, isFlagged)=>{
    let bgColor = `var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`;
    if (isFlagged && isSelected) bgColor = `var(--ds-background-warning-pressed, ${$7890ada1e2d232ce$var$cardFlaggedAndSelectedColor})`;
    else if (isFlagged) bgColor = `var(--ds-background-warning, ${$7890ada1e2d232ce$var$cardFlaggedColor})`;
    else if (isSelected) bgColor = `var(--ds-background-selected, ${(0, $5e0c0d4e15efb4a6$exports).B50})`;
    return bgColor;
};
const $7890ada1e2d232ce$var$getHoverBgColor = (isSelected, isFlagged)=>{
    let hoverBgColor = `var(--ds-background-neutral-subtle-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N10})`;
    if (isFlagged) hoverBgColor = `var(--ds-background-warning-hovered, ${$7890ada1e2d232ce$var$cardFlaggedAndHoveredColor})`;
    else if (isSelected) hoverBgColor = `var(--ds-background-selected-hovered, ${(0, $5e0c0d4e15efb4a6$exports).B50})`;
    return hoverBgColor;
};
const $7890ada1e2d232ce$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ect4qk37 _1wyb1no3 _syaz1n3s _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _o5721q9c",
            (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? "_k48pi7a9" : "_k48p1pd9",
            __cmplp.isDone ?? false ? "_4bfu1r81 _1hms1cog _ajmmvv82" : "_4bfu1r81 _1hmsagmp _ajmmvv82",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$be6fcc6a7e078caa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowCheckbox: shouldShowCheckbox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _1pbykb7n _1e0c1txw _1bah1h6o _yyhy168a _1ii7wtyw",
            __cmplp.shouldShowCheckbox ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$fc8eb8928c84ef7b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $89thI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbdlk8 _4t3idlk8 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$94026ee33dbabc26 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$87cb5a8bc2c72dc8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n _yyhy1l0g _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$543895d0ab5334d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7890ada1e2d232ce$export$cd0f44441c3b7719, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_142m7mnp _19pm1wmp _1ybtt94y _1ma0t94y _3sml1n1a _hsjw1n1a _2u081n1a _4jes1n1a _1k9z15vq _xghe15vq _1nagidpf _172jidpf _1lrxidpf _1akkidpf _nxshstnw _nt751r31 _49pcglyw _1hvw1o36 _7ehi1vt6 _twmeglyw _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b2027db09cc3f848 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _vchhusvi _uiztglyw _yyhy1uzv _1ii7wtyw _4cvr1h6o _1ul9idpf _1ouwidpf",
            __cmplp.isSummaryFieldEditing ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b13648308b87115 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSummaryFieldEditing: isSummaryFieldEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_19g2etl": (0, $lD23V.default)(__cmplp.isSummaryFieldEditing && '100%')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsbstyr",
            __cmplp.isSummaryFieldEditing ? "_1pbycs5v" : "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$46453a0401d6cd1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1kt9b3bt _cfu11ule",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$6dc4dd6105cae5b0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`),
            "--_ichgug": (0, $lD23V.default)(`${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _6a6zv2br _yv0e105t _1ul9bcwo _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$56fba512661ff388 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0e105t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$d6d2b7ad039cd190 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$15529022dcaf3eec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _4t3i1tcg _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$716284ed33ba9160 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hideTypeIcon: hideTypeIcon, isSmartCardEnabled: isSmartCardEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7pazf _1e0c11p5 _vchhusvi _yv0eql95 _4cvrv2br _syaz1e9r _gy1p1b66 _1reo15vq _18m915vq _1ouwidpf _vqbzkb7n",
            __cmplp.hideTypeIcon ? "_yyhy4co5" : "_yyhydpws",
            __cmplp.isSmartCardEnabled ? "_4t3i1cfm" : "_4t3i1ul9",
            __cmplp.isSmartCardEnabled ? "_ca0qv77o" : "_ca0qze3t",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$35cb5ad1a5a164c6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1eaj _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$19dffc35a621b610 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMenuOpen: isMenuOpen, isPulseActive: isPulseActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9xy5q _yyhy1m0k _1ii7wtyw _kqswh2mm",
            __cmplp.isMenuOpen || __cmplp.isPulseActive ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$444c71687e56d76e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154iidpf _1xi2idpf _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$574576b1d7c68429 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154ir5cr _1ltvr5cr _t9ec1tul",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$a7b75c5e23a48343 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy1m0k _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$2c60bada4ddd3b79 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yv0e1gmk _yyhy1sd3 _1ii7wtyw _1e0c1txw _vchhusvi _4cvr1h6o _etbnotz2 _1bmuidpf _1uu8idpf",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$c20c19c635a1723f = ()=>'[start checkbox] min-content ';
const $7890ada1e2d232ce$export$cf4b3a0da67596a8 = (gridTemplateColumnsValue, shouldShowChevron)=>{
    if (shouldShowChevron) {
        if (gridTemplateColumnsValue) return '[chevron] 16px';
        return '[start chevron] 12px ';
    }
    return '';
};
const $7890ada1e2d232ce$export$73efac7034b68854 = (gridTemplateColumnsValue)=>{
    if (gridTemplateColumnsValue) return '[issue-type] 16px ';
    return '[start issue-type] 16px ';
};
const $7890ada1e2d232ce$export$4439a7282ef88de8 = ({ isOptimistic: isOptimistic })=>{
    if (isOptimistic) return `0 ${(0, $gwIPs.gridSize) / 2}px 0 ${(0, $gwIPs.gridSize) * 3.5}px`;
    return `0 ${(0, $gwIPs.gridSize) / 2}px 0 ${(0, $gwIPs.gridSize) * 1.5}px`;
};
const $7890ada1e2d232ce$var$calculateGridTemplateValues = ({ hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact = false, hideTypeIcon: hideTypeIcon = false, isAssigneeShown: isAssigneeShown = true })=>{
    let gridTemplateColumnsValue = '';
    let gridTemplateRowsValue = '';
    gridTemplateColumnsValue += $7890ada1e2d232ce$export$c20c19c635a1723f();
    gridTemplateColumnsValue += $7890ada1e2d232ce$export$cf4b3a0da67596a8(gridTemplateColumnsValue, shouldShowChevron);
    if (!hideTypeIcon) gridTemplateColumnsValue += $7890ada1e2d232ce$export$73efac7034b68854(gridTemplateColumnsValue);
    gridTemplateColumnsValue += '[issue-key] min-content [summary] 1fr';
    if (!isDragHandle) {
        gridTemplateColumnsValue += ' ';
        gridTemplateColumnsValue += '[card-group-key] max-content ';
        gridTemplateColumnsValue += [
            '[optional-fields] max-content',
            /* These values have to be in PX to ensure the elements take exactly the amount of space they need. Using a token/REM causes issues if browser's font size settings are set to smaller or larger */ `[assignee] ${isAssigneeShown ? 'calc(8px * 3.5)' : "var(--ds-space-0, 0px)"}`,
            '[menu] 32px',
            '[end]'
        ].join(' ');
    }
    // Minus 1 to fix layout issues
    // We need to totally rework the layout to do this properly
    gridTemplateRowsValue += `[start card-detail] ${(isCompact ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT)) - 1}px `;
    if (!isDragHandle && hasExtraFields) gridTemplateRowsValue += `[card-extra-fields] ${0, $2lpqS.EXTRA_CARD_ROW_HEIGHT}px [end]`;
    else gridTemplateRowsValue += '[end]';
    return {
        gridTemplateColumnsValue: gridTemplateColumnsValue,
        gridTemplateRowsValue: gridTemplateRowsValue
    };
};
const $7890ada1e2d232ce$export$8a23e74e5cf3ca41 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isFlagged: isFlagged, isDraggable: isDraggable, lowerOpacity: lowerOpacity, hasExtraFields: hasExtraFields, shouldShowChevron: shouldShowChevron, isDragHandle: isDragHandle, isCompact: isCompact, hideTypeIcon: hideTypeIcon, isAssigneeShown: isAssigneeShown, isOptimistic: isOptimistic, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_fbeie2": (0, $lD23V.default)($7890ada1e2d232ce$export$122b84414b9478ae(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false)),
            "--_183xcfk": (0, $lD23V.default)($7890ada1e2d232ce$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateColumnsValue),
            "--_1d7lvij": (0, $lD23V.default)($7890ada1e2d232ce$var$calculateGridTemplateValues({
                hasExtraFields: __cmplp.hasExtraFields,
                shouldShowChevron: __cmplp.shouldShowChevron,
                isDragHandle: __cmplp.isDragHandle,
                isCompact: __cmplp.isCompact ?? false,
                hideTypeIcon: __cmplp.hideTypeIcon ?? false,
                isAssigneeShown: __cmplp.isAssigneeShown ?? true
            }).gridTemplateRowsValue),
            "--_vwvgr5": (0, $lD23V.default)((()=>{
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                const cardRowHeight = __cmplp.isCompact ?? false ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                return __cmplp.hasExtraFields ? `${cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT)}px` : `${cardRowHeight}px`;
            })()),
            "--_xn0y17": (0, $lD23V.default)($7890ada1e2d232ce$export$4439a7282ef88de8({
                isOptimistic: __cmplp.isOptimistic
            })),
            "--_13xqh42": (0, $lD23V.default)($7890ada1e2d232ce$var$getHoverBgColor(__cmplp.isSelected ?? false, __cmplp.isFlagged ?? false))
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkbi58 _1e0c11p5 _yv0es54b _2z05kxnq _gy1p1b66 _1p57idpf _4cvr1h6o _kqswh2mm _4t3i8lrv _1yt414ue _19it1l7n _4bfu18uv _1hmsglyw _ajmmnqa1 _19pk1i6y _1tvzbi58 _v8f3ewfl _f48lewfl _1jy6ewfl _16cmewfl _irr3mtee _nhtqmtee _kb9newfl _7zc6ewfl",
            __cmplp.isDraggable === true ? "_80omtlke" : "_80om73ad",
            __cmplp.lowerOpacity ? "_tzy41ou4" : "_tzy41kw7",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _bfhk1qds",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$18c03323864bfda5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $7890ada1e2d232ce$export$cd0f44441c3b7719, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1kw7 _1e0c1bgi _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$e010d58e8595e079 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$b224c3920d5dc114 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _syaz1wmz _11c81vlj _k48pmoej _19bvv77o",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$44715ef83bdcca01 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $89thI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4idpf _v564ch4h _19pkmyb0 _2hwxmyb0 _otyrmyb0 _18u0myb0 _16l4kb7n _19lcglyw",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$bafafde73fef7397 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $7890ada1e2d232ce$export$2780fb0d195b1a91 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13v9lkb": (0, $lD23V.default)(__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 8}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul9n9pv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("khnfQ", function(module, exports) {

$parcel$export(module.exports, "ScreenThreshold", () => $5825eef39a1eb963$export$e533650b80af8cf3);
$parcel$export(module.exports, "ScreenSize", () => $5825eef39a1eb963$export$9098989df19ab765);
const $5825eef39a1eb963$export$e533650b80af8cf3 = {
    EXTRA_SMALL: 768,
    SMALL: 1024,
    MEDIUM: 1440,
    LARGE: 1760
};
const $5825eef39a1eb963$export$9098989df19ab765 = {
    EXTRA_SMALL: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl'
};

});

parcelRegister("3JQPC", function(module, exports) {

$parcel$export(module.exports, "ContainerSizeContext", () => $2f896c9192634f12$export$a78b219fc961f8cd);
$parcel$export(module.exports, "useContainerSize", () => $2f896c9192634f12$export$1b2c18f86b4398c2);
$parcel$export(module.exports, "useBacklogContainerSize", () => $2f896c9192634f12$export$d6913af4e936e4ae);

var $5uXOq = parcelRequire("5uXOq");

var $2m0b6 = parcelRequire("2m0b6");

var $khnfQ = parcelRequire("khnfQ");
const $2f896c9192634f12$export$a78b219fc961f8cd = /*#__PURE__*/ (0, $5uXOq.createContext)({
    size: (0, $khnfQ.ScreenSize).MEDIUM
});
const $2f896c9192634f12$export$1b2c18f86b4398c2 = ()=>(0, $5uXOq.useContext)($2f896c9192634f12$export$a78b219fc961f8cd);
function $2f896c9192634f12$var$getBacklogContainerSize(offsetWidth) {
    if (offsetWidth === undefined) return (0, $khnfQ.ScreenSize).MEDIUM;
    if (offsetWidth < (0, $khnfQ.ScreenThreshold).EXTRA_SMALL) return (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).EXTRA_SMALL && offsetWidth < (0, $khnfQ.ScreenThreshold).SMALL) return (0, $khnfQ.ScreenSize).SMALL;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).SMALL && offsetWidth < (0, $khnfQ.ScreenThreshold).MEDIUM) return (0, $khnfQ.ScreenSize).MEDIUM;
    if (offsetWidth > (0, $khnfQ.ScreenThreshold).MEDIUM && (0, $khnfQ.ScreenThreshold).LARGE) return (0, $khnfQ.ScreenSize).LARGE;
    return (0, $khnfQ.ScreenSize).EXTRA_LARGE;
}
function $2f896c9192634f12$export$d6913af4e936e4ae({ ref: ref }) {
    const [backlogContainerSize, setBacklogContainerSize] = (0, $5uXOq.useState)(ref.current?.offsetWidth !== undefined ? $2f896c9192634f12$var$getBacklogContainerSize(ref.current?.offsetWidth) : (0, $khnfQ.ScreenSize).MEDIUM);
    (0, $2m0b6.useResizeObserver)({
        ref: ref,
        onResize () {
            if (ref.current) {
                const { offsetWidth: offsetWidth } = ref.current;
                setBacklogContainerSize(offsetWidth !== undefined ? $2f896c9192634f12$var$getBacklogContainerSize(offsetWidth) : (0, $khnfQ.ScreenSize).MEDIUM);
            }
        }
    });
    return backlogContainerSize;
}

});
parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});



parcelRegister("4w5xH", function(module, exports) {

$parcel$export(module.exports, "AssigneeLite", () => $d9374eb07d3643c0$export$a031037f4a309a04);

var $5uXOq = parcelRequire("5uXOq");

var $dWTaZ = parcelRequire("dWTaZ");

var $3fAi8 = parcelRequire("3fAi8");


var $iDGXn = parcelRequire("iDGXn");

var $kAodW = parcelRequire("kAodW");
const $d9374eb07d3643c0$export$a031037f4a309a04 = ({ issueKey: issueKey })=>{
    const showAssignee = (0, $iDGXn.useShowAssignee)();
    const [assigneeFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    return showAssignee ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAodW.AvatarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        src: value?.avatarUrl,
        size: "small",
        borderColor: "transparent"
    })) : null;
};

});
parcelRegister("kAodW", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $1c29bb03d4c1e343$export$f7513421c53ce141);
$parcel$export(module.exports, "default", () => $1c29bb03d4c1e343$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dWTaZ = parcelRequire("dWTaZ");

var $MGmIU = parcelRequire("MGmIU");

var $koVbs = parcelRequire("koVbs");

var $8Wp1B = parcelRequire("8Wp1B");
const $1c29bb03d4c1e343$export$20dedc39b82b5168 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const name = value?.id ? formatMessage((0, $8Wp1B.default).assigneeTooltip, {
        name: value.displayName
    }) : formatMessage((0, $8Wp1B.default).assigneeTooltipUnassigned);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c29bb03d4c1e343$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        src: value?.avatarUrl,
        name: name,
        size: "small",
        borderColor: "transparent"
    })));
};
var $1c29bb03d4c1e343$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1c29bb03d4c1e343$export$20dedc39b82b5168);
const $1c29bb03d4c1e343$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8Wp1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b55e76c620f1978$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2b55e76c620f1978$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    },
    assigneeTooltipUnassigned: {
        "id": "backlog.card-list.card.card-contents.assignee-field.assignee-field-static.assignee-tooltip-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});



parcelRegister("1OiOR", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $5513aeaaa590b47f$export$4c248a4717685909);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $13fTq = parcelRequire("13fTq");
const $5513aeaaa590b47f$export$4c248a4717685909 = (props)=>{
    const shouldRenderDueDateColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13fTq.DueDate), {
        ...props,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn
    });
};

});
parcelRegister("13fTq", function(module, exports) {

$parcel$export(module.exports, "DueDate", () => $7bddcbbc6ff4e4a5$export$4c248a4717685909);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $itzcE = parcelRequire("itzcE");

var $dCm1o = parcelRequire("dCm1o");
const $7bddcbbc6ff4e4a5$export$4c248a4717685909 = ({ dueDate: dueDate, shouldRenderDueDateColumn: shouldRenderDueDateColumn, isDone: isDone })=>{
    const cardDueDate = dueDate || '';
    const dueDateNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
        dueDate: cardDueDate,
        isCompleted: isDone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7bddcbbc6ff4e4a5$var$CardDueDateWrapper, {
        shouldRenderColumn: shouldRenderDueDateColumn,
        hasDueDate: dueDate !== null,
        "data-testid": "software-backlog.card-list.card.card-contents.due-date",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, cardDueDate ? dueDateNode : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bddcbbc6ff4e4a5$var$CardDueDateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, visualRefresh: visualRefresh, hasDueDate: hasDueDate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s2raoz": (0, $lD23V.default)(__cmplp.visualRefresh ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `${__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 9.6}px`}` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `${__cmplp.hasDueDate ? `${(0, $gwIPs.gridSize) * 7.5}px` : `${(0, $gwIPs.gridSize) * 8}px`}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldRenderColumn && "_1ul99em0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("itzcE", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $1f73e6aec72eb1bf$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mBKK = parcelRequire("4mBKK");
var $70Rr2 = parcelRequire("70Rr2");
var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $MGmIU = parcelRequire("MGmIU");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $8uZt8 = parcelRequire("8uZt8");


var $eDs1Y = parcelRequire("eDs1Y");
const $1f73e6aec72eb1bf$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat } = props;
    const dueDateEndOfDay = (0, $70Rr2.default)((0, $eZDAP.default)(dueDate));
    const currentDate = (0, $it1wb.default)(new Date());
    const diffInDays = (0, $4mBKK.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $k7m40.default)(dueDateEndOfDay, dateFormat) : (0, $k7m40.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $eDs1Y.messages).text, {
        date: (0, $k7m40.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $1f73e6aec72eb1bf$var$baseStyles,
            isOverDue ? $1f73e6aec72eb1bf$var$overdueStyles : $1f73e6aec72eb1bf$var$normalStyles,
            !(0, $4R6GH.fg)('jira_nav4_eap_drop_2') && $1f73e6aec72eb1bf$var$OldPaddingRight
        ],
        testId: "platform-card.common.ui.due-date.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $1f73e6aec72eb1bf$var$formattedDueDateStyles
    }, formattedDueDate) : formattedDueDate))) : null;
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null; /* eslint-enable jira/react/no-style-attribute */ 
};
$1f73e6aec72eb1bf$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $1f73e6aec72eb1bf$export$2e2bcd8739ae039 = $1f73e6aec72eb1bf$export$9e242219cf1cc36c;
const $1f73e6aec72eb1bf$var$baseStyles = (0, $jJ1Sb.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    paddingLeft: 'space.050'
});
const $1f73e6aec72eb1bf$var$OldPaddingRight = (0, $jJ1Sb.xcss)({
    paddingRight: 'space.050'
});
const $1f73e6aec72eb1bf$var$overdueStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text.danger',
    borderColor: 'color.border.danger'
});
const $1f73e6aec72eb1bf$var$normalStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text',
    borderColor: 'color.border'
});
const $1f73e6aec72eb1bf$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: `var(--ds-text-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
        backgroundColor: `var(--ds-background-danger, ${(0, $5e0c0d4e15efb4a6$exports).R50})`
    } : {
        color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N500})`,
        backgroundColor: `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N20})`
    };
const $1f73e6aec72eb1bf$var$formattedDueDateStyles = (0, $jJ1Sb.xcss)({
    width: '6ch',
    fontVariantNumeric: 'tabular-nums',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80 _zulp1b66",
            __cmplp.className
        ])
    });
});
const $1f73e6aec72eb1bf$var$Content = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $1f73e6aec72eb1bf$var$ContentNew, $1f73e6aec72eb1bf$var$ContentOld);

});
parcelRegister("8uZt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d11d6903be96d2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $8T1Nu = parcelRequire("8T1Nu");

var $6T4rd = parcelRequire("6T4rd");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $dCm1o = parcelRequire("dCm1o");

var $6OCZm = parcelRequire("6OCZm");

const $72d11d6903be96d2$var$renderIcon = (type)=>{
    switch(type){
        case 0, $6d6eac2504286faf$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.ChildIssuesGlyph), null);
        case 0, $6d6eac2504286faf$export$aac403da0d127706:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.FlagGlyph), null);
        case 0, $6d6eac2504286faf$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.CheckGlyph), null);
        case 0, $6d6eac2504286faf$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.UploadGlyph), null);
        case 0, $6d6eac2504286faf$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketBranchesGlyph), null);
        case 0, $6d6eac2504286faf$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketCommitsGlyph), null);
        case 0, $6d6eac2504286faf$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketPullrequestsGlyph), null);
        case 0, $6d6eac2504286faf$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.EmojiFrequentGlyph), null);
        case 0, $6d6eac2504286faf$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.MoreGlyph), null);
        case 0, $6d6eac2504286faf$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.PersonGlyph), null);
        case 0, $6d6eac2504286faf$export$d4ee7b46933c494f:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
                paddingInlineEnd: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8T1Nu))), {
                label: "",
                color: "currentColor"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $72d11d6903be96d2$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72d11d6903be96d2$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $72d11d6903be96d2$var$renderIcon(type));
};
var $72d11d6903be96d2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
 = $72d11d6903be96d2$var$CardIcon;
const $72d11d6903be96d2$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1tuyf7k-0"
})((props)=>({
        display: 'inline-block',
        flexShrink: 0,
        lineHeight: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> svg': {
            verticalAlign: 'bottom',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.primaryColor || undefined
        }
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72d11d6903be96d2$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $lD23V.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});
const $72d11d6903be96d2$var$Container = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $72d11d6903be96d2$var$ContainerExperiment, $72d11d6903be96d2$var$ContainerControl);

});
parcelRegister("8T1Nu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6784dab29bdae81b$var$_react = $6784dab29bdae81b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6784dab29bdae81b$var$_UNSAFE_baseNew = $6784dab29bdae81b$var$_interopRequireDefault((parcelRequire("huIZN")));
function $6784dab29bdae81b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6784dab29bdae81b$var$CalendarIcon = (props)=>/*#__PURE__*/ $6784dab29bdae81b$var$_react.default.createElement($6784dab29bdae81b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$6784dab29bdae81b$var$CalendarIcon.displayName = 'CalendarIcon';
var $6784dab29bdae81b$var$_default = module.exports.default = $6784dab29bdae81b$var$CalendarIcon;

});

parcelRegister("6OCZm", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $9f38e13816957edc$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $9f38e13816957edc$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $9f38e13816957edc$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $9f38e13816957edc$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $9f38e13816957edc$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $9f38e13816957edc$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $9f38e13816957edc$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $9f38e13816957edc$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $9f38e13816957edc$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $9f38e13816957edc$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $9f38e13816957edc$export$45e4820251213456);

var $5uXOq = parcelRequire("5uXOq");
const $9f38e13816957edc$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $9f38e13816957edc$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $9f38e13816957edc$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $9f38e13816957edc$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $9f38e13816957edc$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $6d6eac2504286faf$export$3b43f1ca008dad23 = 'child-issues';
const $6d6eac2504286faf$export$aac403da0d127706 = 'flag';
const $6d6eac2504286faf$export$540a31b23d6b9abd = 'tick';
const $6d6eac2504286faf$export$352da558a3a09227 = 'upload';
const $6d6eac2504286faf$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $6d6eac2504286faf$export$a153e0417183b79 = 'bitbucket-commits';
const $6d6eac2504286faf$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $6d6eac2504286faf$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $6d6eac2504286faf$export$423cd243bf1888bc = 'more';
const $6d6eac2504286faf$export$30a9be92cbb6f382 = 'person';
const $6d6eac2504286faf$export$d4ee7b46933c494f = 'due-date';


parcelRegister("eDs1Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d2a4fa84ab79be6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d2a4fa84ab79be6$export$593a022a1631ee1e = 'Due Date: ';
const $9d2a4fa84ab79be6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});




parcelRegister("46Lnx", function(module, exports) {

$parcel$export(module.exports, "EpicLiteWrapper", () => $1234998e468059c1$export$bb3aabd940f6f405);

var $5uXOq = parcelRequire("5uXOq");

var $iDGXn = parcelRequire("iDGXn");

var $96018 = parcelRequire("96018");
const $1234998e468059c1$export$bb3aabd940f6f405 = ({ card: card, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView })=>{
    const showEpics = (0, $iDGXn.useShowEpics)();
    if (showEpics) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96018.EpicLite), {
        card: card,
        screenSize: backlogContainerSize,
        isCompactView: isCompactView
    });
    return null;
};

});
parcelRegister("96018", function(module, exports) {

$parcel$export(module.exports, "EpicLite", () => $8d3811cd0e9398e5$export$84103c8f50e5bb46);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $kFsv3 = parcelRequire("kFsv3");

var $3fAi8 = parcelRequire("3fAi8");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $3xj9Y = parcelRequire("3xj9Y");

var $8wOzB = parcelRequire("8wOzB");

var $963tu = parcelRequire("963tu");

var $kM28N = parcelRequire("kM28N");
const $8d3811cd0e9398e5$var$EpicLozengeForAllNonEpicsLite = ({ card: card, isCompactView: isCompactView, screenSize: screenSize })=>{
    const parents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const [parentValue] = (0, $3fAi8.useFieldValue)({
        issueKey: card.key,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    const mappedParent = card.parentId ? parents.find(({ id: id })=>Number(id) === Number(card.parentId)) : null;
    // Check if the card and parent are different as `useFieldValue` can fail and fallback to
    // the current card's summary which is VERY wrong. We need to check this and not show
    // a lozenge if that happens.
    const isParentValueSameAsCard = card.id === parentValue?.id || card.key === parentValue?.key;
    // Use mapped parent first, fallback to parentValue
    const color = mappedParent?.color || parentValue?.color || (0, $kFsv3.PURPLE);
    let summary = mappedParent?.summary;
    // If we couldn't get summary from mapped parent, try to add it from parentValue if
    // we got a valid value from useFieldValue.
    if (!summary && !isParentValueSameAsCard) summary = parentValue?.fields?.summary;
    // There are multiple ways that the backlog will fetch the epic. It will either exist in redux
    // OR we will need to retrieve it from the issue fields sweet state.
    const hasValidEpic = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(summary) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(color);
    return(// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null && !isSubtask
    }, hasValidEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
        color: color,
        summary: summary ?? '',
        isCompactView: isCompactView
    })));
};
const $8d3811cd0e9398e5$export$84103c8f50e5bb46 = (props)=>{
    const { card: card, screenSize: screenSize } = props;
    const cardHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardHierarchyLevel));
    const isEpic = (0, $g4tDr.isEpicHierarchyLevel)(cardHierarchyLevel(card.id));
    if (isEpic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, screenSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: card.parentId === null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xj9Y.default), {
        issueId: card.id,
        issueKey: card.key,
        ...props
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8d3811cd0e9398e5$var$EpicLozengeForAllNonEpicsLite, props);
};

});
parcelRegister("3xj9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae93275362a6a5b5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iHPnC = parcelRequire("iHPnC");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $8wOzB = parcelRequire("8wOzB");
const $ae93275362a6a5b5$var$EpicLozengeField = ({ issueKey: issueKey, issueId: issueId, isCompactView: isCompactView })=>{
    const epicColorFieldId = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getEpicColorFieldId));
    const cardColor = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardEpicColor)(state, issueId));
    const [epicColorFromFieldsStore] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: epicColorFieldId ?? ''
    });
    const [epicSummary] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const color = (0, $iHPnC.asColor)(epicColorFromFieldsStore || cardColor);
    return epicSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
        color: (0, $iHPnC.asColor)(color),
        summary: epicSummary,
        isCompactView: isCompactView
    }) : null;
};
var $ae93275362a6a5b5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ae93275362a6a5b5$var$EpicLozengeField);

});
parcelRegister("8wOzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81db34a04dd013$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koOOC = parcelRequire("koOOC");

var $bxSom = parcelRequire("bxSom");

var $dCm1o = parcelRequire("dCm1o");
const $bc81db34a04dd013$export$2fe14dcf8683ace1 = ({ color: color, summary: summary, isCompactView: isCompactView })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc81db34a04dd013$var$StaticLozengeWrapper, {
        isCompactView: isCompactView
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxSom.EpicTag), {
        color: color,
        summary: summary,
        isCompactView: isCompactView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koOOC.EpicLozenge), {
        color: color,
        summary: summary,
        isCompactView: isCompactView
    }));
var $bc81db34a04dd013$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($bc81db34a04dd013$export$2fe14dcf8683ace1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc81db34a04dd013$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvresu3 _o5721q9c _1bto1l2s _1reo15vq _18m915vq _vchhusvi _p12f1osq _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            !__cmplp.isCompactView && "_19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("koOOC", function(module, exports) {

$parcel$export(module.exports, "EpicLozenge", () => $415a24051fa911e5$export$2e623d726e27c97);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eddAM = parcelRequire("eddAM");

var $MGmIU = parcelRequire("MGmIU");

var $7XYc4 = parcelRequire("7XYc4");

var $iHPnC = parcelRequire("iHPnC");

var $dCm1o = parcelRequire("dCm1o");

var $k8qVk = parcelRequire("k8qVk");

var $7Fute = parcelRequire("7Fute");
const $415a24051fa911e5$export$2e623d726e27c97 = ({ color: color, summary: summary, maxWidth: maxWidth, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || '';
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$export$d9d9ccbf5da84ba4, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$var$LozengeWrapper, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7Fute.getLozengeThemeByColor)(color),
        maxWidth: maxWidth,
        testId: "issue-field-parent-switcher.common.ui.epic-lozenge.lozenge"
    }, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $415a24051fa911e5$var$LozengeWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b _1c11glyw",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $415a24051fa911e5$var$LozengeWrapperNew, $415a24051fa911e5$var$LozengeWrapperOld);
const $415a24051fa911e5$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1bsb7vkz _4t3i7vkz _2rko1l7b _11q71cj8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bxSom", function(module, exports) {

$parcel$export(module.exports, "EpicTag", () => $a31a219538287c5f$export$7152f0595ef00247);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $c9Fym = parcelRequire("c9Fym");

var $h1hDx = parcelRequire("h1hDx");

var $MGmIU = parcelRequire("MGmIU");

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $a31a219538287c5f$var$colorIndicatorStyles = null;
const $a31a219538287c5f$export$9f3aea0d30ce7517 = ({ color: color })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            backgroundColor: color
        },
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1bsbpxbi _4t3ipxbi _2rko1l7b"
        ])
    });
};
const $a31a219538287c5f$export$7152f0595ef00247 = ({ color: color, summary: summary, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || paletteColorValues.PURPLE;
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31a219538287c5f$export$9f3aea0d30ce7517, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a31a219538287c5f$var$TagHack, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID),
        tagColor: selectedColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9Fym.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1hDx.default), {
        testId: "issue-field-parent-switcher.common.ui.epic-tag.tag",
        text: summary
    }))));
};
//! This is used to override the default theme as Tag doesn't support custom styles.
const $a31a219538287c5f$var$tagHackStyles = null;
const $a31a219538287c5f$var$TagHack = ({ tagColor: tagColor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @typescript-eslint/consistent-type-assertions
        style: {
            '--epic-tag-border-color': tagColor
        },
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _fw2t1cyy _8xmeidpf _1iepidpf _1jvqidpf _uk5jidpf _1axytlke"
        ])
    }, children);

});



parcelRegister("963tu", function(module, exports) {

$parcel$export(module.exports, "LabelType", () => $4fbf68de04360380$export$db162f9c7976a7ea);
$parcel$export(module.exports, "getLabelWidthMultiplier", () => $4fbf68de04360380$export$f9a98c799935274d);

var $khnfQ = parcelRequire("khnfQ");
const $4fbf68de04360380$export$db162f9c7976a7ea = {
    VERSION: 'version',
    EPIC: 'epic',
    STATUS: 'status'
};
const $4fbf68de04360380$export$f9a98c799935274d = (labelType, containerWidth)=>{
    switch(containerWidth){
        case (0, $khnfQ.ScreenSize).EXTRA_SMALL:
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.VERSION) return 3;
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.EPIC) return 3;
            return 12.5;
        case (0, $khnfQ.ScreenSize).SMALL:
            if (labelType === $4fbf68de04360380$export$db162f9c7976a7ea.VERSION) return 3;
            return 12.5;
        case (0, $khnfQ.ScreenSize).MEDIUM:
            return 18.75;
        case (0, $khnfQ.ScreenSize).LARGE:
            return 18.75;
        case (0, $khnfQ.ScreenSize).EXTRA_LARGE:
            return 25;
        default:
            return 12.5;
    }
};

});



parcelRegister("dzwJA", function(module, exports) {

$parcel$export(module.exports, "EstimateLite", () => $86030bc50e153025$export$30d0f48cab624df4);

var $5uXOq = parcelRequire("5uXOq");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $45Qwd = parcelRequire("45Qwd");

var $80uDK = parcelRequire("80uDK");
const $86030bc50e153025$export$30d0f48cab624df4 = ({ shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    if (estimationType !== (0, $guzeq.ORIGINAL_ESTIMATE)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80uDK.default), {
        hasEstimate: shouldRenderEstimatesColumn,
        value: undefined
    });
};

});
parcelRegister("80uDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68646e058dc9ae00$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bxhgD = parcelRequire("bxhgD");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $gnK7n = parcelRequire("gnK7n");

var $ayyYR = parcelRequire("ayyYR");
const $68646e058dc9ae00$var$DEFAULT_NO_VALUE = '0m';
const $68646e058dc9ae00$export$fdcfaf17c0796808 = ({ value: value, hasEstimate: hasEstimate, valueInSeconds: valueInSeconds, timeTrackingOptions: timeTrackingOptions })=>{
    const intl = (0, $koVbs.default)();
    const longFormValue = hasEstimate && valueInSeconds && timeTrackingOptions ? (0, $etKNj.timeTrackingFormatterLongForm)(valueInSeconds, timeTrackingOptions, intl) : undefined;
    const ariaLabel = longFormValue ? `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabelNullValue)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68646e058dc9ae00$var$OriginalEstimateContainer, null, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: intl.formatMessage((0, $ayyYR.default).originalEstimateTooltip),
        ariaLabel: ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68646e058dc9ae00$var$OriginalEstimateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: "default"
    }, value ?? $68646e058dc9ae00$var$DEFAULT_NO_VALUE))));
};
var $68646e058dc9ae00$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($68646e058dc9ae00$export$fdcfaf17c0796808);
const $68646e058dc9ae00$var$OriginalEstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _vchhusvi _19itj1ic _o5721q9c _80om73ad _1bsb1ns9 _1reo1kw7 _18m91kw7 _1ul9ys9h _ks4fys9h _1w7e18uv _z6uakb7n _18j015vq _d38j15vq _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68646e058dc9ae00$var$OriginalEstimateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9ys9h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bxhgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $34bf77d10b11ecd3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $294ns = parcelRequire("294ns");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $kW5e5 = parcelRequire("kW5e5");
function $34bf77d10b11ecd3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $34bf77d10b11ecd3$var$boxStyles = (0, $jJ1Sb.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $34bf77d10b11ecd3$var$neutral300 = '#DDDEE1';
const $34bf77d10b11ecd3$var$red300 = '#FD9891';
const $34bf77d10b11ecd3$var$blue300 = '#8FB8F6';
const $34bf77d10b11ecd3$var$neutral1000 = '#292A2E';
const $34bf77d10b11ecd3$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $34bf77d10b11ecd3$var$neutral300,
        color: $34bf77d10b11ecd3$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $34bf77d10b11ecd3$var$red300,
        color: $34bf77d10b11ecd3$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $f8Sb3.css)({
        backgroundColor: $34bf77d10b11ecd3$var$blue300,
        color: $34bf77d10b11ecd3$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $34bf77d10b11ecd3$var$Badge = /*#__PURE__*/ (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $294ns.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $34bf77d10b11ecd3$var$styles.root,
            $34bf77d10b11ecd3$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1m92z.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $kW5e5.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        testId: testId,
        as: "span",
        backgroundColor: $34bf77d10b11ecd3$var$backgroundColors[appearance],
        xcss: $34bf77d10b11ecd3$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1m92z.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $34bf77d10b11ecd3$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $kW5e5.formatValue)(children, max) : children));
});
$34bf77d10b11ecd3$var$Badge.displayName = 'Badge';
var $34bf77d10b11ecd3$export$2e2bcd8739ae039 = $34bf77d10b11ecd3$var$Badge;
const $34bf77d10b11ecd3$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $34bf77d10b11ecd3$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("kW5e5", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $f645fe5312171f82$export$7c4d25c0c3217d8c);
function $f645fe5312171f82$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $f645fe5312171f82$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $f645fe5312171f82$var$getSafeValue(value);
    const safeMax = $f645fe5312171f82$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("gnK7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a4393c280aa53fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MGmIU = parcelRequire("MGmIU");

var $cizWc = parcelRequire("cizWc");
const $2a4393c280aa53fe$var$EstimateFieldWrapper = ({ tooltipLabel: tooltipLabel, ariaLabel: ariaLabel, children: children, tooltipPosition: tooltipPosition = 'bottom' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a4393c280aa53fe$var$EstimateFieldContainer, {
        role: "group",
        "aria-label": ariaLabel,
        "data-testid": (0, $cizWc.ESTIMATE_FIELD_WRAPPER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipLabel,
        position: tooltipPosition
    }, children));
var $2a4393c280aa53fe$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2a4393c280aa53fe$var$EstimateFieldWrapper);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a4393c280aa53fe$var$EstimateFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cizWc", function(module, exports) {

$parcel$export(module.exports, "CHECKBOX_TESTID", () => $ca62fade11f0de7f$export$6fe7aa6a89a9b29);
$parcel$export(module.exports, "CARD_CONTAINER_TESTID", () => $ca62fade11f0de7f$export$b28b0b4c916693a4);
$parcel$export(module.exports, "CARDS_AMOUNT_BADGE_TESTID", () => $ca62fade11f0de7f$export$d1903e0c7f8ee5c7);
$parcel$export(module.exports, "CMD_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$532ecc85a046702a);
$parcel$export(module.exports, "CHECKBOX_ANALYTICS_ID", () => $ca62fade11f0de7f$export$88f95597995c9129);
$parcel$export(module.exports, "SHIFT_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$416730846dcfbfdb);
$parcel$export(module.exports, "CMD_SHIFT_CLICK_ANALYTICS_ID", () => $ca62fade11f0de7f$export$757f7ef32cfa3ff);
$parcel$export(module.exports, "CHECKBOX_COMPONENT_SELECTOR", () => $ca62fade11f0de7f$export$40d8217ec5a8ae9a);
$parcel$export(module.exports, "KEY_COMPONENT_SELECTOR", () => $ca62fade11f0de7f$export$eb017f8fc9323651);
$parcel$export(module.exports, "KEY_CONTAINER_TEST_ID", () => $ca62fade11f0de7f$export$3ca3a5ea5b54742d);
$parcel$export(module.exports, "SCREEN_READER_KEY_TEST_ID", () => $ca62fade11f0de7f$export$d30ca8490ead1b3b);
$parcel$export(module.exports, "FLAG_CONTAINER_TEST_ID", () => $ca62fade11f0de7f$export$97794d9709da94ad);
$parcel$export(module.exports, "FLAGGED_BUTTON_TEST_ID", () => $ca62fade11f0de7f$export$f84ddfbd95bff080);
$parcel$export(module.exports, "ADD_FLAG_BUTTON_TEST_ID", () => $ca62fade11f0de7f$export$1dd60f3ce6926cb);
$parcel$export(module.exports, "ESTIMATE_FIELD_WRAPPER_TEST_ID", () => $ca62fade11f0de7f$export$5242fed4d28f1249);
$parcel$export(module.exports, "SUMMARY_TEST_ID", () => $ca62fade11f0de7f$export$b6840ddc4661f707);

var $gwIPs = parcelRequire("gwIPs");
const $ca62fade11f0de7f$export$6fe7aa6a89a9b29 = 'software-backlog.card-list.card.card-contents.checkbox';
const $ca62fade11f0de7f$export$b28b0b4c916693a4 = 'software-backlog.card-list.card.card-contents.card-container';
const $ca62fade11f0de7f$export$d1903e0c7f8ee5c7 = 'software-backlog.card-list.card.card-contents.cards-amount-badge';
const $ca62fade11f0de7f$export$532ecc85a046702a = 'cmdclick';
const $ca62fade11f0de7f$export$88f95597995c9129 = 'checkbox';
const $ca62fade11f0de7f$export$416730846dcfbfdb = 'shiftclick';
const $ca62fade11f0de7f$export$757f7ef32cfa3ff = 'cmdshiftclick';
const $ca62fade11f0de7f$export$40d8217ec5a8ae9a = 'software-backlog-card-card-contents-checkbox-container';
const $ca62fade11f0de7f$export$eb017f8fc9323651 = 'software-backlog.card-list.card.card-contents.key';
const $ca62fade11f0de7f$export$3ca3a5ea5b54742d = 'software-backlog.card-list.card.card-contents.accessible-card-key';
const $ca62fade11f0de7f$export$d30ca8490ead1b3b = 'software-backlog.card-list.card.card-contents.screen-reader-key';
const $ca62fade11f0de7f$export$97794d9709da94ad = 'software-backlog.card-list.card.card-contents.flag-container';
const $ca62fade11f0de7f$export$f84ddfbd95bff080 = 'software-backlog.card-list.card.card-contents.flagged-button';
const $ca62fade11f0de7f$export$1dd60f3ce6926cb = 'software-backlog.card-list.card.card-contents.add-flag-button';
const $ca62fade11f0de7f$export$5242fed4d28f1249 = 'software-backlog.card-list.card.card-contents.estimate-field-wrapper';
const $ca62fade11f0de7f$export$b6840ddc4661f707 = 'software-backlog.card-list.card.card-contents.summary';
const $ca62fade11f0de7f$export$a7e851dd01b7bece = (0, $gwIPs.gridSize) * 2;

});


parcelRegister("ayyYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b997f17803ac882$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4b997f17803ac882$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    originalEstimateTooltip: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-tooltip",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabel: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label",
        "defaultMessage": "Original estimate"
    },
    originalEstimateAriaLabelNullValue: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.original-estimate-aria-label-null-value",
        "defaultMessage": "No estimate set"
    },
    invalidTimeFormatMessage: {
        "id": "backlog.card-list.card.card-contents.original-estimate-field.invalid-time-format-message",
        "defaultMessage": "Your estimate must be in the format {format}."
    }
});

});



parcelRegister("MdcUe", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $50f4f7d0b168b8e8$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hW6cm = parcelRequire("hW6cm");

var $7xReK = parcelRequire("7xReK");


var $4R6GH = parcelRequire("4R6GH");
const $50f4f7d0b168b8e8$export$48ea269755562084 = ({ shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, isFlagged: isFlagged })=>{
    const inlineFlag = shouldRenderInlineAddFlag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f4f7d0b168b8e8$var$FlagPlaceHolder, null) : null;
    const flagIcon = (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hW6cm))), {
        label: "Flagged icon",
        color: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7xReK))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7xReK))), {
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        label: "Flagged icon"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($50f4f7d0b168b8e8$var$FlagContainer, null, isFlagged ? flagIcon : inlineFlag);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50f4f7d0b168b8e8$var$FlagContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $50f4f7d0b168b8e8$var$FlagPlaceHolder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hW6cm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a2f79b68f83f7bee45defc51e10a7e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0eca94a6f4bc229$var$_react = $d0eca94a6f4bc229$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d0eca94a6f4bc229$var$_UNSAFE_baseNew = $d0eca94a6f4bc229$var$_interopRequireDefault((parcelRequire("huIZN")));
function $d0eca94a6f4bc229$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0eca94a6f4bc229$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $d0eca94a6f4bc229$var$_react.default.createElement($d0eca94a6f4bc229$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 1.75H2.75v8H14l-3-4z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
    }, props));
$d0eca94a6f4bc229$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $d0eca94a6f4bc229$var$_default = module.exports.default = $d0eca94a6f4bc229$var$FlagFilledIcon;

});

parcelRegister("7xReK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57e4e93a6be1d19a$var$_react = $57e4e93a6be1d19a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $57e4e93a6be1d19a$var$_flagFilled = $57e4e93a6be1d19a$var$_interopRequireDefault((parcelRequire("hW6cm")));
function $57e4e93a6be1d19a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57e4e93a6be1d19a$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $57e4e93a6be1d19a$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $57e4e93a6be1d19a$var$_flagFilled.default
    }));
$57e4e93a6be1d19a$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $57e4e93a6be1d19a$var$_default = module.exports.default = $57e4e93a6be1d19a$var$FlagFilledIcon;

});


parcelRegister("5GU7f", function(module, exports) {

$parcel$export(module.exports, "PriorityLite", () => $7dc996f90b69552f$export$919bb9d97260bc8d);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $4EUws = parcelRequire("4EUws");

var $aHbBN = parcelRequire("aHbBN");
const $7dc996f90b69552f$export$919bb9d97260bc8d = ({ issueKey: issueKey, shouldRenderPriorityColumn: shouldRenderPriorityColumn })=>{
    const [priorityFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    // Matching src/packages/software/backlog/src/view/card-list/card/card-contents/priority-field/index.tsx
    if (!shouldRenderPriorityColumn) return null;
    const hasPriority = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EUws.StaticPriorityFieldWrapper), {
        shouldRenderColumn: shouldRenderPriorityColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHbBN.default), {
        name: priorityFieldValue.name,
        iconUrl: priorityFieldValue.iconUrl
    }) : null);
    return priorityFieldStatic;
};

});
parcelRegister("4EUws", function(module, exports) {

$parcel$export(module.exports, "StaticPriorityFieldWrapper", () => $5d2c811b08f9b18f$export$82aa3dc89c56ae53);
$parcel$export(module.exports, "default", () => $5d2c811b08f9b18f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $gwIPs = parcelRequire("gwIPs");

var $3fAi8 = parcelRequire("3fAi8");

var $hTfH8 = parcelRequire("hTfH8");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $hPtZI = parcelRequire("hPtZI");


var $dM9vk = parcelRequire("dM9vk");

var $aHbBN = parcelRequire("aHbBN");

const $5d2c811b08f9b18f$var$PriorityChipFieldLazy = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("lzSI3")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/index.tsx"
});
const $5d2c811b08f9b18f$var$PriorityField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, shouldRenderColumn: shouldRenderColumn })=>{
    const [priorityFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    // Do not render the priority column if no card on backlog has priority
    if (!shouldRenderColumn && ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) || !priorityFieldValue.name || !priorityFieldValue.iconUrl)) return null;
    const hasPriority = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priorityFieldValue.iconUrl);
    const priorityFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$export$82aa3dc89c56ae53, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aHbBN.default), {
        name: priorityFieldValue.name,
        iconUrl: priorityFieldValue.iconUrl
    }) : null);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTfH8.PriorityChipFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: priorityFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: (0, $5fc53.PRIORITY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$var$PriorityFieldWrapper, {
        shouldRenderColumn: shouldRenderColumn
    }, hasPriority ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d2c811b08f9b18f$var$PriorityChipFieldLazy, {
        issueKey: issueKey
    })) : null)));
    return priorityFieldStatic;
};
var $5d2c811b08f9b18f$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $5uXOq.memo)($5d2c811b08f9b18f$var$PriorityField);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5d2c811b08f9b18f$var$PriorityFieldWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-178nh9s-0"
})`position:relative;display:flex;align-items:center;cursor:default;min-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $gwIPs.gridSize) * 3}px` : null};max-width:${({ shouldRenderColumn: shouldRenderColumn })=>shouldRenderColumn ? `${(0, $gwIPs.gridSize) * 3}px` : null};& > button + div{position:absolute !important;top:${"var(--ds-space-400, 32px)"} !important;left:auto !important;right:${"var(--ds-space-negative-025, -2px)"} !important;transform:none !important;}&:focus,&:focus-within{outline:none;}`;
const $5d2c811b08f9b18f$export$82aa3dc89c56ae53 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderColumn: shouldRenderColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRenderColumn && "_1ul91tcg _p12f1tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hTfH8", function(module, exports) {

$parcel$export(module.exports, "PriorityChipFieldBoundary", () => $c88604a3dedf5694$export$9d18c32154d1536);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");
const $c88604a3dedf5694$export$9d18c32154d1536 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-priority-chip",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-priority-chip-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("aHbBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $13293c200f360bb1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Y70r = parcelRequire("7Y70r");
const $13293c200f360bb1$export$2ccb5d74629a741d = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y70r.PriorityChipRead), {
        name: name,
        iconUrl: iconUrl
    });
var $13293c200f360bb1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($13293c200f360bb1$export$2ccb5d74629a741d);

});
parcelRegister("7Y70r", function(module, exports) {

$parcel$export(module.exports, "PriorityChipRead", () => $cdcd5a4499ede0a2$export$92ecdadfd000de84);

var $5uXOq = parcelRequire("5uXOq");

var $1tQVG = parcelRequire("1tQVG");
const $cdcd5a4499ede0a2$export$92ecdadfd000de84 = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tQVG.PriorityIcon), {
        name: name,
        iconUrl: iconUrl
    });

});
parcelRegister("1tQVG", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $6684e89be4f617c8$export$3abf8cb3bcb0225);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MGmIU = parcelRequire("MGmIU");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $a5ldi = parcelRequire("a5ldi");
const $6684e89be4f617c8$export$3abf8cb3bcb0225 = ({ name: name, iconUrl: iconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let priorityName = name;
    if ((0, $co1wz.ff)('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq')) priorityName = formatMessage((0, $a5ldi.default).priorityTooltip, {
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: priorityName,
        testId: "issue-field-priority-chip.common.ui.priority-icon.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$f04a61298a47a40f, {
        alt: priorityName,
        src: iconUrl
    })));
};
const $6684e89be4f617c8$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $6684e89be4f617c8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3if6fq _1bsbf6fq _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a5ldi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d1a749f620728b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d7d1a749f620728b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "issue-field-priority-chip.common.priority-icon.priority-tooltip",
        "defaultMessage": "Priority: {name}"
    }
});

});




parcelRegister("lzSI3", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8OrYU").then(()=>parcelRequire('h16RV'));

});



parcelRegister("7eYN2", function(module, exports) {

$parcel$export(module.exports, "Status", () => $b66cfc821f3ed707$export$96e9906d6d93a972);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $9Pc1U = parcelRequire("9Pc1U");

var $963tu = parcelRequire("963tu");

var $bhQK9 = parcelRequire("bhQK9");
const $b66cfc821f3ed707$export$96e9906d6d93a972 = ({ cardKey: cardKey, backlogContainerSize: backlogContainerSize })=>{
    const isUserAtLeastMember = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isUserAtLeastMemberOfProject));
    const showStatuses = (0, $iDGXn.useShowStatuses)();
    return showStatuses ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b66cfc821f3ed707$var$StatusContainer, {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhQK9.StatusLite), {
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey
    })) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66cfc821f3ed707$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _4t3i1tcg _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bhQK9", function(module, exports) {

$parcel$export(module.exports, "StatusLite", () => $a5bc8bd5d47cbd27$export$8c32e03375f9b492);

var $5uXOq = parcelRequire("5uXOq");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");


var $7I9R8 = parcelRequire("7I9R8");
const $a5bc8bd5d47cbd27$export$8c32e03375f9b492 = ({ issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember })=>{
    const [statusFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
    const value = {
        id: statusFieldValue.id,
        name: statusFieldValue.name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7I9R8.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        value: value
    });
};

});
parcelRegister("7I9R8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8d993c1e4fcd4a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $gDyTC = parcelRequire("gDyTC");

var $eddAM = parcelRequire("eddAM");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $dz8QR = parcelRequire("dz8QR");

var $e9UTK = parcelRequire("e9UTK");
const $7e8d993c1e4fcd4a$export$5aa9263ebcef0dab = ({ isUserAtLeastMember: isUserAtLeastMember, value: { name: name, category: category } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ChevronDownGlyph = (0, $8QpSo.default)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
            width: 12,
            height: 12,
            viewBox: "5 5 13 13"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
            fill: "currentColor",
            fillRule: "evenodd"
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e8d993c1e4fcd4a$var$StaticLozengeWrapper, {
        visualRefresh: (0, $4R6GH.fg)('visual-refresh_font-weight-bug-fix') && !(0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $dz8QR.default).statusLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        appearance: (0, $e9UTK.getStatusAppearance)(category),
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            isBold: true
        } : {}
    }, isUserAtLeastMember ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e8d993c1e4fcd4a$var$StaticLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: ChevronDownGlyph,
        label: ""
    })) : name));
};
var $7e8d993c1e4fcd4a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($7e8d993c1e4fcd4a$export$5aa9263ebcef0dab);
const $7e8d993c1e4fcd4a$var$StaticLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1o8l _s7n4jp4b _4cvr1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e8d993c1e4fcd4a$var$StaticLozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s _o5721q9c _1reo15vq _18m915vq _1npcyh40 _1gicyh40 _1e09yh40 _1mspyh40 _1esrotz2 _26sd1fw0 _172pidpf _1hcdidpf _1oyyidpf _19h8idpf",
            !(0, $dCm1o.isVisualRefreshEnabled)() && "_1r9u1vlj",
            __cmplp.visualRefresh && "_jbwy1fw0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dz8QR", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f388fba4641d64$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $69f388fba4641d64$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    statusLozenge: {
        "id": "backlog.card-list.card.card-contents.status-field.status-field-static.status-lozenge",
        "defaultMessage": "status"
    }
});

});

parcelRegister("e9UTK", function(module, exports) {

$parcel$export(module.exports, "getStatusAppearance", () => $e688dc4afbe8e1d9$export$548966735f47dde3);

var $gULOk = parcelRequire("gULOk");

var $b8gJu = parcelRequire("b8gJu");
const $e688dc4afbe8e1d9$export$548966735f47dde3 = (statusCategory)=>{
    const { default: defaultAppearance, inprogress: inprogress, success: success } = (0, $b8gJu.LOZENGE_APPEARANCE);
    const StatusCategoryAppearances = Object.freeze({
        [(0, $gULOk.StatusCategoryTypes).UNDEFINED]: defaultAppearance,
        [(0, $gULOk.StatusCategoryTypes).NEW]: defaultAppearance,
        [(0, $gULOk.StatusCategoryTypes).DONE]: success,
        [(0, $gULOk.StatusCategoryTypes).INDETERMINATE]: inprogress
    });
    return StatusCategoryAppearances[statusCategory] || defaultAppearance;
};

});
parcelRegister("b8gJu", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $5730f4b91f5d7ebc$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $5730f4b91f5d7ebc$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $5730f4b91f5d7ebc$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $5730f4b91f5d7ebc$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $5730f4b91f5d7ebc$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $5730f4b91f5d7ebc$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $5730f4b91f5d7ebc$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $5730f4b91f5d7ebc$export$373e09b633948dc);

const $5730f4b91f5d7ebc$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $5730f4b91f5d7ebc$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $5730f4b91f5d7ebc$export$fb374ae0d58ab29b = `[data-component-selector="${$5730f4b91f5d7ebc$export$7608524551986a84}"]`;
const $5730f4b91f5d7ebc$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $5730f4b91f5d7ebc$export$bb13afdd2dbe0316 = `[data-component-selector="${$5730f4b91f5d7ebc$export$c2a2d9d97661439b}"]`;
const $5730f4b91f5d7ebc$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $5730f4b91f5d7ebc$export$1be96bcf0abb2b8e = `[data-component-selector="${$5730f4b91f5d7ebc$export$675d25966b2d2499}"]`;
const $5730f4b91f5d7ebc$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $5730f4b91f5d7ebc$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $5730f4b91f5d7ebc$export$9d54b3872a1af680 = `[data-component-selector="${$5730f4b91f5d7ebc$export$4167d13afb6ba84b}"]`;
const $5730f4b91f5d7ebc$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $5730f4b91f5d7ebc$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $5730f4b91f5d7ebc$export$eb11bcee172fa7de = 'data-announced-column-header';
const $5730f4b91f5d7ebc$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $5730f4b91f5d7ebc$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});





parcelRegister("gQmIm", function(module, exports) {

$parcel$export(module.exports, "StoryPointLite", () => $67f641da665c9bfd$export$314bcc76f8a35673);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $81g2L = parcelRequire("81g2L");
const $67f641da665c9bfd$export$314bcc76f8a35673 = ({ issue: issue })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const shouldRenderStoryPointColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issue.key,
        fieldKey: storyPointKey
    });
    const hasEstimate = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.estimate);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $guzeq.STORY_POINTS))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81g2L.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
};

});
parcelRegister("81g2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1535cf7b32b551$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $bxhgD = parcelRequire("bxhgD");

var $6T4rd = parcelRequire("6T4rd");

var $koVbs = parcelRequire("koVbs");

var $7q84v = parcelRequire("7q84v");

var $gnK7n = parcelRequire("gnK7n");
const $2a1535cf7b32b551$var$DEFAULT_NO_VALUE = '-';
const $2a1535cf7b32b551$export$fdd6fddc555f3cc5 = ({ value: value, hasStoryPoints: hasStoryPoints, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const { formatNumber: formatNumber, formatMessage: formatMessage } = (0, $koVbs.default)();
    const ariaLabelWithValue = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? formatMessage((0, $7q84v.default).storyPointsAriaLabel, {
        storyPointValue: formatNumber(value)
    }) : formatMessage((0, $7q84v.default).storyPointsAriaLabelNullValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a1535cf7b32b551$var$StoryPointWrapper, {
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    }, hasStoryPoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: formatMessage((0, $7q84v.default).storyPointsTooltip),
        ariaLabel: ariaLabelWithValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: "default"
    }, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) ? formatNumber(value) : $2a1535cf7b32b551$var$DEFAULT_NO_VALUE))));
};
var $2a1535cf7b32b551$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($2a1535cf7b32b551$export$fdd6fddc555f3cc5);
const $2a1535cf7b32b551$var$StoryPointWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _2lx21bp4 _4cvr1h6o _vchhusvi _vwz4kb7n _o5721q9c _80om73ad",
            __cmplp.shouldRenderStoryPointColumn && "_1reo1kw7 _18m91kw7 _1bsb1ns9 _1ul91shb _p12f1shb _ks4f1shb _1w7e1ule _18j015vq _d38j15vq _1sqt1q9c _14hh1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("epPSJ", function(module, exports) {

$parcel$export(module.exports, "Versions", () => $40c735510e80905d$export$4893a37082435e75);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $iDGXn = parcelRequire("iDGXn");

var $963tu = parcelRequire("963tu");

var $a6e3u = parcelRequire("a6e3u");
const $40c735510e80905d$export$4893a37082435e75 = ({ card: card, isCompanyManaged: isCompanyManaged, backlogContainerSize: backlogContainerSize, isCardListContainsVersion: isCardListContainsVersion })=>{
    const shouldDisplayVersions = isCompanyManaged && isCardListContainsVersion;
    const showVersions = (0, $iDGXn.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c735510e80905d$var$VersionsContainer, {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6e3u.VersionsField), {
        cardId: card.id,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c735510e80905d$var$VersionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $lD23V.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $lD23V.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a6e3u", function(module, exports) {

$parcel$export(module.exports, "VersionsField", () => $50fd536bb47da793$export$5413999baebac1f7);

var $5uXOq = parcelRequire("5uXOq");

var $9Md3g = parcelRequire("9Md3g");

var $9uTTl = parcelRequire("9uTTl");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $khnfQ = parcelRequire("khnfQ");

var $kM28N = parcelRequire("kM28N");

var $aYeHZ = parcelRequire("aYeHZ");
function $50fd536bb47da793$export$5413999baebac1f7({ cardId: cardId, backlogContainerSize: backlogContainerSize }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const versions = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardVersionsSelector)(state, cardId));
    const tooltipText = (0, $5uXOq.useMemo)(()=>versions.map((version)=>version.name).join(', '), [
        versions
    ]);
    const text = (0, $5uXOq.useMemo)(()=>versions.length === 1 ? versions[0].name : formatMessage((0, $aYeHZ.messages).text, {
            count: versions.length
        }), [
        formatMessage,
        versions
    ]);
    if (!versions.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $50fd536bb47da793$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipText
    }, backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL || backlogContainerSize === (0, $khnfQ.ScreenSize).SMALL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.VersionIconWrapper), null, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Md3g))), {
        label: "version icon",
        color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9uTTl))),
        LEGACY_primaryColor: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9uTTl))), {
        primaryColor: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
        size: "small",
        label: "version icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.VersionIconNumber), null, versions.length)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), null, text)));
}
const $50fd536bb47da793$var$containerStyles = (0, $jJ1Sb.xcss)({
    maxWidth: '100%',
    pointerEvents: 'all'
});

});
parcelRegister("aYeHZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9749e76c88603657$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9749e76c88603657$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "backlog.card-list.card.card-contents.versions-field.text",
        "defaultMessage": "{count} versions"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.card-contents.versions-field.aria-label",
        "defaultMessage": "{versions} {count, plural, one {version} other {versions}}"
    }
});

});




parcelRegister("iuO0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1234dacecf6943c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $k35me = parcelRequire("k35me");

var $7YAWr = parcelRequire("7YAWr");
const $d1234dacecf6943c$export$7b43361c37f3a9e7 = (cardListType)=>cardListType !== (0, $guzeq.BACKLOG);
function $d1234dacecf6943c$var$ConnectedCardWithIccWrapperInner(props) {
    const { cardId: cardId, cardListId: cardListId, isAttachedToParent: isAttachedToParent, forciblyRenderRichCard: forciblyRenderRichCard, setRichActiveCard: setRichActiveCard } = props;
    // Redux hook
    const cardList = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardLists)(state)[cardListId]);
    // Check if the card is not in the backlog (we don't show status lozenges in the backlog)
    const canShowStatusLozengeOnCards = $d1234dacecf6943c$export$7b43361c37f3a9e7(cardList.type);
    const visibleCardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    // cards that are being hidden by the filter will have index -1.
    // Dnd does not officially support this but it works fine.
    const draggableIndex = visibleCardIds.indexOf(cardId);
    const isActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(cardListId));
    const isIccEnabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $jG5HW.getIsCompanyManaged)(state) && (0, $9Pc1U.isInlineIssueCreateAvailableForCurrentUser)(state) && (0, $dGljH.hasCardTypesSelector)(state));
    const isVisible = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeIsCardVisible)(state)(cardId));
    const shouldRenderRichCard = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.shouldRenderRichElements)(state, {
            cardId: cardId
        })) || forciblyRenderRichCard === true;
    const hasIccOpen = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.hasICCOpen)(state, {
            cardId: cardId
        }));
    // This will be defined if this card is a parent of a card group
    const cardGroup = (0, $c1MAf.useBacklogSelector)((0, $ld0jI.makeGetCardGroupByParentId))(cardListId, cardId);
    const subtaskIds = cardGroup && cardGroup.cardIds;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YAWr.CardWithIccWrapper), {
        ...props,
        isVisible: isVisible,
        shouldRenderRichCard: shouldRenderRichCard,
        hasIccOpen: hasIccOpen,
        setRichActiveCard: setRichActiveCard,
        isIccEnabled: isIccEnabled,
        draggableIndex: draggableIndex,
        isActiveSprint: isActiveSprint,
        canShowStatusLozengeOnCards: canShowStatusLozengeOnCards,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    });
}
const $d1234dacecf6943c$var$ConnectedCardWithIccWrapper = /*#__PURE__*/ (0, $5uXOq.memo)($d1234dacecf6943c$var$ConnectedCardWithIccWrapperInner);
var $d1234dacecf6943c$export$2e2bcd8739ae039 = $d1234dacecf6943c$var$ConnectedCardWithIccWrapper;

});
parcelRegister("7YAWr", function(module, exports) {

$parcel$export(module.exports, "CardWithIccWrapper", () => $7641ddb99215ff69$export$55a2755069cf4bed);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $il2Q2 = parcelRequire("il2Q2");

var $hQh4f = parcelRequire("hQh4f");

var $1hEu3 = parcelRequire("1hEu3");

var $hyUTn = parcelRequire("hyUTn");
const $7641ddb99215ff69$var$CardWithIccWrapperInner = ({ cardId: cardId, cardListId: cardListId, isVisible: isVisible, shouldRenderRichCard: shouldRenderRichCard, hasIccOpen: hasIccOpen, setRichActiveCard: setRichActiveCard, isIccEnabled: isIccEnabled, draggableIndex: draggableIndex, canShowStatusLozengeOnCards: canShowStatusLozengeOnCards, isAttachedToParent: isAttachedToParent, subtaskIds: subtaskIds })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const hasRenderedRichElements = (0, $5uXOq.useRef)(false);
    const pendingHoverAction = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>clearTimeout(pendingHoverAction.current), [
        pendingHoverAction
    ]);
    const autobatch = (0, $1fZVH.useAutobatch)();
    const onMouseEnter = (0, $7D59a.useEvent)((e)=>{
        autobatch(()=>{
            (0, $il2Q2.default)('backlog.card-hover', e);
            setRichActiveCard(cardId);
        });
    });
    const onFocus = (0, $7D59a.useEvent)(()=>{
        setRichActiveCard(cardId);
    });
    const onMouseLeave = (0, $7D59a.useEvent)(()=>{
        const containerElement = containerRef.current;
        if (!containerElement) return;
         // Remove pending setRichActiveCard if it hasn't already fired
        if (pendingHoverAction) {
            clearTimeout(pendingHoverAction.current);
            pendingHoverAction.current = undefined;
        }
        const activeElement = (0, $hyUTn.getActiveElement)(); // Ignore event if focused on a child
        if (activeElement instanceof Node && containerElement.contains(activeElement)) return;
        setRichActiveCard(null);
    });
    const onBlur = (0, $7D59a.useEvent)((e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (containerRef.current && relatedTarget instanceof Node && !containerRef.current.contains(relatedTarget)) setRichActiveCard(null);
    });
    if (shouldRenderRichCard && !hasRenderedRichElements.current) hasRenderedRichElements.current = true;
     // First card on the list always renders ICC above itself so tab works from the list header
    const canUseICC = isIccEnabled && cardId > 0;
    const shouldRenderICCAbove = canUseICC && (draggableIndex === 0 || hasIccOpen || shouldRenderRichCard || hasRenderedRichElements.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7641ddb99215ff69$export$6236cfcd981152cf, {
        isVisible: isVisible,
        innerRef: containerRef,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, shouldRenderICCAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hEu3.default), {
        listId: cardListId,
        insertBefore: cardId,
        isBetweenCards: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQh4f.default), {
        id: cardId,
        cardListId: cardListId,
        canShowStatus: canShowStatusLozengeOnCards,
        draggableIndex: draggableIndex,
        shouldRenderRichCard: shouldRenderRichCard || hasRenderedRichElements.current,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }));
};
const $7641ddb99215ff69$export$55a2755069cf4bed = /*#__PURE__*/ (0, $5uXOq.memo)($7641ddb99215ff69$var$CardWithIccWrapperInner); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $7641ddb99215ff69$var$CardWithICCControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1tdshev-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.isVisible ? 'block' : 'none'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7641ddb99215ff69$var$CardWithICCExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7641ddb99215ff69$export$6236cfcd981152cf = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $7641ddb99215ff69$var$CardWithICCExperiment, $7641ddb99215ff69$var$CardWithICCControl);

});
parcelRegister("1fZVH", function(module, exports) {

$parcel$export(module.exports, "useAutobatch", () => $befa27b0681ab6bc$export$5b8ae94abd7adcf);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $befa27b0681ab6bc$var$queue = new Set();
let $befa27b0681ab6bc$var$hasQueuedFlush = false;
function $befa27b0681ab6bc$var$flush() {
    const tasks = Array.from($befa27b0681ab6bc$var$queue);
    $befa27b0681ab6bc$var$queue.clear();
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $befa27b0681ab6bc$export$46f5568dd7916109(task) {
    $befa27b0681ab6bc$var$queue.add(task);
    if (!$befa27b0681ab6bc$var$hasQueuedFlush) {
        $befa27b0681ab6bc$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $befa27b0681ab6bc$var$hasQueuedFlush = false;
            $befa27b0681ab6bc$var$flush();
        });
    }
    return ()=>{
        $befa27b0681ab6bc$var$queue.delete(task);
    };
}
function $befa27b0681ab6bc$export$5b8ae94abd7adcf() {
    if (!(0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $5uXOq.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $5uXOq.useCallback)((task)=>{
        const cancel = $befa27b0681ab6bc$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("il2Q2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf448399fcb49c9$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $cwjlq = parcelRequire("cwjlq");

var $35xfG = parcelRequire("35xfG");

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");

var $6kwk0 = parcelRequire("6kwk0");
function $3cf448399fcb49c9$var$mapToInteractionType(eventType) {
    if (eventType === 'click' || eventType === 'dblclick' || eventType === 'mousedown') return 'press';
    if (eventType === 'mouseenter' || eventType === 'mouseover') return 'hover';
    return undefined;
}
function $3cf448399fcb49c9$export$2e2bcd8739ae039(name, event) {
    if (!event || !event.isTrusted) return;
    const interactionType = $3cf448399fcb49c9$var$mapToInteractionType(event.type);
    if (!interactionType) // when interactionType is falsy we do not yet support this type of event. should we blow up with throwing error instead?
    return;
    const rate = (0, $35xfG.getInteractionRate)(name, interactionType);
    const pressInteractionsList = (0, $35xfG.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $bBkFW.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $cwjlq.default)(rate)) {
        (0, $bBkFW.abortAll)('new_interaction', name);
        const startTimestamp = event.timeStamp ?? performance.now();
        const newId = (0, $7Jxgt.v4)();
        (0, $6InPJ.DefaultInteractionID).current = newId;
        (0, $bBkFW.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $6kwk0.default).current);
    }
}

});

parcelRegister("hQh4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e82b26b42582d534$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9MjbF = parcelRequire("9MjbF");

var $MGmIU = parcelRequire("MGmIU");

var $7wqBZ = parcelRequire("7wqBZ");

var $bv8GQ = parcelRequire("bv8GQ");

var $7D59a = parcelRequire("7D59a");

var $iDGXn = parcelRequire("iDGXn");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $gFfOq = parcelRequire("gFfOq");


var $h5zHO = parcelRequire("h5zHO");

var $kM28N = parcelRequire("kM28N");

var $lzKXg = parcelRequire("lzKXg");
const $e82b26b42582d534$export$60332b2344f7fe41 = ({ id: id, cardListId: cardListId, canShowStatus: canShowStatus = false, shouldRenderRichCard: shouldRenderRichCard = true, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds })=>{
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[String(id)]);
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const onMouseDown = (0, $7D59a.useEvent)(()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
        (0, $7wqBZ.getLongTasksMetrics)('dnd').start('backlog', (0, $guzeq.BACKLOG_LONG_TASKS_DND_MARK_NAME));
    });
    const onMouseUp = (0, $7D59a.useEvent)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('dnd').stop((0, $bv8GQ.softwareGenericLongTasksReporter)('dnd'));
    });
    const getHasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    const elementRef = (0, $5uXOq.useRef)(null);
    const { isDragging: isDragging, dragPreview: dragPreview, closestEdge: closestEdge, dropState: dropState } = (0, $lzKXg.useDraggableCard)({
        elementRef: elementRef,
        cardListId: cardListId,
        cardId: id
    });
    if (!card) return null;
    const key = card.key;
    const summary = card.summary;
    const icon = card.icon;
    const isOptimistic = id < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        isCompact: showCompactMode,
        lowerOpacity: false,
        isSelected: false,
        isFlagged: false,
        isDraggable: true,
        isDragHandle: false,
        hasExtraFields: getHasExtraFields,
        isOptimistic: true,
        shouldShowChevron: isCompanyManaged,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ImageContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Img), {
        role: "presentation",
        src: icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Summary), null, summary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "small"
    })));
    const testIdProps = {
        'data-test-id': `software-backlog.card-list.card.content-container.${key}`,
        'data-testid': `software-backlog.card-list.card.content-container.${key}`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ContentContainer), {
        ref: elementRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        tabIndex: -1,
        ...testIdProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFfOq.default), {
        id: id,
        canShowStatus: canShowStatus,
        isDragging: isDragging,
        shouldRenderRichCard: shouldRenderRichCard,
        isAttachedToParent: isAttachedToParent,
        subtaskIds: subtaskIds
    }), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5zHO.DropIndicator), {
        dropStatisticsCardListId: dropState?.cardListIfDivider ?? undefined,
        droppingOverCardListId: cardListId,
        droppingOverCardId: id,
        edge: closestEdge
    }), dragPreview);
};
var $e82b26b42582d534$export$2e2bcd8739ae039 = $e82b26b42582d534$export$60332b2344f7fe41;

});
parcelRegister("gFfOq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51b02e8ed71c16e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $acDhY = parcelRequire("acDhY");

var $7wqBZ = parcelRequire("7wqBZ");

var $6s1PB = parcelRequire("6s1PB");

var $g4tDr = parcelRequire("g4tDr");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $a4GLz = parcelRequire("a4GLz");

var $6U9Sv = parcelRequire("6U9Sv");

var $7D59a = parcelRequire("7D59a");


var $c1MAf = parcelRequire("c1MAf");

var $a7yHf = parcelRequire("a7yHf");

var $lReb9 = parcelRequire("lReb9");

var $4mqko = parcelRequire("4mqko");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $45Qwd = parcelRequire("45Qwd");

var $l9VFH = parcelRequire("l9VFH");

var $fmuR9 = parcelRequire("fmuR9");

var $1z1J7 = parcelRequire("1z1J7");

var $fopK0 = parcelRequire("fopK0");

var $bIoVa = parcelRequire("bIoVa");
const $b51b02e8ed71c16e$var$staticEntryPointActions = {
    load: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
function $b51b02e8ed71c16e$var$CardContentsContainer({ id: id, isDragging: isDragging, isDragHandle: isDragHandle, shouldRenderRichCard: shouldRenderRichCard, isAttachedToParent: isAttachedToParent = false, subtaskIds: subtaskIds }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    // There is always the possibility that the card selected does not exist.
    const card = cards[String(id)];
    const storyPointFieldId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getStoryPointFieldId));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isUserAtLeastMember = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isUserAtLeastMemberOfProject));
    const canUserEditIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const currentProjectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const projectAris = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectAris));
    const parents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const isFocused = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFocusedCard)(state) === id);
    const isSelected = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.isCardSelected)(state)(id));
    const highlightText = (0, $c1MAf.useBacklogSelector)((state)=>(0, $l9VFH.getFilters)(state).TEXT ?? null);
    const hasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    const fireCheckboxAnalytics = (0, $6U9Sv.useFireCheckboxAnalytics)();
    const { entryPointActions: entryPointActions } = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? (0, $acDhY.useBulkOpsEntryPoint)() : {
        entryPointActions: $b51b02e8ed71c16e$var$staticEntryPointActions
    };
    const { key: cardKey, priority: priority, summary: summary, issueUrl: issueUrl, isDone: isDone, icon: icon, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, parentId: parentId, parentKey: parentKey, dueDate: dueDate, isFlagged: isFlagged, extraFields: extraFields, typeHierarchyLevel: issueHierarchyLevel } = card;
    const onClick = (0, $c1MAf.useBacklogActionCreator)((withCmd, withShift, source, // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    viaCheckbox = false, externalAction)=>{
        (0, $7wqBZ.getLongTasksMetrics)('bento').start('backlog');
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        }), 'backlogCard', {
            source: source,
            issueHierarchyLevel: issueHierarchyLevel
        });
        const fireSelectionAnalytics = (extraAttr)=>{
            if (viaCheckbox || withCmd || withShift && extraAttr.numSelectedCards > 1) fireCheckboxAnalytics?.(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                ...extraAttr,
                inputSource: (0, $fopK0.getCardSelectionAnalyticsInputSource)(withShift, withCmd, viaCheckbox),
                isCheckboxChecked: !isSelected,
                issueHierarchyLevel: issueHierarchyLevel,
                selectType: 'individual',
                issueId: id
            });
        };
        (withCmd || withShift) && (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && entryPointActions.load();
        return (0, $4mqko.cardClick)(id, withCmd, withShift, viaCheckbox, fireSelectionAnalytics, externalAction);
    });
    const singleSelectCard = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $4mqko.cardSingleSelect)(id));
    const onContextMenu = (0, $7D59a.useEvent)(()=>{
        const isCardOutsideOfSelectedCards = !selectedCards.includes(id);
        if (isCardOutsideOfSelectedCards) singleSelectCard();
    });
    const onFocus = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $lReb9.cardFocus)(id));
    const onBlur = (0, $c1MAf.useBacklogActionCreator)((0, $lReb9.cardBlur));
    const onToggleCardGroup = (0, $c1MAf.useBacklogActionCreator)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'expansionState'
        }), 'backlogCardGroup', {
            issueHierarchyLevel: issueHierarchyLevel
        });
        return (0, $a7yHf.cardGroupToggle)(id);
    });
    const isGroupExpanded = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeGetCardGroupExpanded)(state)(id) || !!(0, $dGljH.getOrderedCardIdsByCardListIdWithLimit)(state)[id].length : (0, $dGljH.makeGetCardGroupExpanded)(state)(id));
    const selectedCardsForFlagWithCommentModal = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsForFlagWithCommentModalFromCardIdsSelector)(state)([
            id
        ]));
    const onAddFlag = (0, $c1MAf.useBacklogActionCreator)((_)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'inlineCardField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'addFlag');
        return (0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$34f52cb2089ddc40),
            payload: {
                flagAction: (0, $a4GLz.ADD),
                cards: selectedCardsForFlagWithCommentModal
            }
        });
    });
    const hasFlaggedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasFlaggedCards));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const hasCardsWithDueDate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const orderedVersions = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedVersions));
    if (!card) return null;
    /*
	 * as long as there is a single card having fix version, the orderedVersions is not empty
	 * checking the orderedVersions value against empty to determine if we should preserve the space for version
	 * even this card has no version
	 * the reason to do that is to to make sure the subtask text and subtask icons are aligned.
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-54
	 * https://hello.jira.atlassian.cloud/browse/FTFNS-55
	 */ const shouldDisplayVersions = isCompanyManaged && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(orderedVersions);
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(issueHierarchyLevel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bIoVa.default), {
        cardId: id,
        isSelected: isSelected,
        selectedCards: selectedCards,
        numSelectedCards: selectedCards.length,
        parents: parents,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        projectAris: projectAris,
        storyPointFieldId: storyPointFieldId,
        isUserAtLeastMember: isUserAtLeastMember,
        canUserEditIssue: canUserEditIssue,
        isDragging: isDragging,
        isDragHandle: isDragHandle,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        shouldRenderRichCard: shouldRenderRichCard,
        highlightText: highlightText,
        isFocused: isFocused,
        hasExtraFields: hasExtraFields,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onContextMenu: onContextMenu,
        isAttachedToParent: isAttachedToParent,
        isSubtask: isSubtask,
        subtaskIds: subtaskIds,
        isCardGroupExpanded: isGroupExpanded,
        onToggleCardGroup: onToggleCardGroup,
        cardKey: cardKey,
        dueDate: dueDate,
        icon: icon,
        isDone: isDone,
        isFlagged: isFlagged,
        issueUrl: issueUrl,
        numCompleteChildren: numCompleteChildren,
        numTotalChildren: numTotalChildren,
        parentId: parentId,
        parentKey: parentKey,
        priority: priority,
        shouldDisplayVersions: shouldDisplayVersions,
        summary: summary,
        extraFields: extraFields,
        onAddFlag: onAddFlag,
        shouldRenderInlineAddFlag: hasFlaggedCards,
        shouldRenderPriorityColumn: hasCardsWithPriority,
        shouldRenderDueDateColumn: hasCardsWithDueDate,
        shouldRenderStoryPointColumn: hasCardsWithStoryPoint,
        shouldRenderEstimatesColumn: hasCardsWithEstimate
    }));
}
var $b51b02e8ed71c16e$export$2e2bcd8739ae039 = $b51b02e8ed71c16e$var$CardContentsContainer;

});
parcelRegister("a4GLz", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $65b7e6dbe70f8139$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $65b7e6dbe70f8139$export$29d55e1f664a246b);
$parcel$export(module.exports, "FLAG_REMOVED_PREFIX", () => $65b7e6dbe70f8139$export$43b00f69c32e9a5);
$parcel$export(module.exports, "FLAG_ADDED_PREFIX", () => $65b7e6dbe70f8139$export$625f394c78645dcd);
const $65b7e6dbe70f8139$export$bb6389024b71c2ae = 'ADD';
const $65b7e6dbe70f8139$export$29d55e1f664a246b = 'REMOVE';
const $65b7e6dbe70f8139$export$43b00f69c32e9a5 = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_off:',
                        id: 'atlassian-flag_off',
                        text: ':flag_off:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag removed '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $65b7e6dbe70f8139$export$625f394c78645dcd = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_on:',
                        id: 'atlassian-flag_on',
                        text: ':flag_on:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag added '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};

});

parcelRegister("6U9Sv", function(module, exports) {

$parcel$export(module.exports, "useContextMenuAnalytics", () => $bd5d557ceb1e8011$export$e3e152955394305b);
$parcel$export(module.exports, "ContextMenuAnalytics", () => $bd5d557ceb1e8011$export$eceb0d68a993ec5c);
$parcel$export(module.exports, "ContextualAnalyticsDataFromNode", () => $bd5d557ceb1e8011$export$f9d8ab9f9d913310);
$parcel$export(module.exports, "useFireCheckboxAnalytics", () => $bd5d557ceb1e8011$export$41c45cbb6f557de5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iAbh9 = parcelRequire("iAbh9");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ewaBk = parcelRequire("ewaBk");

var $gj8F1 = parcelRequire("gj8F1");
const $bd5d557ceb1e8011$export$e3e152955394305b = ()=>{
    const analyticsMapping = (0, $ewaBk.useAnalyticsMapping)();
    const getAnalyticsMapping = (0, $5uXOq.useMemo)(()=>(0, $gj8F1.createGetAnalyticsMapping)(analyticsMapping), [
        analyticsMapping
    ]);
    const addMappedAnalyticsToEvent = (0, $5uXOq.useCallback)((event, id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        if (mappedAnalytics && typeof mappedAnalytics === 'object') {
            const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = mappedAnalytics;
            event.update(analytics);
        }
        if (updater) {
            if (typeof updater === 'function') event.update(updater);
            else {
                const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = updater;
                event.update(analytics);
            }
        }
        return event;
    }, [
        getAnalyticsMapping
    ]);
    const getAttributesForId = (0, $5uXOq.useCallback)((id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        const mappedAttributes = typeof mappedAnalytics === 'object' ? mappedAnalytics.attributes : undefined;
        return typeof updater === 'object' ? {
            ...mappedAttributes,
            ...updater?.attributes
        } : mappedAttributes;
    }, [
        getAnalyticsMapping
    ]);
    const fireUIAnalyticsForNode = (0, $5uXOq.useCallback)((event, id, updater, attributes)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        let subjectId = typeof updater === 'function' ? updater(event.payload).actionSubjectId : updater?.actionSubjectId;
        if (!subjectId && mappedAnalytics) subjectId = typeof mappedAnalytics === 'string' ? mappedAnalytics : mappedAnalytics.actionSubjectId;
        if (attributes) subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId, attributes) : (0, $8zOmE.fireUIAnalytics)(event, attributes);
        else subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId) : (0, $8zOmE.fireUIAnalytics)(event);
    }, [
        getAnalyticsMapping
    ]);
    const values = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticsForNode: fireUIAnalyticsForNode,
            getAttributesForId: getAttributesForId,
            addMappedAnalyticsToEvent: addMappedAnalyticsToEvent
        }), [
        fireUIAnalyticsForNode,
        getAttributesForId,
        addMappedAnalyticsToEvent
    ]);
    return values;
};
const $bd5d557ceb1e8011$export$eceb0d68a993ec5c = ({ scope: scope, children: children, cardId: cardId })=>{
    const attributes = (0, $ewaBk.useAnalyticsAttributes)({
        scope: scope,
        cardId: cardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$f9d8ab9f9d913310 = ({ id: id, updater: updater, children: children })=>{
    const { getAttributesForId: getAttributesForId } = $bd5d557ceb1e8011$export$e3e152955394305b();
    const attributes = (0, $5uXOq.useMemo)(()=>getAttributesForId(id, updater), [
        getAttributesForId,
        id,
        updater
    ]);
    if (!attributes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$41c45cbb6f557de5 = ()=>{
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const subscriptionHandle = (0, $4R6GH.fg)('subscription_handler_bulk_ops_analytics') ? (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : undefined;
    const fireCheckboxAnalytics = (0, $5uXOq.useCallback)((event, actionSubjectId, attributes)=>{
        if (!bulkOpsFlow) {
            (0, $jcw0u.default)({
                error: new Error('Trying to fire checkbox analytics when bulkOpsFlow is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-analytics-use-fire-checkbox-analytics',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                },
                attributes: {
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            });
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, {
                ...attributes,
                bulkOpsSessionID: 'unknown'
            });
            return;
        }
        if (bulkOpsFlow.isInFlow()) (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributes);
        else if (subscriptionHandle && (0, $4R6GH.fg)('subscription_handler_bulk_ops_analytics')) /* can remove subscriptionHandle undefined check - on clean up subscription_handler_bulk_ops_analytics */ subscriptionHandle.current = bulkOpsFlow.registerAnalyticsEventPublisher((sessionID)=>{
            const attributesWithSessionId = {
                ...attributes,
                bulkOpsSessionID: sessionID
            };
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributesWithSessionId);
        });
        else bulkOpsFlow.registerAnalyticsEventPublisher((sessionID)=>{
            const attributesWithSessionId = {
                ...attributes,
                bulkOpsSessionID: sessionID
            };
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributesWithSessionId);
        });
    }, [
        bulkOpsFlow,
        subscriptionHandle
    ]);
    (0, $4R6GH.fg)('subscription_handler_bulk_ops_analytics') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            // can remove ? - on clean up subscription_handler_bulk_ops_analytics
            return subscriptionHandle?.current();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return fireCheckboxAnalytics;
};

});
parcelRegister("gj8F1", function(module, exports) {

$parcel$export(module.exports, "createGetAnalyticsMapping", () => $84e9c18cb7a7bed7$export$836ec4673aac623f);

var $gJBT6 = parcelRequire("gJBT6");
const $84e9c18cb7a7bed7$export$7b036678329a3ea2 = (id, analyticsMapping)=>{
    let result = analyticsMapping[id];
    if (!result) {
        const matchedId = Object.keys(analyticsMapping).find((key)=>key.startsWith(id) || id.startsWith(key));
        if (matchedId) result = analyticsMapping[matchedId];
    }
    return result;
};
const $84e9c18cb7a7bed7$export$836ec4673aac623f = (analyticsMapping)=>{
    if (!analyticsMapping) return (_id)=>undefined;
    // Sorting the analytics mapping by key length ensures that the shortest key is matched first - shortest key means best match
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sortedAnalyticsMapping = Object.fromEntries(Object.entries(analyticsMapping).sort(([keyA], [keyB])=>keyA.length - keyB.length));
    const memoizedGetterFunction = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($84e9c18cb7a7bed7$export$7b036678329a3ea2);
    return (id)=>memoizedGetterFunction(id, sortedAnalyticsMapping);
};

});


parcelRegister("fopK0", function(module, exports) {

$parcel$export(module.exports, "getCardSelectionAnalyticsInputSource", () => $34e2155564843a3b$export$cddca765560eae90);

var $cizWc = parcelRequire("cizWc");
const $34e2155564843a3b$export$cddca765560eae90 = (withShift, withCmd, viaCheckbox)=>{
    if (withShift && withCmd) return 0, $cizWc.CMD_SHIFT_CLICK_ANALYTICS_ID;
    if (withShift) return 0, $cizWc.SHIFT_CLICK_ANALYTICS_ID;
    if (viaCheckbox) return 0, $cizWc.CHECKBOX_ANALYTICS_ID;
    return 0, $cizWc.CMD_CLICK_ANALYTICS_ID;
};

});

parcelRegister("bIoVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6036f9f2482e6fb8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $bxhgD = parcelRequire("bxhgD");

var $amts2 = parcelRequire("amts2");

var $9ed83 = parcelRequire("9ed83");

var $2xkq3 = parcelRequire("2xkq3");

var $i3ya9 = parcelRequire("i3ya9");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $e6DOJ = parcelRequire("e6DOJ");

var $4dc4s = parcelRequire("4dc4s");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $9MjbF = parcelRequire("9MjbF");


var $MGmIU = parcelRequire("MGmIU");

var $91LZJ = parcelRequire("91LZJ");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hrjFc = parcelRequire("hrjFc");


var $lu5k0 = parcelRequire("lu5k0");

var $iDGXn = parcelRequire("iDGXn");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $5uBAa = parcelRequire("5uBAa");

var $dGljH = parcelRequire("dGljH");

var $eoB0b = parcelRequire("eoB0b");

var $fSgHa = parcelRequire("fSgHa");

var $3VzmQ = parcelRequire("3VzmQ");

var $7IKPD = parcelRequire("7IKPD");

var $khnfQ = parcelRequire("khnfQ");

var $3JQPC = parcelRequire("3JQPC");


var $d9htP = parcelRequire("d9htP");

var $7q84v = parcelRequire("7q84v");

var $kM28N = parcelRequire("kM28N");

var $5OkdV = parcelRequire("5OkdV");

var $iJZfp = parcelRequire("iJZfp");

var $lM9Tp = parcelRequire("lM9Tp");

var $ekU0X = parcelRequire("ekU0X");

var $cizWc = parcelRequire("cizWc");

var $13fTq = parcelRequire("13fTq");

var $g1Kbb = parcelRequire("g1Kbb");

var $hCPhj = parcelRequire("hCPhj");

var $2JHi9 = parcelRequire("2JHi9");

var $9U5Ic = parcelRequire("9U5Ic");

var $5U2yP = parcelRequire("5U2yP");

var $fuplg = parcelRequire("fuplg");

var $bTzpK = parcelRequire("bTzpK");

var $4EUws = parcelRequire("4EUws");

var $lNMv0 = parcelRequire("lNMv0");

var $9MiEY = parcelRequire("9MiEY");

var $1D3VD = parcelRequire("1D3VD");

var $1e5mE = parcelRequire("1e5mE");

var $xEBl6 = parcelRequire("xEBl6");
const $6036f9f2482e6fb8$var$CardContents = ({ cardId: cardId, cardKey: cardKey, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onContextMenu: onContextMenu, highlightText: highlightText, summary: summary, parents: parents, parentId: parentId, currentProjectId: currentProjectId, projectIds: projectIds, projectAris: projectAris, issueUrl: issueUrl, icon: icon, dueDate: dueDate, estimationType: estimationType, storyPointFieldId: storyPointFieldId, timeTrackingOptions: timeTrackingOptions, extraFields: extraFields, hasExtraFields: hasExtraFields, canUserEditIssue: canUserEditIssue, isUserAtLeastMember: isUserAtLeastMember, isDone: isDone, isFocused: isFocused, isFlagged: isFlagged = false, isSelected: isSelected = false, isDragging: isDragging = false, isDragHandle: isDragHandle = false, shouldRenderRichCard: shouldRenderRichCard = true, selectedCards: selectedCards, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, shouldDisplayVersions: shouldDisplayVersions, isAttachedToParent: isAttachedToParent = false, isSubtask: isSubtask = false, subtaskIds: subtaskIds, parentKey: parentKey, isCardGroupExpanded: isCardGroupExpanded = false, onToggleCardGroup: onToggleCardGroupProp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onAddFlag: onAddFlag, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, shouldRenderPriorityColumn: shouldRenderPriorityColumn, shouldRenderDueDateColumn: shouldRenderDueDateColumn, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const prefersReducedMotion = (0, $e6DOJ.useIsReducedMotion)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    const isCompactView = backlogContainerSize === (0, $khnfQ.ScreenSize).EXTRA_SMALL;
    const [isActionMenuOpen, setIsActionMenuOpen] = (0, $5uXOq.useState)(false); // TODO move to <SummaryAndParents /> during NON UIF clean up
    const [isSummaryFieldEditing, setIsSummaryFieldEditing] = (0, $5uXOq.useState)(false);
    const [isActionMenuTriggerVisible] = (0, $5uXOq.useState)(true);
    const cardHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardHierarchyLevel));
    const isTopCardInBacklogContainer = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)((0, $guzeq.BACKLOG)))[0] === cardId;
    const isEpic = (0, $g4tDr.isEpicHierarchyLevel)(cardHierarchyLevel(cardId));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    const showEpics = (0, $iDGXn.useShowEpics)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const isCompactModeEnabled = showCompactMode;
    const returnFocusTo = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const menuTriggerRef = (0, $5uXOq.useRef)(null);
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const shouldShowCheckbox = (0, $3VzmQ.useShowCheckbox)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const viewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showAssignee: true,
        showEstimate: true,
        showDueDate: true,
        cardExtraFields: undefined
    };
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        if (e.defaultPrevented) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClick(withCmd, withShift, 'mouse');
    }, [
        onClick
    ]);
    const onClickThrough = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (withCmd || withShift) onFocus();
        handleClick(e);
    }, [
        onFocus,
        handleClick
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        if (e.key !== 'Enter' || isDragging) return;
        onClick(withCmd, withShift, 'keyboard');
    }, [
        isDragging,
        onClick
    ]); // TODO move to <SummaryAndParents /> on non UIF clean up
    const onSummaryEditStateChange = (0, $5uXOq.useCallback)((isEditing)=>{
        setIsSummaryFieldEditing(isEditing);
    }, []);
    const onRightClickOutside = (0, $5uXOq.useCallback)((_e)=>{
        setIsActionMenuOpen(false);
    }, []);
    const [versionMenuQueryRef, loadVersionMenuQuery] = (0, $8Uumt.useQueryLoader)((0, $hrjFc.default));
    (0, $5uXOq.useEffect)(()=>{
        if (!versionMenuQueryRef && loadVersionMenuQuery != null && shouldRenderRichCard) loadVersionMenuQuery({
            jiraProjectIds: projectAris,
            first: 500,
            after: null
        });
    }, [
        versionMenuQueryRef,
        loadVersionMenuQuery,
        shouldRenderRichCard,
        projectAris
    ]);
    const renderCardColor = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ekU0X.CardColor), {
            id: cardId
        });
    const handleMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
        setIsActionMenuOpen(isOpen);
    }, [
        setReturnFocusTo
    ]);
    const handlePulseMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen) {
            dispatch((0, $5uBAa.setHasViewedPulseRequest)());
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'opened',
                actionSubject: 'contextMenu'
            }), 'contextMenuWithWhiteboardPulse');
        }
        handleMenuOpenChange(isOpen);
    }, [
        handleMenuOpenChange,
        dispatch,
        createAnalyticsEvent
    ]); // for jsw_sprint_planning_whiteboards experiment
    const { cohort: cohort, flow: flow } = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getWhiteboardEligibility));
    const hasViewedPulse = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getHasViewedPulse));
    const isPulseActive = isTopCardInBacklogContainer && flow === 'crossFlow' && cohort === (0, $7IKPD.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).CONTEXT_MENU && !hasViewedPulse;
    const getMenuComponent = ()=>isPulseActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dc4s.Pulse), {
            radius: 3,
            pulse: !prefersReducedMotion
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9htP.ContextMenu), {
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handlePulseMenuOpenChange,
            issueId: cardId,
            issueKey: cardKey,
            summary: summary,
            selectedCardIds: selectedCards,
            versionMenuQueryRef: versionMenuQueryRef,
            triggerRef: menuTriggerRef
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9htP.ContextMenu), {
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            issueId: cardId,
            issueKey: cardKey,
            summary: summary,
            selectedCardIds: selectedCards,
            versionMenuQueryRef: versionMenuQueryRef,
            triggerRef: menuTriggerRef
        });
    const renderMenu = ()=>{
        const shouldRenderMenu = (isActionMenuOpen || shouldRenderRichCard) && isActionMenuTriggerVisible;
        const triggerIsFocused = returnFocusTo?.current && menuTriggerRef.current && returnFocusTo?.current === menuTriggerRef.current;
        const isMenuOpen = isActionMenuOpen || Boolean(triggerIsFocused);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.MenuPlaceholder), {
            isPulseActive: isPulseActive,
            isMenuOpen: isMenuOpen,
            "data-test-id": "software-backlog.card-list.card.card-contents.context-menu",
            "data-testid": "software-backlog.card-list.card.card-contents.context-menu",
            "data-component-selector": (0, $f836df2846e6254b$export$ca45cc072d50480d)
        }, shouldRenderMenu || isPulseActive ? getMenuComponent() : null);
    };
    const renderInteractionLayer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9U5Ic.default), {
            isFocused: isFocused,
            cardKey: cardKey,
            summary: summary,
            onFocus: onFocus,
            onBlur: onBlur,
            onClick: handleClick,
            onKeyDown: onKeyDown
        });
    const renderOriginalEstimateField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuplg.default), {
            issueId: cardId,
            issueKey: cardKey,
            estimationType: estimationType,
            timeTrackingOptions: timeTrackingOptions,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
        });
        return estimationType === (0, $guzeq.ORIGINAL_ESTIMATE) ? estimateField : null;
    };
    const renderStoryPointField = ()=>{
        const estimateField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MiEY.default), {
            issueId: cardId,
            issueKey: cardKey,
            storyPointFieldId: storyPointFieldId,
            estimationType: estimationType,
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        });
        return storyPointFieldId || estimationType === (0, $guzeq.STORY_POINTS) ? estimateField : null;
    };
    const renderAssigneeField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.AssigneeContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OkdV.default), {
            isUserAtLeastMember: isUserAtLeastMember,
            shouldRenderRichCard: shouldRenderRichCard,
            issueKey: cardKey
        }));
    const parentKeyText = parentKey !== undefined ? formatMessage((0, $7q84v.default).parentKeyText, {
        parentKey: parentKey
    }) : '';
    const renderParentKey = ()=>parentKey !== undefined && isSubtask && !isAttachedToParent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: parentKeyText,
            position: "mouse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardGroupKey), null, `${parentKeyText}`)) : null;
    const hasLinkedSubtasks = subtaskIds !== undefined && subtaskIds.length > 0;
    const numberOfLinkedSubtasks = hasLinkedSubtasks ? formatMessage((0, $7q84v.default).numberOfChildrenText, {
        numberOfChildren: subtaskIds.length
    }) : '';
    const shouldShowChevron = hasLinkedSubtasks && !isDragHandle;
    const onToggleCardGroup = (event)=>{
        event.preventDefault();
        onToggleCardGroupProp();
    };
    const isExpanded = isCardGroupExpanded;
    const getChevronIcon = ()=>{
        if (isExpanded) return (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9ed83))),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
            label: ""
        });
        return (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))),
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))), {
            label: ""
        });
    };
    const getAriaLabel = ()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleExpandedAriaLabelIssueTermRefresh : (0, $7q84v.default).cardGroupToggleCollapsedAriaLabelIssueTermRefresh, {
            issueKey: cardKey,
            summary: summary
        });
        return formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleExpandedAriaLabel : (0, $7q84v.default).cardGroupToggleCollapsedAriaLabel, {
            issueKey: cardKey,
            summary: summary
        });
    };
    const renderCardGroupToggle = ()=>{
        if (!shouldShowChevron) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: formatMessage(isExpanded ? (0, $7q84v.default).cardGroupToggleTooltipCollapse : (0, $7q84v.default).cardGroupToggleTooltipExpand)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6036f9f2482e6fb8$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardGroupToggle), {
            appearance: "subtle",
            onClick: onToggleCardGroup,
            "aria-label": getAriaLabel(),
            testId: "software-backlog.card-list.card.card-contents.subtask",
            "aria-expanded": isExpanded,
            iconBefore: getChevronIcon()
        })));
    };
    const getCheckboxContainerMargin = (shouldAddMargin)=>{
        if (shouldAddMargin && isAttachedToParent) return 'space.400';
        if (shouldAddMargin) return 'space.250';
        return 'space.0';
    };
    const renderCheckbox = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        ), {
            xcss: (0, $jJ1Sb.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                marginRight: getCheckboxContainerMargin(isCompanyManaged && !shouldShowChevron)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CheckboxContainer), {
            "data-component-selector": (0, $cizWc.CHECKBOX_COMPONENT_SELECTOR),
            "data-testid": (0, $cizWc.CHECKBOX_TESTID),
            shouldShowCheckbox: shouldShowCheckbox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iJZfp.default), {
            isSelected: isSelected,
            onClick: onClick,
            isDisabled: isBulkOpsInProgress,
            shouldShowCheckbox: shouldShowCheckbox
        })));
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const renderExtraFields = ()=>hasExtraFields && extraFields && showCardExtraFieldsColumnBasedOnViewSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ExtraFieldsContainer), {
            isSmartCardEnabled: (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true),
            isAttachedToParent: isAttachedToParent && isCompanyManaged,
            hideTypeIcon: !viewSettings.showIssueType
        }, extraFields.filter((field)=>viewSettings.cardExtraFields?.[field.id] === undefined ? true : viewSettings.cardExtraFields[field.id]).map((field, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                key: field.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1Kbb.CardExtraField), {
                field: field
            }), index < extraFields?.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCPhj.FieldSeparator), {
                "aria-hidden": "true",
                key: `${field.id}-separator`
            }, "\u2022"))));
    const renderCmpChildIssuesMetadata = ()=>hasLinkedSubtasks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SubtaskIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: numberOfLinkedSubtasks,
            position: "mouse"
        }, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($amts2))), {
            color: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
            LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
            LEGACY_size: "small",
            label: "subtaskIcon"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i3ya9))), {
            primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
            size: "small",
            label: "subtaskIcon"
        }))) : null;
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('contextmenu', onRightClickOutside);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('contextmenu', onRightClickOutside);
        };
    }, [
        onRightClickOutside
    ]);
    const getDraggingCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDraggingCardIds));
    const isOptimistic = cardId < 0;
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        lowerOpacity: false,
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDraggable: canUserEditIssue,
        isDragHandle: isDragHandle,
        hasExtraFields: hasExtraFields,
        isCompact: isCompactModeEnabled,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e5mE.TypeIcon), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D3VD.SummaryAndParents), {
        cardId: cardId,
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), !isDragHandle && renderExtraFields(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.StyledSpinner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "small"
    })));
    const numSelected = getDraggingCardIds(cardId).length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9htP.ContextMenu), {
        appearance: (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895),
        issueId: cardId,
        issueKey: cardKey,
        selectedCardIds: selectedCards,
        versionMenuQueryRef: versionMenuQueryRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.CardContainer), {
        "data-testid": (0, $cizWc.CARD_CONTAINER_TESTID),
        shouldShowChevron: shouldShowChevron,
        isCompanyManagedKanban: isCompanyManagedKanban,
        isCompact: isCompactModeEnabled,
        isAttachedToParent: isAttachedToParent,
        isSelected: !isDragHandle && isSelected,
        isFlagged: isFlagged,
        lowerOpacity: isDragging && !isDragHandle,
        isDragHandle: isDragHandle,
        isDraggable: canUserEditIssue,
        hasExtraFields: !isDragHandle && hasExtraFields && showCardExtraFieldsColumnBasedOnViewSettings,
        onContextMenu: onContextMenu,
        hideTypeIcon: !viewSettings.showIssueType,
        isAssigneeShown: viewSettings.showAssignee,
        "data-component-selector": (0, $f836df2846e6254b$export$fb374ae0d58ab29b)
    }, !isDragHandle ? renderInteractionLayer() : null, !isDragHandle ? renderCheckbox() : null, renderCardColor(), renderCardGroupToggle(), viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e5mE.TypeIcon), {
        icon: icon
    }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5U2yP.Key), {
        isDone: isDone,
        cardKey: cardKey,
        issueUrl: issueUrl,
        summary: summary,
        highlightText: highlightText,
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1D3VD.SummaryAndParents), {
        cardId: cardId,
        cardKey: cardKey,
        summary: summary,
        highlightText: highlightText,
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClickThrough: onClickThrough,
        onSummaryEditStateChange: onSummaryEditStateChange
    }), renderParentKey(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.OptionalFieldsContainer), null, !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lM9Tp.ChildIssuesMetadata), {
        numTotalChildren: numTotalChildren,
        numCompleteChildren: numCompleteChildren,
        onClickThrough: onClickThrough
    }), renderCmpChildIssuesMetadata(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xEBl6.VersionsWrapper), {
        shouldDisplayVersions: shouldDisplayVersions,
        backlogContainerSize: backlogContainerSize,
        cardId: cardId
    }), showEpics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTzpK.Parent), {
        cardId: cardId,
        cardKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        canUserEditIssue: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        backlogContainerSize: backlogContainerSize,
        isCompactView: isCompactView,
        isSubtask: isSubtask,
        isEpic: isEpic,
        isCompanyManaged: isCompanyManaged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNMv0.StatusFieldWrapper), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        cardKey: cardKey,
        cardId: cardId
    })), !isDragHandle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, viewSettings.showDueDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13fTq.DueDate), {
        dueDate: dueDate,
        shouldRenderDueDateColumn: shouldRenderDueDateColumn,
        isDone: isDone
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JHi9.Flag), {
        isFlagged: isFlagged,
        shouldRenderInlineAddFlag: shouldRenderInlineAddFlag,
        onAddFlag: onAddFlag
    }), viewSettings.showEstimate && renderOriginalEstimateField(), viewSettings.showEstimate && renderStoryPointField(), viewSettings.showPriority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4EUws.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        issueKey: cardKey,
        shouldRenderRichCard: shouldRenderRichCard,
        shouldRenderColumn: shouldRenderPriorityColumn
    }))), !isDragHandle && viewSettings.showAssignee && renderAssigneeField(), !isDragHandle && renderMenu()), !isDragHandle && renderExtraFields())), isDragHandle && numSelected > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.DragHandleCardsAmount), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: "primary",
        testId: (0, $cizWc.CARDS_AMOUNT_BADGE_TESTID)
    }, numSelected)));
};
var $6036f9f2482e6fb8$export$2e2bcd8739ae039 // Chevron icon wrapper, keep it consistent with src/packages/software/backlog/src/view/card-list/card-lite-extended/index.tsx
 = $6036f9f2482e6fb8$var$CardContents;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6036f9f2482e6fb8$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy14f8 _1ii7wtyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("amts2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5ba430e5f5b265db279203bc3692497>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b2cdd985f20227$var$_react = $78b2cdd985f20227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $78b2cdd985f20227$var$_UNSAFE_baseNew = $78b2cdd985f20227$var$_interopRequireDefault((parcelRequire("huIZN")));
function $78b2cdd985f20227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for subtasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78b2cdd985f20227$var$SubtasksIcon = (props)=>/*#__PURE__*/ $78b2cdd985f20227$var$_react.default.createElement($78b2cdd985f20227$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3 8h10c.69 0 1.25.56 1.25 1.25V13c0 .69-.56 1.25-1.25 1.25H9.25C8.56 14.25 8 13.69 8 13V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v3.75C1.75 7.44 2.31 8 3 8Z"/>`
    }, props));
$78b2cdd985f20227$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $78b2cdd985f20227$var$_default = module.exports.default = $78b2cdd985f20227$var$SubtasksIcon;

});

parcelRegister("i3ya9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03646f834264250b$var$_react = $03646f834264250b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $03646f834264250b$var$_subtasks = $03646f834264250b$var$_interopRequireDefault((parcelRequire("amts2")));
function $03646f834264250b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03646f834264250b$var$SubtaskIcon = (props)=>/*#__PURE__*/ $03646f834264250b$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M19 7c1.105.003 2 .899 2 2.006v9.988A2.005 2.005 0 0 1 18.994 21H9.006A2.005 2.005 0 0 1 7 19h11c.555 0 1-.448 1-1zM3 5.006C3 3.898 3.897 3 5.006 3h9.988C16.102 3 17 3.897 17 5.006v9.988A2.005 2.005 0 0 1 14.994 17H5.006A2.005 2.005 0 0 1 3 14.994zM5 5v10h10V5z"/><path d="M7.707 9.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L9 10.586z"/></g></svg>`
    }, props, {
        newIcon: $03646f834264250b$var$_subtasks.default
    }));
$03646f834264250b$var$SubtaskIcon.displayName = 'SubtaskIcon';
var $03646f834264250b$var$_default = module.exports.default = $03646f834264250b$var$SubtaskIcon;

});

parcelRegister("hrjFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4efd6a31187219$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d89330a12e304d1decdadfb7c7a699ca>>
 * @relayHash 93c0d8d16c4e77e0b03ed1162c0f98a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c
const $fa4efd6a31187219$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraProjectIds"
    }, v3 = {
        "kind": "Literal",
        "name": "filter",
        "value": [
            "RELEASED",
            "UNRELEASED"
        ]
    }, v4 = {
        "kind": "Variable",
        "name": "jiraProjectIds",
        "variableName": "jiraProjectIds"
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "versionsForProjects",
                                    "args": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionMenu_softwareBacklog_VersionMenuContent"
                                                    },
                                                    v5 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v6 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProjects.edges"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProjects"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "versionMenuQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "versionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "status"
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                        },
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v9 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "filters": [
                                "jiraProjectIds",
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "versionBacklogPanelRelay_versionsForProjects",
                            "kind": "LinkedHandle",
                            "name": "versionsForProjects"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "versionsForProjects"
                        ]
                    }
                ]
            },
            "name": "versionMenuQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa4efd6a31187219$var$node.hash = "ad42f90f36561f245c5fce9acfe51923";
var $fa4efd6a31187219$export$2e2bcd8739ae039 = $fa4efd6a31187219$var$node;

});

const $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9 = 32;
const $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77 = 5;
const $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9 = 300;
const $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50 = 200;
const $d9cdb1c71f9dbf8c$export$bb89c9064245f005 = 500;
const $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9 = 'software-context-menu.ui.context-menu-inner.context-menu-inner-container';
const $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-submenu';
const $d9cdb1c71f9dbf8c$export$ef86d72244e00c00 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.chevron-icon';
const $d9cdb1c71f9dbf8c$export$8e765acf3440e0b = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-item';
const $d9cdb1c71f9dbf8c$export$75f77b2251314894 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.overflow-visible-popup-container';
const $d9cdb1c71f9dbf8c$export$602eb83148423ac6 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.tooltip';
const $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.context-menu-label';
const $d9cdb1c71f9dbf8c$export$90350df905144507 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search';
const $d9cdb1c71f9dbf8c$export$328d05d650390cfd = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.content';
const $d9cdb1c71f9dbf8c$export$1245780b529c0d82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.loading';
const $d9cdb1c71f9dbf8c$export$803f51dcf576f554 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.no-results';
const $d9cdb1c71f9dbf8c$export$bb79bd28759ee895 = 'context';
const $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b = 'meatball';

parcelRegister("d9htP", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $31c28be4e7773897$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");


var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4tD4f = parcelRequire("4tD4f");


var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $eoB0b = parcelRequire("eoB0b");

var $fSgHa = parcelRequire("fSgHa");

var $7IKPD = parcelRequire("7IKPD");

var $1UfRw = parcelRequire("1UfRw");

var $9nlJl = parcelRequire("9nlJl");

var $iaKyE = parcelRequire("iaKyE");

var $18PeT = parcelRequire("18PeT");

var $hksaN = parcelRequire("hksaN");

var $7MVky = parcelRequire("7MVky");

var $iTQ6G = parcelRequire("iTQ6G");

var $1otSd = parcelRequire("1otSd");

var $bEQvq = parcelRequire("bEQvq");

var $4AddN = parcelRequire("4AddN");

var $5lrV3 = parcelRequire("5lrV3");

var $02921 = parcelRequire("02921");

var $hgBx0 = parcelRequire("hgBx0");

var $7sDhu = parcelRequire("7sDhu");

var $ekjae = parcelRequire("ekjae");

var $ct9uH = parcelRequire("ct9uH");

var $9ZFOK = parcelRequire("9ZFOK");

var $chkmj = parcelRequire("chkmj");

var $5Mhvq = parcelRequire("5Mhvq");

var $jN95k = parcelRequire("jN95k");
const $31c28be4e7773897$export$88a94aa401c6dbd6 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const priority = (0, $7sDhu.usePriority)({
        selectedCardIds: selectedCardIds
    });
    const assignee = (0, $iaKyE.useAssignee)({
        selectedCardIds: selectedCardIds
    });
    const estimate = (0, $iTQ6G.useEstimate)({
        selectedCardIds: selectedCardIds
    });
    const parent = (0, $02921.useParent)(selectedCardIds);
    const version = (0, $9ZFOK.useVersion)({
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const isWithinIssueLimit = selectedCardIds.length <= (0, $e6c5355277661284$export$d05ca0d31d3ffa06);
    return isWithinIssueLimit ? [
        ...assignee,
        ...priority,
        ...version,
        ...parent,
        ...!isCompanyManaged ? estimate : []
    ] : [];
};
const $31c28be4e7773897$export$c087a1fcddb96d21 = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const cardIds = (0, $5uXOq.useMemo)(()=>selectedCardIds.includes(issueId) ? selectedCardIds : [
            issueId
        ], [
        issueId,
        selectedCardIds
    ]);
    const isMultiSelect = cardIds?.length > 1;
    const subtasksWithoutParentsAreSelected = (0, $jN95k.default)(cardIds);
    const header = (0, $4AddN.useHeader)({
        selectedCardIds: cardIds
    });
    const moveToActions = (0, $5lrV3.useMoveTo)({
        issueId: issueId,
        cardIds: cardIds,
        hide: subtasksWithoutParentsAreSelected
    });
    const flag = (0, $1otSd.useFlag)({
        cardIds: cardIds
    });
    const splitIssue = (0, $ct9uH.useSplitIssue)({
        issueId: issueId,
        isMultiSelect: isMultiSelect
    });
    const deleteIssue = (0, $7MVky.useDeleteIssue)({
        issueId: issueId,
        selectedCardIds: cardIds
    });
    const copyIssueLink = (0, $hksaN.useCopyIssueLink)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const copyIssueKey = (0, $18PeT.useCopyIssueKey)({
        selectedCardIds: cardIds,
        issueKey: issueKey
    });
    const viewInIssueSearch = (0, $chkmj.useViewInIssueSearch)({
        selectedCardIds: cardIds
    });
    const gotoBulkEditor = (0, $bEQvq.useGoToBulkEditor)({
        selectedCardIds: cardIds
    });
    const fieldBulkOperations = $31c28be4e7773897$export$88a94aa401c6dbd6({
        selectedCardIds: cardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    // Check if the user is eligible for whiteboard entrypoint experiment and render the plan on whiteboard CTA below the moveTo button before the separator
    const { cohort: cohort, flow: flow } = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getWhiteboardEligibility));
    const planOnWhiteboard = (0, $hgBx0.usePlanOnWhiteboard)({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        flow: flow
    });
    if (flow && cohort === (0, $7IKPD.WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS).CONTEXT_MENU) moveToActions.push(...planOnWhiteboard);
    const moveTo = moveToActions.length ? [
        ...moveToActions,
        (0, $ekjae.createSeparator)('move-to-actions')
    ] : [];
    const bulkActions = [
        ...flag,
        ...fieldBulkOperations,
        ...splitIssue
    ];
    const otherActions = [
        ...copyIssueLink,
        ...copyIssueKey,
        ...viewInIssueSearch
    ];
    const deleteAndBulkEditorActions = gotoBulkEditor.length || deleteIssue.length ? [
        (0, $ekjae.createSeparator)('delete-and-bulk-editor-actions'),
        ...gotoBulkEditor,
        ...deleteIssue
    ] : [];
    return [
        ...header,
        ...moveTo,
        ...otherActions,
        ...bulkActions.length ? [
            (0, $ekjae.createSeparator)('bulk-actions'),
            ...bulkActions
        ] : [],
        ...deleteAndBulkEditorActions
    ];
};
const $31c28be4e7773897$var$MenuRendererWithMenuItems = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, scope: scope, triggerRef: triggerRef, versionMenuQueryRef: versionMenuQueryRef })=>{
    const menuItems = $31c28be4e7773897$export$c087a1fcddb96d21({
        issueId: issueId,
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        versionMenuQueryRef: versionMenuQueryRef
    });
    return(// Prevents drag events being propogated to the parent card
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UfRw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMenuRenderer), {
        scope: scope,
        menuItems: menuItems,
        triggerRef: triggerRef
    })));
});
const $31c28be4e7773897$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, appearance: appearance, versionMenuQueryRef: versionMenuQueryRef } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const triggerRef = 'triggerRef' in props ? props.triggerRef : null;
    const renderMenu = (0, $5uXOq.useCallback)((scope, menuTriggerRef)=>{
        if (triggerRef && menuTriggerRef?.current) triggerRef.current = menuTriggerRef.current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c28be4e7773897$var$MenuRendererWithMenuItems, {
            issueId: issueId,
            issueKey: issueKey,
            selectedCardIds: selectedCardIds,
            versionMenuQueryRef: versionMenuQueryRef,
            scope: scope,
            triggerRef: menuTriggerRef
        });
    }, [
        triggerRef,
        issueId,
        issueKey,
        selectedCardIds,
        versionMenuQueryRef
    ]);
    const handleEscape = (e)=>{
        // this is to prevent the escape key from closing the issue view
        if (e.key === 'Escape') {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.activeElement instanceof HTMLElement) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.activeElement.blur();
        }
    };
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895)) {
        const { children: children } = props;
        return(// disabling the eslint rule since it asks us to turn this into a button which does not fit our use case
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            onKeyDown: handleEscape,
            "data-testid": (0, $9nlJl.ESCAPE_WRAPPER_TESTID),
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncContextMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $9nlJl.ANALYTICS_MAPPING_TABLE),
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardContextMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        }, children)));
    }
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
        const { summary: summary, onOpenChange: onOpenChange } = props;
        const getAriaLabelMessage = ()=>{
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return formatMessage(selectedCardIds.length > 1 ? (0, $5Mhvq.default).menuTriggerMoreCardsIssueTermRefresh : (0, $5Mhvq.default).menuTriggerOneCardIssueTermRefresh, {
                summary: summary,
                issueKey: issueKey
            });
            return formatMessage(selectedCardIds.length > 1 ? (0, $5Mhvq.default).menuTriggerMoreCards : (0, $5Mhvq.default).menuTriggerOneCard, {
                summary: summary,
                issueKey: issueKey
            });
        };
        const ariaLabelMessage = getAriaLabelMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMeatballMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            onOpenChange: onOpenChange,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            analyticsMapping: (0, $9nlJl.ANALYTICS_MAPPING_TABLE),
            ariaLabel: ariaLabelMessage,
            isCompact: showCompactMode,
            jsErrorBoundaryProps: {
                id: 'backlogCardListCardMeatballMenu',
                packageName: 'software-backlog',
                teamName: 'a4t-tanuki'
            }
        });
    }
    return null;
});

});
const $e6c5355277661284$export$d05ca0d31d3ffa06 = 50; // backlog contextual menu still depends on this constant
const $e6c5355277661284$export$45a421fb1ade804f = 1000;
const $e6c5355277661284$export$71fcb0373c771639 = 'bulk-operations-core.ui.form.form-wrapper';
const $e6c5355277661284$export$39f1bbbd67c1f72 = 'bulk-operations-core.common.ui.view-footer.cancel-button';
const $e6c5355277661284$export$a350e08f5290ad98 = 'bulk-operations-core.common.ui.view-footer.back-button';
const $e6c5355277661284$export$256c8e48a4b7d900 = 'bulk-operations-core.common.ui.view-footer.next-button';
const $e6c5355277661284$export$9554e5be9bf7faaf = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-fields';
const $e6c5355277661284$export$3f974d81b7882abc = 'bulk-operations-core.ui.toolbar.edit-dropdown.menu.edit-status';
const $e6c5355277661284$export$3d1cf6035bb6e5e6 = 40;
const $e6c5355277661284$export$2bf1ff09810ebfaa = 50;

parcelRegister("4tD4f", function(module, exports) {

$parcel$export(module.exports, "AsyncContextMenu", () => $65fdd06020fea880$export$88c73a5747b508c6);
$parcel$export(module.exports, "AsyncMeatballMenu", () => $65fdd06020fea880$export$dad57d856f7c40e9);
$parcel$export(module.exports, "AsyncMenuRenderer", () => $65fdd06020fea880$export$481d980aecfdabe6);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $h9HNs = parcelRequire("h9HNs");

var $c1wAv = parcelRequire("c1wAv");

var $g5XcP = parcelRequire("g5XcP");

var $6GBq8 = parcelRequire("6GBq8");

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$ContextMenuLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("7xhPS")).then((module)=>module.ContextMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$MeatballMenuLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("7xhPS")).then((module)=>module.MeatballMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/index.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$AsyncMenuRendererLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("lPNYh")).then((module)=>module.MenuRenderer), {
    moduleId: "./src/packages/software/context-menu/src/ui/menu-renderer/index.tsx"
});
const $65fdd06020fea880$var$InternalAsyncContextMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$ContextMenuLazy, props));
const $65fdd06020fea880$var$InternalAsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$MeatballMenuLazy, props));
const $65fdd06020fea880$export$88c73a5747b508c6 = (props)=>{
    const openContextMenuRef = (0, $5uXOq.useRef)(null);
    const childrenRef = (0, $5uXOq.useRef)(null);
    const { onContextMenu: onContextMenu } = (0, $g5XcP.useOnContextMenu)({
        childrenRef: childrenRef,
        openContextMenuRef: openContextMenuRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wAv.ChildrenWrapperWithAnalytics), {
        onChildrenContextMenu: onContextMenu,
        ref: childrenRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncContextMenu, {
        ...props,
        openContextMenuRef: openContextMenuRef
    })));
};
const $65fdd06020fea880$export$dad57d856f7c40e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu-meatball-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncMeatballMenu, props));
const $65fdd06020fea880$export$481d980aecfdabe6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-menu-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GBq8.MenuRendererPlaceholder), {
            menuItems: props.menuItems
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$AsyncMenuRendererLazy, props));

});
parcelRegister("h9HNs", function(module, exports) {

$parcel$export(module.exports, "ContextMenuErrorBoundary", () => $0bf642946ee45d6d$export$9253ba2022568501);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");
const $0bf642946ee45d6d$export$9253ba2022568501 = ({ id: id, children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: "jiraSoftwareContextMenu",
        fallback: fallback || 'unmount',
        teamName: "deliveroo"
    }, children);

});

parcelRegister("c1wAv", function(module, exports) {

$parcel$export(module.exports, "ChildrenWrapperWithAnalytics", () => $5fcbc6bc21c0dd31$export$1249ce36e893a19b);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");

const $5fcbc6bc21c0dd31$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'opened'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    })));
const $5fcbc6bc21c0dd31$export$1249ce36e893a19b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onChildrenContextMenu: onChildrenContextMenu }, ref)=>{
    const WrapperWithAnalyticsComponent = $5fcbc6bc21c0dd31$var$WrapperWithAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            inputSource: 'rightClick'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperWithAnalyticsComponent, {
        ref: ref,
        onContextMenu: onChildrenContextMenu,
        "data-testid": (0, $c261fa84ee29a782$export$1790245723dd00ad)
    }, children));
});

});
const $c261fa84ee29a782$export$1790245723dd00ad = 'software-context-menu.ui.context-menu.children-wrapper';


parcelRegister("g5XcP", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $f82fb67b9a97c056$export$ca7798d25343efd8);

var $jcw0u = parcelRequire("jcw0u");

var $7D59a = parcelRequire("7D59a");
const $f82fb67b9a97c056$export$ca7798d25343efd8 = ({ childrenRef: childrenRef, openContextMenuRef: openContextMenuRef })=>{
    const onContextMenu = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.stopPropagation();
        if (!childrenRef?.current || !openContextMenuRef?.current) {
            !childrenRef?.current && (0, $jcw0u.default)({
                error: new Error('Trying to open a context menu while childrenRef is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        e.preventDefault();
        const { top: top, left: left } = childrenRef.current.getBoundingClientRect();
        const position = {
            x: e.clientX - left,
            y: e.clientY - top
        };
        openContextMenuRef.current.onOpenContextMenu({
            position: position,
            analyticsEvent: analyticsEvent
        });
    });
    return {
        onContextMenu: onContextMenu
    };
};

});

parcelRegister("6GBq8", function(module, exports) {

$parcel$export(module.exports, "MenuRendererPlaceholder", () => $03bf8ee5a763f135$export$9c3503516e6b2b03);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $9MjbF = parcelRequire("9MjbF");

var $1HF4Y = parcelRequire("1HF4Y");

var $6ssLS = parcelRequire("6ssLS");

var $clxlA = parcelRequire("clxlA");
const $03bf8ee5a763f135$export$b12353dcfd2c40d3 = (menuItems)=>menuItems.reduce((acc, menuItem)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Separator) return acc + $clxlA.SEPARATOR_PLACEHOLDER_HEIGHT;
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Section) return acc + $clxlA.SECTION_HEADER_PLACEHOLDER_HEIGHT + $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItem.children || []);
        return acc + $clxlA.MENU_ITEM_PLACEHOLDER_HEIGHT;
    }, 0);
const $03bf8ee5a763f135$export$9c3503516e6b2b03 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuItems: menuItems })=>{
    const height = $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$Container, {
        "data-testid": $clxlA.CONTEXT_MENU_PLACEHOLDER_TESTID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$InnerItems, {
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
        size: "medium"
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03bf8ee5a763f135$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $03bf8ee5a763f135$var$InnerItems = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1HF4Y", function(module, exports) {

$parcel$export(module.exports, "MenuNodeType", () => $8e9d98803c1f1230$export$d6a3c2c57b227e3b);
const $8e9d98803c1f1230$export$d6a3c2c57b227e3b = {
    Item: 'item',
    Node: 'node',
    Separator: 'separator',
    Section: 'section',
    Search: 'search',
    BulkIndicator: 'bulkIndicator'
};

});

parcelRegister("6ssLS", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $c700ae4c66d12196$export$b286f91cddfedb5a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c700ae4c66d12196$export$b286f91cddfedb5a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9uuw1 _c71ldgin _1yt4swc3 _2rko1l7b _vchhusvi _11q71bhr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("clxlA", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_MENU_PLACEHOLDER_TESTID", () => $be0729fb178ee569$export$d0775d7ba1f28e6);
$parcel$export(module.exports, "SEPARATOR_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$49b3e4b8a0edc9b7);
$parcel$export(module.exports, "SECTION_HEADER_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$71999dec35730ebd);
$parcel$export(module.exports, "MENU_ITEM_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$f9717b5566f9ac9f);

var $gwIPs = parcelRequire("gwIPs");

const $be0729fb178ee569$export$d0775d7ba1f28e6 = 'software-context-menu.ui.menu-renderer-placeholder';
const $be0729fb178ee569$export$49b3e4b8a0edc9b7 = (0, $gwIPs.gridSize) + 1;
const $be0729fb178ee569$export$71999dec35730ebd = (0, $gwIPs.gridSize) * 2;
const $be0729fb178ee569$export$f9717b5566f9ac9f = (0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9);

});


parcelRegister("7xhPS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hsIMW").then(()=>parcelRequire('c0JwO'));

});

parcelRegister("lPNYh", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5r9EF").then(()=>parcelRequire('6hc7I'));

});


parcelRegister("1UfRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a09dc1dca19ef4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $e4a09dc1dca19ef4$var$stopDrag = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Prevents `dragstart` events from within child elements from bubbling
 */ const $e4a09dc1dca19ef4$var$BlockDrag = ({ children: children })=>// Need to mark this as `draggable` in order for `onDragStart`
    // to fire when attempting to drag child elements
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        draggable: true,
        onDragStart: $e4a09dc1dca19ef4$var$stopDrag
    }, children);
var $e4a09dc1dca19ef4$export$2e2bcd8739ae039 = $e4a09dc1dca19ef4$var$BlockDrag;

});

parcelRegister("9nlJl", function(module, exports) {

$parcel$export(module.exports, "MOVE_TO_MENU_ID", () => $fafb6f2662f0482c$export$5645be38d58b5483);
$parcel$export(module.exports, "MOVE_TO_TOP_OF_BACKLOG_MENU_ID", () => $fafb6f2662f0482c$export$13ba6c00d633f348);
$parcel$export(module.exports, "MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID", () => $fafb6f2662f0482c$export$319beca788666a0d);
$parcel$export(module.exports, "MOVE_TO_BOARD_MENU_ID", () => $fafb6f2662f0482c$export$4afa86666270dba0);
$parcel$export(module.exports, "MOVE_TO_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$b54531036348079);
$parcel$export(module.exports, "RANK_MENU_UP_ID", () => $fafb6f2662f0482c$export$10226786f3562a0a);
$parcel$export(module.exports, "RANK_MENU_DOWN_ID", () => $fafb6f2662f0482c$export$ff981f621183205f);
$parcel$export(module.exports, "FLAG_MENU_ID", () => $fafb6f2662f0482c$export$63cb4152f50d2665);
$parcel$export(module.exports, "FLAG_ADD_FLAG_MENU_ID", () => $fafb6f2662f0482c$export$efe455e4d4b4aca9);
$parcel$export(module.exports, "FLAG_REMOVE_FLAG_MENU_ID", () => $fafb6f2662f0482c$export$356329b49381740c);
$parcel$export(module.exports, "COPY_ISSUE_LINK_MENU_ID", () => $fafb6f2662f0482c$export$34b38d58090a7162);
$parcel$export(module.exports, "COPY_ISSUE_KEY_MENU_ID", () => $fafb6f2662f0482c$export$2e74ac183d49087);
$parcel$export(module.exports, "HEADER_BULK_INDICATOR_MENU_ID", () => $fafb6f2662f0482c$export$bdfa217711a39d8d);
$parcel$export(module.exports, "VIEW_IN_ISSUE_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$4231ab934953c1bc);
$parcel$export(module.exports, "SPLIT_ISSUE_MENU_ID", () => $fafb6f2662f0482c$export$b7bce247cd0b2a49);
$parcel$export(module.exports, "DELETE_ISSUE_MENU_ID", () => $fafb6f2662f0482c$export$b35363b92f22bb89);
$parcel$export(module.exports, "SEPARATOR_MENU_ID", () => $fafb6f2662f0482c$export$1fa1533b8d6efd51);
$parcel$export(module.exports, "STORY_POINTS_MENU_ID", () => $fafb6f2662f0482c$export$38cc7f6fd54f040a);
$parcel$export(module.exports, "STORY_POINTS_EDIT_MENU_ID", () => $fafb6f2662f0482c$export$d913180634f6bb7a);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_MENU_ID", () => $fafb6f2662f0482c$export$f44075570bbdc5a9);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_EDIT_MENU_ID", () => $fafb6f2662f0482c$export$e7a2177d793805f9);
$parcel$export(module.exports, "PARENT_MENU_ID", () => $fafb6f2662f0482c$export$744dc4889ca2fd20);
$parcel$export(module.exports, "PARENT_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$21f306406b358f4f);
$parcel$export(module.exports, "VERSION_MENU_ID", () => $fafb6f2662f0482c$export$bd3b3ff7a0a9e25a);
$parcel$export(module.exports, "PRIORITY_MENU_ID", () => $fafb6f2662f0482c$export$203cb0fa00d01abe);
$parcel$export(module.exports, "ASSIGNEE_MENU_ID", () => $fafb6f2662f0482c$export$c3421a7192b5f002);
$parcel$export(module.exports, "ASSIGNEE_SEARCH_MENU_ID", () => $fafb6f2662f0482c$export$ddf4731675705ca4);
$parcel$export(module.exports, "GO_TO_BULK_EDITOR_MENU_ID", () => $fafb6f2662f0482c$export$109f329d0ffd3326);
$parcel$export(module.exports, "PLAN_ON_WHITEBOARD_MENU_ID", () => $fafb6f2662f0482c$export$b7344797d0384ac5);
$parcel$export(module.exports, "ANALYTICS_MAPPING_TABLE", () => $fafb6f2662f0482c$export$77ab83fd54e2c3c);
$parcel$export(module.exports, "ESCAPE_WRAPPER_TESTID", () => $fafb6f2662f0482c$export$341cb34540d073ad);

var $5fc53 = parcelRequire("5fc53");
const $fafb6f2662f0482c$export$5645be38d58b5483 = 'actions/move-to';
const $fafb6f2662f0482c$export$13ba6c00d633f348 = 'actions/move-to/top-of-backlog';
const $fafb6f2662f0482c$export$319beca788666a0d = 'actions/move-to/bottom-of-backlog';
const $fafb6f2662f0482c$export$4afa86666270dba0 = 'actions/move-to/board';
const $fafb6f2662f0482c$export$b54531036348079 = 'actions/move-to/search';
const $fafb6f2662f0482c$export$10226786f3562a0a = 'actions/move-to/rank-up';
const $fafb6f2662f0482c$export$ff981f621183205f = 'actions/move-to/rank-down';
const $fafb6f2662f0482c$export$63cb4152f50d2665 = 'actions/flag';
const $fafb6f2662f0482c$export$efe455e4d4b4aca9 = 'actions/flag/add-flag';
const $fafb6f2662f0482c$export$356329b49381740c = 'actions/flag/remove-flag';
const $fafb6f2662f0482c$export$34b38d58090a7162 = 'actions/copy-issue-link';
const $fafb6f2662f0482c$export$2e74ac183d49087 = 'actions/copy-issue-key';
const $fafb6f2662f0482c$export$bdfa217711a39d8d = 'bulk-indicator';
const $fafb6f2662f0482c$export$4231ab934953c1bc = 'actions/view-in-issue-search';
const $fafb6f2662f0482c$export$b7bce247cd0b2a49 = 'actions/split-issue';
const $fafb6f2662f0482c$export$b35363b92f22bb89 = 'actions/delete-issue';
const $fafb6f2662f0482c$export$1fa1533b8d6efd51 = 'separator';
const $fafb6f2662f0482c$export$38cc7f6fd54f040a = 'actions/story-point';
const $fafb6f2662f0482c$export$d913180634f6bb7a = 'actions/story-point/edit';
const $fafb6f2662f0482c$export$f44075570bbdc5a9 = 'actions/original-estimate';
const $fafb6f2662f0482c$export$e7a2177d793805f9 = 'actions/original-estimate/edit';
const $fafb6f2662f0482c$export$744dc4889ca2fd20 = 'actions/parent';
const $fafb6f2662f0482c$export$21f306406b358f4f = 'actions/parent/search';
const $fafb6f2662f0482c$export$bd3b3ff7a0a9e25a = 'actions/version';
const $fafb6f2662f0482c$export$203cb0fa00d01abe = 'actions/priority';
const $fafb6f2662f0482c$export$c3421a7192b5f002 = 'actions/assignee';
const $fafb6f2662f0482c$export$ddf4731675705ca4 = 'actions/assignee/search';
const $fafb6f2662f0482c$export$109f329d0ffd3326 = 'actions/go-to-bulk-editor';
const $fafb6f2662f0482c$export$b7344797d0384ac5 = 'actions/plan-on-whiteboard';
const $fafb6f2662f0482c$export$95244264c7c3e7b5 = {
    attributes: {
        actionGroup: 'move'
    }
};
const $fafb6f2662f0482c$export$e4c12f391981e0cf = {
    attributes: {
        actionGroup: 'update'
    }
};
const $fafb6f2662f0482c$export$77ab83fd54e2c3c = {
    [$fafb6f2662f0482c$export$5645be38d58b5483]: {
        actionSubjectId: 'moveToSprintDropdownItem',
        ...$fafb6f2662f0482c$export$95244264c7c3e7b5
    },
    [$fafb6f2662f0482c$export$13ba6c00d633f348]: {
        actionSubjectId: 'moveToTopBacklogDropdownItem',
        ...$fafb6f2662f0482c$export$95244264c7c3e7b5
    },
    [$fafb6f2662f0482c$export$319beca788666a0d]: {
        actionSubjectId: 'moveToBottomBacklogDropdownItem',
        ...$fafb6f2662f0482c$export$95244264c7c3e7b5
    },
    [$fafb6f2662f0482c$export$4afa86666270dba0]: {
        actionSubjectId: 'moveToBoardDropdownItem',
        ...$fafb6f2662f0482c$export$95244264c7c3e7b5
    },
    [$fafb6f2662f0482c$export$efe455e4d4b4aca9]: {
        actionSubjectId: 'addFlagDropdownItem',
        ...$fafb6f2662f0482c$export$e4c12f391981e0cf
    },
    [$fafb6f2662f0482c$export$356329b49381740c]: {
        actionSubjectId: 'removeFlagDropdownItem',
        ...$fafb6f2662f0482c$export$e4c12f391981e0cf
    },
    [$fafb6f2662f0482c$export$4231ab934953c1bc]: 'viewIssueSearchDropdownItem',
    [$fafb6f2662f0482c$export$109f329d0ffd3326]: 'goToBulkEditorDropdownItem',
    [$fafb6f2662f0482c$export$b7bce247cd0b2a49]: 'splitIssueDropdownItem',
    [$fafb6f2662f0482c$export$b35363b92f22bb89]: 'deleteDropdownItem',
    [$fafb6f2662f0482c$export$34b38d58090a7162]: 'copyIssueLink',
    [$fafb6f2662f0482c$export$2e74ac183d49087]: 'copyIssueKey',
    [$fafb6f2662f0482c$export$d913180634f6bb7a]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$export$e4c12f391981e0cf.attributes,
            fieldKey: 'storyPointEstimate'
        }
    },
    [$fafb6f2662f0482c$export$e7a2177d793805f9]: {
        actionSubjectId: 'updateEstimateDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $5fc53.TIME_ESTIMATE_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$c3421a7192b5f002]: {
        actionSubjectId: 'updateAssigneeDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $5fc53.ASSIGNEE_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$203cb0fa00d01abe]: {
        actionSubjectId: 'updatePriorityDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $5fc53.PRIORITY_TYPE)
        }
    },
    [$fafb6f2662f0482c$export$744dc4889ca2fd20]: {
        actionSubjectId: 'updateParentDropdownItem',
        attributes: {
            ...$fafb6f2662f0482c$export$e4c12f391981e0cf.attributes,
            fieldKey: (0, $5fc53.PARENT_TYPE)
        }
    }
};
const $fafb6f2662f0482c$export$341cb34540d073ad = 'software-backlog.card-list.card.context-menu.escape-wrapper';

});

parcelRegister("iaKyE", function(module, exports) {

$parcel$export(module.exports, "useAssignee", () => $ec4bf711ffbd69d1$export$db27ad834dc313f2);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $dWTaZ = parcelRequire("dWTaZ");

var $7f4tk = parcelRequire("7f4tk");

var $koVbs = parcelRequire("koVbs");

var $aWse0 = parcelRequire("aWse0");


var $fhSLy = parcelRequire("fhSLy");

var $1HF4Y = parcelRequire("1HF4Y");

var $leRCk = parcelRequire("leRCk");

var $c1MAf = parcelRequire("c1MAf");

var $2HxVZ = parcelRequire("2HxVZ");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $ec4bf711ffbd69d1$export$f3d2344ae01372eb = ({ options: options, isLoading: isLoading, canAssign: canAssign, setQuery: setQuery })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canAssign ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).assignee),
            id: (0, $9nlJl.ASSIGNEE_MENU_ID),
            submenuWidth: 284,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Search,
                    id: (0, $9nlJl.ASSIGNEE_SEARCH_MENU_ID),
                    children: options,
                    hasSearch: true,
                    isAsyncSearch: true,
                    isLoading: isLoading,
                    onChange: (value)=>setQuery(value),
                    ariaLabel: formatMessage((0, $5Mhvq.default).ariaLabel)
                }
            ]
        }
    ] : [];
};
const $ec4bf711ffbd69d1$export$db27ad834dc313f2 = ({ selectedCardIds: selectedCardIds })=>{
    const intl = (0, $aWse0.useIntlV2)(); // used to obtain unassigned and automatic user options
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [assignees, setAssignees] = (0, $5uXOq.useState)([]);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [query, setQuery] = (0, $5uXOq.useState)('');
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const unassigned = (0, $5uXOq.useMemo)(()=>(0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getUnassignedUser)(intl)), [
        intl
    ]);
    const automatic = (0, $5uXOq.useMemo)(()=>(0, $fhSLy.getUserOptionFromUser)((0, $fhSLy.getAutomaticUserOption)(intl)), [
        intl
    ]);
    const assignToMe = (0, $5uXOq.useMemo)(()=>loggedInUser ? (0, $fhSLy.getUserOptionFromUser)({
            ...loggedInUser,
            displayName: formatMessage((0, $5Mhvq.default).assignToMe)
        }) : null, [
        formatMessage,
        loggedInUser
    ]);
    const defaultOptions = (0, $5uXOq.useMemo)(()=>[
            unassigned,
            automatic,
            ...assignToMe ? [
                assignToMe
            ] : []
        ], [
        assignToMe,
        automatic,
        unassigned
    ]);
    const onAssigneeClick = (0, $c1MAf.useBacklogActionCreator)((assignee, analyticsEvent)=>(0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $2HxVZ.cardAssigneeSetOptimistic)({
                cardId: id,
                assignee: assignee.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? null : {
                    avatarUrl: assignee.avatarUrl,
                    displayName: assignee.name,
                    id: assignee.id
                }
            }, getIssueKey(id), analyticsEvent))));
    const fetchUsers = (keywords)=>(0, $7f4tk.default)(`/rest/api/2/user/search?query=${keywords}`);
    (0, $5uXOq.useEffect)(()=>{
        const handleSearch = async (value)=>{
            setIsLoading(true);
            try {
                const response = await fetchUsers(value);
                setAssignees(response.length ? response.map((0, $fhSLy.getUserOptionFromUser)) : []);
            } catch  {
                setAssignees(defaultOptions);
            }
            setIsLoading(false);
        };
        if (query.length) handleSearch(query);
        else setAssignees(defaultOptions);
    }, [
        query,
        defaultOptions
    ]);
    const options = (0, $5uXOq.useMemo)(()=>assignees.map((assignee)=>({
                type: (0, $1HF4Y.MenuNodeType).Item,
                label: assignee.name,
                id: `${0, $9nlJl.ASSIGNEE_MENU_ID}__value_${assignee.id}`,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
                    src: assignee.avatarUrl,
                    size: "small"
                }),
                onClick: (analyticsEvent)=>onAssigneeClick(assignee, analyticsEvent)
            })), [
        assignees,
        onAssigneeClick
    ]);
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canAssignIssue = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canAssignIssues));
    const canAssign = canAssignIssue && canBulkEdit;
    return $ec4bf711ffbd69d1$export$f3d2344ae01372eb({
        options: options,
        isLoading: isLoading,
        canAssign: canAssign,
        setQuery: setQuery
    });
};

});
parcelRegister("5Mhvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f746ba74f8a38cfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f746ba74f8a38cfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveTo: {
        "id": "backlog.card-list.card.context-menu.move-to",
        "defaultMessage": "Move to"
    },
    topOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.top-of-the-backlog",
        "defaultMessage": "Top of backlog"
    },
    bottomOfTheBacklog: {
        "id": "backlog.card-list.card.context-menu.bottom-of-the-backlog",
        "defaultMessage": "Bottom of backlog"
    },
    board: {
        "id": "backlog.card-list.card.context-menu.board",
        "defaultMessage": "Board"
    },
    delete: {
        "id": "backlog.card-list.card.context-menu.delete",
        "defaultMessage": "Delete"
    },
    archive: {
        "id": "backlog.card-list.card.context-menu.archive",
        "defaultMessage": "Archive"
    },
    flag: {
        "id": "backlog.card-list.card.context-menu.flag",
        "defaultMessage": "Flag"
    },
    addFlag: {
        "id": "backlog.card-list.card.context-menu.add-flag",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "backlog.card-list.card.context-menu.remove-flag",
        "defaultMessage": "Remove flag"
    },
    copyIssueLink: {
        "id": "backlog.card-list.card.context-menu.copy-issue-link",
        "defaultMessage": "Copy issue link"
    },
    copyIssueKey: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key",
        "defaultMessage": "Copy issue key"
    },
    viewInIssueSearch: {
        "id": "backlog.card-list.card.context-menu.view-in-issue-search",
        "defaultMessage": "View in issue search"
    },
    splitIssue: {
        "id": "backlog.card-list.card.context-menu.split-issue",
        "defaultMessage": "Split issue"
    },
    addIssueParent: {
        "id": "backlog.card-list.card.context-menu.add-issue-parent",
        "defaultMessage": "Add parent"
    },
    changeIssueParent: {
        "id": "backlog.card-list.card.context-menu.change-issue-parent",
        "defaultMessage": "Change parent"
    },
    parentOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-option-label",
        "defaultMessage": "Parent"
    },
    parentUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.parent-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    versionOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-option-label",
        "defaultMessage": "Version"
    },
    versionUnlinkOptionLabel: {
        "id": "backlog.card-list.card.context-menu.version-unlink-option-label",
        "defaultMessage": "Unlink"
    },
    originalEstimate: {
        "id": "backlog.card-list.card.context-menu.original-estimate",
        "defaultMessage": "Original estimate"
    },
    storyPointEstimate: {
        "id": "backlog.card-list.card.context-menu.story-point-estimate",
        "defaultMessage": "Story point estimate"
    },
    priority: {
        "id": "backlog.card-list.card.context-menu.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "backlog.card-list.card.context-menu.assignee",
        "defaultMessage": "Assignee"
    },
    assignToMe: {
        "id": "backlog.card-list.card.context-menu.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    bulkChange: {
        "id": "backlog.card-list.card.context-menu.bulk-change",
        "defaultMessage": "Bulk change"
    },
    goToBulkEditorIconLabel: {
        "id": "backlog.card-list.card.context-menu.go-to-bulk-editor-icon-label",
        "defaultMessage": "Open in new window"
    },
    menuTriggerOneCard: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-one-card",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCards: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-more-cards",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    rankUp: {
        "id": "backlog.card-list.card.context-menu.rank-up",
        "defaultMessage": "Move up"
    },
    rankDown: {
        "id": "backlog.card-list.card.context-menu.rank-down",
        "defaultMessage": "Move down"
    },
    copyIssueKeySuccessTitle: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-title",
        "defaultMessage": "Issue key copied"
    },
    copyIssueKeySuccessDescription: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-description",
        "defaultMessage": "Issue key successfully copied to your clipboard"
    },
    ariaLabel: {
        "id": "backlog.card-list.card.context-menu.aria-label",
        "defaultMessage": "Select assignee"
    },
    sprintSearchPlaceholder: {
        "id": "backlog.card-list.card.context-menu.sprint-search-placeholder",
        "defaultMessage": "Search sprints"
    },
    copyIssueLinkIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-link-issue-term-refresh",
        "defaultMessage": "Copy issue link"
    },
    copyIssueKeyIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-issue-term-refresh",
        "defaultMessage": "Copy issue key"
    },
    viewInIssueSearchIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.view-in-issue-search-issue-term-refresh",
        "defaultMessage": "View in issue search"
    },
    splitIssueIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.split-issue-issue-term-refresh",
        "defaultMessage": "Split issue"
    },
    menuTriggerOneCardIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-one-card-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCardsIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.menu-trigger-more-cards-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    copyIssueKeySuccessTitleIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-title-issue-term-refresh",
        "defaultMessage": "Issue key copied"
    },
    copyIssueKeySuccessDescriptionIssueTermRefresh: {
        "id": "backlog.card-list.card.context-menu.copy-issue-key-success-description-issue-term-refresh",
        "defaultMessage": "Issue key successfully copied to your clipboard"
    }
});

});


parcelRegister("18PeT", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueKey", () => $d14c3528abbda418$export$e5e3fbcc29675793);

var $6s1PB = parcelRequire("6s1PB");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $d14c3528abbda418$export$e5e3fbcc29675793 = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueKey = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(issueKey).then(()=>{
            showFlag({
                type: 'success',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeySuccessTitleIssueTermRefresh : (0, $5Mhvq.default).copyIssueKeySuccessTitle,
                description: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeySuccessDescriptionIssueTermRefresh : (0, $5Mhvq.default).copyIssueKeySuccessDescription
            });
        }).catch(()=>{
            showFlag((0, $467lJ.default).genericError());
        });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueKeyIssueTermRefresh : (0, $5Mhvq.default).copyIssueKey),
            id: (0, $9nlJl.COPY_ISSUE_KEY_MENU_ID),
            onClick: onCopyIssueKey
        }
    ];
};

});

parcelRegister("hksaN", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $24eaec907af0c229$export$8fa8485fafd17cef);

var $6s1PB = parcelRequire("6s1PB");

var $467lJ = parcelRequire("467lJ");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $hv0VS = parcelRequire("hv0VS");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $24eaec907af0c229$export$30a9fe39fb33160d = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
    if (selectedCardIds.length > 1) return [];
    const onCopyIssueLink = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(issueUrl).then(()=>{
            showFlag((0, $hv0VS.showCopySuccessfulFlag)());
        }).catch(()=>{
            showFlag((0, $467lJ.default).genericError());
        });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).copyIssueLinkIssueTermRefresh : (0, $5Mhvq.default).copyIssueLink),
            id: (0, $9nlJl.COPY_ISSUE_LINK_MENU_ID),
            onClick: onCopyIssueLink
        }
    ];
};
const $24eaec907af0c229$export$8fa8485fafd17cef = ({ issueKey: issueKey, selectedCardIds: selectedCardIds })=>$24eaec907af0c229$export$30a9fe39fb33160d({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds
    });

});
parcelRegister("hv0VS", function(module, exports) {

$parcel$export(module.exports, "showCopySuccessfulFlag", () => $5a03dfdd4528d7b4$export$9fd15e3f1d1c1c2a);

var $5uXOq = parcelRequire("5uXOq");

var $feGGA = parcelRequire("feGGA");

var $8oe80 = parcelRequire("8oe80");

var $b6nbP = parcelRequire("b6nbP");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $h8Z4W = parcelRequire("h8Z4W");
const $5a03dfdd4528d7b4$export$9fd15e3f1d1c1c2a = ()=>({
        type: 'success',
        title: (0, $h8Z4W.default).copySuccessTitle,
        description: (0, $h8Z4W.default).copySuccessMessage
    });
const $5a03dfdd4528d7b4$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $feGGA.default));
const $5a03dfdd4528d7b4$export$d3521c5b8d9fbf8d = (props)=>{
    const { issueUrl: issueUrl } = props;
    const baseUrl = '';
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fullIssueUrl = `${window.location.protocol}//${window.location.hostname}${baseUrl}${issueUrl}`;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b6nbP.default), {
        shouldFitContainer: true,
        hideFieldText: true,
        label: "",
        tooltipLabel: "",
        value: fullIssueUrl,
        tooltipDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a03dfdd4528d7b4$var$DropdownItemWithAnalytics, {
        onClick: (e, analyticsEvent)=>{
            // @ts-expect-error Second argument should be of format "actionSubject action"
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dropdownItem', 'copyIssueLink', {
                nextGenProject: true
            });
            showFlag($5a03dfdd4528d7b4$export$9fd15e3f1d1c1c2a());
        }
    }, formatMessage((0, $h8Z4W.default).copyLink)))));
};
var $5a03dfdd4528d7b4$export$2e2bcd8739ae039 = $5a03dfdd4528d7b4$export$d3521c5b8d9fbf8d;

});
parcelRegister("feGGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3706e29c1e2d34bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $oUGyo = parcelRequire("oUGyo");

var $6PItG = parcelRequire("6PItG");

var $eIm7r = parcelRequire("eIm7r");

var $jJ62p = parcelRequire("jJ62p");

var $294ns = parcelRequire("294ns");

var $7jhTK = parcelRequire("7jhTK");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $3706e29c1e2d34bd$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $7jhTK.default)();
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIm7r.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ62p.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $oUGyo.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $3706e29c1e2d34bd$export$2e2bcd8739ae039 = $3706e29c1e2d34bd$var$DropdownMenuItem;

});

parcelRegister("b6nbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75a19e3ebf5c6c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7EEmi = parcelRequire("7EEmi");
class $f75a19e3ebf5c6c9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            className: undefined,
            shouldFitContainer: false,
            hideFieldText: false,
            onCopyClick: undefined,
            onCopyReset: undefined,
            tooltipDelay: undefined,
            remountOnChange: false,
            tooltipDisabled: false
        };
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    render() {
        const { id: id, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, value: value, className: className, shouldFitContainer: shouldFitContainer, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled } = this.props;
        // When the input field holding the copy text is hidden, its value is not set in
        // the input field to avoid it accidentally being included in a selection when the user
        // is copying other content on the page.
        const fieldValue = hideFieldText ? '' : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EEmi.default), {
            id: id,
            label: label,
            tooltipLabel: tooltipLabel,
            tooltipLabelPosition: tooltipLabelPosition,
            tooltipDelay: tooltipDelay,
            remountOnChange: remountOnChange,
            fieldKey: value,
            value: fieldValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText,
            ...this.state,
            onCopyClick: this.onCopyClick,
            innerInputRef: this.onRef,
            tooltipDisabled: tooltipDisabled
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            copied: false,
            copyFailed: false
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyClick = (event, analyticsEvent)=>{
            if (!this.inputTextRef || !this.inputTextRef.current) return;
            this.props.onCopyClick && this.props.onCopyClick(event, analyticsEvent);
            if (this.props.hideFieldText) // For hidden fields, update the input field ref to include the value only after the user
            // has clicked the copy button.
            this.inputTextRef.current.value = this.props.value;
            this.inputTextRef.current.select();
            let success = false;
            try {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                success = document.execCommand('copy');
                this.setState({
                    copied: true
                });
                this.props.onClickChange && this.props.onClickChange(true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                success = false;
            }
            if (!success) this.setState({
                copyFailed: true
            });
            this.timeoutId = setTimeout(()=>{
                this.setState({
                    copied: false,
                    copyFailed: false
                });
                this.props.onCopyReset && this.props.onCopyReset();
            }, 3000);
            if (this.props.onCopyFinish) this.props.onCopyFinish();
        };
        this.onRef = (ref)=>{
            this.inputTextRef = ref;
        };
    }
}

});
parcelRegister("7EEmi", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $4e1842edd397110a$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "default", () => $4e1842edd397110a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8GVAj = parcelRequire("8GVAj");

var $dkQYr = parcelRequire("dkQYr");

var $9KB2r = parcelRequire("9KB2r");

var $MGmIU = parcelRequire("MGmIU");

var $fVAPR = parcelRequire("fVAPR");

var $gwIPs = parcelRequire("gwIPs");

var $4gmb8 = parcelRequire("4gmb8");

var $az4zD = parcelRequire("az4zD");


var $gT8ZY = parcelRequire("gT8ZY");

var $9iXoh = parcelRequire("9iXoh");
class $4e1842edd397110a$export$71579edc8f362e35 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            id: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            className: undefined,
            copyFailed: false,
            shouldFitContainer: false,
            hideFieldText: false,
            tooltipDelay: 100,
            remountOnChange: false
        };
    }
    constructor(props){
        super(props);
        this.textInput = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.props.innerInputRef(this.textInput);
    }
    renderDefaultButton() {
        const { tooltipLabel: tooltipLabel, onCopyClick: onCopyClick } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$export$2d5d2ba3c7c8c40b, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dkQYr))), {
                label: tooltipLabel
            })),
            onClick: onCopyClick
        });
    }
    render() {
        const { id: id, fieldKey: fieldKey, value: value, label: label, tooltipLabel: tooltipLabel, tooltipLabelPosition: tooltipLabelPosition, tooltipDelay: tooltipDelay, remountOnChange: remountOnChange, intl: intl, copied: copied, onCopyClick: onCopyClick, shouldFitContainer: shouldFitContainer, copyFailed: copyFailed, hideFieldText: hideFieldText, tooltipDisabled: tooltipDisabled, ...props } = this.props;
        let actualTooltipLabel = tooltipLabel;
        if (copied) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copied);
        else if (copyFailed) actualTooltipLabel = intl.formatMessage((0, $gT8ZY.default).copyFailed);
        const copyButton = !this.props.children ? null : // @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.cloneElement)((0, $5uXOq.Children).only(this.props.children), {
            onClick: onCopyClick
        });
        return(// @ts-expect-error - TS2741 - Property 'hideFieldText' is missing in type '{ children: Element[]; className: string | undefined; innerInputRef: (arg1: HTMLInputElementRef) => void; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hideFieldText: boolean; }, any>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.Root), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9iXoh.FieldContainer), {
            shouldFitContainer: shouldFitContainer,
            hideFieldText: hideFieldText
        }, label && !hideFieldText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVAPR.FieldLabel), {
            htmlFor: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KB2r.default), {
            "aria-hidden": hideFieldText ? 'true' : undefined,
            key: fieldKey,
            id: id,
            name: (0, $68788ede79b59f1f$export$4f0520e0d7c4c7b0),
            label: label,
            value: value,
            isReadOnly: true,
            ref: this.textInput,
            tabIndex: hideFieldText ? -1 : undefined
        })), tooltipDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e1842edd397110a$var$FlexGrow, null, copyButton || this.renderDefaultButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            tag: "span",
            key: remountOnChange ? actualTooltipLabel : undefined,
            delay: tooltipDelay,
            position: tooltipLabelPosition,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                "aria-live": "assertive"
            }, actualTooltipLabel)
        }, copyButton || this.renderDefaultButton())));
    }
}
var $4e1842edd397110a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4e1842edd397110a$export$71579edc8f362e35);
const $4e1842edd397110a$export$2d5d2ba3c7c8c40b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
        ...props,
        theme: (0, $4gmb8.getTheme)({
            buttonStyles: {
                default: {
                    height: `${(0, $gwIPs.gridSize) * 5}px`,
                    width: `${(0, $gwIPs.gridSize) * 5}px`
                }
            }
        })
    });
$4e1842edd397110a$export$2d5d2ba3c7c8c40b.displayName = 'StyledButton'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0t94y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e1842edd397110a$var$FlexGrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dkQYr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b563c24f890f84e$var$_react = $9b563c24f890f84e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $9b563c24f890f84e$var$_copy = $9b563c24f890f84e$var$_interopRequireDefault((parcelRequire("jmWAP")));
function $9b563c24f890f84e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b563c24f890f84e$var$CopyIcon = (props)=>/*#__PURE__*/ $9b563c24f890f84e$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9b563c24f890f84e$var$_copy.default
    }));
$9b563c24f890f84e$var$CopyIcon.displayName = 'CopyIcon';
var $9b563c24f890f84e$var$_default = module.exports.default = $9b563c24f890f84e$var$CopyIcon;

});
parcelRegister("jmWAP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ba7502fd657c116f257aba05875c56e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e19d85b9a090daf6$var$_react = $e19d85b9a090daf6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e19d85b9a090daf6$var$_UNSAFE_baseNew = $e19d85b9a090daf6$var$_interopRequireDefault((parcelRequire("huIZN")));
function $e19d85b9a090daf6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e19d85b9a090daf6$var$CopyIcon = (props)=>/*#__PURE__*/ $e19d85b9a090daf6$var$_react.default.createElement($e19d85b9a090daf6$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$e19d85b9a090daf6$var$CopyIcon.displayName = 'CopyIcon';
var $e19d85b9a090daf6$var$_default = module.exports.default = $e19d85b9a090daf6$var$CopyIcon;

});


parcelRegister("9KB2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $783c51fcaaba60da$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $ajFFo = parcelRequire("ajFFo");
const $783c51fcaaba60da$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $783c51fcaaba60da$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$783c51fcaaba60da$var$analyticsParams
    });
    const handleOnBlur = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$783c51fcaaba60da$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $5uXOq.useMemo)(()=>(0, $ajFFo.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $ajFFo.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $783c51fcaaba60da$export$2e2bcd8739ae039 = $783c51fcaaba60da$var$Textfield;

});
parcelRegister("ajFFo", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $edefbc44b2662399$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $edefbc44b2662399$export$3eeb47dc8e6249d9);

const $edefbc44b2662399$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $edefbc44b2662399$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $edefbc44b2662399$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $edefbc44b2662399$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $edefbc44b2662399$var$backgroundColor[appearance],
        borderColor: $edefbc44b2662399$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $edefbc44b2662399$var$backgroundColorHover[appearance],
            borderColor: $edefbc44b2662399$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $edefbc44b2662399$var$backgroundColorFocus[appearance],
            borderColor: $edefbc44b2662399$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$edefbc44b2662399$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $5e0c0d4e15efb4a6$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $edefbc44b2662399$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $edefbc44b2662399$var$getMaxWidth = (width)=>!width ? `100%` : width in $edefbc44b2662399$var$widthMap ? $edefbc44b2662399$var$widthMap[width] : +width;
const $edefbc44b2662399$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$edefbc44b2662399$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $edefbc44b2662399$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $edefbc44b2662399$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("fVAPR", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $97462970d1593b07$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");


var $7u8mi = parcelRequire("7u8mi");

var $gwIPs = parcelRequire("gwIPs");
const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $97462970d1593b07$var$LabelText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $7u8mi.h200)()} display:block;font-family:${(0, $gwIPs.fontFamily)};margin:0;${(0, $47bDC.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97462970d1593b07$var$RequiredIndicator = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $5e0c0d4e15efb4a6$exports).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $gwIPs.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';

});

parcelRegister("4gmb8", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $26e3b01c3b885768$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $5e0c0d4e15efb4a6$exports).P400,
            '> span': {
                color: (0, $5e0c0d4e15efb4a6$exports).N0
            }
        }
    };
    return theme;
};
const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

const $68788ede79b59f1f$export$4f0520e0d7c4c7b0 = 'field-copy-text';

parcelRegister("gT8ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb069c8c90804ba8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fb069c8c90804ba8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copied: {
        "id": "common.field-copy-text.copied",
        "defaultMessage": "Copied!"
    },
    copyFailed: {
        "id": "common.field-copy-text.copy-failed",
        "defaultMessage": "Couldn't copy to clipboard"
    }
});

});

parcelRegister("9iXoh", function(module, exports) {

$parcel$export(module.exports, "Root", () => $d3bb6eb164541ffa$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "FieldContainer", () => $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $d3bb6eb164541ffa$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-0"
})({
    display: 'flex',
    alignItems: 'flex-end'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        userSelect: 'none'
    }) : '');
const $d3bb6eb164541ffa$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g0si8d-1"
})({
    marginRight: "var(--ds-space-100, 8px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.shouldFitContainer ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        flexGrow: 1
    }) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.hideFieldText === true ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $47bDC.css)({
        position: 'absolute',
        left: '-9999px',
        height: 0,
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
    }) : '');

});



parcelRegister("h8Z4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f347cfa55c12637$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5f347cfa55c12637$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyLink: {
        "id": "software-copy-to-clipboard.copy-link",
        "defaultMessage": "Copy issue link"
    },
    copySuccessTitle: {
        "id": "software-copy-to-clipboard.copy-success-title",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessage: {
        "id": "software-copy-to-clipboard.copy-success-message",
        "defaultMessage": "Issue link successfully copied to your clipboard"
    }
});

});



parcelRegister("7MVky", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $c80f04e236a539e4$export$43383fdc9fe04fe6);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $c1MAf = parcelRequire("c1MAf");

var $5Eoed = parcelRequire("5Eoed");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $c80f04e236a539e4$export$33577be3a49c7499 = ({ isDeleteEnabled: isDeleteEnabled, onDeleteIssue: onDeleteIssue, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isDeleteEnabled || selectedCardIds.length > 1) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).delete),
            id: (0, $9nlJl.DELETE_ISSUE_MENU_ID),
            onClick: onDeleteIssue
        }
    ];
};
const $c80f04e236a539e4$export$43383fdc9fe04fe6 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isDeleteEnabled = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canDeleteIssues));
    const onDeleteIssue = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$87c7cb14aa706e2d),
            payload: {
                cardId: issueId
            }
        }));
    return $c80f04e236a539e4$export$33577be3a49c7499({
        isDeleteEnabled: isDeleteEnabled,
        onDeleteIssue: onDeleteIssue,
        selectedCardIds: selectedCardIds
    });
};

});

parcelRegister("iTQ6G", function(module, exports) {

$parcel$export(module.exports, "useEstimate", () => $26c8abb2f6c88fa7$export$3c38ee13c0bb43f6);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $3EtSK = parcelRequire("3EtSK");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $cghR2 = parcelRequire("cghR2");

var $bdIhZ = parcelRequire("bdIhZ");
const $26c8abb2f6c88fa7$export$5fc1a8ac15e506ee = ({ onSubmit: onSubmit, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createConfirmHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>(value)=>onSubmit({
                scope: scope,
                value: value,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.STORY_POINTS_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).storyPointEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 86,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Node,
                    id: (0, $9nlJl.STORY_POINTS_EDIT_MENU_ID),
                    node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdIhZ.AsyncStoryPointField), {
                            onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                            onCancel: createCancelHandler(scope, closeMenu, analyticsEvent)
                        })
                }
            ]
        }
    ];
};
const $26c8abb2f6c88fa7$export$14002335a55c84dc = ({ onSubmit: onSubmit, onCancel: onCancel, timeTrackingOptions: timeTrackingOptions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const createConfirmHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>(estimate)=>onSubmit({
                scope: scope,
                estimate: estimate,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onSubmit
    ]);
    const createCancelHandler = (0, $5uXOq.useCallback)((scope, closeMenu, analyticsEvent)=>()=>onCancel({
                scope: scope,
                closeMenu: closeMenu,
                analyticsEvent: analyticsEvent
            }), [
        onCancel
    ]);
    if (!timeTrackingOptions) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.ORIGINAL_ESTIMATE_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).originalEstimate),
            shouldOverflowChildren: true,
            submenuWidth: 126,
            children: [
                {
                    type: (0, $1HF4Y.MenuNodeType).Node,
                    id: (0, $9nlJl.ORIGINAL_ESTIMATE_EDIT_MENU_ID),
                    node: ({ scope: scope, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cghR2.AsyncOriginalEstimateField), {
                            onConfirm: createConfirmHandler(scope, closeMenu, analyticsEvent),
                            onCancel: createCancelHandler(scope, closeMenu, analyticsEvent),
                            timeTrackingOptions: timeTrackingOptions
                        })
                }
            ]
        }
    ];
};
const $26c8abb2f6c88fa7$export$3c38ee13c0bb43f6 = ({ selectedCardIds: selectedCardIds })=>{
    const estimationType = (0, $c1MAf.useBacklogSelector)((state)=>(0, $45Qwd.getEstimationType)(state));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((state)=>(0, $jG5HW.getTimeTrackingOptions)(state));
    const estimationFieldId = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const handleCancel = (0, $5uXOq.useCallback)(({ closeMenu: closeMenu })=>{
        closeMenu();
    }, []);
    const handleSubmitStoryPoint = (0, $c1MAf.useBacklogActionCreator)(({ value: value, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        const actions = selectedCardIds.map((id)=>(0, $3EtSK.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    storyPoints: value
                }
            }, {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                estimationFieldId: estimationFieldId,
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $aB8eX.batchActions)(actions);
    });
    const handleSubmitOriginalEstimate = (0, $c1MAf.useBacklogActionCreator)(({ estimate: estimate, closeMenu: closeMenu, analyticsEvent: analyticsEvent })=>{
        closeMenu();
        const actions = selectedCardIds.map((id)=>(0, $3EtSK.cardEstimateSetOptimistic)({
                cardId: id,
                estimate: {
                    originalEstimate: {
                        value: estimate.value || 0,
                        valueAsText: estimate.valueAsText
                    }
                }
            }, {
                estimationFieldId: (0, $5fc53.TIME_TRACKING_TYPE),
                issueKey: getIssueKey(id)
            }, analyticsEvent));
        return (0, $aB8eX.batchActions)(actions);
    });
    const storyPointContent = $26c8abb2f6c88fa7$export$5fc1a8ac15e506ee({
        onSubmit: handleSubmitStoryPoint,
        onCancel: handleCancel
    });
    const originalEstimateContent = $26c8abb2f6c88fa7$export$14002335a55c84dc({
        onSubmit: handleSubmitOriginalEstimate,
        onCancel: handleCancel,
        timeTrackingOptions: timeTrackingOptions
    });
    const canEditEstimate = canBulkEdit && canEdit && !!estimationFieldId;
    if (canEditEstimate && estimationType === (0, $guzeq.STORY_POINTS)) return storyPointContent;
    if (canEditEstimate && estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) return originalEstimateContent;
    return [];
};

});
parcelRegister("cghR2", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateField", () => $755de874a30d79d8$export$46675481a7613e3e);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $755de874a30d79d8$var$OriginalEstimateFieldLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("jYQmk")).then((module)=>module.OriginalEstimateField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/original-estimate-field/view.tsx"
});
const $755de874a30d79d8$export$46675481a7613e3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulkops-original-estimate-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($755de874a30d79d8$var$OriginalEstimateFieldLazy, props));

});
parcelRegister("jYQmk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8FjQk").then(()=>parcelRequire('7Kfhk'));

});


parcelRegister("bdIhZ", function(module, exports) {

$parcel$export(module.exports, "AsyncStoryPointField", () => $e8be4e1cdb48e2bd$export$91cc9e87752d0bf8);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e8be4e1cdb48e2bd$var$StoryPointFieldLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("3CopV")).then((module)=>module.StoryPointField), {
    moduleId: "./src/packages/software/backlog/src/view/card-list/card/context-menu/menu-items/estimate/story-point-field/view.tsx"
});
const $e8be4e1cdb48e2bd$export$91cc9e87752d0bf8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "bulkops-story-point-field",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e8be4e1cdb48e2bd$var$StoryPointFieldLazy, props));

});
parcelRegister("3CopV", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("bzjXm").then(()=>parcelRequire('kG3wv'));

});



parcelRegister("1otSd", function(module, exports) {

$parcel$export(module.exports, "useFlag", () => $effa488c9b5feb05$export$983b9b54330812cb);

var $5uXOq = parcelRequire("5uXOq");

var $kvQf6 = parcelRequire("kvQf6");

var $hW6cm = parcelRequire("hW6cm");

var $lQGxb = parcelRequire("lQGxb");

var $7xReK = parcelRequire("7xReK");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $a4GLz = parcelRequire("a4GLz");

var $1HF4Y = parcelRequire("1HF4Y");


var $c1MAf = parcelRequire("c1MAf");

var $5Eoed = parcelRequire("5Eoed");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $ihygG = parcelRequire("ihygG");
const $effa488c9b5feb05$export$81c94ca566d6fb97 = ({ cardIds: cardIds })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const flaggedStates = cardIds.map((cardId)=>cards[cardId]?.isFlagged);
    if (flaggedStates.every((isFlagged)=>isFlagged)) return (0, $ihygG.SelectedIssueFlaggedState).ALL_FLAGGED;
    if (flaggedStates.every((isFlagged)=>!isFlagged)) return (0, $ihygG.SelectedIssueFlaggedState).NONE_FLAGGED;
    return (0, $ihygG.SelectedIssueFlaggedState).INDETERMINATE;
};
const $effa488c9b5feb05$export$64037f4178ea2950 = ({ selectedIssuesFlaggedState: selectedIssuesFlaggedState, onToggleFlag: onToggleFlag, canFlag: canFlag })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!canFlag) return [];
    const addFlag = {
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $9nlJl.FLAG_ADD_FLAG_MENU_ID),
        label: formatMessage((0, $5Mhvq.default).addFlag),
        onClick: ()=>onToggleFlag(true)
    };
    const removeFlag = {
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $9nlJl.FLAG_REMOVE_FLAG_MENU_ID),
        label: formatMessage((0, $5Mhvq.default).removeFlag),
        onClick: ()=>onToggleFlag(false)
    };
    switch(selectedIssuesFlaggedState){
        case (0, $ihygG.SelectedIssueFlaggedState).NONE_FLAGGED:
            return [
                addFlag
            ];
        case (0, $ihygG.SelectedIssueFlaggedState).ALL_FLAGGED:
            return [
                removeFlag
            ];
        case (0, $ihygG.SelectedIssueFlaggedState).INDETERMINATE:
        default:
            return [
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    label: formatMessage((0, $5Mhvq.default).flag),
                    id: (0, $9nlJl.FLAG_MENU_ID),
                    children: [
                        {
                            ...addFlag,
                            icon: (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hW6cm))), {
                                label: formatMessage((0, $5Mhvq.default).addFlag),
                                color: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
                                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7xReK))),
                                LEGACY_primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`
                            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7xReK))), {
                                label: formatMessage((0, $5Mhvq.default).addFlag),
                                primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`
                            })
                        },
                        {
                            ...removeFlag,
                            icon: (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kvQf6))), {
                                label: formatMessage((0, $5Mhvq.default).removeFlag),
                                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lQGxb))),
                                color: "var(--ds-icon, #44546F)"
                            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lQGxb))), {
                                label: formatMessage((0, $5Mhvq.default).removeFlag)
                            })
                        }
                    ]
                }
            ];
    }
};
const $effa488c9b5feb05$export$983b9b54330812cb = ({ cardIds: cardIds })=>{
    const selectedCardsForFlagWithCommentModal = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsForFlagWithCommentModalFromCardIdsSelector)(state)(cardIds));
    const onToggleFlag = (0, $c1MAf.useBacklogActionCreator)((flag)=>(0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$34f52cb2089ddc40),
            payload: {
                flagAction: flag ? (0, $a4GLz.ADD) : (0, $a4GLz.REMOVE),
                cards: selectedCardsForFlagWithCommentModal
            }
        }));
    const canFlag = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const selectedIssuesFlaggedState = $effa488c9b5feb05$export$81c94ca566d6fb97({
        cardIds: cardIds
    });
    return $effa488c9b5feb05$export$64037f4178ea2950({
        selectedIssuesFlaggedState: selectedIssuesFlaggedState,
        onToggleFlag: onToggleFlag,
        canFlag: canFlag
    });
};

});
parcelRegister("kvQf6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14eb36ea32f66a7f271ec5226b3bc556>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeef3a2a731f37b5$var$_react = $eeef3a2a731f37b5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eeef3a2a731f37b5$var$_UNSAFE_baseNew = $eeef3a2a731f37b5$var$_interopRequireDefault((parcelRequire("huIZN")));
function $eeef3a2a731f37b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Flag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: flags in Editor, feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eeef3a2a731f37b5$var$FlagIcon = (props)=>/*#__PURE__*/ $eeef3a2a731f37b5$var$_react.default.createElement($eeef3a2a731f37b5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 15V9.75m0 0v-8H14l-3 4 3 4z"/>`
    }, props));
$eeef3a2a731f37b5$var$FlagIcon.displayName = 'FlagIcon';
var $eeef3a2a731f37b5$var$_default = module.exports.default = $eeef3a2a731f37b5$var$FlagIcon;

});

parcelRegister("lQGxb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe7f72b044853935$var$_react = $fe7f72b044853935$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $fe7f72b044853935$var$_flag = $fe7f72b044853935$var$_interopRequireDefault((parcelRequire("kvQf6")));
function $fe7f72b044853935$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fe7f72b044853935$var$EmojiFlagsIcon = (props)=>/*#__PURE__*/ $fe7f72b044853935$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466zm3.111-1.48c1.094 0 2.148.256 3.129.495 1.381.335 2.6.63 3.768.289V6.836c-1.488.27-2.93-.08-4.24-.398-1.379-.335-2.598-.632-3.768-.29v4.704a6 6 0 0 1 1.111-.097"/></svg>`
    }, props, {
        newIcon: $fe7f72b044853935$var$_flag.default
    }));
$fe7f72b044853935$var$EmojiFlagsIcon.displayName = 'EmojiFlagsIcon';
var $fe7f72b044853935$var$_default = module.exports.default = $fe7f72b044853935$var$EmojiFlagsIcon;

});

parcelRegister("ihygG", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueFlaggedState", () => $7c17b5e67a95d552$export$c7c32a893388b4e4);
const $7c17b5e67a95d552$export$c7c32a893388b4e4 = {
    ALL_FLAGGED: 'ALL_FLAGGED',
    NONE_FLAGGED: 'NONE_FLAGGED',
    INDETERMINATE: 'INDETERMINATE'
};

});


parcelRegister("bEQvq", function(module, exports) {

$parcel$export(module.exports, "useGoToBulkEditor", () => $0606d669d77f5fea$export$ef32b88fc4df461d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7VPRh = parcelRequire("7VPRh");

var $2YFlw = parcelRequire("2YFlw");


var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $0606d669d77f5fea$export$f62a4789211eedd7 = ({ onGoToBulkEditor: onGoToBulkEditor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0606d669d77f5fea$var$LabelWrapper, null, formatMessage((0, $5Mhvq.default).bulkChange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0606d669d77f5fea$var$IconWrapper, null, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7VPRh))), {
                    label: formatMessage((0, $5Mhvq.default).goToBulkEditorIconLabel),
                    color: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N800})`,
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2YFlw))),
                    LEGACY_primaryColor: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N800})`,
                    LEGACY_size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2YFlw))), {
                    size: "small",
                    label: formatMessage((0, $5Mhvq.default).goToBulkEditorIconLabel),
                    primaryColor: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N800})`
                }))),
            id: (0, $9nlJl.GO_TO_BULK_EDITOR_MENU_ID),
            onClick: onGoToBulkEditor
        }
    ];
};
const $0606d669d77f5fea$export$ef32b88fc4df461d = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const isGoToBulkEditorVisible = canBulkEdit && selectedCardIds.length > 1;
    const handleOnGoToBulkEditor = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(issueKeys.join(','))}`; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    };
    const bulkEditorContent = $0606d669d77f5fea$export$f62a4789211eedd7({
        onGoToBulkEditor: handleOnGoToBulkEditor
    });
    return isGoToBulkEditorVisible ? bulkEditorContent : [];
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0606d669d77f5fea$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0606d669d77f5fea$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154iv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4AddN", function(module, exports) {

$parcel$export(module.exports, "useHeader", () => $45ea26ac19b6fc69$export$ae602290ebd82f8e);

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");

var $ekjae = parcelRequire("ekjae");
const $45ea26ac19b6fc69$export$ae602290ebd82f8e = ({ selectedCardIds: selectedCardIds })=>{
    const separator = (0, $ekjae.createSeparator)((0, $9nlJl.HEADER_BULK_INDICATOR_MENU_ID));
    return selectedCardIds?.length > 1 ? [
        {
            id: (0, $9nlJl.HEADER_BULK_INDICATOR_MENU_ID),
            type: (0, $1HF4Y.MenuNodeType).BulkIndicator,
            selectedCount: selectedCardIds.length
        },
        separator
    ] : [];
};

});
parcelRegister("ekjae", function(module, exports) {

$parcel$export(module.exports, "createSeparator", () => $d3a46bd3c0c1e7be$export$2f446885d1462a2f);

var $gJBT6 = parcelRequire("gJBT6");

var $1HF4Y = parcelRequire("1HF4Y");

var $9nlJl = parcelRequire("9nlJl");
const $d3a46bd3c0c1e7be$export$2f446885d1462a2f = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>({
        id: `${0, $9nlJl.SEPARATOR_MENU_ID}/${id}`,
        type: (0, $1HF4Y.MenuNodeType).Separator
    }));

});


parcelRegister("5lrV3", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $f89386024ef31699$export$f91d8f33a4d36cb0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $6GNN7 = parcelRequire("6GNN7");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $g5WXi = parcelRequire("g5WXi");
const $f89386024ef31699$export$53fb05810700cd9c = 5;
const $f89386024ef31699$export$ba5a2e46cd05ad01 = ({ sprints: sprints, filteredSprints: filteredSprints, onMoveToSprint: onMoveToSprint, onMoveToBacklog: onMoveToBacklog, onMoveToBoard: onMoveToBoard, canMoveIssue: canMoveIssue, isMoveToBoardEnabled: isMoveToBoardEnabled, setQuery: setQuery, isSearching: isSearching, numOfSelectedSprints: numOfSelectedSprints, sprintId: sprintId, issueId: issueId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sprintOptions = filteredSprints.map((sprint)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `actions/move-to/${sprint.id}`,
            label: sprint.name,
            analytics: {
                ...isSearching && {
                    actionSubjectId: 'moveToSprintSearchDropdownItem'
                },
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: (analyticsEvent)=>onMoveToSprint(sprint.id, analyticsEvent)
        }));
    const sprintsSearchMenu = [
        {
            type: (0, $1HF4Y.MenuNodeType).Search,
            id: (0, $9nlJl.MOVE_TO_SEARCH_MENU_ID),
            children: sprintOptions,
            hasSearch: sprints.length > $f89386024ef31699$export$53fb05810700cd9c,
            onChange: (value)=>setQuery(value),
            isAsyncSearch: false,
            ariaLabel: formatMessage((0, $5Mhvq.default).sprintSearchPlaceholder)
        }
    ];
    const boardLabel = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardLists))[0, $guzeq.BOARD]?.name;
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const moveToBoard = isMoveToBoardEnabled ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.MOVE_TO_BOARD_MENU_ID),
            label: isCMPBoard && boardLabel ? boardLabel : formatMessage((0, $5Mhvq.default).board),
            analytics: {
                attributes: {
                    numOfSelectedSprints: numOfSelectedSprints,
                    sprintId: sprintId ?? 'backlog'
                }
            },
            onClick: onMoveToBoard
        }
    ] : [];
    const menuWithSeparator = sprints.length || moveToBoard.length ? [
        ...moveToBoard.length ? moveToBoard : sprintsSearchMenu,
        {
            id: (0, $9nlJl.SEPARATOR_MENU_ID),
            type: (0, $1HF4Y.MenuNodeType).Separator
        }
    ] : [];
    const rankIssueItems = (0, $g5WXi.useRankIssueItems)({
        issueId: issueId
    });
    return canMoveIssue ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $5Mhvq.default).moveTo),
            id: (0, $9nlJl.MOVE_TO_MENU_ID),
            children: [
                ...menuWithSeparator,
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    id: (0, $9nlJl.MOVE_TO_TOP_OF_BACKLOG_MENU_ID),
                    label: formatMessage((0, $5Mhvq.default).topOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $guzeq.TOP_OF_LIST), analyticsEvent)
                },
                ...rankIssueItems,
                {
                    type: (0, $1HF4Y.MenuNodeType).Item,
                    id: (0, $9nlJl.MOVE_TO_BOTTOM_OF_BACKLOG_MENU_ID),
                    label: formatMessage((0, $5Mhvq.default).bottomOfTheBacklog),
                    analytics: {
                        attributes: {
                            numOfSelectedSprints: numOfSelectedSprints,
                            sprintId: sprintId ?? 'backlog'
                        }
                    },
                    onClick: (analyticsEvent)=>onMoveToBacklog((0, $guzeq.BOTTOM_OF_LIST), analyticsEvent)
                }
            ]
        }
    ] : [];
};
const $f89386024ef31699$export$f91d8f33a4d36cb0 = ({ issueId: issueId, cardIds: cardIds, hide: hide = false })=>{
    const [query, setQuery] = (0, $5uXOq.useState)('');
    const [filteredSprints, setFilteredSprints] = (0, $5uXOq.useState)([]);
    const backlogStrategy = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBacklogStrategy));
    const getCardListIdByCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardListIdByCardId));
    const originCardListId = (0, $5uXOq.useMemo)(()=>getCardListIdByCardId(issueId), [
        getCardListIdByCardId,
        issueId
    ]);
    const numOfSelectedSprints = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ()=>new Set(cardIds.map(getCardListIdByCardId)).size, [
        cardIds,
        getCardListIdByCardId
    ]);
    const isFromActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(originCardListId || ''));
    const showAllSprints = !!numOfSelectedSprints && numOfSelectedSprints > 1;
    const sprints = (0, $c1MAf.useBacklogSelector)((state)=>showAllSprints ? (0, $k35me.getAllSprints)(state) : (0, $k35me.makeGetOtherOrderedSprints)(state)(originCardListId || ''), (before, after)=>before.length === after.length && before.every((sprint, index)=>sprint.name === after[index].name));
    const isMoveToBoardEnabled = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $dGljH.makeIsCardOnBoard)(state)(issueId) && (backlogStrategy === (0, $guzeq.ISSUE_LIST_BACKLOG_STRATEGY) || backlogStrategy === (0, $guzeq.KANBAN_BACKLOG_STRATEGY)) && sprints.length === 0);
    (0, $5uXOq.useEffect)(()=>{
        setFilteredSprints(sprints.filter((sprint)=>sprint.name.toLowerCase().includes(query.toLowerCase())));
    }, [
        query,
        sprints
    ]);
    const onMoveToSprint = (0, $c1MAf.useBacklogActionCreator)((id, analyticsEvent)=>(0, $6GNN7.cardsMove)({
            cardListId: id,
            placement: (0, $guzeq.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== id,
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent));
    const onMoveToBacklog = (0, $c1MAf.useBacklogActionCreator)((placement, analyticsEvent)=>(0, $6GNN7.cardsMove)({
            cardListId: (0, $guzeq.BACKLOG),
            placement: placement,
            isBetweenLists: originCardListId !== (0, $guzeq.BACKLOG),
            isFromActiveSprint: isFromActiveSprint,
            cardIds: cardIds
        }, analyticsEvent));
    const onMoveToBoard = (0, $c1MAf.useBacklogActionCreator)((analyticsEvent)=>(0, $6GNN7.cardsMove)({
            cardListId: (0, $guzeq.BOARD),
            placement: (0, $guzeq.BOTTOM_OF_LIST),
            isBetweenLists: originCardListId !== (0, $guzeq.BOARD),
            isFromActiveSprint: false,
            cardIds: cardIds
        }, analyticsEvent));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canMoveIssue = canEdit && !hide;
    return $f89386024ef31699$export$ba5a2e46cd05ad01({
        sprints: sprints,
        issueId: issueId,
        filteredSprints: filteredSprints,
        isMoveToBoardEnabled: isMoveToBoardEnabled,
        onMoveToSprint: onMoveToSprint,
        onMoveToBacklog: onMoveToBacklog,
        onMoveToBoard: onMoveToBoard,
        setQuery: setQuery,
        canMoveIssue: canMoveIssue,
        isSearching: !!query,
        numOfSelectedSprints: numOfSelectedSprints,
        sprintId: originCardListId || ''
    });
};

});
parcelRegister("g5WXi", function(module, exports) {

$parcel$export(module.exports, "useRankIssueItems", () => $984f36f425f2fd38$export$fbee3c551294933d);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $jyQw0 = parcelRequire("jyQw0");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
function $984f36f425f2fd38$export$fbee3c551294933d({ issueId: issueId }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const onClick = (type)=>{
        moveCards({
            source: {
                cardId: issueId
            },
            location: {
                type: type
            }
        });
    };
    const onClickRankUp = ()=>onClick('rank-up');
    const onClickRankDown = ()=>onClick('rank-down');
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.RANK_MENU_UP_ID),
            label: formatMessage((0, $5Mhvq.default).rankUp),
            onClick: onClickRankUp
        },
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.RANK_MENU_DOWN_ID),
            label: formatMessage((0, $5Mhvq.default).rankDown),
            onClick: onClickRankDown
        }
    ];
}

});
parcelRegister("jyQw0", function(module, exports) {

$parcel$export(module.exports, "useSimplyMoveCards", () => $2829c9efe0f1d21c$export$acad231ea38305d4);

var $95EVP = parcelRequire("95EVP");

var $g4tDr = parcelRequire("g4tDr");

var $7D59a = parcelRequire("7D59a");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $6GNN7 = parcelRequire("6GNN7");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $4VAKv = parcelRequire("4VAKv");

var $k35me = parcelRequire("k35me");
function $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId) {
    const cardListIds = Object.keys(cardIdsByCardListId);
    for(let i = 0; i < cardListIds.length; i += 1){
        const cardListId = cardListIds[i];
        const cardIds = cardIdsByCardListId[cardListId];
        const maybeCardIndex = cardIds.indexOf(cardId);
        if (maybeCardIndex !== -1) return {
            cardListId: cardListId,
            index: maybeCardIndex
        };
    }
    return null;
}
function $2829c9efe0f1d21c$export$53e40513eb32c9ca({ location: location, targetList: targetList, targetIndex: targetIndex, isCardSubtask: isCardSubtask, cards: cards, card: card, isParentExpanded: isParentExpanded, cardsToMove: cardsToMove }) {
    let index = Math.max(0, targetIndex);
    if (location.type === 'after') index += 1;
    // If the card to move are the target, e.g.: we're moving cards onto themselves, then we
    // scan the list to find the next non-selected card to move before.
    const cardsToMoveSet = new Set(cardsToMove ?? []);
    while(index < targetList.length && cardsToMoveSet.has(targetList[index]))index += 1;
    let beforeCardId = targetList[index] ?? null;
    if (beforeCardId != null && isCardSubtask === false && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel) && (!isParentExpanded || location.type === 'rank-down')) {
        // find next non subtask related to parent, if none, then set null
        const parentId = cards[beforeCardId]?.parentId;
        const offset = location.type === 'rank-down' && card?.id === parentId ? 2 : 1;
        const nextGroupOffset = targetList.slice(targetIndex + 1).findIndex((id)=>parentId !== cards[id]?.parentId);
        const offsetCard = targetList[targetIndex + nextGroupOffset + offset] ?? null;
        beforeCardId = nextGroupOffset > -1 ? offsetCard : null;
    }
    if (beforeCardId == null) return {
        type: 'bottom'
    };
    // When the ticket user is dragging over is a subtask then we send through the parent ID instead of the subtask id
    if (isCardSubtask === false && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[beforeCardId]?.typeHierarchyLevel)) beforeCardId = cards[beforeCardId]?.parentId ?? beforeCardId;
    return {
        type: 'card',
        beforeCardId: beforeCardId
    };
}
const $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent = (state, cardIdsByCardListId, cards, cardsToMove)=>{
    const isCardGroupCollapsed = (parentId)=>!(0, $dGljH.makeGetCardGroupExpanded)(state)(parentId);
    // If it's a CMP scum project, move all subtasks with parent regardless of expansion state
    // Otherwise, move the subtasks with the parent only if it is collapsed
    const shouldMoveSubtasksIfExpanded = (0, $jG5HW.isCMPScrumBacklog)(state);
    const cardsToCheck = shouldMoveSubtasksIfExpanded ? cardsToMove : cardsToMove.filter(isCardGroupCollapsed);
    return cardsToCheck.flatMap((cardGroupId)=>{
        const list = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardGroupId);
        return list ? cardIdsByCardListId[list.cardListId].filter((cardId)=>(0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel) && cards[cardId]?.parentId === cardGroupId) : [];
    });
};
function $2829c9efe0f1d21c$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const targetCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!sourceCardPosition || !targetCardPosition) return null;
    const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const cards = (0, $dGljH.getCards)(state);
    const card = cards[source.cardId];
    const extraCards = $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    const isFromActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(sourceCardPosition.cardListId);
    const isBetweenLists = sourceCardPosition.cardListId !== targetCardPosition.cardListId || selectedCardIds.some((cardId)=>Object.keys(cardIdsByCardListId).some((key)=>{
            if (key === targetCardPosition.cardListId) return false;
            return cardIdsByCardListId[key].includes(cardId);
        }));
    const basePayload = {
        cardIds: allCardsToMove,
        cardListId: targetCardPosition.cardListId,
        isBetweenLists: isBetweenLists,
        isFromActiveSprint: isFromActiveSprint
    };
    const targetList = cardIdsByCardListId[targetCardPosition.cardListId];
    const isParentExpanded = (0, $dGljH.makeGetCardGroupExpanded)(state)(cards[location.target]?.id);
    const beforeCardIdResult = $2829c9efe0f1d21c$export$53e40513eb32c9ca({
        location: location,
        targetList: targetList,
        targetIndex: targetCardPosition.index,
        isCardSubtask: (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel),
        cardsToMove: allCardsToMove,
        cards: cards,
        card: card,
        isParentExpanded: isParentExpanded
    });
    const event = createAnalyticsEvent({
        attributes: {
            target: targetCardPosition.cardListId,
            source: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, event);
    // Ignore dragging a card onto its own leading and trailing edges
    const beforeCardIndex = targetList.indexOf(beforeCardIdResult.beforeCardId);
    const isNoopChange = card.id !== beforeCardIdResult.beforeCardId && allCardsToMove.every((cardId)=>beforeCardIdResult.beforeCardId === cardId || targetList[beforeCardIndex - 1] === cardId);
    if (isNoopChange) return null;
    const isAllSelectedSiblingSubtasks = (0, $4VAKv.makeIsAllSelectedSiblingSubtasks)(state);
    // If the card is a subtask and all selected cards are siblings, then they can only be moved in the group
    // If the "before" card doesn't have a parent it will mean that they have been moved to the last in the group
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && isAllSelectedSiblingSubtasks && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $g4tDr.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $6GNN7.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $guzeq.BEFORE_CARD)
    }, event);
}
function $2829c9efe0f1d21c$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    if (!sourceCardPosition) return null;
    const orderedCardIds = cardIdsByCardListId[sourceCardPosition.cardListId];
    const targetIndex = location.type === 'rank-up' ? sourceCardPosition.index - 1 : sourceCardPosition.index + 2;
    const basePayload = {
        cardIds: [
            source.cardId
        ],
        cardListId: sourceCardPosition.cardListId,
        isBetweenLists: false,
        isFromActiveSprint: false
    };
    const cards = (0, $dGljH.getCards)(state);
    const card = cards[source.cardId];
    const beforeCardIdResult = $2829c9efe0f1d21c$export$53e40513eb32c9ca({
        cards: cards,
        card: card,
        isCardSubtask: (0, $g4tDr.isSubtaskHierarchyLevel)(card?.typeHierarchyLevel),
        location: location,
        targetIndex: targetIndex,
        targetList: orderedCardIds,
        isParentExpanded: (0, $dGljH.makeGetCardGroupExpanded)(state)(cards[orderedCardIds[targetIndex]]?.id)
    });
    const event = createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition.cardListId,
            target: sourceCardPosition.cardListId
        }
    });
    if (beforeCardIdResult.type === 'bottom') return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, event);
    // If the card is a subtask and the "before" card is not, then move to the bottom of the card list
    const targetCard = cards[beforeCardIdResult.beforeCardId];
    if (card && targetCard && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel) && !(0, $g4tDr.isSubtaskHierarchyLevel)(targetCard.typeHierarchyLevel)) return (0, $6GNN7.cardsMove)({
        ...basePayload,
        placement: (0, $guzeq.BOTTOM_OF_CARD_GROUP)
    }, event);
    return (0, $6GNN7.cardsMove)({
        ...basePayload,
        beforeCardId: beforeCardIdResult.beforeCardId,
        placement: (0, $guzeq.BEFORE_CARD)
    }, event);
}
function $2829c9efe0f1d21c$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getOrderedCardIdsByCardListId)(state);
    const selectedCardIds = (0, $dGljH.getSelectedCards)(state);
    const cardsToMove = selectedCardIds.includes(source.cardId) ? selectedCardIds : [
        source.cardId
    ];
    const sourceCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, source.cardId);
    const cards = (0, $dGljH.getCards)(state);
    const extraCards = $2829c9efe0f1d21c$var$getSubtasksIfShouldMoveWithParent(state, cardIdsByCardListId, cards, cardsToMove);
    const allCardsToMove = cardsToMove.concat(extraCards);
    // Quit if any of the cards are missing from the state
    const cardPositions = allCardsToMove.map((cardId)=>$2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, cardId));
    if (cardPositions.some((cardPosition)=>!cardPosition)) return null;
    // Quit if noop
    const isBetweenLists = cardPositions.some((cardPosition)=>cardPosition?.cardListId !== location.targetListId);
    if (!isBetweenLists) return null;
    // Treat as from active sprint if any of the cards is in the active sprint
    const isFromActiveSprint = cardPositions.some((cardPosition)=>cardPosition && (0, $k35me.makeIsCardListActiveSprint)(state)(cardPosition.cardListId));
    return (0, $6GNN7.cardsMove)({
        cardIds: allCardsToMove,
        cardListId: location.targetListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            source: sourceCardPosition?.cardListId,
            target: location.targetListId
        }
    }));
}
/**
 * Returns a filter function that prevents subtasks from being left behind moved without their parents
 * Pass if:
 *  card is not a subtask OR
 *  card's parent is also included in cardsToMove OR
 *  card's parent is in the list we are moving to
 */ function $2829c9efe0f1d21c$var$removeOrphanSubtasks(state, targetList) {
    return (cardId, index, cardsToMove)=>{
        const cardIdsByCardListId = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state);
        const cards = (0, $dGljH.getCards)(state);
        const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardId]?.typeHierarchyLevel);
        const { parentId: parentId } = cards[cardId];
        if (!parentId) return true;
        const parentInTargetList = cardIdsByCardListId[targetList].includes(parentId);
        const parentIsIncluded = cardsToMove.includes(parentId);
        return !isSubtask || parentIsIncluded || parentInTargetList;
    };
}
function $2829c9efe0f1d21c$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent) {
    const cardIdsByCardListId = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state);
    const targetCardPosition = $2829c9efe0f1d21c$export$20b62d0c0d6c07df(cardIdsByCardListId, location.target);
    if (!targetCardPosition) return null;
    const cardListOrder = (0, $dGljH.getOrderedCardListIds)(state);
    const sourceCardListId = source.cardListId;
    const dividerListIndex = cardListOrder.indexOf(sourceCardListId);
    if (dividerListIndex === -1) return null;
    const isFromActiveSprint = (0, $k35me.makeIsCardListActiveSprint)(state)(sourceCardListId);
    const targetIndex = cardListOrder.findIndex((val)=>val === targetCardPosition.cardListId);
    const sourceIndex = cardListOrder.findIndex((val)=>val === source.cardListId);
    const direction = sourceIndex < targetIndex ? 'down' : 'up';
    const cardsFromOtherLists = cardListOrder.slice(direction === 'down' ? sourceIndex + 1 : targetIndex + 1, direction === 'down' ? targetIndex : sourceIndex + 1).flatMap((key)=>cardIdsByCardListId[key]);
    // We will move the divider list's cards to the list under it
    // This happens when dragging the divider up into a list above
    if (direction === 'up') {
        const targetList = cardListOrder[sourceIndex + 1];
        const cardsToMove = cardIdsByCardListId[targetCardPosition.cardListId].slice(location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1).concat(cardsFromOtherLists).filter($2829c9efe0f1d21c$var$removeOrphanSubtasks(state, targetList));
        return (0, $6GNN7.cardsMove)({
            cardIds: cardsToMove,
            cardListId: targetList,
            isBetweenLists: true,
            isFromActiveSprint: isFromActiveSprint,
            placement: (0, $guzeq.TOP_OF_LIST)
        }, createAnalyticsEvent({
            attributes: {
                type: (0, $2lpqS.DND_TARGET_DIVIDER),
                source: sourceCardListId,
                target: targetCardPosition.cardListId
            }
        }));
    }
    // We will move target list's cards to the divider list
    // This happens when dragging the divider down into a list under it
    const cardsToMove = cardsFromOtherLists.concat(cardIdsByCardListId[targetCardPosition.cardListId].slice(0, location.type === 'before' ? targetCardPosition.index : targetCardPosition.index + 1)).filter($2829c9efe0f1d21c$var$removeOrphanSubtasks(state, cardListOrder[sourceIndex]));
    return (0, $6GNN7.cardsMove)({
        cardIds: cardsToMove,
        cardListId: sourceCardListId,
        isBetweenLists: true,
        isFromActiveSprint: isFromActiveSprint,
        placement: (0, $guzeq.BOTTOM_OF_LIST)
    }, createAnalyticsEvent({
        attributes: {
            type: (0, $2lpqS.DND_TARGET_DIVIDER),
            // ? With the divider here the source and target are swapped
            target: sourceCardListId,
            source: targetCardPosition.cardListId
        }
    }));
}
function $2829c9efe0f1d21c$export$5c5a9714d8f54364(store, { source: source, location: location }, createAnalyticsEvent) {
    const state = store.getState();
    if ('type' in source && source.type === 'divider' && (location.type === 'before' || location.type === 'after')) return $2829c9efe0f1d21c$export$5d7be4628e37c837(state, source, location, createAnalyticsEvent);
    if (!('cardId' in source)) return null;
    if (location.type === 'before' || location.type === 'after') return $2829c9efe0f1d21c$export$b5e42ff2ff97d25d(state, source, location, createAnalyticsEvent);
    if (location.type === 'rank-up' || location.type === 'rank-down') return $2829c9efe0f1d21c$export$b50dfd72a14689ae(state, source, location, createAnalyticsEvent);
    if (location.type === 'list') return $2829c9efe0f1d21c$export$a8306ae9a42a578c(state, source, location, createAnalyticsEvent);
    return null;
}
function $2829c9efe0f1d21c$export$acad231ea38305d4() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const store = (0, $c1MAf.useBacklogStore)();
    return (0, $7D59a.useEvent)((payload)=>{
        const action = $2829c9efe0f1d21c$export$5c5a9714d8f54364(store, payload, createAnalyticsEvent);
        if (action) store.dispatch(action);
    });
}

});
parcelRegister("4VAKv", function(module, exports) {

$parcel$export(module.exports, "makeIsAnySelectedOrphanedSubtasks", () => $986a9adf5ab52bc5$export$18dee6c39753b5ad);
$parcel$export(module.exports, "makeIsAllSelectedSiblingSubtasks", () => $986a9adf5ab52bc5$export$a018c3db49ab6617);

var $k8IPx = parcelRequire("k8IPx");

var $24ebX = parcelRequire("24ebX");

var $g4tDr = parcelRequire("g4tDr");

var $ld0jI = parcelRequire("ld0jI");

var $dGljH = parcelRequire("dGljH");
const $986a9adf5ab52bc5$export$18dee6c39753b5ad = (0, $24ebX.createSelector)([
    (0, $dGljH.getSelectedCards),
    (0, $dGljH.getCards)
], (selectedCards, cards)=>selectedCards.some((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const isOrphaned = !!card?.parentId && !selectedCards.includes(card.parentId);
        return isSubtask && isOrphaned;
    }));
const $986a9adf5ab52bc5$export$a018c3db49ab6617 = (0, $24ebX.createSelector)([
    (0, $dGljH.getSelectedCards),
    (0, $dGljH.getCards),
    (0, $ld0jI.makeGetCardGroupByChildId)
], (selectedCards, cards, getCardGroupByChildId)=>!!selectedCards.length && selectedCards.every((cardId)=>{
        const card = cards[cardId];
        const isSubtask = !!card && (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        if (isSubtask) {
            const cardGroup = getCardGroupByChildId(cardId);
            return !!cardGroup && (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(selectedCards, cardGroup.cardIds).length === 0;
        }
        return false;
    }));

});




parcelRegister("02921", function(module, exports) {

$parcel$export(module.exports, "useParent", () => $7862c68ba7c7071c$export$c1a4e24309a2ec52);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $c1MAf = parcelRequire("c1MAf");

var $gkSeR = parcelRequire("gkSeR");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $kJXVt = parcelRequire("kJXVt");
const $7862c68ba7c7071c$export$2e6dd7b2ab013cea = 6;
const $7862c68ba7c7071c$var$UNLINK = 'unlink';
const $7862c68ba7c7071c$var$isUnlinkMenuOption = (option)=>'type' in option && option.type === $7862c68ba7c7071c$var$UNLINK;
const $7862c68ba7c7071c$var$transformOptionToString = (option)=>{
    if ($7862c68ba7c7071c$var$isUnlinkMenuOption(option)) return option.label;
    return `${option.key} ${option.summary}`;
};
const $7862c68ba7c7071c$export$9e34a407c5c18c2f = ({ issueParents: issueParents, loading: loading, cardSelectionValid: cardSelectionValid, showUnlinkMenuItem: showUnlinkMenuItem, onUpdateParent: onUpdateParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const menuOptions = (0, $5uXOq.useMemo)(()=>[
            ...showUnlinkMenuItem ? [
                {
                    type: $7862c68ba7c7071c$var$UNLINK,
                    label: formatMessage((0, $5Mhvq.default).parentUnlinkOptionLabel)
                }
            ] : [],
            ...issueParents
        ], [
        formatMessage,
        issueParents,
        showUnlinkMenuItem
    ]);
    const [filteredMenuOptions, updateFilter] = (0, $gu244.useTextFilter)(menuOptions, $7862c68ba7c7071c$var$transformOptionToString);
    return (0, $5uXOq.useMemo)(()=>{
        if (!cardSelectionValid || !issueParents.length && !showUnlinkMenuItem) return [];
        const options = filteredMenuOptions.map((option)=>$7862c68ba7c7071c$var$isUnlinkMenuOption(option) ? {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: `${0, $9nlJl.PARENT_MENU_ID}/value__unlink`,
                label: option.label,
                onClick: (analyticsEvent)=>{
                    onUpdateParent(null, analyticsEvent);
                }
            } : {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: `${0, $9nlJl.PARENT_MENU_ID}/value__${option.id}`,
                label: $7862c68ba7c7071c$var$transformOptionToString(option),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                    width: "var(--ds-space-200, 16px)",
                    height: "var(--ds-space-200, 16px)",
                    src: option.issueType.iconUrl,
                    alt: ""
                }),
                onClick: (analyticsEvent)=>{
                    onUpdateParent(option, analyticsEvent);
                }
            });
        const showSearch = issueParents.length + (showUnlinkMenuItem ? 1 : 0) > $7862c68ba7c7071c$export$2e6dd7b2ab013cea;
        const subMenu = showSearch ? [
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                type: (0, $1HF4Y.MenuNodeType).Search,
                id: (0, $9nlJl.PARENT_SEARCH_MENU_ID),
                children: options,
                hasSearch: true,
                // Parents are only fetched async once during mount
                isAsyncSearch: false,
                isLoading: loading,
                onChange: updateFilter,
                resultsCount: filteredMenuOptions.length
            }
        ] : options;
        return [
            {
                type: (0, $1HF4Y.MenuNodeType).Item,
                id: (0, $9nlJl.PARENT_MENU_ID),
                label: formatMessage((0, $5Mhvq.default).parentOptionLabel),
                submenuWidth: 284,
                children: subMenu
            }
        ];
    }, [
        cardSelectionValid,
        issueParents.length,
        showUnlinkMenuItem,
        filteredMenuOptions,
        loading,
        updateFilter,
        formatMessage,
        onUpdateParent
    ]);
};
const $7862c68ba7c7071c$export$c1a4e24309a2ec52 = (selectedCardIds)=>{
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const selectedCards = (0, $5uXOq.useMemo)(()=>selectedCardIds.map((cardId)=>allCards[cardId]).filter(Boolean), [
        allCards,
        selectedCardIds
    ]);
    const firstCardParentId = selectedCards.length ? selectedCards[0].parentId : null;
    const { issueParents: allIssueParents, loading: loading, cardSelectionValid: cardSelectionValid } = (0, $kJXVt.useIssueParents)(selectedCards);
    const multipleCardsSelected = selectedCardIds.length > 1;
    const showUnlinkMenuItem = selectedCards.some((card)=>card.parentId !== null);
    // If we're only editing a single card, remove any
    // epic from the list that's assigned to this card
    const issueParents = (0, $5uXOq.useMemo)(()=>!multipleCardsSelected && firstCardParentId ? allIssueParents.filter((parent)=>parent.id !== String(firstCardParentId)) : allIssueParents, [
        allIssueParents,
        firstCardParentId,
        multipleCardsSelected
    ]);
    const onUpdateParent = (0, $c1MAf.useBacklogActionCreator)((parent, analyticsEvent)=>(0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $gkSeR.cardParentSetOptimistic)({
                cardId: id,
                parent: parent
            }, getIssueKey(id), analyticsEvent))));
    return $7862c68ba7c7071c$export$9e34a407c5c18c2f({
        issueParents: issueParents,
        onUpdateParent: onUpdateParent,
        showUnlinkMenuItem: showUnlinkMenuItem,
        loading: loading,
        cardSelectionValid: cardSelectionValid
    });
};

});
parcelRegister("gu244", function(module, exports) {

$parcel$export(module.exports, "useTextFilter", () => $5d5db767318aa751$export$de949492119ddd44);

var $5uXOq = parcelRequire("5uXOq");
const $5d5db767318aa751$var$removeAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $5d5db767318aa751$var$doesStringContainText = (itemString, text)=>itemString.toLowerCase().includes(text.toLowerCase()) || $5d5db767318aa751$var$removeAccents(itemString).toLowerCase().includes(text.toLowerCase());
const $5d5db767318aa751$export$de949492119ddd44 = (items, itemToStringTransformer, defaultFilterValue = '')=>{
    const [filterValue, setFilterValue] = (0, $5uXOq.useState)(defaultFilterValue);
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        if (!filterValue) return items;
        return items.filter((item)=>$5d5db767318aa751$var$doesStringContainText(itemToStringTransformer(item), filterValue));
    }, [
        filterValue,
        itemToStringTransformer,
        items
    ]);
    return [
        filteredItems,
        setFilterValue
    ];
};

});

parcelRegister("kJXVt", function(module, exports) {

$parcel$export(module.exports, "useIssueParents", () => $012fa3a5c174d68b$export$b72cf91ed30503ee);

var $5uXOq = parcelRequire("5uXOq");

var $5fc53 = parcelRequire("5fc53");

var $2LYS2 = parcelRequire("2LYS2");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fmuR9 = parcelRequire("fmuR9");

var $fzhrh = parcelRequire("fzhrh");
const $012fa3a5c174d68b$var$SEARCH_FIELDS = [
    (0, $5fc53.SUMMARY_TYPE),
    (0, $5fc53.ISSUE_TYPE)
];
const $012fa3a5c174d68b$var$constructSearchJql = (projectIds)=>`project in (${projectIds.join(',')}) AND hierarchyLevel=1 ORDER BY lastViewed DESC, updated DESC, priority DESC`;
const $012fa3a5c174d68b$var$transformSearchResponse = (response)=>response.issues.map((issue)=>{
        const { id: id, name: name, iconUrl: iconUrl } = issue.fields.issuetype;
        return {
            id: issue.id,
            key: issue.key,
            summary: issue.fields.summary,
            issueType: {
                id: id,
                name: name,
                iconUrl: iconUrl
            },
            color: undefined
        };
    });
const $012fa3a5c174d68b$var$EMPTY_ARRAY = [];
const $012fa3a5c174d68b$export$b72cf91ed30503ee = (selectedCards)=>{
    const allProjects = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects));
    const issueParentsInState = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    // Array of projects from which a valid parent selection can be made
    const applicableProjects = (0, $5uXOq.useMemo)(()=>isCompanyManaged ? (0, $fzhrh.getAllPossibleProjectsForSelection)(selectedCards, allProjects) : [], [
        allProjects,
        isCompanyManaged,
        selectedCards
    ]);
    // Array of valid issue parents from state
    const filteredIssueParentsInState = (0, $5uXOq.useMemo)(()=>isCompanyManaged ? (0, $fzhrh.filterIssueParentsByProjects)(issueParentsInState, applicableProjects) : issueParentsInState, [
        isCompanyManaged,
        issueParentsInState,
        applicableProjects
    ]);
    // TMP projects do not require validation as they do not
    // include epic or subtasks cards and cross-project boards
    const isCardSelectionValid = isCompanyManaged ? (0, $fzhrh.validateSelectedCards)(selectedCards, allProjects) : true;
    const { data: data, loading: loading, fetch: fetch } = (0, $2LYS2.useIssueSearch)();
    const issueParentsFromSearch = (0, $5uXOq.useMemo)(()=>data && $012fa3a5c174d68b$var$transformSearchResponse(data), [
        data
    ]);
    const issueParents = isCardSelectionValid ? issueParentsFromSearch || filteredIssueParentsInState : $012fa3a5c174d68b$var$EMPTY_ARRAY;
    (0, $5uXOq.useEffect)(()=>{
        if (isCardSelectionValid) {
            const projectIds = isCompanyManaged ? applicableProjects.map((project)=>project.id) : [
                projectId
            ];
            fetch({
                jql: $012fa3a5c174d68b$var$constructSearchJql(projectIds),
                fields: $012fa3a5c174d68b$var$SEARCH_FIELDS
            });
        }
    }, [
        applicableProjects,
        fetch,
        isCardSelectionValid,
        isCompanyManaged,
        projectId
    ]);
    return {
        issueParents: issueParents,
        loading: loading,
        cardSelectionValid: isCardSelectionValid
    };
};

});
parcelRegister("2LYS2", function(module, exports) {

$parcel$export(module.exports, "useIssueSearch", () => $3d22472943f3524e$export$2047aaca681570b0);

var $ebyGx = parcelRequire("ebyGx");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $3d22472943f3524e$var$BASE_URL = '/rest/api/3/search';
const $3d22472943f3524e$var$search = ({ jql: jql, fields: fields = [], maxResults: maxResults = 50 })=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
        jql: jql,
        fields: fields,
        maxResults: maxResults
    });
    return (0, $eusud.performGetRequest)(`${$3d22472943f3524e$var$BASE_URL}?${query}`);
};
const $3d22472943f3524e$export$2047aaca681570b0 = ()=>(0, $ld2hZ.useService)($3d22472943f3524e$var$search);

});

parcelRegister("fzhrh", function(module, exports) {

$parcel$export(module.exports, "getAllPossibleProjectsForSelection", () => $3cc06988f0b52507$export$73fb4b63f0b800bc);
$parcel$export(module.exports, "filterIssueParentsByProjects", () => $3cc06988f0b52507$export$6d89fd51639f36fe);
$parcel$export(module.exports, "validateSelectedCards", () => $3cc06988f0b52507$export$7b9297714722993a);

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");
const $3cc06988f0b52507$var$EMPTY_ARRAY = [];
const $3cc06988f0b52507$export$191ca7f80b22e275 = (selectedCards, allProjects)=>{
    const projectIdsOfSelection = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(selectedCards.map((card)=>card.projectId));
    return allProjects.filter((project)=>projectIdsOfSelection.includes(project.id));
};
const $3cc06988f0b52507$export$73fb4b63f0b800bc = (selectedCards, allProjects)=>{
    if (!(selectedCards.length && allProjects.length)) return $3cc06988f0b52507$var$EMPTY_ARRAY;
    const projectsOfSelection = $3cc06988f0b52507$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return $3cc06988f0b52507$var$EMPTY_ARRAY;
    const isTmp = projectsOfSelection[0].isSimplified;
    if (isTmp) return [
        projectsOfSelection[0]
    ];
    return allProjects.filter((project)=>!project.isSimplified);
};
const $3cc06988f0b52507$export$6d89fd51639f36fe = (issueParents, projects)=>{
    const projectKeys = new Set(projects.map((project)=>project.key));
    return issueParents.filter((parent)=>{
        const [projectKey] = parent.key.split('-');
        return projectKeys.has(projectKey);
    });
};
const $3cc06988f0b52507$export$7b9297714722993a = (selectedCards, allProjects)=>{
    const projectsOfSelection = $3cc06988f0b52507$export$191ca7f80b22e275(selectedCards, allProjects);
    if (!projectsOfSelection.length) return false;
    const subtasksOrEpicsAreSelected = selectedCards.some(({ typeHierarchyLevel: typeHierarchyLevel })=>!(0, $g4tDr.isBaseHierarchyLevel)(typeHierarchyLevel));
    const [firstProject, ...remainingProjects] = projectsOfSelection;
    const projectsAreOfDifferentType = remainingProjects.length ? remainingProjects.some((project)=>project.isSimplified !== firstProject.isSimplified) : false;
    const multipleTmpProjectsHaveSelections = !projectsAreOfDifferentType && firstProject.isSimplified && remainingProjects.length > 0;
    return !(subtasksOrEpicsAreSelected || projectsAreOfDifferentType || multipleTmpProjectsHaveSelections);
};

});



parcelRegister("hgBx0", function(module, exports) {

$parcel$export(module.exports, "usePlanOnWhiteboard", () => $a6ab3aed90321d7b$export$3917b0486d389abb);

var $5uXOq = parcelRequire("5uXOq");

var $ar8lZ = parcelRequire("ar8lZ");

var $eddAM = parcelRequire("eddAM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $1HF4Y = parcelRequire("1HF4Y");

var $2Lk47 = parcelRequire("2Lk47");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $3L1UG = parcelRequire("3L1UG");

var $crgSa = parcelRequire("crgSa");

var $3DKih = parcelRequire("3DKih");

var $9nlJl = parcelRequire("9nlJl");
const $a6ab3aed90321d7b$var$usePlanOnWhiteboardContent = ({ issueKey: issueKey, selectedCardIds: selectedCardIds, cardEntities: cardEntities, flow: flow })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const crossflow = (0, $ar8lZ.useCrossFlow)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $2Lk47.useFireCrossFlowAnalyticsEvents)();
    const coUseEligible = flow === 'coUse';
    const crossFlowEligible = flow === 'crossFlow';
    const url = (0, $3L1UG.useCoUseFlow)(coUseEligible);
    // Extract project name and project id
    const projectName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectName));
    const projectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const planOnWhiteboardButtonLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, `${formatMessage((0, $crgSa.default).planOnWhiteboard)} `, crossFlowEligible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
            appearance: "new"
        }, formatMessage((0, $crgSa.default).planOnWhiteboardTry))), [
        formatMessage,
        crossFlowEligible
    ]);
    const saveSelectedIssuesToLocalStorage = (0, $5uXOq.useCallback)((issueKeys)=>{
        localStorage.setItem('whiteboardsExperimentSelectedIssueKeys', JSON.stringify(issueKeys));
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'selectedIssuesInLocalStorage stored', {
            growthInitiative: 'cross-flow',
            storedIssues: issueKeys,
            sourceComponent: 'planOnWhiteboardsContextualCTAScreen',
            sourceContext: 'planOnWhiteboardContextMenuButton'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onPlanOnWhiteboard = (0, $5uXOq.useCallback)(()=>{
        const selectedIssueKeys = selectedCardIds.map((id)=>cardEntities[String(id)]?.key ?? null).filter(Boolean);
        selectedIssueKeys.indexOf(issueKey) === -1 && selectedIssueKeys.push(issueKey);
        saveSelectedIssuesToLocalStorage(selectedIssueKeys);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'planOnWhiteboardContextMenuButton', {
            growthInitiative: 'cross-flow',
            numSelectedCards: selectedCardIds.length,
            isCrossFlowEligible: crossFlowEligible,
            isCoUseEligible: coUseEligible,
            sourceComponent: 'planOnWhiteboardsContextualCTAScreen',
            sourceContext: 'planOnWhiteboardContextMenuButton'
        });
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'listItem',
            actionSubjectId: 'planOnWhiteboardContextMenuButton'
        }, {
            targetProductId: (0, $ar8lZ.Targets).CONFLUENCE,
            recommendedProductIds: [
                (0, $ar8lZ.Targets).CONFLUENCE
            ],
            source: 'planOnWhiteboardsContextualCTAScreen'
        });
        (0, $3DKih.onClickCTA)({
            createAnalyticsEvent: createAnalyticsEvent,
            crossFlowEligible: crossFlowEligible,
            crossflow: crossflow,
            projectId: projectId,
            projectName: projectName,
            component: 'planOnWhiteboardsContextualCTAScreen',
            context: 'planOnWhiteboardContextMenuButton',
            coUseEligible: coUseEligible,
            url: url
        });
    }, [
        selectedCardIds,
        cardEntities,
        crossFlowEligible,
        coUseEligible,
        projectId,
        projectName,
        crossflow,
        createAnalyticsEvent,
        fireInteractedUIEvent,
        saveSelectedIssuesToLocalStorage,
        issueKey,
        url
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            {
                type: (0, $1HF4Y.MenuNodeType).Item,
                label: ()=>planOnWhiteboardButtonLabel,
                id: (0, $9nlJl.PLAN_ON_WHITEBOARD_MENU_ID),
                onClick: onPlanOnWhiteboard
            }
        ], [
        planOnWhiteboardButtonLabel,
        onPlanOnWhiteboard
    ]);
};
const $a6ab3aed90321d7b$export$3917b0486d389abb = ({ issueKey: issueKey, selectedCardIds: selectedCardIds, flow: flow })=>{
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return $a6ab3aed90321d7b$var$usePlanOnWhiteboardContent({
        issueKey: issueKey,
        selectedCardIds: selectedCardIds,
        cardEntities: cardEntities,
        flow: flow
    });
};

});

parcelRegister("7sDhu", function(module, exports) {

$parcel$export(module.exports, "usePriority", () => $18e1a6ad2ad970b4$export$5b10fbc9ee011cb3);

var $5uXOq = parcelRequire("5uXOq");

var $aB8eX = parcelRequire("aB8eX");

var $jjlQu = parcelRequire("jjlQu");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $c1MAf = parcelRequire("c1MAf");

var $c7Xu8 = parcelRequire("c7Xu8");

var $dGljH = parcelRequire("dGljH");

var $1z1J7 = parcelRequire("1z1J7");

var $c96gv = parcelRequire("c96gv");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $18e1a6ad2ad970b4$export$7499acaeff5d6912 = ({ isPriorityEnabled: isPriorityEnabled, priorities: priorities, canChangePriority: canChangePriority, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isPriorityEnabled || !canChangePriority) return [];
    const priorityOptions = priorities.map((value)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${0, $9nlJl.PRIORITY_MENU_ID}/value__${value.id}`,
            label: value.name,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
                url: value.iconUrl
            }),
            onClick: (analyticsEvent)=>onClick(value, analyticsEvent)
        }));
    if (priorityOptions.length === 0) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $9nlJl.PRIORITY_MENU_ID),
            label: formatMessage((0, $5Mhvq.default).priority),
            children: priorityOptions
        }
    ];
};
const $18e1a6ad2ad970b4$export$5b10fbc9ee011cb3 = ({ selectedCardIds: selectedCardIds })=>{
    const priorities = (0, $c1MAf.useBacklogSelector)((0, $c96gv.getPriorities));
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const getIssueKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeCardKeyFromCardId));
    const canBulkEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canBulkEditIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canChangePriority = canBulkEdit && canEdit;
    const onPriorityClick = (0, $c1MAf.useBacklogActionCreator)((priority, analyticsEvent)=>(0, $aB8eX.batchActions)(selectedCardIds.map((id)=>(0, $c7Xu8.cardPrioritySetOptimistic)({
                cardId: id,
                priority: priority
            }, getIssueKey(id), analyticsEvent))));
    const isPriorityEnabled = (0, $5uXOq.useMemo)(()=>selectedCardIds.some((cardId)=>cardEntities[String(cardId)]?.priority), [
        selectedCardIds,
        cardEntities
    ]);
    return $18e1a6ad2ad970b4$export$7499acaeff5d6912({
        isPriorityEnabled: isPriorityEnabled,
        priorities: priorities,
        canChangePriority: canChangePriority,
        onClick: (priority, analyticsEvent)=>onPriorityClick(priority, analyticsEvent)
    });
};

});
parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        });
        const isNew = (0, $4R6GH.fg)('jfp-1020-use-compiled');
        return isNew ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$ImagePlaceholder = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $5e0c0d4e15efb4a6$exports).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
const $e7f7206d8a029d15$var$placeholderStyles = (0, $jJ1Sb.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
}); // Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c96gv", function(module, exports) {

$parcel$export(module.exports, "getPriorities", () => $410cea2ba39bc35d$export$489e9c0d7da0a5e2);

var $e5nhF = parcelRequire("e5nhF");
const $410cea2ba39bc35d$export$489e9c0d7da0a5e2 = (state)=>(0, $e5nhF.getEntities)(state).priorities;

});


parcelRegister("ct9uH", function(module, exports) {

$parcel$export(module.exports, "useSplitIssue", () => $dea5bc936768ba59$export$ca834a1ba255430d);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $c1MAf = parcelRequire("c1MAf");

var $5Eoed = parcelRequire("5Eoed");

var $1z1J7 = parcelRequire("1z1J7");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $dea5bc936768ba59$export$5f7e384ce14f24a6 = ({ onSplitIssue: onSplitIssue, canSplitIssue: canSplitIssue, isMultiSelect: isMultiSelect })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return isMultiSelect || !canSplitIssue ? [] : [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).splitIssueIssueTermRefresh : (0, $5Mhvq.default).splitIssue),
            id: (0, $9nlJl.SPLIT_ISSUE_MENU_ID),
            onClick: onSplitIssue
        }
    ];
};
const $dea5bc936768ba59$export$ca834a1ba255430d = ({ issueId: issueId, isMultiSelect: isMultiSelect })=>{
    const onSplitIssue = (0, $c1MAf.useBacklogActionCreator)(()=>(0, $5Eoed.openModal)({
            type: (0, $b107c54ec82f76f2$export$77e94846ed2f57d7),
            payload: {
                cardId: issueId
            }
        }));
    const canCreate = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canCreateIssues));
    const canEdit = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const canSplitIssue = canCreate && canEdit;
    return $dea5bc936768ba59$export$5f7e384ce14f24a6({
        onSplitIssue: onSplitIssue,
        canSplitIssue: canSplitIssue,
        isMultiSelect: isMultiSelect
    });
};

});

parcelRegister("9ZFOK", function(module, exports) {

$parcel$export(module.exports, "useVersion", () => $4599610fe42edc80$export$d01fd6c038443a68);

var $5uXOq = parcelRequire("5uXOq");

var $kGsr8 = parcelRequire("kGsr8");

var $39xOx = parcelRequire("39xOx");

var $1HF4Y = parcelRequire("1HF4Y");


var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $elDM1 = parcelRequire("elDM1");
const $4599610fe42edc80$export$356153774e3dba20 = (versionMenuProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        id: "jira.backlog.context-menu.version"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elDM1.VersionMenu), versionMenuProps)));
const $4599610fe42edc80$var$EMPTY_ARR = [];
const $4599610fe42edc80$export$d01fd6c038443a68 = ({ selectedCardIds: selectedCardIds, versionMenuQueryRef: versionMenuQueryRef })=>{
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return (0, $5uXOq.useMemo)(()=>{
        if (!versionMenuQueryRef) return $4599610fe42edc80$var$EMPTY_ARR;
        const selectedCards = selectedCardIds.map((cardId)=>cards[cardId]).filter(Boolean);
        // Selected cards are valid if they belong to the same project
        const isCardSelectionValid = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(selectedCards.map((card)=>card.projectId)).length === 1;
        if (!isCardSelectionValid) return $4599610fe42edc80$var$EMPTY_ARR;
        const menuItemNode = {
            type: (0, $1HF4Y.MenuNodeType).Node,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/node`,
            node: (menuItemNodeArgs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4599610fe42edc80$export$356153774e3dba20, {
                    selectedCardIds: selectedCardIds,
                    selectedCards: selectedCards,
                    versionMenuQueryRef: versionMenuQueryRef,
                    menuItemNodeArgs: menuItemNodeArgs
                })
        };
        return [
            menuItemNode
        ];
    }, [
        cards,
        selectedCardIds,
        versionMenuQueryRef
    ]);
};

});
parcelRegister("elDM1", function(module, exports) {

$parcel$export(module.exports, "VersionMenu", () => $07ae86e06a2a730f$export$ff839af10c1133ea);

var $caDhG = parcelRequire("caDhG");

var $hrjFc = parcelRequire("hrjFc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $42KkK = parcelRequire("42KkK");

var $1z3OV = parcelRequire("1z3OV");

var $9Mj0A = parcelRequire("9Mj0A");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");

var $64FxD = parcelRequire("64FxD");

var $cHomS = parcelRequire("cHomS");
const $07ae86e06a2a730f$var$OptionType = {
    Version: 'version',
    Unlink: 'unlink'
};
const $07ae86e06a2a730f$var$transformOptionToString = (option)=>option.type === $07ae86e06a2a730f$var$OptionType.Version ? option.edge.node.name : option.label;
const $07ae86e06a2a730f$export$6a451aef481e8837 = (0, $hrjFc.default);
const $07ae86e06a2a730f$export$ff839af10c1133ea = ({ versionMenuQueryRef: versionMenuQueryRef, ...props })=>{
    const data = (0, $8Uumt.usePreloadedQuery)($07ae86e06a2a730f$export$6a451aef481e8837, versionMenuQueryRef);
    const versionEdges = (0, $5uXOq.useMemo)(()=>data.jira.versionsForProjects.edges.filter(Boolean), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07ae86e06a2a730f$var$VersionMenuContent, {
        ...props,
        versionEdges: versionEdges
    });
};
const $07ae86e06a2a730f$var$VersionMenuContent = ({ selectedCardIds: selectedCardIds, selectedCards: selectedCards, menuItemNodeArgs: menuItemNodeArgs, versionEdges: versionEdges })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Without breaking the edges between query and fragment, we cannot make the fields here required due to the connection
    const versions = (0, $8Uumt.useFragment)((0, $caDhG.default), versionEdges);
    const versionOptions = (0, $5uXOq.useMemo)(()=>{
        // Menu's only rendered if selected cards belong to the same project, so we can filter the versions using it
        const projectId = String(selectedCards[0].projectId);
        const filteredVersions = versions.filter(({ node: node })=>node.status === 'UNRELEASED' && node.project.projectId === projectId);
        // If there's only 1 card selected, ensure any already assigned versions are removed from the list
        const firstCardVersionIds = selectedCards[0]?.fixVersions ?? [];
        const availableVersions = selectedCards.length === 1 && firstCardVersionIds.length > 0 ? filteredVersions.filter(({ node: node })=>!firstCardVersionIds.includes(node.versionId)) : filteredVersions;
        return availableVersions.map((edge)=>({
                type: $07ae86e06a2a730f$var$OptionType.Version,
                edge: edge
            }));
    }, [
        versions,
        selectedCards
    ]);
    // Show unlink option if any card's version can be found in our queried versions
    const versionIdsSet = (0, $5uXOq.useMemo)(()=>new Set(versions.map(({ node: node })=>node.versionId)), [
        versions
    ]);
    const showUnlinkMenuItem = (0, $5uXOq.useMemo)(()=>selectedCards.some((card)=>card.fixVersions?.some((versionId)=>versionIdsSet.has(versionId)) ?? false), [
        selectedCards,
        versionIdsSet
    ]);
    const options = (0, $5uXOq.useMemo)(()=>showUnlinkMenuItem ? [
            {
                type: $07ae86e06a2a730f$var$OptionType.Unlink,
                label: formatMessage((0, $5Mhvq.default).versionUnlinkOptionLabel)
            },
            ...versionOptions
        ] : versionOptions, [
        versionOptions,
        formatMessage,
        showUnlinkMenuItem
    ]);
    const [filteredOptions, updateFilter] = (0, $gu244.useTextFilter)(options, $07ae86e06a2a730f$var$transformOptionToString);
    return versionOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z3OV.ContextMenuNode), {
        ...menuItemNodeArgs,
        menuNode: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu`,
            label: formatMessage((0, $5Mhvq.default).versionOptionLabel),
            submenuWidth: 284,
            element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42KkK.ContextMenuSearch), {
                onChange: updateFilter,
                autoFocus: true,
                isAsyncSearch: false,
                isLoading: false,
                hasSearch: options.length > 6,
                hasResult: filteredOptions.length > 0,
                resultsCount: filteredOptions.length
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yList), null, filteredOptions.map((option)=>option.type === $07ae86e06a2a730f$var$OptionType.Version ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yListItem), {
                    key: option.edge.node.versionId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHomS.VersionMenuItem), {
                    selectedCardIds: selectedCardIds,
                    versionEdge: option.edge,
                    menuItemNodeArgs: menuItemNodeArgs
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Mj0A.A11yListItem), {
                    key: "unlink"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64FxD.UnlinkMenuItem), {
                    key: "unlink",
                    selectedCardIds: selectedCardIds,
                    label: option.label,
                    menuItemNodeArgs: menuItemNodeArgs
                })))))
        }
    }) : null;
};

});
parcelRegister("caDhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f48978273e20a0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<982c324b2465f44e22128f5709dfdd89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f48978273e20a0a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true
    },
    "name": "versionMenu_softwareBacklog_VersionMenuContent",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        "action": "THROW",
                        "path": "node.status"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    "action": "THROW",
                                    "path": "node.project.projectId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.project"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        },
        {
            "kind": "FragmentSpread",
            "name": "versionMenuItem_softwareBacklog"
        }
    ],
    "type": "JiraVersionEdge"
};
$0f48978273e20a0a$var$node.hash = "a4cdeffafe39db4bddd6ce699b40af53";
var $0f48978273e20a0a$export$2e2bcd8739ae039 = $0f48978273e20a0a$var$node;

});

parcelRegister("42KkK", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSearch", () => $25a4fcce187183d2$export$800c7f2ae9d8f14d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $dPuU1 = parcelRequire("dPuU1");

var $9KB2r = parcelRequire("9KB2r");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $kqKGs = parcelRequire("kqKGs");

var $lPUo5 = parcelRequire("lPUo5");
const $25a4fcce187183d2$export$800c7f2ae9d8f14d = ({ onChange: onChange, autoFocus: autoFocus = true, hasSearch: hasSearch = true, maxViewportItems: maxViewportItems = (0, $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77), isLoading: isLoading = false, hasResult: hasResult = false, isAsyncSearch: isAsyncSearch, children: children, ariaLabel: ariaLabel, resultsCount: resultsCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [query, setQuery] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>()=>{
            onChange?.(''); // reset the filter result when the component unmounts
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((value)=>{
            onChange?.(value);
        }, (0, $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9)), [
        onChange
    ]);
    const handleChange = (0, $5uXOq.useCallback)((e)=>{
        const { value: value } = e.target;
        debouncedOnChange(value);
        setQuery(value);
    }, [
        debouncedOnChange,
        setQuery
    ]);
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape' && query !== '') {
            e.preventDefault();
            e.stopPropagation();
            onChange?.('');
            setQuery('');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$90350df905144507)
    }, hasSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$SearchWrapper, {
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KB2r.default), {
        role: "searchbox",
        "aria-label": ariaLabel,
        "aria-autocomplete": "list",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPuU1))), {
            label: (0, $4R6GH.fg)('ip_remove_aria_labels_for_decorative_images') ? '' : formatMessage((0, $kqKGs.default).search),
            size: "small"
        })),
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        placeholder: formatMessage((0, $kqKGs.default).search),
        isCompact: true,
        value: query,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lPUo5.default), {
        resultsCount: resultsCount,
        query: query,
        isAsyncSearch: isAsyncSearch,
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchContent, {
        maxViewportItems: maxViewportItems,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$328d05d650390cfd)
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchMessage, {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$1245780b529c0d82)
    }, formatMessage((0, $kqKGs.default).loading)), !isLoading && !hasResult && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25a4fcce187183d2$var$ContextMenuSearchMessage, {
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$803f51dcf576f554)
    }, formatMessage((0, $kqKGs.default).noResults)), !isLoading && hasResult && children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazqjbk _18u0u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$SearchWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4el4l _4t3izwfg _1e0c1txw _4cvr1h6o _n7zlh6cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$ContextMenuSearchContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxViewportItems: maxViewportItems, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8dv613": (0, $lD23V.default)(`${(0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9) * __cmplp.maxViewportItems}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71lx1ju _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25a4fcce187183d2$var$ContextMenuSearchMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o _syaz1thw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqKGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62d973eb0093b5e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e62d973eb0093b5e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    search: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.search",
        "defaultMessage": "Search"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.loading",
        "defaultMessage": "Loading..."
    },
    noResults: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.no-results",
        "defaultMessage": "No results"
    }
});

});

parcelRegister("lPUo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1e43b54ce9834d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $fraBZ = parcelRequire("fraBZ");

var $koVbs = parcelRequire("koVbs");


var $ll7Ps = parcelRequire("ll7Ps");
/** Generate a JSX friendly string filled with spaces */ const $5b1e43b54ce9834d$var$generateRandomSpaces = (max = 100)=>{
    const numSpaces = Math.round(Math.random() * max);
    return new Array(numSpaces).fill('\u00a0').join('');
};
const $5b1e43b54ce9834d$var$appendRandomSpacesToString = (text)=>`${text}${$5b1e43b54ce9834d$var$generateRandomSpaces()}`;
/**
 *
 * Triggers screenreader announcements of loading state and search result count
 */ const $5b1e43b54ce9834d$var$ResultsAnnouncer = ({ query: query, resultsCount: resultsCount, isAsyncSearch: isAsyncSearch, isLoading: isLoading })=>{
    const [message, setMessage] = (0, $5uXOq.useState)('');
    const hasMounted = (0, $5uXOq.useRef)(false);
    const prevLoading = (0, $5uXOq.useRef)(false);
    const prevQuery = (0, $5uXOq.useRef)(query);
    const prevCount = (0, $5uXOq.useRef)(resultsCount);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const setResultsMessage = (0, $5uXOq.useCallback)((count)=>{
        setMessage(/**
     * We need to append a random number of empty spaces to messages to
     * make them unique and force a re-announcement for two reasons:
     * 1) When the query has changed but the results count is the same,
     *    so the message wouldn't have changed
     * 2) During VoiceOver testing, it appeared that on ocassion the same
     *    message being output in a short space of time; even when a
     *    unique message was sandwiched in between; lead to messages being
     *    ignored by the screenreader.
     *
     * Although in theory AnnouncerV2 is built to handle these scenarios,
     * in testing this was not the case.
     */ $5b1e43b54ce9834d$var$appendRandomSpacesToString(formatMessage((0, $ll7Ps.default).resultsAnnouncement, {
            count: count
        })));
    }, [
        formatMessage
    ]);
    /**
   * The updating of the message is debounced as 'query'
   * updates in real time, but the on change callback
   * that triggers the updating of results is itself debounced.
   * We only want to update the message once we've received the
   * new results, not everytime the query changes.
   */ const setMessageDebounced = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newCount, newQuery, loading)=>{
            if (loading) setMessage($5b1e43b54ce9834d$var$appendRandomSpacesToString(formatMessage((0, $ll7Ps.default).loading)));
            else if (isAsyncSearch && prevLoading.current) setResultsMessage(newCount);
            else if (!isAsyncSearch && newQuery !== prevQuery.current) setResultsMessage(newCount);
            prevLoading.current = loading;
            prevCount.current = newCount;
            prevQuery.current = newQuery;
        }, (0, $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9) + 50), [
        isAsyncSearch,
        formatMessage,
        setResultsMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasMounted.current) hasMounted.current = true;
        else setMessageDebounced(resultsCount, query, isLoading);
    }, [
        isLoading,
        query,
        resultsCount,
        setMessageDebounced
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
        message: message
    });
};
var $5b1e43b54ce9834d$export$2e2bcd8739ae039 = $5b1e43b54ce9834d$var$ResultsAnnouncer;

});
parcelRegister("fraBZ", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f73a83ae5cba96ea$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");
const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $5uXOq.useRef)('');
    const setAlternatePolite = (0, $5uXOq.useRef)(false);
    const addSuffix = (0, $5uXOq.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
    const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $5uXOq.createElement((0, $dqoiX.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $f73a83ae5cba96ea$var$positionRelative = null;

});

parcelRegister("ll7Ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3de096429e18f50$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e3de096429e18f50$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resultsAnnouncement: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.results-announcement",
        "defaultMessage": "{count, plural, =0 {no results found} one {one result found} other {# results found}}"
    },
    loading: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.context-menu-search.results-announcer.loading",
        "defaultMessage": "Loading results"
    }
});

});



parcelRegister("1z3OV", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNode", () => $e9e5f3b0ca8b78ac$export$b809af7ff33fc17d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $95EVP = parcelRequire("95EVP");

var $1HF4Y = parcelRequire("1HF4Y");

var $duCCb = parcelRequire("duCCb");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $5wSOB = parcelRequire("5wSOB");


var $569Yl = parcelRequire("569Yl");

var $42KkK = parcelRequire("42KkK");

var $5u1jX = parcelRequire("5u1jX");
const $e9e5f3b0ca8b78ac$export$b809af7ff33fc17d = ({ scope: scope, menuNode: menuNode, onClick: onClick, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $6U9Sv.useContextMenuAnalytics)();
    const { closeMenu: closeMenu } = (0, $ewaBk.useContextMenuActions)();
    const getMenuItemNodeProps = (0, $5uXOq.useCallback)((menuItem)=>{
        const analyticsEvent = addMappedAnalyticsToEvent(createAnalyticsEvent({
            actionSubject: 'dropdownItem',
            action: 'clicked'
        }), menuItem.id, menuItem.analytics);
        return {
            scope: scope,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            analyticsEvent: analyticsEvent.clone(),
            closeMenu: ()=>{
                closeMenu(scope);
                fireUIAnalyticsForNode(analyticsEvent, menuItem.id, menuItem.analytics);
            },
            onClick: onClick,
            onMouseEnter: onMouseEnter
        };
    }, [
        createAnalyticsEvent,
        fireUIAnalyticsForNode,
        addMappedAnalyticsToEvent,
        closeMenu,
        scope,
        onClick,
        onMouseEnter
    ]);
    const renderNode = (0, $5uXOq.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9e5f3b0ca8b78ac$export$b809af7ff33fc17d, {
            scope: scope,
            menuNode: node,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClick,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Section) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5u1jX.ContextMenuSection), {
        section: menuNode
    }, menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Item) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        scope: scope,
        menuItem: menuNode,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        shouldRenderToParent: shouldRenderToParent
    }, /*#__PURE__*/ (0, $5uXOq.isValidElement)(menuNode.element) ? menuNode.element : menuNode.children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    })));
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextualAnalyticsDataFromNode), {
        id: menuNode.id,
        updater: menuNode.analytics
    }, typeof menuNode.node === 'function' ? menuNode.node(getMenuItemNodeProps(menuNode)) : menuNode.node);
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Separator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9e5f3b0ca8b78ac$var$ContextMenuSeparator, {
        tabIndex: -1,
        "data-testid": (0, $b6a39f6f0587f06b$export$c1dbf4585c850e82)
    });
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).BulkIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5wSOB.BulkIndicator), {
        selectedCount: menuNode.selectedCount,
        "data-testid": (0, $b6a39f6f0587f06b$export$4502867028c77602)
    });
    if (menuNode.type === (0, $1HF4Y.MenuNodeType).Search) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42KkK.ContextMenuSearch), {
        onChange: menuNode.onChange,
        autoFocus: menuNode.autoFocus,
        maxViewportItems: menuNode.maxViewportItems,
        hasSearch: menuNode.hasSearch,
        isAsyncSearch: menuNode.isAsyncSearch,
        isLoading: menuNode.isLoading ?? false,
        hasResult: !!menuNode.children?.length,
        ariaLabel: menuNode.ariaLabel,
        resultsCount: menuNode.children.length
    }, !menuNode.isLoading && !!menuNode.children?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuNode.children,
        renderNode: renderNode
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9e5f3b0ca8b78ac$var$ContextMenuSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _1bsb1osq _11q7hloo _18s8swc3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("duCCb", function(module, exports) {

$parcel$export(module.exports, "ContextMenuNodeList", () => $47ad7749cf48ddcf$export$59ef8d374540d9f8);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $47ad7749cf48ddcf$var$listStyles = (0, $jJ1Sb.xcss)({
    listStyle: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
const $47ad7749cf48ddcf$var$listItemStyles = (0, $jJ1Sb.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $47ad7749cf48ddcf$export$59ef8d374540d9f8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuNodes: menuNodes, renderNode: renderNode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "ul",
        xcss: $47ad7749cf48ddcf$var$listStyles
    }, menuNodes.map((menuNode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            as: "li",
            key: menuNode.id,
            xcss: $47ad7749cf48ddcf$var$listItemStyles
        }, renderNode(menuNode)))));

});

parcelRegister("5wSOB", function(module, exports) {

$parcel$export(module.exports, "BulkIndicator", () => $2482d2d0b9107db7$export$1dde12b63932e6bf);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bxhgD = parcelRequire("bxhgD");

var $koVbs = parcelRequire("koVbs");

var $6vzTF = parcelRequire("6vzTF");
const $2482d2d0b9107db7$export$1dde12b63932e6bf = ({ selectedCount: selectedCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2482d2d0b9107db7$var$BulkIndicatorContainer, {
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: "primary"
    }, selectedCount), " ", formatMessage((0, $6vzTF.messages).selected));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2482d2d0b9107db7$var$BulkIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1e0c1txw _1yt4ie5z _4cvr1h6o _1p1dangw _syazjjyb _11c8qk37 _k48p1wq8 _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6vzTF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9948278016d09b9e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9948278016d09b9e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    selected: {
        "id": "software-context-menu.menu-renderer.context-menu-inner.context-menu-node.bulk-indicator.selected",
        "defaultMessage": "Selected"
    }
});

});


const $b6a39f6f0587f06b$export$c1dbf4585c850e82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-separator';
const $b6a39f6f0587f06b$export$4502867028c77602 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-bulk-indicator';

parcelRegister("569Yl", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItem", () => $78a51cd7033d0a1b$export$16a26dc176a49100);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lm9d2 = parcelRequire("lm9d2");


var $ewaBk = parcelRequire("ewaBk");

var $byRc1 = parcelRequire("byRc1");

var $eskuB = parcelRequire("eskuB");

var $lCAQO = parcelRequire("lCAQO");
const $78a51cd7033d0a1b$var$OverflowVisiblePopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($78a51cd7033d0a1b$var$OverflowVisiblePopupContainerStyled, {
        ...props,
        ref: ref,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$75f77b2251314894)
    }, children));
const $78a51cd7033d0a1b$export$16a26dc176a49100 = ({ scope: scope, menuItem: menuItem, children: children, onMouseEnter: onMouseEnter, shouldRenderToParent: shouldRenderToParent = true, ...others })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const { setForcedFocusPath: setForcedFocusPath } = (0, $ewaBk.useContextMenuActions)();
    const shouldFocus = (0, $ewaBk.useShouldForceFocus)({
        scope: scope,
        menuItem: menuItem
    });
    const { persistentFocus: persistentFocus, enablePersistentFocus: enablePersistentFocus, disablePersistentFocus: disablePersistentFocus, isOpen: isOpen } = (0, $lCAQO.useSubmenuPersistentFocus)({
        menuItem: menuItem,
        scope: scope
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (ref.current !== null && document.activeElement !== ref.current) {
            if (shouldFocus) {
                ref.current?.focus();
                setForcedFocusPath(scope, undefined);
            }
        }
    }, [
        shouldFocus,
        scope,
        setForcedFocusPath
    ]);
    const Content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eskuB.SubmenuContainer), {
            width: menuItem.submenuWidth,
            shouldOverflowChildren: menuItem.shouldOverflowChildren,
            persistentFocus: persistentFocus
        }, children), [
        menuItem.submenuWidth,
        menuItem.shouldOverflowChildren,
        children,
        persistentFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
        autoFocus: false,
        offset: [
            0,
            0
        ],
        isOpen: !!isOpen && !!children,
        popupComponent: menuItem.shouldOverflowChildren ? $78a51cd7033d0a1b$var$OverflowVisiblePopupContainer : undefined,
        content: Content,
        placement: "right-start",
        shouldRenderToParent: shouldRenderToParent,
        trigger: ({ ref: popupRef, ...popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byRc1.ContextMenuItemButton), {
                ...popupProps,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    ref.current = r;
                },
                isOpen: isOpen,
                hasChildren: !!children,
                menuItem: menuItem,
                onOpenWithKeyboard: enablePersistentFocus,
                onMouseEnter: (node)=>{
                    disablePersistentFocus();
                    onMouseEnter(node);
                },
                ...others
            })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $78a51cd7033d0a1b$var$OverflowVisiblePopupContainerStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _2rko1l7b _16qs1mxi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("byRc1", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItemButton", () => $e9c66628c383ba02$export$c41377fb9346496d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2xkq3 = parcelRequire("2xkq3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $2OMDV = parcelRequire("2OMDV");

var $7D59a = parcelRequire("7D59a");

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$StyledContextMenuItemButton, {
        ...props,
        ref: ref
    })));
const $e9c66628c383ba02$export$90c1cb250e648e1f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, hasChildren: hasChildren }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, menuItem.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e9c66628c383ba02$var$contextMenuIconStyles
    }, menuItem.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuLabel, {
        ref: ref,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f)
    }, typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()), hasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))), {
        label: menuItem.id,
        testId: (0, $d9cdb1c71f9dbf8c$export$ef86d72244e00c00)
    })));
const $e9c66628c383ba02$export$7387ff9c7ca7b0ae = ()=>(0, $5uXOq.useRef)(null);
const $e9c66628c383ba02$export$c41377fb9346496d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, isOpen: isOpen, onMouseEnter: onMouseEnter, onClick: onClick, hasChildren: hasChildren, onOpenWithKeyboard: onOpenWithKeyboard }, ref)=>{
    const [hasEllipsis, setHasEllipsis] = (0, $5uXOq.useState)(false);
    const labelRef = $e9c66628c383ba02$export$7387ff9c7ca7b0ae();
    const onMouseEnterHandler = (0, $7D59a.useEvent)(()=>onMouseEnter(menuItem));
    const onHandleClick = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        if (e.detail === 0) onOpenWithKeyboard?.();
        onClick(menuItem, analyticsEvent);
    });
    const onHandleKeyDown = (0, $7D59a.useEvent)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    });
    (0, $5uXOq.useEffect)(()=>{
        if (labelRef.current) {
            const isContentOverflowing = labelRef.current.scrollWidth > labelRef.current.clientWidth;
            setHasEllipsis(isContentOverflowing);
        }
    }, [
        labelRef
    ]);
    const commonProps = {
        'data-testid': (0, $d9cdb1c71f9dbf8c$export$8e765acf3440e0b),
        ref: ref,
        isOpen: isOpen,
        onClick: onHandleClick,
        onMouseEnter: onMouseEnterHandler,
        onKeyDown: onHandleKeyDown
    };
    return hasEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        testId: (0, $d9cdb1c71f9dbf8c$export$602eb83148423ac6),
        content: typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()
    }, ({ ref: tooltipRef, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
            ...rest,
            ...commonProps,
            ...hasChildren && {
                'aria-expanded': !!isOpen
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
            hasChildren: hasChildren,
            menuItem: menuItem,
            ref: (r)=>{
                labelRef.current = r;
                tooltipRef(r);
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
        ...commonProps,
        ...hasChildren && {
            'aria-expanded': !!isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
        hasChildren: hasChildren,
        menuItem: menuItem,
        ref: labelRef
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9c66628c383ba02$var$StyledContextMenuItemButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1e5h _1yt413su _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _zulp1b66 _7ehiglyw _1bg41i6y",
            __cmplp.isOpen ? "_bfhk29zg" : "_bfhk1kw7",
            __cmplp.isOpen ? "_syaz16q2" : "_syaz1fxt",
            __cmplp.isOpen ? "_irr329zg" : "_irr31nz6",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$ContextMenuLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81oud _16jlkb7n _1o9zkb7n _i0dlf1ug _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$contextMenuIconStyles = (0, $jJ1Sb.xcss)({
    paddingRight: 'space.100'
});

});

parcelRegister("eskuB", function(module, exports) {

$parcel$export(module.exports, "SubmenuContainer", () => $b53c71158999a9c9$export$5e6b4e3ac9115f51);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ao4Ml = parcelRequire("ao4Ml");

const $b53c71158999a9c9$var$stopPropagation = (e)=>{
    e.stopPropagation();
};
const $b53c71158999a9c9$export$5e6b4e3ac9115f51 = ({ children: children, width: width = (0, $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50), shouldOverflowChildren: shouldOverflowChildren, persistentFocus: persistentFocus = false })=>{
    const contextMenuContainerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const eventRef = contextMenuContainerRef.current;
        eventRef?.addEventListener('mousedown', $b53c71158999a9c9$var$stopPropagation);
        return ()=>{
            eventRef?.removeEventListener('mousedown', $b53c71158999a9c9$var$stopPropagation);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !persistentFocus,
        persistentFocus: persistentFocus,
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b53c71158999a9c9$export$4f48a5067cf73390, {
        width: width,
        ref: contextMenuContainerRef,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9),
        shouldOverflowChildren: shouldOverflowChildren
    }, children));
};
const $b53c71158999a9c9$export$4f48a5067cf73390 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldOverflowChildren: shouldOverflowChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71bhr _c71l1kdj _vchhusvi _1pby16oo _2rko1l7b _1e0c1ule _1bsb1hdq",
            __cmplp.shouldOverflowChildren ? "_1reoewfl" : "_1reo15vq",
            __cmplp.shouldOverflowChildren ? "_18m9ewfl" : "_18m91wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCAQO", function(module, exports) {

$parcel$export(module.exports, "useSubmenuPersistentFocus", () => $867263bf48b9fe05$export$c220508d7e1c51c3);

var $5uXOq = parcelRequire("5uXOq");

var $1HF4Y = parcelRequire("1HF4Y");

var $ewaBk = parcelRequire("ewaBk");
const $867263bf48b9fe05$export$c220508d7e1c51c3 = ({ scope: scope, menuItem: menuItem })=>{
    const isOpen = (0, $ewaBk.useMenuItemCheckOpen)({
        scope: scope,
        menuItem: menuItem
    });
    const hasSearch = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $5uXOq.isValidElement)(menuItem.element) ? menuItem.element.props.hasSearch : menuItem.children?.some((s)=>s.type === (0, $1HF4Y.MenuNodeType).Search && s.hasSearch), [
        menuItem.element,
        menuItem.children
    ]);
    const [persistentFocus, setPersistentFocus] = (0, $5uXOq.useState)(hasSearch);
    const disablePersistentFocus = (0, $5uXOq.useCallback)(()=>{
        if (!hasSearch) setPersistentFocus(false);
    }, [
        hasSearch
    ]);
    return {
        persistentFocus: persistentFocus && isOpen,
        enablePersistentFocus: ()=>{
            setPersistentFocus(true);
        },
        disablePersistentFocus: disablePersistentFocus,
        isOpen: isOpen
    };
};

});


parcelRegister("5u1jX", function(module, exports) {

$parcel$export(module.exports, "ContextMenuSection", () => $daff62afbe1eff3f$export$804016f6c3dde223);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $daff62afbe1eff3f$export$804016f6c3dde223 = ({ section: section, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": (0, $b98e06fd6c153c34$export$6f322a4f1f85b809)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($daff62afbe1eff3f$var$ContextMenuSectionLabel, null, section.label), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $daff62afbe1eff3f$var$ContextMenuSectionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1thw _1yt418iy _11c81vlj _1p1dangw",
            __cmplp.className
        ])
    });
});

});
const $b98e06fd6c153c34$export$6f322a4f1f85b809 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-section';



parcelRegister("9Mj0A", function(module, exports) {

$parcel$export(module.exports, "ContextMenuInner", () => $c120d179a7545147$export$bcdb1c07321c5951);
$parcel$export(module.exports, "A11yList", () => $c120d179a7545147$export$eb8d03735465a5c2);
$parcel$export(module.exports, "A11yListItem", () => $c120d179a7545147$export$c545894512c6d817);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iAbh9 = parcelRequire("iAbh9");

var $7D59a = parcelRequire("7D59a");

var $1HF4Y = parcelRequire("1HF4Y");

var $duCCb = parcelRequire("duCCb");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $1z3OV = parcelRequire("1z3OV");

var $9uF0N = parcelRequire("9uF0N");

var $8KGNe = parcelRequire("8KGNe");
const $c120d179a7545147$export$bcdb1c07321c5951 = ({ scope: scope, menuItems: menuItems, openPath: openPath, shouldRenderToParent: shouldRenderToParent = true })=>{
    const { closeMenu: closeMenu, openSubMenu: openSubMenu, closeSubMenu: closeSubMenu, setForcedFocusPath: setForcedFocusPath, setPersistentFocus: setPersistentFocus } = (0, $ewaBk.useContextMenuActions)();
    const previousItemFocusPath = (0, $5uXOq.useRef)(undefined);
    const { addMappedAnalyticsToEvent: addMappedAnalyticsToEvent, fireUIAnalyticsForNode: fireUIAnalyticsForNode } = (0, $6U9Sv.useContextMenuAnalytics)();
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const isPersistentFocus = (0, $ewaBk.useIsPersistentFocus)();
    const handleOpenSubMenu = (0, $5uXOq.useCallback)((menuItem)=>{
        previousItemFocusPath.current = menuItem.id;
        openSubMenu(scope, menuItem);
    }, [
        scope,
        openSubMenu
    ]);
    const handleCloseSubMenu = (0, $5uXOq.useCallback)(()=>{
        closeSubMenu(scope);
    }, [
        scope,
        closeSubMenu
    ]);
    const onClickContentMenuNode = (0, $7D59a.useEvent)((menuItem, analyticsEvent)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Item) {
            if ((0, $8KGNe.hasSubmenuItems)(menuItem)) {
                if (!(0, $8KGNe.isSubmenuOpen)(openPath)) // clicked on menu item - submenu closed
                handleOpenSubMenu(menuItem);
                else if ((0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) // click on opened menu item - submenu open
                handleCloseSubMenu();
                else if (!(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) {
                    // clicked on different menu item - submenu open
                    handleCloseSubMenu();
                    handleOpenSubMenu(menuItem);
                }
            } else {
                // clicked on root menu item
                const event = addMappedAnalyticsToEvent(analyticsEvent, menuItem.id, menuItem.analytics);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                menuItem.onClick?.(event.clone());
                bulkOpsFlow?.executeAction();
                const attributes = bulkOpsFlow?.getFlowAttributes();
                fireUIAnalyticsForNode(event, menuItem.id, menuItem.analytics, {
                    ...attributes,
                    asdfsadf: 'asdfasdf'
                });
                closeMenu(scope);
            }
        }
    });
    const onMouseEnter = (0, $7D59a.useEvent)((menuItem)=>{
        if (isPersistentFocus) setPersistentFocus(false);
        if (!(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath) && menuItem.type === (0, $1HF4Y.MenuNodeType).Item && (0, $8KGNe.hasSubmenuItems)(menuItem)) {
            /*
                 setTimeout is needed to avoid conflicting situation, when 2 updates are being kicked off
                 at the same time because react-sweet-state batches updates.
                */ setTimeout(()=>{
                // hovered on menu item - submenu closed
                handleOpenSubMenu(menuItem);
            }, 0);
            return;
        }
        if ((0, $8KGNe.isSubmenuOpen)(openPath) && !(0, $8KGNe.isSubmenuOpenForNode)(menuItem, openPath)) {
            // We don't want to focus any element when closing a submenu because of `mouseLeave`
            previousItemFocusPath.current = undefined;
            closeSubMenu(scope);
        }
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Item) menuItem.onMouseEnter?.();
    });
    const renderNode = (0, $5uXOq.useCallback)((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z3OV.ContextMenuNode), {
            scope: scope,
            menuNode: node,
            onClick: onClickContentMenuNode,
            onMouseEnter: onMouseEnter,
            shouldRenderToParent: shouldRenderToParent
        }), [
        onClickContentMenuNode,
        onMouseEnter,
        scope,
        shouldRenderToParent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $8KGNe.isSubmenuOpen)(openPath) && previousItemFocusPath.current !== undefined) {
            setForcedFocusPath(scope, previousItemFocusPath.current);
            previousItemFocusPath.current = undefined;
        }
    }, [
        openPath,
        scope,
        setForcedFocusPath
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleEscapeNavigation = (ev)=>{
            if (ev.key === 'Escape') {
                ev.preventDefault();
                if ((0, $8KGNe.isSubmenuOpen)(openPath)) handleCloseSubMenu();
                else closeMenu(scope);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keyup', handleEscapeNavigation);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keyup', handleEscapeNavigation);
        };
    }, [
        scope,
        closeMenu,
        handleCloseSubMenu,
        openPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9uF0N.FocusLockedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duCCb.ContextMenuNodeList), {
        menuNodes: menuItems,
        renderNode: renderNode
    }));
};
const $c120d179a7545147$export$eb8d03735465a5c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $c120d179a7545147$export$c545894512c6d817 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9uF0N", function(module, exports) {

$parcel$export(module.exports, "FocusLockedWrapper", () => $d7f44222f705e1f7$export$788065bfcceceaa3);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");


var $6ssLS = parcelRequire("6ssLS");

var $ewaBk = parcelRequire("ewaBk");
const $d7f44222f705e1f7$var$WrapperDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onFocus: onFocus, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d7f44222f705e1f7$var$ContextMenuInnerContainer, {
        ref: ref,
        onFocus: onFocus,
        "data-testid": (0, $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9)
    }, children));
const $d7f44222f705e1f7$export$788065bfcceceaa3 = ({ children: children })=>{
    const isPersistentFocus = (0, $ewaBk.useIsPersistentFocus)();
    const [focuslockDisabled, setFocuslockDisabled] = (0, $5uXOq.useState)(!isPersistentFocus);
    const ref = (0, $5uXOq.useRef)(null);
    const onFocus = (0, $5uXOq.useCallback)((e)=>{
        if (focuslockDisabled && ref.current?.contains(e.target)) setFocuslockDisabled(false);
    }, [
        focuslockDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d7f44222f705e1f7$var$WrapperDiv, {
        onFocus: onFocus,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: focuslockDisabled,
        persistentFocus: isPersistentFocus,
        autoFocus: false
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d7f44222f705e1f7$var$ContextMenuInnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pby1nn1 _1reoewfl _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8KGNe", function(module, exports) {

$parcel$export(module.exports, "hasSubmenuItems", () => $c903fbd3aaf7f502$export$a141a5e74a818335);
$parcel$export(module.exports, "isSubmenuOpen", () => $c903fbd3aaf7f502$export$5870693bd83d8526);
$parcel$export(module.exports, "isSubmenuOpenForNode", () => $c903fbd3aaf7f502$export$e36cf825fe8902f3);

var $5uXOq = parcelRequire("5uXOq");
const $c903fbd3aaf7f502$export$a141a5e74a818335 = (menuNode)=>/*#__PURE__*/ (0, $5uXOq.isValidElement)(menuNode.element) || !!menuNode.children && menuNode.children.length > 0;
const $c903fbd3aaf7f502$export$5870693bd83d8526 = (openPath)=>!!openPath;
const $c903fbd3aaf7f502$export$e36cf825fe8902f3 = (menuNode, openPath)=>$c903fbd3aaf7f502$export$5870693bd83d8526(openPath) && menuNode.id.startsWith(openPath);

});


parcelRegister("64FxD", function(module, exports) {

$parcel$export(module.exports, "UnlinkMenuItem", () => $afa52bde1cb88c47$export$bbb2afae2486e136);

var $5uXOq = parcelRequire("5uXOq");

var $1HF4Y = parcelRequire("1HF4Y");

var $569Yl = parcelRequire("569Yl");

var $5L7dD = parcelRequire("5L7dD");

var $9nlJl = parcelRequire("9nlJl");
const $afa52bde1cb88c47$export$bbb2afae2486e136 = ({ selectedCardIds: selectedCardIds, label: label, menuItemNodeArgs: menuItemNodeArgs })=>{
    const removeIssuesFromAllVersions = (0, $5L7dD.useRemoveIssuesFromAllVersionsMutation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu/value__unlink`,
            label: label,
            onClick: (analyticsEvent)=>{
                removeIssuesFromAllVersions(selectedCardIds, analyticsEvent);
            }
        }
    });
};

});
parcelRegister("5L7dD", function(module, exports) {

$parcel$export(module.exports, "useRemoveIssuesFromAllVersionsMutation", () => $b825e2a5e9ece079$export$a54d2e97907396b7);

var $3k05e = parcelRequire("3k05e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dJl1T = parcelRequire("dJl1T");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $98kub = parcelRequire("98kub");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $87wCD = parcelRequire("87wCD");


var $66hgZ = parcelRequire("66hgZ");
const $b825e2a5e9ece079$export$a54d2e97907396b7 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const boardAri = (0, $98kub.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitFn] = (0, $8Uumt.useMutation)((0, $3k05e.default));
    const removeIssuesFromAllVersionsCallback = (0, $5uXOq.useCallback)((issueIds, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $98kub.createIssueAris)(cloudId, issueIds)
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'removeIssuesFromAllVersions',
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    type: 'error',
                    title: (0, $66hgZ.default).versionUpdateErrorTitle,
                    description: (0, $66hgZ.default).versionUpdateErrorDescription
                });
                (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.removeVersions', 'An error occurred when removing versions from issues in AGG', error);
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    operation: 'removeIssuesFromAllVersions',
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    error: error,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return removeIssuesFromAllVersionsCallback;
};

});
parcelRegister("3k05e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c283a660b1b1edf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9fd95210a3543ee41d4cf601829b9166>>
 * @relayHash 54f53df9c971403cebb9ceaed9ca1232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500
const $c283a660b1b1edf9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "JiraVersionIssueUpdateResult",
        "kind": "LinkedField",
        "name": "issueUpdateResults",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "issueId"
            },
            {
                "kind": "ScalarField",
                "name": "updated"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "content_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRemoveIssuesFromAllFixVersionsPayload",
                            "kind": "LinkedField",
                            "name": "removeIssuesFromAllFixVersions",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "versions",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0fa9669b974f688d91987636bbf14d3c1803a4bc062e179d0a09931e8f04d500",
            "metadata": {},
            "name": "useRemoveIssuesFromAllVersionsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c283a660b1b1edf9$var$node.hash = "d60aafd65f63c4583af72cc4c256ebbf";
var $c283a660b1b1edf9$export$2e2bcd8739ae039 = $c283a660b1b1edf9$var$node;

});

parcelRegister("98kub", function(module, exports) {

$parcel$export(module.exports, "createBoardAri", () => $cad1f489de8b3413$export$a9ef0ce47eb35304);
$parcel$export(module.exports, "createIssueAris", () => $cad1f489de8b3413$export$7a8bc17d57772015);

var $dXq4S = parcelRequire("dXq4S");
const $cad1f489de8b3413$export$a9ef0ce47eb35304 = (cloudId, boardId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
const $cad1f489de8b3413$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId.toString()
    });
const $cad1f489de8b3413$export$7a8bc17d57772015 = (cloudId, issueIds)=>issueIds.map((issueId)=>$cad1f489de8b3413$export$6b0ec881a3540845(cloudId, issueId));

});

parcelRegister("66hgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c80fa85725559e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $76c80fa85725559e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    // non-final until text is finalised
    versionUpdateErrorTitle: {
        "id": "backlog.common.hooks.version-update-error-title-non-final",
        "defaultMessage": "Failed to update"
    },
    versionUpdateErrorDescription: {
        "id": "backlog.common.hooks.version-update-error-description-non-final",
        "defaultMessage": "Refresh the page and try again."
    }
});

});



parcelRegister("cHomS", function(module, exports) {

$parcel$export(module.exports, "VersionMenuItem", () => $80374c424d657fc6$export$ea9d65dd05b6ef3d);

var $c8QhZ = parcelRequire("c8QhZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1HF4Y = parcelRequire("1HF4Y");

var $569Yl = parcelRequire("569Yl");

var $5lB2h = parcelRequire("5lB2h");

var $9nlJl = parcelRequire("9nlJl");
const $80374c424d657fc6$export$ea9d65dd05b6ef3d = ({ selectedCardIds: selectedCardIds, versionEdge: versionEdge, menuItemNodeArgs: menuItemNodeArgs })=>{
    const { node: { id: versionAri, versionId: versionId, name: name } } = (0, $8Uumt.useFragment)((0, $c8QhZ.default), versionEdge);
    const addIssuesToVersionMutation = (0, $5lB2h.useAddIssuesToVersionMutation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $569Yl.ContextMenuItem), {
        ...menuItemNodeArgs,
        menuItem: {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${(0, $9nlJl.VERSION_MENU_ID)}/menu/value__${versionId}`,
            label: name,
            onClick: (analyticsEvent)=>{
                addIssuesToVersionMutation(selectedCardIds, versionAri, analyticsEvent);
            }
        }
    });
};

});
parcelRegister("c8QhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc119bf92adc52a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fdc3b26ca7718aac65ae162c41620f87>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cdc119bf92adc52a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "versionMenuItem_softwareBacklog",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        "action": "THROW",
                        "path": "node.id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "versionId"
                        },
                        "action": "THROW",
                        "path": "node.versionId"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        "action": "THROW",
                        "path": "node.name"
                    }
                ]
            },
            "action": "THROW",
            "path": "node"
        }
    ],
    "type": "JiraVersionEdge"
};
$cdc119bf92adc52a$var$node.hash = "abd3a2327d76d6cec48e7802950c72b4";
var $cdc119bf92adc52a$export$2e2bcd8739ae039 = $cdc119bf92adc52a$var$node;

});

parcelRegister("5lB2h", function(module, exports) {

$parcel$export(module.exports, "useAddIssuesToVersionMutation", () => $61933e51e48e09a3$export$af7b1139de7c94fd);

var $1MyL6 = parcelRequire("1MyL6");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dJl1T = parcelRequire("dJl1T");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $98kub = parcelRequire("98kub");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $87wCD = parcelRequire("87wCD");


var $66hgZ = parcelRequire("66hgZ");
const $61933e51e48e09a3$export$af7b1139de7c94fd = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const boardId = (0, $c1MAf.useBacklogSelector)((state)=>Number((0, $jG5HW.getRapidViewId)(state)));
    const boardAri = (0, $98kub.createBoardAri)(cloudId, boardId);
    const onIssueVersionsUpdated = (0, $87wCD.useOnIssueVersionsUpdated)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitFn] = (0, $8Uumt.useMutation)((0, $1MyL6.default));
    const addIssuesToVersionCallback = (0, $5uXOq.useCallback)((issueIds, versionAri, analyticsEvent)=>{
        commitFn({
            variables: {
                input: {
                    issueIds: (0, $98kub.createIssueAris)(cloudId, issueIds),
                    versionId: versionAri
                },
                boardId: boardAri
            },
            onCompleted: ()=>{
                // Request card data refresh for redux state and detail view if its open
                onIssueVersionsUpdated(issueIds);
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            },
            onError: (error)=>{
                showFlag({
                    type: 'error',
                    title: (0, $66hgZ.default).versionUpdateErrorTitle,
                    description: (0, $66hgZ.default).versionUpdateErrorDescription
                });
                (0, $dJl1T.default).safeErrorWithoutCustomerData('jiraSoftwareContextMenu.jira.backlog.version.addVersion', 'An error occurred when adding a version to issues in AGG', error);
                (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    analyticsSource: (0, $a9c483c0d986286a$export$840e3848643f7781),
                    operation: 'addIssuesToVersion',
                    error: error,
                    versionAri: versionAri,
                    isContextualEditing: true
                });
            }
        });
    }, [
        cloudId,
        boardAri,
        commitFn,
        onIssueVersionsUpdated,
        showFlag
    ]);
    return addIssuesToVersionCallback;
};

});
parcelRegister("1MyL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $74458424bfb38374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<57f61f45cfd82866851009a9dceff221>>
 * @relayHash ac3a59f9c6df1081d50eada9866054c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b5cfc0f22da01fcc43248e0f4de9d27a91c55774fdf76e3d47dbd40ba19bd3d

var $iWXRl = parcelRequire("iWXRl");
const $74458424bfb38374$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
                }
            ],
            "kind": "Operation",
            "name": "useAddIssuesToVersionMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraAddIssuesToFixVersionPayload",
                            "kind": "LinkedField",
                            "name": "addIssuesToFixVersion",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "versionId"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "releaseDate"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "boardId",
                                                    "variableName": "boardId"
                                                }
                                            ],
                                            "concreteType": "JiraVersionStatistics",
                                            "kind": "LinkedField",
                                            "name": "statistics",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "doneEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalEstimate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "percentageCompleted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "notEstimated"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "done"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "totalIssueCount"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "toDo"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inProgress"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "alias": "editProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "EDIT_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "canPerform"
                                                        }
                                                    ],
                                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1b5cfc0f22da01fcc43248e0f4de9d27a91c55774fdf76e3d47dbd40ba19bd3d",
            "metadata": {},
            "name": "useAddIssuesToVersionMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default)
            }
        }
    };
}();
$74458424bfb38374$var$node.hash = "78cd3b934e90c86f1f62037be8c3d343";
var $74458424bfb38374$export$2e2bcd8739ae039 = $74458424bfb38374$var$node;

});





parcelRegister("chkmj", function(module, exports) {

$parcel$export(module.exports, "useViewInIssueSearch", () => $5288dd69845cfb78$export$95e4f0766878a325);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $dIdda = parcelRequire("dIdda");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $9nlJl = parcelRequire("9nlJl");

var $5Mhvq = parcelRequire("5Mhvq");
const $5288dd69845cfb78$export$b95edc2172de41fe = ({ selectedCardIds: selectedCardIds, cardEntities: cardEntities })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = ()=>{
        const issueKeys = selectedCardIds.map((id)=>cardEntities[String(id)].key);
        const query = encodeURIComponent(`issuekey IN (${issueKeys.join(',')})`);
        push(`/issues/?jql=${query}`);
    };
    if (selectedCardIds.length < 2) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5Mhvq.default).viewInIssueSearchIssueTermRefresh : (0, $5Mhvq.default).viewInIssueSearch),
            id: (0, $9nlJl.VIEW_IN_ISSUE_SEARCH_MENU_ID),
            onClick: handleClick
        }
    ];
};
const $5288dd69845cfb78$export$95e4f0766878a325 = ({ selectedCardIds: selectedCardIds })=>{
    const cardEntities = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return $5288dd69845cfb78$export$b95edc2172de41fe({
        selectedCardIds: selectedCardIds,
        cardEntities: cardEntities
    });
};

});

parcelRegister("jN95k", function(module, exports) {

$parcel$export(module.exports, "default", () => $78470904968aca83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $g4tDr = parcelRequire("g4tDr");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
const $78470904968aca83$var$useCardsIncludeSubtasksWithoutParents = (cardIds)=>{
    const selectedCards = (0, $c1MAf.useBacklogSelector)((state)=>{
        const allCards = (0, $dGljH.getCards)(state);
        return cardIds.map((cardId)=>allCards[cardId]).filter(Boolean);
    });
    const selectedSubtasks = (0, $5uXOq.useMemo)(()=>selectedCards.filter(({ typeHierarchyLevel: typeHierarchyLevel })=>(0, $g4tDr.isSubtaskHierarchyLevel)(typeHierarchyLevel)), [
        selectedCards
    ]);
    return (0, $5uXOq.useMemo)(()=>selectedSubtasks.some(({ parentId: parentId })=>parentId && !cardIds.includes(parentId)), [
        cardIds,
        selectedSubtasks
    ]);
};
var $78470904968aca83$export$2e2bcd8739ae039 = $78470904968aca83$var$useCardsIncludeSubtasksWithoutParents;

});


parcelRegister("5OkdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f17efb921d4520a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2eMTS = parcelRequire("2eMTS");

var $3fAi8 = parcelRequire("3fAi8");


var $hPtZI = parcelRequire("hPtZI");


var $dspDn = parcelRequire("dspDn");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $kAodW = parcelRequire("kAodW");

const $2f17efb921d4520a$export$3ddafe6eb894bff8 = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("bMprb")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $2f17efb921d4520a$var$AssigneeField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [assigneeFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$e18419056f3d184a)
    });
    const value = assigneeFieldValue ? {
        id: assigneeFieldValue.accountId,
        displayName: assigneeFieldValue.displayName,
        avatarUrl: assigneeFieldValue.avatarUrls?.['48x48']
    } : null;
    const issueAssigneeFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAodW.default), {
        value: value
    });
    const handleChange = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditAssigneeInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditAssigneeInteractionStopMark)(isCompanyManaged);
    }, [
        isCompanyManaged
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditAssigneeInteractionMark)();
    }, []);
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.IssueAssigneeFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueAssigneeFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline assignee",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f17efb921d4520a$var$AssigneeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f17efb921d4520a$export$3ddafe6eb894bff8, {
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        onChange: handleChange,
        onUpdate: handleUpdate,
        onFailure: handleFailure
    }))));
    return issueAssigneeFieldStatic;
};
var $2f17efb921d4520a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($2f17efb921d4520a$var$AssigneeField);
const $2f17efb921d4520a$var$AssigneeFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _vsj07079 _qedf1kev _c6p11h90 _15m21prr _96l5agmp _1hgltlke _1j3t6smz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2eMTS", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $40ac4b7314747a71$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $40ac4b7314747a71$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $40ac4b7314747a71$export$9b541007f4ef3ffe);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $fE0Ry = parcelRequire("fE0Ry");

const $40ac4b7314747a71$export$3eed76542de607d2 = (0, $hPtZI.lazy)(()=>(parcelRequire("bMprb")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $40ac4b7314747a71$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40ac4b7314747a71$export$3eed76542de607d2, props)));
const $40ac4b7314747a71$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("bMprb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("amJuG")
]).then(()=>parcelRequire('278RC'));

});


parcelRegister("dspDn", function(module, exports) {

$parcel$export(module.exports, "setInlineEditStatusInteractionStartMark", () => $c55f61321be216c5$export$1c8cae5dc9b7d34a);
$parcel$export(module.exports, "setInlineEditStatusInteractionStopMark", () => $c55f61321be216c5$export$b1acd52e03abb3b2);
$parcel$export(module.exports, "cancelInlineEditStatusInteractionMark", () => $c55f61321be216c5$export$cdaa2d2685d8101e);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStartMark", () => $c55f61321be216c5$export$931331f1846e934f);
$parcel$export(module.exports, "setInlineEditAssigneeInteractionStopMark", () => $c55f61321be216c5$export$40692731bc6535c7);
$parcel$export(module.exports, "cancelInlineEditAssigneeInteractionMark", () => $c55f61321be216c5$export$afc1cc386d2100be);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStartMark", () => $c55f61321be216c5$export$463102067393e83b);
$parcel$export(module.exports, "setInlineEditStoryPointInteractionStopMark", () => $c55f61321be216c5$export$bb93666f630b9a57);
$parcel$export(module.exports, "cancelInlineEditStoryPointInteractionMark", () => $c55f61321be216c5$export$d0a680c7e3623e7b);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStartMark", () => $c55f61321be216c5$export$781c8c2cc1ad3945);
$parcel$export(module.exports, "setInlineEditOriginalEstimateInteractionStopMark", () => $c55f61321be216c5$export$65678122e1338f09);
$parcel$export(module.exports, "cancelInlineEditOriginalEstimateInteractionMark", () => $c55f61321be216c5$export$b728cf17d787205d);

var $8hVbJ = parcelRequire("8hVbJ");
const $c55f61321be216c5$export$1c8cae5dc9b7d34a = ()=>{
    (0, $8hVbJ.inlineEditStatusInteraction).start();
};
const $c55f61321be216c5$export$b1acd52e03abb3b2 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditStatusInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$cdaa2d2685d8101e = ()=>{
    (0, $8hVbJ.inlineEditStatusInteraction).cancel();
};
const $c55f61321be216c5$export$931331f1846e934f = ()=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).start();
};
const $c55f61321be216c5$export$40692731bc6535c7 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$afc1cc386d2100be = ()=>{
    (0, $8hVbJ.inlineEditAssigneeInteraction).cancel();
};
const $c55f61321be216c5$export$463102067393e83b = ()=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).start();
};
const $c55f61321be216c5$export$bb93666f630b9a57 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$d0a680c7e3623e7b = ()=>{
    (0, $8hVbJ.inlineEditStoryPointInteraction).cancel();
};
const $c55f61321be216c5$export$781c8c2cc1ad3945 = ()=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).start();
};
const $c55f61321be216c5$export$65678122e1338f09 = (isCompanyManaged)=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).stop({
        customData: {
            isCompanyManaged: isCompanyManaged
        }
    });
};
const $c55f61321be216c5$export$b728cf17d787205d = ()=>{
    (0, $8hVbJ.inlineEditOriginalEstimateInteraction).cancel();
};

});


parcelRegister("iJZfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $baaa5a692f73b76e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $95EVP = parcelRequire("95EVP");

var $al6I6 = parcelRequire("al6I6");

var $iAbh9 = parcelRequire("iAbh9");

var $acDhY = parcelRequire("acDhY");

var $6s1PB = parcelRequire("6s1PB");

var $6U9Sv = parcelRequire("6U9Sv");

var $c1MAf = parcelRequire("c1MAf");

var $8SI0F = parcelRequire("8SI0F");

var $fopK0 = parcelRequire("fopK0");
const $baaa5a692f73b76e$var$staticEntryPointActions = {
    load: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $baaa5a692f73b76e$var$CheckboxField = ({ isSelected: isSelected, onClick: onClick, isDisabled: isDisabled, shouldShowCheckbox: shouldShowCheckbox })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const sessionAttributes = (0, $iAbh9.useBulkOpsSessionContext)()?.getFlowAttributes();
    const { entryPointActions: entryPointActions } = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? (0, $acDhY.useBulkOpsEntryPoint)() : {
        entryPointActions: $baaa5a692f73b76e$var$staticEntryPointActions
    };
    const fireCheckboxAnalytics = (0, $6U9Sv.useFireCheckboxAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const handleKeyDown = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        if (e.key === 'Space') {
            (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && entryPointActions.load();
            if (isSelected && !shouldShowCheckbox) {
                dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
                return;
            }
            onClick(withCmd, withShift, 'keyboard', true);
        }
    };
    const handleClickCheckbox = (e)=>{
        const withCmd = true; /* always considered true for checkbox as it is used for multiple selection */ 
        const withShift = e.shiftKey;
        (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && entryPointActions.load();
        if (isSelected && !shouldShowCheckbox) {
            dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
            fireCheckboxAnalytics(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'checkbox'
            }), 'backlogCard', {
                isIssueDetailVisible: true,
                numSelectedCards: 1,
                inputSource: (0, $fopK0.getCardSelectionAnalyticsInputSource)(withShift, withCmd, true),
                isCheckboxChecked: isSelected,
                bulkOpsSessionID: sessionAttributes?.bulkOpsSessionID
            });
            return;
        }
        onClick(withCmd, withShift, 'mouse', true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $al6I6.default), {
        isChecked: isSelected && shouldShowCheckbox,
        onKeyDown: handleKeyDown,
        onClick: handleClickCheckbox,
        isDisabled: isDisabled
    });
};
var $baaa5a692f73b76e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($baaa5a692f73b76e$var$CheckboxField);

});
parcelRegister("al6I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b873ffcb2b3221c3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3tZix = parcelRequire("3tZix");

var $oUGyo = parcelRequire("oUGyo");


var $9CQTP = parcelRequire("9CQTP");
var $bAvay = parcelRequire("bAvay");
var $hXNbt = parcelRequire("hXNbt");
var $be6lw = parcelRequire("be6lw");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $b873ffcb2b3221c3$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $b873ffcb2b3221c3$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $3tZix.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $oUGyo.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bAvay.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $b873ffcb2b3221c3$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9CQTP.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hXNbt.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $be6lw.default), null)));
}));
$b873ffcb2b3221c3$var$Checkbox.displayName = 'Checkbox';
var $b873ffcb2b3221c3$export$2e2bcd8739ae039 = $b873ffcb2b3221c3$var$Checkbox;

});
parcelRegister("9CQTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $073c59f51bcd9ac8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aQRdR = parcelRequire("aQRdR");
function $073c59f51bcd9ac8$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $073c59f51bcd9ac8$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$073c59f51bcd9ac8$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aQRdR.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $073c59f51bcd9ac8$export$2e2bcd8739ae039 = $073c59f51bcd9ac8$var$CheckboxIcon;

});

parcelRegister("bAvay", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d48f3bf36664c0f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $1d48f3bf36664c0f$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $1d48f3bf36664c0f$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $1d48f3bf36664c0f$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $1d48f3bf36664c0f$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $5e0c0d4e15efb4a6$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $5e0c0d4e15efb4a6$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $5e0c0d4e15efb4a6$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $1d48f3bf36664c0f$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $1d48f3bf36664c0f$var$baseStyles,
            label && $1d48f3bf36664c0f$var$textLabelLayoutStyles,
            isDisabled && $1d48f3bf36664c0f$var$disabledStyles,
            $1d48f3bf36664c0f$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hXNbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb210e75d82ed232$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $eb210e75d82ed232$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eb210e75d82ed232$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $eb210e75d82ed232$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $eb210e75d82ed232$var$labelTextStyles
    }, children);
}

});

parcelRegister("be6lw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c9a4eada527a4e4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $9c9a4eada527a4e4$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $9c9a4eada527a4e4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $9c9a4eada527a4e4$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});



parcelRegister("lM9Tp", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesMetadata", () => $eebdc4e31971c249$export$56b7a8e50535249e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4NIy5 = parcelRequire("4NIy5");

var $3xpCN = parcelRequire("3xpCN");


var $MGmIU = parcelRequire("MGmIU");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2EHfW = parcelRequire("2EHfW");
const $eebdc4e31971c249$export$56b7a8e50535249e = ({ numTotalChildren: numTotalChildren, numCompleteChildren: numCompleteChildren, onClickThrough: onClickThrough })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!numTotalChildren) return null;
    const message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2EHfW.default).childIssuesMetadataTooltipIssueTermRefresh : (0, $2EHfW.default).childIssuesMetadataTooltip, {
        complete: numCompleteChildren,
        total: numTotalChildren
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eebdc4e31971c249$var$ChildIssuesMetadataWrapper, {
        tabIndex: -1,
        onClick: onClickThrough,
        "data-testid": "software-backlog.card-list.card.card-contents.child-issues-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: message,
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.tooltip"
    }, (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4NIy5))), {
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.child-issues-icon",
        label: "",
        color: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3xpCN))),
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
        LEGACY_size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xpCN))), {
        testId: "software-backlog.card-list.card.card-contents.child-issues-metadata.child-issues-icon",
        primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N300})`,
        size: "small",
        label: ""
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eebdc4e31971c249$var$ChildIssuesMetadataWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _yyhy54tg _1ii7wtyw _3rss1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4NIy5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::573ec388b005b16cfabb95e4ea3d026a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37ee4b780db33014$var$_react = $37ee4b780db33014$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $37ee4b780db33014$var$_UNSAFE_baseNew = $37ee4b780db33014$var$_interopRequireDefault((parcelRequire("huIZN")));
function $37ee4b780db33014$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37ee4b780db33014$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $37ee4b780db33014$var$_react.default.createElement($37ee4b780db33014$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$37ee4b780db33014$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $37ee4b780db33014$var$_default = module.exports.default = $37ee4b780db33014$var$ChildIssuesIcon;

});

parcelRegister("3xpCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293854b1b916857d$var$_react = $293854b1b916857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $293854b1b916857d$var$_childIssues = $293854b1b916857d$var$_interopRequireDefault((parcelRequire("4NIy5")));
function $293854b1b916857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $293854b1b916857d$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $293854b1b916857d$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $293854b1b916857d$var$_childIssues.default
    }));
$293854b1b916857d$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $293854b1b916857d$var$_default = module.exports.default = $293854b1b916857d$var$ChildIssuesIcon;

});

parcelRegister("2EHfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $567ae6b1bc7ab77c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567ae6b1bc7ab77c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadataTooltip: {
        "id": "backlog.card-list.card.card-contents.child-issues-metadata.child-issues-metadata-tooltip",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    },
    childIssuesMetadataTooltipIssueTermRefresh: {
        "id": "backlog.card-list.card.card-contents.child-issues-metadata.child-issues-metadata-tooltip-issue-term-refresh",
        "defaultMessage": "{complete} of {total, plural, one {# child issue} other {# child issues}} complete"
    }
});

});


parcelRegister("2JHi9", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $cfab57ca8e812411$export$48ea269755562084);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $hW6cm = parcelRequire("hW6cm");

var $7xReK = parcelRequire("7xReK");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7q84v = parcelRequire("7q84v");

var $cizWc = parcelRequire("cizWc");
const $cfab57ca8e812411$export$48ea269755562084 = ({ isFlagged: isFlagged, shouldRenderInlineAddFlag: shouldRenderInlineAddFlag, onAddFlag: onAddFlag })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfab57ca8e812411$var$FlagContainer, {
        "data-testid": (0, $cizWc.FLAG_CONTAINER_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: isFlagged ? formatMessage((0, $7q84v.default).flaggedTooltip) : formatMessage((0, $7q84v.default).addFlagTooltip)
    }, isFlagged && ((0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hW6cm))), {
        label: "Add flag icon",
        color: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7xReK))),
        LEGACY_size: "small",
        LEGACY_primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7xReK))), {
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})`,
        label: "Flagged icon",
        testId: (0, $cizWc.FLAGGED_BUTTON_TEST_ID)
    })), !isFlagged && shouldRenderInlineAddFlag && ((0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $cfab57ca8e812411$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        label: "Add Flag" // eslint-disable-next-line jira/react-no-inline-function-prop
        ,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hW6cm))), {
                ...iconProps,
                label: "Add flag icon",
                color: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7xReK))),
                LEGACY_size: "small",
                LEGACY_primaryColor: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`
            }),
        appearance: "subtle",
        spacing: "compact",
        onClick: onAddFlag,
        testId: (0, $cizWc.ADD_FLAG_BUTTON_TEST_ID)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfab57ca8e812411$var$AddFlagButton, {
        "aria-label": "Add Flag",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7xReK))), {
            size: "small",
            primaryColor: `var(--ds-text-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N200})`,
            label: "Add flag icon"
        }),
        spacing: "compact",
        testId: (0, $cizWc.ADD_FLAG_BUTTON_TEST_ID),
        onClick: onAddFlag
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfab57ca8e812411$var$FlagContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfab57ca8e812411$var$AddFlagButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $89thI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4idpf _v564ch4h _19pkmyb0 _2hwxmyb0 _otyrmyb0 _18u0myb0 _16l4kb7n _19lcglyw",
            __cmplp.className
        ])
    });
});
const $cfab57ca8e812411$var$buttonContainerStyle = (0, $jJ1Sb.xcss)({
    display: 'inline-block',
    opacity: '0',
    transition: 'opacity .35s ease',
    ':hover': {
        opacity: '1',
        background: 'none'
    }
});

});

parcelRegister("9U5Ic", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb2c821efde046e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");


var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $95EVP = parcelRequire("95EVP");

var $7q84v = parcelRequire("7q84v");
const $adb2c821efde046e$var$InteractionLayer = ({ cardKey: cardKey, summary: summary, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isFocused: isFocused = false })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (isFocused === true && ref.current !== null && document.activeElement !== ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onKeyDown(e, analyticsEvent);
    }, [
        onKeyDown,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($adb2c821efde046e$export$42a852a2b6b56249, {
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        "aria-label": `${cardKey} ${summary}. ${formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7q84v.default).cardFocusScreenreaderTextIssueTermRefresh : (0, $7q84v.default).cardFocusScreenreaderText)}`,
        "data-testid": "software-backlog.card-list.card.card-contents.interaction-layer.accessible-card",
        onFocus: onFocus,
        onBlur: onBlur,
        ref: ref
    });
};
var $adb2c821efde046e$export$2e2bcd8739ae039 = $adb2c821efde046e$var$InteractionLayer;
const $adb2c821efde046e$var$cardFocusStyles = {
    content: '',
    display: 'block',
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$exports).B200})`}`,
    pointerEvents: 'none'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
const $adb2c821efde046e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1xi2idpf _nt751r31 _49pcglyw _1hvw1o36 _1lztewfl _h10pb3bt _j7gt1ule _1tfxstnw _1v98kb7n _1a07idpf _ti30idpf _44x7idpf _gabdidpf _1n511vt6 _6q10glyw _zjd3b3bt _1vfc1ule _hkspstnw _1hl4kb7n _ehfnidpf _1btaidpf _1vdbidpf _o6k0idpf _1m551vt6 _1191glyw _1m552jkb _bwdwb3bt _6ycq1ule _1h9dstnw _i6g0kb7n _9jtdidpf _1snmidpf _1jstidpf _pnw9idpf _xp6a1vt6 _15y0glyw _xp6a2jkb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5U2yP", function(module, exports) {

$parcel$export(module.exports, "Key", () => $5747c4050e3d8f18$export$cd0f44441c3b7719);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dqoiX = parcelRequire("dqoiX");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");

var $1SqXg = parcelRequire("1SqXg");
const $5747c4050e3d8f18$var$stopPropagation = (event)=>event.stopPropagation();
const $5747c4050e3d8f18$export$cd0f44441c3b7719 = ({ isDone: isDone, cardKey: cardKey, issueUrl: issueUrl, summary: summary, highlightText: highlightText, onClick: cardOnClick })=>{
    const onKeyClick = (0, $5uXOq.useCallback)((e)=>{
        const withCmd = e.ctrlKey || e.metaKey;
        if (!withCmd) {
            e.preventDefault();
            cardOnClick(false, false, 'mouse');
        }
    }, [
        cardOnClick
    ]);
    // When the ScreenReaderKey is focused, it becomes visible and its sibling
    // Key is hidden. This allows the key to behave as a regular link for keyboard
    // users without compromising dnd functionality for mouse users.
    // Previously, the issue page could not be accessed directly via keyboard.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5747c4050e3d8f18$var$KeyContainer, {
        "data-testid": (0, $cizWc.KEY_CONTAINER_TEST_ID),
        onContextMenu: $5747c4050e3d8f18$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.ScreenReaderKey), {
        href: issueUrl,
        isDone: isDone,
        "data-testid": (0, $cizWc.SCREEN_READER_KEY_TEST_ID)
    }, cardKey, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, summary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1SqXg.default), {
        highlightText: highlightText,
        issueUrl: issueUrl,
        isDone: isDone,
        issueKey: cardKey,
        onClick: onKeyClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5747c4050e3d8f18$var$KeyContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n _u5f3cxkx _yyhy1l0g _1ii7wtyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1SqXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0abff13d9b3091$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $k2wwp = parcelRequire("k2wwp");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");
const $ad0abff13d9b3091$var$KeyWithAnalytics = ({ issueUrl: issueUrl, issueKey: issueKey, isDone: isDone, onClick: onClick, highlightText: highlightText })=>{
    const highlight = (0, $5uXOq.useMemo)(()=>highlightText != null ? [
            highlightText
        ] : [], [
        highlightText
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'issue'
        });
        onClick(e, analyticsEvent);
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const handleOnContextMenu = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Key), {
        href: issueUrl,
        tabIndex: -1,
        isDone: isDone,
        onClick: handleClick,
        "aria-hidden": "true",
        onContextMenu: handleOnContextMenu,
        "data-component-selector": (0, $cizWc.KEY_COMPONENT_SELECTOR),
        "data-testid": (0, $cizWc.KEY_COMPONENT_SELECTOR)
    }, highlightText != null && highlightText !== '' && issueKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        text: issueKey,
        highlight: highlight
    }) : issueKey);
};
var $ad0abff13d9b3091$export$2e2bcd8739ae039 = $ad0abff13d9b3091$var$KeyWithAnalytics;

});
parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e9H98 = parcelRequire("e9H98");
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9H98.Mark), {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});
parcelRegister("e9H98", function(module, exports) {

$parcel$export(module.exports, "Mark", () => $ef706e6c8afab51f$export$c9d15bcfc6d42044);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ef706e6c8afab51f$export$c9d15bcfc6d42044 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkwtfv _syaz1fxt",
            __cmplp.className
        ])
    });
});

});





parcelRegister("fuplg", function(module, exports) {

$parcel$export(module.exports, "default", () => $696609a8ce9192b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $ciMkN = parcelRequire("ciMkN");


var $3bPZM = parcelRequire("3bPZM");

var $etKNj = parcelRequire("etKNj");

var $hPtZI = parcelRequire("hPtZI");


var $guzeq = parcelRequire("guzeq");

var $dspDn = parcelRequire("dspDn");

var $c1MAf = parcelRequire("c1MAf");

var $gwOHY = parcelRequire("gwOHY");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $gnK7n = parcelRequire("gnK7n");

var $ayyYR = parcelRequire("ayyYR");

var $80uDK = parcelRequire("80uDK");

var $k4laV = parcelRequire("k4laV");

const $696609a8ce9192b2$var$IssueOriginalEstimateField = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("j1KUi")), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/index.tsx"
});
const $696609a8ce9192b2$var$OriginalEstimateField = ({ issueId: issueId, issueKey: issueKey, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderEstimatesColumn: shouldRenderEstimatesColumn })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const hasEstimate = (0, $c1MAf.useBacklogSelector)((state)=>!!(0, $dGljH.getCards)(state)[String(issueId)]?.estimate);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const intl = (0, $koVbs.default)();
    const [originalEstimateFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)
    });
    const handleConfirm = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditOriginalEstimateInteractionStartMark)();
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditOriginalEstimateInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditOriginalEstimateInteractionMark)();
    }, []);
    if (!shouldRenderEstimatesColumn && (estimationType !== (0, $guzeq.ORIGINAL_ESTIMATE) || !hasEstimate)) return null;
    const isOriginalEstimateAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalEstimateFieldValue);
    const value = isOriginalEstimateAccessible ? (0, $etKNj.timeTrackingFormatter)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
    const placeholder = '2w 4d 6h 45m';
    const invalidTimeFormatMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $ayyYR.default).invalidTimeFormatMessage,
        values: {
            format: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, placeholder)
        }
    });
    const longFormValue = isOriginalEstimateAccessible && originalEstimateFieldValue > 0 ? (0, $etKNj.timeTrackingFormatterLongForm)(originalEstimateFieldValue, timeTrackingOptions, intl) : undefined;
    const ariaLabel = longFormValue ? `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${longFormValue}` : `${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabel)}: ${intl.formatMessage((0, $ayyYR.default).originalEstimateAriaLabelNullValue)}`;
    const issueOriginalEstimateFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $80uDK.default), {
        value: value,
        valueInSeconds: originalEstimateFieldValue,
        hasEstimate: hasEstimate,
        timeTrackingOptions: timeTrackingOptions
    });
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciMkN.IssueOriginalEstimateFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueOriginalEstimateFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline original estimate",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$var$OriginalEstimateFieldWrapper, {
        shouldRenderEstimatesColumn: shouldRenderEstimatesColumn
    }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$var$OriginalEstimateFieldContainer, {
        hasValue: isOriginalEstimateAccessible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
        tooltipLabel: intl.formatMessage((0, $ayyYR.default).originalEstimateTooltip),
        ariaLabel: ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($696609a8ce9192b2$var$IssueOriginalEstimateField, {
        isEditable: true,
        isMobile: false,
        isFitContainerWidthReadView: true,
        fieldId: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
        issueId: String(issueId),
        issueKey: issueKey,
        config: (0, $k4laV.timeTrackingConfigTransformer)(timeTrackingOptions),
        placeholder: placeholder,
        timeTrackingValue: {},
        invalidTimeFormatMessage: invalidTimeFormatMessage,
        isBacklogComponent: true,
        onUpdate: handleUpdate,
        onConfirm: handleConfirm,
        onFailure: handleFailure
    }))))));
    return issueOriginalEstimateFieldStatic;
};
var $696609a8ce9192b2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($696609a8ce9192b2$var$OriginalEstimateField);
const $696609a8ce9192b2$var$OriginalEstimateFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om73ad _1ul9ys9h _1reo1kw7 _18m91kw7 _1e0c1txw _4t3i1osq _4cvr1h6o _tkqh1txw _9t8gglyw _1la1idpf _9v95v0yc _18vj1txw _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _13mo1ule _1ny3ys9h _1udr15vq _nmyy15vq _g5ay1q9c _ox3r1l2s _1lab1ule _1n1y15vq _2jfx15vq _9xlo1q9c _pgqw1l2s _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            __cmplp.className
        ])
    });
}); // empty column for the cards that without original estimates
const $696609a8ce9192b2$var$OriginalEstimateFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderEstimatesColumn: shouldRenderEstimatesColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1wpz1fhb _4cvr1h6o",
            __cmplp.shouldRenderEstimatesColumn && "_1ul9ys9h _p12fys9h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ciMkN", function(module, exports) {

$parcel$export(module.exports, "IssueOriginalEstimateFieldBoundary", () => $cd2046d273882d40$export$1c6d9e9bdb2427ab);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

const $cd2046d273882d40$export$1c6d9e9bdb2427ab = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-original-estimate-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-original-estimate-field-boundary",
        fallback: fallback
    }, children));

const $cd2046d273882d40$export$572c30be3fc4b061 = (0, $hPtZI.lazy)(()=>(parcelRequire("9WB4b")).then((IssueOriginalEstimateField)=>IssueOriginalEstimateField), {
    moduleId: "./src/packages/issue/fields/original-estimate/src/ui/index.tsx"
});

});
parcelRegister("9WB4b", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1ao1N").then(()=>parcelRequire('9HayT'));

});


parcelRegister("k4laV", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigTransformer", () => $f545cf974bf70a21$export$5507631896590474);
const $f545cf974bf70a21$export$5507631896590474 = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultUnit: defaultUnit, timeFormat: timeFormat })=>({
        isTimeTrackingEnabled: true,
        daysPerWeek: workingDaysPerWeek,
        hoursPerDay: workingHoursPerDay,
        defaultUnit: defaultUnit,
        format: timeFormat
    });

});

parcelRegister("j1KUi", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("e7ZVL").then(()=>parcelRequire('4pygV'));

});


parcelRegister("bTzpK", function(module, exports) {

$parcel$export(module.exports, "Parent", () => $4af02e2826e9a973$export$ef39aebeb16866ce);

var $5uXOq = parcelRequire("5uXOq");

var $kM28N = parcelRequire("kM28N");

var $3xj9Y = parcelRequire("3xj9Y");

var $kKQ57 = parcelRequire("kKQ57");

var $963tu = parcelRequire("963tu");
const $4af02e2826e9a973$export$ef39aebeb16866ce = ({ cardId: cardId, cardKey: cardKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents, parentId: parentId, currentProjectId: currentProjectId, projectIds: projectIds, canUserEditIssue: canUserEditIssue, shouldRenderRichCard: shouldRenderRichCard, backlogContainerSize: backlogContainerSize, isCompactView: isCompactView, isSubtask: isSubtask, isEpic: isEpic, isCompanyManaged: isCompanyManaged })=>// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.EpicWrapper), {
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).EPIC, backlogContainerSize),
        // To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
        showPlaceholder: parentId === null && !isSubtask
    }, isEpic && isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xj9Y.default), {
        issueKey: cardKey,
        issueId: cardId,
        isCompactView: isCompactView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kKQ57.default), {
        issueId: cardId,
        issueKey: cardKey,
        isUserAtLeastMember: isUserAtLeastMember,
        parents: parents,
        parentId: parentId,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        forceEditable: canUserEditIssue,
        shouldRenderRichCard: shouldRenderRichCard,
        isCompactView: isCompactView
    }));

});
parcelRegister("kKQ57", function(module, exports) {

$parcel$export(module.exports, "default", () => $575becd3ec2f8837$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $kFsv3 = parcelRequire("kFsv3");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $jRmmq = parcelRequire("jRmmq");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $3bPZM = parcelRequire("3bPZM");

var $hPtZI = parcelRequire("hPtZI");


var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $8wOzB = parcelRequire("8wOzB");

const $575becd3ec2f8837$export$470a9ca634922e36 = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("1kt9N")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/index.tsx"
});
const $575becd3ec2f8837$var$ParentField = ({ issueId: issueId, issueKey: issueKey, isUserAtLeastMember: isUserAtLeastMember, parents: parents = [], currentProjectId: currentProjectId, projectIds: projectIds, shouldRenderRichCard: shouldRenderRichCard, forceEditable: forceEditable, parentId: parentId, isCompactView: isCompactView })=>{
    const [parentValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const transformedEpic = (0, $5uXOq.useMemo)(()=>parents.map((p)=>(0, $7Fute.transformToEpic)(p)), [
        parents
    ]); // Mapped parent is required to get the epic/parent's color
    const mappedParent = (0, $5uXOq.useMemo)(()=>parentId ? parents.find(({ id: id })=>Number(id) === Number(parentId)) : null, [
        parentId,
        parents
    ]);
    const renderParentFieldStatic = (0, $5uXOq.useCallback)(()=>{
        const color = mappedParent?.color || parentValue?.color || (0, $kFsv3.PURPLE);
        const summary = mappedParent?.summary || parentValue?.fields?.summary;
        return summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wOzB.default), {
            color: color,
            summary: summary,
            isCompactView: isCompactView
        }) : null;
    }, [
        isCompactView,
        mappedParent,
        parentValue?.color,
        parentValue?.fields?.summary
    ]);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        isCompanyManaged,
        triggerEpicPanelRefetch
    ]); // in the storybook, it first displays the static epic lozenge.
    // but when we mouse over on a card, the epic field would disappear due to missing hierarchy-level-above value in the sweet state
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.ParentSwitcherBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: renderParentFieldStatic()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline epic",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($575becd3ec2f8837$var$ParentFieldWrapper, {
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentValue),
        isCompactView: isCompactView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($575becd3ec2f8837$export$470a9ca634922e36, {
        onSuccess: handleSuccess,
        issueKey: issueKey,
        issueId: String(issueId),
        epics: transformedEpic,
        forceEditable: forceEditable,
        isSimplifiedProject: !isCompanyManaged,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        isCompactView: isCompactView
    })))));
    return renderParentFieldStatic();
};
var $575becd3ec2f8837$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($575becd3ec2f8837$var$ParentField);
const $575becd3ec2f8837$var$ParentFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompactView: isCompactView, hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvresu3 _kqswh2mm _80om73ad _p12f1osq _vchhusvi _5ci27079 _907j1kev _1rt91h90 _1u4t126e _nyj2agmp _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7",
            !__cmplp.isCompactView && "_19bvu2gc",
            !__cmplp.hasValue && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jRmmq", function(module, exports) {

$parcel$export(module.exports, "ParentSwitcherBoundary", () => $363a63430d7d18c1$export$5fd31a263aabeb24);
$parcel$export(module.exports, "AsyncLazyParentSwitcherField", () => $363a63430d7d18c1$export$690bf5ebb9d6daf8);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");
const $363a63430d7d18c1$export$5fd31a263aabeb24 = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-parent-switcher",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-parent-switcher-boundary",
        fallback: fallback
    }, children));

const $363a63430d7d18c1$export$690bf5ebb9d6daf8 = (0, $hPtZI.lazy)(()=>(parcelRequire("fYVh2")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/ui/main.tsx"
});

});
parcelRegister("fYVh2", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("511sN").then(()=>parcelRequire('1vozy'));

});


parcelRegister("1kt9N", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("Y1vcy").then(()=>parcelRequire('6wu0G'));

});



parcelRegister("lNMv0", function(module, exports) {

$parcel$export(module.exports, "StatusFieldWrapper", () => $2f4a9a997cc0237d$export$b298de36b54f1050);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iDGXn = parcelRequire("iDGXn");

var $3JQPC = parcelRequire("3JQPC");

var $963tu = parcelRequire("963tu");

var $1QXjd = parcelRequire("1QXjd");
const $2f4a9a997cc0237d$export$b298de36b54f1050 = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, cardKey: cardKey, cardId: cardId })=>{
    const showStatuses = (0, $iDGXn.useShowStatuses)();
    const { size: backlogContainerSize } = (0, $3JQPC.useContainerSize)();
    if (showStatuses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f4a9a997cc0237d$var$StatusContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.status-field.status-field-wrapper.status-container",
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QXjd.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard,
        issueKey: cardKey,
        issueId: String(cardId),
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).STATUS, backlogContainerSize)
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f4a9a997cc0237d$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_uu7jbp": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `repeat(auto-fit,${(0, $gwIPs.gridSize) * __cmplp.widthMultiplier}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _lcxvglyw _1reo1kw7 _18m91kw7 _yv0e105t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1QXjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $342ba4724accfebb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ggSx2 = parcelRequire("ggSx2");

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $3fAi8 = parcelRequire("3fAi8");

var $9fZKh = parcelRequire("9fZKh");


var $3bPZM = parcelRequire("3bPZM");

var $dCm1o = parcelRequire("dCm1o");

var $hPtZI = parcelRequire("hPtZI");


var $dspDn = parcelRequire("dspDn");

var $c1MAf = parcelRequire("c1MAf");

var $czUNp = parcelRequire("czUNp");

var $gwOHY = parcelRequire("gwOHY");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $7I9R8 = parcelRequire("7I9R8");

const $342ba4724accfebb$export$58bec2551a247e1d = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("hOlgW")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
const $342ba4724accfebb$var$StatusField = ({ isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, issueKey: issueKey, widthMultiplier: widthMultiplier, issueId: issueId })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const [statusFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const handleSubmit = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditStatusInteractionStartMark)();
    }, []);
    const handleSuccess = (0, $5uXOq.useCallback)((value)=>{
        (0, $dspDn.setInlineEditStatusInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (issueId !== undefined) {
            const cardId = Number.parseInt(issueId, 10);
            dispatch((0, $czUNp.cardStatusSet)(cardId, statusFieldValue.id, value.id, statusFieldValue.id, isCompanyManaged));
        }
        if (isCompanyManaged) triggerEpicPanelRefetch();
    }, [
        dispatch,
        isCompanyManaged,
        issueId,
        statusFieldValue,
        triggerEpicPanelRefetch
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStatusInteractionMark)();
    }, []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) return null;
    const value = {
        id: statusFieldValue.id,
        name: statusFieldValue.name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $gULOk.StatusCategoryIds))[statusFieldValue.statusCategory.id] || (0, $gULOk.StatusCategoryTypes).UNDEFINED
    };
    const issueStatusFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7I9R8.default), {
        isUserAtLeastMember: isUserAtLeastMember,
        value: value
    });
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fZKh.IssueStatusFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueStatusFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline status",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($342ba4724accfebb$export$653fc70614ecd562, {
        widthMultiplier: widthMultiplier
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($342ba4724accfebb$export$58bec2551a247e1d, {
        appearance: "lozenge",
        issueKey: issueKey,
        issueId: issueId,
        initialValue: statusFieldValue,
        onSubmit: handleSubmit,
        onSuccess: handleSuccess,
        onFailure: handleFailure
    }))));
    return issueStatusFieldStatic;
};
var $342ba4724accfebb$export$2e2bcd8739ae039 // NOTE: The div is needed here because StatusLozenge is an async component and
 = /*#__PURE__*/ (0, $5uXOq.memo)($342ba4724accfebb$var$StatusField);
const $342ba4724accfebb$export$653fc70614ecd562 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_4lcd6e": (0, $lD23V.default)(__cmplp.widthMultiplier * 8 - 4, "px"),
            "--_hikewg": (0, $lD23V.default)(__cmplp.widthMultiplier * 8, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4cvr1h6o _rcmc11p5 _1i661h6o _5th9v2br _9u161rj4 _1a191qo1 _bvcr7079 _1sgz1wje _es1l1prr _1o3v1h90 _ewzg1h90 _1dg1agmp _132g1h90 _1v5x1q9c",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1d7yl1s9" : "_1d7y1ljj",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_d2c8yh40" : "_d2c8idpf",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1a5tyh40" : "_1a5tidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9fZKh", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $0cd8b9cfe3ba1e4a$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $fQeLt = parcelRequire("fQeLt");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0cd8b9cfe3ba1e4a$var$AsyncLazyIssueStatusField = (0, $hPtZI.lazy)(()=>(parcelRequire("6TWYA")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $0cd8b9cfe3ba1e4a$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cd8b9cfe3ba1e4a$var$AsyncLazyIssueStatusField, props)));
};
const $0cd8b9cfe3ba1e4a$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $8GVAj = parcelRequire("8GVAj");

var $gDyTC = parcelRequire("gDyTC");

var $6T4rd = parcelRequire("6T4rd");
var $9nD7C = parcelRequire("9nD7C");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $kGDYq = parcelRequire("kGDYq");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    }));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nD7C.default), {
        xcss: (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? $390c5e7bc7d9c77b$var$pressableStyles : $390c5e7bc7d9c77b$var$pressableStylesOld,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        ...(0, $4R6GH.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $5e0c0d4e15efb4a6$exports).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$exports).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$exports).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        ...(0, $4R6GH.fg)('issue-jiv-18579-status-field-interaction-name') ? {
            // When cleaning up we will need to disable the `jira/ufo/valid-labels` lint rule
            // because for this particular interaction we only want to track
            // opening the status popup.
            interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
        } : {
            interactionName: 'auto-generated.jira-issue-field-status.common.ui.status-lozenge.button'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual_refresh-status-text-color-changed') ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            (0, $kGDYq.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStylesOld = (0, $jJ1Sb.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    width: '100%'
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $jJ1Sb.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $jJ1Sb.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);

const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $5e0c0d4e15efb4a6$export$a6ee3d71bc067634)})`
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $5e0c0d4e15efb4a6$export$a6ee3d71bc067634)})`
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $5e0c0d4e15efb4a6$export$a49394138f7b8e85)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64)})`
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $5e0c0d4e15efb4a6$export$7d61b15e0da132af)})`,
    [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb)})`,
    text: `var(--ds-text-disabled, ${(0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd)})`
};

});

parcelRegister("kGDYq", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b);

var $co1wz = parcelRequire("co1wz");
const $4b98d8a4e0ed63d5$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b = ()=>(0, $co1wz.ff)($4b98d8a4e0ed63d5$export$455240e4be839479, false); // </rkarki>
 // <bento>
 // </bento>

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $eddAM = parcelRequire("eddAM");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("6TWYA", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("4A1p8")
]).then(()=>parcelRequire('2azQI'));

});


parcelRegister("hOlgW", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("2Lfdl"),
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("bt53R")
]).then(()=>parcelRequire('gUKTg'));

});



parcelRegister("9MiEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $82ca48db4553a327$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $fUvM9 = parcelRequire("fUvM9");


var $bJ2M7 = parcelRequire("bJ2M7");

var $iXVV6 = parcelRequire("iXVV6");

var $3XO6n = parcelRequire("3XO6n");

var $3bPZM = parcelRequire("3bPZM");

var $hPtZI = parcelRequire("hPtZI");


var $guzeq = parcelRequire("guzeq");

var $dspDn = parcelRequire("dspDn");

var $c1MAf = parcelRequire("c1MAf");

var $3EtSK = parcelRequire("3EtSK");

var $gwOHY = parcelRequire("gwOHY");

var $dGljH = parcelRequire("dGljH");

var $fSgHa = parcelRequire("fSgHa");

var $dM9vk = parcelRequire("dM9vk");

var $7q84v = parcelRequire("7q84v");

var $gnK7n = parcelRequire("gnK7n");

var $81g2L = parcelRequire("81g2L");

const $82ca48db4553a327$export$88b57365e3a3cb92 = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("bsYfb")), {
    moduleId: "./src/packages/issue/fields/number/src/index.tsx"
});
const $82ca48db4553a327$var$StoryPointField = ({ issueKey: issueKey, storyPointFieldId: storyPointFieldId, estimationType: estimationType, issueId: issueId, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, shouldRenderStoryPointColumn: shouldRenderStoryPointColumn })=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const [_, { triggerEpicPanelRefetch: triggerEpicPanelRefetch }] = (0, $3bPZM.useShouldRefetchEpicPanel)();
    const storyPointKey = storyPointFieldId || '';
    const [storyPointFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: storyPointKey
    });
    const ariaLabelWithValue = storyPointFieldValue ? formatMessage((0, $7q84v.default).storyPointsAriaLabel, {
        storyPointValue: formatNumber(storyPointFieldValue)
    }) : formatMessage((0, $7q84v.default).storyPointsAriaLabelNullValue); // I think this is more correct since hasEstimate only checks THIS issue but there could be
    // other issues on the backlog that do have estimates. That will mess up the layout
    // and shift all the content slightly across to make space for the story point field
    const shouldRenderEstimatesColumn = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const hasEstimate = (0, $c1MAf.useBacklogSelector)((state)=>!!(0, $dGljH.getCards)(state)[String(issueId)]?.estimate);
    const saveCompanyManaged = (0, $5uXOq.useCallback)((iKey, fieldKey, newValue, baseURL)=>(0, $fUvM9.saveField)(String(issueId), fieldKey, newValue, baseURL), [
        issueId
    ]);
    const handleEdit = (0, $5uXOq.useCallback)(()=>{
        setIsEditing(true);
    }, [
        setIsEditing
    ]);
    const handleConfirm = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.setInlineEditStoryPointInteractionStartMark)();
        setIsEditing(false);
    }, []);
    const handleUpdate = (0, $5uXOq.useCallback)((value)=>{
        (0, $dspDn.setInlineEditStoryPointInteractionStopMark)(isCompanyManaged);
        dispatch((0, $gwOHY.refetchVersions)());
        if (value !== undefined && typeof value === 'number') dispatch((0, $3EtSK.cardEstimateSet)(issueId, {
            storyPoints: value
        }));
        if (isCompanyManaged) triggerEpicPanelRefetch();
        setIsEditing(false);
    }, [
        dispatch,
        isCompanyManaged,
        triggerEpicPanelRefetch,
        issueId
    ]);
    const handleFailure = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, []);
    const handleCancel = (0, $5uXOq.useCallback)(()=>{
        (0, $dspDn.cancelInlineEditStoryPointInteractionMark)();
        setIsEditing(false);
    }, [
        setIsEditing
    ]);
    if (!shouldRenderStoryPointColumn && (!storyPointKey || estimationType !== (0, $guzeq.STORY_POINTS) || shouldRenderEstimatesColumn)) return null;
    const isStoryPointAccessible = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(storyPointFieldValue);
    const issueStoryPointFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81g2L.default), {
        value: storyPointFieldValue ?? undefined,
        hasStoryPoints: hasEstimate,
        shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
    });
    const renderStorypointField = ()=>// We should always render the container otherwise the layout gets all messed up
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$var$StoryPointFieldWrapper, {
            shouldRenderStoryPointColumn: shouldRenderStoryPointColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gnK7n.default), {
            tooltipLabel: formatMessage((0, $7q84v.default).storyPointsTooltip),
            ariaLabel: ariaLabelWithValue,
            tooltipPosition: isEditing ? 'top' : 'bottom'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$var$StoryPointFieldContainer, {
            hasValue: isStoryPointAccessible
        }, hasEstimate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82ca48db4553a327$export$88b57365e3a3cb92, {
            issueKey: issueKey,
            fieldKey: storyPointKey,
            fieldFocusStyle: (0, $a4c5fe4dcf7753af$export$44f42916442b37c3),
            fieldEditStyle: (0, $a4c5fe4dcf7753af$export$1ff9623b26415f8),
            onEdit: handleEdit,
            onUpdate: handleUpdate,
            onConfirm: handleConfirm,
            onFailure: handleFailure,
            onCancel: handleCancel,
            saveField: isCompanyManaged ? saveCompanyManaged : undefined
        }))));
    if (isUserAtLeastMember && shouldRenderRichCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJ2M7.IssueNumberFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: issueStoryPointFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: "inline story point",
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldName: (0, $3XO6n.STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE)
        }
    }, renderStorypointField())));
    return issueStoryPointFieldStatic;
};
var $82ca48db4553a327$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($82ca48db4553a327$var$StoryPointField);
const $82ca48db4553a327$var$StoryPointFieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80om73ad _1e0c1txw _18kq1kw7 _1jsw1kw7 _3p7d1kw7 _j88e1kw7 _1ksg1kw7 _zpal1kw7 _wnsb1kw7 _bwtn1kw7 _wlgl1kw7 _1n6k1kw7 _tq0k1kw7 _xzt01kw7 _13g31txw _y5xnglyw _1la1idpf _9v95v0yc _18vj1txw _nt751r31 _1guj1r31 _49pcglyw _pbhaglyw _1hvw1o36 _11ow1o36",
            __cmplp.className
        ])
    });
}); // empty column for the cards that without storyPoint
const $82ca48db4553a327$var$StoryPointFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRenderStoryPointColumn: shouldRenderStoryPointColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRenderStoryPointColumn && "_1ul91shb _p12f1shb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fUvM9", function(module, exports) {

$parcel$export(module.exports, "saveField", () => $f0796cdd3cd63a15$export$72a8b15fb4557735);
$parcel$export(module.exports, "useClassicStoryPointField", () => $f0796cdd3cd63a15$export$aa8e8a51326640a2);

var $9XE6b = parcelRequire("9XE6b");

var $ebyGx = parcelRequire("ebyGx");

var $eusud = parcelRequire("eusud");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $4tcSU = parcelRequire("4tcSU");

var $g5X3G = parcelRequire("g5X3G");
const $f0796cdd3cd63a15$export$72a8b15fb4557735 = async (issueId, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPostRequest)('/secure/AjaxIssueAction.jspa?decorator=none', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: (0, $ebyGx.stringify)({
            [fieldKey]: newValue,
            issueId: issueId,
            skipScreenCheck: true,
            atl_token: (0, $4tcSU.default)(),
            singleFieldEdit: true
        })
    });
const $f0796cdd3cd63a15$export$aa8e8a51326640a2 = ({ issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, onSuccess: onSuccess })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
    const saveClassicField = (_issueKey, _fieldKey, newValue, baseUrl)=>$f0796cdd3cd63a15$export$72a8b15fb4557735((0, $g5X3G.toIssueKey)(issueId.toString()), fieldKey, newValue, baseUrl);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        saveField: saveClassicField,
        onSuccess: onSuccess,
        analyticsFieldTypeAlias: 'classicstorypoint'
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $3BIWb = parcelRequire("3BIWb");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $2gCtH = parcelRequire("2gCtH");

var $6Ou5i = parcelRequire("6Ou5i");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $dJl1T.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            if (fieldKey === 'timetracking' && (0, $co1wz.ff)('jiv-18751-investigate-time-tracking-update-errors_ng38s')) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'timetracking updateFailed', {
                fieldKey: fieldKey,
                fieldType: fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex),
                exceptionName: ex.name,
                exceptionMessage: ex.message,
                exceptionStack: ex.stack
            });
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $6Ou5i.useIsEditFromIssueView);
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, meta);
        if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            (0, $co1wz.ff)('relay-migration-issue-fields-soft-refresh-ld') ? await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason) : await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);

var $afs7f = parcelRequire("afs7f");
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = (0, $afs7f.Reason).OnDemand)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});
parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("6Ou5i", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $b57bb78db332aa99$export$870b996a6c1c7896);

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $b57bb78db332aa99$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        ...!(0, $4R6GH.fg)('fix_issue_hook_from_backlog') ? [
            'backlogScreen'
        ] : [],
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $co1wz = parcelRequire("co1wz");

var $7JoAD = parcelRequire("7JoAD");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $co1wz.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if ((0, $co1wz.ff)('relay-migration-issue-fields-events-transformer-ld')) {
            if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
        }
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $7JoAD.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $7JoAD.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $7JoAD.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                components: fieldValue.components,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, context)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, context) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, fields);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);

var $co1wz = parcelRequire("co1wz");


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    const allowedValues = (0, $co1wz.ff)('issue.details.relay-cascading-select-field-issue-view-layout-integration') ? [] : (0, $o7K5u.transformAggConnection)(node.cascadingOptions, (cascadingOption)=>{
        if (!cascadingOption.parentOptionValue) return null;
        const { parentOptionValue: parentOptionValue, childOptionValues: childOptionValues } = cascadingOption;
        const childrenObj = childOptionValues?.length ? {
            children: childOptionValues.filter(Boolean).map((option)=>({
                    id: option.optionId,
                    value: option.value ?? null,
                    ari: option.id
                }))
        } : {};
        return {
            value: parentOptionValue.value,
            id: parentOptionValue.optionId,
            ...childrenObj
        };
    });
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);

var $co1wz = parcelRequire("co1wz");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        ...!(0, $co1wz.ff)('assets-rearch-deprecate-attribute-value-id_ykukg') && {
            id: node.attributeId
        },
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);

var $co1wz = parcelRequire("co1wz");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ...(0, $co1wz.ff)('compass-components-in-jira-components_xw42u', false) ? {
            ari: component.ari,
            metadata: component.metadata
        } : {}
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $1jcOW = parcelRequire("1jcOW");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $1jcOW.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("1jcOW", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $c948befca907b8e1$export$d109ab46c9575565);

var $jKLhs = parcelRequire("jKLhs");
const $c948befca907b8e1$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("jKLhs", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $f364376512c412a0$export$dd1bc94b04021eeb);
const $f364376512c412a0$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $dJl1T.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $kFsv3 = parcelRequire("kFsv3");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $kFsv3.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, context)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    const project = (0, $hA3EZ.getSystemAggJiraProject)(context);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: project.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "transformAggProjectToProjectContext", () => $e3d5807b112803bd$export$275f121d4e6f5165);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $k5x3N = parcelRequire("k5x3N");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar.large
        }
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $k5x3N.isJPDDeliveryLinkTypeFilteringEnabled)()) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';

parcelRegister("k5x3N", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $9be9ea07d5dfc538$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJPDDeliveryLinkTypeFilteringEnabled", () => $9be9ea07d5dfc538$export$8fac1563227555f2);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $co1wz = parcelRequire("co1wz");
const $9be9ea07d5dfc538$export$9c7fa56ed1fa2e15 = ()=>(0, $co1wz.ff)('parent-field-in-issue-view_x4zn4', false);
const $9be9ea07d5dfc538$export$8fac1563227555f2 = ()=>(0, $co1wz.ff)('polaris.jpd-panel-filter-by-delivery-link-type', false);

});



parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");

var $co1wz = parcelRequire("co1wz");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, context)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            {
                if ((0, $co1wz.ff)('relay-migration-issue-fields-request-participants_itocm') && node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)) return {
                    ...legacyFieldValues,
                    value: value
                };
                const project = (0, $hA3EZ.getSystemAggJiraProject)(context);
                if ((0, $hA3EZ.getProjectType)(project.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
                // Empty array is the expected value when there are no request
                // participants.
                return {
                    ...legacyFieldValues,
                    value: value
                };
            }
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");


const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $1jcOW = parcelRequire("1jcOW");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $1jcOW.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $fpYAi = parcelRequire("fpYAi");
var $9JtFv = parcelRequire("9JtFv");

var $dJl1T = parcelRequire("dJl1T");

var $co1wz = parcelRequire("co1wz");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $co1wz.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $co1wz.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $9JtFv.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $9JtFv.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $co1wz.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $9JtFv.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $9JtFv.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $9JtFv.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $9JtFv.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $fpYAi.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("j87Vo"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("80p0p"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("l971E"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("fpYAi", function(module, exports) {

$parcel$export(module.exports, "filter", () => $0508f1757f76c18b$export$3dea766d36a8935f);

var $9JtFv = parcelRequire("9JtFv");
function $0508f1757f76c18b$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $9JtFv.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("9JtFv", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $c99be4b6ee65acdc$export$df3f009e3d155b20);
function $c99be4b6ee65acdc$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $c99be4b6ee65acdc$export$df3f009e3d155b20(adf, visitors) {
    if (!$c99be4b6ee65acdc$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $c99be4b6ee65acdc$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $c99be4b6ee65acdc$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $c99be4b6ee65acdc$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("j87Vo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8Q4nN").then(()=>parcelRequire('kOFhM'));

});

parcelRegister("80p0p", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("i4VKd").then(()=>parcelRequire('jdXnh'));

});

parcelRegister("l971E", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6wrCc").then(()=>parcelRequire('4hJsq'));

});



parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.singlePickerVersions, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$export$8b9b8ed7fbac313c]: $c6ffe75554a4bac3$export$8b9b8ed7fbac313c,
    [$c6ffe75554a4bac3$export$7c15aaba9a26f469]: $c6ffe75554a4bac3$export$7c15aaba9a26f469,
    [$c6ffe75554a4bac3$export$f567ac9d3526e5ce]: $c6ffe75554a4bac3$export$f567ac9d3526e5ce
};

});


parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fetchDataOld = async (issueKey)=>{
    const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
        body: JSON.stringify({
            query: $a5085d8f4019d625$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchDataWithExperienceTracking = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$fetchData = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jiv-18890-field-configuration-query-exp-tracking'), $a5085d8f4019d625$var$fetchDataWithExperienceTracking, $a5085d8f4019d625$var$fetchDataOld);
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");
const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $7JoAD = parcelRequire("7JoAD");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $7JoAD.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $7JoAD.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $7JoAD.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $7JoAD.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $7JoAD.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $7JoAD.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});



const $a4c5fe4dcf7753af$export$1ff9623b26415f8 = 'INLINE';
const $a4c5fe4dcf7753af$export$44f42916442b37c3 = 'LOZENGE';
const $a4c5fe4dcf7753af$export$eade6b6091579183 = 'NORMAL';
const $a4c5fe4dcf7753af$export$797ed91ebb8db1c5 = 'CHILD_ISSUE_LOZENGE';

parcelRegister("bJ2M7", function(module, exports) {

$parcel$export(module.exports, "IssueNumberFieldBoundary", () => $7558df822eaca863$export$5efed0d3367e90db);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $hXYQI = parcelRequire("hXYQI");

const $7558df822eaca863$export$17e6ae9e4022a01f = (0, $hPtZI.lazy)(()=>(parcelRequire("qy4fm")), {
    moduleId: "./src/packages/issue/fields/number/src/ui/index.tsx"
});
const $7558df822eaca863$export$e170b9657d273707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-field-number",
        packageName: "jira-issue-field-number",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXYQI.NumberView), {
                isEditable: props.isEditable !== undefined ? props.isEditable : false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-field-number-readonly",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXYQI.NumberView), {
            isEditable: props.isEditable !== undefined ? props.isEditable : false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7558df822eaca863$export$17e6ae9e4022a01f, props)));
const $7558df822eaca863$export$5efed0d3367e90db = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "issue-number-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-number-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("hXYQI", function(module, exports) {

$parcel$export(module.exports, "NumberView", () => $667e08b0b18f78dd$export$3a0cbbcc23d8ca3d);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $bxhgD = parcelRequire("bxhgD");


var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $aWse0 = parcelRequire("aWse0");

const $667e08b0b18f78dd$var$noValueText = '-';
const $667e08b0b18f78dd$export$3a0cbbcc23d8ca3d = ({ isEditable: isEditable, value: value, setIsEditing: setIsEditing })=>{
    const { formatNumber: formatNumber } = (0, $aWse0.useIntlV2)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsEditing?.(true);
    }, [
        setIsEditing
    ]);
    if (value === undefined) return null;
    const displayValue = value === null ? $667e08b0b18f78dd$var$noValueText : formatNumber(value);
    const BadgeComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        testId: (0, $ea286d2db1e9f268$export$ddb0dcfa9074309f)
    }, displayValue);
    const BadgeComponent = isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($667e08b0b18f78dd$var$HoverContainer, {
        "data-testid": `${(0, $ea286d2db1e9f268$export$ddb0dcfa9074309f)}-hover-container`,
        onClick: handleOnClick
    }, BadgeComp) : BadgeComp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($667e08b0b18f78dd$var$BadgeWrapper, null, BadgeComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $667e08b0b18f78dd$var$HoverContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "b6v085-0"
})({
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&:hover > span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `${`var(--ds-text, ${(0, $5e0c0d4e15efb4a6$exports).N800})`} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `${`var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N90})`} !important`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $667e08b0b18f78dd$var$HoverContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _ll8p16l4 _1lgi1prw",
            __cmplp.className
        ])
    });
});
const $667e08b0b18f78dd$var$HoverContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled-react-migration-issue-view_u9myz'), $667e08b0b18f78dd$var$HoverContainerExperiment, $667e08b0b18f78dd$var$HoverContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $667e08b0b18f78dd$var$BadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itj1ic",
            __cmplp.className
        ])
    });
});

});
const $ea286d2db1e9f268$export$195635d59130784a = 'issue-field-number.ui.issue-field-number';
const $ea286d2db1e9f268$export$5dadcbcc34de35f = 'issue-field-number.ui.issue-field-number--container';
const $ea286d2db1e9f268$export$ddb0dcfa9074309f = 'issue-field-number.ui.badge';
const $ea286d2db1e9f268$export$3cb3b73ace5de3d1 = `${$ea286d2db1e9f268$export$ddb0dcfa9074309f}-hover-container`;
const $ea286d2db1e9f268$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';


parcelRegister("qy4fm", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("4AM5N").then(()=>parcelRequire('jojgm'));

});


parcelRegister("bsYfb", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("1Me05").then(()=>parcelRequire('ge1Lf'));

});


parcelRegister("1D3VD", function(module, exports) {

$parcel$export(module.exports, "SummaryAndParents", () => $8794a2b0e6b8c6a9$export$819decb1869bab94);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $k2wwp = parcelRequire("k2wwp");

var $kM28N = parcelRequire("kM28N");

var $cizWc = parcelRequire("cizWc");

var $3FjKF = parcelRequire("3FjKF");
const $8794a2b0e6b8c6a9$export$819decb1869bab94 = ({ cardId: cardId, cardKey: cardKey, summary: summary, highlightText: highlightText, isUserAtLeastMember: isUserAtLeastMember, shouldRenderRichCard: shouldRenderRichCard, isSummaryFieldEditing: isSummaryFieldEditing, onClickThrough: onClickThrough, onSummaryEditStateChange: onSummaryEditStateChange, children: children })=>{
    const getHighlightText = (0, $8QpSo.default)((highlightedText)=>[
            highlightedText
        ]);
    const highlightTextEl = // Possibility that summary is null/undefined
    highlightText !== null && highlightText !== '' && summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        text: summary,
        highlight: getHighlightText(highlightText)
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryAndParentContainer), {
        isSummaryFieldEditing: isSummaryFieldEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.SummaryWrapper), {
        tabIndex: -1,
        isSummaryFieldEditing: isSummaryFieldEditing,
        onClick: isSummaryFieldEditing ? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) : onClickThrough,
        "data-testid": (0, $cizWc.SUMMARY_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3FjKF.default), {
        issueId: cardId.toString(),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        issueKey: cardKey,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isUserAtLeastMember: isUserAtLeastMember,
        shouldRenderRichCard: shouldRenderRichCard ?? false,
        summary: summary,
        highlightText: highlightTextEl,
        onSummaryEditStateChange: onSummaryEditStateChange
    })), children);
};

});
parcelRegister("3FjKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14a5dc71d40567a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1UppJ = parcelRequire("1UppJ");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $hPtZI = parcelRequire("hPtZI");


var $dM9vk = parcelRequire("dM9vk");

var $JMY9i = parcelRequire("JMY9i");

// MultilineInlineSummary is actually just a proxy for @atlassian/jira-issue-field-summary-inline-edit-link
const $b14a5dc71d40567a$var$MultilineInlineSummaryLazy = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("6d6TS")).then(({ MultilineInlineSummary: MultilineInlineSummary })=>MultilineInlineSummary), {
    moduleId: "./src/packages/issue/fields/summary/src/ui/multiline-inline-summary/index.tsx"
});
const $b14a5dc71d40567a$var$SummaryField = ({ shouldRenderRichCard: shouldRenderRichCard, issueId: issueId, issueKey: issueKey, highlightText: highlightText, onSummaryEditStateChange: onSummaryEditStateChange, summary: summary, isUserAtLeastMember: isUserAtLeastMember })=>{
    const summaryFieldStatic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $JMY9i.StaticSummaryField), {
        highlightText: highlightText,
        summary: summary
    });
    if (shouldRenderRichCard && isUserAtLeastMember) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1UppJ.IssueSummaryFieldBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        fallback: summaryFieldStatic
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dM9vk.default), {
        experienceTarget: (0, $5fc53.SUMMARY_TYPE),
        experienceTargetId: issueKey,
        additionalAttributes: {
            issueKey: issueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b14a5dc71d40567a$var$MultilineSummaryFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b14a5dc71d40567a$var$MultilineInlineSummaryLazy, {
        issueId: issueId,
        issueKey: issueKey,
        highlightText: highlightText,
        onEditStateChange: onSummaryEditStateChange
    })))));
    return summaryFieldStatic;
};
var $b14a5dc71d40567a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = /*#__PURE__*/ (0, $5uXOq.memo)($b14a5dc71d40567a$var$SummaryField);
const $b14a5dc71d40567a$var$MultilineSummaryFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0x0bf _2hwxx0bf _gjxvze3t _132nubjl _192wstnw _11041osq _1q8jgrf3 _1s8q1txw _wryf13la _122i13la _570a13la _1kwi13la",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1UppJ", function(module, exports) {

$parcel$export(module.exports, "IssueSummaryFieldBoundary", () => $d01ef8c87f783d29$export$f8e4f73217de638d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

const $d01ef8c87f783d29$export$f8e4f73217de638d = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "issue-summary-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-summary-field-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("JMY9i", function(module, exports) {

$parcel$export(module.exports, "StaticSummaryField", () => $e86b4bd2962f74b0$export$852299389cd57d63);

var $5uXOq = parcelRequire("5uXOq");

var $MGmIU = parcelRequire("MGmIU");

var $kM28N = parcelRequire("kM28N");
const $e86b4bd2962f74b0$export$852299389cd57d63 = ({ summary: summary, highlightText: highlightText })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: summary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM28N.Summary), null, highlightText ?? summary));

});

parcelRegister("6d6TS", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("brKI1").then(()=>parcelRequire('fyJFY'));

});



parcelRegister("1e5mE", function(module, exports) {

$parcel$export(module.exports, "TypeIcon", () => $c41cf15b3b40645a$export$ad8f8fc3bcd61b4a);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c41cf15b3b40645a$export$ad8f8fc3bcd61b4a = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c41cf15b3b40645a$var$ImageContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.type-icon.type"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c41cf15b3b40645a$var$Img, {
        role: "presentation",
        src: icon
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c41cf15b3b40645a$var$ImageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yyhy11t1 _1ii7wtyw",
            __cmplp.className
        ])
    });
});
const $c41cf15b3b40645a$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("xEBl6", function(module, exports) {

$parcel$export(module.exports, "VersionsWrapper", () => $9030fd3a889ff9ec$export$5c54d44b9c100bd1);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $iDGXn = parcelRequire("iDGXn");

var $963tu = parcelRequire("963tu");

var $a6e3u = parcelRequire("a6e3u");
const $9030fd3a889ff9ec$export$5c54d44b9c100bd1 = ({ shouldDisplayVersions: shouldDisplayVersions, backlogContainerSize: backlogContainerSize, cardId: cardId })=>{
    const showVersions = (0, $iDGXn.useShowVersions)();
    if (shouldDisplayVersions && showVersions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9030fd3a889ff9ec$var$VersionsContainer, {
        "data-testid": "software-backlog.card-list.card.card-contents.versions-field.version-field-wrapper.versions-container",
        widthMultiplier: (0, $963tu.getLabelWidthMultiplier)((0, $963tu.LabelType).VERSION, backlogContainerSize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6e3u.VersionsField), {
        cardId: cardId,
        backlogContainerSize: backlogContainerSize
    }));
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9030fd3a889ff9ec$var$VersionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthMultiplier: widthMultiplier, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ewl67i": (0, $lD23V.default)(`repeat(auto-fit, calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier}))`),
            "--_1qtnkr6": (0, $lD23V.default)(`calc(${"var(--ds-space-100, 8px)"} * ${__cmplp.widthMultiplier})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _1pbykb7n _1reo15vq _18m915vq _1bto1l2s _4cvr1h6o _6a6zv2br _lcxvglyw _yv0epq74 _1ul9dike",
            __cmplp.className
        ])
    });
});

});



parcelRegister("h5zHO", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $8ec67faa5923f21e$export$62ed72bc21f6b8a6);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $ibJfd = parcelRequire("ibJfd");
function $8ec67faa5923f21e$export$62ed72bc21f6b8a6({ edge: edge, droppingOverCardId: droppingOverCardId, droppingOverCardListId: droppingOverCardListId, dropStatisticsCardListId: dropStatisticsCardListId }) {
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        xcss: [
            (0, $4R6GH.fg)('backlog-drag-n-drop-indicator') ? $8ec67faa5923f21e$var$dropLineStylesNew : $8ec67faa5923f21e$var$dropLineStyles,
            edge === 'top' && $8ec67faa5923f21e$var$topStyles,
            edge === 'bottom' && $8ec67faa5923f21e$var$bottomStyles
        ]
    }, dropStatisticsCardListId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        xcss: $8ec67faa5923f21e$var$informationPillStyles,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: dropStatisticsCardListId,
        isDragIndicator: true,
        edge: edge === 'top' ? 'top' : 'bottom',
        droppingOverCardListId: droppingOverCardListId,
        droppingOverCardId: droppingOverCardId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ec67faa5923f21e$var$DropLine, {
        edge: edge
    }, dropStatisticsCardListId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ec67faa5923f21e$var$InformationPill, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: dropStatisticsCardListId,
        isDragIndicator: true,
        edge: edge === 'top' ? 'top' : 'bottom',
        droppingOverCardListId: droppingOverCardListId,
        droppingOverCardId: droppingOverCardId
    })));
}
const $8ec67faa5923f21e$var$DropLine = (0, $cSD7y.componentWithFG)('backlog-drag-n-drop-indicator', /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1bsb1osq _4t3iyh40 _1pbykb7n _1e0c1txw _1bah1y6m _4cvr1h6o _bfhk1r2e _lcxvglyw _1kt9b3bt _1cs8stnw _kfgt1y44 _1mp41y44 _1aukj39m _qnec16fl _rfx31ssb _14h8oh42",
            __cmplp.edge === 'top' && "_154i1i6y",
            __cmplp.edge === 'bottom' && "_94n5ze3t",
            __cmplp.className
        ])
    });
}), /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1bsb1osq _4t3iyh40 _1pbykb7n _1e0c1txw _1bah1y6m _4cvr1h6o _bfhk1r2e _lcxvglyw _1kt9b3bt _cfu11txw _kfgtidpf _1mp4idpf _6w5g1h6o _fntnr5cr _1pq812me _4k1c12me _1n1j18is",
            __cmplp.edge === 'top' && "_154i1i6y",
            __cmplp.edge === 'bottom' && "_94n5ze3t",
            __cmplp.className
        ])
    });
}));
const $8ec67faa5923f21e$var$InformationPill = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1r2e _2rko1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _1yt418iy",
            __cmplp.className
        ])
    });
});
const $8ec67faa5923f21e$var$dropLineStyles = (0, $jJ1Sb.xcss)({
    position: 'absolute',
    left: "var(--ds-space-050, 4px)",
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: '2px',
    zIndex: 'card',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'color.background.selected.bold',
    pointerEvents: 'none',
    '::before': {
        content: '""',
        width: '8px',
        height: '8px',
        boxSizing: 'border-box',
        position: 'absolute',
        border: `2px solid ${"var(--ds-background-selected-bold, #0C66E4)"}`,
        borderRadius: '50%',
        left: "var(--ds-space-negative-100, -8px)",
        backgroundColor: 'elevation.surface'
    }
});
const $8ec67faa5923f21e$var$dropLineStylesNew = (0, $jJ1Sb.xcss)({
    position: 'absolute',
    left: "var(--ds-space-050, 4px)",
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: '2px',
    zIndex: 'card',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'color.background.selected.bold',
    pointerEvents: 'none',
    '::before': {
        content: "''",
        position: 'absolute',
        height: '4px',
        width: '4px',
        top: '-3px',
        left: '-7px',
        borderRadius: '50%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `2px solid ${`var(--ds-border-brand, ${(0, $5e0c0d4e15efb4a6$exports).B300})`}`
    }
});
const $8ec67faa5923f21e$var$topStyles = (0, $jJ1Sb.xcss)({
    top: "var(--ds-space-negative-025, -2px)"
});
const $8ec67faa5923f21e$var$bottomStyles = (0, $jJ1Sb.xcss)({
    bottom: "var(--ds-space-0, 0px)"
});
const $8ec67faa5923f21e$var$informationPillStyles = (0, $jJ1Sb.xcss)({
    backgroundColor: 'color.background.selected.bold',
    borderRadius: '4px',
    paddingBlock: 'space.075',
    paddingInline: 'space.150',
    position: 'absolute',
    marginLeft: 'space.100'
});

});
parcelRegister("ibJfd", function(module, exports) {

$parcel$export(module.exports, "DividerStatistics", () => $cce02bdbcbe8b2c4$export$6542605af85d934);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $fHbE4 = parcelRequire("fHbE4");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");

var $l9VFH = parcelRequire("l9VFH");

var $4NOUT = parcelRequire("4NOUT");

var $enPV1 = parcelRequire("enPV1");

var $6diJT = parcelRequire("6diJT");
function $cce02bdbcbe8b2c4$export$6542605af85d934(props) {
    const { dividerCardListId: dividerCardListId, isDragIndicator: isDragIndicator } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const totalIssues = (0, $c1MAf.useBacklogSelector)((state)=>(0, $6diJT.getTotalIssues)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const remainingEstimates = (0, $c1MAf.useBacklogSelector)((state)=>(0, $6diJT.getRemainingEstimate)(state, {
            cardListId: dividerCardListId,
            dropIndicator: isDragIndicator === true ? props : undefined
        }));
    const filteredIssues = (0, $6diJT.useFilteredIssueCount)(dividerCardListId);
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const isFilterOn = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters);
    const isDisplayRemainTimeEnabled = (0, $c1MAf.useBacklogSelector)((0, $4NOUT.getIsRemainingTimeTrackingEnabledSelector));
    const shouldShowFilteredCount = isFilterOn && !isDragIndicator;
    const filteredRemainingEstimates = (0, $6diJT.useFilteredRemainingEstimate)(dividerCardListId);
    const isRemainDifferentFromOriginal = shouldShowFilteredCount ? filteredRemainingEstimates.originalTimeEstimate !== filteredRemainingEstimates.remainingTimeEstimate : remainingEstimates.originalTimeEstimate !== remainingEstimates.remainingTimeEstimate;
    const formatEstimationValue = (0, $6diJT.useFormatEstimationValue)();
    const formatTimeTrackingValue = (0, $6diJT.useFormatTimeTrackingValue)();
    const formatStrong = (0, $5uXOq.useCallback)((chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
            size: "medium",
            color: (0, $dCm1o.isVisualRefreshEnabled)() && isDragIndicator ? 'color.text.inverse' : undefined,
            as: "strong",
            weight: (0, $dCm1o.isVisualRefreshEnabled)() && isDragIndicator ? 'bold' : undefined
        }, chunks), [
        isDragIndicator
    ]);
    const getElementsText = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredAmountCardsIssueTermRefresh, {
            cardAmount: totalIssues,
            filteredIssues: filteredIssues,
            strong: (chunks)=>formatStrong(chunks)
        }) : formatMessage(isDragIndicator && (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $enPV1.messages).totalCardsDragIndicatorIssueTermRefresh : (0, $enPV1.messages).totalCardsIssueTermRefresh, {
            cardAmount: totalIssues,
            strong: (chunks)=>formatStrong(chunks)
        });
        return shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredAmountCards, {
            cardAmount: totalIssues,
            filteredIssues: filteredIssues,
            strong: (chunks)=>formatStrong(chunks)
        }) : formatMessage(isDragIndicator && (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $enPV1.messages).totalCardsDragIndicator : (0, $enPV1.messages).totalCards, {
            cardAmount: totalIssues,
            strong: (chunks)=>formatStrong(chunks)
        });
    }, [
        filteredIssues,
        formatMessage,
        formatStrong,
        isDragIndicator,
        shouldShowFilteredCount,
        totalIssues
    ]);
    const elements = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: "total"
        }, getElementsText)
    ];
    const infoVerticalDivider = (prefix)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce02bdbcbe8b2c4$var$InfoVerticalDivider, {
            key: `${prefix}VerticalDivider`,
            isDragIndicator: isDragIndicator
        });
    const remainingEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "remainingEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredRemainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        filteredEstimate: formatTimeTrackingValue(filteredRemainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).remainingLabel, {
        estimate: formatTimeTrackingValue(remainingEstimates.remainingTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }));
    const storyPointState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "storyPoints"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.storyPoints),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.storyPoints),
        strong: (chunks)=>formatStrong(chunks)
    }));
    const originalEstimateState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: "originalEstimate"
    }, shouldShowFilteredCount ? formatMessage((0, $enPV1.messages).filteredEstimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        filteredEstimate: formatEstimationValue(filteredRemainingEstimates.originalTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }) : formatMessage((0, $enPV1.messages).estimateLabel, {
        estimate: formatEstimationValue(remainingEstimates.originalTimeEstimate),
        strong: (chunks)=>formatStrong(chunks)
    }));
    if (estimationType === (0, $guzeq.STORY_POINTS)) {
        if (isCompanyManaged && isDisplayRemainTimeEnabled) elements.push(...[
            infoVerticalDivider('remaining'),
            remainingEstimateState
        ]);
        elements.push(...[
            infoVerticalDivider('storyPoint'),
            storyPointState
        ]);
    } else if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) {
        if (isCompanyManaged) {
            // in a CMP board
            // show remaining estimate only if it's different from original estimate
            // and Time Tracking is set to "Remaining Estimate and Time Spent"
            isDisplayRemainTimeEnabled && isRemainDifferentFromOriginal && elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]); // always show original estimate
            elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        } else {
            // TMP
            if (remainingEstimates.remainingTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('remaining'),
                remainingEstimateState
            ]);
            if (remainingEstimates.originalTimeEstimate > 0) elements.push(...[
                infoVerticalDivider('originalEstimate'),
                originalEstimateState
            ]);
        }
    }
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center",
        justifyContent: "start",
        xcss: [
            $cce02bdbcbe8b2c4$var$dividerStatisticsContainerStyles,
            isDragIndicator ? $cce02bdbcbe8b2c4$var$dragIndicatorTextStyles : $cce02bdbcbe8b2c4$var$defaultTextStyles
        ]
    }, elements) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cce02bdbcbe8b2c4$var$DividerStatisticsContainer, {
        isDragIndicator: isDragIndicator
    }, elements);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cce02bdbcbe8b2c4$var$DividerStatisticsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wybutpp _1e0c1txw _4cvr1h6o _gy1putpp _1bahv2br _1n261g80 _18u0u2gc",
            __cmplp.isDragIndicator ? "_syaz15cr" : "_syaz1ifp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cce02bdbcbe8b2c4$var$InfoVerticalDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragIndicator: isDragIndicator, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbt94y _4t3ipxbi _1apgnqa1 _hr4jt94y _tzy41ou4",
            __cmplp.isDragIndicator ? "_mowc15cr" : "_mowc1ifp",
            __cmplp.className
        ])
    });
});
const $cce02bdbcbe8b2c4$var$dividerStatisticsContainerStyles = (0, $jJ1Sb.xcss)({
    font: 'font.body',
    columnGap: 'space.100',
    flexWrap: 'wrap'
});
const $cce02bdbcbe8b2c4$var$dragIndicatorTextStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text.inverse'
});
const $cce02bdbcbe8b2c4$var$defaultTextStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("4NOUT", function(module, exports) {

$parcel$export(module.exports, "getIsRemainingTimeTrackingEnabledSelector", () => $978174931084ba01$export$8570c81ed161c2ff);

var $dGvGJ = parcelRequire("dGvGJ");

var $guzeq = parcelRequire("guzeq");

var $e5nhF = parcelRequire("e5nhF");
const $978174931084ba01$export$bbf9cd07c2eaa1ef = (state)=>(0, $e5nhF.getEntities)(state).tracking;
const $978174931084ba01$export$8570c81ed161c2ff = (0, $dGvGJ.createSelector)($978174931084ba01$export$bbf9cd07c2eaa1ef, ({ fieldId: fieldId, isEnabled: isEnabled })=>fieldId === (0, $guzeq.REMAINING_TIME_ESTIMATE) && isEnabled);

});

parcelRegister("enPV1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3068047a3cbdcd8e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3068047a3cbdcd8e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    totalCards: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    totalCardsDragIndicator: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-drag-indicator",
        "defaultMessage": "<strong>{cardAmount} {cardAmount, plural, one {issue} other {issues}}</strong>"
    },
    remainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.remaining-label",
        "defaultMessage": "Remaining: <strong> {estimate}</strong>"
    },
    estimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.estimate-label",
        "defaultMessage": "Estimate: <strong> {estimate}</strong>"
    },
    filteredAmountCards: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-amount-cards",
        "defaultMessage": "{filteredIssues} of {cardAmount} {cardAmount, plural, one {issue} other {issues}} visible"
    },
    filteredRemainingLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-remaining-label",
        "defaultMessage": "Remaining: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    },
    filteredEstimateLabel: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-estimate-label",
        "defaultMessage": "Estimate: <strong>{filteredEstimate}</strong> of <strong> {estimate}</strong>"
    },
    totalCardsDragIndicatorIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-drag-indicator-issue-term-refresh",
        "defaultMessage": "<strong>{cardAmount} {cardAmount, plural, one {issue} other {issues}}</strong>"
    },
    totalCardsIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.total-cards-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    filteredAmountCardsIssueTermRefresh: {
        "id": "backlog.card-list.divider.divider-statistics.filtered-amount-cards-issue-term-refresh",
        "defaultMessage": "{filteredIssues} of {cardAmount} {cardAmount, plural, one {issue} other {issues}} visible"
    }
});

});

parcelRegister("6diJT", function(module, exports) {

$parcel$export(module.exports, "getTotalIssues", () => $ca06649e502e40d5$export$ccdde37230173dca);
$parcel$export(module.exports, "useFilteredIssueCount", () => $ca06649e502e40d5$export$e00b7e9864c0aea);
$parcel$export(module.exports, "getRemainingEstimate", () => $ca06649e502e40d5$export$f7a6085461cb8569);
$parcel$export(module.exports, "useFilteredRemainingEstimate", () => $ca06649e502e40d5$export$c02472649cbf065e);
$parcel$export(module.exports, "useFormatEstimationValue", () => $ca06649e502e40d5$export$272fec22eab6d7a0);
$parcel$export(module.exports, "useFormatTimeTrackingValue", () => $ca06649e502e40d5$export$4098419827dc90d2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $g4tDr = parcelRequire("g4tDr");

var $etKNj = parcelRequire("etKNj");

var $cL3Uo = parcelRequire("cL3Uo");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $e5nhF = parcelRequire("e5nhF");

var $45Qwd = parcelRequire("45Qwd");
function $ca06649e502e40d5$export$a9dc09a05e35644a(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = (0, $e5nhF.getEntities)(state).cardOrder[cardListId] ?? [];
    if (!dropIndicator) return cardIds;
    const cardListOrder = (0, $e5nhF.getEntities)(state).cardListOrder ?? [];
    const filteredCards = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? [];
    const targetListIndex = cardListOrder.indexOf(dropIndicator.droppingOverCardListId);
    const sourceListIndex = cardListOrder.indexOf(cardListId);
    // When dragging up into a previous list
    if (targetListIndex < sourceListIndex) return cardIds.filter((cardId)=>filteredCards.includes(cardId) === false);
    if (dropIndicator.droppingOverCardListId === cardListId) {
        const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
        const targetIndex = filteredCards?.indexOf(droppingOverCardId);
        const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
        const cardsToInclude = new Set(filteredCards.slice(0, limitIndex));
        const filteredCardsSet = new Set(filteredCards);
        return cardIds.filter((cardId)=>filteredCardsSet.has(cardId) === false || cardsToInclude.has(cardId));
    }
    const { droppingOverCardId: droppingOverCardId, edge: edge } = dropIndicator;
    const targetListCardIds = (0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[dropIndicator.droppingOverCardListId] ?? [];
    const targetIndex = targetListCardIds?.indexOf(droppingOverCardId);
    const limitIndex = edge === 'bottom' ? targetIndex + 1 : targetIndex;
    const extraCards = targetListCardIds.slice(0, limitIndex);
    const betweenListsCardIds = cardListOrder.slice(sourceListIndex + 1, targetListIndex).flatMap((listId)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[listId]);
    return cardIds.concat(betweenListsCardIds).concat(extraCards);
}
function $ca06649e502e40d5$export$ccdde37230173dca(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const dividerCardIds = $ca06649e502e40d5$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    const cards = dividerCardIds.map((cardId)=>(0, $e5nhF.getEntities)(state).card[cardId]);
    const dividerCardIdsExcludingSubtasks = cards.filter((card)=>!(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel)).map((card)=>card.id);
    return dividerCardIdsExcludingSubtasks.length;
}
const $ca06649e502e40d5$export$e00b7e9864c0aea = (cardListId)=>{
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId]) || [];
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const cardIdsExcludingSubtasks = cardIds.filter((cardId)=>{
        const card = allCards[cardId];
        return !(0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
    });
    return cardIdsExcludingSubtasks?.length ?? 0;
};
function $ca06649e502e40d5$export$20385ed8ed7319fa(card) {
    if (card.isDone) return {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0
    };
    return {
        storyPoints: card.estimate?.storyPoints ?? 0,
        originalTimeEstimate: card.estimate?.originalEstimate?.value ?? 0,
        remainingTimeEstimate: card.estimate?.timeRemainingEstimate?.value ?? 0
    };
}
function $ca06649e502e40d5$export$f7a6085461cb8569(state, { cardListId: cardListId, dropIndicator: dropIndicator }) {
    const cardIds = $ca06649e502e40d5$export$a9dc09a05e35644a(state, {
        cardListId: cardListId,
        dropIndicator: dropIndicator
    });
    const cards = cardIds.map((cardId)=>(0, $e5nhF.getEntities)(state).card[cardId]);
    const estimates = cards.map((card)=>$ca06649e502e40d5$export$20385ed8ed7319fa(card));
    return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
            totalIssues: acc.totalIssues + 1,
            storyPoints: acc.storyPoints + storyPoints,
            originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
            remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
        }), {
        storyPoints: 0,
        originalTimeEstimate: 0,
        remainingTimeEstimate: 0,
        totalIssues: 0
    });
}
function $ca06649e502e40d5$export$c02472649cbf065e(cardListId) {
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getFilteredOrderedCardIdsByCardListId)(state)[cardListId] ?? []);
    const allCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    return (0, $5uXOq.useMemo)(()=>{
        const cards = cardIds.map((cardId)=>allCards[cardId]);
        const estimates = cards.map((card)=>$ca06649e502e40d5$export$20385ed8ed7319fa(card));
        return estimates.reduce((acc, { storyPoints: storyPoints, originalTimeEstimate: originalTimeEstimate, remainingTimeEstimate: remainingTimeEstimate })=>({
                totalIssues: acc.totalIssues + 1,
                storyPoints: acc.storyPoints + storyPoints,
                originalTimeEstimate: acc.originalTimeEstimate + originalTimeEstimate,
                remainingTimeEstimate: acc.remainingTimeEstimate + remainingTimeEstimate
            }), {
            storyPoints: 0,
            originalTimeEstimate: 0,
            remainingTimeEstimate: 0,
            totalIssues: 0
        });
    }, [
        cardIds,
        allCards
    ]);
}
function $ca06649e502e40d5$export$272fec22eab6d7a0() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const formatStoryPointsTotal = (0, $cL3Uo.useFormatStoryPointsTotal)();
    return (value)=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatStoryPointsTotal(value);
    };
}
const $ca06649e502e40d5$export$4098419827dc90d2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    return (value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
};

});
parcelRegister("cL3Uo", function(module, exports) {

$parcel$export(module.exports, "useFormatStoryPointsTotal", () => $027176c8dd096f8f$export$1d30858fcd85be3);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $027176c8dd096f8f$export$1d30858fcd85be3 = ()=>{
    const { formatNumber: formatNumber } = (0, $koVbs.default)();
    // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
    // as the numbers end with lots of zeroes followed by a single digit, trimming
    // after 8 decimal points results in a sane representation
    return (0, $5uXOq.useCallback)((total)=>formatNumber(total, {
            maximumFractionDigits: 8
        }), [
        formatNumber
    ]);
};

});




parcelRegister("lzKXg", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $7af680f370d0a17c$export$ee9f6369c1b523a9);
/**
 * This module implements the view handling of drag-and-drop for cards on the backlog.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $gccSB = parcelRequire("gccSB");

var $7DcPW = parcelRequire("7DcPW");

var $leVjT = parcelRequire("leVjT");

var $7Gk7K = parcelRequire("7Gk7K");
parcelRequire("fypfV");
var $i0uMQ = parcelRequire("i0uMQ");
parcelRequire("fFy9O");
var $jGko2 = parcelRequire("jGko2");

var $g4tDr = parcelRequire("g4tDr");

var $1fZVH = parcelRequire("1fZVH");

var $lowQN = parcelRequire("lowQN");

var $2lpqS = parcelRequire("2lpqS");


var $c1MAf = parcelRequire("c1MAf");

var $a7yHf = parcelRequire("a7yHf");

var $6GNN7 = parcelRequire("6GNN7");

var $eMLHT = parcelRequire("eMLHT");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $4VAKv = parcelRequire("4VAKv");

var $cYzNd = parcelRequire("cYzNd");

var $jyQw0 = parcelRequire("jyQw0");

var $kPjMF = parcelRequire("kPjMF");
function $7af680f370d0a17c$export$3e7309cd70331d59({ args: args, into: { cardId: cardId, cardParentId: cardParentId, cardIsSubtask: cardIsSubtask, cardIndex: cardIndex, cardOrderList: cardOrderList, cards: cards }, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask }) {
    if (args.source.data.type === 'DIVIDER') return !cardIsSubtask;
    if (args.source.data.type !== (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) return false;
    if (args.source.data.cardId === cardId) return false;
    if (!args.source.data.cardIsSubtask && cardOrderList.length === 1) return true;
    // ? Parent is in list and next card is subtask and has same parent
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId)) return !((0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // ? Parent is not in list and prev and next card is subtask
    if (cardIsSubtask && args.source.data.cardIsSubtask === false && cardOrderList.find((id)=>id === cardParentId) === undefined) return !((0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex - 1]]?.typeHierarchyLevel) && (0, $g4tDr.isSubtaskHierarchyLevel)(cards[cardOrderList[cardIndex + 1]]?.typeHierarchyLevel) && cardParentId === cards[cardOrderList[cardIndex - 1]]?.parentId && cardParentId === cards[cardOrderList[cardIndex + 1]]?.parentId);
    // rerank within parent card group if only subtasks within that group are selected
    if (cardIsSubtask) return args.source.data.cardParentId === cardParentId && isAllSelectedSiblingSubtasks;
    return !isAnySelectedOrphanedSubtask;
}
function $7af680f370d0a17c$export$e2e8fa6a19b7160b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks }) {
    if (isCmpKanban) return true;
    // disable drag if orphaned subtasks have been selected with other cards
    return !(isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks);
}
function $7af680f370d0a17c$export$d195ad1a96bdcc9b({ isCmpKanban: isCmpKanban, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isInvalidDropTarget: isInvalidDropTarget }) {
    return !isCmpKanban && isAnySelectedOrphanedSubtask && isInvalidDropTarget;
}
function $7af680f370d0a17c$export$c20a17931b5f1f2d({ source: source, into: into, orderedCardIds: orderedCardIds, cards: cards, isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask, isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks, isCmpKanban: isCmpKanban }) {
    const intoCard = cards[orderedCardIds[into.index]];
    // Cards above and under the *target* card
    const intoCardTop = cards[orderedCardIds[into.index - 1]];
    const intoCardBottom = cards[orderedCardIds[into.index + 1]];
    // Dragging sub-task alone or with its own siblings onto its parent group
    if (source.isSubtask && !into.isSubtask && source.parentId === intoCard?.id && isAllSelectedSiblingSubtasks) return into.isCollapsed ? [] : [
        'bottom'
    ];
    // Dragging sub-task into any of its siblings
    if (source.isSubtask && into.isSubtask && source.parentId === into.parentId) return [
        'top',
        'bottom'
    ];
    // Can't drag sub-task on other cases if their parent isn't also selected
    if (source.isSubtask && isAnySelectedOrphanedSubtask) return [];
    if (isAnySelectedOrphanedSubtask && !isAllSelectedSiblingSubtasks && !isCmpKanban) return [];
    // Dragging task into a parent group
    const isDroppingIntoParentAttachedToGroup = !into.isSubtask && intoCardBottom?.parentId === intoCard?.id && !into.isCollapsed;
    if (isDroppingIntoParentAttachedToGroup) return [
        'top'
    ];
    // Test function for if a card is the same "card group" as the target
    const isSameGroup = (cardToTest)=>{
        if (cardToTest?.id === into.parentId) return true;
        if (cardToTest && (0, $g4tDr.isSubtaskHierarchyLevel)(cardToTest.typeHierarchyLevel) && cardToTest?.parentId === into.parentId) return true;
        return false;
    };
    // Dragging task into a detached sub-task group's first card
    // * target is sub-task
    // * card above it is not or is missing
    // * card above it is not this card's parent
    // This is the "first sub-task in a group without parent"
    const isDetachedSubtaskTopCard = into.isSubtask && !isSameGroup(intoCardTop);
    if (isDetachedSubtaskTopCard) return [
        'top'
    ];
    // This is the "last sub-task in a group with or without parent"
    const isBottomSubtask = into.isSubtask && !isSameGroup(intoCardBottom);
    if (isBottomSubtask) return [
        'bottom'
    ];
    // Dragging task into another task
    return into.isSubtask ? [] : [
        'bottom',
        'top'
    ];
}
function $7af680f370d0a17c$export$ee9f6369c1b523a9({ elementRef: elementRef, cardId: cardId, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const [dropState, setDropState] = (0, $5uXOq.useState)(null);
    const selectSingleCard = (0, $cYzNd.useSelectSingleCard)();
    const cards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCards));
    const card = cards[cardId];
    const cardListKeys = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListsKeys));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const cardOrderList = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    const getIsParentExpanded = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetCardGroupExpanded));
    const autobatch = (0, $1fZVH.useAutobatch)();
    const isAnySelectedOrphanedSubtask = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAnySelectedOrphanedSubtasks));
    const isAllSelectedSiblingSubtasks = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAllSelectedSiblingSubtasks));
    const isCmpKanban = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        if (!card) return undefined;
        const cardParentId = card.parentId;
        const cardIsSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(card.typeHierarchyLevel);
        const cardIndex = cardOrderList[cardListId].indexOf(cardId);
        return (0, $leVjT.combine)((0, $7Gk7K.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardIsSubtask: cardIsSubtask,
                    cardParentId: cardParentId,
                    cardListId: cardListId
                }),
            onDragStart: ()=>{
                autobatch(()=>{
                    selectSingleCard(cardId);
                    const sourceCardGroupType = cardIsSubtask === true && cardListId && cardParentId ? (0, $lowQN.createCardGroupDroppableId)(cardParentId, cardListId) : (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE);
                    dispatch((0, $eMLHT.beforeCapture)(sourceCardGroupType, cardListId, cardIsSubtask, cardParentId ?? undefined));
                    dispatch((0, $a7yHf.cardListDragStart)(cardListKeys, cardListId, cardParentId ? `${cardParentId}-${cardListId}` : undefined));
                    dispatch((0, $eMLHT.dragStart)());
                });
            },
            onDrop: (_args)=>{
                autobatch(()=>{
                    const isInvalidDropTarget = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(_args.location.current.dropTargets);
                    const showHelperFunction = $7af680f370d0a17c$export$d195ad1a96bdcc9b({
                        isCmpKanban: isCmpKanban,
                        isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                        isInvalidDropTarget: isInvalidDropTarget
                    });
                    if (showHelperFunction) dispatch((0, $6GNN7.cardDragDisallowed)());
                    setDragState({
                        type: 'idle'
                    });
                    dispatch((0, $a7yHf.cardListDragEnd)());
                });
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jGko2.setCustomNativeDragPreview)({
                    getOffset: (0, $i0uMQ.pointerOutsideOfPreview)({
                        x: '8px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }), (0, $7Gk7K.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element, source: source })=>{
                const data = {
                    type: (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
                    cardId: cardId,
                    cardListId: cardListId
                };
                const allowedEdges = $7af680f370d0a17c$export$c20a17931b5f1f2d({
                    source: {
                        isSubtask: Boolean(source.data.cardIsSubtask),
                        cardId: Number(source.data.cardId),
                        parentId: source.data.cardParentId != null ? Number(source.data.cardParentId) : null
                    },
                    into: {
                        index: cardIndex,
                        isSubtask: cardIsSubtask,
                        cardId: cardId,
                        parentId: cardParentId,
                        isCollapsed: !getIsParentExpanded(cardId)
                    },
                    orderedCardIds: cardOrderList[cardListId],
                    cards: cards,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask,
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isCmpKanban: isCmpKanban
                });
                return (0, $7DcPW.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            },
            onDrag: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $7DcPW.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.source.data.cardListId) : null
                        });
                    }
                });
            },
            onDragEnter: (args)=>{
                autobatch(()=>{
                    if (args.source.data.cardId !== cardId) {
                        const edge = (0, $7DcPW.extractClosestEdge)(args.self.data);
                        setDropState(edge && {
                            edge: edge,
                            cardListIfDivider: args.source.data.type === 'DIVIDER' ? String(args.self.data.cardListId) : null
                        });
                    }
                });
            },
            onDragLeave: (_args)=>{
                autobatch(()=>{
                    setDropState(null);
                });
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onDropTargetChange: (_args)=>{},
            canDrop: (args)=>$7af680f370d0a17c$export$3e7309cd70331d59({
                    args: args,
                    into: {
                        cardId: cardId,
                        cardParentId: cardParentId,
                        cardIsSubtask: cardIsSubtask,
                        cardIndex: cardIndex,
                        cardOrderList: cardOrderList[cardListId],
                        cards: cards
                    },
                    isAllSelectedSiblingSubtasks: isAllSelectedSiblingSubtasks,
                    isAnySelectedOrphanedSubtask: isAnySelectedOrphanedSubtask
                }),
            onDrop: (args)=>{
                autobatch(()=>{
                    const location = {
                        type: dropState?.edge === 'top' ? 'before' : 'after',
                        target: cardId
                    };
                    if (args.source.data.type === 'DIVIDER') moveCards({
                        source: {
                            type: 'divider',
                            cardListId: String(args.source.data.cardListId)
                        },
                        location: location
                    });
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: location
                    });
                    setDropState(null);
                    dispatch((0, $eMLHT.dragEnd)());
                });
            }
        }));
    }, [
        card,
        cardId,
        cardListId,
        dispatch,
        moveCards,
        dropState?.edge,
        elementRef,
        selectSingleCard,
        cardListKeys,
        cardOrderList,
        cards,
        getIsParentExpanded,
        autobatch,
        isAnySelectedOrphanedSubtask,
        isAllSelectedSiblingSubtasks,
        isCmpKanban
    ]);
    return {
        isDragging: dragState.type === 'dragging',
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kPjMF.CardDragPreview), {
            id: cardId
        }), dragState.container) : null,
        closestEdge: dropState?.edge ?? null,
        dropState: dropState
    };
}

});
parcelRegister("7DcPW", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $cad05cf43b0ad094$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $cad05cf43b0ad094$export$945a571f3b658bf);
const $cad05cf43b0ad094$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $cad05cf43b0ad094$var$uniqueKey = Symbol('closestEdge');
function $cad05cf43b0ad094$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $cad05cf43b0ad094$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$cad05cf43b0ad094$var$uniqueKey]: addClosestEdge
    };
}
function $cad05cf43b0ad094$export$945a571f3b658bf(userData) {
    return userData[$cad05cf43b0ad094$var$uniqueKey] ?? null;
}

});

parcelRegister("fypfV", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("i0uMQ")).pointerOutsideOfPreview);

var $i0uMQ = parcelRequire("i0uMQ");

});
parcelRegister("i0uMQ", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $32205252804d1b6d$export$427e20518819fabc);
function $32205252804d1b6d$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        // Only reliable cross browser technique found to push a
        // drag preview away from the cursor is to use transparent borders on the container
        Object.assign(container.style, {
            borderLeft: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        return {
            x: 0,
            y: 0
        };
    };
}

});


parcelRegister("fFy9O", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("jGko2")).setCustomNativeDragPreview);

var $jGko2 = parcelRequire("jGko2");

});
parcelRegister("jGko2", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $eecd261de9880ca0$export$52d889c66db0f96e);

var $7ZhsK = parcelRequire("7ZhsK");

var $8rlxw = parcelRequire("8rlxw");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $eecd261de9880ca0$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $eecd261de9880ca0$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $eecd261de9880ca0$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $bcf04451a6b3a355$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $8rlxw.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $7ZhsK.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $bcf04451a6b3a355$export$7d0a15ee70427305 = 2147483647;



parcelRegister("lowQN", function(module, exports) {

$parcel$export(module.exports, "createCardGroupDroppableId", () => $109391da4a112ce1$export$307280e35e15ee59);

var $2lpqS = parcelRequire("2lpqS");
const $109391da4a112ce1$export$307280e35e15ee59 = (parentId, cardListId)=>`${0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE}::${parentId}::${cardListId}`;
const $109391da4a112ce1$export$241ac0b55520e68e = (droppableId)=>{
    const [prefix, parentId, cardListId] = droppableId.split('::');
    if (prefix === (0, $2lpqS.CARD_GROUP_DROPPABLE_TYPE) && parentId && cardListId) return {
        parentId: Number(parentId),
        cardListId: cardListId
    };
    return null;
};

});

parcelRegister("cYzNd", function(module, exports) {

$parcel$export(module.exports, "useSelectSingleCard", () => $9139c3fc9e0d318a$export$a8cb27a008b03fe0);

var $7D59a = parcelRequire("7D59a");

var $4mqko = parcelRequire("4mqko");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $9139c3fc9e0d318a$export$a8cb27a008b03fe0() {
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    return (0, $7D59a.useEvent)((cardId)=>{
        if (!selectedCards.includes(cardId)) dispatch((0, $4mqko.cardSingleSelect)(cardId));
    });
}

});

parcelRegister("kPjMF", function(module, exports) {

$parcel$export(module.exports, "CardDragPreview", () => $d6f6f8f102e59d9e$export$4b9ac0eff1e3aa75);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $gFfOq = parcelRequire("gFfOq");
function $d6f6f8f102e59d9e$export$4b9ac0eff1e3aa75({ id: id }) {
    const isCmpKanbanBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCmpKanbanProject));
    const getDraggingCardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDraggingCardIds));
    const getChildIdsByParentId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getChildIdsByParentIdSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6f6f8f102e59d9e$var$CardDragPreviewContainer, null, getDraggingCardIds(id).slice(0, 5).map((contentsId, index)=>{
        const subtaskIds = isCmpKanbanBacklog ? [] : getChildIdsByParentId[contentsId];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFfOq.default), {
            id: contentsId,
            key: contentsId,
            canShowStatus: false,
            isDragging: index === 0,
            isDragHandle: true,
            shouldRenderRichCard: false,
            isAttachedToParent: false,
            subtaskIds: subtaskIds
        });
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6f6f8f102e59d9e$var$CardDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _p12fgx0z",
            __cmplp.className
        ])
    });
});

});



parcelRegister("1hEu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe4a2ecb92b3234$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $h1sEN = parcelRequire("h1sEN");

var $hIWd8 = parcelRequire("hIWd8");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dCm1o = parcelRequire("dCm1o");

var $10Ngv = parcelRequire("10Ngv");


var $c1MAf = parcelRequire("c1MAf");

var $hf5c2 = parcelRequire("hf5c2");

var $9tZuw = parcelRequire("9tZuw");

var $7zF3i = parcelRequire("7zF3i");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $74oBv = parcelRequire("74oBv");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");

var $aU3CO = parcelRequire("aU3CO");

var $fmuR9 = parcelRequire("fmuR9");

var $1z1J7 = parcelRequire("1z1J7");
const $ffe4a2ecb92b3234$var$isInSimplifyIccBundleVariation = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isInVariationM2 = expConfigM2.get('cohort', 'not-enrolled') === 'variation';
    return isInVariationM2;
};
// Hacky way to generate optimistic issue id.
// Not ideal, but have to do it for now to react backwards compatibility with current ICC.
let $ffe4a2ecb92b3234$var$lastCardId = 0;
const $ffe4a2ecb92b3234$var$generateId = ()=>{
    $ffe4a2ecb92b3234$var$lastCardId -= 1;
    return $ffe4a2ecb92b3234$var$lastCardId;
};
const $ffe4a2ecb92b3234$var$StyledTypeSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ffe4a2ecb92b3234$var$TypeSelectWrapper, {
        shouldShowChevron: isCompanyManaged,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_beta_drop_1')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1sEN.default), {
        ...props,
        ref: ref
    }));
});
const $ffe4a2ecb92b3234$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('backlog');
const $ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY = 'selectedIssueType';
const $ffe4a2ecb92b3234$var$InlineCardCreate = ({ isBetweenCards: isBetweenCards = false, isOpenByDefault: isOpenByDefault = false, messages: messages, insertBefore: insertBefore = null, listId: listId, placeholderText: placeholderText = '', triggerLabel: triggerLabel = '', ariaLabelledBy: ariaLabelledBy, isFormVisible: isFormVisible })=>{
    const initialCardTypes = (0, $c1MAf.useBacklogSelector)((0, $aU3CO.getCardTypesForICC));
    const parentId = (0, $c1MAf.useBacklogSelector)((0, $3QmBe.getLastAppliedParentFilters));
    const manageIssueTypesLink = (0, $c1MAf.useBacklogSelector)((state)=>{
        if ((0, $1z1J7.canEditBoardConfig)(state)) return (0, $74oBv.manageIssueTypesSelector)(state);
        return null;
    });
    const enabledFilters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const hasICCOpen = (0, $c1MAf.useBacklogSelector)((state)=>insertBefore != null ? (0, $dGljH.hasICCOpen)(state, {
            cardId: insertBefore
        }) : false);
    const issueParents = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentsSelector)(state));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { storeFieldsFromCardCreateData: storeFieldsFromCardCreateData, storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData } = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isBoardCrossProject = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsBoardCrossProject));
    const inlineCreateSessionId = (0, $c1MAf.useBacklogSelector)((0, $aU3CO.getInlineCreateSessionId));
    const defaultCardTypeId = $ffe4a2ecb92b3234$var$localStorage.get($ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY) || null;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onAutoOpen = (0, $5uXOq.useCallback)((sessionId)=>{
        // start event for auto open icc
        const startAutoOpenICCAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        // firing start event for icc that is auto open - same as onTriggerClickCallback
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(startAutoOpenICCAnalyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: isBetweenCards ? (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) : (0, $7462c685f739ed5a$export$dda6912361cddac9),
            sessionId: sessionId,
            isInSimplifyIccBundleVariation: $ffe4a2ecb92b3234$var$isInSimplifyIccBundleVariation(),
            isAutoOpen: true
        });
        dispatch((0, $7zF3i.setInlineCreateSessionId)({
            sessionId: sessionId
        }));
    }, [
        createAnalyticsEvent,
        dispatch,
        isBetweenCards,
        isFormVisible
    ]);
    const onTriggerClick = (sessionId)=>{
        const shouldOpenGICModal = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
        if (shouldOpenGICModal) {
            const fixVersions = enabledFilters.VERSION || [];
            const cardTypeId = initialCardTypes?.[0]?.id ?? null;
            dispatch((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    cardSummary: '',
                    cardTypeId: cardTypeId,
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
        } else {
            // Dispatch session id.
            if (sessionId) dispatch((0, $7zF3i.setInlineCreateSessionId)({
                sessionId: sessionId
            }));
            dispatch((0, $9tZuw.setCardIdWithAboveICCOpen)(insertBefore));
        }
    };
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $9tZuw.setCardIdWithAboveICCOpen)(null));
    }, [
        dispatch
    ]);
    const onCreate = (0, $5uXOq.useCallback)((inlineCards)=>{
        const { cardTypeId: cardTypeId } = inlineCards[0];
        const cardTypeEntity = initialCardTypes.find((ct)=>ct.id === cardTypeId);
        const fixVersions = enabledFilters.VERSION || [];
        const tempIds = inlineCards.map(()=>$ffe4a2ecb92b3234$var$generateId());
        const doesCardTypeHaveRequiredFields = !!cardTypeEntity?.hasRequiredFields;
        if (doesCardTypeHaveRequiredFields) {
            dispatch((0, $5Eoed.openModal)({
                type: (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5),
                payload: {
                    cardListId: listId,
                    cardParentId: parentId,
                    // With requiredfield multiple card creation is disabled
                    cardSummary: inlineCards[0].summary,
                    cardTypeId: Number(cardTypeId),
                    rankBeforeCardId: insertBefore,
                    fixVersions: fixVersions,
                    sessionId: inlineCreateSessionId
                }
            }));
            return;
        }
        /** Analytics: We indicate to the analytics for issue creation that the inline creation ended up finishing inline creation (With session ID) */ const analyticsEvent = createAnalyticsEvent({
            action: 'created',
            actionSubject: 'issue',
            sessionId: inlineCreateSessionId
        });
        dispatch((0, $hf5c2.cardCreateMultipleRequest)({
            tempIds: tempIds,
            summaries: inlineCards.map((inlineCard)=>inlineCard.summary),
            typeId: Number(cardTypeId),
            typeIcon: cardTypeEntity ? cardTypeEntity.iconUrl : '',
            parentId: parentId,
            fixVersions: fixVersions,
            insertBefore: insertBefore,
            listId: listId,
            storeFieldsFromCardCreateData: storeFieldsFromCardCreateData,
            storeFieldsFromFetchIssuesData: storeFieldsFromFetchIssuesData,
            analyticsEvent: analyticsEvent
        }));
        $ffe4a2ecb92b3234$var$localStorage.set($ffe4a2ecb92b3234$var$SELECTED_ISSUE_TYPE_KEY, cardTypeId);
    }, [
        initialCardTypes,
        enabledFilters.VERSION,
        createAnalyticsEvent,
        dispatch,
        parentId,
        insertBefore,
        listId,
        storeFieldsFromCardCreateData,
        storeFieldsFromFetchIssuesData,
        inlineCreateSessionId
    ]);
    const onCancelWrapper = (0, $5uXOq.useCallback)(()=>{
        onCancel();
    }, [
        onCancel
    ]);
    const onIccCreate = (0, $5uXOq.useCallback)((issues)=>{
        onCreate(issues.map((issue)=>({
                summary: issue.summary,
                cardTypeId: Number(issue.cardTypeId)
            })));
    }, [
        onCreate
    ]);
    const isFormHidden = isCompanyManaged && (isBoardCrossProject || !initialCardTypes?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hIWd8.default), {
        cardTypes: initialCardTypes,
        extraItems: manageIssueTypesLink && [
            {
                url: manageIssueTypesLink
            }
        ] || undefined,
        numFilters: Object.keys(enabledFilters).length,
        onCreate: onIccCreate,
        onTriggerClick: onTriggerClick,
        onCancel: onCancelWrapper,
        onBlur: onCancelWrapper,
        appearance: (0, $7462c685f739ed5a$export$db1cdb8627b81f84),
        triggerAppearance: isBetweenCards ? (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) : (0, $7462c685f739ed5a$export$dda6912361cddac9),
        isFormVisibleDefault: isFormHidden ? false : isOpenByDefault || hasICCOpen,
        messages: messages,
        placeholderText: placeholderText,
        triggerLabel: triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        defaultCardTypeId: defaultCardTypeId,
        isFormVisible: isFormHidden ? false : isFormVisible,
        TypeSelect: $ffe4a2ecb92b3234$var$StyledTypeSelect,
        onAutoOpen: onAutoOpen
    });
};
var $ffe4a2ecb92b3234$export$2e2bcd8739ae039 = $ffe4a2ecb92b3234$var$InlineCardCreate;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ffe4a2ecb92b3234$var$TypeSelectWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowChevron: shouldShowChevron, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7oyrj",
            __cmplp.shouldShowChevron ? "_18u01jfw" : __cmplp.isVisualRefresh ? "_18u0u2gc" : "_18u0v47k",
            __cmplp.className
        ])
    });
});

});
const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("h1sEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ada8b7065598a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gZL7V = parcelRequire("gZL7V");

var $89thI = parcelRequire("89thI");

var $dHJL9 = parcelRequire("dHJL9");

var $9ed83 = parcelRequire("9ed83");

var $huYk7 = parcelRequire("huYk7");

var $68lfN = parcelRequire("68lfN");

var $cmm8Z = parcelRequire("cmm8Z");

var $df73Y = parcelRequire("df73Y");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");
var $cpoLo = parcelRequire("cpoLo");

var $MGmIU = parcelRequire("MGmIU");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dCm1o = parcelRequire("dCm1o");


var $cjDfJ = parcelRequire("cjDfJ");

var $2ehBu = parcelRequire("2ehBu");
const $d5ada8b7065598a5$var$ANALYTICS_SUBJECT = 'iccTypeSelect'; // NOTE: Compiled/css rules needs to be defined at the top of the component (Otherwise Cypress tests failing)
// ----------------------------------------------------------------------------------------------------------
// kept here the negative margins from the original dropdown component but ideally these shouldn't exist
const $d5ada8b7065598a5$var$containerStyles = null;
const $d5ada8b7065598a5$var$optionWrapperStyles = null;
const $d5ada8b7065598a5$var$triggerContentStylesOld = null;
const $d5ada8b7065598a5$var$singValueContainerStyles = null;
const $d5ada8b7065598a5$var$extraLinksGroupStyles = null;
const $d5ada8b7065598a5$var$optionContentStyles = null;
const $d5ada8b7065598a5$var$Option = ({ children: children, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { cardType: cardType, renderAdditionalContent: renderAdditionalContent } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "platform-inline-card-create.ui.form.type-select.option",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, !!cardType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        styles: {
            marginRight: "var(--ds-space-100, 8px)"
        },
        cardType: cardType
    }), !cardType && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $d5ada8b7065598a5$var$manageTypesIconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($df73Y))), {
        label: formatMessage((0, $cjDfJ.default).manageTypes),
        color: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug"
        ])
    }, children), !!cardType && !!renderAdditionalContent && renderAdditionalContent(cardType)));
};
const $d5ada8b7065598a5$var$Group = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_x3dope8f _19pk1b66 _ca0q1b66"
        ])
    }, children);
const $d5ada8b7065598a5$var$COMPONENTS_OLD = {
    Option: $d5ada8b7065598a5$var$Option,
    Group: $d5ada8b7065598a5$var$Group
};
const $d5ada8b7065598a5$var$COMPONENTS = {
    Option: $d5ada8b7065598a5$var$Option
};
const $d5ada8b7065598a5$var$makeOption = (cardType, renderAdditionalContent)=>({
        label: cardType.name,
        value: cardType.id,
        cardType: cardType,
        optionType: 'card',
        renderAdditionalContent: renderAdditionalContent
    });
const $d5ada8b7065598a5$var$TypeSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cardTypes: cardTypes, selectedCardTypeId: selectedCardTypeId, extraItems: extraItems, shouldRenderToParent: shouldRenderToParent = false, onSelectCardType: onSelectCardType, renderAdditionalOptionContent: renderAdditionalOptionContent }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const isDefaultItem = cardTypes[0]?.id === selectedCardTypeId;
    const value = (0, $5uXOq.useMemo)(()=>{
        const selectedType = cardTypes.find((type)=>type.id === selectedCardTypeId);
        return selectedType ? $d5ada8b7065598a5$var$makeOption(selectedType, renderAdditionalOptionContent) : null;
    }, [
        cardTypes,
        selectedCardTypeId,
        renderAdditionalOptionContent
    ]);
    const options = (0, $5uXOq.useMemo)(()=>{
        const result = cardTypes.filter((type)=>type.id !== selectedCardTypeId).map((type)=>$d5ada8b7065598a5$var$makeOption(type, renderAdditionalOptionContent)); // add extra links if there are any
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems)) {
            let message;
            if ((0, $dCm1o.isVisualRefreshEnabled)()) message = (0, $cjDfJ.default).manageTypes;
            else message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).manageIssueTypesIssueTermRefresh : (0, $cjDfJ.default).manageIssueTypes;
            const linkOptions = extraItems.map((item)=>({
                    label: item.name != null ? item.name : formatMessage(message),
                    value: item.url,
                    url: item.url,
                    onItemSelect: item.onItemSelect,
                    openNewTab: item.openNewTab ?? false,
                    optionType: 'link'
                })); // if there are no other options, or if visual-refresh is enabled, add them flat
            if ((0, $dCm1o.isVisualRefreshEnabled)() || !result.length) result.push(...linkOptions);
            else // if there are other options already, group the extra links in a new section
            result.push({
                options: linkOptions,
                optionType: 'links'
            });
        }
        return result;
    }, [
        cardTypes,
        extraItems,
        formatMessage,
        renderAdditionalOptionContent,
        selectedCardTypeId
    ]);
    const isOptionDisabled = (0, $5uXOq.useCallback)((option)=>option.optionType === 'card' && option.cardType.isDisabled === true, []);
    const trigger = (0, $5uXOq.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: value?.label ?? null,
            delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
            ...triggerProps,
            appearance: "subtle",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger",
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.075",
            xcss: $d5ada8b7065598a5$var$triggerContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cmm8Z))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_18u0r5cr _2hwxr5cr"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cjDfJ.default).ariaLabelIssueTermRefresh : (0, $cjDfJ.default).ariaLabel, {
                value: value?.label ?? formatMessage((0, $cjDfJ.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.type-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _4cvr1h6o _18u01b66"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
            cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
        }), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($huYk7))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
            label: ""
        })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $d5ada8b7065598a5$var$typeContainerStyles
        }, triggerContent);
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        if (option && 'cardType' in option && option.cardType != null) {
            onSelectCardType(option.cardType.id);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedType',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'url' in option && option.url != null) {
            if (option.openNewTab === true) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(option.url, '_blank');
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.href = option.url;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'selectedExtraItem',
                actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
            }), {
                issueTypesCount: cardTypes.length
            });
        }
        if (option && 'onItemSelect' in option && option.onItemSelect) option.onItemSelect();
    }, [
        cardTypes.length,
        createAnalyticsEvent,
        onSelectCardType
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: $d5ada8b7065598a5$var$ANALYTICS_SUBJECT
        }), {
            isDefaultItem: isDefaultItem
        });
    }, [
        createAnalyticsEvent,
        isDefaultItem
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    if (cardTypes.length === 1 && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(extraItems)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: value?.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_18u0r5cr _2hwxr5cr",
            "_1e0c116y _4cvr1h6o _1yt41b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ehBu.default), {
        cardType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, 'cardType')
    })));
     // to render popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpoLo.default // @ts-expect-error — Type 'T | null' is not assignable to type 'PopupSelect<SelectOption, false, ModifierList>'
    ), {
        ref: setRefNode,
        components: (0, $dCm1o.isVisualRefreshEnabled)() ? $d5ada8b7065598a5$var$COMPONENTS : $d5ada8b7065598a5$var$COMPONENTS_OLD,
        target: trigger,
        options: options,
        isOptionDisabled: isOptionDisabled,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-type-select",
        testId: "platform-inline-card-create.ui.form.type-select.type-select",
        popperProps: {
            strategy: popupStrategy
        }
    });
});
const $d5ada8b7065598a5$var$typeContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $d5ada8b7065598a5$var$triggerContentStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.050'
});
const $d5ada8b7065598a5$var$manageTypesIconContainer = (0, $jJ1Sb.xcss)({
    paddingInline: 'space.025',
    marginRight: 'space.100'
});
var $d5ada8b7065598a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d5ada8b7065598a5$var$TypeSelect);

});
parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});

parcelRegister("huYk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbd408067dd10042$var$_react = $cbd408067dd10042$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $cbd408067dd10042$var$_chevronUp = $cbd408067dd10042$var$_interopRequireDefault((parcelRequire("cmm8Z")));
function $cbd408067dd10042$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cbd408067dd10042$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $cbd408067dd10042$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $cbd408067dd10042$var$_chevronUp.default,
        iconType: "utility"
    }));
$cbd408067dd10042$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $cbd408067dd10042$var$_default = module.exports.default = $cbd408067dd10042$var$ChevronUpIcon;

});

parcelRegister("df73Y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5b544bb8861995e91922f92ab112b41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a4227a649cbbc21$var$_react = $9a4227a649cbbc21$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a4227a649cbbc21$var$_UNSAFE_baseNew = $9a4227a649cbbc21$var$_interopRequireDefault((parcelRequire("huIZN")));
function $9a4227a649cbbc21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShowMoreHorizontal".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for secondary/tertiary more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a4227a649cbbc21$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $9a4227a649cbbc21$var$_react.default.createElement($9a4227a649cbbc21$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-9.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`,
        type: 'utility'
    }, props));
$9a4227a649cbbc21$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $9a4227a649cbbc21$var$_default = module.exports.default = $9a4227a649cbbc21$var$ShowMoreHorizontalIcon;

});

parcelRegister("cpoLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d8aa9ddc3ee04f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $9ZKDH = parcelRequire("9ZKDH");

var $dI393 = parcelRequire("dI393");

var $an6Kn = parcelRequire("an6Kn");
var $7WKv6 = parcelRequire("7WKv6");
var $cNrZb = parcelRequire("cNrZb");

var $4wJSY = parcelRequire("4wJSY");

var $3QrEQ = parcelRequire("3QrEQ");

var $294ns = parcelRequire("294ns");

var $8dMtY = parcelRequire("8dMtY");


var $j6ZuL = parcelRequire("j6ZuL");

var $i4Azc = parcelRequire("i4Azc");

var $fw6Sj = parcelRequire("fw6Sj");

var $3DGLw = parcelRequire("3DGLw");
/**
 * Are we rendering on the client or server?
 */ const $21d8aa9ddc3ee04f$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $21d8aa9ddc3ee04f$var$FocusLock = (0, $294ns.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
const $21d8aa9ddc3ee04f$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $21d8aa9ddc3ee04f$var$defaultPopperProps = {
    modifiers: $21d8aa9ddc3ee04f$var$modifiers,
    placement: 'bottom-start'
};
const $21d8aa9ddc3ee04f$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $21d8aa9ddc3ee04f$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$21d8aa9ddc3ee04f$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $3DGLw.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$21d8aa9ddc3ee04f$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $an6Kn.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QrEQ.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNrZb.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $8dMtY.mergeStyles)((0, $i4Azc.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $3DGLw.defaultComponents),
            mergedPopperProps: $21d8aa9ddc3ee04f$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $294ns.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $294ns.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $294ns.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $21d8aa9ddc3ee04f$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $3DGLw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $fw6Sj.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $fw6Sj.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $fw6Sj.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7WKv6.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21d8aa9ddc3ee04f$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $294ns.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3DGLw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: id,
                    testId: testId,
                    ref: !(0, $294ns.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21d8aa9ddc3ee04f$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6ZuL.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $8dMtY.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $21d8aa9ddc3ee04f$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("an6Kn", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $78d1492bc11ed2b6$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $78d1492bc11ed2b6$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $78d1492bc11ed2b6$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $78d1492bc11ed2b6$export$3dbd3405086fec7b = $5uXOq.createContext();
var $78d1492bc11ed2b6$export$cbabb21c2529b130 = $5uXOq.createContext();
function $78d1492bc11ed2b6$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($78d1492bc11ed2b6$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($78d1492bc11ed2b6$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("7WKv6", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $5c92053d7495f524$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $an6Kn = parcelRequire("an6Kn");

var $509xu = parcelRequire("509xu");

var $itPl7 = parcelRequire("itPl7");
var $5c92053d7495f524$var$NOOP = function NOOP() {
    return void 0;
};
var $5c92053d7495f524$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $5c92053d7495f524$var$EMPTY_MODIFIERS = [];
function $5c92053d7495f524$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $5c92053d7495f524$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $an6Kn.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $509xu.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $itPl7.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $5c92053d7495f524$var$NOOP,
            update: update || $5c92053d7495f524$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $509xu.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("509xu", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3a445a1b1480f0cb$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3a445a1b1480f0cb$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3a445a1b1480f0cb$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3a445a1b1480f0cb$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3a445a1b1480f0cb$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $3a445a1b1480f0cb$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3a445a1b1480f0cb$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3a445a1b1480f0cb$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3a445a1b1480f0cb$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3a445a1b1480f0cb$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3a445a1b1480f0cb$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("itPl7", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $d742c26b64924d1f$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lIebA = parcelRequire("lIebA");

var $lHrkK = parcelRequire("lHrkK");

var $509xu = parcelRequire("509xu");
var $d742c26b64924d1f$var$EMPTY_MODIFIERS = [];
var $d742c26b64924d1f$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $d742c26b64924d1f$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $509xu.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $509xu.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $509xu.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $509xu.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $lIebA.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("lIebA", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $fce8b60ac80205fe$export$8f7491d57c8f97a9);

var $48JvH = parcelRequire("48JvH");

var $1hC8g = parcelRequire("1hC8g");

var $l2REG = parcelRequire("l2REG");

var $jsvAg = parcelRequire("jsvAg");

var $lJxD0 = parcelRequire("lJxD0");

var $8LUqn = parcelRequire("8LUqn");

var $eJKmL = parcelRequire("eJKmL");

var $1nCiI = parcelRequire("1nCiI");

var $8YxiD = parcelRequire("8YxiD");

var $3MuHn = parcelRequire("3MuHn");


var $fce8b60ac80205fe$export$d34966752335dd47 = [
    (0, $1hC8g.default),
    (0, $l2REG.default),
    (0, $jsvAg.default),
    (0, $lJxD0.default),
    (0, $8LUqn.default),
    (0, $eJKmL.default),
    (0, $1nCiI.default),
    (0, $8YxiD.default),
    (0, $3MuHn.default)
];
var $fce8b60ac80205fe$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $48JvH.popperGenerator)({
    defaultModifiers: $fce8b60ac80205fe$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("48JvH", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $303b362fd3ffb668$export$ed5e13716264f202);

var $6B9c0 = parcelRequire("6B9c0");

var $8t11G = parcelRequire("8t11G");

var $8ysBd = parcelRequire("8ysBd");

var $lqBUe = parcelRequire("lqBUe");

var $i0AW4 = parcelRequire("i0AW4");

var $1h8uw = parcelRequire("1h8uw");

var $3sGEe = parcelRequire("3sGEe");


var $4ANRp = parcelRequire("4ANRp");
var $303b362fd3ffb668$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $303b362fd3ffb668$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $303b362fd3ffb668$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $303b362fd3ffb668$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $303b362fd3ffb668$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $4ANRp.isElement)(reference) ? (0, $8ysBd.default)(reference) : reference.contextElement ? (0, $8ysBd.default)(reference.contextElement) : [],
                    popper: (0, $8ysBd.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $i0AW4.default)((0, $3sGEe.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$303b362fd3ffb668$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $6B9c0.default)(reference, (0, $lqBUe.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $8t11G.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1h8uw.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$303b362fd3ffb668$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $303b362fd3ffb668$export$8f7491d57c8f97a9 = /*#__PURE__*/ $303b362fd3ffb668$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6B9c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdd544559a37d5c$export$2e2bcd8739ae039);

var $9Pa0v = parcelRequire("9Pa0v");

var $8JTaa = parcelRequire("8JTaa");

var $VVNM8 = parcelRequire("VVNM8");

var $4ANRp = parcelRequire("4ANRp");

var $9n2GA = parcelRequire("9n2GA");

var $4lI7X = parcelRequire("4lI7X");

var $cYpLb = parcelRequire("cYpLb");

var $araUe = parcelRequire("araUe");
function $4cdd544559a37d5c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $araUe.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $araUe.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4cdd544559a37d5c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $4ANRp.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $4ANRp.isHTMLElement)(offsetParent) && $4cdd544559a37d5c$var$isElementScaled(offsetParent);
    var documentElement = (0, $4lI7X.default)(offsetParent);
    var rect = (0, $9Pa0v.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $VVNM8.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $cYpLb.default)(documentElement)) scroll = (0, $8JTaa.default)(offsetParent);
        if ((0, $4ANRp.isHTMLElement)(offsetParent)) {
            offsets = (0, $9Pa0v.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9n2GA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("9Pa0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $7270a3ad7b4eae0d$export$2e2bcd8739ae039);

var $4ANRp = parcelRequire("4ANRp");

var $araUe = parcelRequire("araUe");

var $fcUvZ = parcelRequire("fcUvZ");

var $73HJD = parcelRequire("73HJD");
function $7270a3ad7b4eae0d$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $4ANRp.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $araUe.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $araUe.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $4ANRp.isElement)(element) ? (0, $fcUvZ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $73HJD.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("4ANRp", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $3581337b8d502ffb$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $3581337b8d502ffb$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $3581337b8d502ffb$export$af51f0f06c0f328a);

var $fcUvZ = parcelRequire("fcUvZ");
function $3581337b8d502ffb$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fcUvZ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3581337b8d502ffb$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fcUvZ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3581337b8d502ffb$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fcUvZ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fcUvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b123d0b84a855384$export$2e2bcd8739ae039);
function $b123d0b84a855384$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("araUe", function(module, exports) {

$parcel$export(module.exports, "max", () => $7994e2b5ab944ac9$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $7994e2b5ab944ac9$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $7994e2b5ab944ac9$export$2077e0241d6afd3c);
var $7994e2b5ab944ac9$export$8960430cfd85939f = Math.max;
var $7994e2b5ab944ac9$export$96ec731ed4dcb222 = Math.min;
var $7994e2b5ab944ac9$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("73HJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $523abd175d1c0c0c$export$2e2bcd8739ae039);

var $jzoda = parcelRequire("jzoda");
function $523abd175d1c0c0c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $jzoda.default)());
}

});
parcelRegister("jzoda", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f411175bf1f87c$export$2e2bcd8739ae039);
function $e3f411175bf1f87c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("8JTaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cd50ed04a4d1ab$export$2e2bcd8739ae039);

var $70PwY = parcelRequire("70PwY");

var $fcUvZ = parcelRequire("fcUvZ");

var $4ANRp = parcelRequire("4ANRp");

var $llHPA = parcelRequire("llHPA");
function $65cd50ed04a4d1ab$export$2e2bcd8739ae039(node) {
    if (node === (0, $fcUvZ.default)(node) || !(0, $4ANRp.isHTMLElement)(node)) return (0, $70PwY.default)(node);
    else return (0, $llHPA.default)(node);
}

});
parcelRegister("70PwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b08172e3f7231d$export$2e2bcd8739ae039);

var $fcUvZ = parcelRequire("fcUvZ");
function $51b08172e3f7231d$export$2e2bcd8739ae039(node) {
    var win = (0, $fcUvZ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("llHPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ad8f1605e68799$export$2e2bcd8739ae039);
function $f8ad8f1605e68799$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("VVNM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae22939b1f03fce$export$2e2bcd8739ae039);
function $0ae22939b1f03fce$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("9n2GA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d28586ad88e5595$export$2e2bcd8739ae039);

var $9Pa0v = parcelRequire("9Pa0v");

var $4lI7X = parcelRequire("4lI7X");

var $70PwY = parcelRequire("70PwY");
function $6d28586ad88e5595$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $9Pa0v.default)((0, $4lI7X.default)(element)).left + (0, $70PwY.default)(element).scrollLeft;
}

});
parcelRegister("4lI7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ab5a58c7bd95a1$export$2e2bcd8739ae039);

var $4ANRp = parcelRequire("4ANRp");
function $32ab5a58c7bd95a1$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $4ANRp.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("cYpLb", function(module, exports) {

$parcel$export(module.exports, "default", () => $971f1206407ff8ca$export$2e2bcd8739ae039);

var $4GFmd = parcelRequire("4GFmd");
function $971f1206407ff8ca$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $4GFmd.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("4GFmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $369b2a62abb43f5a$export$2e2bcd8739ae039);

var $fcUvZ = parcelRequire("fcUvZ");
function $369b2a62abb43f5a$export$2e2bcd8739ae039(element) {
    return (0, $fcUvZ.default)(element).getComputedStyle(element);
}

});



parcelRegister("8t11G", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a1d3f1d097ac67$export$2e2bcd8739ae039);

var $9Pa0v = parcelRequire("9Pa0v");
function $62a1d3f1d097ac67$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $9Pa0v.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("8ysBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a7aeea309c9808$export$2e2bcd8739ae039);

var $8p2kj = parcelRequire("8p2kj");

var $j4chq = parcelRequire("j4chq");

var $fcUvZ = parcelRequire("fcUvZ");

var $cYpLb = parcelRequire("cYpLb");
function $63a7aeea309c9808$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $8p2kj.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fcUvZ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $cYpLb.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($63a7aeea309c9808$export$2e2bcd8739ae039((0, $j4chq.default)(target)));
}

});
parcelRegister("8p2kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e2768854fd1ce3$export$2e2bcd8739ae039);

var $j4chq = parcelRequire("j4chq");

var $cYpLb = parcelRequire("cYpLb");

var $VVNM8 = parcelRequire("VVNM8");

var $4ANRp = parcelRequire("4ANRp");
function $61e2768854fd1ce3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $VVNM8.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $4ANRp.isHTMLElement)(node) && (0, $cYpLb.default)(node)) return node;
    return $61e2768854fd1ce3$export$2e2bcd8739ae039((0, $j4chq.default)(node));
}

});
parcelRegister("j4chq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de17ea979e763a44$export$2e2bcd8739ae039);

var $VVNM8 = parcelRequire("VVNM8");

var $4lI7X = parcelRequire("4lI7X");

var $4ANRp = parcelRequire("4ANRp");
function $de17ea979e763a44$export$2e2bcd8739ae039(element) {
    if ((0, $VVNM8.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $4ANRp.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $4lI7X.default)(element) // fallback
    );
}

});



parcelRegister("lqBUe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9996e00899aebcc$export$2e2bcd8739ae039);

var $fcUvZ = parcelRequire("fcUvZ");

var $VVNM8 = parcelRequire("VVNM8");

var $4GFmd = parcelRequire("4GFmd");

var $4ANRp = parcelRequire("4ANRp");

var $hHttu = parcelRequire("hHttu");

var $j4chq = parcelRequire("j4chq");

var $jzoda = parcelRequire("jzoda");
function $f9996e00899aebcc$var$getTrueOffsetParent(element) {
    if (!(0, $4ANRp.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $4GFmd.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $f9996e00899aebcc$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $jzoda.default)());
    var isIE = /Trident/i.test((0, $jzoda.default)());
    if (isIE && (0, $4ANRp.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $4GFmd.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $j4chq.default)(element);
    if ((0, $4ANRp.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $4ANRp.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $VVNM8.default)(currentNode)) < 0){
        var css = (0, $4GFmd.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $f9996e00899aebcc$export$2e2bcd8739ae039(element) {
    var window = (0, $fcUvZ.default)(element);
    var offsetParent = $f9996e00899aebcc$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $hHttu.default)(offsetParent) && (0, $4GFmd.default)(offsetParent).position === 'static')offsetParent = $f9996e00899aebcc$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $VVNM8.default)(offsetParent) === 'html' || (0, $VVNM8.default)(offsetParent) === 'body' && (0, $4GFmd.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $f9996e00899aebcc$var$getContainingBlock(element) || window;
}

});
parcelRegister("hHttu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce2d50e088e75636$export$2e2bcd8739ae039);

var $VVNM8 = parcelRequire("VVNM8");
function $ce2d50e088e75636$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $VVNM8.default)(element)) >= 0;
}

});


parcelRegister("i0AW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c4e0bc6156144b$export$2e2bcd8739ae039);

var $kTrv6 = parcelRequire("kTrv6");
function $d1c4e0bc6156144b$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d1c4e0bc6156144b$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d1c4e0bc6156144b$var$order(modifiers); // order based on phase
    return (0, $kTrv6.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kTrv6", function(module, exports) {

$parcel$export(module.exports, "top", () => $f35e46c54a7fed6d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f35e46c54a7fed6d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f35e46c54a7fed6d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f35e46c54a7fed6d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f35e46c54a7fed6d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f35e46c54a7fed6d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f35e46c54a7fed6d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f35e46c54a7fed6d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f35e46c54a7fed6d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f35e46c54a7fed6d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f35e46c54a7fed6d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f35e46c54a7fed6d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f35e46c54a7fed6d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f35e46c54a7fed6d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f35e46c54a7fed6d$export$d087d3878fdf71d5);
var $f35e46c54a7fed6d$export$1e95b668f3b82d = 'top';
var $f35e46c54a7fed6d$export$40e543e69a8b3fbb = 'bottom';
var $f35e46c54a7fed6d$export$79ffe56a765070d2 = 'right';
var $f35e46c54a7fed6d$export$eabcd2c8791e7bf4 = 'left';
var $f35e46c54a7fed6d$export$dfb5619354ba860 = 'auto';
var $f35e46c54a7fed6d$export$aec2ce47c367b8c3 = [
    $f35e46c54a7fed6d$export$1e95b668f3b82d,
    $f35e46c54a7fed6d$export$40e543e69a8b3fbb,
    $f35e46c54a7fed6d$export$79ffe56a765070d2,
    $f35e46c54a7fed6d$export$eabcd2c8791e7bf4
];
var $f35e46c54a7fed6d$export$b3571188c770cc5a = 'start';
var $f35e46c54a7fed6d$export$bd5df0f255a350f8 = 'end';
var $f35e46c54a7fed6d$export$390fd549c5303b4d = 'clippingParents';
var $f35e46c54a7fed6d$export$d7b7311ec04a3e8f = 'viewport';
var $f35e46c54a7fed6d$export$ae5ab1c730825774 = 'popper';
var $f35e46c54a7fed6d$export$ca50aac9f3ba507f = 'reference';
var $f35e46c54a7fed6d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f35e46c54a7fed6d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f35e46c54a7fed6d$export$b3571188c770cc5a,
        placement + "-" + $f35e46c54a7fed6d$export$bd5df0f255a350f8
    ]);
}, []);
var $f35e46c54a7fed6d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f35e46c54a7fed6d$export$aec2ce47c367b8c3, [
    $f35e46c54a7fed6d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f35e46c54a7fed6d$export$b3571188c770cc5a,
        placement + "-" + $f35e46c54a7fed6d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f35e46c54a7fed6d$export$421679a7c3d56e = 'beforeRead';
var $f35e46c54a7fed6d$export$aafa59e2e03f2942 = 'read';
var $f35e46c54a7fed6d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f35e46c54a7fed6d$export$c65e99957a05207c = 'beforeMain';
var $f35e46c54a7fed6d$export$f22da7240b7add18 = 'main';
var $f35e46c54a7fed6d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f35e46c54a7fed6d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f35e46c54a7fed6d$export$68d8715fc104d294 = 'write';
var $f35e46c54a7fed6d$export$70a6e5159acce2e6 = 'afterWrite';
var $f35e46c54a7fed6d$export$d087d3878fdf71d5 = [
    $f35e46c54a7fed6d$export$421679a7c3d56e,
    $f35e46c54a7fed6d$export$aafa59e2e03f2942,
    $f35e46c54a7fed6d$export$6964f6c886723980,
    $f35e46c54a7fed6d$export$c65e99957a05207c,
    $f35e46c54a7fed6d$export$f22da7240b7add18,
    $f35e46c54a7fed6d$export$bab79516f2d662fe,
    $f35e46c54a7fed6d$export$8d4d2d70e7d46032,
    $f35e46c54a7fed6d$export$68d8715fc104d294,
    $f35e46c54a7fed6d$export$70a6e5159acce2e6
];

});


parcelRegister("1h8uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eddf72a74d8222a$export$2e2bcd8739ae039);
function $0eddf72a74d8222a$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("3sGEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2855119f130218ba$export$2e2bcd8739ae039);
function $2855119f130218ba$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1hC8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef4f53cc9c53b3f$export$2e2bcd8739ae039);

var $fcUvZ = parcelRequire("fcUvZ");
var $0ef4f53cc9c53b3f$var$passive = {
    passive: true
};
function $0ef4f53cc9c53b3f$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fcUvZ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $0ef4f53cc9c53b3f$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $0ef4f53cc9c53b3f$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $0ef4f53cc9c53b3f$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $0ef4f53cc9c53b3f$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $0ef4f53cc9c53b3f$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $0ef4f53cc9c53b3f$var$effect,
    data: {}
};

});

parcelRegister("l2REG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f52367b18fcdc24a$export$2e2bcd8739ae039);

var $7X7oG = parcelRequire("7X7oG");
function $f52367b18fcdc24a$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $7X7oG.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f52367b18fcdc24a$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $f52367b18fcdc24a$var$popperOffsets,
    data: {}
};

});
parcelRegister("7X7oG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca3c8025c8f82b6$export$2e2bcd8739ae039);

var $6MuVv = parcelRequire("6MuVv");

var $9T4yd = parcelRequire("9T4yd");

var $284nw = parcelRequire("284nw");

var $kTrv6 = parcelRequire("kTrv6");
function $5ca3c8025c8f82b6$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6MuVv.default)(placement) : null;
    var variation = placement ? (0, $9T4yd.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kTrv6.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kTrv6.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kTrv6.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kTrv6.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $284nw.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kTrv6.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kTrv6.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("6MuVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eff372790563d5b$export$2e2bcd8739ae039);

function $4eff372790563d5b$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("9T4yd", function(module, exports) {

$parcel$export(module.exports, "default", () => $732cc7ce1c6ea366$export$2e2bcd8739ae039);
function $732cc7ce1c6ea366$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("284nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $18cfb98fee216b51$export$2e2bcd8739ae039);
function $18cfb98fee216b51$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("jsvAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a921bbb46f01f1$export$2e2bcd8739ae039);

var $kTrv6 = parcelRequire("kTrv6");

var $lqBUe = parcelRequire("lqBUe");

var $fcUvZ = parcelRequire("fcUvZ");

var $4lI7X = parcelRequire("4lI7X");

var $4GFmd = parcelRequire("4GFmd");

var $6MuVv = parcelRequire("6MuVv");

var $9T4yd = parcelRequire("9T4yd");

var $araUe = parcelRequire("araUe");
var $e2a921bbb46f01f1$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $e2a921bbb46f01f1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $araUe.round)(x * dpr) / dpr || 0,
        y: (0, $araUe.round)(y * dpr) / dpr || 0
    };
}
function $e2a921bbb46f01f1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kTrv6.left);
    var sideY = (0, $kTrv6.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $lqBUe.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fcUvZ.default)(popper)) {
            offsetParent = (0, $4lI7X.default)(popper);
            if ((0, $4GFmd.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kTrv6.top) || (placement === (0, $kTrv6.left) || placement === (0, $kTrv6.right)) && variation === (0, $kTrv6.end)) {
            sideY = (0, $kTrv6.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kTrv6.left) || (placement === (0, $kTrv6.top) || placement === (0, $kTrv6.bottom)) && variation === (0, $kTrv6.end)) {
            sideX = (0, $kTrv6.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $e2a921bbb46f01f1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $e2a921bbb46f01f1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fcUvZ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $e2a921bbb46f01f1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6MuVv.default)(state.placement),
        variation: (0, $9T4yd.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $e2a921bbb46f01f1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $e2a921bbb46f01f1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e2a921bbb46f01f1$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $e2a921bbb46f01f1$var$computeStyles,
    data: {}
};

});

parcelRegister("lJxD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd27e2cfff6bf754$export$2e2bcd8739ae039);

var $VVNM8 = parcelRequire("VVNM8");

var $4ANRp = parcelRequire("4ANRp");
// and applies them to the HTMLElements such as popper and arrow
function $fd27e2cfff6bf754$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $4ANRp.isHTMLElement)(element) || !(0, $VVNM8.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $fd27e2cfff6bf754$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $4ANRp.isHTMLElement)(element) || !(0, $VVNM8.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $fd27e2cfff6bf754$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $fd27e2cfff6bf754$var$applyStyles,
    effect: $fd27e2cfff6bf754$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("8LUqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $662e7b3700d3de86$export$2e2bcd8739ae039);

var $6MuVv = parcelRequire("6MuVv");

var $kTrv6 = parcelRequire("kTrv6");
function $662e7b3700d3de86$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6MuVv.default)(placement);
    var invertDistance = [
        (0, $kTrv6.left),
        (0, $kTrv6.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kTrv6.left),
        (0, $kTrv6.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $662e7b3700d3de86$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kTrv6.placements).reduce(function(acc, placement) {
        acc[placement] = $662e7b3700d3de86$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $662e7b3700d3de86$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $662e7b3700d3de86$var$offset
};

});

parcelRegister("eJKmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba93bfd274b3ff9$export$2e2bcd8739ae039);

var $1Q5Mp = parcelRequire("1Q5Mp");

var $6MuVv = parcelRequire("6MuVv");

var $b8hJ1 = parcelRequire("b8hJ1");

var $fBODx = parcelRequire("fBODx");

var $7sYDZ = parcelRequire("7sYDZ");

var $kTrv6 = parcelRequire("kTrv6");

var $9T4yd = parcelRequire("9T4yd");
function $aba93bfd274b3ff9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6MuVv.default)(placement) === (0, $kTrv6.auto)) return [];
    var oppositePlacement = (0, $1Q5Mp.default)(placement);
    return [
        (0, $b8hJ1.default)(placement),
        oppositePlacement,
        (0, $b8hJ1.default)(oppositePlacement)
    ];
}
function $aba93bfd274b3ff9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6MuVv.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1Q5Mp.default)(preferredPlacement)
    ] : $aba93bfd274b3ff9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6MuVv.default)(placement) === (0, $kTrv6.auto) ? (0, $7sYDZ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6MuVv.default)(placement);
        var isStartVariation = (0, $9T4yd.default)(placement) === (0, $kTrv6.start);
        var isVertical = [
            (0, $kTrv6.top),
            (0, $kTrv6.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $fBODx.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kTrv6.right) : (0, $kTrv6.left) : isStartVariation ? (0, $kTrv6.bottom) : (0, $kTrv6.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1Q5Mp.default)(mainVariationSide);
        var altVariationSide = (0, $1Q5Mp.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $aba93bfd274b3ff9$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $aba93bfd274b3ff9$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1Q5Mp", function(module, exports) {

$parcel$export(module.exports, "default", () => $156f218442b9c9d8$export$2e2bcd8739ae039);
var $156f218442b9c9d8$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $156f218442b9c9d8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $156f218442b9c9d8$var$hash[matched];
    });
}

});

parcelRegister("b8hJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $81ae30e65e5db77c$export$2e2bcd8739ae039);
var $81ae30e65e5db77c$var$hash = {
    start: 'end',
    end: 'start'
};
function $81ae30e65e5db77c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $81ae30e65e5db77c$var$hash[matched];
    });
}

});

parcelRegister("fBODx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5d1971986c5a87b$export$2e2bcd8739ae039);

var $f8ZEL = parcelRequire("f8ZEL");

var $4lI7X = parcelRequire("4lI7X");

var $9Pa0v = parcelRequire("9Pa0v");

var $7X7oG = parcelRequire("7X7oG");

var $iyQtI = parcelRequire("iyQtI");

var $kTrv6 = parcelRequire("kTrv6");

var $4ANRp = parcelRequire("4ANRp");

var $5U0w1 = parcelRequire("5U0w1");

var $4N00j = parcelRequire("4N00j");
function $b5d1971986c5a87b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kTrv6.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kTrv6.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kTrv6.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5U0w1.default)(typeof padding !== 'number' ? padding : (0, $4N00j.default)(padding, (0, $kTrv6.basePlacements)));
    var altContext = elementContext === (0, $kTrv6.popper) ? (0, $kTrv6.reference) : (0, $kTrv6.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $f8ZEL.default)((0, $4ANRp.isElement)(element) ? element : element.contextElement || (0, $4lI7X.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $9Pa0v.default)(state.elements.reference);
    var popperOffsets = (0, $7X7oG.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $iyQtI.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kTrv6.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kTrv6.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kTrv6.right),
                (0, $kTrv6.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kTrv6.top),
                (0, $kTrv6.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("f8ZEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0676e12e59e27d9$export$2e2bcd8739ae039);

var $kTrv6 = parcelRequire("kTrv6");

var $hVRt0 = parcelRequire("hVRt0");

var $1IaHh = parcelRequire("1IaHh");

var $8ysBd = parcelRequire("8ysBd");

var $lqBUe = parcelRequire("lqBUe");

var $4lI7X = parcelRequire("4lI7X");

var $4GFmd = parcelRequire("4GFmd");

var $4ANRp = parcelRequire("4ANRp");

var $9Pa0v = parcelRequire("9Pa0v");

var $j4chq = parcelRequire("j4chq");

var $eBVPY = parcelRequire("eBVPY");

var $VVNM8 = parcelRequire("VVNM8");

var $iyQtI = parcelRequire("iyQtI");

var $araUe = parcelRequire("araUe");
function $b0676e12e59e27d9$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $9Pa0v.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b0676e12e59e27d9$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kTrv6.viewport) ? (0, $iyQtI.default)((0, $hVRt0.default)(element, strategy)) : (0, $4ANRp.isElement)(clippingParent) ? $b0676e12e59e27d9$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $iyQtI.default)((0, $1IaHh.default)((0, $4lI7X.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b0676e12e59e27d9$var$getClippingParents(element) {
    var clippingParents = (0, $8ysBd.default)((0, $j4chq.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $4GFmd.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $4ANRp.isHTMLElement)(element) ? (0, $lqBUe.default)(element) : element;
    if (!(0, $4ANRp.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $4ANRp.isElement)(clippingParent) && (0, $eBVPY.default)(clippingParent, clipperElement) && (0, $VVNM8.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b0676e12e59e27d9$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b0676e12e59e27d9$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b0676e12e59e27d9$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $araUe.max)(rect.top, accRect.top);
        accRect.right = (0, $araUe.min)(rect.right, accRect.right);
        accRect.bottom = (0, $araUe.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $araUe.max)(rect.left, accRect.left);
        return accRect;
    }, $b0676e12e59e27d9$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("hVRt0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e13bef0e5ae3cb$export$2e2bcd8739ae039);

var $fcUvZ = parcelRequire("fcUvZ");

var $4lI7X = parcelRequire("4lI7X");

var $9n2GA = parcelRequire("9n2GA");

var $73HJD = parcelRequire("73HJD");
function $d0e13bef0e5ae3cb$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fcUvZ.default)(element);
    var html = (0, $4lI7X.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $73HJD.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9n2GA.default)(element),
        y: y
    };
}

});

parcelRegister("1IaHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f232b9761882e9$export$2e2bcd8739ae039);

var $4lI7X = parcelRequire("4lI7X");

var $4GFmd = parcelRequire("4GFmd");

var $9n2GA = parcelRequire("9n2GA");

var $70PwY = parcelRequire("70PwY");

var $araUe = parcelRequire("araUe");
function $13f232b9761882e9$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $4lI7X.default)(element);
    var winScroll = (0, $70PwY.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $araUe.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $araUe.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9n2GA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $4GFmd.default)(body || html).direction === 'rtl') x += (0, $araUe.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("eBVPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3162a7e1f09485$export$2e2bcd8739ae039);

var $4ANRp = parcelRequire("4ANRp");
function $aa3162a7e1f09485$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $4ANRp.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("iyQtI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8341c11d28cae37$export$2e2bcd8739ae039);
function $d8341c11d28cae37$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5U0w1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44c2950ff460d218$export$2e2bcd8739ae039);

var $6I3Sm = parcelRequire("6I3Sm");
function $44c2950ff460d218$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $6I3Sm.default)(), paddingObject);
}

});
parcelRegister("6I3Sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e29dbcf06db87a6$export$2e2bcd8739ae039);
function $4e29dbcf06db87a6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4N00j", function(module, exports) {

$parcel$export(module.exports, "default", () => $37cbbdd36c87eb8d$export$2e2bcd8739ae039);
function $37cbbdd36c87eb8d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("7sYDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $56fa308dd56dcd49$export$2e2bcd8739ae039);

var $9T4yd = parcelRequire("9T4yd");

var $kTrv6 = parcelRequire("kTrv6");

var $fBODx = parcelRequire("fBODx");

var $6MuVv = parcelRequire("6MuVv");
function $56fa308dd56dcd49$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kTrv6.placements) : _options$allowedAutoP;
    var variation = (0, $9T4yd.default)(placement);
    var placements = variation ? flipVariations ? (0, $kTrv6.variationPlacements) : (0, $kTrv6.variationPlacements).filter(function(placement) {
        return (0, $9T4yd.default)(placement) === variation;
    }) : (0, $kTrv6.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $fBODx.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6MuVv.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1nCiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1015a62c20aa0ceb$export$2e2bcd8739ae039);

var $kTrv6 = parcelRequire("kTrv6");

var $6MuVv = parcelRequire("6MuVv");

var $284nw = parcelRequire("284nw");

var $3DF8O = parcelRequire("3DF8O");

var $jeeww = parcelRequire("jeeww");

var $8t11G = parcelRequire("8t11G");

var $lqBUe = parcelRequire("lqBUe");

var $fBODx = parcelRequire("fBODx");

var $9T4yd = parcelRequire("9T4yd");

var $6I3Sm = parcelRequire("6I3Sm");

var $araUe = parcelRequire("araUe");
function $1015a62c20aa0ceb$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $fBODx.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6MuVv.default)(state.placement);
    var variation = (0, $9T4yd.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $284nw.default)(basePlacement);
    var altAxis = (0, $3DF8O.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kTrv6.top) : (0, $kTrv6.left);
        var altSide = mainAxis === 'y' ? (0, $kTrv6.bottom) : (0, $kTrv6.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kTrv6.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kTrv6.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8t11G.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $6I3Sm.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jeeww.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $lqBUe.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jeeww.within)(tether ? (0, $araUe.min)(min, tetherMin) : min, offset, tether ? (0, $araUe.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kTrv6.top) : (0, $kTrv6.left);
        var _altSide = mainAxis === 'x' ? (0, $kTrv6.bottom) : (0, $kTrv6.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kTrv6.top),
            (0, $kTrv6.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jeeww.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jeeww.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1015a62c20aa0ceb$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $1015a62c20aa0ceb$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3DF8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a64ed611f6b4fae$export$2e2bcd8739ae039);
function $2a64ed611f6b4fae$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("jeeww", function(module, exports) {

$parcel$export(module.exports, "within", () => $dffa973a19872d68$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $dffa973a19872d68$export$86c8af6d3ef0b4a);

var $araUe = parcelRequire("araUe");
function $dffa973a19872d68$export$f28d906d67a997f3(min, value, max) {
    return (0, $araUe.max)(min, (0, $araUe.min)(value, max));
}
function $dffa973a19872d68$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $dffa973a19872d68$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("8YxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $688dc1ef1ede0f97$export$2e2bcd8739ae039);

var $6MuVv = parcelRequire("6MuVv");

var $8t11G = parcelRequire("8t11G");

var $eBVPY = parcelRequire("eBVPY");

var $lqBUe = parcelRequire("lqBUe");

var $284nw = parcelRequire("284nw");

var $jeeww = parcelRequire("jeeww");

var $5U0w1 = parcelRequire("5U0w1");

var $4N00j = parcelRequire("4N00j");

var $kTrv6 = parcelRequire("kTrv6");
var $688dc1ef1ede0f97$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5U0w1.default)(typeof padding !== 'number' ? padding : (0, $4N00j.default)(padding, (0, $kTrv6.basePlacements)));
};
function $688dc1ef1ede0f97$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6MuVv.default)(state.placement);
    var axis = (0, $284nw.default)(basePlacement);
    var isVertical = [
        (0, $kTrv6.left),
        (0, $kTrv6.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $688dc1ef1ede0f97$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8t11G.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kTrv6.top) : (0, $kTrv6.left);
    var maxProp = axis === 'y' ? (0, $kTrv6.bottom) : (0, $kTrv6.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $lqBUe.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jeeww.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $688dc1ef1ede0f97$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $eBVPY.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $688dc1ef1ede0f97$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $688dc1ef1ede0f97$var$arrow,
    effect: $688dc1ef1ede0f97$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("3MuHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0daaeb1593909c$export$2e2bcd8739ae039);

var $kTrv6 = parcelRequire("kTrv6");

var $fBODx = parcelRequire("fBODx");
function $2c0daaeb1593909c$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $2c0daaeb1593909c$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kTrv6.top),
        (0, $kTrv6.right),
        (0, $kTrv6.bottom),
        (0, $kTrv6.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $2c0daaeb1593909c$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $fBODx.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $fBODx.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $2c0daaeb1593909c$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $2c0daaeb1593909c$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $2c0daaeb1593909c$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $2c0daaeb1593909c$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $2c0daaeb1593909c$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $2c0daaeb1593909c$var$hide
};

});




parcelRegister("cNrZb", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $950fc5047a8da9c7$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $an6Kn = parcelRequire("an6Kn");

var $509xu = parcelRequire("509xu");
function $950fc5047a8da9c7$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $an6Kn.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $509xu.setRef)(innerRef, node);
        (0, $509xu.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $509xu.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $509xu.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("3DGLw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $d930593cb12fb5ba$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $d930593cb12fb5ba$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $d930593cb12fb5ba$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $kR0Zl = parcelRequire("kR0Zl");

var $32eUr = parcelRequire("32eUr");


var $dtXUS = parcelRequire("dtXUS");

var $8tUJa = parcelRequire("8tUJa");
function $d930593cb12fb5ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d930593cb12fb5ba$var$menuDialogStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $dtXUS.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $5e0c0d4e15efb4a6$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $5e0c0d4e15efb4a6$export$46987b49aab6d1a8)}`})`
});
const $d930593cb12fb5ba$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        css: [
            $d930593cb12fb5ba$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $d930593cb12fb5ba$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $d930593cb12fb5ba$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d930593cb12fb5ba$var$dropdownStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kR0Zl))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $d930593cb12fb5ba$var$controlStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $d930593cb12fb5ba$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        css: $d930593cb12fb5ba$var$controlStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).Control, {
        ...props,
        innerProps: innerProps
    }));
const $d930593cb12fb5ba$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8tUJa.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $d930593cb12fb5ba$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $d930593cb12fb5ba$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).IndicatorSeparator, props);
const $d930593cb12fb5ba$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).ClearIndicator, props);
const $d930593cb12fb5ba$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $32eUr.components).MultiValueRemove, props);
const $d930593cb12fb5ba$export$71abc632aa29e6fe = {
    Control: $d930593cb12fb5ba$var$Control,
    DropdownIndicator: $d930593cb12fb5ba$var$DropdownIndicator,
    Menu: $d930593cb12fb5ba$var$Menu,
    IndicatorSeparator: $d930593cb12fb5ba$var$IndicatorSeparator,
    ClearIndicator: $d930593cb12fb5ba$var$ClearIndicator,
    MultiValueRemove: $d930593cb12fb5ba$var$MultiValueRemove
};

});
parcelRegister("kR0Zl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2e9862b59e573d2$var$_react = $f2e9862b59e573d2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f2e9862b59e573d2$var$_search = $f2e9862b59e573d2$var$_interopRequireDefault((parcelRequire("5VL3N")));

var $f2e9862b59e573d2$var$_search2 = $f2e9862b59e573d2$var$_interopRequireDefault((parcelRequire("kGwNk")));
function $f2e9862b59e573d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2e9862b59e573d2$var$SearchIcon = (props)=>/*#__PURE__*/ $f2e9862b59e573d2$var$_react.default.createElement($f2e9862b59e573d2$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $f2e9862b59e573d2$var$_search2.default
    }, props));
$f2e9862b59e573d2$var$SearchIcon.Name = 'SearchIconMigration';
var $f2e9862b59e573d2$var$_default = module.exports.default = $f2e9862b59e573d2$var$SearchIcon;

});
parcelRegister("kGwNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0f12b3df0b8a7fc$var$_react = $f0f12b3df0b8a7fc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $f0f12b3df0b8a7fc$var$_search = $f0f12b3df0b8a7fc$var$_interopRequireDefault((parcelRequire("5VL3N")));
function $f0f12b3df0b8a7fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f0f12b3df0b8a7fc$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $f0f12b3df0b8a7fc$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $f0f12b3df0b8a7fc$var$_search.default
    }));
$f0f12b3df0b8a7fc$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $f0f12b3df0b8a7fc$var$_default = module.exports.default = $f0f12b3df0b8a7fc$var$EditorSearchIcon;

});




parcelRegister("cjDfJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98179f22ec008310$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98179f22ec008310$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.type-select.aria-label",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    invalid: {
        "id": "inline-card-create.form.type-select.invalid",
        "defaultMessage": "invalid"
    },
    // Delete this message when cleaning up visual-refresh FG
    manageIssueTypes: {
        "id": "inline-card-create.form.type-select.manage-issue-types",
        "defaultMessage": "Manage issue types"
    },
    manageTypes: {
        "id": "inline-card-create.form.type-select.manage-types",
        "defaultMessage": "Manage types"
    },
    addIssueType: {
        "id": "inline-card-create.form.type-select.add-issue-type",
        "defaultMessage": "Add issue type"
    },
    ariaLabelIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.aria-label-issue-term-refresh",
        "defaultMessage": "The current issue type is {value}. Press the 'Space' key to change the issue type."
    },
    manageIssueTypesIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.manage-issue-types-issue-term-refresh",
        "defaultMessage": "Manage issue types"
    },
    addIssueTypeIssueTermRefresh: {
        "id": "inline-card-create.form.type-select.add-issue-type-issue-term-refresh",
        "defaultMessage": "Add issue type"
    }
});

});

parcelRegister("2ehBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9af3d59273fe1f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* eslint-disable jira/react/no-style-attribute */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $f9af3d59273fe1f1$export$9fbe3594a958ae08 = '/icons/issuetypes/genericissue.svg';
const $f9af3d59273fe1f1$var$cardTypeImageStyles = null;
const $f9af3d59273fe1f1$var$TypeIcon = ({ cardType: cardType, styles: styles, className: className })=>cardType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: cardType.iconUrl,
        alt: cardType.name,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        alt: "",
        src: $f9af3d59273fe1f1$export$9fbe3594a958ae08,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_4t3i7vkz _1bsb7vkz",
            className
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styles
    });
var $f9af3d59273fe1f1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f9af3d59273fe1f1$var$TypeIcon);

});


parcelRegister("hIWd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d06f081c1e675aa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $5knXz = parcelRequire("5knXz");

var $4pxa7 = parcelRequire("4pxa7");


var $2Z6La = parcelRequire("2Z6La");

var $dhszq = parcelRequire("dhszq");

var $kNtWa = parcelRequire("kNtWa");

var $hNJJt = parcelRequire("hNJJt");

var $l94uE = parcelRequire("l94uE");
const $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isEnrolledM2 = expConfigM2.get('cohort', 'not-enrolled') !== 'not-enrolled';
    return isEnrolledM2;
};
const $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation = ()=>{
    const [expConfigM2] = (0, $6s1PB.UNSAFE_noExposureExp)('simplify_icc_bundle_m2');
    const isInVariationM2 = expConfigM2.get('cohort', 'not-enrolled') === 'variation';
    return isInVariationM2;
};
// exact trigger height
const $0d06f081c1e675aa$var$TRIGGER_HEIGHT = 40;
const $0d06f081c1e675aa$var$withMarginTopStyles = null;
const $0d06f081c1e675aa$var$withTransparentStyles = null;
const $0d06f081c1e675aa$export$c283de3a59c46bc6 = (cardTypes, cardTypeId, defaultCardTypeId)=>{
    const selectedCardType = cardTypes.find(({ id: id })=>id === cardTypeId);
    const fallbackCardTypeId = defaultCardTypeId && cardTypes.some(({ id: id, isDisabled: isDisabled })=>id === defaultCardTypeId && isDisabled !== true) ? defaultCardTypeId : null;
    if (selectedCardType?.isDisabled === true) return fallbackCardTypeId;
    // To prevent setting invalid value when user switches to another ICC component that have different cardTypes
    return selectedCardType !== undefined ? cardTypeId : fallbackCardTypeId;
};
const $0d06f081c1e675aa$var$InlineCardCreate = (props)=>{
    const { isFormVisible: isFormVisibleProp, isFormVisibleDefault: isFormVisibleDefault = false, isDisabled: isDisabled = false, shouldScrollIntoView: shouldScrollIntoView, onChangeFormVisible: onChangeFormVisible = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), triggerAppearance: triggerAppearance, onTriggerClick: onTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeCardType: onChangeCardType = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeSummary: onChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeStatusTransition: onChangeStatusTransition = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeProject: onChangeProject = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardTypes: cardTypes = [], defaultCardTypeId: defaultCardTypeId, autoFocus: autoFocus, extraItems: extraItems, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, triggerLabel: triggerLabel, ariaLabelledBy: ariaLabelledBy, appearance: appearance, placeholderText: placeholderText, numFilters: numFilters, messages: messages, saveOnBlur: saveOnBlur, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter, onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), TypeSelect: TypeSelect, StatusSelect: StatusSelect, statusTransitions: statusTransitions, projects: projects, isModalTrigger: isModalTrigger, shouldShowCreateButton: shouldShowCreateButton, onAutoOpen: onAutoOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isFormVisibleProp ?? isFormVisibleDefault);
    const [triggerUnmountTimeoutId, setTriggerUnmountTimeoutId] = (0, $5uXOq.useState)(null);
    const previousIsFormVisibleProp = (0, $1XJ20.usePreviousWithInitial)(isFormVisibleProp);
    const previousIsFormVisible = (0, $1XJ20.usePreviousWithInitial)(isFormVisible);
    const [shouldFocusTrigger, setShouldFocusTrigger] = (0, $5uXOq.useState)(false);
    const setFocusOnTrigger = (0, $5uXOq.useCallback)(()=>{
        setShouldFocusTrigger(true);
    }, []);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    // should be clean up with experiment simplify_icc_bundle_m2 or move up to src/packages/software/board/src/view/board-container/board/inline-card-create/visible-icc
    const { hasCreatedIssueICC: hasCreatedIssueICC, triggerReason: triggerReason } = $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4pxa7.useTriggerEventState)() : {
        hasCreatedIssueICC: false,
        triggerReason: undefined
    };
    const { setHasCreatedIssueICC: setHasCreatedIssueICC, setTriggerReason: setTriggerReason } = $0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4pxa7.useKeepIccOpenActions)() : {
        setHasCreatedIssueICC: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        setTriggerReason: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!false && (previousIsFormVisibleProp !== isFormVisibleProp || previousIsFormVisible !== isFormVisible)) // invoke callback everytime isFormVisibleProp or internal isFormVisible state changes
        onChangeFormVisible(isFormVisibleProp ?? isFormVisible);
    }, [
        isFormVisible,
        isFormVisibleProp,
        onChangeFormVisible,
        previousIsFormVisible,
        previousIsFormVisibleProp
    ]);
    const onTriggerClickCallback = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
        if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(false);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
            },
            isAutoOpen: false
        });
        if (isFormVisibleProp === undefined) {
            setTriggerUnmountTimeoutId(null);
            setIsFormVisible(true);
        }
        if ((0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally')) setShouldFocusTrigger(false);
        onTriggerClick(sessionId);
    }, [
        setHasCreatedIssueICC,
        isFormVisible,
        triggerAppearance,
        isFormVisibleProp,
        onTriggerClick
    ]);
    const onCancelCallback = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'inlineCardCreate'
        }), {
            cancelledBy: (0, $7462c685f739ed5a$export$2bb790b9008907b4)
        });
        if (isFormVisibleProp === undefined) {
            if (triggerUnmountTimeoutId) {
                clearTimeout(triggerUnmountTimeoutId);
                setTriggerUnmountTimeoutId(null);
            }
            setIsFormVisible(false);
        }
        onCancel();
    }, [
        createAnalyticsEvent,
        triggerUnmountTimeoutId,
        isFormVisibleProp,
        onCancel
    ]);
    const makeOnBlur = (0, $5uXOq.useCallback)((context)=>(summary)=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'blurred',
                actionSubject: 'inlineCardCreate'
            }), {
                cancelledBy: (0, $7462c685f739ed5a$export$565566e3df4dad53),
                ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                    withContent: !!summary,
                    isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
                }
            });
            context.onChangeSummary(summary);
            if (isFormVisibleProp === undefined) {
                if (triggerUnmountTimeoutId) {
                    clearTimeout(triggerUnmountTimeoutId);
                    setTriggerUnmountTimeoutId(null);
                }
                setIsFormVisible(false);
            }
            onBlur();
            if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) setHasCreatedIssueICC(true);
        }, [
        createAnalyticsEvent,
        isFormVisibleProp,
        onBlur,
        setHasCreatedIssueICC,
        triggerUnmountTimeoutId
    ]);
    const makeOnCreate = (0, $5uXOq.useCallback)((context)=>(issues, metadata)=>{
            // analytic event name will be changed in the future to match other events
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'input'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                createdBy: metadata.createdBy
            });
            context.onCreate();
            onCreate(issues, metadata, analyticsEvent);
            showEnforcementIfStorageIsFull({
                touchpoint: 'inline-card-create'
            });
            if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle()) {
                setHasCreatedIssueICC(true);
                setTriggerReason('lastIssueCreated');
            }
        }, [
        createAnalyticsEvent,
        onCreate,
        showEnforcementIfStorageIsFull,
        setHasCreatedIssueICC,
        setTriggerReason
    ]);
    const makeOnCancel = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onCancel) return ()=>{
            context.onCancel();
            onCancelCallback();
        };
        return onCancelCallback;
    }, [
        onCancelCallback
    ]);
    const makeOnChangeCardType = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeCardType) return (issueTypeId)=>{
            context.onChangeCardType(issueTypeId);
            onChangeCardType(issueTypeId);
        };
        return onChangeCardType;
    }, [
        onChangeCardType
    ]);
    const makeOnChangeStatusTransition = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeFieldValue) return (transitionId)=>{
            context.onChangeFieldValue((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), transitionId);
            onChangeStatusTransition(transitionId);
        };
        return onChangeStatusTransition;
    }, [
        onChangeStatusTransition
    ]);
    const makeOnChangeSummary = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeSummary) return (summary)=>{
            context.onChangeSummary(summary);
            onChangeSummary(summary);
        };
        return onChangeSummary;
    }, [
        onChangeSummary
    ]);
    const makeOnChangeProject = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeProject) return (projectId)=>{
            context.onChangeProject(projectId);
            onChangeProject(projectId);
        };
        return onChangeProject;
    }, [
        onChangeProject
    ]);
    const isCardTypesEmptyOrAllDisabled = cardTypes.every(({ isDisabled: isCardTypeDisabled })=>Boolean(isCardTypeDisabled));
    const isTriggerDisabled = cardTypes?.length ? isDisabled || isCardTypesEmptyOrAllDisabled : isDisabled;
    const shouldRenderForm = (isFormVisibleProp ?? isFormVisible) && !isTriggerDisabled;
    (0, $5uXOq.useEffect)(()=>{
        /* 	below block is intended for case where icc is automatically opened after icc issue
    	created when user opens originally opens icc in-between two existing issues */ if ($0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && shouldRenderForm === true && hasCreatedIssueICC) {
            // unique sessionId for each icc
            const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4();
            // fires start event and sets sessionId for end event
            onAutoOpen(sessionId);
            const autoFocusAnalyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input',
                actionSubjectId: 'inlineCreateCard'
            });
            (0, $8zOmE.fireUIAnalytics)(autoFocusAnalyticsEvent, {
                triggeredBy: 'autoFocus',
                reason: triggerReason,
                ...$0d06f081c1e675aa$var$isEnrolledInSimplifyIccBundle() && {
                    isInSimplifyIccBundleVariation: $0d06f081c1e675aa$var$isInSimplifyIccBundleVariation()
                }
            });
            setHasCreatedIssueICC(false);
        }
    }, [
        createAnalyticsEvent,
        hasCreatedIssueICC,
        setHasCreatedIssueICC,
        shouldRenderForm,
        triggerReason,
        isFormVisible,
        triggerAppearance,
        onTriggerClick,
        onAutoOpen
    ]);
    const ICCForm = (0, $4R6GH.fg)('board_icc_form_async_load') ? (0, $dhszq.AsyncInlineCardCreateForm) : (0, $kNtWa.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "inline-card-create",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            appearance: appearance,
            numFilters: numFilters
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $0d06f081c1e675aa$var$containerStyles,
            triggerUnmountTimeoutId !== null && $0d06f081c1e675aa$var$withTriggerUnmountStyles
        ],
        testId: "platform-inline-card-create.ui.container"
    }, shouldRenderForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccContext).Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ICCForm, {
            autoFocus: autoFocus ?? true,
            shouldScrollIntoView: shouldScrollIntoView ?? false,
            onSubmit: makeOnCreate(value),
            onCancel: makeOnCancel(value),
            onBlur: makeOnBlur(value),
            onChangeSummary: makeOnChangeSummary(value),
            numFilters: numFilters ?? 0,
            messages: messages ?? [],
            cardTypes: cardTypes,
            extraItems: extraItems,
            shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside,
            selectedCardTypeId: $0d06f081c1e675aa$export$c283de3a59c46bc6(cardTypes, value.initialCardTypeId, defaultCardTypeId),
            selectedFieldValues: value.initialFieldValues,
            appearance: appearance ?? 'full',
            placeholderText: placeholderText ?? '',
            saveOnBlur: saveOnBlur ?? false,
            onChangeCardType: makeOnChangeCardType(value),
            onChangeStatusTransition: makeOnChangeStatusTransition(value),
            onChangeProject: makeOnChangeProject(value),
            initialSummary: value.initialSummary,
            renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
            renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter,
            TypeSelect: TypeSelect,
            StatusSelect: StatusSelect,
            statusTransitions: statusTransitions,
            selectedProjectId: value.initialProjectId,
            projects: projects,
            shouldShowCreateButton: shouldShowCreateButton,
            ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                setFocusOnTrigger: setFocusOnTrigger
            } : {}
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            triggerUnmountTimeoutId !== null && "_19pk10j7",
            !(!shouldRenderForm && triggerUnmountTimeoutId === null) && "_tzy4idpf"
        ])
    }, (!shouldRenderForm || triggerUnmountTimeoutId !== null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        isModalTrigger: isModalTrigger,
        isSticky: appearance === (0, $7462c685f739ed5a$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        label: triggerLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onTriggerClickCallback,
        isDisabled: isTriggerDisabled,
        ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    }))));
};
$0d06f081c1e675aa$var$InlineCardCreate.defaultProps = {
    isFormVisibleDefault: false,
    isDisabled: false,
    autoFocus: true,
    saveOnBlur: false,
    appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    triggerLabel: '',
    placeholderText: '',
    numFilters: 0,
    messages: [],
    cardTypes: [],
    extraItems: undefined,
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTriggerClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAutoOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    renderAdditionalInlineCreateFooter: undefined,
    shouldShowCreateButton: false
};
var $0d06f081c1e675aa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0d06f081c1e675aa$var$InlineCardCreate);
const $0d06f081c1e675aa$var$containerStyles = (0, $jJ1Sb.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
});
const $0d06f081c1e675aa$var$withTriggerUnmountStyles = (0, $jJ1Sb.xcss)({
    minHeight: `${$0d06f081c1e675aa$var$TRIGGER_HEIGHT}px`
});

});
parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$8f56a4ad6e1486ea = 10;
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("l2AwX", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $377250c350eb1ea3$export$56beb4c2629d6615);

var $7JoAD = parcelRequire("7JoAD");

var $7FEwN = parcelRequire("7FEwN");
const $377250c350eb1ea3$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $377250c350eb1ea3$var$store = (0, $7JoAD.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $377250c350eb1ea3$var$initialState,
    actions: $7FEwN.actions
});
const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, $7JoAD.createHook)($377250c350eb1ea3$var$store);

});
parcelRegister("7FEwN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a1630f6ff8f7879d$export$e324594224ef24da);

var $aBMM9 = parcelRequire("aBMM9");
const $a1630f6ff8f7879d$export$e324594224ef24da = {
    setIsOpen: $aBMM9.setIsOpen
};

});
parcelRegister("aBMM9", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $bd4df525f1eeff62$export$dcf23146e0a40195);
const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("4pxa7", function(module, exports) {

$parcel$export(module.exports, "useKeepIccOpenState", () => $e01b50e33333395d$export$991bb5f828c64eee);
$parcel$export(module.exports, "useKeepIccOpenActions", () => $e01b50e33333395d$export$bbdeb5b20a0dc1c1);
$parcel$export(module.exports, "useTriggerEventState", () => $e01b50e33333395d$export$438ab5dbdf55872);


var $9yQlD = parcelRequire("9yQlD");

var $7JoAD = parcelRequire("7JoAD");

var $g7fKq = parcelRequire("g7fKq");
const $e01b50e33333395d$var$isModalVisible = (key)=>(0, $9yQlD.sessionStorage).get(key) !== undefined;
// If either modal is visible, then don't open the ICC
const $e01b50e33333395d$var$setInitialState = ()=>!($e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$4e1360a3e7785935)) || $e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)));
const $e01b50e33333395d$export$d4c72bab9d6cc13a = {
    keepIccOpen: $e01b50e33333395d$var$setInitialState(),
    hasCreatedIssueICC: true,
    triggerReason: 'emptyBoard'
};
const $e01b50e33333395d$var$store = (0, $7JoAD.createStore)({
    name: 'jsw-onboarding-keep-icc-open',
    initialState: $e01b50e33333395d$export$d4c72bab9d6cc13a,
    actions: $g7fKq.actions
});
const $e01b50e33333395d$export$991bb5f828c64eee = (0, $7JoAD.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpen
});
const $e01b50e33333395d$export$bbdeb5b20a0dc1c1 = (0, $7JoAD.createActionsHook)($e01b50e33333395d$var$store);
const $e01b50e33333395d$export$438ab5dbdf55872 = (0, $7JoAD.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>({
            hasCreatedIssueICC: state.hasCreatedIssueICC,
            triggerReason: state.triggerReason
        })
});

});
parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorage", () => $816fbeb16311dd64$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("g7fKq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $22684fd1187cb60b$export$e324594224ef24da);

var $5hyrq = parcelRequire("5hyrq");

var $ePMUR = parcelRequire("ePMUR");

var $cr2Jb = parcelRequire("cr2Jb");

var $lWd86 = parcelRequire("lWd86");
const $22684fd1187cb60b$export$e324594224ef24da = {
    toggleKeepIccOpen: $lWd86.toggleKeepIccOpen,
    setHasCreatedIssueICC: $ePMUR.setHasCreatedIssueICC,
    setTriggerReason: $cr2Jb.setTriggerReason,
    closeICC: $5hyrq.closeICC
};

});
parcelRegister("5hyrq", function(module, exports) {

$parcel$export(module.exports, "closeICC", () => $a1f8bda87b6ffc9a$export$e6c10955f11a7b51);
const $a1f8bda87b6ffc9a$export$e6c10955f11a7b51 = ()=>({ setState: setState })=>{
        setState({
            keepIccOpen: false
        });
    };

});

parcelRegister("ePMUR", function(module, exports) {

$parcel$export(module.exports, "setHasCreatedIssueICC", () => $a1b9adc891c00dd5$export$4bb464fc9800c324);
const $a1b9adc891c00dd5$export$4bb464fc9800c324 = (hasCreatedIssueICC)=>({ getState: getState, setState: setState })=>{
        const { hasCreatedIssueICC: currentHasCreatedIssueICC } = getState();
        if (hasCreatedIssueICC === currentHasCreatedIssueICC) return;
        setState({
            hasCreatedIssueICC: hasCreatedIssueICC
        });
    };

});

parcelRegister("cr2Jb", function(module, exports) {

$parcel$export(module.exports, "setTriggerReason", () => $b662b9cea36b43af$export$8b8ceaca9e30bc48);
const $b662b9cea36b43af$export$8b8ceaca9e30bc48 = (triggerReason)=>({ getState: getState, setState: setState })=>{
        const { triggerReason: currentTriggerReason } = getState();
        if (triggerReason === currentTriggerReason) return;
        setState({
            triggerReason: triggerReason
        });
    };

});

parcelRegister("lWd86", function(module, exports) {

$parcel$export(module.exports, "toggleKeepIccOpen", () => $071bcdbf7bb018d8$export$d09b33ff198a059);
const $071bcdbf7bb018d8$export$d09b33ff198a059 = ()=>({ getState: getState, setState: setState })=>{
        const { keepIccOpen: iccOpenState } = getState();
        setState({
            keepIccOpen: !iccOpenState
        });
    };

});



parcelRegister("dhszq", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineCardCreateForm", () => $a64c6427d6c752bd$export$4f2abfdfd1993102);

var $5uXOq = parcelRequire("5uXOq");

var $heNNl = parcelRequire("heNNl");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

const $a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp = (0, $hPtZI.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("kNtWa"))), {
    moduleId: "./src/packages/platform/ui/inline-card-create/src/ui/form/main.tsx"
});
const $a64c6427d6c752bd$export$4f2abfdfd1993102 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async-inline-card-create-form",
        packageName: "JiraPlatformBoardKit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-inline-card-create-form",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp, props)));

});
parcelRegister("kNtWa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getSelectedCardTypeId", () => $602e27e62ab6fe28$export$154199a7e659306d);
$parcel$export(module.exports, "isClickOutsideElement", () => $602e27e62ab6fe28$export$a662648a70e4e0d0);
$parcel$export(module.exports, "isClickOutsideSelect", () => $602e27e62ab6fe28$export$e3399e7287b8e45d);
$parcel$export(module.exports, "Form", () => $602e27e62ab6fe28$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "default", () => $602e27e62ab6fe28$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");


var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");


var $3FdYO = parcelRequire("3FdYO");

var $k72ii = parcelRequire("k72ii");

var $3abEe = parcelRequire("3abEe");

var $2Q9me = parcelRequire("2Q9me");

var $cTb2j = parcelRequire("cTb2j");

var $hNJJt = parcelRequire("hNJJt");

var $cbChK = parcelRequire("cbChK");

var $h1sEN = parcelRequire("h1sEN");
const $602e27e62ab6fe28$export$154199a7e659306d = (initialSelectedCardTypeId, cardTypes)=>{
    if (initialSelectedCardTypeId) return initialSelectedCardTypeId;
    const filteredCardTypes = cardTypes.filter(({ isDisabled: isDisabled })=>!isDisabled);
    return filteredCardTypes.length > 0 ? filteredCardTypes[0].id : null;
};
const $602e27e62ab6fe28$export$a662648a70e4e0d0 = (target, ref)=>target instanceof Node && ref ? !ref.contains(target) : true;
const $602e27e62ab6fe28$export$e3399e7287b8e45d = (target, selectRef)=>target instanceof Node && selectRef?.node ? !selectRef.node.menuRef?.contains(target) && !selectRef.node.targetRef?.contains(target) : true;
class $602e27e62ab6fe28$export$a7fed597f4b8afd8 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            autoFocus: true,
            saveOnBlur: false,
            numFilters: 0,
            messages: [],
            cardTypes: [],
            TypeSelect: (0, $h1sEN.default),
            extraItems: undefined,
            shouldKeepFormOpenOnClickOutside: undefined,
            selectedCardTypeId: null,
            selectedFieldVaues: new Map(),
            appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
            placeholderText: '',
            initialSummary: '',
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            renderAdditionalInlineCreateFooter: undefined,
            shouldShowCreateButton: false
        };
    }
    static getDerivedStateFromProps(props, state) {
        if ((0, $co1wz.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) {
            // Checks if the selectedCardTypeId still exists in the cardTypes array and refresh the value if it isn't
            // This is used in Program board where the cardTypes are updated when the project selector value changes
            const selectedCardType = props.cardTypes.find(({ id: id, isDisabled: isDisabled })=>id === state.selectedCardTypeId && !isDisabled);
            if (!selectedCardType) return {
                ...state,
                selectedCardTypeId: $602e27e62ab6fe28$export$154199a7e659306d(props.selectedCardTypeId, props.cardTypes)
            };
        }
        return null;
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', this.onMouseUp);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', this.onMouseUp);
        this.debouncedOnChangeSummary.flush();
    }
    render() {
        const { appearance: appearance, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Container, {
            ref: this.form,
            appearance: appearance,
            "data-testid": "platform-inline-card-create.ui.form.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$StyledForm, {
            appearance: appearance
        }, appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? this.renderFullViewContent(renderAdditionalInlineCreateFooter) : this.renderCompactViewContent()));
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationError: (0, $cbChK.validateSummary)(this.props.initialSummary, this.props.intl),
            selectedCardTypeId: $602e27e62ab6fe28$export$154199a7e659306d(this.props.selectedCardTypeId, this.props.cardTypes),
            selectedTransitionId: Number(this.props.selectedFieldValues?.get((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS))) || null,
            selectedProjectId: this.props.selectedProjectId,
            sanitisedSummary: (0, $cbChK.stripConsecutiveWhitespacesAndTrim)(this.props.initialSummary)
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.onMouseUp = ({ target: target })=>{
            if (this.props.shouldKeepFormOpenOnClickOutside) return;
            if ($602e27e62ab6fe28$export$a662648a70e4e0d0(target, this.form.current) && $602e27e62ab6fe28$export$a662648a70e4e0d0(target, this.inlineMessagePopupRef.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.typeSelect.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.statusSelect.current) && $602e27e62ab6fe28$export$e3399e7287b8e45d(target, this.projectSelect.current)) this.onBlur();
        };
        this.onSubmit = ({ createdBy: createdBy = (0, $7462c685f739ed5a$export$806b905ec7df742f) } = {})=>()=>{
                const { sanitisedSummary: sanitisedSummary, selectedCardTypeId: selectedCardTypeId, selectedTransitionId: selectedTransitionId, selectedProjectId: selectedProjectId } = this.state;
                if (selectedCardTypeId === null) return;
                this.debouncedOnChangeSummary.flush();
                this.submitCounter += 1;
                const metadata = {
                    createdBy: createdBy
                }; // summaryData is a string
                const summaryData = sanitisedSummary;
                if (summaryData.length > 0) {
                    const fields = new Map();
                    fields.set((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), selectedTransitionId);
                    const summaryDataTransformed = {
                        summary: summaryData,
                        cardTypeId: selectedCardTypeId,
                        fields: fields,
                        projectId: selectedProjectId === null ? undefined : selectedProjectId
                    };
                    this.props.onSubmit([
                        summaryDataTransformed
                    ], metadata);
                } else this.props.onBlur('');
                this.setState({
                    validationError: (0, $3FdYO.emptyValidationError),
                    sanitisedSummary: ''
                });
            };
        this.onCancel = ()=>{
            this.debouncedOnChangeSummary.flush();
            this.props.onCancel();
            this.setState({
                validationError: (0, $3FdYO.emptyValidationError),
                sanitisedSummary: ''
            });
        };
        this.onSelectCardType = (cardTypeId)=>{
            this.props.onChangeCardType(cardTypeId);
            this.setState({
                selectedCardTypeId: cardTypeId
            });
        };
        this.onSelectProject = (projectId)=>{
            this.props.onChangeProject(projectId);
            this.setState({
                selectedProjectId: projectId
            });
        };
        this.onSelectTransition = (transitionId)=>{
            this.props.onChangeStatusTransition(transitionId);
            this.setState({
                selectedTransitionId: transitionId
            });
        };
        this.onChangeSummary = ({ summary: summary, validationError: validationError })=>{
            this.setState((prevState)=>({
                    sanitisedSummary: summary.replace('\n', ' '),
                    validationError: {
                        ...prevState.validationError,
                        ...validationError
                    }
                }));
            this.debouncedOnChangeSummary(summary);
        };
        this.onBlur = ()=>{
            if (this.props.saveOnBlur) this.onSubmit({
                isConcat: true,
                createdBy: (0, $7462c685f739ed5a$export$565566e3df4dad53)
            })();
            else this.props.onBlur(this.state.sanitisedSummary);
        };
        this.submitCounter = 0;
        this.initialSummary = this.props.initialSummary;
        this.form = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.typeSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.statusSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.projectSelect = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.inlineMessagePopupRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.debouncedOnChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((summary)=>{
            this.props.onChangeSummary(summary);
        }, 250);
        this.getSelectedIssueType = ()=>{
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            const { cardTypes: cardTypes } = this.props;
            return cardTypes.find((type)=>type.id === selectedCardTypeId);
        };
        this.renderTypeDropdown = ()=>{
            const { cardTypes: cardTypes, extraItems: extraItems, TypeSelect: TypeSelect = (0, $h1sEN.default) } = this.props;
            const { selectedCardTypeId: selectedCardTypeId } = this.state;
            if (selectedCardTypeId === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TypeSelect, {
                ref: this.typeSelect,
                cardTypes: cardTypes,
                selectedCardTypeId: selectedCardTypeId,
                onSelectCardType: this.onSelectCardType,
                renderAdditionalOptionContent: this.props.renderAdditionalTypeSelectOptionContent,
                shouldRenderToParent: true,
                extraItems: extraItems
            });
        };
        this.renderProjectDropdown = ()=>{
            if (!(0, $co1wz.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1')) return null;
            const { ProjectSelect: ProjectSelect = (0, $cTb2j.default), projects: projects } = this.props;
            const { selectedProjectId: selectedProjectId } = this.state;
            if ((projects?.length || 0) > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectSelect, {
                ref: this.projectSelect,
                projects: projects || [],
                selectedProjectId: selectedProjectId,
                onSelectProject: this.onSelectProject
            });
            return null;
        };
        this.renderStatusDropdown = ()=>{
            const { StatusSelect: StatusSelect = (0, $hNJJt.default), statusTransitions: statusTransitions } = this.props;
            const { selectedTransitionId: selectedTransitionId } = this.state;
            if (!statusTransitions?.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StatusSelect, {
                ref: this.statusSelect,
                statusTransitions: statusTransitions,
                selectedTransitionId: selectedTransitionId || statusTransitions[0].transitionId,
                onSelectTransition: this.onSelectTransition
            });
        };
        this.renderSummary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$SummaryContainer, {
                appearance: this.props.appearance
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cbChK.default), {
                initialSummary: this.initialSummary,
                appearance: this.props.appearance,
                submitCounter: this.submitCounter,
                placeholderText: this.props.placeholderText,
                autoFocus: this.props.autoFocus,
                shouldScrollIntoView: this.props.shouldScrollIntoView,
                onChangeSummary: this.onChangeSummary,
                onSubmit: this.onSubmit(),
                onCancel: this.onCancel,
                ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                    selectedIssueType: this.getSelectedIssueType()?.name,
                    setFocusOnTrigger: this.props.setFocusOnTrigger
                } : {}
            }));
        this.buildWarnings = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { sanitisedSummary: sanitisedSummary, validationError: validationError } = this.state;
            if (sanitisedSummary.length > 0) {
                const validationErrors = Object.values(validationError).reduce((accumulator, errorMessage)=>{
                    if (errorMessage) accumulator.push(String(errorMessage));
                    return accumulator;
                }, []);
                return validationErrors.map((error)=>({
                        title: formatMessage((0, $2Q9me.default).validationErrorTitle, {
                            validationErrorsNo: validationErrors.length
                        }),
                        description: error
                    }));
            }
            return [];
        };
        this.renderInlineMessageInfo = ()=>{
            const { numFilters: numFilters, messages: inlineMessages, intl: { formatMessage: formatMessage } } = this.props;
            const infos = inlineMessages.length > 0 ? [
                ...inlineMessages
            ] : [];
            const warnings = this.buildWarnings();
            if (numFilters) infos.push({
                title: formatMessage((0, $2Q9me.default).appliedFiltersTitleNew),
                description: formatMessage((0, $2Q9me.default).appliedFiltersDescription)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3abEe.default), {
                infos: infos,
                warnings: warnings,
                innerRef: this.inlineMessagePopupRef
            });
        };
        this.renderCreateButton = ()=>{
            const isEmpty = this.state.sanitisedSummary.length === 0;
            return this.props.shouldShowCreateButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k72ii.CreateButton), {
                onClick: this.onSubmit({
                    isConcat: false,
                    createdBy: (0, $7462c685f739ed5a$export$ba9f60edfdf2e66)
                }),
                isEmpty: isEmpty,
                hasValidationError: (0, $cbChK.hasValidationError)(this.state.validationError)
            });
        };
        this.renderFullViewContent = (renderAdditionalInlineCreateFooter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FullContent, {
                isInvalid: (0, $cbChK.hasValidationError)(this.state.validationError)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Body, {
                appearance: this.props.appearance
            }, this.renderSummary()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FullFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderTypeDropdown(), this.renderProjectDropdown(), this.renderStatusDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderInlineMessageInfo(), " ", this.renderCreateButton())), renderAdditionalInlineCreateFooter);
        this.renderCompactViewContent = ()=>{
            const { appearance: appearance } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$CompactContent, {
                isInvalid: (0, $cbChK.hasValidationError)(this.state.validationError),
                appearance: appearance
            }, appearance !== (0, $7462c685f739ed5a$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Header, null, this.renderTypeDropdown(), this.renderProjectDropdown()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$Body, {
                appearance: appearance
            }, this.renderSummary()), appearance !== (0, $7462c685f739ed5a$export$aca095bc476d426f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$CompactFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($602e27e62ab6fe28$var$FooterSection, null, this.renderInlineMessageInfo())));
        };
    }
}
// AK icon is not vertically aligned AK-5620 so we have to hack the button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1ul9idpf _dpd31txw _1n14idpf",
            __cmplp.className
        ])
    });
});
var $602e27e62ab6fe28$export$2e2bcd8739ae039 /* Card layout */  = (0, $az4zD.injectIntlV2)($602e27e62ab6fe28$export$a7fed597f4b8afd8);
const $602e27e62ab6fe28$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _16jlkb7n _2lx21bp4 _bfhk18uv",
            __cmplp.appearance !== (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_1pby11wp",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_19pkyh40 _2hwxidpf _otyryh40 _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$CompactContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInvalid: isInvalid, appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1841qrf": (0, $lD23V.default)(__cmplp.isInvalid ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-danger, ${(0, $5e0c0d4e15efb4a6$exports).R400})` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$exports).B200})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvu2gc _u5f3u2gc _12ji1r31 _1qu2glyw _12y31o36 _16qs148r _vchhusvi _1bsb1osq _bfhkvuon _v56416gf",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_19bv7vkz",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_19bv1crf",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) && "_19bv1crf",
            __cmplp.appearance !== (0, $7462c685f739ed5a$export$db1cdb8627b81f84) && "_2rko1l7b",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) ? "_4t3i1osq" : "_4t3i1ylp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FullContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$CompactContent, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _4cvrv2br _4t3i1wug _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Body = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$FullFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1bah1yb4 _4t3i1f4h _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $602e27e62ab6fe28$var$CompactFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $602e27e62ab6fe28$var$Footer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bahesu3 _18u0u2gc",
            __cmplp.className
        ])
    });
}); /* Form */ 
const $602e27e62ab6fe28$var$StyledForm = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8) && "_4t3izwfg",
            __cmplp.className
        ])
    });
}); /* Text area */ 
const $602e27e62ab6fe28$var$SummaryContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _1bahv2br _4cvr1h6o",
            __cmplp.appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_otyrftgi",
            (__cmplp.appearance === (0, $7462c685f739ed5a$export$db1cdb8627b81f84) || __cmplp.appearance === (0, $7462c685f739ed5a$export$1aad44a7533f8ad8)) && "_18u0ftgi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3FdYO", function(module, exports) {

$parcel$export(module.exports, "emptyValidationError", () => $d43814abe3fa7cf5$export$a691a8856deba80b);
const $d43814abe3fa7cf5$export$a691a8856deba80b = {
    summary: '',
    summaryConcat: ''
};

});

parcelRegister("k72ii", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $5befc8db90207b42$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $6T4rd = parcelRequire("6T4rd");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $1SjXn = parcelRequire("1SjXn");

var $MNEb2 = parcelRequire("MNEb2");
const $5befc8db90207b42$export$6d3c345ce7c38fd9 = ({ onClick: onClick, isEmpty: isEmpty, hasValidationError: hasValidationError })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isDisabled = isEmpty || hasValidationError;
    let tooltipContent = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1SjXn.default).createButtonTooltipIssueTermRefresh : (0, $1SjXn.default).createButtonTooltip, {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MNEb2.default), null)
    });
    if (isEmpty) tooltipContent = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1SjXn.default).createButtonTooltipContentEmptyIssueTermRefresh : (0, $1SjXn.default).createButtonTooltipContentEmpty);
    else if (hasValidationError) tooltipContent = undefined;
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5befc8db90207b42$var$createButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        spacing: "compact",
        type: "submit",
        isDisabled: isDisabled,
        onClick: (e)=>{
            e.preventDefault();
            onClick();
        },
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
                color: "inherit",
                as: "span"
            }, "\u23CE"),
        label: formatMessage((0, $1SjXn.default).createButtonLabel)
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $5befc8db90207b42$var$createButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "primary",
        spacing: "compact",
        type: "submit",
        isDisabled: isDisabled,
        onClick: (e)=>{
            e.preventDefault();
            onClick();
        }
    }, formatMessage((0, $1SjXn.default).createButtonLabel))));
};
const $5befc8db90207b42$var$createButtonStyles = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("1SjXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4eb430acd8b1b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d4eb430acd8b1b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createButtonLabel: {
        "id": "inline-card-create.form.create-button.create-button-label",
        "defaultMessage": "Create"
    },
    createButtonTooltip: {
        "id": "inline-card-create.form.create-button.create-button-tooltip",
        "defaultMessage": "Create issue <icon>return icon</icon>"
    },
    createButtonTooltipContentEmpty: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-content-empty",
        "defaultMessage": "Type an issue summary"
    },
    createButtonTooltipIssueTermRefresh: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-issue-term-refresh",
        "defaultMessage": "Create issue <icon>return icon</icon>"
    },
    createButtonTooltipContentEmptyIssueTermRefresh: {
        "id": "inline-card-create.form.create-button.create-button-tooltip-content-empty-issue-term-refresh",
        "defaultMessage": "Type an issue summary"
    }
});

});

parcelRegister("MNEb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $253f5a50f101458c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gDyTC = parcelRequire("gDyTC");
const $253f5a50f101458c$var$ReturnGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "12",
        viewBox: "0 0 16 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "16",
        height: "12",
        rx: "2",
        fill: "var(--ds-background-accent-gray-bolder, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.375 3.1875V4.4375C12.375 6.33597 10.836 7.875 8.9375 7.875H3.9375C3.41974 7.875 3 7.45526 3 6.9375C3 6.41974 3.41974 6 3.9375 6H8.9375C9.8005 6 10.5 5.30045 10.5 4.4375V3.1875C10.5 2.66974 10.9197 2.25 11.4375 2.25C11.9553 2.25 12.375 2.66974 12.375 3.1875Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.60041 7.60041L6.78787 5.41291C7.154 5.0468 7.154 4.4532 6.78787 4.08708C6.42175 3.72097 5.82825 3.72097 5.46208 4.08708L3.27458 6.27459C2.90847 6.6407 2.90847 7.2343 3.27458 7.60041C3.6407 7.96652 4.2343 7.96652 4.60041 7.60041Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.60041 6.27458L6.78787 8.46208C7.154 8.82825 7.154 9.42175 6.78787 9.78787C6.42175 10.154 5.82825 10.154 5.46208 9.78787L3.27458 7.60041C2.90847 7.2343 2.90847 6.6407 3.27458 6.27458C3.6407 5.90847 4.2343 5.90847 4.60041 6.27458Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $253f5a50f101458c$var$ReturnIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: $253f5a50f101458c$var$ReturnGlyph,
        label: ""
    });
var $253f5a50f101458c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($253f5a50f101458c$var$ReturnIcon);

});


parcelRegister("3abEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d46a6a1d0b2bee$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $89thI = parcelRequire("89thI");

var $3Ro9e = parcelRequire("3Ro9e");

var $dyTTI = parcelRequire("dyTTI");

var $lm9d2 = parcelRequire("lm9d2");

var $iaTnv = parcelRequire("iaTnv");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $1m92z = parcelRequire("1m92z");

const $14d46a6a1d0b2bee$var$OPACITY = 0.9;
const $14d46a6a1d0b2bee$var$iconWrapperStyles = null;
const $14d46a6a1d0b2bee$var$getColor = (type)=>{
    const types = {
        info: `var(--ds-icon-discovery, ${(0, $5e0c0d4e15efb4a6$exports).P300})`,
        warning: `var(--ds-icon-warning, ${(0, $5e0c0d4e15efb4a6$exports).Y300})`
    };
    return types[type];
};
const $14d46a6a1d0b2bee$var$typesMapping = {
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Ro9e))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dyTTI))),
        defaultLabel: 'warning inline message'
    }
};
const $14d46a6a1d0b2bee$var$InlineMessages = ({ infos: infos = [], warnings: warnings = [], innerRef: innerRef, defaultIsOpen: defaultIsOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    (0, $5uXOq.useEffect)(()=>{
        const onScroll = ()=>{
            setIsOpen(false);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('scroll', onScroll, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const renderMessage = (title, description, index, isLast)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
            key: index,
            space: "space.100",
            xcss: !isLast && $14d46a6a1d0b2bee$var$separatorStyles
        }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
            as: "p",
            weight: "bold",
            color: "inherit"
        }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
            as: "p",
            color: "inherit"
        }, description));
    };
    const renderInlineMessage = (messages, type)=>{
        const { [type]: { icon: SelectedIcon, defaultLabel: defaultLabel } } = $14d46a6a1d0b2bee$var$typesMapping;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($14d46a6a1d0b2bee$var$Wrapper, {
            "data-testid": `platform-inline-card-create.ui.form.inline-messages-${type}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
                    xcss: $14d46a6a1d0b2bee$var$inlineMessageContentStyles,
                    space: "space.200",
                    ref: innerRef
                }, messages.map(({ title: title, description: description }, index)=>{
                    const isLast = index === messages.length - 1;
                    return (title || description) && renderMessage(title, description, index, isLast);
                })),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
                    ...triggerProps,
                    appearance: "subtle-link",
                    spacing: "none",
                    onClick: ()=>setIsOpen(!isOpen)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    // eslint-disable-next-line jira/react/no-style-attribute
                    style: {
                        opacity: isOpen ? $14d46a6a1d0b2bee$var$OPACITY : 1,
                        color: $14d46a6a1d0b2bee$var$getColor(type)
                    },
                    className: (0, $bwpsq.default)([
                        "_16l4q80t"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectedIcon, {
                    label: defaultLabel,
                    spacing: "spacious",
                    color: "currentColor"
                })))
        }));
    };
    if (warnings.length > 0) return renderInlineMessage(warnings, 'warning');
    if (infos.length > 0) return renderInlineMessage(infos, 'info');
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14d46a6a1d0b2bee$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _2hwx1i6y",
            __cmplp.className
        ])
    });
});
var $14d46a6a1d0b2bee$export$2e2bcd8739ae039 = $14d46a6a1d0b2bee$var$InlineMessages;
const $14d46a6a1d0b2bee$var$inlineMessageContentStyles = (0, $jJ1Sb.xcss)({
    width: '200px',
    boxSizing: 'content-box',
    textAlign: 'left',
    paddingInline: 'space.300',
    paddingBlock: 'space.200'
});
const $14d46a6a1d0b2bee$var$separatorStyles = (0, $jJ1Sb.xcss)({
    paddingBlockEnd: 'space.200',
    borderBottomWidth: 'space.025',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border'
});

});
parcelRegister("3Ro9e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cf90d9af0da2329$var$_react = $2cf90d9af0da2329$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cf90d9af0da2329$var$_information = $2cf90d9af0da2329$var$_interopRequireDefault((parcelRequire("lrYDv")));

var $2cf90d9af0da2329$var$_info = $2cf90d9af0da2329$var$_interopRequireDefault((parcelRequire("itVjj")));
function $2cf90d9af0da2329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cf90d9af0da2329$var$InformationIcon = (props)=>/*#__PURE__*/ $2cf90d9af0da2329$var$_react.default.createElement($2cf90d9af0da2329$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $2cf90d9af0da2329$var$_info.default
    }, props));
$2cf90d9af0da2329$var$InformationIcon.Name = 'InformationIconMigration';
var $2cf90d9af0da2329$var$_default = module.exports.default = $2cf90d9af0da2329$var$InformationIcon;

});


parcelRegister("2Q9me", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea1cf770feb64c3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea1cf770feb64c3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    appliedFiltersTitleNew: {
        "id": "inline-card-create.form.inline-messages.applied-filters-title-new",
        "defaultMessage": "Filters applied"
    },
    appliedFiltersDescription: {
        "id": "inline-card-create.form.inline-messages.applied-filters-description",
        "defaultMessage": "We'll update this issue\u2019s fields to match your current filters."
    },
    willAffectSprintScopeTitle: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-title",
        "defaultMessage": "Sprint scope will be affected"
    },
    willAffectSprintScopeDescription: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-description",
        "defaultMessage": "Creating an issue in an active sprint will affect it's scope."
    },
    validationErrorTitle: {
        "id": "inline-card-create.form.inline-messages.validation-error-title",
        "defaultMessage": "{validationErrorsNo} {validationErrorsNo, plural, one {error} other {errors}} found"
    },
    appliedFiltersDescriptionIssueTermRefresh: {
        "id": "inline-card-create.form.inline-messages.applied-filters-description-issue-term-refresh",
        "defaultMessage": "We'll update this issue\u2019s fields to match your current filters."
    },
    willAffectSprintScopeDescriptionIssueTermRefresh: {
        "id": "inline-card-create.form.inline-messages.will-affect-sprint-scope-description-issue-term-refresh",
        "defaultMessage": "Creating an issue in an active sprint will affect it's scope."
    }
});

});

parcelRegister("cTb2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf44ebc2a1cc212$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $gZL7V = parcelRequire("gZL7V");

var $dWTaZ = parcelRequire("dWTaZ");

var $89thI = parcelRequire("89thI");

var $9ed83 = parcelRequire("9ed83");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");
var $cpoLo = parcelRequire("cpoLo");

var $MGmIU = parcelRequire("MGmIU");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");


var $7tjw9 = parcelRequire("7tjw9");
const $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT = 'iccProjectSelect';
const $fcf44ebc2a1cc212$var$Option = ({ children: children, ...props })=>{
    const { projectInfo: projectInfo } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$OptionWrapper, {
        "data-testId": "platform-inline-card-create.ui.form.project-select.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        src: projectInfo.avatar,
        size: "xsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$LabelWrapper, null, projectInfo.name)));
};
const $fcf44ebc2a1cc212$var$transformOptions = (projects, selectedProjectId)=>{
    let value;
    const options = [];
    projects.forEach((project)=>{
        const option = {
            label: project.name,
            value: project.id,
            projectInfo: project
        };
        if (project.id === selectedProjectId) value = option;
        else options.push(option);
    });
    if (!value) value = null;
    return {
        options: options,
        value: value
    };
};
const $fcf44ebc2a1cc212$var$ProjectSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ projects: projects, selectedProjectId: selectedProjectId, onSelectProject: onSelectProject }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$fcf44ebc2a1cc212$var$transformOptions(projects, selectedProjectId), [
        projects,
        selectedProjectId
    ]);
    const trigger = (0, $5uXOq.useCallback)(({ isOpen: isOpen, ...triggerProps })=>{
        const { label: label, projectInfo: projectInfo } = value || {
            label: undefined,
            projectInfo: {
                avatar: '',
                name: '',
                key: ''
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $fcf44ebc2a1cc212$var$projectContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $fcf44ebc2a1cc212$var$projectButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: label ?? null,
            delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "none",
            isSelected: isOpen,
            "aria-label": formatMessage((0, $7tjw9.default).ariaLabel, {
                value: label ?? formatMessage((0, $7tjw9.default).invalid)
            }),
            testId: "platform-inline-card-create.ui.form.project-select.trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$OptionWrapper, null, (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectInfo) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$PlaceholderWrapper, null, formatMessage((0, $7tjw9.default).placeholder)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
            src: projectInfo.avatar || '',
            size: "xsmall"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fcf44ebc2a1cc212$var$LabelWrapper, null, projectInfo.key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
            label: ""
        })))))));
    }, [
        formatMessage,
        value
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectProject(option.projectInfo.id);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectProject
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $fcf44ebc2a1cc212$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpoLo.default), {
        ref: setRefNode,
        components: {
            Option: $fcf44ebc2a1cc212$var$Option
        },
        target: trigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-project-select",
        testId: "platform-inline-card-create.ui.form.project-select.project-select"
    });
});
const $fcf44ebc2a1cc212$var$projectContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $fcf44ebc2a1cc212$var$projectButtonWrapperStyles = (0, $jJ1Sb.xcss)({
    width: '100%',
    paddingLeft: 'space.100',
    paddingRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$PlaceholderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$OptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwx1b66 _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fcf44ebc2a1cc212$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1ul9idpf",
            __cmplp.className
        ])
    });
});
var $fcf44ebc2a1cc212$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = /*#__PURE__*/ (0, $5uXOq.memo)($fcf44ebc2a1cc212$var$ProjectSelect);

});
parcelRegister("7tjw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e61bdc6f2144dcf1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e61bdc6f2144dcf1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.project-select.aria-label",
        "defaultMessage": "The current project is {value}. Press the 'Space' key to change the project."
    },
    invalid: {
        "id": "inline-card-create.form.project-select.invalid",
        "defaultMessage": "invalid"
    },
    placeholder: {
        "id": "inline-card-create.form.project-select.placeholder",
        "defaultMessage": "Select project"
    }
});

});


parcelRegister("hNJJt", function(module, exports) {

$parcel$export(module.exports, "FIELD_KEY_STATUS_TRANSITIONS", () => $e682d994c4b3be50$export$9f9b866ee3adcf04);
$parcel$export(module.exports, "default", () => $e682d994c4b3be50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gZL7V = parcelRequire("gZL7V");

var $eSI7k = parcelRequire("eSI7k");

var $6T4rd = parcelRequire("6T4rd");
var $9nD7C = parcelRequire("9nD7C");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $32eUr = parcelRequire("32eUr");
var $cpoLo = parcelRequire("cpoLo");

var $MGmIU = parcelRequire("MGmIU");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");


var $85BdV = parcelRequire("85BdV");
const $e682d994c4b3be50$var$ANALYTICS_SUBJECT = 'iccStatusSelect';
const $e682d994c4b3be50$export$9f9b866ee3adcf04 = 'statusTransitions';
const $e682d994c4b3be50$var$getStatusTheme = (id)=>$e682d994c4b3be50$var$statusCategoryToThemeMap[id] || 'default';
const $e682d994c4b3be50$var$statusCategoryToThemeMap = {
    '1': 'default',
    '2': 'default',
    '3': 'success',
    '4': 'inprogress'
};
const $e682d994c4b3be50$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { statusInfo: statusInfo } = props.data;
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(statusInfo?.statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        testId: "platform-inline-card-create.ui.form.status-select.option",
        xcss: [
            $e682d994c4b3be50$var$optionContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ]
    }, children));
};
const $e682d994c4b3be50$var$transformOptions = (statusTransitions, selectedTransitionId)=>{
    let value;
    const options = [];
    statusTransitions.forEach((transition)=>{
        const option = {
            label: transition.name,
            value: transition.transitionId,
            statusInfo: transition
        };
        if (transition.transitionId === selectedTransitionId) value = option;
        else options.push(option);
    });
    if (!value) value = options?.[0];
    return {
        options: options,
        value: value
    };
};
const $e682d994c4b3be50$var$buttonThemeStyle = {
    default: (0, $jJ1Sb.xcss)({
        backgroundColor: 'color.background.neutral',
        color: 'color.text',
        ':hover': {
            color: 'color.text',
            backgroundColor: 'color.background.neutral.hovered'
        }
    }),
    success: (0, $jJ1Sb.xcss)({
        backgroundColor: 'color.background.success',
        color: 'color.text.success',
        ':hover': {
            color: 'color.text.success',
            backgroundColor: 'color.background.success.hovered'
        }
    }),
    inprogress: (0, $jJ1Sb.xcss)({
        backgroundColor: 'color.background.information',
        color: 'color.text.information',
        ':hover': {
            color: 'color.text.information',
            backgroundColor: 'color.background.information.hovered'
        }
    })
};
const $e682d994c4b3be50$var$StatusTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ value: value, isOpen: isOpen, ...triggerProps }, ref)=>{
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(value?.statusInfo?.statusCategoryId));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e682d994c4b3be50$var$statusContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e682d994c4b3be50$var$statusButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: value.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9nD7C.default), {
        key: "pressable",
        ...triggerProps,
        ref: ref,
        xcss: [
            $e682d994c4b3be50$var$buttonContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ],
        "aria-label": formatMessage((0, $85BdV.default).ariaLabel, {
            value: value.label ?? formatMessage((0, $85BdV.default).invalid)
        }),
        testId: "platform-inline-card-create.ui.form.status-select.trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        maxLines: 1,
        weight: "bold",
        size: "small",
        color: "inherit"
    }, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $e682d994c4b3be50$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eSI7k))), {
        LEGACY_size: "medium",
        label: "",
        "aria-hidden": "true",
        color: "currentColor"
    }))))));
});
const $e682d994c4b3be50$var$StatusSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ statusTransitions: statusTransitions, selectedTransitionId: selectedTransitionId, onSelectTransition: onSelectTransition }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$e682d994c4b3be50$var$transformOptions(statusTransitions, selectedTransitionId), [
        statusTransitions,
        selectedTransitionId
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectTransition(option.statusInfo.transitionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectTransition
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    const renderTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e682d994c4b3be50$var$StatusTrigger, {
            ...props,
            value: value
        }), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpoLo.default), {
        ref: setRefNode,
        components: {
            Option: $e682d994c4b3be50$var$Option
        },
        target: renderTrigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        // DSP-2990 - PopupSelect doesn't respect isSearchable, searchThreshold is required
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-status-select",
        testId: "platform-inline-card-create.ui.form.status-select.status-select"
    });
});
var $e682d994c4b3be50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$statusContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $e682d994c4b3be50$var$statusButtonWrapperStyles = (0, $jJ1Sb.xcss)({
    width: '100%',
    paddingLeft: 'space.100'
});
const $e682d994c4b3be50$export$548912fb31084970 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$buttonContentStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0',
    textTransform: 'uppercase',
    borderRadius: "var(--ds-border-radius, 3px)",
    textAlign: 'left',
    width: '100%'
});
const $e682d994c4b3be50$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e682d994c4b3be50$var$optionContentStyles = (0, $jJ1Sb.xcss)({
    display: 'inline-block',
    width: 'auto',
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    paddingBlock: 'space.0',
    paddingInline: 'space.050',
    borderRadius: "var(--ds-border-radius, 3px)"
});

});
parcelRegister("85BdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dac99c767b21e7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dac99c767b21e7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.status-select.aria-label",
        "defaultMessage": "The current status is {value}. Press the 'Space' key to change the status."
    },
    invalid: {
        "id": "inline-card-create.form.status-select.invalid",
        "defaultMessage": "invalid"
    }
});

});


parcelRegister("cbChK", function(module, exports) {

$parcel$export(module.exports, "stripConsecutiveWhitespacesAndTrim", () => $b09eae22f5f1e6ca$export$ad399be9aa35d90a);
$parcel$export(module.exports, "validateSummary", () => $b09eae22f5f1e6ca$export$1b7a903b2450d74d);
$parcel$export(module.exports, "hasValidationError", () => $b09eae22f5f1e6ca$export$3100ac1da5e98644);
$parcel$export(module.exports, "default", () => $b09eae22f5f1e6ca$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");

var $3iMqq = parcelRequire("3iMqq");


var $3FdYO = parcelRequire("3FdYO");

var $iQa4Q = parcelRequire("iQa4Q");
const $b09eae22f5f1e6ca$var$textAreaStyles = null;
const $b09eae22f5f1e6ca$var$appearanceStyles = null;
const $b09eae22f5f1e6ca$export$ad399be9aa35d90a = (value)=>value.replace(/\s/g, ' ').replace(/  +/g, ' ').trim(); // splitSummary can be cleaned up with simplify_icc_summary_validation
const $b09eae22f5f1e6ca$var$splitSummary = (summary)=>summary.split('\n').reduce((summaries, item)=>{
        const trimmedItem = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(item); // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...summaries,
            ...trimmedItem ? [
                trimmedItem
            ] : []
        ];
    }, []);
const $b09eae22f5f1e6ca$export$1b7a903b2450d74d = (summary, { formatMessage: formatMessage })=>{
    const trimmedSummary = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(summary); // show a warning when summary has reached max length
    if (trimmedSummary.length >= (0, $7462c685f739ed5a$export$193356664cd84c83)) return {
        ...(0, $3FdYO.emptyValidationError),
        summary: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).maxLengthIssueTermRefresh : (0, $iQa4Q.default).maxLength)
    };
    return 0, $3FdYO.emptyValidationError;
};
const $b09eae22f5f1e6ca$export$3100ac1da5e98644 = (validationError)=>Object.values(validationError).filter((error)=>error).length > 0;
class $b09eae22f5f1e6ca$export$46453a0401d6cd1a extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            autoFocus: true,
            shouldScrollIntoView: false,
            initialSummary: '',
            placeholderText: '',
            appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
            submitCounter: 0,
            selectedIssueType: undefined,
            onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            setFocusOnTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    // then setting the setSelectionRange in the textarea will send the cursor to the end of the textarea value.
    // And setting the textarea scrollHeight to scrollTop will send the cursor to the last line when add multiples.
    componentDidMount() {
        const { shouldScrollIntoView: shouldScrollIntoView, autoFocus: autoFocus } = this.props;
        const textArea = this.textAreaRef.current;
        if (textArea) {
            const { length: length } = textArea.value; // preventScroll used to prevent unwanted scrolling with virtualization mounting / re-mounting the component
            textArea.focus({
                preventScroll: !shouldScrollIntoView
            });
            textArea.setSelectionRange(length, length);
            textArea.scrollTop = textArea.scrollHeight;
            if (autoFocus) {
                textArea.focus();
                textArea.setSelectionRange(length, length);
                textArea.scrollTop = textArea.scrollHeight;
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.submitCounter > prevProps.submitCounter) this.reset();
    }
    shouldSummarySubmit() {
        const { summary: summary, validationError: validationError } = this.state;
        if ((0, $4R6GH.fg)('simplify_icc_summary_validation')) return !$b09eae22f5f1e6ca$export$3100ac1da5e98644(validationError);
        const sanitisedSummaries = $b09eae22f5f1e6ca$var$splitSummary(summary); // the warning when summary has reached max length, should not block submit
        return (!$b09eae22f5f1e6ca$export$3100ac1da5e98644(validationError) || summary.length === (0, $7462c685f739ed5a$export$193356664cd84c83)) && sanitisedSummaries.length === 1;
    }
    reset() {
        this.setState({
            summary: '',
            validationError: (0, $3FdYO.emptyValidationError)
        });
    }
    render() {
        const { placeholderText: placeholderText, appearance: appearance, selectedIssueType: selectedIssueType, intl: { formatMessage: formatMessage } } = this.props;
        let ariaLabel;
        if (selectedIssueType) ariaLabel = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).ariaLabelSelectedTypeIssueTermRefresh : (0, $iQa4Q.default).ariaLabelSelectedType, {
            value: selectedIssueType
        });
        else ariaLabel = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).ariaLabelIssueTermRefresh : (0, $iQa4Q.default).ariaLabel);
        const ariaLabelOld = formatMessage((0, $iQa4Q.default).ariaLabelOld);
        const accessibilityProps = {
            'aria-label': (0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? ariaLabel : ariaLabelOld,
            'aria-required': true,
            'aria-invalid': !this.isValid()
        };
        const accessibilityMessage = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iQa4Q.default).issueWithNameCreatedSuccessfullyIssueTermRefresh : (0, $iQa4Q.default).issueWithNameCreatedSuccessfully, {
            name: this.state.ariaLive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
            "aria-live": "assertive",
            id: "inline-card-create.form.summary.a11y.aria-live",
            "data-testid": "platform-inline-card-create.ui.form.summary.aria-live"
        }, this.state.ariaLive && accessibilityMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("textarea", {
            ref: this.textAreaRef,
            "data-testid": "platform-inline-card-create.ui.form.summary.styled-text-area",
            placeholder: placeholderText || formatMessage((0, $iQa4Q.default).prompt),
            value: this.state.summary,
            onChange: this.onChangeSummary,
            onKeyDown: this.onKeyDown,
            ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
                onKeyUp: this.onKeyUp
            } : {},
            rows: appearance === (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) ? 2 : 1,
            maxLength: (0, $7462c685f739ed5a$export$193356664cd84c83),
            tabIndex: 0,
            "aria-controls": "inline-card-create.form.summary.a11y.aria-live",
            ...accessibilityProps,
            className: (0, $bwpsq.default)([
                "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1jfw _1bsb1osq _14zgglyw _bfhkvuon _syaz1fxt _11c81oud _1idr1wmz _1wfakb7n",
                appearance !== (0, $7462c685f739ed5a$export$3789e4b2a10baa2b) && "_4t3iv47k _o572qvpr _1fjgglyw _4pckglyw _1cicglyw"
            ])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            summary: this.props.initialSummary,
            validationError: $b09eae22f5f1e6ca$export$1b7a903b2450d74d(this.props.initialSummary, this.props.intl),
            ariaLive: ''
        } // For the cursor to be move to the end when the component remount, the textarea has to have focus first,
        ;
        this.textAreaRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
        this.onChangeSummary = (event)=>{
            const { onChangeSummary: onChangeSummary, intl: intl } = this.props;
            const summary = $b09eae22f5f1e6ca$export$ad399be9aa35d90a(event.target.value);
            const displayedSummary = event.target.value.replace(/[\n\r]+/g, ' ');
            const validationError = $b09eae22f5f1e6ca$export$1b7a903b2450d74d(summary, intl);
            onChangeSummary({
                summary: summary,
                validationError: validationError
            });
            this.setState({
                summary: displayedSummary,
                validationError: validationError,
                ariaLive: ''
            });
        };
        this.onKeyDown = (event)=>{
            event.stopPropagation();
            const { onSubmit: onSubmit, onCancel: onCancel } = this.props; // RTL tests cannot send event ASCII code but only the actual string `Enter` or `Escape`
            // ref: https://github.com/testing-library/user-event/blob/main/src/keyboard/keyMap.ts#L60C24-L60C35
            if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
                event.preventDefault();
                if (this.shouldSummarySubmit()) {
                    (0, $3iMqq.default)('inline-card-create-submit', event.timeStamp);
                    onSubmit();
                    this.setState({
                        ariaLive: this.state.summary
                    });
                }
            } else if (!(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') && event.key === 'Escape' && !event.nativeEvent.isComposing) return onCancel();
        };
        this.onKeyUp = (event)=>{
            event.stopPropagation();
            const { onCancel: onCancel, setFocusOnTrigger: setFocusOnTrigger } = this.props; // nativeEvent isComposing check is here to prevent ICC from closing when IMEs are open
            // When an IME is open, pressing Escape should close the IME, but ICC should remain open
            if (event.key === 'Escape' && !event.nativeEvent.isComposing) {
                // Set to required on FG cleanup jsw_roadmaps_timeline-issue-creation-ally
                setFocusOnTrigger?.();
                return onCancel();
            }
        };
        this.isValid = ()=>{
            const { summary: summary, summaryConcat: summaryConcat } = this.state.validationError;
            return summary === '' && summaryConcat === '';
        };
    }
}
var $b09eae22f5f1e6ca$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('ICC-summary', {
    onSubmit: 'onSubmitSummary',
    onCancel: 'onCancelSummary'
})((0, $az4zD.injectIntlV2)($b09eae22f5f1e6ca$export$46453a0401d6cd1a));

});
parcelRegister("iQa4Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b047ff7079bd97d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7b047ff7079bd97d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    prompt: {
        "id": "inline-card-create.form.summary.prompt",
        "defaultMessage": "What needs to be done?"
    },
    maxLength: {
        "id": "inline-card-create.form.summary.max-length",
        "defaultMessage": "The issue summary must be less than or equal to 255 characters."
    },
    maxLengthMultiple: {
        "id": "inline-card-create.form.summary.max-length-multiple",
        "defaultMessage": "The summary of every issue must be less than or equal to 255 characters."
    },
    issueWithNameCreatedSuccessfully: {
        "id": "inline-card-create.form.summary.issue-with-name-created-successfully",
        "defaultMessage": "Issue {name} created successfully"
    },
    ariaLabel: {
        "id": "inline-card-create.form.summary.aria-label",
        "defaultMessage": "Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelSelectedType: {
        "id": "inline-card-create.form.summary.aria-label-selected-type",
        "defaultMessage": "{value} selected. Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelOld: {
        "id": "inline-card-create.form.summary.aria-label-old",
        "defaultMessage": "What needs to be done? - Press the \"Enter\" key to submit or the \"Escape\" key to cancel."
    },
    maxLengthIssueTermRefresh: {
        "id": "inline-card-create.form.summary.max-length-issue-term-refresh",
        "defaultMessage": "The issue summary must be less than or equal to 255 characters."
    },
    maxLengthMultipleIssueTermRefresh: {
        "id": "inline-card-create.form.summary.max-length-multiple-issue-term-refresh",
        "defaultMessage": "The summary of every issue must be less than or equal to 255 characters."
    },
    issueWithNameCreatedSuccessfullyIssueTermRefresh: {
        "id": "inline-card-create.form.summary.issue-with-name-created-successfully-issue-term-refresh",
        "defaultMessage": "Issue {name} created successfully"
    },
    ariaLabelIssueTermRefresh: {
        "id": "inline-card-create.form.summary.aria-label-issue-term-refresh",
        "defaultMessage": "Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    },
    ariaLabelSelectedTypeIssueTermRefresh: {
        "id": "inline-card-create.form.summary.aria-label-selected-type-issue-term-refresh",
        "defaultMessage": "{value} selected. Add your issue summary and then press Enter to submit. Use the Escape key to cancel."
    }
});

});




parcelRegister("l94uE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719a5afff7fc59d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");


var $gBq9h = parcelRequire("gBq9h");

var $egFHr = parcelRequire("egFHr");

var $5Qqfj = parcelRequire("5Qqfj");
function $9719a5afff7fc59d$export$41fb9f06171c75f4({ isDisabled: isDisabled, triggerAppearance: triggerAppearance, isSticky: isSticky, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, intl: { formatMessage: formatMessage }, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false }) {
    const defaultLabel = label || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $egFHr.default).labelIssueTermRefresh : (0, $egFHr.default).label);
    if (triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Qqfj.default), {
        isModalTrigger: isModalTrigger,
        isSticky: isSticky,
        label: defaultLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        isDisabled: isDisabled,
        ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    });
    if (isDisabled !== true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        label: defaultLabel,
        onClick: onClick,
        ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            shouldFocusTrigger: shouldFocusTrigger
        } : {}
    });
    return null;
}
$9719a5afff7fc59d$export$41fb9f06171c75f4.defaultProps = {
    isDisabled: false,
    isSticky: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    label: '',
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldFocusTrigger: false
};
var $9719a5afff7fc59d$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $az4zD.injectIntlV2)($9719a5afff7fc59d$export$41fb9f06171c75f4));

});
parcelRegister("gBq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a1afa644007482$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jY1Ee = parcelRequire("jY1Ee");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

const $e0a1afa644007482$var$fadeInAnimation = null;
const $e0a1afa644007482$var$triggerStyles = null;
const $e0a1afa644007482$var$buttonStyles = null;
// eslint-disable-next-line jira/styled/styled-component-order
const $e0a1afa644007482$var$centeredIconStyles = (0, $jJ1Sb.xcss)({
    margin: 'space.negative.025',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line jira/styled/styled-component-order
const $e0a1afa644007482$var$dividerStyles = (0, $jJ1Sb.xcss)({
    position: 'absolute',
    transform: 'translateY(3px)',
    height: "var(--ds-space-025, 2px)",
    width: '100%'
});
const $e0a1afa644007482$var$TriggerFallback = (props)=>/*#__PURE__*/ $5uXOq.createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswh2mm _1pbykb7n _18s8p5ac _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _4t3iu2gc _1bsb1osq _bfhk18uv _tzy4idpf _1pjhtlke _1mygkb7n _qj9aglyw _d0altlke _11om1wwu _7psyfnf5 _1uy0fnf5 _bir2q7pw"
        ])
    });
const $e0a1afa644007482$export$9496cf78b8451731 = ({ label: label, onClick: onClick, TriggerWrapper: TriggerWrapper = $e0a1afa644007482$var$TriggerFallback, shouldFocusTrigger: shouldFocusTrigger = false })=>/*#__PURE__*/ $5uXOq.createElement(TriggerWrapper, {
        onClick: onClick
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MGmIU.default), {
        content: label,
        position: "left",
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        ...(0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? {
            autoFocus: shouldFocusTrigger
        } : {},
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswstnw _t9ec1c9r _1pbykb7n _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _4t3iv47k _1bsbv47k _19itglyw _2rko1sit _bfhkq17z _80om1kw7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $e0a1afa644007482$var$centeredIconStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jY1Ee))), {
        label: label,
        primaryColor: `var(--ds-icon-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $6T4rd.default), {
        xcss: $e0a1afa644007482$var$dividerStyles,
        backgroundColor: "color.background.brand.bold"
    }));
var $e0a1afa644007482$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e0a1afa644007482$export$9496cf78b8451731);

});

parcelRegister("egFHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f56794831a7b04b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f56794831a7b04b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "inline-card-create.trigger.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "inline-card-create.trigger.label-issue-term-refresh",
        "defaultMessage": "Create issue"
    }
});

});

parcelRegister("5Qqfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd137c52878495bb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8GVAj = parcelRequire("8GVAj");

var $3zMpi = parcelRequire("3zMpi");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");


var $MGmIU = parcelRequire("MGmIU");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $iKdRC = parcelRequire("iKdRC");

var $k7nVK = parcelRequire("k7nVK");
const $cd137c52878495bb$var$labelWrapperStyles = null;
const $cd137c52878495bb$var$contentWrapperStyles = null;
const $cd137c52878495bb$export$305831e851c35a16 = ({ isDisabled: isDisabled = false, isSticky: isSticky = false, label: label, ariaLabelledBy: ariaLabelledBy, onClick: onClick, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const iccButtonTheme = (currentTheme, props)=>{
        const themeProps = {
            ...props
        };
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                marginTop: "var(--ds-space-025, 2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                height: `${(0, $gwIPs.gridSize) * 4.5}px`,
                alignItems: 'center'
            },
            spinnerStyles: spinnerStyles
        };
    };
    const iconColor = isDisabled ? `var(--ds-icon-disabled, ${(0, $5e0c0d4e15efb4a6$exports).N70})` : `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N500})`;
    const shouldShowTooltip = label.length > 16;
    const renderStickyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1e5h"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zMpi))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            color: iconColor,
            LEGACY_size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1ule _18u01b66 _1reo15vq _1wnr15vq"
            ])
        }, (0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k7nVK.default), null, label)));
    const ButtonComponent = isModalTrigger ? (0, $iKdRC.ModalTriggerButton) : (0, $8GVAj.default);
    const renderButtonComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
            ...triggerProps,
            iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zMpi))), {
                testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
                label: "",
                color: iconColor,
                LEGACY_size: "small"
            }),
            appearance: "subtle",
            theme: iccButtonTheme,
            shouldFitContainer: true,
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "platform-inline-card-create.ui.trigger.visible.button",
            "aria-labelledby": ariaLabelledBy,
            "aria-label": label,
            autoFocus: shouldFocusTrigger
        }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label));
    return (0, $4R6GH.fg)('jsw_roadmaps_timeline-issue-creation-ally') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: label,
        tag: "span"
    }, renderButtonComponent) : renderButtonComponent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zMpi))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            color: iconColor,
            LEGACY_size: "small"
        }),
        appearance: "subtle",
        theme: iccButtonTheme,
        shouldFitContainer: true,
        onClick: onClick,
        isDisabled: isDisabled,
        testId: "platform-inline-card-create.ui.trigger.visible.button",
        "aria-labelledby": ariaLabelledBy
    }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k7nVK.default), null, label));
};
const $cd137c52878495bb$var$labelContextStyles = (0, $jJ1Sb.xcss)({
    display: 'block',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflowX: 'hidden'
});
var $cd137c52878495bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cd137c52878495bb$export$305831e851c35a16);

});
parcelRegister("3zMpi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45e9dbc5862bfe91f01c54aec1c8b1e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29aa30a10eb5cfd4$var$_react = $29aa30a10eb5cfd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $29aa30a10eb5cfd4$var$_add = $29aa30a10eb5cfd4$var$_interopRequireDefault((parcelRequire("hBUeM")));

var $29aa30a10eb5cfd4$var$_add2 = $29aa30a10eb5cfd4$var$_interopRequireDefault((parcelRequire("gxncq")));
function $29aa30a10eb5cfd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29aa30a10eb5cfd4$var$AddIcon = (props)=>/*#__PURE__*/ $29aa30a10eb5cfd4$var$_react.default.createElement($29aa30a10eb5cfd4$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $29aa30a10eb5cfd4$var$_add2.default
    }, props));
$29aa30a10eb5cfd4$var$AddIcon.Name = 'AddIconMigration';
var $29aa30a10eb5cfd4$var$_default = module.exports.default = $29aa30a10eb5cfd4$var$AddIcon;

});

parcelRegister("k7nVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b62c3f5cd2414f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MGmIU = parcelRequire("MGmIU");
const $4b62c3f5cd2414f1$var$Label = ({ children: children })=>{
    // naive solution to check whether the text is too long and might be truncated with ellipsis
    const shouldShowTooltip = children.length > 16;
    return shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: children,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b62c3f5cd2414f1$var$Content, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4b62c3f5cd2414f1$var$Content, null, children);
};
var $4b62c3f5cd2414f1$export$2e2bcd8739ae039 = $4b62c3f5cd2414f1$var$Label;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4b62c3f5cd2414f1$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _y3gn1e5h _1bto1l2s _1reo15vq",
            __cmplp.className
        ])
    });
});

});





parcelRegister("hyUTn", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $7a91e61e41af25ec$export$cd4e5573fbe2b576);
/**
 * This is here to make testing easier.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
const $7a91e61e41af25ec$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});



parcelRegister("3mWFd", function(module, exports) {

$parcel$export(module.exports, "useRenderFullItem", () => $ad658e0d8f102510$export$f774065b6ff9b006);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Version of requestIdleCallback with fallback to setTimeout of 200ms.
 */ const $ad658e0d8f102510$var$scheduleIdle = (cb)=>{
    if (typeof requestIdleCallback === 'undefined') {
        const timer = setTimeout(cb, 200);
        return ()=>{
            clearTimeout(timer);
        };
    }
    const idleCallback = requestIdleCallback(cb);
    return ()=>{
        cancelIdleCallback(idleCallback);
    };
};
const $ad658e0d8f102510$export$f774065b6ff9b006 = ({ isVisible: isVisible, isScrolling: isScrolling })=>{
    const [renderFullCard, setRenderFullCard] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isScrolling) return undefined;
        if (isVisible) {
            setRenderFullCard(true);
            return undefined;
        }
        return $ad658e0d8f102510$var$scheduleIdle(()=>{
            setRenderFullCard(true);
        });
    }, [
        isScrolling,
        isVisible
    ]);
    return renderFullCard;
};

});


parcelRegister("aJ0IJ", function(module, exports) {

$parcel$export(module.exports, "CardGroup", () => $20061fd03e670f1c$export$9acc0474485b44b2);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iDGXn = parcelRequire("iDGXn");

var $2lpqS = parcelRequire("2lpqS");

var $f6RVN = parcelRequire("f6RVN");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");

var $b7YUC = parcelRequire("b7YUC");
function $20061fd03e670f1c$export$9acc0474485b44b2({ cardGroup: { cardIds: cardIds, isAttachedToParent: isAttachedToParent, isCollapsed: isCollapsed }, row: row, isScrolling: isScrolling, cardListId: cardListId, setRichActiveCard: setRichActiveCard }) {
    const isCompactMode = (0, $iDGXn.useShowCompactMode)();
    /**
   * Checking if the card has extra fields set from board configuration
   */ const hasExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.hasCardExtraFields));
    /**
   * Checking if the extra fields is off from view settings
   */ const shouldRenderExtraFields = (0, $iDGXn.useHasCardExtraFields)();
    const hasExtraCardHeight = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? shouldRenderExtraFields && hasExtraFields : hasExtraFields;
    let cardRowHeight = isCompactMode ? (0, $2lpqS.COMPACT_CARD_ROW_HEIGHT) : (0, $2lpqS.CARD_ROW_HEIGHT);
    cardRowHeight = hasExtraCardHeight ? cardRowHeight + (0, $2lpqS.EXTRA_CARD_ROW_HEIGHT) : cardRowHeight;
    const content = !isCollapsed ? cardIds.map((cardId, index)=>{
        const cardContainerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b7YUC.default), {
            row: row,
            isScrolling: isScrolling,
            cardId: cardId,
            cardListId: cardListId,
            isAttachedToParent: isAttachedToParent,
            setRichActiveCard: setRichActiveCard
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20061fd03e670f1c$var$CardWrapper, {
            key: cardId,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                top: index * cardRowHeight
            }
        }, cardContainerEl);
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20061fd03e670f1c$var$CardGroupWrapper, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20061fd03e670f1c$var$CardGroupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $20061fd03e670f1c$var$CardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kaE44", function(module, exports) {

$parcel$export(module.exports, "CardListHeader", () => $1f3231f9110617b8$export$4b6322f1b24707fd);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");

var $3t5QD = parcelRequire("3t5QD");

var $hZ46s = parcelRequire("hZ46s");

var $guzeq = parcelRequire("guzeq");

var $fvfVu = parcelRequire("fvfVu");

var $2oFWP = parcelRequire("2oFWP");

var $hTJrU = parcelRequire("hTJrU");

var $lusSu = parcelRequire("lusSu");

var $fSrcf = parcelRequire("fSrcf");

var $kykx0 = parcelRequire("kykx0");

var $klxs8 = parcelRequire("klxs8");
const $1f3231f9110617b8$var$BacklogAccordionNudgeAsyncWithFullWidth = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        xcss: $1f3231f9110617b8$var$backlogAccordionNudgeAsyncStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZ46s.BacklogAccordionNudgeAsync), null, children));
const $1f3231f9110617b8$export$4b6322f1b24707fd = ({ isCreateSprintButtonVisible: isCreateSprintButtonVisible, isDisabled: isDisabled, isMaxLimitReached: isMaxLimitReached, isMinLimitReached: isMinLimitReached, onCreateSprint: onCreateSprint, onToggle: onToggle = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { cardListId: cardListId, type: type, listName: listName } = (0, $fvfVu.useCardListContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        xcss: [
            $1f3231f9110617b8$var$cardListHeaderStyles,
            isMaxLimitReached && $1f3231f9110617b8$var$maxLimitReachedStyles,
            isMinLimitReached && $1f3231f9110617b8$var$minLimitReachedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTJrU.CardListCheckbox), {
        cardListId: cardListId,
        isDisabled: isDisabled,
        ...(0, $4R6GH.fg)('a11y_violations_fixes') ? {
            listName: `${type === (0, $guzeq.SPRINT) ? `${formatMessage((0, $kykx0.default).sprintListNamePrefix)} ` : ''}${listName}`
        } : {}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: $1f3231f9110617b8$var$BacklogAccordionNudgeAsyncWithFullWidth,
        conditionsToApplyWrapper: ((0, $4R6GH.fg)('jsw-perf-backlog-lazy-instrumented-nudge-spotlight') ? !isOnboardingDismissed : true) && type === (0, $guzeq.BACKLOG)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lusSu.CardListAccordionButton), {
        onToggle: onToggle
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $klxs8.SprintHeader), null), type === (0, $guzeq.BACKLOG) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2oFWP.BacklogButtonVariant), null), isCreateSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fSrcf.CreateSprintButton), {
        onCreateSprint: onCreateSprint
    })));
};
const $1f3231f9110617b8$var$cardListHeaderStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.100',
    minHeight: "var(--ds-space-400, 32px)",
    paddingInline: 'space.100',
    // Added the 1px border so that we get 9px of padding on the left and right of the header.
    // We do this so that the checkbox aligns with the checkboxes in the card list.
    borderLeft: '1px solid transparent',
    borderRight: '1px solid transparent'
});
const $1f3231f9110617b8$var$minLimitReachedStyles = (0, $jJ1Sb.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest'
});
const $1f3231f9110617b8$var$maxLimitReachedStyles = (0, $jJ1Sb.xcss)({
    backgroundColor: 'color.background.accent.red.subtlest'
});
const $1f3231f9110617b8$var$backlogAccordionNudgeAsyncStyles = (0, $jJ1Sb.xcss)({
    flex: '1'
});

});
parcelRegister("hTJrU", function(module, exports) {

$parcel$export(module.exports, "CardListCheckbox", () => $da9473345a1fc6db$export$e5861b404a98a88f);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $al6I6 = parcelRequire("al6I6");

var $acDhY = parcelRequire("acDhY");

var $i2bSr = parcelRequire("i2bSr");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dCm1o = parcelRequire("dCm1o");

var $c1MAf = parcelRequire("c1MAf");

var $8SI0F = parcelRequire("8SI0F");

var $4mqko = parcelRequire("4mqko");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $3aKtu = parcelRequire("3aKtu");

var $5dyvY = parcelRequire("5dyvY");
const $da9473345a1fc6db$export$3a055e4082f2e2d5 = ()=>(0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
const $da9473345a1fc6db$export$2cfb87b4e8fba2a2 = (cardListId)=>(0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeOrderedVisibleCardsForCardList)(state)(cardListId));
const $da9473345a1fc6db$export$18cc44b9c48de32 = ()=>(0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCheckboxSelectionMode));
const $da9473345a1fc6db$var$staticEntryPointActions = {
    load: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $da9473345a1fc6db$export$e5861b404a98a88f = ({ cardListId: cardListId, isDisabled: isDisabled, listName: listName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions } = (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $acDhY.useBulkOpsEntryPoint)() : {
        entryPointActions: $da9473345a1fc6db$var$staticEntryPointActions
    };
    const selectedCards = $da9473345a1fc6db$export$3a055e4082f2e2d5();
    const selectableCards = $da9473345a1fc6db$export$2cfb87b4e8fba2a2(cardListId);
    const selectionMode = $da9473345a1fc6db$export$18cc44b9c48de32();
    const selectableIssueIds = (0, $5uXOq.useMemo)(()=>selectableCards.map((card)=>card.id), [
        selectableCards
    ]);
    const selectedCardsSet = (0, $5uXOq.useMemo)(()=>new Set(selectedCards), [
        selectedCards
    ]);
    const selectedIssueIds = (0, $5uXOq.useMemo)(()=>selectableIssueIds.filter((id)=>selectedCardsSet.has(id)), [
        selectableIssueIds,
        selectedCardsSet
    ]);
    const extraAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            selectAll: {
                checkbox: {
                    issue_ids: selectableIssueIds,
                    numSelectedCards: selectableIssueIds.length,
                    selectType: 'sprint',
                    isCheckboxChecked: true
                }
            },
            clearAll: {
                checkbox: {
                    issue_ids: [],
                    numSelectedCards: 0,
                    selectType: 'sprint',
                    isCheckboxChecked: false
                }
            }
        }), [
        selectableIssueIds
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onSelectAll = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $4mqko.cardMultiSelectExtend)(selectableIssueIds));
        dispatch((0, $8SI0F.setCheckboxSelectionMode)(true));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.selectAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.selectAll.checkbox,
        selectableIssueIds
    ]);
    const onClearAll = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'checkbox'
        });
        dispatch((0, $4mqko.cardMultiRemove)(selectedIssueIds));
        if (selectedCards.length === selectedIssueIds.length) dispatch((0, $8SI0F.setCheckboxSelectionMode)(false));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'bulkSelectCardList', {
            ...extraAnalyticsAttributes.clearAll.checkbox
        });
    }, [
        createAnalyticsEvent,
        dispatch,
        extraAnalyticsAttributes.clearAll.checkbox,
        selectedCards.length,
        selectedIssueIds
    ]);
    const checkboxState = (0, $5uXOq.useMemo)(()=>(0, $5dyvY.getCardListCheckboxState)({
            selectedIssueIds: selectedIssueIds,
            selectableIssueIds: selectableIssueIds,
            selectionMode: selectionMode
        }), [
        selectedIssueIds,
        selectableIssueIds,
        selectionMode
    ]);
    const onCheckboxClick = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
        if (checkboxState === (0, $i2bSr.CheckboxState).CHECKED) onClearAll();
        else if (checkboxState === (0, $i2bSr.CheckboxState).UNCHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE) {
            (0, $6s1PB.expVal)('bulk_operations_floating_toolbar', 'isEnabled', false) && entryPointActions.load();
            onSelectAll();
        }
    }, [
        checkboxState,
        onClearAll,
        onSelectAll,
        entryPointActions
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getLabel = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('a11y_violations_fixes')) {
            if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabelIssueTermRefresh, {
                listName: listName
            }) : formatMessage((0, $3aKtu.messages).selectCheckboxLabelIssueTermRefresh, {
                listName: listName
            });
            return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabel, {
                listName: listName
            }) : formatMessage((0, $3aKtu.messages).selectCheckboxLabel, {
                listName: listName
            });
        }
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabelOldIssueTermRefresh) : formatMessage((0, $3aKtu.messages).selectCheckboxLabelOldIssueTermRefresh);
        return checkboxState === (0, $i2bSr.CheckboxState).CHECKED ? formatMessage((0, $3aKtu.messages).deselectCheckboxLabelOld, {
            listName: listName
        }) : formatMessage((0, $3aKtu.messages).selectCheckboxLabelOld);
    }, [
        checkboxState,
        formatMessage,
        listName
    ]);
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $al6I6.default), {
        testId: "software-backlog.card-list.cardlist-checkbox.checkbox",
        onClick: onCheckboxClick,
        isChecked: checkboxState === (0, $i2bSr.CheckboxState).CHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isIndeterminate: checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isDisabled: isDisabled || selectableIssueIds.length === 0,
        "aria-label": getLabel,
        "aria-disabled": isDisabled || selectableIssueIds.length === 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da9473345a1fc6db$var$StyledCardListCheckbox, {
        "data-testid": "software-backlog.card-list.cardlist-checkbox.checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $al6I6.default), {
        onClick: onCheckboxClick,
        isChecked: checkboxState === (0, $i2bSr.CheckboxState).CHECKED || checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isIndeterminate: checkboxState === (0, $i2bSr.CheckboxState).INDETERMINATE,
        isDisabled: isDisabled || selectableIssueIds.length === 0,
        "aria-label": getLabel,
        "aria-disabled": isDisabled || selectableIssueIds.length === 0
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da9473345a1fc6db$var$StyledCardListCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc _1bsbgktf _19itoyrj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2bSr", function(module, exports) {

$parcel$export(module.exports, "CheckboxState", () => $cf7acea0ad7120b6$export$10d1ecb0f8412c60);
const $cf7acea0ad7120b6$export$10d1ecb0f8412c60 = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
};

});

parcelRegister("3aKtu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $78527b0a4741fb8f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $78527b0a4741fb8f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deselectCheckboxLabelOld: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old",
        "defaultMessage": "Deselect all issues in sprint"
    },
    selectCheckboxLabelOld: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-old",
        "defaultMessage": "Select all issues in sprint"
    },
    deselectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label",
        "defaultMessage": "Deselect all issues in {listName}"
    },
    selectCheckboxLabel: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label",
        "defaultMessage": "Select all issues in {listName}"
    },
    selectCheckboxLabelIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-issue-term-refresh",
        "defaultMessage": "Select all issues in {listName}"
    },
    deselectCheckboxLabelIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-issue-term-refresh",
        "defaultMessage": "Deselect all issues in {listName}"
    },
    deselectCheckboxLabelOldIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.deselect-checkbox-label-old-issue-term-refresh",
        "defaultMessage": "Deselect all issues in sprint"
    },
    selectCheckboxLabelOldIssueTermRefresh: {
        "id": "backlog.card-list.cardlist-checkbox.select-checkbox-label-old-issue-term-refresh",
        "defaultMessage": "Select all issues in sprint"
    }
});

});

parcelRegister("5dyvY", function(module, exports) {

$parcel$export(module.exports, "getCardListCheckboxState", () => $91355c9856c0ba56$export$ff0019101ecd17c9);

var $i2bSr = parcelRequire("i2bSr");
const $91355c9856c0ba56$export$ff0019101ecd17c9 = ({ selectedIssueIds: selectedIssueIds, selectableIssueIds: selectableIssueIds, selectionMode: selectionMode })=>{
    const selectedSelectableIssueIds = selectableIssueIds.filter((id)=>selectedIssueIds.includes(id));
    if (selectableIssueIds.length === selectedSelectableIssueIds.length && selectedSelectableIssueIds.length > 0 && selectionMode) return (0, $i2bSr.CheckboxState).CHECKED;
    if (selectedIssueIds.length > 0) {
        if (selectedIssueIds.length === 1) {
            if (selectionMode) return (0, $i2bSr.CheckboxState).INDETERMINATE;
            return (0, $i2bSr.CheckboxState).UNCHECKED;
        }
        return (0, $i2bSr.CheckboxState).INDETERMINATE;
    }
    return (0, $i2bSr.CheckboxState).UNCHECKED;
};

});


parcelRegister("lusSu", function(module, exports) {

$parcel$export(module.exports, "CardListAccordionButton", () => $30f16cff590cebe3$export$6651856fa745dad);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $95qVZ = parcelRequire("95qVZ");

var $53KbV = parcelRequire("53KbV");

var $9ed83 = parcelRequire("9ed83");

var $2xkq3 = parcelRequire("2xkq3");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $eddAM = parcelRequire("eddAM");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $dqoiX = parcelRequire("dqoiX");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $fvfVu = parcelRequire("fvfVu");

var $f5uwQ = parcelRequire("f5uwQ");

var $kARaY = parcelRequire("kARaY");


var $5iS2L = parcelRequire("5iS2L");

var $kykx0 = parcelRequire("kykx0");
const $30f16cff590cebe3$export$6651856fa745dad = ({ onToggle: onToggle })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDate = (0, $5iS2L.useFormatDate)();
    const { cardCountExcludingSubtasks: cardCountExcludingSubtasks, cardListId: cardListId, isCollapsed: isCollapsed, isFirstList: isFirstList, isMaxLimitReached: isMaxLimitReached, isMinLimitReached: isMinLimitReached, maxColumnLimit: maxColumnLimit, minColumnLimit: minColumnLimit, listName: listName, sprintData: sprintData, type: type, visibleCardAmount: visibleCardAmount } = (0, $fvfVu.useCardListContext)();
    const { isAddSprintDatesButtonVisible: isAddSprintDatesButtonVisible } = (0, $f5uwQ.useSprintLifecycleContext)();
    const chevronRightIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
        label: formatMessage((0, $kykx0.default).expandAccessabilityLabel),
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
    const chevronDownIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
        label: formatMessage((0, $kykx0.default).collapseAccessabilityLabel),
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9ed83))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    });
    const renderIcon = ()=>isCollapsed ? chevronRightIcon : chevronDownIcon;
    const leftSideRef = (0, $5uXOq.useRef)(null);
    const handleToggle = (event)=>{
        event.preventDefault();
        onToggle();
    };
    const handleHeaderKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            onToggle();
        }
    };
    const renderNumberOfVisibleCardsText = ()=>{
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return cardCountExcludingSubtasks !== visibleCardAmount ? formatMessage((0, $kykx0.default).visibleCardAmountIssueTermRefresh, {
            totalCardAmount: cardCountExcludingSubtasks,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $kykx0.default).cardAmountIssueTermRefresh, {
            cardAmount: cardCountExcludingSubtasks
        });
        return cardCountExcludingSubtasks !== visibleCardAmount ? formatMessage((0, $kykx0.default).visibleCardAmount, {
            totalCardAmount: cardCountExcludingSubtasks,
            cardAmount: visibleCardAmount
        }) : formatMessage((0, $kykx0.default).cardAmount, {
            cardAmount: cardCountExcludingSubtasks
        });
    };
    const renderAddSprintDatesButton = ()=>{
        const stopPropagation = (e)=>e.stopPropagation();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            onClick: stopPropagation,
            onKeyDown: stopPropagation,
            testId: "software-backlog.card-list.card-list-header.card-list-accordion-button.add-sprint-date-button-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kARaY.default), {
            cardListId: Number(cardListId)
        }));
    };
    const renderColumnLimits = ()=>isFirstList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, minColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            testId: (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
            appearance: isMinLimitReached ? 'moved' : 'default',
            isBold: isMinLimitReached
        }, `MIN ${minColumnLimit}`)) : null, maxColumnLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
            testId: (0, $0226f08d081871ec$export$54c7326f7173c649)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), {
            appearance: isMaxLimitReached ? 'removed' : 'default',
            isBold: isMaxLimitReached
        }, `MAX ${maxColumnLimit}`)) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $95qVZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $30f16cff590cebe3$var$leftSideStyles,
        testId: (0, $0226f08d081871ec$export$483ac6106791f695),
        role: "button",
        tabIndex: 0,
        "aria-controls": `backlog-accordion-${cardListId}`,
        onClick: handleToggle,
        onKeyDown: handleHeaderKeyDown,
        "aria-expanded": !isCollapsed,
        ref: leftSideRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $30f16cff590cebe3$var$iconStyles
    }, renderIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        as: "h2",
        size: "xsmall"
    }, listName), sprintData && isAddSprintDatesButtonVisible && renderAddSprintDatesButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, sprintData && !isAddSprintDatesButtonVisible && sprintData.startDate && sprintData.endDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        size: "medium",
        color: "color.text.subtle"
    }, `${formatDate(sprintData.startDate)} \u{2013} ${formatDate(sprintData.endDate)}`), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        size: "medium",
        color: "color.text.subtle"
    }, "(", renderNumberOfVisibleCardsText(), ")")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${(0, $0226f08d081871ec$export$483ac6106791f695)}-${type}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "aria-live": "polite",
        role: "status"
    }, listName, " ", renderNumberOfVisibleCardsText())), renderColumnLimits())));
};
const $30f16cff590cebe3$var$leftSideStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 1,
    gap: 'space.050'
});
const $30f16cff590cebe3$var$iconStyles = (0, $jJ1Sb.xcss)({
    pointerEvents: 'none',
    width: '24px',
    height: '24px'
});

});
const $0226f08d081871ec$export$483ac6106791f695 = 'software-backlog.card-list.left-side';
const $0226f08d081871ec$export$54c7326f7173c649 = 'software-backlog.card-list.column-limit';

parcelRegister("5iS2L", function(module, exports) {

$parcel$export(module.exports, "useFormatDate", () => $5cb8518452b7be6a$export$fc5db2b57ab9d291);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $7jns1 = parcelRequire("7jns1");

var $lzeFL = parcelRequire("lzeFL");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $leRCk = parcelRequire("leRCk");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $ie0h1 = parcelRequire("ie0h1");
const $5cb8518452b7be6a$var$MS_IN_HOURS = 3600000;
const $5cb8518452b7be6a$export$fc5db2b57ab9d291 = ()=>{
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getLocale)) || (0, $lzeFL.defaultLocale);
    return (0, $5uXOq.useCallback)((date)=>{
        const utcOffset = Math.floor((0, $7jns1.default)(loggedInUser?.timeZone ?? 'utc') / $5cb8518452b7be6a$var$MS_IN_HOURS);
        const parsedDate = (0, $1p96B.setNumberOffsetToISODate)(date, utcOffset);
        return (0, $jovBr.default)(parsedDate) ? (0, $1p96B.formatWithLocale)(parsedDate, (0, $guzeq.DEFAULT_DATE_DISPLAY_FORMAT), locale) : formatMessage((0, $ie0h1.default).invalidDate);
    }, [
        formatMessage,
        locale,
        loggedInUser?.timeZone
    ]);
};

});
parcelRegister("ie0h1", function(module, exports) {

$parcel$export(module.exports, "default", () => $343319cf1ab5fb37$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $343319cf1ab5fb37$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    invalidDate: {
        "id": "backlog.card-list.hooks.use-format-date.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});


parcelRegister("kykx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4ade00f55a5206$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c4ade00f55a5206$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cardAmount: {
        "id": "backlog.card-list.card-list-header.card-amount",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    },
    visibleCardAmount: {
        "id": "backlog.card-list.card-list-header.visible-card-amount",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    startSprint: {
        "id": "backlog.card-list.card-list-header.start-sprint",
        "defaultMessage": "Start sprint"
    },
    createSprint: {
        "id": "backlog.card-list.card-list-header.create-sprint",
        "defaultMessage": "Create sprint"
    },
    completeSprint: {
        "id": "backlog.card-list.card-list-header.complete-sprint",
        "defaultMessage": "Complete sprint"
    },
    disabledStartSprintButtonEmpty: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-empty",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    disabledStartSprintButtonNoParallel: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-no-parallel",
        "defaultMessage": "Can be planned but not started until the completion of above active sprint"
    },
    sprintListNamePrefix: {
        "id": "backlog.card-list.card-list-header.sprint-list-name-prefix",
        "defaultMessage": "sprint"
    },
    expandAccessabilityLabel: {
        "id": "backlog.card-list.card-list-header.expand-accessability-label",
        "defaultMessage": "Expand"
    },
    collapseAccessabilityLabel: {
        "id": "backlog.card-list.card-list-header.collapse-accessability-label",
        "defaultMessage": "Collapse"
    },
    createSprintButtonDisabledInfoTextNonFinal: {
        "id": "backlog.card-list.card-list-header.create-sprint-button-disabled-info-text-non-final",
        "defaultMessage": "Request permissions from board admin"
    },
    completeSprintButtonDisabledInfoTextNonFinal: {
        "id": "backlog.card-list.card-list-header.complete-sprint-button-disabled-info-text-non-final",
        "defaultMessage": "Request permissions from project admin"
    },
    disabledStartSprintButtonEmptyIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.disabled-start-sprint-button-empty-issue-term-refresh",
        "defaultMessage": "Sprint cannot be started because it contains no issues"
    },
    visibleCardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.visible-card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} of {totalCardAmount} {totalCardAmount, plural, one {issue} other {issues}} visible"
    },
    cardAmountIssueTermRefresh: {
        "id": "backlog.card-list.card-list-header.card-amount-issue-term-refresh",
        "defaultMessage": "{cardAmount} {cardAmount, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("fSrcf", function(module, exports) {

$parcel$export(module.exports, "CreateSprintButton", () => $4c578b2b09c33ffa$export$e3fcc84403d55941);

var $5uXOq = parcelRequire("5uXOq");

var $dHJL9 = parcelRequire("dHJL9");

var $fHbE4 = parcelRequire("fHbE4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");

var $8zOmE = parcelRequire("8zOmE");

var $3t5QD = parcelRequire("3t5QD");

var $4lQkG = parcelRequire("4lQkG");

var $f5uwQ = parcelRequire("f5uwQ");

var $elctU = parcelRequire("elctU");

var $kykx0 = parcelRequire("kykx0");
const $4c578b2b09c33ffa$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.create-sprint-button.a11y-helper-text';
const $4c578b2b09c33ffa$export$e3fcc84403d55941 = ({ onCreateSprint: onCreateSprint })=>{
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canManageSprints: canManageSprints, isCreateSprintButtonDisabled: isCreateSprintButtonDisabled } = (0, $f5uwQ.useSprintLifecycleContext)();
    const handleCreateSprint = (event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createSprint');
        onCreateSprint(analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        direction: "row",
        alignItems: "center",
        testId: "software-backlog.card-list.card-list-header.create-sprint-button.create-sprint-button-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $4lQkG.BacklogCreateSprintNudgeAsync),
        conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw-perf-onboarding-backlog-create-sprint-load') ? nudgeStep === (0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID) : true
    }, !canManageSprints && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), {
        isDisabled: true,
        helpTextId: $4c578b2b09c33ffa$var$A11Y_HELPER_TEXT_ID,
        helpText: formatMessage((0, $kykx0.default).createSprintButtonDisabledInfoTextNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        "aria-describedby": $4c578b2b09c33ffa$var$A11Y_HELPER_TEXT_ID,
        onClick: handleCreateSprint,
        isDisabled: true,
        testId: "software-backlog.card-list.card-list-header.create-sprint-button",
        spacing: "compact"
    }, formatMessage((0, $kykx0.default).createSprint))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
        onClick: handleCreateSprint,
        isDisabled: isCreateSprintButtonDisabled,
        testId: "software-backlog.card-list.card-list-header.create-sprint-button",
        spacing: "compact"
    }, formatMessage((0, $kykx0.default).createSprint))));
};

});
parcelRegister("elctU", function(module, exports) {

$parcel$export(module.exports, "DisabledButtonHelper", () => $8fecce8b5a414d33$export$7407340f59537358);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $1m92z = parcelRequire("1m92z");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $8fecce8b5a414d33$export$7407340f59537358 = ({ children: children, isDisabled: isDisabled, helpTextId: helpTextId, helpText: helpText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        gap: "space.050",
        alignItems: "center"
    }, isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $8fecce8b5a414d33$var$helperTextWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
        as: "p",
        size: "small",
        color: "color.text.subtle",
        id: helpTextId
    }, helpText)), children);
};
const $8fecce8b5a414d33$var$helperTextWrapperStyles = (0, $jJ1Sb.xcss)({
    textAlign: 'right',
    width: '120px'
});

});


parcelRegister("klxs8", function(module, exports) {

$parcel$export(module.exports, "SprintHeader", () => $b1fc2d85299762af$export$75b8174ace1d568);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6T4rd = parcelRequire("6T4rd");
var $fHbE4 = parcelRequire("fHbE4");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");


var $9USr3 = parcelRequire("9USr3");

var $3t5QD = parcelRequire("3t5QD");

var $emeAH = parcelRequire("emeAH");

var $ayaAN = parcelRequire("ayaAN");

var $dCm1o = parcelRequire("dCm1o");

var $fvfVu = parcelRequire("fvfVu");

var $f5uwQ = parcelRequire("f5uwQ");

var $bs6dR = parcelRequire("bs6dR");

var $2dBGm = parcelRequire("2dBGm");

var $hkjgs = parcelRequire("hkjgs");

var $cOAVR = parcelRequire("cOAVR");

var $kykx0 = parcelRequire("kykx0");
const $b1fc2d85299762af$export$75b8174ace1d568 = ()=>{
    const { cardIds: cardIds, cardListId: cardListId, type: type, listName: listName, isFirstList: isFirstList } = (0, $fvfVu.useCardListContext)();
    const { canEditSprint: canEditSprint, isStartSprintEnabled: isStartSprintEnabled, isStartSprintButtonVisible: isStartSprintButtonVisible, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, isCompleteSprintButtonDisabled: isCompleteSprintButtonDisabled, isSprintMenuVisible: isSprintMenuVisible } = (0, $f5uwQ.useSprintLifecycleContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const { ref: startSprintButtonNudgeRef } = (0, $9USr3.useRegisterNudgeTarget)('start-sprint-button', isFirstList);
    const renderStartSprintButton = ()=>{
        const totalCardAmount = cardIds.length;
        const isEmpty = totalCardAmount === 0;
        const shouldShowPrimaryButton = !isEmpty && isFirstList;
        const isStartSprintButtonDisabled = !isStartSprintEnabled || isEmpty;
        const appearanceValue = shouldShowPrimaryButton ? 'primary' : 'default';
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOAVR.default), {
            // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
            testId: "software-backlog.card-list.card-list-header.sprint-header.start-sprint-button",
            sprintId: cardListId,
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : appearanceValue,
            isDisabled: (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? isStartSprintButtonDisabled || !canEditSprint : isStartSprintButtonDisabled,
            shouldShowDisabledButtonHelper: !canEditSprint,
            ref: startSprintButtonNudgeRef,
            // Missing on original implementation
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            redirectTo: ""
        }, formatMessage((0, $kykx0.default).startSprint));
        const possiblyNudgeWrappedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: isFirstList,
            Wrapper: (0, $ayaAN.BacklogStartSprintNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, button));
        if ((0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? isStartSprintButtonDisabled && canEditSprint : isStartSprintButtonDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: totalCardAmount === 0 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kykx0.default).disabledStartSprintButtonEmptyIssueTermRefresh : (0, $kykx0.default).disabledStartSprintButtonEmpty) : formatMessage((0, $kykx0.default).disabledStartSprintButtonNoParallel)
        }, possiblyNudgeWrappedButton);
        return possiblyNudgeWrappedButton;
    };
    const renderCompleteSprintButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            Wrapper: (0, $emeAH.BacklogCompleteSprintNudgeAsync),
            conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw_perf_backlog_complete_sprint_button') ? nudgeStep === (0, $dbbf68c32d8c4308$export$63b61f654ce3da3d) : true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bs6dR.default), {
            sprintId: cardListId,
            // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
            testId: "software-backlog.card-list.card-list-header.sprint-header.complete-sprint-button",
            isDisabled: isCompleteSprintButtonDisabled && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions')
        }, formatMessage((0, $kykx0.default).completeSprint)));
    // This test-id is being used for the Jira Software NextGen Sprint Lifecycle pollinator test
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        direction: "row",
        alignItems: "center",
        testId: "software-backlog.card-list.card-list-header.sprint-header.estimations-and-actions-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2dBGm.default), {
        cardListId: cardListId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $b1fc2d85299762af$var$cardMenuActionsStyles
    }, isStartSprintButtonVisible && renderStartSprintButton(), isCompleteSprintButtonVisible && renderCompleteSprintButton(), isSprintMenuVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkjgs.default), {
        cardListId: cardListId,
        cardListType: type,
        cardListName: listName
    })));
};
const $b1fc2d85299762af$var$cardMenuActionsStyles = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.100',
    ':empty': {
        display: 'none'
    }
});

});
parcelRegister("bs6dR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c891abf9152dbab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jj52j = parcelRequire("jj52j");
var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $hZ1SC = parcelRequire("hZ1SC");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $dAfqg = parcelRequire("dAfqg");

var $bOsIL = parcelRequire("bOsIL");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");


var $guzeq = parcelRequire("guzeq");

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $3lZ6i = parcelRequire("3lZ6i");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $elctU = parcelRequire("elctU");

var $5uuHQ = parcelRequire("5uuHQ");
const $0c891abf9152dbab$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.complete-sprint-button.a11y-helper-text';
const $0c891abf9152dbab$var$CompleteSprintButton = ({ children: children, sprintId: sprintId, testId: testId, theme: theme, isDisabled: isDisabled })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const jiraProjectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: String(project?.projectId)
    });
    const sourceIssueNo = (0, $c1MAf.useBacklogSelector)((0, $dGljH.cardsSelector)).length;
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const boardIdAri = (0, $dXq4S.createAri)({
        cloudId: cloudId,
        resourceId: String(boardId),
        resourceOwner: 'jira-software',
        resourceType: 'board'
    });
    const sprintIdAri = (0, $dXq4S.createAri)({
        cloudId: cloudId,
        resourceId: sprintId,
        resourceOwner: 'jira-software',
        resourceType: 'sprint'
    });
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const showRetrosModal = (0, $hZ1SC.useShowCreateRetroOrCrossSellModal)();
    const onCompleted = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_SPRINT_COMPLETE)));
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), 'COMPLETE_SPRINT_MODAL_COMPLETE');
        showRetrosModal();
    }, [
        dispatch,
        showRetrosModal
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            jiraProjectAri: jiraProjectAri,
            // Date of 12 weeks ago as we want to fetch deployments date updated at most 12 weeks ago for deployments report nudge on sprint completion
            updatedFromDeploymentsDate: (0, $jj52j.default)((0, $it1wb.default)((0, $gn1v9.default)(Date.now(), {
                weeks: 12
            }))),
            boardId: boardIdAri,
            activeSprintIds: [
                sprintIdAri
            ],
            isCompanyManaged: isCompanyManaged
        }), [
        jiraProjectAri,
        boardIdAri,
        sprintIdAri,
        isCompanyManaged
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bOsIL.completeSprintModalEntryPoint), entryPointParams, (0, $8hVbJ.completeSprintModalLoad));
    const entryPointTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const props = (0, $5uXOq.useMemo)(()=>({
            analyticsSource: 'software-backlog',
            boardId: boardIdAri,
            onCompleted: onCompleted,
            sourceIssueNo: sourceIssueNo,
            sprintId: sprintId,
            onReady: stopMetric,
            isCompanyManaged: isCompanyManaged
        }), [
        boardIdAri,
        onCompleted,
        sourceIssueNo,
        sprintId,
        stopMetric,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDisabled && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), {
        isDisabled: true,
        helpTextId: $0c891abf9152dbab$var$A11Y_HELPER_TEXT_ID,
        helpText: formatMessage((0, $5uuHQ.messages).completeSprintButtonDisabledInfoTextNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ref: entryPointTriggerRef,
        ...!theme && (0, $dCm1o.isVisualRefreshEnabled)() ? {} : {
            theme: theme
        },
        testId: testId,
        isDisabled: isDisabled,
        "aria-describedby": $0c891abf9152dbab$var$A11Y_HELPER_TEXT_ID,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ref: entryPointTriggerRef,
        ...!theme && (0, $dCm1o.isVisualRefreshEnabled)() ? {} : {
            theme: theme
        },
        testId: testId,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "complete-sprint-modal",
        teamName: "a4t-pandora",
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c),
        entryPointActions: entryPointActions,
        runtimeProps: props
    }));
};
var $0c891abf9152dbab$export$2e2bcd8739ae039 = $0c891abf9152dbab$var$CompleteSprintButton;

});
parcelRegister("hZ1SC", function(module, exports) {

$parcel$export(module.exports, "useShowCreateRetroOrCrossSellModal", () => $b6bc1441fa7da9d1$export$3918442dc3bc3c6b);

var $5uXOq = parcelRequire("5uXOq");

var $cyA39 = parcelRequire("cyA39");

var $hqBSi = parcelRequire("hqBSi");

var $84Uym = parcelRequire("84Uym");

var $9LoyA = parcelRequire("9LoyA");
const $b6bc1441fa7da9d1$export$3918442dc3bc3c6b = ()=>{
    const isCrossflowFFEnabled = (0, $84Uym.isCompleteSprintCrossFlowEnabled)();
    const isCrossjoinFFEnabled = (0, $84Uym.isCompleteSprintCrossJoinEnabled)();
    const [retrosState, retrosActions] = (0, $9LoyA.useRetros)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { hasAccess: hasAccess } = (0, $cyA39.useUserHasConfluenceAccess)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!retrosState.shouldCreateRetro) return;
        let action = retrosActions.setLoadCreateRetroModal;
        if (isCrossflowFFEnabled && isCrossjoinFFEnabled) {
            if (!licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
            else if (!hasAccess) action = retrosActions.setLoadCrossJoinModal;
        } else if (isCrossflowFFEnabled && !licensedProducts.confluence) action = retrosActions.setLoadCrossFlowModal;
        else if (isCrossjoinFFEnabled && licensedProducts.confluence && !hasAccess) action = retrosActions.setLoadCrossJoinModal;
        action(true);
    }, [
        isCrossflowFFEnabled,
        isCrossjoinFFEnabled,
        licensedProducts,
        hasAccess,
        retrosState.shouldCreateRetro,
        retrosActions
    ]);
};

});
parcelRegister("cyA39", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $e1d1047ca6c0e736$export$bddce71054147149);

var $5uXOq = parcelRequire("5uXOq");

var $eNf8a = parcelRequire("eNf8a");

var $imVeH = parcelRequire("imVeH");

var $jcw0u = parcelRequire("jcw0u");

var $9OXo1 = parcelRequire("9OXo1");

var $9KYrx = parcelRequire("9KYrx");

var $cu7Vs = parcelRequire("cu7Vs");

var $cpyFY = parcelRequire("cpyFY");

var $8o1o1 = parcelRequire("8o1o1");
const $e1d1047ca6c0e736$var$TIME_TO_LIVE = 1800000; // 30 minutes
const $e1d1047ca6c0e736$var$storage = (0, $eNf8a.createSessionStorageProvider)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $e1d1047ca6c0e736$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const fireAnalyticsEvent = (0, $8o1o1.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $5uXOq.useState)(false);
    const permitted = (0, $5uXOq.useMemo)(()=>(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = tenantHasConfluence ? await (0, $cu7Vs.fetchConfluenceUserPermissions)(cloudId) : {
                permitted: false
            };
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        tenantHasConfluence
    ]);
    const refetchHasAccess = (0, $5uXOq.useCallback)(async ()=>{
        (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        if (!(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)) (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        if (!(0, $cpyFY.isStorageKeyExpired)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage) && permitted !== undefined) setHasAccess(permitted);
        else if (cloudId) getConfluencePermissions();
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cu7Vs", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $c0391b42dbea5292$export$e1aee708fe0c56c2);

var $7f4tk = parcelRequire("7f4tk");
const $c0391b42dbea5292$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = await (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("cpyFY", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $bcceba29d01fe1ab$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $bcceba29d01fe1ab$export$59dd918a314efec0);
$parcel$export(module.exports, "clearSessionStorageData", () => $bcceba29d01fe1ab$export$47001de47bd4a961);
const $bcceba29d01fe1ab$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $bcceba29d01fe1ab$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $bcceba29d01fe1ab$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $bcceba29d01fe1ab$export$59dd918a314efec0 = (key, storage)=>{
    if (!$bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $bcceba29d01fe1ab$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("8o1o1", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $66febf67b379b5c1$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $95EVP = parcelRequire("95EVP");

var $9OXo1 = parcelRequire("9OXo1");

var $j8Srb = parcelRequire("j8Srb");
const $66febf67b379b5c1$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $66febf67b379b5c1$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $66febf67b379b5c1$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $j8Srb.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("j8Srb", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $da71518e42bc9539$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $da71518e42bc9539$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



parcelRegister("84Uym", function(module, exports) {

$parcel$export(module.exports, "isCompleteSprintCrossFlowEnabled", () => $141b2b7a8812be56$export$85fbb2a414949eea);
$parcel$export(module.exports, "fireCompleteSprintCrossFlowExposureEventWhenEnrolled", () => $141b2b7a8812be56$export$f304ef0c9d0114d6);
$parcel$export(module.exports, "isCompleteSprintCrossJoinEnabled", () => $141b2b7a8812be56$export$80ecf97fd1ddd003);
$parcel$export(module.exports, "fireCompleteSprintCrossJoinExposureEventWhenEnrolled", () => $141b2b7a8812be56$export$4c5f2c8aff3c3599);

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $8zOmE = parcelRequire("8zOmE");
const $141b2b7a8812be56$export$69932781b42dd805 = 'jsw_sprint_completion_retro_cross_flow';
const $141b2b7a8812be56$export$6ae71ceef72281af = 'conf_jira_sprint_completion_cross_join_exp';
const $141b2b7a8812be56$export$3d370c33621572df = 'cohort';
const $141b2b7a8812be56$export$8ea6555e3e46f620 = 'not-enrolled';
const $141b2b7a8812be56$export$e9cae393a0b9eb85 = 'experiment';
const $141b2b7a8812be56$export$b3ba2b75eab4739d = 'control';
const $141b2b7a8812be56$export$85fbb2a414949eea = ()=>{
    const [completeSprintCrossFlowConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    return (0, $co1wz.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620) === $141b2b7a8812be56$export$e9cae393a0b9eb85;
};
const $141b2b7a8812be56$export$f304ef0c9d0114d6 = (createAnalyticsEvent)=>{
    const [completeSprintCrossFlowConfig, completeSprintCrossFlowFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_sprint_completion_retro_cross_flow');
    const completeSprintCrossFlowExperimentValue = completeSprintCrossFlowConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620);
    if ((0, $co1wz.ff)('sprint-completion-cross-flow') && completeSprintCrossFlowExperimentValue !== $141b2b7a8812be56$export$8ea6555e3e46f620) {
        completeSprintCrossFlowFireExposure();
        // manually fire for Socrates
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $141b2b7a8812be56$export$69932781b42dd805,
            value: completeSprintCrossFlowExperimentValue,
            growthInitiative: 'cross-flow'
        });
    }
};
const $141b2b7a8812be56$export$80ecf97fd1ddd003 = ()=>{
    const [completeSprintCrossJoinConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    return completeSprintCrossJoinConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620) === $141b2b7a8812be56$export$e9cae393a0b9eb85;
};
const $141b2b7a8812be56$export$4c5f2c8aff3c3599 = (createAnalyticsEvent)=>{
    const [completeSprintCrossJoinConfig, completeSprintCrossJoinFireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('conf_jira_sprint_completion_cross_join_exp');
    const completeSprintCrossJoinExperimentValue = completeSprintCrossJoinConfig.get($141b2b7a8812be56$export$3d370c33621572df, $141b2b7a8812be56$export$8ea6555e3e46f620);
    if (completeSprintCrossJoinExperimentValue !== $141b2b7a8812be56$export$8ea6555e3e46f620) {
        completeSprintCrossJoinFireExposure();
        // manually fire for Socrates
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: $141b2b7a8812be56$export$6ae71ceef72281af,
            value: completeSprintCrossJoinExperimentValue,
            growthInitiative: 'cross-join'
        });
    }
};

});

parcelRegister("9LoyA", function(module, exports) {

$parcel$export(module.exports, "useRetros", () => $27c0746d7d3517fa$export$70e27f56232e4ea8);

var $7JoAD = parcelRequire("7JoAD");

var $bkZLr = parcelRequire("bkZLr");

var $c85ZN = parcelRequire("c85ZN");

const $27c0746d7d3517fa$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    initialState: $c85ZN.initialState,
    actions: $bkZLr.default,
    name: 'create-retros'
});
const $27c0746d7d3517fa$export$70e27f56232e4ea8 = (0, $7JoAD.createHook)($27c0746d7d3517fa$export$390f32400eaf98c9);

});
parcelRegister("bkZLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $48222d4aa85b1c99$export$2e2bcd8739ae039);

var $8LQ84 = parcelRequire("8LQ84");

var $1QOns = parcelRequire("1QOns");

var $agVdz = parcelRequire("agVdz");

var $jJZqs = parcelRequire("jJZqs");

var $42TYq = parcelRequire("42TYq");

var $b7gdg = parcelRequire("b7gdg");

var $c85ZN = parcelRequire("c85ZN");
const $48222d4aa85b1c99$var$resetState = ()=>({ setState: setState })=>{
        setState((0, $c85ZN.initialState));
    };
const $48222d4aa85b1c99$var$resetCreatedData = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            createRetroPage: (0, $c85ZN.initialState).createRetroPage,
            createWhiteboard: (0, $c85ZN.initialState).createWhiteboard
        });
    };
const $48222d4aa85b1c99$var$setSprintId = (sprintId)=>({ setState: setState })=>{
        setState({
            sprintId: sprintId
        });
    };
const $48222d4aa85b1c99$var$setShouldCreateRetro = (shouldCreateRetro)=>({ setState: setState })=>{
        setState({
            shouldCreateRetro: shouldCreateRetro
        });
    };
const $48222d4aa85b1c99$var$setLoadCreateRetroModal = (loadCreateRetroModal)=>({ setState: setState })=>{
        setState({
            loadCreateRetroModal: loadCreateRetroModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossFlowModal = (loadCrossFlowModal)=>({ setState: setState })=>{
        setState({
            loadCrossFlowModal: loadCrossFlowModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossJoinModal = (loadCrossJoinModal)=>({ setState: setState })=>{
        setState({
            loadCrossJoinModal: loadCrossJoinModal
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinked = (isRetroLinked)=>({ setState: setState })=>{
        setState({
            isRetroLinked: isRetroLinked
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinking = (isRetroLinking)=>({ setState: setState })=>{
        setState({
            isRetroLinking: isRetroLinking
        });
    };
const $48222d4aa85b1c99$var$setRetroLinkingError = (retroLinkingError)=>({ setState: setState })=>{
        setState({
            retroLinkingError: retroLinkingError
        });
    };
const $48222d4aa85b1c99$var$setIsRetroPublished = (isRetroPublished)=>({ setState: setState })=>{
        setState({
            isRetroPublished: isRetroPublished
        });
    };
const $48222d4aa85b1c99$var$setConfluenceData = (data)=>({ getState: getState, setState: setState })=>{
        const { confluenceData: confluenceData } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...data
            }
        });
    };
const $48222d4aa85b1c99$var$setRetroType = (retroType)=>({ setState: setState })=>{
        setState({
            retroType: retroType
        });
    };
const $48222d4aa85b1c99$var$createRetroPage = (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createRetroPage: {
                ...state.createRetroPage,
                loading: true,
                error: undefined
            }
        });
        try {
            const retroPage = await (0, $42TYq.createRetro)(cloudId, spaceKey, parentPageId, sprintId, blueprintId);
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    data: retroPage
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    error: error
                }
            });
        }
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsError = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(error) && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(e) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.title) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.code));
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled = async (error)=>{
    if (!(error instanceof (0, $jJZqs.default) && error.originalResponse)) return false;
    const errorResponse = await error.originalResponse.json();
    // Check for title until more specific error code is available (CBT-3079)
    return $48222d4aa85b1c99$var$isConfluenceWhiteboardsError(errorResponse) && errorResponse.errors[0].title === 'Whiteboards are not enabled';
};
const $48222d4aa85b1c99$var$createRetroWhiteboard = (cloudId, spaceId, parentId, templateKey)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createWhiteboard: {
                ...state.createWhiteboard,
                loading: true,
                error: undefined
            }
        });
        try {
            const whiteboard = await (0, $b7gdg.createWhiteboard)(cloudId, spaceId, parentId, templateKey);
            setState({
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    data: whiteboard
                }
            });
        } catch (error) {
            setState({
                isWhiteboardsDisabled: state.isWhiteboardsDisabled || await $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled(error),
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    error: error instanceof Error ? error : undefined
                }
            });
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48222d4aa85b1c99$export$2e2bcd8739ae039 = {
    resetState: $48222d4aa85b1c99$var$resetState,
    resetCreatedData: $48222d4aa85b1c99$var$resetCreatedData,
    setSprintId: $48222d4aa85b1c99$var$setSprintId,
    setShouldCreateRetro: $48222d4aa85b1c99$var$setShouldCreateRetro,
    setLoadCreateRetroModal: $48222d4aa85b1c99$var$setLoadCreateRetroModal,
    setLoadCrossFlowModal: $48222d4aa85b1c99$var$setLoadCrossFlowModal,
    setLoadCrossJoinModal: $48222d4aa85b1c99$var$setLoadCrossJoinModal,
    setIsRetroLinked: $48222d4aa85b1c99$var$setIsRetroLinked,
    setIsRetroLinking: $48222d4aa85b1c99$var$setIsRetroLinking,
    setRetroLinkingError: $48222d4aa85b1c99$var$setRetroLinkingError,
    setIsRetroPublished: $48222d4aa85b1c99$var$setIsRetroPublished,
    setConfluenceData: $48222d4aa85b1c99$var$setConfluenceData,
    createRetroPage: $48222d4aa85b1c99$var$createRetroPage,
    setRetroType: $48222d4aa85b1c99$var$setRetroType,
    createRetroWhiteboard: $48222d4aa85b1c99$var$createRetroWhiteboard
};

});
parcelRegister("42TYq", function(module, exports) {

$parcel$export(module.exports, "createRetro", () => $f4242736fa792950$export$a63913da797715a6);

var $7f4tk = parcelRequire("7f4tk");


var $cYuHt = parcelRequire("cYuHt");
const $f4242736fa792950$export$a63913da797715a6 = async (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>{
    const [sprint] = await Promise.all([
        (0, $cYuHt.getSprint)(sprintId)
    ]);
    const title = `Retrospective: ${sprint.name}`;
    if (!blueprintId) throw new Error('User attempted to create a Confluence page retro, but no retro blueprint was found');
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${(0, $63b79f4ff36af7f3$export$48a96ef844462313)}/instance`, {
        method: 'POST',
        body: JSON.stringify({
            content: {
                type: 'page',
                title: title,
                status: 'draft',
                ancestors: parentPageId ? [
                    {
                        id: parentPageId
                    }
                ] : undefined,
                space: {
                    key: spaceKey
                },
                // these values are required to create an NCS page
                metadata: {
                    properties: {
                        editor: {
                            value: 'v2'
                        }
                    },
                    frontend: {
                        embedded: true
                    }
                }
            },
            contentBlueprintSpec: {
                context: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId
                },
                blueprintId: blueprintId
            }
        })
    });
};

});
const $63b79f4ff36af7f3$export$48a96ef844462313 = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';

parcelRegister("cYuHt", function(module, exports) {

$parcel$export(module.exports, "getSprint", () => $28d2a59892eb2d5b$export$4402d4ed26f26131);

var $7f4tk = parcelRequire("7f4tk");
const $28d2a59892eb2d5b$export$4402d4ed26f26131 = async (sprintId)=>(0, $7f4tk.default)(`/rest/agile/1.0/sprint/${sprintId}`);

});


parcelRegister("b7gdg", function(module, exports) {

$parcel$export(module.exports, "createWhiteboard", () => $ed7d58a2374be2eb$export$36ce0aac6b5c6804);

var $7f4tk = parcelRequire("7f4tk");
const $ed7d58a2374be2eb$export$36ce0aac6b5c6804 = async (cloudId, spaceId, parentId, templateKey)=>(0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/whiteboards`, {
        method: 'POST',
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: parentId || null,
            templateKey: templateKey
        })
    });

});

parcelRegister("c85ZN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c4ef19a54ae6936a$export$d4c72bab9d6cc13a);

var $kGefV = parcelRequire("kGefV");
const $c4ef19a54ae6936a$export$d4c72bab9d6cc13a = {
    sprintId: undefined,
    shouldCreateRetro: false,
    loadCreateRetroModal: false,
    loadCrossFlowModal: false,
    loadCrossJoinModal: false,
    isRetroLinked: false,
    isRetroLinking: false,
    isRetroPublished: false,
    isWhiteboardsDisabled: false,
    retroLinkingError: undefined,
    retroType: (0, $kGefV.RetroTypes).WHITEBOARD,
    confluenceData: {
        spaceKey: undefined,
        parentPageId: undefined,
        spaceId: undefined
    },
    createRetroPage: {
        data: undefined,
        loading: false,
        error: undefined
    },
    createWhiteboard: {
        data: undefined,
        loading: false,
        error: undefined
    }
};

});
parcelRegister("kGefV", function(module, exports) {

$parcel$export(module.exports, "RetroTypes", () => $030b4200896d24ad$export$1da38a077679bab0);
const $030b4200896d24ad$export$1da38a077679bab0 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};

});





parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions), shouldFocusBackOnSecondMount = false)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    const isNotFirstMount = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
            if (shouldFocusBackOnSecondMount && isNotFirstMount.current && (0, $4R6GH.fg)('jsc_create_bar_refresh')) element.focus();
        } else {
            removePreviousListeners.current = null;
            isNotFirstMount.current = true;
        }
    }, [
        eventMap,
        isActive,
        shouldFocusBackOnSecondMount
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("ivDCs", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d);

var $5uXOq = parcelRequire("5uXOq");

var $lkDqR = parcelRequire("lkDqR");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $832a9e21b9f9d7ff$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("bOsIL", function(module, exports) {

$parcel$export(module.exports, "completeSprintModalEntryPoint", () => $da8db933301c2e65$export$e19f219885fe8c5f);

var $j4C5v = parcelRequire("j4C5v");

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $da8db933301c2e65$export$e19f219885fe8c5f = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("61yxy")), {
        moduleId: "3d417b0d"
    }),
    getPreloadProps: ({ jiraProjectAri: jiraProjectAri, updatedFromDeploymentsDate: updatedFromDeploymentsDate, boardId: boardId, activeSprintIds: activeSprintIds })=>({
            queries: {
                completeSprintMetadata: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $j4C5v.default,
                    variables: {
                        jiraProjectAri: jiraProjectAri,
                        updatedFromDeploymentsDate: updatedFromDeploymentsDate,
                        boardId: boardId,
                        activeSprintIds: activeSprintIds
                    }
                }
            }
        })
});

});
parcelRegister("j4C5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc3007e99f5743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fa8139ab68de2adaf65c8eae3998ecd>>
 * @relayHash ea4312ab52f27e8938047934d2f94d9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05
const $65bc3007e99f5743$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7136bf3a8b621191f5688b40ac28c430f5e6237f2ebcb6fea7a09680f67dff05",
        "metadata": {},
        "name": "mainCompleteSprintMetadataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $65bc3007e99f5743$export$2e2bcd8739ae039 = $65bc3007e99f5743$var$node;

});

parcelRegister("61yxy", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("1XW3O")
]).then(()=>parcelRequire('4gPTd'));

});


parcelRegister("5uuHQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $65bcf76e448f989c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $65bcf76e448f989c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    completeSprintButtonDisabledInfoTextNonFinal: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-text-non-final",
        "defaultMessage": "Request permissions from board admin"
    }
});

});


parcelRegister("2dBGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45258e61f7660708$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $kwBUh = parcelRequire("kwBUh");

var $45Qwd = parcelRequire("45Qwd");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $dZ8RF = parcelRequire("dZ8RF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45258e61f7660708$export$2e2bcd8739ae039 = ({ cardListId: cardListId })=>{
    const columns = (0, $c1MAf.useBacklogSelector)((0, $kwBUh.getColumns));
    const estimations = (0, $c1MAf.useBacklogSelector)((state)=>columns !== null ? (0, $k35me.makeGetSprintEstimations)(state)(cardListId) : null);
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const estimationName = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationName));
    const totalEstimations = estimations ? Object.values(estimations).reduce((a, b)=>a + b, 0) : 0;
    const cardOrder = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getOrderedCardIdsByCardListId));
    const totalCards = cardOrder[cardListId]?.length ?? 0;
    const columnCounts = isCompanyManaged ? (0, $kwBUh.getColumnCount)(columns) : undefined;
    const props = {
        estimations: estimations,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        isCompanyManaged: isCompanyManaged,
        estimationName: estimationName,
        totalEstimations: totalEstimations,
        totalCards: totalCards,
        columnCounts: columnCounts
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZ8RF.Estimations), props);
};

});
parcelRegister("dZ8RF", function(module, exports) {

$parcel$export(module.exports, "Estimations", () => $34324323f3a3472b$export$df255ecd06d2abc3);

var $5uXOq = parcelRequire("5uXOq");

var $1m92z = parcelRequire("1m92z");


var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $dCm1o = parcelRequire("dCm1o");

var $2hYGi = parcelRequire("2hYGi");

var $cL3Uo = parcelRequire("cL3Uo");

var $guzeq = parcelRequire("guzeq");


var $3KA8f = parcelRequire("3KA8f");

var $6hYI0 = parcelRequire("6hYI0");
const $34324323f3a3472b$export$df255ecd06d2abc3 = ({ estimations: estimations, estimationType: estimationType, timeTrackingOptions: timeTrackingOptions, isCompanyManaged: isCompanyManaged, estimationName: estimationName, totalEstimations: totalEstimations, totalCards: totalCards, columnCounts: columnCounts, tooltipDelay: tooltipDelay })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatStoryPointsTotal = (0, $cL3Uo.useFormatStoryPointsTotal)();
    const formatEstimationValue = (value)=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        // fix for floating point math issues (like 0.1 + 0.2 becomes 0.30000000000000004)
        // as the numbers end with lots of zeroes followed by a single digit, trimming
        // after 8 decimal points results in a sane representation
        return formatStoryPointsTotal(value);
    };
    const getTotal = ()=>{
        if (estimationType === (0, $guzeq.ORIGINAL_ESTIMATE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $etKNj.timeTrackingFormatter)(totalEstimations, timeTrackingOptions, {
            formatMessage: formatMessage
        });
        return formatEstimationValue(estimationType === (0, $guzeq.STORY_POINTS) ? totalEstimations : totalCards);
    };
    const makeStatusWithoutDescription = (statusMessage, estimationFormatted, total, tooltipTarget)=>`${formatMessage(statusMessage)}: ${formatMessage((0, $6hYI0.default).tooltip, {
            count: estimationFormatted,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
    const makeTooltipContent = (statusMessage, total, tooltipTarget, estimationCount, statusDescription)=>{
        if (isCompanyManaged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1m92z.default), {
            as: "strong",
            color: "color.text.inverse"
        }, formatMessage(statusMessage)), statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), formatMessage((0, $6hYI0.default).tooltip, {
            count: estimationCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        }));
        return makeStatusWithoutDescription(statusMessage, estimationCount, total, tooltipTarget);
    };
    const makeScreenReaderMessage = (statusMessage, total, tooltipTarget, estimateCount, statusDescription)=>{
        if (isCompanyManaged) return `${formatMessage(statusMessage)}${statusDescription ? ` (${formatMessage(statusDescription.statusDescriptionMessage, {
            ...statusDescription.statusDescriptionMessageParams
        })})` : ''}: ${formatMessage((0, $6hYI0.default).tooltip, {
            count: estimateCount,
            total: total,
            estimationName: (isCompanyManaged && estimationName && estimationName !== (0, $7aa9ed31c5ab3869$export$2c9ef5d2c18593f7) ? estimationName : tooltipTarget).toLowerCase()
        })}`;
        return makeStatusWithoutDescription(statusMessage, estimateCount, total, tooltipTarget);
    };
    const formatEstimation = (estimationValue)=>{
        const value = estimationValue || 0;
        return estimationType === (0, $guzeq.ORIGINAL_ESTIMATE) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $etKNj.timeTrackingFormatter)(value, timeTrackingOptions, {
            formatMessage: formatMessage
        }) : formatEstimationValue(value);
    };
    const makeTooltipContentForEstimationGroups = ()=>{
        const { inProgressColumnCount: inProgressColumnCount } = columnCounts || {};
        const showStatusDescriptionForNotStartedAndDone = inProgressColumnCount && inProgressColumnCount > 0;
        const notStarted = {
            status: isCompanyManaged ? (0, $6hYI0.default).notStartedV2 : (0, $6hYI0.default).notStarted,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $6hYI0.default).leftmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.NOT_STARTED)
        };
        const inProgress = {
            status: isCompanyManaged ? (0, $6hYI0.default).inProgressV2 : (0, $6hYI0.default).inProgress,
            statusDescription: undefined,
            estimationValue: formatEstimation(estimations?.IN_PROGRESS)
        };
        const done = {
            status: isCompanyManaged ? (0, $6hYI0.default).completed : (0, $6hYI0.default).done,
            statusDescription: isCompanyManaged && showStatusDescriptionForNotStartedAndDone ? {
                message: (0, $6hYI0.default).rightmostColumn
            } : undefined,
            estimationValue: formatEstimation(estimations?.DONE)
        };
        const tooltipTypes = Object.freeze({
            [(0, $guzeq.ORIGINAL_ESTIMATE)]: (0, $6hYI0.default).originalEstimate,
            [(0, $guzeq.STORY_POINTS)]: (0, $6hYI0.default).storyPoints,
            [(0, $guzeq.ISSUE_COUNT)]: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6hYI0.default).issueCountIssueTermRefresh : (0, $6hYI0.default).issueCount
        });
        const tooltipTarget = formatMessage(tooltipTypes[estimationType] || ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6hYI0.default).issueCountIssueTermRefresh : (0, $6hYI0.default).issueCount));
        const total = getTotal();
        return {
            notStarted: notStarted,
            inProgress: inProgress,
            done: done,
            tooltipTarget: tooltipTarget,
            total: total
        };
    };
    if (estimations) {
        const { notStarted: notStarted, inProgress: inProgress, done: done, tooltipTarget: tooltipTarget, total: total } = makeTooltipContentForEstimationGroups();
        const { inProgressColumnCount: inProgressColumnCount, doneColumnCount: doneColumnCount } = columnCounts || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            appearance: "default",
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(notStarted.status, total, tooltipTarget, notStarted.estimationValue, notStarted.statusDescription ? {
                statusDescriptionMessage: notStarted.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.NOT_STARTED)), (inProgressColumnCount && inProgressColumnCount > 0 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: `var(--ds-border-information, ${(0, $5e0c0d4e15efb4a6$exports).B400})`
            },
            appearance: "primary",
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(inProgress.status, total, tooltipTarget, inProgress.estimationValue, undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(inProgress.status, total, tooltipTarget, inProgress.estimationValue, inProgress.statusDescription)
        }, formatEstimationValue(estimations.IN_PROGRESS)), (doneColumnCount && doneColumnCount === 1 || !isCompanyManaged) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KA8f.default), {
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'added' : undefined,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: `var(--ds-border-success, ${(0, $5e0c0d4e15efb4a6$exports).G300})`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                color: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$exports).N0})`
            },
            max: (0, $guzeq.ESTIMATION_ROLLUP_BADGE_MAX),
            tooltipContent: makeTooltipContent(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined),
            tooltipDelay: tooltipDelay,
            screenReaderMessage: makeScreenReaderMessage(done.status, total, tooltipTarget, done.estimationValue, done.statusDescription ? {
                statusDescriptionMessage: done.statusDescription.message
            } : undefined)
        }, formatEstimationValue(estimations.DONE)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2hYGi.default), {
        name: "estimations"
    }, null);
};

});
parcelRegister("3KA8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $001bc48f35c4b5ee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fW62l = parcelRequire("fW62l");

var $bxhgD = parcelRequire("bxhgD");

var $MGmIU = parcelRequire("MGmIU");

var $dCm1o = parcelRequire("dCm1o");
const $001bc48f35c4b5ee$var$EstimationsBadge = ({ appearance: appearance, style: style, children: children, max: max, screenReaderMessage: screenReaderMessage, tooltipContent: tooltipContent, tooltipDelay: tooltipDelay })=>{
    const [active, setActive] = (0, $5uXOq.useState)(false);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setActive(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setActive(false);
    }, []);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
            event.preventDefault();
            setActive((prev)=>!prev);
        }
    }, []);
    const tooltipMessage = active ? tooltipContent : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: tooltipMessage,
        delay: tooltipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($001bc48f35c4b5ee$var$EstimationBadgeWrapper, {
        // @ts-expect-error tabIndex should be a number
        tabIndex: "0",
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseLeave: onBlur,
        onMouseEnter: onFocus,
        onKeyDown: onKeyDown,
        "aria-label": screenReaderMessage,
        "data-testid": "software-backlog.card-list.estimations.badge.estimation-badge-wrapper"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: appearance,
        max: max
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: appearance,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        max: max
    }, children)));
};
var $001bc48f35c4b5ee$export$2e2bcd8739ae039 = $001bc48f35c4b5ee$var$EstimationsBadge;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $001bc48f35c4b5ee$var$EstimationBadgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _k48p8n31",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6hYI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4174f9cf4973f96d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4174f9cf4973f96d$var$messages = (0, $7VHMR.defineMessages)({
    notStarted: {
        "id": "backlog.card-list.estimations.not-started",
        "defaultMessage": "To Do"
    },
    inProgress: {
        "id": "backlog.card-list.estimations.in-progress",
        "defaultMessage": "In Progress"
    },
    done: {
        "id": "backlog.card-list.estimations.done",
        "defaultMessage": "Done"
    },
    notStartedV2: {
        "id": "backlog.card-list.estimations.not-started-v-2",
        "defaultMessage": "Not started"
    },
    inProgressV2: {
        "id": "backlog.card-list.estimations.in-progress-v-2",
        "defaultMessage": "In progress"
    },
    completed: {
        "id": "backlog.card-list.estimations.completed",
        "defaultMessage": "Completed"
    },
    tooltip: {
        "id": "backlog.card-list.estimations.tooltip",
        "defaultMessage": "{count} of {total} ({estimationName})"
    },
    storyPoints: {
        "id": "backlog.card-list.estimations.story-points",
        "defaultMessage": "Story points"
    },
    originalEstimate: {
        "id": "backlog.card-list.estimations.original-estimate",
        "defaultMessage": "Original estimate"
    },
    issueCount: {
        "id": "backlog.card-list.estimations.issue-count",
        "defaultMessage": "Issue count"
    },
    leftmostColumn: {
        "id": "backlog.card-list.estimations.leftmost-column",
        "defaultMessage": "leftmost column"
    },
    rightmostColumn: {
        "id": "backlog.card-list.estimations.rightmost-column",
        "defaultMessage": "rightmost column"
    },
    issueCountIssueTermRefresh: {
        "id": "backlog.card-list.estimations.issue-count-issue-term-refresh",
        "defaultMessage": "Issue count"
    }
});
var $4174f9cf4973f96d$export$2e2bcd8739ae039 = $4174f9cf4973f96d$var$messages;

});



parcelRegister("hkjgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $137da169bccf5172$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8GVAj = parcelRequire("8GVAj");

var $e0OK7 = parcelRequire("e0OK7");

var $8Agsd = parcelRequire("8Agsd");
var $feGGA = parcelRequire("feGGA");

var $k9ymy = parcelRequire("k9ymy");

var $7ZfjH = parcelRequire("7ZfjH");

var $9T1wg = parcelRequire("9T1wg");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2HbP2 = parcelRequire("2HbP2");

var $lXAdy = parcelRequire("lXAdy");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $5L7z2 = parcelRequire("5L7z2");

var $cYsq9 = parcelRequire("cYsq9");

var $lu5k0 = parcelRequire("lu5k0");

var $dCm1o = parcelRequire("dCm1o");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $dkxyn = parcelRequire("dkxyn");

var $dGljH = parcelRequire("dGljH");

var $k35me = parcelRequire("k35me");

var $fSgHa = parcelRequire("fSgHa");

var $93II4 = parcelRequire("93II4");

var $2F0OA = parcelRequire("2F0OA");

var $gTtxS = parcelRequire("gTtxS");

var $kseO3 = parcelRequire("kseO3");
const $137da169bccf5172$var$DropdownItemWithAnalytics = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $feGGA.default));
function $137da169bccf5172$export$2e2bcd8739ae039({ cardListId: cardListId, cardListName: cardListName, cardListType: cardListType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const element = (0, $5uXOq.useRef)(null);
    const [isEditSprintModalOpen, setIsEditSprintModalOpen] = (0, $5uXOq.useState)(false);
    const previousSprintId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeGetPreviousNotStartedSprintId)(state)(cardListId));
    const nextSprintId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeGetNextSprintId)(state)(cardListId));
    const firstInactiveSprintId = (0, $c1MAf.useBacklogSelector)((0, $k35me.getFirstInactiveSprintId));
    const lastInactiveSprintId = (0, $c1MAf.useBacklogSelector)((0, $k35me.getLastInactiveSprintId));
    const isCardListActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(cardListId));
    const sprint = (0, $c1MAf.useBacklogSelector)((state)=>cardListId ? (0, $dGljH.getCardLists)(state)[String(cardListId)] : null);
    const canMoveSprintUp = previousSprintId !== null;
    const canMoveSprintDown = !isCardListActiveSprint && nextSprintId !== null;
    const enabledMenuActions = cardListType !== (0, $guzeq.SPRINT) ? {} : {
        MOVE_SPRINT_TO_TOP: canMoveSprintUp,
        MOVE_SPRINT_UP: canMoveSprintUp,
        MOVE_SPRINT_DOWN: canMoveSprintDown,
        MOVE_SPRINT_TO_BOTTOM: canMoveSprintDown,
        EDIT_SPRINT: true,
        DELETE_SPRINT: true
    };
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const renderTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...props })=>{
        const handleRef = (refElement)=>{
            if (typeof triggerRef === 'function') triggerRef(refElement);
            if (refElement) element.current = refElement;
        };
        // TODO: remove this icon on visual-refresh cleanup
        const moreIcon = (0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZfjH))), {
            label: "More actions",
            color: "var(--ds-icon, #44546F)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))), {
            label: "More actions",
            primaryColor: "var(--ds-icon, #44546F)"
        });
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
            ...props,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9ymy))),
            label: formatMessage((0, $kseO3.default).menuTrigger, {
                sprintName: cardListName
            }),
            ref: handleRef,
            appearance: "subtle",
            testId: `software-backlog.card-list.sprints-menu.${cardListName}`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
            ...props,
            ref: handleRef,
            iconBefore: moreIcon,
            "aria-label": formatMessage((0, $kseO3.default).menuTrigger, {
                sprintName: cardListName
            }),
            theme: (0, $gTtxS.darkerButtonTheme),
            testId: `software-backlog.card-list.sprints-menu.${cardListName}`
        });
    }, [
        cardListName,
        formatMessage
    ]);
    const handleOpenChange = (0, $5uXOq.useCallback)(()=>setReturnFocusTo(element), [
        element,
        setReturnFocusTo
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            sprintId: cardListId,
            onClose: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
            }
        }), [
        cardListId,
        createAnalyticsEvent
    ]);
    const isVisible = enabledMenuActions && Object.keys(enabledMenuActions).length > 0;
    if (!isVisible) return null;
    const onMoveUp = (event, analyticsEvent)=>{
        if (previousSprintId != null && previousSprintId !== '') dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: previousSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_UP),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintUp');
    };
    const onMoveToTop = (event, analyticsEvent)=>{
        dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: firstInactiveSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_TO_TOP),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintToTop');
    };
    const onMoveDown = (event, analyticsEvent)=>{
        if (nextSprintId != null && nextSprintId !== '') dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: nextSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_DOWN),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintDown');
    };
    const onMoveToBottom = (event, analyticsEvent)=>{
        dispatch((0, $dkxyn.sprintMoveRequest)({
            sprintId: cardListId,
            targetSprintId: lastInactiveSprintId,
            direction: (0, $guzeq.SPRINT_MOVE_TO_BOTTOM),
            analyticsEvent: analyticsEvent
        }));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'moveSprintToBottom');
    };
    const onEditSprintClick = (event, analyticsEvent)=>{
        setIsEditSprintModalOpen(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openEditSprint');
        (0, $cYsq9.editSprintModalLoad).start();
    };
    const onEditSprintModalCloseClick = ()=>{
        setIsEditSprintModalOpen(false);
    };
    const menuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, enabledMenuActions.MOVE_SPRINT_TO_TOP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-top",
        onClick: onMoveToTop
    }, formatMessage((0, $kseO3.default).moveSprintToTop)), enabledMenuActions.MOVE_SPRINT_UP && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-up",
        onClick: onMoveUp
    }, formatMessage((0, $kseO3.default).moveSprintUp)), enabledMenuActions.MOVE_SPRINT_DOWN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-down",
        onClick: onMoveDown
    }, formatMessage((0, $kseO3.default).moveSprintDown)), enabledMenuActions.MOVE_SPRINT_TO_BOTTOM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-move-to-bottom",
        onClick: onMoveToBottom
    }, formatMessage((0, $kseO3.default).moveSprintToBottom)), enabledMenuActions.EDIT_SPRINT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($137da169bccf5172$var$DropdownItemWithAnalytics, {
        "data-testid": "software-backlog.card-list.sprints-menu.sprint-edit",
        onClick: onEditSprintClick
    }, formatMessage((0, $kseO3.default).editSprint)), enabledMenuActions.DELETE_SPRINT && sprint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        entryPoint: (0, $2F0OA.sprintDeleteModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "sprint-delete-modal",
        testId: "software-backlog.card-list.sprints-menu.sprint-delete",
        useInternalModal: false
    }, formatMessage((0, $kseO3.default).deleteSprint)), isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-move-actions"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-edit-action"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5L7z2.SprintActionsConnectMenuItems), {
        sprintId: cardListId,
        location: "sprint-delete-action"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, isEditSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $93II4.default), {
        cardListId: Number(cardListId),
        onClose: onEditSprintModalCloseClick,
        onSubmit: onEditSprintModalCloseClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
        onOpenChange: handleOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end",
        shouldRenderToParent: true,
        testId: "software-backlog.card-list.sprints-menu.dropdown-menu"
    }, menuItems)));
}

});
parcelRegister("k9ymy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eabf4da6794de083$var$_react = $eabf4da6794de083$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eabf4da6794de083$var$_showMoreHorizontal = $eabf4da6794de083$var$_interopRequireDefault((parcelRequire("7ZfjH")));

var $eabf4da6794de083$var$_more = $eabf4da6794de083$var$_interopRequireDefault((parcelRequire("9T1wg")));
function $eabf4da6794de083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eabf4da6794de083$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $eabf4da6794de083$var$_react.default.createElement($eabf4da6794de083$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $eabf4da6794de083$var$_more.default
    }, props));
$eabf4da6794de083$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $eabf4da6794de083$var$_default = module.exports.default = $eabf4da6794de083$var$ShowMoreHorizontalIcon;

});

parcelRegister("lXAdy", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointDropdownItemTrigger", () => $d1639b87be26e4ed$export$82b29db923c97084);

var $5uXOq = parcelRequire("5uXOq");

var $feGGA = parcelRequire("feGGA");

var $2KAtx = parcelRequire("2KAtx");
function $d1639b87be26e4ed$export$82b29db923c97084({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...dropdownProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        interactionName: interactionName,
        title: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feGGA.default), {
            ref: ref,
            ...dropdownProps
        }, children));
}

});
parcelRegister("2KAtx", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $a17c22dd70443cfd$export$defad645fcc21c0a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8STCT = parcelRequire("8STCT");

var $dOHxT = parcelRequire("dOHxT");
var $ezPyr = parcelRequire("ezPyr");
var $bvt08 = parcelRequire("bvt08");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");

var $iaTnv = parcelRequire("iaTnv");

var $9fuVs = parcelRequire("9fuVs");

var $c5vfY = parcelRequire("c5vfY");

var $gJdig = parcelRequire("gJdig");

var $fiv1r = parcelRequire("fiv1r");

var $7fk3R = parcelRequire("7fk3R");

var $dWBzX = parcelRequire("dWBzX");
const $a17c22dd70443cfd$var$emptyObject = {};
function $a17c22dd70443cfd$export$defad645fcc21c0a({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal }) {
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $gJdig.ModalContext));
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $7fk3R.default)(interactionName ?? '');
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaTnv.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8STCT.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8STCT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8STCT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8STCT.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                // @ts-expect-error Need to fix the types on this
                id: entryPoint.root.getModuleName?.() ?? 'unknown',
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                    onClose: onClose
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
                ...modalProps,
                onClose: onClose
            }, container)) : container;
        });
    }, [
        entryPoint,
        entryPointProps,
        errorAttributes,
        Fallback,
        openModal,
        title,
        modalProps,
        useInternalModal
    ]);
    const triggerRef = (0, $dWBzX.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    return children({
        ref: triggerRef
    });
}

});
parcelRegister("9fuVs", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $1dd87679d9ca363b$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $1dd87679d9ca363b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k4r7E = parcelRequire("k4r7E");
const $1dd87679d9ca363b$export$ebbb59327adb551a = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $k4r7E.rootRegistry));
const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $5uXOq.useMemo)(()=>new (0, $k4r7E.ShortcutRegistry)(), []);
    const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, $k4r7E.rootRegistry);
    (0, $5uXOq.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;

});
parcelRegister("k4r7E", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $a65fecdbaed23de2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $lbWm4 = parcelRequire("lbWm4");

var $561FV = parcelRequire("561FV");

var $hGgHi = parcelRequire("hGgHi");

var $FISJv = parcelRequire("FISJv");

var $lIZQG = parcelRequire("lIZQG");
const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $lIZQG.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $lIZQG.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $lIZQG.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();

});
parcelRegister("lIZQG", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $ca3344250c7b7406$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $ca3344250c7b7406$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $ca3344250c7b7406$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $ca3344250c7b7406$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $ca3344250c7b7406$var$toKey = (e)=>{
    if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("dWBzX", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $01294bc664dce1e5$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
            }, $01294bc664dce1e5$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});



parcelRegister("5L7z2", function(module, exports) {

$parcel$export(module.exports, "SprintActionsConnectMenuItems", () => $65eeeccb724af285$export$f9a25247020e32b7);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $2NYED = parcelRequire("2NYED");

var $fNWqR = parcelRequire("fNWqR");
const $65eeeccb724af285$var$SprintActionsConnectInner = ({ sprintId: sprintId, location: location })=>{
    const sprintActions = (0, $fNWqR.useFetchedSprintActions)({
        sprintId: sprintId
    });
    const targetActions = (0, $5uXOq.useMemo)(()=>sprintActions?.[sprintId]?.[location] ?? null, [
        sprintId,
        location,
        sprintActions
    ]);
    if (!sprintActions || !targetActions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetActions.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: item.id,
            subItem: item
        })));
};
function $65eeeccb724af285$export$f9a25247020e32b7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-sprint-actions-connect-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65eeeccb724af285$var$SprintActionsConnectInner, props));
}

});
parcelRegister("2NYED", function(module, exports) {

$parcel$export(module.exports, "BoardToolWebItemView", () => $d8e9f6c964974fcf$export$37f386501b29905e);
$parcel$export(module.exports, "BoardToolSubItem", () => $d8e9f6c964974fcf$export$dbbc4e042bbab47e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $89thI = parcelRequire("89thI");

var $8Agsd = parcelRequire("8Agsd");

var $hdlWZ = parcelRequire("hdlWZ");

var $cSFUi = parcelRequire("cSFUi");

var $6PItG = parcelRequire("6PItG");
var $jJ62p = parcelRequire("jJ62p");
var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $lm9d2 = parcelRequire("lm9d2");

var $MGmIU = parcelRequire("MGmIU");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $hPtZI = parcelRequire("hPtZI");
var $1iaoS = parcelRequire("1iaoS");

const $d8e9f6c964974fcf$export$87f324ad8d8a087a = (0, $hPtZI.lazy)(()=>(parcelRequire("599op")).then(({ BoardToolWebPanelView: BoardToolWebPanelView })=>({
            default: BoardToolWebPanelView
        })), {
    moduleId: "./src/packages/software/connect-toolbar/src/common/ui/tool-sections/board-tool-section-view/board-tool-sub-item/board-tool-web-panel-view/index.tsx"
});
function $d8e9f6c964974fcf$export$37f386501b29905e({ subItem: subItem, mode: mode = 'dropdown-item', onClickWebItem: onClickWebItem }) {
    const webItemLinkRef = (0, $5uXOq.useRef)(null);
    const handleOnClickWebItem = (e)=>{
        e.preventDefault();
        webItemLinkRef.current?.click();
        if (onClickWebItem) onClickWebItem();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, mode === 'dropdown-item' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? subItem.label : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ62p.default), {
        "data-testid": "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem,
        iconBefore: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hdlWZ))), {
            label: subItem.label,
            color: "var(--ds-icon, #44546F)"
        }) : undefined
    }, subItem.label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: handleOnClickWebItem
    }, subItem.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$var$HiddenLink, {
        ref: webItemLinkRef,
        href: subItem.url,
        className: subItem.cssClass ?? ''
    }, subItem.label));
}
function $d8e9f6c964974fcf$export$dbbc4e042bbab47e({ subItem: subItem, onClickWebItem: onClickWebItem }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (subItem.type === 'webItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$37f386501b29905e, {
        onClickWebItem: onClickWebItem,
        subItem: subItem
    });
    if (subItem.type === 'section') {
        const content = subItem.subItems?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$dbbc4e042bbab47e, {
                key: item.id,
                subItem: item
            }));
        if (subItem.label === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
        if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
                    content: subItem.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hdlWZ))), {
                        label: subItem.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.popup-menu-trigger"
                }, subItem.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7df7o.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), null, content))
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
            placement: "right-end",
            trigger: subItem.label,
            testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.dropdown-menu"
        }, content);
    }
    if (subItem.type === 'webPanel') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-tool-web-panel-view",
        packageName: "@atlassian/jira-software-connect-toolbar",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iaoS.LazySuspense), {
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$87f324ad8d8a087a, {
        webPanel: subItem
    })));
    return null;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d8e9f6c964974fcf$var$HiddenLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("599op", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("6LO0W").then(()=>parcelRequire('cvEOi'));

});


parcelRegister("fNWqR", function(module, exports) {

$parcel$export(module.exports, "useFetchedToolSections", () => $08c1f6f26ff4abdf$export$32bd6c5ac0419028);
$parcel$export(module.exports, "useHasToolSections", () => $08c1f6f26ff4abdf$export$54be06d39c052cd5);
$parcel$export(module.exports, "useFetchedSprintActions", () => $08c1f6f26ff4abdf$export$d58666d3ff237ccd);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $fjfkx = parcelRequire("fjfkx");

var $78UP2 = parcelRequire("78UP2");

var $lEUlW = parcelRequire("lEUlW");
const $08c1f6f26ff4abdf$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
    name: '@atlassian/jira-software-connect-toolbar',
    initialState: {
        toolSections: null,
        key: null,
        isLoading: false,
        sprintActions: null
    },
    actions: $lEUlW
});
const $08c1f6f26ff4abdf$export$d5aeb5eefb04c978 = (0, $7JoAD.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.toolSections
});
function $08c1f6f26ff4abdf$export$32bd6c5ac0419028({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    const [toolSections, { fetchExtensionData: fetchExtensionData }] = $08c1f6f26ff4abdf$export$d5aeb5eefb04c978();
    (0, $5uXOq.useEffect)(()=>{
        fetchExtensionData({
            boardId: boardId,
            projectKey: projectKey,
            mode: mode
        });
    }, [
        boardId,
        fetchExtensionData,
        mode,
        projectKey
    ]);
    return toolSections;
}
function $08c1f6f26ff4abdf$export$54be06d39c052cd5({ boardId: boardId, projectKey: projectKey, mode: mode = 'work', itemLocations: itemLocations = [] }) {
    const toolSections = $08c1f6f26ff4abdf$export$32bd6c5ac0419028({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const relevantSections = (0, $fjfkx.useConnectPluginSections)(toolSections ?? []);
    const hasRelevantSections = relevantSections ? relevantSections.length > 0 : false;
    const hasTargetSections = itemLocations.some((location)=>((toolSections && (0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length) ?? 0) > 0);
    return hasTargetSections || hasRelevantSections;
}
const $08c1f6f26ff4abdf$export$fa6cceef0215e684 = (0, $7JoAD.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.sprintActions
});
const $08c1f6f26ff4abdf$export$d58666d3ff237ccd = ({ sprintId: sprintId })=>{
    const [sprintActions, { fetchSprintActionsData: fetchSprintActionsData }] = $08c1f6f26ff4abdf$export$fa6cceef0215e684();
    (0, $5uXOq.useEffect)(()=>{
        fetchSprintActionsData({
            sprintId: sprintId
        });
    }, [
        fetchSprintActionsData,
        sprintId
    ]);
    return sprintActions;
};

});
parcelRegister("fjfkx", function(module, exports) {

$parcel$export(module.exports, "useConnectPluginSections", () => $761d5c3db4b1e977$export$9f557e5e5102c0b2);
$parcel$export(module.exports, "BoardToolsView", () => $761d5c3db4b1e977$export$a97914bd35ac0c68);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $88pw4 = parcelRequire("88pw4");

var $2NYED = parcelRequire("2NYED");
function $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections) {
    return (0, $5uXOq.useMemo)(()=>toolSections?.filter((section)=>section.id !== 'board-tools-section'), [
        toolSections
    ]);
}
function $761d5c3db4b1e977$export$a97914bd35ac0c68({ toolSections: toolSections, mode: mode = 'button' }) {
    const relevantSections = $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, relevantSections?.map((section)=>section.type === 'webItem' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolWebItemView), {
            key: section.id,
            subItem: section,
            mode: mode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88pw4.BoardToolSectionView), {
            key: section.id,
            section: section,
            isMenuItem: mode === 'dropdown-item' && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')
        })));
}

});
parcelRegister("88pw4", function(module, exports) {

$parcel$export(module.exports, "BoardToolSectionView", () => $298a4a1ba5bb50fb$export$c57d75d82c2414d5);

var $5uXOq = parcelRequire("5uXOq");

var $dHJL9 = parcelRequire("dHJL9");

var $8Agsd = parcelRequire("8Agsd");

var $hdlWZ = parcelRequire("hdlWZ");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $6PItG = parcelRequire("6PItG");
var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $lm9d2 = parcelRequire("lm9d2");

var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $2NYED = parcelRequire("2NYED");
function $298a4a1ba5bb50fb$export$c57d75d82c2414d5({ section: section, isMenuItem: isMenuItem = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) {
        const content = ()=>section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
                    key: subItem.id,
                    subItem: subItem
                }));
        return isMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
                    ...triggerProps,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hdlWZ))), {
                        label: section.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7df7o.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), null, content()))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHJL9.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($68lfN))),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: content
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
        placement: "bottom-end",
        trigger: section.label,
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
    }, section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: subItem.id,
            subItem: subItem
        })));
}

});


parcelRegister("78UP2", function(module, exports) {

$parcel$export(module.exports, "findSection", () => $003eeb674acde218$export$967ce3543c950aeb);
function $003eeb674acde218$export$967ce3543c950aeb(toolSections, location) {
    for(let i = 0; i < toolSections.length; i += 1){
        const item = toolSections[i];
        if (item.type === 'section' && item.id === location) return item;
        if (item.type === 'section' && item.subItems != null) {
            const candidate = $003eeb674acde218$export$967ce3543c950aeb(item.subItems, location);
            if (candidate != null) return candidate;
        }
    }
    return null;
}

});

parcelRegister("lEUlW", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $5344c8cf4b3b110f$export$5fe98ae96d282610);
$parcel$export(module.exports, "fetchSprintActionsData", () => $5344c8cf4b3b110f$export$d50a304a5f5a89a3);

var $dJl1T = parcelRequire("dJl1T");

var $agj21 = parcelRequire("agj21");

var $b1Aqw = parcelRequire("b1Aqw");
const $5344c8cf4b3b110f$export$5fe98ae96d282610 = ({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' })=>async ({ getState: getState, setState: setState })=>{
        const key = JSON.stringify([
            projectKey,
            boardId,
            mode
        ]);
        const state = getState();
        if (state.key === key && state.isLoading) return;
        if (state.key !== key) setState({
            toolSections: null,
            isLoading: true,
            key: key
        });
        else setState({
            isLoading: true
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPExtensionData)({
                boardId: boardId,
                projectKey: projectKey,
                mode: mode
            });
            setState({
                toolSections: response.sections,
                key: key,
                isLoading: false
            });
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('software.extension.board-tools', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                isLoading: false
            });
        }
    };
const $5344c8cf4b3b110f$export$d50a304a5f5a89a3 = ({ sprintId: sprintId })=>async ({ getState: getState, setState: setState })=>{
        const { sprintActions: sprintActions } = getState();
        const findActions = sprintActions?.[sprintId] || {
            isLoading: false,
            hasLoaded: false
        };
        if (findActions.isLoading || findActions.hasLoaded) return;
        // set loading to true to prevent multiple requests
        setState({
            sprintActions: {
                ...sprintActions,
                [sprintId]: {
                    isLoading: true,
                    hasLoaded: false
                }
            }
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPSprintActionsData)({
                sprintId: sprintId
            });
            const actionsForSprint = (0, $agj21.transformSprintActionsResponse)(response);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        ...actionsForSprint,
                        isLoading: false,
                        hasLoaded: true
                    }
                }
            });
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('software.extension.sprint-actions', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        isLoading: false,
                        hasLoaded: false
                    }
                }
            });
        }
    };

});
parcelRegister("agj21", function(module, exports) {

$parcel$export(module.exports, "transformSprintActionsResponse", () => $96e521c26ac919f8$export$bb626d8539383296);
const $96e521c26ac919f8$export$8b3475589327aa1c = (sprintAction)=>({
        id: sprintAction.id,
        type: 'webItem',
        label: sprintAction.name,
        url: sprintAction.url,
        cssClass: sprintAction.styleClass
    });
const $96e521c26ac919f8$export$5365f133b30aefb1 = (sprintAction)=>Boolean(sprintAction.url);
const $96e521c26ac919f8$export$1d427bb13100a4da = (section)=>section.groupId === 'sprint-move-actions' || section.groupId === 'sprint-edit-action' || section.groupId === 'sprint-delete-action';
const $96e521c26ac919f8$export$bb626d8539383296 = (sprintActionsResponse)=>{
    const result = {};
    sprintActionsResponse.sections.filter($96e521c26ac919f8$export$1d427bb13100a4da).forEach((section)=>{
        const actions = section.actions.filter($96e521c26ac919f8$export$5365f133b30aefb1).map($96e521c26ac919f8$export$8b3475589327aa1c);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[section.groupId] = actions;
    });
    return result;
};

});

parcelRegister("b1Aqw", function(module, exports) {

$parcel$export(module.exports, "fetchCMPExtensionData", () => $ce9155dcdaa49b1d$export$aa96aae4fab07720);
$parcel$export(module.exports, "fetchCMPSprintActionsData", () => $ce9155dcdaa49b1d$export$2a796a8235b7b986);

var $7f4tk = parcelRequire("7f4tk");
function $ce9155dcdaa49b1d$export$aa96aae4fab07720({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/toolSections?mode=${mode}&rapidViewId=${boardId}&selectedProjectKey=${projectKey}&_=${Date.now()}`);
}
function $ce9155dcdaa49b1d$export$2a796a8235b7b986({ sprintId: sprintId }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/plan/sprints/actions?sprintId=${sprintId}&_=${Date.now()}`);
}

});




parcelRegister("2F0OA", function(module, exports) {

$parcel$export(module.exports, "sprintDeleteModalEntryPoint", () => $db990fee6dc12c0b$export$60f5a667ca68ee8c);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $db990fee6dc12c0b$export$60f5a667ca68ee8c = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("EceND")), {
        moduleId: "a19e1920"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("EceND", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lyVwg").then(()=>parcelRequire('fWpr3'));

});


parcelRegister("kseO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c3a62095ba21d7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $02c3a62095ba21d7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuTrigger: {
        "id": "backlog.card-list.sprints-menu.menu-trigger",
        "defaultMessage": "{sprintName} actions"
    },
    editSprint: {
        "id": "backlog.card-list.sprints-menu.edit-sprint",
        "defaultMessage": "Edit sprint"
    },
    deleteSprint: {
        "id": "backlog.card-list.sprints-menu.delete-sprint",
        "defaultMessage": "Delete sprint"
    },
    moveSprintToTop: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-top",
        "defaultMessage": "Move sprint to top"
    },
    moveSprintUp: {
        "id": "backlog.card-list.sprints-menu.move-sprint-up",
        "defaultMessage": "Move sprint up"
    },
    moveSprintDown: {
        "id": "backlog.card-list.sprints-menu.move-sprint-down",
        "defaultMessage": "Move sprint down"
    },
    moveSprintToBottom: {
        "id": "backlog.card-list.sprints-menu.move-sprint-to-bottom",
        "defaultMessage": "Move sprint to bottom"
    }
});

});


parcelRegister("cOAVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $742dbcf86a84a4d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $gV01p = parcelRequire("gV01p");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $75InM = parcelRequire("75InM");

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $e978U = parcelRequire("e978U");

var $jG5HW = parcelRequire("jG5HW");

var $elctU = parcelRequire("elctU");

var $dgJKn = parcelRequire("dgJKn");

var $3fVgL = parcelRequire("3fVgL");
const $742dbcf86a84a4d4$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.start-sprint-button.a11y-helper-text';
const $742dbcf86a84a4d4$var$StartSprintButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ theme: theme, appearance: appearance, isDisabled: isDisabled, testId: testId, children: children, sprintId: sprintId, shouldShowDisabledButtonHelper: shouldShowDisabledButtonHelper = false }, ref)=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const hasActiveSprints = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getHasActiveSprints));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onSave = ()=>{
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187), 'START_SPRINT_MODAL_START');
        dispatch((0, $e978U.showSprintStartedFlagAction)());
    };
    const redirectTo = (0, $75InM.useBoardUrl)(hasActiveSprints ? [
        'sprintStarted=true',
        `sprints=${sprintId}`
    ] : [
        'sprintStarted=true'
    ]) || '';
    const [isModalVisible, setModalVisible] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const [queryReference, loadQuery, disposeQuery] = (0, $8Uumt.useQueryLoader)((0, $gV01p.default));
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const sprintIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'sprint',
        resourceId: String(sprintId)
    });
    const onClick = ()=>{
        (0, $8hVbJ.startSprintModalLoad).start();
        loadQuery({
            boardId: boardIdAri,
            sprintId: sprintIdAri,
            isCompanyManaged: isCompanyManaged
        }, {
            fetchPolicy: 'network-only'
        });
        setModalVisible(true);
    };
    const onClose = ()=>{
        setModalVisible(false);
        disposeQuery();
    };
    const onStartSprintSave = ()=>{
        onClose();
        onSave();
    };
    const onReady = ()=>{
        (0, $8hVbJ.startSprintModalLoad).stop({
            customData: {
                relay: true
            }
        });
    };
    const commonProps = {
        ...isDisabled && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? {
            'aria-describedby': $742dbcf86a84a4d4$var$A11Y_HELPER_TEXT_ID
        } : {},
        onClick: onClick,
        isDisabled: isDisabled,
        testId: testId,
        ref: ref
    };
    const buttonComponent = theme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ...commonProps,
        theme: theme,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        ...commonProps,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : appearance,
        spacing: (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : undefined
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowDisabledButtonHelper && (0, $4R6GH.fg)('jsw-jet-yamato-fe-permissions-seq-sprint-actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elctU.DisabledButtonHelper), {
        isDisabled: isDisabled,
        helpTextId: $742dbcf86a84a4d4$var$A11Y_HELPER_TEXT_ID,
        helpText: formatMessage((0, $dgJKn.messages).startSprintButtonDisabledInfoTextNonFinal)
    }, buttonComponent) : buttonComponent, isModalVisible && queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3fVgL.default), {
        analyticsSource: "software-backlog",
        onClose: onClose,
        onSave: onStartSprintSave,
        queryReference: queryReference,
        onReady: onReady,
        sprintId: String(sprintIdAri),
        boardId: String(boardIdAri),
        redirectTo: redirectTo,
        showAlternateHeaderMessage: hasActiveSprints,
        isCompanyManaged: isCompanyManaged
    }) : null);
});
var $742dbcf86a84a4d4$export$2e2bcd8739ae039 = $742dbcf86a84a4d4$var$StartSprintButton;

});
parcelRegister("gV01p", function(module, exports) {

$parcel$export(module.exports, "default", () => $3adc083481f365d7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<460c599037694fd14d389b534583c5cc>>
 * @relayHash 9203ca1c3f1dd776474f4a1b5b46683a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1
const $3adc083481f365d7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCompanyManaged"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sprintId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "sprintIds.0",
                    "variableName": "sprintId"
                }
            ],
            "kind": "ListValue",
            "name": "sprintIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v7 = {
        "kind": "ScalarField",
        "name": "defaultStartDate"
    }, v8 = {
        "kind": "ScalarField",
        "name": "defaultEndDate"
    }, v9 = {
        "kind": "ScalarField",
        "name": "numCompletedIssues"
    }, v10 = {
        "kind": "ScalarField",
        "name": "numOpenIssues"
    }, v11 = {
        "condition": "isCompanyManaged",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueKeys"
            },
            {
                "kind": "ScalarField",
                "name": "unestimatedIssueCount"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4 /*: any*/ ,
                                "concreteType": "SprintWithStatistics",
                                "kind": "LinkedField",
                                "name": "sprintWithStatistics",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v5 /*: any*/ ,
                                        "action": "THROW",
                                        "path": "boardScope.sprintWithStatistics.name"
                                    },
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "SoftwareSprintMetadata",
                                            "kind": "LinkedField",
                                            "name": "sprintMetadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprintWithStatistics.sprintMetadata.numCompletedIssues"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.sprintWithStatistics.sprintMetadata.numOpenIssues"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "boardScope.sprintWithStatistics.sprintMetadata"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "startSprintPeriod_softwareStartSprintModalRelay"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SprintWithStatistics",
                            "kind": "LinkedField",
                            "name": "sprintWithStatistics",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareSprintMetadata",
                                    "kind": "LinkedField",
                                    "name": "sprintMetadata",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1",
            "metadata": {},
            "name": "mainJiraSoftwareStartSprintPrototypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3adc083481f365d7$var$node.hash = "9ff5d851732ba2b395256eb73ffe6c21";
var $3adc083481f365d7$export$2e2bcd8739ae039 = $3adc083481f365d7$var$node;

});

parcelRegister("75InM", function(module, exports) {

$parcel$export(module.exports, "useBoardUrl", () => $563c8ce62b3f2234$export$66c8e3658ad37452);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1fyfD = parcelRequire("1fyfD");
const $563c8ce62b3f2234$export$66c8e3658ad37452 = (additionalParams = [])=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCMPBoard = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!data || error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData('useBoardUrl', 'Failed getting container context');
            return null;
        }
        const url = (0, $gSBIZ.isUserContext)(data) ? `/jira/people/${data.user.accountId}` : `/jira/software${isCMPBoard ? '/c' : ''}/projects/${data.project.key}`;
        const embed = isEmbedView ? '/embed' : '';
        return `${url}/boards/${boardId}${embed}${additionalParams.length ? `?${additionalParams.join('&')}` : ''}`;
    }, [
        additionalParams,
        boardId,
        data,
        error,
        isCMPBoard,
        isEmbedView
    ]);
};

});
parcelRegister("gSBIZ", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $3bb86183071b9984$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $3bb86183071b9984$export$8d1083037a4a6250);
const $3bb86183071b9984$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $3bb86183071b9984$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("1fyfD", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedView", () => $a4ef6d470ff8a97a$export$83ee417ebec96ced);

var $bMz5r = parcelRequire("bMz5r");

var $hziQo = parcelRequire("hziQo");

var $dIdda = parcelRequire("dIdda");
const $a4ef6d470ff8a97a$export$83ee417ebec96ced = ()=>{
    const [{ route: route }] = (0, $dIdda.useRouter)();
    return route.name === (0, $hziQo.softwareBacklogEmbedRoute).name || route.name === (0, $bMz5r.rapidboardBacklogEmbedRoute).name;
};

});


parcelRegister("dgJKn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6d384d31ed7cf9b3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6d384d31ed7cf9b3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    startSprintButtonDisabledInfoTextNonFinal: {
        "id": "software.main.header.start-sprint-button.start-sprint-button-disabled-info-text-non-final",
        "defaultMessage": "Request permissions from board admin"
    }
});

});

parcelRegister("3fVgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a1d189d452ad5d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $khnQM = parcelRequire("khnQM");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a9a1d189d452ad5d$var$StartSprintModal = (0, $hPtZI.lazy)(()=>(parcelRequire("j2LWj")), {
    moduleId: "./src/packages/software/start-sprint-modal-relay/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9a1d189d452ad5d$export$2e2bcd8739ae039 = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khnQM.StartSprintModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9a1d189d452ad5d$var$StartSprintModal, props));

});
parcelRegister("khnQM", function(module, exports) {

$parcel$export(module.exports, "StartSprintModalBoundary", () => $38c3d72c70c659fb$export$6cfe815c8e1cbd86);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");
const $38c3d72c70c659fb$export$6cfe815c8e1cbd86 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "start-sprint-modal",
        ...props
    }, children);

});

parcelRegister("j2LWj", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("lhwTF")
]).then(()=>parcelRequire('lLDJx'));

});





parcelRegister("3pyss", function(module, exports) {

$parcel$export(module.exports, "default", () => $503e57299162bf07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gDyTC = parcelRequire("gDyTC");


var $dCm1o = parcelRequire("dCm1o");

var $ibJfd = parcelRequire("ibJfd");

var $auOJt = parcelRequire("auOJt");

var $gBMim = parcelRequire("gBMim");
const $503e57299162bf07$var$GRABBER_SELECTOR = 'software-backlog-divider-grabber';
const $503e57299162bf07$var$GRABBER_LINE_SELECTOR = 'software-backlog-divider-grabber-line';
const $503e57299162bf07$var$DividerContents = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberLine, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_LINE_SELECTOR
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$Grabber, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_SELECTOR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: (0, $auOJt.GrabberIcon),
        size: "small",
        primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N90})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$GrabberLine, {
        "data-component-selector": $503e57299162bf07$var$GRABBER_LINE_SELECTOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ibJfd.DividerStatistics), {
        dividerCardListId: id
    })));
    const containerRef = (0, $5uXOq.useRef)(null);
    const { dragPreview: dragPreview } = (0, $gBMim.useDraggableDivider)({
        elementRef: containerRef,
        cardListId: id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$Container, {
        ref: containerRef,
        "data-testid": "software-backlog.card-list.divider.container",
        "aria-hidden": "true",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, content), dragPreview);
});
function $503e57299162bf07$export$2e2bcd8739ae039(props) {
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($503e57299162bf07$var$DividerContents, {
        id: props.id
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $503e57299162bf07$var$GrabberLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _16jlkb7n _4t3iidpf _tzy4idpf _n7zldwhu _v564m7ou",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$Grabber = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4t3i7vkz _1bsb7vkz _tzy4txnc _v564m7ou _80om776v",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$GrabberContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _i0dlidpf _16jlkb7n _4cvr1h6o _zulpu2gc _bfhk18uv",
            __cmplp.className
        ])
    });
});
const $503e57299162bf07$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3izwfg _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _zulpu2gc _otyr1no3 _16jlkb7n _1ov1kb7n _1minkb7n _10n8kb7n _1us6kb7n",
            !__cmplp.visualRefresh && "_1yt4119w",
            __cmplp.className
        ])
    });
});

});
parcelRegister("auOJt", function(module, exports) {

$parcel$export(module.exports, "GrabberIcon", () => $02ed4fa9ff6ac03a$export$1154891bc70a7bd);

var $5uXOq = parcelRequire("5uXOq");
const $02ed4fa9ff6ac03a$export$1154891bc70a7bd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "18px",
        height: "20px",
        viewBox: "0 0 18 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        transform: "translate(-3.000000, -2.000000)",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        transform: "translate(3.000000, 2.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "7",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0",
        y: "11",
        width: "18",
        height: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.29175912,15.2930586 C4.90274696,15.685137 4.90274696,16.3202641 5.29175912,16.7123425 L8.23085096,19.6779356 C8.44885778,19.8929786 8.73086659,20 9.00987531,20 C9.28888403,20 9.56589268,19.8929786 9.77889934,19.6779356 L12.7089909,16.7223445 C13.097003,16.3302661 13.097003,15.695139 12.7089909,15.3030606 C12.3199787,14.9109822 11.6909591,14.9109822 11.302947,15.3030606 L9.00487515,17.6205241 L6.69780306,15.2930586 C6.50379699,15.0980196 6.24878902,15 5.99478109,15 C5.73977312,15 5.48476515,15.0980196 5.29175912,15.2930586 Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.29175912,0.293058612 C4.90274696,0.685137027 4.90274696,1.32026405 5.29175912,1.71234247 L8.23085096,4.67793559 C8.44885778,4.8929786 8.73086659,5 9.00987531,5 C9.28888403,5 9.56589268,4.8929786 9.77889934,4.67793559 L12.7089909,1.72234447 C13.097003,1.33026605 13.097003,0.695139028 12.7089909,0.303060612 C12.3199787,-0.0890178036 11.6909591,-0.0890178036 11.302947,0.303060612 L9.00487515,2.6205241 L6.69780306,0.293058612 C6.50379699,0.0980196039 6.24878902,0 5.99478109,0 C5.73977312,0 5.48476515,0.0980196039 5.29175912,0.293058612 Z",
        transform: "translate(9.000000, 2.500000) rotate(180.000000) translate(-9.000000, -2.500000) "
    })))));

});

parcelRegister("gBMim", function(module, exports) {

$parcel$export(module.exports, "useDraggableDivider", () => $8769a50639b1284f$export$731cb43729e9cccd);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $gDyTC = parcelRequire("gDyTC");

var $7Gk7K = parcelRequire("7Gk7K");
parcelRequire("fFy9O");
var $jGko2 = parcelRequire("jGko2");


var $auOJt = parcelRequire("auOJt");
function $8769a50639b1284f$export$731cb43729e9cccd({ elementRef: elementRef, cardListId: cardListId }) {
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $7Gk7K.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: 'DIVIDER',
                    cardListId: cardListId
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $jGko2.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    render ({ container: container }) {
                        setDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'idle'
                            });
                    }
                });
            }
        });
    }, [
        cardListId,
        elementRef
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
            glyph: (0, $auOJt.GrabberIcon),
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $5e0c0d4e15efb4a6$exports).N90})`,
            label: ""
        }), dragState.container) : null
    };
}

});


parcelRegister("l4p68", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c4f4a1e05b25651$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iDGXn = parcelRequire("iDGXn");

var $2lpqS = parcelRequire("2lpqS");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $453ro = parcelRequire("453ro");
const $0c4f4a1e05b25651$var$FastVirtualListContainer = ({ isDropDisabled: isDropDisabled, cardListId: cardListId, emptyList: emptyList, renderCard: renderCard })=>{
    const cardIdWithAboveIccOpen = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIdWithAboveICCOpen));
    const getDefaultRowSize = (0, $c1MAf.useBacklogSelector)((0, $dGljH.makeGetDefaultRowSize));
    const showCompactMode = (0, $iDGXn.useShowCompactMode)();
    const defaultCardHeight = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getDefaultCardHeight)(state)(showCompactMode));
    const isCmpBacklog = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const cardEntries = (0, $c1MAf.useBacklogSelector)((state)=>isCmpBacklog ? (0, $dGljH.makeOrderedVisibleCardEntries)(state)(cardListId) : (0, $dGljH.makeOrderedVisibleCardEntriesOld)(state)(cardListId));
    const cardIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetVisibleCardOrderFromCardEntries)(state)(cardListId));
    const visibleCardAmount = (0, $c1MAf.useBacklogSelector)((state)=>false ? (0, $dGljH.makeOrderVisibleCardIdsForCardListWithLimit)(state)(cardListId).length : (0, $dGljH.makeOrderedVisibleCardIdsForCardList)(state)(cardListId).length);
    const minimumOffset = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetFastVirtualListMinimumOffSetByCardListId)(state)(cardListId));
    const expandedCardGroups = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getExpandedCardGroups));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $453ro.FastVirtualList), {
        cardIdWithAboveIccOpen: cardIdWithAboveIccOpen,
        cardEntries: cardEntries,
        visibleCardAmount: visibleCardAmount,
        minimumOffset: minimumOffset,
        isDropDisabled: isDropDisabled,
        getDefaultRowSize: getDefaultRowSize,
        defaultCardHeight: defaultCardHeight,
        cardListId: cardListId,
        emptyList: emptyList,
        renderCard: renderCard,
        expandedCardGroups: expandedCardGroups,
        droppableType: (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE),
        cardIds: cardIds
    });
};
var $0c4f4a1e05b25651$export$2e2bcd8739ae039 = $0c4f4a1e05b25651$var$FastVirtualListContainer;

});
parcelRegister("453ro", function(module, exports) {

$parcel$export(module.exports, "FastVirtualList", () => $88f5ea7ff0eb1668$export$32fc6f03ada9e09e);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $53KbV = parcelRequire("53KbV");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $7u8mi = parcelRequire("7u8mi");

var $gSExi = parcelRequire("gSExi");

var $co1wz = parcelRequire("co1wz");

var $687vG = parcelRequire("687vG");

var $guFRy = parcelRequire("guFRy");

var $iDGXn = parcelRequire("iDGXn");

var $f6RVN = parcelRequire("f6RVN");

var $ee1tL = parcelRequire("ee1tL");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");

var $2ixAa = parcelRequire("2ixAa");

var $g2Dfe = parcelRequire("g2Dfe");

var $fFUiJ = parcelRequire("fFUiJ");

var $i1hCy = parcelRequire("i1hCy");
const $88f5ea7ff0eb1668$export$32fc6f03ada9e09e = ({ cardEntries: cardEntries, renderCard: renderCard, cardIdWithAboveIccOpen: cardIdWithAboveIccOpen, getDefaultRowSize: getDefaultRowSize, defaultCardHeight: defaultCardHeight, cardListId: cardListId, visibleCardAmount: visibleCardAmount, emptyList: emptyList, minimumOffset: minimumOffset, expandedCardGroups: expandedCardGroups, cardIds: cardIds })=>{
    const { ref: listElRef, offsetTop: offsetTop } = (0, $687vG.useElementOffset)({
        initialOffset: minimumOffset
    });
    const cardHeightCache = (0, $g2Dfe.useCardHeightCache)();
    const isCompact = (0, $iDGXn.useShowCompactMode)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>{
                const issueEntry = cardEntries[index];
                if (!issueEntry) return 'none';
                 // If its just 1 extra, we know its the ICC
                if (index === cardEntries.length) return 'ICC';
                if ((0, $ee1tL.isCardEntryGroup)(issueEntry)) return (0, $ee1tL.getCardEntryGroupKey)(issueEntry, cardListId);
                return issueEntry.cardId;
            }
        }), [
        cardEntries,
        cardHeightCache,
        cardListId
    ]);
    const isCardListEmpty = cardEntries.length === 0 || visibleCardAmount === 0;
    (0, $fFUiJ.useEmptyCardListDropTarget)({
        elementRef: listElRef,
        isCardListEmpty: isCardListEmpty,
        cardListId: cardListId
    });
    const overscanHeight = (0, $i1hCy.useOverscanHeight)(cardListId, 400);
    const showCardExtraFieldsColumnBasedOnViewSettings = (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useHasCardExtraFields)() : true;
    const { rows: rows, totalSize: totalSize, reinitialize: reinitialize, isScrolling: isScrolling, scrollTo: scrollTo } = (0, $guFRy.useVirtual)({
        rowCount: cardEntries.length,
        overscanHeight: overscanHeight,
        offsetTop: offsetTop,
        cacheOptions: cacheOptions,
        getDefaultRowSize: (index)=>{
            const cardEntry = cardEntries[index];
            const cardId = (0, $ee1tL.isCardEntryGroup)(cardEntry) ? cardEntry?.parentId : cardEntry?.cardId;
            let totalCardsInCardEntry = 1;
            if ((0, $ee1tL.isCardEntryGroup)(cardEntry)) {
                const isCardGroupExpanded = cardEntry.isAttachedToParent === true ? Boolean(expandedCardGroups[cardEntry.parentId]) : true;
                if (isCardGroupExpanded) totalCardsInCardEntry = cardEntry.cardIds.length;
            }
            const height = getDefaultRowSize({
                isInlineCardCreateOpen: cardId === cardIdWithAboveIccOpen,
                numberOfCardsInCardEntry: totalCardsInCardEntry,
                isCompact: isCompact,
                hideExtraFields: !showCardExtraFieldsColumnBasedOnViewSettings
            });
            return height;
        }
    });
    (0, $2ixAa.useAutoScrollCard)(cardEntries, scrollTo);
    (0, $5uXOq.useEffect)(()=>{
        reinitialize(); // ? We need cardIds in here to make sure the card list is recalculated when things change
    // We need `isCompact` as part of dependencies to make sure the card list is recalculated when compact mode is toggled
    }, [
        cardIdWithAboveIccOpen,
        reinitialize,
        cardIds,
        isCompact,
        showCardExtraFieldsColumnBasedOnViewSettings
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        cardIds,
        isCompact
    ]);
    const isCardDragging = (0, $c1MAf.useBacklogSelector)((0, $lDDqj.isDragging));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: listElRef,
        "data-test-id": `software-backlog.card-list.id-${cardListId}`,
        "data-testid": `software-backlog.card-list.id-${cardListId}`
    }, isCardListEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$EmptyCardList // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-test-id": "software-backlog.card-list.empty-card-list",
        "data-testid": "software-backlog.card-list.fast-virtual-list.empty-card-list",
        isDragging: isCardDragging
    }, emptyList) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$ListContainer, {
        hide: !isScrolling || isCardDragging,
        defaultCardHeight: defaultCardHeight,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'relative',
            height: totalSize
        }
    }, rows.map((row)=>{
        const cardEntry = cardEntries[row.index];
        const cardId = (0, $ee1tL.isCardEntryGroup)(cardEntry) ? (0, $ee1tL.getCardEntryGroupKey)(cardEntry, cardListId) : cardEntry?.cardId;
        if (cardId == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: cardId,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: 0,
                top: row.top - offsetTop,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%'
            }
        }, renderCard(cardEntry, row, isScrolling));
    })));
};
const $88f5ea7ff0eb1668$var$EmptyCardListWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "div",
        xcss: $88f5ea7ff0eb1668$var$emptyCardListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88f5ea7ff0eb1668$var$EmptyCardListExperiment, props)));
const $88f5ea7ff0eb1668$var$emptyCardListWrapperStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.0'
}); /**
     * This is a background for the lists, which is:
     *
     * * White
     * * Has stripes that look like the cards' borders
     *
     * This is to fool people looking at the list to think cards are rendered when
     * they're not. Since it's only using CSS it can always be displayed & should
     * be reasonably efficient.
     *
     * While dragging the background is disabled.
     */ 
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88f5ea7ff0eb1668$var$ListContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1566zr9-0"
})`${({ hide: hide, defaultCardHeight: defaultCardHeight })=>hide ? '' : `
    background-color: ${`var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`};
    background-image: repeating-linear-gradient(
        180deg,
        ${`var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N30})`} 0px,
        ${`var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`} 1px,
        ${`var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`} ${defaultCardHeight - 1}px,
        ${`var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N30})`} ${defaultCardHeight}px
    );
    box-shadow: inset 0 0 1px 1px ${`var(--ds-border, ${(0, $5e0c0d4e15efb4a6$exports).N30})`};
    `}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$ListContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, defaultCardHeight: defaultCardHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3jsq9m": (0, $lD23V.default)("repeating-linear-gradient180deg, " + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N30})`} 0px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`} 1px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-surface-raised, ${(0, $5e0c0d4e15efb4a6$exports).N0})`} ${__cmplp.defaultCardHeight - 1}px, ` + // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${`var(--ds-background-neutral-hovered, ${(0, $5e0c0d4e15efb4a6$exports).N30})`} ${__cmplp.defaultCardHeight}px )`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.hide && "_bfhkhp5a _1itkn3g2 _16qs1ols",
            __cmplp.className
        ])
    });
});
const $88f5ea7ff0eb1668$var$ListContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $88f5ea7ff0eb1668$var$ListContainerExperiment, $88f5ea7ff0eb1668$var$ListContainerControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$EmptyCardListControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1566zr9-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $co1wz.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && props.isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(--ds-background-selected, ${(0, $5e0c0d4e15efb4a6$exports).B50})` : undefined,
        border: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $co1wz.ff)('jsw-tanuki-fit-and-finish_rhzmf', false) && props.isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `2px solid ${`var(--ds-border-selected, ${(0, $5e0c0d4e15efb4a6$exports).B300})`}` : `2px dashed ${"var(--ds-border, #dfe1e6)"}`,
        borderRadius: '3px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $7u8mi).h100(), {
    fontWeight: 'normal',
    marginTop: "var(--ds-space-0, 0px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $88f5ea7ff0eb1668$var$EmptyCardListExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1yt4utpp _y3gn1h6o _k48p4jg8",
            __cmplp.isDragging && "_bfhk29zg",
            __cmplp.isDragging ? "_19it5r1b" : "_19it7lsx",
            __cmplp.className
        ])
    });
});
const $88f5ea7ff0eb1668$var$EmptyCardList = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $88f5ea7ff0eb1668$var$EmptyCardListWrapper, $88f5ea7ff0eb1668$var$EmptyCardListControl);

});
parcelRegister("guFRy", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $8a37cce55cc85701$export$ebc1863da693699a);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $itWjr = parcelRequire("itWjr");

var $9Ik53 = parcelRequire("9Ik53");

var $2PIRw = parcelRequire("2PIRw");
const $8a37cce55cc85701$export$c61d420d8ad72523 = (rowCount, offsetTop, getDefaultRowSize, cacheOptions)=>{
    const states = new Array(rowCount);
    let currentTop = offsetTop;
    for(let i = 0; i < rowCount; i += 1){
        const height = cacheOptions?.cache.get(cacheOptions.getCacheKey(i))?.height ?? getDefaultRowSize(i);
        const result = {
            height: height,
            top: currentTop,
            bottom: currentTop + height
        };
        currentTop = result.bottom;
        states[i] = result;
    }
    return states;
};
const $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT = 0.05;
function $8a37cce55cc85701$export$fd7df3dcf242e12a({ cacheOptions: cacheOptions, index: index, rowStates: rowStates, setRowHeight: setRowHeight, isVisible: isVisible }) {
    const forceRemeasure = (el, withCache = false)=>{
        if (!el) return;
        if (withCache && cacheOptions?.cache?.has(cacheOptions.getCacheKey(index))) return;
        const { height: height } = el.getBoundingClientRect();
        const roundedHeight = Math.round(height * 100) / 100;
        // TODO: React DnD will set row height to 0 on pick-up, that update must be ignored.
        // This is not a clean solution.
        if (roundedHeight > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && cacheOptions) {
            const cacheKey = cacheOptions.getCacheKey(index);
            if (cacheKey !== undefined) cacheOptions.cache.set(cacheKey, {
                height: height
            });
        }
        if (height != null && height > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && rowStates[index].height !== height) setRowHeight(index, height);
    };
    return {
        key: index,
        index: index,
        top: rowStates[index].top,
        isVisible: isVisible,
        measure (el) {
            forceRemeasure(el, true);
        },
        forceRemeasure: forceRemeasure
    };
}
function $8a37cce55cc85701$export$824e0ab10a990d7b({ start: start, end: end, rowStates: rowStates, cacheOptions: cacheOptions, setRowHeight: setRowHeight, startVisible: startVisible, endVisible: endVisible }) {
    if (start === end) return [];
    const numRows = end - start;
    // This code is structured in a way that allows it to be changed into stable indexes and support element recycling.
    const result = new Array(Math.max(numRows, 0));
    for(let offset = 0; offset < numRows; offset += 1){
        const index = start + offset;
        const isVisible = index >= startVisible && index <= endVisible;
        result[offset] = $8a37cce55cc85701$export$fd7df3dcf242e12a({
            cacheOptions: cacheOptions,
            index: index,
            rowStates: rowStates,
            setRowHeight: setRowHeight,
            isVisible: isVisible
        });
    }
    return result;
}
function $8a37cce55cc85701$var$useRows(scrollState, rowStates, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
cacheOptions, setRowHeight, overscanHeight) {
    const { start: start, end: end } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, overscanHeight), [
        scrollState,
        rowStates,
        overscanHeight
    ]);
    const { start: startVisible, end: endVisible } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, 0), [
        scrollState,
        rowStates
    ]);
    return (0, $5uXOq.useMemo)(()=>$8a37cce55cc85701$export$824e0ab10a990d7b({
            start: start,
            end: end,
            rowStates: rowStates,
            cacheOptions: cacheOptions,
            setRowHeight: setRowHeight,
            startVisible: startVisible,
            endVisible: endVisible
        }), [
        start,
        end,
        rowStates,
        cacheOptions,
        setRowHeight,
        startVisible,
        endVisible
    ]);
}
function $8a37cce55cc85701$export$ebc1863da693699a({ rowCount: rowCount, getDefaultRowSize: getDefaultRowSize, offsetTop: offsetTop = 0, overscanHeight: overscanHeight = 0, cacheOptions: cacheOptions, version: version }) {
    const scrollState = (0, $9Ik53.useScrollState)();
    const [rowStates, setRowStates] = (0, $5uXOq.useState)(()=>$8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitialize = ()=>setRowStates($8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitializeRef = (0, $5uXOq.useRef)(reinitialize);
    reinitializeRef.current = reinitialize;
    const reinitializeCb = (0, $5uXOq.useCallback)(()=>reinitializeRef.current(), []);
    const lastOffsetTop = (0, $5uXOq.useRef)(null);
    const lastVersion = (0, $5uXOq.useRef)(null);
    /**
	 * checking rowCount, offsetTop and version to rebuild the rowStates
	 * if the version is undefined, null or empty string, it will not be used
	 */ const shouldRebuildRowStates = rowCount !== rowStates.length || offsetTop !== lastOffsetTop.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(version) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(version) && version !== lastVersion.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRebuildRowStates) {
            lastVersion.current = version;
            lastOffsetTop.current = offsetTop;
            const states = $8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions);
            setRowStates(states);
        }
    }, [
        rowStates,
        rowCount,
        offsetTop,
        cacheOptions,
        getDefaultRowSize,
        shouldRebuildRowStates,
        version
    ]);
    const scrollTo = (0, $2PIRw.useScrollTo)(rowStates);
    const setRowHeight = (0, $5uXOq.useCallback)((row, height)=>{
        setRowStates((currentRowStates)=>{
            let currentTop = offsetTop;
            return currentRowStates.map((state, index)=>{
                const newState = {
                    ...state
                };
                if (index === row) newState.height = height;
                newState.top = currentTop;
                newState.bottom = currentTop + newState.height;
                currentTop = newState.bottom;
                return newState;
            });
        });
    }, [
        offsetTop
    ]);
    const totalSize = (0, $5uXOq.useMemo)(()=>{
        let sum = 0;
        rowStates.forEach(({ height: height })=>{
            sum += height; // This is a float
        });
        // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(sum);
    }, [
        rowStates
    ]);
    const rows = $8a37cce55cc85701$var$useRows(scrollState, rowStates, cacheOptions, setRowHeight, overscanHeight);
    return {
        rows: rows,
        rowStates: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? rowStates : undefined,
        scrollTo: scrollTo,
        totalSize: totalSize,
        isScrolling: scrollState.isScrolling,
        reinitialize: reinitializeCb
    };
}

});
parcelRegister("itWjr", function(module, exports) {

$parcel$export(module.exports, "getRenderedRange", () => $cbe28e6cb7ea4dcb$export$303e1fc2567e8469);
/**
 * Binary search for the nearest value to a `needle`, given high and low indexes
 * and a `getValue` function to get the value at a certain index.
 */ const $cbe28e6cb7ea4dcb$export$b961f15adda64c7b = (lowIndexDontRead, highIndexDontRead, getValue, needle)=>{
    // JFE linting doesn't allow changing the arg as a local.
    let low = lowIndexDontRead;
    let high = highIndexDontRead;
    while(low < high){
        const middleIndex = Math.floor((high + low) / 2);
        const candidate = getValue(middleIndex);
        if (candidate > needle) high = middleIndex - 1;
        else if (candidate < needle) low = middleIndex + 1;
        else return middleIndex;
    }
    return low;
};
const $cbe28e6cb7ea4dcb$export$303e1fc2567e8469 = (viewportRectangle, rowPositions, overscanHeight)=>{
    if (rowPositions.length === 0) return {
        start: 0,
        end: 0
    };
    // Render elements starting at the top edge of the scroll container, minus
    // some overscan height.
    const startPositionTop = viewportRectangle.scrollTop - overscanHeight;
    // And up to elements at the bottom edge of the scroll container, plus some
    // overscan height.
    // NOTE: This needs to default to 0 otherwise it is NaN which means that isAbove is true.
    const endPositionTop = (viewportRectangle?.scrollTop ?? 0) + (viewportRectangle?.height ?? 0) + overscanHeight;
    // If the viewport fully above or under the rows, render nothing
    const isAbove = endPositionTop < rowPositions[0].top;
    const isUnder = startPositionTop > rowPositions[rowPositions.length - 1].bottom;
    if (isAbove || isUnder) return {
        start: 0,
        end: 0
    };
    const startIndex = $cbe28e6cb7ea4dcb$export$b961f15adda64c7b(0, rowPositions.length, (i)=>rowPositions[i].bottom, startPositionTop);
    let endIndex = startIndex;
    while(endIndex < rowPositions.length && rowPositions[endIndex].top <= endPositionTop)endIndex += 1;
    return {
        start: startIndex,
        end: endIndex
    };
};

});

parcelRegister("2PIRw", function(module, exports) {

$parcel$export(module.exports, "useScrollTo", () => $6575a25f747838db$export$d774db9fe736aa73);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $kTgNN = parcelRequire("kTgNN");
const $6575a25f747838db$export$e1700fccdc2280c5 = 80;
const $6575a25f747838db$var$SCROLLING_INTERVAL = 50;
const $6575a25f747838db$var$SCROLLING_ATTEMPT = 5;
const $6575a25f747838db$export$d774db9fe736aa73 = (rowStates)=>{
    // scrollState CONSTANTLY changes
    // Just grabbing out the scrollElement will hardly change
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    // We do NOT want to regenerate the return function everytime so we should use REFs
    // here instead
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const rowStatesRef = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        // Only bind to the scrollElementRef once. We don't need it anymore once we have it
        if (scrollElementRef.current === null && scrollElement) scrollElementRef.current = scrollElement;
        // Always ensure our rowStates ref is up to date
        rowStatesRef.current = rowStates ?? rowStatesRef.current;
    }, [
        rowStates,
        scrollElement
    ]);
    const scrollTo = (0, $5uXOq.useCallback)((index, options, attempt = 1)=>{
        let timeoutId = null;
        // Early termination for invalid data
        if (index === -1 || attempt > $6575a25f747838db$var$SCROLLING_ATTEMPT) {
            options?.onComplete?.();
            return;
        }
        if (rowStatesRef?.current == null || // Can be null on first pass
        scrollElementRef?.current == null || // Can be null on first pass
        index >= rowStatesRef.current.length) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            timeoutId = window.setTimeout(()=>{
                scrollTo(index, options, attempt + 1);
            }, $6575a25f747838db$var$SCROLLING_INTERVAL);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }
        const scrollElementEl = scrollElementRef.current;
        const rowState = rowStatesRef.current;
        // Complete scrolling when the target is on screen.
        if ((0, $kTgNN.hasScrolledIntoView)(scrollElementRef.current, rowStatesRef.current[index])) {
            options?.onComplete?.();
            return;
        }
        const scrollToPosition = (0, $kTgNN.getScrollToPosition)(scrollElementEl, rowState[index], options);
        if (options?.immediate) scrollElementEl.scrollTop = scrollToPosition;
        else scrollElementEl.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        timeoutId = window.setTimeout(()=>scrollTo(index, options, attempt + 1), $6575a25f747838db$var$SCROLLING_INTERVAL);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        scrollElementRef,
        rowStatesRef
    ]);
    return scrollTo;
};

});
parcelRegister("kTgNN", function(module, exports) {

$parcel$export(module.exports, "hasScrolledIntoView", () => $abb1a9602db1b1f8$export$6ced3bc78dcece56);
$parcel$export(module.exports, "getScrollToPosition", () => $abb1a9602db1b1f8$export$dfe56cb366876f29);
const $abb1a9602db1b1f8$var$VIEWPORT_BUFFER = 50;
const $abb1a9602db1b1f8$export$6ced3bc78dcece56 = (scrollElementEl, rowState)=>{
    if (!scrollElementEl || !rowState) return false;
    const topOfRow = rowState.top;
    const bottomOfRow = rowState.top + rowState.height;
    // Make the viewport a bit smaller so the card won't stick to the edge of the screen
    const topOfView = scrollElementEl.scrollTop + $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    const bottomOfView = scrollElementEl.scrollTop + scrollElementEl.clientHeight - $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    return topOfRow > topOfView && topOfRow < bottomOfView || bottomOfRow > topOfView && bottomOfRow < bottomOfView || topOfRow < topOfView && bottomOfRow > bottomOfView;
};
const $abb1a9602db1b1f8$export$dfe56cb366876f29 = (scrollElementEl, rowState, options)=>{
    if (!scrollElementEl || !rowState) return 0;
    if (options?.hasVirtualisedChildren) return rowState.top - scrollElementEl.clientHeight;
    return rowState.top + rowState.height / 2 - scrollElementEl.clientHeight / 3;
};

});



parcelRegister("2ixAa", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollCard", () => $d34bdbd827f67a8e$export$b61f82894f7693a4);

var $5uXOq = parcelRequire("5uXOq");

var $ee1tL = parcelRequire("ee1tL");

var $c1MAf = parcelRequire("c1MAf");

var $9Z18E = parcelRequire("9Z18E");

var $dGljH = parcelRequire("dGljH");
const $d34bdbd827f67a8e$export$b61f82894f7693a4 = (cardEntries, scrollTo)=>{
    const autoScroll = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardAutoScroll));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollCardId = autoScroll?.cardId;
        if (!autoScrollCardId) return;
        // NOTE: Auto scrolling to a subtask may not work as expected
        const cardIndex = cardEntries.findIndex((issueEntry)=>(0, $ee1tL.isCardEntryGroup)(issueEntry) ? issueEntry.cardIds.includes(autoScrollCardId) : issueEntry.cardId === autoScrollCardId);
        if (cardIndex === -1) return;
        return scrollTo(cardIndex, {
            immediate: true,
            onComplete: ()=>dispatch((0, $9Z18E.cardAutoScroll)(null))
        });
    }, [
        autoScroll,
        cardEntries,
        dispatch,
        scrollTo
    ]);
};

});

parcelRegister("g2Dfe", function(module, exports) {

$parcel$export(module.exports, "useCardHeightCache", () => $8dc2b4d005c49b2a$export$bd41b84dc563782c);

var $5uXOq = parcelRequire("5uXOq");
const $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE = new Map();
const $8dc2b4d005c49b2a$export$bd41b84dc563782c = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE;
const $8dc2b4d005c49b2a$export$201114c49d4ccb5a = ()=>{
    (0, $5uXOq.useEffect)(()=>()=>{
            $8dc2b4d005c49b2a$var$CARD_HEIGHTS_CACHE.clear();
        }, []);
};

});

parcelRegister("fFUiJ", function(module, exports) {

$parcel$export(module.exports, "useEmptyCardListDropTarget", () => $fe901f06ece28d7a$export$d05d016cc6925d9c);

var $5uXOq = parcelRequire("5uXOq");

var $leVjT = parcelRequire("leVjT");

var $7Gk7K = parcelRequire("7Gk7K");

var $1fZVH = parcelRequire("1fZVH");

var $c1MAf = parcelRequire("c1MAf");

var $eMLHT = parcelRequire("eMLHT");

var $4VAKv = parcelRequire("4VAKv");

var $jyQw0 = parcelRequire("jyQw0");
function $fe901f06ece28d7a$export$d05d016cc6925d9c({ elementRef: elementRef, isCardListEmpty: isCardListEmpty, cardListId: cardListId }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const simplyMoveCards = (0, $jyQw0.useSimplyMoveCards)();
    const isAnySelectedOrphanedSubtask = (0, $c1MAf.useBacklogSelector)((0, $4VAKv.makeIsAnySelectedOrphanedSubtasks));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return undefined;
        return (0, $leVjT.combine)((0, $7Gk7K.dropTargetForElements)({
            element: elementRef.current,
            // Only accept drop events on empty lists. This is because drop events will bubble from the cards
            // when the lists are non-empty. On that case, the card is itself handling move.
            canDrop: ()=>isCardListEmpty && !isAnySelectedOrphanedSubtask,
            onDrop: (args)=>{
                autobatch(()=>{
                    const sourceCardId = Number(args.source.data.cardId);
                    simplyMoveCards({
                        source: {
                            cardId: sourceCardId
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    dispatch((0, $eMLHT.dragEnd)());
                });
            }
        }));
    }, [
        autobatch,
        cardListId,
        elementRef,
        isCardListEmpty,
        simplyMoveCards,
        isAnySelectedOrphanedSubtask,
        dispatch
    ]);
}

});

parcelRegister("i1hCy", function(module, exports) {

$parcel$export(module.exports, "useOverscanHeight", () => $1403dad59cb5804b$export$9af25d9f90686948);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $c1MAf = parcelRequire("c1MAf");

var $lDDqj = parcelRequire("lDDqj");
const $1403dad59cb5804b$export$9af25d9f90686948 = (cardListId, defaultOverscanHeight = 0)=>{
    const { scrollTop: scrollTop } = (0, $9Ik53.useScrollState)();
    const isDraggingSubtask = (0, $c1MAf.useBacklogSelector)((state)=>(0, $lDDqj.isDragging)(state) && (0, $lDDqj.getIsSubtaskDrag)(state));
    const isDraggingSourceCardlist = (0, $c1MAf.useBacklogSelector)((state)=>(0, $lDDqj.getSourceCardListId)(state) === cardListId);
    const scrollTopOnDragStart = (0, $5uXOq.useMemo)(()=>isDraggingSubtask && isDraggingSourceCardlist ? scrollTop : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isDraggingSubtask,
        isDraggingSourceCardlist
    ]);
    return defaultOverscanHeight + (scrollTopOnDragStart !== undefined ? Math.abs(scrollTop - scrollTopOnDragStart) : 0);
};

});



parcelRegister("9u5My", function(module, exports) {

$parcel$export(module.exports, "default", () => $5654b26c413cf285$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7u8mi = parcelRequire("7u8mi");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $KFBcs = parcelRequire("KFBcs");

var $1dPBY = parcelRequire("1dPBY");
function $5654b26c413cf285$export$5bf2d993553f05ff() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$FirstSprintPlanning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningImage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5654b26c413cf285$var$SprintPlanningTitle, null, formatMessage((0, $1dPBY.default).emptyFirstSprintTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1dPBY.default).emptyFirstSprintDescriptionIssueTermRefresh : (0, $1dPBY.default).emptyFirstSprintDescription,
        values: {
            backlog: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $1dPBY.default).backlog)),
            startSprint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, formatMessage((0, $1dPBY.default).startSprint))
        }
    }))));
}
var $5654b26c413cf285$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $5654b26c413cf285$export$5bf2d993553f05ff;
const $5654b26c413cf285$var$FirstSprintPlanning = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1ogm _19pkidpf _2hwx1wug _otyridpf _18u01wug _y3gn1e5h _4cvr1h6o _1bah1h6o _1tke1lit",
            __cmplp.className
        ])
    });
});
const $5654b26c413cf285$var$SprintPlanningImageControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8h0lec-0"
})({
    height: '128px',
    width: '128px',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($KFBcs)))})`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5654b26c413cf285$var$SprintPlanningImageExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_ixrapm": (0, $lD23V.default)((0, (/*@__PURE__*/$parcel$interopDefault($KFBcs))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1qr7 _1bsb1qr7 _ouxl1ssb _1lrw1f51 _12vemgnk _1itk1866",
            __cmplp.className
        ])
    });
});
const $5654b26c413cf285$var$SprintPlanningImage = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $5654b26c413cf285$var$SprintPlanningImageExperiment, $5654b26c413cf285$var$SprintPlanningImageControl); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5654b26c413cf285$var$SprintPlanningMessageControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8h0lec-1"
})`${(0, $7u8mi).h500()};font-weight:normal;margin-top:0;color:${`var(--ds-text, ${(0, $5e0c0d4e15efb4a6$exports).N800})`};padding-left:${"var(--ds-space-200, 16px)"};line-height:1.5;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5654b26c413cf285$var$SprintPlanningMessageExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81lkt _bt1jqdok _syaz1fxt _19bvpxbi _vwz4bs82",
            __cmplp.className
        ])
    });
});
const $5654b26c413cf285$var$SprintPlanningMessage = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $5654b26c413cf285$var$SprintPlanningMessageExperiment, $5654b26c413cf285$var$SprintPlanningMessageControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5654b26c413cf285$var$SprintPlanningTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pni7l _n3td1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("KFBcs", function(module, exports) {
module.exports = new URL("sprint-planning.32ed1a38.svg", import.meta.url).toString();

});

parcelRegister("1dPBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78ea6a2945164e4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b78ea6a2945164e4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyFirstSprintTitle: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-title",
        "defaultMessage": "Plan your sprint"
    },
    emptyFirstSprintDescription: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-description",
        "defaultMessage": "Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready."
    },
    backlog: {
        "id": "backlog.card-list.first-sprint-blank-state.backlog",
        "defaultMessage": "Backlog"
    },
    startSprint: {
        "id": "backlog.card-list.first-sprint-blank-state.start-sprint",
        "defaultMessage": "Start sprint"
    },
    emptyFirstSprintDescriptionIssueTermRefresh: {
        "id": "backlog.card-list.first-sprint-blank-state.empty-first-sprint-description-issue-term-refresh",
        "defaultMessage": "Drag issues from the {backlog} section, or create new issues, to plan the work for this sprint. Select {startSprint} when you're ready."
    }
});

});


parcelRegister("ldRVl", function(module, exports) {

$parcel$export(module.exports, "LastResultMarker", () => $67b3a9dce0524621$export$cd661a12882ae547);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $9Ik53 = parcelRequire("9Ik53");

var $5tMAe = parcelRequire("5tMAe");

var $c1MAf = parcelRequire("c1MAf");

var $l9VFH = parcelRequire("l9VFH");
const $67b3a9dce0524621$export$cd661a12882ae547 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    // Only use scrollElement as it wont update as much
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    const markerRef = (0, $5uXOq.useRef)(null);
    const [, actions] = (0, $5tMAe.useMoreResultsStore)();
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getFilters));
    const filtersRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.IntersectionObserver) return undefined;
        const observer = new IntersectionObserver((entries)=>{
            const [entry] = entries;
            const isLastResultBelowFold = !entry.isIntersecting && entry.boundingClientRect.top > (entry.rootBounds?.bottom ?? 0);
            const isFilterApplied = Object.keys(filters).length > 0;
            const isFilterChanged = filters !== filtersRef.current;
            if (isLastResultBelowFold && isFilterChanged && isFilterApplied) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'moreResultsButton shown');
                filtersRef.current = filters;
            }
            actions.setIsLastResultMarkerBelowFold(isLastResultBelowFold);
        }, {
            root: scrollElement,
            threshold: 0.5
        });
        const markerElement = markerRef.current;
        if (markerElement && markerRef.current) observer.observe(markerRef.current);
        return ()=>{
            if (markerElement) observer.unobserve(markerElement);
            actions.setIsLastResultMarkerBelowFold(false);
        };
    }, [
        scrollElement,
        actions,
        createAnalyticsEvent,
        filters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($67b3a9dce0524621$var$Marker, {
        ref: markerRef
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $67b3a9dce0524621$var$Marker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iiJr8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3445017986ba9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $c1MAf = parcelRequire("c1MAf");

var $eMLHT = parcelRequire("eMLHT");
const $c5d3445017986ba9$var$TransitionZone = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isVisible: isVisible }, ref)=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onEnter = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $eMLHT.transitionZoneEnter)());
    }, [
        dispatch
    ]);
    const onLeave = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $eMLHT.transitionZoneLeave)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5d3445017986ba9$var$TransitionZoneOuterContainer, {
        ref: ref,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5d3445017986ba9$var$TransitionZoneInnerContainer, {
        onMouseOver: onEnter,
        onMouseOut: onLeave,
        "data-testid": "software-backlog.card-list.transition-zone.transition-zone-inner-container"
    }));
});
var $c5d3445017986ba9$export$2e2bcd8739ae039 = $c5d3445017986ba9$var$TransitionZone;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5d3445017986ba9$var$TransitionZoneOuterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pbycs5v",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.className
        ])
    });
});
const $c5d3445017986ba9$var$TransitionZoneInnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1ul91osq _kqswh2mm _1tke1osq _2rkoi2wt _19it24b2 _bfhk29zg _lcxv4shg _irr3wtfv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gcvrq", function(module, exports) {

$parcel$export(module.exports, "useCardListDropTarget", () => $31ed95224b1ed24b$export$4c4dc2d355187470);

var $5uXOq = parcelRequire("5uXOq");

var $7Gk7K = parcelRequire("7Gk7K");

var $co1wz = parcelRequire("co1wz");

var $1fZVH = parcelRequire("1fZVH");

var $2lpqS = parcelRequire("2lpqS");


var $c1MAf = parcelRequire("c1MAf");

var $eMLHT = parcelRequire("eMLHT");

var $fSgHa = parcelRequire("fSgHa");

var $jyQw0 = parcelRequire("jyQw0");
function $31ed95224b1ed24b$var$useCardListHeaderDropTarget({ headerElementRef: headerElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    const isCompanyManagedKanban = (0, $fSgHa.useIsCMPKanbanBacklog)();
    (0, $5uXOq.useEffect)(()=>{
        if (!headerElementRef.current) return undefined;
        return (0, $7Gk7K.dropTargetForElements)({
            element: headerElementRef.current,
            getData: ()=>({
                    type: (0, $2lpqS.CARD_LIST_DROPPABLE_TYPE)
                }),
            canDrop: (args)=>!isHeaderDropDisabled && args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b) && (!args.source.data.cardIsSubtask || !!isCompanyManagedKanban),
            onDrop: (args)=>{
                autobatch(()=>{
                    setIsDraggingOver(false);
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                });
            },
            onDragEnter: ()=>{
                setIsDraggingOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggingOver(false);
            }
        });
    }, [
        autobatch,
        cardListId,
        headerElementRef,
        isHeaderDropDisabled,
        moveCards,
        isCompanyManagedKanban
    ]);
    return {
        isDraggingOver: isDraggingOver
    };
}
function $31ed95224b1ed24b$var$useTransitionZoneDropTarget({ cardListId: cardListId, transitionZoneElementRef: transitionZoneElementRef }) {
    const autobatch = (0, $1fZVH.useAutobatch)();
    const moveCards = (0, $jyQw0.useSimplyMoveCards)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (!transitionZoneElementRef.current) return undefined;
        return (0, $7Gk7K.dropTargetForElements)({
            element: transitionZoneElementRef.current,
            canDrop: (args)=>args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b),
            onDrop: (args)=>{
                autobatch(()=>{
                    if (args.source.data.type === (0, $b6a5a61e3f2f3f09$export$4d4e6ab48cd5be5b)) moveCards({
                        source: {
                            cardId: Number(args.source.data.cardId)
                        },
                        location: {
                            type: 'list',
                            targetListId: cardListId
                        }
                    });
                    if ((0, $co1wz.ff)('fix-hanging-low-opacity-after-backlog-card-drag-and-drop_0roex')) dispatch((0, $eMLHT.dragEnd)());
                });
            }
        });
    }, [
        transitionZoneElementRef,
        moveCards,
        cardListId,
        autobatch,
        dispatch
    ]);
}
function $31ed95224b1ed24b$export$4c4dc2d355187470({ headerElementRef: headerElementRef, transitionZoneElementRef: transitionZoneElementRef, cardListId: cardListId, isHeaderDropDisabled: isHeaderDropDisabled }) {
    const { isDraggingOver: isDraggingOver } = $31ed95224b1ed24b$var$useCardListHeaderDropTarget({
        headerElementRef: headerElementRef,
        cardListId: cardListId,
        isHeaderDropDisabled: isHeaderDropDisabled
    });
    $31ed95224b1ed24b$var$useTransitionZoneDropTarget({
        cardListId: cardListId,
        transitionZoneElementRef: transitionZoneElementRef
    });
    return {
        isDraggingOver: isDraggingOver
    };
}

});

parcelRegister("c4Chf", function(module, exports) {

$parcel$export(module.exports, "default", () => $95b2bec0c05c9822$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");

var $c1MAf = parcelRequire("c1MAf");

var $lHBhO = parcelRequire("lHBhO");

var $jG5HW = parcelRequire("jG5HW");

var $45Qwd = parcelRequire("45Qwd");

var $62nZT = parcelRequire("62nZT");

var $iKURq = parcelRequire("iKURq");
const $95b2bec0c05c9822$var$WorkLoadByAssigneeContainer = ({ cardListId: cardListId, sprintName: sprintName })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const assignees = (0, $c1MAf.useBacklogSelector)((0, $62nZT.makeWorkLoadByAssignee))(cardListId);
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const estimationFieldName = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationName));
    const isRemainingTimeTrackingEnabled = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getIsRemainingTimeTrackingEnabled));
    const isEstimationEnabled = !!estimationType && estimationType !== 'ISSUE_COUNT';
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const includeSubtasks = (0, $c1MAf.useBacklogSelector)((0, $62nZT.getIncludeSubtasks));
    const toggleIncludeSubtasks = (event, analyticsEvent)=>{
        dispatch((0, $lHBhO.toggleIncludeSubtasks)());
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'includeSubtasks', {
            includeSubtasks: !includeSubtasks
        });
    };
    const filterUnassignedAssignees = assignees.filter((assignee)=>assignee.name !== undefined);
    const unassigned = (0, $5uXOq.useMemo)(()=>assignees.find((assignee)=>assignee.name === undefined), [
        assignees
    ]);
    return filterUnassignedAssignees.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKURq.default), {
        assignees: filterUnassignedAssignees,
        estimationType: estimationType,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        unassigned: unassigned,
        sprintName: sprintName,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: toggleIncludeSubtasks
    }) : null;
};
var $95b2bec0c05c9822$export$2e2bcd8739ae039 = $95b2bec0c05c9822$var$WorkLoadByAssigneeContainer;

});
parcelRegister("iKURq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cffc08c0c6f576c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dWTaZ = parcelRequire("dWTaZ");

var $7ZfjH = parcelRequire("7ZfjH");

var $9T1wg = parcelRequire("9T1wg");

var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXc3K = parcelRequire("iXc3K");

var $8zOmE = parcelRequire("8zOmE");

var $2zsgE = parcelRequire("2zsgE");

var $bNQzi = parcelRequire("bNQzi");

var $fp05h = parcelRequire("fp05h");

var $iDrrO = parcelRequire("iDrrO");
const $5cffc08c0c6f576c$var$wrapperStyles = null;
const $5cffc08c0c6f576c$var$containerStyles = null;
const $5cffc08c0c6f576c$var$IconComponent = ()=>(0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZfjH))), {
        label: "More actions",
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))),
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))), {
        label: "More actions",
        primaryColor: "var(--ds-icon, #44546F)"
    });
const $5cffc08c0c6f576c$var$WorkLoadByAssigneeView = ({ assignees: assignees, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, sprintName: sprintName, unassigned: unassigned, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName, includeSubtasks: includeSubtasks, onToggleIncludeSubtasks: onToggleIncludeSubtasks })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onOpenModal = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        analyticsEvent && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openWorkloadModal');
    }, []);
    const firstTenAssignees = (0, $5uXOq.useMemo)(()=>assignees.slice(0, 10), [
        assignees
    ]);
    const assigneeCount = assignees.length;
    const unshownCount = assigneeCount > 10 ? assigneeCount - 10 : undefined;
    const onShowTooltip = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'workloadTooltipViewed');
    };
    const summaryModalProps = {
        sprintName: sprintName,
        assignees: assignees,
        unassigned: unassigned,
        isEstimationEnabled: isEstimationEnabled,
        isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
        estimationType: estimationType,
        timeTrackingOptions: timeTrackingOptions,
        estimationFieldName: estimationFieldName,
        includeSubtasks: includeSubtasks,
        onToggleIncludeSubtasks: onToggleIncludeSubtasks
    };
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'medium'
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bahv2br _16jlkb7n _1reo1wug _18m91wug _19pk1b66 _2hwxu2gc _19bvdlk8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _zulp1b66 _tkqh1txw _dvzt1h6o _1chiglyw _15zoidpf _g8ht1l7b _tp1zidpf _1olh1l7b _yp0n1h6o _1jot1txw"
        ])
    }, firstTenAssignees.map((assignee, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            onShow: onShowTooltip,
            key: `assignee-tool-tip-${index}`,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fp05h.default), {
                username: assignee.name ?? '',
                storyPoints: assignee.storyPoints,
                remainingTimeEstimateInSeconds: assignee.remainingTimeEstimateInSeconds,
                issueCount: assignee.issueCount,
                estimationType: estimationType,
                isEstimationEnabled: isEstimationEnabled,
                isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled,
                originalTimeEstimateInSeconds: assignee.originalTimeEstimateInSeconds,
                timeTrackingOptions: timeTrackingOptions,
                estimationFieldName: estimationFieldName
            }),
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
            src: assignee.profilePicture,
            appearance: "circle",
            name: assignee.name,
            size: "small",
            borderColor: "transparent"
        }))), unshownCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDrrO.default), {
        count: unshownCount,
        onClick: onOpenModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXc3K.ModalEntryPointIconButtonTrigger), {
        appearance: "subtle",
        entryPoint: (0, $bNQzi.workloadByAssigneeEntryPoint),
        entryPointProps: summaryModalProps,
        interactionName: "open-work-load-by-assignee-modal",
        id: "entryPointButtonTrigger",
        testId: "software-backlog.card-list.work-load-by-assignee.entry-point-button-trigger",
        icon: $5cffc08c0c6f576c$var$IconComponent,
        label: formatMessage((0, $2zsgE.default).openModalButtonAriaLabel),
        onClick: onOpenModal,
        modalProps: modalProps,
        useInternalModal: true
    })));
};
var $5cffc08c0c6f576c$export$2e2bcd8739ae039 = $5cffc08c0c6f576c$var$WorkLoadByAssigneeView;

});
parcelRegister("iXc3K", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointIconButtonTrigger", () => $b0e020063eb1351b$export$7d379857be6c65e7);

var $5uXOq = parcelRequire("5uXOq");

var $e0OK7 = parcelRequire("e0OK7");

var $2KAtx = parcelRequire("2KAtx");
function $b0e020063eb1351b$export$7d379857be6c65e7({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
            ref: ref,
            ...buttonProps
        }));
}

});

parcelRegister("2zsgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b204b315dd900d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $96b204b315dd900d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    },
    moreButtonIconLabel: {
        "id": "backlog.card-list.work-load-by-assignee.more-button-icon-label",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("bNQzi", function(module, exports) {

$parcel$export(module.exports, "workloadByAssigneeEntryPoint", () => $4797267b97a62cea$export$40038863d8211697);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $4797267b97a62cea$export$40038863d8211697 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("cHaAr")), {
        moduleId: "70c648cc"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cHaAr", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("2cKLs").then(()=>parcelRequire('a5k5R'));

});


parcelRegister("fp05h", function(module, exports) {

$parcel$export(module.exports, "default", () => $9663c285b7dbeb29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $etKNj = parcelRequire("etKNj");

var $guzeq = parcelRequire("guzeq");

var $3jxXQ = parcelRequire("3jxXQ");
const $9663c285b7dbeb29$var$containerStyles = null;
const $9663c285b7dbeb29$var$containerP = null;
const $9663c285b7dbeb29$var$TooltipContent = ({ username: username, storyPoints: storyPoints, remainingTimeEstimateInSeconds: remainingTimeEstimateInSeconds, originalTimeEstimateInSeconds: originalTimeEstimateInSeconds, issueCount: issueCount, estimationType: estimationType, isEstimationEnabled: isEstimationEnabled, isRemainingTimeTrackingEnabled: isRemainingTimeTrackingEnabled, timeTrackingOptions: timeTrackingOptions, estimationFieldName: estimationFieldName })=>{
    const intl = (0, $koVbs.default)();
    const { formatMessage: formatMessage } = intl;
    const isShowTimeEstimateVisible = isEstimationEnabled && estimationType === (0, $guzeq.ORIGINAL_ESTIMATE);
    const isStoryPointsVisible = isEstimationEnabled && estimationType === (0, $guzeq.STORY_POINTS);
    const remainingTimeEstimate = (0, $5uXOq.useMemo)(()=>(0, $etKNj.timeTrackingFormatter)(remainingTimeEstimateInSeconds, timeTrackingOptions, intl), [
        remainingTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimate = (0, $5uXOq.useMemo)(()=>(0, $etKNj.timeTrackingFormatter)(originalTimeEstimateInSeconds, timeTrackingOptions, intl), [
        originalTimeEstimateInSeconds,
        timeTrackingOptions,
        intl
    ]);
    const originalTimeEstimateField = (0, $5uXOq.useMemo)(()=>`${originalTimeEstimate} ${estimationFieldName.toLowerCase()}`, [
        originalTimeEstimate,
        estimationFieldName
    ]);
    const numericEstimateField = (0, $5uXOq.useMemo)(()=>`${storyPoints} ${estimationFieldName.toLowerCase()}`, [
        storyPoints,
        estimationFieldName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_vwz4pxbi _1wybutpp _1yt41b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, username), isStoryPointsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, numericEstimateField), isShowTimeEstimateVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, originalTimeEstimateField), isRemainingTimeTrackingEnabled && isEstimationEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $3jxXQ.default).remainingTimeEstimate, {
        remainingTimeEstimate: remainingTimeEstimate
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ])
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3jxXQ.default).issueCountIssueTermRefresh : (0, $3jxXQ.default).issueCount, {
        issueCount: issueCount
    })));
};
var $9663c285b7dbeb29$export$2e2bcd8739ae039 = $9663c285b7dbeb29$var$TooltipContent;

});
parcelRegister("3jxXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cad33223b72712$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7cad33223b72712$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    remainingTimeEstimate: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.remaining-time-estimate",
        "defaultMessage": "{remainingTimeEstimate} remaining time estimate"
    },
    issueCount: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.issue-count",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}}"
    },
    issueCountIssueTermRefresh: {
        "id": "backlog.card-list.work-load-by-assignee.tooltip-content.issue-count-issue-term-refresh",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}}"
    }
});

});


parcelRegister("iDrrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a9b51e293d32e2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dWTaZ = parcelRequire("dWTaZ");

var $koVbs = parcelRequire("koVbs");

var $iNmtw = parcelRequire("iNmtw");
const $96a9b51e293d32e2$var$UnshownCount = ({ count: count, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        appearance: "circle",
        size: "small",
        onClick: onClick
    }, ({ testId: _, className: className, ref: ref, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
            "aria-label": formatMessage((0, $iNmtw.default).openModalButtonAriaLabel),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bwpsq.default)([
                "_11c81vlj _abyqc8hx _bfhk155y _19itglyw _16qsglyw _irr3u9me",
                className
            ]),
            ...props
        }, `+${count}`));
};
var $96a9b51e293d32e2$export$2e2bcd8739ae039 = $96a9b51e293d32e2$var$UnshownCount;
const $96a9b51e293d32e2$var$buttonStyles = null;

});
parcelRegister("iNmtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0677d583243d182$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b0677d583243d182$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openModalButtonAriaLabel: {
        "id": "backlog.card-list.work-load-by-assignee.unshown-count.open-modal-button-aria-label",
        "defaultMessage": "Open workload by assignee summary modal"
    }
});

});






parcelRegister("X8Rcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $9faef35b547e44b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ew1Lk = parcelRequire("ew1Lk");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1lTah = parcelRequire("1lTah");
function $9faef35b547e44b9$export$2e2bcd8739ae039() {
    const intl = (0, $koVbs.default)();
    const boardName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ew1Lk.DocumentTitle), {
        title: intl.formatMessage((0, $1lTah.default).pageTitle, {
            boardName: boardName
        })
    });
}

});
parcelRegister("ew1Lk", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $41b549fa18234081$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $6nkVm = parcelRequire("6nkVm");

class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $6nkVm.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nkVm.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("1lTah", function(module, exports) {

$parcel$export(module.exports, "default", () => $528e1098b3036ec0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $528e1098b3036ec0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "backlog.document-title.page-title",
        "defaultMessage": "{boardName} - Backlog"
    }
});

});


parcelRegister("aPfpu", function(module, exports) {

$parcel$export(module.exports, "FiltersStorage", () => $1b96912253cd199c$export$311c7d3073893ae);

var $5uXOq = parcelRequire("5uXOq");

var $wKznQ = parcelRequire("wKznQ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $fSgHa = parcelRequire("fSgHa");
const $1b96912253cd199c$export$311c7d3073893ae = ()=>{
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const filters = (0, $c1MAf.useBacklogSelector)((state)=>state.ui.filters);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBacklog) (0, $wKznQ.setCachedFilters)('backlog', boardId, filters);
    }, [
        boardId,
        filters,
        isCMPBacklog
    ]);
    return null;
};

});
parcelRegister("wKznQ", function(module, exports) {

$parcel$export(module.exports, "getCachedFilters", () => $a26a3456dc06172d$export$cc165fee46da38d4);
$parcel$export(module.exports, "setCachedFilters", () => $a26a3456dc06172d$export$fb56bc6b9e534664);

var $bSSG7 = parcelRequire("bSSG7");
const $a26a3456dc06172d$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $a26a3456dc06172d$var$CACHED_FILTERS_KEY = 'filters';
const $a26a3456dc06172d$var$getKey = (feature, projectId)=>`${feature}-${$a26a3456dc06172d$var$CACHED_FILTERS_KEY}.${projectId}`;
function $a26a3456dc06172d$export$cc165fee46da38d4(feature, projectId) {
    return $a26a3456dc06172d$var$localStorage.get($a26a3456dc06172d$var$getKey(feature, projectId)) || undefined;
}
function $a26a3456dc06172d$export$fb56bc6b9e534664(feature, projectId, filters) {
    if (filters && Object.entries(filters).length > 0) $a26a3456dc06172d$var$localStorage.set($a26a3456dc06172d$var$getKey(feature, projectId), filters);
    else $a26a3456dc06172d$var$localStorage.remove($a26a3456dc06172d$var$getKey(feature, projectId));
}

});


parcelRegister("bzlhL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7129ab0f59cd4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dF9Z3 = parcelRequire("dF9Z3");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
function $5b7129ab0f59cd4a$export$2e2bcd8739ae039() {
    const numCards = (0, $c1MAf.useBacklogSelector)((state)=>Object.keys((0, $dGljH.getCards)(state)).length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF9Z3.default), {
        analyticsAttributes: {
            numCards: numCards
        }
    });
}

});
parcelRegister("dF9Z3", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $3300b05877fade72$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $3300b05877fade72$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $3300b05877fade72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");
const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $3300b05877fade72$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $5uXOq.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $8zOmE.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;

});


parcelRegister("aammX", function(module, exports) {

$parcel$export(module.exports, "default", () => $89535920340e6239$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $jS4lj = parcelRequire("jS4lj");

var $cS37j = parcelRequire("cS37j");

var $7XYc4 = parcelRequire("7XYc4");

var $1asmd = parcelRequire("1asmd");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $1z1J7 = parcelRequire("1z1J7");

var $eKQP4 = parcelRequire("eKQP4");

var $4hApq = parcelRequire("4hApq");

var $bONT7 = parcelRequire("bONT7");

var $bmw3d = parcelRequire("bmw3d");
const $89535920340e6239$export$2676d4da338c3ba1 = (state)=>(0, $1z1J7.canEditBoardConfig)(state) || (0, $jG5HW.getIsCompanyManaged)(state);
function $89535920340e6239$var$HeaderNew(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $c1MAf.useBacklogSelector)($89535920340e6239$export$2676d4da338c3ba1);
    const isFilterSelectionBarOpen = (0, $iDGXn.useShowQuickFilters)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1asmd.PageTopBar), {
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $89535920340e6239$var$controlsBarWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hApq.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        })),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKQP4.ActionsBar), {
            isMenuVisible: isMenuVisible
        }),
        wrapAtMd: true
    }), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bONT7.default), null));
}
function $89535920340e6239$var$HeaderOld(props) {
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = props;
    const isMenuVisible = (0, $c1MAf.useBacklogSelector)($89535920340e6239$export$2676d4da338c3ba1);
    const boardType = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBoardType));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        truncateTitle: true,
        breadcrumbs: $89535920340e6239$var$breadcrumbs,
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hApq.default), {
            customFiltersQueryRef: customFiltersQueryRef,
            versionFilterRelayQueryRef: versionFilterRelayQueryRef
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKQP4.ActionsBar), {
            isMenuVisible: isMenuVisible,
            boardType: boardType
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$var$HeadingStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$var$TruncatingTextStyle, null, formatMessage((0, $bmw3d.default).pageTitle))));
}
var $89535920340e6239$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $89535920340e6239$var$HeaderNew, $89535920340e6239$var$HeaderOld);
const $89535920340e6239$var$controlsBarWrapper = (0, $jJ1Sb.xcss)({
    // enough width to fit expanded search + avatar filter + clear filters button
    minWidth: '480px',
    display: 'flex',
    alignItems: 'end',
    flex: '1 1 auto'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $89535920340e6239$export$c7432936d9c50db7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11w3glyw",
            __cmplp.className
        ])
    });
});
const $89535920340e6239$var$breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($89535920340e6239$export$c7432936d9c50db7, {
    "data-fullscreen-id": "fullscreen-backlog-breadcrumbs"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89535920340e6239$var$HeadingStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89535920340e6239$var$TruncatingTextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jYIE = parcelRequire("1jYIE");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jYIE.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1jYIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $622b85ee800d74dc$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $5uXOq = parcelRequire("5uXOq");

var $fIdIO = parcelRequire("fIdIO");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $622b85ee800d74dc$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fIdIO.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $622b85ee800d74dc$export$2e2bcd8739ae039 = $622b85ee800d74dc$var$PageHeader;

});
parcelRegister("fIdIO", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $63eaf4260decdc00$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $63eaf4260decdc00$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $63eaf4260decdc00$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $63eaf4260decdc00$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $63eaf4260decdc00$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $63eaf4260decdc00$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");
function $63eaf4260decdc00$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63eaf4260decdc00$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $63eaf4260decdc00$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $63eaf4260decdc00$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $63eaf4260decdc00$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $63eaf4260decdc00$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $63eaf4260decdc00$var$titleContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $63eaf4260decdc00$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $63eaf4260decdc00$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $63eaf4260decdc00$var$bottomBarStyles = (0, $jJ1Sb.xcss)({
    marginBlockStart: 'space.200'
});
const $63eaf4260decdc00$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$outerStyles
    }, children);
};
const $63eaf4260decdc00$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("h1", {
        css: [
            $63eaf4260decdc00$var$titleStyles,
            truncateTitle && $63eaf4260decdc00$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $63eaf4260decdc00$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleWrapperStyles,
            truncateTitle && $63eaf4260decdc00$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $63eaf4260decdc00$var$titleContainerStyles,
            truncateTitle && $63eaf4260decdc00$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $63eaf4260decdc00$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $63eaf4260decdc00$var$actionStyles
    }, children);
};
const $63eaf4260decdc00$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6T4rd.default), {
        xcss: $63eaf4260decdc00$var$bottomBarStyles
    }, children);
};

});



parcelRegister("1asmd", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $a509d50a7a06aca2$export$7e5801dc91bf1819);

var $5uXOq = parcelRequire("5uXOq");

var $6T4rd = parcelRequire("6T4rd");
var $2MVcM = parcelRequire("2MVcM");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $cS37j = parcelRequire("cS37j");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

const $a509d50a7a06aca2$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$90c4434a1e138106),
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $a509d50a7a06aca2$var$wrapperStyles : $a509d50a7a06aca2$var$wrapperStylesOld,
            wrapAtMd ? $a509d50a7a06aca2$var$wrapAtMdStyle : $a509d50a7a06aca2$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$1742330ac6a668f0),
        xcss: [
            $a509d50a7a06aca2$var$actionsBoxStyles,
            wrapAtMd && $a509d50a7a06aca2$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $a509d50a7a06aca2$export$7e5801dc91bf1819 = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a509d50a7a06aca2$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), props);
const $a509d50a7a06aca2$var$noWrapStyle = (0, $jJ1Sb.xcss)({
    flexWrap: 'nowrap'
});
const $a509d50a7a06aca2$var$wrapAtMdStyle = (0, $jJ1Sb.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $2MVcM.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $a509d50a7a06aca2$var$wrapperStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.250',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $2MVcM.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$wrapperStylesOld = (0, $jJ1Sb.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $2MVcM.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$actionsBoxAtMdStyles = (0, $jJ1Sb.xcss)({
    flex: '1 1 auto',
    [(0, $2MVcM.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $a509d50a7a06aca2$var$actionsBoxStyles = (0, $jJ1Sb.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $2fd65ab7d0fa0d2a$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $2fd65ab7d0fa0d2a$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("eKQP4", function(module, exports) {

$parcel$export(module.exports, "ActionsBar", () => $af50ae0f8b822d38$export$8c8e9293b68041de);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $foBuY = parcelRequire("foBuY");

var $fHbE4 = parcelRequire("fHbE4");
var $dsFR3 = parcelRequire("dsFR3");
var $2MVcM = parcelRequire("2MVcM");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $e0kZI = parcelRequire("e0kZI");

var $2ZySJ = parcelRequire("2ZySJ");

var $k9JTq = parcelRequire("k9JTq");

var $dCm1o = parcelRequire("dCm1o");

var $1fyfD = parcelRequire("1fyfD");

var $c1MAf = parcelRequire("c1MAf");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $k35me = parcelRequire("k35me");

var $czw5V = parcelRequire("czw5V");

var $fxbvZ = parcelRequire("fxbvZ");

var $iLlDl = parcelRequire("iLlDl");

var $jzmeD = parcelRequire("jzmeD");

var $i03cI = parcelRequire("i03cI");

var $lHl5z = parcelRequire("lHl5z");

var $fFw8N = parcelRequire("fFw8N");
const $af50ae0f8b822d38$var$ActionsBarNew = ({ isMenuVisible: isMenuVisible })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbedView = (0, $4R6GH.fg)('enable_backlog_smartlink_route') ? (0, $1fyfD.useIsEmbedView)() : false;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const appEditions = (0, $k9JTq.useAppEditions)();
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const backlogWithSprints = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const handleOnToggle = (0, $5uXOq.useCallback)((panelType)=>{
        dispatch((0, $9g0YE.togglePanel)(panelType));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        justifyContent: "end",
        wrap: "wrap",
        alignItems: (0, $dCm1o.isVisualRefreshEnabled)() ? 'center' : undefined
    }, !(0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), {
        justifyContent: "end",
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $af50ae0f8b822d38$var$extensionsStyles : $af50ae0f8b822d38$var$extensionsStylesOld
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxbvZ.default), null), isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: "plan"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $foBuY.default), null, !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzmeD.FullscreenButton), {
        boardId: Number(rapidViewId)
    })), backlogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i03cI.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: Number(rapidViewId),
        edition: appEditions.software
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fFw8N.default), null), isMenuVisible && !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLlDl.default), null)));
};
const $af50ae0f8b822d38$var$ActionsBarOld = ({ isMenuVisible: isMenuVisible, boardType: boardType })=>{
    const isEmbedView = (0, $1fyfD.useIsEmbedView)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const shareContentType = `${boardType}_backlog`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onShareButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'shareContentType', {
            contentType: shareContentType
        });
    };
    const iconsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxbvZ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHl5z.ShareButton), {
        shareContentType: shareContentType,
        onTriggerButtonClick: onShareButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jzmeD.FullscreenButton), {
        boardId: Number(rapidViewId)
    }));
    return isEmbedView ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af50ae0f8b822d38$var$ActionsBarWrapper, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.100"
    }, iconsComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHbE4.default), null, iconsComponent), isCompanyManaged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
        boardId: rapidViewId,
        projectKey: projectKey,
        mode: "plan"
    }), isMenuVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af50ae0f8b822d38$var$MenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iLlDl.default), null)) : null);
};
const $af50ae0f8b822d38$export$8c8e9293b68041de = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)(), $af50ae0f8b822d38$var$ActionsBarNew, $af50ae0f8b822d38$var$ActionsBarOld);
const $af50ae0f8b822d38$var$extensionsStylesOld = (0, $jJ1Sb.xcss)({
    paddingBottom: 'space.100',
    gap: 'space.100',
    width: '100%',
    flex: '0 1 auto',
    flexWrap: 'wrap',
    [(0, $2MVcM.media).above.md]: {
        flex: '0 0 auto',
        flexWrap: 'wrap'
    }
});
const $af50ae0f8b822d38$var$extensionsStyles = (0, $jJ1Sb.xcss)({
    paddingBottom: 'space.100',
    gap: 'space.100',
    width: '100%',
    flex: '0 1 auto',
    flexWrap: 'wrap',
    [(0, $2MVcM.media).above.md]: {
        flex: '0 0 auto',
        flexWrap: 'wrap'
    },
    ':empty': {
        display: 'none'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af50ae0f8b822d38$var$ActionsBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $af50ae0f8b822d38$var$MenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e0kZI", function(module, exports) {

$parcel$export(module.exports, "BoardConnectToolbar", () => $4677f90b43f839a0$export$afbfa45d45a0cda1);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");
function $4677f90b43f839a0$var$BoardConnectToolbarInner({ boardId: boardId, projectKey: projectKey, mode: mode }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    if (!toolSections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections
    });
}
function $4677f90b43f839a0$export$afbfa45d45a0cda1(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-toolbar",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4677f90b43f839a0$var$BoardConnectToolbarInner, props));
}

});

parcelRegister("2ZySJ", function(module, exports) {

$parcel$export(module.exports, "ImportWorkButton", () => $650ab30d4dd366bc$export$311dc74043c51081);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $hPtZI = parcelRequire("hPtZI");


var $8kda3 = parcelRequire("8kda3");

const $650ab30d4dd366bc$export$1d333e4178627a87 = (0, $hPtZI.lazy)(()=>(parcelRequire("jpl8s")).then(({ ImportWorkButtonInternal: ImportWorkButtonInternal })=>ImportWorkButtonInternal), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-invites/src/ui/import-work-button/index.tsx"
});
const $650ab30d4dd366bc$var$ImportWorkButtonWithTargeting = ()=>{
    const isTargeted = (0, $8kda3.useIsTargetedForRaisingAwarenessOfImporter)();
    return isTargeted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$export$1d333e4178627a87, null) : null;
};
const $650ab30d4dd366bc$export$311dc74043c51081 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "importWorkButton",
        packageName: (0, $daef8268a41061ca$export$b8b9d90f9e5bd72b),
        teamName: (0, $daef8268a41061ca$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$var$ImportWorkButtonWithTargeting, null));

});
const $daef8268a41061ca$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingInvites';
const $daef8268a41061ca$export$d57b6b390e78d90f = 'jlove-makkuro';
const $daef8268a41061ca$export$719991a6cc456f06 = 'software-onboarding-invites.ui.import-work-button.button';

parcelRegister("8kda3", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForRaisingAwarenessOfImporter", () => $8571e29361584ab7$export$c45655b60f7ebf1c);

var $2vSU6 = parcelRequire("2vSU6");

var $9y6jE = parcelRequire("9y6jE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $8571e29361584ab7$export$c45655b60f7ebf1c = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const isWithin30Day = (0, $9y6jE.useIsFirstActivationDateWithinLast30Days)();
    const isSoftwareProject = data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return data?.simplified && isSiteAdmin && isWithin30Day && edition === (0, $ldyPw.FREE_EDITION) && isSoftwareProject;
};

});
parcelRegister("9y6jE", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $e7cd4e878e1b25bc$export$f561835faf21b733);

var $dkqym = parcelRequire("dkqym");

var $at4B6 = parcelRequire("at4B6");
const $e7cd4e878e1b25bc$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    return (0, $at4B6.isWithinLast30Days)(firstActivationDate);
};

});
parcelRegister("dkqym", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $61794ef454831b86$export$9df3a539e50a284b);

var $9OXo1 = parcelRequire("9OXo1");
const $61794ef454831b86$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});

parcelRegister("at4B6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast30Days", () => $6d4f0d42d84e1d91$export$550dea1ca60eaa64);

var $iS3m6 = parcelRequire("iS3m6");
const $6d4f0d42d84e1d91$export$550dea1ca60eaa64 = (0, $iS3m6.isWithinLast)({
    days: 30
});

});
parcelRegister("iS3m6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $8541d32f174f7876$export$15bc1a874225842d);

var $59y5F = parcelRequire("59y5F");

var $dQChl = parcelRequire("dQChl");

var $2xkYZ = parcelRequire("2xkYZ");
const $8541d32f174f7876$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $59y5F.default)(date)) return false;
        const end = Date.now();
        const start = (0, $2xkYZ.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $dQChl.default)({
            start: start,
            end: end
        })(date);
    };

});




parcelRegister("jpl8s", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8bhUA").then(()=>parcelRequire('eK5YJ'));

});


parcelRegister("fxbvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de2f583b030ce80$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCgfP = parcelRequire("eCgfP");

var $c1MAf = parcelRequire("c1MAf");

var $iY49l = parcelRequire("iY49l");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5de2f583b030ce80$export$2e2bcd8739ae039 = ()=>{
    const operations = (0, $c1MAf.useBacklogSelector)((0, $iY49l.operationsSelector));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCgfP.default), {
        operations: operations
    });
};

});
parcelRegister("eCgfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $30adade8afbc4e74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3HwlS = parcelRequire("3HwlS");

var $9AYKy = parcelRequire("9AYKy");
function $30adade8afbc4e74$export$2e2bcd8739ae039(props) {
    if ((0, $3HwlS.getWillShowNav4)()) {
        if (props.operations.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
                key: op.url,
                operation: op,
                onModalClose: props.onModalClose
            })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30adade8afbc4e74$var$OperationWrapper, {
            key: op.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
            operation: op,
            onModalClose: props.onModalClose
        }))));
}
$30adade8afbc4e74$export$2e2bcd8739ae039.defaultProps = {
    operations: [],
    onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30adade8afbc4e74$var$OperationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9AYKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b405f55a447be3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $hdlWZ = parcelRequire("hdlWZ");

var $dfL30 = parcelRequire("dfL30");

var $6PItG = parcelRequire("6PItG");

var $MGmIU = parcelRequire("MGmIU");

var $jjlQu = parcelRequire("jjlQu");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $40b405f55a447be3$var$iconSize = (0, $gwIPs.gridSize) * 3;
class $40b405f55a447be3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            operation: {},
            onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    static{
        this.getFallbackIcon = (name)=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hdlWZ))), {
                label: name,
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dfL30))), {
                size: "medium",
                label: name
            });
    }
    /*
   * ABE-22: The reason for using this 'invisible' anchor with an href is needed, instead of simply
   * passing the href to the component which would then have an underlying anchor, is that the
   * styleClasses list of classes here are needed to trigger the ecosystem addon modal to come
   * up on click. This is in contrast to the component behaviour of a vanilla anchor that
   * currently does not support custom classes, which would redirect to a Jira 404 error page.
   */ renderEcosystemModalLink() {
        const { url: url, styleClass: styleClass } = this.props.operation;
        return(// go/jfe-eslint
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: url,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass,
            ref: this.setEcosystemModalLinkRef,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none'
            }
        }));
    }
    renderIcon() {
        const { icon: icon, name: name } = this.props.operation;
        return icon && icon.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            title: name,
            url: icon.url,
            width: $40b405f55a447be3$var$iconSize,
            height: $40b405f55a447be3$var$iconSize,
            fallback: ()=>$40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '')
        }) : $40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '');
    }
    renderButton() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
            iconBefore: name ? icon : null
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    renderMenuItem() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            iconBefore: name ? icon : null
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    render() {
        const { tooltip: tooltip } = this.props.operation;
        const content = (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4') ? this.renderMenuItem() : this.renderButton();
        if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: tooltip
        }, content);
        return content;
    }
    constructor(...args){
        super(...args);
        /* not used yet TOTEM-818 */ this.onModalClose = ()=>this.props.onModalClose();
        this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        };
        this.clickEcosystemModalLinkRef = ()=>{
            this.ecosystemModalLinkRef && this.ecosystemModalLinkRef.click();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40b405f55a447be3$var$OnlyIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});


parcelRegister("iY49l", function(module, exports) {

$parcel$export(module.exports, "operationsSelector", () => $aa236735a293475b$export$5244c0030b3a418e);
const $aa236735a293475b$export$5244c0030b3a418e = (state)=>state.config.extension.operations;

});


parcelRegister("iLlDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8ec5296cbf43a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e0OK7 = parcelRequire("e0OK7");

var $89thI = parcelRequire("89thI");

var $7ZfjH = parcelRequire("7ZfjH");

var $9T1wg = parcelRequire("9T1wg");

var $lm9d2 = parcelRequire("lm9d2");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dCm1o = parcelRequire("dCm1o");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $ffAwz = parcelRequire("ffAwz");

var $lt367 = parcelRequire("lt367");
const $8f8ec5296cbf43a9$var$BacklogPopupMenu = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // from old props
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const canEditBoardConfigProp = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditBoardConfig));
    const shouldShowDetailViewItem = (0, $c1MAf.useBacklogSelector)((state)=>!(0, $dGljH.isBacklogEmptySelector)(state));
    const shouldShowEpicAsPanel = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const shouldShowVersionsPanel = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        analyticsEvent.update({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        isOpen
    ]);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'backlogHeaderMenu');
    }, [
        createAnalyticsEvent
    ]);
    const getMoreIcon = ()=>(0, $4R6GH.fg)('tnk-1620-visual-refresh-software-backlog-icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZfjH))), {
            label: formatMessage((0, $lt367.default).dropdownAriaLabel),
            color: "var(--ds-icon, #44546F)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9T1wg))), {
            label: formatMessage((0, $lt367.default).dropdownAriaLabel),
            primaryColor: "var(--ds-icon, #44546F)"
        });
    const renderTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() || (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7ZfjH))),
            label: formatMessage((0, $lt367.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            isTooltipDisabled: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            ...triggerProps,
            iconBefore: getMoreIcon(),
            isSelected: isOpen,
            onClick: handleClick
        }));
    const renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffAwz.default), {
            canEditBoardConfig: canEditBoardConfigProp,
            isCompanyManaged: isCompanyManaged,
            shouldShowDetailViewItem: shouldShowDetailViewItem,
            shouldShowEpicAsPanel: shouldShowEpicAsPanel,
            shouldShowVersionsPanel: shouldShowVersionsPanel,
            onClosePopup: handleClose
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.default), {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: renderContent,
        trigger: renderTrigger
    });
};
var $8f8ec5296cbf43a9$export$2e2bcd8739ae039 = $8f8ec5296cbf43a9$var$BacklogPopupMenu;

});
parcelRegister("ffAwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $247df5f67e9da735$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7df7o = parcelRequire("7df7o");
var $Hi7fY = parcelRequire("Hi7fY");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");

var $78UP2 = parcelRequire("78UP2");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $iY49l = parcelRequire("iY49l");

var $fxbvZ = parcelRequire("fxbvZ");

var $hhmH6 = parcelRequire("hhmH6");

var $bcdwp = parcelRequire("bcdwp");

var $ctQ5b = parcelRequire("ctQ5b");

var $8fQBb = parcelRequire("8fQBb");
const $247df5f67e9da735$var$BacklogMenuContentOld = ({ isCompanyManaged: isCompanyManaged, canEditBoardConfig: canEditBoardConfig, onClosePopup: onClosePopup })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7df7o.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hhmH6.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan"
    }), canEditBoardConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcdwp.CreateBoardMenuItem), {
        onClosePopup: onClosePopup
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctQ5b.default), {
        isDisabled: !canEditBoardConfig
    })));
};
const $247df5f67e9da735$var$BacklogMenuContentNew = ({ isCompanyManaged: isCompanyManaged, canEditBoardConfig: canEditBoardConfig, onClosePopup: onClosePopup })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const hasOperations = (0, $c1MAf.useBacklogSelector)((0, $iY49l.operationsSelector)).length > 0;
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'plan'
    });
    const shouldRenderSection = (0, $5uXOq.useMemo)(()=>{
        const connectMenuItemLocations = [
            'board-tools-1',
            'view-actions-print'
        ];
        return Boolean(toolSections && (connectMenuItemLocations.map((location)=>((0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length ?? 0) > 0).includes(true) || toolSections?.filter((section)=>section.id !== 'board-tools-section').length > 0));
    }, [
        toolSections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7df7o.default), {
        maxWidth: 240
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), null, isCompanyManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hhmH6.default), null), canEditBoardConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bcdwp.CreateBoardMenuItem), {
        onClosePopup: onClosePopup
    }), (0, $4R6GH.fg)('jira_nav4_eap_drop_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8fQBb.BoardConnectItems), {
        projectKey: projectKey,
        boardId: boardId
    }) : shouldRenderSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "plan"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctQ5b.default), {
        isDisabled: !canEditBoardConfig
    }), hasOperations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fxbvZ.default), null)))));
};
const $247df5f67e9da735$var$BacklogMenuContent = (0, $7XYc4.componentWithCondition)(()=>(0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4'), $247df5f67e9da735$var$BacklogMenuContentNew, $247df5f67e9da735$var$BacklogMenuContentOld);
var $247df5f67e9da735$export$2e2bcd8739ae039 = $247df5f67e9da735$var$BacklogMenuContent;

});
parcelRegister("e8X1M", function(module, exports) {

$parcel$export(module.exports, "BoardConnectMenuItems", () => $7ffeafe4bb5b3117$export$d8d46adb5b629caf);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $fjfkx = parcelRequire("fjfkx");

var $2NYED = parcelRequire("2NYED");

var $fNWqR = parcelRequire("fNWqR");

var $78UP2 = parcelRequire("78UP2");
function $7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner({ projectKey: projectKey, boardId: boardId, location: location, mode: mode, onClickWebItem: onClickWebItem }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const targetSection = (0, $5uXOq.useMemo)(()=>toolSections && location && (0, $78UP2.findSection)(toolSections, location), [
        toolSections,
        location
    ]);
    if (!location && (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('move-connect-addons-board-backlog-nav4')) return toolSections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections,
        mode: "dropdown-item"
    }) : null;
    if (!toolSections || !targetSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetSection.subItems?.filter((item)=>item.id != null) // built-in items don't have IDs set
    .map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            onClickWebItem: onClickWebItem,
            key: item.id,
            subItem: item
        })) ?? null);
}
function $7ffeafe4bb5b3117$export$d8d46adb5b629caf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-menu-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner, props));
}

});

parcelRegister("hhmH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $55821056826b5b99$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jJ62p = parcelRequire("jJ62p");

var $dJl1T = parcelRequire("dJl1T");

var $koVbs = parcelRequire("koVbs");

var $dIdda = parcelRequire("dIdda");

var $l4fDC = parcelRequire("l4fDC");
const $55821056826b5b99$export$444102a091dc311d = ()=>{
    const defaultValue = 'filter';
    try {
        const value = localStorage.getItem('selectedConfigTab');
        return value ? JSON.parse(value) : defaultValue;
    } catch (err) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('software-backlog.header.menu.configure-board-item.dropdown-item', `Error reading "selectedConfigTab" value: ${err}`);
        return defaultValue;
    }
};
const $55821056826b5b99$export$cc501cfa2aa02d4e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectedConfigTab = $55821056826b5b99$export$444102a091dc311d();
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const url = `${location.pathname}?config=${selectedConfigTab}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ62p.default), {
        "data-testid": "software-backlog.header.menu.configure-board-item.dropdown-item",
        href: url
    }, formatMessage((0, $l4fDC.default).displayText));
};
var $55821056826b5b99$export$2e2bcd8739ae039 = $55821056826b5b99$export$cc501cfa2aa02d4e;

});
parcelRegister("l4fDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $285c52b1fe4c8d09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $285c52b1fe4c8d09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.configure-board-item.display-text",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("bcdwp", function(module, exports) {

$parcel$export(module.exports, "CreateBoardMenuItem", () => $a9a6640c869cb525$export$8b66d40068c85a7a);

var $5uXOq = parcelRequire("5uXOq");

var $6PItG = parcelRequire("6PItG");

var $dJl1T = parcelRequire("dJl1T");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hLpMG = parcelRequire("hLpMG");
function $a9a6640c869cb525$export$8b66d40068c85a7a({ onClosePopup: onClosePopup }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'createBoard clicked',
            actionSubject: 'menuItem'
        }), 'createBoard clicked');
        onClosePopup && onClosePopup();
        (0, $1ADgn.default)().catch((error)=>{
            (0, $dJl1T.default).safeErrorWithoutCustomerData('backlog.modal.create-board.failure', 'Failed to open legacy Create board dialog', error);
        });
    }, [
        createAnalyticsEvent,
        onClosePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        onClick: handleClick
    }, formatMessage((0, $hLpMG.messages).displayText));
}

});
parcelRegister("hLpMG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $039ae69d50f44352$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $039ae69d50f44352$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.create-board.display-text",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("ctQ5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $290aca59c7cae385$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6PItG = parcelRequire("6PItG");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dIdda = parcelRequire("dIdda");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $7M9S7 = parcelRequire("7M9S7");
const $290aca59c7cae385$export$84a62bf03b005a81 = (boardUrl)=>`${boardUrl}/custom-filters`;
const $290aca59c7cae385$export$538689bb697618b7 = ({ isDisabled: isDisabled })=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $dIdda.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const url = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickManageCustomFilterItem');
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        isDisabled: isDisabled,
        onClick: onClick
    }, formatMessage((0, $7M9S7.default).displayText));
};
var $290aca59c7cae385$export$2e2bcd8739ae039 = $290aca59c7cae385$export$538689bb697618b7;

});
parcelRegister("7M9S7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9613022e4de36e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f9613022e4de36e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "backlog.header.menu.manage-custom-filters-item.display-text",
        "defaultMessage": "Manage custom filters"
    }
});

});


parcelRegister("8fQBb", function(module, exports) {

$parcel$export(module.exports, "BoardConnectItems", () => $cc7e64a8f648369c$export$2843ddf118c543ac);

var $5uXOq = parcelRequire("5uXOq");

var $Hi7fY = parcelRequire("Hi7fY");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");
const $cc7e64a8f648369c$export$2843ddf118c543ac = ({ projectKey: projectKey, boardId: boardId })=>{
    const itemLocations = [
        'board-tools-1',
        'view-actions-print'
    ];
    const hasToolSections = (0, $fNWqR.useHasToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'plan',
        itemLocations: itemLocations
    });
    return hasToolSections && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Hi7fY.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        mode: "plan"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        mode: "plan"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "plan"
    }));
};

});


parcelRegister("lt367", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef9fee212e453f55$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef9fee212e453f55$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownAriaLabel: {
        "id": "backlog.header.menu.dropdown-aria-label",
        "defaultMessage": "Backlog menu"
    },
    buttonLabel: {
        "id": "backlog.header.menu.button-label",
        "defaultMessage": "More"
    }
});

});


parcelRegister("jzmeD", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $e7bca00c8a90878e$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $3HwlS = parcelRequire("3HwlS");

var $iDGXn = parcelRequire("iDGXn");
const $e7bca00c8a90878e$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $e7bca00c8a90878e$export$305be705ce696d42 = ({ boardId: boardId })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen
        });
    }, [
        boardId,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-backlog.header.actions-bar.fullscreen-button",
        getCustomRefs: $e7bca00c8a90878e$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: (0, $3HwlS.getWillShowNav4)()
    });
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $3ReDb = parcelRequire("3ReDb");

var $2bIP4 = parcelRequire("2bIP4");

var $MGmIU = parcelRequire("MGmIU");

var $3Tty1 = parcelRequire("3Tty1");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        globalStyle.id = 'fullscreen-global-style';
        globalStyle.appendChild(hiddenStylesNode);
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)()) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            onClick: onClick,
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($2bIP4))) : (0, (/*@__PURE__*/$parcel$interopDefault($3ReDb))),
            appearance: isSubtle ? 'subtle' : 'default',
            isTooltipDisabled: false
        });
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($2bIP4))) : (0, (/*@__PURE__*/$parcel$interopDefault($3ReDb))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bIP4))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ReDb))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            })
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ReDb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cf1abc216f43016$var$_react = $2cf1abc216f43016$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cf1abc216f43016$var$_growDiagonal = $2cf1abc216f43016$var$_interopRequireDefault((parcelRequire("l3rdB")));

var $2cf1abc216f43016$var$_actualSize = $2cf1abc216f43016$var$_interopRequireDefault((parcelRequire("2flr2")));
function $2cf1abc216f43016$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cf1abc216f43016$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $2cf1abc216f43016$var$_react.default.createElement($2cf1abc216f43016$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $2cf1abc216f43016$var$_actualSize.default
    }, props));
$2cf1abc216f43016$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $2cf1abc216f43016$var$_default = module.exports.default = $2cf1abc216f43016$var$GrowDiagonalIcon;

});
parcelRegister("l3rdB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f990ef7feacad13ce09338893186ed73>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f53efdccc9430dce$var$_react = $f53efdccc9430dce$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f53efdccc9430dce$var$_UNSAFE_baseNew = $f53efdccc9430dce$var$_interopRequireDefault((parcelRequire("huIZN")));
function $f53efdccc9430dce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f53efdccc9430dce$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $f53efdccc9430dce$var$_react.default.createElement($f53efdccc9430dce$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$f53efdccc9430dce$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $f53efdccc9430dce$var$_default = module.exports.default = $f53efdccc9430dce$var$GrowDiagonalIcon;

});

parcelRegister("2flr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a2d9c12573b0998$var$_react = $1a2d9c12573b0998$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $1a2d9c12573b0998$var$_growDiagonal = $1a2d9c12573b0998$var$_interopRequireDefault((parcelRequire("l3rdB")));
function $1a2d9c12573b0998$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a2d9c12573b0998$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1a2d9c12573b0998$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1a2d9c12573b0998$var$_growDiagonal.default
    }));
$1a2d9c12573b0998$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1a2d9c12573b0998$var$_default = module.exports.default = $1a2d9c12573b0998$var$MediaServicesActualSizeIcon;

});


parcelRegister("2bIP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b2e8bb6e01e7e0a7a6c4696ef5279cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $197f60b07781dff0$var$_react = $197f60b07781dff0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $197f60b07781dff0$var$_shrinkDiagonal = $197f60b07781dff0$var$_interopRequireDefault((parcelRequire("2ttaN")));

var $197f60b07781dff0$var$_fitToPage = $197f60b07781dff0$var$_interopRequireDefault((parcelRequire("fWoew")));
function $197f60b07781dff0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $197f60b07781dff0$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $197f60b07781dff0$var$_react.default.createElement($197f60b07781dff0$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $197f60b07781dff0$var$_fitToPage.default
    }, props));
$197f60b07781dff0$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $197f60b07781dff0$var$_default = module.exports.default = $197f60b07781dff0$var$ShrinkDiagonalIcon;

});
parcelRegister("2ttaN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::093b1e9b17ed5e0dd45627fbe3b0508b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1cd4eb6367c87463$var$_react = $1cd4eb6367c87463$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1cd4eb6367c87463$var$_UNSAFE_baseNew = $1cd4eb6367c87463$var$_interopRequireDefault((parcelRequire("huIZN")));
function $1cd4eb6367c87463$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1cd4eb6367c87463$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $1cd4eb6367c87463$var$_react.default.createElement($1cd4eb6367c87463$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
    }, props));
$1cd4eb6367c87463$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $1cd4eb6367c87463$var$_default = module.exports.default = $1cd4eb6367c87463$var$ShrinkDiagonalIcon;

});

parcelRegister("fWoew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9af1202cff75ff1$var$_react = $b9af1202cff75ff1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $b9af1202cff75ff1$var$_shrinkDiagonal = $b9af1202cff75ff1$var$_interopRequireDefault((parcelRequire("2ttaN")));
function $b9af1202cff75ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b9af1202cff75ff1$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $b9af1202cff75ff1$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $b9af1202cff75ff1$var$_shrinkDiagonal.default
    }));
$b9af1202cff75ff1$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $b9af1202cff75ff1$var$_default = module.exports.default = $b9af1202cff75ff1$var$MediaServicesFitToPageIcon;

});


parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9IeM0 = parcelRequire("9IeM0");

var $h0GOb = parcelRequire("h0GOb");

var $4lkOX = parcelRequire("4lkOX");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $7JoAD = parcelRequire("7JoAD");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $7JoAD.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});

parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $dJl1T = parcelRequire("dJl1T");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $dJl1T.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});


parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});




parcelRegister("i03cI", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $8350c37f9ee6e208$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1Klyc = parcelRequire("1Klyc");

var $7BuUr = parcelRequire("7BuUr");

var $cE2Qr = parcelRequire("cE2Qr");


var $3t5QD = parcelRequire("3t5QD");

var $5PP3a = parcelRequire("5PP3a");


var $fSgHa = parcelRequire("fSgHa");
const $8350c37f9ee6e208$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null })=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const onToggleHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle((0, $c35fd6591a78fffe$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $5PP3a.BacklogInsightsNudgeAsync),
        conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw-perf-backlog-insights-nudge-load') ? nudgeStep === (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619) : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});
parcelRegister("1Klyc", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsButton", () => $a676123686368d41$export$fc456a966efbe170);

var $5uXOq = parcelRequire("5uXOq");

var $MGmIU = parcelRequire("MGmIU");


var $9Y7dM = parcelRequire("9Y7dM");

var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $e9Bts = parcelRequire("e9Bts");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $4mJDy = parcelRequire("4mJDy");

var $aokXg = parcelRequire("aokXg");
const $a676123686368d41$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: formatMessage((0, $aokXg.default).tooltip)
    }, children);
};
const $a676123686368d41$var$BacklogInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { refreshUniqueId: refreshUniqueId, onDataUpdatedCallback: onDataUpdatedCallback, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            boardId: boardId,
            edition: edition,
            experienceId: uniqueId,
            projectId: projectId,
            userLocation: userLocation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9Bts.InsightsSettingsLoader), {
        boardId: boardId,
        onSettingsLoaded: onDataUpdatedCallback('settings')
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        boardId: boardId,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isCompact: isCompact,
        isHidden: !isProjectType,
        isInsightsPanelOpen: isOpen,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        onToggle: onToggle,
        renderTooltip: $a676123686368d41$var$ButtonTooltip
    })) : null;
};
const $a676123686368d41$var$BacklogInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBacklogScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a676123686368d41$var$BacklogInsightsButtonComponent, props));
};
const $a676123686368d41$var$BacklogInsightsButtonFinal = $a676123686368d41$var$BacklogInsightsButtonWithContainer;
const $a676123686368d41$var$SafeBacklogInsightsButton = (0, $2KxPr.withComponentSafety)($a676123686368d41$var$BacklogInsightsButtonFinal, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $4mJDy.BACKLOG_BUTTON_ID),
    message: ({ boardId: boardId })=>`Backlog button received invalid boardId: ${boardId}`
});
const $a676123686368d41$export$fc456a966efbe170 = (0, $1UEsW.WithInsightsErrorBoundary)($a676123686368d41$var$SafeBacklogInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("9Y7dM", function(module, exports) {

$parcel$export(module.exports, "permissionStatus", () => $0d3bfc9bd66c1fa3$export$b7019a8563593449);
const $0d3bfc9bd66c1fa3$export$b7019a8563593449 = {
    LOADING: 'LOADING',
    ALLOWED: 'ALLOWED',
    DISALLOWED: 'DISALLOWED'
};

});

parcelRegister("9YlLW", function(module, exports) {

$parcel$export(module.exports, "getMessageFromEstimationUnit", () => $74b4eed620b03a26$export$680a8efbdf2f2020);
$parcel$export(module.exports, "getCommonMessageDescriptorFromEstimationUnit", () => $74b4eed620b03a26$export$c0f3281b1c14f2e6);
$parcel$export(module.exports, "getEstimatedUnit", () => $74b4eed620b03a26$export$120f64ac447e3a5a);
$parcel$export(module.exports, "getUpdatedEstimation", () => $74b4eed620b03a26$export$5ec90264a55fd048);
$parcel$export(module.exports, "getPermissionEnum", () => $74b4eed620b03a26$export$8e09a9f3c4b56097);
$parcel$export(module.exports, "isValidBoardId", () => $74b4eed620b03a26$export$e168d1e9d0082d6a);

var $e4eHl = parcelRequire("e4eHl");

var $6s1PB = parcelRequire("6s1PB");


var $cpUUk = parcelRequire("cpUUk");

var $8uXQO = parcelRequire("8uXQO");
const $74b4eed620b03a26$export$680a8efbdf2f2020 = ({ estimationUnit: estimationUnit, messages: messages })=>{
    if (!messages[estimationUnit]) throw new Error(`Unsupported estimationUnit: ${estimationUnit} for ${JSON.stringify(messages)}`);
    return messages[estimationUnit];
};
const $74b4eed620b03a26$export$c0f3281b1c14f2e6 = (estimationUnit)=>{
    let issueTermRefreshSuffix = '';
    if (estimationUnit === 'ISSUE_COUNT' && (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) issueTermRefreshSuffix = 'IssueTermRefresh';
    const estimationUnitCamelCase = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(estimationUnit);
    const labelDescriptorName = `${estimationUnitCamelCase}Label${issueTermRefreshSuffix}`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    if (!(0, $8uXQO.messages)[labelDescriptorName]) throw new Error(`Unsupported estimationUnit: ${estimationUnit}, label not found for ${labelDescriptorName}} in ${JSON.stringify(Object.keys((0, $8uXQO.messages)))}`);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    return (0, $8uXQO.messages)[labelDescriptorName];
};
const $74b4eed620b03a26$export$120f64ac447e3a5a = (estimationUnit, estimation)=>{
    // these endpoints returning null shouldn't happen, so let's degrade gracefully
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return estimation.issueCount || 0;
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return estimation.storyPoints != null ? parseFloat(estimation.storyPoints.toFixed(1)) : 0;
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return estimation.time || 0;
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$5ec90264a55fd048 = (estimationUnit, estimation, value)=>{
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return {
                ...estimation,
                issueCount: value
            };
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return {
                ...estimation,
                storyPoints: value
            };
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return {
                ...estimation,
                time: value
            };
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$8e09a9f3c4b56097 = (value, defaultValue)=>value === null || value === undefined ? defaultValue : value;
const $74b4eed620b03a26$export$8081780e7051e8dd = (boardId)=>`print-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$9eca4630c417f1b = (boardId)=>`auto-expand-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$e168d1e9d0082d6a = ({ boardId: boardId })=>{
    // BoardId must be a positive integer
    if (boardId === undefined || boardId === null || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !(Number.isInteger(boardId) && boardId > 0)) return false;
    return true;
};
const $74b4eed620b03a26$export$2e033b8f7ea3f02a = ({ boardId: boardId })=>{
    if (typeof boardId !== 'string') return false;
    return /^[0-9]+$/.test(boardId) && Number.parseInt(boardId, 10) > 0;
};

});
const $b298cf836b53195d$export$5c425db6689b9aae = 'no-account-id';
const $b298cf836b53195d$export$bc8ae8b96c2da16b = 'no-board-id';

parcelRegister("cpUUk", function(module, exports) {

$parcel$export(module.exports, "EstimationUnit", () => $e74c6047a4f07896$export$65cc899e447718b8);
const $e74c6047a4f07896$export$65cc899e447718b8 = {
    STORY_POINTS: 'STORY_POINTS',
    ISSUE_COUNT: 'ISSUE_COUNT',
    TIME_TRACKING: 'TIME_TRACKING',
    OTHER: 'OTHER'
};
const $e74c6047a4f07896$export$c17e0027053340c = 'OTHER';

});

parcelRegister("8uXQO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34dd4dbb16b250cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $34dd4dbb16b250cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "insights-common.common.story-points",
        "defaultMessage": "{value, plural, one {point} other {points}}"
    },
    issueCount: {
        "id": "insights-common.common.issue-count",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    sprints: {
        "id": "insights-common.common.sprints",
        "defaultMessage": "{sprintCount, plural, one {sprint} other {sprints}}"
    },
    timeTrackingLabel: {
        "id": "insights-common.common.time-tracking-label",
        "defaultMessage": "time estimation"
    },
    storyPointsLabel: {
        "id": "insights-common.common.story-points-label",
        "defaultMessage": "story points"
    },
    issueCountLabel: {
        "id": "insights-common.common.issue-count-label",
        "defaultMessage": "issue count"
    },
    issueCountIssueTermRefresh: {
        "id": "insights-common.common.issue-count-issue-term-refresh",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    issueCountLabelIssueTermRefresh: {
        "id": "insights-common.common.issue-count-label-issue-term-refresh",
        "defaultMessage": "issue count"
    }
});

});


parcelRegister("7BuUr", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $8c56e783e1a84cd8$export$e2f83ae69f04608f);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c56e783e1a84cd8$var$isDefined = (value)=>value !== null && value !== undefined;
const $8c56e783e1a84cd8$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!$8c56e783e1a84cd8$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $8c56e783e1a84cd8$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $5uXOq.useMemo)(()=>$8c56e783e1a84cd8$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("0241A", function(module, exports) {

$parcel$export(module.exports, "useValueChangeEffect", () => $bc4d44bb107dee16$export$7dd9a2cc149d56b3);

var $5uXOq = parcelRequire("5uXOq");
const $bc4d44bb107dee16$export$7dd9a2cc149d56b3 = ({ listener: listener, callback: callback }, deps = [])=>{
    const previous = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        if (listener !== previous.current) callback(listener, previous.current);
        previous.current = listener;
    /* We do not memoize the callback as this will change every render
		 * But it is important to pass in all dependencies used in the callback */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        ...deps
    ]);
};

});

parcelRegister("6OlO8", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $9fd1aa0f281e7d95$export$7cfa8d622acbc99f);
$parcel$export(module.exports, "buildBacklogScopeName", () => $9fd1aa0f281e7d95$export$68610636ce5df399);

const $9fd1aa0f281e7d95$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$8e66b21ec141a0bd) : (0, $b0e6fec6a4686296$export$c9290acd1ba498ff)}-boardId:${boardId}`;
const $9fd1aa0f281e7d95$export$68610636ce5df399 = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$75eb9639a5b0ba25) : (0, $b0e6fec6a4686296$export$2fd6d7f902b01d67)}-boardId:${boardId}`;

});

parcelRegister("cOddg", function(module, exports) {

$parcel$export(module.exports, "CheckClassicViewAggregatedDataPermission", () => $09f9796263d4f1f9$export$379f6e97a42d4a9d);
$parcel$export(module.exports, "CheckSimplifiedDataPermission", () => $09f9796263d4f1f9$export$b5e65dc6f010c84c);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $9Y7dM = parcelRequire("9Y7dM");

var $dfjss = parcelRequire("dfjss");

var $iuEfD = parcelRequire("iuEfD");

var $6WV5x = parcelRequire("6WV5x");

var $47u1P = parcelRequire("47u1P");

const $09f9796263d4f1f9$export$379f6e97a42d4a9d = ({ boardId: boardId, userLocation: userLocation, onPermissionLoaded: onPermissionLoaded, onInsightsEnabledWithoutPermission: onInsightsEnabledWithoutPermission })=>{
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const actionSubject = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}`;
    const [{ data: permissionResult, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }] = (0, $iuEfD.useFetch)({
        onFetch: (options)=>(0, $6WV5x.fetchInsightPermission)({
                boardId: boardId
            }, options),
        browserMetricsKey: `${actionSubject}.${(0, $4de57a9072cf4c55$export$5dad270161d08a8c)}`,
        analyticsTracking: {
            actionSubject: `${actionSubject}.${(0, $4de57a9072cf4c55$export$5dad270161d08a8c)}`,
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        },
        loggingKey: (0, $4de57a9072cf4c55$export$5dad270161d08a8c)
    }, []);
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loading) onPermissionLoaded((0, $9Y7dM.permissionStatus).LOADING);
        if (fetched && !hasError && !aborted) {
            if (permissionResult) {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                const shouldPermittedUsersUseJQLData = (0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users');
                setShouldUseJQLData(shouldPermittedUsersUseJQLData);
            } else {
                // target experiment only towards not-permitted users
                const shouldEnableAccess = (0, $6s1PB.expVal)('jira_insights_open-insights', 'isEnabled', false);
                if (shouldEnableAccess) {
                    onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                    onInsightsEnabledWithoutPermission?.();
                    setShouldUseJQLData(true);
                } else onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
            }
        }
        if (hasError || aborted) onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
    }, [
        fetched,
        loading,
        aborted,
        permissionResult,
        hasError,
        onPermissionLoaded,
        setShouldUseJQLData,
        onInsightsEnabledWithoutPermission
    ]);
    return null;
};
const $09f9796263d4f1f9$export$b5e65dc6f010c84c = ()=>{
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    const shouldPermittedUsersUseJQLData = (0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users');
    (0, $5uXOq.useEffect)(()=>{
        setShouldUseJQLData(shouldPermittedUsersUseJQLData);
    }, [
        setShouldUseJQLData,
        shouldPermittedUsersUseJQLData
    ]);
    return null;
};

});
parcelRegister("dfjss", function(module, exports) {

$parcel$export(module.exports, "getBoardOrBacklogFromLocation", () => $8952e8de617aa53a$export$bb6a57ca7b7487bb);

const $8952e8de617aa53a$var$locations = {
    [(0, $b117e2ebd359768a$export$743304c0b847bdee)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$47ae5cd4a7ee5f2a)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$40705e2848d2f6a5)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491),
    [(0, $b117e2ebd359768a$export$f995350d8da9bb90)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491)
};
const $8952e8de617aa53a$export$bb6a57ca7b7487bb = (userLocation)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "software:software-backlog": "backlog"; readonly "classic-software:rapidboard-backlog": "backlog"; readonly "software:software-boards": "board"; readonly "classic-software:rapidboard-board": "board"; }'.
    $8952e8de617aa53a$var$locations[userLocation] || (0, $b117e2ebd359768a$export$5f4028218eaee319);

});
const $b117e2ebd359768a$export$dedbdcc35e955187 = 'backlog';
const $b117e2ebd359768a$export$9b8283d5878d2491 = 'board';
const $b117e2ebd359768a$export$5f4028218eaee319 = 'unknown';
const $b117e2ebd359768a$export$47ae5cd4a7ee5f2a = 'classic-software:rapidboard-backlog';
const $b117e2ebd359768a$export$f995350d8da9bb90 = 'classic-software:rapidboard-board';
const $b117e2ebd359768a$export$743304c0b847bdee = 'software:software-backlog';
const $b117e2ebd359768a$export$40705e2848d2f6a5 = 'software:software-boards';


parcelRegister("iuEfD", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $082fa94a7a9fe60c$export$d852f5f778460fa4);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $aAhmV = parcelRequire("aAhmV");

var $d6Xq4 = parcelRequire("d6Xq4");

var $bYINM = parcelRequire("bYINM");

var $lUlda = parcelRequire("lUlda");

var $dg0bO = parcelRequire("dg0bO");

var $eW4Xh = parcelRequire("eW4Xh");
const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)((0, $bYINM.reducer), {
        ...(0, $dg0bO.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
    const isMounted = (0, $5uXOq.useRef)(true);
    const getAbortController = (0, $5uXOq.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $eW4Xh.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $aAhmV.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $5uXOq.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) callFetch();
            else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("aAhmV", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b5443ab87e9d487f$export$5297818927df1cbf);

var $aTJxm = parcelRequire("aTJxm");
const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $aTJxm.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("aTJxm", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $e708554df9e0cc9d$export$c5491a8691a23b9e);

var $dg0bO = parcelRequire("dg0bO");
const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, $dg0bO.initialState);
const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $e708554df9e0cc9d$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $e708554df9e0cc9d$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $e708554df9e0cc9d$var$setDefault = (state)=>state;
const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
    resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
    setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
    setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
    setError: $e708554df9e0cc9d$var$setError,
    setAborted: $e708554df9e0cc9d$var$setAborted,
    default: $e708554df9e0cc9d$var$setDefault
};

});
parcelRegister("dg0bO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $147c98f07a60815a$export$d4c72bab9d6cc13a);
const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("d6Xq4", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $7de9d917d4a5c394$export$2801d9c787d65a99);
class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});

parcelRegister("bYINM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $82dfd012f8e9e396$export$1650419e431d3ba3);

var $aTJxm = parcelRequire("aTJxm");

var $dg0bO = parcelRequire("dg0bO");
const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, $dg0bO.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $aTJxm.strategies)[action.type] || (0, $aTJxm.strategies).default;
    return transformer(state, action);
};

});

parcelRegister("lUlda", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $76bb872f5000fbec$export$a42e2ec7d66a0c03);
const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("eW4Xh", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $4eddb453cf1aa4e2$export$eb2332b8a94a914a);

var $eUcR1 = parcelRequire("eUcR1");

var $dTD3b = parcelRequire("dTD3b");

var $7lFwJ = parcelRequire("7lFwJ");
const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $7lFwJ.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $dTD3b.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("7lFwJ", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $81689b1ad2d5cba4$export$f35316da257b76e4);

var $dJl1T = parcelRequire("dJl1T");

var $fZneA = parcelRequire("fZneA");
const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $fZneA.isClientFetchError)(thrownError)) (0, $dJl1T.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});



parcelRegister("6WV5x", function(module, exports) {

$parcel$export(module.exports, "fetchInsightPermission", () => $3d7ce849d39a845d$export$a465feaffcf65c97);

var $48DMb = parcelRequire("48DMb");
const $3d7ce849d39a845d$export$a465feaffcf65c97 = async ({ boardId: boardId }, options)=>{
    const response = await (0, $48DMb.fetchJson)(`/rest/internal/board/${boardId}/insight-permission`, options);
    return response && response.allowed;
};

});

parcelRegister("47u1P", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $4772a73a96e71e67$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $4772a73a96e71e67$export$9c89ac8256e92fbb);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $bSSG7.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});

const $4de57a9072cf4c55$export$5dad270161d08a8c = 'check-insight-permission';


parcelRegister("1UEsW", function(module, exports) {

$parcel$export(module.exports, "WithInsightsErrorBoundary", () => $0d7082c2a6c6ecc7$export$b240a041e4bface8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $39xOx = parcelRequire("39xOx");

var $93jKl = parcelRequire("93jKl");

var $jb5yn = parcelRequire("jb5yn");

var $f9Owr = parcelRequire("f9Owr");

var $4Fbrj = parcelRequire("4Fbrj");


var $1s62S = parcelRequire("1s62S");
const $0d7082c2a6c6ecc7$var$insightsExperience = {
    experience: (0, $4Fbrj.JIRA_INSIGHTS)
};
const $0d7082c2a6c6ecc7$export$eff352405fe6db90 = ({ id: id, packageName: packageName, children: children, onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    if (!(0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
};
const $0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker = ({ children: children })=>{
    const onFail = (0, $93jKl.useExperienceFail)($0d7082c2a6c6ecc7$var$insightsExperience);
    const { fail: fail } = (0, $1s62S.useInsightsExperience)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        onError: (...args)=>{
            onFail(...args);
            const [, error] = args;
            fail((0, $4Fbrj.ERROR_BOUNDARY_HIT), error);
        }
    }, children);
};
const $0d7082c2a6c6ecc7$export$cf848bf84642a299 = ({ children: children, experienceIdsToTrack: experienceIdsToTrack = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1s62S.InsightsExperienceTracker), {
        experienceId: (0, $4Fbrj.INSIGHTS_PANEL_EXPERIENCE),
        experienceIdsToCollect: experienceIdsToTrack || [],
        timeoutInMs: (0, $4Fbrj.EXPERIENCE_TIMEOUT_MILLIS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jb5yn.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker, null, children)));
const $0d7082c2a6c6ecc7$export$b240a041e4bface8 = (Component, id, packageName)=>(props)=>{
        if (!(0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: id,
            packageName: packageName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };

});
parcelRegister("4Fbrj", function(module, exports) {

$parcel$export(module.exports, "JIRA_INSIGHTS", () => $fea73e8d1542f4b4$export$74798a8d8755efe8);
$parcel$export(module.exports, "INSIGHTS_BEACON", () => $fea73e8d1542f4b4$export$36aafe55be325e9c);
$parcel$export(module.exports, "INSIGHTS_PANEL", () => $fea73e8d1542f4b4$export$29d7f2210b16d662);
$parcel$export(module.exports, "EXPERIENCE_TIMEOUT_MILLIS", () => $fea73e8d1542f4b4$export$b50c2fb16a87be63);
$parcel$export(module.exports, "DATA_FETCH_ACTION", () => $fea73e8d1542f4b4$export$4857a322416ea6fc);
$parcel$export(module.exports, "CLIENT_ERROR", () => $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2);
$parcel$export(module.exports, "RENDER_ACTION", () => $fea73e8d1542f4b4$export$e902262516430940);
$parcel$export(module.exports, "dataFetchSuccess", () => $fea73e8d1542f4b4$export$d392c424a6c74b59);
$parcel$export(module.exports, "dataFetchFail", () => $fea73e8d1542f4b4$export$8d035b8b8e3383e);
$parcel$export(module.exports, "INSIGHTS_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$3ea7cf58d679b8d9);
$parcel$export(module.exports, "ERROR_BOUNDARY_HIT", () => $fea73e8d1542f4b4$export$680b36a84ba453e0);
$parcel$export(module.exports, "boardType", () => $fea73e8d1542f4b4$export$6796f2a60fb31770);
$parcel$export(module.exports, "BOARD_KANBAN_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$36467f64abcaaaa5);
$parcel$export(module.exports, "INSIGHTS_BUTTON", () => $fea73e8d1542f4b4$export$28ab2964530cf411);
$parcel$export(module.exports, "INSIGHTS_BUTTON_LG", () => $fea73e8d1542f4b4$export$8a355daa8d0cf830);
$parcel$export(module.exports, "INSIGHTS_BUTTON_SM", () => $fea73e8d1542f4b4$export$f8c16af1b950b647);
$parcel$export(module.exports, "INSIGHTS_BUTTON_RESPONSIVE", () => $fea73e8d1542f4b4$export$e80ae42ddabf80c5);

const $fea73e8d1542f4b4$export$74798a8d8755efe8 = (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
const $fea73e8d1542f4b4$export$36aafe55be325e9c = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.beacon`;
const $fea73e8d1542f4b4$export$29d7f2210b16d662 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.panel`;
const $fea73e8d1542f4b4$export$8a1dfa6c0a610c5f = `${$fea73e8d1542f4b4$export$29d7f2210b16d662}.help`;
const $fea73e8d1542f4b4$export$956c91960ecaaf52 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.location`;
const $fea73e8d1542f4b4$export$b50c2fb16a87be63 = 60000;
const $fea73e8d1542f4b4$export$4857a322416ea6fc = 'dataFetch';
const $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2 = 'clientError';
const $fea73e8d1542f4b4$export$e902262516430940 = 'render';
const $fea73e8d1542f4b4$export$d392c424a6c74b59 = {
    successful: true
};
const $fea73e8d1542f4b4$export$8d035b8b8e3383e = {
    successful: false
};
const $fea73e8d1542f4b4$export$3ea7cf58d679b8d9 = 'panel';
const $fea73e8d1542f4b4$export$680b36a84ba453e0 = 'error-boundary-hit';
const $fea73e8d1542f4b4$export$6796f2a60fb31770 = {
    SCRUM: 'scrum',
    KANBAN: 'kanban'
};
const $fea73e8d1542f4b4$export$36467f64abcaaaa5 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.board.${$fea73e8d1542f4b4$export$6796f2a60fb31770.KANBAN}-panel`;
const $fea73e8d1542f4b4$export$28ab2964530cf411 = 'insights-show-insights-button.ui.insights-button';
const $fea73e8d1542f4b4$export$8a355daa8d0cf830 = 'insights-show-insights-button.ui.insights-button-large';
const $fea73e8d1542f4b4$export$f8c16af1b950b647 = 'insights-show-insights-button.ui.insights-button-small';
const $fea73e8d1542f4b4$export$e80ae42ddabf80c5 = 'insights-show-insights-button.ui.insights-button-responsive';

});

parcelRegister("1s62S", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTracker", () => $86531a62d14892a7$export$9c32e0183f3330c4);
$parcel$export(module.exports, "useInsightsExperience", () => $86531a62d14892a7$export$6a440957407835a0);
$parcel$export(module.exports, "StartInsightsExperience", () => $86531a62d14892a7$export$d8f7e3f6742303b4);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");

var $f9Owr = parcelRequire("f9Owr");


var $dfjss = parcelRequire("dfjss");

var $cfDZ3 = parcelRequire("cfDZ3");

var $30KM0 = parcelRequire("30KM0");

var $2Siis = parcelRequire("2Siis");

var $eUcR1 = parcelRequire("eUcR1");

var $2B9C9 = parcelRequire("2B9C9");

var $bSClU = parcelRequire("bSClU");

var $dfzOH = parcelRequire("dfzOH");
const $86531a62d14892a7$export$9c32e0183f3330c4 = ({ ufoExperience: ufoExperience, experienceId: experienceId, experienceIdsToCollect: experienceIdsToCollect, timeoutInMs: timeoutInMs = (0, $30KM0.TIMEOUT_IN_MS), attributes: attributes, children: children, packageName: packageName })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const ufoErrorLogger = (0, $dfzOH.useUfoErrorLogger)({
        eventFrom: eventFrom,
        ufoExperience: ufoExperience
    });
    const insightsPackage = (0, $f9Owr.ff)('jsm-board-insights-issues-for-attention_erwbg') && packageName ? packageName : (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
    const insightsExperience = `${insightsPackage}.${eventFrom}.${experienceId}`;
    const metricsTracker = (0, $bSClU.useMetricsMemo)(()=>{
        const browserMetricsKey = `${insightsExperience}.${(0, $30KM0.experiences).RENDER}`;
        const metricsAttributes = {
            ...attributes,
            userLocation: userLocation
        };
        const service = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey,
            attributes: metricsAttributes
        });
        return {
            start: ()=>{
                service.start();
                ufoExperience?.start().catch(ufoErrorLogger);
            },
            end: ()=>{
                service.end();
                ufoExperience?.success().catch(ufoErrorLogger);
            },
            cancel: (error)=>{
                // send message to splunk here
                if (error) (0, $dJl1T.default).safeErrorWithoutCustomerData(browserMetricsKey, 'Insights experience failed', new (0, $2Siis.ExperienceError)(error, metricsAttributes));
                service.cancel();
                ufoExperience?.failure().catch(ufoErrorLogger);
            }
        };
    }, [
        insightsExperience,
        userLocation,
        attributes,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2B9C9.InsightsExperienceTrackerStoreContainer), {
        scope: insightsExperience,
        experienceIdsToCollect: experienceIdsToCollect,
        timeoutInMs: timeoutInMs,
        metricsTracker: metricsTracker,
        ufoExperience: ufoExperience
    }, children);
};
const $86531a62d14892a7$export$6a440957407835a0 = ()=>{
    const [, actions] = (0, $2B9C9.useInsightsExperienceTracker)();
    const [isExperienceOwner, setExperienceOwner] = (0, $5uXOq.useState)(false);
    // we only need to expose start, fail and success
    const returnActions = (0, $5uXOq.useMemo)(()=>({
            start: ()=>{
                setExperienceOwner(true);
                actions.start();
            },
            fail: actions.fail,
            success: actions.success
        }), [
        actions,
        setExperienceOwner
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (isExperienceOwner === true) actions.reset();
        }, [
        isExperienceOwner,
        actions
    ]);
    return returnActions;
};
const $86531a62d14892a7$export$d8f7e3f6742303b4 = ()=>{
    const { start: start } = $86531a62d14892a7$export$6a440957407835a0();
    (0, $5uXOq.useLayoutEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
};

});
parcelRegister("2Siis", function(module, exports) {

$parcel$export(module.exports, "ExperienceError", () => $e57b689d183ecfd7$export$14d796af4fae7309);
class $e57b689d183ecfd7$export$14d796af4fae7309 extends Error {
    constructor(error, extraProps){
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        Object.assign(this, {
            ...error
        });
        Object.assign(this, extraProps);
    }
}

});

parcelRegister("2B9C9", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTrackerStoreContainer", () => $aa56c148ed849f26$export$ed39ab6b8cf88c60);
$parcel$export(module.exports, "useInsightsExperienceTracker", () => $aa56c148ed849f26$export$941e72d49b686b93);

var $7JoAD = parcelRequire("7JoAD");

var $30KM0 = parcelRequire("30KM0");

var $fKAQw = parcelRequire("fKAQw");

var $k8iQN = parcelRequire("k8iQN");
const $aa56c148ed849f26$var$Store = (0, $7JoAD.createStore)({
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to type 'State'.
    $k8iQN.initialState,
    actions: $fKAQw.actions,
    name: (0, $30KM0.STORE_NAME)
});
const $aa56c148ed849f26$export$ed39ab6b8cf88c60 = (0, $7JoAD.createContainer)($aa56c148ed849f26$var$Store);
const $aa56c148ed849f26$export$941e72d49b686b93 = (0, $7JoAD.createHook)($aa56c148ed849f26$var$Store);

});
parcelRegister("fKAQw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e0f25a0ee99bb826$export$e324594224ef24da);

var $4Fbrj = parcelRequire("4Fbrj");

var $k8iQN = parcelRequire("k8iQN");
const $e0f25a0ee99bb826$var$success = (experienceId)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasTimedOut) return;
        if (!experienceIdsToCollect.includes(experienceId)) return;
        if (state.eventsSuccess.includes(experienceId)) return;
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_success`);
        const nextEventsSuccess = [
            ...state.eventsSuccess,
            experienceId
        ];
        const shouldSetHasCompleted = nextEventsSuccess.length === experienceIdsToCollect.length && !currentStatus.hasCompleted;
        const nextState = {
            status: shouldSetHasCompleted ? {
                ...currentStatus,
                hasCompleted: true
            } : currentStatus,
            timeoutId: state.timeoutId,
            eventsSuccess: [
                ...state.eventsSuccess,
                experienceId
            ],
            eventsFail: state.eventsFail
        };
        setState(nextState);
        if (shouldSetHasCompleted) {
            if (state.timeoutId) clearTimeout(state.timeoutId);
            metricsTracker.end();
        }
    };
const $e0f25a0ee99bb826$var$fail = (experienceId, error)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted) return;
        if (!experienceIdsToCollect.includes(experienceId) && // Panel level error boundary hits do not pass in an experienceId,
        // so we accept the constant "error-boundary-hit" in addition to the experienceIds
        // Note: Insight level error boundary hits do pass in experienceId
        experienceId !== (0, $4Fbrj.ERROR_BOUNDARY_HIT)) return;
        if (state.timeoutId) clearTimeout(state.timeoutId);
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_fail`);
        const nextEventsFail = [
            ...state.eventsFail,
            experienceId
        ];
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true
            },
            timeoutId: state.timeoutId,
            eventsSuccess: state.eventsSuccess,
            eventsFail: nextEventsFail
        };
        setState(nextState);
        metricsTracker.cancel(error);
    };
const $e0f25a0ee99bb826$var$timeout = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasFailed) return;
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true,
                hasTimedOut: true
            },
            eventsSuccess: state.eventsSuccess,
            eventsFail: state.eventsFail
        };
        setState(nextState);
        metricsTracker.cancel();
    };
const $e0f25a0ee99bb826$var$start = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { timeoutInMs: timeoutInMs, metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect })=>{
        const state = getState();
        const currentStatus = state.status;
        if (currentStatus.hasCompleted || currentStatus.hasStarted || currentStatus.hasFailed || currentStatus.hasTimedOut || experienceIdsToCollect.length === 0) return;
        const timeoutId = setTimeout(()=>{
            dispatch($e0f25a0ee99bb826$var$timeout());
        }, timeoutInMs);
        const nextState = {
            status: {
                ...currentStatus,
                hasStarted: true
            },
            timeoutId: timeoutId,
            eventsSuccess: [],
            eventsFail: []
        };
        // @ts-expect-error - TS2345 - Argument of type '{ status: { hasStarted: boolean; hasFailed: boolean; hasCompleted: boolean; hasTimedOut: boolean; }; timeoutId: NodeJS.Timeout; eventsSuccess: never[]; eventsFail: never[]; }' is not assignable to parameter of type 'Partial<State>'.
        setState(nextState);
        metricsTracker.start();
    };
const $e0f25a0ee99bb826$var$reset = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        if (state.timeoutId) clearTimeout(state.timeoutId);
        const currentStatus = state.status;
        if (currentStatus.hasStarted && !currentStatus.hasCompleted && !currentStatus.hasFailed && !currentStatus.hasTimedOut) metricsTracker.cancel();
        // @ts-expect-error - TS2345 - Argument of type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to parameter of type 'Partial<State>'.
        setState((0, $k8iQN.initialState));
    };
const $e0f25a0ee99bb826$export$e324594224ef24da = {
    reset: $e0f25a0ee99bb826$var$reset,
    start: $e0f25a0ee99bb826$var$start,
    timeout: $e0f25a0ee99bb826$var$timeout,
    success: $e0f25a0ee99bb826$var$success,
    fail: $e0f25a0ee99bb826$var$fail
};

});
parcelRegister("k8iQN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $7bb650eee945c3d9$export$d4c72bab9d6cc13a);
const $7bb650eee945c3d9$export$d4c72bab9d6cc13a = {
    status: {
        hasFailed: false,
        hasCompleted: false,
        hasStarted: false,
        hasTimedOut: false
    },
    timeoutId: null,
    eventsSuccess: [],
    eventsFail: []
};

});



parcelRegister("bSClU", function(module, exports) {

$parcel$export(module.exports, "useMetricsMemo", () => $5617a8526f2df6be$export$f5d771045a704f1f);

var $5uXOq = parcelRequire("5uXOq");
const $5617a8526f2df6be$var$isShallowDifferent = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
const $5617a8526f2df6be$export$f5d771045a704f1f = (f, deps)=>{
    const metricsTrackerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(deps);
    (0, $5uXOq.useMemo)(()=>{
        const hasEffectsChanged = $5617a8526f2df6be$var$isShallowDifferent(fetchDependenciesRef.current, deps);
        if (!metricsTrackerRef.current || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = deps;
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            metricsTrackerRef.current = f();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T'.
    return metricsTrackerRef.current;
};

});

parcelRegister("dfzOH", function(module, exports) {

$parcel$export(module.exports, "useUfoErrorLogger", () => $b799d4cddaf33695$export$688547a52c1d762b);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");


var $30KM0 = parcelRequire("30KM0");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b799d4cddaf33695$var$noop = ()=>{};
const $b799d4cddaf33695$export$688547a52c1d762b = ({ eventFrom: eventFrom, ufoExperience: ufoExperience })=>{
    const ufoErrorLogger = (0, $5uXOq.useCallback)((error)=>(0, $dJl1T.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}.${ufoExperience?.id || 'unknown'}.${(0, $30KM0.experiences).RENDER}`, 'Insights experience failed', error), [
        eventFrom,
        ufoExperience
    ]);
    return ufoExperience ? ufoErrorLogger : $b799d4cddaf33695$var$noop;
};

});



parcelRegister("gkPFQ", function(module, exports) {

$parcel$export(module.exports, "InsightsSpotlight", () => $7a791a009d9ba36f$export$f441a5f6be0f18a);

var $5uXOq = parcelRequire("5uXOq");

var $5MdCt = parcelRequire("5MdCt");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $bMiSe = parcelRequire("bMiSe");
const $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID = 'jira-insights-open-up-message';
const $7a791a009d9ba36f$export$f441a5f6be0f18a = ({ onOpenInsightsPanel: onOpenInsightsPanel, onDismiss: onDismiss, isOnboardingApplicable: isOnboardingApplicable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MdCt.default), null, isOnboardingApplicable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a791a009d9ba36f$var$CoordinationStopProvider, null, (stopEngagementMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onOpenInsightsPanel();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).viewButtonLabel)
                },
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).skipButtonLabel)
                }
            ],
            messageType: "engagement",
            messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            target: "jira-insights-button",
            key: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            targetRadius: 3,
            dialogPlacement: "bottom right"
        }, formatMessage((0, $bMiSe.default).spotlightContent)))));
};
const $7a791a009d9ba36f$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bpIMA = parcelRequire("bpIMA");

var $dgHpW = parcelRequire("dgHpW");
var $aiddd = parcelRequire("aiddd");

var $3iMQo = parcelRequire("3iMQo");

var $ioD1B = parcelRequire("ioD1B");

var $fG5AJ = parcelRequire("fG5AJ");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $aiddd.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $bpIMA.envType).PROD;
            if (env === 'staging') return (0, $bpIMA.envType).STAGING;
            return (0, $bpIMA.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $3iMQo.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $co1wz.ff)('ep-external-message-debug-mode') || (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $3iMQo.MessageDeliveryStatus).STARTED : (0, $3iMQo.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $3iMQo.MessageDeliveryStatus).STOPPED : (0, $3iMQo.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $3iMQo.MessageDeliveryStatus).STARTED : (0, $3iMQo.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $3iMQo.MessageDeliveryStatus).STOPPED : (0, $3iMQo.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $fG5AJ.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgHpW.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("ioD1B", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $c141e5ba3428702a$export$c3226151caaf2fbf);

var $5uXOq = parcelRequire("5uXOq");

var $fG5AJ = parcelRequire("fG5AJ");
const $c141e5ba3428702a$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $c141e5ba3428702a$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $fG5AJ.useChoreographedStatusContext)();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG5AJ.ChoreographedStatusContext).Provider, {
        value: $c141e5ba3428702a$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});


parcelRegister("bMiSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00d0f1af606d21a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b00d0f1af606d21a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipButtonLabel: {
        "id": "insights-common.insights-spotlight.skip-button-label",
        "defaultMessage": "Skip"
    },
    viewButtonLabel: {
        "id": "insights-common.insights-spotlight.view-button-label",
        "defaultMessage": "View insights"
    },
    spotlightContent: {
        "id": "insights-common.insights-spotlight.spotlight-content",
        "defaultMessage": "Insights have made it to your board and backlog, so you can monitor work and make informed decisions using real-time data."
    }
});

});


parcelRegister("2KxPr", function(module, exports) {

$parcel$export(module.exports, "withComponentSafety", () => $3fc106ae6756d120$export$cb70221ec28d89b);

var $5uXOq = parcelRequire("5uXOq");

var $dJl1T = parcelRequire("dJl1T");
/* condition must return true for component to render */ function $3fc106ae6756d120$export$cb70221ec28d89b(Component, { condition: condition, location: location, message: message = ()=>'withComponentSafety blocked render', Fallback: Fallback = ()=>null }) {
    return (props)=>{
        const isSafe = condition(props);
        const formattedMessage = message(props);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSafe) (0, $dJl1T.default).safeErrorWithoutCustomerData(location, formattedMessage);
        }, [
            isSafe,
            formattedMessage
        ]);
        // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
        return isSafe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, props);
    };
}

});

parcelRegister("6f6NP", function(module, exports) {

$parcel$export(module.exports, "useInsightsContainer", () => $19bd560421a87b26$export$8ecf81d0c059927c);

var $5uXOq = parcelRequire("5uXOq");

var $1NrMQ = parcelRequire("1NrMQ");

var $j8sJY = parcelRequire("j8sJY");

var $5h4e8 = parcelRequire("5h4e8");
const $19bd560421a87b26$export$8ecf81d0c059927c = ()=>{
    const [state, actions] = (0, $j8sJY.useInsightsStoreContainer)();
    const memoCallbacksRef = (0, $5uXOq.useRef)({});
    const toggleAction = actions.toggleProp;
    (0, $1NrMQ.useIsAnyLevelOfAdmin)({
        onIsAnyLevelOfAdminUpdated: actions.setInfo
    });
    (0, $5h4e8.useIsProjectType)({
        onIsProjectTypeUpdated: actions.setInfo
    });
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { isPanelOpen } }, { onToggleCallback }) => {
            <HidePanelButton onClick={onToggleCallback('isPanelOpen')}
            <Panel isPanelOpen={isPanelOpen} />
          }}
        <InsightsContainer>
    */ const onToggleCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (propName && !callbacksMap[propName]) // this will prevent recreate the callback on each render
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = ()=>toggleAction(propName);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        toggleAction
    ]);
    const updateContainerAction = actions.updateContainer;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { settings } }, { onDataUpdatedCallback }) => {
            <LoadPanelSettings onLoad={onDataUpdatedCallback('settings')}
            <Panel settings={settings} />
          }}
        <InsightsContainer>
    */ const onDataUpdatedCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (!callbacksMap[propName]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = (data)=>// this will prevent recreate the callback on each render
            updateContainerAction({
                [propName]: data
            });
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        updateContainerAction
    ]);
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        state,
        {
            onDataUpdatedCallback: // preferred usage is onDataUpdatedCallback and onToggleCallback
            onDataUpdatedCallback,
            onToggleCallback: onToggleCallback,
            // when we need a big customization and onDataUpdatedCallback and onToggleCallback do not fit
            // to solve the problem, we can use the original implementation onUpdate and onToggle
            doUpdate: actions.updateContainer,
            doToggle: actions.toggleProp,
            doClean: actions.cleanState,
            // pass through actions (from insights container)
            refreshUniqueId: actions.refreshUniqueId,
            updateIsDeepLinking: actions.updateIsDeepLinking
        }
    ];
};

});
parcelRegister("1NrMQ", function(module, exports) {

$parcel$export(module.exports, "useIsAnyLevelOfAdmin", () => $ca08f41fafaf028c$export$b29f514064315678);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");
const $ca08f41fafaf028c$export$b29f514064315678 = ({ onIsAnyLevelOfAdminUpdated: onIsAnyLevelOfAdminUpdated })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = !!projectContext?.isProjectAdmin;
    (0, $5uXOq.useEffect)(()=>{
        onIsAnyLevelOfAdminUpdated({
            isAnyLevelOfAdmin: !!(isSiteAdmin || isAdmin || isProjectAdmin)
        });
    }, [
        isProjectAdmin,
        isSiteAdmin,
        isAdmin,
        onIsAnyLevelOfAdminUpdated
    ]);
};

});

parcelRegister("j8sJY", function(module, exports) {

$parcel$export(module.exports, "InsightsStoreContainer", () => $1089c091fa1f71a9$export$4b6f97ed14dce97c);
$parcel$export(module.exports, "useInsightsStoreContainer", () => $1089c091fa1f71a9$export$bd382fb3f9d0551e);

var $7JoAD = parcelRequire("7JoAD");


var $hXuQC = parcelRequire("hXuQC");

var $keDMh = parcelRequire("keDMh");
const $1089c091fa1f71a9$var$Store = (0, $7JoAD.createStore)({
    initialState: $keDMh.initialState,
    actions: $hXuQC.actions,
    name: (0, $622cc15065a8e93c$export$cd79d01fb3d2f506)
});
const $1089c091fa1f71a9$export$4b6f97ed14dce97c = (0, $7JoAD.createContainer)($1089c091fa1f71a9$var$Store);
const $1089c091fa1f71a9$export$bd382fb3f9d0551e = (0, $7JoAD.createHook)($1089c091fa1f71a9$var$Store);

});
const $622cc15065a8e93c$export$cd79d01fb3d2f506 = 'jira.insights.container-store';

parcelRegister("hXuQC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dfa05910dfd04d9d$export$e324594224ef24da);

var $7Jxgt = parcelRequire("7Jxgt");

var $keDMh = parcelRequire("keDMh");
const $dfa05910dfd04d9d$var$updateContainer = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$toggleProp = (propsName)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                [propsName]: !state.data[propsName]
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$setInfo = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$refreshUniqueId = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4()
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$cleanState = ()=>({ setState: setState })=>{
        setState((0, $keDMh.initialState));
    };
const $dfa05910dfd04d9d$var$updateIsDeepLinking = (isDeepLinking)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                isDeepLinking: isDeepLinking
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$export$e324594224ef24da = {
    setInfo: $dfa05910dfd04d9d$var$setInfo,
    cleanState: $dfa05910dfd04d9d$var$cleanState,
    toggleProp: $dfa05910dfd04d9d$var$toggleProp,
    updateContainer: $dfa05910dfd04d9d$var$updateContainer,
    refreshUniqueId: $dfa05910dfd04d9d$var$refreshUniqueId,
    updateIsDeepLinking: $dfa05910dfd04d9d$var$updateIsDeepLinking
};

});
parcelRegister("keDMh", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a);

var $7Jxgt = parcelRequire("7Jxgt");
const $2bb5e17d6b3cb888$var$info = {
    uniqueId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
    isDeepLinking: true
};
const $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a = {
    info: $2bb5e17d6b3cb888$var$info,
    data: {}
};

});



parcelRegister("5h4e8", function(module, exports) {

$parcel$export(module.exports, "useIsProjectType", () => $92c8eb9133a9a3c1$export$3b6950eab2454ef6);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $4DPZY = parcelRequire("4DPZY");
const $92c8eb9133a9a3c1$export$3b6950eab2454ef6 = ({ onIsProjectTypeUpdated: onIsProjectTypeUpdated })=>{
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const isProjectType = containerContext?.contextType === 'project';
    const previousIsProjectType = (0, $5uXOq.useRef)();
    if (previousIsProjectType.current !== isProjectType && (0, $4R6GH.fg)('render_insights_button_immediately_when_ready')) {
        onIsProjectTypeUpdated({
            isProjectType: isProjectType
        });
        previousIsProjectType.current = isProjectType;
    }
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('render_insights_button_immediately_when_ready')) return;
        onIsProjectTypeUpdated({
            isProjectType: isProjectType
        });
    }, [
        isProjectType,
        onIsProjectTypeUpdated
    ]);
};

});


parcelRegister("ebnTF", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $ab366a2319b78816$export$6ca03cb7b75bfa13);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ab366a2319b78816$var$isUndefinedOrNull = (value)=>value === null || value === undefined;
const $ab366a2319b78816$export$96252741c837b909 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$22a0d6ac9d3db3b9 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$6ca03cb7b75bfa13 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$e1a3353b722e75de = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;

});

parcelRegister("apoVO", function(module, exports) {

$parcel$export(module.exports, "InsightsContainer", () => $8769e024218efab1$export$af2273df1febba45);

var $5uXOq = parcelRequire("5uXOq");

var $j8sJY = parcelRequire("j8sJY");

var $6f6NP = parcelRequire("6f6NP");
const $8769e024218efab1$var$buildScopeName = (scope, packageName)=>`${scope}-${packageName}`;
const $8769e024218efab1$var$ChildrenWrapperWithHook = ({ children: children })=>{
    const [state, actions] = (0, $6f6NP.useInsightsContainer)();
    return children(state, actions);
};
const $8769e024218efab1$export$af2273df1febba45 = ({ scope: scope, packageName: packageName, children: children })=>{
    const insightsStoreContainerScope = $8769e024218efab1$var$buildScopeName(scope, packageName);
    if (typeof children === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8769e024218efab1$var$ChildrenWrapperWithHook, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, children);
};

});

parcelRegister("e9Bts", function(module, exports) {

$parcel$export(module.exports, "InsightsSettingsLoader", () => $ffd2a5f9d6d9b178$export$28079df9c9fef0d2);

var $5uXOq = parcelRequire("5uXOq");

var $iuEfD = parcelRequire("iuEfD");

var $8g6eK = parcelRequire("8g6eK");

var $85ZyG = parcelRequire("85ZyG");

var $1Urwa = parcelRequire("1Urwa");
const $ffd2a5f9d6d9b178$export$28079df9c9fef0d2 = ({ boardId: boardId, onSettingsLoaded: onSettingsLoaded })=>{
    const [{ data: settingsResult, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }, { doAbort: doAbort }] = (0, $iuEfD.useFetch)({
        onFetch: (options)=>(0, $1Urwa.fetchInsightsSettings)({
                boardId: boardId
            }, options),
        isAbortable: true,
        analyticsTracking: {
            actionSubject: `${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`,
            sampleRate: 100
        },
        browserMetricsKey: `${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`,
        loggingKey: `${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT}.${(0, $8g6eK.insightsSettingsLoaderAnalytics).ACTION_SUBJECT_ID}`
    }, [
        boardId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let timeout;
        if (loading || !settingsResult) {
            onSettingsLoaded({
                status: 'loading'
            });
            timeout = setTimeout(doAbort, (0, $8g6eK.GET_SETTINGS_ENDPOINT_TIMEOUT_WHEN_INSIGHTS_LOADING));
        }
        if (fetched && settingsResult && !hasError && !aborted) onSettingsLoaded({
            status: 'success',
            data: (0, $85ZyG.withDefaults)(settingsResult.context.board.settings)
        });
        if (hasError || aborted) onSettingsLoaded({
            status: 'error',
            data: (0, $8g6eK.insightsSettingsDefaults)
        });
        return ()=>clearTimeout(timeout);
    }, [
        fetched,
        loading,
        aborted,
        settingsResult,
        hasError,
        onSettingsLoaded,
        doAbort
    ]);
    return null;
};

});

parcelRegister("g5uUm", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $98922b077d0d412f$export$943e069e37d25a04);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $e0OK7 = parcelRequire("e0OK7");

var $2VcU4 = parcelRequire("2VcU4");

var $47htk = parcelRequire("47htk");

var $5bp9K = parcelRequire("5bp9K");
var $c0SO4 = parcelRequire("c0SO4");


var $39xOx = parcelRequire("39xOx");

var $co1wz = parcelRequire("co1wz");

var $4Fbrj = parcelRequire("4Fbrj");

var $7BuUr = parcelRequire("7BuUr");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $2Mspb = parcelRequire("2Mspb");
const $98922b077d0d412f$var$actionSubjectId = 'toggleInsightsPanel';
const $98922b077d0d412f$var$TooltipWrapper = ({ children: children, render: render })=>render != null ? render({
        children: children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $98922b077d0d412f$var$buttonTestId = 'insights-show-insights-button.ui.insights-button';
const $98922b077d0d412f$var$buttonForHiddenTestId = 'insights-show-insights-button.ui.button-test-id-hide';
const $98922b077d0d412f$export$2fdc3445dd252e1 = ({ clickEventAnalytics: clickEventAnalytics, iconAfter: iconAfter, isCompact: isCompact = false, isHidden: isHidden = false, isInsightsPanelOpen: isInsightsPanelOpen, isOnboardingDisabled: isOnboardingDisabled = false, onToggle: onToggle, renderTooltip: renderTooltip })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRefSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const onRefButton = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON), ref);
    }, [
        register
    ]);
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isDisabled = isOnboardingDisabled;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $98922b077d0d412f$var$actionSubjectId, {
            action: isInsightsPanelOpen ? 'close' : 'open',
            isDisabled: isDisabled,
            ...clickEventAnalytics?.attributes || {}
        });
        onToggle(analyticsEvent);
    }, [
        clickEventAnalytics,
        isDisabled,
        isInsightsPanelOpen,
        onToggle
    ]);
    const label = isInsightsPanelOpen ? formatMessage((0, $2Mspb.default).hideInsights) : formatMessage((0, $2Mspb.default).showInsights);
    if (!isSupported) return null;
    const showInsightsButton = !isHidden;
    if (!showInsightsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "hidden",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    });
    const iconColor = isInsightsPanelOpen ? undefined : `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N500})`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "jira-insights-button"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))),
        label: label,
        iconAfter: typeof iconAfter === 'function' ? iconAfter : undefined,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonResponsive
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton
    })) : isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        interactionName: "show-insights-button",
        appearance: "subtle",
        spacing: "none",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefSmall
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0SO4.Show), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))), {
            label: "",
            color: iconColor
        }),
        iconAfter: typeof iconAfter === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconAfter : undefined,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonLarge
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5bp9K.Hide), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VcU4))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonForHiddenTestId,
        ref: onRefSmall
    }))))));
};
const $98922b077d0d412f$export$943e069e37d25a04 = (props)=>{
    const packageName = (0, $co1wz.ff)('jsm-board-insights-issues-for-attention_erwbg') && props && props.packageName ? props.packageName : (0, $4Fbrj.JIRA_INSIGHTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "button",
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$export$2fdc3445dd252e1, props));
};

});
parcelRegister("2VcU4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3be954ea5d070f5903d5961389b0e8fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $220aea009e336443$var$_react = $220aea009e336443$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $220aea009e336443$var$_chartTrend = $220aea009e336443$var$_interopRequireDefault((parcelRequire("6yprV")));

var $220aea009e336443$var$_graphLine = $220aea009e336443$var$_interopRequireDefault((parcelRequire("iR6aO")));
function $220aea009e336443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $220aea009e336443$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $220aea009e336443$var$_react.default.createElement($220aea009e336443$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $220aea009e336443$var$_graphLine.default
    }, props));
$220aea009e336443$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $220aea009e336443$var$_default = module.exports.default = $220aea009e336443$var$ChartTrendIcon;

});
parcelRegister("6yprV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c87cea19f3e54fed45de6b49a026def6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c59a8c08cfcae98$var$_react = $4c59a8c08cfcae98$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4c59a8c08cfcae98$var$_UNSAFE_baseNew = $4c59a8c08cfcae98$var$_interopRequireDefault((parcelRequire("huIZN")));
function $4c59a8c08cfcae98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c59a8c08cfcae98$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $4c59a8c08cfcae98$var$_react.default.createElement($4c59a8c08cfcae98$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m0 0 4.5-4.5L8.5 8.5l5.25-5.25m.5 3.75V2.75H10"/>`
    }, props));
$4c59a8c08cfcae98$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $4c59a8c08cfcae98$var$_default = module.exports.default = $4c59a8c08cfcae98$var$ChartTrendIcon;

});

parcelRegister("iR6aO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dba1f7263bf8231f$var$_react = $dba1f7263bf8231f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $dba1f7263bf8231f$var$_chartTrend = $dba1f7263bf8231f$var$_interopRequireDefault((parcelRequire("6yprV")));
function $dba1f7263bf8231f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dba1f7263bf8231f$var$GraphLineIcon = (props)=>/*#__PURE__*/ $dba1f7263bf8231f$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $dba1f7263bf8231f$var$_chartTrend.default
    }));
$dba1f7263bf8231f$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $dba1f7263bf8231f$var$_default = module.exports.default = $dba1f7263bf8231f$var$GraphLineIcon;

});


parcelRegister("5bp9K", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $4486883ce518e032$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $jJ1Sb = parcelRequire("jJ1Sb");

var $bdmUH = parcelRequire("bdmUH");
const $4486883ce518e032$var$hideAboveQueries = (0, $bdmUH.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $4486883ce518e032$var$hideBelowQueries = (0, $bdmUH.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $4486883ce518e032$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $jJ1Sb.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $4486883ce518e032$var$hideAboveQueries[above],
            below && $4486883ce518e032$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("2Mspb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c41f59518ad2b73$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c41f59518ad2b73$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showInsights: {
        "id": "insights-show-insights-button.show-insights",
        "defaultMessage": "Insights"
    },
    hideInsights: {
        "id": "insights-show-insights-button.hide-insights",
        "defaultMessage": "Insights"
    }
});

});


parcelRegister("4mJDy", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_BUTTON_ID", () => $2b69ae47bb5ef239$export$8587b2c6e52de53f);

const $2b69ae47bb5ef239$export$8587b2c6e52de53f = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.backlog-button`;

});

parcelRegister("aokXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69d1df268ac3a81$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f69d1df268ac3a81$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-backlog-button.tooltip",
        "defaultMessage": "Backlog insights"
    }
});

});


parcelRegister("5PP3a", function(module, exports) {

$parcel$export(module.exports, "BacklogInsightsNudgeAsync", () => $b5c16da729763877$export$bdccb7ceffac5743);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b5c16da729763877$var$BacklogInsightsNudgeLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("hMZ5M")).then((exportedModule)=>exportedModule.BacklogInsightsNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/scrum-onboarding-tour/backlog-insights/index.tsx"
});
const $b5c16da729763877$export$bdccb7ceffac5743 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$65fb0c4e534f03fc),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-backlog-insights-nudge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5c16da729763877$var$BacklogInsightsNudgeLazy, null, children)));
$b5c16da729763877$export$bdccb7ceffac5743.displayName = 'BacklogInsightsNudgeAsync';

});
parcelRegister("hMZ5M", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("aG7Cn")
]).then(()=>parcelRequire('3DCtq'));

});



parcelRegister("lHl5z", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $86d62f0e47a77ccb$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $9ARNv = parcelRequire("9ARNv");

var $hfc8j = parcelRequire("hfc8j");
var $47htk = parcelRequire("47htk");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $iL8EU = parcelRequire("iL8EU");

var $5GqLe = parcelRequire("5GqLe");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $40Whg = parcelRequire("40Whg");
const $86d62f0e47a77ccb$export$e980dfbc2840e8bc = ({ shareContentType: shareContentType, onTriggerButtonClick: onTriggerButtonClick })=>{
    const cloudId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getCloudId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const boardName = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getName));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfc8j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.default), {
        productId: "jira",
        subProductId: "jira-software",
        shareContentType: shareContentType,
        integrationType: (0, $5GqLe.integrationTypes).BOARD,
        shareTitle: boardName,
        shareFormTitle: formatMessage((0, $40Whg.default).shareFormTitle),
        objectAri: (0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: boardId
        }),
        onTriggerButtonClick: onTriggerButtonClick,
        shareFormHelperMessage: formatMessage((0, $40Whg.default).shareHelperMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ARNv.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    }));
};

});
parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $4e5335f44d688bbf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $i2xy6 = parcelRequire("i2xy6");


var $heNNl = parcelRequire("heNNl");

var $koVbs = parcelRequire("koVbs");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

var $Kpokz = parcelRequire("Kpokz");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i2xy6))), {
            size: "medium",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButton = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));

});
parcelRegister("i2xy6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d222700ec3238b27$var$_react = $d222700ec3238b27$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $d222700ec3238b27$var$_share = $d222700ec3238b27$var$_interopRequireDefault((parcelRequire("qnL8V")));
function $d222700ec3238b27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d222700ec3238b27$var$ShareIcon = (props)=>/*#__PURE__*/ $d222700ec3238b27$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $d222700ec3238b27$var$_share.default
    }));
$d222700ec3238b27$var$ShareIcon.displayName = 'ShareIcon';
var $d222700ec3238b27$var$_default = module.exports.default = $d222700ec3238b27$var$ShareIcon;

});
parcelRegister("qnL8V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04f4dbf0550eb041$var$_react = $04f4dbf0550eb041$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04f4dbf0550eb041$var$_UNSAFE_baseNew = $04f4dbf0550eb041$var$_interopRequireDefault((parcelRequire("huIZN")));
function $04f4dbf0550eb041$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04f4dbf0550eb041$var$ShareIcon = (props)=>/*#__PURE__*/ $04f4dbf0550eb041$var$_react.default.createElement($04f4dbf0550eb041$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$04f4dbf0550eb041$var$ShareIcon.displayName = 'ShareIcon';
var $04f4dbf0550eb041$var$_default = module.exports.default = $04f4dbf0550eb041$var$ShareIcon;

});


parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("jHQiG", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("bfk3F")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("40Whg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d20aca9fbb0156$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1d20aca9fbb0156$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareFormTitle: {
        "id": "backlog.header.actions-bar.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "backlog.header.actions-bar.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("fFw8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4aad3065aa3b41$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $k35me = parcelRequire("k35me");

var $fpDLy = parcelRequire("fpDLy");

var $i3GNO = parcelRequire("i3GNO");
var $4f4aad3065aa3b41$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        rapidViewId: Number((0, $jG5HW.getRapidViewId)(state)),
        isBacklogWithSprints: (0, $k35me.isBacklogWithSprints)(state),
        isClassic: (0, $jG5HW.getIsCompanyManaged)(state),
        showEpicAsPanel: (0, $9Pc1U.getShowEpicAsPanel)(state),
        isVersionsEnabled: (0, $fpDLy.isVersionsFeatureEnabled)(state)
    }), {
    onTogglePanel: (0, $9g0YE.togglePanel)
})((0, $i3GNO.BacklogViewSettings));

});
parcelRegister("i3GNO", function(module, exports) {

$parcel$export(module.exports, "BacklogViewSettings", () => $d4634def6eeed81d$export$c0bf3e52465abf3b);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");


var $c1MAf = parcelRequire("c1MAf");

var $a7yHf = parcelRequire("a7yHf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $le1bQ = parcelRequire("le1bQ");

var $c060Z = parcelRequire("c060Z");
const $d4634def6eeed81d$export$c0bf3e52465abf3b = (props)=>{
    const { rapidViewId: rapidViewId, isClassic: isClassic, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, onTogglePanel: onTogglePanel } = props;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const isDataLoaded = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isCriticalDataLoaded));
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const isViewSettingPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const showFilterBarToggle = isCompanyManaged;
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $5uXOq.useCallback)(()=>{
        (0, $a7yHf.setExpandedCardGroups)(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups
    ]);
    const handleCollapseSubtasks = (0, $5uXOq.useCallback)(()=>{
        (0, $a7yHf.collapseAllCardGroups)();
    }, []);
    const handleViewSettingPanelToggle = (0, $5uXOq.useCallback)(()=>{
        onTogglePanel((0, $c35fd6591a78fffe$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    return (0, $4R6GH.fg)('jira_view_settings_additional_fields') ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $a4XJc.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    });
};

});



parcelRegister("4hApq", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ce6ab608ed8152$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $a7yHf = parcelRequire("a7yHf");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $k35me = parcelRequire("k35me");

var $fpDLy = parcelRequire("fpDLy");

var $fxbvZ = parcelRequire("fxbvZ");

var $l5nOr = parcelRequire("l5nOr");

var $7ml2y = parcelRequire("7ml2y");
var $80ce6ab608ed8152$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        rapidViewId: Number((0, $jG5HW.getRapidViewId)(state)),
        isBacklogWithSprints: (0, $k35me.isBacklogWithSprints)(state),
        FilterBar: $l5nOr.default,
        Operations: $fxbvZ.default,
        isClassic: (0, $jG5HW.getIsCompanyManaged)(state),
        showEpicAsPanel: (0, $9Pc1U.getShowEpicAsPanel)(state),
        isVersionsEnabled: (0, $fpDLy.isVersionsFeatureEnabled)(state)
    }), {
    onTogglePanel: (0, $9g0YE.togglePanel),
    onSubtasksExpandAll: (0, $a7yHf.setExpandedCardGroups),
    onSubtasksCollapseAll: (0, $a7yHf.collapseAllCardGroups)
})((0, $7ml2y.ControlsBar));

});
parcelRegister("l5nOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d0272eac005333$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $7wqBZ = parcelRequire("7wqBZ");

var $6s1PB = parcelRequire("6s1PB");

var $bC2fB = parcelRequire("bC2fB");

var $88tXZ = parcelRequire("88tXZ");

var $dIdda = parcelRequire("dIdda");



var $h9NU3 = parcelRequire("h9NU3");

var $9Z18E = parcelRequire("9Z18E");

var $8MHVw = parcelRequire("8MHVw");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $l9VFH = parcelRequire("l9VFH");

var $f9Swb = parcelRequire("f9Swb");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

var $l89dM = parcelRequire("l89dM");

var $1z1J7 = parcelRequire("1z1J7");

var $fpDLy = parcelRequire("fpDLy");

var $fSgHa = parcelRequire("fSgHa");

var $aTx7m = parcelRequire("aTx7m");

var $cFqzj = parcelRequire("cFqzj");
const $35d0272eac005333$export$148c63f5480aef70 = (state)=>(0, $jG5HW.getIsCompanyManaged)(state) ? true // we always want to show the link so user can see read-only board settings page even with no edit board permission
     : (0, $1z1J7.canEditBoardConfig)(state);
const $35d0272eac005333$var$isTMPBoardAddPeopleExperimentEnabled = (state)=>{
    const canInviteOthersToProject = (0, $9Pc1U.getCanInviteOthersToProject)(state);
    return canInviteOthersToProject && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
};
const $35d0272eac005333$export$c31df4bd766f9c35 = (state)=>{
    const isCompanyManaged = (0, $jG5HW.getIsCompanyManaged)(state);
    return {
        assignees: (0, $dGljH.getOrderedAssignees)(state),
        filter: (0, $l9VFH.getFilters)(state),
        panels: (0, $l89dM.getPanels)(state),
        labels: (0, $dGljH.getOrderedLabels)(state),
        issueTypes: (0, $dGljH.getOrderedCardTypes)(state),
        maxAvatars: (0, $41ce9b5576b92b7a$export$360e7ca29749d455),
        isAddPeopleButtonEnabled: isCompanyManaged ? (0, $1z1J7.canEditBoardConfig)(state) // Existing permission check for CMP
         : (0, $1z1J7.canEditBoardConfig)(state) || $35d0272eac005333$var$isTMPBoardAddPeopleExperimentEnabled(state),
        isCustomFilterManageLinkEnabled: $35d0272eac005333$export$148c63f5480aef70(state),
        isVersionFilterSpotlightEnabled: (0, $1z1J7.canEditBoardConfig)(state),
        issueParentsLabel: isCompanyManaged ? (0, $f9Swb.getFirstLevelHierarchyName)(state) || (0, $fmuR9.firstParentIssueTypeNameSelector)(state) : (0, $fmuR9.firstParentIssueTypeNameSelector)(state),
        issueParents: (0, $fmuR9.issueParentsToListItemSelector)(state),
        isAnyModalOpen: (0, $fC5rN.isAnyModalOpen)(state),
        boardId: Number((0, $jG5HW.getRapidViewId)(state)),
        isVersionsFeatureEnabled: (0, $fpDLy.isVersionsFeatureEnabled)(state),
        projectId: (0, $jG5HW.projectIdSelector)(state),
        projectName: (0, $jG5HW.getProjectName)(state),
        projectKey: (0, $jG5HW.getProjectKey)(state),
        cardIds: (0, $dGljH.getCardIds)(state),
        isCustomFiltersLoading: (0, $dGljH.isFilteredCardsLoading)(state),
        isEpicPanelOpen: (0, $h9NU3.isIssueParentPanelOpen)(),
        isVersionPanelOpen: (0, $h9NU3.isVersionPanelOpen)(),
        isCompanyManaged: isCompanyManaged
    };
};
const $35d0272eac005333$var$mapDispatchToProps = (dispatch)=>({
        dispatch: dispatch
    });
const $35d0272eac005333$var$getOnChange = (0, $8QpSo.default)((issueIds, dispatch, syncFiltersWithRemoteStore)=>(filters, filterType, _, analyticsEvent)=>{
        if (filterType === (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)) // @ts-expect-error Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
        dispatch((0, $8MHVw.filteredCardsRequest)(issueIds, analyticsEvent, filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]));
        else (0, $7wqBZ.getLongTasksMetrics)('filter').start('backlog');
        syncFiltersWithRemoteStore(filters);
        if (filterType !== (0, $41ce9b5576b92b7a$export$68d693c35a8d8866)) dispatch((0, $9Z18E.cardAutoScrollRequestOnFilter)());
    });
const $35d0272eac005333$var$getClearAllFilters = (0, $8QpSo.default)((dispatch, isCompanyManaged)=>(event, analyticsEvent)=>{
        isCompanyManaged ? dispatch((0, $8MHVw.clearFilteredCardsRequest)(analyticsEvent)) : dispatch((0, $8MHVw.clearFilteredCards)());
        dispatch((0, $9Z18E.cardAutoScrollRequestOnFilter)());
    });
const $35d0272eac005333$var$getOnToggleParentPanel = (0, $8QpSo.default)((dispatch)=>()=>{
        dispatch((0, $9g0YE.togglePanel)((0, $c35fd6591a78fffe$export$a10c132b86ae798b)));
    });
const $35d0272eac005333$var$getOnToggleVersionsPanel = (0, $8QpSo.default)((dispatch)=>()=>{
        dispatch((0, $9g0YE.togglePanel)((0, $c35fd6591a78fffe$export$41073ac826c57195)));
    });
const $35d0272eac005333$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { assignees: assignees, filter: filter, panels: panels, labels: labels, maxAvatars: maxAvatars, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled, isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled, issueParentsLabel: issueParentsLabel, issueParents: issueParents, issueTypes: issueTypes, boardId: boardId, isVersionsFeatureEnabled: isVersionsFeatureEnabled, projectId: projectId, projectName: projectName, projectKey: projectKey, cardIds: cardIds, isCustomFiltersLoading: isCustomFiltersLoading, isVersionPanelOpen: isVersionsOpen, isEpicPanelOpen: isEpicPanelOpen, isCompanyManaged: isCompanyManaged } = stateProps;
    const { dispatch: dispatch } = dispatchProps;
    const { customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef } = ownProps;
    return {
        assignees: assignees,
        filter: filter,
        panels: panels,
        labels: labels,
        maxAvatars: maxAvatars,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled,
        isVersionFilterSpotlightEnabled: isVersionFilterSpotlightEnabled,
        issueParentsLabel: issueParentsLabel,
        issueParents: issueParents,
        issueTypes: issueTypes,
        AddPeopleModal: $aTx7m.default,
        boardId: boardId,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCustomFiltersLoading: isCustomFiltersLoading,
        projectId: projectId,
        projectName: projectName,
        projectKey: projectKey,
        onChange: $35d0272eac005333$var$getOnChange(cardIds, dispatch, ownProps.syncFiltersWithRemoteStore),
        onToggleParentPanel: $35d0272eac005333$var$getOnToggleParentPanel(dispatch),
        isIssueParentPanelToggleChecked: isEpicPanelOpen,
        onToggleVersionsPanel: $35d0272eac005333$var$getOnToggleVersionsPanel(dispatch),
        isVersionPanelToggleChecked: isVersionsOpen,
        onClearAllButtonClicked: $35d0272eac005333$var$getClearAllFilters(dispatch, isCompanyManaged),
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isCompanyManaged: isCompanyManaged
    };
};
const $35d0272eac005333$var$connector = (0, $bC2fB.connect)($35d0272eac005333$export$c31df4bd766f9c35, $35d0272eac005333$var$mapDispatchToProps, $35d0272eac005333$export$9d1611c77c2fe928);
// @ts-expect-error - TS2345 - Argument of type 'ComponentType<WithIntlProps<APIProps & { intl: IntlShapeV2; customFiltersQueryRef?: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>> | null | undefined; versionFilterRelayQueryRef?: PreloadedQuery<...> | ... 1 more ... | undefined; }>>' is not assignable to parameter of type 'Component<{ assignees: Person[]; filter: Filters; panels: PanelState; labels: string[]; maxAvatars: number; isAddPeopleButtonEnabled: boolean; isCustomFilterManageLinkEnabled: boolean; ... 16 more ...; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }>'.
const $35d0272eac005333$var$ConnectedFilterBar = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($35d0272eac005333$var$connector, (0, $dIdda.withRouter))((0, $cFqzj.default));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$35d0272eac005333$export$2e2bcd8739ae039 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef })=>{
    const [filters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    // Temporary remove custom filters from the url on initial load for team-managed backlog.
    // Need to be removed when applying custom filters on initial load.
    const self = (0, $5uXOq.useRef)({
        isMounted: false
    }).current;
    (0, $5uXOq.useEffect)(()=>{
        if (!self.isMounted) {
            if (isCompanyManaged) setFilters(filters);
            else {
                const { [(0, $41ce9b5576b92b7a$export$68d693c35a8d8866)]: customFilters, ...otherFilters } = filters;
                setFilters(otherFilters);
            }
        }
        self.isMounted = true;
    }, [
        self,
        filters,
        setFilters,
        isCompanyManaged
    ]);
    return(// @ts-expect-error - TS2739 - Type '{ syncFiltersWithRemoteStore: (filters: Filters) => void | Promise<void>; customFiltersQueryRef: PreloadedQuery<viewBacklogCustomFiltersQuery, Record<...>> | null | undefined; versionFilterRelayQueryRef: PreloadedQuery<...> | ... 1 more ... | undefined; }' is missing the following properties from type 'RouteContext': location, query, route, match, action.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35d0272eac005333$var$ConnectedFilterBar, {
        syncFiltersWithRemoteStore: setFilters,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }));
};

});
parcelRegister("fC5rN", function(module, exports) {

$parcel$export(module.exports, "getOpenModalData", () => $63d2f18f3a07e22e$export$580d73f81f464028);
$parcel$export(module.exports, "makeIsModalOpen", () => $63d2f18f3a07e22e$export$95fc19f697e2a886);
$parcel$export(module.exports, "isAnyModalOpen", () => $63d2f18f3a07e22e$export$5160f01afdf30a59);

var $dGvGJ = parcelRequire("dGvGJ");
const $63d2f18f3a07e22e$export$580d73f81f464028 = (state)=>state.ui.modals;
const $63d2f18f3a07e22e$export$95fc19f697e2a886 = (0, $dGvGJ.createSelector)([
    $63d2f18f3a07e22e$export$580d73f81f464028
], (modalData)=>{
    const isModalOpen = (modalType)=>modalData !== null && modalData.type === modalType;
    return isModalOpen;
});
const $63d2f18f3a07e22e$export$5160f01afdf30a59 = (0, $dGvGJ.createSelector)([
    $63d2f18f3a07e22e$export$580d73f81f464028
], (modalData)=>modalData !== null);

});

parcelRegister("aTx7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $539d7fb08de3dccf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2vSU6 = parcelRequire("2vSU6");

var $fjJ1B = parcelRequire("fjJ1B");

var $bC2fB = parcelRequire("bC2fB");

var $hPtZI = parcelRequire("hPtZI");
var $3qQLk = parcelRequire("3qQLk");


var $jG5HW = parcelRequire("jG5HW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $539d7fb08de3dccf$var$AddPeopleModal = (0, $hPtZI.lazy)(()=>(parcelRequire("7HRyA")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $539d7fb08de3dccf$var$Modal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjJ1B.AddPeopleModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3qQLk.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539d7fb08de3dccf$var$AddPeopleModal, props)));
var $539d7fb08de3dccf$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state, ownProps)=>({
        projectId: (0, $jG5HW.projectIdSelector)(state),
        projectKey: (0, $jG5HW.getProjectKey)(state),
        baseUrl: (0, $jG5HW.getBaseUrl)(state),
        isOpen: ownProps.isOpen,
        onClose: ownProps.onClose || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onError: ownProps.onError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onAddSuccess: ownProps.onAddSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onStopPerfMetric: ownProps.onStopPerfMetric || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        isAdmin: true,
        analyticsPrefix: 'software.backlog',
        allowFlags: true
    }), {})($539d7fb08de3dccf$var$Modal);

});
parcelRegister("fjJ1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d4cefe384a250f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $05d4cefe384a250f$export$374b95de0cd72a02);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $39xOx = parcelRequire("39xOx");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


const $05d4cefe384a250f$var$LazyComponent = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("7HRyA")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
const $f7307e9423a0bb88$export$8fcd8ea7ed6539b1 = 'project-settings-apps.add-people-dialog';
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("7HRyA", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("1TWxe")
]).then(()=>parcelRequire('jd2mv'));

});



parcelRegister("cFqzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $af814fbd506433e2$export$2e2bcd8739ae039);

var $jgtyX = parcelRequire("jgtyX");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ljMDN = parcelRequire("ljMDN");

var $ksXL1 = parcelRequire("ksXL1");

var $iFIkB = parcelRequire("iFIkB");

var $39xOx = parcelRequire("39xOx");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $aMFc7 = parcelRequire("aMFc7");

var $koVbs = parcelRequire("koVbs");

var $7Oku1 = parcelRequire("7Oku1");

var $8KmrC = parcelRequire("8KmrC");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $2lpqS = parcelRequire("2lpqS");

var $guzeq = parcelRequire("guzeq");

var $hJnrC = parcelRequire("hJnrC");

var $eY43C = parcelRequire("eY43C");

var $fOzEZ = parcelRequire("fOzEZ");

var $4GPQ6 = parcelRequire("4GPQ6");

var $c1MAf = parcelRequire("c1MAf");

var $gwOHY = parcelRequire("gwOHY");

var $jG5HW = parcelRequire("jG5HW");

var $9Pc1U = parcelRequire("9Pc1U");

var $fSgHa = parcelRequire("fSgHa");

var $5jOz5 = parcelRequire("5jOz5");

var $37oMw = parcelRequire("37oMw");

var $lLAmg = parcelRequire("lLAmg");
// eslint-disable-next-line @atlassian/relay/must-use-inline
const $af814fbd506433e2$var$ViewBacklogVersionFilterRelayQuery = (0, $jgtyX.default);
const $af814fbd506433e2$export$1ac8be34f814ec5b = ({ versionFilterRelayQueryRef: versionFilterRelayQueryRef, ...props })=>{
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $4GPQ6.VersionPanelEntrypointContext));
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const triggerRef = (0, $iFIkB.useEntryPointToggleTrigger)(entryPointActions);
    const projects = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjects));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const jiraProjectIds = (0, $5uXOq.useMemo)(()=>projects.map((project)=>(0, $ljMDN.JiraProjectAri).create({
                projectId: `${project.id}`,
                siteId: tenantContext.cloudId
            }).toString()), [
        projects,
        tenantContext.cloudId
    ]);
    const [data, setData] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (jiraProjectIds.length > 0) (0, $8Uumt.fetchQuery)(environment, $af814fbd506433e2$var$ViewBacklogVersionFilterRelayQuery, {
            jiraProjectIds: jiraProjectIds,
            first: 500,
            after: null
        }, (0, $4R6GH.fg)('fix_backlog_version_filter_loading_issue') ? {
            fetchPolicy: 'store-or-network'
        } : undefined).subscribe({
            next: (response)=>{
                setData(response);
            }
        });
    }, [
        jiraProjectIds,
        environment
    ]);
    const versions = (0, $5uXOq.useMemo)(()=>{
        if (!data) return [];
        const transformedVersions = data.jira.versionsForProjects.edges.filter(Boolean).map(({ node: node })=>({
                id: node?.versionId || '',
                name: node?.name || '',
                projectKey: node?.project?.key
            }));
        return transformedVersions;
    }, [
        data
    ]);
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (data) dispatch({
            type: (0, $gwOHY.SET_VERSIONS),
            payload: {
                versions: data.jira.versionsForProjects.edges.filter(Boolean).map((edge)=>edge.node?.versionId).filter(Boolean)
            }
        });
    }, [
        dispatch,
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
        versions: versions,
        isLoading: !data,
        toggleRef: triggerRef,
        ...props
    });
};
const $af814fbd506433e2$var$isShowParentIssueFilter = (isCMPBacklog, isCMPScrum, showEpicPanelToggle, isIssueParents, isParentIssueTypeValid)=>{
    let showParentIssueFilter;
    if (isCMPBacklog) {
        if (isCMPScrum) // CMP Scrum backlog
        showParentIssueFilter = true;
        else // CMP Kanban backlog
        showParentIssueFilter = showEpicPanelToggle || isIssueParents;
    } else // TMP backlog
    showParentIssueFilter = isParentIssueTypeValid;
    return showParentIssueFilter;
};
const $af814fbd506433e2$export$7a40f967ca91c4d3 = ({ customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, issueTypes: issueTypes, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let parents = (0, $5uXOq.useMemo)(()=>[], []);
    let issueParentsTypeName = '';
    let isParentIssueTypeAvailable = false;
    if ((0, $4R6GH.fg)('jsw_epic_panel_paginated_fetch')) {
        const [{ cards: parentsNew, epicIssueTypeName: issueParentsTypeNameNew, isEpicIssueTypeAvailable: isParentIssueTypeAvailableNew }] = (0, $ksXL1.useEpicsFilterData)();
        parents = parentsNew;
        issueParentsTypeName = issueParentsTypeNameNew;
        isParentIssueTypeAvailable = isParentIssueTypeAvailableNew;
    } else {
        const { parents: parentsOld, issueParentsTypeName: issueParentsTypeNameOld, isParentIssueTypeAvailable: isParentIssueTypeAvailableOld } = (0, $fOzEZ.useGetEpicsAndProject)(props.boardId, true);
        parents = parentsOld;
        issueParentsTypeName = issueParentsTypeNameOld;
        isParentIssueTypeAvailable = isParentIssueTypeAvailableOld;
    }
    const { issueParentsLabel: issueParentsLabel } = props;
    const issueParents = (0, $5uXOq.useMemo)(()=>{
        const target = issueParentsLabel && issueParentsLabel !== (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME) ? issueParentsLabel : (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME).toLowerCase();
        const partialParents = parents.map((parent)=>{
            if ('epic' in parent) return {
                id: String(parent.epic.id),
                key: parent.epic.key,
                name: parent.epic.name
            };
            return {
                id: parent.id,
                key: parent.key,
                name: parent.summary
            };
        });
        return partialParents && partialParents.length ? [
            {
                id: String((0, $2lpqS.UNASSIGNED_EPIC_ID)),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $37oMw.default).unassignedIssueTermRefresh : (0, $37oMw.default).unassigned, {
                    target: target
                })
            },
            ...partialParents
        ] : partialParents;
    }, [
        formatMessage,
        issueParentsLabel,
        parents
    ]);
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const isCMPScrum = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.isCMPScrumBacklog));
    const showEpicPanelToggle = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const hasMultipleProjects = (0, $c1MAf.useBacklogSelector)((state)=>(0, $jG5HW.getProjects)(state).length > 1);
    const showParentIssueFilter = $af814fbd506433e2$var$isShowParentIssueFilter(isCMPBacklog, isCMPScrum, showEpicPanelToggle, issueParents.length > 0, isParentIssueTypeAvailable);
    const versionFilterProps = {
        VersionFilterRelay: $af814fbd506433e2$export$1ac8be34f814ec5b,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        isVersionFilterRelayEnabled: true
    };
    const panelToggleVisibility = {
        showEpicPanelToggle: isCMPBacklog ? showEpicPanelToggle : true,
        showVersionsPanelToggle: true
    };
    const issueTypesToDisplay = (0, $lLAmg.useIssueTypes)(issueTypes);
    const handleRelayRequiredFail = (location, error)=>{
        if (!(0, $7Oku1.isRelayValidationError)(error)) throw error;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "backlogHeaderControlsBarFilterBar",
        packageName: "software-backlog",
        onError: handleRelayRequiredFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8KmrC.default), {
        ...props,
        issueTypes: issueTypesToDisplay,
        issueParents: issueParents,
        issueParentsLabel: issueParentsTypeName,
        showPanelToggle: undefined,
        panelToggleVisibility: panelToggleVisibility,
        showParentIssueMenuIfValuesAreEmpty: showParentIssueFilter,
        showSearchFilterChangeboarding: true,
        hijackBrowserDefaultSearch: !isCMPBacklog,
        screenName: "backlog",
        onChangeInteractionFeedback: (0, $eY43C.setInteractionFeedbackMark),
        onChangeInteractionStart: (0, $eY43C.setInteractionStartMark),
        onCustomFilterChangeInteractionFeedback: (0, $hJnrC.setCustomFilterInteractionFeedbackMark),
        onCustomFilterChangeInteractionStart: (0, $hJnrC.setCustomFilterInteractionStartMark),
        showCustomFilters: isCMPBacklog,
        customFiltersQueryRef: customFiltersQueryRef,
        // @ts-expect-error - TS2345 - Type 'CustomFiltersQueryRef | undefined' is not assignable to type 'PreloadedQuery<viewBacklogCustomFiltersQuery, Record<string, unknown>>'.
        CustomFilter: (0, $5jOz5.BacklogCustomFilter),
        placeholder: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $37oMw.default).filterPlaceholder) : formatMessage((0, $37oMw.default).textFilter),
        isUnassignedAssigneeOptionEnabled: true,
        isUnassignedVersionOptionEnabled: isCMPBacklog,
        onClearCustomFilterInteractionStart: (0, $hJnrC.setClearCustomFilterInteractionStartMark),
        hasMultipleProjects: hasMultipleProjects,
        ...versionFilterProps
    }));
};
var $af814fbd506433e2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($af814fbd506433e2$export$7a40f967ca91c4d3);

});
parcelRegister("iFIkB", function(module, exports) {

$parcel$export(module.exports, "useEntryPointToggleTrigger", () => $7b49b15164b51422$export$85854750ad265021);

var $5uXOq = parcelRequire("5uXOq");

var $f9Q5V = parcelRequire("f9Q5V");
const $7b49b15164b51422$export$85854750ad265021 = (actions, offValue = false)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((refElement)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (refElement) {
            const { type: type } = refElement;
            if (type !== 'checkbox' && type !== 'radio') throw new Error(`HTMLInputElement ref of type ${type} cannot be used with useEntryPointToggleTrigger. Try checkbox or radio.`);
            const hoverElement = (0, $f9Q5V.getHoverProxy)(refElement);
            const handlers = {
                load () {
                    if (refElement.checked !== offValue) actions.load();
                },
                preload () {
                    if (refElement.checked === offValue) actions.preload();
                },
                cancelPreload () {
                    if (refElement.checked === offValue) actions.cancelPreload();
                }
            };
            (0, $f9Q5V.addListeners)(handlers, refElement, hoverElement);
            removePreviousListeners.current = ()=>{
                (0, $f9Q5V.removeListeners)(handlers, refElement, hoverElement);
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        offValue
    ]);
};

});
parcelRegister("f9Q5V", function(module, exports) {

$parcel$export(module.exports, "getHoverProxy", () => $1f1f6fdef1f8dba5$export$ed19923445ff0a86);
$parcel$export(module.exports, "addListeners", () => $1f1f6fdef1f8dba5$export$95d0815810fa2c63);
$parcel$export(module.exports, "removeListeners", () => $1f1f6fdef1f8dba5$export$5073839cf61ff85c);
const $1f1f6fdef1f8dba5$export$ed19923445ff0a86 = (element)=>element.parentElement?.tagName === 'LABEL' ? element.parentElement : element;
const $1f1f6fdef1f8dba5$export$95d0815810fa2c63 = (handlers, refElement, hoverElement)=>{
    refElement.addEventListener('change', handlers.load);
    refElement.addEventListener('focusin', handlers.preload);
    refElement.addEventListener('focusout', handlers.cancelPreload);
    hoverElement.addEventListener('mouseenter', handlers.preload);
    hoverElement.addEventListener('mouseleave', handlers.cancelPreload);
};
const $1f1f6fdef1f8dba5$export$5073839cf61ff85c = (handlers, refElement, hoverElement)=>{
    refElement.removeEventListener('change', handlers.load);
    refElement.removeEventListener('focusin', handlers.preload);
    refElement.removeEventListener('focusout', handlers.cancelPreload);
    hoverElement.removeEventListener('mouseenter', handlers.preload);
    hoverElement.removeEventListener('mouseleave', handlers.cancelPreload);
};

});


parcelRegister("aMFc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $119ce63ee3cabcee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9ARNv = parcelRequire("9ARNv");

var $hfc8j = parcelRequire("hfc8j");
var $47htk = parcelRequire("47htk");

var $heNNl = parcelRequire("heNNl");

var $7iJwP = parcelRequire("7iJwP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $dIdda = parcelRequire("dIdda");

var $96s6B = parcelRequire("96s6B");

var $gfbKZ = parcelRequire("gfbKZ");
const $119ce63ee3cabcee$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const [boardId] = (0, $dIdda.usePathParam)('boardId');
    const values = (0, $5uXOq.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $gfbKZ.default).label),
            toggleLabel: formatMessage((0, $gfbKZ.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $g5X3G.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $gfbKZ.default).noUnreleasedVersions : (0, $gfbKZ.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef,
            isLoading: isLoading
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel,
        isLoading
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hfc8j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9ARNv.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$119ce63ee3cabcee$var$VersionFilter.displayName = 'VersionFilter';
$119ce63ee3cabcee$var$VersionFilter.whyDidYouRender = true;
const $119ce63ee3cabcee$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $heNNl.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($119ce63ee3cabcee$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
$119ce63ee3cabcee$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isNested: false
};
var $119ce63ee3cabcee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($119ce63ee3cabcee$var$ErrorWrapper);

});
parcelRegister("96s6B", function(module, exports) {

$parcel$export(module.exports, "ListFilter", () => $51e7460acbb65361$export$fa71ab09534e6447);
$parcel$export(module.exports, "default", () => $51e7460acbb65361$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $95EVP = parcelRequire("95EVP");

var $iYdlH = parcelRequire("iYdlH");
var $32eUr = parcelRequire("32eUr");
var $cpoLo = parcelRequire("cpoLo");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8C9C3 = parcelRequire("8C9C3");

var $dF38k = parcelRequire("dF38k");

var $73s29 = parcelRequire("73s29");

var $d9hVL = parcelRequire("d9hVL");

var $4Mv0u = parcelRequire("4Mv0u");

var $ijTad = parcelRequire("ijTad");
const $51e7460acbb65361$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32eUr.components).MenuList, rest, children));
const $51e7460acbb65361$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const options = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $8C9C3.OPEN_CHANGE_PAYLOAD));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8C9C3.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>(0, $4R6GH.fg)('allow_jplat_filter_list_to_be_disabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF38k.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9hVL.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $d9hVL.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpoLo.default), {
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $73s29.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $iYdlH.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $51e7460acbb65361$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $ijTad.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        })
    });
};
$51e7460acbb65361$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $51e7460acbb65361$export$2e2bcd8739ae039 = $51e7460acbb65361$export$fa71ab09534e6447;

});
parcelRegister("iYdlH", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $4367ceec54590ad3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $4367ceec54590ad3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2rl6t = parcelRequire("2rl6t");

var $ayaEM = parcelRequire("ayaEM");

function $4367ceec54590ad3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4367ceec54590ad3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $4367ceec54590ad3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $5e0c0d4e15efb4a6$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $5e0c0d4e15efb4a6$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $5e0c0d4e15efb4a6$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $4367ceec54590ad3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $4367ceec54590ad3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`;
};
const $4367ceec54590ad3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $4367ceec54590ad3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $4367ceec54590ad3$var$ControlOption extends (0, $5uXOq.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $4367ceec54590ad3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $4367ceec54590ad3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $4367ceec54590ad3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
            label: "",
            primaryColor: $4367ceec54590ad3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $4367ceec54590ad3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $4367ceec54590ad3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $4367ceec54590ad3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($4367ceec54590ad3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2rl6t))),
        ...props
    });
const $4367ceec54590ad3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)($4367ceec54590ad3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ayaEM))),
        ...props
    });

});
parcelRegister("2rl6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c6e7919e498e5bc$var$_react = $1c6e7919e498e5bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $1c6e7919e498e5bc$var$_checkboxChecked = $1c6e7919e498e5bc$var$_interopRequireDefault((parcelRequire("boymd")));
function $1c6e7919e498e5bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c6e7919e498e5bc$var$CheckboxIcon = (props)=>/*#__PURE__*/ $1c6e7919e498e5bc$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $1c6e7919e498e5bc$var$_checkboxChecked.default
    }));
$1c6e7919e498e5bc$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $1c6e7919e498e5bc$var$_default = module.exports.default = $1c6e7919e498e5bc$var$CheckboxIcon;

});
parcelRegister("boymd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84bc9640484b107d$var$_react = $84bc9640484b107d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $84bc9640484b107d$var$_UNSAFE_baseNew = $84bc9640484b107d$var$_interopRequireDefault((parcelRequire("huIZN")));
function $84bc9640484b107d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84bc9640484b107d$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $84bc9640484b107d$var$_react.default.createElement($84bc9640484b107d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$84bc9640484b107d$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $84bc9640484b107d$var$_default = module.exports.default = $84bc9640484b107d$var$CheckboxCheckedIcon;

});


parcelRegister("ayaEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ae5589184882d35$var$_react = $7ae5589184882d35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $7ae5589184882d35$var$_radioChecked = $7ae5589184882d35$var$_interopRequireDefault((parcelRequire("aEsVh")));
function $7ae5589184882d35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ae5589184882d35$var$RadioIcon = (props)=>/*#__PURE__*/ $7ae5589184882d35$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $7ae5589184882d35$var$_radioChecked.default
    }));
$7ae5589184882d35$var$RadioIcon.displayName = 'RadioIcon';
var $7ae5589184882d35$var$_default = module.exports.default = $7ae5589184882d35$var$RadioIcon;

});
parcelRegister("aEsVh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c14134d2616dc5d$var$_react = $7c14134d2616dc5d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c14134d2616dc5d$var$_UNSAFE_baseNew = $7c14134d2616dc5d$var$_interopRequireDefault((parcelRequire("huIZN")));
function $7c14134d2616dc5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c14134d2616dc5d$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $7c14134d2616dc5d$var$_react.default.createElement($7c14134d2616dc5d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$7c14134d2616dc5d$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $7c14134d2616dc5d$var$_default = module.exports.default = $7c14134d2616dc5d$var$RadioCheckedIcon;

});



parcelRegister("8C9C3", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $e9228ce7bf573a8c$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $e9228ce7bf573a8c$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $e9228ce7bf573a8c$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $e9228ce7bf573a8c$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $e9228ce7bf573a8c$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $e9228ce7bf573a8c$export$b94e5dc1a8a1409);

var $gwIPs = parcelRequire("gwIPs");
const $e9228ce7bf573a8c$export$84ae3fb9fdba8a12 = (0, $gwIPs.gridSize) * 21;
const $e9228ce7bf573a8c$export$920d89f17cd2fe3d = (0, $gwIPs.gridSize) * 25;
const $e9228ce7bf573a8c$export$6ea791ab71b8fa00 = (0, $gwIPs.gridSize) * 48;
const $e9228ce7bf573a8c$export$1d287c6a8b81eb5b = 9;
const $e9228ce7bf573a8c$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $e9228ce7bf573a8c$export$b94e5dc1a8a1409 = 'filterList';

});

parcelRegister("dF38k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2deb009ebf7ebceb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

var $8wifS = parcelRequire("8wifS");

var $l6YPM = parcelRequire("l6YPM");
const $2deb009ebf7ebceb$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$HorizontalSeparator, null), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6YPM.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wifS.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$2deb009ebf7ebceb$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $2deb009ebf7ebceb$export$2e2bcd8739ae039 = $2deb009ebf7ebceb$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2deb009ebf7ebceb$var$HorizontalSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $2deb009ebf7ebceb$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4wux3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wifS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8743d62747e29a3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $feGGA = parcelRequire("feGGA");

var $8oe80 = parcelRequire("8oe80");

var $8zOmE = parcelRequire("8zOmE");

var $dIdda = parcelRequire("dIdda");
const $8743d62747e29a3c$var$DropdownItem = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $feGGA.default));
const $8743d62747e29a3c$var$linkWrapperStyles = null;
const $8743d62747e29a3c$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $dIdda.useRouterActions)();
    const onDropdownClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $8743d62747e29a3c$export$2e2bcd8739ae039 = $8743d62747e29a3c$export$532cb6865ebe8946;

});

parcelRegister("l6YPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad247e508ffc141$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $eddAM = parcelRequire("eddAM");

var $as51G = parcelRequire("as51G");

var $8oe80 = parcelRequire("8oe80");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3XFdo = parcelRequire("3XFdo");

var $gCuaO = parcelRequire("gCuaO");
const $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $4ad247e508ffc141$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $4ad247e508ffc141$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $3XFdo.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $gCuaO.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as51G.default), {
        label: ariaLabel,
        id: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleLabel, {
        htmlFor: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleHint, {
        id: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $gCuaO.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eddAM.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$4ad247e508ffc141$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $4ad247e508ffc141$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $5uXOq.memo), (0, $8oe80.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($4ad247e508ffc141$var$PanelToggle);
const $4ad247e508ffc141$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleControl = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleHint = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3XFdo", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $5bd9980697730d58$export$fa36ece4b5d88abc);

const $5bd9980697730d58$var$panelShortcuts = {
    Epic: (0, $570f28ac9bf58edd$export$9b094cdf6fd7589e),
    Version: (0, $570f28ac9bf58edd$export$6f416a1fb11a53d9)
};
const $5bd9980697730d58$export$fa36ece4b5d88abc = (panelType)=>$5bd9980697730d58$var$panelShortcuts[panelType];

});
const $570f28ac9bf58edd$export$a10c132b86ae798b = 'Epic';
const $570f28ac9bf58edd$export$41073ac826c57195 = 'Version';
const $570f28ac9bf58edd$export$9b094cdf6fd7589e = 'E';
const $570f28ac9bf58edd$export$6f416a1fb11a53d9 = 'V';


parcelRegister("gCuaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2063ebcfe536a9b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2063ebcfe536a9b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("73s29", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a49ecd68dc207cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a49ecd68dc207cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    }
});

});

parcelRegister("d9hVL", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $3a4e6a305ebc1d35$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $3a4e6a305ebc1d35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $MGmIU = parcelRequire("MGmIU");

var $gwIPs = parcelRequire("gwIPs");
const $3a4e6a305ebc1d35$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionLabel, null, label));
const $3a4e6a305ebc1d35$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionSubLabel, null, subLabel));
};
$3a4e6a305ebc1d35$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $3a4e6a305ebc1d35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3a4e6a305ebc1d35$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a4e6a305ebc1d35$var$SelectOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _11c81vlj _syaz1e9r",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_zb0g5d": (0, $lD23V.default)((0, $gwIPs.layout).issueIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Mv0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd436e148f99ab3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bxhgD = parcelRequire("bxhgD");

var $89thI = parcelRequire("89thI");

var $9ed83 = parcelRequire("9ed83");

var $2xkq3 = parcelRequire("2xkq3");

var $68lfN = parcelRequire("68lfN");

var $cSFUi = parcelRequire("cSFUi");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $4R6GH = parcelRequire("4R6GH");

var $7mPT9 = parcelRequire("7mPT9");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bd436e148f99ab3e$var$FilterListTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSFUi))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2xkq3))),
        LEGACY_primaryColor: primaryColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68lfN))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9ed83))),
        LEGACY_primaryColor: primaryColor
    });
    const inputRef = (0, $5uXOq.useRef)();
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $7mPT9.mergeRefs)(ref, inputRef) : ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            !isNested && $bd436e148f99ab3e$var$containerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$StyledButton, {
        ...popupProps,
        ref: conditionalRef,
        isNested: isNested,
        isSelected: isOpen || (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        ...(0, $4R6GH.fg)('allow_jplat_filter_list_to_be_disabled') && {
            isDisabled: isDisabled || false
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerLabel, null, label), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
        appearance: "primary"
    }, selectedCount)))))));
});
var $bd436e148f99ab3e$export$2e2bcd8739ae039 = $bd436e148f99ab3e$var$FilterListTrigger;
const $bd436e148f99ab3e$var$containerStyles = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $bd436e148f99ab3e$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $89thI.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("ijTad", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $a5603fd49981b3bf$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $a5603fd49981b3bf$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $a5603fd49981b3bf$export$62d9d395b3dd2ae8);

var $eB7nO = parcelRequire("eB7nO");

var $8C9C3 = parcelRequire("8C9C3");
const $a5603fd49981b3bf$var$isValueGroupOption = (value)=>'options' in value;
const $a5603fd49981b3bf$var$containsOnlyOption = (values)=>values.every((value)=>!$a5603fd49981b3bf$var$isValueGroupOption(value));
const $a5603fd49981b3bf$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $a5603fd49981b3bf$var$containsOnlyOption(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $a5603fd49981b3bf$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$a5603fd49981b3bf$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $a5603fd49981b3bf$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $8C9C3.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $8C9C3.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $8C9C3.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $8C9C3.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $eB7nO.createFilter)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};

});


parcelRegister("gfbKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f065e16be4d58f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f065e16be4d58f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("7Oku1", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $8940bd8b67d2f481$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $8940bd8b67d2f481$export$60d8267243755b9c);

var $ht021 = parcelRequire("ht021");
const $8940bd8b67d2f481$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $8940bd8b67d2f481$export$f450dbe0abffdade = (error)=>error.message.includes($8940bd8b67d2f481$export$321834dc4377cb7);
class $8940bd8b67d2f481$export$60d8267243755b9c extends (0, $ht021.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});

parcelRegister("8KmrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2622f927d259b739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $fr1K2 = parcelRequire("fr1K2");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");


var $kbfkr = parcelRequire("kbfkr");

var $361on = parcelRequire("361on");
const $2622f927d259b739$var$clearAndSetPerformanceMark = (markKey)=>{
    if ((0, $6RCeq.default) && (0, $6RCeq.default).clearMarks) (0, $6RCeq.default).clearMarks(markKey);
    (0, $x9xyg.setMark)(markKey);
};
const $2622f927d259b739$var$useDebouncedOnChange = (onChange, createAnalyticsEvent)=>{
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((filters, filterType, attributes)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'filterBar'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
                    ...attributes,
                    filterType: filterType
                });
                onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes, analyticsEvent);
            } else onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes);
        }, 5), [
        onChange,
        createAnalyticsEvent
    ]);
    return debouncedOnChange;
};
const $2622f927d259b739$var$useOnChangeFilterValues = (filter, onChange, // @ts-expect-error - TS7006 - Parameter 'onChangeInteractionStart' implicitly has an 'any' type.
onChangeInteractionStart, // @ts-expect-error - TS7006 - Parameter 'onCustomFilterChangeInteractionStart' implicitly has an 'any' type.
onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged)=>{
    const [localFilter, setFilters] = (0, $5uXOq.useState)(filter);
    (0, $5uXOq.useEffect)(()=>{
        setFilters(filter);
    }, [
        filter
    ]);
    const debouncedOnChange = $2622f927d259b739$var$useDebouncedOnChange(onChange, createAnalyticsEvent);
    const onChangeFilterValues = (0, $5uXOq.useCallback)((filters, fieldType, attributes)=>{
        if (fieldType !== null) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStart');
            (0, $361on.onFilterChangeStartInteraction)(fieldType, onChangeInteractionStart, onCustomFilterChangeInteractionStart);
            const values = filters[fieldType] ?? [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            let updatedFilter = {
                ...localFilter,
                [fieldType]: values
            };
            if (values.length === 0) {
                isCompanyManaged && onClearCustomFilterInteractionStart();
                updatedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(localFilter, fieldType);
            }
            setFilters(updatedFilter);
            // fieldType could in theory not be accurate on a final debounced call,
            // however there's only a 5ms window during which this may happen.
            debouncedOnChange(updatedFilter, fieldType, attributes);
        }
    }, [
        onChangeInteractionStart,
        onCustomFilterChangeInteractionStart,
        setFilters,
        localFilter,
        debouncedOnChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        const emptyFilters = {
            TEXT: undefined,
            ASSIGNEE: undefined,
            LABEL: undefined,
            SPRINT: undefined,
            ISSUE_PARENT: undefined,
            ISSUE_PROJECT: undefined,
            ISSUE_TYPE: undefined,
            VERSION: undefined,
            REQUEST_TYPE: undefined,
            STATUS_CATEGORY: undefined,
            STATUS: undefined,
            CUSTOM_FILTER: undefined,
            DEPENDENCIES: undefined
        };
        isCompanyManaged && onClearCustomFilterInteractionStart();
        setFilters(emptyFilters);
        // A 2nd `null` argument is required so that the analytics event doesn't get treated as the
        // filter type on filter analytics.
        onChange((0, $361on.getNormalizedFilters)(emptyFilters), null, undefined);
    }, [
        onChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    return [
        localFilter,
        onChangeFilterValues,
        clearFilter
    ];
};
const $2622f927d259b739$var$SoftwareFilters = (props)=>{
    const { filter: filter, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked, onChangeInteractionFeedback: onChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionFeedback: onCustomFilterChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionStart: onCustomFilterChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isCompanyManaged: isCompanyManaged = false, onClearCustomFilterInteractionStart: onClearCustomFilterInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [localFilters, onChangeFilterValues, clearFilter] = $2622f927d259b739$var$useOnChangeFilterValues(filter, onChange, onChangeInteractionStart, onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter, localFilters)) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStop');
            onChangeInteractionFeedback();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter.CUSTOM_FILTER, localFilters.CUSTOM_FILTER)) onCustomFilterChangeInteractionFeedback();
        }
    }, [
        filter,
        localFilters,
        onChangeInteractionFeedback,
        onCustomFilterChangeInteractionFeedback
    ]);
    $2622f927d259b739$var$clearAndSetPerformanceMark('oldFilterBarStop');
    const onClear = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        // we always have to pass void entityType, so analytics events will always be as third argument
        clearFilter();
        onClearAllButtonClicked && onClearAllButtonClicked(event, analyticsEvent);
        const customAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(customAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $15a528573ccd89ae$export$6c4d37c7f376a1de)
        });
    }, [
        clearFilter,
        onClearAllButtonClicked,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbfkr.default), {
        ...props,
        filter: localFilters,
        onClearAllButtonClicked: onClear,
        onChange: onChangeFilterValues
    });
};
var $2622f927d259b739$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2622f927d259b739$var$SoftwareFilters);

});
parcelRegister("kbfkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7c802f0a442491$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hqTkp = parcelRequire("hqTkp");

var $gKZoD = parcelRequire("gKZoD");

var $cOXTq = parcelRequire("cOXTq");

var $dPuU1 = parcelRequire("dPuU1");

var $6T4rd = parcelRequire("6T4rd");

var $9MjbF = parcelRequire("9MjbF");

var $9KB2r = parcelRequire("9KB2r");

var $dqoiX = parcelRequire("dqoiX");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $joX8T = parcelRequire("joX8T");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $6CjZR = parcelRequire("6CjZR");

var $1beWO = parcelRequire("1beWO");

var $3oCwY = parcelRequire("3oCwY");

var $7j6PN = parcelRequire("7j6PN");

var $8bg0N = parcelRequire("8bg0N");

var $kgqZV = parcelRequire("kgqZV");

var $efv79 = parcelRequire("efv79");

var $jKPI1 = parcelRequire("jKPI1");

var $hHL6f = parcelRequire("hHL6f");

var $2fsdj = parcelRequire("2fsdj");

var $bLWKp = parcelRequire("bLWKp");

var $hpA0D = parcelRequire("hpA0D");

var $g65Ek = parcelRequire("g65Ek");

var $jdA4J = parcelRequire("jdA4J");

var $cSFZv = parcelRequire("cSFZv");

var $3f9TT = parcelRequire("3f9TT");

var $aMFc7 = parcelRequire("aMFc7");

var $fJnmW = parcelRequire("fJnmW");

var $koVbs = parcelRequire("koVbs");

var $cTi8P = parcelRequire("cTi8P");

var $2m0b6 = parcelRequire("2m0b6");

var $gtgKk = parcelRequire("gtgKk");

var $8vjSE = parcelRequire("8vjSE");

var $2WENx = parcelRequire("2WENx");

var $2xSAL = parcelRequire("2xSAL");

var $g5X3G = parcelRequire("g5X3G");

var $fUHZ2 = parcelRequire("fUHZ2");

var $90yGq = parcelRequire("90yGq");

var $dCm1o = parcelRequire("dCm1o");


var $4Djk8 = parcelRequire("4Djk8");

var $cM4EP = parcelRequire("cM4EP");

var $2FvdY = parcelRequire("2FvdY");

var $kH9yv = parcelRequire("kH9yv");

var $bBMqL = parcelRequire("bBMqL");

var $l38sT = parcelRequire("l38sT");

var $649U3 = parcelRequire("649U3");
const $cb7c802f0a442491$var$EMPTY_ARRAY = [];
const $cb7c802f0a442491$var$MIN_VISIBLE_USERS = 2;
const $cb7c802f0a442491$var$USER_AVATAR_WIDTH = 30;
const $cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS = 7;
const $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH = 510;
const $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $cb7c802f0a442491$var$SoftwareFiltersStateless = (props)=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [] } = props;
    const accountId = (0, $90yGq.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allAssignees = (0, $5uXOq.useMemo)(()=>{
        if (!isUnassignedAssigneeOptionEnabled) return assignees;
        const unassignedUser = {
            id: (0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            displayName: formatMessage((0, $l38sT.default).unassignedAssigneeDisplayName),
            avatarUrl: undefined
        };
        if ((0, $4R6GH.fg)('jira-collab-unassigned-filter-cta-gate')) return [
            unassignedUser,
            ...assignees
        ];
        return [
            ...assignees,
            unassignedUser
        ];
    }, [
        assignees,
        isUnassignedAssigneeOptionEnabled,
        formatMessage
    ]);
    const allVersions = (0, $5uXOq.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedVersionLabelIssueTermRefresh : (0, $l38sT.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedLabelLabelIssueTermRefresh : (0, $l38sT.default).unassignedLabelLabel),
            value: (0, $15a528573ccd89ae$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $5uXOq.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $15a528573ccd89ae$export$4b7c755e61199a36),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedComponentLabelIssueTermRefresh : (0, $l38sT.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: newText
        }, (0, $15a528573ccd89ae$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filter, [
            (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
        ], $cb7c802f0a442491$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $5uXOq.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $g5X3G.toAccountIdArray)(newFilterValue)
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: false,
            // part of experiment jira-collab-unassigned-filter-cta
            isUnassignedSelected: newFilterValue.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $5uXOq.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: parentIds
        }, (0, $15a528573ccd89ae$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $5uXOq.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $g5X3G.toVersionIdArray)(versionIds)
        }, (0, $15a528573ccd89ae$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $5uXOq.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $g5X3G.toComponentIdArray)(componentIds)
        }, (0, $15a528573ccd89ae$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $5uXOq.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $5uXOq.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: newProjects
        }, (0, $15a528573ccd89ae$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $5uXOq.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $15a528573ccd89ae$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $5uXOq.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $15a528573ccd89ae$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $5uXOq.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $15a528573ccd89ae$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $5uXOq.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $15a528573ccd89ae$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $5uXOq.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: newStatuses
        }, (0, $15a528573ccd89ae$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $5uXOq.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $15a528573ccd89ae$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $5uXOq.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goalIds
        }, (0, $15a528573ccd89ae$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const onChangeDependencies = (0, $5uXOq.useCallback)((dependencyOptions, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: dependencyOptions
        }, (0, $15a528573ccd89ae$export$db362e2d293fe52e), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $5uXOq.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]);
    const searchInputRef = (0, $5uXOq.useRef)(null);
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)(screenName);
    const focusSearchInput = (0, $6s1PB.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false) ? ()=>{
        if (!searchInputRef.current) return; // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef.current && searchInputRef.current.focus();
        });
        const analyticsPayload = {
            id: 'focusSearchField',
            key: 'f',
            attributes: {}
        };
        fireShortcutAnalytics(analyticsPayload);
    } : ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    };
    const screenReaderDescriptionId = 'search-issue-description'; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $649U3.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $15a528573ccd89ae$export$2a4f270075a033de),
        isStatic: false,
        isHidden: (0, $4Djk8.isIncrementPlanningBoardM1Enabled)() ? !isIssueParentsFeatureEnabled : undefined,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLWKp.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $15a528573ccd89ae$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $15a528573ccd89ae$export$a4ad2735b021c132),
        isStatic: false,
        hidden: !isVersionsFeatureEnabled,
        renderer: (isNested)=>isVersionFilterRelayEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                key: "VersionFilterRelayBoundary",
                screenName: screenName,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                    isNested: isNested,
                    versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isToggleChecked: isVersionPanelToggleChecked,
                    onChange: onChangeVersions,
                    onTogglePanel: onToggleVersionsPanel,
                    selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                    isSpotlightEnabled: false,
                    showPanelToggle: showVersionsPanelToggle,
                    isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    isLoading: true
                })
            }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled,
                versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                hasMultipleProjects: hasMultipleProjects
            }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                key: "VersionFilter",
                isNested: isNested,
                versions: allVersions,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            })
    };
    const overflowItemsBefore = [
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: (0, $4Djk8.isIncrementPlanningBoardM1Enabled)() ? !isIssueProjectsFeatureEnabled : undefined,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    shouldReturnFocus: (0, $4R6GH.fg)('jsw_remove_the_auto_focus_on_custom_filter') ? undefined : isClearButtonVisible === false,
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: (0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be') ? !isDependenciesFeatureEnabled : true,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        }
    ];
    const overflowItemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: isClearButtonVisible,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oCwY.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) overflowItemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb7c802f0a442491$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9MjbF.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $5uXOq.useState)($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $5uXOq.useState)(true);
    const filterBarRef = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return;
        const completeFilterBarWidth = filterBarRef.current.offsetWidth; // complete bar with input + filter controls
        const searchInputWidth = searchInputRef.current.offsetWidth; // only the input
        const remainingWidth = completeFilterBarWidth - searchInputWidth; // remaining room for avatar, etc.
        // Handle avatar overflow
        if (remainingWidth < $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $cb7c802f0a442491$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS - usersToReduce, $cb7c802f0a442491$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        setShowLargeSearchFilter(window.innerWidth >= $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $2m0b6.useResizeObserver)({
        ref: filterBarRef,
        onResize: onResize
    });
    (0, $2m0b6.useResizeObserver)({
        ref: searchInputRef,
        onResize: onResize
    });
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = ()=>screenName === 'board' && experimentCohort === (0, $joX8T.VARIATION);
    if (screenName === 'board' && experimentCohort !== (0, $joX8T.NOT_ENROLLED)) {
        const [, fireExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
        fireExposure();
    }
    const [{ participants: participants }] = (0, $8vjSE.useCollabStore)();
    const allUsersWithPresence = isRealtimePresenceEnabled() ? (0, $649U3.getAssigneesWithPresence)(allAssignees, participants) : allAssignees;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $l38sT.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOXTq))), {
                                label: formatMessage((0, $l38sT.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: screenReaderDescriptionId
    }, screenReaderInstruction || formatMessage((0, $l38sT.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $l38sT.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvdY.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH9yv.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: screenReaderDescriptionId,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field"
    }), (0, $co1wz.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTi8P.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1beWO.default), {
        maxUsers: maxVisibleUsers,
        users: allUsersWithPresence,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey
    }), isRealtimePresenceEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtgKk.CollabContainerAsync), {
        screenName: screenName,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CjZR.default), {
        itemsBefore: overflowItemsBefore,
        itemsAfter: overflowItemsAfter,
        selectedItems: filter
    })));
};
const $cb7c802f0a442491$var$customSearchInputStyles = null; // TODO: remove on visual-refresh cleanup
const $cb7c802f0a442491$var$customSearchInputStylesOld = null;
const $cb7c802f0a442491$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KB2r.default), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dPuU1))), {
            primaryColor: "var(--ds-icon, #44546F)",
            size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66" : "_2rkoq1pp _1yt4ze3t _1rns1b66 _1srlxy5q"
        ])
    });
var $cb7c802f0a442491$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($cb7c802f0a442491$var$SoftwareFiltersStateless);
const $cb7c802f0a442491$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cOXTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95589d0a14a7a926$var$_react = $95589d0a14a7a926$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $95589d0a14a7a926$var$_page = $95589d0a14a7a926$var$_interopRequireDefault((parcelRequire("fjyuB")));
function $95589d0a14a7a926$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95589d0a14a7a926$var$PageIcon = (props)=>/*#__PURE__*/ $95589d0a14a7a926$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $95589d0a14a7a926$var$_page.default
    }));
$95589d0a14a7a926$var$PageIcon.displayName = 'PageIcon';
var $95589d0a14a7a926$var$_default = module.exports.default = $95589d0a14a7a926$var$PageIcon;

});
parcelRegister("fjyuB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b26362db4774db4d$var$_react = $b26362db4774db4d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b26362db4774db4d$var$_UNSAFE_baseNew = $b26362db4774db4d$var$_interopRequireDefault((parcelRequire("huIZN")));
function $b26362db4774db4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b26362db4774db4d$var$PageIcon = (props)=>/*#__PURE__*/ $b26362db4774db4d$var$_react.default.createElement($b26362db4774db4d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$b26362db4774db4d$var$PageIcon.displayName = 'PageIcon';
var $b26362db4774db4d$var$_default = module.exports.default = $b26362db4774db4d$var$PageIcon;

});


parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($7691773a5eed3db6$export$16b06d29ef8f802b || ($7691773a5eed3db6$export$16b06d29ef8f802b = {}));
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($7691773a5eed3db6$export$abf26cc5daebd2c8 || ($7691773a5eed3db6$export$abf26cc5daebd2c8 = {}));
var $7691773a5eed3db6$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($7691773a5eed3db6$export$12514ca8899b0521 || ($7691773a5eed3db6$export$12514ca8899b0521 = {}));
var $7691773a5eed3db6$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($7691773a5eed3db6$export$5fa0bcf59f933c21 || ($7691773a5eed3db6$export$5fa0bcf59f933c21 = {}));
var $7691773a5eed3db6$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($7691773a5eed3db6$export$7d9743be0b7d862f || ($7691773a5eed3db6$export$7d9743be0b7d862f = {}));
var $7691773a5eed3db6$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($7691773a5eed3db6$export$b4e1633c86db2b70 || ($7691773a5eed3db6$export$b4e1633c86db2b70 = {}));
var $7691773a5eed3db6$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($7691773a5eed3db6$export$5e5a87aac5d9771f || ($7691773a5eed3db6$export$5e5a87aac5d9771f = {}));

});

parcelRegister("5rVQI", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $c7aab549acec9d6e$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $c7aab549acec9d6e$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($c7aab549acec9d6e$export$5ea2dca0a260365d || ($c7aab549acec9d6e$export$5ea2dca0a260365d = {}));

});

parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("879xD", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $6700f9962d7215c2$export$7ff7e4fe85a5960a);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $jh7L9 = parcelRequire("jh7L9");

var $3Tty1 = parcelRequire("3Tty1");
const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $5uXOq.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $jh7L9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $7JoAD = parcelRequire("7JoAD");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $7JoAD.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $7JoAD.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $7JoAD.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $7JoAD.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $7JoAD.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($3996a4302dca83b1$export$1ee9d153576afd13 || ($3996a4302dca83b1$export$1ee9d153576afd13 = {}));
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($b1e48ebd4c8d5e4e$export$f041b1b117ab382f || ($b1e48ebd4c8d5e4e$export$f041b1b117ab382f = {}));
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $9C5d5 = parcelRequire("9C5d5");

var $3iMqq = parcelRequire("3iMqq");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $3iMqq.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $9C5d5.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $3iMqq.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $3iMqq.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $9C5d5.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});








parcelRegister("6CjZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef8f88c53fc825$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $bxhgD = parcelRequire("bxhgD");

var $89thI = parcelRequire("89thI");

var $9ed83 = parcelRequire("9ed83");

var $lm9d2 = parcelRequire("lm9d2");

var $MGmIU = parcelRequire("MGmIU");

var $gSExi = parcelRequire("gSExi");

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $koVbs = parcelRequire("koVbs");

var $2m0b6 = parcelRequire("2m0b6");

var $dCm1o = parcelRequire("dCm1o");

var $7Hgp8 = parcelRequire("7Hgp8");

var $AOaWd = parcelRequire("AOaWd");

var $5yCxu = parcelRequire("5yCxu");
const $0aef8f88c53fc825$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const overflowContainerRef = (0, $5uXOq.useRef)(null);
    const moreFilterRef = (0, $5uXOq.useRef)(null);
    const elementsRef = (0, $5uXOq.useRef)({});
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $5uXOq.useRef)(0);
    const elementsWidthRef = (0, $5uXOq.useRef)({});
    const visibleElementsRef = (0, $5uXOq.useRef)({});
    const prevElementsWidthRef = (0, $5uXOq.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $5uXOq.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $5uXOq.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $5uXOq.useMemo)(()=>(0, $5yCxu.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        const { current: overflowContainer } = overflowContainerRef;
        const { current: moreFilter } = moreFilterRef;
        const shouldRecomputeOverflow = (0, $5yCxu.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $5yCxu.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    if ((0, $6s1PB.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2m0b6.useResizeObserver)({
        ref: overflowContainerRef,
        onResize: onResize
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $AOaWd.useResizeObserver)(overflowContainerRef, onResize);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $7Hgp8.default).more);
    const triggerTooltipText = formatMessage((0, $7Hgp8.default).moreFiltersTooltip);
    const buttonToolTip = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxhgD.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _18s83l1n" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lm9d2.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ed83))), {
                    primaryColor: "var(--ds-icon, #44546F)",
                    label: triggerLabel
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $0aef8f88c53fc825$export$2e2bcd8739ae039 = $0aef8f88c53fc825$var$OverflowHandler;
const $0aef8f88c53fc825$var$overflowContainerStylesOld = null;
const $0aef8f88c53fc825$var$overflowContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $co1wz.ff)('compiled.migration.jsw.tanuki'), $0aef8f88c53fc825$var$ItemWrapperExperiment, $0aef8f88c53fc825$var$ItemWrapperControl);

});
parcelRegister("7Hgp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea3021c9215d69b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea3021c9215d69b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("AOaWd", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d7fe9cd69e6a83c0$export$683480f191c0e3ea);

var $5uXOq = parcelRequire("5uXOq");
let $d7fe9cd69e6a83c0$var$resizeObserver;
const $d7fe9cd69e6a83c0$var$callbacks = new Map();
const $d7fe9cd69e6a83c0$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $d7fe9cd69e6a83c0$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $d7fe9cd69e6a83c0$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) $d7fe9cd69e6a83c0$var$resizeObserver = new ResizeObserver($d7fe9cd69e6a83c0$var$runCallbacks);
    $d7fe9cd69e6a83c0$var$callbacks.set(target, callback);
    $d7fe9cd69e6a83c0$var$resizeObserver.observe(target);
};
const $d7fe9cd69e6a83c0$var$unobserveElement = (target)=>{
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) return;
    $d7fe9cd69e6a83c0$var$callbacks.delete(target);
    $d7fe9cd69e6a83c0$var$resizeObserver.unobserve(target);
};
const $d7fe9cd69e6a83c0$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $d7fe9cd69e6a83c0$var$observeElement(element, callback);
        return ()=>{
            element && $d7fe9cd69e6a83c0$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("5yCxu", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $6dfc047016dbaaed$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $6dfc047016dbaaed$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $6dfc047016dbaaed$export$b0e31612dc0df344);

var $gccSB = parcelRequire("gccSB");
const $6dfc047016dbaaed$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $6dfc047016dbaaed$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $6dfc047016dbaaed$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $6dfc047016dbaaed$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $6dfc047016dbaaed$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $6dfc047016dbaaed$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("1beWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4b1966602deeb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7rViF = parcelRequire("7rViF");

var $caSh0 = parcelRequire("caSh0");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $12hlA = parcelRequire("12hlA");


var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $cpQgt = parcelRequire("cpQgt");

var $j6etC = parcelRequire("j6etC");

var $eJpZk = parcelRequire("eJpZk");

var $lAu6N = parcelRequire("lAu6N");
const $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $lAu6N.default));
$6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $6f4b1966602deeb5$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
    if ((0, $caSh0.isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        inviteRef: modalRef,
        appEdition: appEdition,
        cloudId: cloudId,
        isOpen: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: isSiteAdmin
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddPeopleModal, {
        onClose: onAddPeopleModalClose,
        isOpen: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal
    });
};
const $6f4b1966602deeb5$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        (0, $7rViF.fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $ldyPw.toEdition)((0, $ldyPw.FREE_EDITION))) (0, $j6etC.getRemainingSeats)(baseUrl, (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpQgt.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $6f4b1966602deeb5$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $5uXOq.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const appEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $8zOmE.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $6f4b1966602deeb5$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        tenantContext.isSiteAdmin,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $5uXOq.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJpZk.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && ((0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleButton) && ((0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? showAddPeopleModal : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$export$3ecb2c48b5973cac, {
        modalRef: addButtonRef,
        projectName: projectName,
        projectKey: projectKey,
        projectId: projectId,
        AddPeopleModal: AddPeopleModal,
        showAddPeopleModal: (0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onAddPeopleModalClose: onAddPeopleModalClose,
        cloudId: tenantContext.cloudId,
        appEdition: appEdition,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$6f4b1966602deeb5$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $6f4b1966602deeb5$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($6f4b1966602deeb5$export$20e0939737a940df);
$6f4b1966602deeb5$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$6f4b1966602deeb5$var$AssigneeFilterComponent.whyDidYouRender = true;
var $6f4b1966602deeb5$export$2e2bcd8739ae039 = $6f4b1966602deeb5$var$AssigneeFilterComponent;

});
parcelRegister("7rViF", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", () => $19157e19516eca78$export$2f2d4a4234531655);
$parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", () => $19157e19516eca78$export$4ae66d6e56a5cb11);

var $co1wz = parcelRequire("co1wz");

var $8zOmE = parcelRequire("8zOmE");

var $caSh0 = parcelRequire("caSh0");
const $19157e19516eca78$var$getCoreInvitesInJiraProjects = ()=>(0, $co1wz.getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
        (0, $caSh0.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
    ]);
const $19157e19516eca78$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
    const featureFlagValue = $19157e19516eca78$var$getCoreInvitesInJiraProjects();
    const cohort = featureFlagValue;
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'core-invites-in-jira-projects',
        value: featureFlagValue,
        cohort: cohort,
        isSiteAdmin: isSiteAdmin,
        ineligibilityReasons: [],
        growthInitiative: 'virality'
    });
};
const $19157e19516eca78$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_core_invites_experiment',
        cohort: coreInvitesJsmExpValue
    });
};

});
parcelRegister("caSh0", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $c0c54262b44db685$export$3496ae3c3008d7e5);
$parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", () => $c0c54262b44db685$export$78d85fc0e603743c);
$parcel$export(module.exports, "isElligibleProject", () => $c0c54262b44db685$export$b0222359e25e154);
$parcel$export(module.exports, "isServiceProject", () => $c0c54262b44db685$export$f52f6e19ac3c110);

var $2vSU6 = parcelRequire("2vSU6");

var $co1wz = parcelRequire("co1wz");
const $c0c54262b44db685$export$3496ae3c3008d7e5 = {
    CONTROL: 'control',
    NOT_ENROLLED: 'not-enrolled',
    INVITE_ONLY: 'invite-only-variation',
    INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
    INVITE_RA: 'invite-ra-variation',
    INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
};
const $c0c54262b44db685$var$getCoreInvitesInJiraProjects = ()=>(0, $co1wz.getMultivariateFeatureFlag)('core-invites-in-jira-projects', $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED, [
        $c0c54262b44db685$export$3496ae3c3008d7e5.NOT_ENROLLED,
        $c0c54262b44db685$export$3496ae3c3008d7e5.CONTROL,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA,
        $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
    ]);
const $c0c54262b44db685$export$78d85fc0e603743c = (isSiteAdmin)=>{
    const flag = $c0c54262b44db685$var$getCoreInvitesInJiraProjects();
    return isSiteAdmin && flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $c0c54262b44db685$export$3496ae3c3008d7e5.INVITE_RA;
};
const $c0c54262b44db685$export$b0222359e25e154 = (projectType)=>projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT);
const $c0c54262b44db685$export$f52f6e19ac3c110 = (projectType)=>projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});


parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

const $0bc8c7c74346f034$var$LazyComponent = (0, $hPtZI.lazyForPaint)(()=>(parcelRequire("jWZZk")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("jWZZk", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("6C6tQ")
]).then(()=>parcelRequire('3dNZP'));

});


const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("cpQgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee2ed613b7661e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8GVAj = parcelRequire("8GVAj");

var $lNkm9 = parcelRequire("lNkm9");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $2hXCB = parcelRequire("2hXCB");

var $02gpZ = parcelRequire("02gpZ");

var $4J6oz = parcelRequire("4J6oz");


var $de8ma = parcelRequire("de8ma");
const $1fee2ed613b7661e$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $ldyPw.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $1fee2ed613b7661e$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $1fee2ed613b7661e$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8GVAj.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $1fee2ed613b7661e$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $5uXOq.useState)(null);
    const currentEdition = (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $iMd5l.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.UPGRADE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.LEARN_MORE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $5uXOq.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNkm9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fee2ed613b7661e$var$MultiLineParagraph, null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
            xcss: $1fee2ed613b7661e$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $1fee2ed613b7661e$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $de8ma.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $1fee2ed613b7661e$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $de8ma.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02gpZ.UpFlowIFrame), {
            targetEdition: (0, $ldyPw.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $1fee2ed613b7661e$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($1fee2ed613b7661e$var$UpgradeToAddUsersDialog));
const $1fee2ed613b7661e$var$buttonBarStyles = (0, $jJ1Sb.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fee2ed613b7661e$var$MultiLineParagraph = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iMd5l", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $658df12da4e62335$export$53e066a63a960439);

const $658df12da4e62335$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("2hXCB", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $a61f434346a6f772$export$1979295cc80a7ec1);
$parcel$export(module.exports, "WORKFLOW_EDIT_PERMISSION_LEARN_MORE", () => $a61f434346a6f772$export$779203acbfa8bf12);
$parcel$export(module.exports, "UPGRADE", () => $a61f434346a6f772$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $a61f434346a6f772$export$2bf527ee1645dc7d);
const $a61f434346a6f772$export$9ba2bc3b1bdc1519 = 'experiment';
const $a61f434346a6f772$export$5b7423264d48ab04 = 'not-enrolled';
const $a61f434346a6f772$export$43f367b3e957f219 = 'control';
const $a61f434346a6f772$export$1979295cc80a7ec1 = 'learn-more';
const $a61f434346a6f772$export$779203acbfa8bf12 = 'workflow-edit-permission-learn-more';
const $a61f434346a6f772$export$fe5b785cab515b6e = 'upgrade';
const $a61f434346a6f772$export$2bf527ee1645dc7d = {
    [$a61f434346a6f772$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$a61f434346a6f772$export$779203acbfa8bf12]: 'workflowEditLearnMore',
    [$a61f434346a6f772$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("02gpZ", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $6cdd801078d648f3$export$e9eafd8c579e773d);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");


var $4J6oz = parcelRequire("4J6oz");

var $g6ckq = parcelRequire("g6ckq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cdd801078d648f3$var$UpFlowIFrameLazy = (0, $hPtZI.lazy)(()=>(parcelRequire("lQ4bZ")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $6cdd801078d648f3$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        teamName: "growth-tako",
        fallback: (0, $g6ckq.ChunkLoadErrorFlag),
        attributes: (0, $4J6oz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cdd801078d648f3$var$UpFlowIFrameLazy, props)));

});
const $abaf639d63a27f10$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $abaf639d63a27f10$export$cb7e587097a78810 = 'upsell-edition';
const $abaf639d63a27f10$export$fb320338324d1328 = 'upflowIFrame';
const $abaf639d63a27f10$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $abaf639d63a27f10$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $abaf639d63a27f10$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $abaf639d63a27f10$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $abaf639d63a27f10$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $abaf639d63a27f10$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("4J6oz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $7e87fb5ffa0cfceb$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58);

var $5uXOq = parcelRequire("5uXOq");

var $cHBMC = parcelRequire("cHBMC");

var $jcw0u = parcelRequire("jcw0u");

var $ldyPw = parcelRequire("ldyPw");

var $7NJFp = parcelRequire("7NJFp");



var $ajCo3 = parcelRequire("ajCo3");
const $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            teamName: 'growth-tako'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $ldyPw.FREE_EDITION)) return 0, $4c0643787f48cf65$export$e69af2c4378638a2;
    if (applicationEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $4c0643787f48cf65$export$7bc7dd5faba7ad6b;
    return 0, $4c0643787f48cf65$export$3fd0bbb8c68dc4c7;
};
const $7e87fb5ffa0cfceb$export$7d4045a899f62dfd = (0, $cHBMC.metrics).interaction({
    key: `${(0, $abaf639d63a27f10$export$c73007a11ea7e52)}.upgrade.plan`
});
const $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7NJFp.isLoaderError)(error)
    });
const $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $7e87fb5ffa0cfceb$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajCo3.CommerceApiErrorFlag), null);
};

});
const $4c0643787f48cf65$export$e69af2c4378638a2 = 'free';
const $4c0643787f48cf65$export$7bc7dd5faba7ad6b = 'standard';
const $4c0643787f48cf65$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("ajCo3", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $0ee877bbb47ef7cb$export$7ee77c445dd775b4);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $cPOtr = parcelRequire("cPOtr");
const $0ee877bbb47ef7cb$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $7HGHK.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $cPOtr.default).title,
        description: (0, $cPOtr.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("cPOtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8891414a165fed2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8891414a165fed2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("g6ckq", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $590350b4061b001a$export$7a9d9407b3a5f50e);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $7NJFp = parcelRequire("7NJFp");

var $kgvbW = parcelRequire("kgvbW");
const $590350b4061b001a$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $7HGHK.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    if ((0, $7NJFp.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $kgvbW.default).title,
        description: (0, $kgvbW.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $kgvbW.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("kgvbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae312d01f0160cd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae312d01f0160cd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("lQ4bZ", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("9cUHu")
]).then(()=>parcelRequire('1W7nw'));

});


const $9996ddd22815931e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $9996ddd22815931e$export$30ce584c3652886c = 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';
const $9996ddd22815931e$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("de8ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc942e740b757f44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc942e740b757f44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("j6etC", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $1d52ab7e56655772$export$6397e3bbf35b34e3);

var $eusud = parcelRequire("eusud");
const $1d52ab7e56655772$var$toRemainingSeats = (json)=>json.remainingSeat;
const $1d52ab7e56655772$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $eusud.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$1d52ab7e56655772$var$toRemainingSeats(json));

});

parcelRegister("eJpZk", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $981a920c7dd6e4e8$export$2b3af6baec22bd98);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $1sLR4 = parcelRequire("1sLR4");

var $1zwpK = parcelRequire("1zwpK");

var $iqJSe = parcelRequire("iqJSe");
const $981a920c7dd6e4e8$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $1zwpK.getUserProjectRoles)(baseUrl, projectId),
            (0, $1sLR4.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $iqJSe.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $iqJSe.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("1sLR4", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $6d37e68816b91c3b$export$f5f97c28ee230e06);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $6d37e68816b91c3b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $6d37e68816b91c3b$var$transform = (data)=>data.value;
const $6d37e68816b91c3b$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($6d37e68816b91c3b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$6d37e68816b91c3b$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("1zwpK", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $845d77939718574b$export$3b587d1e1fe73b9d);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $845d77939718574b$var$MEMBER_ROLE_NAME = 'Member';
const $845d77939718574b$var$VIEWER_ROLE_NAME = 'Viewer';
const $845d77939718574b$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $845d77939718574b$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $845d77939718574b$var$MEMBER_ROLE_NAME);
const $845d77939718574b$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $845d77939718574b$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $845d77939718574b$var$VIEWER_ROLE_NAME && role.name !== $845d77939718574b$var$MEMBER_ROLE_NAME && !role.admin);
const $845d77939718574b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $845d77939718574b$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($845d77939718574b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $845d77939718574b$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $845d77939718574b$export$10eeb2d34050404e(data),
            hasCustomRole: $845d77939718574b$export$a4d7f3415bee4b75(data),
            projectRoleNames: $845d77939718574b$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("iqJSe", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $131644081500a421$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $131644081500a421$export$7f2d1c0dab5190f9);

var $8zOmE = parcelRequire("8zOmE");
const $131644081500a421$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $131644081500a421$export$ecf9824f02c8a125 = 'Custom Role';
const $131644081500a421$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $131644081500a421$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $131644081500a421$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($131644081500a421$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("lAu6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $020a81e9686d5942$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $gQDFP = parcelRequire("gQDFP");

var $kfN7T = parcelRequire("kfN7T");

var $a43Dp = parcelRequire("a43Dp");

var $2eCzd = parcelRequire("2eCzd");

var $mafYu = parcelRequire("mafYu");
const $020a81e9686d5942$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
    const mainList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "fieldset",
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $020a81e9686d5942$var$fieldsetStyles : $020a81e9686d5942$var$fieldsetStylesOld
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line jira/react/no-style-attribute
        ,
        style: {
            // Ensure layering of avatars does not conflict with anything else in the DOM tree
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarFilterLegend, {
        id: (0, $gQDFP.FILTER_PREFIX)
    }, formatMessage((0, $2eCzd.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarsList, null, mainList.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mafYu.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: onAssigneeMenuOpen
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfN7T.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    })));
};
$020a81e9686d5942$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showAddPeopleButton: false
};
var $020a81e9686d5942$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($020a81e9686d5942$var$AssigneeFilter);
const $020a81e9686d5942$var$fieldsetStyles = (0, $jJ1Sb.xcss)({
    flexShrink: 0,
    border: 0
});
const $020a81e9686d5942$var$fieldsetStylesOld = (0, $jJ1Sb.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarFilterLegend = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gQDFP", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $4ab71e27db0ec1f1$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $4ab71e27db0ec1f1$export$42310dd57a41067);
const $4ab71e27db0ec1f1$export$d6acfe0d617669c3 = 'assignee';
const $4ab71e27db0ec1f1$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $4ab71e27db0ec1f1$export$e70f7f4a08e4d8fb = 10;
const $4ab71e27db0ec1f1$export$75297e3804621b0 = 36;

});

parcelRegister("kfN7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a6af3ecba65952$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $fR82N = parcelRequire("fR82N");

var $1aVR0 = parcelRequire("1aVR0");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $cE2Qr = parcelRequire("cE2Qr");

var $hchBL = parcelRequire("hchBL");

var $2XCFo = parcelRequire("2XCFo");

var $k1LTw = parcelRequire("k1LTw");

var $gQDFP = parcelRequire("gQDFP");

var $cWMNe = parcelRequire("cWMNe");

var $7oMpD = parcelRequire("7oMpD");

var $ihiH5 = parcelRequire("ihiH5");
const $66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $66a6af3ecba65952$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $cWMNe.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register($66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const NudgeTooltip = !(0, $4R6GH.fg)('jsw-perf-async-add-people-modal-load') || !isDismissed ? (0, $2XCFo.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ihiH5.AddPeopleTooltip), {
        content: formatMessage((0, $7oMpD.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $gQDFP.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $7oMpD.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $gQDFP.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1aVR0))), {
        size: "medium",
        label: formatMessage((0, $7oMpD.default).addPeople)
    }))))));
};
$66a6af3ecba65952$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $66a6af3ecba65952$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($66a6af3ecba65952$var$AddUsersButton);
const $66a6af3ecba65952$var$AddButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $fR82N.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $66a6af3ecba65952$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $66a6af3ecba65952$var$ActionAvatarWrapper
};

});
parcelRegister("1aVR0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0db39a326f15b730$var$_react = $0db39a326f15b730$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $kfAhl = parcelRequire("kfAhl");

var $0db39a326f15b730$var$_personAdd = $0db39a326f15b730$var$_interopRequireDefault((parcelRequire("cKFOj")));
function $0db39a326f15b730$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0db39a326f15b730$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $0db39a326f15b730$var$_react.default.createElement($kfAhl.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $0db39a326f15b730$var$_personAdd.default
    }));
$0db39a326f15b730$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $0db39a326f15b730$var$_default = module.exports.default = $0db39a326f15b730$var$InviteTeamIcon;

});
parcelRegister("cKFOj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c71910615fcdf3419bf276c45a2048a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $948a36988d6aa6bc$var$_react = $948a36988d6aa6bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $948a36988d6aa6bc$var$_UNSAFE_baseNew = $948a36988d6aa6bc$var$_interopRequireDefault((parcelRequire("huIZN")));
function $948a36988d6aa6bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $948a36988d6aa6bc$var$PersonAddIcon = (props)=>/*#__PURE__*/ $948a36988d6aa6bc$var$_react.default.createElement($948a36988d6aa6bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$948a36988d6aa6bc$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $948a36988d6aa6bc$var$_default = module.exports.default = $948a36988d6aa6bc$var$PersonAddIcon;

});


parcelRegister("2XCFo", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $ca2358eaf62c0b1a$export$4e4097c2567f79b7);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy = (0, $hPtZI.lazyAfterPaint)(()=>(parcelRequire("1YfpH")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $ca2358eaf62c0b1a$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
    }, children)));

});
parcelRegister("1YfpH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("d744b")
]).then(()=>parcelRequire('1Pog6'));

});


parcelRegister("k1LTw", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $03be4aba8d3a8915$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $03be4aba8d3a8915$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $03be4aba8d3a8915$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fR82N = parcelRequire("fR82N");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $gQDFP = parcelRequire("gQDFP");
const $03be4aba8d3a8915$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $03be4aba8d3a8915$export$a3e8c7acf36da4c1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$7d5adb020315f211 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $03be4aba8d3a8915$export$a3e8c7acf36da4c1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3in7od",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$f7513421c53ce141 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $03be4aba8d3a8915$export$7d5adb020315f211, $03be4aba8d3a8915$export$a3e8c7acf36da4c1);
const $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $fR82N.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz8a6j _vwz412pq",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$398a7826f6fd570e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _19itj1ic",
            __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cWMNe", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $3b2d077e6f2bec18$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $3b2d077e6f2bec18$export$49f6dd346c7dfb52);

var $5uXOq = parcelRequire("5uXOq");
const $3b2d077e6f2bec18$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $3b2d077e6f2bec18$export$49f6dd346c7dfb52 = (callback)=>(0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("7oMpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("ihiH5", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $936c019622c243d2$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $MGmIU = parcelRequire("MGmIU");
const $936c019622c243d2$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($936c019622c243d2$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936c019622c243d2$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("a43Dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ed3a89d7efd9a4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dWTaZ = parcelRequire("dWTaZ");

var $MGmIU = parcelRequire("MGmIU");

var $joX8T = parcelRequire("joX8T");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $2WENx = parcelRequire("2WENx");

var $dCm1o = parcelRequire("dCm1o");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");

var $iv6Wk = parcelRequire("iv6Wk");
const $68ed3a89d7efd9a4$var$type = 'assignee';
const $68ed3a89d7efd9a4$var$AvatarWithAnalytics = ({ isRealtimePresenceEnabled: isRealtimePresenceEnabled, intl: intl, ...user })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = intl;
    const onShow = ()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'tooltip viewed');
    };
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $iv6Wk.default).presenceOnlineLabel : (0, $iv6Wk.default).presenceOfflineLabel, {
        name: user.displayName
    });
    if (isRealtimePresenceEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span",
        presence: user.presence
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
};
const $68ed3a89d7efd9a4$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const userIdentifier = user.id;
    const checkboxId = `${$68ed3a89d7efd9a4$var$type}-${userIdentifier}`;
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $cWMNe.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $iv6Wk.default).presenceOnlineLabel : (0, $iv6Wk.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $iv6Wk.default).avatarInputCheckboxLabel),
        type: "checkbox",
        id: checkboxId,
        name: $68ed3a89d7efd9a4$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $cWMNe.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
        selected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, (0, $co1wz.ff)('jsw.enable.avatar.tooltip.label.and.analytic_hikl3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarWithAnalytics, {
        ...user,
        isRealtimePresenceEnabled: isRealtimePresenceEnabled,
        intl: intl
    }) : avatarWithTooltip)));
};
$68ed3a89d7efd9a4$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $68ed3a89d7efd9a4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($68ed3a89d7efd9a4$var$Avatar);
const $68ed3a89d7efd9a4$var$AvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $68ed3a89d7efd9a4$var$AvatarInputCheckbox
};

});
parcelRegister("2WENx", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $ef9e8ab383852170$export$ba964695877b24);

var $4mBKK = parcelRequire("4mBKK");

var $6s1PB = parcelRequire("6s1PB");

var $dkqym = parcelRequire("dkqym");
const $ef9e8ab383852170$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $4mBKK.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});

parcelRegister("f0vy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff18090899dca54$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $MGmIU = parcelRequire("MGmIU");

var $koVbs = parcelRequire("koVbs");

var $hf0Xf = parcelRequire("hf0Xf");
const $fff18090899dca54$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $hf0Xf.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $hf0Xf.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $fff18090899dca54$export$2e2bcd8739ae039 = $fff18090899dca54$var$PresenceTooltip;

});
parcelRegister("hf0Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a1fa5c7f46c36b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14a1fa5c7f46c36b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("iv6Wk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7903d4e27c8480$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a7903d4e27c8480$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    }
});

});


parcelRegister("2eCzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3184a04c19fde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a3184a04c19fde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    }
});

});

parcelRegister("mafYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb88f751cbd22241$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $fR82N = parcelRequire("fR82N");
var $dWTaZ = parcelRequire("dWTaZ");

var $8Agsd = parcelRequire("8Agsd");
var $01wdO = parcelRequire("01wdO");

var $MGmIU = parcelRequire("MGmIU");

var $joX8T = parcelRequire("joX8T");

var $4R6GH = parcelRequire("4R6GH");

var $2WENx = parcelRequire("2WENx");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $k1LTw = parcelRequire("k1LTw");

var $gQDFP = parcelRequire("gQDFP");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");
const $bb88f751cbd22241$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
    const [isOpen, setOpenState] = (0, $5uXOq.useState)(false);
    const _onOpenChange = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attrs)=>{
        setOpenState(attrs.isOpen);
        if (attrs.isOpen) onOpen();
    }, [
        setOpenState,
        onOpen
    ]);
    const isSelected = (0, $5uXOq.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const dropdownItems = (0, $5uXOq.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01wdO.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $g5X3G.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
                content: displayName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWTaZ.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Agsd.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
                ...triggerProps,
                ref: triggerRef,
                zIndex: (0, $gQDFP.Z_INDEX).MENU
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ActionInputCheckbox, {
                "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                type: "checkbox",
                id: `${(0, $gQDFP.FILTER_PREFIX)}-show-more`,
                name: (0, $gQDFP.FILTER_PREFIX),
                value: `${(0, $gQDFP.FILTER_PREFIX)}-show-more`,
                defaultChecked: isOpen,
                "aria-describedby": (0, $gQDFP.FILTER_PREFIX),
                onClick: (0, $cWMNe.onBlur)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.ActionAvatar), {
                tabIndex: -1
            }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('jira_nav4_eap_drop_1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer, null, `+${users.length}`) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bb88f751cbd22241$var$DropdownItemsWrapper, null, dropdownItems)));
};
$bb88f751cbd22241$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $bb88f751cbd22241$export$2e2bcd8739ae039 = $bb88f751cbd22241$var$ShowMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1mjv _1yt4swc3",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1t4ug9d8 _k907ze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ActionInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wiw70x": (0, $lD23V.default)((0, $fR82N.AVATAR_SIZES).small, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1yj7 _4t3i1yj7 _1wyb19bv _t9ec1win",
            __cmplp.className
        ])
    });
});

});
parcelRegister("01wdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4f4571fe2db432$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ePBXU = parcelRequire("ePBXU");

var $6SJYd = parcelRequire("6SJYd");

var $6PItG = parcelRequire("6PItG");

var $294ns = parcelRequire("294ns");

var $gfGSI = parcelRequire("gfGSI");

var $7TlSv = parcelRequire("7TlSv");

var $7jhTK = parcelRequire("7jhTK");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $fe4f4571fe2db432$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ePBXU.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $7TlSv.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $7jhTK.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6SJYd.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6PItG.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gfGSI.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...(0, $294ns.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children));
};
var $fe4f4571fe2db432$export$2e2bcd8739ae039 = $fe4f4571fe2db432$var$DropdownItemCheckbox;

});
parcelRegister("gfGSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $792f61240273190c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aQRdR = parcelRequire("aQRdR");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $792f61240273190c$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQRdR.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $5e0c0d4e15efb4a6$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $792f61240273190c$export$2e2bcd8739ae039 = $792f61240273190c$var$CheckboxIcon;

});

parcelRegister("7TlSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a84c533c13368aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $feE0h = parcelRequire("feE0h");

var $hxKwv = parcelRequire("hxKwv");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $0a84c533c13368aa$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, $hxKwv.SelectionStoreContext));
    const groupId = (0, $5uXOq.useContext)((0, $feE0h.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $0a84c533c13368aa$export$2e2bcd8739ae039 = $0a84c533c13368aa$var$useCheckboxState;

});
parcelRegister("feE0h", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $772259897782a5fb$export$baf37c4be89255b8);

var $5uXOq = parcelRequire("5uXOq");
const $772259897782a5fb$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5uXOq.createContext)('');

});






parcelRegister("3oCwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $195137f112bf0000$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $89thI = parcelRequire("89thI");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $aVUro = parcelRequire("aVUro");
const $195137f112bf0000$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $195137f112bf0000$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: props.onClick
    }, props.label || formatMessage((0, $aVUro.default).label)));
};
$195137f112bf0000$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $195137f112bf0000$export$2e2bcd8739ae039 = $195137f112bf0000$var$ClearFilterButton;
const $195137f112bf0000$var$styledClearFilterStyles = (0, $jJ1Sb.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("aVUro", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdad8f510b5e904$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdad8f510b5e904$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("7j6PN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf5bd4e554fcb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $cTznA = parcelRequire("cTznA");
const $1bf5bd4e554fcb50$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $cTznA.default).label),
            values: values,
            selectedValues: (0, $g5X3G.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $1bf5bd4e554fcb50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1bf5bd4e554fcb50$var$ComponentFilter);

});
parcelRegister("cTznA", function(module, exports) {

$parcel$export(module.exports, "default", () => $798caf1923191bc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $798caf1923191bc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    }
});

});


parcelRegister("8bg0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3ccb8efb497741$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $1k18w = parcelRequire("1k18w");

var $kIDH3 = parcelRequire("kIDH3");
const $6a3ccb8efb497741$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: // only used for VR testing purposes
onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedValues: selectedValues = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        onChange(entries.map(({ value: value })=>value));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $1k18w.default).label),
        onChange: onChangeValue,
        values: [
            {
                label: formatMessage((0, $1k18w.default).dependencyType),
                options: [
                    {
                        label: formatMessage((0, $1k18w.default).offTrack),
                        value: (0, $kIDH3.DependencyFilterOption).OFF_TRACK
                    },
                    {
                        label: formatMessage((0, $1k18w.default).onTrack),
                        value: (0, $kIDH3.DependencyFilterOption).ON_TRACK
                    }
                ]
            }
        ],
        selectedValues: selectedValues
    });
};
$6a3ccb8efb497741$var$DependenciesFilter.displayName = 'DependenciesFilter';
$6a3ccb8efb497741$var$DependenciesFilter.whyDidYouRender = true;
var $6a3ccb8efb497741$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a3ccb8efb497741$var$DependenciesFilter);

});
parcelRegister("1k18w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bab5f988dfca5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6bab5f988dfca5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.dependencies.label",
        "defaultMessage": "Dependencies"
    },
    dependencyType: {
        "id": "software-filters.filters.dependencies.dependency-type",
        "defaultMessage": "Dependency type"
    },
    offTrack: {
        "id": "software-filters.filters.dependencies.off-track",
        "defaultMessage": "Off-track"
    },
    onTrack: {
        "id": "software-filters.filters.dependencies.on-track",
        "defaultMessage": "On-track"
    }
});

});


parcelRegister("kgqZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $089e7ae732d57721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $2Ywmz = parcelRequire("2Ywmz");

var $3uePO = parcelRequire("3uePO");

var $96s6B = parcelRequire("96s6B");

var $9vXUM = parcelRequire("9vXUM");

var $BZHAT = parcelRequire("BZHAT");
const $089e7ae732d57721$var$EMPTY_ARRAY = [];
const $089e7ae732d57721$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $5uXOq.useContext)((0, $9vXUM.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Ywmz.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        as: "span",
        xcss: $089e7ae732d57721$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uePO.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $089e7ae732d57721$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $089e7ae732d57721$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vXUM.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $BZHAT.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $BZHAT.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $BZHAT.default).placeholder),
        CustomOptionLabel: $089e7ae732d57721$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }));
};
var $089e7ae732d57721$export$2e2bcd8739ae039 = $089e7ae732d57721$var$GoalFilter;
const $089e7ae732d57721$var$goalLabelStyles = (0, $jJ1Sb.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("2Ywmz", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $7be6a95607230c54$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $gDyTC = parcelRequire("gDyTC");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $koVbs = parcelRequire("koVbs");

var $6yf6t = parcelRequire("6yf6t");

var $4UrMe = parcelRequire("4UrMe");
const $7be6a95607230c54$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $7be6a95607230c54$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6yf6t.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gDyTC.default), {
        glyph: $7be6a95607230c54$var$GoalGlyph,
        label: formatMessage((0, $4UrMe.default).goalIconLabel),
        primaryColor: (0, $6yf6t.mapStateToColor)(state)
    }));
};
const $7be6a95607230c54$var$iconContainerStyles = (0, $jJ1Sb.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("6yf6t", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $6a435c3af325b8dc$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $6a435c3af325b8dc$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $6a435c3af325b8dc$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $6a435c3af325b8dc$export$88bbcb3741dee92d);

const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-background-accent-red-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).R50})`;
        case 'at_risk':
            return `var(--ds-background-accent-yellow-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).Y50})`;
        case 'on_track':
            return `var(--ds-background-accent-green-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).G50})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-background-accent-gray-subtlest, ${(0, $5e0c0d4e15efb4a6$exports).N20})`;
    }
};
const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return `var(--ds-text-accent-red, ${(0, $5e0c0d4e15efb4a6$exports).R500})`;
        case 'at_risk':
            return `var(--ds-text-accent-orange, ${(0, $5e0c0d4e15efb4a6$exports).Y500})`;
        case 'on_track':
            return `var(--ds-text-accent-green, ${(0, $5e0c0d4e15efb4a6$exports).G500})`;
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return `var(--ds-text-accent-gray, ${(0, $5e0c0d4e15efb4a6$exports).N500})`;
    }
};
const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return `var(--ds-background-danger-bold, ${(0, $5e0c0d4e15efb4a6$exports).R500})`;
    if (score < 0.7) return `var(--ds-background-accent-orange-bolder, ${(0, $5e0c0d4e15efb4a6$exports).Y500})`;
    return `var(--ds-background-success-bold, ${(0, $5e0c0d4e15efb4a6$exports).G500})`;
};
const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("4UrMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec31bd513378ade$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("3uePO", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $ec22661ff8271891$export$c0fdf469f92e8578);

var $5uXOq = parcelRequire("5uXOq");

var $6yf6t = parcelRequire("6yf6t");

var $aabh6 = parcelRequire("aabh6");

var $e0NSW = parcelRequire("e0NSW");
const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0NSW.Tracker), {
        backgroundColor: (0, $6yf6t.mapStateToBgColor)(value),
        color: (0, $6yf6t.mapStateToColor)(value)
    }, (0, $6yf6t.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aabh6.Score), {
        score: score
    }));

});
parcelRegister("aabh6", function(module, exports) {

$parcel$export(module.exports, "Score", () => $08dbd54fe256bc26$export$6735cf84ecd2736);

var $5uXOq = parcelRequire("5uXOq");

var $6yf6t = parcelRequire("6yf6t");

var $3b4jf = parcelRequire("3b4jf");
const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3b4jf.ScoreContainer), {
        backgroundColor: (0, $6yf6t.mapScoreToBgColor)(score)
    }, score);

});
parcelRegister("3b4jf", function(module, exports) {

$parcel$export(module.exports, "ScoreContainer", () => $c781656d37adaa64$export$32466e20de52fc97);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $c781656d37adaa64$export$32466e20de52fc97 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _bfhk3qkl _syaz15cr _2rko1l7b _18u01b66 _1yt4otz2 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e0NSW", function(module, exports) {

$parcel$export(module.exports, "Tracker", () => $5a7c474ebf7da8e1$export$254d9747e34ddc90);
/* styled.tsx generated by @compiled/babel-plugin v0.31.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $5a7c474ebf7da8e1$export$254d9747e34ddc90 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk3qkl _2rko1l7b _1yt41b66 _11c81vlj _k48pmoej _syaz1cj8 _1p1dangw _3fcw1q9c _1e0c1ule _4t3i7vkz _vwz47vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9vXUM", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $c20e77c82f0ed08e$export$f656d92d95229cd2);

var $5uXOq = parcelRequire("5uXOq");
const $c20e77c82f0ed08e$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    goals: {}
});

});

parcelRegister("BZHAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb7fe3166051b6f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfb7fe3166051b6f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("efv79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e07b1cd691dec67$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $4c4ZP = parcelRequire("4c4ZP");
const $7e07b1cd691dec67$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $4c4ZP.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values
    });
};
$7e07b1cd691dec67$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$7e07b1cd691dec67$var$IssueProjectFilter.whyDidYouRender = true;
var $7e07b1cd691dec67$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7e07b1cd691dec67$var$IssueProjectFilter);

});
parcelRegister("4c4ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01676d3e9ff29bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01676d3e9ff29bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    }
});

});


parcelRegister("jKPI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6442616aa336213b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $hF6jn = parcelRequire("hF6jn");
const $6442616aa336213b$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueTypeGroupByIssueType = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $5uXOq.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $5uXOq.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $5uXOq.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $hF6jn.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested
    });
};
$6442616aa336213b$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6442616aa336213b$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6442616aa336213b$export$2e2bcd8739ae039 = $6442616aa336213b$var$IssueTypeGroupFilter;

});
parcelRegister("hF6jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d157749564d70c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d157749564d70c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("hHL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5fa2dd02736e8c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $lcsGW = parcelRequire("lcsGW");
const $2b5fa2dd02736e8c$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $g5X3G.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $lcsGW.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $2b5fa2dd02736e8c$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2b5fa2dd02736e8c$var$IssueTypeFilter);
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $2b5fa2dd02736e8c$export$2e2bcd8739ae039 = $2b5fa2dd02736e8c$var$IssueTypeFilterComponent;

});
parcelRegister("lcsGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $418d852f97677c87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $418d852f97677c87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("2fsdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5c968fce1f630e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $bvI90 = parcelRequire("bvI90");
const $2f5c968fce1f630e$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $bvI90.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $2f5c968fce1f630e$var$LabelFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2f5c968fce1f630e$var$LabelFilter);
$2f5c968fce1f630e$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2f5c968fce1f630e$var$LabelFilterComponent.whyDidYouRender = true;
var $2f5c968fce1f630e$export$2e2bcd8739ae039 = $2f5c968fce1f630e$var$LabelFilterComponent;

});
parcelRegister("bvI90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7299efb383111469$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7299efb383111469$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    }
});

});


parcelRegister("bLWKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $31db5ca9c486657a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $dIdda = parcelRequire("dIdda");

var $96s6B = parcelRequire("96s6B");

var $9oo3F = parcelRequire("9oo3F");
const $31db5ca9c486657a$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $dIdda.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const values = (0, $5uXOq.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $g5X3G.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: label,
        toggleLabel: formatMessage((0, $9oo3F.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9oo3F.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
    }));
};
$31db5ca9c486657a$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $31db5ca9c486657a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($31db5ca9c486657a$var$ParentFilter);

});
parcelRegister("9oo3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9506229386ae6ee1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9506229386ae6ee1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    }
});

});


parcelRegister("hpA0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $779f77cd70091738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $96s6B = parcelRequire("96s6B");

var $6DAJ4 = parcelRequire("6DAJ4");
const $779f77cd70091738$var$MAX_SELECTION_ALLOWED = 10;
const $779f77cd70091738$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6DAJ4.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6DAJ4.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested
    });
};
const $779f77cd70091738$var$QuickFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($779f77cd70091738$var$QuickFilter);
$779f77cd70091738$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$779f77cd70091738$var$QuickFilterComponent.whyDidYouRender = true;
var $779f77cd70091738$export$2e2bcd8739ae039 = $779f77cd70091738$var$QuickFilterComponent;

});
parcelRegister("6DAJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d3824050b576c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28d3824050b576c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("g65Ek", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc78a455db68a11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $e0XMB = parcelRequire("e0XMB");
const $ccc78a455db68a11$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $e0XMB.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $ccc78a455db68a11$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($ccc78a455db68a11$var$RequestTypeFilter);
$ccc78a455db68a11$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$ccc78a455db68a11$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $ccc78a455db68a11$export$2e2bcd8739ae039 = $ccc78a455db68a11$var$RequestTypeFilterComponent;

});
parcelRegister("e0XMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7eddbc8ad682f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c7eddbc8ad682f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    }
});

});


parcelRegister("jdA4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6cedc5f723f1df5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $96s6B = parcelRequire("96s6B");

var $6TH6s = parcelRequire("6TH6s");
const $b6cedc5f723f1df5$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $5uXOq.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6TH6s.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested
    });
};
const $b6cedc5f723f1df5$var$SprintFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($b6cedc5f723f1df5$var$SprintFilter);
$b6cedc5f723f1df5$var$SprintFilterComponent.displayName = 'SprintFilter';
var $b6cedc5f723f1df5$export$2e2bcd8739ae039 = $b6cedc5f723f1df5$var$SprintFilterComponent;

});
parcelRegister("6TH6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a136882e810c6f5b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a136882e810c6f5b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    }
});

});


parcelRegister("cSFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $746f8d9f8aa82396$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $5qiVm = parcelRequire("5qiVm");
const $746f8d9f8aa82396$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $5qiVm.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $746f8d9f8aa82396$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($746f8d9f8aa82396$var$StatusCategoryFilter);
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $746f8d9f8aa82396$export$2e2bcd8739ae039 = $746f8d9f8aa82396$var$StatusCategoryFilterComponent;

});
parcelRegister("5qiVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c5f1e62f5bac0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16c5f1e62f5bac0b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    }
});

});


parcelRegister("3f9TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ecaaab2e5e2a52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $33ioU = parcelRequire("33ioU");
const $45ecaaab2e5e2a52$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $33ioU.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested
    });
};
const $45ecaaab2e5e2a52$var$StatusFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($45ecaaab2e5e2a52$var$StatusFilter);
$45ecaaab2e5e2a52$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$45ecaaab2e5e2a52$var$StatusFilterComponent.whyDidYouRender = true;
var $45ecaaab2e5e2a52$export$2e2bcd8739ae039 = $45ecaaab2e5e2a52$var$StatusFilterComponent;

});
parcelRegister("33ioU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3eff355f28d572$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee3eff355f28d572$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    }
});

});


parcelRegister("fJnmW", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $fcc1c800bf761f9d$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $fcc1c800bf761f9d$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $fcc1c800bf761f9d$export$9ea8cdcfa806101a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$35dfe29d505ceb8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$56a20ec2552ffba2 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$35dfe29d505ceb8f, $fcc1c800bf761f9d$export$9ea8cdcfa806101a);
const $fcc1c800bf761f9d$export$847557029097218a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _1sn01d4u",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$6fe98dc7be67e1c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$595be9b8d0603674 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$4a72bd88f9845459 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$595be9b8d0603674, $fcc1c800bf761f9d$export$6fe98dc7be67e1c2);

});

parcelRegister("cTi8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e898d158ecdd3c47$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $3Qsxg = parcelRequire("3Qsxg");
const $e898d158ecdd3c47$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Qsxg.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $e898d158ecdd3c47$export$2e2bcd8739ae039 = $e898d158ecdd3c47$var$AsyncBoardSwitcher;

});
parcelRegister("3Qsxg", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $afceff36abed190f$export$e13b401cdb60e3ed);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $afceff36abed190f$export$e13b401cdb60e3ed = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("g0sLo")).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("g0sLo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("exBMr")
]).then(()=>parcelRequire('2C9Uz'));

});



parcelRegister("gtgKk", function(module, exports) {

$parcel$export(module.exports, "CollabContainerAsync", () => $d8b06fe481f4b829$export$69b83fdf5027068d);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d8b06fe481f4b829$var$LazyCollabContainer = (0, $hPtZI.lazy)(()=>(parcelRequire("hSq0e")).then(({ CollabContainer: CollabContainer })=>CollabContainer), {
    moduleId: "./src/packages/software/real-time-presence/src/controllers/collab/index.tsx"
});
const $d8b06fe481f4b829$export$69b83fdf5027068d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-jira-software-real-time-presence",
        packageName: "jiraSoftwareRealtimePresence",
        teamName: "jira-werewolves",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-real-time-presence",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8b06fe481f4b829$var$LazyCollabContainer, props)));

});
parcelRegister("hSq0e", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("7IZwQ")
]).then(()=>parcelRequire('cwA3d'));

});


parcelRegister("8vjSE", function(module, exports) {

$parcel$export(module.exports, "useCollabStore", () => $4e59b4cbd57cc99d$export$4159ae80cfa2156);

var $3JOCw = parcelRequire("3JOCw");

var $7JoAD = parcelRequire("7JoAD");

const $4e59b4cbd57cc99d$var$updateUserInParticipants = (user)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            participants: state.participants.map((participant)=>{
                if (participant.clientId === user.userId) return {
                    ...participant,
                    avatar: user.avatar,
                    name: user.name,
                    email: user.email
                };
                return participant;
            })
        });
    };
const $4e59b4cbd57cc99d$var$participantsJoined = (joined)=>({ getState: getState, setState: setState })=>{
        const uniqueJoined = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(joined, ({ sessionId: sessionId })=>sessionId);
        const newParticipantSessionIds = uniqueJoined.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        const { provider: provider } = state;
        const newParticipants = [
            ...state.participants.filter(({ sessionId: sessionId })=>!newParticipantSessionIds.includes(sessionId)),
            ...uniqueJoined
        ];
        // Collab team advised we should limit the number of max connections to control the load on collab service
        if (newParticipants.length >= (0, $4123025face0353e$export$3debf01bbfa135e5) && provider) {
            // sort users by last active (last joined)
            const sortedUsers = newParticipants.sort((userA, userB)=>userA.lastActive > userB.lastActive ? 1 : -1);
            const currentUser = sortedUsers.find((user)=>user.sessionId === provider.sessionId);
            const lastActiveUser = sortedUsers[sortedUsers.length - 1];
            // kick the last joined user out
            setState({
                ...state,
                participants: newParticipants.filter(({ sessionId: sessionId })=>sessionId !== lastActiveUser.sessionId)
            });
            if (lastActiveUser.sessionId === currentUser?.sessionId) provider.destroy();
            return;
        }
        setState({
            ...state,
            participants: newParticipants
        });
    };
const $4e59b4cbd57cc99d$var$participantsLeft = (left)=>({ getState: getState, setState: setState })=>{
        const leftSessionIds = left.map(({ sessionId: sessionId })=>sessionId);
        const state = getState();
        // cleanup user selection when they leave the session
        const newSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>!leftSessionIds.includes(selection.sessionId));
                if (filteredSelections.length === 0) return;
                newSelection[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            participants: state.participants.filter(({ sessionId: sessionId })=>!leftSessionIds.includes(sessionId)),
            nodeSelection: newSelection
        });
    };
const $4e59b4cbd57cc99d$var$setProvider = (provider)=>({ getState: getState, setState: setState })=>setState({
            ...getState(),
            provider: provider
        });
const $4e59b4cbd57cc99d$var$sendNodeSelected = ({ nodeId: nodeId })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                anchor: JSON.stringify({
                    nodeId: nodeId
                })
            }
        });
    };
const $4e59b4cbd57cc99d$var$sendClearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams })=>({ getState: getState })=>{
        if (nodeId == null) return;
        const { provider: provider, participants: participants } = getState();
        if (participants.length <= 1) return;
        if (provider) provider.sendMessage({
            type: 'telepointer',
            sessionId: provider.sessionId,
            selection: {
                type: 'nodeSelection',
                head: JSON.stringify({
                    nodeId: nodeId,
                    dropParams: dropParams
                })
            }
        });
    };
const $4e59b4cbd57cc99d$var$setNodeSelection = ({ nodeId: nodeId, sessionId: sessionId, user: user })=>({ setState: setState, getState: getState })=>{
        const newSelection = {
            nodeId: nodeId,
            user: user,
            sessionId: sessionId
        };
        const state = getState();
        const dedupCurrentSelection = state.nodeSelection[nodeId] && state.nodeSelection[nodeId].filter((selection)=>selection.user.userId !== user.userId);
        const nodeSelection = dedupCurrentSelection ? [
            ...dedupCurrentSelection,
            newSelection
        ] : [
            newSelection
        ];
        // deduplicate selected nodes from this user, because each user can have only one selected node on the page
        const dedupOtherSelections = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            // keep selections from all other users
            const selections = state.nodeSelection[nodeIdKey];
            if (selections.length > 0) {
                const filteredSelections = selections.filter((selection)=>selection.user.userId !== user.userId);
                if (filteredSelections.length === 0) return;
                dedupOtherSelections[nodeIdKey] = filteredSelections;
            }
        });
        setState({
            ...state,
            nodeSelection: {
                ...dedupOtherSelections,
                [nodeId]: nodeSelection
            }
        });
    };
const $4e59b4cbd57cc99d$var$clearNodeSelection = ({ nodeId: nodeId, dropParams: dropParams, userId: userId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const newNodeSelection = {};
        Object.keys(state.nodeSelection).forEach((nodeIdKey)=>{
            if (nodeIdKey !== nodeId) newNodeSelection[nodeIdKey] = state.nodeSelection[nodeIdKey];
        });
        setState({
            ...state,
            nodeSelection: newNodeSelection,
            dragAnimation: dropParams && userId != null ? [
                ...state.dragAnimation,
                {
                    ...dropParams,
                    userId: userId
                }
            ] : state.dragAnimation
        });
    };
const $4e59b4cbd57cc99d$var$stopDragAnimation = ({ sourceNodeId: sourceNodeId })=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            dragAnimation: state.dragAnimation.filter((animation)=>String(animation.sourceNodeId) !== String(sourceNodeId))
        });
    };
const $4e59b4cbd57cc99d$var$actions = {
    setProvider: $4e59b4cbd57cc99d$var$setProvider,
    participantsLeft: $4e59b4cbd57cc99d$var$participantsLeft,
    participantsJoined: $4e59b4cbd57cc99d$var$participantsJoined,
    updateUserInParticipants: $4e59b4cbd57cc99d$var$updateUserInParticipants,
    sendNodeSelected: $4e59b4cbd57cc99d$var$sendNodeSelected,
    sendClearNodeSelection: $4e59b4cbd57cc99d$var$sendClearNodeSelection,
    setNodeSelection: $4e59b4cbd57cc99d$var$setNodeSelection,
    clearNodeSelection: $4e59b4cbd57cc99d$var$clearNodeSelection,
    stopDragAnimation: $4e59b4cbd57cc99d$var$stopDragAnimation
};
const $4e59b4cbd57cc99d$var$Store = (0, $7JoAD.createStore)({
    initialState: {
        provider: null,
        participants: [],
        nodeSelection: {},
        dragAnimation: []
    },
    actions: $4e59b4cbd57cc99d$var$actions,
    name: 'JSWCollabStore'
});
const $4e59b4cbd57cc99d$export$4159ae80cfa2156 = (0, $7JoAD.createHook)($4e59b4cbd57cc99d$var$Store);

});
const $4123025face0353e$export$3debf01bbfa135e5 = 80;


parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $95EVP = parcelRequire("95EVP");

var $9KB2r = parcelRequire("9KB2r");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KB2r.default), {
        ...textFieldProps,
        testId: testId,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $e0OK7 = parcelRequire("e0OK7");

var $3nMUH = parcelRequire("3nMUH");

var $6T4rd = parcelRequire("6T4rd");
var $2MVcM = parcelRequire("2MVcM");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0OK7.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3nMUH)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $jJ1Sb.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $2MVcM.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $4d5mG = parcelRequire("4d5mG");

var $9bfKK = parcelRequire("9bfKK");

var $5VL3N = parcelRequire("5VL3N");

var $6T4rd = parcelRequire("6T4rd");
var $2MVcM = parcelRequire("2MVcM");
var $jJ1Sb = parcelRequire("jJ1Sb");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bfKK))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4d5mG))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5VL3N))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $jJ1Sb.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $jJ1Sb.xcss)({
    marginRight: 'space.075',
    [(0, $2MVcM.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $jJ1Sb.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $2MVcM.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $jJ1Sb.xcss)({
    marginLeft: 'space.075',
    [(0, $2MVcM.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("fUHZ2", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $a45625fee4d71e0e$export$cd482f0b72849b2c);

var $5uXOq = parcelRequire("5uXOq");

var $95EVP = parcelRequire("95EVP");

var $8zOmE = parcelRequire("8zOmE");
const $a45625fee4d71e0e$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $a45625fee4d71e0e$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        $a45625fee4d71e0e$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

parcelRegister("cM4EP", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fab47741ff1022$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $iqr2y = parcelRequire("iqr2y");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $95EVP = parcelRequire("95EVP");

var $5a0Nh = parcelRequire("5a0Nh");

var $7Oku1 = parcelRequire("7Oku1");
class $93fab47741ff1022$export$876b3e4acf4df22c extends (0, $5uXOq.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $7Oku1.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $5a0Nh.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $7Oku1.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $93fab47741ff1022$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $fZneA.isClientFetchError)(error),
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93fab47741ff1022$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $93fab47741ff1022$export$2e2bcd8739ae039 = $93fab47741ff1022$var$CustomFilterBoundary;

});

parcelRegister("2FvdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1987110dd76b24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dF9Z3 = parcelRequire("dF9Z3");
const $fb1987110dd76b24$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $fb1987110dd76b24$export$2e2bcd8739ae039 = $fb1987110dd76b24$var$HijackBrowserDefaultSearch;

});

parcelRegister("kH9yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $333f125f896ef4d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hipvl = parcelRequire("hipvl");
var $4dc4s = parcelRequire("4dc4s");

var $6T4rd = parcelRequire("6T4rd");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $dF9Z3 = parcelRequire("dF9Z3");

var $ew9g5 = parcelRequire("ew9g5");

var $gtlfw = parcelRequire("gtlfw");
const $333f125f896ef4d8$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
    const hasShown = (0, $5uXOq.useRef)(false);
    const onGlobalSearch = (0, $5uXOq.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $ew9g5.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                text: formatMessage((0, $gtlfw.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $ew9g5.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $dF9Z3.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hipvl.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, changeBoardingMessage()));
    if (isCompanyManaged) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hipvl.default), {
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageHeadingIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessage)));
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $333f125f896ef4d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $333f125f896ef4d8$var$SearchFilterChangeboarding;
const $333f125f896ef4d8$var$Pulse = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $4dc4s.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$ChangeboardingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $333f125f896ef4d8$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$SpolightCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _y44v18t4 _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$Code = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _11q7exu1 _syaz1fxt _2rko1l7b _1e0c1nu9 _1reo1wug _o5721jtm _1yt4u49m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ew9g5", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$fba51361338c8f18);

var $i205g = parcelRequire("i205g");

var $8zOmE = parcelRequire("8zOmE");
const $f70c479b04e71cf2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $f70c479b04e71cf2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $i205g.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$f70c479b04e71cf2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$f70c479b04e71cf2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $f70c479b04e71cf2$export$fba51361338c8f18 = (screenName)=>(0, $i205g.setFlag)($f70c479b04e71cf2$var$changeboardingFlags[screenName], $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $dJl1T = parcelRequire("dJl1T");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("gtlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e167f73d4db9857$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e167f73d4db9857$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    },
    changeboardingUifMessageHeadingIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading-issue-term-refresh",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessageIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-issue-term-refresh",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    }
});

});


parcelRegister("bBMqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b1c241e667722$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");
const $cf4b1c241e667722$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cf4b1c241e667722$export$2e2bcd8739ae039 = $cf4b1c241e667722$var$VersionFilterRelayBoundary;

});

parcelRegister("l38sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c71ac6a8ffa9b82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c71ac6a8ffa9b82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    },
    textFilterIssueTermRefresh: {
        "id": "software-filters.stateless.text-filter-issue-term-refresh",
        "defaultMessage": "Filter issues"
    },
    unassignedVersionLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-version-label-issue-term-refresh",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-label-label-issue-term-refresh",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-component-label-issue-term-refresh",
        "defaultMessage": "Issues without component"
    }
});

});

parcelRegister("649U3", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $224b64cdfcbfd0e3$export$84a62bf03b005a81);
$parcel$export(module.exports, "getAssigneesWithPresence", () => $224b64cdfcbfd0e3$export$cd7b2f0d4c426239);

const $224b64cdfcbfd0e3$export$84a62bf03b005a81 = (projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname)=>{
    if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return `${pathname}?config=quickFilters`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
};
const $224b64cdfcbfd0e3$export$cd7b2f0d4c426239 = (allAssignees, participants)=>allAssignees.map((assignee)=>{
        if (assignee.id === (0, $15a528573ccd89ae$export$12e572fd459c10dc)) return assignee;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            ...assignee,
            presence: participants.some((participant)=>participant.clientId === assignee.id) ? (0, $15a528573ccd89ae$export$7a105aa475396c65) : (0, $15a528573ccd89ae$export$c9408e3fb31ddc71)
        };
    }).sort((a, b)=>{
        // sort by presence & keep current user as the first
        if (a.id === allAssignees[0].id) return -1;
        if (b.id === allAssignees[0].id) return 1;
        if (a.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return -1;
        if (b.presence === (0, $15a528573ccd89ae$export$7a105aa475396c65)) return 1;
        return 0;
    });

});


parcelRegister("361on", function(module, exports) {

$parcel$export(module.exports, "getNormalizedFilters", () => $d5949234e82f3596$export$459be3406d78c3a5);
$parcel$export(module.exports, "onFilterChangeStartInteraction", () => $d5949234e82f3596$export$568db3ec08ca631b);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $4R6GH = parcelRequire("4R6GH");


var $4Djk8 = parcelRequire("4Djk8");
const $d5949234e82f3596$export$459be3406d78c3a5 = (filters)=>{
    const chainedFilters = (0, $7uUwQ.chain)({}).setIn([
        (0, $15a528573ccd89ae$export$d597759d33be802e)
    ], filters[0, $15a528573ccd89ae$export$d597759d33be802e] ? filters[0, $15a528573ccd89ae$export$d597759d33be802e] : undefined).setIn([
        (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]) ? filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7] : undefined).setIn([
        (0, $15a528573ccd89ae$export$2a4f270075a033de)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$2a4f270075a033de]) ? filters[0, $15a528573ccd89ae$export$2a4f270075a033de] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]) ? filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb] : undefined).setIn([
        (0, $15a528573ccd89ae$export$ebb48b08205007c5)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$ebb48b08205007c5]) ? filters[0, $15a528573ccd89ae$export$ebb48b08205007c5] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a4ad2735b021c132)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]) ? filters[0, $15a528573ccd89ae$export$a4ad2735b021c132] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a316570a0dbfd2b0)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0]) ? filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] : undefined).setIn([
        (0, $15a528573ccd89ae$export$92ab80c1dc9baf44)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44]) ? filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44] : undefined).setIn([
        (0, $15a528573ccd89ae$export$e50006273435e7d4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$e50006273435e7d4]) ? filters[0, $15a528573ccd89ae$export$e50006273435e7d4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$68d693c35a8d8866)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$68d693c35a8d8866]) ? filters[0, $15a528573ccd89ae$export$68d693c35a8d8866] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f863b019d19144f4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f863b019d19144f4]) ? filters[0, $15a528573ccd89ae$export$f863b019d19144f4] : undefined);
    /**
	 * Delete the condition and merge the content in the chain({}) above when removing the isIncrementPlanningBoardM1Enabled FF i.e.
	 * getNormalizedFilters = () => chain({}).setIn()...setIn([ISSUE_PROJECT])...setIn().value();
	 */ if ((0, $4Djk8.isIncrementPlanningBoardM1Enabled)()) chainedFilters.setIn([
        (0, $15a528573ccd89ae$export$401f4b6eda6a369c)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c]) ? filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c] : undefined);
    if ((0, $4R6GH.fg)('dependency_visualisation_program_board_fe_and_be')) chainedFilters.setIn([
        (0, $15a528573ccd89ae$export$db362e2d293fe52e)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$db362e2d293fe52e]) ? filters[0, $15a528573ccd89ae$export$db362e2d293fe52e] : undefined);
    return chainedFilters.value();
};
const $d5949234e82f3596$export$568db3ec08ca631b = (filterType, onChangeInteractionStart, onCustomFilterChangeInteractionStart)=>{
    if (filterType === (0, $15a528573ccd89ae$export$68d693c35a8d8866)) onCustomFilterChangeInteractionStart();
    else onChangeInteractionStart();
};

});


parcelRegister("eY43C", function(module, exports) {

$parcel$export(module.exports, "setInteractionFeedbackMark", () => $4fd2e97bfd321407$export$2a56340540433ea3);
$parcel$export(module.exports, "setInteractionStartMark", () => $4fd2e97bfd321407$export$1da8f59ae62c0e17);

var $8hVbJ = parcelRequire("8hVbJ");
const $4fd2e97bfd321407$export$2a56340540433ea3 = ()=>{
    (0, $8hVbJ.filterInteraction).mark('feedback');
};
const $4fd2e97bfd321407$export$1da8f59ae62c0e17 = ()=>{
    (0, $8hVbJ.filterInteraction).start();
};

});

parcelRegister("fOzEZ", function(module, exports) {

$parcel$export(module.exports, "useGetEpicsAndProject", () => $e5ae4f46b6d4a4bf$export$6a0adf6c96018071);

var $5tTFS = parcelRequire("5tTFS");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $5ZVKE = parcelRequire("5ZVKE");

var $f6RVN = parcelRequire("f6RVN");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $f9Swb = parcelRequire("f9Swb");

var $fSgHa = parcelRequire("fSgHa");
const $e5ae4f46b6d4a4bf$var$useEpicQuery = (boardId, isCompanyManaged, shouldSyncEpics)=>(0, $5tTFS.useQuery)((0, $5ZVKE.EPIC_QUERY), {
        skip: false,
        variables: {
            boardId: boardId,
            isCompanyManaged: // Legacy BacklogGetAllEpics does not require isCompanyManaged variables
            // Therefore, we omit isCompanyManaged variable if FF is off
            isCompanyManaged,
            isQueryColumns: isCompanyManaged && (0, $f6RVN.isEpicPanelInProgressBarTooltipsUpdateEnabled)(),
            skipEpicDetails: (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details'),
            includeIssueTypes: (0, $4R6GH.fg)('jsw_cmp_backlog_remove_epics_request')
        },
        context: {
            headers: {
                /*  This header is required for EpicPanelEpics query
                        Please note that isCompanyManaged == true is also behind feature flag
                */ 'is-company-managed-board': isCompanyManaged
            }
        },
        fetchPolicy: shouldSyncEpics ? 'cache-and-network' : 'cache-first'
    });
const $e5ae4f46b6d4a4bf$export$6a0adf6c96018071 = (boardId, shouldSyncEpics = false)=>{
    const isCompanyManaged = (0, $fSgHa.useIsCMPBacklog)();
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    let isParentIssueTypeAvailable = false;
    let issueParentsTypeName = (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    const { data: data } = $e5ae4f46b6d4a4bf$var$useEpicQuery(boardId, isCompanyManaged, shouldSyncEpics);
    if (false || !data) return {
        parents: [],
        isParentIssueTypeAvailable: isParentIssueTypeAvailable,
        issueParentsTypeName: issueParentsTypeName
    };
    const { boardScope: { projectLocation: projectLocation }, globalConfig: globalConfig } = data;
    if (isCompanyManaged) {
        isParentIssueTypeAvailable = globalConfig?.issueParentTypeConfig.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        issueParentsTypeName = firstLevelHierarchyName || globalConfig?.issueParentTypeConfig.name || (0, $guzeq.DEFAULT_PARENT_ISSUE_TYPE_NAME);
    } else if (projectLocation?.issueTypes.length) {
        const issueType = projectLocation.issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
        isParentIssueTypeAvailable = Boolean(issueType);
        if (issueType) issueParentsTypeName = issueType.name;
    }
    return {
        parents: data.boardScope.issueParents,
        isParentIssueTypeAvailable: isParentIssueTypeAvailable,
        issueParentsTypeName: issueParentsTypeName
    };
};

});
parcelRegister("5ZVKE", function(module, exports) {

$parcel$export(module.exports, "EPIC_QUERY", () => $d4b9c93a4c9ddd9f$export$cb085029733a197f);
$parcel$export(module.exports, "useEpicQuery", () => $d4b9c93a4c9ddd9f$export$e0168062c1c658e5);
$parcel$export(module.exports, "useEpicDetailsQuery", () => $d4b9c93a4c9ddd9f$export$97e1c9675ac0bfb2);

var $5uXOq = parcelRequire("5uXOq");

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $dZggJ = parcelRequire("dZggJ");

var $kGkjZ = parcelRequire("kGkjZ");

var $6kSke = parcelRequire("6kSke");
const $d4b9c93a4c9ddd9f$export$cb085029733a197f = (0, $5cllN.default)`
    ${(0, $kGkjZ.timeTrackingOptionsFragment)}
    ${(0, $kGkjZ.epicLiteFragment)}
    ${(0, $kGkjZ.epicFragment)}
    ${(0, $kGkjZ.estimationInfoFragment)}
    ${(0, $kGkjZ.projectLocationFragment)}
    ${(0, $kGkjZ.currentUserFragment)}
    ${(0, $kGkjZ.boardLocationFragment)}
    ${(0, $kGkjZ.issueParentTypeConfigFragment)}
    ${(0, $kGkjZ.columnFragment)}
    ${(0, $kGkjZ.boardFragment)}
    query EpicPanelEpics($boardId: ID!, $isCompanyManaged: Boolean!, $isQueryColumns: Boolean!, $skipEpicDetails: Boolean! = false, $includeIssueTypes: Boolean! = false) {
        jira @include(if: $isCompanyManaged) {
            timeTrackingOptions {
                ...TimeTrackingOptionsFragment
            }
        }
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            issueParents @skip(if: $skipEpicDetails) {
                ...EpicPanelIssueParentFragment
                estimationInfo @include(if: $isCompanyManaged) {
                    ...EstimationInfoFragment
                }
            }
            issueParents @include(if: $skipEpicDetails) {
                ...EpicPanelIssueParentLiteFragment
            }
            projectLocation @skip(if: $isCompanyManaged) {
                ...ProjectLocationFragment
            }
            currentUser {
                ...CurrentUserFragment
            }
            boardLocation @include(if: $isCompanyManaged) {
                ...BoardLocationFragment
            }
            board @include(if: $isQueryColumns) {
                columns {
                    ...ColumnFragment
                }
                ...BoardFragment
            }
        }
        globalConfig @include(if: $isCompanyManaged) {
            issueParentTypeConfig {
                ...IssueParentTypeConfigFragment
            }
        }
    }
`;
const $d4b9c93a4c9ddd9f$export$e0168062c1c658e5 = (boardId, isCompanyManaged)=>{
    const [hasFullFetched, setFullFetched] = (0, $5uXOq.useState)(false);
    const [shouldShowLoadingState, setShouldShowLoadingState] = (0, $5uXOq.useState)(false);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $5tTFS.useQuery)($d4b9c93a4c9ddd9f$export$cb085029733a197f, {
        skip: (0, $4R6GH.fg)('jsw_epic_panel_paginated_fetch') || false,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: boardId,
            isCompanyManaged: isCompanyManaged,
            isQueryColumns: (0, $co1wz.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl') && isCompanyManaged,
            skipEpicDetails: (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details'),
            includeIssueTypes: (0, $4R6GH.fg)('jsw_cmp_backlog_remove_epics_request')
        },
        fetchPolicy: 'cache-first'
    });
    const fetchFull = (0, $5uXOq.useCallback)(async ({ triggerLoadingState: triggerLoadingState = false } = {})=>{
        if ((0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details')) {
            setShouldShowLoadingState(triggerLoadingState);
            setFullFetched(true);
            const result = await refetch({
                boardId: boardId,
                isCompanyManaged: isCompanyManaged,
                isQueryColumns: (0, $co1wz.ff)('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl') && isCompanyManaged,
                skipEpicDetails: false
            });
            setShouldShowLoadingState(false);
            return result;
        }
        return refetch();
    }, [
        boardId,
        isCompanyManaged,
        refetch
    ]);
    const transformedData = (0, $5uXOq.useMemo)(()=>(0, $6kSke.transformEpic)({
            isCompanyManaged: isCompanyManaged,
            isLoading: loading && shouldShowLoadingState,
            hasError: !!error,
            data: data
        }), [
        data,
        error,
        isCompanyManaged,
        loading,
        shouldShowLoadingState
    ]);
    return {
        data: transformedData,
        loading: loading,
        error: error,
        refetch: fetchFull,
        hasFullFetched: (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details') ? hasFullFetched : undefined
    };
};
/* -------------------------------------------------------------------------- */ /**
 * Query to fetch full epic details for the epic panel. This is responsible for updating the apollo cache,
 * and the values are read via VIEW_EPIC_DETAILS_QUERY.
 */ const $d4b9c93a4c9ddd9f$var$EPIC_DETAILS_QUERY = (0, $5cllN.default)`
    ${(0, $kGkjZ.epicFragment)}
    ${(0, $kGkjZ.estimationInfoFragment)}
    query FullEpicDetails($boardId: ID!, $isCompanyManaged: Boolean!, $pageSize: Int!, $startCursor: String) {
        boardScope(boardId: $boardId, isCMP: $isCompanyManaged) {
            parents(first: $pageSize, after: $startCursor) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        ...EpicPanelIssueParentFragment
                        estimationInfo @include(if: $isCompanyManaged) {
                            ...EstimationInfoFragment
                        }
                    }
                }
            }
        }
    }
`;
const $d4b9c93a4c9ddd9f$export$97e1c9675ac0bfb2 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged })=>(0, $5tTFS.useQuery)($d4b9c93a4c9ddd9f$var$EPIC_DETAILS_QUERY, {
        notifyOnNetworkStatusChange: true,
        context: {
            headers: {
                'is-company-managed-board': isCompanyManaged
            }
        },
        variables: {
            boardId: String(boardId),
            isCompanyManaged: isCompanyManaged,
            pageSize: (0, $dZggJ.PAGE_SIZE)
        },
        fetchPolicy: 'network-only',
        skip: true
    });

});
parcelRegister("6kSke", function(module, exports) {

$parcel$export(module.exports, "transformEpic", () => $488d6951ad97ea77$export$db2b81c6fdbe846c);
$parcel$export(module.exports, "transformFullCard", () => $488d6951ad97ea77$export$7b09839985806501);

var $kQZsR = parcelRequire("kQZsR");

var $co1wz = parcelRequire("co1wz");

var $g4tDr = parcelRequire("g4tDr");

var $gBj4V = parcelRequire("gBj4V");

var $dZggJ = parcelRequire("dZggJ");
const $488d6951ad97ea77$var$isEpicLoadingBecauseOfOptimisticCreation = (epicId)=>Number(epicId) < 0;
const $488d6951ad97ea77$export$ac8d104fa0f53892 = (estimation)=>{
    const { details: { estimationType: estimationType, name: name }, childrenEstimationStats: { doneEstimate: doneEstimate, totalEstimate: totalEstimate, percentageCompleted: percentageCompleted, notEstimated: notEstimated } } = estimation;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(estimationType) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(name) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(doneEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(totalEstimate) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(percentageCompleted) || (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(notEstimated)) return null;
    return {
        estimationType: estimationType,
        name: name,
        doneEstimate: doneEstimate,
        totalEstimate: totalEstimate,
        percentageCompleted: percentageCompleted / 100,
        notEstimated: notEstimated
    };
};
const $488d6951ad97ea77$var$transformCard = ({ id: id, key: key, summary: summary, color: color, childrenInfo: childrenInfo, estimationInfo: estimationInfo, startDate: startDate, dueDate: dueDate }, columnCounts, isLoading, hasError)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(color) ? undefined : color,
        isLoading: $488d6951ad97ea77$var$isEpicLoadingBecauseOfOptimisticCreation(id) || (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details') && (isLoading || !childrenInfo),
        hasError: (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details') && hasError,
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(startDate) ? undefined : startDate,
        dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(dueDate) ? undefined : dueDate
    };
    const shouldHideProgress = (0, $co1wz.ff)('jsw-epic-panel-performance-async-epic-details') && (isLoading || hasError);
    const { todoStats: todoStats, inProgressStats: inProgressStats, doneStats: doneStats } = childrenInfo || {};
    const toDo = !shouldHideProgress && todoStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(todoStats.issueCount) ? todoStats.issueCount : 0;
    const inProgress = !shouldHideProgress && inProgressStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(inProgressStats.issueCount) ? inProgressStats.issueCount : 0;
    const done = !shouldHideProgress && doneStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(doneStats.issueCount) ? doneStats.issueCount : 0;
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: toDo,
                    columnCount: columnCounts.toDo
                },
                inProgress: {
                    issueCount: inProgress,
                    columnCount: columnCounts.inProgress
                },
                done: {
                    issueCount: done,
                    columnCount: columnCounts.done
                }
            },
            totalIssues: toDo + inProgress + done
        },
        estimation: estimationInfo ? $488d6951ad97ea77$export$ac8d104fa0f53892(estimationInfo) : null
    };
};
const $488d6951ad97ea77$var$getColumnsCounts = (columns)=>{
    const toDo = columns.filter((column)=>column.isInitial).length;
    const inProgress = columns.filter((column)=>!column.isInitial && !column.isDone).length;
    const done = columns.filter((column)=>column.isDone).length;
    return {
        toDo: toDo,
        inProgress: inProgress,
        done: done
    };
};
const $488d6951ad97ea77$export$db2b81c6fdbe846c = ({ isCompanyManaged: isCompanyManaged, isLoading: isLoading, hasError: hasError, data: data })=>{
    const defaultReturn = {
        ...isCompanyManaged && {
            timeTrackingOptions: (0, $gBj4V.defaultTimeTrackingOptions)
        },
        projectId: '0',
        isRankingEnabled: !isCompanyManaged,
        cards: [],
        epicIssueType: {
            id: 0,
            name: (0, $dZggJ.DEFAULT_PARENT_ISSUE_TYPE_NAME),
            hasRequiredFields: false
        },
        currentUserHasCreatePermission: false,
        currentUserHasEditPermission: false
    };
    if (!data) return defaultReturn;
    const { globalConfig: globalConfig, boardScope: { issueParents: issueParents, projectLocation: projectLocation, currentUser: { permissions: permissions }, boardLocation: boardLocation, board: board } } = data;
    let epicIssueType;
    let projectId = '';
    if (isCompanyManaged) {
        epicIssueType = globalConfig?.issueParentTypeConfig;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        projectId = boardLocation?.id ?? '';
    } else if (projectLocation) {
        const { issueTypes: issueTypes, id: id } = projectLocation;
        projectId = id;
        epicIssueType = issueTypes.find(({ hierarchyLevelType: hierarchyLevelType })=>hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
    }
    if (epicIssueType) {
        const currentUserHasCreatePermission = permissions.includes((0, $dZggJ.CREATE_ISSUE_PERMISSION));
        const currentUserHasEditPermission = permissions.includes((0, $dZggJ.EDIT_ISSUE_PERMISSION));
        const columns = board?.columns ?? [];
        const columnCounts = $488d6951ad97ea77$var$getColumnsCounts(columns);
        const cards = issueParents.map((card)=>$488d6951ad97ea77$var$transformCard(card, columnCounts, isLoading, hasError));
        return {
            ...data.jira && {
                timeTrackingOptions: data.jira.timeTrackingOptions
            },
            projectId: projectId,
            isRankingEnabled: board ? !!board.rankCustomFieldId : true,
            cards: cards,
            epicIssueType: {
                id: epicIssueType.id,
                name: epicIssueType.name,
                hasRequiredFields: epicIssueType.hasRequiredFields ?? false
            },
            currentUserHasCreatePermission: currentUserHasCreatePermission,
            currentUserHasEditPermission: currentUserHasEditPermission
        };
    }
    return defaultReturn;
};
const $488d6951ad97ea77$export$7b09839985806501 = ({ id: id, key: key, summary: summary, color: color, childrenInfo: childrenInfo, estimationInfo: estimationInfo, startDate: startDate, dueDate: dueDate }, columnCounts)=>{
    const epicData = {
        id: Number(id),
        key: key,
        name: summary,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(color) ? undefined : color,
        isLoading: $488d6951ad97ea77$var$isEpicLoadingBecauseOfOptimisticCreation(id),
        hasError: false,
        startDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(startDate) ? undefined : startDate,
        dueDate: (0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(dueDate) ? undefined : dueDate
    };
    const { todoStats: todoStats, inProgressStats: inProgressStats, doneStats: doneStats } = childrenInfo || {};
    const toDo = todoStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(todoStats.issueCount) ? todoStats.issueCount : 0;
    const inProgress = inProgressStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(inProgressStats.issueCount) ? inProgressStats.issueCount : 0;
    const done = doneStats && !(0, (/*@__PURE__*/$parcel$interopDefault($kQZsR)))(doneStats.issueCount) ? doneStats.issueCount : 0;
    return {
        epic: epicData,
        progress: {
            status: {
                toDo: {
                    issueCount: toDo,
                    columnCount: columnCounts.toDo
                },
                inProgress: {
                    issueCount: inProgress,
                    columnCount: columnCounts.inProgress
                },
                done: {
                    issueCount: done,
                    columnCount: columnCounts.done
                }
            },
            totalIssues: toDo + inProgress + done
        },
        estimation: estimationInfo ? $488d6951ad97ea77$export$ac8d104fa0f53892(estimationInfo) : null
    };
};

});



parcelRegister("5jOz5", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilter", () => $0c38389865ba77d9$export$34fa6a8efdb70dd8);

var $5uXOq = parcelRequire("5uXOq");

var $9vASA = parcelRequire("9vASA");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $l9VFH = parcelRequire("l9VFH");

var $fSgHa = parcelRequire("fSgHa");

var $fzMlf = parcelRequire("fzMlf");
const $0c38389865ba77d9$var$BacklogCustomFilterRedux = (props)=>{
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const filters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters));
    const showPanelToggle = props.isCompanyManaged;
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onToggleIsFilterBarVisible = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BACKLOG,
            setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters,
        isPanelToggleChecked: isFilterBarVisible,
        onTogglePanel: onToggleIsFilterBarVisible,
        showPanelToggle: showPanelToggle
    });
};
const $0c38389865ba77d9$export$34fa6a8efdb70dd8 = (props)=>{
    const isCMPBoard = (0, $fSgHa.useIsCMPBacklog)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0c38389865ba77d9$var$BacklogCustomFilterRedux, {
        ...props,
        isCompanyManaged: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzMlf.BacklogCustomFilterRelay), props);
};

});
parcelRegister("9vASA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0f814f674e18a1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $96s6B = parcelRequire("96s6B");

var $78uGw = parcelRequire("78uGw");
const $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED = 10;
const $0c0f814f674e18a1$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $78uGw.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $78uGw.default).labelCmp : (0, $78uGw.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $78uGw.default).manageLinkTitleCmp : (0, $78uGw.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $78uGw.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel
    });
};
const $0c0f814f674e18a1$var$CustomFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($0c0f814f674e18a1$var$CustomFilter);
$0c0f814f674e18a1$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$0c0f814f674e18a1$var$CustomFilterComponent.whyDidYouRender = true;
var $0c0f814f674e18a1$export$2e2bcd8739ae039 = $0c0f814f674e18a1$var$CustomFilterComponent;

});
parcelRegister("78uGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad440f119fd51b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cad440f119fd51b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});


parcelRegister("fzMlf", function(module, exports) {

$parcel$export(module.exports, "BacklogCustomFilterRelay", () => $d6b373cf7fd65a0f$export$bb99cea1633822a7);

var $aYacW = parcelRequire("aYacW");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $05fhZ = parcelRequire("05fhZ");
const $d6b373cf7fd65a0f$export$bb99cea1633822a7 = ({ customFiltersQueryRef: customFiltersQueryRef, ...props })=>{
    const customFiltersFragmentRef = (0, $8Uumt.usePreloadedQuery)((0, $aYacW.default), customFiltersQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props
    });
};

});
parcelRegister("05fhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d2b93146d18158$export$2e2bcd8739ae039);

var $fKrqu = parcelRequire("fKrqu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9vASA = parcelRequire("9vASA");

var $5oFIy = parcelRequire("5oFIy");
const $17d2b93146d18158$var$CustomFilterRelay = ({ customFiltersFragmentRef: customFiltersFragmentRef, screenName: screenName, ...props })=>{
    const { boardScope: boardScope } = (0, $8Uumt.useFragment)((0, $fKrqu.default), customFiltersFragmentRef);
    // each item in an array is nullable & an object's keys readonly in relay's generated type
    const filters = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>boardScope?.customFilters.filter(Boolean) || [], [
        boardScope?.customFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        actionSubject: "ui",
        action: "taskSuccess",
        attributes: {
            screenName: screenName,
            task: 'loadCustomFilters',
            customFiltersCount: filters.length
        }
    }));
};
var $17d2b93146d18158$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($17d2b93146d18158$var$CustomFilterRelay);

});
parcelRegister("fKrqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d300f59e5c1532b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27f6e515959b3fa71c98f3b9ea403490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d300f59e5c1532b6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ],
    "kind": "Fragment",
    "name": "customFilter_softwareFilters_CustomFilterRelay",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                    }
                ],
                "concreteType": "BoardScope",
                "kind": "LinkedField",
                "name": "boardScope",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope.customFilters"
                    }
                ]
            },
            "action": "THROW",
            "path": "boardScope"
        }
    ],
    "type": "Query"
};
$d300f59e5c1532b6$var$node.hash = "ae7389daa2b7626fc0f4f542c785e41f";
var $d300f59e5c1532b6$export$2e2bcd8739ae039 = $d300f59e5c1532b6$var$node;

});




parcelRegister("37oMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ad209fbaa07e5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e0ad209fbaa07e5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassigned: {
        "id": "backlog.header.controls-bar.filter-bar.unassigned",
        "defaultMessage": "Issues without {target}"
    },
    textFilter: {
        "id": "backlog.header.controls-bar.filter-bar.text-filter",
        "defaultMessage": "Search"
    },
    filterPlaceholder: {
        "id": "backlog.header.controls-bar.filter-bar.filter-placeholder",
        "defaultMessage": "Search backlog"
    },
    unassignedIssueTermRefresh: {
        "id": "backlog.header.controls-bar.filter-bar.unassigned-issue-term-refresh",
        "defaultMessage": "Issues without {target}"
    }
});

});

parcelRegister("lLAmg", function(module, exports) {

$parcel$export(module.exports, "useIssueTypes", () => $220289fc31d94b44$export$8bbc5cc35915a21b);

var $5uXOq = parcelRequire("5uXOq");

var $g4tDr = parcelRequire("g4tDr");
const $220289fc31d94b44$export$8bbc5cc35915a21b = (issueTypes)=>(0, $5uXOq.useMemo)(()=>{
        if (!issueTypes || !issueTypes.length) return issueTypes;
        return issueTypes.filter((issueType)=>issueType.typeHierarchyLevel !== (0, $g4tDr.EPIC_PARENT_HIERARCHY_TYPE) && issueType.typeHierarchyLevel !== (0, $g4tDr.CHILD_HIERARCHY_TYPE));
    }, [
        issueTypes
    ]);

});



parcelRegister("7ml2y", function(module, exports) {

$parcel$export(module.exports, "ControlsBar", () => $55602d07891954d1$export$9b3bbae461092bf8);
/* view.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $6T4rd = parcelRequire("6T4rd");
var $dsFR3 = parcelRequire("dsFR3");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $2ZySJ = parcelRequire("2ZySJ");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");

var $8vM1G = parcelRequire("8vM1G");

var $k9JTq = parcelRequire("k9JTq");

var $dCm1o = parcelRequire("dCm1o");

var $f6RVN = parcelRequire("f6RVN");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $le1bQ = parcelRequire("le1bQ");

var $czw5V = parcelRequire("czw5V");

var $c060Z = parcelRequire("c060Z");

var $bONT7 = parcelRequire("bONT7");

var $dvM2i = parcelRequire("dvM2i");
const $55602d07891954d1$export$9b3bbae461092bf8 = (props)=>{
    const { isBacklogWithSprints: isBacklogWithSprints, rapidViewId: rapidViewId, FilterBar: FilterBar, onTogglePanel: onTogglePanel, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, isClassic: isClassic, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, onSubtasksExpandAll: onSubtasksExpandAll, onSubtasksCollapseAll: onSubtasksCollapseAll } = props;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const config = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getConfig));
    const isDataLoaded = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.isCriticalDataLoaded));
    const epicCustomName = config.hierarchyNomenclature?.firstLevelName;
    const appEditions = (0, $k9JTq.useAppEditions)();
    const handleOnToggle = (0, $5uXOq.useCallback)((panelType)=>{
        onTogglePanel(panelType);
    }, [
        onTogglePanel
    ]);
    const handleViewSettingPanelToggle = (0, $5uXOq.useCallback)(()=>{
        onTogglePanel((0, $c35fd6591a78fffe$export$ba1da943283b9900));
    }, [
        onTogglePanel
    ]);
    const isInsightsOpen = (0, $czw5V.useIsInsightsPanelOpen)();
    const isViewSettingPanelOpen = (0, $c060Z.useIsViewSettingsPanelOpen)();
    const isFilterSelectionBarOpen = (0, $iDGXn.useShowQuickFilters)();
    const showFilterBarToggle = isCompanyManaged;
    const allCardGroups = (0, $le1bQ.useAllCardGroups)();
    const shouldShowSubtasks = (0, $5uXOq.useMemo)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(allCardGroups), [
        allCardGroups
    ]);
    const isDueDateEnabled = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasDueDate));
    const hasCardsWithStoryPoint = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasStoryPoints));
    const hasCardsWithEstimate = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasEstimates));
    const hasCardsWithPriority = (0, $c1MAf.useBacklogSelector)((0, $dGljH.backlogHasPriority));
    const areAllSubtasksExpanded = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>!card.isCollapsed), [
        allCardGroups
    ]);
    const areAllSubtasksCollapsed = (0, $5uXOq.useMemo)(()=>allCardGroups.every((card)=>card.isCollapsed), [
        allCardGroups
    ]);
    const handleExpandSubtasks = (0, $5uXOq.useCallback)(()=>{
        onSubtasksExpandAll(allCardGroups.map((card)=>card.parentId.toString()));
    }, [
        allCardGroups,
        onSubtasksExpandAll
    ]);
    const handleCollapseSubtasks = (0, $5uXOq.useCallback)(()=>{
        onSubtasksCollapseAll();
    }, [
        onSubtasksCollapseAll
    ]);
    const cardExtraFields = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardExtraFields));
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55602d07891954d1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55602d07891954d1$var$FilterBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FilterBar, {
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), (0, $dCm1o.isVisualRefreshEnabled)() || (0, $4R6GH.fg)('fix_insight_button_spacing_on_board_and_backlog') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsFR3.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null), isBacklogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvM2i.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: rapidViewId,
        edition: appEditions.software
    }), (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $a4XJc.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: handleViewSettingPanelToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelButtonSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55602d07891954d1$var$OperationsWrapperOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $55602d07891954d1$var$importWorkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), null)), isBacklogWithSprints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dvM2i.InsightsButton), {
        onToggle: handleOnToggle,
        isInsightsPanelOpen: isInsightsOpen,
        boardId: rapidViewId,
        edition: appEditions.software
    }), (0, $f6RVN.isViewSettingAsPanelExpEnabledWithNoExposure)() ? isDataLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
        boardId: rapidViewId,
        view: (0, $a4XJc.View).BACKLOG,
        cardExtraFields: cardExtraFields,
        isVersionsEnabled: isVersionsEnabled,
        isEstimateEnabled: hasCardsWithStoryPoint || hasCardsWithEstimate,
        showEpicAsPanel: showEpicAsPanel,
        isDueDateEnabled: !isCompanyManaged && isDueDateEnabled,
        isPriorityEnabled: hasCardsWithPriority
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: handleViewSettingPanelToggle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelButtonSpotlight), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
        isSelected: isViewSettingPanelOpen,
        onClick: handleViewSettingPanelToggle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        view: (0, $a4XJc.View).BACKLOG,
        boardId: rapidViewId,
        isClassic: isClassic,
        areSubtasksEnabled: isCompanyManaged && shouldShowSubtasks,
        onSubtasksExpandAll: handleExpandSubtasks,
        onSubtasksCollapseAll: handleCollapseSubtasks,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        isVersionsEnabled: isVersionsEnabled,
        showFilterBarToggle: showFilterBarToggle
    })))), isFilterSelectionBarOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bONT7.default), null));
};
var $55602d07891954d1$export$2e2bcd8739ae039 = $55602d07891954d1$export$9b3bbae461092bf8;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55602d07891954d1$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19pkx0bf _1bsb1osq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $55602d07891954d1$var$FilterBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $55602d07891954d1$var$OperationsWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $55602d07891954d1$var$importWorkWrapperStyles = (0, $jJ1Sb.xcss)({
    marginRight: 'space.050'
});

});
parcelRegister("8vM1G", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanelOnboarding", () => $2f6bb1e464f0a6ca$export$215da70478ebbc7);
$parcel$export(module.exports, "ViewSettingsPanelButtonSpotlight", () => $2f6bb1e464f0a6ca$export$67c31a192079fb3c);

var $5uXOq = parcelRequire("5uXOq");

var $fR82N = parcelRequire("fR82N");

var $47htk = parcelRequire("47htk");
var $5MdCt = parcelRequire("5MdCt");


var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $hchBL = parcelRequire("hchBL");

var $ehdJY = parcelRequire("ehdJY");

var $cYeCp = parcelRequire("cYeCp");


var $jnjYD = parcelRequire("jnjYD");
const $2f6bb1e464f0a6ca$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase = ({ onTogglePanel: onTogglePanel, isViewSettingPanelOpen: isViewSettingPanelOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const [viewSettingsPanelRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$989661c424340ff8));
    const [addPeopleButtonRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$4a16d41d3ff730bf));
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(0);
    const next = (0, $5uXOq.useCallback)(()=>setActiveSpotlight((current)=>current !== null ? current + 1 : 0), []);
    const renderSpotlight = (0, $5uXOq.useCallback)((stop)=>{
        const finalStepActions = [
            {
                text: formatMessage((0, $jnjYD.default).doneStepButton),
                onClick: ()=>{
                    isViewSettingPanelOpen && onTogglePanel();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDone');
                    setActiveSpotlight(null);
                    stop && stop();
                }
            }
        ];
        const isAddPeopleButtonAvailable = Boolean(addPeopleButtonRef);
        const numberOfSpotlights = isAddPeopleButtonAvailable ? 3 : 2;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                target: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                heading: formatMessage((0, $jnjYD.default).viewSettingsButtonStepTitle),
                actionsBeforeElement: `1/${numberOfSpotlights}`,
                actions: [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            !isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ],
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
                dialogPlacement: "bottom right",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).viewSettingsButtonStepContent)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$989661c424340ff8),
                targetNode: viewSettingsPanelRef,
                actionsBeforeElement: `2/${numberOfSpotlights}`,
                actions: isAddPeopleButtonAvailable ? [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ] : finalStepActions,
                targetRadius: 10,
                targetBgColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
                dialogPlacement: "left top",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jnjYD.default).viewSettingsPanelFirstPartContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jnjYD.default).viewSettingsPanelSecondPartContentIssueTermRefresh : (0, $jnjYD.default).viewSettingsPanelSecondPartContent)))),
            isAddPeopleButtonAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$4a16d41d3ff730bf),
                targetNode: addPeopleButtonRef,
                heading: formatMessage((0, $jnjYD.default).addPeopleButtonStepTitle),
                actionsBeforeElement: `3/${numberOfSpotlights}`,
                actions: finalStepActions,
                targetRadius: (0, $fR82N.AVATAR_SIZES).medium,
                targetBgColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$exports).N0})`,
                dialogPlacement: "bottom left",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.2",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).addPeopleButtonStepContent)) : null
        ];
        return activeSpotlight != null ? spotlights[activeSpotlight] : null;
    }, [
        activeSpotlight,
        createAnalyticsEvent,
        formatMessage,
        isViewSettingPanelOpen,
        next,
        onTogglePanel,
        viewSettingsPanelRef,
        addPeopleButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $3795a016b6403547$export$8be246eeba922980),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f6bb1e464f0a6ca$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5MdCt.default), null, renderSpotlight(stop))));
};
const $2f6bb1e464f0a6ca$export$215da70478ebbc7 = (0, $7XYc4.componentWithCondition)((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled), $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase, ()=>null);
const $2f6bb1e464f0a6ca$export$67c31a192079fb3c = ({ children: children })=>{
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47htk.default), {
        name: (0, $3795a016b6403547$export$a57856d4380e4bb8)
    }, children);
    return children;
};

});
parcelRegister("jnjYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d14ba5d33834aaf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d14ba5d33834aaf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewSettingsButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-title",
        "defaultMessage": "Customize your view"
    },
    viewSettingsButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-content",
        "defaultMessage": "Use view settings to simplify the look and feel of your board and backlog."
    },
    viewSettingsPanelFirstPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-first-part-content",
        "defaultMessage": "Switch on what you need, and switch off what you don\u2019t."
    },
    viewSettingsPanelSecondPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    },
    addPeopleButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-title",
        "defaultMessage": "Share your view"
    },
    addPeopleButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-content",
        "defaultMessage": "Now when you add a new teammate to Jira, you can share your view settings so they see what you see. Includes view settings and filters."
    },
    nextStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.next-step-button",
        "defaultMessage": "Next"
    },
    dismissStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.dismiss-step-button",
        "defaultMessage": "Dismiss"
    },
    doneStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.done-step-button",
        "defaultMessage": "Done"
    },
    viewSettingsPanelSecondPartContentIssueTermRefresh: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content-issue-term-refresh",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    }
});

});


parcelRegister("bONT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b49e9ab60b23fb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $88tXZ = parcelRequire("88tXZ");

var $iU0UM = parcelRequire("iU0UM");


var $c1MAf = parcelRequire("c1MAf");

var $8MHVw = parcelRequire("8MHVw");

var $dGljH = parcelRequire("dGljH");

var $l9VFH = parcelRequire("l9VFH");
const $93b49e9ab60b23fb$var$FilterSelectionBarContainer = ()=>{
    const [selectedFilters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const allFilters = (0, $c1MAf.useBacklogSelector)((0, $l9VFH.getCMPFilters));
    const cardIds = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardIds));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onChange = (0, $5uXOq.useCallback)((filters, analyticsEvent)=>{
        dispatch((0, $8MHVw.filteredCardsRequest)(cardIds, analyticsEvent, filters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]));
        setFilters({
            ...selectedFilters,
            ...filters
        });
    }, [
        selectedFilters,
        dispatch,
        cardIds,
        setFilters
    ]);
    const selectedFilterSet = (0, $5uXOq.useMemo)(()=>new Set(selectedFilters[0, $41ce9b5576b92b7a$export$68d693c35a8d8866]), [
        selectedFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iU0UM.default), {
        selectedFilters: selectedFilterSet,
        onChange: onChange,
        filters: allFilters
    });
};
var $93b49e9ab60b23fb$export$2e2bcd8739ae039 = $93b49e9ab60b23fb$var$FilterSelectionBarContainer;

});
parcelRegister("iU0UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8822a2681eb1c63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $caqPj = parcelRequire("caqPj");

var $euWQZ = parcelRequire("euWQZ");
const $8822a2681eb1c63b$var$FilterSelectionBar = ({ onChange: onChange, selectedFilters: selectedFilters, filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-filters.ui.filter-selection-bar.filter-selection-bar",
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1reo1g80 _18m91g80 _1e0c1txw _zulpu2gc _19pku2gc _1n261g80 _qtt8glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", {
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw"
        ])
    }, formatMessage((0, $euWQZ.default).filterToolBarAriaLabel)), filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caqPj.default), {
            key: `filter-option-${filter.id}`,
            onChange: onChange,
            selectedFilters: selectedFilters,
            filter: filter
        })));
};
var $8822a2681eb1c63b$export$2e2bcd8739ae039 = $8822a2681eb1c63b$var$FilterSelectionBar;
const $8822a2681eb1c63b$var$styles = null;

});
parcelRegister("caqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef490007e1102a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $MGmIU = parcelRequire("MGmIU");

var $95EVP = parcelRequire("95EVP");

var $a38Ao = parcelRequire("a38Ao");

var $5MHig = parcelRequire("5MHig");
const $8ef490007e1102a8$var$FilterOption = (props)=>{
    const { onChange: onChange, selectedFilters: selectedFilters, filter: filter } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const isSelected = (0, $5uXOq.useMemo)(()=>selectedFilters.has(filter.id), [
        selectedFilters,
        filter
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isSelected) selectedFilters.delete(filter.id);
        else selectedFilters.add(filter.id);
        onChange({
            CUSTOM_FILTER: Array.from(selectedFilters)
        }, createAnalyticsEvent({}));
    }, [
        onChange,
        filter,
        isSelected,
        selectedFilters,
        createAnalyticsEvent
    ]);
    const id = `checkbox-id-${filter.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MGmIU.default), {
        content: filter.description,
        position: "bottom",
        "data-testid": "software-filters.ui.filter-selection-bar.filter-option.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $8ef490007e1102a8$var$maxWidthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a38Ao.default), {
        id: id,
        checked: isSelected,
        onChange: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)));
};
var $8ef490007e1102a8$export$2e2bcd8739ae039 = $8ef490007e1102a8$var$FilterOption;
const $8ef490007e1102a8$var$maxWidthWrapperStyles = (0, $jJ1Sb.xcss)({
    maxWidth: '380px'
});

});
parcelRegister("a38Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $9843dc35bcc8c6ea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $9843dc35bcc8c6ea$var$HiddenCheckbox = (props)=>{
    const { id: id, checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        className: (0, $bwpsq.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _81qx24b2 _ui4mv77o"
        ])
    });
};
var $9843dc35bcc8c6ea$export$2e2bcd8739ae039 = $9843dc35bcc8c6ea$var$HiddenCheckbox;
const $9843dc35bcc8c6ea$var$styles = null;

});

parcelRegister("5MHig", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0acb68a7fed3bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $dd0acb68a7fed3bf$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        ref: ref,
        htmlFor: props.id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            props.className
        ]),
        // eslint-disable-next-line react/no-children-prop
        children: props.children
    }));
var $dd0acb68a7fed3bf$export$2e2bcd8739ae039 = $dd0acb68a7fed3bf$var$Label;
const $dd0acb68a7fed3bf$var$styles = null;

});


parcelRegister("euWQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55c59fbc57ecf3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d55c59fbc57ecf3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterToolBarAriaLabel: {
        "id": "software-filters.filter-selection-bar.filter-tool-bar-aria-label",
        "defaultMessage": "filter tool bar"
    }
});

});



parcelRegister("dvM2i", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $5bcf5abdb1b0ff4e$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $1Klyc = parcelRequire("1Klyc");

var $7BuUr = parcelRequire("7BuUr");

var $cE2Qr = parcelRequire("cE2Qr");


var $3t5QD = parcelRequire("3t5QD");

var $5PP3a = parcelRequire("5PP3a");


var $fSgHa = parcelRequire("fSgHa");
const $5bcf5abdb1b0ff4e$export$95e4a3c3bc863d9c = ({ onToggle: onToggle, isInsightsPanelOpen: isInsightsPanelOpen, boardId: boardId, edition: edition = null })=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isCMPBacklog = (0, $fSgHa.useIsCMPBacklog)();
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const onToggleHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle((0, $c35fd6591a78fffe$export$29d7f2210b16d662));
    }, [
        onToggle
    ]);
    if (!isSupported) return null;
    if (!edition) return null;
    return !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $5PP3a.BacklogInsightsNudgeAsync),
        conditionsToApplyWrapper: (0, $4R6GH.fg)('jsw-perf-backlog-insights-nudge-load') ? nudgeStep === (0, $dbbf68c32d8c4308$export$1c7a80b00ad9619) : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Klyc.BacklogInsightsButton), {
        isSimplifiedProject: !isCMPBacklog,
        isOpen: isInsightsPanelOpen,
        isCompact: false,
        boardId: Number(boardId),
        edition: edition,
        onToggle: onToggleHandler
    });
};

});



parcelRegister("bmw3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6fbf0e6e7fb8e94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a6fbf0e6e7fb8e94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "backlog.header.page-title",
        "defaultMessage": "Backlog"
    },
    beta: {
        "id": "backlog.header.beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("emFUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1375abf298c4955$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $bDZwD = parcelRequire("bDZwD");
const $a1375abf298c4955$var$KeyboardShortcuts = ()=>{
    const keyMap = (0, $bDZwD.useKeyMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap,
        location: "software.backlog.keyboard-shortcuts"
    });
};
var $a1375abf298c4955$export$2e2bcd8739ae039 = $a1375abf298c4955$var$KeyboardShortcuts;

});
parcelRegister("bDZwD", function(module, exports) {

$parcel$export(module.exports, "useKeyMap", () => $58eab6421b7d09c0$export$c83661c96ac791c2);

var $hGgHi = parcelRequire("hGgHi");

var $91LZJ = parcelRequire("91LZJ");

var $d68jx = parcelRequire("d68jx");

var $95EVP = parcelRequire("95EVP");


var $fUHZ2 = parcelRequire("fUHZ2");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $dIdda = parcelRequire("dIdda");

var $guzeq = parcelRequire("guzeq");


var $cik5h = parcelRequire("cik5h");

var $c1MAf = parcelRequire("c1MAf");

var $g4P00 = parcelRequire("g4P00");

var $6GNN7 = parcelRequire("6GNN7");

var $cscVG = parcelRequire("cscVG");

var $4mqko = parcelRequire("4mqko");

var $38qhf = parcelRequire("38qhf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $9Pc1U = parcelRequire("9Pc1U");

var $1z1J7 = parcelRequire("1z1J7");

var $9ZuIF = parcelRequire("9ZuIF");

var $fpDLy = parcelRequire("fpDLy");
const $58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap = {
    [(0, $efaa4b99695f90d6$export$e2291655ce717023)]: 'assignIssueKeyboardShortcut',
    [(0, $efaa4b99695f90d6$export$4834da14f7c856f4)]: 'editIssueLabelsKeyboardShortcut',
    [(0, $efaa4b99695f90d6$export$1303babe27c61a83)]: 'commentIssueKeyboardShortcut'
};
const $58eab6421b7d09c0$var$bentoShortcutKeys = [
    (0, $efaa4b99695f90d6$export$e2291655ce717023),
    (0, $efaa4b99695f90d6$export$4834da14f7c856f4),
    (0, $efaa4b99695f90d6$export$1303babe27c61a83)
];
const $58eab6421b7d09c0$export$c8673ee45279f35b = (key)=>{
    switch(key){
        case 0, $efaa4b99695f90d6$export$e2291655ce717023:
            return (0, $d68jx.externalEditFieldAction)((0, $e9be48d6d2c01760$export$e18419056f3d184a));
        case 0, $efaa4b99695f90d6$export$4834da14f7c856f4:
            return (0, $d68jx.externalEditFieldAction)((0, $e9be48d6d2c01760$export$93605f2a09aa8d26));
        case 0, $efaa4b99695f90d6$export$1303babe27c61a83:
            return (0, $d68jx.externalAddCommentAction)();
        default:
            return null;
    }
};
const $58eab6421b7d09c0$export$c83661c96ac791c2 = ()=>{
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)('backlog');
    const [{ location: location }, { push: push }] = (0, $dIdda.useRouter)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isBulkOperationsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    const onNextIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $cscVG.cardNext)(fireShortcutAnalytics));
    };
    const onPrevIssue = ()=>{
        if (isBulkOperationsInProgress) return;
        dispatch((0, $cscVG.cardPrev)(fireShortcutAnalytics));
    };
    const onAssignToMe = (activeCardId, activeCardAssignee, currentUser)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId)) return;
        const assignee = currentUser?.id === activeCardAssignee?.id ? null : currentUser;
        dispatch((0, $g4P00.assignToMeRequestThrottled)(activeCardId, assignee, fireShortcutAnalytics));
    };
    const onOpenFocusedCard = (activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || isBulkOperationsSidebarActive) return;
        dispatch((0, $4mqko.cardClick)(activeCardId, false, false, false));
        fireShortcutAnalytics({
            key: 'o',
            id: 'viewIssueKeyboardShortcut'
        });
    };
    const onToggleBentoViewForFocusedCard = (detailViewData, activeCardId, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || isBulkOperationsSidebarActive) return;
        const isDetailsViewAlreadyOpen = detailViewData !== null;
        if (detailViewData !== null && detailViewData.cardId === activeCardId) dispatch((0, $38qhf.closeDetailView)());
        else dispatch((0, $38qhf.openDetailView)(activeCardId));
        fireShortcutAnalytics({
            key: 't',
            id: 'toggleDetailsViewKeyboardShortcut',
            attributes: {
                toggled: !isDetailsViewAlreadyOpen ? 'open' : 'closed'
            }
        });
    };
    const onOpenAndFocusBentoField = (key, activeCardId, activeCardKey, isBulkOperationsSidebarActive)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardKey) || isBulkOperationsSidebarActive) return;
        const externalAction = $58eab6421b7d09c0$export$c8673ee45279f35b(key);
        if (!externalAction) return;
        dispatch((0, $38qhf.openDetailView)(activeCardId, externalAction));
        push((0, $cik5h.addSelectedIssueToUrl)(activeCardKey, location));
        if ($58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap[key]) fireShortcutAnalytics({
            key: key,
            id: $58eab6421b7d09c0$var$bentoShortcutsAnalyticsMap[key]
        });
    };
    /*
        Required to create a separate AnalyticsEvent for the cardsMove() action since
        fireShortcutAnalytics is of the wrong type. This analytics event is not used and is simply
        created to satisfy the cardsMove input parameters
    */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const onMoveToTopOrBottomOfContainer = (selectedCards, originCardListId, placement, canUserEditIssues)=>{
        /*
        Adding logic so that if a user only has viewer permissions then they cannot edit the cards
        */ if (!canUserEditIssues || !selectedCards.length || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originCardListId)) return;
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'keyboardShortcut',
            action: 'pressed'
        });
        dispatch((0, $6GNN7.cardsMove)({
            cardListId: originCardListId,
            placement: placement,
            isBetweenLists: false,
            isFromActiveSprint: false,
            cardIds: selectedCards
        }, analyticsEvent));
        const isTop = placement === (0, $guzeq.TOP_OF_LIST);
        const attributes = {
            key: isTop ? 's t' : 's b',
            id: isTop ? 'sendToTopKeyboardShortcut' : 'sendToBottomKeyboardShortcut',
            attributes: {
                isMultiSelect: selectedCards.length > 1
            }
        };
        fireShortcutAnalytics(attributes);
    };
    const selectedCards = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getSelectedCards));
    const selectedCardId = selectedCards.length !== 0 ? selectedCards[selectedCards.length - 1] : undefined;
    const activeCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCard));
    const activeCardKey = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCardKey));
    const detailViewData = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getDetailViewData));
    const activeCardAssignee = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getActiveCardAssignee));
    const currentUserAccount = (0, $c1MAf.useBacklogSelector)((0, $9ZuIF.getCurrentUser));
    const originCardListId = (0, $c1MAf.useBacklogSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedCardId) ? (0, $dGljH.makeGetCardListIdByCardId)(state)(selectedCardId) : undefined);
    const canUserEditIssues = (0, $c1MAf.useBacklogSelector)((0, $1z1J7.canEditIssue));
    const isVersionsEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const isEpicsPanelEnabled = (0, $c1MAf.useBacklogSelector)((0, $9Pc1U.getShowEpicAsPanel));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onEpicsPanelToggle = ()=>{
        if (!isEpicsPanelEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'e',
            id: 'epicPanelToggleKeyboardShortcut'
        });
    };
    const onVersionsPanelToggle = ()=>{
        if (!isVersionsEnabled) return;
        toggleViewSetting({
            boardId: Number(rapidViewId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL,
            view: (0, $a4XJc.View).BACKLOG
        });
        fireShortcutAnalytics({
            key: 'v',
            id: 'versionPanelToggleKeyboardShortcut'
        });
    };
    const keyMap = {
        o: {
            callback: ()=>{
                onOpenFocusedCard(activeCardId, isBulkOperationsInProgress);
            }
        },
        j: {
            callback: onNextIssue
        },
        k: {
            callback: onPrevIssue
        },
        t: {
            callback: ()=>{
                onToggleBentoViewForFocusedCard(detailViewData, activeCardId, isBulkOperationsInProgress);
            }
        },
        i: {
            callback: ()=>{
                onAssignToMe(activeCardId, activeCardAssignee, currentUserAccount);
            }
        },
        's t': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $guzeq.TOP_OF_LIST), canUserEditIssues);
            }
        },
        's b': {
            callback: ()=>{
                onMoveToTopOrBottomOfContainer(selectedCards, originCardListId, (0, $guzeq.BOTTOM_OF_LIST), canUserEditIssues);
            }
        },
        e: {
            callback: onEpicsPanelToggle
        },
        v: {
            callback: onVersionsPanelToggle
        }
    };
    $58eab6421b7d09c0$var$bentoShortcutKeys.forEach((key)=>{
        keyMap[key] = {
            callback: ()=>{
                onOpenAndFocusBentoField(key, activeCardId, activeCardKey, isBulkOperationsInProgress);
            }
        };
    });
    return keyMap;
};

});
parcelRegister("d68jx", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $9aec05de8de4c511$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $9aec05de8de4c511$export$c70036fd42f0ed99);
$parcel$export(module.exports, "externalAssignToMeAction", () => $9aec05de8de4c511$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $9aec05de8de4c511$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $9aec05de8de4c511$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $9aec05de8de4c511$export$78aa3108fdac0ac3);

var $akbnA = parcelRequire("akbnA");

var $8dFNe = parcelRequire("8dFNe");
const $9aec05de8de4c511$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $9aec05de8de4c511$export$316a97ea1161ac5a = (type)=>({
        type: $9aec05de8de4c511$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $9aec05de8de4c511$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $9aec05de8de4c511$export$5d020593666779fc = (fieldId)=>({
        type: $9aec05de8de4c511$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $9aec05de8de4c511$export$c70036fd42f0ed99 = ()=>({
        type: $9aec05de8de4c511$export$35aff3ed3a26081d
    });
const $9aec05de8de4c511$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $9aec05de8de4c511$export$8f1d4f64b4b74146 = ()=>({
        type: $9aec05de8de4c511$export$ae8a4274289f40bb
    });
const $9aec05de8de4c511$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $9aec05de8de4c511$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $9aec05de8de4c511$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $9aec05de8de4c511$export$e3035a7e8a739325 = ()=>({
        type: $9aec05de8de4c511$export$c60815f29b5cfb6d
    });
const $9aec05de8de4c511$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $9aec05de8de4c511$export$35aff3ed3a26081d:
            return (0, $8dFNe.addCommentFormExpand)();
        case $9aec05de8de4c511$export$ae8a4274289f40bb:
            return $9aec05de8de4c511$export$e3035a7e8a739325();
        case $9aec05de8de4c511$export$256eddbefbf4b2ce:
            return $9aec05de8de4c511$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $9aec05de8de4c511$export$5834f946a995a2ca:
            return (0, $akbnA.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});

parcelRegister("8dFNe", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $17d2ae7757c211f3$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $17d2ae7757c211f3$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $17d2ae7757c211f3$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $17d2ae7757c211f3$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $17d2ae7757c211f3$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $17d2ae7757c211f3$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $17d2ae7757c211f3$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $17d2ae7757c211f3$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $17d2ae7757c211f3$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $17d2ae7757c211f3$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $17d2ae7757c211f3$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $17d2ae7757c211f3$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $17d2ae7757c211f3$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $17d2ae7757c211f3$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $17d2ae7757c211f3$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $17d2ae7757c211f3$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $17d2ae7757c211f3$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $17d2ae7757c211f3$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $17d2ae7757c211f3$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $17d2ae7757c211f3$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $17d2ae7757c211f3$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $17d2ae7757c211f3$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $17d2ae7757c211f3$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $17d2ae7757c211f3$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $17d2ae7757c211f3$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $17d2ae7757c211f3$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $17d2ae7757c211f3$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $17d2ae7757c211f3$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $17d2ae7757c211f3$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $17d2ae7757c211f3$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $17d2ae7757c211f3$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$32f9b2d50e470721);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $17d2ae7757c211f3$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $17d2ae7757c211f3$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $17d2ae7757c211f3$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $17d2ae7757c211f3$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $17d2ae7757c211f3$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $17d2ae7757c211f3$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_VALUE", () => $17d2ae7757c211f3$export$66f932c47f92031b);
$parcel$export(module.exports, "setCommentValue", () => $17d2ae7757c211f3$export$ef0e64b81798a6f2);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $17d2ae7757c211f3$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $17d2ae7757c211f3$export$1dda1a9962bdad5f);
$parcel$export(module.exports, "REPLY_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$d5ede80029a6397e);
$parcel$export(module.exports, "replyCommentBegin", () => $17d2ae7757c211f3$export$f1a18b29fe2549e9);
$parcel$export(module.exports, "REPLY_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$25a7e12fd2d783a3);
$parcel$export(module.exports, "replyCommentUpdate", () => $17d2ae7757c211f3$export$ecea73f83f50bca0);
$parcel$export(module.exports, "REPLY_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$f87250d72435d6b4);
$parcel$export(module.exports, "replyCommentCancel", () => $17d2ae7757c211f3$export$9dc83707765a3fa8);

var $fOGZN = parcelRequire("fOGZN");

var $7Vj9c = parcelRequire("7Vj9c");
const $17d2ae7757c211f3$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $17d2ae7757c211f3$export$2b19aad250b973d = ()=>({
        type: $17d2ae7757c211f3$export$71d398107e783d48
    });
const $17d2ae7757c211f3$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $17d2ae7757c211f3$export$835c1049633b19d4 = ()=>({
        type: $17d2ae7757c211f3$export$85ff14da4a33157b
    });
const $17d2ae7757c211f3$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $17d2ae7757c211f3$export$cbb43c6e2782f713 = ()=>({
        type: $17d2ae7757c211f3$export$2a743018e170b1c5
    });
const $17d2ae7757c211f3$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $17d2ae7757c211f3$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $17d2ae7757c211f3$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $17d2ae7757c211f3$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $17d2ae7757c211f3$export$854252150d2da91c = (optimisticId)=>({
        type: $17d2ae7757c211f3$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $17d2ae7757c211f3$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $17d2ae7757c211f3$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $17d2ae7757c211f3$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$180890d02f5569ee = (comment, analyticsEvent)=>({
        type: $17d2ae7757c211f3$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag, parentId)=>({
        type: $17d2ae7757c211f3$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $fOGZN.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                eventOccurredAt: eventOccurredAt
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() && fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            ...(0, $7Vj9c.isJsmTimelineEnabled)() ? {
                triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
            } : {}
        },
        meta: meta
    });
const $17d2ae7757c211f3$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$c9acef2c154290a0 = (payload)=>({
        type: $17d2ae7757c211f3$export$181640cafd83e422,
        payload: payload
    });
const $17d2ae7757c211f3$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$6971a9cf19e7bff0 = (optimisticId, isNewComment, parentId)=>({
        type: $17d2ae7757c211f3$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$89824d2d0989262b = ()=>({
        type: $17d2ae7757c211f3$export$8759655e9c2c6d63
    });
const $17d2ae7757c211f3$export$ccf1730684d88fc7 = ()=>({
        type: $17d2ae7757c211f3$export$d55056f931f514de
    });
const $17d2ae7757c211f3$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$a06e5ade6af52efd = (loadedComments)=>({
        type: $17d2ae7757c211f3$export$1c31d581a6bc6013,
        payload: loadedComments
    });
const $17d2ae7757c211f3$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$c3ffb947d06519d4 = ()=>({
        type: $17d2ae7757c211f3$export$b0ac6cc6abb21a3c
    });
const $17d2ae7757c211f3$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$4805c80809193e58 = (commentId)=>({
        type: $17d2ae7757c211f3$export$47acda4b8d2cc300,
        payload: commentId
    });
const $17d2ae7757c211f3$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$248225c0816f92b1 = (loadedComments)=>({
        type: $17d2ae7757c211f3$export$f72e87877cdff1d3,
        payload: loadedComments
    });
const $17d2ae7757c211f3$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$2f204bc36c94722d = ()=>({
        type: $17d2ae7757c211f3$export$5ae0e03aaca20486
    });
const $17d2ae7757c211f3$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$b59e3ef618f3f5a4 = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $17d2ae7757c211f3$export$76f4fdc85b3c4983 = (id)=>({
        type: $17d2ae7757c211f3$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$b42a5c3d327fad1a = (id)=>({
        type: $17d2ae7757c211f3$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $17d2ae7757c211f3$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $17d2ae7757c211f3$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $17d2ae7757c211f3$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $17d2ae7757c211f3$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $17d2ae7757c211f3$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$ed74b3a5f1c036c2 = (id, analyticsEvent, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            hasReplies: hasReplies,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$88e6cb2a45e9c67b = (id, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT),
            parentId: parentId,
            hasReplies: hasReplies
        }
    });
const $17d2ae7757c211f3$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$f1282c6c2bcc0a44 = (id)=>({
        type: $17d2ae7757c211f3$export$17bfad3338f45e82,
        payload: id
    });
const $17d2ae7757c211f3$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $17d2ae7757c211f3$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $17d2ae7757c211f3$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $17d2ae7757c211f3$export$d7ed3c847a4656f7 = (isInProgress)=>({
        type: $17d2ae7757c211f3$export$ec38bcd617424c64,
        payload: {
            isInProgress: isInProgress
        }
    });
const $17d2ae7757c211f3$export$66f932c47f92031b = 'SET_COMMENT_VALUE';
const $17d2ae7757c211f3$export$ef0e64b81798a6f2 = (id, value)=>({
        type: $17d2ae7757c211f3$export$66f932c47f92031b,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $17d2ae7757c211f3$export$1dda1a9962bdad5f = (status)=>({
        type: $17d2ae7757c211f3$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });
const $17d2ae7757c211f3$export$d5ede80029a6397e = 'REPLY_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$f1a18b29fe2549e9 = (commentId, authorId, authorDisplayName, visibility)=>({
        type: $17d2ae7757c211f3$export$d5ede80029a6397e,
        payload: {
            commentId: commentId,
            authorId: authorId,
            authorDisplayName: authorDisplayName,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$25a7e12fd2d783a3 = 'REPLY_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ecea73f83f50bca0 = (parentId, value)=>({
        type: $17d2ae7757c211f3$export$25a7e12fd2d783a3,
        payload: {
            parentId: parentId,
            value: value
        }
    });
const $17d2ae7757c211f3$export$f87250d72435d6b4 = 'REPLY_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$9dc83707765a3fa8 = (parentId)=>({
        type: $17d2ae7757c211f3$export$f87250d72435d6b4,
        payload: {
            parentId: parentId
        }
    });

});
parcelRegister("7Vj9c", function(module, exports) {

$parcel$export(module.exports, "isJsmTimelineEnabled", () => $bc9eb3af4e788bdb$export$575e1bf822db15b5);

var $co1wz = parcelRequire("co1wz");
const $bc9eb3af4e788bdb$export$575e1bf822db15b5 = ()=>(0, $co1wz.ff)('jsm-timelines-phase-2_70gja', false);

});



const $efaa4b99695f90d6$export$e2291655ce717023 = 'a';
const $efaa4b99695f90d6$export$4834da14f7c856f4 = 'l';
const $efaa4b99695f90d6$export$1303babe27c61a83 = 'm';



parcelRegister("b75A0", function(module, exports) {

$parcel$export(module.exports, "default", () => $03da30a481e2d472$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lkDqR = parcelRequire("lkDqR");

var $jA0eS = parcelRequire("jA0eS");

var $306J7 = parcelRequire("306J7");

var $gaIrH = parcelRequire("gaIrH");

var $kw5KD = parcelRequire("kw5KD");


var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $74oBv = parcelRequire("74oBv");

var $fC5rN = parcelRequire("fC5rN");

var $8RslB = parcelRequire("8RslB");

var $auGCU = parcelRequire("auGCU");

var $1fF8a = parcelRequire("1fF8a");

var $aVDTD = parcelRequire("aVDTD");

var $cdsQH = parcelRequire("cdsQH");

var $bspMX = parcelRequire("bspMX");

var $8U9FQ = parcelRequire("8U9FQ");

var $26tBB = parcelRequire("26tBB");

var $jtyx2 = parcelRequire("jtyx2");

var $hDscR = parcelRequire("hDscR");

var $e2cKU = parcelRequire("e2cKU");

var $1vE6g = parcelRequire("1vE6g");

var $fLCrV = parcelRequire("fLCrV");
const $03da30a481e2d472$var$Modals = ()=>{
    const isModalOpen = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.makeIsModalOpen));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isCardDeleteModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$87c7cb14aa706e2d));
    const isMoveCardsActiveSprintModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$86a0c18887a92eae));
    const isAssignIssueParentModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$9d5b8103d4fbbb34));
    const isGlobalIssueCreateModal = isModalOpen((0, $b107c54ec82f76f2$export$55cae6fd3c958bc5));
    const isSplitIssueModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$77e94846ed2f57d7));
    const isSelectTransitionsModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$dcb8eb3e585ecde));
    const isFlagWithCommentModalOpen = isModalOpen((0, $b107c54ec82f76f2$export$34f52cb2089ddc40));
    const hasAnyIssueTypeWithRequiredFields = (0, $c1MAf.useBacklogSelector)((0, $74oBv.getHasAnyIssueTypeWithRequireFields));
    const shouldShowScrumOnboardingModal = (0, $306J7.useShouldShowScrumOnboardingModal)();
    const GlobalIssueCreateModalComponent = isCompanyManaged ? (0, $jtyx2.default) : (0, $26tBB.default);
    const shouldShowWelcomeModal = (0, $kw5KD.useShouldShowWelcomeModal)('backlog');
    return(// div is required here, otherwise backlog layout breaks when a modal pops up
    // eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, shouldShowScrumOnboardingModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jA0eS.AsyncScrumOnboardingModal), null), isCardDeleteModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auGCU.default), null), isMoveCardsActiveSprintModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2cKU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, isAssignIssueParentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RslB.default), null)), (hasAnyIssueTypeWithRequiredFields || isGlobalIssueCreateModal) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GlobalIssueCreateModalComponent, null), isSplitIssueModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fLCrV.default), null), isSelectTransitionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vE6g.SelectTransitionsModal), null), isFlagWithCommentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8U9FQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1fF8a.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aVDTD.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cdsQH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bspMX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDscR.IssueTransitionModal), null), shouldShowWelcomeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gaIrH.AsyncWelcomeModal), {
        source: "backlog"
    })));
};
var $03da30a481e2d472$export$2e2bcd8739ae039 = $03da30a481e2d472$var$Modals;

});
parcelRegister("jA0eS", function(module, exports) {

$parcel$export(module.exports, "AsyncScrumOnboardingModal", () => $68afb034032af6be$export$744c5f72d1694510);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68afb034032af6be$var$LazyScrumOnboardingModal = (0, $hPtZI.lazy)(()=>(parcelRequire("4zQUu")).then(({ ScrumOnboardingModal: ScrumOnboardingModal })=>ScrumOnboardingModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/scrum-onboarding-modal/index.tsx"
});
const $68afb034032af6be$export$744c5f72d1694510 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncScrumOnboardingModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-modals-scrum-onboarding",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68afb034032af6be$var$LazyScrumOnboardingModal, null)));

});
parcelRegister("4zQUu", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("cIVMr")
]).then(()=>parcelRequire('8aL25'));

});


parcelRegister("306J7", function(module, exports) {

$parcel$export(module.exports, "useShouldShowScrumOnboardingModal", () => $05ee9f68eca484b6$export$b752c215b94b059e);

var $5uXOq = parcelRequire("5uXOq");

var $eNf8a = parcelRequire("eNf8a");


var $cE2Qr = parcelRequire("cE2Qr");
const $05ee9f68eca484b6$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('onboarding-core');
const $05ee9f68eca484b6$export$b752c215b94b059e = ()=>{
    const [shouldShowScrumOnBoardingExperience] = (0, $cE2Qr.useShouldShowScrumOnboardingExperience)();
    const sessionStorageVal = (0, $5uXOq.useMemo)(()=>$05ee9f68eca484b6$var$sessionStorageProvider.get((0, $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f)), []);
    return shouldShowScrumOnBoardingExperience !== false && sessionStorageVal !== undefined;
};

});

parcelRegister("gaIrH", function(module, exports) {

$parcel$export(module.exports, "AsyncWelcomeModal", () => $469ada65feba09b1$export$d08881a6c29dfdb2);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $469ada65feba09b1$var$LazyWelcomeModal = (0, $hPtZI.lazy)(()=>(parcelRequire("kVfJo")).then(({ WelcomeModal: WelcomeModal })=>WelcomeModal), {
    moduleId: "./src/packages/software/onboarding-modals/src/ui/welcome-modal/index.tsx"
});
const $469ada65feba09b1$export$d08881a6c29dfdb2 = ({ source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "async-onboarding-welcome-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: "asyncWelcomeModalComponent",
        fallback: "unmount",
        packageName: "jiraSoftwareOnboardingModals",
        teamName: "jlove-makkuro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-modals-welcome-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($469ada65feba09b1$var$LazyWelcomeModal, {
        source: source
    }))));
};

});
parcelRegister("kVfJo", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("fgoJG")
]).then(()=>parcelRequire('68yeS'));

});


parcelRegister("kw5KD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowModalBasedOnSessionStorage", () => $37bcf797fd2f572d$export$b39cbd941f378bec);
$parcel$export(module.exports, "useShouldShowWelcomeModal", () => $37bcf797fd2f572d$export$b01115c2f75a04f8);

var $5uXOq = parcelRequire("5uXOq");


var $9yQlD = parcelRequire("9yQlD");

var $i4CeP = parcelRequire("i4CeP");
const $37bcf797fd2f572d$export$b39cbd941f378bec = ()=>{
    const shouldShowModalBasedOnSessionStorage = (0, $5uXOq.useMemo)(()=>{
        const sessionStorageVal = (0, $9yQlD.sessionStorage).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
        if (sessionStorageVal === undefined) return false;
        return true;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Remove the session storage value to prevent the modal showing again
        (0, $9yQlD.sessionStorage).remove((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
    }, []);
    return shouldShowModalBasedOnSessionStorage;
};
const $37bcf797fd2f572d$export$b01115c2f75a04f8 = (source)=>{
    const canShowNudgeTour = (0, $i4CeP.useCanShowNudgeTour)();
    const sessionStorageVal = (0, $5uXOq.useMemo)(()=>(0, $9yQlD.sessionStorage).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)), []);
    if (sessionStorageVal === undefined) return false;
    return canShowNudgeTour(source);
};

});
parcelRegister("i4CeP", function(module, exports) {

$parcel$export(module.exports, "useCanShowNudgeTour", () => $f9e2cd0a6b3c1f13$export$3381da528a252680);

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $cE2Qr = parcelRequire("cE2Qr");
const $f9e2cd0a6b3c1f13$export$3381da528a252680 = ()=>{
    const [completedTaskList] = (0, $cE2Qr.useCompletedTaskList)();
    const [shouldShowScrumOnboardingExperience] = (0, $cE2Qr.useShouldShowScrumOnboardingExperience)();
    const [shouldShowOnboardingKanbanTour] = (0, $cE2Qr.useShouldShowOnboardingKanbanTour)();
    const shouldShowOnboardingScrumTour = shouldShowScrumOnboardingExperience === true && // edge case for KURO-2088: After welcome modal failed to load, users complete welcome tour by themselves. Welcome modal should be skipped to load on refreshment.
    !completedTaskList.includes((0, $8Bc5A.SCRUM_ONBOARDING_TASK));
    return (source)=>{
        switch(source){
            case 'board':
                return shouldShowOnboardingKanbanTour;
            case 'backlog':
                return shouldShowOnboardingScrumTour;
            case 'timeline':
                // display if eligible for either board/backlog scenarios
                return shouldShowOnboardingKanbanTour || shouldShowOnboardingScrumTour;
            case 'getStarted':
                if ((0, $4R6GH.fg)('jira_one_screen_onboarding_feature_gate')) return true;
                return false;
            default:
                return false;
        }
    };
};

});


parcelRegister("8RslB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc15ceffc4eae2e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l4kDS = parcelRequire("l4kDS");

var $hPtZI = parcelRequire("hPtZI");



var $c1MAf = parcelRequire("c1MAf");

var $et6P7 = parcelRequire("et6P7");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $f9Swb = parcelRequire("f9Swb");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fc15ceffc4eae2e7$var$AssignIssueParentModal = (0, $hPtZI.lazy)(()=>(parcelRequire("3s8jl")), {
    moduleId: "./src/packages/assign-issue-parent-modal/src/index.tsx"
});
function $fc15ceffc4eae2e7$export$2e2bcd8739ae039() {
    const modalData = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData));
    const issues = (0, $c1MAf.useBacklogSelector)((state)=>modalData && modalData.type === (0, $b107c54ec82f76f2$export$9d5b8103d4fbbb34) ? (0, $dGljH.partialCardsFromCardIdsSelector)(state)(modalData.payload.cardIds) : []);
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.partialIssueParentSelector));
    const issueParentTypeIds = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentTypeIdsSelector));
    const issueHierarchyLevel = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueHierarchyLevelSelector))();
    const parentIssueTypeName = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.firstParentIssueTypeNameSelector));
    const firstLevelHierarchyName = (0, $c1MAf.useBacklogSelector)((0, $f9Swb.getFirstLevelHierarchyName));
    const baseUrl = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getBaseUrl));
    const currentProjectId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.projectIdSelector));
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const onClose = (0, $c1MAf.useBacklogActionCreator)((0, $5Eoed.closeModal));
    const label = isCompanyManaged ? firstLevelHierarchyName : parentIssueTypeName;
    const onSubmit = (cards, parentId, issueParent, requestPromise)=>{
        dispatch((0, $et6P7.cardsParentSetOptimistic)({
            cards: // @ts-expect-error - TS2322 - Type 'Issue[]' is not assignable to type 'PartialCard[]'.
            cards,
            parentId: // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'number | null'.
            parentId,
            requestPromise: requestPromise
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l4kDS.AssignIssueParentModalBoundary), {
        packageName: (0, $a9c483c0d986286a$export$dfd208682d29484c)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc15ceffc4eae2e7$var$AssignIssueParentModal, {
        issues: issues,
        issueParents: issueParents,
        issueParentTypeIds: issueParentTypeIds,
        issueHierarchyLevel: issueHierarchyLevel,
        parentIssueTypeName: label,
        baseUrl: baseUrl,
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        onClose: onClose,
        onSubmit: onSubmit,
        isSimplifiedProject: !isCompanyManaged
    }));
}

});
parcelRegister("l4kDS", function(module, exports) {

$parcel$export(module.exports, "AssignIssueParentModalBoundary", () => $965b0f9088163c5f$export$eb6171d83c7b32bb);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");
const $965b0f9088163c5f$export$eb6171d83c7b32bb = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "assign-issue-parent-modal",
        ...props
    }, children);

});

parcelRegister("3s8jl", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("lWxZl").then(()=>parcelRequire('3lI7K'));

});


parcelRegister("auGCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e338eb9297ead1c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $ezPyr = parcelRequire("ezPyr");
var $bvt08 = parcelRequire("bvt08");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $1ppIJ = parcelRequire("1ppIJ");

var $dCm1o = parcelRequire("dCm1o");


var $c1MAf = parcelRequire("c1MAf");

var $legw4 = parcelRequire("legw4");

var $5Eoed = parcelRequire("5Eoed");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");

var $hNfht = parcelRequire("hNfht");
function $e338eb9297ead1c3$var$CardDeleteModal() {
    const card = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$87c7cb14aa706e2d)) return null;
        const { payload: { cardId: cardId } } = modalData;
        return cardId ? (0, $dGljH.getCards)(state)[String(cardId)] : null;
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onDelete = ()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        card && dispatch((0, $legw4.cardDeleteRequest)({
            cardId: card.id
        }));
        dispatch((0, $5Eoed.closeModal)());
    };
    const onClose = ()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $5Eoed.closeModal)());
    };
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!card) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), {
        appearance: "danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $hNfht.default).title,
        values: {
            cardKey: card.key
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hNfht.default).deleteDataPermanentlyWarningIssueTermRefresh : (0, $hNfht.default).deleteDataPermanentlyWarning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hNfht.default).resolveOrCloseInsteadIssueTermRefresh : (0, $hNfht.default).resolveOrCloseInstead)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $hNfht.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $hNfht.default).delete))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "danger",
        onClick: onDelete
    }, formatMessage((0, $hNfht.default).delete)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $hNfht.default).cancel))))));
}
function $e338eb9297ead1c3$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "deleteCard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e338eb9297ead1c3$var$CardDeleteModal, null));
}

});
parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $dOHxT = parcelRequire("dOHxT");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
        shouldReturnFocus: returnFocus,
        ...rest
    });
};

});

parcelRegister("hNfht", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fbaad05f507ca53$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6fbaad05f507ca53$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "backlog.modals.card-delete-modal.delete",
        "defaultMessage": "Delete"
    },
    cancel: {
        "id": "backlog.modals.card-delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    title: {
        "id": "backlog.modals.card-delete-modal.title",
        "defaultMessage": "Delete {cardKey}?"
    },
    deleteDataPermanentlyWarning: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    resolveOrCloseInstead: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    },
    deleteDataPermanentlyWarningIssueTermRefresh: {
        "id": "backlog.modals.card-delete-modal.delete-data-permanently-warning-issue-term-refresh",
        "defaultMessage": "You're about to permanently delete this issue, its comments and attachments, and all of its data."
    },
    resolveOrCloseInsteadIssueTermRefresh: {
        "id": "backlog.modals.card-delete-modal.resolve-or-close-instead-issue-term-refresh",
        "defaultMessage": "If you're not sure, you can resolve or close this issue instead."
    }
});

});


parcelRegister("1fF8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc8489a54e5d3428$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l25oY = parcelRequire("l25oY");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");
const $cc8489a54e5d3428$var$entryPointParams = {};
function $cc8489a54e5d3428$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $l25oY.retroCreateModalEntryPoint), $cc8489a54e5d3428$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCreateRetroModal) {
            actions.setLoadCreateRetroModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCreateRetroModal,
        actions,
        entryPointActions
    ]);
    const props = (0, $5uXOq.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-create-modal",
        packageName: "jira-confluence-sprint-retro-create-modal",
        teamName: "helios-headcoach",
        runtimeProps: props
    });
}

});
parcelRegister("l25oY", function(module, exports) {

$parcel$export(module.exports, "retroCreateModalEntryPoint", () => $fb012128bdf4d96d$export$5475eb8732086597);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $fb012128bdf4d96d$export$5475eb8732086597 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("g3H63")), {
        moduleId: "5e0982c9"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("g3H63", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("iS7DA")
]).then(()=>parcelRequire('dh6oC'));

});



parcelRegister("aVDTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $df7708cdab79f2fa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kyDyy = parcelRequire("kyDyy");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");


const $df7708cdab79f2fa$var$entryPointParams = {};
function $df7708cdab79f2fa$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $kyDyy.confluenceCrossFlowModalEntryPoint), $df7708cdab79f2fa$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCrossFlowModal) {
            actions.setLoadCrossFlowModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossFlowModal,
        entryPointActions,
        actions
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        actions.resetState();
    }, [
        actions
    ]);
    const onComplete = ({ success: success })=>{
        if (success) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-flow-modal",
        packageName: "jira-confluence-cross-flow-modal",
        teamName: "Confluence - Better Together",
        runtimeProps: {
            onClose: onClose,
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $3ca5d8c2ff27b2b4$export$d7568f1916ebda24),
            crossFlowSource: (0, $1fcd698cd2006024$export$ae844fca2858b7c4)
        }
    }));
}

});
parcelRegister("kyDyy", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossFlowModalEntryPoint", () => $d88c1fbe7cc0c1c3$export$d147ed79220ebf4);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $d88c1fbe7cc0c1c3$export$d147ed79220ebf4 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("lelu4")), {
        moduleId: "75f5e774"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("lelu4", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("kgavg")
]).then(()=>parcelRequire('6qOOt'));

});


const $1fcd698cd2006024$export$ae844fca2858b7c4 = 'Retro';
const $1fcd698cd2006024$export$bda5d6727c30cf36 = 'JiraIssueCreateContent';

const $3ca5d8c2ff27b2b4$export$f19c4e560a68c416 = 'jiraIssueView';
const $3ca5d8c2ff27b2b4$export$2e6ff5d53a830129 = 'jiraIssueViewLinkedMentionedPage';
const $3ca5d8c2ff27b2b4$export$2d990bc8cd668ca1 = 'jiraIssueViewQuickAddItem';
const $3ca5d8c2ff27b2b4$export$d3566448206b58e = 'jiraIssueViewLinkConfluencePage';
const $3ca5d8c2ff27b2b4$export$c257b3d4e328f4ba = 'jiraIssueViewLengthyDescriptionMessage';
const $3ca5d8c2ff27b2b4$export$d7568f1916ebda24 = 'jiraSoftwareBacklogEndOfSprintRetro';
const $3ca5d8c2ff27b2b4$export$79e2b0aa41c936ad = 'jiraIssueAutoLinkContentOnLinkPaste';


parcelRegister("cdsQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eb28957b2a9cbe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3zRec = parcelRequire("3zRec");


var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");
const $b7eb28957b2a9cbe$var$entryPointParams = {};
const $b7eb28957b2a9cbe$var$CROSS_JOIN_SOURCE = 'Retro';
function $b7eb28957b2a9cbe$export$2e2bcd8739ae039() {
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3zRec.confluenceCrossJoinModalEntryPoint), $b7eb28957b2a9cbe$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.loadCrossJoinModal) {
            actions.setLoadCrossJoinModal(false);
            entryPointActions.load();
        }
    }, [
        state.loadCrossJoinModal,
        entryPointActions,
        actions
    ]);
    const onComplete = (0, $5uXOq.useCallback)(({ directJoinSuccess: directJoinSuccess })=>{
        if (directJoinSuccess) actions.setLoadCreateRetroModal(true);
    }, [
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-cross-join-modal",
        packageName: "jira-confluence-cross-join-modal",
        teamName: "Confluence - Better Together",
        runtimeProps: {
            onComplete: onComplete,
            embeddedConfluenceSource: (0, $1e471926441c6303$export$5cdbf483845e61aa),
            crossJoinSource: $b7eb28957b2a9cbe$var$CROSS_JOIN_SOURCE
        }
    });
}

});
parcelRegister("3zRec", function(module, exports) {

$parcel$export(module.exports, "confluenceCrossJoinModalEntryPoint", () => $d64df6cf66d1da31$export$6b94fb5b310ef3e1);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $d64df6cf66d1da31$export$6b94fb5b310ef3e1 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("1dQCR")), {
        moduleId: "8339c23d"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("1dQCR", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("jrcap")
]).then(()=>parcelRequire('6NZ6z'));

});


const $1e471926441c6303$export$5cdbf483845e61aa = 'jiraSprintCompletion';


parcelRegister("bspMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a03ba590f4c178$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6W0YL = parcelRequire("6W0YL");

var $9LoyA = parcelRequire("9LoyA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");
const $57a03ba590f4c178$var$entryPointParams = {};
function $57a03ba590f4c178$export$2e2bcd8739ae039() {
    const projectKey = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectKey));
    const rapidViewId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const [state, actions] = (0, $9LoyA.useRetros)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6W0YL.retroPublishedModalEntryPoint), $57a03ba590f4c178$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.isRetroPublished) {
            entryPointActions.load();
            actions.setIsRetroPublished(false);
        }
    }, [
        state.isRetroPublished,
        entryPointActions,
        actions
    ]);
    const props = (0, $5uXOq.useMemo)(()=>({
            projectKey: projectKey,
            rapidViewId: rapidViewId,
            isCompanyManaged: isCompanyManaged
        }), [
        projectKey,
        rapidViewId,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        id: "jira-confluence-sprint-retro-published-modal",
        packageName: "jira-confluence-sprint-retro-published-modal",
        teamName: "helios-headcoach",
        runtimeProps: props
    }));
}

});
parcelRegister("6W0YL", function(module, exports) {

$parcel$export(module.exports, "retroPublishedModalEntryPoint", () => $f42b35e4ddb001d5$export$46f503ee10ceb3cd);

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $f42b35e4ddb001d5$export$46f503ee10ceb3cd = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("3cHIH")), {
        moduleId: "250e60a4"
    }),
    getPreloadProps: (_params)=>({
            queries: {}
        })
});

});
parcelRegister("3cHIH", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("5Bu9O").then(()=>parcelRequire('751pC'));

});



parcelRegister("8U9FQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $378eb224ec1a1c3d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");


var $c1MAf = parcelRequire("c1MAf");

var $aKajY = parcelRequire("aKajY");

var $5Eoed = parcelRequire("5Eoed");

var $fC5rN = parcelRequire("fC5rN");

var $8v1yQ = parcelRequire("8v1yQ");
const $378eb224ec1a1c3d$var$useFlagWithCommentState = ()=>({
        modalData: (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData))
    });
const $378eb224ec1a1c3d$var$useFlagWithCommentActions = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    /*
      Should only need to create this once since the modal is closed
      by either confirm or cancel
    */ const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent
    ]);
    const onFlagWithComment = (0, $5uXOq.useCallback)((cards, flag, comment)=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'confirmButton');
        const requestAnalyticsEvent = createAnalyticsEvent({
            actionSubject: 'cards',
            action: 'flagged'
        });
        dispatch((0, $aKajY.cardsFlagWithCommentRequest)({
            cards: cards,
            flag: flag,
            comment: comment
        }, requestAnalyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        modalAnalyticsEvent,
        createAnalyticsEvent
    ]);
    return {
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    };
};
const $378eb224ec1a1c3d$var$FlagWithComment = ()=>{
    const { modalData: modalData } = $378eb224ec1a1c3d$var$useFlagWithCommentState();
    const { onClose: onClose, onFlagWithComment: onFlagWithComment } = $378eb224ec1a1c3d$var$useFlagWithCommentActions();
    if (modalData?.type !== (0, $b107c54ec82f76f2$export$34f52cb2089ddc40)) return null;
    const { flagAction: flagAction, cards: cards } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8v1yQ.FlagWithCommentRenderer), {
        flagAction: flagAction,
        cards: cards,
        onClose: onClose,
        onFlagWithComment: onFlagWithComment
    });
};
function $378eb224ec1a1c3d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "flagCardsWithCommentBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($378eb224ec1a1c3d$var$FlagWithComment, null));
}

});
parcelRegister("8v1yQ", function(module, exports) {

$parcel$export(module.exports, "FlagWithCommentRenderer", () => $77959e071dc6842c$export$5bed0e93a95d2e33);
// eslint-disable-next-line jira/restricted/react-lazy

var $5uXOq = parcelRequire("5uXOq");

var $1iaoS = parcelRequire("1iaoS");

var $lkDqR = parcelRequire("lkDqR");

var $39xOx = parcelRequire("39xOx");

const $77959e071dc6842c$var$FlagWithComment = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("47u60")), {
    moduleId: "./src/packages/software/add-comment-on-flag-action/src/ui/index.tsx"
});
const $77959e071dc6842c$export$5bed0e93a95d2e33 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "backlog-flag-with-comment-modal",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1iaoS.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($77959e071dc6842c$var$FlagWithComment, props))));

});
parcelRegister("47u60", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("dsiAd"),
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("hPzOn"),
    $6fhBS("gXwUo")
]).then(()=>parcelRequire('dbKJB'));

});



parcelRegister("26tBB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f9a0c3535072e5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $a0E5R = parcelRequire("a0E5R");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $2TOwr = parcelRequire("2TOwr");



var $c1MAf = parcelRequire("c1MAf");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $d3kOO = parcelRequire("d3kOO");

var $fC5rN = parcelRequire("fC5rN");
const $18f9a0c3535072e5$var$GlobalIssueCreate = ()=>{
    const data = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5)) return {
            fields: null,
            disableCreationSuccessFlag: true,
            sourceName: (0, $a9c483c0d986286a$export$840e3848643f7781)
        };
        return {
            fields: (0, $d3kOO.getPrefilledFieldsFromInputs)(state),
            disableCreationSuccessFlag: true,
            sourceName: (0, $a9c483c0d986286a$export$840e3848643f7781),
            submitErrorMessage: (0, $d3kOO.getSubmitErrorMessage)(state),
            sessionId: (0, $d3kOO.getSessionIdFromInputs)(state)
        };
    });
    const cloudId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getCloudId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const closeModalAction = (0, $c1MAf.useBacklogActionCreator)((0, $5Eoed.closeModal));
    const onCreateSuccess = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueWithRequiredFields created', {
            createdMultipleIssues: analyticsEvent.payload.createdMultipleIssues
        });
    }, [
        closeModalAction
    ]);
    const onCancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        closeModalAction();
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'issueWithRequiredFields cancelled', {});
    }, [
        closeModalAction
    ]);
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $2TOwr.default));
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: (0, $dXq4S.createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'board',
                resourceId: String(boardId)
            })
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        boardId,
        cloudId,
        loadQuery
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0E5R.default), {
        ...data,
        onCancel: onCancel,
        onCreateSuccess: onCreateSuccess,
        queryReference: queryReference
    }) : null;
};
var $18f9a0c3535072e5$export$2e2bcd8739ae039 = $18f9a0c3535072e5$var$GlobalIssueCreate;

});
parcelRegister("a0E5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $9375c4c02f139011$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9375c4c02f139011$var$LazyGICTrigger = (0, $hPtZI.lazy)(()=>(parcelRequire("5FwPO")), {
    moduleId: "./src/packages/software/jsw-adapted-global-issue-create-trigger/src/index.tsx"
});
const $9375c4c02f139011$var$AsyncJswAdaptedGlobalIssueCreateTrigger = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-gicTrigger",
        teamName: "a4t-pandora",
        packageName: "jiraJswAdaptedGlobalIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsw-adapted-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9375c4c02f139011$var$LazyGICTrigger, props)));
var $9375c4c02f139011$export$2e2bcd8739ae039 = $9375c4c02f139011$var$AsyncJswAdaptedGlobalIssueCreateTrigger;

});
parcelRegister("5FwPO", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("8Qe3j").then(()=>parcelRequire('gwnVZ'));

});


parcelRegister("2TOwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3a9e7b7142c7dd8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7ef3dd78f617ba20e117903caea5f68>>
 * @relayHash dff560da6b44e8698cb7db6cce996d50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543
const $d3a9e7b7142c7dd8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isCMP"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v2 = {
        "concreteType": "GlobalCardCreateAdditionalFields",
        "kind": "LinkedField",
        "name": "globalCardCreateAdditionalFields",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sprintCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "rankCustomFieldId"
            },
            {
                "kind": "ScalarField",
                "name": "boardIssueListKey"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ec8ebec42ce3a627014ff3055a722125ee7a7a44b01f69e101974c5c5fe01543",
            "metadata": {},
            "name": "triggerWithCustomFieldsJSWGlobalIssueCreateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d3a9e7b7142c7dd8$var$node.hash = "96d35f31f30c5edc94e3d721f9444ea0";
var $d3a9e7b7142c7dd8$export$2e2bcd8739ae039 = $d3a9e7b7142c7dd8$var$node;

});

parcelRegister("d3kOO", function(module, exports) {

$parcel$export(module.exports, "getPrefilledFieldsFromInputs", () => $68971c4c7e5dfaa1$export$819256f3c3cb490a);
$parcel$export(module.exports, "getSessionIdFromInputs", () => $68971c4c7e5dfaa1$export$1f4921affea1cade);
$parcel$export(module.exports, "getSubmitErrorMessage", () => $68971c4c7e5dfaa1$export$1facbc353d35a4eb);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $guzeq = parcelRequire("guzeq");


var $jG5HW = parcelRequire("jG5HW");

var $3QmBe = parcelRequire("3QmBe");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");
const $68971c4c7e5dfaa1$export$819256f3c3cb490a = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData),
    (0, $dGljH.getCardLists),
    (0, $jG5HW.projectIdSelector),
    (0, $3QmBe.getAppliedLabelFilters),
    (0, $3QmBe.getMostRecentAssigneeFilter)
], (modalData, cardLists, projectId, appliedLabels, assignee)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return null;
    const { cardSummary: cardSummary, cardTypeId: cardTypeId, rankBeforeCardId: rankBeforeCardId, cardParentId: cardParentId, cardListId: cardListId, fixVersions: fixVersions } = modalData.payload;
    const parentIssueId = // parentId is 0 when 'issues without epic' filter is selected
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardParentId) && cardParentId !== 0 ? String(cardParentId) : '';
    const destination = cardLists[cardListId]?.type;
    return {
        projectId: String(projectId),
        issueType: String(cardTypeId),
        summary: cardSummary,
        labels: appliedLabels || [],
        assignee: assignee?.id || '',
        parentIssueId: parentIssueId,
        fixVersions: fixVersions,
        sprintId: destination === (0, $guzeq.SPRINT) ? cardListId : undefined,
        context: {
            rankBeforeCardId: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeCardId) ? String(rankBeforeCardId) : null,
            destination: destination
        }
    };
});
const $68971c4c7e5dfaa1$export$1f4921affea1cade = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return undefined;
    return modalData?.payload?.sessionId || undefined;
});
const $68971c4c7e5dfaa1$export$1facbc353d35a4eb = (0, $dGvGJ.createSelector)([
    (0, $fC5rN.getOpenModalData)
], (modalData)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData) || modalData?.type !== (0, $b107c54ec82f76f2$export$55cae6fd3c958bc5) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(modalData?.payload)) return undefined;
    return modalData.payload.submitErrorMessage;
});

});


parcelRegister("jtyx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf321c61fc3700a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8bf321c61fc3700a$var$LazyGICTrigger = (0, $hPtZI.lazy)(()=>(parcelRequire("26Lqx")), {
    moduleId: "./src/packages/software/backlog/src/view/modals/global-issue-create-cmp/index.tsx"
});
const $8bf321c61fc3700a$var$AsyncGlobalIssueCreateCMPTrigger = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "async-cmp-gicTrigger",
        packageName: "jira-software-backlog",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cmp-gic-trigger",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8bf321c61fc3700a$var$LazyGICTrigger, null)));
var $8bf321c61fc3700a$export$2e2bcd8739ae039 = $8bf321c61fc3700a$var$AsyncGlobalIssueCreateCMPTrigger;

});
parcelRegister("26Lqx", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("hmAcN").then(()=>parcelRequire('7XJHb'));

});


parcelRegister("hDscR", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionModal", () => $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8);

var $5uXOq = parcelRequire("5uXOq");

var $jpZIw = parcelRequire("jpZIw");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $c1MAf = parcelRequire("c1MAf");

var $6zjUi = parcelRequire("6zjUi");

var $f7vcs = parcelRequire("f7vcs");
const $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const openIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $6zjUi.closeIssueTransitionModal)());
    }, [
        dispatch
    ]);
    const isOpen = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.isIssueTransitionModalOpen)(state));
    const { issueId: issueId = '', issueKey: issueKey = '', transitionId: transitionId = '' } = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.getPayloadForIssueTransitionModal)(state));
    const { onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError } = (0, $c1MAf.useBacklogSelector)((state)=>(0, $f7vcs.getHandlersForIssueTransitionModal)(state));
    const cloudId = (0, $koeKL.useCloudId)();
    const ariIssueId = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'issue',
        cloudId: cloudId,
        resourceId: `${issueId}`
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) {
            const handleDialogCancel = ()=>{
                onDialogCancel?.();
                onClose();
            };
            const handleDialogError = (error)=>{
                onDialogError?.(error);
                onClose();
            };
            const handleDialogSuccess = ()=>{
                onDialogSuccess?.();
                onClose();
            };
            openIssueTransitionModal({
                payload: {
                    issueId: ariIssueId,
                    issueKey: issueKey,
                    transitionId: transitionId
                },
                triggerPointKey: 'issue-transition-board-card-transition',
                onDialogSuccess: handleDialogSuccess,
                onDialogCancel: handleDialogCancel,
                onDialogError: handleDialogError
            });
        }
    }, [
        ariIssueId,
        isOpen,
        issueKey,
        onClose,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        openIssueTransitionModal,
        transitionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
var $2de1547cc4c3b4b7$export$2e2bcd8739ae039 = $2de1547cc4c3b4b7$export$98b2cbb8ec9c06d8;

});
parcelRegister("jpZIw", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $f41d32ebe3d90af0$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $f41d32ebe3d90af0$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $f41d32ebe3d90af0$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $f41d32ebe3d90af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $6ikhl = parcelRequire("6ikhl");

var $2gCtH = parcelRequire("2gCtH");

var $ct2PA = parcelRequire("ct2PA");

var $3NlyR = parcelRequire("3NlyR");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $1btwe = parcelRequire("1btwe");

var $gjoNn = parcelRequire("gjoNn");

var $ipUU1 = parcelRequire("ipUU1");
const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $fNOVA.useIssueTransitionLabsOptIn)();
    const publish = (0, $1btwe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $3NlyR.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $9MiT2.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $ct2PA.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $5uXOq.useCallback)((nextState)=>{
        if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
            fireOperationalAnalyticsTransitionScreenOpened({
                actionSubject: 'issueTransition triggered',
                isBenefitsModalFGEneabled: (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal'),
                preferNewIssueTransitionScreen: isEnabled,
                issueViewAnalyticsSource: source,
                isBenefitsModalDisabled: isDisabled,
                dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
            });
            openIssueTransitionModalNew({
                nextState: nextState,
                preferNewIssueTransitionScreen: isEnabled,
                issueViewAnalyticsSource: source,
                publishTriggerToOpenTransitions: publish,
                isBenefitsModalDisabled: isDisabled,
                dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                fireUIEvent: fireUIEvent
            });
            return;
        }
        if (source === 'connect-issue') {
            // fire UI event when issue transition is opened via connect API
            fireUIEvent({
                actionSubject: 'issueTransition',
                actionSubjectId: 'connectIssue',
                action: 'opened'
            });
            publish(nextState, isEnabled);
        } else openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        (0, $4R6GH.fg)('ditto-fcf-transition-view-forge-rendering') && resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'switch to legacy transition screen');
            };
            (0, $ipUU1.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
    const state = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const actions = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;

});
parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);

var $7JoAD = parcelRequire("7JoAD");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $7JoAD.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $7JoAD.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $7JoAD.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $7JoAD.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("ct2PA", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $539a3126b0b48d6d$export$4d10663856b750d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");
const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("3NlyR", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $5656c248adec15f1$export$d0823e3d2e087672);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");
const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $8zOmE.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("1btwe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $9796b79be99bbec0$export$76b6328962c9935f);

var $5uXOq = parcelRequire("5uXOq");


var $iXy8e = parcelRequire("iXy8e");
const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
        (0, $iXy8e.ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("iXy8e", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $c6c4e897a3edd1a2$export$a3877931259d622e);

var $da7iT = parcelRequire("da7iT");
const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, $da7iT.PubSubHub)();
const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
        ...$c6c4e897a3edd1a2$export$a3877931259d622e
    });

});
parcelRegister("da7iT", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $4d1dbccbbe967a62$export$e3607828f8f2c01e);
class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("gjoNn", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $18f6c8628e84d111$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $18f6c8628e84d111$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $18f6c8628e84d111$export$d3aceeec551eaab5);

var $7JoAD = parcelRequire("7JoAD");

var $QnL9H = parcelRequire("QnL9H");

var $bpOxh = parcelRequire("bpOxh");
const $18f6c8628e84d111$var$store = (0, $7JoAD.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $QnL9H.initialState,
    actions: $bpOxh
});
const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, $7JoAD.createContainer)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$68de001c738e4145 = (0, $7JoAD.createActionsHook)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, $7JoAD.createStateHook)($18f6c8628e84d111$var$store);

});
parcelRegister("QnL9H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $b1651ed43432db50$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $b1651ed43432db50$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $b1651ed43432db50$export$8ed7400ca8e89de2);

var $7Jxgt = parcelRequire("7Jxgt");

const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';


parcelRegister("bpOxh", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("3KYVT")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("3cIaS")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("keQtD")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("fb5Xn")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("bemkp")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bnv5t")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3KYVT = parcelRequire("3KYVT");

var $3cIaS = parcelRequire("3cIaS");

var $keQtD = parcelRequire("keQtD");

var $fb5Xn = parcelRequire("fb5Xn");

var $bemkp = parcelRequire("bemkp");

var $bnv5t = parcelRequire("bnv5t");

});
parcelRegister("3KYVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ddf425c332ed49$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");
const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $QnL9H.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;

});

parcelRegister("3cIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7e957c004b1c31$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $jcw0u = parcelRequire("jcw0u");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;

});
parcelRegister("eVcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bfe0b90f22578e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");

var $4tcSU = parcelRequire("4tcSU");

var $emTT1 = parcelRequire("emTT1");
class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $emTT1.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $6BZYo.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("emTT1", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $4a78c80c71ff3414$export$9d20a86383e90d09);

var $cHBMC = parcelRequire("cHBMC");
const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, $cHBMC.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jtjyW", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $1832266ecf87e128$export$3fc439100e136a52);

var $4R6GH = parcelRequire("4R6GH");

var $lL2Jl = parcelRequire("lL2Jl");

var $lP1Jn = parcelRequire("lP1Jn");

var $fc6nm = parcelRequire("fc6nm");

var $3iMqq = parcelRequire("3iMqq");
const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $lL2Jl.IssueTransitionLoadUFOExperience).start();
    (0, $lL2Jl.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lP1Jn.issueTransittionModalLoadSubsequent) : (0, $lP1Jn.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $3iMqq.default)('issue-transition.transition-modal-subsequent');
    else (0, $3iMqq.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $4R6GH.fg)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fc6nm.startUimTTI)();
};

});
parcelRegister("lL2Jl", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $f07939f1a4892f29$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $f07939f1a4892f29$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $f07939f1a4892f29$export$2f3b26e8acf79182);

var $hNAhd = parcelRequire("hNAhd");
var $d3cxT = parcelRequire("d3cxT");
const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, $d3cxT.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $hNAhd.ExperienceTypes).Experience,
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, $d3cxT.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $hNAhd.ExperienceTypes).Experience,
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, $d3cxT.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $hNAhd.ExperienceTypes).Experience,
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lP1Jn", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $e48205cb6c384272$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $e48205cb6c384272$export$afa89f024c56a00a);

var $cHBMC = parcelRequire("cHBMC");
const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, $cHBMC.metrics).interaction({
    key: 'issue-transition-modal'
});
const $e48205cb6c384272$export$afa89f024c56a00a = (0, $cHBMC.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fc6nm", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $50f6a9f98192a4eb$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $50f6a9f98192a4eb$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $50f6a9f98192a4eb$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $50f6a9f98192a4eb$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $50f6a9f98192a4eb$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $50f6a9f98192a4eb$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $50f6a9f98192a4eb$export$d86f4868694f2aa7);

var $cHBMC = parcelRequire("cHBMC");

var $a1HyB = parcelRequire("a1HyB");
const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, $cHBMC.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $a1HyB.TTIFFs)
});
const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
};
const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
};
const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});
parcelRegister("a1HyB", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $aec371b77b607203$export$c396ba1504d97f3f);
const $aec371b77b607203$export$c396ba1504d97f3f = [];

});



parcelRegister("jHYHS", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);

var $1WqFo = parcelRequire("1WqFo");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $5f3a7dc1f1182e00$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $4R6GH.fg)('issue-transition-issue-view'),
        'issue-transition-issue-view-shortcut-dialog': (0, $4R6GH.fg)('issue-transition-issue-view-shortcut'),
        'issue-transition-board-card-transition': (0, $4R6GH.fg)('issue-transition-board-card-transition'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $4R6GH.fg)('issue-transition-advanced-roadmaps-jira-transition'),
        'issue-transition-command-palette-status-field-transition': (0, $4R6GH.fg)('issue-transition-command-palette-status'),
        'issue-transition-issue-results-shortcut-transition': (0, $4R6GH.fg)('issue-transition-issue-results-shortcut-transition'),
        'issue-transition-backlog-inline-transition': (0, $4R6GH.fg)('issue-transition-backlog-inline-transition'),
        'issue-transition-status-field-trigger': (0, $4R6GH.fg)('issue-transition-status-field-trigger'),
        'trigger-point-key-not-defined': (0, $4R6GH.fg)('trigger-point-key-not-defined')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $1WqFo.isFedRamp)()) return true;
    if (!(0, $co1wz.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$5f3a7dc1f1182e00$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $4R6GH.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("keQtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9984214aecd9b0cd$export$2e2bcd8739ae039);
const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;

});

parcelRegister("fb5Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f04f71b4951234$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;

});

parcelRegister("bemkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c42f9cd1814e06$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");

var $jtjyW = parcelRequire("jtjyW");
const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $QnL9H.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $QnL9H.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;

});

parcelRegister("bnv5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522276a96c69778$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $jcw0u = parcelRequire("jcw0u");

var $co1wz = parcelRequire("co1wz");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if ((0, $co1wz.ff)('render-modern-issue-transition_cxt0z') && !isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $emTT1.timeToRenderTransitionModal).start();
                    new (0, $eVcDT.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;

});



parcelRegister("ipUU1", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $f258fa9a0604f29b$export$6bfef2005bd55204);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $jcw0u = parcelRequire("jcw0u");
const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $emTT1.timeToRenderTransitionModal).start();
        new (0, $eVcDT.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("f7vcs", function(module, exports) {

$parcel$export(module.exports, "isIssueTransitionModalOpen", () => $36e6d5fee96d6523$export$635dff68cff1d935);
$parcel$export(module.exports, "getPayloadForIssueTransitionModal", () => $36e6d5fee96d6523$export$c7eee86986a78e72);
$parcel$export(module.exports, "getHandlersForIssueTransitionModal", () => $36e6d5fee96d6523$export$514262e3dee62ae2);

var $dGvGJ = parcelRequire("dGvGJ");

var $8Rkzz = parcelRequire("8Rkzz");
const $36e6d5fee96d6523$var$getUiIssueTransitionModal = (state)=>state.ui.issueTransitionModal;
const $36e6d5fee96d6523$export$635dff68cff1d935 = (state)=>Boolean($36e6d5fee96d6523$var$getUiIssueTransitionModal(state)?.isOpen);
const $36e6d5fee96d6523$var$getSelectedIssueActionPayload = (state)=>$36e6d5fee96d6523$var$getUiIssueTransitionModal(state);
const $36e6d5fee96d6523$var$noSelectedIssue = {
    issueId: '',
    issueKey: '',
    transitionId: ''
};
const $36e6d5fee96d6523$export$c7eee86986a78e72 = (0, $dGvGJ.createSelector)([
    $36e6d5fee96d6523$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) return {
        issueId: issuePayload.issueId,
        issueKey: issuePayload.issueKey,
        transitionId: issuePayload.transitionId
    };
    return $36e6d5fee96d6523$var$noSelectedIssue;
});
const $36e6d5fee96d6523$var$noHandlers = {
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDialogSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $36e6d5fee96d6523$export$514262e3dee62ae2 = (0, $dGvGJ.createSelector)([
    $36e6d5fee96d6523$var$getSelectedIssueActionPayload
], (issuePayload)=>{
    if (issuePayload?.isOpen) {
        const { onDialogCancel: onDialogCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDialogError: onDialogError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onDialogSuccess: onDialogSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = issuePayload;
        return {
            onDialogCancel: onDialogCancel,
            onDialogError: onDialogError,
            onDialogSuccess: onDialogSuccess
        };
    }
    return $36e6d5fee96d6523$var$noHandlers;
});

});


parcelRegister("e2cKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $461c8fb9218d005e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $ezPyr = parcelRequire("ezPyr");
var $bvt08 = parcelRequire("bvt08");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");

var $1ppIJ = parcelRequire("1ppIJ");


var $c1MAf = parcelRequire("c1MAf");

var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $dGljH = parcelRequire("dGljH");

var $fC5rN = parcelRequire("fC5rN");

var $831wI = parcelRequire("831wI");
function $461c8fb9218d005e$export$2ddffba95706b42d() {
    const data = (0, $c1MAf.useBacklogSelector)((state)=>{
        const cards = (0, $dGljH.getCards)(state);
        const modalData = (0, $fC5rN.getOpenModalData)(state);
        if (!modalData || modalData.type !== (0, $b107c54ec82f76f2$export$86a0c18887a92eae)) return {};
        return {
            confirmActionPayload: modalData.payload.confirmActionPayload,
            originCardListName: modalData.payload.originCardListName,
            destinationCardListName: modalData.payload.destinationCardListName,
            analyticsEvent: modalData.payload.analyticsEvent,
            cards: modalData.payload.cardIds// Make sure the card exists
            .filter((id)=>cards[String(id)]).map((id)=>cards[String(id)])
        };
    });
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    /*
       Should only need to create this once since the modal is closed
       by either confirm or cancel
     */ const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cancelButton');
        dispatch((0, $5Eoed.closeModal)());
    }, [
        analyticsEvent,
        dispatch
    ]);
    const onMove = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'confirmButton');
        // Wrapping in an if as confirmActionPayload has the potential to be undefined
        if (data.confirmActionPayload) dispatch((0, $6GNN7.cardsMoveRequest)(data.confirmActionPayload, data.analyticsEvent));
        onClose();
    }, [
        analyticsEvent,
        onClose,
        data,
        dispatch
    ]);
    const renderMovedIssues = (0, $5uXOq.useCallback)(()=>{
        const cards = data.cards || [];
        if (cards.length <= 0) return null;
        if (cards.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $831wI.default).movedOneCard,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName)
            }
        });
        if (cards.length === 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $831wI.default).movedTwoCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName)
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $831wI.default).movedMoreCardsIssueTermRefresh : (0, $831wI.default).movedMoreCards,
            values: {
                cardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[0].key),
                anotherCardName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards[1].key),
                originCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.originCardListName),
                destinationCardListName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, data.destinationCardListName),
                moreCardsCountText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, cards.length - 2),
                moreCardsCount: cards.length - 2
            }
        });
    }, [
        data
    ]);
    const buttonCancel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        onClick: onClose,
        key: "buttonCancel"
    }, formatMessage((0, $831wI.default).cancel));
    const buttonConfirm = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "primary",
        onClick: onMove,
        key: "buttonConfirm"
    }, formatMessage((0, $831wI.default).confirm));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        width: 400,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), {
        appearance: "warning"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $831wI.default).titleIssueTermRefresh : (0, $831wI.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $831wI.default).changedScope)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        "data-testid": "software-backlog.modals.move-cards-active-sprint-modal.content"
    }, renderMovedIssues()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null, [
        buttonCancel,
        buttonConfirm
    ])));
}
function $461c8fb9218d005e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "moveCardsActiveSprint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($461c8fb9218d005e$export$2ddffba95706b42d, null));
}

});
parcelRegister("831wI", function(module, exports) {

$parcel$export(module.exports, "default", () => $70bca34109ac4c91$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70bca34109ac4c91$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.move-cards-active-sprint-modal.title",
        "defaultMessage": "Move issues"
    },
    changedScope: {
        "id": "backlog.modals.move-cards-active-sprint-modal.changed-scope",
        "defaultMessage": "Sprint scope will be affected by this action."
    },
    movedOneCard: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-one-card",
        "defaultMessage": "{cardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedTwoCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-two-cards",
        "defaultMessage": "{cardName} and {anotherCardName} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    movedMoreCards: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-more-cards",
        "defaultMessage": "{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    },
    confirm: {
        "id": "backlog.modals.move-cards-active-sprint-modal.confirm",
        "defaultMessage": "Confirm"
    },
    cancel: {
        "id": "backlog.modals.move-cards-active-sprint-modal.cancel",
        "defaultMessage": "Cancel"
    },
    titleIssueTermRefresh: {
        "id": "backlog.modals.move-cards-active-sprint-modal.title-issue-term-refresh",
        "defaultMessage": "Move issues"
    },
    movedMoreCardsIssueTermRefresh: {
        "id": "backlog.modals.move-cards-active-sprint-modal.moved-more-cards-issue-term-refresh",
        "defaultMessage": "{cardName}, {anotherCardName} and {moreCardsCountText} more {moreCardsCount, plural, one {issue} other {issues}} will be moved from sprint {originCardListName} to sprint {destinationCardListName}."
    }
});

});


parcelRegister("1vE6g", function(module, exports) {

$parcel$export(module.exports, "SelectTransitionsModal", () => $c9f7d4a79e685bda$export$ccd1f82a2bacb02);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $dOHxT = parcelRequire("dOHxT");
var $ezPyr = parcelRequire("ezPyr");
var $bvt08 = parcelRequire("bvt08");
var $hEKJD = parcelRequire("hEKJD");
var $D0YJV = parcelRequire("D0YJV");
var $lkDqR = parcelRequire("lkDqR");

var $atG8z = parcelRequire("atG8z");

var $hZHze = parcelRequire("hZHze");

var $9fuVs = parcelRequire("9fuVs");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $95EVP = parcelRequire("95EVP");


var $c1MAf = parcelRequire("c1MAf");

var $6GNN7 = parcelRequire("6GNN7");

var $5Eoed = parcelRequire("5Eoed");

var $fC5rN = parcelRequire("fC5rN");

var $lSZAF = parcelRequire("lSZAF");
const $c9f7d4a79e685bda$var$getOptions = (transitions)=>transitions.map((transition)=>({
            name: 'transition',
            value: String(transition.id),
            label: transition.name
        }));
function $c9f7d4a79e685bda$export$ccd1f82a2bacb02() {
    const [selectedTransitionId, setSelectedTransitionId] = (0, $5uXOq.useState)(undefined);
    const [isDisabled, setIsDisabled] = (0, $5uXOq.useState)(true);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $95EVP.useAnalyticsEvents)();
    const modalAnalyticsEvent = createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked'
    });
    const modalData = (0, $c1MAf.useBacklogSelector)((state)=>{
        const modal = (0, $fC5rN.getOpenModalData)(state);
        return modal && modal.type === (0, $b107c54ec82f76f2$export$dcb8eb3e585ecde) ? modal.payload : null;
    });
    const onSelectionChange = (0, $5uXOq.useCallback)(({ currentTarget: { value: value } })=>{
        if (value) {
            setSelectedTransitionId(Number(value));
            setIsDisabled(false);
        }
    }, [
        setIsDisabled,
        setSelectedTransitionId
    ]);
    if (!modalData) return null;
    const { cardKeys: cardKeys, transitions: transitions, moveCardsActionPayload: moveCardsActionPayload, optimisticId: optimisticId, analyticsEvent: analyticsEvent } = modalData;
    const onCancel = ()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'cancelButton');
        dispatch((0, $6GNN7.cardsMoveCancel)(optimisticId, analyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    };
    const onChoose = ()=>{
        (0, $8zOmE.fireUIAnalytics)(modalAnalyticsEvent, 'chooseTransitionButton');
        selectedTransitionId && dispatch((0, $6GNN7.cardsMoveNonOptimisticRequest)(optimisticId, {
            ...moveCardsActionPayload,
            selectedTransition: transitions.find((transition)=>transition.id === selectedTransitionId)
        }, analyticsEvent));
        dispatch((0, $5Eoed.closeModal)());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "selectTransition"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkDqR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOHxT.default), {
        onClose: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEKJD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $D0YJV.default), null, formatMessage((0, $lSZAF.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ezPyr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSZAF.messages).descriptionIssueTermRefresh : (0, $lSZAF.messages).description, {
        count: transitions.length,
        cardKeys: cardKeys.join(', ')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $atG8z.default), {
        onChange: onSelectionChange,
        options: $c9f7d4a79e685bda$var$getOptions(transitions)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvt08.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $lSZAF.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
        isDisabled: isDisabled,
        appearance: "primary",
        onClick: onChoose,
        autoFocus: true
    }, formatMessage((0, $lSZAF.messages).choose)))))));
}

});
parcelRegister("atG8z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9193de26c2f6ec5d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ePBXU = parcelRequire("ePBXU");

var $p4h3d = parcelRequire("p4h3d");
const $9193de26c2f6ec5d$var$noOptions = [];
function $9193de26c2f6ec5d$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $9193de26c2f6ec5d$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $ePBXU.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $p4h3d.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});

parcelRegister("lSZAF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $181320bce18912a8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $181320bce18912a8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.select-transitions-modal.title",
        "defaultMessage": "Choose a transition"
    },
    description: {
        "id": "backlog.modals.select-transitions-modal.description",
        "defaultMessage": "Choose one of {count} available transitions for issue {cardKeys}"
    },
    cancel: {
        "id": "backlog.modals.select-transitions-modal.cancel",
        "defaultMessage": "Cancel"
    },
    choose: {
        "id": "backlog.modals.select-transitions-modal.choose",
        "defaultMessage": "Choose"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.modals.select-transitions-modal.description-issue-term-refresh",
        "defaultMessage": "Choose one of {count} available transitions for issue {cardKeys}"
    }
});

});


parcelRegister("fLCrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff77b69424f86f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gUikp = parcelRequire("gUikp");

var $10Ngv = parcelRequire("10Ngv");

var $f01qr = parcelRequire("f01qr");


var $i4Z8q = parcelRequire("i4Z8q");

var $c1MAf = parcelRequire("c1MAf");

var $3lZ6i = parcelRequire("3lZ6i");

var $hf5c2 = parcelRequire("hf5c2");

var $5Eoed = parcelRequire("5Eoed");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $45Qwd = parcelRequire("45Qwd");

var $fmuR9 = parcelRequire("fmuR9");

var $fC5rN = parcelRequire("fC5rN");

var $k35me = parcelRequire("k35me");

var $k4laV = parcelRequire("k4laV");
const $6ff77b69424f86f6$var$useSplitIssueState = (cardId)=>{
    const isSprintsEnabled = (0, $c1MAf.useBacklogSelector)((0, $k35me.isBacklogWithSprints));
    const card = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCards)(state)[cardId]);
    const cardListId = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.makeGetCardListIdByCardId)(state)(cardId));
    const isCardListActiveSprint = (0, $c1MAf.useBacklogSelector)((state)=>(0, $k35me.makeIsCardListActiveSprint)(state)(String(cardListId)));
    const serviceContext = (0, $c1MAf.useBacklogSelector)((state)=>(0, $i4Z8q.makeServiceContext)(state));
    const cardLists = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardLists));
    const cardListData = (0, $c1MAf.useBacklogSelector)((state)=>Object.values(cardLists).map(({ id: id, name: name })=>({
                id: id,
                name: name,
                type: (0, $dGljH.makeGetCardListAnalyticsTypeById)(state)(id),
                isActive: (0, $k35me.makeIsCardListActiveSprint)(state)(id)
            })), (0, $f01qr.isObjectArrayEqual));
    const estimationFieldId = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationFieldId));
    const estimationType = (0, $c1MAf.useBacklogSelector)((0, $45Qwd.getEstimationType));
    const timeTrackingOptions = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getTimeTrackingOptions));
    const timeTrackingConfig = (0, $k4laV.timeTrackingConfigTransformer)(timeTrackingOptions);
    return {
        card: card,
        originalIssueDestinationId: cardListId,
        cardLists: cardListData,
        estimationFieldId: estimationFieldId,
        estimationType: estimationType,
        isCardListActiveSprint: isCardListActiveSprint,
        isSprintsEnabled: isSprintsEnabled,
        timeTrackingConfig: timeTrackingConfig,
        isCompanyManaged: serviceContext.isCompanyManaged
    };
};
const $6ff77b69424f86f6$export$10af25b190c591c7 = ()=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const issueParents = (0, $c1MAf.useBacklogSelector)((0, $fmuR9.issueParentsSelector));
    const storeFieldsActions = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch
    ]);
    const onSplitIssue = (0, $5uXOq.useCallback)((originalIssue, newSplitIssues)=>{
        const newSplitIssueKeys = newSplitIssues?.map((issue)=>issue?.key ?? '');
        dispatch((0, $3lZ6i.loadAppData)({
            storeFieldsActions: storeFieldsActions
        }));
        dispatch((0, $hf5c2.splitIssueCreate)(originalIssue.key, newSplitIssueKeys));
        dispatch((0, $5Eoed.closeModal)());
    }, [
        dispatch,
        storeFieldsActions
    ]);
    return {
        onClose: onClose,
        onSplitIssue: onSplitIssue
    };
};
const $6ff77b69424f86f6$var$SplitIssueModalView = ({ cardId: cardId })=>{
    const state = $6ff77b69424f86f6$var$useSplitIssueState(cardId);
    const actions = $6ff77b69424f86f6$export$10af25b190c591c7();
    const props = {
        ...state,
        ...actions
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gUikp.default), props);
};
const $6ff77b69424f86f6$var$SplitIssueModalContainer = ()=>{
    const modalData = (0, $c1MAf.useBacklogSelector)((0, $fC5rN.getOpenModalData));
    if (modalData?.type !== (0, $b107c54ec82f76f2$export$77e94846ed2f57d7)) return null;
    const { cardId: cardId } = modalData.payload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ff77b69424f86f6$var$SplitIssueModalView, {
        cardId: cardId
    });
};
var $6ff77b69424f86f6$export$2e2bcd8739ae039 = $6ff77b69424f86f6$var$SplitIssueModalContainer;

});
parcelRegister("gUikp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c7cb770f484586$export$2e2bcd8739ae039);
/**
 * This async file lives here since it needs to access the generated query, and stricter only allows one level of imports in UI
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $dXq4S = parcelRequire("dXq4S");

var $cg5z5 = parcelRequire("cg5z5");

var $9OXo1 = parcelRequire("9OXo1");

var $hPtZI = parcelRequire("hPtZI");

var $dIdda = parcelRequire("dIdda");

var $hHoTb = parcelRequire("hHoTb");

var $ilUQh = parcelRequire("ilUQh");

var $9qoqd = parcelRequire("9qoqd");

var $8h8Xu = parcelRequire("8h8Xu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e9c7cb770f484586$var$LazySplitIssueModal = (0, $hPtZI.lazy)(()=>(parcelRequire("4Ehls")), {
    moduleId: "./src/packages/software/backlog-split-issue/src/ui/split-issue-modal/index.tsx"
});
const $e9c7cb770f484586$export$5f61d6092ee768bc = (props)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [boardId = null] = (0, $dIdda.usePathParam)('boardId');
    const [onViewExperienceStart, onViewExperienceSuccess, onViewExperienceFail] = (0, $8h8Xu.useExperienceTracker)((0, $ilUQh.EXPERIENCES).viewApp, (0, $ilUQh.SOURCE_NAME));
    (0, $hHoTb.useUFOComponentExperience)((0, $9qoqd.initialLoadSplitIssueModalExperience));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $cg5z5.default));
    const boardARI = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const cardARI = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'card',
        resourceId: String(props.card.id)
    });
    const onError = (0, $5uXOq.useCallback)((location, error, errorAttributes)=>{
        onViewExperienceFail(location, error, errorAttributes);
        (0, $9qoqd.initialLoadSplitIssueModalExperience).failure();
    }, [
        onViewExperienceFail
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            (0, $9qoqd.initialLoadSplitIssueModalExperience).abort();
        }, []);
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            boardId: boardARI,
            cardId: cardARI
        }, {
            fetchPolicy: 'store-or-network'
        });
        onViewExperienceStart();
    }, [
        boardARI,
        cardARI,
        loadQuery,
        onViewExperienceStart
    ]);
    return queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: (0, $ilUQh.APP_IDENTIFIER),
        packageName: (0, $ilUQh.PACKAGE_NAME),
        fallback: "flag",
        teamName: "a4t-pandora",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-backlog-split-issue-ui",
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c7cb770f484586$var$LazySplitIssueModal, {
        queryReference: queryReference,
        ...props,
        onLoadSuccess: onViewExperienceSuccess
    }))) : null;
};
var $e9c7cb770f484586$export$2e2bcd8739ae039 = $e9c7cb770f484586$export$5f61d6092ee768bc;

});
parcelRegister("cg5z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac8a84a70044601$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<900b80199afc9efa03c01e67aea1e3e8>>
 * @relayHash cfcfb33cef7d4219a6d3f24984f7bcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d
const $3ac8a84a70044601$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cardId"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            },
            {
                "kind": "Variable",
                "name": "cardId",
                "variableName": "cardId"
            }
        ],
        "kind": "ScalarField",
        "name": "canSplitIssue"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "splitIssueModalQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "canSplitIssue"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "splitIssueModalQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "32db338fa9736886f416e43946a8e0a64a7b66d85da678268e01a687db02bc1d",
            "metadata": {},
            "name": "splitIssueModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3ac8a84a70044601$var$node.hash = "9c5280b41e46526652e1eaef4fc47ef2";
var $3ac8a84a70044601$export$2e2bcd8739ae039 = $3ac8a84a70044601$var$node;

});

parcelRegister("hHoTb", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $8a3e4bfd1eabdf48$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $8a3e4bfd1eabdf48$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $8a3e4bfd1eabdf48$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $8a3e4bfd1eabdf48$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("ilUQh", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_ERROR_FLAG_ID", () => $c45ff6ef6fc3070f$export$6066d6393ad0b789);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $c45ff6ef6fc3070f$export$f5e4c120ac01b615);
$parcel$export(module.exports, "ISSUE_COUNT", () => $c45ff6ef6fc3070f$export$8775696968c9b13c);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE", () => $c45ff6ef6fc3070f$export$bfb354504bb547a0);
$parcel$export(module.exports, "STORY_POINTS", () => $c45ff6ef6fc3070f$export$405b6d72f2d243a9);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c45ff6ef6fc3070f$export$2cea7f14750b8c19);
$parcel$export(module.exports, "PACKAGE_NAME", () => $c45ff6ef6fc3070f$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SOURCE_NAME", () => $c45ff6ef6fc3070f$export$a3821bc63538b210);
$parcel$export(module.exports, "MUTATION_FAILURE", () => $c45ff6ef6fc3070f$export$178c5c429f396aa0);
$parcel$export(module.exports, "EXPERIENCES", () => $c45ff6ef6fc3070f$export$a2008ed3b02411a3);
$parcel$export(module.exports, "SUMMARY_CHAR_LIMIT", () => $c45ff6ef6fc3070f$export$5ff63ab521d3d56c);
$parcel$export(module.exports, "SPLIT_ISSUE_INPUT", () => $c45ff6ef6fc3070f$export$5fd76d6bc878265a);

var $7HGHK = parcelRequire("7HGHK");
const $c45ff6ef6fc3070f$export$6066d6393ad0b789 = (0, $7HGHK.toFlagId)('permission-error-flag');
const $c45ff6ef6fc3070f$export$f5e4c120ac01b615 = (0, $7HGHK.toFlagId)('error-flag');
const $c45ff6ef6fc3070f$export$8775696968c9b13c = 'ISSUE_COUNT';
const $c45ff6ef6fc3070f$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $c45ff6ef6fc3070f$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $c45ff6ef6fc3070f$export$2cea7f14750b8c19 = 'backlog-split-issue';
const $c45ff6ef6fc3070f$export$b8b9d90f9e5bd72b = 'jira-software-backlog-split-issue';
const $c45ff6ef6fc3070f$export$a3821bc63538b210 = 'SplitIssue';
const $c45ff6ef6fc3070f$export$178c5c429f396aa0 = 'mutation failed';
const $c45ff6ef6fc3070f$export$a2008ed3b02411a3 = {
    viewApp: 'viewSplitIssueModal',
    saveApp: 'saveSplitIssue'
};
const $c45ff6ef6fc3070f$export$5ff63ab521d3d56c = 255;
const $c45ff6ef6fc3070f$export$5fd76d6bc878265a = 'split-issue-modal.summary.split-issue-input';

});

parcelRegister("9qoqd", function(module, exports) {

$parcel$export(module.exports, "initialLoadSplitIssueModalExperience", () => $3e5d7a2dd8409315$export$c85e655fc9a5ae13);
$parcel$export(module.exports, "saveSplitIssuesExperience", () => $3e5d7a2dd8409315$export$82dfb3a19169f7bb);

var $hNAhd = parcelRequire("hNAhd");
var $d3cxT = parcelRequire("d3cxT");
const $3e5d7a2dd8409315$export$c85e655fc9a5ae13 = new (0, $d3cxT.UFOExperience)('split-issue-modal-load', {
    type: (0, $hNAhd.ExperienceTypes).Operation,
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).PageLoad
});
const $3e5d7a2dd8409315$export$82dfb3a19169f7bb = new (0, $d3cxT.UFOExperience)('split-issue-save', {
    type: (0, $hNAhd.ExperienceTypes).Operation,
    performanceType: (0, $hNAhd.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("8h8Xu", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $17dff8ba77e51a1f$export$cdefb2a8b53f879f);

var $7Jxgt = parcelRequire("7Jxgt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $efvDm = parcelRequire("efvDm");

var $9OXo1 = parcelRequire("9OXo1");

var $g7sgY = parcelRequire("g7sgY");
const $17dff8ba77e51a1f$export$cdefb2a8b53f879f = (experience, analyticsSource)=>{
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt))).v4(),
        experience: experience,
        analyticsSource: analyticsSource,
        edition: appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE)
    });
    const synthetic = (0, $g7sgY.isPollinatorTenant)();
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {
            synthetic: synthetic
        }
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {
            synthetic: synthetic
        }
    });
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("g7sgY", function(module, exports) {

$parcel$export(module.exports, "isPollinatorTenant", () => $47ace69a57c36de5$export$f59b7b56b5cada61);

var $co1wz = parcelRequire("co1wz");
const $47ace69a57c36de5$export$f59b7b56b5cada61 = ()=>(0, $co1wz.ff)('jsw.pollinator.tenants');

});


parcelRegister("4Ehls", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("8OnqP")
]).then(()=>parcelRequire('9BoBM'));

});




parcelRegister("h7RbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cbf7fd877e1b481$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $foBuY = parcelRequire("foBuY");
var $89thI = parcelRequire("89thI");

var $53KbV = parcelRequire("53KbV");

var $lNkm9 = parcelRequire("lNkm9");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $c1MAf = parcelRequire("c1MAf");

var $3qXBy = parcelRequire("3qXBy");

var $7b0Pa = parcelRequire("7b0Pa");

var $1k1Kz = parcelRequire("1k1Kz");
const $7cbf7fd877e1b481$var$BoardIssueMoveDialog = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const isOpen = (0, $c1MAf.useBacklogSelector)((0, $7b0Pa.isDialogOpen)); // Strip arguments from event handlers
    const handleConfirm = (0, $5uXOq.useCallback)(()=>dispatch((0, $3qXBy.boardIssueMoveExecute)()), [
        dispatch
    ]);
    const handleCancel = (0, $5uXOq.useCallback)(()=>dispatch((0, $3qXBy.boardIssueMoveCancel)()), [
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$AbsolutePosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lNkm9.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $53KbV.default), {
            as: "h5",
            size: "xsmall"
        }, formatMessage((0, $1k1Kz.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7cbf7fd877e1b481$var$DescriptionStyle, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1k1Kz.default).descriptionIssueTermRefresh : (0, $1k1Kz.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $foBuY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, formatMessage((0, $1k1Kz.default).confirm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            onClick: handleCancel,
            appearance: "subtle"
        }, formatMessage((0, $1k1Kz.default).cancel)))),
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)));
};
var $7cbf7fd877e1b481$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7cbf7fd877e1b481$var$BoardIssueMoveDialog;
const $7cbf7fd877e1b481$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5724jg8 _11c81oud _1bsbr0r7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cbf7fd877e1b481$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cbf7fd877e1b481$var$AbsolutePosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _w4h2stnw _z2g7xy5q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Kz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76b3b21c7d927e2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a76b3b21c7d927e2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "backlog.modals.board-issue-move-dialog.title",
        "defaultMessage": "Fill your backlog with to-do's"
    },
    description: {
        "id": "backlog.modals.board-issue-move-dialog.description",
        "defaultMessage": "Want to move all issues in your board's first column to the backlog?"
    },
    confirm: {
        "id": "backlog.modals.board-issue-move-dialog.confirm",
        "defaultMessage": "Yes, move"
    },
    cancel: {
        "id": "backlog.modals.board-issue-move-dialog.cancel",
        "defaultMessage": "No thanks"
    },
    descriptionIssueTermRefresh: {
        "id": "backlog.modals.board-issue-move-dialog.description-issue-term-refresh",
        "defaultMessage": "Want to move all issues in your board's first column to the backlog?"
    }
});

});


parcelRegister("9HRx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe8944a06d65b50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4MFiN = parcelRequire("4MFiN");

var $c1MAf = parcelRequire("c1MAf");

var $dGljH = parcelRequire("dGljH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bfe8944a06d65b50$export$2e2bcd8739ae039 = ()=>{
    const issueIds = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.getCardIds)(state).map((cardId)=>String(cardId)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MFiN.default), {
        issueIds: issueIds
    });
};

});
parcelRegister("4MFiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c7654d7458abfb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iINXJ = parcelRequire("iINXJ");
function $d8c7654d7458abfb$var$PrefetchClientOnly(props) {
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iINXJ.Prefetch), props);
}
var $d8c7654d7458abfb$export$2e2bcd8739ae039 = $d8c7654d7458abfb$var$PrefetchClientOnly;

});
parcelRegister("iINXJ", function(module, exports) {

$parcel$export(module.exports, "Prefetch", () => $29ba10d1bace2883$export$a92e3edabc61a974);

var $5uXOq = parcelRequire("5uXOq");

var $l53am = parcelRequire("l53am");
// eslint-disable-next-line jira/react/no-class-components
class $29ba10d1bace2883$var$Prefetch extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.fetchIssues(props.issueIds, props.issueKeys);
    }
    componentDidUpdate({ issueIds: prevIssueIds, issueKeys: prevIssueKeys }) {
        const { issueIds: issueIds, issueKeys: issueKeys } = this.props;
        if (prevIssueIds !== issueIds) {
            const newIds = issueIds.filter((issueId)=>{
                const isTemporaryId = Number(issueId) < 0;
                return !prevIssueIds.includes(issueId) && !isTemporaryId;
            });
            this.fetchIssues(newIds);
        }
        if (issueKeys && prevIssueKeys && prevIssueKeys !== issueKeys) this.fetchIssues([], issueKeys);
    }
    fetchIssues(issueIds, issueKeys) {
        if (issueIds.length > 0) this.props.dataProvider.loadIssuesById(issueIds.map((id)=>String(id)));
        if (issueKeys && issueKeys.length > 0) this.props.dataProvider.loadIssues(issueKeys);
    }
    render() {
        return null;
    }
}
// @ts-expect-error - TS2559 - Type 'Props' has no properties in common with type '{ readonly dataProvider?: DataProvider | undefined; }'.
const $29ba10d1bace2883$export$a92e3edabc61a974 = (0, $l53am.WithDataProvider)($29ba10d1bace2883$var$Prefetch);

});
parcelRegister("l53am", function(module, exports) {

$parcel$export(module.exports, "WithDataProvider", () => $02b95a9a182f987c$export$b0017632f1661e1);

var $5uXOq = parcelRequire("5uXOq");

var $3H1wD = parcelRequire("3H1wD");
const $02b95a9a182f987c$export$b0017632f1661e1 = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: TProps) => JSX.Element' is not assignable to type 'AbstractComponent<TProps, any>'.
    (props)=>{
        const { dataProvider: dataProvider, ...otherProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3H1wD.DataProviderContext).Consumer, null, (contextDataProvider)=>// @ts-expect-error - TS2322 - Type 'Omit<TProps, "dataProvider"> & { dataProvider: DataProvider; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<TProps & OwnProps> & RefAttributes<any> & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...otherProps,
                dataProvider: dataProvider || contextDataProvider()
            }));
    };

});
parcelRegister("3H1wD", function(module, exports) {

$parcel$export(module.exports, "DataProviderContext", () => $0843efd524aaa43a$export$5bce75db3a3f66c4);

var $5uXOq = parcelRequire("5uXOq");

var $7353r = parcelRequire("7353r");
const $0843efd524aaa43a$export$5bce75db3a3f66c4 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $7353r.getDataProvider));

});
parcelRegister("7353r", function(module, exports) {

$parcel$export(module.exports, "getDataProvider", () => $cd2cb3c904264bdf$export$add6bf8e4261fead);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");

var $4Pf62 = parcelRequire("4Pf62");

var $g5X3G = parcelRequire("g5X3G");

var $aS73q = parcelRequire("aS73q");
const $cd2cb3c904264bdf$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS = 3600;
const $cd2cb3c904264bdf$var$DEFAULT_MAX_SIZE = 100;
const $cd2cb3c904264bdf$var$getTenantBaseUrl = ()=>{
    try {
        return (0, $g5X3G.toBaseUrl)((0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().baseUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return (0, $g5X3G.toBaseUrl)('');
    }
};
const $cd2cb3c904264bdf$var$createConfig = (config = {})=>{
    const defaultConfig = {
        expiryThresholdSeconds: $cd2cb3c904264bdf$var$DEFAULT_EXPIRY_THRESHOLD_SECONDS,
        maxSize: $cd2cb3c904264bdf$var$DEFAULT_MAX_SIZE,
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        baseUrl: Object.prototype.hasOwnProperty.call(config, 'baseUrl') ? config.baseUrl : $cd2cb3c904264bdf$var$getTenantBaseUrl(),
        ssrCachedIssue: null
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return Object.assign({}, defaultConfig, config);
};
const $cd2cb3c904264bdf$export$33c5e0ba77bb7d8 = (options = {})=>{
    const config = $cd2cb3c904264bdf$var$createConfig(options);
    const baseUrl = (0, $g5X3G.toBaseUrl)(config.baseUrl);
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const clearCache = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const insertSerializedIssue = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssues = ()=>{};
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const loadIssuesById = ()=>{};
    // @ts-expect-error - TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const getIssue = ()=>{};
    const loadIssue$ = ()=>(0, $kVLXA.Observable).empty();
    const getIssue$ = ()=>(0, $kVLXA.Observable).empty();
    const refreshIssue$ = ()=>loadIssue$();
    const getIssueRemoteData$ = (issueKey, cloudId, isIssueViewWhiteboardsStandaloneEnabled)=>isIssueViewWhiteboardsStandaloneEnabled ? (0, $aS73q.fetchIssueRemoteDataWithWhiteboards$)((0, $g5X3G.toIssueKey)(issueKey), (0, $g5X3G.toCloudId)(cloudId)) : (0, $aS73q.fetchIssueRemoteData$)(baseUrl, (0, $g5X3G.toIssueKey)(issueKey));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const updateIssue = ()=>{};
    const getMetrics = ()=>({
            cacheSize: 0,
            cacheStaleCount: 0,
            cacheAvailableCapacity: 0,
            cacheHit: false,
            staleCacheHit: false
        });
    return {
        clearCache: clearCache,
        loadIssues: loadIssues,
        loadIssuesById: loadIssuesById,
        getIssue: getIssue,
        getIssue$: getIssue$,
        getIssueRemoteData$: getIssueRemoteData$,
        refreshIssue$: refreshIssue$,
        updateIssue: updateIssue,
        getMetrics: getMetrics,
        insertSerializedIssue: insertSerializedIssue
    };
};
// store it as a singleton
let $cd2cb3c904264bdf$var$dataProvider;
const $cd2cb3c904264bdf$export$add6bf8e4261fead = ()=>{
    if ($cd2cb3c904264bdf$var$dataProvider == null) $cd2cb3c904264bdf$var$dataProvider = $cd2cb3c904264bdf$export$33c5e0ba77bb7d8();
    return $cd2cb3c904264bdf$var$dataProvider;
};

});
parcelRegister("aS73q", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData$", () => $f482d3f0ea8f2add$export$83220ed1a595568a);
$parcel$export(module.exports, "fetchIssueRemoteDataWithWhiteboards$", () => $f482d3f0ea8f2add$export$3aec720cf88c26cd);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("c66Ur");
parcelRequire("6hSeW");

var $aq199 = parcelRequire("aq199");

var $e6C7w = parcelRequire("e6C7w");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $jEfnV = parcelRequire("jEfnV");

var $1bLFJ = parcelRequire("1bLFJ");

var $6r7fT = parcelRequire("6r7fT");

var $g5X3G = parcelRequire("g5X3G");

var $hcsJY = parcelRequire("hcsJY");

var $fb243 = parcelRequire("fb243");

const $f482d3f0ea8f2add$var$LOG_LOCATION = 'issue.data-provider.source.issue-express';
const $f482d3f0ea8f2add$var$getIssueKeyFromResponse = (response)=>{
    // @ts-expect-error - TS2339 - Property 'fields' does not exist on type 'ViewIssue | ViewIssueRemoteData'.
    const fields = response.fields || [];
    const issueKeyField = fields.find(// @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
    (field)=>field.__typename === $a620d3896f16afcc$export$40bed7a29c3b629);
    if (!issueKeyField) throw new Error('Issue key field missing in graphql response');
    return (0, $g5X3G.toIssueKey)(issueKeyField.stringValue);
};
const $f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData = (response, issueKey)=>{
    if (!response) return null;
    const key = issueKey || $f482d3f0ea8f2add$var$getIssueKeyFromResponse(response);
    const now = new Date();
    const { issueId: issueId, remoteLinks: remoteLinks } = response;
    return (0, $hcsJY.createIssue)({
        key: key
    }).withMeta({
        newIssueViewLockedIn: response.meta ? response.meta.newIssueViewLockedIn : false,
        dataSource: 'issueExpress',
        fetchTime: now
    }).withId(issueId).withRemoteLinks(remoteLinks).build();
};
const $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData = (response)=>{
    const issueToWhiteboard = response?.graphStore?.issueToWhiteboard ?? {};
    const whiteboards = issueToWhiteboard.edges?.map(({ node: node })=>({
            whiteboardId: node.whiteboardId,
            author: {
                ...node.author
            },
            href: `${node.links?.base}${node.links?.webUi}`,
            type: (0, $1bLFJ.CONFLUENCE_WHITEBOARD),
            id: node.id,
            title: node.title
        }));
    return {
        confluenceWhiteboards: {
            linkedWhiteboards: {
                whiteboardCount: issueToWhiteboard.totalCount,
                whiteboards: whiteboards
            }
        }
    };
};
const $f482d3f0ea8f2add$export$83220ed1a595568a = (baseUrl, issueKey)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $fb243.fetchIssueRemoteData)(baseUrl, issueKey).map((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)).filter(Boolean).catch((err)=>{
        (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $kVLXA.Observable).empty();
    });
const $f482d3f0ea8f2add$export$3aec720cf88c26cd = (issueKey, cloudId)=>// @ts-expect-error - TS2322 - Type 'Observable<IssueRemoteData | null>' is not assignable to type 'Observable<IssueRemoteData>'.
    (0, $fb243.fetchIssueRemoteData)('', issueKey).pipe((0, $jEfnV.switchMap)((remoteDataResponse)=>(0, $fb243.fetchIssueConfluenceWhiteboardData)(remoteDataResponse.issueId, cloudId).pipe((0, $cVFxd.map)((confluenceWhiteboardDataResponse)=>{
            const confluenceWhiteboards = $f482d3f0ea8f2add$var$transformConfluenceWhiteboardData(confluenceWhiteboardDataResponse);
            const combinedRemoteData = {
                ...remoteDataResponse,
                remoteLinks: {
                    ...remoteDataResponse.remoteLinks,
                    ...confluenceWhiteboards
                }
            };
            return combinedRemoteData;
        }), (0, $cVFxd.map)((graphQlIssue)=>$f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(graphQlIssue, issueKey)), (0, $4cJXk.filter)(Boolean), (0, $e6C7w.catchError)((err)=>{
            (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueConfluenceWhiteboardData: Failed to fetch confluence whiteboards from AGG', err);
            return (0, $aq199.of)($f482d3f0ea8f2add$var$transformGraphQlIssueRemoteData(remoteDataResponse, issueKey));
        }))), (0, $e6C7w.catchError)((err)=>{
        (0, $6r7fT.trackOrLogClientError)($f482d3f0ea8f2add$var$LOG_LOCATION, 'fetchIssueRemoteData: Failed to fetch issue remote data from gira', err);
        return (0, $kVLXA.Observable).empty();
    }));

});
parcelRegister("1bLFJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_BLOGPOST", () => $0864033b77341257$export$b0807d3d613e535);
$parcel$export(module.exports, "CONFLUENCE_WHITEBOARD", () => $0864033b77341257$export$489cb2e515fef0c4);
$parcel$export(module.exports, "toConfluencePageType", () => $0864033b77341257$export$a7ae1ae0a3d7d205);
const $0864033b77341257$export$b0807d3d613e535 = 'blogpost';
const $0864033b77341257$export$353109fb558251b1 = 'page';
const $0864033b77341257$export$489cb2e515fef0c4 = 'whiteboard';
const $0864033b77341257$export$a7ae1ae0a3d7d205 = (type)=>type === $0864033b77341257$export$b0807d3d613e535 ? $0864033b77341257$export$b0807d3d613e535 : $0864033b77341257$export$353109fb558251b1;

});

parcelRegister("6r7fT", function(module, exports) {

$parcel$export(module.exports, "trackOrLogClientError", () => $cdae82c8a9c247d5$export$2fc29872103bf255);

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");
const $cdae82c8a9c247d5$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $jcw0u.default)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $cdae82c8a9c247d5$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $fZneA.isClientFetchError)(error)) $cdae82c8a9c247d5$export$c392d6295c0a29c7(location, message, error);
    else (0, $dJl1T.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("hcsJY", function(module, exports) {

$parcel$export(module.exports, "createIssue", () => $b09eba4e8be21e93$export$b61347e00e271b8e);
class $b09eba4e8be21e93$var$IssueBuilder {
    constructor({ key: key }){
        this.key = key;
        this.fields = new Map();
    }
    withMeta(meta) {
        this.meta = meta;
        return this;
    }
    // go/jfe-eslint
    withId(id) {
        this.id = id;
        return this;
    }
    // go/jfe-eslint
    withFields(fields) {
        fields.forEach(this.withField, this);
        return this;
    }
    // go/jfe-eslint
    withField(field) {
        if (field) this.fields.set(String(field.key), field);
        return this;
    }
    // go/jfe-eslint
    withRemoteLinks(remoteLinks) {
        this.remoteLinks = remoteLinks;
        return this;
    }
    // go/jfe-eslint
    withPreferences(myPreferences) {
        this.myPreferences = myPreferences;
        return this;
    }
    // go/jfe-eslint
    withComments(commentsData) {
        this.commentsData = commentsData;
        return this;
    }
    // go/jfe-eslint
    withWorkflow(workflow) {
        this.workflow = workflow;
        return this;
    }
    // go/jfe-eslint
    withActivitySortOrder(activitySortOrder) {
        this.activitySortOrder = activitySortOrder;
        return this;
    }
    build() {
        const meta = this.meta !== null && this.meta !== undefined ? this.meta : {
            dataSource: 'unknown',
            newIssueViewLockedIn: false,
            fetchTime: new Date()
        };
        const remoteLinks = this.remoteLinks !== null && this.remoteLinks !== undefined ? this.remoteLinks : {
            confluencePages: {
                linkedPages: {
                    pageCount: 0
                },
                mentionedPages: {
                    pageCount: 0
                }
            },
            confluenceWhiteboards: {
                linkedWhiteboards: {
                    whiteboardCount: 0
                }
            },
            webLinks: {
                linkCount: 0
            },
            remoteLinkedIssues: []
        };
        const myPreferences = this.myPreferences !== null && this.myPreferences !== undefined ? this.myPreferences : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let users = {};
        let comments = {
            totalCount: 0,
            startIndex: 0,
            comments: {}
        };
        if (this.commentsData !== null && this.commentsData !== undefined) {
            comments = {
                totalCount: this.commentsData.totalCount,
                // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'number'.
                startIndex: this.commentsData.startIndex,
                comments: this.commentsData.comments
            };
            users = this.commentsData.users;
        }
        const workflow = this.workflow !== null && this.workflow !== undefined ? this.workflow : undefined;
        const activitySortOrder = this.activitySortOrder;
        const issue = {
            key: this.key,
            fields: this.fields,
            meta: meta,
            remoteLinks: remoteLinks,
            myPreferences: myPreferences,
            comments: comments,
            users: users,
            workflow: workflow,
            activitySortOrder: activitySortOrder,
            ...this.id !== null && this.id !== undefined ? {
                id: this.id
            } : undefined
        };
        return issue;
    }
}
const $b09eba4e8be21e93$export$b61347e00e271b8e = ({ key: key })=>new $b09eba4e8be21e93$var$IssueBuilder({
        key: key
    });

});

parcelRegister("fb243", function(module, exports) {

$parcel$export(module.exports, "fetchIssueRemoteData", () => $0c2e88a5dd27b6f5$export$619c3be06a997564);
$parcel$export(module.exports, "fetchIssueConfluenceWhiteboardData", () => $0c2e88a5dd27b6f5$export$886e1cd5d478fbe5);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $487fd = parcelRequire("487fd");

var $fqpdr = parcelRequire("fqpdr");

var $fKtck = parcelRequire("fKtck");

var $dvijh = parcelRequire("dvijh");

var $POnYB = parcelRequire("POnYB");

var $gxWw1 = parcelRequire("gxWw1");

var $gmIuw = parcelRequire("gmIuw");
const $0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD = 5;
const $0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING = '-created';
const $0c2e88a5dd27b6f5$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $dvijh.COMMENTS));
    return hasPermalink ? `, commentId: ${permalinkId}` : '';
};
const $0c2e88a5dd27b6f5$var$LOG_LOCATION = 'issue.data-provider.source.issue-express.graphql';
const $0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $0c2e88a5dd27b6f5$var$addQueryForRemoteLinks = ()=>`remoteLinks {
       isLinkingEnabled
       confluencePages {
         linkedPages {
            pageCount
         }
         mentionedPages {
            pageCount
         }
       }
     }`;
const $0c2e88a5dd27b6f5$var$getCommentsQuery = ()=>{
    const commentAmountParameter = `, commentAmount: ${Math.floor($0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD / 2)}`;
    const orderByParameter = `, orderBy: "${$0c2e88a5dd27b6f5$var$CREATED_ORDER_DESCENDING}"`;
    const query = `comments (first: 0, maxResults: ${$0c2e88a5dd27b6f5$var$NUM_INITIAL_COMMENTS_TO_LOAD}${orderByParameter}, isPreview: true ${$0c2e88a5dd27b6f5$var$commentParameter()}${commentAmountParameter}) {
            nodes{
              id
              author {
                  accountId
                  displayName
                  avatarUrl
              }
              updateAuthor {
                  accountId
                  displayName
                  avatarUrl
              }
              visibility {
                  type
                  value
              }
              created
              updated
              jsdPublic
              bodyAdf
              jsdAuthorCanSeeRequest
            }
            totalCount
            startIndex
          }
        `;
    return query;
};
const $0c2e88a5dd27b6f5$export$895cf5b64d42d88d = ()=>`
        issueId
        fields {
            __typename

            ... on ProjectField {
                fieldKey
                type
                simplified
                name
            }

            ... on TextField {
                fieldKey
                title
                isEditable
                textValue
                adf
                renderer
            }

            ... on IssueTypeField {
              fieldKey
              id
              iconUrl
              name
            }

            ... on StatusField {
              fieldKey
              name
              statusCategoryId
            }

            ... on IssueKeyField {
              fieldKey
              stringValue
            }

            ... on PriorityField {
              fieldKey
              title
              isEditable
              iconUrl
              name
              id
            }

            ... on UserField {
              fieldKey
              title
              isEditable
              userValue {
                displayName
                avatarUrl
                accountId
              }
            }

            ... on VersionsField {
              fieldKey
              title
              isEditable
              versions {
                id
                name
              }
            }

            ... on LabelsField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on ProjectComponentsField {
              fieldKey
              title
              isEditable
              componentValues {
                id
                name
              }
            }

            ... on TimeTrackingField {
              fieldKey
              title
              isEditable
              originalEstimate {
                estimateSeconds
              }
              remainingEstimate {
                estimateSeconds
              }
              timeSpent {
                estimateSeconds
              }
            }

            ... on StoryPointsField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on EpicLinkField {
              fieldKey
              title
              isEditable
              epic {
                id
                key
                name
                summary
                colorKey
                done
              }
            }

            ... on EpicNameField {
              fieldKey
              stringValue
              title
              isEditable
            }

            ... on EpicStatusField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on SprintCustomField {
              fieldKey
              title
              isEditable
              values {
                id
                name
                goal
                state
                boardId
                startDate
                endDate
                completeDate
              }
            }

            ... on SelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
              }
            }

            ... on CascadingSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValue {
                  optionId
                  value
                  child {
                    optionId
                    value
                  }
              }
            }

            ... on UserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUser {
                displayName
                avatarUrl
              }
            }

            ... on TextAreaCustomField {
              fieldKey
              title
              isEditable
              wiki
              adf
              renderer
              textValue
            }

            ... on FloatCustomField {
              fieldKey
              title
              isEditable
              floatValue
            }

            ... on DatePickerCustomField {
              fieldKey
              title
              isEditable
              stringValue
            }

            ... on DateTimeCustomField {
              fieldKey
              title
              isEditable
              dateTime
            }

            ... on TextFieldCustomField {
              fieldKey
              title
              isEditable
              wiki
            }

            ... on MultiSelectCustomField {
              fieldKey
              title
              isEditable
              selectedValues {
                  optionId
                  value
              }
            }

            ... on LabelsCustomField {
              fieldKey
              title
              isEditable
              labels
            }

            ... on MultiUserPickerCustomField {
              fieldKey
              title
              isEditable
              selectedUsers {
                accountId
                displayName
                avatarUrl
              }
            }

            ... on UrlCustomField {
              fieldKey
              title
              isEditable
              url
            }

            ... on VersionCustomField {
              fieldKey
              title
              isEditable
              version {
                  id
                  name
              }
            }

            ... on GroupPickerCustomField {
              fieldKey
              title
              isEditable
              group
            }

            ... on MultiVersionCustomField {
              fieldKey
              title
              isEditable
              versions {
                  id
                  name
              }
            }

            ... on MultiGroupPickerCustomField {
              fieldKey
              title
              isEditable
              groups
            }

            ... on DateField {
              fieldKey
              stringValue
              isEditable
              title
            }

            ... on CheckBoxesCustomField {
                fieldKey
                isEditable
                title
                selectedValues {
                    optionId
                    value
                }
            }

            ... on RadioButtonsCustomField {
                fieldKey
                isEditable
                title
                selectedValue {
                    optionId
                    value
                }
            }

            ... on ColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on EpicColorField {
                fieldKey
                isEditable
                title
                stringValue
            }

            ... on ResolutionField {
                id
                fieldKey
                name
            }

            ... on FlaggedCustomField {
                fieldKey
                title
                isFlagged
                isEditable
                selectedValues {
                    optionId
                    value
                }
            }

            ... on ProjectCustomField {
              fieldKey
              key
              name
              title
              avatarUrl
              isEditable
            }
        }
        ${$0c2e88a5dd27b6f5$var$addQueryForRemoteLinks()}
        ${$0c2e88a5dd27b6f5$var$getCommentsQuery()}
    `;
const $0c2e88a5dd27b6f5$var$getQueryPrefix = ()=>'_all';
const $0c2e88a5dd27b6f5$var$getFieldPinningPreference = (projectKey)=>projectKey != null ? `"jira.user.issue.details.pinned-fields.${projectKey}",` : '';
const $0c2e88a5dd27b6f5$var$getQueryForMyPreferences = (projectKey)=>`
    myPreferences(keys: [
        "jira.user.issue.changeboarding.lastinteracted",
        "jira.user.issue.clickthrough-banner.lastinteracted",
        "jira.user.issue.pinned-fields-banner.lastinteracted",
        ${$0c2e88a5dd27b6f5$var$getFieldPinningPreference(projectKey)}
    ])`;
const $0c2e88a5dd27b6f5$var$getProjectQueryFragment = (projectKey)=>`
    project(projectKey: "${projectKey}") {
        newIssueViewLockedIn
    }
`;
const $0c2e88a5dd27b6f5$export$71eec30d9db46a56 = (projectKey)=>`query issueViewQuery($issueKey: String!) {
    ${$0c2e88a5dd27b6f5$var$getQueryForMyPreferences(projectKey)}
    ${projectKey !== undefined ? $0c2e88a5dd27b6f5$var$getProjectQueryFragment(projectKey) : ''}
    ${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${$0c2e88a5dd27b6f5$var$getQueryPrefix()}: viewIssue(issueKey: $issueKey) {
        ${$0c2e88a5dd27b6f5$export$895cf5b64d42d88d()}
    }
    activitySortOrder
}
`;
const $0c2e88a5dd27b6f5$var$getFieldDataOptions = (query, variables)=>({
        method: 'POST',
        body: JSON.stringify({
            query: query,
            variables: variables
        }),
        perf: (0, $POnYB.fetchIssueExpressPerf)
    });
const $0c2e88a5dd27b6f5$export$619c3be06a997564 = (baseUrl, issueKey)=>(0, $487fd.default)((0, $fqpdr.getGiraUrl)(baseUrl, 'issueViewRemoteDataQuery'), $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, $gxWw1.getIssueRemoteDataQuery)(), {
        issueKey: issueKey
    }))// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GraphqlResponse<ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse>'.
    .map((response)=>(0, $gmIuw.getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response))// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`bentoViewIssue${string}`' can't be used to index type 'ViewIssueGraphqlResponse | ViewMultipleIssueGraphqlResponse'.
    .map((value)=>value[`${$0c2e88a5dd27b6f5$var$VIEW_ISSUE_ALIAS}${(0, $gxWw1.getRemoteDataQueryPrefix)()}`]);
const $0c2e88a5dd27b6f5$export$886e1cd5d478fbe5 = (issueId, cloudId)=>(0, $487fd.default)('/gateway/api/graphql?operation=issueViewRemoteConfluenceWhiteboardQuery', $0c2e88a5dd27b6f5$var$getFieldDataOptions((0, $gxWw1.getIssueRemoteConfluenceWhiteboardQuery)(), {
        id: `ari:cloud:jira:${cloudId}:issue/${issueId}`
    })).map((response)=>(0, $gmIuw.getGraphQlData)($0c2e88a5dd27b6f5$var$LOG_LOCATION, response));

});
parcelRegister("fKtck", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $11ab2af1eff70e7f$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $11ab2af1eff70e7f$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $11ab2af1eff70e7f$export$b66f3e03c722c21c);

var $8QpSo = parcelRequire("8QpSo");

var $ebyGx = parcelRequire("ebyGx");

var $dvijh = parcelRequire("dvijh");
const $11ab2af1eff70e7f$export$58d3deae755361f = (0, $8QpSo.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parseUrl(searchString).query;
    if (params[(0, $dvijh.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $dvijh.COMMENTS),
        permalinkId: params[(0, $dvijh.PermalinkType).COMMENTS]
    };
    if (params[(0, $dvijh.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $dvijh.WORKLOG),
        permalinkId: params[(0, $dvijh.PermalinkType).WORKLOG]
    };
    return null;
});
const $11ab2af1eff70e7f$export$f72cac1fa8a03e80 = ()=>$11ab2af1eff70e7f$export$58d3deae755361f(window.location.search);
const $11ab2af1eff70e7f$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $11ab2af1eff70e7f$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $11ab2af1eff70e7f$export$b66f3e03c722c21c = (id, permalinkType)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $dvijh.PermalinkType).WORKLOG ? (0, $dvijh.PermalinkType).COMMENTS : (0, $dvijh.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});
parcelRegister("dvijh", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $1403612d0fe1296c$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $1403612d0fe1296c$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $1403612d0fe1296c$export$b18d061fc042df1a);
const $1403612d0fe1296c$export$4cab9dfa8fc858f4 = 'Comments';
const $1403612d0fe1296c$export$df36fc05622c402 = 'Worklog';
const $1403612d0fe1296c$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});


parcelRegister("POnYB", function(module, exports) {

$parcel$export(module.exports, "fetchIssueExpressPerf", () => $a1e38295f63ccee3$export$9040f8aef1f66451);
const $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST = 'FETCH_ISSUE_EXPRESS';
const $a1e38295f63ccee3$export$9040f8aef1f66451 = {
    key: $a1e38295f63ccee3$var$FETCH_ISSUE_EXPRESS_REQUEST,
    prefix: $a1e38295f63ccee3$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});

parcelRegister("gxWw1", function(module, exports) {

$parcel$export(module.exports, "getRemoteDataQueryPrefix", () => $12e83d615b5da262$export$1a164444721ce2fb);
$parcel$export(module.exports, "getIssueRemoteDataQuery", () => $12e83d615b5da262$export$65f9808f978ee25);
$parcel$export(module.exports, "getIssueRemoteConfluenceWhiteboardQuery", () => $12e83d615b5da262$export$8ec691b48e552cf4);
const $12e83d615b5da262$var$VIEW_ISSUE_ALIAS = 'bentoViewIssue';
const $12e83d615b5da262$var$getUserQueryFragment = ()=>`
    user {
        key
        accountId
        emailAddress
        avatarUrl
        displayName
        active
    }
`;
const $12e83d615b5da262$var$getConfluencePagesQueryFragment = ()=>`
    pages {
        ... on ConfluencePage {
            id
            globalId
            href
            title
            type
            lastUpdatedContext {
                ${$12e83d615b5da262$var$getUserQueryFragment()}
            }
        }
        ... on FailedRemoteLink {
            id
            error
            link {
                id
                globalId
                href
            }
            repairLink { href }
        }
    }
`;
const $12e83d615b5da262$var$getConfluencePageGroupQueryFragment = ()=>`
    pageCount
    ${$12e83d615b5da262$var$getConfluencePagesQueryFragment()}
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $12e83d615b5da262$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$12e83d615b5da262$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $12e83d615b5da262$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$12e83d615b5da262$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $12e83d615b5da262$export$761fd517f0dda983 = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $12e83d615b5da262$var$getRemoteDataQueryFragment = ()=>`
    issueId
    remoteLinks {
       isLinkingEnabled
       confluencePages {
            linkedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
            mentionedPages {
                ${$12e83d615b5da262$var$getConfluencePageGroupQueryFragment()}
            }
        }
        ${$12e83d615b5da262$export$761fd517f0dda983()}
        ${$12e83d615b5da262$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $12e83d615b5da262$export$1a164444721ce2fb = ()=>'_remote_data';
const $12e83d615b5da262$export$65f9808f978ee25 = ()=>`
    query issueViewRemoteDataQuery($issueKey: String!) {
        ${$12e83d615b5da262$var$VIEW_ISSUE_ALIAS}${$12e83d615b5da262$export$1a164444721ce2fb()}: viewIssue(issueKey: $issueKey) {
            ${$12e83d615b5da262$var$getRemoteDataQueryFragment()}
        }
    }
`;
const $12e83d615b5da262$export$8ec691b48e552cf4 = ()=>`
    query issueViewRemoteConfluenceWhiteboardQuery($id: ID!) {
        graphStore @optIn(to: "GraphStore") {
            issueToWhiteboard (id: $id first: 900) @optIn(to: "GraphStoreIssueToWhiteboard") {
                edges {
                    node {
                        ... on ConfluenceWhiteboard {
                            id
                            links {
                                base
                                webUi
                            }
                            author {
                                user {
                                accountId
                                accountStatus
                                name
                                picture
                                }
                            }
                            title
                            whiteboardId
                        }
                    }
                }
                totalCount
            }
        }
    }
`;

});

parcelRegister("gmIuw", function(module, exports) {

$parcel$export(module.exports, "getGraphQlData", () => $cfd7686b41fd6499$export$b30cdd26702abb9d);
$parcel$export(module.exports, "checkEmptyResponse", () => $cfd7686b41fd6499$export$a0603b0ff181c30a);

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $g81XS = parcelRequire("g81XS");
const $cfd7686b41fd6499$export$b30cdd26702abb9d = (logLocation, graphQlResponse)=>{
    if (graphQlResponse.errors) {
        const firstError = graphQlResponse.errors[0];
        const validationError = new (0, $jJZqs.ValidationError)(firstError.message);
        (0, $dJl1T.default).safeErrorWithoutCustomerData(logLocation, 'getGraphQlData: Error present in GraphQL response', validationError);
        throw validationError;
    }
    return graphQlResponse.data;
};
const $cfd7686b41fd6499$var$emptyResponseText = 'Response is either not present or has no data.';
const $cfd7686b41fd6499$export$a0603b0ff181c30a = (response)=>{
    if (!response || !Object.prototype.hasOwnProperty.call(response, 'data')) throw new (0, $g81XS.NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
    if (response.data === null) throw new (0, $g81XS.NoDataError)($cfd7686b41fd6499$var$emptyResponseText);
    return response;
};

});
parcelRegister("g81XS", function(module, exports) {

$parcel$export(module.exports, "NoDataError", () => $7410460e4f0e390b$export$5faf0a0592e30f56);
class $7410460e4f0e390b$export$5faf0a0592e30f56 extends Error {
}

});



const $a620d3896f16afcc$export$40bed7a29c3b629 = 'IssueKeyField';








parcelRegister("gz8lb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb506c130e0fe88$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jiRmc = parcelRequire("jiRmc");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $azrUb = parcelRequire("azrUb");
const $ffb506c130e0fe88$var$Realtime = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const realtimeChannels = (0, $c1MAf.useBacklogSelector)((0, $azrUb.realtimeChannelsSelector));
    if (realtimeChannels?.length === 0) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
        appId: (0, $guzeq.APP_ID),
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        channels: realtimeChannels
    }, props.children);
});
var $ffb506c130e0fe88$export$2e2bcd8739ae039 = $ffb506c130e0fe88$var$Realtime;

});
parcelRegister("jiRmc", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $db014a952af56f77$export$64d242981d970821);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $dJl1T = parcelRequire("dJl1T");

var $2OMDV = parcelRequire("2OMDV");

var $fjcgS = parcelRequire("fjcgS");


var $bYYrF = parcelRequire("bYYrF");

var $1eGpy = parcelRequire("1eGpy");

var $FPIEb = parcelRequire("FPIEb");

const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("50Dc0")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('realtime.channel.join.failure', `Failed to join channel @ ${appId}`, error);
    });
const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $dJl1T.default).safeErrorWithoutCustomerData('realtime.channel.leave.failure', `Failed to left channel @ ${appId}`, error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels } = this.props;
        this.isComponentMounted = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel);
            $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel);
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            client: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result.currentChannels));
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result.currentChannels));
        };
        this.isComponentMounted = false;
    }
}
const $db014a952af56f77$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $db014a952af56f77$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, $1eGpy.withHost), (0, $FPIEb.withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;

});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("1eGpy", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $af5e53f160713d44$export$b2d89aaea1461cd9);

var $5uXOq = parcelRequire("5uXOq");

var $4h0Jz = parcelRequire("4h0Jz");
function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            host: (0, $4h0Jz.getDefaultPubSubHost)()
        });
}
var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;

});
parcelRegister("4h0Jz", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $15272668181566a5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $15272668181566a5$export$354e43de513ff5);

var $j8DrX = parcelRequire("j8DrX");

const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, $j8DrX.default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("FPIEb", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $5962bf1fe62742cb$export$4b38d0b01368c3f4);

var $5uXOq = parcelRequire("5uXOq");
function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;

});

parcelRegister("50Dc0", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("cM9em"),
    $6fhBS("fr9NE"),
    $6fhBS("avdBG")
]).then(()=>parcelRequire('acKtV'));

});


parcelRegister("azrUb", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelsSelector", () => $f7ddc6bb65b350d8$export$3d8a5aabe9d41ff7);

var $dGvGJ = parcelRequire("dGvGJ");

var $4h0Jz = parcelRequire("4h0Jz");

var $jG5HW = parcelRequire("jG5HW");
const $f7ddc6bb65b350d8$export$3d8a5aabe9d41ff7 = (0, $dGvGJ.createSelector)((0, $jG5HW.getCloudId), (0, $jG5HW.getProjectIds), (cloudId, projectIds)=>projectIds.map((projectId)=>(0, $4h0Jz.buildChannelString)(cloudId, projectId)));

});


parcelRegister("1UKUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b3b6d5da541e81$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k12ix = parcelRequire("k12ix");

var $5rqex = parcelRequire("5rqex");

var $9wkw7 = parcelRequire("9wkw7");


var $b0yad = parcelRequire("b0yad");

var $f6RVN = parcelRequire("f6RVN");

var $8hVbJ = parcelRequire("8hVbJ");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $fmuR9 = parcelRequire("fmuR9");

var $eoB0b = parcelRequire("eoB0b");

var $fSgHa = parcelRequire("fSgHa");

var $6MzeB = parcelRequire("6MzeB");
// Also fire BM3 metric.mark() for custom timings, on top of performance.mark() invocations
const $f3b3b6d5da541e81$var$SubmitApdexContainer = ({ isCacheHit: isCacheHit })=>{
    const issueNo = (0, $c1MAf.useBacklogSelector)((state)=>(0, $dGljH.cardsSelector)(state).length);
    const epicsNo = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentIdsSelector)(state).length);
    const issueChildrenNo = (0, $c1MAf.useBacklogSelector)((0, $dGljH.numTotalIssueChildren));
    const cardListCounts = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getCardListStats));
    const backlogSessionId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getSessionId));
    const boardId = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getRapidViewId));
    const metric = (0, $6MzeB.usePerformanceMetric)();
    const isClassic = (0, $fSgHa.useIsCMPBacklog)();
    const { cohort: whiteboardCohort } = (0, $c1MAf.useBacklogSelector)((0, $eoB0b.getWhiteboardEligibility));
    const extra = (0, $5uXOq.useMemo)(()=>({
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            isCacheHit: isCacheHit,
            cacheInvalidationReasons: (0, $b0yad.getAndClearInvalidationReasons)((0, $8631d6ce464ccf2e$export$dedbdcc35e955187)).join(','),
            issueNo: issueNo,
            epicsNo: epicsNo,
            issueChildrenNo: issueChildrenNo,
            backlogSessionId: backlogSessionId,
            boardId: boardId,
            ...cardListCounts,
            isSentryEnabled: String((0, $f6RVN.isErrorTrackingEnabledWithSentry)()),
            isPrefetchIssueDataByRankEnabled: false,
            isUIF: true,
            isClassic: isClassic,
            jswSprintPlanningWhiteboards: whiteboardCohort
        }), [
        isCacheHit,
        issueNo,
        epicsNo,
        issueChildrenNo,
        backlogSessionId,
        boardId,
        cardListCounts,
        isClassic,
        whiteboardCohort
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $9wkw7.pushEarlyMarksToBrowserMetrics)(metric, {
            marks: {
                BACKLOG_FETCH_START: (0, $8hVbJ.JSW_CRITICAL_RESOURCE_START),
                'jira.fe.spa-prefetchApiReady': (0, $8hVbJ.JSW_CRITICAL_RESOURCE_END),
                USE_RESOURCE_START_MARK: (0, $8hVbJ.USE_RESOURCE_START),
                USE_RESOURCE_READY_MARK: (0, $8hVbJ.USE_RESOURCE_READY),
                'render:start': (0, $8hVbJ.RENDER_START),
                'render:end': (0, $8hVbJ.RENDER_END),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:start': (0, $8hVbJ.CRITICAL_RELAY_RESOURCE_GET_DATA_START),
                'relay_resource_get_data:NEXTGEN_BACKLOG_RELAY:end': (0, $8hVbJ.CRITICAL_RELAY_RESOURCE_GET_DATA_END)
            }
        });
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        extra: extra,
        appName: "software-backlog",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: metric,
        emitOnAnimationFrame: (0, $f6RVN.emitApdexOnAnimationFrame)()
    });
};
var $f3b3b6d5da541e81$export$2e2bcd8739ae039 = $f3b3b6d5da541e81$var$SubmitApdexContainer;

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $co1wz = parcelRequire("co1wz");

var $gshwr = parcelRequire("gshwr");

var $14hPy = parcelRequire("14hPy");

var $6InPJ = parcelRequire("6InPJ");

var $5GhjE = parcelRequire("5GhjE");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $co1wz.ff)('uip.ufo') && (0, $5GhjE.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gshwr.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $14hPy.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $6InPJ.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("14hPy", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $aa4ac710ea08d6d6$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $aa4ac710ea08d6d6$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $aa4ac710ea08d6d6$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $fwf6E = parcelRequire("fwf6E");

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");
function $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $aa4ac710ea08d6d6$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $fwf6E.default));
    const interactionId = (0, $6InPJ.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bBkFW.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $aa4ac710ea08d6d6$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $6InPJ.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bBkFW.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $aa4ac710ea08d6d6$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bBkFW.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $19hl5 = parcelRequire("19hl5");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $co1wz = parcelRequire("co1wz");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

var $fwf6E = parcelRequire("fwf6E");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $co1wz.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
            (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $co1wz.ff)('bm3.wait-for-long-task') ? (0, $19hl5.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                    (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                }
                if ((0, $co1wz.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $co1wz.ff)('bm3.emit-on-raf.top-experiences') && (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $fwf6E.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $fwf6E = parcelRequire("fwf6E");

var $5GhjE = parcelRequire("5GhjE");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $5GhjE.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $5GhjE.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $fwf6E.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bBkFW.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $6InPJ = parcelRequire("6InPJ");

var $bBkFW = parcelRequire("bBkFW");

var $5GhjE = parcelRequire("5GhjE");
var $epSI1 = parcelRequire("epSI1");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $5GhjE.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $epSI1.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bBkFW.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $y7eb2 = parcelRequire("y7eb2");

var $6InPJ = parcelRequire("6InPJ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $6InPJ.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9wkw7", function(module, exports) {

$parcel$export(module.exports, "pushEarlyMarksToBrowserMetrics", () => $18c0c41d8db3822c$export$b7c0f32f0c63e86b);
const $18c0c41d8db3822c$export$2f0748f9bcbd5ff0 = {
    'jira.fe-spa.software.early-preload:start': 'EARLY_FETCH_START',
    'jira.fe-spa.software.early-preload:end': 'EARLY_FETCH_END'
};
const $18c0c41d8db3822c$export$b7c0f32f0c63e86b = (metric, options)=>{
    const marks = {
        ...$18c0c41d8db3822c$export$2f0748f9bcbd5ff0,
        ...options?.marks ?? {}
    };
    Object.keys(marks).forEach((mark)=>{
        const startTime = performance.getEntriesByName(mark)[0]?.startTime;
        if (startTime != null) metric.mark(marks[mark], startTime);
    });
};

});


parcelRegister("4MJfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1ef070d9e6909a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dIdda = parcelRequire("dIdda");

var $c1MAf = parcelRequire("c1MAf");

var $4mqko = parcelRequire("4mqko");

var $9g0YE = parcelRequire("9g0YE");

var $jG5HW = parcelRequire("jG5HW");

var $dGljH = parcelRequire("dGljH");

var $7xwsz = parcelRequire("7xwsz");
const $0d1ef070d9e6909a$var$SyncWithRoutingContainer = ()=>{
    const lastSelectedCardId = (0, $c1MAf.useBacklogSelector)((0, $dGljH.getLastSelectedCard));
    const setLastSelectedCardKeyAction = (0, $c1MAf.useBacklogActionCreator)((0, $4mqko.setLastSelectedCardKey));
    const setAllPanelsAction = (0, $c1MAf.useBacklogActionCreator)((0, $9g0YE.setAllPanels));
    const [{ action: action, location: location }] = (0, $dIdda.useRouter)();
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const props = {
        lastSelectedCardId: lastSelectedCardId,
        setLastSelectedCardKey: setLastSelectedCardKeyAction,
        setAllPanels: setAllPanelsAction,
        action: action,
        location: location,
        isCompanyManaged: isCompanyManaged
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xwsz.SyncWithRouting), props);
};
var $0d1ef070d9e6909a$export$2e2bcd8739ae039 = $0d1ef070d9e6909a$var$SyncWithRoutingContainer;

});
parcelRegister("7xwsz", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $afbd9af9da366f4c$export$6cfa8b91c03902d6);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

const $afbd9af9da366f4c$export$6cfa8b91c03902d6 = (props)=>{
    const { action: action, location: location, lastSelectedCardId: lastSelectedCardId, setLastSelectedCardKey: setLastSelectedCardKey, setAllPanels: setAllPanels, isCompanyManaged: isCompanyManaged = false } = props;
    const update = (0, $5uXOq.useCallback)(()=>{
        const { search: search } = location;
        const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
        if (!isCompanyManaged) setAllPanels();
        // Update Selected Card Key
        const selectedCardKeyFromParams = searchParams[0, $4f4a02cead13bb5a$export$3a0c4bc79274bbaa];
        if (!lastSelectedCardId && selectedCardKeyFromParams) setLastSelectedCardKey(selectedCardKeyFromParams);
    }, [
        location,
        lastSelectedCardId,
        setLastSelectedCardKey,
        setAllPanels,
        isCompanyManaged
    ]);
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!isMounted.current) {
            update();
            isMounted.current = true;
        }
    }, [
        update,
        isMounted
    ]);
    const loc = (0, $5uXOq.useRef)(location);
    (0, $5uXOq.useEffect)(()=>{
        if (action === 'POP' && loc.current !== location) update();
        loc.current = location;
    }, [
        action,
        location,
        update
    ]);
    return null;
};

});




parcelRegister("gshHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47ef8d075adac28$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3anEO = parcelRequire("3anEO");

var $c1MAf = parcelRequire("c1MAf");

var $likqC = parcelRequire("likqC");

var $jG5HW = parcelRequire("jG5HW");

var $fpDLy = parcelRequire("fpDLy");

var $lCFtU = parcelRequire("lCFtU");
// register root level data-providers here
const $a47ef8d075adac28$var$View = (props)=>{
    const { children: children, boardId: boardId } = props;
    const isCompanyManaged = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getIsCompanyManaged));
    const isVersionsFeatureEnabled = (0, $c1MAf.useBacklogSelector)((0, $fpDLy.isVersionsFeatureEnabled));
    const onFiltersChange = (0, $c1MAf.useBacklogActionCreator)((filters)=>(0, $likqC.setAllFilters)(filters));
    // onSetAllFilters is a redux action fired to sync filters
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3anEO.FiltersContainer), {
        boardId: boardId,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isCompanyManaged || isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lCFtU.VersionPanelEntrypointContextProvider), null, children));
};
var $a47ef8d075adac28$export$2e2bcd8739ae039 = $a47ef8d075adac28$var$View;

});
parcelRegister("3anEO", function(module, exports) {

$parcel$export(module.exports, "FiltersContainer", () => $3fad31ed9ec6979b$export$4e5fef3bf0d55c67);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $wKznQ = parcelRequire("wKznQ");

var $7JoAD = parcelRequire("7JoAD");


var $h3f3a = parcelRequire("h3f3a");

var $86mek = parcelRequire("86mek");

var $88tXZ = parcelRequire("88tXZ");

var $8QLN8 = parcelRequire("8QLN8");
const $3fad31ed9ec6979b$var$Container = (0, $7JoAD.createContainer)((0, $88tXZ.FiltersStore), {
    onInit: ()=>({ dispatch: dispatch }, { isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged, boardId: boardId })=>{
            // set initial filters from URL
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const { search: search } = window.location;
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
            let initialFilters = (0, $h3f3a.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled);
            if (isCompanyManaged && Object.entries(initialFilters).length === 0) initialFilters = (0, $wKznQ.getCachedFilters)('backlog', boardId) ?? {};
            dispatch((0, $86mek.setFilters)(initialFilters));
        }
});
const $3fad31ed9ec6979b$export$4e5fef3bf0d55c67 = ({ boardId: boardId, onFiltersChange: onFiltersChange, children: children, isVersionsFeatureEnabled: isVersionsFeatureEnabled, isCompanyManaged: isCompanyManaged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3fad31ed9ec6979b$var$Container, {
        scope: `${(0, $0904d0fa958edff5$export$37f04a6502d23030)}-${String(boardId)}`,
        onFiltersChange: onFiltersChange,
        isVersionsFeatureEnabled: isVersionsFeatureEnabled,
        isCompanyManaged: isCompanyManaged,
        boardId: boardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8QLN8.SyncWithRouting), {
        isVersionsFeatureEnabled: isVersionsFeatureEnabled
    })));

});
parcelRegister("h3f3a", function(module, exports) {

$parcel$export(module.exports, "getFiltersFromQuery", () => $45e427c2f325b4a6$export$7b8e59218dd68efc);
$parcel$export(module.exports, "getQueryFromFilters", () => $45e427c2f325b4a6$export$aad56ffdcf894f3b);

const $45e427c2f325b4a6$var$toArray = (x)=>Array.isArray(x) ? x : x.split(',');
const $45e427c2f325b4a6$export$7b8e59218dd68efc = (searchParams, isVersionsFeatureEnabled)=>{
    const filtersFromQuery = {};
    // search comes from old CMP
    if (searchParams[0, $0904d0fa958edff5$export$a181206198b7f50c]) filtersFromQuery[0, $0904d0fa958edff5$export$d597759d33be802e] = searchParams[0, $0904d0fa958edff5$export$a181206198b7f50c];
    if (searchParams[0, $0904d0fa958edff5$export$e39925d10cebc0b]) filtersFromQuery[0, $0904d0fa958edff5$export$d597759d33be802e] = searchParams[0, $0904d0fa958edff5$export$e39925d10cebc0b];
    if (searchParams[0, $0904d0fa958edff5$export$f78d8c81fcad32a2]) filtersFromQuery[0, $0904d0fa958edff5$export$f8f7545d2bb78afb] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$f78d8c81fcad32a2]);
    if (searchParams[0, $0904d0fa958edff5$export$e729d951ab128c3b]) filtersFromQuery[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$e729d951ab128c3b]);
    if (searchParams[0, $0904d0fa958edff5$export$8a2cab795731dc42]) filtersFromQuery[0, $0904d0fa958edff5$export$2a4f270075a033de] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$8a2cab795731dc42]);
    if (searchParams[0, $0904d0fa958edff5$export$392308739e657b75] && isVersionsFeatureEnabled) filtersFromQuery[0, $0904d0fa958edff5$export$a4ad2735b021c132] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$392308739e657b75]);
    if (searchParams[0, $0904d0fa958edff5$export$fa7b72626a2e0090]) filtersFromQuery[0, $0904d0fa958edff5$export$ebb48b08205007c5] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$fa7b72626a2e0090]);
    // quickFilters from the old CMP
    if (searchParams[0, $0904d0fa958edff5$export$163cc317352fc53e]) filtersFromQuery[0, $0904d0fa958edff5$export$68d693c35a8d8866] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$163cc317352fc53e]);
    if (searchParams[0, $0904d0fa958edff5$export$cb08ebea4a46cd29]) filtersFromQuery[0, $0904d0fa958edff5$export$68d693c35a8d8866] = $45e427c2f325b4a6$var$toArray(searchParams[0, $0904d0fa958edff5$export$cb08ebea4a46cd29]);
    return filtersFromQuery;
};
const $45e427c2f325b4a6$export$aad56ffdcf894f3b = (filters)=>({
        [(0, $0904d0fa958edff5$export$e39925d10cebc0b)]: filters[0, $0904d0fa958edff5$export$d597759d33be802e] || undefined,
        // Replace CMP search with text above
        [(0, $0904d0fa958edff5$export$a181206198b7f50c)]: undefined,
        [(0, $0904d0fa958edff5$export$f78d8c81fcad32a2)]: filters[0, $0904d0fa958edff5$export$f8f7545d2bb78afb] ? filters[0, $0904d0fa958edff5$export$f8f7545d2bb78afb].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$e729d951ab128c3b)]: filters[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7] ? filters[0, $0904d0fa958edff5$export$37aee82a3cb1e8f7].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$8a2cab795731dc42)]: filters[0, $0904d0fa958edff5$export$2a4f270075a033de] ? filters[0, $0904d0fa958edff5$export$2a4f270075a033de].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$fa7b72626a2e0090)]: filters[0, $0904d0fa958edff5$export$ebb48b08205007c5] ? filters[0, $0904d0fa958edff5$export$ebb48b08205007c5].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$392308739e657b75)]: filters[0, $0904d0fa958edff5$export$a4ad2735b021c132] ? filters[0, $0904d0fa958edff5$export$a4ad2735b021c132].join(',') : undefined,
        [(0, $0904d0fa958edff5$export$cb08ebea4a46cd29)]: filters[0, $0904d0fa958edff5$export$68d693c35a8d8866] ? filters[0, $0904d0fa958edff5$export$68d693c35a8d8866].join(',') : undefined,
        // Replace CMP quickFilter with customFilter
        [(0, $0904d0fa958edff5$export$163cc317352fc53e)]: undefined
    });

});

parcelRegister("8QLN8", function(module, exports) {

$parcel$export(module.exports, "SyncWithRouting", () => $6801f19dd5932cce$export$6cfa8b91c03902d6);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3hGWp = parcelRequire("3hGWp");


var $h3f3a = parcelRequire("h3f3a");

var $88tXZ = parcelRequire("88tXZ");
const $6801f19dd5932cce$export$6cfa8b91c03902d6 = /*#__PURE__*/ (0, $5uXOq.memo)(({ isVersionsFeatureEnabled: isVersionsFeatureEnabled })=>{
    const [filters, { setFilters: setFilters }] = (0, $88tXZ.useFilters)();
    const [queryParams, setQueryParams] = (0, $3hGWp.useQueryParams)((0, $0904d0fa958edff5$export$e39925d10cebc0b), (0, $0904d0fa958edff5$export$a181206198b7f50c), (0, $0904d0fa958edff5$export$f78d8c81fcad32a2), (0, $0904d0fa958edff5$export$e729d951ab128c3b), (0, $0904d0fa958edff5$export$8a2cab795731dc42), (0, $0904d0fa958edff5$export$fa7b72626a2e0090), (0, $0904d0fa958edff5$export$392308739e657b75), (0, $0904d0fa958edff5$export$cb08ebea4a46cd29), (0, $0904d0fa958edff5$export$163cc317352fc53e));
    const filtersFromQuery = (0, $5uXOq.useMemo)(()=>(0, $h3f3a.getFiltersFromQuery)(queryParams, isVersionsFeatureEnabled), [
        isVersionsFeatureEnabled,
        queryParams
    ]);
    const filtersRef = (0, $5uXOq.useRef)(filtersFromQuery);
    const queryFromFilters = (0, $5uXOq.useMemo)(()=>(0, $h3f3a.getQueryFromFilters)(filters), [
        filters
    ]);
    // set as initially empty so we can sync the query parameters from the filters store
    const routeRef = (0, $5uXOq.useRef)({
        [(0, $0904d0fa958edff5$export$e39925d10cebc0b)]: undefined,
        [(0, $0904d0fa958edff5$export$a181206198b7f50c)]: undefined,
        [(0, $0904d0fa958edff5$export$f78d8c81fcad32a2)]: undefined,
        [(0, $0904d0fa958edff5$export$e729d951ab128c3b)]: undefined,
        [(0, $0904d0fa958edff5$export$8a2cab795731dc42)]: undefined,
        [(0, $0904d0fa958edff5$export$fa7b72626a2e0090)]: undefined,
        [(0, $0904d0fa958edff5$export$392308739e657b75)]: undefined,
        [(0, $0904d0fa958edff5$export$cb08ebea4a46cd29)]: undefined,
        [(0, $0904d0fa958edff5$export$163cc317352fc53e)]: undefined
    });
    // set initial filters from URL (prev componentDidMount)
    (0, $5uXOq.useEffect)(()=>{
        // Sync state -> url
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryFromFilters, routeRef.current)) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParams, queryFromFilters)) setQueryParams(queryFromFilters);
            routeRef.current = queryFromFilters;
        }
    }, [
        setQueryParams,
        queryFromFilters,
        queryParams
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Sync url -> state
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filtersFromQuery, filtersRef.current)) {
            // check if filters state is already updated to prevent useless update
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filtersFromQuery, filters)) setFilters(filtersFromQuery);
            filtersRef.current = filtersFromQuery;
        }
    }, [
        filters,
        filtersFromQuery,
        setFilters
    ]);
    return null;
});

});


parcelRegister("lCFtU", function(module, exports) {

$parcel$export(module.exports, "VersionPanelEntrypointContextProvider", () => $a5227fd571b1570c$export$e87f6587ec389c16);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $dXq4S = parcelRequire("dXq4S");

var $3HX6K = parcelRequire("3HX6K");

var $koeKL = parcelRequire("koeKL");

var $93BDy = parcelRequire("93BDy");

var $8hVbJ = parcelRequire("8hVbJ");

var $4GPQ6 = parcelRequire("4GPQ6");

var $c1MAf = parcelRequire("c1MAf");

var $jG5HW = parcelRequire("jG5HW");

var $kuePT = parcelRequire("kuePT");
const $a5227fd571b1570c$export$e87f6587ec389c16 = ({ children: children })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isFirstRender = (0, $5uXOq.useRef)(true);
    const isLoaded = (0, $5uXOq.useRef)(false);
    const isVersionPanelOpen = (0, $kuePT.useIsVersionsPanelOpen)();
    const projectIds = (0, $c1MAf.useBacklogSelector)((0, $jG5HW.getProjectIds));
    const jiraProjectIds = projectIds.map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: String(id)
        }));
    const boardARI = (0, $93BDy.useBoardAri)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            after: null,
            first: 500,
            jiraProjectIds: jiraProjectIds,
            boardId: boardARI,
            shouldShowVersionPanel: !!jiraProjectIds.length
        }), [
        boardARI,
        cloudId,
        jiraProjectIds
    ]);
    const entryPointHookResult = (0, $4mO32.useEntryPoint)((0, $3HX6K.versionsPanelEntryPoint), entryPointParams, (0, $8hVbJ.versionsPanelLoad));
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoaded.current && isVersionPanelOpen) {
            entryPointHookResult.entryPointActions.load();
            isLoaded.current = true;
        } else if (isFirstRender.current) {
            // if panel is open on first render - load versions panel
            if (isVersionPanelOpen) entryPointHookResult.entryPointActions.load();
            isFirstRender.current = false;
        }
    }, [
        entryPointHookResult,
        isVersionPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4GPQ6.VersionPanelEntrypointContext).Provider, {
        value: entryPointHookResult
    }, children);
};

});
parcelRegister("3HX6K", function(module, exports) {

$parcel$export(module.exports, "versionsPanelEntryPoint", () => $c64b6f10df23ec8c$export$b707e1ce7d4339f2);

var $emydz = parcelRequire("emydz");

var $2Ftxm = parcelRequire("2Ftxm");

var $ikgNX = parcelRequire("ikgNX");

const $c64b6f10df23ec8c$export$b707e1ce7d4339f2 = (0, $ikgNX.createEntryPoint)({
    root: (0, $2Ftxm.JSResourceForInteraction)(()=>(parcelRequire("iPEqe")), {
        moduleId: "a6db963d"
    }),
    getPreloadProps: (variables)=>({
            queries: {
                versionsPanel: {
                    options: {
                        // have to add "as const" https://stackoverflow.com/questions/37978528/typescript-type-string-is-not-assignable-to-type
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $emydz.default,
                    variables: variables
                }
            }
        })
});

});
parcelRegister("emydz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9b068d712ed45ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8c904947f965e7671de274f54b7ef02e>>
 * @relayHash c129616ebc682e824d3bf3b37f2e3d91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c00b9b16fa88ad4906ee150e8b79e09ed8f9b75a4441ea5f608e420ef4295c2b

var $iWXRl = parcelRequire("iWXRl");
const $a9b068d712ed45ea$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "c00b9b16fa88ad4906ee150e8b79e09ed8f9b75a4441ea5f608e420ef4295c2b",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "jira",
                        "versionsForProjects"
                    ]
                }
            ]
        },
        "name": "uiVersionBacklogPanelRelayQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": (0, $iWXRl.default)
        }
    }
};
var $a9b068d712ed45ea$export$2e2bcd8739ae039 = $a9b068d712ed45ea$var$node;

});

parcelRegister("iPEqe", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = $6fhBS("btKss").then(()=>parcelRequire('4yyWF'));

});




parcelRegister("hzdKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b88614fc499447$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $10Ngv = parcelRequire("10Ngv");

var $guzeq = parcelRequire("guzeq");

var $c1MAf = parcelRequire("c1MAf");

var $3lZ6i = parcelRequire("3lZ6i");

var $fmuR9 = parcelRequire("fmuR9");
const $d4b88614fc499447$var$GICOnCloseHandler = ({ bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose })=>{
    const dispatch = (0, $c1MAf.useBacklogDispatch)();
    const issueParents = (0, $c1MAf.useBacklogSelector)((state)=>(0, $fmuR9.issueParentsSelector)(state));
    const storeFieldsActions = (0, $10Ngv.useStoreFields)({
        issueParents: issueParents
    });
    (0, $5uXOq.useEffect)(()=>{
        bindToOnJiraGlobalIssueCreateClose((_, issues)=>{
            dispatch((0, $3lZ6i.refreshDataRequest)((0, $guzeq.REFRESH_SOURCE_GLOBAL_ISSUE_CREATE), issues, storeFieldsActions));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
var $d4b88614fc499447$export$2e2bcd8739ae039 = $d4b88614fc499447$var$GICOnCloseHandler;

});


parcelRegister("9kARR", function(module, exports) {

$parcel$export(module.exports, "SuspenseTrackerProvider", () => $e05a0c2231be48ec$export$58f6796252ab3147);
$parcel$export(module.exports, "SuspenseTrackerFallback", () => $e05a0c2231be48ec$export$8637c61d65a3606b);
$parcel$export(module.exports, "useGetHasSuspended", () => $e05a0c2231be48ec$export$a143cd14d496de4d);

var $5uXOq = parcelRequire("5uXOq");
class $e05a0c2231be48ec$export$87993bf75925b3bd {
    getHasSuspended() {
        return this.suspendCount !== 0;
    }
    /**
	 * Should be called on unmount of the tracked sub-tree
	 */ reset() {
        this.suspendCount = 0;
    }
    /**
	 * Should be called when a suspend happens
	 */ onSuspend() {
        this.suspendCount += 1;
    }
    constructor(){
        this.suspendCount = 0;
    }
}
const $e05a0c2231be48ec$var$SuspenseTrackerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
const $e05a0c2231be48ec$export$58f6796252ab3147 = ({ children: children })=>{
    const suspenseTrackerRef = (0, $5uXOq.useRef)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
    (0, $5uXOq.useEffect)(()=>()=>{
            suspenseTrackerRef.current?.reset();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e05a0c2231be48ec$var$SuspenseTrackerContext.Provider, {
        value: suspenseTrackerRef.current
    }, children);
};
const $e05a0c2231be48ec$export$8637c61d65a3606b = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    (0, $5uXOq.useEffect)(()=>{
        suspenseTracker.onSuspend();
    }, [
        suspenseTracker
    ]);
    return null;
};
const $e05a0c2231be48ec$export$a143cd14d496de4d = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    return suspenseTracker.getHasSuspended();
};

});

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $bNvU3 = parcelRequire("bNvU3");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNvU3.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1u3Jv = parcelRequire("1u3Jv");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u3Jv.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $6BZYo.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("hHoqo", function(module, exports) {

$parcel$export(module.exports, "BacklogCriticalDataBoundary", () => $7930a0ae1533d45b$export$70778fd35e1f4a0d);
// eslint-disable-next-line max-classes-per-file

var $5uXOq = parcelRequire("5uXOq");

var $ht021 = parcelRequire("ht021");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $5a0Nh = parcelRequire("5a0Nh");

var $gFU0Q = parcelRequire("gFU0Q");

var $01j5n = parcelRequire("01j5n");
class $7930a0ae1533d45b$var$AGGErrors extends (0, $ht021.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        });
        this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
    }
}
class $7930a0ae1533d45b$export$70778fd35e1f4a0d extends (0, $5uXOq.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.error && !state.capturedErrors) {
            // Look for errors in backend response
            const capturedGQLErrorsInfo = (0, $5a0Nh.stopCaptureGraphQlErrors)(props.errorCaptureKey);
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === props.backlogRootQueryName);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                capturedErrors: validGQLErrorsInfo.errors,
                capturedErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            capturedErrors: null
        };
    }
    render() {
        /* If there are no caught errors, render children as usual.
           This could mean there are optional GraphQL errors which won't be captured. If needed use @required to capture them. */ if (!this.state.error) return this.props.children;
        if (this.state.capturedErrors?.length) {
            const aggError = new $7930a0ae1533d45b$var$AGGErrors(this.state.capturedErrors, this.state.capturedErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.BacklogSlaTracker), {
                error: aggError
            });
        }
        // Capture the following errors related to backlog critical data the endpoint:
        // 1. Network errors
        // 2. RelayNetwork error - No data returned for operation
        if (this.state.error instanceof (0, $jJZqs.default) || (0, $01j5n.isUserNetworkError)(this.state.error) || (0, $fZneA.isClientFetchError)(this.state.error) || this.state.error.name === 'RelayNetwork') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.BacklogSlaTracker), {
            error: this.state.error
        });
        /* If the error is not something related to the backlog critical data, which we specifically handle above,
           we need to throw so upper error boundary (ExperienceTrackerProvider) can catch and handle it.
           These also include clientside Relay @required errors which doesn't have a corresponding GraphQL error in the backend response */ throw this.state.error;
    }
}

});

parcelRegister("fpQn9", function(module, exports) {

$parcel$export(module.exports, "useGetDataFromAGG", () => $4f821edfbf8fd2c1$export$f721677ef2b26eae);

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $loNZB = parcelRequire("loNZB");
const $4f821edfbf8fd2c1$export$f721677ef2b26eae = ({ cloudId: cloudId, boardId: boardId })=>{
    const [fetchError, setFetchError] = (0, $5uXOq.useState)();
    const getDataFromAGG = (0, $5uXOq.useCallback)(async (captureError = false)=>{
        const boardAri = (0, $dXq4S.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        });
        const variables = {
            boardId: boardAri,
            cloudId: cloudId
        };
        const fetchResponse$ = (0, $eiowN.fetchQuery)((0, $5yJb9.default)(), (0, $loNZB.default), variables);
        fetchResponse$.subscribe({
            error: captureError ? setFetchError : undefined
        });
        const responseData = await fetchResponse$.toPromise();
        if (!responseData) throw new Error(`${(0, $loNZB.default).params.name} returned undefined`);
        return responseData;
    }, [
        boardId,
        cloudId
    ]);
    if (fetchError) throw fetchError;
    return getDataFromAGG;
};

});

parcelRegister("5S6NV", function(module, exports) {

$parcel$export(module.exports, "isBacklogDisabledFromAggData", () => $7cbca13574813b5a$export$21ab9a52bb2020c0);

var $gBj4V = parcelRequire("gBj4V");

const $7cbca13574813b5a$export$386a9e1b526d9276 = (defaultUnit)=>{
    switch(defaultUnit.toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};
const $7cbca13574813b5a$export$8140cb9d29c60b3b = (format)=>{
    switch(format.toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $7cbca13574813b5a$export$21ab9a52bb2020c0 = (aggData)=>{
    if (!aggData || !aggData.boardScope || !aggData.boardScope.features) return true;
    const filteredFeatures = aggData.boardScope.features.filter(Boolean);
    const backlogFeature = filteredFeatures.some((feature)=>String(feature.key) === (0, $a64d16806d35fb92$export$dedbdcc35e955187) && String(feature.status) === (0, $a64d16806d35fb92$export$e927a5d1b72f0b68));
    return !backlogFeature;
};

});


parcelRegister("jVPfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62083da6b4fd29f$export$2e2bcd8739ae039);
parcelRequire("c4xqm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $x9xyg = parcelRequire("x9xyg");

var $cSD7y = parcelRequire("cSD7y");

var $ezRTW = parcelRequire("ezRTW");

var $dXq4S = parcelRequire("dXq4S");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $jgtyX = parcelRequire("jgtyX");

var $9SRRO = parcelRequire("9SRRO");

var $5Nutl = parcelRequire("5Nutl");

var $5uWNE = parcelRequire("5uWNE");

var $9dbF6 = parcelRequire("9dbF6");

var $gqLmL = parcelRequire("gqLmL");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");


var $ahuix = parcelRequire("ahuix");

var $1kij3 = parcelRequire("1kij3");
const $b62083da6b4fd29f$export$ad5cd5a1ff804acc = ()=>{
    const [paramProjectKey] = (0, $dIdda.usePathParam)('projectKey');
    const [boardIdStr] = (0, $dIdda.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const jiraPlanDataRestResource = (0, $dIdda.useResource)((0, $5Nutl.uifBacklogResourceOld));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!jiraPlanDataRestResource.data);
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(jiraPlanDataRestResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = jiraPlanDataRestResource;
    const { data: features } = (0, $ezRTW.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.projects?.length) {
            const jiraProjectIds = data.projects.map((project)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.projects
    ]);
    /**
   * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
   *
   * If features.hasBacklog is undefined but the resource has returned a 404 due to
   * the backlog being disabled, this error will be passed through to responseToSla in
   * the BacklogApp which will redirect to the projects page as a fallback.
   *
   * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $ahuix.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kij3.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        aggData: null,
        planModeData: data,
        planModeDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: jiraPlanDataRestResource,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey
    }));
};
const $b62083da6b4fd29f$export$dff34c560328b03c = ()=>{
    const [paramProjectKey] = (0, $dIdda.usePathParam)('projectKey');
    const [boardIdStr] = (0, $dIdda.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const projectKey = paramProjectKey ?? '';
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const uifBacklogDataResult = (0, $dIdda.useResource)((0, $5Nutl.uifBacklogResource));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!uifBacklogDataResult.data);
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(Boolean(uifBacklogDataResult.data?.isCacheHit));
    const isCacheHit = isCacheHitRef.current;
    const { data: data, promise: promise, loading: loading, error: error } = uifBacklogDataResult;
    const { data: features } = (0, $ezRTW.useFeatures)();
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        if (loadVersionFilterRelayQuery !== null && data?.result?.projects?.length) {
            const jiraProjectIds = data.result.projects.map((project)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'project',
                    resourceId: `${project.id}`
                }));
            loadVersionFilterRelayQuery({
                jiraProjectIds: jiraProjectIds,
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        tenantContext.cloudId,
        data?.result?.projects
    ]);
    /**
   * Redirect to the board only if the backlog is disabled. Do not redirect on timeout.
   *
   * If features.hasBacklog is undefined but the resource has returned a 404 due to
   * the backlog being disabled, this error will be passed through to responseToSla in
   * the BacklogApp which will redirect to the projects page as a fallback.
   *
   * */ if (loading === false && features?.hasBacklog === false) {
        const boardUrl = (0, $ahuix.getCMPBoardUrl)(projectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kij3.default), {
        rapidViewId: boardId,
        projectKeyFromContext: projectKey,
        projectIdFromContext: "",
        tenantContext: tenantContext,
        data: null,
        aggData: null,
        cmpBacklogData: data,
        cmpBacklogDataPromise: promise,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: uifBacklogDataResult,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey
    }));
};
var $b62083da6b4fd29f$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('indexeddb_cache_for_backlog', $b62083da6b4fd29f$export$dff34c560328b03c, $b62083da6b4fd29f$export$ad5cd5a1ff804acc);

});
parcelRegister("ezRTW", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $0396841ba6adfb11$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $hRzej = parcelRequire("hRzej");
const $0396841ba6adfb11$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $hRzej.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("hRzej", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $ec1c13e67ecdf44f$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");
const $ec1c13e67ecdf44f$export$9df5fa0a366163d2 = (data)=>{
    const { aiInfo: aiInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCalendar: hasCalendar, hasCode: hasCode, hasComponents: hasComponents, hasDeployments: hasDeployments, hasForms: hasForms, hasGoals: hasGoals, hasIncidents: hasIncidents, hasIssues: hasIssues, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasReports: hasReports, hasRequests: hasRequests, hasRoadmap: hasRoadmap, hasSecurity: hasSecurity, permissionInfo: permissionInfo } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasEditIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasCalendar: hasCalendar,
        hasCode: hasCode,
        hasComponents: hasComponents,
        hasDeployments: hasDeployments,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasGoals: hasGoals,
        hasIncidents: hasIncidents,
        hasIssues: hasIssues,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasReleases: hasReleases,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasRoadmap: hasRoadmap,
        hasSecurity: hasSecurity,
        hasSettings: (0, $co1wz.ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions : isProjectOrSiteAdmin,
        hasShortcutsAdd: isProjectOrSiteAdmin
    };
};

});


parcelRegister("5uWNE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdde1962c5219579$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iqr2y = parcelRequire("iqr2y");

var $bVDE5 = parcelRequire("bVDE5");
/**
 * Refresh the resource on mount if it's not already loading or stale, resource from prefetch will have 10s expiry time.
 */ const $fdde1962c5219579$var$RefreshResourceOnMount = ({ resource: resource, refreshOnExpired: refreshOnExpired })=>{
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    // Store these values once, we don't want the useEffect proccing more than once after mount
    const [isFullRender] = (0, $5uXOq.useState)(isInitialRender);
    const [hasCache, setHasCache] = (0, $5uXOq.useState)(false);
    const [hasRefreshed, setHasRefreshed] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (resource === null || hasRefreshed) return;
        // If we started loading set the cache miss flag to true. React-resource-router procs this
        // on page load
        if (resource.loading || refreshOnExpired && resource.expiresAt && resource.expiresAt > Date.now()) {
            setHasCache(true);
            return;
        }
        // If this is not a full render (i.e. a SPA transition)
        // And this is a cache miss (our requested resource never got set to loading true)
        if (!isFullRender && !hasCache) {
            resource.refresh();
            setHasRefreshed(true);
        }
    }, [
        hasRefreshed,
        hasCache,
        isFullRender,
        resource,
        refreshOnExpired
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $fdde1962c5219579$var$RefreshResourceOnMountWithBoundaries = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqr2y.ErrorBoundaryFlag), {
        id: "jira-software-resource-invalidator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fdde1962c5219579$var$RefreshResourceOnMount, props));
var $fdde1962c5219579$export$2e2bcd8739ae039 = $fdde1962c5219579$var$RefreshResourceOnMountWithBoundaries;

});

parcelRegister("gqLmL", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $89b567f441a32e03$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $jgyQq = parcelRequire("jgyQq");

var $7waah = parcelRequire("7waah");

var $liUyW = parcelRequire("liUyW");
const $89b567f441a32e03$export$2dc68d50d56fbbd = ()=>{
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    const { chartView: chartView, boardId: boardId, isBoardLocationless: isBoardLocationless, isReportsView: isReportsView, accountId: accountId } = (0, $jgyQq.useUrlState)();
    if (!data || error) return null;
    const boardName = data.scope && data.scope.name || '';
    if ((0, $gSBIZ.isUserContext)(data) && accountId) {
        const { user: user } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liUyW.UserBreadcrumbs), {
            accountId: accountId,
            boardId: Number(boardId),
            boardName: boardName,
            isReportsView: isReportsView,
            profileUrl: user.profileUrl,
            userName: user.name,
            chart: chartView,
            isLocationlessBoard: isBoardLocationless
        });
    }
    if ((0, $gSBIZ.isProjectContext)(data)) {
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7waah.ProjectBreadcrumbs), {
            baseUrl: "",
            boardId: Number(boardId),
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    }
    return null;
};

});
parcelRegister("jgyQq", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $1c5a5dbec5fedd96$export$6a582373474709af);

var $dIdda = parcelRequire("dIdda");

var $eZFkq = parcelRequire("eZFkq");
const $1c5a5dbec5fedd96$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $dIdda.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $eZFkq.getModeV2)(route) : (0, $eZFkq.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $eZFkq.toCamelCaseChartView)(match.params.chartView || '') : chart;
    const isReportsView = query && query.view === 'reporting';
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless,
        isReportsView: isReportsView
    };
};

});
parcelRegister("eZFkq", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $8f9b588eed549686$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $8f9b588eed549686$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $8f9b588eed549686$export$cc65f5a30b63da10);

var $e4eHl = parcelRequire("e4eHl");

var $65Ltd = parcelRequire("65Ltd");

const $8f9b588eed549686$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(chartView);
const $8f9b588eed549686$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'reporting':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};
const $8f9b588eed549686$export$cc65f5a30b63da10 = (route)=>{
    if (!route) return 0, $257789568f7508a4$export$77d6f70978850641;
    switch(route.name){
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_REPORT:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_REPORT:
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};

});
const $257789568f7508a4$export$77d6f70978850641 = 'work';
const $257789568f7508a4$export$c303e491e026ebc6 = 'plan';
const $257789568f7508a4$export$e3d31417f21c1ce7 = 'report';



parcelRegister("7waah", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $8abb6938d84ad6f7$export$38f8c59e2af08a87);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $4Fx92 = parcelRequire("4Fx92");
const $8abb6938d84ad6f7$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $5uXOq.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $4Fx92.messages).projectReportBreadcrumb),
            href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`
        }
    })));
});

});
parcelRegister("4Fx92", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aafea47193ed555$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aafea47193ed555$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("liUyW", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $3727e2d15103e5d8$export$74fdd5a0187b08ef);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $75PvK = parcelRequire("75PvK");

var $koVbs = parcelRequire("koVbs");

var $ikP65 = parcelRequire("ikP65");
const $3727e2d15103e5d8$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $5uXOq.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("ikP65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a2e9bc5bc00af22$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a2e9bc5bc00af22$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    userReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("1kij3", function(module, exports) {

$parcel$export(module.exports, "default", () => $284ba787b422c110$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $aaV7S = parcelRequire("aaV7S");

var $6BZYo = parcelRequire("6BZYo");

var $4R6GH = parcelRequire("4R6GH");

var $feJRr = parcelRequire("feJRr");

var $aJzGl = parcelRequire("aJzGl");

var $76Weg = parcelRequire("76Weg");

var $dPlT1 = parcelRequire("dPlT1");

var $dZw8H = parcelRequire("dZw8H");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $284ba787b422c110$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $284ba787b422c110$var$isBoardSizeLimit = (planDataResponse)=>planDataResponse.isIssueLimitExceeded;
const $284ba787b422c110$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, tenantContext: tenantContext, data: data, aggData: aggData, planModeData: planModeData, planModeDataPromise: planModeDataPromise, cmpBacklogData: cmpBacklogData, cmpBacklogDataPromise: cmpBacklogDataPromise, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, getDataFromAGG: getDataFromAGG, error: error, loading: loading })=>{
    // We are assuming that if we get a 400 error, it's because the user doesn't have access to the project for whatever reason
    // including project being deleted that is linked to the board in which we'd prompt the user to change the board's location.
    if (!loading && error && error.message === (0, $a64d16806d35fb92$export$912d9029af46d426)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
        rapidViewId: rapidViewId
    });
    const shouldRenderSkeleton = (0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? !cmpBacklogDataPromise : !planModeDataPromise;
    if (shouldRenderSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJzGl.NextGenBacklogSkeleton), null);
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog') ? cmpBacklogData && $284ba787b422c110$var$isBoardSizeLimit(cmpBacklogData.result) : planModeData && $284ba787b422c110$var$isBoardSizeLimit(planModeData)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dPlT1.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76Weg.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $284ba787b422c110$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        prefetchedAggData: aggData,
        prefetchedJiraPlanRestData: planModeData,
        prefetchedJiraPlanRestDataPromise: planModeDataPromise,
        prefetchCmpBacklogData: cmpBacklogData,
        prefetchCmpBacklogDataPromise: cmpBacklogDataPromise,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG,
        isCompanyManaged: true,
        // TODO: This is wrong
        projectName: projectKeyFromContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
var $284ba787b422c110$export$2e2bcd8739ae039 = $284ba787b422c110$var$BacklogApp;

});
parcelRegister("aaV7S", function(module, exports) {

$parcel$export(module.exports, "AsyncLocationlessDialog", () => $5875e6aa9017967d$export$15ccbdebadffcb56);

var $5uXOq = parcelRequire("5uXOq");

var $39xOx = parcelRequire("39xOx");

var $lfTZh = parcelRequire("lfTZh");

var $hPtZI = parcelRequire("hPtZI");

// TODO: FEBA-214 - convert to use EntryPoint (see https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138307/Tutorial+How+to+create+an+EntryPoint)
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5875e6aa9017967d$var$LazyComponent = (0, $hPtZI.lazy)(()=>(parcelRequire("kQH2l")), {
    moduleId: "./src/packages/board-location-dialogs/locationless/src/app.tsx"
});
const $5875e6aa9017967d$export$15ccbdebadffcb56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $39xOx.JSErrorBoundary), {
        id: "bundle-async-locationless-dialog",
        teamName: "a4t-pandora",
        packageName: "jiraBoardLocationDialogsLocationless"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "locationless-dialog-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5875e6aa9017967d$var$LazyComponent, {
        baseUrl: "",
        ...props
    })));

});
parcelRegister("kQH2l", function(module, exports) {

var $6fhBS = parcelRequire("6fhBS");
module.exports = Promise.all([
    $6fhBS("hPzOn"),
    $6fhBS("h2MrD"),
    $6fhBS("bYT2S"),
    $6fhBS("boUnd")
]).then(()=>parcelRequire('h6olf'));

});


parcelRegister("dPlT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f002878b2588702$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $89thI = parcelRequire("89thI");

var $4hGw3 = parcelRequire("4hGw3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $65Ltd = parcelRequire("65Ltd");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $dviIi = parcelRequire("dviIi");

var $c8ARX = parcelRequire("c8ARX");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $dIdda = parcelRequire("dIdda");

var $5CRhS = parcelRequire("5CRhS");

var $1Lvdv = parcelRequire("1Lvdv");

var $3MT7z = parcelRequire("3MT7z");
const $0f002878b2588702$var$issueLimitsIPHArticleId = '1KMwTxMBNiDPhaHMDlfT4u';
/**
 * TODO: update primaryAction to redirect to board filter via savedFilterId
 * TODO: accommodate TMP empty states by copying existing version
 */ const $0f002878b2588702$var$SizeLimitError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const [{ location: location }] = (0, $dIdda.useRouter)();
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage } = (0, $5uXOq.useMemo)(()=>(0, $3MT7z.getIssueLimitMessages)(name), [
        name
    ]);
    const boardSettingsUrl = `${location.pathname}?config=filter`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        ...(0, $4R6GH.fg)('jsw-size-limit-error-asset-consolidation') ? {
            renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
        } : {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dviIi)))
        },
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            href: boardSettingsUrl,
            appearance: "primary"
        }, formatMessage((0, $5CRhS.default).editFilter)),
        tertiaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            appearance: "link",
            articleId: $0f002878b2588702$var$issueLimitsIPHArticleId,
            fallbackComponent: null
        }, formatMessage((0, $5CRhS.default).moreLinkText))
    });
};
const $0f002878b2588702$var$SizeLimitErrorEmptyState = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $0f002878b2588702$var$containerStyles
    }, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Lvdv.SizeLimitErrorWithNoCTA), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f002878b2588702$var$SizeLimitError, null));
};
const $0f002878b2588702$var$containerStyles = (0, $jJ1Sb.xcss)({
    width: '100%'
});
var $0f002878b2588702$export$2e2bcd8739ae039 = $0f002878b2588702$var$SizeLimitErrorEmptyState;

});
parcelRegister("dviIi", function(module, exports) {
module.exports = new URL("error-loading-file.02dc84f6.svg", import.meta.url).toString();

});

parcelRegister("c8ARX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fefc6da4073af21$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mstqrh7gfrgxbc8ggp3w5jrj
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mstqrh7gfrgxbc8ggp3w5jrj

var $dCLgq = parcelRequire("dCLgq");

var $at4lO = parcelRequire("at4lO");
const $2fefc6da4073af21$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($at4lO)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($at4lO))
});
var $2fefc6da4073af21$export$2e2bcd8739ae039 = $2fefc6da4073af21$var$Illustration;
// for advanced use only
const $2fefc6da4073af21$export$a179c88182cb9d56 = [
    0,
    0,
    236,
    211
];

});
parcelRegister("at4lO", function(module, exports) {
module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();

});


parcelRegister("5CRhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8501f4d49e03f39$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $d8501f4d49e03f39$var$messages = (0, $7VHMR.defineMessages)({
    boardHeader: {
        "id": "software-size-limit-error-empty-state.board-header",
        "defaultMessage": "Too many issues to display the board"
    },
    backlogHeader: {
        "id": "software-size-limit-error-empty-state.backlog-header",
        "defaultMessage": "Too many issues to display the backlog"
    },
    timelineHeader: {
        "id": "software-size-limit-error-empty-state.timeline-header",
        "defaultMessage": "Too many issues to display the timeline"
    },
    boardDescription: {
        "id": "software-size-limit-error-empty-state.board-description",
        "defaultMessage": "The board can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    backlogDescription: {
        "id": "software-size-limit-error-empty-state.backlog-description",
        "defaultMessage": "The backlog can only display up to 5,000 issues at a time. Move or delete issues to continue using your backlog."
    },
    timelineDescription: {
        "id": "software-size-limit-error-empty-state.timeline-description",
        "defaultMessage": "The timeline can only display up to 5,000 issues at a time. Move or delete issues to continue using your timeline."
    },
    editFilter: {
        "id": "software-size-limit-error-empty-state.edit-filter",
        "defaultMessage": "Edit filter"
    },
    moreLinkText: {
        "id": "software-size-limit-error-empty-state.more-link-text",
        "defaultMessage": "More about issue limits"
    }
});
var $d8501f4d49e03f39$export$2e2bcd8739ae039 = $d8501f4d49e03f39$var$messages;

});

parcelRegister("1Lvdv", function(module, exports) {

$parcel$export(module.exports, "SizeLimitErrorWithNoCTA", () => $df14d8f608088d44$export$c0bbfc5b8cd7cce0);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $4R6GH = parcelRequire("4R6GH");

var $dviIi = parcelRequire("dviIi");

var $c8ARX = parcelRequire("c8ARX");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $enlND = parcelRequire("enlND");
const $df14d8f608088d44$export$c0bbfc5b8cd7cce0 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        ...(0, $4R6GH.fg)('jsw-size-limit-error-asset-consolidation') ? {
            renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $c8ARX.default))
        } : {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($dviIi)))
        },
        header: formatMessage((0, $enlND.default).header),
        description: formatMessage((0, $enlND.default).description)
    });
};

});
parcelRegister("enlND", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e7d6e770f65f431$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $9e7d6e770f65f431$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only work in projects with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    }
});
var $9e7d6e770f65f431$export$2e2bcd8739ae039 = $9e7d6e770f65f431$var$messages;

});


parcelRegister("3MT7z", function(module, exports) {

$parcel$export(module.exports, "getIssueLimitMessages", () => $75e0d55398e1041f$export$5c4dd481ffce3dbf);

var $65Ltd = parcelRequire("65Ltd");

var $5CRhS = parcelRequire("5CRhS");
const $75e0d55398e1041f$export$5c4dd481ffce3dbf = (routeName)=>{
    switch(routeName){
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BOARD:
        case 0, $65Ltd.ROUTE_NAMES_SOFTWARE_BOARDS:
        case 0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS:
            return {
                headerMessage: (0, $5CRhS.default).boardHeader,
                descriptionMessage: (0, $5CRhS.default).boardDescription
            };
        case 0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE:
        case 0, $65Ltd.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC:
            return {
                headerMessage: (0, $5CRhS.default).timelineHeader,
                descriptionMessage: (0, $5CRhS.default).timelineDescription
            };
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
        case 0, $65Ltd.ROUTE_NAMES_SOFTWARE_BACKLOG:
        default:
            return {
                headerMessage: (0, $5CRhS.default).backlogHeader,
                descriptionMessage: (0, $5CRhS.default).backlogDescription
            };
    }
};

});




parcelRegister("bcP1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7bdb2feeca931f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $8Uumt = parcelRequire("8Uumt");

var $gEFwt = parcelRequire("gEFwt");

var $x9xyg = parcelRequire("x9xyg");

var $dXq4S = parcelRequire("dXq4S");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $jgtyX = parcelRequire("jgtyX");

var $bC0n0 = parcelRequire("bC0n0");

var $9SRRO = parcelRequire("9SRRO");

var $5uWNE = parcelRequire("5uWNE");

var $9dbF6 = parcelRequire("9dbF6");

var $9OXo1 = parcelRequire("9OXo1");

var $dIdda = parcelRequire("dIdda");


var $ahuix = parcelRequire("ahuix");

var $83Pnu = parcelRequire("83Pnu");
const $a7bdb2feeca931f5$export$6a9f96b87df4de90 = ()=>{
    const [projectKey] = (0, $dIdda.usePathParam)('projectKey');
    const [boardIdStr] = (0, $dIdda.usePathParam)('boardId');
    const boardId = Number(boardIdStr);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$b5f697f1279a473e));
    });
    const backlogDataResource = (0, $dIdda.useResource)((0, $bC0n0.backlogSyncResource));
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$a6940922387b16));
    });
    (0, $ahuix.useOnce)(()=>{
        (0, $x9xyg.setMark)((0, $a64d16806d35fb92$export$e9163c48bfd4013e));
    }, ()=>!!backlogDataResource.data);
    const response = (0, $ao2h1.useRelayResource)((0, $9SRRO.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    const isCacheHitRef = (0, $5uXOq.useRef)(backlogDataResource.data != null);
    const isCacheHit = isCacheHitRef.current;
    const { data: data, loading: loading, error: error } = backlogDataResource;
    const projectKeyFromContext = data?.boardScope.projectLocation.key || '';
    const projectNameFromContext = data?.boardScope.projectLocation.name || '';
    const projectIdFromContext = data?.boardScope.projectLocation.id || '';
    const [versionFilterRelayQueryRef, loadVersionFilterRelayQuery] = (0, $8Uumt.useQueryLoader)((0, $jgtyX.default));
    (0, $5uXOq.useEffect)(()=>{
        // only run the query if projectId exists in context
        // we load the query client-side because:
        //  1. The field relies on projectId which isn't available from the URL path
        //  2. We don't want version data to block the critical page load
        if (loadVersionFilterRelayQuery != null && projectIdFromContext != null && projectIdFromContext.length > 0) {
            const jiraProjectId = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'project',
                resourceId: `${projectIdFromContext}`
            });
            loadVersionFilterRelayQuery({
                jiraProjectIds: [
                    jiraProjectId
                ],
                first: 500,
                after: null
            });
        }
    }, [
        loadVersionFilterRelayQuery,
        projectIdFromContext,
        tenantContext.cloudId
    ]);
    // redirect to the board only if the backlog is disabled, no redirect if timeout
    if (loading === false && (0, $ahuix.isBacklogDisabled)(data)) {
        const urlProjectKey = projectKey ?? projectKeyFromContext;
        const boardUrl = (0, $ahuix.getBoardUrl)(urlProjectKey, String(boardId));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: boardUrl
        });
    }
    const backlogEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $83Pnu.default), {
        rapidViewId: boardId,
        projectKey: projectKey ?? projectKeyFromContext,
        projectKeyFromContext: projectKeyFromContext,
        projectNameFromContext: projectNameFromContext,
        projectIdFromContext: projectIdFromContext,
        tenantContext: tenantContext,
        data: data,
        aggData: null,
        error: error,
        loading: loading,
        isCacheHit: isCacheHit,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uWNE.default), {
        resource: backlogDataResource,
        refreshOnExpired: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: projectKeyFromContext,
        projectName: projectNameFromContext,
        projectId: projectIdFromContext,
        isSimplifiedProject: true
    }, backlogEl, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey ?? projectKeyFromContext ?? null
    }));
};
var $a7bdb2feeca931f5$export$2e2bcd8739ae039 = $a7bdb2feeca931f5$export$6a9f96b87df4de90;

});
parcelRegister("bC0n0", function(module, exports) {

$parcel$export(module.exports, "backlogSyncResource", () => $1f9e7587bfbf950c$export$ae26ed4881473ce4);

var $gNStA = parcelRequire("gNStA");

var $dIdda = parcelRequire("dIdda");


var $lq5RB = parcelRequire("lq5RB");
const $1f9e7587bfbf950c$export$ae26ed4881473ce4 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $dIdda.createResource)({
    type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve({
            default: (0, $lq5RB.default)
        }),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));

});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $fe839261f35d1611$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';

parcelRegister("lq5RB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $6ad6b3be334e1ef4$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $6ad6b3be334e1ef4$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $6ad6b3be334e1ef4$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $74daz = parcelRequire("74daz");

var $cNrxd = parcelRequire("cNrxd");
const $6ad6b3be334e1ef4$export$fed0052f40119df3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JSW_BACKLOG_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JSW_BACKLOG_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JSW_BACKLOG_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $cNrxd.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Backlog early fetch failed'
            });
            return preload.data;
        });
    }
    return null;
};
const $6ad6b3be334e1ef4$export$8134c072fddab6a5 = (baseUrl, rapidViewId)=>{
    const earlyPreload = $6ad6b3be334e1ef4$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    const data = (0, $74daz.fetchAgilityGraphqlData)(baseUrl, rapidViewId);
    return data;
};
const $6ad6b3be334e1ef4$var$BACKLOG_FETCH_START_MARK = 'BACKLOG_FETCH_START';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ad6b3be334e1ef4$export$2e2bcd8739ae039 = async ({ match: match }, { tenantContext: tenantContext })=>{
    const { baseUrl: baseUrl } = tenantContext;
    const rapidViewId = match.params.boardId || '';
    (0, $x9xyg.setMark)($6ad6b3be334e1ef4$var$BACKLOG_FETCH_START_MARK);
    try {
        setTimeout(()=>{
            (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        });
        const data = await $6ad6b3be334e1ef4$export$8134c072fddab6a5(baseUrl, rapidViewId);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.backlog.getData',
            message: 'An error was thrown while prefetching backlog data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $dJl1T = parcelRequire("dJl1T");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});



parcelRegister("83Pnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $82700b5c274863dd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("c4xqm");

var $6BZYo = parcelRequire("6BZYo");

var $feJRr = parcelRequire("feJRr");

var $aJzGl = parcelRequire("aJzGl");

var $76Weg = parcelRequire("76Weg");

var $gFU0Q = parcelRequire("gFU0Q");

var $5sgUt = parcelRequire("5sgUt");

var $7LEyz = parcelRequire("7LEyz");

var $dZw8H = parcelRequire("dZw8H");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $82700b5c274863dd$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $82700b5c274863dd$var$BacklogApp = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectKeyFromContext: projectKeyFromContext, projectIdFromContext: projectIdFromContext, projectNameFromContext: projectNameFromContext, tenantContext: tenantContext, data: data, aggData: aggData, error: error, loading: loading, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, versionFilterRelayQueryRef: versionFilterRelayQueryRef, getDataFromAGG: getDataFromAGG })=>{
    const isAppReady = Boolean(data);
    if ((0, $5sgUt.isBoardSizeLimitError)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
        projectKey: projectKey
    });
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFU0Q.BacklogSlaTracker), {
        error: error
    });
    if (!isAppReady) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJzGl.NextGenBacklogSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76Weg.default), {
        isCacheHit: isCacheHit,
        bindToOnJiraGlobalIssueCreateClose: $82700b5c274863dd$var$bindToOnJiraGlobalIssueCreateClose,
        // Route match data that could be read inside of the app
        projectKey: projectKeyFromContext,
        projectId: Number(projectIdFromContext),
        projectName: projectNameFromContext,
        rapidViewId: String(rapidViewId),
        // Tenant context data that could be read inside of the app
        locale: tenantContext.locale,
        baseUrl: tenantContext.baseUrl,
        xsrfToken: tenantContext.xsrfToken ?? '',
        cloudId: tenantContext.cloudId ?? '',
        atlassianAccountId: tenantContext.atlassianAccountId ?? null,
        prefetchedData: data,
        prefetchedAggData: aggData,
        isServer: false,
        customFiltersQueryRef: customFiltersQueryRef,
        versionFilterRelayQueryRef: versionFilterRelayQueryRef,
        getDataFromAGG: getDataFromAGG
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
var $82700b5c274863dd$export$2e2bcd8739ae039 = $82700b5c274863dd$var$BacklogApp;

});
parcelRegister("5sgUt", function(module, exports) {

$parcel$export(module.exports, "isBoardSizeLimitError", () => $9689f51629af798e$export$c72e0becab2a28fe);

var $9XE6b = parcelRequire("9XE6b");
const $9689f51629af798e$export$c72e0becab2a28fe = (error)=>error != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    Array.isArray(error.graphQLErrors) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors[0] != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ]) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ]) === 'jsw.board-size-limit-exceeded';

});

parcelRegister("7LEyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ba20431946ab6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $5QVhk = parcelRequire("5QVhk");
/**
 * @deprecated use generic version of SizeLimitErrorEmptyStateComponent component @atlassian/jira-software-size-limit-error-empty-state
 */ const $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl = ({ projectKey: projectKey, savedFilterId: savedFilterId, isCMPBoard: isCMPBoard = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QVhk.default), {
            projectKey: projectKey,
            baseUrl: baseUrl,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    });
var $85ba20431946ab6e$export$2e2bcd8739ae039 = $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl;

});
parcelRegister("5QVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46e677f9d568066$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.31.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $89thI = parcelRequire("89thI");

var $4hGw3 = parcelRequire("4hGw3");

var $i4N7W = parcelRequire("i4N7W");

var $65Ltd = parcelRequire("65Ltd");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $6jY6G = parcelRequire("6jY6G");

var $bMyyL = parcelRequire("bMyyL");

var $gzib5 = parcelRequire("gzib5");
const $d46e677f9d568066$var$BoardSizeLimitError = ({ intl: intl, projectKey: projectKey, baseUrl: baseUrl, isCMPBoard: isCMPBoard = false, savedFilterId: savedFilterId })=>{
    const description = isCMPBoard ? intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionCmpIssueTermRefresh : (0, $bMyyL.default).descriptionCmp) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionIssueTermRefresh : (0, $bMyyL.default).description);
    const url = isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(savedFilterId) ? `${baseUrl}/issues/?filter=${savedFilterId}` : `${baseUrl}/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`;
    const buttonText = isCMPBoard ? intl.formatMessage((0, $bMyyL.default).editBoardFilter) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).goToSearchIssueTermRefresh : (0, $bMyyL.default).goToSearch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i4N7W))),
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).headerIssueTermRefresh : (0, $bMyyL.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $89thI.default), {
            href: url,
            appearance: "primary"
        }, buttonText)
    }));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyState = (props)=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === (0, $65Ltd.ROUTE_NAMES_SERVICEDESK_BOARDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzib5.BoardSizeLimitErrorWithNoCTA), {
        intl: props.intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$BoardSizeLimitError, props));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl = (0, $az4zD.injectIntlV2)($d46e677f9d568066$var$BoardSizeLimitErrorEmptyState);
var $d46e677f9d568066$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl;
const $d46e677f9d568066$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i4N7W", function(module, exports) {
module.exports = new URL("something-wrong.1260804e.svg", import.meta.url).toString();

});

parcelRegister("bMyyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfedbe69eb72a9f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dfedbe69eb72a9f4$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.header",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearch: {
        "id": "software-board-size-limit-error-empty-state.go-to-search",
        "defaultMessage": "See issues in search"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.description",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmp: {
        "id": "software-board-size-limit-error-empty-state.description-cmp",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    },
    editBoardFilter: {
        "id": "software-board-size-limit-error-empty-state.edit-board-filter",
        "defaultMessage": "Edit board filter"
    },
    headerIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.header-issue-term-refresh",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearchIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.go-to-search-issue-term-refresh",
        "defaultMessage": "See issues in search"
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmpIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-cmp-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    }
});
var $dfedbe69eb72a9f4$export$2e2bcd8739ae039 = $dfedbe69eb72a9f4$var$messages;

});

parcelRegister("gzib5", function(module, exports) {

$parcel$export(module.exports, "BoardSizeLimitErrorWithNoCTA", () => $6e3be43d7f71b8ae$export$67ed49fd05b7aff8);

var $5uXOq = parcelRequire("5uXOq");

var $4hGw3 = parcelRequire("4hGw3");

var $6T4rd = parcelRequire("6T4rd");
var $jJ1Sb = parcelRequire("jJ1Sb");

var $i4N7W = parcelRequire("i4N7W");

var $6s1PB = parcelRequire("6s1PB");

var $9NE02 = parcelRequire("9NE02");
const $6e3be43d7f71b8ae$export$67ed49fd05b7aff8 = ({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6T4rd.default), {
        xcss: $6e3be43d7f71b8ae$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hGw3.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($i4N7W))),
        header: intl.formatMessage((0, $9NE02.default).header),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9NE02.default).descriptionIssueTermRefresh : (0, $9NE02.default).description)
    }));
const $6e3be43d7f71b8ae$var$containerStyles = (0, $jJ1Sb.xcss)({
    width: '100%'
});

});
parcelRegister("9NE02", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e962dff92e62d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a9e962dff92e62d1$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description-issue-term-refresh",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    }
});
var $a9e962dff92e62d1$export$2e2bcd8739ae039 = $a9e962dff92e62d1$var$messages;

});









const $25c2ea87c2b04bf9$export$b05303cbde3e8c8c = 'CARD';
const $25c2ea87c2b04bf9$export$57d0ef745f304b91 = 'COLUMN';
const $25c2ea87c2b04bf9$export$2927f4d423091b16 = 'TRANSITION_ZONE';


//# sourceMappingURL=async-next-gen-backlog.495bf39f.js.map
